import { toRaw as Xd, computed as ge, isRef as _c, isReactive as Tc, toRef as Ua, reactive as dt, watch as nt, openBlock as C, createElementBlock as k, withKeys as Ao, withModifiers as Nt, normalizeClass as $e, renderSlot as be, createElementVNode as L, withDirectives as Qt, Fragment as De, renderList as rt, toDisplayString as _e, vShow as An, createCommentVNode as q, createVNode as vt, Transition as un, withCtx as je, normalizeStyle as io, createTextVNode as Gt, createBlock as ft, Teleport as _p, ref as Ee, defineComponent as wt, useSlots as _i, getCurrentInstance as Tp, onMounted as or, nextTick as Kr, onUnmounted as tn, unref as R, mergeProps as ht, createSlots as so, normalizeProps as Er, guardReactiveProps as fo, resolveDynamicComponent as nu, h as Ds, render as Ac, useAttrs as eA, toValue as _l, getCurrentScope as Ap, onScopeDispose as Pp, onBeforeUpdate as tA, withAsyncContext as ri, inject as Yn, vModelText as Io, vModelDynamic as rA, vModelCheckbox as Mp, onBeforeMount as Nn, shallowRef as $p, effectScope as oA, Text as nA, readonly as aA, customRef as lA, onBeforeUnmount as PS, setBlockTracking as Qh, resolveComponent as fl, vModelSelect as iA, resolveDirective as sA } from "vue";
process.env.NODE_ENV;
var jh;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(jh || (jh = {}));
process.env.NODE_ENV;
function om(e) {
  const t = Xd(e), r = {};
  for (const o in t) {
    const n = t[o];
    n.effect ? r[o] = // ...
    ge({
      get: () => e[o],
      set(a) {
        e[o] = a;
      }
    }) : (_c(n) || Tc(n)) && (r[o] = // ---
    Ua(e, o));
  }
  return r;
}
var MS;
function Ve() {
  return MS.apply(null, arguments);
}
function dA(e) {
  MS = e;
}
function Qn(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function oi(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Dt(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Cp(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (Dt(e, t))
      return !1;
  return !0;
}
function Yo(e) {
  return e === void 0;
}
function Xa(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function au(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function $S(e, t) {
  var r = [], o, n = e.length;
  for (o = 0; o < n; ++o)
    r.push(t(e[o], o));
  return r;
}
function ha(e, t) {
  for (var r in t)
    Dt(t, r) && (e[r] = t[r]);
  return Dt(t, "toString") && (e.toString = t.toString), Dt(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function _a(e, t, r, o) {
  return JS(e, t, r, o, !0).utc();
}
function uA() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidOffset: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Et(e) {
  return e._pf == null && (e._pf = uA()), e._pf;
}
var Of;
Array.prototype.some ? Of = Array.prototype.some : Of = function(e) {
  var t = Object(this), r = t.length >>> 0, o;
  for (o = 0; o < r; o++)
    if (o in t && e.call(this, t[o], o, t))
      return !0;
  return !1;
};
function Lp(e) {
  var t = null, r = !1, o = e._d && !isNaN(e._d.getTime());
  if (o && (t = Et(e), r = Of.call(t.parsedDateParts, function(n) {
    return n != null;
  }), o = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidOffset && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r), e._strict && (o = o && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = o;
  else
    return o;
  return e._isValid;
}
function lu(e) {
  var t = _a(NaN);
  return e != null ? ha(Et(t), e) : Et(t).userInvalidated = !0, t;
}
var Zh = Ve.momentProperties = [], hg = !1;
function Ep(e, t) {
  var r, o, n, a = Zh.length;
  if (Yo(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Yo(t._i) || (e._i = t._i), Yo(t._f) || (e._f = t._f), Yo(t._l) || (e._l = t._l), Yo(t._strict) || (e._strict = t._strict), Yo(t._tzm) || (e._tzm = t._tzm), Yo(t._isUTC) || (e._isUTC = t._isUTC), Yo(t._offset) || (e._offset = t._offset), Yo(t._pf) || (e._pf = Et(t)), Yo(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      o = Zh[r], n = t[o], Yo(n) || (e[o] = n);
  return e;
}
function iu(e) {
  Ep(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), hg === !1 && (hg = !0, Ve.updateOffset(this), hg = !1);
}
function cn(e) {
  return e instanceof iu || e != null && e._isAMomentObject != null;
}
function CS(e) {
  Ve.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Dn(e, t) {
  var r = !0;
  return ha(function() {
    if (Ve.deprecationHandler != null && Ve.deprecationHandler(null, e), r) {
      var o = [], n, a, l, i = arguments.length;
      for (a = 0; a < i; a++) {
        if (n = "", typeof arguments[a] == "object") {
          n += `
[` + a + "] ";
          for (l in arguments[0])
            Dt(arguments[0], l) && (n += l + ": " + arguments[0][l] + ", ");
          n = n.slice(0, -2);
        } else
          n = arguments[a];
        o.push(n);
      }
      CS(
        e + `
Arguments: ` + Array.prototype.slice.call(o).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var zh = {};
function LS(e, t) {
  Ve.deprecationHandler != null && Ve.deprecationHandler(e, t), zh[e] || (CS(t + `
` + new Error().stack), zh[e] = !0);
}
Ve.suppressDeprecationWarnings = !1;
Ve.deprecationHandler = null;
function Ta(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
var qh = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function kn(e) {
  return typeof e == "string" ? qh[e] || qh[e.toLowerCase()] : void 0;
}
function Op(e) {
  var t = {}, r, o;
  for (o in e)
    Dt(e, o) && (r = kn(o), r && (t[r] = e[o]));
  return t;
}
var cA = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function mA(e) {
  var t = [], r;
  for (r in e)
    Dt(e, r) && t.push({ unit: r, priority: cA[r] });
  return t.sort(function(o, n) {
    return o.priority - n.priority;
  }), t;
}
function Ln(e, t, r) {
  var o = "" + Math.abs(e), n = t - o.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, n)).toString().substr(1) + o;
}
var Np = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Yu = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, xg = {}, Ts = {};
function pt(e, t, r, o) {
  var n = o;
  typeof o == "string" && (n = function() {
    return this[o]();
  }), e && (Ts[e] = n), t && (Ts[t[0]] = function() {
    return Ln(n.apply(this, arguments), t[1], t[2]);
  }), r && (Ts[r] = function() {
    return this.localeData().ordinal(
      n.apply(this, arguments),
      e
    );
  });
}
function gA(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function fA(e) {
  var t = e.match(Np), r, o;
  for (r = 0, o = t.length; r < o; r++)
    Ts[t[r]] ? t[r] = Ts[t[r]] : t[r] = gA(t[r]);
  return function(n) {
    var a = "", l;
    for (l = 0; l < o; l++)
      a += Ta(t[l]) ? t[l].call(n, e) : t[l];
    return a;
  };
}
function gc(e, t) {
  if (!e.isValid())
    return e.localeData().invalidDate();
  t = ES(t, e.localeData());
  var r = "$" + t;
  return Dt(xg, r) || (xg[r] = fA(t)), xg[r](e);
}
function ES(e, t) {
  var r = 5;
  function o(n) {
    return t.longDateFormat(n) || n;
  }
  for (Yu.lastIndex = 0; r >= 0 && Yu.test(e); )
    e = e.replace(
      Yu,
      o
    ), Yu.lastIndex = 0, r -= 1;
  return e;
}
var OS = /\d/, fn = /\d\d/, NS = /\d{3}/, Dp = /\d{4}/, nm = /[+-]?\d{6}/, _r = /\d\d?/, DS = /\d\d\d\d?/, kp = /\d\d\d\d\d\d?/, am = /\d{1,3}/, Gp = /\d{1,4}/, lm = /[+-]?\d{1,6}/, qs = /\d+/, im = /[+-]?\d+/, pA = /Z|[+-]\d\d:?\d\d/gi, sm = /Z|[+-]\d\d(?::?\d\d)?/gi, hA = /[+-]?\d+(\.\d{1,3})?/, su = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Js = /^[1-9]\d?/, Bp = /^([1-9]\d|\d)/, Pc;
Pc = {};
function it(e, t, r) {
  Pc[e] = Ta(t) ? t : function(o, n) {
    return o && r ? r : t;
  };
}
function xA(e, t) {
  return Dt(Pc, e) ? Pc[e](t._strict, t._locale) : new RegExp(vA(e));
}
function vA(e) {
  return Fa(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, o, n, a) {
        return r || o || n || a;
      }
    )
  );
}
function Fa(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function yn(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function Ot(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = yn(t)), r;
}
var Nf = {};
function gr(e, t) {
  var r, o = t, n;
  for (typeof e == "string" && (e = [e]), Xa(t) && (o = function(a, l) {
    l[t] = Ot(a);
  }), n = e.length, r = 0; r < n; r++)
    Nf[e[r]] = o;
}
function ed(e, t) {
  gr(e, function(r, o, n, a) {
    n._w = n._w || {}, t(r, n._w, n, a);
  });
}
function SA(e, t, r) {
  t != null && Dt(Nf, e) && Nf[e](t, r._a, r, e);
}
function dm(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var Vr = 0, nn = 1, Qo = 2, to = 3, Pn = 4, Ba = 5, jl = 6, bA = 7, yA = 8;
pt("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Ln(e, 4) : "+" + e;
});
pt(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
pt(0, ["YYYY", 4], 0, "year");
pt(0, ["YYYYY", 5], 0, "year");
pt(0, ["YYYYYY", 6, !0], 0, "year");
it("Y", im);
it("YY", _r, fn);
it("YYYY", Gp, Dp);
it("YYYYY", lm, nm);
it("YYYYYY", lm, nm);
gr(["YYYYY", "YYYYYY"], Vr);
gr("YYYY", function(e, t) {
  t[Vr] = e.length === 2 ? Ve.parseTwoDigitYear(e) : Ot(e);
});
gr("YY", function(e, t) {
  t[Vr] = Ve.parseTwoDigitYear(e);
});
gr("Y", function(e, t) {
  t[Vr] = parseInt(e, 10);
});
function Fd(e) {
  return dm(e) ? 366 : 365;
}
Ve.parseTwoDigitYear = function(e) {
  return Ot(e) + (Ot(e) > 68 ? 1900 : 2e3);
};
var kS = td("FullYear", !0);
function wA() {
  return dm(this.year());
}
function td(e, t) {
  return function(r) {
    return r != null ? (GS(this, e, r), Ve.updateOffset(this, t), this) : Wd(this, e);
  };
}
function Wd(e, t) {
  if (!e.isValid())
    return NaN;
  var r = e._d, o = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return o ? r.getUTCMilliseconds() : r.getMilliseconds();
    case "Seconds":
      return o ? r.getUTCSeconds() : r.getSeconds();
    case "Minutes":
      return o ? r.getUTCMinutes() : r.getMinutes();
    case "Hours":
      return o ? r.getUTCHours() : r.getHours();
    case "Date":
      return o ? r.getUTCDate() : r.getDate();
    case "Day":
      return o ? r.getUTCDay() : r.getDay();
    case "Month":
      return o ? r.getUTCMonth() : r.getMonth();
    case "FullYear":
      return o ? r.getUTCFullYear() : r.getFullYear();
    default:
      return NaN;
  }
}
function GS(e, t, r) {
  var o, n, a, l, i;
  if (!(!e.isValid() || isNaN(r))) {
    switch (o = e._d, n = e._isUTC, t) {
      case "Milliseconds":
        return void (n ? o.setUTCMilliseconds(r) : o.setMilliseconds(r));
      case "Seconds":
        return void (n ? o.setUTCSeconds(r) : o.setSeconds(r));
      case "Minutes":
        return void (n ? o.setUTCMinutes(r) : o.setMinutes(r));
      case "Hours":
        return void (n ? o.setUTCHours(r) : o.setHours(r));
      case "Date":
        return void (n ? o.setUTCDate(r) : o.setDate(r));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    a = r, l = e.month(), i = e.date(), i = i === 29 && l === 1 && !dm(a) ? 28 : i, n ? o.setUTCFullYear(a, l, i) : o.setFullYear(a, l, i);
  }
}
function _A(e) {
  return e = kn(e), Ta(this[e]) ? this[e]() : this;
}
function TA(e, t) {
  if (typeof e == "object") {
    e = Op(e);
    var r = mA(e), o, n = r.length;
    for (o = 0; o < n; o++)
      this[r[o].unit](e[r[o].unit]);
  } else if (e = kn(e), Ta(this[e]))
    return this[e](t);
  return this;
}
function AA(e, t) {
  return (e % t + t) % t;
}
var Ir;
Array.prototype.indexOf ? Ir = Array.prototype.indexOf : Ir = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function Ip(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = AA(t, 12);
  return e += (t - r) / 12, r === 1 ? dm(e) ? 29 : 28 : 31 - r % 7 % 2;
}
pt("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
pt("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
pt("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
it("M", _r, Js);
it("MM", _r, fn);
it("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
it("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
gr(["M", "MM"], function(e, t) {
  t[nn] = Ot(e) - 1;
});
gr(["MMM", "MMMM"], function(e, t, r, o) {
  var n = r._locale.monthsParse(e, o, r._strict);
  n != null ? t[nn] = n : Et(r).invalidMonth = e;
});
var PA = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), BS = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), IS = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, MA = su, $A = su, Jh = [
  "monthsParse",
  "longMonthsParse",
  "shortMonthsParse",
  "monthsRegex",
  "monthsShortRegex",
  "monthsStrictRegex",
  "monthsShortStrictRegex"
];
function CA(e, t) {
  var r, o;
  for (r = 0; r < Jh.length; r++)
    o = Jh[r], Dt(t, o) || delete e["_" + o];
}
function LA(e, t) {
  return e ? Qn(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || IS).test(t) ? "format" : "standalone"][e.month()] : Qn(this._months) ? this._months : this._months.standalone;
}
function EA(e, t) {
  return e ? Qn(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[IS.test(t) ? "format" : "standalone"][e.month()] : Qn(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function OA(e, t, r) {
  var o, n, a, l = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], o = 0; o < 12; ++o)
      a = _a([2e3, o]), this._shortMonthsParse[o] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[o] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (n = Ir.call(this._shortMonthsParse, l), n !== -1 ? n : null) : (n = Ir.call(this._longMonthsParse, l), n !== -1 ? n : null) : t === "MMM" ? (n = Ir.call(this._shortMonthsParse, l), n !== -1 ? n : (n = Ir.call(this._longMonthsParse, l), n !== -1 ? n : null)) : (n = Ir.call(this._longMonthsParse, l), n !== -1 ? n : (n = Ir.call(this._shortMonthsParse, l), n !== -1 ? n : null));
}
function NA(e, t, r) {
  var o, n, a;
  if (this._monthsParseExact)
    return OA.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), o = 0; o < 12; o++) {
    if (n = _a([2e3, o]), r && !this._longMonthsParse[o] && (this._longMonthsParse[o] = new RegExp(
      "^" + this.months(n, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[o] = new RegExp(
      "^" + this.monthsShort(n, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[o] && (a = "^" + this.months(n, "") + "|^" + this.monthsShort(n, ""), this._monthsParse[o] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[o].test(e))
      return o;
    if (r && t === "MMM" && this._shortMonthsParse[o].test(e))
      return o;
    if (!r && this._monthsParse[o].test(e))
      return o;
  }
}
function RS(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = Ot(t);
    else if (t = e.localeData().monthsParse(t), !Xa(t))
      return e;
  }
  var r = t, o = e.date();
  return o = o < 29 ? o : Math.min(o, Ip(e.year(), r)), e._isUTC ? e._d.setUTCMonth(r, o) : e._d.setMonth(r, o), e;
}
function FS(e) {
  return e != null ? (RS(this, e), Ve.updateOffset(this, !0), this) : Wd(this, "Month");
}
function DA() {
  return Ip(this.year(), this.month());
}
function kA(e) {
  return this._monthsParseExact ? (Dt(this, "_monthsRegex") || VS.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Dt(this, "_monthsShortRegex") || (this._monthsShortRegex = MA), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function GA(e) {
  return this._monthsParseExact ? (Dt(this, "_monthsRegex") || VS.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Dt(this, "_monthsRegex") || (this._monthsRegex = $A), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function VS() {
  function e(s, u) {
    return u.length - s.length;
  }
  var t = [], r = [], o = [], n, a, l, i;
  for (n = 0; n < 12; n++)
    a = _a([2e3, n]), l = Fa(this.monthsShort(a, "")), i = Fa(this.months(a, "")), t.push(l), r.push(i), o.push(i), o.push(l);
  t.sort(e), r.sort(e), o.sort(e), this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
pt("d", 0, "do", "day");
pt("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
pt("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
pt("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
pt("e", 0, 0, "weekday");
pt("E", 0, 0, "isoWeekday");
pt("eHHmm", 0, 0, function() {
  return "" + this.weekday() + Ln(this.hours(), 2) + Ln(this.minutes(), 2);
});
it("d", _r);
it("e", _r);
it("E", _r);
it("eHHmm", kp);
it("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
it("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
it("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
ed(["dd", "ddd", "dddd"], function(e, t, r, o) {
  var n = r._locale.weekdaysParse(e, o, r._strict);
  n != null ? t.d = n : Et(r).invalidWeekday = e;
});
ed(["d", "e", "E"], function(e, t, r, o) {
  t[o] = Ot(e);
});
ed("eHHmm", function(e, t, r) {
  var o = e.length - 4;
  t.e = Ot(e.substr(0, o)), r._a[to] = Ot(e.substr(o, 2)), r._a[Pn] = Ot(e.substr(o + 2));
});
function BA(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function IA(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function Rp(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var RA = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), HS = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), FA = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), VA = su, HA = su, UA = su, e1 = [
  "weekdaysParse",
  "fullWeekdaysParse",
  "shortWeekdaysParse",
  "minWeekdaysParse",
  "weekdaysRegex",
  "weekdaysShortRegex",
  "weekdaysMinRegex",
  "weekdaysStrictRegex",
  "weekdaysShortStrictRegex",
  "weekdaysMinStrictRegex"
];
function XA(e, t) {
  var r, o;
  for (r = 0; r < e1.length; r++)
    o = e1[r], Dt(t, o) || delete e["_" + o];
}
function WA(e, t) {
  var r = Qn(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? Rp(r, this._week.dow) : e ? r[e.day()] : r;
}
function YA(e) {
  return e === !0 ? Rp(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function KA(e) {
  return e === !0 ? Rp(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function QA(e, t, r) {
  var o, n, a, l = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], o = 0; o < 7; ++o)
      a = _a([2e3, 1]).day(o), this._minWeekdaysParse[o] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[o] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[o] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (n = Ir.call(this._weekdaysParse, l), n !== -1 ? n : null) : t === "ddd" ? (n = Ir.call(this._shortWeekdaysParse, l), n !== -1 ? n : null) : (n = Ir.call(this._minWeekdaysParse, l), n !== -1 ? n : null) : t === "dddd" ? (n = Ir.call(this._weekdaysParse, l), n !== -1 || (n = Ir.call(this._shortWeekdaysParse, l), n !== -1) ? n : (n = Ir.call(this._minWeekdaysParse, l), n !== -1 ? n : null)) : t === "ddd" ? (n = Ir.call(this._shortWeekdaysParse, l), n !== -1 || (n = Ir.call(this._weekdaysParse, l), n !== -1) ? n : (n = Ir.call(this._minWeekdaysParse, l), n !== -1 ? n : null)) : (n = Ir.call(this._minWeekdaysParse, l), n !== -1 || (n = Ir.call(this._weekdaysParse, l), n !== -1) ? n : (n = Ir.call(this._shortWeekdaysParse, l), n !== -1 ? n : null));
}
function jA(e, t, r) {
  var o, n, a;
  if (this._weekdaysParseExact)
    return QA.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), o = 0; o < 7; o++) {
    if (n = _a([2e3, 1]).day(o), r && !this._fullWeekdaysParse[o] && (this._fullWeekdaysParse[o] = new RegExp(
      "^" + this.weekdays(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[o] = new RegExp(
      "^" + this.weekdaysShort(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[o] = new RegExp(
      "^" + this.weekdaysMin(n, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[o] || (a = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), this._weekdaysParse[o] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[o].test(e))
      return o;
    if (r && t === "ddd" && this._shortWeekdaysParse[o].test(e))
      return o;
    if (r && t === "dd" && this._minWeekdaysParse[o].test(e))
      return o;
    if (!r && this._weekdaysParse[o].test(e))
      return o;
  }
}
function ZA(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = Wd(this, "Day");
  return e != null ? (e = BA(e, this.localeData()), this.add(e - t, "d")) : t;
}
function zA(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function qA(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = IA(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function JA(e) {
  return this._weekdaysParseExact ? (Dt(this, "_weekdaysRegex") || Fp.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Dt(this, "_weekdaysRegex") || (this._weekdaysRegex = VA), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function e2(e) {
  return this._weekdaysParseExact ? (Dt(this, "_weekdaysRegex") || Fp.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Dt(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = HA), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function t2(e) {
  return this._weekdaysParseExact ? (Dt(this, "_weekdaysRegex") || Fp.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Dt(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = UA), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Fp() {
  function e(c, g) {
    return g.length - c.length;
  }
  var t = [], r = [], o = [], n = [], a, l, i, s, u;
  for (a = 0; a < 7; a++)
    l = _a([2e3, 1]).day(a), i = Fa(this.weekdaysMin(l, "")), s = Fa(this.weekdaysShort(l, "")), u = Fa(this.weekdays(l, "")), t.push(i), r.push(s), o.push(u), n.push(i), n.push(s), n.push(u);
  t.sort(e), r.sort(e), o.sort(e), n.sort(e), this._weekdaysRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + o.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function r2(e) {
  var t, r;
  CA(this, e), XA(this, e);
  for (r in e)
    Dt(e, r) && (t = e[r], Ta(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Df(e, t) {
  var r = ha({}, e), o;
  for (o in t)
    Dt(t, o) && (oi(e[o]) && oi(t[o]) ? (r[o] = {}, ha(r[o], e[o]), ha(r[o], t[o])) : t[o] != null ? r[o] = t[o] : delete r[o]);
  for (o in e)
    Dt(e, o) && !Dt(t, o) && oi(e[o]) && (r[o] = ha({}, r[o]));
  return r;
}
function Vp(e) {
  e != null && this.set(e);
}
var kf;
Object.keys ? kf = Object.keys : kf = function(e) {
  var t, r = [];
  for (t in e)
    Dt(e, t) && r.push(t);
  return r;
};
var o2 = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function n2(e, t, r) {
  var o = this._calendar[e] || this._calendar.sameElse;
  return Ta(o) ? o.call(t, r) : o;
}
var a2 = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function l2(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()], o = this._longDateFormatCache;
  return t || !r ? t : o && o[e] && o[e].formatUpper === r ? o[e].format : (t = r.match(Np).map(function(n) {
    return n === "MMMM" || n === "MM" || n === "DD" || n === "dddd" ? n.slice(1) : n;
  }).join(""), o || (o = this._longDateFormatCache = {}), o[e] = {
    formatUpper: r,
    format: t
  }, t);
}
var i2 = "Invalid date";
function s2() {
  return this._invalidDate;
}
var d2 = "%d", u2 = /\d{1,2}/;
function c2(e) {
  return this._ordinal.replace("%d", e);
}
var m2 = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function US(e, t, r, o) {
  var n = this._relativeTime[r];
  return Ta(n) ? n(e, t, r, o) : n.replace(/%d/i, e);
}
function g2(e, t, r, o) {
  return this.postformat(
    US.call(
      this,
      e,
      t,
      r,
      o
    )
  );
}
function XS(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return Ta(r) ? r(t) : r.replace(/%s/i, t);
}
function f2(e, t) {
  return this.postformat(
    XS.call(this, e, t)
  );
}
function p2(e, t, r, o, n, a, l) {
  var i;
  return e < 100 && e >= 0 ? (i = new Date(e + 400, t, r, o, n, a, l), isFinite(i.getFullYear()) && i.setFullYear(e)) : i = new Date(e, t, r, o, n, a, l), i;
}
function ui(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function Mc(e, t, r) {
  var o = 7 + t - r, n = (7 + ui(e, 0, o).getUTCDay() - t) % 7;
  return -n + o - 1;
}
function WS(e, t, r, o, n) {
  var a = (7 + r - o) % 7, l = Mc(e, o, n), i = 1 + 7 * (t - 1) + a + l, s, u;
  return i <= 0 ? (s = e - 1, u = Fd(s) + i) : i > Fd(e) ? (s = e + 1, u = i - Fd(e)) : (s = e, u = i), {
    year: s,
    dayOfYear: u
  };
}
function YS(e, t, r, o) {
  var n = Mc(e, r, o), a = Math.floor((t - n - 1) / 7) + 1, l, i;
  return a < 1 ? (i = e - 1, l = a + Va(i, r, o)) : a > Va(e, r, o) ? (l = a - Va(e, r, o), i = e + 1) : (i = e, l = a), {
    week: l,
    year: i
  };
}
function Hp(e, t, r) {
  return YS(e.year(), e.dayOfYear(), t, r);
}
function t1(e, t, r, o, n) {
  var a = Math.round(
    (ui(e, t, r) - ui(e, 0, 1)) / 864e5
  ) + 1;
  return YS(e, a, o, n);
}
function Va(e, t, r) {
  var o = Mc(e, t, r), n = Mc(e + 1, t, r);
  return (Fd(e) - o + n) / 7;
}
pt("w", ["ww", 2], "wo", "week");
pt("W", ["WW", 2], "Wo", "isoWeek");
it("w", _r, Js);
it("ww", _r, fn);
it("W", _r, Js);
it("WW", _r, fn);
ed(
  ["w", "ww", "W", "WW"],
  function(e, t, r, o) {
    t[o.substr(0, 1)] = Ot(e);
  }
);
function h2(e) {
  return Hp(e, this._week.dow, this._week.doy).week;
}
var x2 = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function v2() {
  return this._week.dow;
}
function S2() {
  return this._week.doy;
}
function b2(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function y2(e) {
  var t = Hp(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
function Up() {
  return this.hours() % 12 || 12;
}
function w2() {
  return this.hours() || 24;
}
pt("H", ["HH", 2], 0, "hour");
pt("h", ["hh", 2], 0, Up);
pt("k", ["kk", 2], 0, w2);
pt("hmm", 0, 0, function() {
  return "" + Up.apply(this) + Ln(this.minutes(), 2);
});
pt("hmmss", 0, 0, function() {
  return "" + Up.apply(this) + Ln(this.minutes(), 2) + Ln(this.seconds(), 2);
});
pt("Hmm", 0, 0, function() {
  return "" + this.hours() + Ln(this.minutes(), 2);
});
pt("Hmmss", 0, 0, function() {
  return "" + this.hours() + Ln(this.minutes(), 2) + Ln(this.seconds(), 2);
});
function KS(e, t) {
  pt(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
KS("a", !0);
KS("A", !1);
function QS(e, t) {
  return t._meridiemParse;
}
it("a", QS);
it("A", QS);
it("H", _r, Bp);
it("h", _r, Js);
it("k", _r, Js);
it("HH", _r, fn);
it("hh", _r, fn);
it("kk", _r, fn);
it("hmm", DS);
it("hmmss", kp);
it("Hmm", DS);
it("Hmmss", kp);
gr(["H", "HH"], to);
gr(["k", "kk"], function(e, t, r) {
  var o = Ot(e);
  t[to] = o === 24 ? 0 : o;
});
gr(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
gr(["h", "hh"], function(e, t, r) {
  t[to] = Ot(e), Et(r).bigHour = !0;
});
gr("hmm", function(e, t, r) {
  var o = e.length - 2;
  t[to] = Ot(e.substr(0, o)), t[Pn] = Ot(e.substr(o)), Et(r).bigHour = !0;
});
gr("hmmss", function(e, t, r) {
  var o = e.length - 4, n = e.length - 2;
  t[to] = Ot(e.substr(0, o)), t[Pn] = Ot(e.substr(o, 2)), t[Ba] = Ot(e.substr(n)), Et(r).bigHour = !0;
});
gr("Hmm", function(e, t, r) {
  var o = e.length - 2;
  t[to] = Ot(e.substr(0, o)), t[Pn] = Ot(e.substr(o));
});
gr("Hmmss", function(e, t, r) {
  var o = e.length - 4, n = e.length - 2;
  t[to] = Ot(e.substr(0, o)), t[Pn] = Ot(e.substr(o, 2)), t[Ba] = Ot(e.substr(n));
});
function _2(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var T2 = /[ap]\.?m?\.?/i, A2 = td("Hours", !0);
function P2(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var jS = {
  calendar: o2,
  longDateFormat: a2,
  invalidDate: i2,
  ordinal: d2,
  dayOfMonthOrdinalParse: u2,
  relativeTime: m2,
  months: PA,
  monthsShort: BS,
  week: x2,
  weekdays: RA,
  weekdaysMin: FA,
  weekdaysShort: HS,
  meridiemParse: T2
}, ur = {}, _d = {}, Yd;
function M2(e, t) {
  var r, o = Math.min(e.length, t.length);
  for (r = 0; r < o; r += 1)
    if (e[r] !== t[r])
      return r;
  return o;
}
function Gf(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function $2(e) {
  for (var t = 0, r, o, n, a; t < e.length; ) {
    for (a = Gf(e[t]).split("-"), r = a.length, o = Gf(e[t + 1]), o = o ? o.split("-") : null; r > 0; ) {
      if (n = um(a.slice(0, r).join("-")), n)
        return n;
      if (o && o.length >= r && M2(a, o) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return Yd;
}
function C2(e) {
  return typeof e == "string" && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(e);
}
function um(e) {
  var t = null, r, o;
  if (Dt(ur, e))
    return ur[e];
  if (o = Gf(e), Dt(ur, o))
    return ur[o];
  if (typeof module < "u" && module && module.exports && C2(o))
    try {
      t = Yd._abbr, r = require, r("./locale/" + o), Tl(t);
    } catch {
      ur[o] = null;
    }
  if (Dt(ur, o))
    return ur[o];
}
function Tl(e, t) {
  var r;
  return e && (Yo(t) ? r = Za(e) : r = Xp(e, t), r ? Yd = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Yd._abbr;
}
function Xp(e, t) {
  if (t !== null) {
    var r, o = jS;
    if (t.abbr = e, ur[e] != null)
      LS(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), o = ur[e]._config;
    else if (t.parentLocale != null)
      if (ur[t.parentLocale] != null)
        o = ur[t.parentLocale]._config;
      else if (r = um(t.parentLocale), r != null)
        o = r._config;
      else
        return _d[t.parentLocale] || (_d[t.parentLocale] = []), _d[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return ur[e] = new Vp(Df(o, t)), _d[e] && _d[e].forEach(function(n) {
      Xp(n.name, n.config);
    }), Tl(e), ur[e];
  } else
    return delete ur[e], null;
}
function L2(e, t) {
  var r, o = um(e), n = jS;
  return o != null && (e = o._abbr), t != null ? (ur[e] != null && ur[e].parentLocale != null ? ur[e].set(Df(ur[e]._config, t)) : (o != null && (n = o._config), t = Df(n, t), o == null && (t.abbr = e), r = new Vp(t), r.parentLocale = ur[e], ur[e] = r), Tl(e)) : ur[e] != null && (ur[e].parentLocale != null ? (ur[e] = ur[e].parentLocale, e === Tl() && Tl(e)) : ur[e] != null && delete ur[e]), ur[e];
}
function Za(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Yd;
  if (!Qn(e)) {
    if (t = um(e), t)
      return t;
    e = [e];
  }
  return $2(e);
}
function E2() {
  return kf(ur);
}
function Wp(e) {
  var t, r = e._a;
  return r && Et(e).overflow === -2 && (t = r[nn] < 0 || r[nn] > 11 ? nn : r[Qo] < 1 || r[Qo] > Ip(r[Vr], r[nn]) ? Qo : r[to] < 0 || r[to] > 24 || r[to] === 24 && (r[Pn] !== 0 || r[Ba] !== 0 || r[jl] !== 0) ? to : r[Pn] < 0 || r[Pn] > 59 ? Pn : r[Ba] < 0 || r[Ba] > 59 ? Ba : r[jl] < 0 || r[jl] > 999 ? jl : -1, Et(e)._overflowDayOfYear && (t < Vr || t > Qo) && (t = Qo), Et(e)._overflowWeeks && t === -1 && (t = bA), Et(e)._overflowWeekday && t === -1 && (t = yA), Et(e).overflow = t), e;
}
var O2 = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, N2 = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, D2 = /Z|[+-]\d\d(?::?\d\d)?/, Ku = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], vg = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], k2 = /^\/?Date\((-?\d+)/i, G2 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, B2 = {
  UT: 0,
  GMT: 0,
  EDT: -240,
  EST: -300,
  CDT: -300,
  CST: -360,
  MDT: -360,
  MST: -420,
  PDT: -420,
  PST: -480
};
function ZS(e) {
  var t, r, o = e._i, n = O2.exec(o) || N2.exec(o), a, l, i, s, u = Ku.length, c = vg.length;
  if (n) {
    for (Et(e).iso = !0, t = 0, r = u; t < r; t++)
      if (Ku[t][1].exec(n[1])) {
        l = Ku[t][0], a = Ku[t][2] !== !1;
        break;
      }
    if (l == null) {
      e._isValid = !1;
      return;
    }
    if (n[3]) {
      for (t = 0, r = c; t < r; t++)
        if (vg[t][1].exec(n[3])) {
          i = (n[2] || " ") + vg[t][0];
          break;
        }
      if (i == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && i != null) {
      e._isValid = !1;
      return;
    }
    if (n[4])
      if (D2.exec(n[4]))
        s = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = l + (i || "") + (s || ""), Kp(e);
  } else
    e._isValid = !1;
}
function I2(e, t, r, o, n, a) {
  var l = [
    R2(e),
    BS.indexOf(t),
    parseInt(r, 10),
    parseInt(o, 10),
    parseInt(n, 10)
  ];
  return a && l.push(parseInt(a, 10)), l;
}
function R2(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function F2(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function V2(e, t, r) {
  if (e) {
    var o = HS.indexOf(e), n = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (o !== n)
      return Et(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function H2(e, t, r) {
  if (e)
    return B2[e];
  if (t)
    return 0;
  var o = parseInt(r, 10), n = o % 100, a = (o - n) / 100;
  return a * 60 + n;
}
function zS(e) {
  var t = G2.exec(F2(e._i)), r;
  if (t) {
    if (r = I2(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !V2(t[1], r, e))
      return;
    e._a = r, e._tzm = H2(t[8], t[9], t[10]), e._d = ui.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Et(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function U2(e) {
  var t = k2.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (ZS(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (zS(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : Ve.createFromInputFallback(e);
}
Ve.createFromInputFallback = Dn(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Td(e, t, r) {
  return e ?? t ?? r;
}
function r1(e, t, r) {
  var o = Object.prototype.hasOwnProperty.call(
    e,
    "_isDefaultDatePartsForWeek"
  ), n = e._isDefaultDatePartsForWeek;
  e._isDefaultDatePartsForWeek = !!r;
  try {
    return Ve._getDefaultDateParts(e, t, r);
  } finally {
    o ? e._isDefaultDatePartsForWeek = n : delete e._isDefaultDatePartsForWeek;
  }
}
function X2(e) {
  var t = e._defaultDatePartsNow;
  return t ? (t.hasValue || (t.value = Ve.now(), t.hasValue = !0), t.value) : Ve.now();
}
function W2(e, t, r) {
  var o = r || e._isDefaultDatePartsForWeek, n = o ? Ar(t) : new Date(t);
  return o ? [n.year(), n.month(), n.date()] : e._useUTC ? [
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate()
  ] : [n.getFullYear(), n.getMonth(), n.getDate()];
}
Ve._getDefaultDateParts = W2;
function Yp(e) {
  var t, r, o = [], n, a, l, i, s;
  if (!e._d) {
    for ((e._a[Vr] == null || e._a[nn] == null || e._a[Qo] == null) && (n = X2(e), a = r1(e, n)), e._w && e._a[Qo] == null && e._a[nn] == null && Y2(e, r1(e, n, !0)), e._dayOfYear != null && (i = e._a[Vr] != null ? e._a[Vr] : a[Vr], (e._dayOfYear > Fd(i) || e._dayOfYear === 0) && (Et(e)._overflowDayOfYear = !0), r = ui(i, 0, e._dayOfYear), e._a[nn] = r.getUTCMonth(), e._a[Qo] = r.getUTCDate()), s = e._a[Vr] == null || e._a[nn] == null || e._a[Qo] == null, t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = o[t] = a[t];
    for (; t < 7; t++)
      e._a[t] = o[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[to] === 24 && e._a[Pn] === 0 && e._a[Ba] === 0 && e._a[jl] === 0 && (e._nextDay = !0, e._a[to] = 0), e._d = (e._useUTC ? ui : p2).apply(
      null,
      o
    ), l = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[to] = 24), e._w && typeof e._w.d < "u" && !s && e._w.d !== l && (Et(e).weekdayMismatch = !0);
  }
}
function Y2(e, t) {
  var r, o, n, a, l, i, s, u, c;
  r = e._w, r.GG != null || r.W != null || r.E != null ? (l = 1, i = 4, o = Td(
    r.GG,
    e._a[Vr],
    t1(
      t[Vr],
      t[nn],
      t[Qo],
      1,
      4
    ).year
  ), n = Td(r.W, 1), a = Td(r.E, 1), (a < 1 || a > 7) && (u = !0)) : (l = e._locale._week.dow, i = e._locale._week.doy, c = t1(
    t[Vr],
    t[nn],
    t[Qo],
    l,
    i
  ), o = Td(r.gg, e._a[Vr], c.year), n = Td(r.w, c.week), r.d != null ? (a = r.d, (a < 0 || a > 6) && (u = !0)) : r.e != null ? (a = r.e + l, (r.e < 0 || r.e > 6) && (u = !0)) : a = l), n < 1 || n > Va(o, l, i) ? Et(e)._overflowWeeks = !0 : u != null ? Et(e)._overflowWeekday = !0 : (s = WS(o, n, a, l, i), e._a[Vr] = s.year, e._dayOfYear = s.dayOfYear);
}
Ve.ISO_8601 = function() {
};
Ve.RFC_2822 = function() {
};
function Kp(e) {
  if (e._f === Ve.ISO_8601) {
    ZS(e);
    return;
  }
  if (e._f === Ve.RFC_2822) {
    zS(e);
    return;
  }
  e._a = [], Et(e).empty = !0;
  var t = "" + e._i, r, o, n, a, l, i = t.length, s = 0, u, c;
  for (n = ES(e._f, e._locale).match(Np) || [], c = n.length, r = 0; r < c; r++)
    a = n[r], o = (t.match(xA(a, e)) || [])[0], o && (l = t.substr(0, t.indexOf(o)), l.length > 0 && Et(e).unusedInput.push(l), t = t.slice(
      t.indexOf(o) + o.length
    ), s += o.length), Ts[a] ? (o ? Et(e).empty = !1 : Et(e).unusedTokens.push(a), SA(a, o, e)) : e._strict && !o && Et(e).unusedTokens.push(a);
  Et(e).charsLeftOver = i - s, t.length > 0 && Et(e).unusedInput.push(t), e._a[to] <= 12 && Et(e).bigHour === !0 && e._a[to] > 0 && (Et(e).bigHour = void 0), Et(e).parsedDateParts = e._a.slice(0), Et(e).meridiem = e._meridiem, e._a[to] = K2(
    e._locale,
    e._a[to],
    e._meridiem
  ), u = Et(e).era, u !== null && (e._a[Vr] = e._locale.erasConvertYear(u, e._a[Vr])), Yp(e), Wp(e);
}
function K2(e, t, r) {
  var o;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (o = e.isPM(r), o && t < 12 && (t += 12), !o && t === 12 && (t = 0)), t);
}
function Q2(e) {
  var t, r, o, n, a, l, i = !1, s = {}, u = e._f.length;
  if (u === 0) {
    Et(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (n = 0; n < u; n++)
    a = 0, l = !1, t = Ep({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._defaultDatePartsNow = s, t._f = e._f[n], Kp(t), Lp(t) && (l = !0), a += Et(t).charsLeftOver, a += Et(t).unusedTokens.length * 10, Et(t).score = a, i ? a < o && (o = a, r = t) : (o == null || a < o || l) && (o = a, r = t, l && (i = !0));
  ha(e, r || t);
}
function j2(e) {
  if (!e._d) {
    var t = Op(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = $S(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(o) {
        return o && parseInt(o, 10);
      }
    ), Yp(e);
  }
}
function Z2(e) {
  var t = new iu(Wp(qS(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function qS(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || Za(e._l), t === null || r === void 0 && t === "" ? lu({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), cn(t) ? new iu(Wp(t)) : (au(t) ? e._d = t : Qn(r) ? Q2(e) : r ? Kp(e) : z2(e), Lp(e) || (e._d = null), e));
}
function z2(e) {
  var t = e._i;
  Yo(t) ? e._d = new Date(Ve.now()) : au(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? U2(e) : Qn(t) ? (e._a = $S(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), Yp(e)) : oi(t) ? j2(e) : Xa(t) ? e._d = new Date(t) : Ve.createFromInputFallback(e);
}
function JS(e, t, r, o, n) {
  var a = {};
  return (t === !0 || t === !1) && (o = t, t = void 0), (r === !0 || r === !1) && (o = r, r = void 0), (oi(e) && Cp(e) || Qn(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = n, a._l = r, a._i = e, a._f = t, a._strict = o, Z2(a);
}
function Ar(e, t, r, o) {
  return JS(e, t, r, o, !1);
}
var q2 = Dn(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ar.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : lu();
  }
), J2 = Dn(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ar.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : lu();
  }
);
function eb(e, t) {
  var r, o;
  if (t.length === 1 && Qn(t[0]) && (t = t[0]), !t.length)
    return Ar();
  for (o = 0; o < t.length; ++o)
    if (cn(t[o])) {
      r = t[o];
      break;
    }
  if (!r)
    return lu();
  for (++o; o < t.length; ++o)
    cn(t[o]) && (!t[o].isValid() || t[o][e](r)) && (r = t[o]);
  return r;
}
function eP() {
  var e = [].slice.call(arguments, 0);
  return eb("isBefore", e);
}
function tP() {
  var e = [].slice.call(arguments, 0);
  return eb("isAfter", e);
}
var rP = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Ad = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function oP(e) {
  var t, r = !1, o, n = Ad.length;
  for (t in e)
    if (Dt(e, t) && !(Ir.call(Ad, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (o = 0; o < n; ++o)
    if (e[Ad[o]]) {
      if (r)
        return !1;
      parseFloat(e[Ad[o]]) !== Ot(e[Ad[o]]) && (r = !0);
    }
  return !0;
}
function nP() {
  return this._isValid;
}
function aP() {
  return zn(NaN);
}
function cm(e) {
  var t = Op(e), r = t.year || 0, o = t.quarter || 0, n = t.month || 0, a = t.week || t.isoWeek || 0, l = t.day || 0, i = t.hour || 0, s = t.minute || 0, u = t.second || 0, c = t.millisecond || 0;
  this._isValid = oP(t), this._milliseconds = +c + u * 1e3 + // 1000
  s * 6e4 + // 1000 * 60
  i * 1e3 * 60 * 60, this._days = +l + a * 7, this._months = +n + o * 3 + r * 12, this._data = {}, this._locale = Za(), this._bubble();
}
function fc(e) {
  return e instanceof cm;
}
function Bf(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function lP(e, t, r) {
  var o = Math.min(e.length, t.length), n = Math.abs(e.length - t.length), a = 0, l;
  for (l = 0; l < o; l++)
    Ot(e[l]) !== Ot(t[l]) && a++;
  return a + n;
}
function tb(e, t) {
  pt(e, 0, 0, function() {
    var r = this.utcOffset(), o = "+";
    return r < 0 && (r = -r, o = "-"), o + Ln(~~(r / 60), 2) + t + Ln(~~r % 60, 2);
  });
}
tb("Z", ":");
tb("ZZ", "");
it("Z", sm);
it("ZZ", sm);
gr(["Z", "ZZ"], function(e, t, r) {
  var o = Qp(sm, e);
  r._useUTC = !0, r._tzm = o, o === null && (Et(r).invalidOffset = e);
});
var iP = /([\+\-]|\d\d)/gi;
function Qp(e, t) {
  var r = (t || "").match(e), o, n, a;
  return r === null || (o = r[r.length - 1] || [], n = (o + "").match(iP) || ["-", 0, 0], a = +(n[1] * 60) + Ot(n[2]), Ot(n[2]) > 59 || (n[0] === "+" ? a > 840 : a > 720)) ? null : a === 0 ? 0 : n[0] === "+" ? a : -a;
}
function jp(e, t) {
  var r, o;
  return t._isUTC ? (r = t.clone(), o = (cn(e) || au(e) ? e.valueOf() : Ar(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + o), Ve.updateOffset(r, !1), r) : Ar(e).local();
}
function If(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
Ve.updateOffset = function() {
};
function sP(e, t, r) {
  var o = this._offset || 0, n;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Qp(sm, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (n = If(this)), this._offset = e, this._isUTC = !0, n != null && this.add(n, "m"), o !== e && (!t || this._changeInProgress ? nb(
      this,
      zn(e - o, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, Ve.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? o : If(this);
}
function dP(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function uP(e) {
  return this.utcOffset(0, e);
}
function cP(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(If(this), "m")), this;
}
function mP() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Qp(pA, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function gP(e) {
  return this.isValid() ? (e = e ? Ar(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function fP() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function pP() {
  if (!Yo(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return Ep(e, this), e = qS(e), e._a ? (t = e._isUTC ? _a(e._a) : Ar(e._a), this._isDSTShifted = this.isValid() && lP(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function hP() {
  return this.isValid() ? !this._isUTC : !1;
}
function xP() {
  return this.isValid() ? this._isUTC : !1;
}
function rb() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var vP = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, SP = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function zn(e, t) {
  var r = e, o = null, n, a, l;
  return fc(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Xa(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (o = vP.exec(e)) ? (n = o[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: Ot(o[Qo]) * n,
    h: Ot(o[to]) * n,
    m: Ot(o[Pn]) * n,
    s: Ot(o[Ba]) * n,
    ms: Ot(Bf(o[jl] * 1e3)) * n
    // the millisecond decimal point is included in the match
  }) : (o = SP.exec(e)) ? (n = o[1] === "-" ? -1 : 1, r = {
    y: Ul(o[2], n),
    M: Ul(o[3], n),
    w: Ul(o[4], n),
    d: Ul(o[5], n),
    h: Ul(o[6], n),
    m: Ul(o[7], n),
    s: Ul(o[8], n)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (l = bP(
    Ar(r.from),
    Ar(r.to)
  ), r = {}, r.ms = l.milliseconds, r.M = l.months), a = new cm(r), fc(e) && Dt(e, "_locale") && (a._locale = e._locale), fc(e) && Dt(e, "_isValid") && (a._isValid = e._isValid), a;
}
zn.fn = cm.prototype;
zn.invalid = aP;
function Ul(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function o1(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function bP(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = jp(t, e), e.isBefore(t) ? r = o1(e, t) : (r = o1(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function ob(e, t) {
  return function(r, o) {
    var n, a;
    return o !== null && !isNaN(+o) && (LS(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = o, o = a), n = zn(r, o), nb(this, n, e), this;
  };
}
function nb(e, t, r, o) {
  var n = t._milliseconds, a = Bf(t._days), l = Bf(t._months);
  e.isValid() && (o = o ?? !0, l && RS(e, Wd(e, "Month") + l * r), a && GS(e, "Date", Wd(e, "Date") + a * r), n && e._d.setTime(e._d.valueOf() + n * r), o && Ve.updateOffset(e, a || l));
}
var yP = ob(1, "add"), wP = ob(-1, "subtract");
function ab(e) {
  return typeof e == "string" || e instanceof String;
}
function _P(e) {
  return cn(e) || au(e) || ab(e) || Xa(e) || AP(e) || TP(e) || e === null || e === void 0;
}
function TP(e) {
  var t = oi(e) && !Cp(e), r = !1, o = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], n, a, l = o.length;
  for (n = 0; n < l; n += 1)
    a = o[n], r = r || Dt(e, a);
  return t && r;
}
function AP(e) {
  var t = Qn(e), r = !1;
  return t && (r = e.filter(function(o) {
    return !Xa(o) && ab(e);
  }).length === 0), t && r;
}
function PP(e) {
  var t = oi(e) && !Cp(e), r = !1, o = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], n, a;
  for (n = 0; n < o.length; n += 1)
    a = o[n], r = r || Dt(e, a);
  return t && r;
}
function MP(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function $P(e, t) {
  arguments.length === 1 && (arguments[0] ? _P(arguments[0]) ? (e = arguments[0], t = void 0) : PP(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || Ar(), o = jp(r, this).startOf("day"), n = Ve.calendarFormat(this, o) || "sameElse", a = t && (Ta(t[n]) ? t[n].call(this, r) : t[n]);
  return this.format(
    a || this.localeData().calendar(n, this, Ar(r))
  );
}
function CP() {
  return new iu(this);
}
function LP(e, t) {
  var r = cn(e) ? e : Ar(e);
  return this.isValid() && r.isValid() ? (t = kn(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function EP(e, t) {
  var r = cn(e) ? e : Ar(e);
  return this.isValid() && r.isValid() ? (t = kn(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function OP(e, t, r, o) {
  var n = cn(e) ? e : Ar(e), a = cn(t) ? t : Ar(t);
  return this.isValid() && n.isValid() && a.isValid() ? (o = o || "()", (o[0] === "(" ? this.isAfter(n, r) : !this.isBefore(n, r)) && (o[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function NP(e, t) {
  var r = cn(e) ? e : Ar(e), o;
  return this.isValid() && r.isValid() ? (t = kn(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (o = r.valueOf(), this.clone().startOf(t).valueOf() <= o && o <= this.clone().endOf(t).valueOf())) : !1;
}
function DP(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function kP(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function GP(e, t, r) {
  var o, n, a;
  if (!this.isValid())
    return NaN;
  if (o = jp(e, this), !o.isValid())
    return NaN;
  switch (n = (o.utcOffset() - this.utcOffset()) * 6e4, t = kn(t), t) {
    case "year":
      a = pc(this, o) / 12;
      break;
    case "month":
      a = pc(this, o);
      break;
    case "quarter":
      a = pc(this, o) / 3;
      break;
    case "second":
      a = (this - o) / 1e3;
      break;
    // 1000
    case "minute":
      a = (this - o) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      a = (this - o) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      a = (this - o - n) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      a = (this - o - n) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      a = this - o;
  }
  return r ? a : yn(a);
}
function pc(e, t) {
  if (e.date() < t.date())
    return -pc(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), o = e.clone().add(r, "months"), n, a;
  return t - o < 0 ? (n = e.clone().add(r - 1, "months"), a = (t - o) / (o - n)) : (n = e.clone().add(r + 1, "months"), a = (t - o) / (n - o)), -(r + a) || 0;
}
Ve.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
Ve.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function BP() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function IP(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? gc(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Ta(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", gc(r, "Z")) : gc(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function RP() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, o, n, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', o = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + o + n + a);
}
function FP(e) {
  e || (e = this.isUtc() ? Ve.defaultFormatUtc : Ve.defaultFormat);
  var t = gc(this, e);
  return this.localeData().postformat(t);
}
function VP(e, t) {
  return this.isValid() && (cn(e) && e.isValid() || Ar(e).isValid()) ? zn({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function HP(e) {
  return this.from(Ar(), e);
}
function UP(e, t) {
  return this.isValid() && (cn(e) && e.isValid() || Ar(e).isValid()) ? zn({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function XP(e) {
  return this.to(Ar(), e);
}
function lb(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = Za(e), t != null && (this._locale = t), this);
}
var ib = Dn(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function sb() {
  return this._locale;
}
var $c = 1e3, As = 60 * $c, Cc = 60 * As, db = (365 * 400 + 97) * 24 * Cc;
function Ps(e, t) {
  return (e % t + t) % t;
}
function ub(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - db : new Date(e, t, r).valueOf();
}
function cb(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - db : Date.UTC(e, t, r);
}
function WP(e) {
  var t, r;
  if (e = kn(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? cb : ub, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Ps(
        t + (this._isUTC ? 0 : this.utcOffset() * As),
        Cc
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Ps(t, As);
      break;
    case "second":
      t = this._d.valueOf(), t -= Ps(t, $c);
      break;
  }
  return this._d.setTime(t), Ve.updateOffset(this, !0), this;
}
function YP(e) {
  var t, r;
  if (e = kn(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? cb : ub, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += Cc - Ps(
        t + (this._isUTC ? 0 : this.utcOffset() * As),
        Cc
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += As - Ps(t, As) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += $c - Ps(t, $c) - 1;
      break;
  }
  return this._d.setTime(t), Ve.updateOffset(this, !0), this;
}
function KP() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function QP() {
  return Math.floor(this.valueOf() / 1e3);
}
function jP() {
  return new Date(this.valueOf());
}
function ZP() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function zP() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function qP() {
  return this.isValid() ? this.toISOString() : null;
}
function JP() {
  return Lp(this);
}
function eM() {
  return ha({}, Et(this));
}
function tM() {
  return Et(this).overflow;
}
function rM() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
pt("N", 0, 0, "eraAbbr");
pt("NN", 0, 0, "eraAbbr");
pt("NNN", 0, 0, "eraAbbr");
pt("NNNN", 0, 0, "eraName");
pt("NNNNN", 0, 0, "eraNarrow");
pt("y", ["y", 1], "yo", "eraYear");
pt("y", ["yy", 2], 0, "eraYear");
pt("y", ["yyy", 3], 0, "eraYear");
pt("y", ["yyyy", 4], 0, "eraYear");
it("N", Zp);
it("NN", Zp);
it("NNN", Zp);
it("NNNN", gM);
it("NNNNN", fM);
gr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, o) {
    var n = r._locale.erasParse(e, o, r._strict);
    n ? Et(r).era = n : Et(r).invalidEra = e;
  }
);
it("y", qs);
it("yy", qs);
it("yyy", qs);
it("yyyy", qs);
it("yo", pM);
gr(["y", "yy", "yyy", "yyyy"], Vr);
gr(["yo"], function(e, t, r, o) {
  var n;
  r._locale._eraYearOrdinalRegex && (n = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[Vr] = r._locale.eraYearOrdinalParse(e, n) : t[Vr] = parseInt(e, 10);
});
function oM(e, t) {
  var r, o, n, a = this._eras || Za("en")._eras;
  for (r = 0, o = a.length; r < o; ++r)
    switch (typeof a[r].since === "string" && (n = Ve(a[r].since).startOf("day"), a[r].since = n.valueOf()), typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        n = Ve(a[r].until).startOf("day").valueOf(), a[r].until = n.valueOf();
        break;
    }
  return a;
}
function nM(e, t, r) {
  var o, n, a = this.eras(), l, i, s;
  for (e = e.toUpperCase(), o = 0, n = a.length; o < n; ++o)
    if (l = a[o].name.toUpperCase(), i = a[o].abbr.toUpperCase(), s = a[o].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (i === e)
            return a[o];
          break;
        case "NNNN":
          if (l === e)
            return a[o];
          break;
        case "NNNNN":
          if (s === e)
            return a[o];
          break;
      }
    else if ([l, i, s].indexOf(e) >= 0)
      return a[o];
}
function aM(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? Ve(e.since).year() : Ve(e.since).year() + (t - e.offset) * r;
}
function lM() {
  var e, t, r, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), o[e].since <= r && r <= o[e].until || o[e].until <= r && r <= o[e].since)
      return o[e].name;
  return "";
}
function iM() {
  var e, t, r, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), o[e].since <= r && r <= o[e].until || o[e].until <= r && r <= o[e].since)
      return o[e].narrow;
  return "";
}
function sM() {
  var e, t, r, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), o[e].since <= r && r <= o[e].until || o[e].until <= r && r <= o[e].since)
      return o[e].abbr;
  return "";
}
function dM() {
  var e, t, r, o, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = n[e].since <= n[e].until ? 1 : -1, o = this.clone().startOf("day").valueOf(), n[e].since <= o && o <= n[e].until || n[e].until <= o && o <= n[e].since)
      return (this.year() - Ve(n[e].since).year()) * r + n[e].offset;
  return this.year();
}
function uM(e) {
  return Dt(this, "_erasNameRegex") || zp.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function cM(e) {
  return Dt(this, "_erasAbbrRegex") || zp.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function mM(e) {
  return Dt(this, "_erasNarrowRegex") || zp.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Zp(e, t) {
  return t.erasAbbrRegex(e);
}
function gM(e, t) {
  return t.erasNameRegex(e);
}
function fM(e, t) {
  return t.erasNarrowRegex(e);
}
function pM(e, t) {
  return t._eraYearOrdinalRegex || qs;
}
function zp() {
  var e = [], t = [], r = [], o = [], n, a, l, i, s, u = this.eras();
  for (n = 0, a = u.length; n < a; ++n)
    l = Fa(u[n].name), i = Fa(u[n].abbr), s = Fa(u[n].narrow), t.push(l), e.push(i), r.push(s), o.push(l), o.push(i), o.push(s);
  this._erasRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
pt(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
pt(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function mm(e, t) {
  pt(0, [e, e.length], 0, t);
}
mm("gggg", "weekYear");
mm("ggggg", "weekYear");
mm("GGGG", "isoWeekYear");
mm("GGGGG", "isoWeekYear");
it("G", im);
it("g", im);
it("GG", _r, fn);
it("gg", _r, fn);
it("GGGG", Gp, Dp);
it("gggg", Gp, Dp);
it("GGGGG", lm, nm);
it("ggggg", lm, nm);
ed(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, o) {
    t[o.substr(0, 2)] = Ot(e);
  }
);
ed(["gg", "GG"], function(e, t, r, o) {
  t[o] = Ve.parseTwoDigitYear(e);
});
function hM(e) {
  return mb.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function xM(e) {
  return mb.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function vM() {
  return Va(this.year(), 1, 4);
}
function SM() {
  return Va(this.isoWeekYear(), 1, 4);
}
function bM() {
  var e = this.localeData()._week;
  return Va(this.year(), e.dow, e.doy);
}
function yM() {
  var e = this.localeData()._week;
  return Va(this.weekYear(), e.dow, e.doy);
}
function mb(e, t, r, o, n) {
  var a;
  return e == null ? Hp(this, o, n).year : (a = Va(e, o, n), t > a && (t = a), wM.call(this, e, t, r, o, n));
}
function wM(e, t, r, o, n) {
  var a = WS(e, t, r, o, n), l = ui(a.year, 0, a.dayOfYear);
  return this.year(l.getUTCFullYear()), this.month(l.getUTCMonth()), this.date(l.getUTCDate()), this;
}
pt("Q", 0, "Qo", "quarter");
it("Q", OS);
gr("Q", function(e, t) {
  t[nn] = (Ot(e) - 1) * 3;
});
function _M(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
pt("D", ["DD", 2], "Do", "date");
it("D", _r, Js);
it("DD", _r, fn);
it("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
gr(["D", "DD"], Qo);
gr("Do", function(e, t) {
  t[Qo] = Ot(e.match(_r)[0]);
});
var gb = td("Date", !0);
pt("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
it("DDD", am);
it("DDDD", NS);
gr(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = Ot(e);
});
function TM(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
pt("m", ["mm", 2], 0, "minute");
it("m", _r, Bp);
it("mm", _r, fn);
gr(["m", "mm"], Pn);
var AM = td("Minutes", !1);
pt("s", ["ss", 2], 0, "second");
it("s", _r, Bp);
it("ss", _r, fn);
gr(["s", "ss"], Ba);
var PM = td("Seconds", !1);
pt("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
pt(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
pt(0, ["SSS", 3], 0, "millisecond");
pt(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
pt(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
pt(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
pt(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
pt(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
pt(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
it("S", am, OS);
it("SS", am, fn);
it("SSS", am, NS);
var pl, fb;
for (pl = "SSSS"; pl.length <= 9; pl += "S")
  it(pl, qs);
function MM(e, t) {
  t[jl] = Ot(("0." + e) * 1e3);
}
for (pl = "S"; pl.length <= 9; pl += "S")
  gr(pl, MM);
fb = td("Milliseconds", !1);
pt("z", 0, 0, "zoneAbbr");
pt("zz", 0, 0, "zoneName");
function $M() {
  return this._isUTC ? "UTC" : "";
}
function CM() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var Ye = iu.prototype;
Ye.add = yP;
Ye.calendar = $P;
Ye.clone = CP;
Ye.diff = GP;
Ye.endOf = YP;
Ye.format = FP;
Ye.from = VP;
Ye.fromNow = HP;
Ye.to = UP;
Ye.toNow = XP;
Ye.get = _A;
Ye.invalidAt = tM;
Ye.isAfter = LP;
Ye.isBefore = EP;
Ye.isBetween = OP;
Ye.isSame = NP;
Ye.isSameOrAfter = DP;
Ye.isSameOrBefore = kP;
Ye.isValid = JP;
Ye.lang = ib;
Ye.locale = lb;
Ye.localeData = sb;
Ye.max = J2;
Ye.min = q2;
Ye.parsingFlags = eM;
Ye.set = TA;
Ye.startOf = WP;
Ye.subtract = wP;
Ye.toArray = ZP;
Ye.toObject = zP;
Ye.toDate = jP;
Ye.toISOString = IP;
Ye.inspect = RP;
typeof Symbol < "u" && Symbol.for != null && (Ye[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
Ye.toJSON = qP;
Ye.toString = BP;
Ye.unix = QP;
Ye.valueOf = KP;
Ye.creationData = rM;
Ye.eraName = lM;
Ye.eraNarrow = iM;
Ye.eraAbbr = sM;
Ye.eraYear = dM;
Ye.year = kS;
Ye.isLeapYear = wA;
Ye.weekYear = hM;
Ye.isoWeekYear = xM;
Ye.quarter = Ye.quarters = _M;
Ye.month = FS;
Ye.daysInMonth = DA;
Ye.week = Ye.weeks = b2;
Ye.isoWeek = Ye.isoWeeks = y2;
Ye.weeksInYear = bM;
Ye.weeksInWeekYear = yM;
Ye.isoWeeksInYear = vM;
Ye.isoWeeksInISOWeekYear = SM;
Ye.date = gb;
Ye.day = Ye.days = ZA;
Ye.weekday = zA;
Ye.isoWeekday = qA;
Ye.dayOfYear = TM;
Ye.hour = Ye.hours = A2;
Ye.minute = Ye.minutes = AM;
Ye.second = Ye.seconds = PM;
Ye.millisecond = Ye.milliseconds = fb;
Ye.utcOffset = sP;
Ye.utc = uP;
Ye.local = cP;
Ye.parseZone = mP;
Ye.hasAlignedHourOffset = gP;
Ye.isDST = fP;
Ye.isLocal = hP;
Ye.isUtcOffset = xP;
Ye.isUtc = rb;
Ye.isUTC = rb;
Ye.zoneAbbr = $M;
Ye.zoneName = CM;
Ye.dates = Dn(
  "dates accessor is deprecated. Use date instead.",
  gb
);
Ye.months = Dn(
  "months accessor is deprecated. Use month instead",
  FS
);
Ye.years = Dn(
  "years accessor is deprecated. Use year instead",
  kS
);
Ye.zone = Dn(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  dP
);
Ye.isDSTShifted = Dn(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  pP
);
function LM(e) {
  return Ar(e * 1e3);
}
function EM() {
  return Ar.apply(null, arguments).parseZone();
}
function pb(e) {
  return e;
}
var Zt = Vp.prototype;
Zt.calendar = n2;
Zt.longDateFormat = l2;
Zt.invalidDate = s2;
Zt.ordinal = c2;
Zt.preparse = pb;
Zt.postformat = pb;
Zt.relativeTime = g2;
Zt.pastFuture = f2;
Zt.set = r2;
Zt.eras = oM;
Zt.erasParse = nM;
Zt.erasConvertYear = aM;
Zt.erasAbbrRegex = cM;
Zt.erasNameRegex = uM;
Zt.erasNarrowRegex = mM;
Zt.months = LA;
Zt.monthsShort = EA;
Zt.monthsParse = NA;
Zt.monthsRegex = GA;
Zt.monthsShortRegex = kA;
Zt.week = h2;
Zt.firstDayOfYear = S2;
Zt.firstDayOfWeek = v2;
Zt.weekdays = WA;
Zt.weekdaysMin = KA;
Zt.weekdaysShort = YA;
Zt.weekdaysParse = jA;
Zt.weekdaysRegex = JA;
Zt.weekdaysShortRegex = e2;
Zt.weekdaysMinRegex = t2;
Zt.isPM = _2;
Zt.meridiem = P2;
function Lc(e, t, r, o) {
  var n = Za(), a = _a().set(o, t);
  return n[r](a, e);
}
function hb(e, t, r) {
  if (Xa(e) && (t = e, e = void 0), e = e || "", t != null)
    return Lc(e, t, r, "month");
  var o, n = [];
  for (o = 0; o < 12; o++)
    n[o] = Lc(e, o, r, "month");
  return n;
}
function qp(e, t, r, o) {
  typeof e == "boolean" ? (Xa(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, Xa(t) && (r = t, t = void 0), t = t || "");
  var n = Za(), a = e ? n._week.dow : 0, l, i = [];
  if (r != null)
    return Lc(t, (r + a) % 7, o, "day");
  for (l = 0; l < 7; l++)
    i[l] = Lc(t, (l + a) % 7, o, "day");
  return i;
}
function OM(e, t) {
  return hb(e, t, "months");
}
function NM(e, t) {
  return hb(e, t, "monthsShort");
}
function DM(e, t, r) {
  return qp(e, t, r, "weekdays");
}
function kM(e, t, r) {
  return qp(e, t, r, "weekdaysShort");
}
function GM(e, t, r) {
  return qp(e, t, r, "weekdaysMin");
}
Tl("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = Ot(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
Ve.lang = Dn(
  "moment.lang is deprecated. Use moment.locale instead.",
  Tl
);
Ve.langData = Dn(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Za
);
var Na = Math.abs;
function BM() {
  var e = this._data;
  return this._milliseconds = Na(this._milliseconds), this._days = Na(this._days), this._months = Na(this._months), e.milliseconds = Na(e.milliseconds), e.seconds = Na(e.seconds), e.minutes = Na(e.minutes), e.hours = Na(e.hours), e.months = Na(e.months), e.years = Na(e.years), this;
}
function xb(e, t, r, o) {
  var n = zn(t, r);
  return e._milliseconds += o * n._milliseconds, e._days += o * n._days, e._months += o * n._months, e._bubble();
}
function IM(e, t) {
  return xb(this, e, t, 1);
}
function RM(e, t) {
  return xb(this, e, t, -1);
}
function n1(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function FM() {
  var e = this._milliseconds, t = this._days, r = this._months, o = this._data, n, a, l, i, s;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += n1(Rf(r) + t) * 864e5, t = 0, r = 0), o.milliseconds = e % 1e3, n = yn(e / 1e3), o.seconds = n % 60, a = yn(n / 60), o.minutes = a % 60, l = yn(a / 60), o.hours = l % 24, t += yn(l / 24), s = yn(vb(t)), r += s, t -= n1(Rf(s)), i = yn(r / 12), r %= 12, o.days = t, o.months = r, o.years = i, this;
}
function vb(e) {
  return e * 4800 / 146097;
}
function Rf(e) {
  return e * 146097 / 4800;
}
function VM(e) {
  if (!this.isValid())
    return NaN;
  var t, r, o = this._milliseconds;
  if (e = kn(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + o / 864e5, r = this._months + vb(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(Rf(this._months)), e) {
      case "week":
        return t / 7 + o / 6048e5;
      case "day":
        return t + o / 864e5;
      case "hour":
        return t * 24 + o / 36e5;
      case "minute":
        return t * 1440 + o / 6e4;
      case "second":
        return t * 86400 + o / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(t * 864e5) + o;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function za(e) {
  return function() {
    return this.as(e);
  };
}
var Sb = za("ms"), HM = za("s"), UM = za("m"), XM = za("h"), WM = za("d"), YM = za("w"), KM = za("M"), QM = za("Q"), jM = za("y"), ZM = Sb;
function zM() {
  return zn(this);
}
function qM(e) {
  return e = kn(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Ti(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var JM = Ti("milliseconds"), e$ = Ti("seconds"), t$ = Ti("minutes"), r$ = Ti("hours"), o$ = Ti("days"), n$ = Ti("months"), a$ = Ti("years");
function l$() {
  return yn(this.days() / 7);
}
var ka = Math.round, ys = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function i$(e, t, r, o, n) {
  return US.call(
    n,
    t || 1,
    !!r,
    e,
    o
  );
}
function s$(e, t, r, o) {
  var n = zn(e).abs(), a = ka(n.as("s")), l = ka(n.as("m")), i = ka(n.as("h")), s = ka(n.as("d")), u = ka(n.as("M")), c = ka(n.as("w")), g = ka(n.as("y")), p = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || l <= 1 && ["m"] || l < r.m && ["mm", l] || i <= 1 && ["h"] || i < r.h && ["hh", i] || s <= 1 && ["d"] || s < r.d && ["dd", s];
  return r.w != null && (p = p || c <= 1 && ["w"] || c < r.w && ["ww", c]), p = p || u <= 1 && ["M"] || u < r.M && ["MM", u] || g <= 1 && ["y"] || ["yy", g], p[2] = t, p[3] = +e > 0, p[4] = o, i$.apply(null, p);
}
function d$(e) {
  return e === void 0 ? ka : typeof e == "function" ? (ka = e, !0) : !1;
}
function u$(e, t) {
  return ys[e] === void 0 ? !1 : t === void 0 ? ys[e] : (ys[e] = t, e === "s" && (ys.ss = t - 1), !0);
}
function c$(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, o = ys, n, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (o = ha(ha({}, ys), t || {}), t.s != null && t.ss == null && (o.ss = t.s - 1)), n = this.localeData(), a = s$(this, !r, o, n), r && (a = XS.call(n, +this, a)), n.postformat(a);
}
var Sg = Math.abs;
function Xi(e) {
  return (e > 0) - (e < 0) || +e;
}
function gm() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Sg(this._milliseconds) / 1e3, t = Sg(this._days), r = Sg(this._months), o, n, a, l, i = this.asSeconds(), s, u, c, g;
  return i ? (o = yn(e / 60), n = yn(o / 60), e %= 60, o %= 60, a = yn(r / 12), r %= 12, l = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", s = i < 0 ? "-" : "", u = Xi(this._months) !== Xi(i) ? "-" : "", c = Xi(this._days) !== Xi(i) ? "-" : "", g = Xi(this._milliseconds) !== Xi(i) ? "-" : "", s + "P" + (a ? u + a + "Y" : "") + (r ? u + r + "M" : "") + (t ? c + t + "D" : "") + (n || o || e ? "T" : "") + (n ? g + n + "H" : "") + (o ? g + o + "M" : "") + (e ? g + l + "S" : "")) : "P0D";
}
var Ht = cm.prototype;
Ht.isValid = nP;
Ht.abs = BM;
Ht.add = IM;
Ht.subtract = RM;
Ht.as = VM;
Ht.asMilliseconds = Sb;
Ht.asSeconds = HM;
Ht.asMinutes = UM;
Ht.asHours = XM;
Ht.asDays = WM;
Ht.asWeeks = YM;
Ht.asMonths = KM;
Ht.asQuarters = QM;
Ht.asYears = jM;
Ht.valueOf = ZM;
Ht._bubble = FM;
Ht.clone = zM;
Ht.get = qM;
Ht.milliseconds = JM;
Ht.seconds = e$;
Ht.minutes = t$;
Ht.hours = r$;
Ht.days = o$;
Ht.weeks = l$;
Ht.months = n$;
Ht.years = a$;
Ht.humanize = c$;
Ht.toISOString = gm;
Ht.toString = gm;
Ht.toJSON = gm;
Ht.locale = lb;
Ht.localeData = sb;
Ht.toIsoString = Dn(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  gm
);
Ht.lang = ib;
pt("X", 0, 0, "unix");
pt("x", 0, 0, "valueOf");
it("x", im);
it("X", hA);
gr("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
gr("x", function(e, t, r) {
  r._d = new Date(Ot(e));
});
Ve.version = "2.31.0";
dA(Ar);
Ve.fn = Ye;
Ve.min = eP;
Ve.max = tP;
Ve.now = rP;
Ve.utc = _a;
Ve.unix = LM;
Ve.months = OM;
Ve.isDate = au;
Ve.locale = Tl;
Ve.invalid = lu;
Ve.duration = zn;
Ve.isMoment = cn;
Ve.weekdays = DM;
Ve.parseZone = EM;
Ve.localeData = Za;
Ve.isDuration = fc;
Ve.monthsShort = NM;
Ve.weekdaysMin = GM;
Ve.defineLocale = Xp;
Ve.updateLocale = L2;
Ve.locales = E2;
Ve.weekdaysShort = kM;
Ve.normalizeUnits = kn;
Ve.relativeTimeRounding = d$;
Ve.relativeTimeThreshold = u$;
Ve.calendarFormat = MP;
Ve.prototype = Ye;
Ve.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const m$ = (e) => e.charAt(0).toUpperCase() + e.slice(1), g$ = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z])([A-Z][a-z])/g, "$1-$2").replace(/[_\s]+/g, "-").toLowerCase(), f$ = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1_$2").replace(/([A-Z])([A-Z][a-z])/g, "$1_$2").toLowerCase(), p$ = (e) => e.toLowerCase().replace(/([-_][a-z])/g, (t) => t.toUpperCase().replace("-", "").replace("_", "")), h$ = (e) => e.toLowerCase().replace(/\s+/g, "_"), x$ = (e, t = "DD/MM/YYYY") => {
  const r = Ve(e);
  if (!r.isValid()) return "";
  const o = Ve();
  return r.isSame(o, "day") ? `Today at ${r.format("hh:mma")}` : r.format(t);
}, Ec = (e) => {
  if (e === null || typeof e != "object")
    return e;
  const t = Tc(e) ? Xd(e) : e;
  return Array.isArray(t) ? t.map((r) => Ec(r)) : Object.fromEntries(
    Object.entries(t).map(([r, o]) => [r, Ec(o)])
  );
}, v$ = (e) => String(e ?? "").replace(
  /[&<>"']/g,
  (t) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  })[t]
), S$ = (e, t = 2) => e ? e.trim().split(/\s+/).slice(0, t).map((o) => o[0]?.toUpperCase() ?? "").join("") : "", b$ = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}, En = (e) => JSON.stringify(e) === "{}", Oc = (e, t) => {
  if (Object.is(e, t))
    return !0;
  if (e === null || t === null || typeof e != "object" || typeof t != "object")
    return !1;
  if (Tc(e) && (e = Xd(e)), Tc(t) && (t = Xd(t)), Array.isArray(e) || Array.isArray(t)) {
    if (!Array.isArray(e) || !Array.isArray(t) || e.length !== t.length)
      return !1;
    for (let a = 0; a < e.length; a++)
      if (!Oc(e[a], t[a]))
        return !1;
    return !0;
  }
  const r = e, o = t, n = Object.keys(r);
  if (n.length !== Object.keys(o).length)
    return !1;
  for (const a of n)
    if (!(a in o) || !Oc(r[a], o[a]))
      return !1;
  return !0;
}, Jp = (e) => typeof e == "object" && !Array.isArray(e) && e !== null, y$ = (e) => /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(e), e0 = (e) => {
  try {
    return !!new URL(e);
  } catch {
    return !1;
  }
}, xa = (e, t) => {
  const r = {
    ...e,
    ...t
  };
  for (const o of Object.keys(r))
    typeof r[o] == "object" && r[o] !== null && e[o] && t[o] && (r[o] = xa(e[o], t[o]));
  return r;
}, ci = (e) => {
  if (e = e || window.event, e instanceof KeyboardEvent) {
    const t = e.which ? e.which : e.keyCode;
    if (t != 46 && t > 31 && (t < 48 || t > 57))
      e.preventDefault();
    else
      return !0;
  } else
    return e.target.value % 1 === 0;
}, va = (e) => {
  if (e = e || window.event, e instanceof KeyboardEvent) {
    const t = e.which ? e.which : e.keyCode;
    if (!(t > 47 && t < 58))
      e.preventDefault();
    else
      return !0;
  } else
    return e.target.value % 1 === 0;
}, bb = (e) => {
  e = e || window.event;
  const t = e.which ? e.which : e.keyCode, r = String.fromCharCode(t), o = e.target.value;
  if (r === "-" && o.indexOf("-") === -1 || r === "." && o.indexOf(".") === -1 || t >= 48 && t <= 57)
    return !0;
  e.preventDefault();
}, w$ = (e, t) => {
  const r = {};
  for (const o in e) {
    const n = t[o] || o;
    r[n] = e[o];
  }
  return r;
}, _$ = (e) => new Promise((t) => setTimeout(t, e)), t0 = (e) => {
  if (typeof e == "string")
    try {
      e = JSON.parse(e);
    } catch {
      return e;
    }
  const t = {};
  for (const [r, o] of Object.entries(e))
    if (typeof o == "string")
      try {
        t[r] = t0(JSON.parse(o));
      } catch {
        t[r] = o;
      }
    else
      t[r] = o;
  return t;
}, hs = (e, ...t) => e.replace(/{(\d+)}/g, function(r, o) {
  return typeof t[o] < "u" ? t[o] : r;
}), T$ = (e, t = 50) => {
  const r = e.trim();
  if (r.length <= t) return r;
  const o = r.slice(0, t);
  return o.slice(0, o.lastIndexOf(" ")) + "...";
}, ni = (e) => e.replace(/<br\s*\/?>/gi, ""), A$ = (e) => {
  if (!e)
    return null;
  try {
    const t = new URL(String(e), window.location.origin);
    return t.protocol === "http:" || t.protocol === "https:" ? t.href : null;
  } catch {
    return null;
  }
}, Hpe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalizeFirstLetter: m$,
  convertCamelToKebab: g$,
  convertCamelToSnake: f$,
  convertSnakeToCamel: p$,
  convertStringToSnake: h$,
  dateFormat: x$,
  deepClone: Ec,
  escapeHtml: v$,
  getInitialChars: S$,
  isArrayEqual: b$,
  isEmptyObject: En,
  isEqualVal: Oc,
  isObject: Jp,
  isValidDateFormat: y$,
  isValidUrl: e0,
  objectMerge: xa,
  onlyDecimal: ci,
  onlyNumber: va,
  onlyPositiveOrNegativeDecimal: bb,
  renameObjKeys: w$,
  sleep: _$,
  smartParse: t0,
  stringFormat: hs,
  stringLimitWords: T$,
  stringRemoveBreak: ni,
  toSafeUrl: A$
}, Symbol.toStringTag, { value: "Module" })), P$ = (e) => {
  var t, r, o;
  for (r = 0, o = e.length; r < o; r++)
    if (t = e.charCodeAt(r), !(t > 47 && t < 58) && // numeric (0-9)
    !(t > 64 && t < 91) && // upper alpha (A-Z)
    !(t > 96 && t < 123))
      return !1;
  return !0;
}, M$ = (e) => !!/^[a-zA-Z0-9\s]+$/i.test(e), $$ = (e) => !!/^[a-zA-Z0-9\s!"#$%&'()*+,.\\/:;<=>?@^_`\][{|}~-]+$/i.test(e), C$ = (e) => /^[0-9,]+$/.test(e), L$ = (e) => {
  var t, r, o;
  for (r = 0, o = e.length; r < o; r++)
    if (t = e.charCodeAt(r), !(t > 47 && t < 58) && // numeric (0-9)
    !(t > 96 && t < 123))
      return !1;
  return !0;
}, E$ = (e) => !!e, O$ = (e) => !!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e), N$ = (e) => !!/^[0-9]+$/i.test(e), D$ = (e, t) => {
  let r = parseInt(t.split("-")[0]), o = parseInt(t.split("-")[1]);
  return parseInt(e) >= r && parseInt(e) <= o;
}, k$ = (e) => !!yb(e, 10), G$ = (e) => e0(e), a1 = /* @__PURE__ */ new Map(), B$ = (e, t, r) => {
  const o = `${t},${r}`;
  let n = a1.get(o);
  return n || (n = new RegExp(`^-?\\d{1,${t - r}}(?:\\.\\d{1,${r}})?$`), a1.set(o, n)), n.test(String(e).trim());
}, I$ = (e, t) => !(e.length > t), yb = (e, t) => !(e.length < t), R$ = { rules: { username: { required: !0 }, password: { required: !0, alpha_numeric_symbol: !0, minlength: 6 } }, messages: { english: { username: { required: "Please enter your username", minlength: "Enter at least {0} characters" }, password: { required: "Please insert your password", alpha_numeric_symbol: "Password must only contain characters or numbers.", minlength: "Enter at least {0} characters" } }, simplified: { username: { required: "用户名不能为空白", minlength: "用户名字数最少为 {0} 字" }, password: { required: "帐号密码不能为空白", alpha_numeric_symbol: "帐号密码只能包含字符或数字。", minlength: "帐号密码字数最少为 {0} 字" } } } }, F$ = { rules: { current_password: { required: !0, alpha_numeric_symbol: !0, minlength: 6 }, new_password: { required: !0, alpha_numeric_symbol: !0, minlength: 6 }, confirm_password: { required: !0, alpha_numeric_symbol: !0, minlength: 6 } }, messages: { english: { current_password: { required: "Please enter your current password", minlength: "Enter at least {0} characters" }, new_password: { required: "Please insert your new password", alpha_numeric_symbol: "Password must only contain characters or numbers.", minlength: "Enter at least {0} characters" }, confirm_password: { required: "Please confirm your new password", alpha_numeric_symbol: "Password must only contain characters or numbers.", minlength: "Enter at least {0} characters" } }, simplified: { current_password: { required: "请输入您当前的密码", minlength: "输入至少 {0} 个字符" }, new_password: { required: "请输入您的新密码", alpha_numeric_symbol: "密码只能包含字符或数字。", minlength: "输入至少 {0} 个字符" }, confirm_password: { required: "请确认您的新密码", alpha_numeric_symbol: "密码只能包含字符或数字。", minlength: "输入至少 {0} 个字符" } } } }, V$ = { rules: { new_password: { required: !0, alpha_numeric_symbol: !0, minlength: 6 }, confirm_password: { required: !0, alpha_numeric_symbol: !0, minlength: 6 } }, messages: { english: { new_password: { required: "Please insert your new password", alpha_numeric_symbol: "Password must only contain characters or numbers.", minlength: "Enter at least {0} characters" }, confirm_password: { required: "Please confirm your new password", alpha_numeric_symbol: "Password must only contain characters or numbers.", minlength: "Enter at least {0} characters" } }, simplified: { new_password: { required: "请输入您的新密码", alpha_numeric_symbol: "密码只能包含字符或数字。", minlength: "输入至少 {0} 个字符" }, confirm_password: { required: "请确认您的新密码", alpha_numeric_symbol: "密码只能包含字符或数字。", minlength: "输入至少 {0} 个字符" } } } }, H$ = {
  login: R$,
  changePassword: F$,
  firstLoginPassword: V$
};
var Xl = {};
const Zl = async (e, t, r, o) => {
  const n = document.getElementById(t);
  if (typeof n < "u" && n != null) {
    if (document.body.contains(n)) {
      const i = Array.from(n.elements);
      var a = {}, l = !1;
      for (let s of i) {
        const u = s.closest(".multiselect");
        if (!(u && u.hasAttribute("readonly") && u.getAttribute("readonly") == "true") && !s.readOnly && !(!("name" in s) || !s.name) && (s.tagName == "INPUT" || s.tagName == "TEXTAREA" || s.tagName == "SELECT")) {
          let c = await wb(s, e, {
            ...o,
            data: a,
            stores: r
          });
          if (c.status) {
            let g = "";
            if (s.type == "checkbox")
              if ("match" in o)
                if (s.name in o.match) {
                  let p = s.checked ? 1 : 0, h = o.match[s.name].find(
                    (v) => v.id === p
                  );
                  a[s.name] = h.code;
                } else
                  a[s.name] = !!s.checked;
              else
                s.value == "on" ? a[s.name] = !!s.checked : s.name in a ? s.checked && a[s.name].push(s.value) : s.checked && (a[s.name] = [], a[s.name].push(s.value));
            else s.type == "file" ? (g = s.files, "length" in g && g.length && (a[s.name] = g[0])) : (g = s.value || s.getAttribute("value"), g || (g = s.getAttribute("data-value")), "preAction" in o && o.preAction instanceof Function && (g = o.preAction(s.name, g)), g != null && (g || g.toString().length) && (s.type == "number" ? a[s.name] = parseInt(g) : s.type == "decimal" ? a[s.name] = parseFloat(g) : s.classList.contains("number_format_float") ? a[s.name] = parseFloat(g.replace(/,/g, "")) : a[s.name] = g), c?.nullable !== void 0 && c.nullable[s.name] && (a[s.name] = ""));
          } else
            l = !0;
        }
      }
      if (r.user.getTestMode() && (console.debug("data", a), console.debug("error", l)), !l)
        return a = xa(a, { locale: r.user.getLanguage() }), a;
    }
  } else
    r.action.setError({
      status: "500",
      message: "An internal error has occurred. Please contact your administrator!"
    });
  return !1;
}, U$ = async (e) => e == "authRules" ? H$ : {}, X$ = async (e, t) => await new Promise((r, o) => {
  t && Object.keys(t).length > 0 && "ruler" in t ? fetch(t.ruler.url + `?v=${Ve().format("YYMMDDss")}`).then((n) => n.json()).then((n) => {
    "extend" in t.ruler && t.ruler.extend ? r(xa(t.defaultRules[e], n[e])) : r(n[e]);
  }).catch((n) => {
    console.error(`${e} ruler loaded with an error,`, n), o(`${e} ruler loaded with an error,`);
  }) : r(t.defaultRules[e]);
}), wb = async (e, t, r) => {
  (!(r.action in Xl) || !Xl[r.action]) && ("defaultRuler" in r && (r.defaultRules = await U$(r.defaultRuler)), Xl[r.action] = await X$(t, r));
  const o = r && "language" in r ? r.language : r.stores.user.getLanguage();
  if (r && Object.keys(r).length > 0 && !("stores" in r))
    return {
      msg: "There are no action store found.",
      status: !1,
      error: {}
    };
  if (r.stores.action.setFormID(r.action), typeof Xl[r.action] == "string")
    return {
      msg: Xl[r.action],
      status: !1,
      error: {},
      nullable: {}
    };
  const n = Xl[r.action].rules, a = Xl[r.action].messages[o];
  var l = {}, i = {};
  if (r.stores.action.setRules(r.action, {
    rules: n,
    messages: a
  }), n[e.name] && e.type !== "hidden") {
    for (let s in n[e.name]) {
      let u = "", c = e.value ? e.value.length : 0;
      if (e.value || c && e.value == 0 ? u = e.value : (u = e instanceof HTMLInputElement ? e.getAttribute("value") : "", u || (u = e instanceof HTMLInputElement ? e.getAttribute("data-value") : "")), s == "required" && n[e.name][s]) {
        if ("accept" in n[e.name] && Array.isArray(n[e.name].accept) && (n[e.name].accept.includes(e.value) || n[e.name].accept.includes(String(e.value))))
          break;
        if (!E$(u)) {
          l[e.name] = a[e.name][s];
          break;
        }
      }
      if (!u) {
        n[e.name].nullable && (i[e.name] = !0);
        break;
      }
      if (s == "email" && !O$(u)) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "number" && !N$(u)) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "decimal") {
        const g = n[e.name].precision, p = n[e.name].scale;
        if (!B$(u, g, p)) {
          l[e.name] = hs(a[e.name][s], g, p);
          break;
        }
      }
      if (s == "phone" && !k$(u)) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "alpha_numeric" && !P$(u)) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "alpha_numeric_space" && !M$(u)) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "alpha_numeric_symbol" && !$$(u)) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "comma_numeric" && !C$(u)) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "lower_alpha_numeric" && !L$(u)) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "maxlength" && !I$(u, n[e.name][s])) {
        l[e.name] = hs(a[e.name][s], n[e.name][s]);
        break;
      }
      if (s == "minlength" && !yb(u, n[e.name][s])) {
        l[e.name] = hs(a[e.name][s], n[e.name][s]);
        break;
      }
      if (s == "equalTo" && u != r.data[n[e.name][s]]) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "range" && !D$(u, n[e.name][s])) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "url" && !G$(u)) {
        l[e.name] = a[e.name][s];
        break;
      }
      if (s == "checkUserName")
        break;
      if (e.type == "file") {
        const g = document.getElementById(e.name), p = g.files ? g.files[0] : null;
        if (p) {
          if (s == "accept" && "accept" in n[e.name]) {
            const h = n[e.name][s].split(","), v = p.name.split(".").pop();
            if (!h.includes(`.${v}`)) {
              l[e.name] = hs(
                a[e.name][s],
                `(${n[e.name][s]})`
              );
              break;
            }
          }
          if (s == "maxsize" && "maxsize" in n[e.name]) {
            const h = parseInt(g.getAttribute("maxsize"));
            if (p.size > h * 1024) {
              l[e.name] = hs(a[e.name][s], n[e.name][s]);
              break;
            }
          }
        }
      }
    }
    if (Object.keys(l).length > 0)
      return r.stores.action.setFormError(!0), r.stores.action.setFormErrorMessage(l), {
        msg: "There are one or more field having errors.",
        status: !1,
        error: l
      };
    r.stores.action.setFormError(!1), r.stores.action.setFormErrorMessage({});
  }
  return {
    msg: "Success",
    status: !0,
    error: {},
    nullable: i
  };
};
function _b(e, t, r) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : r;
  throw new TypeError("Private element is not present on this object");
}
function W$(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function l1(e, t) {
  return e.get(_b(e, t));
}
function Y$(e, t, r) {
  W$(e, t), t.set(e, r);
}
function K$(e, t, r) {
  return e.set(_b(e, t), r), r;
}
const Q$ = 100, gt = {}, j$ = () => {
  gt.previousActiveElement instanceof HTMLElement ? (gt.previousActiveElement.focus(), gt.previousActiveElement = null) : document.body && document.body.focus();
}, Z$ = (e) => new Promise((t) => {
  if (!e)
    return t();
  const r = window.scrollX, o = window.scrollY;
  gt.restoreFocusTimeout = setTimeout(() => {
    j$(), t();
  }, Q$), window.scrollTo(r, o);
}), Tb = "swal2-", z$ = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], Me = z$.reduce(
  (e, t) => (e[t] = Tb + t, e),
  /** @type {SwalClasses} */
  {}
), q$ = ["success", "warning", "info", "question", "error"], Nc = q$.reduce(
  (e, t) => (e[t] = Tb + t, e),
  /** @type {SwalIcons} */
  {}
), Ab = "SweetAlert2:", r0 = (e) => e.charAt(0).toUpperCase() + e.slice(1), Vo = (e) => {
  console.warn(`${Ab} ${typeof e == "object" ? e.join(" ") : e}`);
}, Ai = (e) => {
  console.error(`${Ab} ${e}`);
}, i1 = [], J$ = (e) => {
  i1.includes(e) || (i1.push(e), Vo(e));
}, Pb = (e, t = null) => {
  J$(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, fm = (e) => typeof e == "function" ? e() : e, o0 = (e) => e && typeof e.toPromise == "function", du = (e) => o0(e) ? e.toPromise() : Promise.resolve(e), n0 = (e) => e && Promise.resolve(e) === e, eC = () => navigator.userAgent.includes("Firefox"), Ho = () => document.body.querySelector(`.${Me.container}`), uu = (e) => {
  const t = Ho();
  return t ? t.querySelector(e) : null;
}, pn = (e) => uu(`.${e}`), Jt = () => pn(Me.popup), rd = () => pn(Me.icon), tC = () => pn(Me["icon-content"]), Mb = () => pn(Me.title), a0 = () => pn(Me["html-container"]), $b = () => pn(Me.image), l0 = () => pn(Me["progress-steps"]), pm = () => pn(Me["validation-message"]), ba = () => (
  /** @type {HTMLButtonElement} */
  uu(`.${Me.actions} .${Me.confirm}`)
), od = () => (
  /** @type {HTMLButtonElement} */
  uu(`.${Me.actions} .${Me.cancel}`)
), Pi = () => (
  /** @type {HTMLButtonElement} */
  uu(`.${Me.actions} .${Me.deny}`)
), rC = () => pn(Me["input-label"]), nd = () => uu(`.${Me.loader}`), cu = () => pn(Me.actions), Cb = () => pn(Me.footer), hm = () => pn(Me["timer-progress-bar"]), i0 = () => pn(Me.close), oC = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, s0 = () => {
  const e = Jt();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), r = Array.from(t).sort((a, l) => {
    const i = parseInt(a.getAttribute("tabindex") || "0"), s = parseInt(l.getAttribute("tabindex") || "0");
    return i > s ? 1 : i < s ? -1 : 0;
  }), o = e.querySelectorAll(oC), n = Array.from(o).filter((a) => a.getAttribute("tabindex") !== "-1");
  return [...new Set(r.concat(n))].filter((a) => Zo(a));
}, d0 = () => Ha(document.body, Me.shown) && !Ha(document.body, Me["toast-shown"]) && !Ha(document.body, Me["no-backdrop"]), xm = () => {
  const e = Jt();
  return e ? Ha(e, Me.toast) : !1;
}, nC = () => {
  const e = Jt();
  return e ? e.hasAttribute("data-loading") : !1;
}, hn = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), n = o.querySelector("head");
    n && Array.from(n.childNodes).forEach((l) => {
      e.appendChild(l);
    });
    const a = o.querySelector("body");
    a && Array.from(a.childNodes).forEach((l) => {
      l instanceof HTMLVideoElement || l instanceof HTMLAudioElement ? e.appendChild(l.cloneNode(!0)) : e.appendChild(l);
    });
  }
}, Ha = (e, t) => t ? t.split(/\s+/).every((r) => e.classList.contains(r)) : !1, aC = (e, t) => {
  Array.from(e.classList).forEach((r) => {
    !Object.values(Me).includes(r) && !Object.values(Nc).includes(r) && !Object.values(t.showClass || {}).includes(r) && e.classList.remove(r);
  });
}, mn = (e, t, r) => {
  if (aC(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    r
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Vo(`Invalid type of customClass.${r}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    qt(e, o);
  }
}, vm = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${Me.popup} > .${Me[t]}`);
    case "checkbox":
      return e.querySelector(`.${Me.popup} > .${Me.checkbox} input`);
    case "radio":
      return e.querySelector(`.${Me.popup} > .${Me.radio} input:checked`) || e.querySelector(`.${Me.popup} > .${Me.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${Me.popup} > .${Me.range} input`);
    default:
      return e.querySelector(`.${Me.popup} > .${Me.input}`);
  }
}, Lb = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Eb = (e, t, r) => {
  if (!e || !t)
    return;
  const o = typeof t == "string" ? t.split(/\s+/).filter(Boolean) : t;
  (Array.isArray(e) ? e : [e]).forEach((a) => {
    o.forEach((l) => {
      r ? a.classList.add(l) : a.classList.remove(l);
    });
  });
}, qt = (e, t) => {
  Eb(e, t, !0);
}, On = (e, t) => {
  Eb(e, t, !1);
}, hl = (e, t) => (
  /** @type {HTMLElement | undefined} */
  Array.from(e.children).find((r) => r instanceof HTMLElement && Ha(r, t))
), ai = (e, t, r) => {
  r === `${parseInt(`${r}`)}` && (r = parseInt(r)), r || r === 0 ? e.style.setProperty(t, typeof r == "number" ? `${r}px` : (
    /** @type {string} */
    r
  )) : e.style.removeProperty(t);
}, po = (e, t = "flex") => {
  e && (e.style.display = t);
}, Lo = (e) => {
  e && (e.style.display = "none");
}, u0 = (e, t = "block") => {
  e && new MutationObserver(() => {
    mu(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, s1 = (e, t, r, o) => {
  const n = e.querySelector(t);
  n && n.style.setProperty(r, o);
}, mu = (e, t, r = "flex") => {
  t ? po(e, r) : Lo(e);
}, Zo = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), lC = () => !Zo(ba()) && !Zo(Pi()) && !Zo(od()), Ff = (e) => e.scrollHeight > e.clientHeight, iC = (e, t) => {
  let r = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; r && r !== t; ) {
    if (Ff(r))
      return !0;
    r = r.parentElement;
  }
  return !1;
}, Ob = (e) => {
  const t = window.getComputedStyle(e), r = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return r > 0 || o > 0;
}, c0 = (e, t = !1) => {
  const r = hm();
  r && Zo(r) && (t && (r.style.transition = "none", r.style.width = "100%"), setTimeout(() => {
    r.style.transition = `width ${e / 1e3}s linear`, r.style.width = "0%";
  }, 10));
}, sC = () => {
  const e = hm();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const r = parseInt(window.getComputedStyle(e).width), o = t / r * 100;
  e.style.width = `${o}%`;
}, dC = () => typeof window > "u" || typeof document > "u", uC = `
 <div aria-labelledby="${Me.title}" aria-describedby="${Me["html-container"]}" class="${Me.popup}" tabindex="-1">
   <button type="button" class="${Me.close}"></button>
   <ul class="${Me["progress-steps"]}"></ul>
   <div class="${Me.icon}"></div>
   <img class="${Me.image}" />
   <h2 class="${Me.title}" id="${Me.title}"></h2>
   <div class="${Me["html-container"]}" id="${Me["html-container"]}"></div>
   <input class="${Me.input}" id="${Me.input}" />
   <input type="file" class="${Me.file}" />
   <div class="${Me.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${Me.select}" id="${Me.select}"></select>
   <div class="${Me.radio}"></div>
   <label class="${Me.checkbox}">
     <input type="checkbox" id="${Me.checkbox}" />
     <span class="${Me.label}"></span>
   </label>
   <textarea class="${Me.textarea}" id="${Me.textarea}"></textarea>
   <div class="${Me["validation-message"]}" id="${Me["validation-message"]}"></div>
   <div class="${Me.actions}">
     <div class="${Me.loader}"></div>
     <button type="button" class="${Me.confirm}"></button>
     <button type="button" class="${Me.deny}"></button>
     <button type="button" class="${Me.cancel}"></button>
   </div>
   <div class="${Me.footer}"></div>
   <div class="${Me["timer-progress-bar-container"]}">
     <div class="${Me["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), cC = () => {
  const e = Ho();
  return e ? (e.remove(), On([document.documentElement, document.body], [
    Me["no-backdrop"],
    Me["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    Me["has-column"]
  ]), !0) : !1;
}, Wl = () => {
  gt.currentInstance && gt.currentInstance.resetValidationMessage();
}, mC = () => {
  const e = Jt();
  if (!e)
    return;
  const t = hl(e, Me.input), r = hl(e, Me.file), o = e.querySelector(`.${Me.range} input`), n = e.querySelector(`.${Me.range} output`), a = hl(e, Me.select), l = e.querySelector(`.${Me.checkbox} input`), i = hl(e, Me.textarea);
  t && (t.oninput = Wl), r && (r.onchange = Wl), a && (a.onchange = Wl), l && (l.onchange = Wl), i && (i.oninput = Wl), o && n && (o.oninput = () => {
    Wl(), n.value = o.value;
  }, o.onchange = () => {
    Wl(), n.value = o.value;
  });
}, gC = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, fC = (e) => {
  const t = Jt();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, pC = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (qt(Ho(), Me.rtl), gt.isRTL = !0);
}, hC = (e) => {
  const t = cC();
  if (dC()) {
    Ai("SweetAlert2 requires document to initialize");
    return;
  }
  const r = document.createElement("div");
  r.className = Me.container, t && qt(r, Me["no-transition"]), hn(r, uC), r.dataset.swal2Theme = e.theme;
  const o = gC(e.target || "body");
  o.appendChild(r), e.topLayer && (r.setAttribute("popover", ""), r.showPopover()), fC(e), pC(o), mC();
}, m0 = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? xC(e, t) : e && hn(t, e);
}, xC = (e, t) => {
  "jquery" in e ? vC(t, e) : hn(t, e.toString());
}, vC = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let r = 0; r in t; r++)
      e.appendChild(t[r].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, SC = (e, t) => {
  const r = cu(), o = nd();
  !r || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? Lo(r) : po(r), mn(r, t, "actions"), bC(r, o, t), hn(o, t.loaderHtml || ""), mn(o, t, "loader"));
};
function bC(e, t, r) {
  const o = ba(), n = Pi(), a = od();
  !o || !n || !a || (bg(o, "confirm", r), bg(n, "deny", r), bg(a, "cancel", r), yC(o, n, a, r), r.reverseButtons && (r.toast ? (e.insertBefore(a, o), e.insertBefore(n, o)) : (e.insertBefore(a, t), e.insertBefore(n, t), e.insertBefore(o, t))));
}
function yC(e, t, r, o) {
  if (!o.buttonsStyling) {
    On([e, t, r], Me.styled);
    return;
  }
  qt([e, t, r], Me.styled), [[e, "confirm", o.confirmButtonColor], [t, "deny", o.denyButtonColor], [r, "cancel", o.cancelButtonColor]].forEach(([a, l, i]) => {
    i && a.style.setProperty(`--swal2-${l}-button-background-color`, i), wC(a);
  });
}
function wC(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const r = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${r}`));
}
function bg(e, t, r) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    r0(t)
  );
  mu(e, r[`show${o}Button`], "inline-block"), hn(e, r[`${t}ButtonText`] || ""), e.setAttribute("aria-label", r[`${t}ButtonAriaLabel`] || ""), e.className = Me[t], mn(e, r, `${t}Button`);
}
const _C = (e, t) => {
  const r = i0();
  r && (hn(r, t.closeButtonHtml || ""), mn(r, t, "closeButton"), mu(r, t.showCloseButton), r.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, TC = (e, t) => {
  const r = Ho();
  r && (AC(r, t.backdrop), PC(r, t.position), MC(r, t.grow), mn(r, t, "container"));
};
function AC(e, t) {
  typeof t == "string" ? e.style.background = t : t || qt([document.documentElement, document.body], Me["no-backdrop"]);
}
function PC(e, t) {
  t && (t in Me ? qt(e, Me[t]) : (Vo('The "position" parameter is not valid, defaulting to "center"'), qt(e, Me.center)));
}
function MC(e, t) {
  t && qt(e, Me[`grow-${t}`]);
}
var lr = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap(),
  focusedElement: /* @__PURE__ */ new WeakMap()
};
const $C = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], CC = (e, t) => {
  const r = Jt();
  if (!r)
    return;
  const o = lr.innerParams.get(e), n = !o || t.input !== o.input;
  $C.forEach((a) => {
    const l = hl(r, Me[a]);
    l && (OC(a, t.inputAttributes), l.className = Me[a], n && Lo(l));
  }), t.input && (n && LC(t), NC(t));
}, LC = (e) => {
  if (!e.input)
    return;
  if (!Rr[e.input]) {
    Ai(`Unexpected type of input! Expected ${Object.keys(Rr).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Nb(e.input);
  if (!t)
    return;
  const r = Rr[e.input](t, e);
  po(t), e.inputAutoFocus && setTimeout(() => {
    Lb(r);
  });
}, EC = (e) => {
  for (const {
    name: t
  } of Array.from(e.attributes))
    ["id", "type", "value", "style"].includes(t) || e.removeAttribute(t);
}, OC = (e, t) => {
  const r = Jt();
  if (!r)
    return;
  const o = vm(r, e);
  if (o) {
    EC(o);
    for (const n in t)
      o.setAttribute(n, t[n]);
  }
}, NC = (e) => {
  if (!e.input)
    return;
  const t = Nb(e.input);
  t && mn(t, e, "input");
}, g0 = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, gu = (e, t, r) => {
  if (r.inputLabel) {
    const o = document.createElement("label"), n = Me["input-label"];
    o.setAttribute("for", e.id), o.className = n, typeof r.customClass == "object" && qt(o, r.customClass.inputLabel), o.innerText = r.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, Nb = (e) => {
  const t = Jt();
  if (t)
    return hl(t, Me[
      /** @type {SwalClass} */
      e
    ] || Me.input);
}, Dc = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : n0(t) || Vo(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, Rr = {};
Rr.text = Rr.email = Rr.password = Rr.number = Rr.tel = Rr.url = Rr.search = Rr.date = Rr["datetime-local"] = Rr.time = Rr.week = Rr.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const r = (
    /** @type {HTMLInputElement} */
    e
  );
  return Dc(r, t.inputValue), gu(r, r, t), g0(r, t), r.type = /** @type {string} */
  t.input, r;
};
Rr.file = (e, t) => {
  const r = (
    /** @type {HTMLInputElement} */
    e
  );
  return gu(r, r, t), g0(r, t), r;
};
Rr.range = (e, t) => {
  const r = (
    /** @type {HTMLElement} */
    e
  ), o = r.querySelector("input"), n = r.querySelector("output");
  return o && (Dc(o, t.inputValue), o.type = /** @type {string} */
  t.input, gu(
    o,
    /** @type {Input} */
    e,
    t
  )), n && Dc(n, t.inputValue), /** @type {Input} */
  e;
};
Rr.select = (e, t) => {
  const r = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (r.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    hn(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, r.appendChild(o);
  }
  return gu(r, r, t), r;
};
Rr.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
Rr.checkbox = (e, t) => {
  const r = Jt();
  if (!r)
    throw new Error("Popup not found");
  const o = vm(r, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const a = /** @type {HTMLElement} */ e.querySelector("span");
  if (a) {
    const l = t.inputPlaceholder || t.inputLabel;
    l && hn(a, l);
  }
  return o;
};
Rr.textarea = (e, t) => {
  const r = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  Dc(r, t.inputValue), g0(r, t), gu(r, r, t);
  const o = (n) => parseInt(window.getComputedStyle(n).marginLeft) + parseInt(window.getComputedStyle(n).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const n = Jt();
      if (!n)
        return;
      const a = parseInt(window.getComputedStyle(n).width), l = () => {
        if (!document.body.contains(r))
          return;
        const i = r.offsetWidth + o(r), s = Jt();
        s && (i > a ? s.style.width = `${i}px` : ai(s, "width", t.width));
      };
      new MutationObserver(l).observe(r, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), r;
};
const DC = (e, t) => {
  const r = a0();
  r && (u0(r), mn(r, t, "htmlContainer"), t.html ? (m0(t.html, r), po(r, "block")) : t.text ? (r.textContent = t.text, po(r, "block")) : Lo(r), CC(e, t));
}, kC = (e, t) => {
  const r = Cb();
  r && (u0(r), mu(r, !!t.footer, "block"), t.footer && m0(t.footer, r), mn(r, t, "footer"));
}, GC = (e, t) => {
  const r = lr.innerParams.get(e), o = rd();
  if (!o)
    return;
  if (r && t.icon === r.icon) {
    u1(o, t), d1(o, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    Lo(o);
    return;
  }
  if (t.icon && Object.keys(Nc).indexOf(t.icon) === -1) {
    Ai(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), Lo(o);
    return;
  }
  po(o), u1(o, t), d1(o, t), qt(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Db);
}, d1 = (e, t) => {
  for (const [r, o] of Object.entries(Nc))
    t.icon !== r && On(e, o);
  qt(e, t.icon && Nc[t.icon]), RC(e, t), Db(), mn(e, t, "icon");
}, Db = () => {
  const e = Jt();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color");
  e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix").forEach((o) => {
    o.style.backgroundColor = t;
  });
}, BC = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, IC = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, u1 = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let r = e.innerHTML, o = "";
  t.iconHtml ? o = c1(t.iconHtml) : t.icon === "success" ? (o = BC(t), r = r.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = IC : t.icon && (o = c1({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), r.trim() !== o.trim() && hn(e, o);
}, RC = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const r of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      s1(e, r, "background-color", t.iconColor);
    s1(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, c1 = (e) => `<div class="${Me["icon-content"]}">${e}</div>`, FC = (e, t) => {
  const r = $b();
  if (r) {
    if (!t.imageUrl) {
      Lo(r);
      return;
    }
    po(r, ""), r.setAttribute("src", t.imageUrl), r.setAttribute("alt", t.imageAlt || ""), ai(r, "width", t.imageWidth), ai(r, "height", t.imageHeight), r.className = Me.image, mn(r, t, "image");
  }
};
let f0 = !1, kb = 0, Gb = 0, Bb = 0, Ib = 0;
const VC = (e) => {
  e.addEventListener("mousedown", kc), document.body.addEventListener("mousemove", Gc), e.addEventListener("mouseup", Bc), e.addEventListener("touchstart", kc), document.body.addEventListener("touchmove", Gc), e.addEventListener("touchend", Bc);
}, HC = (e) => {
  e.removeEventListener("mousedown", kc), document.body.removeEventListener("mousemove", Gc), e.removeEventListener("mouseup", Bc), e.removeEventListener("touchstart", kc), document.body.removeEventListener("touchmove", Gc), e.removeEventListener("touchend", Bc);
}, kc = (e) => {
  const t = Jt();
  if (!t)
    return;
  const r = rd();
  if (e.target === t || r && r.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    f0 = !0;
    const o = Rb(e);
    kb = o.clientX, Gb = o.clientY, Bb = parseInt(t.style.insetInlineStart) || 0, Ib = parseInt(t.style.insetBlockStart) || 0, qt(t, "swal2-dragging");
  }
}, Gc = (e) => {
  const t = Jt();
  if (t && f0) {
    let {
      clientX: r,
      clientY: o
    } = Rb(e);
    const n = r - kb;
    t.style.insetInlineStart = `${Bb + (gt.isRTL ? -n : n)}px`, t.style.insetBlockStart = `${Ib + (o - Gb)}px`;
  }
}, Bc = () => {
  const e = Jt();
  f0 = !1, On(e, "swal2-dragging");
}, Rb = (e) => {
  const t = e.type.startsWith("touch") ? (
    /** @type {TouchEvent} */
    e.touches[0]
  ) : (
    /** @type {MouseEvent} */
    e
  );
  return {
    clientX: t.clientX,
    clientY: t.clientY
  };
}, UC = (e, t) => {
  const r = Ho(), o = Jt();
  if (!(!r || !o)) {
    if (t.toast) {
      ai(r, "width", t.width), o.style.width = "100%";
      const n = nd();
      n && o.insertBefore(n, rd());
    } else
      ai(o, "width", t.width);
    ai(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), Lo(pm()), XC(o, t), t.draggable && !t.toast ? (qt(o, Me.draggable), VC(o)) : (On(o, Me.draggable), HC(o));
  }
}, XC = (e, t) => {
  const r = t.showClass || {};
  e.className = `${Me.popup} ${Zo(e) ? r.popup : ""}`, t.toast ? (qt([document.documentElement, document.body], Me["toast-shown"]), qt(e, Me.toast)) : qt(e, Me.modal), mn(e, t, "popup"), typeof t.customClass == "string" && qt(e, t.customClass), t.icon && qt(e, Me[`icon-${t.icon}`]);
}, WC = (e, t) => {
  const r = l0();
  if (!r)
    return;
  const {
    progressSteps: o,
    currentProgressStep: n
  } = t;
  if (!o || o.length === 0 || n === void 0) {
    Lo(r);
    return;
  }
  po(r), r.textContent = "", n >= o.length && Vo("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((a, l) => {
    const i = YC(a);
    if (r.appendChild(i), l === n && qt(i, Me["active-progress-step"]), l !== o.length - 1) {
      const s = KC(t);
      r.appendChild(s);
    }
  });
}, YC = (e) => {
  const t = document.createElement("li");
  return qt(t, Me["progress-step"]), hn(t, e), t;
}, KC = (e) => {
  const t = document.createElement("li");
  return qt(t, Me["progress-step-line"]), e.progressStepsDistance && ai(t, "width", e.progressStepsDistance), t;
}, QC = (e, t) => {
  const r = Mb();
  r && (u0(r), mu(r, !!(t.title || t.titleText), "block"), t.title && m0(t.title, r), t.titleText && (r.innerText = t.titleText), mn(r, t, "title"));
}, Fb = (e, t) => {
  var r;
  UC(e, t), TC(e, t), WC(e, t), GC(e, t), FC(e, t), QC(e, t), _C(e, t), DC(e, t), SC(e, t), kC(e, t);
  const o = Jt();
  typeof t.didRender == "function" && o && t.didRender(o), (r = gt.eventEmitter) === null || r === void 0 || r.emit("didRender", o);
}, jC = () => Zo(Jt()), Vb = () => {
  var e;
  return (e = ba()) === null || e === void 0 ? void 0 : e.click();
}, ZC = () => {
  var e;
  return (e = Pi()) === null || e === void 0 ? void 0 : e.click();
}, zC = () => {
  var e;
  return (e = od()) === null || e === void 0 ? void 0 : e.click();
}, ad = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), Hb = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, qC = (e, t, r) => {
  if (Hb(e), !t.toast) {
    const o = (a) => e5(t, a, r);
    e.keydownHandler = o;
    const n = t.keydownListenerCapture ? window : Jt();
    if (n) {
      e.keydownTarget = n, e.keydownListenerCapture = t.keydownListenerCapture;
      const a = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", a, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, Vf = (e, t) => {
  var r;
  const o = s0();
  return o.length ? (e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus(), !(eC() && o[e] instanceof HTMLIFrameElement)) : ((r = Jt()) === null || r === void 0 || r.focus(), !0);
}, Ub = ["ArrowRight", "ArrowDown"], JC = ["ArrowLeft", "ArrowUp"], e5 = (e, t, r) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? t5(t, e) : t.key === "Tab" ? r5(t) : [...Ub, ...JC].includes(t.key) ? o5(t.key) : t.key === "Escape" && n5(t, e, r)));
}, t5 = (e, t) => {
  if (!fm(t.allowEnterKey))
    return;
  const r = Jt();
  if (!r || !t.input)
    return;
  const o = vm(r, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    Vb(), e.preventDefault();
  }
}, r5 = (e) => {
  const t = e.target, o = s0().findIndex((a) => a === t);
  let n = !0;
  e.shiftKey ? n = Vf(o, -1) : n = Vf(o, 1), e.stopPropagation(), n && e.preventDefault();
}, o5 = (e) => {
  const t = cu(), r = ba(), o = Pi(), n = od();
  if (!t || !r || !o || !n)
    return;
  const a = [r, o, n];
  if (document.activeElement instanceof HTMLElement && !a.includes(document.activeElement))
    return;
  const l = Ub.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let s = 0; s < t.children.length; s++) {
      if (i = i[l], !i)
        return;
      if (i instanceof HTMLButtonElement && Zo(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, n5 = (e, t, r) => {
  e.preventDefault(), fm(t.allowEscapeKey) && r(ad.esc);
};
var ks = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const a5 = () => {
  const e = Ho();
  Array.from(document.body.children).forEach((r) => {
    r.contains(e) || (r.hasAttribute("aria-hidden") && r.setAttribute("data-previous-aria-hidden", r.getAttribute("aria-hidden") || ""), r.setAttribute("aria-hidden", "true"));
  });
}, Xb = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, p0 = typeof window < "u" && !!window.GestureEvent, l5 = p0 && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, i5 = () => {
  if (p0 && !Ha(document.body, Me.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, qt(document.body, Me.iosfix), s5();
  }
}, s5 = () => {
  const e = Ho();
  if (!e)
    return;
  let t;
  e.ontouchstart = (r) => {
    t = d5(r);
  }, e.ontouchmove = (r) => {
    t && (r.preventDefault(), r.stopPropagation());
  };
}, d5 = (e) => {
  const t = e.target, r = Ho(), o = a0();
  return !r || !o || u5(e) || c5(e) ? !1 : t === r || !Ff(r) && t instanceof HTMLElement && !iC(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(Ff(o) && // #1944
  o.contains(t));
}, u5 = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), c5 = (e) => e.touches && e.touches.length > 1, m5 = () => {
  if (Ha(document.body, Me.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    On(document.body, Me.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, g5 = () => {
  const e = document.createElement("div");
  e.className = Me["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let Ms = null;
const f5 = (e) => {
  Ms === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (Ms = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${Ms + g5()}px`);
}, p5 = () => {
  Ms !== null && (document.body.style.paddingRight = `${Ms}px`, Ms = null);
};
function Wb(e, t, r, o) {
  xm() ? m1(e, o) : (Z$(r).then(() => m1(e, o)), Hb(gt)), p0 ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), d0() && (p5(), m5(), Xb()), h5();
}
function h5() {
  On([document.documentElement, document.body], [Me.shown, Me["height-auto"], Me["no-backdrop"], Me["toast-shown"]]);
}
function xl(e) {
  e = v5(e);
  const t = ks.swalPromiseResolve.get(this), r = x5(this);
  this.isAwaitingPromise ? e.isDismissed || (fu(this), t(e)) : r && t(e);
}
const x5 = (e) => {
  const t = Jt();
  if (!t)
    return !1;
  const r = lr.innerParams.get(e);
  if (!r || Ha(t, r.hideClass.popup))
    return !1;
  On(t, r.showClass.popup), qt(t, r.hideClass.popup);
  const o = Ho();
  return On(o, r.showClass.backdrop), qt(o, r.hideClass.backdrop), S5(e, t, r), !0;
};
function Yb(e) {
  const t = ks.swalPromiseReject.get(this);
  fu(this), t && t(e);
}
const fu = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, lr.innerParams.get(e) || e._destroy());
}, v5 = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), S5 = (e, t, r) => {
  var o;
  const n = Ho(), a = Ob(t);
  typeof r.willClose == "function" && r.willClose(t), (o = gt.eventEmitter) === null || o === void 0 || o.emit("willClose", t), a && n ? b5(e, t, n, !!r.returnFocus, r.didClose) : n && Wb(e, n, !!r.returnFocus, r.didClose);
}, b5 = (e, t, r, o, n) => {
  gt.swalCloseEventFinishedCallback = Wb.bind(null, e, r, o, n);
  const a = function(l) {
    if (l.target === t) {
      var i;
      (i = gt.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(gt), delete gt.swalCloseEventFinishedCallback, t.removeEventListener("animationend", a), t.removeEventListener("transitionend", a);
    }
  };
  t.addEventListener("animationend", a), t.addEventListener("transitionend", a);
}, m1 = (e, t) => {
  setTimeout(() => {
    var r;
    typeof t == "function" && t.bind(e.params)(), (r = gt.eventEmitter) === null || r === void 0 || r.emit("didClose"), e._destroy && e._destroy();
  });
}, Gs = (e) => {
  let t = Jt();
  if (t || new ro(), t = Jt(), !t)
    return;
  const r = nd();
  xm() ? Lo(rd()) : y5(t, e), po(r), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, y5 = (e, t) => {
  const r = cu(), o = nd();
  !r || !o || (!t && Zo(ba()) && (t = ba()), po(r), t && (Lo(t), o.setAttribute("data-button-to-replace", t.className), r.insertBefore(o, t)), qt([e, r], Me.loading));
}, w5 = (e, t) => {
  t.input === "select" || t.input === "radio" ? M5(e, t) : ["text", "email", "number", "tel", "textarea"].some((r) => r === t.input) && (o0(t.inputValue) || n0(t.inputValue)) && (Gs(ba()), $5(e, t));
}, _5 = (e, t) => {
  const r = e.getInput();
  if (!r)
    return null;
  switch (t.input) {
    case "checkbox":
      return T5(r);
    case "radio":
      return A5(r);
    case "file":
      return P5(r);
    default:
      return t.inputAutoTrim ? r.value.trim() : r.value;
  }
}, T5 = (e) => e.checked ? 1 : 0, A5 = (e) => e.checked ? e.value : null, P5 = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, M5 = (e, t) => {
  const r = Jt();
  if (!r)
    return;
  const o = (n) => {
    t.input === "select" ? C5(r, Hf(n), t) : t.input === "radio" && L5(r, Hf(n), t);
  };
  o0(t.inputOptions) || n0(t.inputOptions) ? (Gs(ba()), du(t.inputOptions).then((n) => {
    e.hideLoading(), o(n);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : Ai(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, $5 = (e, t) => {
  const r = e.getInput();
  r && (Lo(r), du(t.inputValue).then((o) => {
    r.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, po(r), r.focus(), e.hideLoading();
  }).catch((o) => {
    Ai(`Error in inputValue promise: ${o}`), r.value = "", po(r), r.focus(), e.hideLoading();
  }));
};
function C5(e, t, r) {
  const o = hl(e, Me.select);
  if (!o)
    return;
  const n = (a, l, i) => {
    const s = document.createElement("option");
    s.value = i, hn(s, l), s.selected = Kb(i, r.inputValue), a.appendChild(s);
  };
  t.forEach((a) => {
    const l = a[0], i = a[1];
    if (Array.isArray(i)) {
      const s = document.createElement("optgroup");
      s.label = l, s.disabled = !1, o.appendChild(s), i.forEach((u) => n(s, u[1], u[0]));
    } else
      n(o, i, l);
  }), o.focus();
}
function L5(e, t, r) {
  const o = hl(e, Me.radio);
  if (!o)
    return;
  t.forEach((a) => {
    const l = a[0], i = a[1], s = document.createElement("input"), u = document.createElement("label");
    s.type = "radio", s.name = Me.radio, s.value = l, Kb(l, r.inputValue) && (s.checked = !0);
    const c = document.createElement("span");
    hn(c, i), c.className = Me.label, u.appendChild(s), u.appendChild(c), o.appendChild(u);
  });
  const n = o.querySelectorAll("input");
  n.length && n[0].focus();
}
const Hf = (e) => (e instanceof Map ? Array.from(e) : Object.entries(e)).map(([r, o]) => [r, typeof o == "object" ? Hf(o) : o]), Kb = (e, t) => !!t && t != null && t.toString() === e.toString(), E5 = (e) => {
  const t = lr.innerParams.get(e);
  e.disableButtons(), t.input ? Qb(e, "confirm") : x0(e, !0);
}, O5 = (e) => {
  const t = lr.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? Qb(e, "deny") : h0(e, !1);
}, N5 = (e, t) => {
  e.disableButtons(), t(ad.cancel);
}, Qb = (e, t) => {
  const r = lr.innerParams.get(e);
  if (!r.input) {
    Ai(`The "input" parameter is needed to be set when using returnInputValueOn${r0(t)}`);
    return;
  }
  const o = e.getInput(), n = _5(e, r);
  r.inputValidator ? D5(e, n, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(r.validationMessage || o.validationMessage)) : t === "deny" ? h0(e, n) : x0(e, n);
}, D5 = (e, t, r) => {
  const o = lr.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => du(o.inputValidator(t, o.validationMessage))).then((a) => {
    e.enableButtons(), e.enableInput(), a ? e.showValidationMessage(a) : r === "deny" ? h0(e, t) : x0(e, t);
  });
}, h0 = (e, t) => {
  const r = lr.innerParams.get(e);
  r.showLoaderOnDeny && Gs(Pi()), r.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => du(r.preDeny(t, r.validationMessage))).then((n) => {
    n === !1 ? (e.hideLoading(), fu(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof n > "u" ? t : n
      }
    );
  }).catch((n) => jb(e, n))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, g1 = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, jb = (e, t) => {
  e.rejectPromise(t);
}, x0 = (e, t) => {
  const r = lr.innerParams.get(e);
  r.showLoaderOnConfirm && Gs(), r.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => du(r.preConfirm(t, r.validationMessage))).then((n) => {
    Zo(pm()) || n === !1 ? (e.hideLoading(), fu(e)) : g1(e, typeof n > "u" ? t : n);
  }).catch((n) => jb(e, n))) : g1(e, t);
};
function Ic() {
  const e = lr.innerParams.get(this);
  if (!e)
    return;
  const t = lr.domCache.get(this);
  Lo(t.loader), xm() ? e.icon && po(rd()) : k5(t), On([t.popup, t.actions], Me.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), this.enableButtons();
}
const k5 = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), r = t ? e.popup.getElementsByClassName(t) : [];
  r.length ? po(
    /** @type {HTMLElement} */
    r[0],
    "inline-block"
  ) : lC() && Lo(e.actions);
};
function Zb() {
  const e = lr.innerParams.get(this), t = lr.domCache.get(this);
  return t ? vm(t.popup, e.input) : null;
}
function zb(e, t, r) {
  const o = lr.domCache.get(e);
  t.forEach((n) => {
    o[n].disabled = r;
  });
}
function qb(e, t) {
  const r = Jt();
  !r || !e || (e.type === "radio" ? r.querySelectorAll(`[name="${Me.radio}"]`).forEach((n) => {
    n.disabled = t;
  }) : e.disabled = t);
}
function Jb() {
  zb(this, ["confirmButton", "denyButton", "cancelButton"], !1);
  const e = lr.focusedElement.get(this);
  e instanceof HTMLElement && document.activeElement === document.body && e.focus(), lr.focusedElement.delete(this);
}
function ey() {
  lr.focusedElement.set(this, document.activeElement), zb(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function ty() {
  qb(this.getInput(), !1);
}
function ry() {
  qb(this.getInput(), !0);
}
function oy(e) {
  const t = lr.domCache.get(this), r = lr.innerParams.get(this);
  hn(t.validationMessage, e), t.validationMessage.className = Me["validation-message"], r.customClass && r.customClass.validationMessage && qt(t.validationMessage, r.customClass.validationMessage), po(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", Me["validation-message"]), Lb(o), qt(o, Me.inputerror));
}
function ny() {
  const e = lr.domCache.get(this);
  e.validationMessage && Lo(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), On(t, Me.inputerror));
}
const vl = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, G5 = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], B5 = {
  allowEnterKey: void 0
}, I5 = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], ay = (e) => Object.prototype.hasOwnProperty.call(vl, e), ly = (e) => G5.indexOf(e) !== -1, iy = (e) => B5[e], R5 = (e) => {
  ay(e) || Vo(`Unknown parameter "${e}"`);
}, F5 = (e) => {
  I5.includes(e) && Vo(`The parameter "${e}" is incompatible with toasts`);
}, V5 = (e) => {
  const t = iy(e);
  t && Pb(e, t);
}, sy = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Vo('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Vo(`Invalid theme "${e.theme}"`);
  for (const t in e)
    R5(t), e.toast && F5(t), V5(t);
};
function dy(e) {
  const t = Ho(), r = Jt(), o = lr.innerParams.get(this);
  if (!r || Ha(r, o.hideClass.popup)) {
    Vo("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const n = H5(e), a = Object.assign({}, o, n);
  sy(a), t && (t.dataset.swal2Theme = a.theme), Fb(this, a), lr.innerParams.set(this, a), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const H5 = (e) => {
  const t = {};
  return Object.keys(e).forEach((r) => {
    if (ly(r)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[r] = o[r];
    } else
      Vo(`Invalid parameter to update: ${r}`);
  }), t;
};
function uy() {
  var e;
  const t = lr.domCache.get(this), r = lr.innerParams.get(this);
  if (!r) {
    cy(this);
    return;
  }
  t.popup && gt.swalCloseEventFinishedCallback && (gt.swalCloseEventFinishedCallback(), delete gt.swalCloseEventFinishedCallback), typeof r.didDestroy == "function" && r.didDestroy(), (e = gt.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), U5(this);
}
const U5 = (e) => {
  cy(e), delete e.params, delete gt.keydownHandler, delete gt.keydownTarget, delete gt.currentInstance;
}, cy = (e) => {
  e.isAwaitingPromise ? (yg(lr, e), e.isAwaitingPromise = !0) : (yg(ks, e), yg(lr, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, yg = (e, t) => {
  for (const r in e)
    e[r].delete(t);
};
var X5 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: uy,
  close: xl,
  closeModal: xl,
  closePopup: xl,
  closeToast: xl,
  disableButtons: ey,
  disableInput: ry,
  disableLoading: Ic,
  enableButtons: Jb,
  enableInput: ty,
  getInput: Zb,
  handleAwaitingPromise: fu,
  hideLoading: Ic,
  rejectPromise: Yb,
  resetValidationMessage: ny,
  showValidationMessage: oy,
  update: dy
});
const W5 = (e, t, r) => {
  e.toast ? Y5(e, t, r) : (Q5(t), j5(t), Z5(e, t, r));
}, Y5 = (e, t, r) => {
  t.popup.onclick = () => {
    e && (K5(e) || e.timer || e.input) || r(ad.close);
  };
}, K5 = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let Rc = !1;
const Q5 = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (Rc = !0);
    };
  };
}, j5 = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(r) {
      e.popup.onmouseup = () => {
      }, (r.target === e.popup || r.target instanceof HTMLElement && e.popup.contains(r.target)) && (Rc = !0);
    };
  };
}, Z5 = (e, t, r) => {
  t.container.onclick = (o) => {
    if (Rc) {
      Rc = !1;
      return;
    }
    o.target === t.container && fm(e.allowOutsideClick) && r(ad.backdrop);
  };
}, z5 = (e) => typeof e == "object" && e !== null && "jquery" in e, f1 = (e) => e instanceof Element || z5(e), q5 = (e) => {
  const t = {};
  return typeof e[0] == "object" && !f1(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((r, o) => {
    const n = e[o];
    typeof n == "string" || f1(n) ? t[r] = n : n !== void 0 && Ai(`Unexpected type of ${r}! Expected "string" or "Element", got ${typeof n}`);
  }), /** @type {SweetAlertOptions} */
  t;
};
function J5(...e) {
  return new this(...e);
}
function eL(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, n) {
      return super._main(o, Object.assign({}, e, n));
    }
  }
  return t;
}
const tL = () => gt.timeout && gt.timeout.getTimerLeft(), my = () => {
  if (gt.timeout)
    return sC(), gt.timeout.stop();
}, gy = () => {
  if (gt.timeout) {
    const e = gt.timeout.start();
    return c0(e), e;
  }
}, rL = () => {
  const e = gt.timeout;
  return e && (e.running ? my() : gy());
}, oL = (e) => {
  if (gt.timeout) {
    const t = gt.timeout.increase(e);
    return c0(t, !0), t;
  }
}, nL = () => !!(gt.timeout && gt.timeout.isRunning());
let p1 = !1;
const Uf = {};
function aL(e = "data-swal-template") {
  Uf[e] = this, p1 || (document.body.addEventListener("click", lL), p1 = !0);
}
const lL = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const r in Uf) {
      const o = t.getAttribute && t.getAttribute(r);
      if (o) {
        Uf[r].fire({
          template: o
        });
        return;
      }
    }
};
class iL {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, r) {
    const o = this._getHandlersByEventName(t);
    o.includes(r) || o.push(r);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, r) {
    const o = (...n) => {
      this.removeListener(t, o), r.apply(this, n);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...r) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, r);
        } catch (n) {
          console.error(n);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, r) {
    const o = this._getHandlersByEventName(t), n = o.indexOf(r);
    n > -1 && o.splice(n, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
gt.eventEmitter = new iL();
const sL = (e, t) => {
  gt.eventEmitter && gt.eventEmitter.on(e, t);
}, dL = (e, t) => {
  gt.eventEmitter && gt.eventEmitter.once(e, t);
}, uL = (e, t) => {
  if (gt.eventEmitter) {
    if (!e) {
      gt.eventEmitter.reset();
      return;
    }
    t ? gt.eventEmitter.removeListener(e, t) : gt.eventEmitter.removeAllListeners(e);
  }
};
var cL = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: q5,
  bindClickHandler: aL,
  clickCancel: zC,
  clickConfirm: Vb,
  clickDeny: ZC,
  enableLoading: Gs,
  fire: J5,
  getActions: cu,
  getCancelButton: od,
  getCloseButton: i0,
  getConfirmButton: ba,
  getContainer: Ho,
  getDenyButton: Pi,
  getFocusableElements: s0,
  getFooter: Cb,
  getHtmlContainer: a0,
  getIcon: rd,
  getIconContent: tC,
  getImage: $b,
  getInputLabel: rC,
  getLoader: nd,
  getPopup: Jt,
  getProgressSteps: l0,
  getTimerLeft: tL,
  getTimerProgressBar: hm,
  getTitle: Mb,
  getValidationMessage: pm,
  increaseTimer: oL,
  isDeprecatedParameter: iy,
  isLoading: nC,
  isTimerRunning: nL,
  isUpdatableParameter: ly,
  isValidParameter: ay,
  isVisible: jC,
  mixin: eL,
  off: uL,
  on: sL,
  once: dL,
  resumeTimer: gy,
  showLoading: Gs,
  stopTimer: my,
  toggleTimer: rL
});
class mL {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, r) {
    this.callback = t, this.remaining = r, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const r = this.running;
    return r && this.stop(), this.remaining += t, r && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const fy = ["swal-title", "swal-html", "swal-footer"], gL = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const r = t.content;
  return yL(r), Object.assign(fL(r), pL(r), hL(r), xL(r), vL(r), SL(r), bL(r, fy));
}, fL = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    mi(o, ["name", "value"]);
    const n = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), a = o.getAttribute("value");
    !n || !a || (n in vl && typeof vl[
      /** @type {keyof typeof defaultParams} */
      n
    ] == "boolean" ? t[n] = a !== "false" : n in vl && typeof vl[
      /** @type {keyof typeof defaultParams} */
      n
    ] == "object" ? t[n] = JSON.parse(a) : t[n] = a);
  }), t;
}, pL = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const n = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), a = o.getAttribute("value");
    !n || !a || (t[n] = new Function(`return ${a}`)());
  }), t;
}, hL = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    mi(o, ["type", "color", "aria-label"]);
    const n = o.getAttribute("type");
    if (!n || !["confirm", "cancel", "deny"].includes(n))
      return;
    t[`${n}ButtonText`] = o.innerHTML, t[`show${r0(n)}Button`] = !0;
    const a = o.getAttribute("color");
    a !== null && (t[`${n}ButtonColor`] = a);
    const l = o.getAttribute("aria-label");
    l !== null && (t[`${n}ButtonAriaLabel`] = l);
  }), t;
}, xL = (e) => {
  const t = {}, r = e.querySelector("swal-image");
  if (r) {
    mi(r, ["src", "width", "height", "alt"]);
    const o = r.getAttribute("src");
    o !== null && (t.imageUrl = o || void 0);
    const n = r.getAttribute("width");
    n !== null && (t.imageWidth = n || void 0);
    const a = r.getAttribute("height");
    a !== null && (t.imageHeight = a || void 0);
    const l = r.getAttribute("alt");
    l !== null && (t.imageAlt = l || void 0);
  }
  return t;
}, vL = (e) => {
  const t = {}, r = e.querySelector("swal-icon");
  return r && (mi(r, ["type", "color"]), r.hasAttribute("type") && (t.icon = r.getAttribute("type")), r.hasAttribute("color") && (t.iconColor = r.getAttribute("color")), t.iconHtml = r.innerHTML), t;
}, SL = (e) => {
  const t = {}, r = e.querySelector("swal-input");
  r && (mi(r, ["type", "label", "placeholder", "value"]), t.input = r.getAttribute("type") || "text", r.hasAttribute("label") && (t.inputLabel = r.getAttribute("label")), r.hasAttribute("placeholder") && (t.inputPlaceholder = r.getAttribute("placeholder")), r.hasAttribute("value") && (t.inputValue = r.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((n) => {
    mi(n, ["value"]);
    const a = n.getAttribute("value");
    if (!a)
      return;
    const l = n.innerHTML;
    t.inputOptions[a] = l;
  })), t;
}, bL = (e, t) => {
  const r = {};
  for (const o in t) {
    const n = t[o], a = e.querySelector(n);
    a && (mi(a, []), r[n.replace(/^swal-/, "")] = a.innerHTML.trim());
  }
  return r;
}, yL = (e) => {
  const t = fy.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((r) => {
    const o = r.tagName.toLowerCase();
    t.includes(o) || Vo(`Unrecognized element <${o}>`);
  });
}, mi = (e, t) => {
  Array.from(e.attributes).forEach((r) => {
    t.indexOf(r.name) === -1 && Vo([`Unrecognized attribute "${r.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, py = 10, wL = (e) => {
  var t, r;
  const o = Ho(), n = Jt();
  if (!o || !n)
    return;
  typeof e.willOpen == "function" && e.willOpen(n), (t = gt.eventEmitter) === null || t === void 0 || t.emit("willOpen", n);
  const l = window.getComputedStyle(document.body).overflowY;
  if (AL(o, n, e), setTimeout(() => {
    _L(o, n);
  }, py), d0() && (TL(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, l), a5()), l5 && e.backdrop === !1 && n.scrollHeight > o.clientHeight && (o.style.pointerEvents = "auto"), !xm() && !gt.previousActiveElement && (gt.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const i = e.didOpen;
    setTimeout(() => i(n));
  }
  (r = gt.eventEmitter) === null || r === void 0 || r.emit("didOpen", n);
}, Fc = (e) => {
  const t = Jt();
  if (!t || e.target !== t)
    return;
  const r = Ho();
  r && (t.removeEventListener("animationend", Fc), t.removeEventListener("transitionend", Fc), r.style.overflowY = "auto", On(r, Me["no-transition"]));
}, _L = (e, t) => {
  Ob(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", Fc), t.addEventListener("transitionend", Fc)) : e.style.overflowY = "auto";
}, TL = (e, t, r) => {
  i5(), t && r !== "hidden" && f5(r), setTimeout(() => {
    e.scrollTop = 0;
  });
}, AL = (e, t, r) => {
  var o;
  (o = r.showClass) !== null && o !== void 0 && o.backdrop && qt(e, r.showClass.backdrop), r.animation ? (t.style.setProperty("opacity", "0", "important"), po(t, "grid"), setTimeout(() => {
    var n;
    (n = r.showClass) !== null && n !== void 0 && n.popup && qt(t, r.showClass.popup), t.style.removeProperty("opacity");
  }, py)) : po(t, "grid"), qt([document.documentElement, document.body], Me.shown), r.heightAuto && r.backdrop && !r.toast && qt([document.documentElement, document.body], Me["height-auto"]);
};
var h1 = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function PL(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = h1.email), e.input === "url" && (e.inputValidator = h1.url));
}
function ML(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Vo('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function $L(e) {
  PL(e), e.showLoaderOnConfirm && !e.preConfirm && Vo(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), ML(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), hC(e);
}
let ca;
var Qu = /* @__PURE__ */ new WeakMap();
class jr {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (Y$(
      this,
      Qu,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    ca = this;
    const r = Object.freeze(this.constructor.argsToParams(t));
    this.params = r, this.isAwaitingPromise = !1, K$(Qu, this, this._main(ca.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, r = {}) {
    if (sy(Object.assign({}, r, t)), gt.currentInstance) {
      const a = ks.swalPromiseResolve.get(gt.currentInstance), {
        isAwaitingPromise: l
      } = gt.currentInstance;
      gt.currentInstance._destroy(), l || a({
        isDismissed: !0
      }), d0() && Xb();
    }
    gt.currentInstance = ca;
    const o = LL(t, r);
    $L(o), Object.freeze(o), gt.timeout && (gt.timeout.stop(), delete gt.timeout), clearTimeout(gt.restoreFocusTimeout);
    const n = EL(ca);
    return Fb(ca, o), lr.innerParams.set(ca, o), CL(ca, n, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  // oxlint-disable-next-line unicorn/no-thenable
  then(t) {
    return l1(Qu, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return l1(Qu, this).finally(t);
  }
}
const CL = (e, t, r) => new Promise((o, n) => {
  const a = (l) => {
    e.close({
      isDismissed: !0,
      dismiss: l,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  ks.swalPromiseResolve.set(e, o), ks.swalPromiseReject.set(e, n), t.confirmButton.onclick = () => {
    E5(e);
  }, t.denyButton.onclick = () => {
    O5(e);
  }, t.cancelButton.onclick = () => {
    N5(e, a);
  }, t.closeButton.onclick = () => {
    a(ad.close);
  }, W5(r, t, a), qC(gt, r, a), w5(e, r), wL(r), OL(gt, r, a), NL(t, r), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), LL = (e, t) => {
  const r = gL(e), o = Object.assign({}, vl, t, r, e);
  return o.showClass = Object.assign({}, vl.showClass, o.showClass), o.hideClass = Object.assign({}, vl.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, EL = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        Jt()
      ),
      container: (
        /** @type {HTMLElement} */
        Ho()
      ),
      actions: (
        /** @type {HTMLElement} */
        cu()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        ba()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        Pi()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        od()
      ),
      loader: (
        /** @type {HTMLElement} */
        nd()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        i0()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        pm()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        l0()
      )
    }
  );
  return lr.domCache.set(e, t), t;
}, OL = (e, t, r) => {
  const o = hm();
  Lo(o), t.timer && (e.timeout = new mL(() => {
    r("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (po(o), mn(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && c0(
      /** @type {number} */
      t.timer
    );
  })));
}, NL = (e, t) => {
  if (!t.toast) {
    if (!fm(t.allowEnterKey)) {
      Pb("allowEnterKey", "preConfirm: () => false"), e.popup.focus();
      return;
    }
    DL(e) || kL(e, t) || Vf(-1, 1);
  }
}, DL = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const r of t)
    if (r instanceof HTMLElement && Zo(r))
      return r.focus(), !0;
  return !1;
}, kL = (e, t) => t.focusDeny && Zo(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && Zo(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && Zo(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1;
jr.prototype.disableButtons = ey;
jr.prototype.enableButtons = Jb;
jr.prototype.getInput = Zb;
jr.prototype.disableInput = ry;
jr.prototype.enableInput = ty;
jr.prototype.hideLoading = Ic;
jr.prototype.disableLoading = Ic;
jr.prototype.showValidationMessage = oy;
jr.prototype.resetValidationMessage = ny;
jr.prototype.close = xl;
jr.prototype.closePopup = xl;
jr.prototype.closeModal = xl;
jr.prototype.closeToast = xl;
jr.prototype.rejectPromise = Yb;
jr.prototype.update = dy;
jr.prototype._destroy = uy;
Object.assign(jr, cL);
Object.keys(X5).forEach((e) => {
  jr[e] = function(...t) {
    if (ca && ca[e])
      return ca[e](...t);
  };
});
jr.DismissReason = ad;
jr.version = "11.26.25";
const ro = jr;
ro.default = ro;
typeof document < "u" && (function(e, t) {
  var r = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(r), r.styleSheet) r.styleSheet.disabled || (r.styleSheet.cssText = t);
  else try {
    r.innerHTML = t;
  } catch {
    r.innerText = t;
  }
})(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:auto}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:auto}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const hy = (e, t) => {
  t = [...["token", "type", "user"], ...t], t.forEach((o) => {
    e?.isKey(o) && (console.debug("cookie", o), e?.remove(o));
  });
}, GL = (e) => e.pathname.split("/").slice(-2, -1)[0], BL = async (e, t) => {
  const r = "action" in t ? t.action : "", o = t.stores;
  return await Zl(r, e, o, t);
}, IL = (e, t = "") => {
  let r = t ? new Date(t) : /* @__PURE__ */ new Date(), o = r.getDate(), n = r.getMonth() + 1, a = r.getFullYear(), l = r.toLocaleTimeString(e.locales, e.options);
  return o < 10 && (o = `0${o}`), n < 10 && (n = `0${n}`), `${a}-${n}-${o} ${l}`;
}, RL = (e) => parseFloat(e) > 0 ? "text-success" : "text-danger", FL = (e) => "status" in e, $o = (e) => e.getDeviceMode() == "mobile", xy = () => {
  ro.isVisible() && ro.close();
}, VL = (e, t) => {
  const r = e.app.getEnvAttrsByKey("VITE_APP_DOMAIN"), o = e.user.getLanguage(), n = e.user.getDefaultType() ? "" : e.user.getType();
  if (t instanceof Object ? t.isRedirect && (window.location.href = n ? `${r}/${n}/${t.path}?lang=${o}` : `${r}/${t.path}?lang=${o}`) : t = {
    path: t
  }, !e0(t.path)) {
    let a = "";
    o && (t.path.includes("?") ? a = `&lang=${o}` : a = `?lang=${o}`), t.path = n ? `${r}/${n}/${t.path}${a}` : `${r}/${t.path}${a}`;
  }
  return t.path;
}, HL = (e, t, r = "") => Object.keys(e).filter((a) => r in e[a] ? e[a][r] : e[a].id).map((a, l) => ({
  code: t[0].split(".").reduce((i, s) => i && i[s] || null, e[a]),
  name: t[1].split(".").reduce((i, s) => i && i[s] || null, e[a]),
  group: e[a][t[2]] || "",
  data: e[a]
}), {}).sort(function(a, l) {
  return a.name.localeCompare(l.name);
}), UL = (e) => {
  const t = new URL(window.location.href);
  e.forEach(function(r, o) {
    t.searchParams.has(r) && t.searchParams.delete(r);
  }), window.history.replaceState({}, document.title, t.toString());
}, hc = (e, t, r = "") => {
  ro.mixin({
    toast: !0,
    position: "top-end",
    showConfirmButton: !1,
    timer: 2e3,
    timerProgressBar: !0,
    didOpen: (n) => {
      n.addEventListener("mouseenter", ro.stopTimer), n.addEventListener("mouseleave", ro.resumeTimer), n.addEventListener("click", () => ro.close());
    }
  }).fire({
    icon: e,
    title: t,
    text: r
  });
}, XL = (e, t) => !!e.app.getLocales().includes(t), WL = (e, t) => !!e.app.getTypes().includes(t), YL = () => {
  document.querySelectorAll(".auto-resize").forEach((e) => {
    const t = () => {
      e.style.height = "auto", e.style.height = `${Math.min(e.scrollHeight, 300)}px`;
    };
    t(), e.addEventListener("input", t);
  });
}, KL = (e, t, r = {}) => {
  const o = [], n = "only" in r, a = "excludes" in r, l = "select" in r, i = n ? new Set(r.only) : null, s = a ? new Set(r.excludes) : null;
  if (!n)
    for (const u in e)
      e[u].value = "";
  for (const u in t) {
    if (s?.has(u)) {
      o.push(u);
      continue;
    }
    if (n && !i.has(u))
      continue;
    if (!(u in e)) {
      o.push(u);
      continue;
    }
    if (!l || !(u in r.select)) {
      e[u].value = t[u];
      continue;
    }
    const c = e[u];
    if (c.divClasses === "d-none")
      continue;
    const g = r.select[u].options, p = c.attributes;
    if (p && "multi" in p) {
      const h = [];
      for (const v of t[u]) {
        const A = g?.find((S) => S.code == v.id);
        A && h.push(A);
      }
      c.value = h;
    } else {
      const h = g?.find((v) => v.code == t[u]);
      h && (c.value = h);
    }
  }
  return o;
}, Upe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clearUserCookies: hy,
  getCurrentModule: GL,
  getFormDataByID: BL,
  getRealDateTime: IL,
  getTextColor: RL,
  instanceOfIResponse: FL,
  isMobileDevice: $o,
  onHidePopOut: xy,
  onNavigateTo: VL,
  onPopulateSelectOption: HL,
  onRemoveQueryParams: UL,
  onShowReponse: hc,
  onValidateLocale: XL,
  onValidateType: WL,
  resizeTextarea: YL,
  setFormData: KL
}, Symbol.toStringTag, { value: "Module" })), v0 = () => {
  const e = dt({}), t = dt({
    bIsViewOnly: !1,
    fInitialForm: () => {
    },
    fInputChange: () => {
    },
    fValidator: () => {
    },
    vFormAlign: "",
    vFormOption: {},
    vModel: ""
  }), r = dt({
    icon: {},
    input: {},
    error: {},
    blade: {},
    draw: 0,
    file: {},
    reset: !1,
    isSubmit: !1
  });
  dt({
    isClearForm: !1
    // select: {} as ISelectOptions
  });
  const o = {
    dateSettings: {
      "auto-range": 0,
      "enable-seconds": !0,
      "enable-time-picker": !1,
      flow: [],
      // 'flow': ['month', 'year', 'calendar'],
      format: "yyyy-MM-dd",
      "min-date": "",
      "max-date": "",
      "model-type": "yyyy-MM-dd",
      "month-picker": !1,
      "multi-calendars": !1,
      "multi-dates": !1,
      // 'prevent-min-max-navigation': true,
      position: "center",
      range: !1,
      "text-input": !0,
      "time-picker": !1,
      "time-picker-inline": !0,
      vertical: !1,
      "week-picker": !1,
      "year-picker": !1
    },
    selectSettings: {
      "close-on-select": !0,
      disabled: !1,
      label: "name",
      multiple: !1,
      "open-direction": "bottom",
      placeholder: "",
      "preserve-search": !0,
      "track-by": "code",
      "select-label": "",
      "selected-label": "✔",
      "deselect-label": "✖"
    }
  }, n = (O, m = {}) => {
    Object.assign(e, O), t.bIsViewOnly = "isViewOnly" in m ? m.isViewOnly : !1, t.fInitialForm = "initialForm" in m ? m.initialForm : () => {
    }, t.fInputChange = "inputChange" in m ? m.inputChange : () => {
    }, t.fValidator = "validator" in m ? m.validator : () => {
    }, t.vFormAlign = "formAlign" in m ? m.formAlign : "", t.vFormOption = "formOption" in m ? m.formOption : {}, t.vModel = "model" in m ? m.model : "", r.icon = t.fInitialForm(), r.input = t.fInitialForm(), r.error = t.fInitialForm(), r.blade = "formBlade" in m ? m.formBlade : {};
  }, a = (O) => {
    let m = { ...o.dateSettings };
    if (typeof O == "object")
      for (let _ in O)
        _ in m && (m[_] = O[_]), "enable-time-picker" in O && O["enable-time-picker"] && (m.format = "yyyy-MM-dd HH:mm:ss");
    return m;
  }, l = (O) => typeof O == "object" && O !== null && "rNote" in O ? O.rNote : null, i = (O, m) => typeof m == "object" && m !== null && "cType" in m ? m.cType : O, s = (O) => (O = { ...o.selectSettings, ...O }, typeof O == "object" && "group-select" in O && (O["group-select"] ? (O.selectGroupLabel = "", O.deselectGroupLabel = "") : (delete O["group-select"], delete O["group-label"], delete O["group-values"])), O), u = (O, m) => {
    if (typeof m == "object" && "group-select" in m && m["group-select"]) {
      var _ = [];
      const X = O.reduce(($, E) => {
        _.includes(E.group) || _.push(E.group);
        const D = $[E.group] || [];
        return D.push(E), $[E.group] = D, $;
      }, {});
      return _.sort().map(($) => ({
        title: $,
        options: X[$]
      }));
    }
    return O;
  }, c = (O, m) => {
    if (typeof O == "object")
      return O.allowNegative === !0 ? bb(m) : ci(m);
  }, g = (O) => typeof O == "object" && "required" in O ? "multi" in O ? O.required : !O.required : !0, p = (O, m) => typeof O == "object" && "disabled" in O ? m || O.disabled : m, h = (O) => !!(typeof O == "object" && "multi" in O && O.multi), v = (O) => typeof O == "object" && "required" in O ? O.required : !1, A = (O, m) => {
    console.debug("onRemoveOption", O, m);
  }, S = (O, m) => {
    console.debug("onSelectOption", O, m);
  }, b = () => {
    for (const O in r.blade) {
      const m = r.blade[O];
      if (r.input[O] = m.value, m.type === "file") {
        const _ = m.attributes;
        _ && typeof _ == "object" && _.filename ? r.file[O] = _.filename : r.file[O] = "no_file_choosen";
      }
      m.type === "password" && (r.icon[O] = "fa-eye", (!m.attributes || typeof m.attributes != "object") && (m.attributes = {}), m.attributes.cType = "password");
    }
  }, T = async (O, m) => {
    if (r.reset) {
      setTimeout(function() {
        r.reset = !1;
      }, 500);
      return;
    }
    for (let _ in O)
      if (O[_] != m[_]) {
        if (r.error[_] = "", e.user.getTestMode() && console.debug("watch", _, O[_]), r.blade[_].type == "select") {
          let X = document.querySelector(`input[name="${_}"]`);
          if (!X) continue;
          X.setAttribute("data-type", "select");
          const $ = O[_];
          let E = "";
          Array.isArray($) ? $.length > 0 && (E = JSON.stringify($.map((D) => D.code))) : $ && typeof $ == "object" && Object.keys($).length > 0 && (E = $.code ?? ""), X.setAttribute("value", E), X.setAttribute("data-value", E);
        }
        if (r.blade[_].type == "decimal" && "attributes" in r.blade[_] && typeof r.blade[_].attributes == "object" && "decimal" in r.blade[_]?.attributes) {
          const X = (r.blade[_]?.attributes).decimal;
          String(O[_]).includes(".") && (r.input[_] = String(O[_]).split(".")[0] + "." + String(O[_]).split(".")[1].slice(0, X));
        }
        if (r.blade[_].type == "number" && "attributes" in r.blade[_] && typeof r.blade[_].attributes == "object") {
          if ("min" in r.blade[_]?.attributes) {
            const X = (r.blade[_]?.attributes).min;
            O[_] >= X ? r.input[_] = O[_] : r.input[_] = m[_];
          }
          if ("max" in r.blade[_]?.attributes) {
            const X = (r.blade[_]?.attributes).max;
            O[_] <= X ? r.input[_] = O[_] : r.input[_] = m[_];
          }
        }
        if (r.blade[_].type == "text" && "attributes" in r.blade[_] && typeof r.blade[_].attributes == "object") {
          if ("maxlength" in r.blade[_]?.attributes) {
            const X = (r.blade[_]?.attributes).maxlength;
            String(r.input[_]).length <= X ? r.input[_] = O[_] : r.input[_] = m[_];
          }
          "transform" in r.blade[_]?.attributes && ((r.blade[_]?.attributes).transform == "uppercase" ? r.input[_] = O[_].toUpperCase() : r.input[_] = O[_].toLowerCase());
        }
        if (["datetime", "decimal", "number", "switch", "text", "textarea"].includes(r.blade[_].type) && (r.blade[_].value = r.input[_]), "relation" in r.blade[_] && t.fInputChange instanceof Function)
          for (let X in r.blade[_].relation) {
            let $ = r.blade[_].relation[X];
            t.fInputChange($, _, O[_]);
          }
        t.vModel && t.fValidator(
          {
            name: _,
            type: r.blade[_].type,
            value: O[_]
          },
          t.vModel,
          { ...t.vFormOption, data: r.input }
        );
      }
  }, w = ge(() => t.vFormAlign === "row"), N = ge(() => Object.keys(r.blade).filter(
    (O) => !r.blade[O].divClasses?.includes("d-none") && !r.blade[O].type?.includes("hidden")
  ).reduce((O, m) => {
    const _ = { ...r.blade[m] };
    return t.bIsViewOnly && (typeof _.attributes == "object" && _.attributes !== null ? (_.attributes.disabled = !0, _.attributes.readonly = !0) : _.attributes = {
      disabled: !0,
      readonly: !0
    }), O[m] = _, O;
  }, {}));
  return nt(
    () => ({ ...r.blade }),
    (O) => {
      for (let m in O)
        ["datetime", "decimal", "number", "select", "switch", "text", "textarea"].includes(
          O[m].type
        ) && (r.input[m] = O[m].value), ["file"].includes(O[m].type) && typeof O[m].attributes == "object" && "filename" in O[m].attributes && (r.file[m] = O[m].attributes.filename, r.draw++);
    },
    { deep: !0 }
  ), {
    mxForm: r,
    mxFormGroupData: o,
    initForm: n,
    getDateSetting: a,
    getInputNote: l,
    getInputType: i,
    getSelectAttributes: s,
    getSelectOptions: u,
    handleDecimalType: c,
    isAllowEmpty: g,
    isDisabled: p,
    isMultiSelect: h,
    isRequired: v,
    onRemoveOption: A,
    onSelectOption: S,
    setInitialInput: b,
    watchMxForm: T,
    bFormRowAlign: w,
    vFormBlade: N
  };
};
function wg(e) {
  return e === 0 ? !1 : Array.isArray(e) && e.length === 0 ? !0 : !e;
}
function QL(e) {
  return (...t) => !e(...t);
}
function jL(e, t) {
  return e === void 0 && (e = "undefined"), e === null && (e = "null"), e === !1 && (e = "false"), e.toString().toLowerCase().indexOf(t.trim()) !== -1;
}
function ZL(e) {
  return e.filter((t) => !t.$isLabel);
}
function _g(e, t) {
  return (r) => r.reduce((o, n) => n[e] && n[e].length ? (o.push({
    $groupLabel: n[t],
    $isLabel: !0
  }), o.concat(n[e])) : o, []);
}
const x1 = (...e) => (t) => e.reduce((r, o) => o(r), t);
var zL = {
  data() {
    return {
      search: "",
      isOpen: !1,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: !0
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: !0
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(e, t) {
        return wg(e) ? "" : t ? e[t] : e;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: !1
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: !1
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: !1
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
     */
    preventAutofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows a custom function for sorting search/filtered results.
     * @default null
     * @type {Function}
     */
    filteringSortFunc: {
      type: Function,
      default: null
    }
  },
  mounted() {
    !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const e = this.search || "", t = e.toLowerCase().trim();
      let r = this.options.concat();
      return this.internalSearch ? r = this.groupValues ? this.filterAndFlat(r, t, this.label) : this.filterOptions(r, t, this.label, this.customLabel) : r = this.groupValues ? _g(this.groupValues, this.groupLabel)(r) : r, r = this.hideSelected ? r.filter(QL(this.isSelected)) : r, this.taggable && t.length && !this.isExistingOption(t) && (this.tagPosition === "bottom" ? r.push({ isTag: !0, label: e }) : r.unshift({ isTag: !0, label: e })), r.slice(0, this.optionsLimit);
    },
    valueKeys() {
      return this.trackBy ? this.internalValue.map((e) => e[this.trackBy]) : this.internalValue;
    },
    optionKeys() {
      return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map((t) => this.customLabel(t, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("update:modelValue", this.multiple ? [] : null));
      },
      deep: !0
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(e, t, r) {
      return x1(
        this.filterGroups(t, r, this.groupValues, this.groupLabel, this.customLabel),
        _g(this.groupValues, this.groupLabel)
      )(e);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(e) {
      return x1(
        _g(this.groupValues, this.groupLabel),
        ZL
      )(e);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(e) {
      this.search = e;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(e) {
      return this.options ? this.optionKeys.indexOf(e) > -1 : !1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(e) {
      const t = this.trackBy ? e[this.trackBy] : e;
      return this.valueKeys.indexOf(t) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(e) {
      return !!e.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(e) {
      if (wg(e)) return "";
      if (e.isTag) return e.label;
      if (e.$isLabel) return e.$groupLabel;
      const t = this.customLabel(e, this.label);
      return wg(t) ? "" : t;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(e, t) {
      if (e.$isLabel && this.groupSelect) {
        this.selectGroup(e);
        return;
      }
      if (!(this.blockKeys.indexOf(t) !== -1 || this.disabled || e.$isDisabled || e.$isLabel) && !(this.max && this.multiple && this.internalValue.length === this.max) && !(t === "Tab" && !this.pointerDirty)) {
        if (e.isTag)
          this.$emit("tag", e.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
        else {
          if (this.isSelected(e)) {
            t !== "Tab" && this.removeElement(e);
            return;
          }
          this.multiple ? this.$emit("update:modelValue", this.internalValue.concat([e])) : this.$emit("update:modelValue", e), this.$emit("select", e, this.id), this.clearOnSelect && (this.search = "");
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(e) {
      const t = this.options.find((r) => r[this.groupLabel] === e.$groupLabel);
      if (t) {
        if (this.wholeGroupSelected(t)) {
          this.$emit("remove", t[this.groupValues], this.id);
          const r = this.trackBy ? t[this.groupValues].map((n) => n[this.trackBy]) : t[this.groupValues], o = this.internalValue.filter(
            (n) => r.indexOf(this.trackBy ? n[this.trackBy] : n) === -1
          );
          this.$emit("update:modelValue", o);
        } else {
          const r = t[this.groupValues].filter(
            (o) => !(this.isOptionDisabled(o) || this.isSelected(o))
          );
          this.max && r.splice(this.max - this.internalValue.length), this.$emit("select", r, this.id), this.$emit(
            "update:modelValue",
            this.internalValue.concat(r)
          );
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(e) {
      return e[this.groupValues].every(
        (t) => this.isSelected(t) || this.isOptionDisabled(t)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(e) {
      return e[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(e, t = !0) {
      if (this.disabled || e.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const r = typeof e == "object" ? this.valueKeys.indexOf(e[this.trackBy]) : this.valueKeys.indexOf(e);
      if (this.multiple) {
        const o = this.internalValue.slice(0, r).concat(this.internalValue.slice(r + 1));
        this.$emit("update:modelValue", o);
      } else
        this.$emit("update:modelValue", null);
      this.$emit("remove", e, this.id), this.closeOnSelect && t && this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(() => this.$refs.search && this.$refs.search.focus())) : this.preventAutofocus || typeof this.$el < "u" && this.$el.focus(), this.$emit("open", this.id));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search !== null && typeof this.$refs.search < "u" && this.$refs.search.blur() : typeof this.$el < "u" && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window > "u") return;
      const e = this.$el.getBoundingClientRect().top, t = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      t > this.maxHeight || t > e || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(t - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(e - 40, this.maxHeight));
    },
    /**
     * Filters and sorts the options ready for selection
     * @param {Array} options
     * @param {String} search
     * @param {String} label
     * @param {Function} customLabel
     * @returns {Array}
     */
    filterOptions(e, t, r, o) {
      return t ? e.filter((n) => jL(o(n, r), t)).sort((n, a) => typeof this.filteringSortFunc == "function" ? this.filteringSortFunc(n, a) : o(n, r).length - o(a, r).length) : e;
    },
    /**
     *
     * @param {String} search
     * @param {String} label
     * @param {String} values
     * @param {String} groupLabel
     * @param {function} customLabel
     * @returns {function(*): *}
     */
    filterGroups(e, t, r, o, n) {
      return (a) => a.map((l) => {
        if (!l[r])
          return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
        const i = this.filterOptions(l[r], e, t, n);
        return i.length ? {
          [o]: l[o],
          [r]: i
        } : [];
      });
    }
  }
}, qL = {
  data() {
    return {
      pointer: 0,
      pointerDirty: !1
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: !0
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = !1;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(e, t) {
      return {
        "multiselect__option--highlight": e === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(t)
      };
    },
    groupHighlight(e, t) {
      if (!this.groupSelect)
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": t.$isLabel }
        ];
      const r = this.options.find((o) => o[this.groupLabel] === t.$groupLabel);
      return r && !this.wholeGroupDisabled(r) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": e === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(r) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key: e } = "Enter") {
      this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
    },
    pointerForward() {
      this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list?.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
    },
    pointerBackward() {
      this.pointer > 0 ? (this.pointer--, this.$refs.list?.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
    },
    pointerAdjust() {
      this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
    },
    pointerSet(e) {
      this.pointer = e, this.pointerDirty = !0;
    }
  }
}, Wa = {
  name: "vue-multiselect",
  mixins: [zL, qL],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: !1
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (e) => `and ${e} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables search input's spellcheck if true.
     * @default false
     * @type {Boolean}
     */
    spellcheck: {
      type: Boolean,
      default: !1
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: !0
    },
    showNoResults: {
      type: Boolean,
      default: !0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Adds Required attribute to the input element when there is no value selected
     * @default false
     * @type {Boolean}
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Uses Vue Teleport's feature. Teleports the open dropdown to the bottom of the teleportTarget element
     * @default false
     * @type {Boolean}
     */
    useTeleport: {
      type: Boolean,
      default: !1
    },
    /**
     * Target selector for teleporting the dropdown element
     * @default 'body'
     * @type {String|Object}
     */
    teleportTarget: {
      type: [String, Object],
      default: "body"
    },
    /**
     * Classes to apply to the `multiselect__content-wrapper` element. This element is a teleport element (when enabled), so can be used to specifically target
     * the teleported element
     */
    contentWrapperClass: {
      type: [String, Array, Object],
      default: ""
    }
  },
  data() {
    return {
      dropdownStyles: {},
      ready: !1
    };
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      return this.searchable || this.multiple && this.modelValue && this.modelValue.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      return this.openDirection === "above" || this.openDirection === "top" ? !0 : this.openDirection === "below" || this.openDirection === "bottom" ? !1 : this.preferredOpenDirection === "above";
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : !0);
    },
    isRequired() {
      return this.required === !1 ? !1 : this.internalValue.length <= 0;
    }
  },
  watch: {
    isOpen(e) {
      e && (this.useTeleport ? (this.ready = !1, this.$nextTick(() => {
        const t = this.$el.getBoundingClientRect();
        this.dropdownStyles = {
          position: "absolute",
          top: `${t.bottom + window.scrollY}px`,
          left: `${t.left + window.scrollX}px`,
          width: `${t.width}px`,
          zIndex: 9999
        }, this.ready = !0;
      })) : this.ready = !0);
    }
  }
};
const JL = ["tabindex", "aria-expanded", "aria-owns", "aria-activedescendant"], eE = {
  ref: "tags",
  class: "multiselect__tags"
}, tE = { class: "multiselect__tags-wrap" }, rE = ["textContent"], oE = ["onKeydown", "onMousedown"], nE = ["textContent"], aE = { class: "multiselect__spinner" }, lE = ["name", "id", "spellcheck", "placeholder", "required", "value", "disabled", "tabindex", "aria-label", "aria-controls"], iE = ["id", "aria-multiselectable"], sE = { key: 0 }, dE = { class: "multiselect__option" }, uE = ["aria-selected", "id", "role"], cE = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"], mE = ["data-select", "data-deselect", "onMouseenter", "onMousedown"], gE = { class: "multiselect__option" }, fE = { class: "multiselect__option" };
function pE(e, t, r, o, n, a) {
  return C(), k("div", {
    tabindex: e.searchable ? -1 : r.tabindex,
    class: $e([{ "multiselect--active": e.isOpen, "multiselect--disabled": r.disabled, "multiselect--above": a.isAbove, "multiselect--has-options-group": a.hasOptionGroup }, "multiselect"]),
    onFocus: t[14] || (t[14] = (l) => e.activate()),
    onBlur: t[15] || (t[15] = (l) => e.searchable ? !1 : e.deactivate()),
    onKeydown: [
      t[16] || (t[16] = Ao(Nt((l) => e.pointerForward(), ["self", "prevent"]), ["down"])),
      t[17] || (t[17] = Ao(Nt((l) => e.pointerBackward(), ["self", "prevent"]), ["up"])),
      t[18] || (t[18] = Ao(Nt((l) => e.addPointerElement(l), ["stop", "self"]), ["enter", "tab"]))
    ],
    onKeyup: t[19] || (t[19] = Ao((l) => e.deactivate(), ["esc"])),
    role: "combobox",
    "aria-expanded": e.isOpen,
    "aria-owns": "listbox-" + e.id,
    "aria-activedescendant": e.isOpen && e.pointer !== null ? e.id + "-" + e.pointer : null
  }, [
    be(e.$slots, "caret", { toggle: e.toggle }, () => [
      L(
        "div",
        {
          onMousedown: t[0] || (t[0] = Nt((l) => e.toggle(), ["prevent", "stop"])),
          class: "multiselect__select"
        },
        null,
        32
        /* NEED_HYDRATION */
      )
    ]),
    be(e.$slots, "clear", { search: e.search }),
    L(
      "div",
      eE,
      [
        be(e.$slots, "selection", {
          search: e.search,
          remove: e.removeElement,
          values: a.visibleValues,
          isOpen: e.isOpen
        }, () => [
          Qt(L(
            "div",
            tE,
            [
              (C(!0), k(
                De,
                null,
                rt(a.visibleValues, (l, i) => be(e.$slots, "tag", {
                  option: l,
                  search: e.search,
                  remove: e.removeElement
                }, () => [
                  (C(), k(
                    "span",
                    {
                      class: "multiselect__tag",
                      key: i,
                      onMousedown: t[1] || (t[1] = Nt(() => {
                      }, ["prevent"]))
                    },
                    [
                      L("span", {
                        textContent: _e(e.getOptionLabel(l))
                      }, null, 8, rE),
                      L("i", {
                        tabindex: "1",
                        onKeydown: Ao(Nt((s) => e.removeElement(l), ["prevent"]), ["enter"]),
                        onMousedown: Nt((s) => e.removeElement(l), ["prevent"]),
                        class: "multiselect__tag-icon"
                      }, null, 40, oE)
                    ],
                    32
                    /* NEED_HYDRATION */
                  ))
                ])),
                256
                /* UNKEYED_FRAGMENT */
              ))
            ],
            512
            /* NEED_PATCH */
          ), [
            [An, a.visibleValues.length > 0]
          ]),
          e.internalValue && e.internalValue.length > r.limit ? be(e.$slots, "limit", { key: 0 }, () => [
            L("strong", {
              class: "multiselect__strong",
              textContent: _e(r.limitText(e.internalValue.length - r.limit))
            }, null, 8, nE)
          ]) : q("v-if", !0)
        ]),
        vt(un, { name: "multiselect__loading" }, {
          default: je(() => [
            be(e.$slots, "loading", {}, () => [
              Qt(L(
                "div",
                aE,
                null,
                512
                /* NEED_PATCH */
              ), [
                [An, r.loading]
              ])
            ])
          ]),
          _: 3
          /* FORWARDED */
        }),
        e.searchable ? (C(), k("input", {
          key: 0,
          ref: "search",
          name: r.name,
          id: e.id,
          type: "text",
          autocomplete: "off",
          spellcheck: r.spellcheck,
          placeholder: e.placeholder,
          required: a.isRequired,
          style: io(a.inputStyle),
          value: e.search,
          disabled: r.disabled,
          tabindex: r.tabindex,
          "aria-label": r.name + "-searchbox",
          onInput: t[2] || (t[2] = (l) => e.updateSearch(l.target.value)),
          onFocus: t[3] || (t[3] = Nt((l) => e.activate(), ["prevent"])),
          onBlur: t[4] || (t[4] = Nt((l) => e.deactivate(), ["prevent"])),
          onKeyup: t[5] || (t[5] = Ao((l) => e.deactivate(), ["esc"])),
          onKeydown: [
            t[6] || (t[6] = Ao(Nt((l) => e.pointerForward(), ["prevent"]), ["down"])),
            t[7] || (t[7] = Ao(Nt((l) => e.pointerBackward(), ["prevent"]), ["up"])),
            t[8] || (t[8] = Ao(Nt((l) => e.addPointerElement(l), ["prevent", "stop", "self"]), ["enter"])),
            t[9] || (t[9] = Ao(Nt((l) => e.removeLastElement(), ["stop"]), ["delete"]))
          ],
          class: "multiselect__input",
          "aria-controls": "listbox-" + e.id
        }, null, 44, lE)) : q("v-if", !0),
        a.isSingleLabelVisible ? (C(), k(
          "span",
          {
            key: 1,
            class: "multiselect__single",
            onMousedown: t[10] || (t[10] = Nt((...l) => e.toggle && e.toggle(...l), ["prevent"]))
          },
          [
            be(e.$slots, "singleLabel", { option: a.singleValue }, () => [
              Gt(
                _e(e.currentOptionLabel),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : q("v-if", !0),
        a.isPlaceholderVisible ? (C(), k(
          "span",
          {
            key: 2,
            class: "multiselect__placeholder",
            onMousedown: t[11] || (t[11] = Nt((...l) => e.toggle && e.toggle(...l), ["prevent"]))
          },
          [
            be(e.$slots, "placeholder", {}, () => [
              Gt(
                _e(e.placeholder),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : q("v-if", !0)
      ],
      512
      /* NEED_PATCH */
    ),
    (C(), ft(_p, {
      to: r.teleportTarget,
      disabled: !r.useTeleport
    }, [
      vt(un, { name: "multiselect" }, {
        default: je(() => [
          e.isOpen && n.ready ? (C(), k(
            "div",
            {
              key: 0,
              class: $e(["multiselect__content-wrapper", r.contentWrapperClass]),
              onFocus: t[12] || (t[12] = (...l) => e.activate && e.activate(...l)),
              tabindex: "-1",
              onMousedown: t[13] || (t[13] = Nt(() => {
              }, ["prevent"])),
              style: io([n.dropdownStyles, { maxHeight: e.optimizedHeight + "px" }]),
              ref: "list"
            },
            [
              L("ul", {
                class: "multiselect__content",
                style: io(a.contentStyle),
                role: "listbox",
                id: "listbox-" + e.id,
                "aria-multiselectable": e.multiple
              }, [
                be(e.$slots, "beforeList"),
                e.multiple && e.max === e.internalValue.length ? (C(), k("li", sE, [
                  L("span", dE, [
                    be(e.$slots, "maxElements", {}, () => [
                      Gt(
                        "Maximum of " + _e(e.max) + " options selected. First remove a selected option to select another.",
                        1
                        /* TEXT */
                      )
                    ])
                  ])
                ])) : q("v-if", !0),
                !e.max || e.internalValue.length < e.max ? (C(!0), k(
                  De,
                  { key: 1 },
                  rt(e.filteredOptions, (l, i) => (C(), k("li", {
                    class: "multiselect__element",
                    key: i,
                    "aria-selected": e.isSelected(l),
                    id: e.id + "-" + i,
                    role: l && (l.$isLabel || l.$isDisabled) ? null : "option"
                  }, [
                    l && (l.$isLabel || l.$isDisabled) ? q("v-if", !0) : (C(), k("span", {
                      key: 0,
                      class: $e([e.optionHighlight(i, l), "multiselect__option"]),
                      onClick: Nt((s) => e.select(l), ["stop"]),
                      onMouseenter: Nt((s) => e.pointerSet(i), ["self"]),
                      "data-select": l && l.isTag ? e.tagPlaceholder : a.selectLabelText,
                      "data-selected": a.selectedLabelText,
                      "data-deselect": a.deselectLabelText
                    }, [
                      be(e.$slots, "option", {
                        option: l,
                        search: e.search,
                        index: i
                      }, () => [
                        L(
                          "span",
                          null,
                          _e(e.getOptionLabel(l)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, cE)),
                    l && (l.$isLabel || l.$isDisabled) ? (C(), k("span", {
                      key: 1,
                      "data-select": e.groupSelect && a.selectGroupLabelText,
                      "data-deselect": e.groupSelect && a.deselectGroupLabelText,
                      class: $e([e.groupHighlight(i, l), "multiselect__option"]),
                      onMouseenter: Nt((s) => e.groupSelect && e.pointerSet(i), ["self"]),
                      onMousedown: Nt((s) => e.selectGroup(l), ["prevent"])
                    }, [
                      be(e.$slots, "option", {
                        option: l,
                        search: e.search,
                        index: i
                      }, () => [
                        L(
                          "span",
                          null,
                          _e(e.getOptionLabel(l)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, mE)) : q("v-if", !0)
                  ], 8, uE))),
                  128
                  /* KEYED_FRAGMENT */
                )) : q("v-if", !0),
                Qt(L(
                  "li",
                  null,
                  [
                    L("span", gE, [
                      be(e.$slots, "noResult", { search: e.search }, () => [
                        t[20] || (t[20] = Gt("No elements found. Consider changing the search query."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [An, r.showNoResults && e.filteredOptions.length === 0 && e.search && !r.loading]
                ]),
                Qt(L(
                  "li",
                  null,
                  [
                    L("span", fE, [
                      be(e.$slots, "noOptions", {}, () => [
                        t[21] || (t[21] = Gt("List is empty."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [An, r.showNoOptions && e.filteredOptions.length === 0 && !e.search && !r.loading]
                ]),
                be(e.$slots, "afterList")
              ], 12, iE)
            ],
            38
            /* CLASS, STYLE, NEED_HYDRATION */
          )) : q("v-if", !0)
        ]),
        _: 3
        /* FORWARDED */
      })
    ], 8, ["to", "disabled"]))
  ], 42, JL);
}
Wa.render = pE;
const vy = 6048e5, hE = 864e5, xE = 6e4, Sy = 36e5, vE = 1e3, v1 = /* @__PURE__ */ Symbol.for("constructDateFrom");
function ir(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && v1 in e ? e[v1](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function bt(e, t) {
  return ir(t || e, e);
}
function Tn(e, t, r) {
  const o = bt(e, r?.in);
  return isNaN(t) ? ir(r?.in || e, NaN) : (t && o.setDate(o.getDate() + t), o);
}
function Kn(e, t, r) {
  const o = bt(e, r?.in);
  if (isNaN(t)) return ir(e, NaN);
  if (!t)
    return o;
  const n = o.getDate(), a = ir(e, o.getTime());
  a.setMonth(o.getMonth() + t + 1, 0);
  const l = a.getDate();
  return n >= l ? a : (o.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    n
  ), o);
}
function by(e, t, r) {
  const {
    years: o = 0,
    months: n = 0,
    weeks: a = 0,
    days: l = 0,
    hours: i = 0,
    minutes: s = 0,
    seconds: u = 0
  } = t, c = bt(e, r?.in), g = n || o ? Kn(c, n + o * 12) : c, p = l || a ? Tn(g, l + a * 7) : g, h = s + i * 60, A = (u + h * 60) * 1e3;
  return ir(e, +p + A);
}
function SE(e, t, r) {
  return ir(e, +bt(e) + t);
}
function bE(e, t, r) {
  return SE(e, t * Sy);
}
let yE = {};
function Mi() {
  return yE;
}
function jn(e, t) {
  const r = Mi(), o = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, n = bt(e, t?.in), a = n.getDay(), l = (a < o ? 7 : 0) + a - o;
  return n.setDate(n.getDate() - l), n.setHours(0, 0, 0, 0), n;
}
function Bs(e, t) {
  return jn(e, { ...t, weekStartsOn: 1 });
}
function yy(e, t) {
  const r = bt(e, t?.in), o = r.getFullYear(), n = ir(r, 0);
  n.setFullYear(o + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = Bs(n), l = ir(r, 0);
  l.setFullYear(o, 0, 4), l.setHours(0, 0, 0, 0);
  const i = Bs(l);
  return r.getTime() >= a.getTime() ? o + 1 : r.getTime() >= i.getTime() ? o : o - 1;
}
function Vc(e) {
  const t = bt(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function pu(e, ...t) {
  const r = ir.bind(
    null,
    t.find((o) => typeof o == "object")
  );
  return t.map(r);
}
function S1(e, t) {
  const r = bt(e, t?.in);
  return r.setHours(0, 0, 0, 0), r;
}
function wy(e, t, r) {
  const [o, n] = pu(
    r?.in,
    e,
    t
  ), a = S1(o), l = S1(n), i = +a - Vc(a), s = +l - Vc(l);
  return Math.round((i - s) / hE);
}
function wE(e, t) {
  const r = yy(e, t), o = ir(e, 0);
  return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), Bs(o);
}
function _E(e, t, r) {
  return Kn(e, t * 3, r);
}
function S0(e, t, r) {
  return Kn(e, t * 12, r);
}
function b1(e, t) {
  const r = +bt(e) - +bt(t);
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function _y(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Vd(e) {
  return !(!_y(e) && typeof e != "number" || isNaN(+bt(e)));
}
function y1(e, t) {
  const r = bt(e, t?.in);
  return Math.trunc(r.getMonth() / 3) + 1;
}
function TE(e, t, r) {
  const [o, n] = pu(
    r?.in,
    e,
    t
  );
  return o.getFullYear() - n.getFullYear();
}
function AE(e, t, r) {
  const [o, n] = pu(
    r?.in,
    e,
    t
  ), a = b1(o, n), l = Math.abs(TE(o, n));
  o.setFullYear(1584), n.setFullYear(1584);
  const i = b1(o, n) === -a, s = a * (l - +i);
  return s === 0 ? 0 : s;
}
function Ty(e, t) {
  const [r, o] = pu(e, t.start, t.end);
  return { start: r, end: o };
}
function Ay(e, t) {
  const { start: r, end: o } = Ty(t?.in, e);
  let n = +r > +o;
  const a = n ? +r : +o, l = n ? o : r;
  l.setHours(0, 0, 0, 0);
  let i = 1;
  const s = [];
  for (; +l <= a; )
    s.push(ir(r, l)), l.setDate(l.getDate() + i), l.setHours(0, 0, 0, 0);
  return n ? s.reverse() : s;
}
function zl(e, t) {
  const r = bt(e, t?.in), o = r.getMonth(), n = o - o % 3;
  return r.setMonth(n, 1), r.setHours(0, 0, 0, 0), r;
}
function PE(e, t) {
  const { start: r, end: o } = Ty(t?.in, e);
  let n = +r > +o;
  const a = n ? +zl(r) : +zl(o);
  let l = zl(n ? o : r), i = 1;
  const s = [];
  for (; +l <= a; )
    s.push(ir(r, l)), l = _E(l, i);
  return n ? s.reverse() : s;
}
function ME(e, t) {
  const r = bt(e, t?.in);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function Py(e, t) {
  const r = bt(e, t?.in), o = r.getFullYear();
  return r.setFullYear(o + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
function $s(e, t) {
  const r = bt(e, t?.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function My(e, t) {
  const r = Mi(), o = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, n = bt(e, t?.in), a = n.getDay(), l = (a < o ? -7 : 0) + 6 - (a - o);
  return n.setDate(n.getDate() + l), n.setHours(23, 59, 59, 999), n;
}
function w1(e, t) {
  const r = bt(e, t?.in), o = r.getMonth(), n = o - o % 3 + 3;
  return r.setMonth(n, 0), r.setHours(23, 59, 59, 999), r;
}
const $E = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, CE = (e, t, r) => {
  let o;
  const n = $E[e];
  return typeof n == "string" ? o = n : t === 1 ? o = n.one : o = n.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
function Tg(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const LE = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, EE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, OE = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, NE = {
  date: Tg({
    formats: LE,
    defaultWidth: "full"
  }),
  time: Tg({
    formats: EE,
    defaultWidth: "full"
  }),
  dateTime: Tg({
    formats: OE,
    defaultWidth: "full"
  })
}, DE = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, kE = (e, t, r, o) => DE[e];
function Pd(e) {
  return (t, r) => {
    const o = r?.context ? String(r.context) : "standalone";
    let n;
    if (o === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, i = r?.width ? String(r.width) : l;
      n = e.formattingValues[i] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, i = r?.width ? String(r.width) : e.defaultWidth;
      n = e.values[i] || e.values[l];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return n[a];
  };
}
const GE = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, BE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, IE = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, RE = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, FE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, VE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, HE = (e, t) => {
  const r = Number(e), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, UE = {
  ordinalNumber: HE,
  era: Pd({
    values: GE,
    defaultWidth: "wide"
  }),
  quarter: Pd({
    values: BE,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Pd({
    values: IE,
    defaultWidth: "wide"
  }),
  day: Pd({
    values: RE,
    defaultWidth: "wide"
  }),
  dayPeriod: Pd({
    values: FE,
    defaultWidth: "wide",
    formattingValues: VE,
    defaultFormattingWidth: "wide"
  })
};
function Md(e) {
  return (t, r = {}) => {
    const o = r.width, n = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], a = t.match(n);
    if (!a)
      return null;
    const l = a[0], i = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(i) ? WE(i, (g) => g.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      XE(i, (g) => g.test(l))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(s) : s, u = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(u)
    ) : u;
    const c = t.slice(l.length);
    return { value: u, rest: c };
  };
}
function XE(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function WE(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function YE(e) {
  return (t, r = {}) => {
    const o = t.match(e.matchPattern);
    if (!o) return null;
    const n = o[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let l = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    l = r.valueCallback ? r.valueCallback(l) : l;
    const i = t.slice(n.length);
    return { value: l, rest: i };
  };
}
const KE = /^(\d+)(th|st|nd|rd)?/i, QE = /\d+/i, jE = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, ZE = {
  any: [/^b/i, /^(a|c)/i]
}, zE = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, qE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, JE = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, eO = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, tO = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, rO = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, oO = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, nO = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, aO = {
  ordinalNumber: YE({
    matchPattern: KE,
    parsePattern: QE,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Md({
    matchPatterns: jE,
    defaultMatchWidth: "wide",
    parsePatterns: ZE,
    defaultParseWidth: "any"
  }),
  quarter: Md({
    matchPatterns: zE,
    defaultMatchWidth: "wide",
    parsePatterns: qE,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Md({
    matchPatterns: JE,
    defaultMatchWidth: "wide",
    parsePatterns: eO,
    defaultParseWidth: "any"
  }),
  day: Md({
    matchPatterns: tO,
    defaultMatchWidth: "wide",
    parsePatterns: rO,
    defaultParseWidth: "any"
  }),
  dayPeriod: Md({
    matchPatterns: oO,
    defaultMatchWidth: "any",
    parsePatterns: nO,
    defaultParseWidth: "any"
  })
}, $y = {
  code: "en-US",
  formatDistance: CE,
  formatLong: NE,
  formatRelative: kE,
  localize: UE,
  match: aO,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function lO(e, t) {
  const r = bt(e, t?.in);
  return wy(r, $s(r)) + 1;
}
function b0(e, t) {
  const r = bt(e, t?.in), o = +Bs(r) - +wE(r);
  return Math.round(o / vy) + 1;
}
function y0(e, t) {
  const r = bt(e, t?.in), o = r.getFullYear(), n = Mi(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, l = ir(t?.in || e, 0);
  l.setFullYear(o + 1, 0, a), l.setHours(0, 0, 0, 0);
  const i = jn(l, t), s = ir(t?.in || e, 0);
  s.setFullYear(o, 0, a), s.setHours(0, 0, 0, 0);
  const u = jn(s, t);
  return +r >= +i ? o + 1 : +r >= +u ? o : o - 1;
}
function iO(e, t) {
  const r = Mi(), o = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, n = y0(e, t), a = ir(t?.in || e, 0);
  return a.setFullYear(n, 0, o), a.setHours(0, 0, 0, 0), jn(a, t);
}
function w0(e, t) {
  const r = bt(e, t?.in), o = +jn(r, t) - +iO(r, t);
  return Math.round(o / vy) + 1;
}
function nr(e, t) {
  const r = e < 0 ? "-" : "", o = Math.abs(e).toString().padStart(t, "0");
  return r + o;
}
const sl = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
    return nr(t === "yy" ? o % 100 : o, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : nr(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return nr(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return nr(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return nr(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return nr(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return nr(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, o = e.getMilliseconds(), n = Math.trunc(
      o * Math.pow(10, r - 3)
    );
    return nr(n, t.length);
  }
}, Wi = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, _1 = {
  // Era
  G: function(e, t, r) {
    const o = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return r.era(o, { width: "narrow" });
      default:
        return r.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const o = e.getFullYear(), n = o > 0 ? o : 1 - o;
      return r.ordinalNumber(n, { unit: "year" });
    }
    return sl.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, o) {
    const n = y0(e, o), a = n > 0 ? n : 1 - n;
    if (t === "YY") {
      const l = a % 100;
      return nr(l, 2);
    }
    return t === "Yo" ? r.ordinalNumber(a, { unit: "year" }) : nr(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = yy(e);
    return nr(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return nr(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return nr(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return nr(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const o = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return sl.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return r.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const o = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return nr(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return r.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, o) {
    const n = w0(e, o);
    return t === "wo" ? r.ordinalNumber(n, { unit: "week" }) : nr(n, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const o = b0(e);
    return t === "Io" ? r.ordinalNumber(o, { unit: "week" }) : nr(o, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : sl.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const o = lO(e);
    return t === "Do" ? r.ordinalNumber(o, { unit: "dayOfYear" }) : nr(o, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const o = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, o) {
    const n = e.getDay(), a = (n - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return nr(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(a, { unit: "day" });
      case "eee":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, o) {
    const n = e.getDay(), a = (n - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return nr(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return r.day(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(n, {
          width: "short",
          context: "standalone"
        });
      default:
        return r.day(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const o = e.getDay(), n = o === 0 ? 7 : o;
    switch (t) {
      // 2
      case "i":
        return String(n);
      // 02
      case "ii":
        return nr(n, t.length);
      // 2nd
      case "io":
        return r.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const o = e.getHours();
    let n;
    switch (o === 12 ? n = Wi.noon : o === 0 ? n = Wi.midnight : n = o / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const o = e.getHours();
    let n;
    switch (o >= 17 ? n = Wi.evening : o >= 12 ? n = Wi.afternoon : o >= 4 ? n = Wi.morning : n = Wi.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let o = e.getHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, { unit: "hour" });
    }
    return sl.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : sl.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const o = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(o, { unit: "hour" }) : nr(o, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let o = e.getHours();
    return o === 0 && (o = 24), t === "ko" ? r.ordinalNumber(o, { unit: "hour" }) : nr(o, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : sl.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : sl.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return sl.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const o = e.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return A1(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Yl(o);
      // Hours and minutes with `:` delimiter
      default:
        return Yl(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const o = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return A1(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Yl(o);
      // Hours and minutes with `:` delimiter
      default:
        return Yl(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const o = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + T1(o, ":");
      default:
        return "GMT" + Yl(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const o = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + T1(o, ":");
      default:
        return "GMT" + Yl(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const o = Math.trunc(+e / 1e3);
    return nr(o, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    return nr(+e, t.length);
  }
};
function T1(e, t = "") {
  const r = e > 0 ? "-" : "+", o = Math.abs(e), n = Math.trunc(o / 60), a = o % 60;
  return a === 0 ? r + String(n) : r + String(n) + t + nr(a, 2);
}
function A1(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + nr(Math.abs(e) / 60, 2) : Yl(e, t);
}
function Yl(e, t = "") {
  const r = e > 0 ? "-" : "+", o = Math.abs(e), n = nr(Math.trunc(o / 60), 2), a = nr(o % 60, 2);
  return r + n + t + a;
}
const P1 = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, Cy = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, sO = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], o = r[1], n = r[2];
  if (!n)
    return P1(e, t);
  let a;
  switch (o) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", P1(o, t)).replace("{{time}}", Cy(n, t));
}, Xf = {
  p: Cy,
  P: sO
}, dO = /^D+$/, uO = /^Y+$/, cO = ["D", "DD", "YY", "YYYY"];
function Ly(e) {
  return dO.test(e);
}
function Ey(e) {
  return uO.test(e);
}
function Wf(e, t, r) {
  const o = mO(e, t, r);
  if (console.warn(o), cO.includes(e)) throw new RangeError(o);
}
function mO(e, t, r) {
  const o = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${o} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const gO = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, fO = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, pO = /^'([^]*?)'?$/, hO = /''/g, xO = /[a-zA-Z]/;
function Sa(e, t, r) {
  const o = Mi(), n = r?.locale ?? o.locale ?? $y, a = r?.firstWeekContainsDate ?? r?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, l = r?.weekStartsOn ?? r?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, i = bt(e, r?.in);
  if (!Vd(i))
    throw new RangeError("Invalid time value");
  let s = t.match(fO).map((c) => {
    const g = c[0];
    if (g === "p" || g === "P") {
      const p = Xf[g];
      return p(c, n.formatLong);
    }
    return c;
  }).join("").match(gO).map((c) => {
    if (c === "''")
      return { isToken: !1, value: "'" };
    const g = c[0];
    if (g === "'")
      return { isToken: !1, value: vO(c) };
    if (_1[g])
      return { isToken: !0, value: c };
    if (g.match(xO))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + g + "`"
      );
    return { isToken: !1, value: c };
  });
  n.localize.preprocessor && (s = n.localize.preprocessor(i, s));
  const u = {
    firstWeekContainsDate: a,
    weekStartsOn: l,
    locale: n
  };
  return s.map((c) => {
    if (!c.isToken) return c.value;
    const g = c.value;
    (!r?.useAdditionalWeekYearTokens && Ey(g) || !r?.useAdditionalDayOfYearTokens && Ly(g)) && Wf(g, t, String(e));
    const p = _1[g[0]];
    return p(i, g, n.localize, u);
  }).join("");
}
function vO(e) {
  const t = e.match(pO);
  return t ? t[1].replace(hO, "'") : e;
}
function SO(e, t) {
  return bt(e, t?.in).getDay();
}
function bO(e, t) {
  const r = bt(e, t?.in), o = r.getFullYear(), n = r.getMonth(), a = ir(r, 0);
  return a.setFullYear(o, n + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function yO() {
  return Object.assign({}, Mi());
}
function Ya(e, t) {
  return bt(e, t?.in).getHours();
}
function wO(e, t) {
  const r = bt(e, t?.in).getDay();
  return r === 0 ? 7 : r;
}
function $l(e, t) {
  return bt(e, t?.in).getMinutes();
}
function It(e, t) {
  return bt(e, t?.in).getMonth();
}
function Is(e) {
  return bt(e).getSeconds();
}
function $t(e, t) {
  return bt(e, t?.in).getFullYear();
}
function gi(e, t) {
  return +bt(e) > +bt(t);
}
function Rs(e, t) {
  return +bt(e) < +bt(t);
}
function ws(e, t) {
  return +bt(e) == +bt(t);
}
function _O(e, t) {
  const r = TO(t) ? new t(0) : ir(t, 0);
  return r.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), r.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), r;
}
function TO(e) {
  return typeof e == "function" && e.prototype?.constructor === e;
}
const AO = 10;
let Oy = class {
  subPriority = 0;
  validate(t, r) {
    return !0;
  }
}, PO = class extends Oy {
  constructor(t, r, o, n, a) {
    super(), this.value = t, this.validateValue = r, this.setValue = o, this.priority = n, a && (this.subPriority = a);
  }
  validate(t, r) {
    return this.validateValue(t, this.value, r);
  }
  set(t, r, o) {
    return this.setValue(t, r, this.value, o);
  }
};
class MO extends Oy {
  priority = AO;
  subPriority = -1;
  constructor(t, r) {
    super(), this.context = t || ((o) => ir(r, o));
  }
  set(t, r) {
    return r.timestampIsSet ? t : ir(t, _O(t, this.context));
  }
}
let er = class {
  run(t, r, o, n) {
    const a = this.parse(t, r, o, n);
    return a ? {
      setter: new PO(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(t, r, o) {
    return !0;
  }
}, $O = class extends er {
  priority = 140;
  parse(t, r, o) {
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return o.era(t, { width: "narrow" });
      default:
        return o.era(t, { width: "wide" }) || o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
    }
  }
  set(t, r, o) {
    return r.era = o, t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
};
const Hr = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, ma = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Ur(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function $r(e, t) {
  const r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function ga(e, t) {
  const r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const o = r[1] === "+" ? 1 : -1, n = r[2] ? parseInt(r[2], 10) : 0, a = r[3] ? parseInt(r[3], 10) : 0, l = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: o * (n * Sy + a * xE + l * vE),
    rest: t.slice(r[0].length)
  };
}
function Ny(e) {
  return $r(Hr.anyDigitsSigned, e);
}
function Or(e, t) {
  switch (e) {
    case 1:
      return $r(Hr.singleDigit, t);
    case 2:
      return $r(Hr.twoDigits, t);
    case 3:
      return $r(Hr.threeDigits, t);
    case 4:
      return $r(Hr.fourDigits, t);
    default:
      return $r(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Hc(e, t) {
  switch (e) {
    case 1:
      return $r(Hr.singleDigitSigned, t);
    case 2:
      return $r(Hr.twoDigitsSigned, t);
    case 3:
      return $r(Hr.threeDigitsSigned, t);
    case 4:
      return $r(Hr.fourDigitsSigned, t);
    default:
      return $r(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function _0(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    default:
      return 0;
  }
}
function Dy(e, t) {
  const r = t > 0, o = r ? t : 1 - t;
  let n;
  if (o <= 50)
    n = e || 100;
  else {
    const a = o + 50, l = Math.trunc(a / 100) * 100, i = e >= a % 100;
    n = e + l - (i ? 100 : 0);
  }
  return r ? n : 1 - n;
}
function ky(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
let CO = class extends er {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(t, r, o) {
    const n = (a) => ({
      year: a,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return Ur(Or(4, t), n);
      case "yo":
        return Ur(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          n
        );
      default:
        return Ur(Or(r.length, t), n);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, o) {
    const n = t.getFullYear();
    if (o.isTwoDigitYear) {
      const l = Dy(
        o.year,
        n
      );
      return t.setFullYear(l, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const a = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}, LO = class extends er {
  priority = 130;
  parse(t, r, o) {
    const n = (a) => ({
      year: a,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return Ur(Or(4, t), n);
      case "Yo":
        return Ur(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          n
        );
      default:
        return Ur(Or(r.length, t), n);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, o, n) {
    const a = y0(t, n);
    if (o.isTwoDigitYear) {
      const i = Dy(
        o.year,
        a
      );
      return t.setFullYear(
        i,
        0,
        n.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), jn(t, n);
    }
    const l = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(l, 0, n.firstWeekContainsDate), t.setHours(0, 0, 0, 0), jn(t, n);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}, EO = class extends er {
  priority = 130;
  parse(t, r) {
    return Hc(r === "R" ? 4 : r.length, t);
  }
  set(t, r, o) {
    const n = ir(t, 0);
    return n.setFullYear(o, 0, 4), n.setHours(0, 0, 0, 0), Bs(n);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}, OO = class extends er {
  priority = 130;
  parse(t, r) {
    return Hc(r === "u" ? 4 : r.length, t);
  }
  set(t, r, o) {
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}, NO = class extends er {
  priority = 120;
  parse(t, r, o) {
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return Or(r.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return o.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}, DO = class extends er {
  priority = 120;
  parse(t, r, o) {
    switch (r) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return Or(r.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return o.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}, kO = class extends er {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(t, r, o) {
    const n = (a) => a - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "M":
        return Ur(
          $r(Hr.month, t),
          n
        );
      // 01, 02, ..., 12
      case "MM":
        return Ur(Or(2, t), n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return Ur(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          n
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return o.month(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return o.month(t, { width: "wide", context: "formatting" }) || o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}, GO = class extends er {
  priority = 110;
  parse(t, r, o) {
    const n = (a) => a - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return Ur(
          $r(Hr.month, t),
          n
        );
      // 01, 02, ..., 12
      case "LL":
        return Ur(Or(2, t), n);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return Ur(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          n
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return o.month(t, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return o.month(t, { width: "wide", context: "standalone" }) || o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
};
function BO(e, t, r) {
  const o = bt(e, r?.in), n = w0(o, r) - t;
  return o.setDate(o.getDate() - n * 7), bt(o, r?.in);
}
let IO = class extends er {
  priority = 100;
  parse(t, r, o) {
    switch (r) {
      case "w":
        return $r(Hr.week, t);
      case "wo":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return Or(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, o, n) {
    return jn(BO(t, o, n), n);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
};
function RO(e, t, r) {
  const o = bt(e, r?.in), n = b0(o, r) - t;
  return o.setDate(o.getDate() - n * 7), o;
}
let FO = class extends er {
  priority = 100;
  parse(t, r, o) {
    switch (r) {
      case "I":
        return $r(Hr.week, t);
      case "Io":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return Or(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, o) {
    return Bs(RO(t, o));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
};
const VO = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], HO = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
let UO = class extends er {
  priority = 90;
  subPriority = 1;
  parse(t, r, o) {
    switch (r) {
      case "d":
        return $r(Hr.date, t);
      case "do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return Or(r.length, t);
    }
  }
  validate(t, r) {
    const o = t.getFullYear(), n = ky(o), a = t.getMonth();
    return n ? r >= 1 && r <= HO[a] : r >= 1 && r <= VO[a];
  }
  set(t, r, o) {
    return t.setDate(o), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}, XO = class extends er {
  priority = 90;
  subpriority = 1;
  parse(t, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return $r(Hr.dayOfYear, t);
      case "Do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return Or(r.length, t);
    }
  }
  validate(t, r) {
    const o = t.getFullYear();
    return ky(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(t, r, o) {
    return t.setMonth(0, o), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
};
function T0(e, t, r) {
  const o = Mi(), n = r?.weekStartsOn ?? r?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, a = bt(e, r?.in), l = a.getDay(), s = (t % 7 + 7) % 7, u = 7 - n, c = t < 0 || t > 6 ? t - (l + u) % 7 : (s + u) % 7 - (l + u) % 7;
  return Tn(a, c, r);
}
let WO = class extends er {
  priority = 90;
  parse(t, r, o) {
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, o, n) {
    return t = T0(t, o, n), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}, YO = class extends er {
  priority = 90;
  parse(t, r, o, n) {
    const a = (l) => {
      const i = Math.floor((l - 1) / 7) * 7;
      return (l + n.weekStartsOn + 6) % 7 + i;
    };
    switch (r) {
      // 3
      case "e":
      case "ee":
        return Ur(Or(r.length, t), a);
      // 3rd
      case "eo":
        return Ur(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      // Tue
      case "eee":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, o, n) {
    return t = T0(t, o, n), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}, KO = class extends er {
  priority = 90;
  parse(t, r, o, n) {
    const a = (l) => {
      const i = Math.floor((l - 1) / 7) * 7;
      return (l + n.weekStartsOn + 6) % 7 + i;
    };
    switch (r) {
      // 3
      case "c":
      case "cc":
        return Ur(Or(r.length, t), a);
      // 3rd
      case "co":
        return Ur(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      // Tue
      case "ccc":
        return o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return o.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      default:
        return o.day(t, { width: "wide", context: "standalone" }) || o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, o, n) {
    return t = T0(t, o, n), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
};
function QO(e, t, r) {
  const o = bt(e, r?.in), n = wO(o, r), a = t - n;
  return Tn(o, a, r);
}
let jO = class extends er {
  priority = 90;
  parse(t, r, o) {
    const n = (a) => a === 0 ? 7 : a;
    switch (r) {
      // 2
      case "i":
      case "ii":
        return Or(r.length, t);
      // 2nd
      case "io":
        return o.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return Ur(
          o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          n
        );
      // T
      case "iiiii":
        return Ur(
          o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          n
        );
      // Tu
      case "iiiiii":
        return Ur(
          o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          n
        );
      default:
        return Ur(
          o.day(t, {
            width: "wide",
            context: "formatting"
          }) || o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          n
        );
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 7;
  }
  set(t, r, o) {
    return t = QO(t, o), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}, ZO = class extends er {
  priority = 80;
  parse(t, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, o) {
    return t.setHours(_0(o), 0, 0, 0), t;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}, zO = class extends er {
  priority = 80;
  parse(t, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, o) {
    return t.setHours(_0(o), 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}, qO = class extends er {
  priority = 80;
  parse(t, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, o) {
    return t.setHours(_0(o), 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}, JO = class extends er {
  priority = 70;
  parse(t, r, o) {
    switch (r) {
      case "h":
        return $r(Hr.hour12h, t);
      case "ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return Or(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 12;
  }
  set(t, r, o) {
    const n = t.getHours() >= 12;
    return n && o < 12 ? t.setHours(o + 12, 0, 0, 0) : !n && o === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}, e3 = class extends er {
  priority = 70;
  parse(t, r, o) {
    switch (r) {
      case "H":
        return $r(Hr.hour23h, t);
      case "Ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return Or(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 23;
  }
  set(t, r, o) {
    return t.setHours(o, 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}, t3 = class extends er {
  priority = 70;
  parse(t, r, o) {
    switch (r) {
      case "K":
        return $r(Hr.hour11h, t);
      case "Ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return Or(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, o) {
    return t.getHours() >= 12 && o < 12 ? t.setHours(o + 12, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}, r3 = class extends er {
  priority = 70;
  parse(t, r, o) {
    switch (r) {
      case "k":
        return $r(Hr.hour24h, t);
      case "ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return Or(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 24;
  }
  set(t, r, o) {
    const n = o <= 24 ? o % 24 : o;
    return t.setHours(n, 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}, o3 = class extends er {
  priority = 60;
  parse(t, r, o) {
    switch (r) {
      case "m":
        return $r(Hr.minute, t);
      case "mo":
        return o.ordinalNumber(t, { unit: "minute" });
      default:
        return Or(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, o) {
    return t.setMinutes(o, 0, 0), t;
  }
  incompatibleTokens = ["t", "T"];
}, n3 = class extends er {
  priority = 50;
  parse(t, r, o) {
    switch (r) {
      case "s":
        return $r(Hr.second, t);
      case "so":
        return o.ordinalNumber(t, { unit: "second" });
      default:
        return Or(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, o) {
    return t.setSeconds(o, 0), t;
  }
  incompatibleTokens = ["t", "T"];
}, a3 = class extends er {
  priority = 30;
  parse(t, r) {
    const o = (n) => Math.trunc(n * Math.pow(10, -r.length + 3));
    return Ur(Or(r.length, t), o);
  }
  set(t, r, o) {
    return t.setMilliseconds(o), t;
  }
  incompatibleTokens = ["t", "T"];
}, l3 = class extends er {
  priority = 10;
  parse(t, r) {
    switch (r) {
      case "X":
        return ga(
          ma.basicOptionalMinutes,
          t
        );
      case "XX":
        return ga(ma.basic, t);
      case "XXXX":
        return ga(
          ma.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return ga(
          ma.extendedOptionalSeconds,
          t
        );
      default:
        return ga(ma.extended, t);
    }
  }
  set(t, r, o) {
    return r.timestampIsSet ? t : ir(
      t,
      t.getTime() - Vc(t) - o
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}, i3 = class extends er {
  priority = 10;
  parse(t, r) {
    switch (r) {
      case "x":
        return ga(
          ma.basicOptionalMinutes,
          t
        );
      case "xx":
        return ga(ma.basic, t);
      case "xxxx":
        return ga(
          ma.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return ga(
          ma.extendedOptionalSeconds,
          t
        );
      default:
        return ga(ma.extended, t);
    }
  }
  set(t, r, o) {
    return r.timestampIsSet ? t : ir(
      t,
      t.getTime() - Vc(t) - o
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}, s3 = class extends er {
  priority = 40;
  parse(t) {
    return Ny(t);
  }
  set(t, r, o) {
    return [ir(t, o * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}, d3 = class extends er {
  priority = 20;
  parse(t) {
    return Ny(t);
  }
  set(t, r, o) {
    return [ir(t, o), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
};
const u3 = {
  G: new $O(),
  y: new CO(),
  Y: new LO(),
  R: new EO(),
  u: new OO(),
  Q: new NO(),
  q: new DO(),
  M: new kO(),
  L: new GO(),
  w: new IO(),
  I: new FO(),
  d: new UO(),
  D: new XO(),
  E: new WO(),
  e: new YO(),
  c: new KO(),
  i: new jO(),
  a: new ZO(),
  b: new zO(),
  B: new qO(),
  h: new JO(),
  H: new e3(),
  K: new t3(),
  k: new r3(),
  m: new o3(),
  s: new n3(),
  S: new a3(),
  X: new l3(),
  x: new i3(),
  t: new s3(),
  T: new d3()
}, c3 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, m3 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, g3 = /^'([^]*?)'?$/, f3 = /''/g, p3 = /\S/, h3 = /[a-zA-Z]/;
function Yf(e, t, r, o) {
  const n = () => ir(o?.in || r, NaN), a = yO(), l = o?.locale ?? a.locale ?? $y, i = o?.firstWeekContainsDate ?? o?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, s = o?.weekStartsOn ?? o?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0;
  if (!t)
    return e ? n() : bt(r, o?.in);
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: l
  }, c = [new MO(o?.in, r)], g = t.match(m3).map((S) => {
    const b = S[0];
    if (b in Xf) {
      const T = Xf[b];
      return T(S, l.formatLong);
    }
    return S;
  }).join("").match(c3), p = [];
  for (let S of g) {
    !o?.useAdditionalWeekYearTokens && Ey(S) && Wf(S, t, e), !o?.useAdditionalDayOfYearTokens && Ly(S) && Wf(S, t, e);
    const b = S[0], T = u3[b];
    if (T) {
      const { incompatibleTokens: w } = T;
      if (Array.isArray(w)) {
        const O = p.find(
          (m) => w.includes(m.token) || m.token === b
        );
        if (O)
          throw new RangeError(
            `The format string mustn't contain \`${O.fullToken}\` and \`${S}\` at the same time`
          );
      } else if (T.incompatibleTokens === "*" && p.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${S}\` and any other token at the same time`
        );
      p.push({ token: b, fullToken: S });
      const N = T.run(
        e,
        S,
        l.match,
        u
      );
      if (!N)
        return n();
      c.push(N.setter), e = N.rest;
    } else {
      if (b.match(h3))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + b + "`"
        );
      if (S === "''" ? S = "'" : b === "'" && (S = x3(S)), e.indexOf(S) === 0)
        e = e.slice(S.length);
      else
        return n();
    }
  }
  if (e.length > 0 && p3.test(e))
    return n();
  const h = c.map((S) => S.priority).sort((S, b) => b - S).filter((S, b, T) => T.indexOf(S) === b).map(
    (S) => c.filter((b) => b.priority === S).sort((b, T) => T.subPriority - b.subPriority)
  ).map((S) => S[0]);
  let v = bt(r, o?.in);
  if (isNaN(+v)) return n();
  const A = {};
  for (const S of h) {
    if (!S.validate(v, u))
      return n();
    const b = S.set(v, A, u);
    Array.isArray(b) ? (v = b[0], Object.assign(A, b[1])) : v = b;
  }
  return v;
}
function x3(e) {
  return e.match(g3)[1].replace(f3, "'");
}
function M1(e, t, r) {
  const [o, n] = pu(
    r?.in,
    e,
    t
  );
  return +zl(o) == +zl(n);
}
function Gy(e, t, r) {
  return Tn(e, -t, r);
}
function By(e, t, r) {
  const o = bt(e, r?.in), n = o.getFullYear(), a = o.getDate(), l = ir(e, 0);
  l.setFullYear(n, t, 15), l.setHours(0, 0, 0, 0);
  const i = bO(l);
  return o.setMonth(t, Math.min(a, i)), o;
}
function cr(e, t, r) {
  let o = bt(e, r?.in);
  return isNaN(+o) ? ir(e, NaN) : (t.year != null && o.setFullYear(t.year), t.month != null && (o = By(o, t.month)), t.date != null && o.setDate(t.date), t.hours != null && o.setHours(t.hours), t.minutes != null && o.setMinutes(t.minutes), t.seconds != null && o.setSeconds(t.seconds), t.milliseconds != null && o.setMilliseconds(t.milliseconds), o);
}
function v3(e, t, r) {
  const o = bt(e, r?.in);
  return o.setHours(t), o;
}
function Iy(e, t, r) {
  const o = bt(e, r?.in);
  return o.setMilliseconds(t), o;
}
function S3(e, t, r) {
  const o = bt(e, r?.in);
  return o.setMinutes(t), o;
}
function Ry(e, t, r) {
  const o = bt(e, r?.in);
  return o.setSeconds(t), o;
}
function Xn(e, t, r) {
  const o = bt(e, r?.in);
  return isNaN(+o) ? ir(e, NaN) : (o.setFullYear(t), o);
}
function Fs(e, t, r) {
  return Kn(e, -t, r);
}
function b3(e, t, r) {
  const {
    years: o = 0,
    months: n = 0,
    weeks: a = 0,
    days: l = 0,
    hours: i = 0,
    minutes: s = 0,
    seconds: u = 0
  } = t, c = Fs(e, n + o * 12, r), g = Gy(c, l + a * 7, r), p = s + i * 60, v = (u + p * 60) * 1e3;
  return ir(e, +g - v);
}
function Fy(e, t, r) {
  return S0(e, -t, r);
}
function ld() {
  const e = eA();
  return C(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...e
    },
    [
      L("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      L("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      L("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      L("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
ld.compatConfig = {
  MODE: 3
};
function Vy() {
  return C(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      L("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      L("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Vy.compatConfig = {
  MODE: 3
};
function A0() {
  return C(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      L("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
A0.compatConfig = {
  MODE: 3
};
function P0() {
  return C(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      L("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
P0.compatConfig = {
  MODE: 3
};
function M0() {
  return C(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      L("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      L("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
M0.compatConfig = {
  MODE: 3
};
function $0() {
  return C(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      L("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
$0.compatConfig = {
  MODE: 3
};
function C0() {
  return C(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      L("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
C0.compatConfig = {
  MODE: 3
};
const zo = (e, t) => t ? new Date(e.toLocaleString("en-US", { timeZone: t })) : new Date(e), L0 = (e, t, r) => Kf(e, t, r) || Re(), y3 = (e, t, r) => {
  const o = t.dateInTz ? zo(new Date(e), t.dateInTz) : Re(e);
  return r ? uo(o, !0) : o;
}, Kf = (e, t, r) => {
  if (!e) return null;
  const o = r ? uo(Re(e), !0) : Re(e);
  return t ? t.exactMatch ? y3(e, t, r) : zo(o, t.timezone) : o;
}, w3 = (e) => {
  const t = new Date(e.getFullYear(), 0, 1).getTimezoneOffset();
  return e.getTimezoneOffset() < t;
}, _3 = (e, t) => {
  if (!e) return 0;
  const r = /* @__PURE__ */ new Date(), o = new Date(r.toLocaleString("en-US", { timeZone: "UTC" })), n = new Date(r.toLocaleString("en-US", { timeZone: e })), a = (w3(t ?? n) ? n : t ?? n).getTimezoneOffset() / 60;
  return (+o - +n) / (1e3 * 60 * 60) - a;
};
var Hn = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(Hn || {}), Un = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(Un || {}), li = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(li || {}), Po = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Po || {});
const T3 = ["timestamp", "date", "iso"];
var Go = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(Go || {}), wr = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(wr || {}), Cs = /* @__PURE__ */ ((e) => (e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))(Cs || {});
function $1(e) {
  return (t) => {
    const r = new Intl.DateTimeFormat(e, {
      weekday: "short",
      timeZone: "UTC"
    }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`));
    return e === "ar" ? r.slice(2, 5) : r.slice(0, 2);
  };
}
function A3(e) {
  return (t) => Sa(zo(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: e });
}
const P3 = (e, t, r) => {
  const o = [1, 2, 3, 4, 5, 6, 7];
  let n;
  if (e !== null)
    try {
      n = o.map(A3(e));
    } catch {
      n = o.map($1(t));
    }
  else
    n = o.map($1(t));
  const a = n.slice(0, r), l = n.slice(r + 1, n.length);
  return [n[r]].concat(...l).concat(...a);
}, E0 = (e, t, r) => {
  const o = [];
  for (let n = +e[0]; n <= +e[1]; n++)
    o.push({ value: +n, text: N0(n, t) });
  return r ? o.reverse() : o;
}, Hy = (e, t, r) => {
  const o = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((a) => {
    const l = a < 10 ? `0${a}` : a;
    return /* @__PURE__ */ new Date(`2017-${l}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const a = r === "long" ? "LLLL" : "LLL";
      return o.map((l, i) => {
        const s = Sa(zo(l, "UTC"), a, { locale: e });
        return {
          text: s.charAt(0).toUpperCase() + s.substring(1),
          value: i
        };
      });
    } catch {
    }
  const n = new Intl.DateTimeFormat(t, { month: r, timeZone: "UTC" });
  return o.map((a, l) => {
    const i = n.format(a);
    return {
      text: i.charAt(0).toUpperCase() + i.substring(1),
      value: l
    };
  });
}, M3 = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], eo = (e) => {
  const t = R(e);
  return t?.$el ? t?.$el : t;
}, $3 = (e) => ({ type: "dot", ...e ?? {} }), Uy = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, O0 = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, co = (e) => e, C1 = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, L1 = (e) => e === null, Xy = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, C3 = (e) => {
  const t = [], r = (o) => o.filter((n) => n);
  for (let o = 0; o < e.length; o += 3) {
    const n = [e[o], e[o + 1], e[o + 2]];
    t.push(r(n));
  }
  return t;
}, Kd = (e, t, r) => {
  const o = r != null, n = t != null;
  if (!o && !n) return !1;
  const a = +r, l = +t;
  return o && n ? +e > a || +e < l : o ? +e > a : n ? +e < l : !1;
}, Vs = (e, t) => C3(e).map((r) => r.map((o) => {
  const { active: n, disabled: a, isBetween: l, highlighted: i } = t(o);
  return {
    ...o,
    active: n,
    disabled: a,
    className: {
      dp__overlay_cell_active: n,
      dp__overlay_cell: !n,
      dp__overlay_cell_disabled: a,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: a && n,
      dp__cell_in_between: l,
      "dp--highlighted": i
    }
  };
})), Al = (e, t, r = !1) => {
  e && t.allowStopPropagation && (r && e.stopImmediatePropagation(), e.stopPropagation());
}, L3 = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function E3(e, t) {
  let r = [...document.querySelectorAll(L3())];
  r = r.filter((n) => !e.contains(n) || n.hasAttribute("data-datepicker-instance"));
  const o = r.indexOf(e);
  if (o >= 0 && (t ? o - 1 >= 0 : o + 1 <= r.length))
    return r[o + (t ? -1 : 1)];
}
const Qf = (e, t) => e?.querySelector(`[data-dp-element="${t}"]`), N0 = (e, t) => new Intl.NumberFormat(t, { useGrouping: !1, style: "decimal" }).format(e), D0 = (e, t) => Sa(e, t ?? Cs.DATE), Ag = (e) => Array.isArray(e), Uc = (e, t, r) => t.get(D0(e, r)), O3 = (e, t) => e ? t ? t instanceof Map ? !!Uc(e, t) : t(Re(e)) : !1 : !0, Ro = (e, t, r = !1, o) => {
  if (e.key === wr.enter || e.key === wr.space)
    return r && e.preventDefault(), t();
  if (o) return o(e);
}, N3 = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, Wy = (e, t) => e ? Cs.MONTH_AND_YEAR : t ? Cs.YEAR : Cs.DATE, Yy = (e) => e < 10 ? `0${e}` : e, E1 = (e, t, r, o, n, a) => {
  const l = Yf(e, t.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: a });
  return Vd(l) && _y(l) ? o || n ? l : cr(l, {
    hours: +r.hours,
    minutes: +r?.minutes,
    seconds: +r?.seconds,
    milliseconds: 0
  }) : null;
}, D3 = (e, t, r, o, n, a) => {
  const l = Array.isArray(r) ? r[0] : r;
  if (typeof t == "string")
    return E1(e, t, l, o, n, a);
  if (Array.isArray(t)) {
    let i = null;
    for (const s of t)
      if (i = E1(e, s, l, o, n, a), i)
        break;
    return i;
  }
  return typeof t == "function" ? t(e) : null;
}, Re = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), k3 = (e, t, r) => {
  if (t) {
    const n = (e.getMonth() + 1).toString().padStart(2, "0"), a = e.getDate().toString().padStart(2, "0"), l = e.getHours().toString().padStart(2, "0"), i = e.getMinutes().toString().padStart(2, "0"), s = r ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${n}-${a}T${l}:${i}:${s}.000Z`;
  }
  const o = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(o).toISOString();
}, uo = (e, t) => {
  const r = Re(JSON.parse(JSON.stringify(e))), o = cr(r, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return t ? ME(o) : o;
}, Pl = (e, t, r, o) => {
  let n = e ? Re(e) : Re();
  return (t || t === 0) && (n = v3(n, +t)), (r || r === 0) && (n = S3(n, +r)), (o || o === 0) && (n = Ry(n, +o)), Iy(n, 0);
}, Lr = (e, t) => !e || !t ? !1 : Rs(uo(e), uo(t)), Rt = (e, t) => !e || !t ? !1 : ws(uo(e), uo(t)), Fr = (e, t) => !e || !t ? !1 : gi(uo(e), uo(t)), Qd = (e, t, r) => e?.[0] && e?.[1] ? Fr(r, e[0]) && Lr(r, e[1]) : e?.[0] && t ? Fr(r, e[0]) && Lr(r, t) || Lr(r, e[0]) && Fr(r, t) : !1, Wn = (e) => {
  const t = cr(new Date(e), { date: 1 });
  return uo(t);
}, Pg = (e, t, r) => t && (r || r === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((o) => o === t ? [o, r] : [o, isNaN(+e[o]) ? void 0 : +e[o]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, ii = (e) => ({
  hours: Ya(e),
  minutes: $l(e),
  seconds: Is(e)
}), Ky = (e, t) => {
  if (t) {
    const r = $t(Re(t));
    if (r > e) return 12;
    if (r === e) return It(Re(t));
  }
}, Qy = (e, t) => {
  if (t) {
    const r = $t(Re(t));
    return r < e ? -1 : r === e ? It(Re(t)) : void 0;
  }
}, Hs = (e) => {
  if (e) return $t(Re(e));
}, jy = (e, t) => {
  const r = Fr(e, t) ? t : e, o = Fr(t, e) ? t : e;
  return Ay({ start: r, end: o });
}, G3 = (e) => {
  const t = Kn(e, 1);
  return { month: It(t), year: $t(t) };
}, Ga = (e, t) => {
  const r = jn(e, { weekStartsOn: +t }), o = My(e, { weekStartsOn: +t });
  return [r, o];
}, Zy = (e, t) => {
  const r = {
    hours: Ya(Re()),
    minutes: $l(Re()),
    seconds: t ? Is(Re()) : 0
  };
  return Object.assign(r, e);
}, Sl = (e, t, r) => [cr(Re(e), { date: 1 }), cr(Re(), { month: t, year: r, date: 1 })], Ia = (e, t, r) => {
  let o = e ? Re(e) : Re();
  return (t || t === 0) && (o = By(o, t)), r && (o = Xn(o, r)), o;
}, zy = (e, t, r, o, n) => {
  if (!o || n && !t || !n && !r) return !1;
  const a = n ? Kn(e, 1) : Fs(e, 1), l = [It(a), $t(a)];
  return n ? !I3(...l, t) : !B3(...l, r);
}, B3 = (e, t, r) => Lr(...Sl(r, e, t)) || Rt(...Sl(r, e, t)), I3 = (e, t, r) => Fr(...Sl(r, e, t)) || Rt(...Sl(r, e, t)), qy = (e, t, r, o, n, a, l) => {
  if (typeof t == "function" && !l) return t(e);
  const i = r ? { locale: r } : void 0;
  return Array.isArray(e) ? `${Sa(e[0], a, i)}${n && !e[1] ? "" : o}${e[1] ? Sa(e[1], a, i) : ""}` : Sa(e, a, i);
}, Yi = (e) => {
  if (e) return null;
  throw new Error(O0.prop("partial-range"));
}, ju = (e, t) => {
  if (t) return e();
  throw new Error(O0.prop("range"));
}, jf = (e) => Array.isArray(e) ? Vd(e[0]) && (e[1] ? Vd(e[1]) : !0) : e ? Vd(e) : !1, R3 = (e, t) => cr(t ?? Re(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), Mg = (e, t, r, o) => {
  if (!e) return !0;
  if (o) {
    const n = r === "max" ? Rs(e, t) : gi(e, t), a = { seconds: 0, milliseconds: 0 };
    return n || ws(cr(e, a), cr(t, a));
  }
  return r === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, $g = (e, t, r) => e ? R3(e, t) : Re(r ?? t), O1 = (e, t, r, o, n) => {
  if (Array.isArray(o)) {
    const l = $g(e, o[0], t), i = $g(e, o[1], t);
    return Mg(o[0], l, r, !!t) && Mg(o[1], i, r, !!t) && n;
  }
  const a = $g(e, o, t);
  return Mg(o, a, r, !!t) && n;
}, Cg = (e) => cr(Re(), ii(e)), F3 = (e, t, r) => {
  if (e instanceof Map) {
    const o = `${Yy(r + 1)}-${t}`;
    return e.size ? e.has(o) : !1;
  }
  return typeof e == "function" ? e(uo(cr(Re(), { month: r, year: t }), !0)) : !1;
}, V3 = (e, t, r) => {
  if (e instanceof Map) {
    const o = `${Yy(r + 1)}-${t}`;
    return e.size ? e.has(o) : !0;
  }
  return !0;
}, Jy = (e, t, r) => typeof e == "function" ? e({ month: t, year: r }) : !!e.months.find((o) => o.month === t && o.year === r), k0 = (e, t) => typeof e == "function" ? e(t) : e.years.includes(t), Zf = (e) => `dp-${Sa(e, "yyyy-MM-dd")}`, N1 = (e, t) => {
  const r = Gy(uo(t), e), o = Tn(uo(t), e);
  return { before: r, after: o };
}, ew = (e, t) => t < +e[0] || t > +e[1], $d = dt({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), tw = () => {
  const e = (r) => {
    $d.menuFocused = r;
  }, t = (r) => {
    $d.shiftKeyInMenu !== r && ($d.shiftKeyInMenu = r);
  };
  return {
    control: ge(() => ({ shiftKeyInMenu: $d.shiftKeyInMenu, menuFocused: $d.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
}, yr = dt({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Lg = Ee(null), Zu = Ee(!1), Eg = Ee(!1), Og = Ee(!1), Ng = Ee(!1), _o = Ee(0), Br = Ee(0), Ol = () => {
  const e = ge(() => Zu.value ? [...yr.selectionGrid, yr.actionRow].filter((g) => g.length) : Eg.value ? [
    ...yr.timePicker[0],
    ...yr.timePicker[1],
    Ng.value ? [] : [Lg.value],
    yr.actionRow
  ].filter((g) => g.length) : Og.value ? [...yr.monthPicker, yr.actionRow] : [yr.monthYear, ...yr.calendar, yr.time, yr.actionRow].filter((g) => g.length)), t = (g) => {
    _o.value = g ? _o.value + 1 : _o.value - 1;
    let p = null;
    e.value[Br.value] && (p = e.value[Br.value][_o.value]), !p && e.value[Br.value + (g ? 1 : -1)] ? (Br.value = Br.value + (g ? 1 : -1), _o.value = g ? 0 : e.value[Br.value].length - 1) : p || (_o.value = g ? _o.value - 1 : _o.value + 1);
  }, r = (g) => {
    Br.value === 0 && !g || Br.value === e.value.length && g || (Br.value = g ? Br.value + 1 : Br.value - 1, e.value[Br.value] ? e.value[Br.value] && !e.value[Br.value][_o.value] && _o.value !== 0 && (_o.value = e.value[Br.value].length - 1) : Br.value = g ? Br.value - 1 : Br.value + 1);
  }, o = (g) => {
    let p = null;
    e.value[Br.value] && (p = e.value[Br.value][_o.value]), p ? p.focus({ preventScroll: !Zu.value }) : _o.value = g ? _o.value - 1 : _o.value + 1;
  }, n = () => {
    t(!0), o(!0);
  }, a = () => {
    t(!1), o(!1);
  }, l = () => {
    r(!1), o(!0);
  }, i = () => {
    r(!0), o(!0);
  }, s = (g, p) => {
    yr[p] = g;
  }, u = (g, p) => {
    yr[p] = g;
  }, c = () => {
    _o.value = 0, Br.value = 0;
  };
  return {
    buildMatrix: s,
    buildMultiLevelMatrix: u,
    setTimePickerBackRef: (g) => {
      Lg.value = g;
    },
    setSelectionGrid: (g) => {
      Zu.value = g, c(), g || (yr.selectionGrid = []);
    },
    setTimePicker: (g, p = !1) => {
      Eg.value = g, Ng.value = p, c(), g || (yr.timePicker[0] = [], yr.timePicker[1] = []);
    },
    setTimePickerElements: (g, p = 0) => {
      yr.timePicker[p] = g;
    },
    arrowRight: n,
    arrowLeft: a,
    arrowUp: l,
    arrowDown: i,
    clearArrowNav: () => {
      yr.monthYear = [], yr.calendar = [], yr.time = [], yr.actionRow = [], yr.selectionGrid = [], yr.timePicker[0] = [], yr.timePicker[1] = [], Zu.value = !1, Eg.value = !1, Ng.value = !1, Og.value = !1, c(), Lg.value = null;
    },
    setMonthPicker: (g) => {
      Og.value = g, c();
    },
    refSets: yr
    // exposed for testing
  };
}, D1 = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), H3 = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (t) => `Increment ${t}`,
  decrementValue: (t) => `Decrement ${t}`,
  openTpOverlay: (t) => `Open ${t} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (t) => `Month picker${t ? " overlay" : ""}`,
  yearPicker: (t) => `Year picker${t ? " overlay" : ""}`,
  timeOverlay: (t) => `${t} overlay`,
  ...e ?? {}
}), k1 = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, U3 = (e) => {
  const t = typeof e == "object" && e, r = {
    static: !0,
    solo: !1
  };
  if (!e) return { ...r, count: k1(!1) };
  const o = t ? e : {}, n = t ? o.count ?? !0 : e, a = k1(n);
  return Object.assign(r, o, { count: a });
}, X3 = (e, t, r) => e || (typeof r == "string" ? r : t), W3 = (e) => typeof e == "boolean" ? e ? D1({}) : !1 : D1(e), Y3 = (e) => {
  const t = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - ",
    escClose: !0
  };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : { ...t, enabled: e };
}, K3 = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), Q3 = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), j3 = (e) => {
  const t = { input: !1 };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...t
  };
}, Z3 = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, mobileBreakpoint: 600, setDateOnMenuClose: !1, ...e ?? {} }), z3 = (e) => {
  const t = {
    dates: Array.isArray(e) ? e.map((r) => Re(r)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof e == "function" ? e : { ...t, ...e ?? {} };
}, q3 = (e) => typeof e == "object" ? {
  type: e?.type ?? "local",
  hideOnOffsetDates: e?.hideOnOffsetDates ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, J3 = (e) => {
  const t = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof e == "object" ? { enabled: !0, ...t, ...e } : {
    enabled: e,
    ...t
  };
}, eN = (e) => e ? typeof e == "string" ? {
  timezone: e,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: e.timezone,
  exactMatch: e.exactMatch ?? !1,
  dateInTz: e.dateInTz ?? void 0,
  emitTimezone: e.emitTimezone ?? void 0,
  convertModel: e.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, Dg = (e, t, r, o) => new Map(
  e.map((n) => {
    const a = L0(n, t, o);
    return [D0(a, r), a];
  })
), tN = (e, t) => e.length ? new Map(
  e.map((r) => {
    const o = L0(r.date, t);
    return [D0(o, Cs.DATE), r];
  })
) : null, rN = (e) => {
  const t = Wy(e.isMonthPicker, e.isYearPicker);
  return {
    minDate: Kf(e.minDate, e.timezone, e.isSpecific),
    maxDate: Kf(e.maxDate, e.timezone, e.isSpecific),
    disabledDates: Ag(e.disabledDates) ? Dg(e.disabledDates, e.timezone, t, e.isSpecific) : e.disabledDates,
    allowedDates: Ag(e.allowedDates) ? Dg(e.allowedDates, e.timezone, t, e.isSpecific) : null,
    highlight: typeof e.highlight == "object" && Ag(e.highlight?.dates) ? Dg(e.highlight.dates, e.timezone, t) : e.highlight,
    markers: tN(e.markers, e.timezone)
  };
}, oN = (e) => typeof e == "boolean" ? { enabled: e, dragSelect: !0, limit: null } : {
  enabled: !!e,
  limit: e.limit ? +e.limit : null,
  dragSelect: e.dragSelect ?? !0
}, nN = (e) => ({
  ...Object.fromEntries(
    Object.keys(e).map((t) => {
      const r = t, o = e[r], n = typeof e[r] == "string" ? { [o]: !0 } : Object.fromEntries(o.map((a) => [a, !0]));
      return [t, n];
    })
  )
}), Pr = (e) => {
  const t = () => {
    const m = e.enableSeconds ? ":ss" : "", _ = e.enableMinutes ? ":mm" : "";
    return e.is24 ? `HH${_}${m}` : `hh${_}${m} aa`;
  }, r = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? `${S.value?.type === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy", o = (m) => Zy(m, e.enableSeconds), n = () => N.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [o(e.startTime[0]), o(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? o(e.startTime) : null, a = ge(() => U3(e.multiCalendars)), l = ge(() => n()), i = ge(() => H3(e.ariaLabels)), s = ge(() => K3(e.filters)), u = ge(() => W3(e.transitions)), c = ge(() => Q3(e.actionRow)), g = ge(
    () => X3(e.previewFormat, e.format, r())
  ), p = ge(() => Y3(e.textInput)), h = ge(() => j3(e.inline)), v = ge(() => Z3(e.config)), A = ge(() => z3(e.highlight)), S = ge(() => q3(e.weekNumbers)), b = ge(() => eN(e.timezone)), T = ge(() => oN(e.multiDates)), w = ge(
    () => rN({
      minDate: e.minDate,
      maxDate: e.maxDate,
      disabledDates: e.disabledDates,
      allowedDates: e.allowedDates,
      highlight: A.value,
      markers: e.markers,
      timezone: b.value,
      isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker,
      isMonthPicker: e.monthPicker,
      isYearPicker: e.yearPicker
    })
  ), N = ge(() => J3(e.range)), O = ge(() => nN(e.ui));
  return {
    defaultedTransitions: u,
    defaultedMultiCalendars: a,
    defaultedStartTime: l,
    defaultedAriaLabels: i,
    defaultedFilters: s,
    defaultedActionRow: c,
    defaultedPreviewFormat: g,
    defaultedTextInput: p,
    defaultedInline: h,
    defaultedConfig: v,
    defaultedHighlight: A,
    defaultedWeekNumbers: S,
    defaultedRange: N,
    propDates: w,
    defaultedTz: b,
    defaultedMultiDates: T,
    defaultedUI: O,
    getDefaultPattern: r,
    getDefaultStartTime: n,
    handleEventPropagation: (m) => {
      v.value.allowStopPropagation && m.stopPropagation(), v.value.allowPreventDefault && m.preventDefault();
    }
  };
}, aN = (e, t, { isInputFocused: r, isTextInputDate: o }) => {
  const n = Ee(), { defaultedTextInput: a, defaultedRange: l, defaultedTz: i, defaultedMultiDates: s, getDefaultPattern: u } = Pr(t), c = Ee(""), g = Ua(t, "format"), p = Ua(t, "formatLocale");
  nt(
    n,
    () => {
      typeof t.onInternalModelChange == "function" && e("internal-model-change", n.value, B(!0));
    },
    { deep: !0 }
  ), nt(l, (I, ee) => {
    I.enabled !== ee.enabled && (n.value = null);
  }), nt(g, () => {
    Q();
  });
  const h = (I) => i.value.timezone && i.value.convertModel ? zo(I, i.value.timezone) : I, v = (I) => {
    if (i.value.timezone && i.value.convertModel) {
      const ee = _3(i.value.timezone, I);
      return bE(I, ee);
    }
    return I;
  }, A = (I, ee, Se = !1) => qy(
    I,
    t.format,
    t.formatLocale,
    a.value.rangeSeparator,
    t.modelAuto,
    ee ?? u(),
    Se
  ), S = (I) => I ? t.modelType ? V(I) : {
    hours: Ya(I),
    minutes: $l(I),
    seconds: t.enableSeconds ? Is(I) : 0
  } : null, b = (I) => t.modelType ? V(I) : { month: It(I), year: $t(I) }, T = (I) => Array.isArray(I) ? s.value.enabled ? I.map((ee) => w(ee, Xn(Re(), ee))) : ju(
    () => [
      Xn(Re(), I[0]),
      I[1] ? Xn(Re(), I[1]) : Yi(l.value.partialRange)
    ],
    l.value.enabled
  ) : Xn(Re(), +I), w = (I, ee) => (typeof I == "string" || typeof I == "number") && t.modelType ? ue(I) : ee, N = (I) => Array.isArray(I) ? [
    w(
      I[0],
      Pl(null, +I[0].hours, +I[0].minutes, I[0].seconds)
    ),
    w(
      I[1],
      Pl(null, +I[1].hours, +I[1].minutes, I[1].seconds)
    )
  ] : w(I, Pl(null, I.hours, I.minutes, I.seconds)), O = (I) => {
    const ee = cr(Re(), { date: 1 });
    return Array.isArray(I) ? s.value.enabled ? I.map((Se) => w(Se, Ia(ee, +Se.month, +Se.year))) : ju(
      () => [
        w(I[0], Ia(ee, +I[0].month, +I[0].year)),
        w(
          I[1],
          I[1] ? Ia(ee, +I[1].month, +I[1].year) : Yi(l.value.partialRange)
        )
      ],
      l.value.enabled
    ) : w(I, Ia(ee, +I.month, +I.year));
  }, m = (I) => {
    if (Array.isArray(I))
      return I.map((ee) => ue(ee));
    throw new Error(O0.dateArr("multi-dates"));
  }, _ = (I) => {
    if (Array.isArray(I) && l.value.enabled) {
      const ee = I[0], Se = I[1];
      return [
        Re(Array.isArray(ee) ? ee[0] : null),
        Array.isArray(Se) && Se.length ? Re(Se[0]) : null
      ];
    }
    return Re(I[0]);
  }, X = (I) => t.modelAuto ? Array.isArray(I) ? [ue(I[0]), ue(I[1])] : t.autoApply ? [ue(I)] : [ue(I), null] : Array.isArray(I) ? ju(
    () => I[1] ? [
      ue(I[0]),
      I[1] ? ue(I[1]) : Yi(l.value.partialRange)
    ] : [ue(I[0])],
    l.value.enabled
  ) : ue(I), $ = () => {
    Array.isArray(n.value) && l.value.enabled && n.value.length === 1 && n.value.push(Yi(l.value.partialRange));
  }, E = () => {
    const I = n.value;
    return [
      V(I[0]),
      I[1] ? V(I[1]) : Yi(l.value.partialRange)
    ];
  }, D = () => Array.isArray(n.value) ? n.value[1] ? E() : V(co(n.value[0])) : [], U = () => (n.value || []).map((I) => V(I)), Y = (I = !1) => (I || $(), t.modelAuto ? D() : s.value.enabled ? U() : Array.isArray(n.value) ? ju(() => E(), l.value.enabled) : V(co(n.value))), G = (I) => !I || Array.isArray(I) && !I.length ? null : t.timePicker ? N(co(I)) : t.monthPicker ? O(co(I)) : t.yearPicker ? T(co(I)) : s.value.enabled ? m(co(I)) : t.weekPicker ? _(co(I)) : X(co(I)), K = (I) => {
    if (o.value) return;
    const ee = G(I);
    jf(co(ee)) ? (n.value = co(ee), Q()) : (n.value = null, c.value = "");
  }, W = () => {
    const I = (ee) => Sa(ee, a.value.format);
    return `${I(n.value[0])} ${a.value.rangeSeparator} ${n.value[1] ? I(n.value[1]) : ""}`;
  }, xe = () => r.value && n.value ? Array.isArray(n.value) ? W() : Sa(n.value, a.value.format) : A(n.value), Ce = () => n.value ? s.value.enabled ? n.value.map((I) => A(I)).join("; ") : a.value.enabled && typeof a.value.format == "string" ? xe() : A(n.value) : "", Q = () => {
    !t.format || typeof t.format == "string" || a.value.enabled && typeof a.value.format == "string" ? c.value = Ce() : c.value = t.format(n.value);
  }, ue = (I) => {
    if (t.utc) {
      const ee = new Date(I);
      return t.utc === "preserve" ? new Date(ee.getTime() + ee.getTimezoneOffset() * 6e4) : ee;
    }
    return t.modelType ? T3.includes(t.modelType) ? h(new Date(I)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? h(
      Yf(I, u(), /* @__PURE__ */ new Date(), { locale: p.value })
    ) : h(
      Yf(I, t.modelType, /* @__PURE__ */ new Date(), { locale: p.value })
    ) : h(new Date(I));
  }, V = (I) => I ? t.utc ? k3(I, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +v(I) : t.modelType === "iso" ? v(I).toISOString() : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? A(v(I)) : A(v(I), t.modelType, !0) : v(I) : "", ae = (I, ee = !1, Se = !1) => {
    if (Se) return I;
    if (e("update:model-value", I), i.value.emitTimezone && ee) {
      const pe = Array.isArray(I) ? I.map((Ke) => zo(co(Ke), i.value.emitTimezone)) : zo(co(I), i.value.emitTimezone);
      e("update:model-timezone-value", pe);
    }
  }, F = (I) => Array.isArray(n.value) ? s.value.enabled ? n.value.map((ee) => I(ee)) : [
    I(n.value[0]),
    n.value[1] ? I(n.value[1]) : Yi(l.value.partialRange)
  ] : I(co(n.value)), le = () => {
    if (Array.isArray(n.value)) {
      const I = Ga(n.value[0], t.weekStart), ee = n.value[1] ? Ga(n.value[1], t.weekStart) : [];
      return [I.map((Se) => Re(Se)), ee.map((Se) => Re(Se))];
    }
    return Ga(n.value, t.weekStart).map((I) => Re(I));
  }, te = (I, ee) => ae(co(F(I)), !1, ee), ie = (I) => {
    const ee = le();
    return I ? ee : e("update:model-value", le());
  }, B = (I = !1) => (I || Q(), t.monthPicker ? te(b, I) : t.timePicker ? te(S, I) : t.yearPicker ? te($t, I) : t.weekPicker ? ie(I) : ae(Y(I), !0, I));
  return {
    inputValue: c,
    internalModelValue: n,
    checkBeforeEmit: () => n.value ? l.value.enabled ? l.value.partialRange ? n.value.length >= 1 : n.value.length === 2 : !!n.value : !1,
    parseExternalModelValue: K,
    formatInputValue: Q,
    emitModelValue: B
  };
}, lN = (e, t) => {
  const { defaultedFilters: r, propDates: o } = Pr(e), { validateMonthYearInRange: n } = Nl(e), a = (c, g) => {
    let p = c;
    return r.value.months.includes(It(p)) ? (p = g ? Kn(c, 1) : Fs(c, 1), a(p, g)) : p;
  }, l = (c, g) => {
    let p = c;
    return r.value.years.includes($t(p)) ? (p = g ? S0(c, 1) : Fy(c, 1), l(p, g)) : p;
  }, i = (c, g = !1) => {
    const p = cr(Re(), { month: e.month, year: e.year });
    let h = c ? Kn(p, 1) : Fs(p, 1);
    e.disableYearSelect && (h = Xn(h, e.year));
    let v = It(h), A = $t(h);
    r.value.months.includes(v) && (h = a(h, c), v = It(h), A = $t(h)), r.value.years.includes(A) && (h = l(h, c), A = $t(h)), n(v, A, c, e.preventMinMaxNavigation) && s(v, A, g);
  }, s = (c, g, p) => {
    t("update-month-year", { month: c, year: g, fromNav: p });
  }, u = ge(() => (c) => zy(
    cr(Re(), { month: e.month, year: e.year }),
    o.value.maxDate,
    o.value.minDate,
    e.preventMinMaxNavigation,
    c
  ));
  return { handleMonthYearChange: i, isDisabled: u, updateMonthYear: s };
}, Sm = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: [Boolean, String], default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  alwaysClearable: { type: Boolean, default: !1 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, qn = {
  ...Sm,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 },
  isMobile: { type: Boolean, default: void 0 }
}, iN = ["title"], sN = ["disabled"], dN = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...qn
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: t }) {
    const r = t, o = e, {
      defaultedActionRow: n,
      defaultedPreviewFormat: a,
      defaultedMultiCalendars: l,
      defaultedTextInput: i,
      defaultedInline: s,
      defaultedRange: u,
      defaultedMultiDates: c
    } = Pr(o), { isTimeValid: g, isMonthValid: p } = Nl(o), { buildMatrix: h } = Ol(), v = Ee(null), A = Ee(null), S = Ee(!1), b = Ee({}), T = Ee(null), w = Ee(null);
    or(() => {
      o.arrowNavigation && h([eo(v), eo(A)], "actionRow"), N(), window.addEventListener("resize", N);
    }), tn(() => {
      window.removeEventListener("resize", N);
    });
    const N = () => {
      S.value = !1, setTimeout(() => {
        const G = T.value?.getBoundingClientRect(), K = w.value?.getBoundingClientRect();
        G && K && (b.value.maxWidth = `${K.width - G.width - 20}px`), S.value = !0;
      }, 0);
    }, O = ge(() => u.value.enabled && !u.value.partialRange && o.internalModelValue ? o.internalModelValue.length === 2 : !0), m = ge(
      () => !g.value(o.internalModelValue) || !p.value(o.internalModelValue) || !O.value
    ), _ = () => {
      const G = a.value;
      return o.timePicker || o.monthPicker, G(co(o.internalModelValue));
    }, X = () => {
      const G = o.internalModelValue;
      return l.value.count > 0 ? `${$(G[0])} - ${$(G[1])}` : [$(G[0]), $(G[1])];
    }, $ = (G) => qy(
      G,
      a.value,
      o.formatLocale,
      i.value.rangeSeparator,
      o.modelAuto,
      a.value
    ), E = ge(() => !o.internalModelValue || !o.menuMount ? "" : typeof a.value == "string" ? Array.isArray(o.internalModelValue) ? o.internalModelValue.length === 2 && o.internalModelValue[1] ? X() : c.value.enabled ? o.internalModelValue.map((G) => `${$(G)}`) : o.modelAuto ? `${$(o.internalModelValue[0])}` : `${$(o.internalModelValue[0])} -` : $(o.internalModelValue) : _()), D = () => c.value.enabled ? "; " : " - ", U = ge(
      () => Array.isArray(E.value) ? E.value.join(D()) : E.value
    ), Y = () => {
      g.value(o.internalModelValue) && p.value(o.internalModelValue) && O.value ? r("select-date") : r("invalid-select");
    };
    return (G, K) => (C(), k("div", {
      ref_key: "actionRowRef",
      ref: w,
      class: "dp__action_row"
    }, [
      G.$slots["action-row"] ? be(G.$slots, "action-row", Er(ht({ key: 0 }, {
        internalModelValue: G.internalModelValue,
        disabled: m.value,
        selectDate: () => G.$emit("select-date"),
        closePicker: () => G.$emit("close-picker")
      }))) : (C(), k(De, { key: 1 }, [
        R(n).showPreview ? (C(), k("div", {
          key: 0,
          class: "dp__selection_preview",
          title: U.value,
          style: io(b.value)
        }, [
          G.$slots["action-preview"] && S.value ? be(G.$slots, "action-preview", {
            key: 0,
            value: G.internalModelValue
          }) : q("", !0),
          !G.$slots["action-preview"] && S.value ? (C(), k(De, { key: 1 }, [
            Gt(_e(U.value), 1)
          ], 64)) : q("", !0)
        ], 12, iN)) : q("", !0),
        L("div", {
          ref_key: "actionBtnContainer",
          ref: T,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          G.$slots["action-buttons"] ? be(G.$slots, "action-buttons", {
            key: 0,
            value: G.internalModelValue
          }) : q("", !0),
          G.$slots["action-buttons"] ? q("", !0) : (C(), k(De, { key: 1 }, [
            !R(s).enabled && R(n).showCancel ? (C(), k("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: v,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: K[0] || (K[0] = (W) => G.$emit("close-picker")),
              onKeydown: K[1] || (K[1] = (W) => R(Ro)(W, () => G.$emit("close-picker")))
            }, _e(G.cancelText), 545)) : q("", !0),
            R(n).showNow ? (C(), k("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: K[2] || (K[2] = (W) => G.$emit("select-now")),
              onKeydown: K[3] || (K[3] = (W) => R(Ro)(W, () => G.$emit("select-now")))
            }, _e(G.nowButtonLabel), 33)) : q("", !0),
            R(n).showSelect ? (C(), k("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: A,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: m.value,
              "data-test-id": "select-button",
              onKeydown: K[4] || (K[4] = (W) => R(Ro)(W, () => Y())),
              onClick: Y
            }, _e(G.selectText), 41, sN)) : q("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), uN = ["role", "aria-label", "tabindex"], cN = { class: "dp__selection_grid_header" }, mN = ["aria-selected", "aria-disabled", "data-test-id", "onClick", "onKeydown", "onMouseover"], gN = ["aria-label"], hu = /* @__PURE__ */ wt({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: t, emit: r }) {
    const { setSelectionGrid: o, buildMultiLevelMatrix: n, setMonthPicker: a } = Ol(), l = r, i = e, { defaultedAriaLabels: s, defaultedTextInput: u, defaultedConfig: c, handleEventPropagation: g } = Pr(
      i
    ), { hideNavigationButtons: p } = wm(), h = Ee(!1), v = Ee(null), A = Ee(null), S = Ee([]), b = Ee(), T = Ee(null), w = Ee(0), N = Ee(null);
    tA(() => {
      v.value = null;
    }), or(() => {
      Kr().then(() => U()), i.noOverlayFocus || m(), O(!0);
    }), tn(() => O(!1));
    const O = (F) => {
      i.arrowNavigation && (i.headerRefs?.length ? a(F) : o(F));
    }, m = () => {
      const F = eo(A);
      F && (u.value.enabled || (v.value ? v.value?.focus({ preventScroll: !0 }) : F.focus({ preventScroll: !0 })), h.value = F.clientHeight < F.scrollHeight);
    }, _ = ge(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !i.useRelative,
        "dp--overlay-relative": i.useRelative
      })
    ), X = ge(
      () => i.useRelative ? { height: `${i.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), $ = ge(() => ({
      dp__overlay_col: !0
    })), E = ge(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: h.value,
        dp__button_bottom: i.isLast
      })
    ), D = ge(() => ({
      dp__overlay_container: !0,
      dp__container_flex: i.items?.length <= 6,
      dp__container_block: i.items?.length > 6
    }));
    nt(
      () => i.items,
      () => U(!1),
      { deep: !0 }
    );
    const U = (F = !0) => {
      Kr().then(() => {
        const le = eo(v), te = eo(A), ie = eo(T), B = eo(N), I = ie ? ie.getBoundingClientRect().height : 0;
        te && (te.getBoundingClientRect().height ? w.value = te.getBoundingClientRect().height - I : w.value = c.value.modeHeight - I), le && B && F && (B.scrollTop = le.offsetTop - B.offsetTop - (w.value / 2 - le.getBoundingClientRect().height) - I);
      });
    }, Y = (F) => {
      F.disabled || l("selected", F.value);
    }, G = () => {
      l("toggle"), l("reset-flow");
    }, K = (F) => {
      i.escClose && (G(), g(F));
    }, W = (F, le, te, ie) => {
      F && ((le.active || le.value === i.focusValue) && (v.value = F), i.arrowNavigation && (Array.isArray(S.value[te]) ? S.value[te][ie] = F : S.value[te] = [F], xe()));
    }, xe = () => {
      const F = i.headerRefs?.length ? [i.headerRefs].concat(S.value) : S.value.concat([i.skipButtonRef ? [] : [T.value]]);
      n(co(F), i.headerRefs?.length ? "monthPicker" : "selectionGrid");
    }, Ce = (F) => {
      i.arrowNavigation || Al(F, c.value, !0);
    }, Q = (F) => {
      b.value = F, l("hover-value", F);
    }, ue = () => {
      if (G(), !i.isLast) {
        const F = Qf(i.menuWrapRef ?? null, "action-row");
        F && Xy(F)?.focus();
      }
    }, V = (F) => {
      switch (F.key) {
        case wr.esc:
          return K(F);
        case wr.arrowLeft:
          return Ce(F);
        case wr.arrowRight:
          return Ce(F);
        case wr.arrowUp:
          return Ce(F);
        case wr.arrowDown:
          return Ce(F);
        default:
          return;
      }
    }, ae = (F) => {
      if (F.key === wr.enter) return G();
      if (F.key === wr.tab) return ue();
    };
    return t({ focusGrid: m }), (F, le) => (C(), k("div", {
      ref_key: "gridWrapRef",
      ref: A,
      class: $e(_.value),
      style: io(X.value),
      role: e.useRelative ? void 0 : "dialog",
      "aria-label": e.overlayLabel,
      tabindex: e.useRelative ? void 0 : "0",
      onKeydown: V,
      onClick: le[0] || (le[0] = Nt(() => {
      }, ["prevent"]))
    }, [
      L("div", {
        ref_key: "containerRef",
        ref: N,
        class: $e(D.value),
        style: io({ "--dp-overlay-height": `${w.value}px` }),
        role: "grid"
      }, [
        L("div", cN, [
          be(F.$slots, "header")
        ]),
        F.$slots.overlay ? be(F.$slots, "overlay", { key: 0 }) : (C(!0), k(De, { key: 1 }, rt(e.items, (te, ie) => (C(), k("div", {
          key: ie,
          class: $e(["dp__overlay_row", { dp__flex_row: e.items.length >= 3 }]),
          role: "row"
        }, [
          (C(!0), k(De, null, rt(te, (B, I) => (C(), k("div", {
            key: B.value,
            ref_for: !0,
            ref: (ee) => W(ee, B, ie, I),
            role: "gridcell",
            class: $e($.value),
            "aria-selected": B.active || void 0,
            "aria-disabled": B.disabled || void 0,
            tabindex: "0",
            "data-test-id": B.text,
            onClick: Nt((ee) => Y(B), ["prevent"]),
            onKeydown: (ee) => R(Ro)(ee, () => Y(B), !0),
            onMouseover: (ee) => Q(B.value)
          }, [
            L("div", {
              class: $e(B.className)
            }, [
              F.$slots.item ? be(F.$slots, "item", {
                key: 0,
                item: B
              }) : q("", !0),
              F.$slots.item ? q("", !0) : (C(), k(De, { key: 1 }, [
                Gt(_e(B.text), 1)
              ], 64))
            ], 2)
          ], 42, mN))), 128))
        ], 2))), 128))
      ], 6),
      F.$slots["button-icon"] ? Qt((C(), k("button", {
        key: 0,
        ref_key: "toggleButton",
        ref: T,
        type: "button",
        "aria-label": R(s)?.toggleOverlay,
        class: $e(E.value),
        tabindex: "0",
        onClick: G,
        onKeydown: ae
      }, [
        be(F.$slots, "button-icon")
      ], 42, gN)), [
        [An, !R(p)(e.hideNavigation, e.type)]
      ]) : q("", !0)
    ], 46, uN));
  }
}), fN = ["data-dp-mobile"], bm = /* @__PURE__ */ wt({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean },
    isMobile: { type: Boolean }
  },
  setup(e) {
    const t = e, r = ge(
      () => t.multiCalendars > 0 ? [...Array(t.multiCalendars).keys()] : [0]
    ), o = ge(() => ({
      dp__instance_calendar: t.multiCalendars > 0
    }));
    return (n, a) => (C(), k("div", {
      class: $e({
        dp__menu_inner: !e.stretch,
        "dp--menu--inner-stretched": e.stretch,
        dp__flex_display: e.multiCalendars > 0,
        "dp--flex-display-collapsed": e.collapse
      }),
      "data-dp-mobile": e.isMobile
    }, [
      (C(!0), k(De, null, rt(r.value, (l, i) => (C(), k("div", {
        key: l,
        class: $e(o.value)
      }, [
        be(n.$slots, "default", {
          instance: l,
          index: i
        })
      ], 2))), 128))
    ], 10, fN));
  }
}), pN = ["data-dp-element", "aria-label", "aria-disabled"], Hd = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const r = t, o = Ee(null);
    return or(() => r("set-ref", o)), (n, a) => (C(), k("button", {
      ref_key: "elRef",
      ref: o,
      type: "button",
      "data-dp-element": e.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled || void 0,
      onClick: a[0] || (a[0] = (l) => r("activate")),
      onKeydown: a[1] || (a[1] = (l) => R(Ro)(l, () => r("activate"), !0))
    }, [
      L("span", {
        class: $e(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        be(n.$slots, "default")
      ], 2)
    ], 40, pN));
  }
}), hN = ["aria-label", "data-test-id"], rw = /* @__PURE__ */ wt({
  __name: "YearModePicker",
  props: {
    ...qn,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: t }) {
    const r = t, o = e, { showRightIcon: n, showLeftIcon: a } = wm(), { defaultedConfig: l, defaultedMultiCalendars: i, defaultedAriaLabels: s, defaultedTransitions: u, defaultedUI: c } = Pr(o), { showTransition: g, transitionName: p } = xu(u), h = Ee(!1), v = ge(() => N0(o.year, o.locale)), A = (T = !1, w) => {
      h.value = !h.value, r("toggle-year-picker", { flow: T, show: w });
    }, S = (T) => {
      h.value = !1, r("year-select", T);
    }, b = (T = !1) => {
      r("handle-year", T);
    };
    return (T, w) => (C(), k(De, null, [
      L("div", {
        class: $e(["dp--year-mode-picker", { "dp--hidden-el": h.value }])
      }, [
        R(a)(R(i), e.instance) ? (C(), ft(Hd, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": R(s)?.prevYear,
          disabled: e.isDisabled(!1),
          class: $e(R(c)?.navBtnPrev),
          onActivate: w[0] || (w[0] = (N) => b(!1))
        }, {
          default: je(() => [
            T.$slots["arrow-left"] ? be(T.$slots, "arrow-left", { key: 0 }) : q("", !0),
            T.$slots["arrow-left"] ? q("", !0) : (C(), ft(R(A0), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : q("", !0),
        L("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": `${e.year}-${R(s)?.openYearsOverlay}`,
          "data-test-id": `year-mode-btn-${e.instance}`,
          onClick: w[1] || (w[1] = () => A(!1)),
          onKeydown: w[2] || (w[2] = Ao(() => A(!1), ["enter"]))
        }, [
          T.$slots.year ? be(T.$slots, "year", {
            key: 0,
            year: e.year,
            text: v.value,
            value: e.year
          }) : q("", !0),
          T.$slots.year ? q("", !0) : (C(), k(De, { key: 1 }, [
            Gt(_e(v.value), 1)
          ], 64))
        ], 40, hN),
        R(n)(R(i), e.instance) ? (C(), ft(Hd, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": R(s)?.nextYear,
          disabled: e.isDisabled(!0),
          class: $e(R(c)?.navBtnNext),
          onActivate: w[3] || (w[3] = (N) => b(!0))
        }, {
          default: je(() => [
            T.$slots["arrow-right"] ? be(T.$slots, "arrow-right", { key: 0 }) : q("", !0),
            T.$slots["arrow-right"] ? q("", !0) : (C(), ft(R(P0), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : q("", !0)
      ], 2),
      vt(un, {
        name: R(p)(e.showYearPicker),
        css: R(g)
      }, {
        default: je(() => [
          e.showYearPicker ? (C(), ft(hu, {
            key: 0,
            items: e.items,
            "text-input": T.textInput,
            "esc-close": T.escClose,
            config: T.config,
            "is-last": T.autoApply && !R(l).keepActionRow,
            "hide-navigation": T.hideNavigation,
            "aria-labels": T.ariaLabels,
            "overlay-label": R(s)?.yearPicker?.(!0),
            type: "year",
            onToggle: A,
            onSelected: w[4] || (w[4] = (N) => S(N))
          }, so({
            "button-icon": je(() => [
              T.$slots["calendar-icon"] ? be(T.$slots, "calendar-icon", { key: 0 }) : q("", !0),
              T.$slots["calendar-icon"] ? q("", !0) : (C(), ft(R(ld), { key: 1 }))
            ]),
            _: 2
          }, [
            T.$slots["year-overlay-value"] ? {
              name: "item",
              fn: je(({ item: N }) => [
                be(T.$slots, "year-overlay-value", {
                  text: N.text,
                  value: N.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : q("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 64));
  }
}), G0 = (e, t, r) => {
  if (t.value && Array.isArray(t.value))
    if (t.value.some((o) => Rt(e, o))) {
      const o = t.value.filter((n) => !Rt(n, e));
      t.value = o.length ? o : null;
    } else (r && +r > t.value.length || !r) && t.value.push(e);
  else
    t.value = [e];
}, B0 = (e, t, r) => {
  let o = e.value ? e.value.slice() : [];
  return o.length === 2 && o[1] !== null && (o = []), o.length ? (Lr(t, o[0]) ? o.unshift(t) : o[1] = t, r("range-end", t)) : (o = [t], r("range-start", t)), o;
}, ym = (e, t, r, o) => {
  e && (e[0] && e[1] && r && t("auto-apply"), e[0] && !e[1] && o && r && t("auto-apply"));
}, ow = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t) => zo(Re(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = zo(Re(e.value), e.timezone));
}, nw = (e, t, r, o) => Array.isArray(t.value) && (t.value.length === 2 || t.value.length === 1 && o.value.partialRange) ? o.value.fixedStart && (Fr(e, t.value[0]) || Rt(e, t.value[0])) ? [t.value[0], e] : o.value.fixedEnd && (Lr(e, t.value[1]) || Rt(e, t.value[1])) ? [e, t.value[1]] : (r("invalid-fixed-range", e), t.value) : [], aw = ({
  multiCalendars: e,
  range: t,
  highlight: r,
  propDates: o,
  calendars: n,
  modelValue: a,
  props: l,
  filters: i,
  year: s,
  month: u,
  emit: c
}) => {
  const g = ge(() => E0(l.yearRange, l.locale, l.reverseYears)), p = Ee([!1]), h = ge(() => (E, D) => {
    const U = cr(Wn(/* @__PURE__ */ new Date()), {
      month: u.value(E),
      year: s.value(E)
    }), Y = D ? Py(U) : $s(U);
    return zy(
      Y,
      o.value.maxDate,
      o.value.minDate,
      l.preventMinMaxNavigation,
      D
    );
  }), v = () => Array.isArray(a.value) && e.value.solo && a.value[1], A = () => {
    for (let E = 0; E < e.value.count; E++)
      if (E === 0)
        n.value[E] = n.value[0];
      else if (E === e.value.count - 1 && v())
        n.value[E] = {
          month: It(a.value[1]),
          year: $t(a.value[1])
        };
      else {
        const D = cr(Re(), n.value[E - 1]);
        n.value[E] = { month: It(D), year: $t(S0(D, 1)) };
      }
  }, S = (E) => {
    if (!E) return A();
    const D = cr(Re(), n.value[E]);
    return n.value[0].year = $t(Fy(D, e.value.count - 1)), A();
  }, b = (E, D) => {
    const U = AE(D, E);
    return t.value.showLastInRange && U > 1 ? D : E;
  }, T = (E) => l.focusStartDate || e.value.solo ? E[0] : E[1] ? b(E[0], E[1]) : E[0], w = () => {
    if (a.value) {
      const E = Array.isArray(a.value) ? T(a.value) : a.value;
      n.value[0] = { month: It(E), year: $t(E) };
    }
  }, N = () => {
    w(), e.value.count && A();
  };
  nt(a, (E, D) => {
    l.isTextInputDate && JSON.stringify(E ?? {}) !== JSON.stringify(D ?? {}) && N();
  }), or(() => {
    N();
  });
  const O = (E, D) => {
    n.value[D].year = E, c("update-month-year", { instance: D, year: E, month: n.value[D].month }), e.value.count && !e.value.solo && S(D);
  }, m = ge(() => (E) => Vs(g.value, (D) => {
    const U = s.value(E) === D.value, Y = Kd(
      D.value,
      Hs(o.value.minDate),
      Hs(o.value.maxDate)
    ) || i.value.years?.includes(s.value(E)), G = k0(r.value, D.value);
    return { active: U, disabled: Y, highlighted: G };
  })), _ = (E, D) => {
    O(E, D), $(D);
  }, X = (E, D = !1) => {
    if (!h.value(E, D)) {
      const U = D ? s.value(E) + 1 : s.value(E) - 1;
      O(U, E);
    }
  }, $ = (E, D = !1, U) => {
    D || c("reset-flow"), U !== void 0 ? p.value[E] = U : p.value[E] = !p.value[E], p.value[E] ? c("overlay-toggle", { open: !0, overlay: Po.year }) : (c("overlay-closed"), c("overlay-toggle", { open: !1, overlay: Po.year }));
  };
  return {
    isDisabled: h,
    groupedYears: m,
    showYearPicker: p,
    selectYear: O,
    toggleYearPicker: $,
    handleYearSelect: _,
    handleYear: X
  };
}, xN = (e, t) => {
  const {
    defaultedMultiCalendars: r,
    defaultedAriaLabels: o,
    defaultedTransitions: n,
    defaultedConfig: a,
    defaultedRange: l,
    defaultedHighlight: i,
    propDates: s,
    defaultedTz: u,
    defaultedFilters: c,
    defaultedMultiDates: g
  } = Pr(e), p = () => {
    e.isTextInputDate && N($t(Re(e.startDate)), 0);
  }, { modelValue: h, year: v, month: A, calendars: S } = vu(e, t, p), b = ge(() => Hy(e.formatLocale, e.locale, e.monthNameFormat)), T = Ee(null), { checkMinMaxRange: w } = Nl(e), {
    selectYear: N,
    groupedYears: O,
    showYearPicker: m,
    toggleYearPicker: _,
    handleYearSelect: X,
    handleYear: $,
    isDisabled: E
  } = aw({
    modelValue: h,
    multiCalendars: r,
    range: l,
    highlight: i,
    calendars: S,
    year: v,
    propDates: s,
    month: A,
    filters: c,
    props: e,
    emit: t
  });
  or(() => {
    e.startDate && (h.value && e.focusStartDate || !h.value) && N($t(Re(e.startDate)), 0);
  });
  const D = (le) => le ? { month: It(le), year: $t(le) } : { month: null, year: null }, U = () => h.value ? Array.isArray(h.value) ? h.value.map((le) => D(le)) : D(h.value) : D(), Y = (le, te) => {
    const ie = S.value[le], B = U();
    return Array.isArray(B) ? B.some((I) => I.year === ie?.year && I.month === te) : ie?.year === B.year && te === B.month;
  }, G = (le, te, ie) => {
    const B = U();
    return Array.isArray(B) ? v.value(te) === B[ie]?.year && le === B[ie]?.month : !1;
  }, K = (le, te) => {
    if (l.value.enabled) {
      const ie = U();
      if (Array.isArray(h.value) && Array.isArray(ie)) {
        const B = G(le, te, 0) || G(le, te, 1), I = Ia(Wn(Re()), le, v.value(te));
        return Qd(h.value, T.value, I) && !B;
      }
      return !1;
    }
    return !1;
  }, W = ge(() => (le) => Vs(b.value, (te) => {
    const ie = Y(le, te.value), B = Kd(
      te.value,
      Ky(v.value(le), s.value.minDate),
      Qy(v.value(le), s.value.maxDate)
    ) || F3(s.value.disabledDates, v.value(le), te.value) || c.value.months?.includes(te.value) || !V3(s.value.allowedDates, v.value(le), te.value) || ew(e.yearRange, v.value(le)), I = K(te.value, le), ee = Jy(i.value, te.value, v.value(le));
    return { active: ie, disabled: B, isBetween: I, highlighted: ee };
  })), xe = (le, te) => Ia(Wn(Re()), le, v.value(te)), Ce = (le, te) => {
    const ie = h.value ? h.value : Wn(/* @__PURE__ */ new Date());
    h.value = Ia(ie, le, v.value(te)), t("auto-apply"), t("update-flow-step");
  }, Q = (le, te) => {
    const ie = xe(le, te);
    l.value.fixedEnd || l.value.fixedStart ? h.value = nw(ie, h, t, l) : h.value ? w(ie, h.value) && (h.value = B0(h, xe(le, te), t)) : h.value = [xe(le, te)], Kr().then(() => {
      ym(h.value, t, e.autoApply, e.modelAuto);
    });
  }, ue = (le, te) => {
    G0(xe(le, te), h, g.value.limit), t("auto-apply", !0);
  }, V = (le, te) => (S.value[te].month = le, F(te, S.value[te].year, le), g.value.enabled ? ue(le, te) : l.value.enabled ? Q(le, te) : Ce(le, te)), ae = (le, te) => {
    N(le, te), F(te, le, null);
  }, F = (le, te, ie) => {
    let B = ie;
    if (!B && B !== 0) {
      const I = U();
      B = Array.isArray(I) ? I[le].month : I.month;
    }
    t("update-month-year", { instance: le, year: te, month: B });
  };
  return {
    groupedMonths: W,
    groupedYears: O,
    year: v,
    isDisabled: E,
    defaultedMultiCalendars: r,
    defaultedAriaLabels: o,
    defaultedTransitions: n,
    defaultedConfig: a,
    showYearPicker: m,
    modelValue: h,
    presetDate: (le, te) => {
      ow({
        value: le,
        modelValue: h,
        range: l.value.enabled,
        timezone: te ? void 0 : u.value.timezone
      }), t("auto-apply");
    },
    setHoverDate: (le, te) => {
      T.value = xe(le, te);
    },
    selectMonth: V,
    selectYear: ae,
    toggleYearPicker: _,
    handleYearSelect: X,
    handleYear: $,
    getModelMonthYear: U
  };
}, vN = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...qn
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = _i(), a = an(n, "yearMode"), l = e;
    or(() => {
      l.shadow || o("mount", null);
    });
    const {
      groupedMonths: i,
      groupedYears: s,
      year: u,
      isDisabled: c,
      defaultedMultiCalendars: g,
      defaultedConfig: p,
      showYearPicker: h,
      modelValue: v,
      presetDate: A,
      setHoverDate: S,
      selectMonth: b,
      selectYear: T,
      toggleYearPicker: w,
      handleYearSelect: N,
      handleYear: O,
      getModelMonthYear: m
    } = xN(l, o);
    return t({ getSidebarProps: () => ({
      modelValue: v,
      year: u,
      getModelMonthYear: m,
      selectMonth: b,
      selectYear: T,
      handleYear: O
    }), presetDate: A, toggleYearPicker: (_) => w(0, _) }), (_, X) => (C(), ft(bm, {
      "multi-calendars": R(g).count,
      collapse: _.collapse,
      stretch: "",
      "is-mobile": _.isMobile
    }, {
      default: je(({ instance: $ }) => [
        _.$slots["top-extra"] ? be(_.$slots, "top-extra", {
          key: 0,
          value: _.internalModelValue
        }) : q("", !0),
        _.$slots["month-year"] ? be(_.$slots, "month-year", Er(ht({ key: 1 }, {
          year: R(u),
          months: R(i)($),
          years: R(s)($),
          selectMonth: R(b),
          selectYear: R(T),
          instance: $
        }))) : (C(), ft(hu, {
          key: 2,
          items: R(i)($),
          "arrow-navigation": _.arrowNavigation,
          "is-last": _.autoApply && !R(p).keepActionRow,
          "esc-close": _.escClose,
          height: R(p).modeHeight,
          config: _.config,
          "no-overlay-focus": !!(_.noOverlayFocus || _.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (E) => R(b)(E, $),
          onHoverValue: (E) => R(S)(E, $)
        }, so({
          header: je(() => [
            vt(rw, ht(_.$props, {
              items: R(s)($),
              instance: $,
              "show-year-picker": R(h)[$],
              year: R(u)($),
              "is-disabled": (E) => R(c)($, E),
              onHandleYear: (E) => R(O)($, E),
              onYearSelect: (E) => R(N)(E, $),
              onToggleYearPicker: (E) => R(w)($, E?.flow, E?.show)
            }), so({ _: 2 }, [
              rt(R(a), (E, D) => ({
                name: E,
                fn: je((U) => [
                  be(_.$slots, E, Er(fo(U)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          _.$slots["month-overlay-value"] ? {
            name: "item",
            fn: je(({ item: E }) => [
              be(_.$slots, "month-overlay-value", {
                text: E.text,
                value: E.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), SN = (e, t) => {
  const r = () => {
    e.isTextInputDate && (c.value = $t(Re(e.startDate)));
  }, { modelValue: o } = vu(e, t, r), n = Ee(null), { defaultedHighlight: a, defaultedMultiDates: l, defaultedFilters: i, defaultedRange: s, propDates: u } = Pr(e), c = Ee();
  or(() => {
    e.startDate && (o.value && e.focusStartDate || !o.value) && (c.value = $t(Re(e.startDate)));
  });
  const g = (b) => Array.isArray(o.value) ? o.value.some((T) => $t(T) === b) : o.value ? $t(o.value) === b : !1, p = (b) => s.value.enabled && Array.isArray(o.value) ? Qd(o.value, n.value, S(b)) : !1, h = (b) => u.value.allowedDates instanceof Map ? u.value.allowedDates.size ? u.value.allowedDates.has(`${b}`) : !1 : !0, v = (b) => u.value.disabledDates instanceof Map ? u.value.disabledDates.size ? u.value.disabledDates.has(`${b}`) : !1 : typeof u.value.disabledDates == "function" ? u.value.disabledDates(Xn(uo($s(Re())), b)) : !0, A = ge(() => Vs(E0(e.yearRange, e.locale, e.reverseYears), (b) => {
    const T = g(b.value), w = Kd(
      b.value,
      Hs(u.value.minDate),
      Hs(u.value.maxDate)
    ) || i.value.years.includes(b.value) || !h(b.value) || v(b.value), N = p(b.value) && !T, O = k0(a.value, b.value);
    return { active: T, disabled: w, isBetween: N, highlighted: O };
  })), S = (b) => Xn(Wn($s(/* @__PURE__ */ new Date())), b);
  return {
    groupedYears: A,
    modelValue: o,
    focusYear: c,
    setHoverValue: (b) => {
      n.value = Xn(Wn(/* @__PURE__ */ new Date()), b);
    },
    selectYear: (b) => {
      if (t("update-month-year", { instance: 0, year: b }), l.value.enabled)
        return o.value ? Array.isArray(o.value) && ((o.value?.map((T) => $t(T))).includes(b) ? o.value = o.value.filter((T) => $t(T) !== b) : o.value.push(Xn(uo(Re()), b))) : o.value = [Xn(uo($s(Re())), b)], t("auto-apply", !0);
      s.value.enabled ? (o.value = B0(o, S(b), t), Kr().then(() => {
        ym(o.value, t, e.autoApply, e.modelAuto);
      })) : (o.value = S(b), t("auto-apply"));
    }
  };
}, bN = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...qn
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, { groupedYears: a, modelValue: l, focusYear: i, selectYear: s, setHoverValue: u } = SN(n, o), { defaultedConfig: c } = Pr(n);
    return t({ getSidebarProps: () => ({
      modelValue: l,
      selectYear: s
    }) }), (g, p) => (C(), k("div", null, [
      g.$slots["top-extra"] ? be(g.$slots, "top-extra", {
        key: 0,
        value: g.internalModelValue
      }) : q("", !0),
      g.$slots["month-year"] ? be(g.$slots, "month-year", Er(ht({ key: 1 }, {
        years: R(a),
        selectYear: R(s)
      }))) : (C(), ft(hu, {
        key: 2,
        items: R(a),
        "is-last": g.autoApply && !R(c).keepActionRow,
        height: R(c).modeHeight,
        config: g.config,
        "no-overlay-focus": !!(g.noOverlayFocus || g.textInput),
        "focus-value": R(i),
        type: "year",
        "use-relative": "",
        onSelected: R(s),
        onHoverValue: R(u)
      }, so({ _: 2 }, [
        g.$slots["year-overlay-value"] ? {
          name: "item",
          fn: je(({ item: h }) => [
            be(g.$slots, "year-overlay-value", {
              text: h.text,
              value: h.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), yN = {
  key: 0,
  class: "dp__time_input"
}, wN = ["data-compact", "data-collapsed"], _N = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], TN = ["aria-label", "disabled", "data-test-id", "onKeydown", "onClick"], AN = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], PN = { key: 0 }, MN = ["aria-label", "data-compact"], $N = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...qn
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, { setTimePickerElements: a, setTimePickerBackRef: l } = Ol(), {
      defaultedAriaLabels: i,
      defaultedTransitions: s,
      defaultedFilters: u,
      defaultedConfig: c,
      defaultedRange: g,
      defaultedMultiCalendars: p
    } = Pr(n), { transitionName: h, showTransition: v } = xu(s), A = dt({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), S = Ee("AM"), b = Ee(null), T = Ee([]), w = Ee(), N = Ee(!1);
    or(() => {
      o("mounted");
    });
    const O = (j) => cr(/* @__PURE__ */ new Date(), {
      hours: j.hours,
      minutes: j.minutes,
      seconds: n.enableSeconds ? j.seconds : 0,
      milliseconds: 0
    }), m = ge(
      () => (j) => Q(j, n[j]) || X(j, n[j])
    ), _ = ge(() => ({ hours: n.hours, minutes: n.minutes, seconds: n.seconds })), X = (j, Qe) => g.value.enabled && !g.value.disableTimeRangeValidation ? !n.validateTime(j, Qe) : !1, $ = (j, Qe) => {
      if (g.value.enabled && !g.value.disableTimeRangeValidation) {
        const Ae = Qe ? +n[`${j}Increment`] : -+n[`${j}Increment`], re = n[j] + Ae;
        return !n.validateTime(j, re);
      }
      return !1;
    }, E = ge(() => (j) => !le(+n[j] + +n[`${j}Increment`], j) || $(j, !0)), D = ge(() => (j) => !le(+n[j] - +n[`${j}Increment`], j) || $(j, !1)), U = (j, Qe) => by(cr(Re(), j), Qe), Y = (j, Qe) => b3(cr(Re(), j), Qe), G = ge(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !n.timePickerInline,
        dp__time_col_reg_block: !n.enableSeconds && n.is24 && !n.timePickerInline,
        dp__time_col_reg_inline: !n.enableSeconds && n.is24 && n.timePickerInline,
        dp__time_col_reg_with_button: !n.enableSeconds && !n.is24,
        dp__time_col_sec: n.enableSeconds && n.is24,
        dp__time_col_sec_with_button: n.enableSeconds && !n.is24
      })
    ), K = ge(
      () => n.timePickerInline && g.value.enabled && !p.value.count
    ), W = ge(() => {
      const j = [{ type: "hours" }];
      return n.enableMinutes && j.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), n.enableSeconds && j.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), j;
    }), xe = ge(() => W.value.filter((j) => !j.separator)), Ce = ge(() => (j) => {
      if (j === "hours") {
        const Qe = Se(+n.hours);
        return { text: Qe < 10 ? `0${Qe}` : `${Qe}`, value: Qe };
      }
      return { text: n[j] < 10 ? `0${n[j]}` : `${n[j]}`, value: n[j] };
    }), Q = (j, Qe) => {
      if (!n.disabledTimesConfig) return !1;
      const Ae = n.disabledTimesConfig(n.order, j === "hours" ? Qe : void 0);
      return Ae[j] ? !!Ae[j]?.includes(Qe) : !0;
    }, ue = (j, Qe) => Qe !== "hours" || S.value === "AM" ? j : j + 12, V = (j) => {
      const Qe = n.is24 ? 24 : 12, Ae = j === "hours" ? Qe : 60, re = +n[`${j}GridIncrement`], ne = j === "hours" && !n.is24 ? re : 0, Le = [];
      for (let He = ne; He < Ae; He += re)
        Le.push({ value: n.is24 ? He : ue(He, j), text: He < 10 ? `0${He}` : `${He}` });
      return j === "hours" && !n.is24 && Le.unshift({ value: S.value === "PM" ? 12 : 0, text: "12" }), Vs(Le, (He) => ({ active: !1, disabled: u.value.times[j].includes(He.value) || !le(He.value, j) || Q(j, He.value) || X(j, He.value) }));
    }, ae = (j) => j >= 0 ? j : 59, F = (j) => j >= 0 ? j : 23, le = (j, Qe) => {
      const Ae = n.minTime ? O(Pg(n.minTime)) : null, re = n.maxTime ? O(Pg(n.maxTime)) : null, ne = O(
        Pg(
          _.value,
          Qe,
          Qe === "minutes" || Qe === "seconds" ? ae(j) : F(j)
        )
      );
      return Ae && re ? (Rs(ne, re) || ws(ne, re)) && (gi(ne, Ae) || ws(ne, Ae)) : Ae ? gi(ne, Ae) || ws(ne, Ae) : re ? Rs(ne, re) || ws(ne, re) : !0;
    }, te = (j) => n[`no${j[0].toUpperCase() + j.slice(1)}Overlay`], ie = (j) => {
      te(j) || (A[j] = !A[j], A[j] ? (N.value = !0, o("overlay-opened", j)) : (N.value = !1, o("overlay-closed", j)));
    }, B = (j) => j === "hours" ? Ya : j === "minutes" ? $l : Is, I = () => {
      w.value && clearTimeout(w.value);
    }, ee = (j, Qe = !0, Ae) => {
      const re = Qe ? U : Y, ne = Qe ? +n[`${j}Increment`] : -+n[`${j}Increment`];
      le(+n[j] + ne, j) && o(
        `update:${j}`,
        B(j)(re({ [j]: +n[j] }, { [j]: +n[`${j}Increment`] }))
      ), !Ae?.keyboard && c.value.timeArrowHoldThreshold && (w.value = setTimeout(() => {
        ee(j, Qe);
      }, c.value.timeArrowHoldThreshold));
    }, Se = (j) => n.is24 ? j : (j >= 12 ? S.value = "PM" : S.value = "AM", M3(j)), pe = () => {
      S.value === "PM" ? (S.value = "AM", o("update:hours", n.hours - 12)) : (S.value = "PM", o("update:hours", n.hours + 12)), o("am-pm-change", S.value);
    }, Ke = (j) => {
      A[j] = !0;
    }, Oe = (j, Qe, Ae) => {
      if (j && n.arrowNavigation) {
        Array.isArray(T.value[Qe]) ? T.value[Qe][Ae] = j : T.value[Qe] = [j];
        const re = T.value.reduce(
          (ne, Le) => Le.map((He, ze) => [...ne[ze] || [], Le[ze]]),
          []
        );
        l(n.closeTimePickerBtn), b.value && (re[1] = re[1].concat(b.value)), a(re, n.order);
      }
    }, Be = (j, Qe) => (ie(j), o(`update:${j}`, Qe));
    return t({ openChildCmp: Ke }), (j, Qe) => j.disabled ? q("", !0) : (C(), k("div", yN, [
      (C(!0), k(De, null, rt(W.value, (Ae, re) => (C(), k("div", {
        key: re,
        class: $e(G.value),
        "data-compact": K.value && !j.enableSeconds,
        "data-collapsed": K.value && j.enableSeconds
      }, [
        Ae.separator ? (C(), k(De, { key: 0 }, [
          N.value ? q("", !0) : (C(), k(De, { key: 0 }, [
            Gt(":")
          ], 64))
        ], 64)) : (C(), k(De, { key: 1 }, [
          L("button", {
            ref_for: !0,
            ref: (ne) => Oe(ne, re, 0),
            type: "button",
            class: $e({
              dp__btn: !0,
              dp__inc_dec_button: !j.timePickerInline,
              dp__inc_dec_button_inline: j.timePickerInline,
              dp__tp_inline_btn_top: j.timePickerInline,
              dp__inc_dec_button_disabled: E.value(Ae.type),
              "dp--hidden-el": N.value
            }),
            "data-test-id": `${Ae.type}-time-inc-btn-${n.order}`,
            "aria-label": R(i)?.incrementValue(Ae.type),
            tabindex: "0",
            onKeydown: (ne) => R(Ro)(ne, () => ee(Ae.type, !0, { keyboard: !0 }), !0),
            onClick: (ne) => R(c).timeArrowHoldThreshold ? void 0 : ee(Ae.type, !0),
            onMousedown: (ne) => R(c).timeArrowHoldThreshold ? ee(Ae.type, !0) : void 0,
            onMouseup: I
          }, [
            n.timePickerInline ? (C(), k(De, { key: 1 }, [
              j.$slots["tp-inline-arrow-up"] ? be(j.$slots, "tp-inline-arrow-up", { key: 0 }) : (C(), k(De, { key: 1 }, [
                Qe[2] || (Qe[2] = L("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                Qe[3] || (Qe[3] = L("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ], 64))
            ], 64)) : (C(), k(De, { key: 0 }, [
              j.$slots["arrow-up"] ? be(j.$slots, "arrow-up", { key: 0 }) : q("", !0),
              j.$slots["arrow-up"] ? q("", !0) : (C(), ft(R($0), { key: 1 }))
            ], 64))
          ], 42, _N),
          L("button", {
            ref_for: !0,
            ref: (ne) => Oe(ne, re, 1),
            type: "button",
            "aria-label": `${Ce.value(Ae.type).text}-${R(i)?.openTpOverlay(Ae.type)}`,
            class: $e({
              dp__time_display: !0,
              dp__time_display_block: !j.timePickerInline,
              dp__time_display_inline: j.timePickerInline,
              "dp--time-invalid": m.value(Ae.type),
              "dp--time-overlay-btn": !m.value(Ae.type),
              "dp--hidden-el": N.value
            }),
            disabled: te(Ae.type),
            tabindex: "0",
            "data-test-id": `${Ae.type}-toggle-overlay-btn-${n.order}`,
            onKeydown: (ne) => R(Ro)(ne, () => ie(Ae.type), !0),
            onClick: (ne) => ie(Ae.type)
          }, [
            j.$slots[Ae.type] ? be(j.$slots, Ae.type, {
              key: 0,
              text: Ce.value(Ae.type).text,
              value: Ce.value(Ae.type).value
            }) : q("", !0),
            j.$slots[Ae.type] ? q("", !0) : (C(), k(De, { key: 1 }, [
              Gt(_e(Ce.value(Ae.type).text), 1)
            ], 64))
          ], 42, TN),
          L("button", {
            ref_for: !0,
            ref: (ne) => Oe(ne, re, 2),
            type: "button",
            class: $e({
              dp__btn: !0,
              dp__inc_dec_button: !j.timePickerInline,
              dp__inc_dec_button_inline: j.timePickerInline,
              dp__tp_inline_btn_bottom: j.timePickerInline,
              dp__inc_dec_button_disabled: D.value(Ae.type),
              "dp--hidden-el": N.value
            }),
            "data-test-id": `${Ae.type}-time-dec-btn-${n.order}`,
            "aria-label": R(i)?.decrementValue(Ae.type),
            tabindex: "0",
            onKeydown: (ne) => R(Ro)(ne, () => ee(Ae.type, !1, { keyboard: !0 }), !0),
            onClick: (ne) => R(c).timeArrowHoldThreshold ? void 0 : ee(Ae.type, !1),
            onMousedown: (ne) => R(c).timeArrowHoldThreshold ? ee(Ae.type, !1) : void 0,
            onMouseup: I
          }, [
            n.timePickerInline ? (C(), k(De, { key: 1 }, [
              j.$slots["tp-inline-arrow-down"] ? be(j.$slots, "tp-inline-arrow-down", { key: 0 }) : (C(), k(De, { key: 1 }, [
                Qe[4] || (Qe[4] = L("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                Qe[5] || (Qe[5] = L("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ], 64))
            ], 64)) : (C(), k(De, { key: 0 }, [
              j.$slots["arrow-down"] ? be(j.$slots, "arrow-down", { key: 0 }) : q("", !0),
              j.$slots["arrow-down"] ? q("", !0) : (C(), ft(R(C0), { key: 1 }))
            ], 64))
          ], 42, AN)
        ], 64))
      ], 10, wN))), 128)),
      j.is24 ? q("", !0) : (C(), k("div", PN, [
        j.$slots["am-pm-button"] ? be(j.$slots, "am-pm-button", {
          key: 0,
          toggle: pe,
          value: S.value
        }) : q("", !0),
        j.$slots["am-pm-button"] ? q("", !0) : (C(), k("button", {
          key: 1,
          ref_key: "amPmButton",
          ref: b,
          type: "button",
          class: "dp__pm_am_button",
          role: "button",
          "aria-label": R(i)?.amPmButton,
          tabindex: "0",
          "data-compact": K.value,
          onClick: pe,
          onKeydown: Qe[0] || (Qe[0] = (Ae) => R(Ro)(Ae, () => pe(), !0))
        }, _e(S.value), 41, MN))
      ])),
      (C(!0), k(De, null, rt(xe.value, (Ae, re) => (C(), ft(un, {
        key: re,
        name: R(h)(A[Ae.type]),
        css: R(v)
      }, {
        default: je(() => [
          A[Ae.type] ? (C(), ft(hu, {
            key: 0,
            items: V(Ae.type),
            "is-last": j.autoApply && !R(c).keepActionRow,
            "esc-close": j.escClose,
            type: Ae.type,
            "text-input": j.textInput,
            config: j.config,
            "arrow-navigation": j.arrowNavigation,
            "aria-labels": j.ariaLabels,
            "overlay-label": R(i).timeOverlay?.(Ae.type),
            onSelected: (ne) => Be(Ae.type, ne),
            onToggle: (ne) => ie(Ae.type),
            onResetFlow: Qe[1] || (Qe[1] = (ne) => j.$emit("reset-flow"))
          }, so({
            "button-icon": je(() => [
              j.$slots["clock-icon"] ? be(j.$slots, "clock-icon", { key: 0 }) : q("", !0),
              j.$slots["clock-icon"] ? q("", !0) : (C(), ft(nu(j.timePickerInline ? R(ld) : R(M0)), { key: 1 }))
            ]),
            _: 2
          }, [
            j.$slots[`${Ae.type}-overlay-value`] ? {
              name: "item",
              fn: je(({ item: ne }) => [
                be(j.$slots, `${Ae.type}-overlay-value`, {
                  text: ne.text,
                  value: ne.value
                })
              ]),
              key: "0"
            } : void 0,
            j.$slots[`${Ae.type}-overlay-header`] ? {
              name: "header",
              fn: je(() => [
                be(j.$slots, `${Ae.type}-overlay-header`, {
                  toggle: () => ie(Ae.type)
                })
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : q("", !0)
        ]),
        _: 2
      }, 1032, ["name", "css"]))), 128))
    ]));
  }
}), CN = ["data-dp-mobile"], LN = ["aria-label", "tabindex"], EN = ["role", "aria-label", "tabindex"], ON = ["aria-label"], lw = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...qn
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, { buildMatrix: a, setTimePicker: l } = Ol(), i = _i(), { defaultedTransitions: s, defaultedAriaLabels: u, defaultedTextInput: c, defaultedConfig: g, defaultedRange: p } = Pr(n), { transitionName: h, showTransition: v } = xu(s), { hideNavigationButtons: A } = wm(), S = Ee(null), b = Ee(null), T = Ee([]), w = Ee(null), N = Ee(!1);
    or(() => {
      o("mount"), !n.timePicker && n.arrowNavigation ? a([eo(S.value)], "time") : l(!0, n.timePicker);
    });
    const O = ge(() => p.value.enabled && n.modelAuto ? Uy(n.internalModelValue) : !0), m = Ee(!1), _ = (Q) => ({
      hours: Array.isArray(n.hours) ? n.hours[Q] : n.hours,
      minutes: Array.isArray(n.minutes) ? n.minutes[Q] : n.minutes,
      seconds: Array.isArray(n.seconds) ? n.seconds[Q] : n.seconds
    }), X = ge(() => {
      const Q = [];
      if (p.value.enabled)
        for (let ue = 0; ue < 2; ue++)
          Q.push(_(ue));
      else
        Q.push(_(0));
      return Q;
    }), $ = (Q, ue = !1, V = "") => {
      ue || o("reset-flow"), m.value = Q, o(Q ? "overlay-opened" : "overlay-closed", Po.time), n.arrowNavigation && l(Q), Kr(() => {
        V !== "" && T.value[0] && T.value[0].openChildCmp(V);
      });
    }, E = ge(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: n.autoApply && !g.value.keepActionRow
    })), D = an(i, "timePicker"), U = (Q, ue, V) => p.value.enabled ? ue === 0 ? [Q, X.value[1][V]] : [X.value[0][V], Q] : Q, Y = (Q) => {
      o("update:hours", Q);
    }, G = (Q) => {
      o("update:minutes", Q);
    }, K = (Q) => {
      o("update:seconds", Q);
    }, W = () => {
      if (w.value && !c.value.enabled && !n.noOverlayFocus) {
        const Q = Xy(w.value);
        Q && Q.focus({ preventScroll: !0 });
      }
    }, xe = (Q) => {
      N.value = !1, o("overlay-closed", Q);
    }, Ce = (Q) => {
      N.value = !0, o("overlay-opened", Q);
    };
    return t({ toggleTimePicker: $ }), (Q, ue) => (C(), k("div", {
      class: "dp--tp-wrap",
      "data-dp-mobile": Q.isMobile
    }, [
      !Q.timePicker && !Q.timePickerInline ? Qt((C(), k("button", {
        key: 0,
        ref_key: "openTimePickerBtn",
        ref: S,
        type: "button",
        class: $e({ ...E.value, "dp--hidden-el": m.value }),
        "aria-label": R(u)?.openTimePicker,
        tabindex: Q.noOverlayFocus ? void 0 : 0,
        "data-test-id": "open-time-picker-btn",
        onKeydown: ue[0] || (ue[0] = (V) => R(Ro)(V, () => $(!0))),
        onClick: ue[1] || (ue[1] = (V) => $(!0))
      }, [
        Q.$slots["clock-icon"] ? be(Q.$slots, "clock-icon", { key: 0 }) : q("", !0),
        Q.$slots["clock-icon"] ? q("", !0) : (C(), ft(R(M0), { key: 1 }))
      ], 42, LN)), [
        [An, !R(A)(Q.hideNavigation, "time")]
      ]) : q("", !0),
      vt(un, {
        name: R(h)(m.value),
        css: R(v) && !Q.timePickerInline
      }, {
        default: je(() => [
          m.value || Q.timePicker || Q.timePickerInline ? (C(), k("div", {
            key: 0,
            ref_key: "overlayRef",
            ref: w,
            role: Q.timePickerInline ? void 0 : "dialog",
            class: $e({
              dp__overlay: !Q.timePickerInline,
              "dp--overlay-absolute": !n.timePicker && !Q.timePickerInline,
              "dp--overlay-relative": n.timePicker
            }),
            style: io(Q.timePicker ? { height: `${R(g).modeHeight}px` } : void 0),
            "aria-label": R(u)?.timePicker,
            tabindex: Q.timePickerInline ? void 0 : 0
          }, [
            L("div", {
              class: $e(
                Q.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
              ),
              style: { display: "flex" }
            }, [
              Q.$slots["time-picker-overlay"] ? be(Q.$slots, "time-picker-overlay", {
                key: 0,
                hours: e.hours,
                minutes: e.minutes,
                seconds: e.seconds,
                setHours: Y,
                setMinutes: G,
                setSeconds: K
              }) : q("", !0),
              Q.$slots["time-picker-overlay"] ? q("", !0) : (C(), k("div", {
                key: 1,
                class: $e(Q.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
              }, [
                (C(!0), k(De, null, rt(X.value, (V, ae) => Qt((C(), ft($N, ht({ key: ae }, { ref_for: !0 }, {
                  ...Q.$props,
                  order: ae,
                  hours: V.hours,
                  minutes: V.minutes,
                  seconds: V.seconds,
                  closeTimePickerBtn: b.value,
                  disabledTimesConfig: e.disabledTimesConfig,
                  disabled: ae === 0 ? R(p).fixedStart : R(p).fixedEnd
                }, {
                  ref_for: !0,
                  ref_key: "timeInputRefs",
                  ref: T,
                  "validate-time": (F, le) => e.validateTime(F, U(le, ae, F)),
                  "onUpdate:hours": (F) => Y(U(F, ae, "hours")),
                  "onUpdate:minutes": (F) => G(U(F, ae, "minutes")),
                  "onUpdate:seconds": (F) => K(U(F, ae, "seconds")),
                  onMounted: W,
                  onOverlayClosed: xe,
                  onOverlayOpened: Ce,
                  onAmPmChange: ue[2] || (ue[2] = (F) => Q.$emit("am-pm-change", F))
                }), so({ _: 2 }, [
                  rt(R(D), (F, le) => ({
                    name: F,
                    fn: je((te) => [
                      be(Q.$slots, F, ht({ ref_for: !0 }, te))
                    ])
                  }))
                ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                  [An, ae === 0 ? !0 : O.value]
                ])), 128))
              ], 2)),
              !Q.timePicker && !Q.timePickerInline ? Qt((C(), k("button", {
                key: 2,
                ref_key: "closeTimePickerBtn",
                ref: b,
                type: "button",
                class: $e({ ...E.value, "dp--hidden-el": N.value }),
                "aria-label": R(u)?.closeTimePicker,
                tabindex: "0",
                onKeydown: ue[3] || (ue[3] = (V) => R(Ro)(V, () => $(!1))),
                onClick: ue[4] || (ue[4] = (V) => $(!1))
              }, [
                Q.$slots["calendar-icon"] ? be(Q.$slots, "calendar-icon", { key: 0 }) : q("", !0),
                Q.$slots["calendar-icon"] ? q("", !0) : (C(), ft(R(ld), { key: 1 }))
              ], 42, ON)), [
                [An, !R(A)(Q.hideNavigation, "time")]
              ]) : q("", !0)
            ], 2)
          ], 14, EN)) : q("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 8, CN));
  }
}), iw = (e, t, r, o) => {
  const { defaultedRange: n } = Pr(e), a = (w, N) => Array.isArray(t[w]) ? t[w][N] : t[w], l = (w) => e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[w] : t.seconds : 0, i = (w, N) => w ? N !== void 0 ? Pl(w, a("hours", N), a("minutes", N), l(N)) : Pl(w, t.hours, t.minutes, l()) : Ry(Re(), l(N)), s = (w, N) => {
    t[w] = N;
  }, u = ge(() => e.modelAuto && n.value.enabled ? Array.isArray(r.value) ? r.value.length > 1 : !1 : n.value.enabled), c = (w, N) => {
    const O = Object.fromEntries(
      Object.keys(t).map((m) => m === w ? [m, N] : [m, t[m]].slice())
    );
    if (u.value && !n.value.disableTimeRangeValidation) {
      const m = (X) => r.value ? Pl(
        r.value[X],
        O.hours[X],
        O.minutes[X],
        O.seconds[X]
      ) : null, _ = (X) => Iy(r.value[X], 0);
      return !(Rt(m(0), m(1)) && (gi(m(0), _(1)) || Rs(m(1), _(0))));
    }
    return !0;
  }, g = (w, N) => {
    c(w, N) && (s(w, N), o && o());
  }, p = (w) => {
    g("hours", w);
  }, h = (w) => {
    g("minutes", w);
  }, v = (w) => {
    g("seconds", w);
  }, A = (w, N, O, m) => {
    N && p(w), !N && !O && h(w), O && v(w), r.value && m(r.value);
  }, S = (w) => {
    if (w) {
      const N = Array.isArray(w), O = N ? [+w[0].hours, +w[1].hours] : +w.hours, m = N ? [+w[0].minutes, +w[1].minutes] : +w.minutes, _ = N ? [+w[0].seconds, +w[1].seconds] : +w.seconds;
      s("hours", O), s("minutes", m), e.enableSeconds && s("seconds", _);
    }
  }, b = (w, N) => {
    const O = {
      hours: Array.isArray(t.hours) ? t.hours[w] : t.hours,
      disabledArr: []
    };
    return (N || N === 0) && (O.hours = N), Array.isArray(e.disabledTimes) && (O.disabledArr = n.value.enabled && Array.isArray(e.disabledTimes[w]) ? e.disabledTimes[w] : e.disabledTimes), O;
  }, T = ge(() => (w, N) => {
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: O, hours: m } = b(w, N), _ = O.filter((X) => +X.hours === m);
      return _[0]?.minutes === "*" ? { hours: [m], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: _?.map((X) => +X.minutes) ?? [],
        seconds: _?.map((X) => X.seconds ? +X.seconds : void 0) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: s,
    updateHours: p,
    updateMinutes: h,
    updateSeconds: v,
    getSetDateTime: i,
    updateTimeValues: A,
    getSecondsValue: l,
    assignStartTime: S,
    validateTime: c,
    disabledTimesConfig: T
  };
}, NN = (e, t) => {
  const r = () => {
    e.isTextInputDate && N();
  }, { modelValue: o, time: n } = vu(e, t, r), { defaultedStartTime: a, defaultedRange: l, defaultedTz: i } = Pr(e), { updateTimeValues: s, getSetDateTime: u, setTime: c, assignStartTime: g, disabledTimesConfig: p, validateTime: h } = iw(e, n, o, v);
  function v() {
    t("update-flow-step");
  }
  const A = (m) => {
    const { hours: _, minutes: X, seconds: $ } = m;
    return { hours: +_, minutes: +X, seconds: $ ? +$ : 0 };
  }, S = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const _ = A(e.startTime[0]), X = A(e.startTime[1]);
        return [cr(Re(), _), cr(Re(), X)];
      }
      const m = A(e.startTime);
      return cr(Re(), m);
    }
    return l.value.enabled ? [null, null] : null;
  }, b = () => {
    if (l.value.enabled) {
      const [m, _] = S();
      o.value = [
        zo(u(m, 0), i.value.timezone),
        zo(u(_, 1), i.value.timezone)
      ];
    } else
      o.value = zo(u(S()), i.value.timezone);
  }, T = (m) => Array.isArray(m) ? [ii(Re(m[0])), ii(Re(m[1]))] : [ii(m ?? Re())], w = (m, _, X) => {
    c("hours", m), c("minutes", _), c("seconds", e.enableSeconds ? X : 0);
  }, N = () => {
    const [m, _] = T(o.value);
    return l.value.enabled ? w(
      [m.hours, _.hours],
      [m.minutes, _.minutes],
      [m.seconds, _.seconds]
    ) : w(m.hours, m.minutes, m.seconds);
  };
  or(() => {
    if (!e.shadow)
      return g(a.value), o.value ? N() : b();
  });
  const O = () => {
    Array.isArray(o.value) ? o.value = o.value.map((m, _) => m && u(m, _)) : o.value = u(o.value), t("time-update");
  };
  return {
    modelValue: o,
    time: n,
    disabledTimesConfig: p,
    updateTime: (m, _ = !0, X = !1) => {
      s(m, _, X, O);
    },
    validateTime: h
  };
}, DN = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...qn
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, a = _i(), l = an(a, "timePicker"), i = Ee(null), { time: s, modelValue: u, disabledTimesConfig: c, updateTime: g, validateTime: p } = NN(n, o);
    return or(() => {
      n.shadow || o("mount", null);
    }), t({ getSidebarProps: () => ({
      modelValue: u,
      time: s,
      updateTime: g
    }), toggleTimePicker: (h, v = !1, A = "") => {
      i.value?.toggleTimePicker(h, v, A);
    } }), (h, v) => (C(), ft(bm, {
      "multi-calendars": 0,
      stretch: "",
      "is-mobile": h.isMobile
    }, {
      default: je(() => [
        vt(lw, ht({
          ref_key: "tpRef",
          ref: i
        }, h.$props, {
          hours: R(s).hours,
          minutes: R(s).minutes,
          seconds: R(s).seconds,
          "internal-model-value": h.internalModelValue,
          "disabled-times-config": R(c),
          "validate-time": R(p),
          "onUpdate:hours": v[0] || (v[0] = (A) => R(g)(A)),
          "onUpdate:minutes": v[1] || (v[1] = (A) => R(g)(A, !1)),
          "onUpdate:seconds": v[2] || (v[2] = (A) => R(g)(A, !1, !0)),
          onAmPmChange: v[3] || (v[3] = (A) => h.$emit("am-pm-change", A)),
          onResetFlow: v[4] || (v[4] = (A) => h.$emit("reset-flow")),
          onOverlayClosed: v[5] || (v[5] = (A) => h.$emit("overlay-toggle", { open: !1, overlay: A })),
          onOverlayOpened: v[6] || (v[6] = (A) => h.$emit("overlay-toggle", { open: !0, overlay: A }))
        }), so({ _: 2 }, [
          rt(R(l), (A, S) => ({
            name: A,
            fn: je((b) => [
              be(h.$slots, A, Er(fo(b)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }, 8, ["is-mobile"]));
  }
}), kN = { class: "dp--header-wrap" }, GN = {
  key: 0,
  class: "dp__month_year_wrap"
}, BN = { key: 0 }, IN = { class: "dp__month_year_wrap" }, RN = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], FN = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...qn
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, {
      defaultedTransitions: a,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: i,
      defaultedFilters: s,
      defaultedConfig: u,
      defaultedHighlight: c,
      propDates: g,
      defaultedUI: p
    } = Pr(n), { transitionName: h, showTransition: v } = xu(a), { buildMatrix: A } = Ol(), { handleMonthYearChange: S, isDisabled: b, updateMonthYear: T } = lN(n, o), { showLeftIcon: w, showRightIcon: N } = wm(), O = Ee(!1), m = Ee(!1), _ = Ee(!1), X = Ee([null, null, null, null]);
    or(() => {
      o("mount");
    });
    const $ = (F) => ({
      get: () => n[F],
      set: (le) => {
        const te = F === Hn.month ? Hn.year : Hn.month;
        o("update-month-year", { [F]: le, [te]: n[te] }), F === Hn.month ? xe(!0) : Ce(!0);
      }
    }), E = ge($(Hn.month)), D = ge($(Hn.year)), U = ge(() => (F) => ({
      month: n.month,
      year: n.year,
      items: F === Hn.month ? n.months : n.years,
      instance: n.instance,
      updateMonthYear: T,
      toggle: F === Hn.month ? xe : Ce
    })), Y = ge(() => n.months.find((le) => le.value === n.month) || { text: "", value: 0 }), G = ge(() => Vs(n.months, (F) => {
      const le = n.month === F.value, te = Kd(
        F.value,
        Ky(n.year, g.value.minDate),
        Qy(n.year, g.value.maxDate)
      ) || s.value.months.includes(F.value), ie = Jy(c.value, F.value, n.year);
      return { active: le, disabled: te, highlighted: ie };
    })), K = ge(() => Vs(n.years, (F) => {
      const le = n.year === F.value, te = Kd(
        F.value,
        Hs(g.value.minDate),
        Hs(g.value.maxDate)
      ) || s.value.years.includes(F.value), ie = k0(c.value, F.value);
      return { active: le, disabled: te, highlighted: ie };
    })), W = (F, le, te) => {
      te !== void 0 ? F.value = te : F.value = !F.value, F.value ? (_.value = !0, o("overlay-opened", le)) : (_.value = !1, o("overlay-closed", le));
    }, xe = (F = !1, le) => {
      Q(F), W(O, Po.month, le);
    }, Ce = (F = !1, le) => {
      Q(F), W(m, Po.year, le);
    }, Q = (F) => {
      F || o("reset-flow");
    }, ue = (F, le) => {
      n.arrowNavigation && (X.value[le] = eo(F), A(X.value, "monthYear"));
    }, V = ge(() => [
      {
        type: Hn.month,
        index: 1,
        toggle: xe,
        modelValue: E.value,
        updateModelValue: (F) => E.value = F,
        text: Y.value.text,
        showSelectionGrid: O.value,
        items: G.value,
        ariaLabel: l.value?.openMonthsOverlay,
        overlayLabel: l.value.monthPicker?.(!0) ?? void 0
      },
      {
        type: Hn.year,
        index: 2,
        toggle: Ce,
        modelValue: D.value,
        updateModelValue: (F) => D.value = F,
        text: N0(n.year, n.locale),
        showSelectionGrid: m.value,
        items: K.value,
        ariaLabel: l.value?.openYearsOverlay,
        overlayLabel: l.value.yearPicker?.(!0) ?? void 0
      }
    ]), ae = ge(() => n.disableYearSelect ? [V.value[0]] : n.yearFirst ? [...V.value].reverse() : V.value);
    return t({
      toggleMonthPicker: xe,
      toggleYearPicker: Ce,
      handleMonthYearChange: S
    }), (F, le) => (C(), k("div", kN, [
      F.$slots["month-year"] ? (C(), k("div", GN, [
        be(F.$slots, "month-year", Er(fo({
          month: e.month,
          year: e.year,
          months: e.months,
          years: e.years,
          updateMonthYear: R(T),
          handleMonthYearChange: R(S),
          instance: e.instance,
          isDisabled: R(b)
        })))
      ])) : (C(), k(De, { key: 1 }, [
        F.$slots["top-extra"] ? (C(), k("div", BN, [
          be(F.$slots, "top-extra", { value: F.internalModelValue })
        ])) : q("", !0),
        L("div", IN, [
          R(w)(R(i), e.instance) && !F.vertical ? (C(), ft(Hd, {
            key: 0,
            "aria-label": R(l)?.prevMonth,
            disabled: R(b)(!1),
            class: $e(R(p)?.navBtnPrev),
            "el-name": "action-prev",
            onActivate: le[0] || (le[0] = (te) => R(S)(!1, !0)),
            onSetRef: le[1] || (le[1] = (te) => ue(te, 0))
          }, {
            default: je(() => [
              F.$slots["arrow-left"] ? be(F.$slots, "arrow-left", { key: 0 }) : q("", !0),
              F.$slots["arrow-left"] ? q("", !0) : (C(), ft(R(A0), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : q("", !0),
          L("div", {
            class: $e(["dp__month_year_wrap", {
              dp__year_disable_select: F.disableYearSelect
            }])
          }, [
            (C(!0), k(De, null, rt(ae.value, (te, ie) => (C(), k(De, {
              key: te.type
            }, [
              L("button", {
                ref_for: !0,
                ref: (B) => ue(B, ie + 1),
                type: "button",
                "data-dp-element": `overlay-${te.type}`,
                class: $e(["dp__btn dp__month_year_select", { "dp--hidden-el": _.value }]),
                "aria-label": `${te.text}-${te.ariaLabel}`,
                "data-test-id": `${te.type}-toggle-overlay-${e.instance}`,
                onClick: te.toggle,
                onKeydown: (B) => R(Ro)(B, () => te.toggle(), !0)
              }, [
                F.$slots[te.type] ? be(F.$slots, te.type, {
                  key: 0,
                  text: te.text,
                  value: n[te.type]
                }) : q("", !0),
                F.$slots[te.type] ? q("", !0) : (C(), k(De, { key: 1 }, [
                  Gt(_e(te.text), 1)
                ], 64))
              ], 42, RN),
              vt(un, {
                name: R(h)(te.showSelectionGrid),
                css: R(v)
              }, {
                default: je(() => [
                  te.showSelectionGrid ? (C(), ft(hu, {
                    key: 0,
                    items: te.items,
                    "arrow-navigation": F.arrowNavigation,
                    "hide-navigation": F.hideNavigation,
                    "is-last": F.autoApply && !R(u).keepActionRow,
                    "skip-button-ref": !1,
                    config: F.config,
                    type: te.type,
                    "header-refs": [],
                    "esc-close": F.escClose,
                    "menu-wrap-ref": F.menuWrapRef,
                    "text-input": F.textInput,
                    "aria-labels": F.ariaLabels,
                    "overlay-label": te.overlayLabel,
                    onSelected: te.updateModelValue,
                    onToggle: te.toggle
                  }, so({
                    "button-icon": je(() => [
                      F.$slots["calendar-icon"] ? be(F.$slots, "calendar-icon", { key: 0 }) : q("", !0),
                      F.$slots["calendar-icon"] ? q("", !0) : (C(), ft(R(ld), { key: 1 }))
                    ]),
                    _: 2
                  }, [
                    F.$slots[`${te.type}-overlay-value`] ? {
                      name: "item",
                      fn: je(({ item: B }) => [
                        be(F.$slots, `${te.type}-overlay-value`, {
                          text: B.text,
                          value: B.value
                        })
                      ]),
                      key: "0"
                    } : void 0,
                    F.$slots[`${te.type}-overlay`] ? {
                      name: "overlay",
                      fn: je(() => [
                        be(F.$slots, `${te.type}-overlay`, ht({ ref_for: !0 }, U.value(te.type)))
                      ]),
                      key: "1"
                    } : void 0,
                    F.$slots[`${te.type}-overlay-header`] ? {
                      name: "header",
                      fn: je(() => [
                        be(F.$slots, `${te.type}-overlay-header`, {
                          toggle: te.toggle
                        })
                      ]),
                      key: "2"
                    } : void 0
                  ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : q("", !0)
                ]),
                _: 2
              }, 1032, ["name", "css"])
            ], 64))), 128))
          ], 2),
          R(w)(R(i), e.instance) && F.vertical ? (C(), ft(Hd, {
            key: 1,
            "aria-label": R(l)?.prevMonth,
            "el-name": "action-prev",
            disabled: R(b)(!1),
            class: $e(R(p)?.navBtnPrev),
            onActivate: le[2] || (le[2] = (te) => R(S)(!1, !0))
          }, {
            default: je(() => [
              F.$slots["arrow-up"] ? be(F.$slots, "arrow-up", { key: 0 }) : q("", !0),
              F.$slots["arrow-up"] ? q("", !0) : (C(), ft(R($0), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : q("", !0),
          R(N)(R(i), e.instance) ? (C(), ft(Hd, {
            key: 2,
            ref: "rightIcon",
            "el-name": "action-next",
            disabled: R(b)(!0),
            "aria-label": R(l)?.nextMonth,
            class: $e(R(p)?.navBtnNext),
            onActivate: le[3] || (le[3] = (te) => R(S)(!0, !0)),
            onSetRef: le[4] || (le[4] = (te) => ue(te, F.disableYearSelect ? 2 : 3))
          }, {
            default: je(() => [
              F.$slots[F.vertical ? "arrow-down" : "arrow-right"] ? be(F.$slots, F.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : q("", !0),
              F.$slots[F.vertical ? "arrow-down" : "arrow-right"] ? q("", !0) : (C(), ft(nu(F.vertical ? R(C0) : R(P0)), { key: 1 }))
            ]),
            _: 3
          }, 8, ["disabled", "aria-label", "class"])) : q("", !0)
        ])
      ], 64))
    ]));
  }
}), VN = {
  class: "dp__calendar_header",
  role: "row"
}, HN = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, UN = ["aria-label"], XN = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, WN = { class: "dp__cell_inner" }, YN = ["id", "aria-selected", "aria-disabled", "aria-label", "tabindex", "data-test-id", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], KN = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...qn
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, { buildMultiLevelMatrix: a } = Ol(), {
      defaultedTransitions: l,
      defaultedConfig: i,
      defaultedAriaLabels: s,
      defaultedMultiCalendars: u,
      defaultedWeekNumbers: c,
      defaultedMultiDates: g,
      defaultedUI: p
    } = Pr(n), h = Ee(null), v = Ee({
      bottom: "",
      left: "",
      transform: ""
    }), A = Ee([]), S = Ee(null), b = Ee(!0), T = Ee(""), w = Ee({ startX: 0, endX: 0, startY: 0, endY: 0 }), N = Ee([]), O = Ee({ left: "50%" }), m = Ee(!1), _ = ge(() => n.calendar ? n.calendar(n.mappedDates) : n.mappedDates), X = ge(() => n.dayNames ? Array.isArray(n.dayNames) ? n.dayNames : n.dayNames(n.locale, +n.weekStart) : P3(n.formatLocale, n.locale, +n.weekStart));
    or(() => {
      o("mount", { cmp: "calendar", refs: A }), i.value.noSwipe || S.value && (S.value.addEventListener("touchstart", ue, { passive: !1 }), S.value.addEventListener("touchend", V, { passive: !1 }), S.value.addEventListener("touchmove", ae, { passive: !1 })), n.monthChangeOnScroll && S.value && S.value.addEventListener("wheel", te, { passive: !1 });
    }), tn(() => {
      i.value.noSwipe || S.value && (S.value.removeEventListener("touchstart", ue), S.value.removeEventListener("touchend", V), S.value.removeEventListener("touchmove", ae)), n.monthChangeOnScroll && S.value && S.value.removeEventListener("wheel", te);
    });
    const $ = (pe) => pe ? n.vertical ? "vNext" : "next" : n.vertical ? "vPrevious" : "previous", E = (pe, Ke) => {
      if (n.transitions) {
        const Oe = uo(Ia(Re(), n.month, n.year));
        T.value = Fr(uo(Ia(Re(), pe, Ke)), Oe) ? l.value[$(!0)] : l.value[$(!1)], b.value = !1, Kr(() => {
          b.value = !0;
        });
      }
    }, D = ge(
      () => ({
        ...p.value.calendar ?? {}
      })
    ), U = ge(() => (pe) => {
      const Ke = $3(pe);
      return {
        dp__marker_dot: Ke.type === "dot",
        dp__marker_line: Ke.type === "line"
      };
    }), Y = ge(() => (pe) => Rt(pe, h.value)), G = ge(() => ({
      dp__calendar: !0,
      dp__calendar_next: u.value.count > 0 && n.instance !== 0
    })), K = ge(() => (pe) => n.hideOffsetDates ? pe.current : !0), W = async (pe, Ke) => {
      const { width: Oe, height: Be } = pe.getBoundingClientRect();
      h.value = Ke.value;
      let j = { left: `${Oe / 2}px` }, Qe = -50;
      if (await Kr(), N.value[0]) {
        const { left: Ae, width: re } = N.value[0].getBoundingClientRect();
        Ae < 0 && (j = { left: "0" }, Qe = 0, O.value.left = `${Oe / 2}px`), window.innerWidth < Ae + re && (j = { right: "0" }, Qe = 0, O.value.left = `${re - Oe / 2}px`);
      }
      v.value = {
        bottom: `${Be}px`,
        ...j,
        transform: `translateX(${Qe}%)`
      };
    }, xe = async (pe, Ke, Oe) => {
      const Be = eo(A.value[Ke][Oe]);
      Be && (pe.marker?.customPosition && pe.marker?.tooltip?.length ? v.value = pe.marker.customPosition(Be) : await W(Be, pe), o("tooltip-open", pe.marker));
    }, Ce = async (pe, Ke, Oe) => {
      if (m.value && g.value.enabled && g.value.dragSelect)
        return o("select-date", pe);
      if (o("set-hover-date", pe), pe.marker?.tooltip?.length) {
        if (n.hideOffsetDates && !pe.current) return;
        await xe(pe, Ke, Oe);
      }
    }, Q = (pe) => {
      h.value && (h.value = null, v.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), o("tooltip-close", pe.marker));
    }, ue = (pe) => {
      w.value.startX = pe.changedTouches[0].screenX, w.value.startY = pe.changedTouches[0].screenY;
    }, V = (pe) => {
      w.value.endX = pe.changedTouches[0].screenX, w.value.endY = pe.changedTouches[0].screenY, F();
    }, ae = (pe) => {
      n.vertical && !n.inline && pe.preventDefault();
    }, F = () => {
      const pe = n.vertical ? "Y" : "X";
      Math.abs(w.value[`start${pe}`] - w.value[`end${pe}`]) > 10 && o("handle-swipe", w.value[`start${pe}`] > w.value[`end${pe}`] ? "right" : "left");
    }, le = (pe, Ke, Oe) => {
      pe && (Array.isArray(A.value[Ke]) ? A.value[Ke][Oe] = pe : A.value[Ke] = [pe]), n.arrowNavigation && a(A.value, "calendar");
    }, te = (pe) => {
      n.monthChangeOnScroll && (pe.preventDefault(), o("handle-scroll", pe));
    }, ie = (pe) => c.value.type === "local" ? w0(pe.value, { weekStartsOn: +n.weekStart }) : c.value.type === "iso" ? b0(pe.value) : typeof c.value.type == "function" ? c.value.type(pe.value) : "", B = (pe) => {
      const Ke = pe[0];
      return c.value.hideOnOffsetDates ? pe.some((Oe) => Oe.current) ? ie(Ke) : "" : ie(Ke);
    }, I = (pe, Ke, Oe = !0) => {
      !Oe && N3() || (!g.value.enabled || i.value.allowPreventDefault) && (Al(pe, i.value), o("select-date", Ke));
    }, ee = (pe) => {
      Al(pe, i.value);
    }, Se = (pe) => {
      g.value.enabled && g.value.dragSelect ? (m.value = !0, o("select-date", pe)) : g.value.enabled && o("select-date", pe);
    };
    return t({ triggerTransition: E }), (pe, Ke) => (C(), k("div", {
      class: $e(G.value)
    }, [
      L("div", {
        ref_key: "calendarWrapRef",
        ref: S,
        class: $e(D.value),
        role: "grid"
      }, [
        L("div", VN, [
          pe.weekNumbers ? (C(), k("div", HN, _e(pe.weekNumName), 1)) : q("", !0),
          (C(!0), k(De, null, rt(X.value, (Oe, Be) => (C(), k("div", {
            key: Be,
            class: "dp__calendar_header_item",
            role: "gridcell",
            "data-test-id": "calendar-header",
            "aria-label": R(s)?.weekDay?.(Be)
          }, [
            pe.$slots["calendar-header"] ? be(pe.$slots, "calendar-header", {
              key: 0,
              day: Oe,
              index: Be
            }) : q("", !0),
            pe.$slots["calendar-header"] ? q("", !0) : (C(), k(De, { key: 1 }, [
              Gt(_e(Oe), 1)
            ], 64))
          ], 8, UN))), 128))
        ]),
        Ke[2] || (Ke[2] = L("div", { class: "dp__calendar_header_separator" }, null, -1)),
        vt(un, {
          name: T.value,
          css: !!pe.transitions
        }, {
          default: je(() => [
            b.value ? (C(), k("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: Ke[1] || (Ke[1] = (Oe) => m.value = !1)
            }, [
              (C(!0), k(De, null, rt(_.value, (Oe, Be) => (C(), k("div", {
                key: Be,
                class: "dp__calendar_row",
                role: "row"
              }, [
                pe.weekNumbers ? (C(), k("div", XN, [
                  L("div", WN, _e(B(Oe.days)), 1)
                ])) : q("", !0),
                (C(!0), k(De, null, rt(Oe.days, (j, Qe) => (C(), k("div", {
                  id: R(Zf)(j.value),
                  ref_for: !0,
                  ref: (Ae) => le(Ae, Be, Qe),
                  key: Qe + Be,
                  role: "gridcell",
                  class: "dp__calendar_item",
                  "aria-selected": (j.classData.dp__active_date || j.classData.dp__range_start || j.classData.dp__range_end) ?? void 0,
                  "aria-disabled": j.classData.dp__cell_disabled || void 0,
                  "aria-label": R(s)?.day?.(j),
                  tabindex: !j.current && pe.hideOffsetDates ? void 0 : 0,
                  "data-test-id": R(Zf)(j.value),
                  onClick: Nt((Ae) => I(Ae, j), ["prevent"]),
                  onTouchend: (Ae) => I(Ae, j, !1),
                  onKeydown: (Ae) => R(Ro)(Ae, () => pe.$emit("select-date", j)),
                  onMouseenter: (Ae) => Ce(j, Be, Qe),
                  onMouseleave: (Ae) => Q(j),
                  onMousedown: (Ae) => Se(j),
                  onMouseup: Ke[0] || (Ke[0] = (Ae) => m.value = !1)
                }, [
                  L("div", {
                    class: $e(["dp__cell_inner", j.classData])
                  }, [
                    pe.$slots.day && K.value(j) ? be(pe.$slots, "day", {
                      key: 0,
                      day: +j.text,
                      date: j.value
                    }) : q("", !0),
                    pe.$slots.day ? q("", !0) : (C(), k(De, { key: 1 }, [
                      Gt(_e(j.text), 1)
                    ], 64)),
                    j.marker && K.value(j) ? (C(), k(De, { key: 2 }, [
                      pe.$slots.marker ? be(pe.$slots, "marker", {
                        key: 0,
                        marker: j.marker,
                        day: +j.text,
                        date: j.value
                      }) : (C(), k("div", {
                        key: 1,
                        class: $e(U.value(j.marker)),
                        style: io(j.marker.color ? { backgroundColor: j.marker.color } : {})
                      }, null, 6))
                    ], 64)) : q("", !0),
                    Y.value(j.value) ? (C(), k("div", {
                      key: 3,
                      ref_for: !0,
                      ref_key: "activeTooltip",
                      ref: N,
                      class: "dp__marker_tooltip",
                      style: io(v.value)
                    }, [
                      j.marker?.tooltip ? (C(), k("div", {
                        key: 0,
                        class: "dp__tooltip_content",
                        onClick: ee
                      }, [
                        (C(!0), k(De, null, rt(j.marker.tooltip, (Ae, re) => (C(), k("div", {
                          key: re,
                          class: "dp__tooltip_text"
                        }, [
                          pe.$slots["marker-tooltip"] ? be(pe.$slots, "marker-tooltip", {
                            key: 0,
                            tooltip: Ae,
                            day: j.value
                          }) : q("", !0),
                          pe.$slots["marker-tooltip"] ? q("", !0) : (C(), k(De, { key: 1 }, [
                            L("div", {
                              class: "dp__tooltip_mark",
                              style: io(Ae.color ? { backgroundColor: Ae.color } : {})
                            }, null, 4),
                            L("div", null, _e(Ae.text), 1)
                          ], 64))
                        ]))), 128)),
                        L("div", {
                          class: "dp__arrow_bottom_tp",
                          style: io(O.value)
                        }, null, 4)
                      ])) : q("", !0)
                    ], 4)) : q("", !0)
                  ], 2)
                ], 40, YN))), 128))
              ]))), 128))
            ], 32)) : q("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), G1 = (e) => Array.isArray(e), QN = (e, t, r, o) => {
  const n = Ee([]), a = Ee(/* @__PURE__ */ new Date()), l = Ee(), i = () => V(e.isTextInputDate), { modelValue: s, calendars: u, time: c, today: g } = vu(e, t, i), {
    defaultedMultiCalendars: p,
    defaultedStartTime: h,
    defaultedRange: v,
    defaultedConfig: A,
    defaultedTz: S,
    propDates: b,
    defaultedMultiDates: T
  } = Pr(e), { validateMonthYearInRange: w, isDisabled: N, isDateRangeAllowed: O, checkMinMaxRange: m } = Nl(e), { updateTimeValues: _, getSetDateTime: X, setTime: $, assignStartTime: E, validateTime: D, disabledTimesConfig: U } = iw(e, c, s, o), Y = ge(
    () => (ve) => u.value[ve] ? u.value[ve].month : 0
  ), G = ge(
    () => (ve) => u.value[ve] ? u.value[ve].year : 0
  ), K = (ve) => !A.value.keepViewOnOffsetClick || ve ? !0 : !l.value, W = (ve, Ue, tt, St = !1) => {
    K(St) && (u.value[ve] || (u.value[ve] = { month: 0, year: 0 }), u.value[ve].month = L1(Ue) ? u.value[ve]?.month : Ue, u.value[ve].year = L1(tt) ? u.value[ve]?.year : tt);
  }, xe = () => {
    e.autoApply && t("select-date");
  }, Ce = () => {
    h.value && E(h.value);
  };
  or(() => {
    e.shadow || (s.value || (Ke(), Ce()), V(!0), e.focusStartDate && e.startDate && Ke());
  });
  const Q = ge(() => e.flow?.length && !e.partialFlow ? e.flowStep === e.flow.length : !0), ue = () => {
    e.autoApply && Q.value && t("auto-apply", e.partialFlow ? e.flowStep !== e.flow.length : !1);
  }, V = (ve = !1) => {
    if (s.value)
      return Array.isArray(s.value) ? (n.value = s.value, I(ve)) : le(s.value, ve);
    if (p.value.count && ve && !e.startDate)
      return F(Re(), ve);
  }, ae = () => Array.isArray(s.value) && v.value.enabled ? It(s.value[0]) === It(s.value[1] ?? s.value[0]) : !1, F = (ve = /* @__PURE__ */ new Date(), Ue = !1) => {
    if ((!p.value.count || !p.value.static || Ue) && W(0, It(ve), $t(ve)), p.value.count && (!s.value || ae() || !p.value.solo) && (!p.value.solo || Ue))
      for (let tt = 1; tt < p.value.count; tt++) {
        const St = cr(Re(), { month: Y.value(tt - 1), year: G.value(tt - 1) }), Xe = by(St, { months: 1 });
        u.value[tt] = { month: It(Xe), year: $t(Xe) };
      }
  }, le = (ve, Ue) => {
    F(ve), $("hours", Ya(ve)), $("minutes", $l(ve)), $("seconds", Is(ve)), p.value.count && Ue && pe();
  }, te = (ve) => {
    if (p.value.count) {
      if (p.value.solo) return 0;
      const Ue = It(ve[0]), tt = It(ve[1]);
      return Math.abs(tt - Ue) < p.value.count ? 0 : 1;
    }
    return 1;
  }, ie = (ve, Ue) => {
    ve[1] && v.value.showLastInRange ? F(ve[te(ve)], Ue) : F(ve[0], Ue);
    const tt = (St, Xe) => [
      St(ve[0]),
      ve[1] ? St(ve[1]) : c[Xe][1]
    ];
    $("hours", tt(Ya, "hours")), $("minutes", tt($l, "minutes")), $("seconds", tt(Is, "seconds"));
  }, B = (ve, Ue) => {
    if ((v.value.enabled || e.weekPicker) && !T.value.enabled)
      return ie(ve, Ue);
    if (T.value.enabled && Ue) {
      const tt = ve[ve.length - 1];
      return le(tt, Ue);
    }
  }, I = (ve) => {
    const Ue = s.value;
    B(Ue, ve), p.value.count && p.value.solo && pe();
  }, ee = (ve, Ue) => {
    const tt = cr(Re(), { month: Y.value(Ue), year: G.value(Ue) }), St = ve < 0 ? Kn(tt, 1) : Fs(tt, 1);
    w(It(St), $t(St), ve < 0, e.preventMinMaxNavigation) && (W(Ue, It(St), $t(St)), t("update-month-year", { instance: Ue, month: It(St), year: $t(St) }), p.value.count && !p.value.solo && Se(Ue), r());
  }, Se = (ve) => {
    for (let Ue = ve - 1; Ue >= 0; Ue--) {
      const tt = Fs(cr(Re(), { month: Y.value(Ue + 1), year: G.value(Ue + 1) }), 1);
      W(Ue, It(tt), $t(tt));
    }
    for (let Ue = ve + 1; Ue <= p.value.count - 1; Ue++) {
      const tt = Kn(cr(Re(), { month: Y.value(Ue - 1), year: G.value(Ue - 1) }), 1);
      W(Ue, It(tt), $t(tt));
    }
  }, pe = () => {
    if (Array.isArray(s.value) && s.value.length === 2) {
      const ve = Re(
        Re(s.value[1] ? s.value[1] : Kn(s.value[0], 1))
      ), [Ue, tt] = [It(s.value[0]), $t(s.value[0])], [St, Xe] = [It(s.value[1]), $t(s.value[1])];
      (Ue !== St || Ue === St && tt !== Xe) && p.value.solo && W(1, It(ve), $t(ve));
    } else s.value && !Array.isArray(s.value) && (W(0, It(s.value), $t(s.value)), F(Re()));
  }, Ke = () => {
    e.startDate && (W(0, It(Re(e.startDate)), $t(Re(e.startDate))), p.value.count && Se(0));
  }, Oe = (ve, Ue) => {
    if (e.monthChangeOnScroll) {
      const tt = (/* @__PURE__ */ new Date()).getTime() - a.value.getTime(), St = Math.abs(ve.deltaY);
      let Xe = 500;
      St > 1 && (Xe = 100), St > 100 && (Xe = 0), tt > Xe && (a.value = /* @__PURE__ */ new Date(), ee(e.monthChangeOnScroll !== "inverse" ? -ve.deltaY : ve.deltaY, Ue));
    }
  }, Be = (ve, Ue, tt = !1) => {
    e.monthChangeOnArrows && e.vertical === tt && j(ve, Ue);
  }, j = (ve, Ue) => {
    ee(ve === "right" ? -1 : 1, Ue);
  }, Qe = (ve) => {
    if (b.value.markers)
      return Uc(ve.value, b.value.markers);
  }, Ae = (ve, Ue) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [ve == 0, !0];
      case "fair":
        return [ve == 0 || Ue > ve, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, re = (ve, Ue, tt, St) => {
    if (e.sixWeeks && ve.length < 6) {
      const Xe = 6 - ve.length, ut = (Ue.getDay() + 7 - St) % 7, mt = 6 - (tt.getDay() + 7 - St) % 7, [Dr, kr] = Ae(ut, mt);
      for (let Uo = 1; Uo <= Xe; Uo++)
        if (kr ? !!(Uo % 2) == Dr : Dr) {
          const no = ve[0].days[0], Ma = ne(Tn(no.value, -7), It(Ue));
          ve.unshift({ days: Ma });
        } else {
          const no = ve[ve.length - 1], Ma = no.days[no.days.length - 1], pd = ne(Tn(Ma.value, 1), It(Ue));
          ve.push({ days: pd });
        }
    }
    return ve;
  }, ne = (ve, Ue) => {
    const tt = Re(ve), St = [];
    for (let Xe = 0; Xe < 7; Xe++) {
      const ut = Tn(tt, Xe), mt = It(ut) !== Ue;
      St.push({
        text: e.hideOffsetDates && mt ? "" : ut.getDate(),
        value: ut,
        current: !mt,
        classData: {}
      });
    }
    return St;
  }, Le = (ve, Ue) => {
    const tt = [], St = new Date(Ue, ve), Xe = new Date(Ue, ve + 1, 0), ut = e.weekStart, mt = jn(St, { weekStartsOn: ut }), Dr = (kr) => {
      const Uo = ne(kr, ve);
      if (tt.push({ days: Uo }), !tt[tt.length - 1].days.some(
        (no) => Rt(uo(no.value), uo(Xe))
      )) {
        const no = Tn(kr, 7);
        Dr(no);
      }
    };
    return Dr(mt), re(tt, St, Xe, ut);
  }, He = (ve) => {
    const Ue = Pl(Re(ve.value), c.hours, c.minutes, At());
    t("date-update", Ue), T.value.enabled ? G0(Ue, s, T.value.limit) : s.value = Ue, o(), Kr().then(() => {
      ue();
    });
  }, ze = (ve) => v.value.noDisabledRange ? jy(n.value[0], ve).some((Ue) => N(Ue)) : !1, se = () => {
    n.value = s.value ? s.value.slice() : [], n.value.length === 2 && !(v.value.fixedStart || v.value.fixedEnd) && (n.value = []);
  }, Fe = (ve, Ue) => {
    const tt = [
      Re(ve.value),
      Tn(Re(ve.value), +v.value.autoRange)
    ];
    O(tt) ? (Ue && qe(ve.value), n.value = tt) : t("invalid-date", ve.value);
  }, qe = (ve) => {
    const Ue = It(Re(ve)), tt = $t(Re(ve));
    if (W(0, Ue, tt), p.value.count > 0)
      for (let St = 1; St < p.value.count; St++) {
        const Xe = G3(
          cr(Re(ve), { year: G.value(St - 1), month: Y.value(St - 1) })
        );
        W(St, Xe.month, Xe.year);
      }
  }, ye = (ve) => {
    if (ze(ve.value) || !m(ve.value, s.value, v.value.fixedStart ? 0 : 1))
      return t("invalid-date", ve.value);
    n.value = nw(Re(ve.value), s, t, v);
  }, Ne = (ve, Ue) => {
    if (se(), v.value.autoRange) return Fe(ve, Ue);
    if (v.value.fixedStart || v.value.fixedEnd) return ye(ve);
    n.value[0] ? m(Re(ve.value), s.value) && !ze(ve.value) ? Lr(Re(ve.value), Re(n.value[0])) ? (n.value.unshift(Re(ve.value)), t("range-end", n.value[0])) : (n.value[1] = Re(ve.value), t("range-end", n.value[1])) : (e.autoApply && t("auto-apply-invalid", ve.value), t("invalid-date", ve.value)) : (n.value[0] = Re(ve.value), t("range-start", n.value[0]));
  }, At = (ve = !0) => e.enableSeconds ? Array.isArray(c.seconds) ? ve ? c.seconds[0] : c.seconds[1] : c.seconds : 0, Ge = (ve) => {
    n.value[ve] = Pl(
      n.value[ve],
      c.hours[ve],
      c.minutes[ve],
      At(ve !== 1)
    );
  }, Ie = () => {
    n.value[0] && n.value[1] && +n.value?.[0] > +n.value?.[1] && (n.value.reverse(), t("range-start", n.value[0]), t("range-end", n.value[1]));
  }, Ze = () => {
    n.value.length && (n.value[0] && !n.value[1] ? Ge(0) : (Ge(0), Ge(1), o()), Ie(), s.value = n.value.slice(), ym(n.value, t, e.autoApply, e.modelAuto));
  }, et = (ve, Ue = !1) => {
    if (N(ve.value) || !ve.current && e.hideOffsetDates) return t("invalid-date", ve.value);
    if (l.value = JSON.parse(JSON.stringify(ve)), !v.value.enabled) return He(ve);
    G1(c.hours) && G1(c.minutes) && !T.value.enabled && (Ne(ve, Ue), Ze());
  }, Lt = (ve, Ue) => {
    W(ve, Ue.month, Ue.year, !0), p.value.count && !p.value.solo && Se(ve), t("update-month-year", { instance: ve, month: Ue.month, year: Ue.year }), r(p.value.solo ? ve : void 0);
    const tt = e.flow?.length ? e.flow[e.flowStep] : void 0;
    !Ue.fromNav && (tt === Po.month || tt === Po.year) && o();
  }, Ut = (ve, Ue) => {
    ow({
      value: ve,
      modelValue: s,
      range: v.value.enabled,
      timezone: Ue ? void 0 : S.value.timezone
    }), xe(), e.multiCalendars && Kr().then(() => V(!0));
  }, fr = () => {
    const ve = L0(Re(), S.value);
    !v.value.enabled && !T.value.enabled ? s.value = ve : s.value && Array.isArray(s.value) && s.value[0] ? T.value.enabled ? s.value = [...s.value, ve] : s.value = Lr(ve, s.value[0]) ? [ve, s.value[0]] : [s.value[0], ve] : s.value = [ve], xe();
  }, xn = () => {
    if (Array.isArray(s.value))
      if (T.value.enabled) {
        const ve = Pa();
        s.value[s.value.length - 1] = X(ve);
      } else
        s.value = s.value.map((ve, Ue) => ve && X(ve, Ue));
    else
      s.value = X(s.value);
    t("time-update");
  }, Pa = () => Array.isArray(s.value) && s.value.length ? s.value[s.value.length - 1] : null;
  return {
    calendars: u,
    modelValue: s,
    month: Y,
    year: G,
    time: c,
    disabledTimesConfig: U,
    today: g,
    validateTime: D,
    getCalendarDays: Le,
    getMarker: Qe,
    handleScroll: Oe,
    handleSwipe: j,
    handleArrow: Be,
    selectDate: et,
    updateMonthYear: Lt,
    presetDate: Ut,
    selectCurrentDate: fr,
    updateTime: (ve, Ue = !0, tt = !1) => {
      _(ve, Ue, tt, xn);
    },
    assignMonthAndYear: F,
    setStartTime: Ce
  };
}, jN = { key: 0 }, ZN = /* @__PURE__ */ wt({
  __name: "DatePicker",
  props: {
    ...qn
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, {
      calendars: a,
      month: l,
      year: i,
      modelValue: s,
      time: u,
      disabledTimesConfig: c,
      today: g,
      validateTime: p,
      getCalendarDays: h,
      getMarker: v,
      handleArrow: A,
      handleScroll: S,
      handleSwipe: b,
      selectDate: T,
      updateMonthYear: w,
      presetDate: N,
      selectCurrentDate: O,
      updateTime: m,
      assignMonthAndYear: _,
      setStartTime: X
    } = QN(n, o, ae, F), $ = _i(), { setHoverDate: E, getDayClassData: D, clearHoverDate: U } = gD(s, n), { defaultedMultiCalendars: Y } = Pr(n), G = Ee([]), K = Ee([]), W = Ee(null), xe = an($, "calendar"), Ce = an($, "monthYear"), Q = an($, "timePicker"), ue = (Oe) => {
      n.shadow || o("mount", Oe);
    };
    nt(
      a,
      () => {
        n.shadow || setTimeout(() => {
          o("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), nt(
      Y,
      (Oe, Be) => {
        Oe.count - Be.count > 0 && _();
      },
      { deep: !0 }
    );
    const V = ge(() => (Oe) => h(l.value(Oe), i.value(Oe)).map((Be) => ({
      ...Be,
      days: Be.days.map((j) => (j.marker = v(j), j.classData = D(j), j))
    })));
    function ae(Oe) {
      Oe || Oe === 0 ? K.value[Oe]?.triggerTransition(l.value(Oe), i.value(Oe)) : K.value.forEach((Be, j) => Be.triggerTransition(l.value(j), i.value(j)));
    }
    function F() {
      o("update-flow-step");
    }
    const le = (Oe, Be = !1) => {
      T(Oe, Be), n.spaceConfirm && o("select-date");
    }, te = (Oe, Be, j = 0) => {
      G.value[j]?.toggleMonthPicker(Oe, Be);
    }, ie = (Oe, Be, j = 0) => {
      G.value[j]?.toggleYearPicker(Oe, Be);
    }, B = (Oe, Be, j) => {
      W.value?.toggleTimePicker(Oe, Be, j);
    }, I = (Oe, Be) => {
      if (!n.range) {
        const j = s.value ? s.value : g, Qe = Be ? new Date(Be) : j, Ae = Oe ? jn(Qe, { weekStartsOn: 1 }) : My(Qe, { weekStartsOn: 1 });
        T({
          value: Ae,
          current: It(Qe) === l.value(0),
          text: "",
          classData: {}
        }), document.getElementById(Zf(Ae))?.focus();
      }
    }, ee = (Oe) => {
      G.value[0]?.handleMonthYearChange(Oe, !0);
    }, Se = (Oe) => {
      w(0, { month: l.value(0), year: i.value(0) + (Oe ? 1 : -1), fromNav: !0 });
    }, pe = (Oe, Be) => {
      Oe === Po.time && o(`time-picker-${Be ? "open" : "close"}`), o("overlay-toggle", { open: Be, overlay: Oe });
    }, Ke = (Oe) => {
      o("overlay-toggle", { open: !1, overlay: Oe }), o("focus-menu");
    };
    return t({
      clearHoverDate: U,
      presetDate: N,
      selectCurrentDate: O,
      toggleMonthPicker: te,
      toggleYearPicker: ie,
      toggleTimePicker: B,
      handleArrow: A,
      updateMonthYear: w,
      getSidebarProps: () => ({
        modelValue: s,
        month: l,
        year: i,
        time: u,
        updateTime: m,
        updateMonthYear: w,
        selectDate: T,
        presetDate: N
      }),
      changeMonth: ee,
      changeYear: Se,
      selectWeekDate: I,
      setStartTime: X
    }), (Oe, Be) => (C(), k(De, null, [
      vt(bm, {
        "multi-calendars": R(Y).count,
        collapse: Oe.collapse,
        "is-mobile": Oe.isMobile
      }, {
        default: je(({ instance: j, index: Qe }) => [
          Oe.disableMonthYearSelect ? q("", !0) : (C(), ft(FN, ht({
            key: 0,
            ref: (Ae) => {
              Ae && (G.value[Qe] = Ae);
            },
            months: R(Hy)(Oe.formatLocale, Oe.locale, Oe.monthNameFormat),
            years: R(E0)(Oe.yearRange, Oe.locale, Oe.reverseYears),
            month: R(l)(j),
            year: R(i)(j),
            instance: j
          }, Oe.$props, {
            onMount: Be[0] || (Be[0] = (Ae) => ue(R(li).header)),
            onResetFlow: Be[1] || (Be[1] = (Ae) => Oe.$emit("reset-flow")),
            onUpdateMonthYear: (Ae) => R(w)(j, Ae),
            onOverlayClosed: Ke,
            onOverlayOpened: Be[2] || (Be[2] = (Ae) => Oe.$emit("overlay-toggle", { open: !0, overlay: Ae }))
          }), so({ _: 2 }, [
            rt(R(Ce), (Ae, re) => ({
              name: Ae,
              fn: je((ne) => [
                be(Oe.$slots, Ae, Er(fo(ne)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          vt(KN, ht({
            ref: (Ae) => {
              Ae && (K.value[Qe] = Ae);
            },
            "mapped-dates": V.value(j),
            month: R(l)(j),
            year: R(i)(j),
            instance: j
          }, Oe.$props, {
            onSelectDate: (Ae) => R(T)(Ae, j !== 1),
            onHandleSpace: (Ae) => le(Ae, j !== 1),
            onSetHoverDate: Be[3] || (Be[3] = (Ae) => R(E)(Ae)),
            onHandleScroll: (Ae) => R(S)(Ae, j),
            onHandleSwipe: (Ae) => R(b)(Ae, j),
            onMount: Be[4] || (Be[4] = (Ae) => ue(R(li).calendar)),
            onResetFlow: Be[5] || (Be[5] = (Ae) => Oe.$emit("reset-flow")),
            onTooltipOpen: Be[6] || (Be[6] = (Ae) => Oe.$emit("tooltip-open", Ae)),
            onTooltipClose: Be[7] || (Be[7] = (Ae) => Oe.$emit("tooltip-close", Ae))
          }), so({ _: 2 }, [
            rt(R(xe), (Ae, re) => ({
              name: Ae,
              fn: je((ne) => [
                be(Oe.$slots, Ae, Er(fo({ ...ne })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse", "is-mobile"]),
      Oe.enableTimePicker ? (C(), k("div", jN, [
        Oe.$slots["time-picker"] ? be(Oe.$slots, "time-picker", Er(ht({ key: 0 }, { time: R(u), updateTime: R(m) }))) : (C(), ft(lw, ht({
          key: 1,
          ref_key: "timePickerRef",
          ref: W
        }, Oe.$props, {
          hours: R(u).hours,
          minutes: R(u).minutes,
          seconds: R(u).seconds,
          "internal-model-value": Oe.internalModelValue,
          "disabled-times-config": R(c),
          "validate-time": R(p),
          onMount: Be[8] || (Be[8] = (j) => ue(R(li).timePicker)),
          "onUpdate:hours": Be[9] || (Be[9] = (j) => R(m)(j)),
          "onUpdate:minutes": Be[10] || (Be[10] = (j) => R(m)(j, !1)),
          "onUpdate:seconds": Be[11] || (Be[11] = (j) => R(m)(j, !1, !0)),
          onResetFlow: Be[12] || (Be[12] = (j) => Oe.$emit("reset-flow")),
          onOverlayClosed: Be[13] || (Be[13] = (j) => pe(j, !1)),
          onOverlayOpened: Be[14] || (Be[14] = (j) => pe(j, !0)),
          onAmPmChange: Be[15] || (Be[15] = (j) => Oe.$emit("am-pm-change", j))
        }), so({ _: 2 }, [
          rt(R(Q), (j, Qe) => ({
            name: j,
            fn: je((Ae) => [
              be(Oe.$slots, j, Er(fo(Ae)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : q("", !0)
    ], 64));
  }
}), zN = (e, t) => {
  const r = Ee(), {
    defaultedMultiCalendars: o,
    defaultedConfig: n,
    defaultedHighlight: a,
    defaultedRange: l,
    propDates: i,
    defaultedFilters: s,
    defaultedMultiDates: u
  } = Pr(e), { modelValue: c, year: g, month: p, calendars: h } = vu(e, t), { isDisabled: v } = Nl(e), { selectYear: A, groupedYears: S, showYearPicker: b, isDisabled: T, toggleYearPicker: w, handleYearSelect: N, handleYear: O } = aw({
    modelValue: c,
    multiCalendars: o,
    range: l,
    highlight: a,
    calendars: h,
    propDates: i,
    month: p,
    year: g,
    filters: s,
    props: e,
    emit: t
  }), m = (K, W) => [K, W].map((xe) => Sa(xe, "MMMM", { locale: e.formatLocale })).join("-"), _ = ge(() => (K) => c.value ? Array.isArray(c.value) ? c.value.some((W) => M1(K, W)) : M1(c.value, K) : !1), X = (K) => {
    if (l.value.enabled) {
      if (Array.isArray(c.value)) {
        const W = Rt(K, c.value[0]) || Rt(K, c.value[1]);
        return Qd(c.value, r.value, K) && !W;
      }
      return !1;
    }
    return !1;
  }, $ = (K, W) => K.quarter === y1(W) && K.year === $t(W), E = (K) => typeof a.value == "function" ? a.value({ quarter: y1(K), year: $t(K) }) : !!a.value.quarters.find((W) => $(W, K)), D = ge(() => (K) => {
    const W = cr(/* @__PURE__ */ new Date(), { year: g.value(K) });
    return PE({
      start: $s(W),
      end: Py(W)
    }).map((xe) => {
      const Ce = zl(xe), Q = w1(xe), ue = v(xe), V = X(Ce), ae = E(Ce);
      return {
        text: m(Ce, Q),
        value: Ce,
        active: _.value(Ce),
        highlighted: ae,
        disabled: ue,
        isBetween: V
      };
    });
  }), U = (K) => {
    G0(K, c, u.value.limit), t("auto-apply", !0);
  }, Y = (K) => {
    c.value = B0(c, K, t), ym(c.value, t, e.autoApply, e.modelAuto);
  }, G = (K) => {
    c.value = K, t("auto-apply");
  };
  return {
    defaultedConfig: n,
    defaultedMultiCalendars: o,
    groupedYears: S,
    year: g,
    isDisabled: T,
    quarters: D,
    showYearPicker: b,
    modelValue: c,
    setHoverDate: (K) => {
      r.value = K;
    },
    selectYear: A,
    selectQuarter: (K, W, xe) => {
      if (!xe)
        return h.value[W].month = It(w1(K)), u.value.enabled ? U(K) : l.value.enabled ? Y(K) : G(K);
    },
    toggleYearPicker: w,
    handleYearSelect: N,
    handleYear: O
  };
}, qN = { class: "dp--quarter-items" }, JN = ["data-test-id", "disabled", "onClick", "onMouseover"], eD = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...qn
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, a = _i(), l = an(a, "yearMode"), {
      defaultedMultiCalendars: i,
      defaultedConfig: s,
      groupedYears: u,
      year: c,
      isDisabled: g,
      quarters: p,
      modelValue: h,
      showYearPicker: v,
      setHoverDate: A,
      selectQuarter: S,
      toggleYearPicker: b,
      handleYearSelect: T,
      handleYear: w
    } = zN(n, o);
    return t({ getSidebarProps: () => ({
      modelValue: h,
      year: c,
      selectQuarter: S,
      handleYearSelect: T,
      handleYear: w
    }) }), (N, O) => (C(), ft(bm, {
      "multi-calendars": R(i).count,
      collapse: N.collapse,
      stretch: "",
      "is-mobile": N.isMobile
    }, {
      default: je(({ instance: m }) => [
        L("div", {
          class: "dp-quarter-picker-wrap",
          style: io({ minHeight: `${R(s).modeHeight}px` })
        }, [
          N.$slots["top-extra"] ? be(N.$slots, "top-extra", {
            key: 0,
            value: N.internalModelValue
          }) : q("", !0),
          L("div", null, [
            vt(rw, ht(N.$props, {
              items: R(u)(m),
              instance: m,
              "show-year-picker": R(v)[m],
              year: R(c)(m),
              "is-disabled": (_) => R(g)(m, _),
              onHandleYear: (_) => R(w)(m, _),
              onYearSelect: (_) => R(T)(_, m),
              onToggleYearPicker: (_) => R(b)(m, _?.flow, _?.show)
            }), so({ _: 2 }, [
              rt(R(l), (_, X) => ({
                name: _,
                fn: je(($) => [
                  be(N.$slots, _, Er(fo($)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          L("div", qN, [
            (C(!0), k(De, null, rt(R(p)(m), (_, X) => (C(), k("div", { key: X }, [
              L("button", {
                type: "button",
                class: $e(["dp--qr-btn", {
                  "dp--qr-btn-active": _.active,
                  "dp--qr-btn-between": _.isBetween,
                  "dp--qr-btn-disabled": _.disabled,
                  "dp--highlighted": _.highlighted
                }]),
                "data-test-id": _.value,
                disabled: _.disabled,
                onClick: ($) => R(S)(_.value, m, _.disabled),
                onMouseover: ($) => R(A)(_.value)
              }, [
                N.$slots.quarter ? be(N.$slots, "quarter", {
                  key: 0,
                  value: _.value,
                  text: _.text
                }) : (C(), k(De, { key: 1 }, [
                  Gt(_e(_.text), 1)
                ], 64))
              ], 42, JN)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), sw = (e, t) => {
  const r = Ee(0);
  or(() => {
    o(), window.addEventListener("resize", o, { passive: !0 });
  }), tn(() => {
    window.removeEventListener("resize", o);
  });
  const o = () => {
    r.value = window.document.documentElement.clientWidth;
  };
  return {
    isMobile: ge(
      () => r.value <= e.value.mobileBreakpoint && !t ? !0 : void 0
    )
  };
}, tD = ["id", "tabindex", "role", "aria-label"], rD = {
  key: 0,
  class: "dp--menu-load-container"
}, oD = {
  key: 1,
  class: "dp--menu-header"
}, nD = ["data-dp-mobile"], aD = {
  key: 0,
  class: "dp__sidebar_left"
}, lD = ["data-dp-mobile"], iD = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], sD = {
  key: 2,
  class: "dp__sidebar_right"
}, dD = {
  key: 3,
  class: "dp__action_extra"
}, B1 = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Sm,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "menu-blur"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, a = Ee(null), l = ge(() => {
      const { openOnTop: se, ...Fe } = n;
      return {
        ...Fe,
        isMobile: S.value,
        flowStep: Y.value,
        menuWrapRef: a.value
      };
    }), { setMenuFocused: i, setShiftKey: s, control: u } = tw(), c = _i(), { defaultedTextInput: g, defaultedInline: p, defaultedConfig: h, defaultedUI: v, handleEventPropagation: A } = Pr(n), { isMobile: S } = sw(h, n.shadow), b = Ee(null), T = Ee(0), w = Ee(null), N = Ee(!1), O = Ee(null), m = Ee(!1), _ = (se) => {
      m.value = !0, h.value.allowPreventDefault && se.preventDefault(), Al(se, h.value, !0);
    };
    or(() => {
      if (!n.shadow) {
        N.value = !0, X(), window.addEventListener("resize", X);
        const se = eo(a);
        se && !g.value.enabled && !p.value.enabled && (i(!0), ue()), se && (se.addEventListener("pointerdown", _), se.addEventListener("mousedown", _));
      }
      document.addEventListener("mousedown", ze);
    }), tn(() => {
      window.removeEventListener("resize", X), document.removeEventListener("mousedown", ze);
      const se = eo(a);
      se && (se.removeEventListener("pointerdown", _), se.removeEventListener("mousedown", _));
    });
    const X = () => {
      const se = eo(w);
      se && (T.value = se.getBoundingClientRect().width);
    }, { arrowRight: $, arrowLeft: E, arrowDown: D, arrowUp: U } = Ol(), { flowStep: Y, updateFlowStep: G, childMount: K, resetFlow: W, handleFlow: xe } = fD(n, o, O), Ce = ge(() => n.monthPicker ? vN : n.yearPicker ? bN : n.timePicker ? DN : n.quarterPicker ? eD : ZN), Q = ge(() => {
      if (h.value.arrowLeft) return h.value.arrowLeft;
      const se = a.value?.getBoundingClientRect(), Fe = n.getInputRect();
      return Fe?.width < T?.value && Fe?.left <= (se?.left ?? 0) ? `${Fe?.width / 2}px` : Fe?.right >= (se?.right ?? 0) && Fe?.width < T?.value ? `${T?.value - Fe?.width / 2}px` : "50%";
    }), ue = () => {
      const se = eo(a);
      se && se.focus({ preventScroll: !0 });
    }, V = ge(() => O.value?.getSidebarProps() || {}), ae = () => {
      n.openOnTop && o("recalculate-position");
    }, F = an(c, "action"), le = ge(() => n.monthPicker || n.yearPicker ? an(c, "monthYear") : n.timePicker ? an(c, "timePicker") : an(c, "shared")), te = ge(() => n.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), ie = ge(() => ({
      dp__menu_disabled: n.disabled,
      dp__menu_readonly: n.readonly,
      "dp-menu-loading": n.loading
    })), B = ge(
      () => ({
        dp__menu: !0,
        dp__menu_index: !p.value.enabled,
        dp__relative: p.value.enabled,
        ...v.value.menu ?? {}
      })
    ), I = (se) => {
      Al(se, h.value, !0);
    }, ee = (se) => {
      n.escClose && (o("close-picker"), A(se));
    }, Se = (se) => {
      if (n.arrowNavigation) {
        if (se === Go.up) return U();
        if (se === Go.down) return D();
        if (se === Go.left) return E();
        if (se === Go.right) return $();
      } else se === Go.left || se === Go.up ? j("handleArrow", Go.left, 0, se === Go.up) : j("handleArrow", Go.right, 0, se === Go.down);
    }, pe = (se) => {
      s(se.shiftKey), !n.disableMonthYearSelect && se.code === wr.tab && se.target.classList.contains("dp__menu") && u.value.shiftKeyInMenu && (se.preventDefault(), Al(se, h.value, !0), o("close-picker"));
    }, Ke = () => {
      ue(), o("time-picker-close");
    }, Oe = (se) => {
      O.value?.toggleTimePicker(!1, !1), O.value?.toggleMonthPicker(!1, !1, se), O.value?.toggleYearPicker(!1, !1, se);
    }, Be = (se, Fe = 0) => se === "month" ? O.value?.toggleMonthPicker(!1, !0, Fe) : se === "year" ? O.value?.toggleYearPicker(!1, !0, Fe) : se === "time" ? O.value?.toggleTimePicker(!0, !1) : Oe(Fe), j = (se, ...Fe) => {
      O.value?.[se] && O.value?.[se](...Fe);
    }, Qe = () => {
      j("selectCurrentDate");
    }, Ae = (se, Fe) => {
      j("presetDate", _l(se), Fe);
    }, re = () => {
      j("clearHoverDate");
    }, ne = (se, Fe) => {
      j("updateMonthYear", se, Fe);
    }, Le = (se, Fe) => {
      se.preventDefault(), Se(Fe);
    }, He = (se) => {
      if (pe(se), se.key === wr.home || se.key === wr.end)
        return j(
          "selectWeekDate",
          se.key === wr.home,
          se.target.getAttribute("id")
        );
      switch ((se.key === wr.pageUp || se.key === wr.pageDown) && (se.shiftKey ? (j("changeYear", se.key === wr.pageUp), Qf(a.value, "overlay-year")?.focus()) : (j("changeMonth", se.key === wr.pageUp), Qf(a.value, se.key === wr.pageUp ? "action-prev" : "action-next")?.focus()), se.target.getAttribute("id") && a.value?.focus({ preventScroll: !0 })), se.key) {
        case wr.esc:
          return ee(se);
        case wr.arrowLeft:
          return Le(se, Go.left);
        case wr.arrowRight:
          return Le(se, Go.right);
        case wr.arrowUp:
          return Le(se, Go.up);
        case wr.arrowDown:
          return Le(se, Go.down);
        default:
          return;
      }
    }, ze = (se) => {
      p.value.enabled && !p.value.input && !a.value?.contains(se.target) && m.value && (m.value = !1, o("menu-blur"));
    };
    return t({
      updateMonthYear: ne,
      switchView: Be,
      handleFlow: xe,
      onValueCleared: () => {
        O.value?.setStartTime?.();
      }
    }), (se, Fe) => (C(), k("div", {
      id: se.uid ? `dp-menu-${se.uid}` : void 0,
      ref_key: "dpMenuRef",
      ref: a,
      tabindex: R(p).enabled ? void 0 : "0",
      role: R(p).enabled ? void 0 : "dialog",
      "aria-label": se.ariaLabels?.menu,
      class: $e(B.value),
      style: io({ "--dp-arrow-left": Q.value }),
      onMouseleave: re,
      onClick: I,
      onKeydown: He
    }, [
      (se.disabled || se.readonly) && R(p).enabled || se.loading ? (C(), k("div", {
        key: 0,
        class: $e(ie.value)
      }, [
        se.loading ? (C(), k("div", rD, [...Fe[19] || (Fe[19] = [
          L("span", { class: "dp--menu-loader" }, null, -1)
        ])])) : q("", !0)
      ], 2)) : q("", !0),
      se.$slots["menu-header"] ? (C(), k("div", oD, [
        be(se.$slots, "menu-header")
      ])) : q("", !0),
      !R(p).enabled && !se.teleportCenter ? (C(), k("div", {
        key: 2,
        class: $e(te.value)
      }, null, 2)) : q("", !0),
      L("div", {
        ref_key: "innerMenuRef",
        ref: w,
        class: $e({
          dp__menu_content_wrapper: se.presetDates?.length || !!se.$slots["left-sidebar"] || !!se.$slots["right-sidebar"],
          "dp--menu-content-wrapper-collapsed": e.collapse && (se.presetDates?.length || !!se.$slots["left-sidebar"] || !!se.$slots["right-sidebar"])
        }),
        "data-dp-mobile": R(S),
        style: io({ "--dp-menu-width": `${T.value}px` })
      }, [
        se.$slots["left-sidebar"] ? (C(), k("div", aD, [
          be(se.$slots, "left-sidebar", Er(fo(V.value)))
        ])) : q("", !0),
        se.presetDates.length ? (C(), k("div", {
          key: 1,
          class: $e({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 }),
          "data-dp-mobile": R(S)
        }, [
          (C(!0), k(De, null, rt(se.presetDates, (qe, ye) => (C(), k(De, { key: ye }, [
            qe.slot ? be(se.$slots, qe.slot, {
              key: 0,
              presetDate: Ae,
              label: qe.label,
              value: qe.value
            }) : (C(), k("button", {
              key: 1,
              type: "button",
              style: io(qe.style || {}),
              class: $e(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
              "data-test-id": qe.testId ?? void 0,
              "data-dp-mobile": R(S),
              onClick: Nt((Ne) => Ae(qe.value, qe.noTz), ["prevent"]),
              onKeydown: (Ne) => R(Ro)(Ne, () => Ae(qe.value, qe.noTz), !0)
            }, _e(qe.label), 47, iD))
          ], 64))), 128))
        ], 10, lD)) : q("", !0),
        L("div", {
          ref_key: "calendarWrapperRef",
          ref: b,
          class: "dp__instance_calendar",
          role: "document"
        }, [
          (C(), ft(nu(Ce.value), ht({
            ref_key: "dynCmpRef",
            ref: O
          }, l.value, {
            "flow-step": R(Y),
            onMount: R(K),
            onUpdateFlowStep: R(G),
            onResetFlow: R(W),
            onFocusMenu: ue,
            onSelectDate: Fe[0] || (Fe[0] = (qe) => se.$emit("select-date")),
            onDateUpdate: Fe[1] || (Fe[1] = (qe) => se.$emit("date-update", qe)),
            onTooltipOpen: Fe[2] || (Fe[2] = (qe) => se.$emit("tooltip-open", qe)),
            onTooltipClose: Fe[3] || (Fe[3] = (qe) => se.$emit("tooltip-close", qe)),
            onAutoApply: Fe[4] || (Fe[4] = (qe) => se.$emit("auto-apply", qe)),
            onRangeStart: Fe[5] || (Fe[5] = (qe) => se.$emit("range-start", qe)),
            onRangeEnd: Fe[6] || (Fe[6] = (qe) => se.$emit("range-end", qe)),
            onInvalidFixedRange: Fe[7] || (Fe[7] = (qe) => se.$emit("invalid-fixed-range", qe)),
            onTimeUpdate: Fe[8] || (Fe[8] = (qe) => se.$emit("time-update")),
            onAmPmChange: Fe[9] || (Fe[9] = (qe) => se.$emit("am-pm-change", qe)),
            onTimePickerOpen: Fe[10] || (Fe[10] = (qe) => se.$emit("time-picker-open", qe)),
            onTimePickerClose: Ke,
            onRecalculatePosition: ae,
            onUpdateMonthYear: Fe[11] || (Fe[11] = (qe) => se.$emit("update-month-year", qe)),
            onAutoApplyInvalid: Fe[12] || (Fe[12] = (qe) => se.$emit("auto-apply-invalid", qe)),
            onInvalidDate: Fe[13] || (Fe[13] = (qe) => se.$emit("invalid-date", qe)),
            onOverlayToggle: Fe[14] || (Fe[14] = (qe) => se.$emit("overlay-toggle", qe)),
            "onUpdate:internalModelValue": Fe[15] || (Fe[15] = (qe) => se.$emit("update:internal-model-value", qe))
          }), so({ _: 2 }, [
            rt(le.value, (qe, ye) => ({
              name: qe,
              fn: je((Ne) => [
                be(se.$slots, qe, Er(fo({ ...Ne })))
              ])
            }))
          ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
        ], 512),
        se.$slots["right-sidebar"] ? (C(), k("div", sD, [
          be(se.$slots, "right-sidebar", Er(fo(V.value)))
        ])) : q("", !0),
        se.$slots["action-extra"] ? (C(), k("div", dD, [
          se.$slots["action-extra"] ? be(se.$slots, "action-extra", {
            key: 0,
            selectCurrentDate: Qe
          }) : q("", !0)
        ])) : q("", !0)
      ], 14, nD),
      !se.autoApply || R(h).keepActionRow ? (C(), ft(dN, ht({
        key: 3,
        "menu-mount": N.value
      }, l.value, {
        "calendar-width": T.value,
        onClosePicker: Fe[16] || (Fe[16] = (qe) => se.$emit("close-picker")),
        onSelectDate: Fe[17] || (Fe[17] = (qe) => se.$emit("select-date")),
        onInvalidSelect: Fe[18] || (Fe[18] = (qe) => se.$emit("invalid-select")),
        onSelectNow: Qe
      }), so({ _: 2 }, [
        rt(R(F), (qe, ye) => ({
          name: qe,
          fn: je((Ne) => [
            be(se.$slots, qe, Er(fo({ ...Ne })))
          ])
        }))
      ]), 1040, ["menu-mount", "calendar-width"])) : q("", !0)
    ], 46, tD));
  }
});
var xs = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(xs || {});
const uD = ({
  menuRef: e,
  menuRefInner: t,
  inputRef: r,
  pickerWrapperRef: o,
  inline: n,
  emit: a,
  props: l,
  slots: i
}) => {
  const { defaultedConfig: s } = Pr(l), u = Ee({}), c = Ee(!1), g = Ee({
    top: "0",
    left: "0"
  }), p = Ee(!1), h = Ua(l, "teleportCenter");
  nt(h, () => {
    g.value = JSON.parse(JSON.stringify({})), O();
  });
  const v = (W) => {
    if (l.teleport) {
      const xe = W.getBoundingClientRect();
      return {
        left: xe.left + window.scrollX,
        top: xe.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, A = (W, xe) => {
    g.value.left = `${W + xe - u.value.width}px`;
  }, S = (W) => {
    g.value.left = `${W}px`;
  }, b = (W, xe) => {
    l.position === xs.left && S(W), l.position === xs.right && A(W, xe), l.position === xs.center && (g.value.left = `${W + xe / 2 - u.value.width / 2}px`);
  }, T = (W) => {
    const { width: xe, height: Ce } = W.getBoundingClientRect(), { top: Q, left: ue } = v(W);
    return { top: +Q, left: +ue, width: xe, height: Ce };
  }, w = () => {
    g.value.left = "50%", g.value.top = "50%", g.value.transform = "translate(-50%, -50%)", g.value.position = "fixed", delete g.value.opacity;
  }, N = () => {
    const W = eo(r);
    g.value = l.altPosition(W);
  }, O = (W = !0) => {
    if (!n.value.enabled) {
      if (h.value) return w();
      if (l.altPosition !== null) return N();
      if (W) {
        const xe = l.teleport ? t.value?.$el : e.value;
        xe && (u.value = xe.getBoundingClientRect()), a("recalculate-position");
      }
      return U();
    }
  }, m = ({ inputEl: W, left: xe, width: Ce }) => {
    window.screen.width > 768 && !c.value && b(xe, Ce), $(W);
  }, _ = (W) => {
    const { top: xe, left: Ce, height: Q, width: ue } = T(W);
    g.value.top = `${Q + xe + +l.offset}px`, p.value = !1, c.value || (g.value.left = `${Ce + ue / 2 - u.value.width / 2}px`), m({ inputEl: W, left: Ce, width: ue });
  }, X = (W) => {
    const { top: xe, left: Ce, width: Q } = T(W);
    g.value.top = `${xe - +l.offset - u.value.height}px`, p.value = !0, m({ inputEl: W, left: Ce, width: Q });
  }, $ = (W) => {
    if (l.autoPosition) {
      const { left: xe, width: Ce } = T(W), { left: Q, right: ue } = u.value;
      if (!c.value) {
        if (Math.abs(Q) !== Math.abs(ue)) {
          if (Q <= 0)
            return c.value = !0, S(xe);
          if (ue >= document.documentElement.clientWidth)
            return c.value = !0, A(xe, Ce);
        }
        return b(xe, Ce);
      }
    }
  }, E = () => {
    const W = eo(r);
    if (W) {
      if (l.autoPosition === Un.top) return Un.top;
      if (l.autoPosition === Un.bottom) return Un.bottom;
      const { height: xe } = u.value, { top: Ce, height: Q } = W.getBoundingClientRect(), ue = window.innerHeight - Ce - Q, V = Ce;
      return xe <= ue ? Un.bottom : xe > ue && xe <= V ? Un.top : ue >= V ? Un.bottom : Un.top;
    }
    return Un.bottom;
  }, D = (W) => E() === Un.bottom ? _(W) : X(W), U = () => {
    const W = eo(r);
    if (W)
      return l.autoPosition ? D(W) : _(W);
  }, Y = function(W) {
    if (W) {
      const xe = W.scrollHeight > W.clientHeight, Ce = window.getComputedStyle(W).overflowY.indexOf("hidden") !== -1;
      return xe && !Ce;
    }
    return !0;
  }, G = function(W) {
    return !W || W === document.body || W.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : Y(W) ? W : G(
      W.assignedSlot && s.value.shadowDom ? W.assignedSlot.parentNode : W.parentNode
    );
  }, K = (W) => {
    if (W)
      switch (l.position) {
        case xs.left:
          return { left: 0, transform: "translateX(0)" };
        case xs.right:
          return { left: `${W.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${W.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: p,
    menuStyle: g,
    xCorrect: c,
    setMenuPosition: O,
    getScrollableParent: G,
    shadowRender: (W, xe, Ce) => {
      const Q = document.createElement("div"), ue = eo(r)?.getBoundingClientRect();
      Q.setAttribute("id", "dp--temp-container");
      const V = o.value?.clientWidth ? o.value : document.body;
      V.append(Q);
      const ae = K(ue), F = s.value.shadowDom ? Object.keys(i).filter(
        (te) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(te)
      ) : Object.keys(i), le = Ds(
        xe,
        {
          ...Ce,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...ae }
        },
        Object.fromEntries(F.map((te) => [te, i[te]]))
      );
      W != null && (le.appContext = W.appContext), Ac(le, Q), u.value = le.el?.getBoundingClientRect(), Ac(null, Q), V.removeChild(Q);
    }
  };
}, dl = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], cD = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], mD = {
  all: () => dl,
  monthYear: () => dl.filter((e) => e.use.includes("month-year")),
  input: () => cD,
  timePicker: () => dl.filter((e) => e.use.includes("time")),
  action: () => dl.filter((e) => e.use.includes("action")),
  calendar: () => dl.filter((e) => e.use.includes("calendar")),
  menu: () => dl.filter((e) => e.use.includes("menu")),
  shared: () => dl.filter((e) => e.use.includes("shared")),
  yearMode: () => dl.filter((e) => e.use.includes("year-mode"))
}, an = (e, t, r) => {
  const o = [];
  return mD[t]().forEach((n) => {
    e[n.name] && o.push(n.name);
  }), r?.length && r.forEach((n) => {
    n.slot && o.push(n.slot);
  }), o;
}, xu = (e) => {
  const t = ge(() => (o) => e.value ? o ? e.value.open : e.value.close : ""), r = ge(() => (o) => e.value ? o ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: t, showTransition: !!e.value, menuTransition: r };
}, vu = (e, t, r) => {
  const { defaultedRange: o, defaultedTz: n } = Pr(e), a = Re(zo(Re(), n.value.timezone)), l = Ee([{ month: It(a), year: $t(a) }]), i = (p) => {
    const h = {
      hours: Ya(a),
      minutes: $l(a),
      seconds: 0
    };
    return o.value.enabled ? [h[p], h[p]] : h[p];
  }, s = dt({
    hours: i("hours"),
    minutes: i("minutes"),
    seconds: i("seconds")
  });
  nt(
    o,
    (p, h) => {
      p.enabled !== h.enabled && (s.hours = i("hours"), s.minutes = i("minutes"), s.seconds = i("seconds"));
    },
    { deep: !0 }
  );
  const u = ge({
    get: () => e.internalModelValue,
    set: (p) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", p);
    }
  }), c = ge(
    () => (p) => l.value[p] ? l.value[p].month : 0
  ), g = ge(
    () => (p) => l.value[p] ? l.value[p].year : 0
  );
  return nt(
    u,
    (p, h) => {
      r && JSON.stringify(p ?? {}) !== JSON.stringify(h ?? {}) && r();
    },
    { deep: !0 }
  ), {
    calendars: l,
    time: s,
    modelValue: u,
    month: c,
    year: g,
    today: a
  };
}, gD = (e, t) => {
  const {
    defaultedMultiCalendars: r,
    defaultedMultiDates: o,
    defaultedUI: n,
    defaultedHighlight: a,
    defaultedTz: l,
    propDates: i,
    defaultedRange: s
  } = Pr(t), { isDisabled: u } = Nl(t), c = Ee(null), g = Ee(zo(/* @__PURE__ */ new Date(), l.value.timezone)), p = (B) => {
    !B.current && t.hideOffsetDates || (c.value = B.value);
  }, h = () => {
    c.value = null;
  }, v = (B) => Array.isArray(e.value) && s.value.enabled && e.value[0] && c.value ? B ? Fr(c.value, e.value[0]) : Lr(c.value, e.value[0]) : !0, A = (B, I) => {
    const ee = () => e.value ? I ? e.value[0] || null : e.value[1] : null, Se = e.value && Array.isArray(e.value) ? ee() : null;
    return Rt(Re(B.value), Se);
  }, S = (B) => {
    const I = Array.isArray(e.value) ? e.value[0] : null;
    return B ? !Lr(c.value ?? null, I) : !0;
  }, b = (B, I = !0) => (s.value.enabled || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !B.current ? !1 : Rt(Re(B.value), e.value[I ? 0 : 1]) : s.value.enabled ? A(B, I) && S(I) || Rt(B.value, Array.isArray(e.value) ? e.value[0] : null) && v(I) : !1, T = (B, I) => {
    if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
      const ee = Rt(B.value, c.value);
      return I ? Fr(e.value[0], B.value) && ee : Lr(e.value[0], B.value) && ee;
    }
    return !1;
  }, w = (B) => !e.value || t.hideOffsetDates && !B.current ? !1 : s.value.enabled ? t.modelAuto && Array.isArray(e.value) ? Rt(B.value, e.value[0] ? e.value[0] : g.value) : !1 : o.value.enabled && Array.isArray(e.value) ? e.value.some((I) => Rt(I, B.value)) : Rt(B.value, e.value ? e.value : g.value), N = (B) => {
    if (s.value.autoRange || t.weekPicker) {
      if (c.value) {
        if (t.hideOffsetDates && !B.current) return !1;
        const I = Tn(c.value, +s.value.autoRange), ee = Ga(Re(c.value), t.weekStart);
        return t.weekPicker ? Rt(ee[1], Re(B.value)) : Rt(I, Re(B.value));
      }
      return !1;
    }
    return !1;
  }, O = (B) => {
    if (s.value.autoRange || t.weekPicker) {
      if (c.value) {
        const I = Tn(c.value, +s.value.autoRange);
        if (t.hideOffsetDates && !B.current) return !1;
        const ee = Ga(Re(c.value), t.weekStart);
        return t.weekPicker ? Fr(B.value, ee[0]) && Lr(B.value, ee[1]) : Fr(B.value, c.value) && Lr(B.value, I);
      }
      return !1;
    }
    return !1;
  }, m = (B) => {
    if (s.value.autoRange || t.weekPicker) {
      if (c.value) {
        if (t.hideOffsetDates && !B.current) return !1;
        const I = Ga(Re(c.value), t.weekStart);
        return t.weekPicker ? Rt(I[0], B.value) : Rt(c.value, B.value);
      }
      return !1;
    }
    return !1;
  }, _ = (B) => Qd(e.value, c.value, B.value), X = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, $ = () => t.modelAuto ? Uy(t.internalModelValue) : !0, E = (B) => {
    if (t.weekPicker) return !1;
    const I = s.value.enabled ? !b(B) && !b(B, !1) : !0;
    return !u(B.value) && !w(B) && !(!B.current && t.hideOffsetDates) && I;
  }, D = (B) => s.value.enabled ? t.modelAuto ? X() && w(B) : !1 : w(B), U = (B) => a.value ? O3(B.value, i.value.highlight) : !1, Y = (B) => {
    const I = u(B.value);
    return I && (typeof a.value == "function" ? !a.value(B.value, I) : !a.value.options.highlightDisabled);
  }, G = (B) => typeof a.value == "function" ? a.value(B.value) : a.value.weekdays?.includes(B.value.getDay()), K = (B) => (s.value.enabled || t.weekPicker) && (!(r.value.count > 0) || B.current) && $() && !(!B.current && t.hideOffsetDates) && !w(B) ? _(B) : !1, W = (B) => {
    if (Array.isArray(e.value) && e.value.length === 1) {
      const { before: I, after: ee } = N1(+s.value.maxRange, e.value[0]);
      return Rs(B.value, I) || gi(B.value, ee);
    }
    return !1;
  }, xe = (B) => {
    if (Array.isArray(e.value) && e.value.length === 1) {
      const { before: I, after: ee } = N1(+s.value.minRange, e.value[0]);
      return Qd([I, ee], e.value[0], B.value);
    }
    return !1;
  }, Ce = (B) => s.value.enabled && (s.value.maxRange || s.value.minRange) ? s.value.maxRange && s.value.minRange ? W(B) || xe(B) : s.value.maxRange ? W(B) : xe(B) : !1, Q = (B) => {
    const { isRangeStart: I, isRangeEnd: ee } = F(B), Se = s.value.enabled ? I || ee : !1;
    return {
      dp__cell_offset: !B.current,
      dp__pointer: !t.disabled && !(!B.current && t.hideOffsetDates) && !u(B.value) && !Ce(B),
      dp__cell_disabled: u(B.value) || Ce(B),
      dp__cell_highlight: !Y(B) && (U(B) || G(B)) && !D(B) && !Se && !m(B) && !(K(B) && t.weekPicker) && !ee,
      dp__cell_highlight_active: !Y(B) && (U(B) || G(B)) && D(B),
      dp__today: !t.noToday && Rt(B.value, g.value) && B.current,
      "dp--past": Lr(B.value, g.value),
      "dp--future": Fr(B.value, g.value)
    };
  }, ue = (B) => ({
    dp__active_date: D(B),
    dp__date_hover: E(B)
  }), V = (B) => {
    if (e.value && !Array.isArray(e.value)) {
      const I = Ga(e.value, t.weekStart);
      return {
        ...te(B),
        dp__range_start: Rt(I[0], B.value),
        dp__range_end: Rt(I[1], B.value),
        dp__range_between_week: Fr(B.value, I[0]) && Lr(B.value, I[1])
      };
    }
    return {
      ...te(B)
    };
  }, ae = (B) => {
    if (e.value && Array.isArray(e.value)) {
      const I = Ga(e.value[0], t.weekStart), ee = e.value[1] ? Ga(e.value[1], t.weekStart) : [];
      return {
        ...te(B),
        dp__range_start: Rt(I[0], B.value) || Rt(ee[0], B.value),
        dp__range_end: Rt(I[1], B.value) || Rt(ee[1], B.value),
        dp__range_between_week: Fr(B.value, I[0]) && Lr(B.value, I[1]) || Fr(B.value, ee[0]) && Lr(B.value, ee[1]),
        dp__range_between: Fr(B.value, I[1]) && Lr(B.value, ee[0])
      };
    }
    return {
      ...te(B)
    };
  }, F = (B) => {
    const I = r.value.count > 0 ? B.current && b(B) && $() : b(B) && $(), ee = r.value.count > 0 ? B.current && b(B, !1) && $() : b(B, !1) && $();
    return { isRangeStart: I, isRangeEnd: ee };
  }, le = (B) => {
    const { isRangeStart: I, isRangeEnd: ee } = F(B);
    return {
      dp__range_start: I,
      dp__range_end: ee,
      dp__range_between: K(B),
      dp__date_hover: Rt(B.value, c.value) && !I && !ee && !t.weekPicker,
      dp__date_hover_start: T(B, !0),
      dp__date_hover_end: T(B, !1)
    };
  }, te = (B) => ({
    ...le(B),
    dp__cell_auto_range: O(B),
    dp__cell_auto_range_start: m(B),
    dp__cell_auto_range_end: N(B)
  }), ie = (B) => s.value.enabled ? s.value.autoRange ? te(B) : t.modelAuto ? { ...ue(B), ...le(B) } : t.weekPicker ? ae(B) : le(B) : t.weekPicker ? V(B) : ue(B);
  return {
    setHoverDate: p,
    clearHoverDate: h,
    getDayClassData: (B) => t.hideOffsetDates && !B.current ? {} : {
      ...Q(B),
      ...ie(B),
      [t.dayClass ? t.dayClass(B.value, t.internalModelValue) : ""]: !0,
      ...n.value.calendarCell ?? {}
    }
  };
}, Nl = (e) => {
  const { defaultedFilters: t, defaultedRange: r, propDates: o, defaultedMultiDates: n } = Pr(e), a = (G) => o.value.disabledDates ? typeof o.value.disabledDates == "function" ? o.value.disabledDates(Re(G)) : !!Uc(G, o.value.disabledDates) : !1, l = (G) => o.value.maxDate ? e.yearPicker ? $t(G) > $t(o.value.maxDate) : Fr(G, o.value.maxDate) : !1, i = (G) => o.value.minDate ? e.yearPicker ? $t(G) < $t(o.value.minDate) : Lr(G, o.value.minDate) : !1, s = (G) => {
    const K = l(G), W = i(G), xe = a(G), Ce = t.value.months.map((F) => +F).includes(It(G)), Q = e.disabledWeekDays.length ? e.disabledWeekDays.some((F) => +F === SO(G)) : !1, ue = h(G), V = $t(G), ae = ew(e.yearRange, V);
    return !(K || W || xe || Ce || ae || Q || ue);
  }, u = (G, K) => Lr(...Sl(o.value.minDate, G, K)) || Rt(...Sl(o.value.minDate, G, K)), c = (G, K) => Fr(...Sl(o.value.maxDate, G, K)) || Rt(...Sl(o.value.maxDate, G, K)), g = (G, K, W) => {
    let xe = !1;
    return o.value.maxDate && W && c(G, K) && (xe = !0), o.value.minDate && !W && u(G, K) && (xe = !0), xe;
  }, p = (G, K, W, xe) => {
    let Ce = !1;
    return xe && (o.value.minDate || o.value.maxDate) ? o.value.minDate && o.value.maxDate ? Ce = g(G, K, W) : (o.value.minDate && u(G, K) || o.value.maxDate && c(G, K)) && (Ce = !0) : Ce = !0, Ce;
  }, h = (G) => Array.isArray(o.value.allowedDates) && !o.value.allowedDates.length ? !0 : o.value.allowedDates ? !Uc(G, o.value.allowedDates, Wy(e.monthPicker, e.yearPicker)) : !1, v = (G) => !s(G), A = (G) => r.value.noDisabledRange ? !Ay({ start: G[0], end: G[1] }).some((K) => v(K)) : !0, S = (G) => {
    if (G) {
      const K = $t(G);
      return K >= +e.yearRange[0] && K <= e.yearRange[1];
    }
    return !0;
  }, b = (G, K) => !!(Array.isArray(G) && G[K] && (r.value.maxRange || r.value.minRange) && S(G[K])), T = (G, K, W = 0) => {
    if (b(K, W) && S(G)) {
      const xe = wy(G, K[W]), Ce = jy(K[W], G), Q = Ce.length === 1 ? 0 : Ce.filter((V) => v(V)).length, ue = Math.abs(xe) - (r.value.minMaxRawRange ? 0 : Q);
      if (r.value.minRange && r.value.maxRange)
        return ue >= +r.value.minRange && ue <= +r.value.maxRange;
      if (r.value.minRange) return ue >= +r.value.minRange;
      if (r.value.maxRange) return ue <= +r.value.maxRange;
    }
    return !0;
  }, w = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, N = (G) => Array.isArray(G) ? [G[0] ? Cg(G[0]) : null, G[1] ? Cg(G[1]) : null] : Cg(G), O = (G, K, W) => G.find(
    (xe) => +xe.hours === Ya(K) && xe.minutes === "*" ? !0 : +xe.minutes === $l(K) && +xe.hours === Ya(K)
  ) && W, m = (G, K, W) => {
    const [xe, Ce] = G, [Q, ue] = K;
    return !O(xe, Q, W) && !O(Ce, ue, W) && W;
  }, _ = (G, K) => {
    const W = Array.isArray(K) ? K : [K];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? m(e.disabledTimes, W, G) : !W.some((xe) => O(e.disabledTimes, xe, G)) : G;
  }, X = (G, K) => {
    const W = Array.isArray(K) ? [ii(K[0]), K[1] ? ii(K[1]) : void 0] : ii(K), xe = !e.disabledTimes(W);
    return G && xe;
  }, $ = (G, K) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? _(K, G) : X(K, G) : K, E = (G) => {
    let K = !0;
    if (!G || w()) return !0;
    const W = !o.value.minDate && !o.value.maxDate ? N(G) : G;
    return (e.maxTime || o.value.maxDate) && (K = O1(
      e.maxTime,
      o.value.maxDate,
      "max",
      co(W),
      K
    )), (e.minTime || o.value.minDate) && (K = O1(
      e.minTime,
      o.value.minDate,
      "min",
      co(W),
      K
    )), $(G, K);
  }, D = (G) => {
    if (!e.monthPicker) return !0;
    let K = !0;
    const W = Re(Wn(G));
    if (o.value.minDate && o.value.maxDate) {
      const xe = Re(Wn(o.value.minDate)), Ce = Re(Wn(o.value.maxDate));
      return Fr(W, xe) && Lr(W, Ce) || Rt(W, xe) || Rt(W, Ce);
    }
    if (o.value.minDate) {
      const xe = Re(Wn(o.value.minDate));
      K = Fr(W, xe) || Rt(W, xe);
    }
    if (o.value.maxDate) {
      const xe = Re(Wn(o.value.maxDate));
      K = Lr(W, xe) || Rt(W, xe);
    }
    return K;
  }, U = ge(() => (G) => !e.enableTimePicker || e.ignoreTimeValidation ? !0 : E(G)), Y = ge(() => (G) => e.monthPicker ? Array.isArray(G) && (r.value.enabled || n.value.enabled) ? !G.filter((K) => !D(K)).length : D(G) : !0);
  return {
    isDisabled: v,
    validateDate: s,
    validateMonthYearInRange: p,
    isDateRangeAllowed: A,
    checkMinMaxRange: T,
    isValidTime: E,
    isTimeValid: U,
    isMonthValid: Y
  };
}, wm = () => {
  const e = ge(() => (o, n) => o?.includes(n)), t = ge(() => (o, n) => o.count ? o.solo ? !0 : n === 0 : !0), r = ge(() => (o, n) => o.count ? o.solo ? !0 : n === o.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: t, showRightIcon: r };
}, fD = (e, t, r) => {
  const o = Ee(0), n = dt({
    [li.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [li.calendar]: !1,
    [li.header]: !1
  }), a = ge(() => e.monthPicker || e.timePicker), l = (g) => {
    if (e.flow?.length) {
      if (!g && a.value) return c();
      n[g] = !0, Object.keys(n).filter((p) => !n[p]).length || c();
    }
  }, i = () => {
    e.flow?.length && o.value !== -1 && (o.value += 1, t("flow-step", o.value), c()), e.flow?.length === o.value && Kr().then(() => s());
  }, s = () => {
    o.value = -1;
  }, u = (g, p, ...h) => {
    e.flow[o.value] === g && r.value && r.value[p]?.(...h);
  }, c = (g = 0) => {
    g && (o.value += g), u(Po.month, "toggleMonthPicker", !0), u(Po.year, "toggleYearPicker", !0), u(Po.calendar, "toggleTimePicker", !1, !0), u(Po.time, "toggleTimePicker", !0, !0);
    const p = e.flow[o.value];
    (p === Po.hours || p === Po.minutes || p === Po.seconds) && u(p, "toggleTimePicker", !0, !0, p);
  };
  return { childMount: l, updateFlowStep: i, resetFlow: s, handleFlow: c, flowStep: o };
}, pD = {
  key: 1,
  class: "dp__input_wrap"
}, hD = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], xD = {
  key: 2,
  class: "dp--clear-btn"
}, vD = ["aria-label"], SD = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Sm
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, {
      defaultedTextInput: a,
      defaultedAriaLabels: l,
      defaultedInline: i,
      defaultedConfig: s,
      defaultedRange: u,
      defaultedMultiDates: c,
      defaultedUI: g,
      getDefaultPattern: p,
      getDefaultStartTime: h
    } = Pr(n), { checkMinMaxRange: v } = Nl(n), A = Ee(), S = Ee(null), b = Ee(!1), T = Ee(!1), w = ge(
      () => ({
        dp__pointer: !n.disabled && !n.readonly && !a.value.enabled,
        dp__disabled: n.disabled,
        dp__input_readonly: !a.value.enabled,
        dp__input: !0,
        dp__input_not_clearable: !n.clearable,
        dp__input_icon_pad: !n.hideInputIcon,
        dp__input_valid: typeof n.state == "boolean" ? n.state : !1,
        dp__input_invalid: typeof n.state == "boolean" ? !n.state : !1,
        dp__input_focus: b.value || n.isMenuOpen,
        dp__input_reg: !a.value.enabled,
        ...g.value.input ?? {}
      })
    ), N = () => {
      o("set-input-date", null), n.clearable && n.autoApply && (o("set-empty-date"), A.value = null);
    }, O = (V) => {
      const ae = h();
      return D3(
        V,
        a.value.format ?? p(),
        ae ?? Zy({}, n.enableSeconds),
        n.inputValue,
        T.value,
        n.formatLocale
      );
    }, m = (V) => {
      const { rangeSeparator: ae } = a.value, [F, le] = V.split(`${ae}`);
      if (F) {
        const te = O(F.trim()), ie = le ? O(le.trim()) : void 0;
        if (gi(te, ie)) return;
        const B = te && ie ? [te, ie] : [te];
        v(ie, B, 0) && (A.value = te ? B : null);
      }
    }, _ = () => {
      T.value = !0;
    }, X = (V) => {
      if (u.value.enabled)
        m(V);
      else if (c.value.enabled) {
        const ae = V.split(";");
        A.value = ae.map((F) => O(F.trim())).filter((F) => F);
      } else
        A.value = O(V);
    }, $ = (V) => {
      const ae = typeof V == "string" ? V : V.target?.value;
      ae !== "" ? (a.value.openMenu && !n.isMenuOpen && o("open"), X(ae), o("set-input-date", A.value)) : N(), T.value = !1, o("update:input-value", ae), o("text-input", V, A.value);
    }, E = (V) => {
      a.value.enabled ? (X(V.target.value), a.value.enterSubmit && jf(A.value) && n.inputValue !== "" ? (o("set-input-date", A.value, !0), A.value = null) : a.value.enterSubmit && n.inputValue === "" && (A.value = null, o("clear"))) : Y(V);
    }, D = (V, ae) => {
      a.value.enabled && a.value.tabSubmit && !ae && X(V.target.value), a.value.tabSubmit && jf(A.value) && n.inputValue !== "" ? (o("set-input-date", A.value, !0, !0), A.value = null) : a.value.tabSubmit && n.inputValue === "" && (A.value = null, o("clear", !0));
    }, U = () => {
      b.value = !0, o("focus"), Kr().then(() => {
        a.value.enabled && a.value.selectOnFocus && S.value?.select();
      });
    }, Y = (V) => {
      if (Al(V, s.value, !0), a.value.enabled && a.value.openMenu && !i.value.input) {
        if (a.value.openMenu === "open" && !n.isMenuOpen) return o("open");
        if (a.value.openMenu === "toggle") return o("toggle");
      } else a.value.enabled || o("toggle");
    }, G = () => {
      o("real-blur"), b.value = !1, (!n.isMenuOpen || i.value.enabled && i.value.input) && o("blur"), n.autoApply && a.value.enabled && A.value && !n.isMenuOpen && (o("set-input-date", A.value), o("select-date"), A.value = null);
    }, K = (V) => {
      Al(V, s.value, !0), o("clear");
    }, W = () => {
      o("close");
    }, xe = (V) => {
      if (V.key === "Tab" && D(V), V.key === "Enter" && E(V), V.key === "Escape" && a.value.escClose && W(), !a.value.enabled) {
        if (V.code === "Tab") return;
        V.preventDefault();
      }
    }, Ce = () => {
      S.value?.focus({ preventScroll: !0 });
    }, Q = (V) => {
      A.value = V;
    }, ue = (V) => {
      V.key === wr.tab && D(V, !0);
    };
    return t({
      focusInput: Ce,
      setParsedDate: Q
    }), (V, ae) => (C(), k("div", { onClick: Y }, [
      V.$slots.trigger && !V.$slots["dp-input"] && !R(i).enabled ? be(V.$slots, "trigger", { key: 0 }) : q("", !0),
      !V.$slots.trigger && (!R(i).enabled || R(i).input) ? (C(), k("div", pD, [
        V.$slots["dp-input"] && !V.$slots.trigger && (!R(i).enabled || R(i).enabled && R(i).input) ? be(V.$slots, "dp-input", {
          key: 0,
          value: e.inputValue,
          isMenuOpen: e.isMenuOpen,
          onInput: $,
          onEnter: E,
          onTab: D,
          onClear: K,
          onBlur: G,
          onKeypress: xe,
          onPaste: _,
          onFocus: U,
          openMenu: () => V.$emit("open"),
          closeMenu: () => V.$emit("close"),
          toggleMenu: () => V.$emit("toggle")
        }) : q("", !0),
        V.$slots["dp-input"] ? q("", !0) : (C(), k("input", {
          key: 1,
          id: V.uid ? `dp-input-${V.uid}` : void 0,
          ref_key: "inputRef",
          ref: S,
          "data-test-id": "dp-input",
          name: V.name,
          class: $e(w.value),
          inputmode: R(a).enabled ? "text" : "none",
          placeholder: V.placeholder,
          disabled: V.disabled,
          readonly: V.readonly,
          required: V.required,
          value: e.inputValue,
          autocomplete: V.autocomplete,
          "aria-label": R(l)?.input,
          "aria-disabled": V.disabled || void 0,
          "aria-invalid": V.state === !1 ? !0 : void 0,
          onInput: $,
          onBlur: G,
          onFocus: U,
          onKeypress: xe,
          onKeydown: ae[0] || (ae[0] = (F) => xe(F)),
          onPaste: _
        }, null, 42, hD)),
        L("div", {
          onClick: ae[3] || (ae[3] = (F) => o("toggle"))
        }, [
          V.$slots["input-icon"] && !V.hideInputIcon ? (C(), k("span", {
            key: 0,
            class: "dp__input_icon",
            onClick: ae[1] || (ae[1] = (F) => o("toggle"))
          }, [
            be(V.$slots, "input-icon")
          ])) : q("", !0),
          !V.$slots["input-icon"] && !V.hideInputIcon && !V.$slots["dp-input"] ? (C(), ft(R(ld), {
            key: 1,
            "aria-label": R(l)?.calendarIcon,
            class: "dp__input_icon dp__input_icons",
            onClick: ae[2] || (ae[2] = (F) => o("toggle"))
          }, null, 8, ["aria-label"])) : q("", !0)
        ]),
        V.$slots["clear-icon"] && (V.alwaysClearable || e.inputValue && V.clearable && !V.disabled && !V.readonly) ? (C(), k("span", xD, [
          be(V.$slots, "clear-icon", { clear: K })
        ])) : q("", !0),
        !V.$slots["clear-icon"] && (V.alwaysClearable || V.clearable && e.inputValue && !V.disabled && !V.readonly) ? (C(), k("button", {
          key: 3,
          "aria-label": R(l)?.clearInput,
          class: "dp--clear-btn",
          type: "button",
          onKeydown: ae[4] || (ae[4] = (F) => R(Ro)(F, () => K(F), !0, ue)),
          onClick: ae[5] || (ae[5] = Nt((F) => K(F), ["prevent"]))
        }, [
          vt(R(Vy), {
            class: "dp__input_icons",
            "data-test-id": "clear-icon"
          })
        ], 40, vD)) : q("", !0)
      ])) : q("", !0)
    ]));
  }
}), bD = typeof window < "u" ? window : void 0, kg = () => {
}, yD = (e) => Ap() ? (Pp(e), !0) : !1, wD = (e, t, r, o) => {
  if (!e) return kg;
  let n = kg;
  const a = nt(
    () => R(e),
    (i) => {
      n(), i && (i.removeEventListener(t, r), i.addEventListener(t, r, o), n = () => {
        i.removeEventListener(t, r, o), n = kg;
      });
    },
    { immediate: !0, flush: "post" }
  ), l = () => {
    a(), n();
  };
  return yD(l), l;
}, _D = (e, t, r, o = {}) => {
  const { window: n = bD, event: a = "pointerdown" } = o;
  return n ? wD(n, a, (l) => {
    const i = eo(e), s = eo(t);
    !i || !s || i === l.target || l.composedPath().includes(i) || l.composedPath().includes(s) || r(l);
  }, { passive: !0 }) : void 0;
}, TD = ["data-dp-mobile"], AD = /* @__PURE__ */ wt({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Sm
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(e, { expose: t, emit: r }) {
    const o = r, n = e, a = _i(), l = Ee(!1), i = Ua(n, "modelValue"), s = Ua(n, "timezone"), u = Ee(null), c = Ee(null), g = Ee(null), p = Ee(!1), h = Ee(null), v = Ee(!1), A = Ee(!1), S = Ee(!1), b = Ee(!1), { setMenuFocused: T, setShiftKey: w } = tw(), { clearArrowNav: N } = Ol(), { validateDate: O, isValidTime: m } = Nl(n), {
      defaultedTransitions: _,
      defaultedTextInput: X,
      defaultedInline: $,
      defaultedConfig: E,
      defaultedRange: D,
      defaultedMultiDates: U
    } = Pr(n), { menuTransition: Y, showTransition: G } = xu(_), { isMobile: K } = sw(E), W = Tp();
    or(() => {
      B(n.modelValue), Kr().then(() => {
        $.value.enabled || (F(h.value)?.addEventListener("scroll", Ae), window?.addEventListener("resize", re));
      }), $.value.enabled && (l.value = !0), window?.addEventListener("keyup", ne), window?.addEventListener("keydown", Le);
    }), tn(() => {
      $.value.enabled || (F(h.value)?.removeEventListener("scroll", Ae), window?.removeEventListener("resize", re)), window?.removeEventListener("keyup", ne), window?.removeEventListener("keydown", Le);
    });
    const xe = an(a, "all", n.presetDates), Ce = an(a, "input");
    nt(
      [i, s],
      () => {
        B(i.value);
      },
      { deep: !0 }
    );
    const { openOnTop: Q, menuStyle: ue, xCorrect: V, setMenuPosition: ae, getScrollableParent: F, shadowRender: le } = uD({
      menuRef: u,
      menuRefInner: c,
      inputRef: g,
      pickerWrapperRef: h,
      inline: $,
      emit: o,
      props: n,
      slots: a
    }), {
      inputValue: te,
      internalModelValue: ie,
      parseExternalModelValue: B,
      emitModelValue: I,
      formatInputValue: ee,
      checkBeforeEmit: Se
    } = aN(o, n, { isInputFocused: p, isTextInputDate: b }), pe = ge(
      () => ({
        dp__main: !0,
        dp__theme_dark: n.dark,
        dp__theme_light: !n.dark,
        dp__flex_display: $.value.enabled,
        "dp--flex-display-collapsed": S.value,
        dp__flex_display_with_input: $.value.input
      })
    ), Ke = ge(() => n.dark ? "dp__theme_dark" : "dp__theme_light"), Oe = ge(() => n.teleport ? {
      to: typeof n.teleport == "boolean" ? "body" : n.teleport,
      disabled: !n.teleport || $.value.enabled
    } : {}), Be = ge(() => ({ class: "dp__outer_menu_wrap" })), j = ge(() => $.value.enabled && (n.timePicker || n.monthPicker || n.yearPicker || n.quarterPicker)), Qe = () => g.value?.$el?.getBoundingClientRect() ?? { width: 0, left: 0, right: 0 }, Ae = () => {
      l.value && (E.value.closeOnScroll ? Ge() : ae());
    }, re = () => {
      l.value && ae();
      const Xe = c.value?.$el.getBoundingClientRect().width ?? 0;
      S.value = document.body.offsetWidth <= Xe;
    }, ne = (Xe) => {
      Xe.key === "Tab" && !$.value.enabled && !n.teleport && E.value.tabOutClosesMenu && (h.value.contains(document.activeElement) || Ge()), A.value = Xe.shiftKey;
    }, Le = (Xe) => {
      A.value = Xe.shiftKey;
    }, He = () => {
      !n.disabled && !n.readonly && (le(W, B1, n), ae(!1), l.value = !0, l.value && o("open"), l.value || At(), B(n.modelValue));
    }, ze = () => {
      te.value = "", At(), c.value?.onValueCleared(), g.value?.setParsedDate(null), o("update:model-value", null), o("update:model-timezone-value", null), o("cleared"), E.value.closeOnClearValue && Ge();
    }, se = () => {
      const Xe = ie.value;
      return !Xe || !Array.isArray(Xe) && O(Xe) ? !0 : Array.isArray(Xe) ? U.value.enabled || Xe.length === 2 && O(Xe[0]) && O(Xe[1]) ? !0 : D.value.partialRange && !n.timePicker ? O(Xe[0]) : !1 : !1;
    }, Fe = () => {
      Se() && se() ? (I(), Ge()) : o("invalid-select", ie.value);
    }, qe = (Xe) => {
      ye(), I(), E.value.closeOnAutoApply && !Xe && Ge();
    }, ye = () => {
      g.value && X.value.enabled && g.value.setParsedDate(ie.value);
    }, Ne = (Xe = !1) => {
      n.autoApply && m(ie.value) && se() && (D.value.enabled && Array.isArray(ie.value) ? (D.value.partialRange || ie.value.length === 2) && qe(Xe) : qe(Xe));
    }, At = () => {
      X.value.enabled || (ie.value = null);
    }, Ge = (Xe = !1) => {
      Xe && ie.value && E.value.setDateOnMenuClose && Fe(), $.value.enabled || (l.value && (l.value = !1, V.value = !1, T(!1), w(!1), N(), o("closed"), te.value && B(i.value)), At(), o("blur"), c.value?.$el?.remove());
    }, Ie = (Xe, ut, mt = !1) => {
      if (!Xe) {
        ie.value = null;
        return;
      }
      const Dr = Array.isArray(Xe) ? !Xe.some((Uo) => !O(Uo)) : O(Xe), kr = m(Xe);
      Dr && kr ? (b.value = !0, ie.value = Xe, ut ? (v.value = mt, Fe(), o("text-submit")) : n.autoApply && Ne(!0), Kr().then(() => {
        b.value = !1;
      })) : o("invalid-date", Xe);
    }, Ze = () => {
      n.autoApply && m(ie.value) && I(), ye();
    }, et = () => l.value ? Ge() : He(), Lt = (Xe) => {
      ie.value = Xe;
    }, Ut = () => {
      X.value.enabled && (p.value = !0, ee()), o("focus");
    }, fr = () => {
      X.value.enabled && (p.value = !1, B(n.modelValue), v.value && E3(h.value, A.value)?.focus()), o("blur");
    }, xn = (Xe) => {
      c.value && c.value.updateMonthYear(0, {
        month: C1(Xe.month),
        year: C1(Xe.year)
      });
    }, Pa = (Xe) => {
      B(Xe ?? n.modelValue);
    }, ve = (Xe, ut) => {
      c.value?.switchView(Xe, ut);
    }, Ue = (Xe, ut) => E.value.onClickOutside ? E.value.onClickOutside(Xe, ut) : Ge(!0), tt = (Xe = 0) => {
      c.value?.handleFlow(Xe);
    }, St = () => u;
    return _D(
      u,
      g,
      (Xe) => Ue(se, Xe)
    ), t({
      closeMenu: Ge,
      selectDate: Fe,
      clearValue: ze,
      openMenu: He,
      onScroll: Ae,
      formatInputValue: ee,
      // exposed for testing purposes
      updateInternalModelValue: Lt,
      // modify internal modelValue
      setMonthYear: xn,
      parseModel: Pa,
      switchView: ve,
      toggleMenu: et,
      handleFlow: tt,
      getDpWrapMenuRef: St
    }), (Xe, ut) => (C(), k("div", {
      ref_key: "pickerWrapperRef",
      ref: h,
      class: $e(pe.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": R(K)
    }, [
      vt(SD, ht({
        ref_key: "inputRef",
        ref: g,
        "input-value": R(te),
        "onUpdate:inputValue": ut[0] || (ut[0] = (mt) => _c(te) ? te.value = mt : null),
        "is-menu-open": l.value
      }, Xe.$props, {
        onClear: ze,
        onOpen: He,
        onSetInputDate: Ie,
        onSetEmptyDate: R(I),
        onSelectDate: Fe,
        onToggle: et,
        onClose: Ge,
        onFocus: Ut,
        onBlur: fr,
        onRealBlur: ut[1] || (ut[1] = (mt) => p.value = !1),
        onTextInput: ut[2] || (ut[2] = (mt) => Xe.$emit("text-input", mt))
      }), so({ _: 2 }, [
        rt(R(Ce), (mt, Dr) => ({
          name: mt,
          fn: je((kr) => [
            be(Xe.$slots, mt, Er(fo(kr)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (C(), ft(nu(Xe.teleport ? _p : "div"), Er(fo(Oe.value)), {
        default: je(() => [
          vt(un, {
            name: R(Y)(R(Q)),
            css: R(G) && !R($).enabled
          }, {
            default: je(() => [
              l.value ? (C(), k("div", ht({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: u
              }, Be.value, {
                class: { "dp--menu-wrapper": !R($).enabled },
                style: R($).enabled ? void 0 : R(ue)
              }), [
                vt(B1, ht({
                  ref_key: "dpMenuRef",
                  ref: c
                }, Xe.$props, {
                  "internal-model-value": R(ie),
                  "onUpdate:internalModelValue": ut[3] || (ut[3] = (mt) => _c(ie) ? ie.value = mt : null),
                  class: { [Ke.value]: !0, "dp--menu-wrapper": Xe.teleport },
                  "open-on-top": R(Q),
                  "no-overlay-focus": j.value,
                  collapse: S.value,
                  "get-input-rect": Qe,
                  "is-text-input-date": b.value,
                  onClosePicker: Ge,
                  onSelectDate: Fe,
                  onAutoApply: Ne,
                  onTimeUpdate: Ze,
                  onFlowStep: ut[4] || (ut[4] = (mt) => Xe.$emit("flow-step", mt)),
                  onUpdateMonthYear: ut[5] || (ut[5] = (mt) => Xe.$emit("update-month-year", mt)),
                  onInvalidSelect: ut[6] || (ut[6] = (mt) => Xe.$emit("invalid-select", R(ie))),
                  onAutoApplyInvalid: ut[7] || (ut[7] = (mt) => Xe.$emit("invalid-select", mt)),
                  onInvalidFixedRange: ut[8] || (ut[8] = (mt) => Xe.$emit("invalid-fixed-range", mt)),
                  onRecalculatePosition: R(ae),
                  onTooltipOpen: ut[9] || (ut[9] = (mt) => Xe.$emit("tooltip-open", mt)),
                  onTooltipClose: ut[10] || (ut[10] = (mt) => Xe.$emit("tooltip-close", mt)),
                  onTimePickerOpen: ut[11] || (ut[11] = (mt) => Xe.$emit("time-picker-open", mt)),
                  onTimePickerClose: ut[12] || (ut[12] = (mt) => Xe.$emit("time-picker-close", mt)),
                  onAmPmChange: ut[13] || (ut[13] = (mt) => Xe.$emit("am-pm-change", mt)),
                  onRangeStart: ut[14] || (ut[14] = (mt) => Xe.$emit("range-start", mt)),
                  onRangeEnd: ut[15] || (ut[15] = (mt) => Xe.$emit("range-end", mt)),
                  onDateUpdate: ut[16] || (ut[16] = (mt) => Xe.$emit("date-update", mt)),
                  onInvalidDate: ut[17] || (ut[17] = (mt) => Xe.$emit("invalid-date", mt)),
                  onOverlayToggle: ut[18] || (ut[18] = (mt) => Xe.$emit("overlay-toggle", mt)),
                  onMenuBlur: ut[19] || (ut[19] = (mt) => Xe.$emit("blur"))
                }), so({ _: 2 }, [
                  rt(R(xe), (mt, Dr) => ({
                    name: mt,
                    fn: je((kr) => [
                      be(Xe.$slots, mt, Er(fo({ ...kr })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : q("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 10, TD));
  }
}), fi = /* @__PURE__ */ (() => {
  const e = AD;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), PD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fi
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(PD).forEach(([e, t]) => {
  e !== "default" && (fi[e] = t);
});
const MD = {
  key: 0,
  class: "pt-2"
}, $D = { class: "text-center my-3 mt-4" }, CD = { class: "form-separator" }, LD = {
  key: 0,
  class: "form-label tx-medium mb-0"
}, ED = {
  key: 0,
  class: "text-danger ms-1"
}, OD = {
  key: 1,
  class: "ms-auto me-1"
}, ND = { key: 0 }, DD = {
  key: 0,
  class: "input-group"
}, kD = {
  key: 0,
  class: "input-group-prepend"
}, GD = ["onClick"], BD = ["name", "placeholder", "disabled", "onUpdate:modelValue", "data-dd"], ID = {
  key: 1,
  class: "input-group-append"
}, RD = ["onClick"], FD = ["name", "placeholder", "disabled", "onUpdate:modelValue", "data-dd"], VD = ["name", "placeholder", "disabled", "onUpdate:modelValue"], HD = {
  key: 2,
  class: "input-group"
}, UD = ["type", "name", "placeholder", "disabled", "onUpdate:modelValue"], XD = ["onClick"], WD = ["name", "placeholder", "disabled", "onUpdate:modelValue", "onKeypress", "onPaste"], YD = ["name", "placeholder", "disabled", "onUpdate:modelValue", "onPaste"], KD = { key: 0 }, QD = {
  key: 0,
  class: "option-group-label"
}, jD = {
  key: 1,
  class: "text-danger option-disabled"
}, ZD = ["innerHTML"], zD = ["innerHTML"], qD = ["innerHTML"], JD = {
  key: 6,
  class: "custom-switch"
}, ek = ["name", "disabled", "checked", "onChange"], tk = { class: "ms-2 custom-switch-description" }, rk = {
  key: 7,
  class: "input-group"
}, ok = { class: "input-group-text p-0" }, nk = ["for"], ak = ["id", "name", "disabled"], lk = { class: "form-control border border-start-0 m-0 p-2" }, ik = { class: "custom-control custom-checkbox" }, sk = ["name", "disabled", "onUpdate:modelValue"], dk = { class: "custom-control-label" }, uk = {
  key: 11,
  class: "form-error"
}, ck = ["name", "disabled"], mk = /* @__PURE__ */ wt({
  __name: "FormGroup",
  props: {
    propsModel: {
      type: String,
      required: !0
    },
    propsBlade: {
      type: Object,
      required: !0
    },
    propsBladeInit: {
      type: Function,
      required: !0
    },
    propsFormAlign: {
      type: String,
      default: "column"
    },
    propsFormOption: {
      type: Object
    },
    propsInputChange: {
      type: Function
    },
    propsIsClear: {
      type: Boolean,
      default: !1
    },
    propsIsDisable: {
      type: Boolean,
      required: !0
    },
    propsIsEdit: {
      type: Boolean,
      required: !0
    },
    propsIsExcludeLabel: {
      type: Boolean,
      default: !1
    },
    propsIsViewOnly: {
      type: Boolean,
      default: !1
    },
    propsSelectOption: {
      type: Object
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  emits: ["onPostSubmit", "onFormInputUpdate", "onPostClear"],
  async setup(e, { emit: t }) {
    let r, o;
    const n = e, a = n.propsStore.user, l = n.propsStore.action, i = t, { response: s, forms: u } = om(l), { getDateSetting: c, getSelectAttributes: g, getSelectOptions: p, handleDecimalType: h, isAllowEmpty: v, isMultiSelect: A, isRequired: S } = v0(), b = n.propsBladeInit, T = dt({
      checkboxMap: {},
      isClearForm: n.propsIsClear,
      select: n.propsSelectOption
    }), w = dt({
      icon: b(),
      input: b(),
      error: b(),
      blade: n.propsBlade,
      draw: 0,
      file: {},
      reset: !1,
      isSubmit: !1
    });
    or(() => {
      for (let Q in n.propsBlade)
        if (w.input[Q] = n.propsBlade[Q].value, n.propsBlade[Q].type == "file" && ("attributes" in n.propsBlade[Q] && typeof n.propsBlade[Q].attributes == "object" && n.propsBlade[Q].attributes.filename ? w.file[Q] = n.propsBlade[Q].attributes.filename : w.file[Q] = "no_file_choosen"), n.propsBlade[Q].type == "password" && (w.icon[Q] = "fa-eye", n.propsBlade[Q].attributes.cType = "password"), n.propsBlade[Q].type === "checkbox") {
          const ue = n.propsBlade[Q]?.attributes?.options;
          if (ue)
            for (const V of Object.values(ue))
              w.input[V.key] = V.value, T.checkboxMap[V.key] = Q;
        }
    }), tn(() => {
      l.clearFormError();
    });
    const N = ([r, o] = ri(() => Yn("validator")), r = await r, o(), r), O = (Q) => {
      const ue = Q.target.id, V = Q.target.files ? Q.target.files[0] : null;
      if (!V) {
        K(ue);
        return;
      }
      const ae = V.size, F = V.name, le = V.name.split(".").shift(), te = Q.target.accept.split(","), ie = V.name.split(".").pop(), B = te.includes(`.${ie}`);
      console.debug(ae, ie, le, B), w.input[ue] = V, w.file[ue] = F, w.error[ue] = "";
    }, m = async (Q, ue) => {
      const V = ue.currentTarget, ae = V.checked, F = w.blade[Q].attributes;
      if (F && "preCheck" in F && F.preCheck instanceof Function) {
        const le = await F.preCheck(ae);
        w.input[Q] = le, V.checked = le;
        return;
      }
      w.input[Q] = ae, V.checked = ae;
    }, _ = (Q, ue) => typeof ue == "object" ? ue.cType : n.propsBlade[Q].type, X = (Q, ue) => {
      const V = ue.replace(`${n.propsModel}-`, "");
      if (w.blade[V].attributes?.multi) {
        n.propsBlade[V].value = w.input[V];
        return;
      }
      if ("isDisabled" in Q) {
        w.input[V] = n.propsBlade[V].value;
        return;
      }
      Kr(() => {
        const F = w.input[V];
        F.length > 1 ? F[0] && (w.input[V] = F[0]) : "isDisabled" in F && (w.input[V] = n.propsBlade[V].value), n.propsBlade[V].value = w.input[V];
      });
    }, $ = (Q, ue) => {
      const V = ue.replace(`${n.propsModel}-`, "");
      "isDisabled" in Q && (w.input[V] = n.propsBlade[V].value);
    }, E = (Q) => {
      n.propsBlade[Q].attributes.cType === "password" ? (n.propsBlade[Q].attributes.cType = "text", w.icon[Q] = "fa-eye-slash") : (n.propsBlade[Q].attributes.cType = "password", w.icon[Q] = "fa-eye");
    }, D = (Q, ue) => {
      const V = Q.target;
      Kr(() => {
        (ue === "decimal" && !ci(Q) || ue === "number" && !va(Q)) && (V.value = w.input[V.name] = "");
      });
    }, U = (Q) => typeof Q == "object" && "collapse" in Q ? Q.collapse : !0, Y = (Q) => typeof Q == "object" && "disabled" in Q ? w.isSubmit || Q.disabled : w.isSubmit, G = () => {
      Object.assign(w.input, b()), Object.assign(w.error, b()), K();
      for (let Q in w.input)
        if (n.propsBlade?.[Q]) {
          if (n.propsBlade[Q]?.type == "select") {
            let ue = document.querySelector(`input[name="${Q}"]`);
            ue && (ue.setAttribute("value", ""), ue.setAttribute("data-value", ""));
          }
          n.propsBlade[Q].value = "";
        }
      w.reset = !0;
    }, K = (Q) => {
      if (Q)
        w.input[Q] = "", w.file[Q] = "no_file_choosen";
      else
        for (let ue in w.file)
          w.input[ue] = "", w.file[ue] = "no_file_choosen", document.getElementById(ue).value = "";
    }, W = ge(() => n.propsFormAlign === "row"), xe = ge(() => Object.keys(w.blade).filter((Q) => !w.blade[Q].divClasses?.includes("d-none") && !w.blade[Q].type?.includes("hidden")).reduce((Q, ue) => {
      const V = w.blade[ue];
      return Q[ue] = n.propsIsViewOnly ? {
        ...V,
        attributes: {
          ...typeof V.attributes == "object" ? V.attributes : {},
          disabled: !0,
          readonly: !0
        }
      } : V, Q;
    }, {})), Ce = ge(() => Object.keys(w.blade).filter((Q) => w.blade[Q].type?.includes("hidden")).reduce((Q, ue) => Object.assign(Q, { [ue]: w.blade[ue] }), {}));
    return nt(() => ({ ...w.input }), async (Q, ue) => {
      if (w.reset) {
        Kr(() => {
          w.reset = !1;
        });
        return;
      }
      for (const V in Q) {
        if (Q[V] === ue[V]) continue;
        if (w.error[V] = "", a.getTestMode() && console.debug("watch", V, Q[V]), !(V in w.blade)) {
          console.debug("form.input watch not in blade", V);
          const te = T.checkboxMap[V];
          if (te && w.blade[te]?.type === "checkbox") {
            const B = n.propsBlade[te]?.attributes?.options?.find((I) => I.key === V);
            B && (B.value = w.input[V]);
          }
          continue;
        }
        const ae = w.blade[V], F = ae.attributes, le = Q[V];
        if (ae.type === "select") {
          const te = document.querySelector(`input[name="${V}"]`);
          te.setAttribute("data-type", "select");
          const ie = (B) => {
            te.setAttribute("value", B), te.setAttribute("data-value", B);
          };
          le ? Array.isArray(le) && le.length ? ie(JSON.stringify(le.map((B) => B?.code))) : Array.isArray(le) ? ie("") : ie(le.code) : ie("");
        }
        if (ae.type === "decimal" && F && "decimal" in F && String(le).includes(".")) {
          const [te, ie] = String(le).split(".");
          w.input[V] = `${te}.${ie.slice(0, F.decimal)}`;
        }
        if (ae.type === "number" && F && ("min" in F && (w.input[V] = le >= F.min ? le : ue[V]), "max" in F && (w.input[V] = w.input[V] <= F.max ? w.input[V] : ue[V])), ae.type === "text" && F && ("maxlength" in F && (w.input[V] = String(le).length <= F.maxlength ? le : ue[V]), "transform" in F && (w.input[V] = F.transform === "uppercase" ? String(w.input[V]).toUpperCase() : String(w.input[V]).toLowerCase())), ["datetime", "decimal", "number", "switch", "text", "textarea"].includes(ae.type) && (n.propsBlade[V].value = w.input[V]), "relation" in ae && n.propsInputChange instanceof Function)
          for (const te in ae.relation)
            n.propsInputChange(ae.relation[te], V, le);
        n.propsModel && await N({
          name: V,
          type: ae.type,
          value: le
        }, n.propsModel, { ...n.propsFormOption, data: w.input }), i("onFormInputUpdate", { formInput: w.input });
      }
    }), nt(() => [u.value.isError, u.value.id, u.value.error], ([Q, ue, V]) => {
      if (Q && ue === n.propsModel)
        for (const ae in V)
          w.error[ae] = V[ae];
    }), nt(
      () => [s.value.action, s.value.status, s.value.error, s.value.data],
      ([Q, ue, V, ae]) => {
        if (Q === n.propsModel) {
          if (ue)
            n.propsIsEdit || G(), w.error = b();
          else if (V && Object.keys(V).length) {
            Object.assign(w.error, b());
            for (const F in V)
              w.error[F] = V[F][0];
          }
          w.isSubmit = !1, i("onPostSubmit", {
            isSubmit: !1,
            status: ue,
            resp: ae,
            isError: Object.values(w.error).some((F) => F !== "")
          });
        }
      }
    ), nt(() => [n.propsIsDisable, n.propsIsClear], ([Q, ue]) => {
      w.isSubmit = Q, T.isClearForm = ue;
    }), nt(() => n.propsBlade, (Q) => {
      for (let ue in Q)
        if (["datetime", "decimal", "number", "select", "switch", "text", "textarea"].includes(Q[ue].type) && (w.input[ue] = Q[ue].value), ["file"].includes(Q[ue].type) && typeof Q[ue].attributes == "object" && "filename" in Q[ue].attributes && (w.file[ue] = Q[ue].attributes.filename, w.draw++), ["checkbox"].includes(Q[ue].type)) {
          const V = Q[ue]?.attributes?.options;
          if (V)
            for (const ae of Object.values(V))
              w.input[ae.key] = ae.value;
        }
    }, { deep: !0 }), nt(() => [T.isClearForm], (Q) => {
      Q[0] && (G(), i("onPostClear", { isClear: Q[0] }));
    }), (Q, ue) => (C(), k(De, null, [
      (C(!0), k(De, null, rt(xe.value, (V, ae) => (C(), k("span", {
        class: $e(V.divClasses ? V.divClasses : "col-md-12"),
        key: ae
      }, [
        V.type == "separator" ? (C(), k(De, { key: 0 }, [
          V.label !== " " ? (C(), k("div", MD, [
            L("div", $D, [
              L("h5", CD, [
                L("span", null, _e(Q.$t(V.label)), 1)
              ])
            ])
          ])) : q("", !0)
        ], 64)) : (C(), k("div", {
          key: 1,
          class: $e(["form-group", { "form-row": W.value }])
        }, [
          !e.propsIsExcludeLabel && V.label ? (C(), k("label", LD, [
            V.label !== " " ? (C(), k(De, { key: 0 }, [
              Gt(_e(Q.$t(V.label)) + " ", 1),
              R(S)(V.attributes) ? (C(), k("span", ED, "*")) : q("", !0),
              W.value ? (C(), k("span", OD, ":")) : q("", !0)
            ], 64)) : (C(), k(De, { key: 1 }, [
              R($o)(R(a)) ? q("", !0) : (C(), k("span", ND, _e(V.label), 1))
            ], 64))
          ])) : q("", !0),
          L("span", {
            class: $e([{ "form-input": W.value }])
          }, [
            V.type == "text" ? (C(), k(De, { key: 0 }, [
              "group" in V ? (C(), k("div", DD, [
                V.group?.align === "left" ? (C(), k("span", kD, [
                  L("button", {
                    type: "button",
                    class: $e(V.group?.classes),
                    onClick: (F) => "action" in V.group ? V.group?.action() : null
                  }, [
                    L("i", {
                      class: $e(V.group?.icon)
                    }, null, 2)
                  ], 10, GD)
                ])) : q("", !0),
                Qt(L("input", ht({
                  type: "text",
                  name: ae,
                  class: ["form-control", V.classes],
                  placeholder: V.placeholder ? Q.$t(V.placeholder) : ""
                }, { ref_for: !0 }, V.attributes, {
                  disabled: Y(V.attributes),
                  "onUpdate:modelValue": (F) => w.input[ae] = F,
                  "data-dd": w.input[ae]
                }), null, 16, BD), [
                  [Io, w.input[ae]]
                ]),
                V.group?.align === "right" ? (C(), k("span", ID, [
                  L("button", {
                    type: "button",
                    class: $e(V.group?.classes),
                    onClick: (F) => "action" in V.group ? V.group?.action() : null
                  }, [
                    L("i", {
                      class: $e(V.group?.icon)
                    }, null, 2)
                  ], 10, RD)
                ])) : q("", !0)
              ])) : Qt((C(), k("input", ht({
                key: 1,
                type: "text",
                name: ae,
                class: ["form-control", V.classes],
                placeholder: V.placeholder ? Q.$t(V.placeholder) : ""
              }, { ref_for: !0 }, V.attributes, {
                disabled: Y(V.attributes),
                "onUpdate:modelValue": (F) => w.input[ae] = F,
                "data-dd": w.input[ae]
              }), null, 16, FD)), [
                [Io, w.input[ae]]
              ])
            ], 64)) : q("", !0),
            V.type == "textarea" ? Qt((C(), k("textarea", ht({
              key: 1,
              name: ae,
              class: ["form-control", V.classes],
              placeholder: V.placeholder ? Q.$t(V.placeholder) : ""
            }, { ref_for: !0 }, V.attributes, {
              disabled: Y(V.attributes),
              "onUpdate:modelValue": (F) => w.input[ae] = F
            }), "                        ", 16, VD)), [
              [Io, w.input[ae]]
            ]) : q("", !0),
            V.type == "password" ? (C(), k("div", HD, [
              Qt(L("input", ht({
                type: _(ae, V.attributes),
                name: ae,
                class: ["form-control", V.classes],
                placeholder: V.placeholder ? Q.$t(V.placeholder) : ""
              }, { ref_for: !0 }, V.attributes, {
                disabled: Y(V.attributes),
                "onUpdate:modelValue": (F) => w.input[ae] = F
              }), null, 16, UD), [
                [rA, w.input[ae]]
              ]),
              L("span", {
                class: "input-group-text",
                onClick: (F) => E(ae)
              }, [
                L("i", {
                  class: $e(["far c-pointer", w.icon[ae]])
                }, null, 2)
              ], 8, XD)
            ])) : q("", !0),
            V.type == "decimal" ? Qt((C(), k("input", ht({
              key: 3,
              type: "text",
              name: ae,
              class: ["form-control", V.classes],
              placeholder: V.placeholder ? Q.$t(V.placeholder) : ""
            }, { ref_for: !0 }, V.attributes, {
              disabled: Y(V.attributes),
              "onUpdate:modelValue": (F) => w.input[ae] = F,
              onKeypress: (F) => R(h)(V.attributes, F),
              onPaste: (F) => D(F, V.type)
            }), null, 16, WD)), [
              [Io, w.input[ae]]
            ]) : q("", !0),
            V.type == "number" ? Qt((C(), k("input", ht({
              key: 4,
              type: "text",
              name: ae,
              class: ["form-control", V.classes],
              placeholder: V.placeholder ? Q.$t(V.placeholder) : ""
            }, { ref_for: !0 }, V.attributes, {
              disabled: Y(V.attributes),
              "onUpdate:modelValue": (F) => w.input[ae] = F,
              onKeypress: ue[0] || (ue[0] = //@ts-ignore
              (...F) => R(va) && R(va)(...F)),
              onPaste: (F) => D(F, V.type)
            }), null, 16, YD)), [
              [Io, w.input[ae]]
            ]) : q("", !0),
            V.type == "select" ? (C(), ft(R(Wa), ht({
              key: 5,
              id: e.propsModel + "-" + ae,
              name: ae
            }, { ref_for: !0 }, R(g)(V.attributes), {
              placeholder: Q.$t("select_option"),
              selectLabel: Q.$t("select_press_add"),
              deselectLabel: Q.$t("select_press_remove"),
              selectedLabel: Q.$t("selected"),
              multiple: R(A)(V.attributes),
              "close-on-select": !R(A)(V.attributes),
              disabled: Y(V.attributes),
              "allow-empty": R(v)(V.attributes),
              modelValue: w.input[ae],
              "onUpdate:modelValue": (F) => w.input[ae] = F,
              options: R(p)(T.select[ae].options, V.attributes),
              onSelect: X,
              onRemove: $
            }), {
              option: je(({ option: F }) => [
                U(V.attributes) ? (C(), k("div", KD, [
                  F.$isLabel ? (C(), k("div", QD, _e(F.$groupLabel), 1)) : q("", !0),
                  F.isDisabled ? (C(), k("div", jD, _e(F.name), 1)) : (C(), k("div", {
                    key: 2,
                    innerHTML: F.name
                  }, null, 8, ZD))
                ])) : q("", !0)
              ]),
              selection: je(({ values: F, search: le, isOpen: te }) => [
                F.length && U(V.attributes) ? Qt((C(), k("span", {
                  key: 0,
                  class: "multiselect__single",
                  innerHTML: Q.$t("selected_options").replace("n ", `${F.length} `)
                }, null, 8, zD)), [
                  [An, !te]
                ]) : q("", !0)
              ]),
              singleLabel: je(({ option: F }) => [
                U(V.attributes) ? (C(), k("span", {
                  key: 0,
                  innerHTML: F.name
                }, null, 8, qD)) : q("", !0)
              ]),
              noOptions: je(() => [
                Gt(_e(Q.$t("option_empty")), 1)
              ]),
              noResult: je(() => [
                Gt(_e(Q.$t("option_no_result")), 1)
              ]),
              _: 2
            }, 1040, ["id", "name", "placeholder", "selectLabel", "deselectLabel", "selectedLabel", "multiple", "close-on-select", "disabled", "allow-empty", "modelValue", "onUpdate:modelValue", "options"])) : q("", !0),
            V.type == "switch" ? (C(), k("label", JD, [
              L("input", {
                type: "checkbox",
                name: ae,
                class: $e(["custom-switch-input", V.classes]),
                disabled: Y(V.attributes),
                checked: w.input[ae] === !0,
                onChange: (F) => m(ae, F)
              }, null, 42, ek),
              ue[2] || (ue[2] = L("span", { class: "custom-switch-indicator" }, null, -1)),
              L("span", tk, _e(Q.$t(V.attributes?.checkboxLabel)), 1)
            ])) : q("", !0),
            V.type == "file" ? (C(), k("div", rk, [
              L("div", ok, [
                L("label", {
                  for: ae,
                  class: "btn btn-icon-text m-0"
                }, _e(Q.$t("choose_file")), 9, nk)
              ]),
              L("input", ht({
                type: "file",
                id: ae,
                name: ae,
                class: "form-control d-none"
              }, { ref_for: !0 }, V.attributes, {
                disabled: Y(V.attributes),
                onChange: ue[1] || (ue[1] = (F) => O(F))
              }), null, 16, ak),
              L("label", lk, _e(w.file[ae] && w.draw === 0 ? Q.$t(w.file[ae]) : w.file[ae]), 1)
            ])) : q("", !0),
            V.type == "datetime" ? (C(), ft(R(fi), ht({
              key: 8,
              name: ae
            }, { ref_for: !0 }, R(c)(V.attributes), {
              placeholder: V.placeholder ? Q.$t(V.placeholder) : "",
              disabled: Y(V.attributes),
              modelValue: w.input[ae],
              "onUpdate:modelValue": (F) => w.input[ae] = F
            }), null, 16, ["name", "placeholder", "disabled", "modelValue", "onUpdate:modelValue"])) : q("", !0),
            V.type == "checkbox" ? (C(), k("span", {
              key: 9,
              class: $e([{ "row row-sm form-checkbox": V.attributes?.display == "x-axis" }])
            }, [
              (C(!0), k(De, null, rt(V.attributes?.options, (F) => (C(), k("div", {
                class: $e(V.classes),
                key: F.key
              }, [
                L("label", ik, [
                  Qt(L("input", {
                    type: "checkbox",
                    name: F.key,
                    class: "custom-control-input",
                    disabled: Y(V.attributes),
                    "onUpdate:modelValue": (le) => w.input[F.key] = le
                  }, null, 8, sk), [
                    [Mp, w.input[F.key]]
                  ]),
                  L("span", dk, _e(Q.$t(F.label)), 1)
                ])
              ], 2))), 128))
            ], 2)) : q("", !0),
            V.attributes?.rNote ? (C(), k(De, { key: 10 }, [
              L("small", {
                class: $e(V.attributes.rNote.classes)
              }, _e(V.attributes.rNote.text), 3),
              ue[3] || (ue[3] = L("br", null, null, -1))
            ], 64)) : q("", !0),
            w.error[ae] ? (C(), k("small", uk, _e(w.error[ae]), 1)) : q("", !0)
          ], 2)
        ], 2))
      ], 2))), 128)),
      (C(!0), k(De, null, rt(Ce.value, (V, ae) => (C(), k("input", ht({
        key: ae,
        type: "hidden",
        name: ae
      }, { ref_for: !0 }, V.attributes, {
        disabled: Y(V.attributes)
      }), null, 16, ck))), 128))
    ], 64));
  }
}), _m = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [o, n] of t)
    r[o] = n;
  return r;
}, I0 = /* @__PURE__ */ _m(mk, [["__scopeId", "data-v-695eaff2"]]), gk = () => {
  const e = Ee(null), t = Ee(null), r = dt({
    fPostDragEnd: {},
    tableForm: {}
  });
  return {
    draggingIdx: e,
    dragOverIdx: t,
    initTRowDrag: async (u) => {
      r.fPostDragEnd = "fDragEnd" in u ? u.fDragEnd : {}, r.tableForm = "tForm" in u ? u.tForm : {};
    },
    onDragStart: (u) => {
      e.value = u;
    },
    onDragOver: (u, c) => {
      if (u.preventDefault(), e.value === null || e.value === c) return;
      const g = Object.entries(r.tableForm.input), [p] = g.splice(e.value, 1);
      g.splice(c, 0, p);
      const h = {};
      g.forEach(([v, A], S) => {
        h[S] = A;
      }), r.tableForm.input = h, e.value = c;
    },
    onDragLeave: () => {
      t.value = null;
    },
    onDrop: (u) => {
      e.value = null, t.value = null;
    },
    onDragEnd: () => {
      e.value = null, t.value = null, r.fPostDragEnd();
    }
  };
}, fk = { class: "row row-sm" }, pk = { class: "col-md-12" }, hk = {
  key: 0,
  class: "tx-medium me-auto table-form-label"
}, xk = ["disabled"], vk = ["disabled"], Sk = { class: "table text-nowrap text-md-nowrap table-bordered mg-b-0" }, bk = ["width", "innerHTML"], yk = ["data-id", "draggable", "onDragstart", "onDragover", "onDrop"], wk = {
  key: 0,
  class: "row-select"
}, _k = {
  key: 0,
  class: "custom-control custom-checkbox"
}, Tk = ["checked", "onClick"], Ak = { key: 1 }, Pk = ["name", "placeholder", "disabled", "onUpdate:modelValue"], Mk = {
  key: 0,
  class: "form-error"
}, $k = { key: 2 }, Ck = ["name", "placeholder", "disabled", "onUpdate:modelValue", "onKeypress", "onPaste"], Lk = {
  key: 0,
  class: "form-error"
}, Ek = { key: 3 }, Ok = ["name", "placeholder", "disabled", "onUpdate:modelValue", "onPaste"], Nk = {
  key: 0,
  class: "form-error"
}, Dk = { key: 4 }, kk = {
  key: 0,
  class: "form-error"
}, Gk = { key: 5 }, Bk = {
  key: 0,
  class: "form-error"
}, Ik = {
  key: 6,
  class: "row-switch"
}, Rk = { class: "form-check form-switch" }, Fk = { class: "custom-switch" }, Vk = ["name", "disabled", "onUpdate:modelValue"], Hk = { class: "ms-2 custom-switch-description" }, Uk = { key: 0 }, Xk = ["width"], Wk = ["width"], T0e = /* @__PURE__ */ wt({
  __name: "FormListGroup",
  props: {
    propsBlade: {
      type: Object,
      required: !0
    },
    propsBladeInit: {
      type: Function,
      required: !0
    },
    propsData: {
      type: Object
    },
    propsFormId: {
      type: String,
      required: !0
    },
    propsFormOption: {
      type: Object,
      required: !0
    },
    propsGetSelectOption: {
      type: Function
    },
    propsInputChange: {
      type: Function
    },
    propsIsDeleteAble: {
      type: Boolean,
      default: !0
    },
    propsIsDragAble: {
      type: Boolean,
      default: !1
    },
    propsIsEdit: {
      type: Boolean,
      required: !0
    },
    propsIsEditAble: {
      type: Boolean,
      required: !0
    },
    propsIsFooter: {
      type: Boolean,
      default: !1
    },
    propsIsReset: {
      type: Boolean,
      default: !1
    },
    propsIsSubmit: {
      type: Boolean,
      default: !1
    },
    propsIsViewOnly: {
      type: Boolean,
      default: !1
    },
    propsMaxRecord: {
      type: Number,
      required: !0
    },
    propsSelectOption: {
      type: Object,
      default: {}
    },
    propsStore: {
      type: Object,
      required: !0
    },
    propsTitle: {
      type: String,
      default: ""
    }
  },
  emits: ["onPostFormListDragEnd", "onPostFormListReset", "setFormErrorStatus", "setFormListData"],
  async setup(e, { emit: t }) {
    let r, o;
    const n = e, a = t, l = n.propsStore.user, { getSelectAttributes: i, handleDecimalType: s, isDisabled: u } = v0(), { draggingIdx: c, initTRowDrag: g, onDragStart: p, onDragOver: h, onDragLeave: v, onDrop: A, onDragEnd: S } = gk(), b = n.propsBladeInit, T = dt({
      dateSettings: {
        "auto-apply": !1,
        "auto-range": 0,
        "enable-seconds": !0,
        "enable-time-picker": !1,
        flow: [],
        // 'flow': ['month', 'year', 'calendar'],
        format: "yyyy-MM-dd",
        "min-date": "",
        "max-date": "",
        "model-type": "yyyy-MM-dd",
        "month-picker": !1,
        "multi-calendars": !1,
        "multi-dates": !1,
        // 'prevent-min-max-navigation': true,
        position: "center",
        range: !1,
        "text-input": !0,
        "time-picker": !1,
        "time-picker-inline": !0,
        vertical: !1,
        "week-picker": !1,
        "year-picker": !1
      },
      isBegin: !1,
      relationSelect: {},
      select: n.propsSelectOption,
      selected: [],
      totalRecords: 0
    }), w = dt({
      input: {},
      error: {},
      blade: n.propsBlade,
      reset: !1,
      isError: !1,
      isSubmit: !1
    });
    Nn(() => {
      n.propsIsEdit ? K(n.propsData) : n.propsData && En(n.propsData) ? U() : K(n.propsData), n.propsIsDragAble && g({
        tForm: w,
        fDragEnd: V
      });
    });
    const N = ([r, o] = ri(() => Yn("validator")), r = await r, o(), r), O = (ie, B, I) => {
      const ee = B?.attributes;
      if (typeof ee == "object" && "group-select" in ee && ee["group-select"]) {
        var Se = [];
        const Oe = T.select[ie].options.reduce((Be, j) => {
          Se.includes(j.group) || Se.push(j.group);
          const Qe = Be[j.group] || [];
          return Qe.push(j), Be[j.group] = Qe, Be;
        }, {});
        return Se.sort().map((Be) => ({
          title: Be,
          options: Oe[Be]
        }));
      }
      const pe = String(I), Ke = T.relationSelect[pe]?.[ie];
      return Ke || (T.select[ie].options ?? []);
    }, m = (ie, B) => {
      if (typeof B == "object" && "is-fixed" in B && B["is-fixed"]) {
        for (const I in B["is-fixed"])
          for (const ee in B["is-fixed"][I])
            if (ie[I] == B["is-fixed"][I][ee])
              return !0;
      }
      return !1;
    }, _ = (ie, B) => {
      const I = (ee) => {
        if (ee == null || ee === "") return null;
        const Se = Number(String(ee).replace(/,/g, ""));
        return Number.isFinite(Se) ? Se : null;
      };
      if (B.type == "sum") {
        const ee = te.value.reduce((Ke, Oe) => {
          const Be = I(Oe[ie]);
          return Ke + (Be ?? 0);
        }, 0), Se = B.classes?.match(/decimal-(\d+)/), pe = Se ? Number(Se[1]) : 0;
        return ee.toFixed(pe);
      }
      return B.type == "count" ? te.value.filter((ee) => I(ee[ie]) !== null).length : "";
    }, X = (ie, B) => {
      let I = { ...ie };
      if (typeof B == "object")
        for (let ee in B)
          ee in I && (I[ee] = B[ee]), "enable-time-picker" in B && B["enable-time-picker"] && (I.format = "yyyy-MM-dd HH:mm:ss");
      return I;
    }, $ = () => {
      const ie = le.value;
      let B = [];
      for (let I in ie)
        w.blade[ie[I]].type === "order" && B.push(ie[I]);
      return B;
    }, E = (ie) => T.selected.includes(ie), D = (ie) => {
      if (n.propsIsEditAble)
        switch (ie) {
          case "add":
            U();
            break;
          case "del":
            G();
            break;
        }
    }, U = () => {
      if (T.totalRecords != n.propsMaxRecord && (T.totalRecords++, T.totalRecords <= n.propsMaxRecord)) {
        const ie = $();
        for (let B = T.totalRecords - 1; B < T.totalRecords; B++)
          w.input[B] = { ...b() }, w.error[B] = { ...b() }, ie.length && ie.forEach((I) => {
            w.input[B][I] = B + 1;
          });
      }
    }, Y = (ie) => {
      T.selected.includes(ie) ? T.selected = T.selected.filter(function(B) {
        return B != ie;
      }) : T.selected.push(ie);
    }, G = () => {
      if (!T.selected.length)
        return;
      const ie = $();
      let B = {}, I = 0;
      for (const ee in w.input)
        T.selected.includes(Number(ee)) || (B[I] = w.input[ee], ie.length && ie.forEach((Se) => {
          B[I][Se] = I + 1;
        }), I++);
      T.selected = [], w.input = B, T.totalRecords = I, T.totalRecords === 0 && U();
    }, K = (ie) => {
      if (ie)
        if (T.totalRecords = ie.length || 0, T.totalRecords && T.totalRecords <= n.propsMaxRecord)
          for (let B = 0; B < T.totalRecords; B++) {
            let I = Object.keys(T.select), ee = ie[B];
            w.input[B] = b(), w.error[B] = b();
            for (let Se in ee)
              if (Se in w.input[B])
                if (I.includes(Se))
                  for (let pe in T.select[Se].options)
                    "code" in T.select[Se].options[pe] && T.select[Se].options[pe].code == ee[Se] && (w.input[B][Se] = T.select[Se].options[pe]);
                else
                  w.input[B][Se] = ee[Se];
          }
        else
          U();
    }, W = () => {
      w.input = {}, K(n.propsData), a("onPostFormListReset", !0);
    }, xe = async (ie, B) => {
      const [I, ee] = B.replace(/^ms-/, "").split("-", 2), Se = F.value[ee];
      if (!Se)
        return;
      const pe = T.relationSelect[I] ??= {};
      if (ae(I, ee), !(!ie || !Se.relation?.length) && n.propsGetSelectOption instanceof Function)
        for (const Ke of Se.relation)
          Ke && (pe[Ke] = await n.propsGetSelectOption(Ke, ie));
    }, Ce = async (ie, B) => {
      const I = document.getElementsByClassName("table-form"), ee = `.multiselect[data-id="${ie}"]`, Se = document.querySelector(ee);
      await Kr();
      const pe = Se?.querySelector(".multiselect__content-wrapper");
      if (!Se || !pe)
        return;
      I.length && I[0].classList.toggle("open");
      const Ke = () => {
        const Oe = Se.getBoundingClientRect();
        pe.style.position = "fixed", pe.style.zIndex = "9999", pe.style.left = `${Oe.left}px`, pe.style.top = `${Oe.bottom}px`, pe.style.width = `${Oe.width}px`;
      };
      B ? (Ke(), window.addEventListener("scroll", Ke, !0)) : ["position", "z-index", "left", "top", "width"].forEach((Oe) => pe.style.removeProperty(Oe));
    }, Q = (ie, B) => {
      const I = ie.target.name, Se = document.getElementsByName(`${I}`)[0];
      setTimeout(() => {
        B == "decimal" && !ci(ie) && (Se.value = w.input[Se.name] = ""), B == "number" && !va(ie) && (Se.value = w.input[Se.name] = "");
      }, 1);
    }, ue = async (ie, B, I) => {
      const ee = n.propsFormOption;
      let Se = await N({
        name: B,
        type: w.blade[B].type,
        value: I
      }, ee.action, ee);
      Se.status || setTimeout(() => {
        w.isError = !0, a("setFormErrorStatus", w.isError), ie in w.error && B in w.error[ie] && (w.error[ie][B] = Se.error[B]);
      }, 100);
    }, V = () => {
      a("onPostFormListDragEnd", w.input);
    }, ae = async (ie, B) => {
      const I = F.value[B];
      if (!I?.relation?.length)
        return;
      const ee = T.relationSelect[ie] ??= {};
      for (const Se of I.relation)
        Se && (w.input[ie][Se] = "", ee[Se] = [], ae(ie, Se));
    }, F = ge(() => Object.keys(n.propsBlade).filter((ie) => !n.propsBlade[ie].exclude).reduce((ie, B) => {
      const I = w.blade[B];
      return ie[B] = n.propsIsViewOnly ? {
        ...I,
        attributes: {
          ...typeof I.attributes == "object" ? I.attributes : {},
          disabled: !0,
          readonly: !0
        }
      } : I, ie;
    }, {})), le = ge(() => Object.keys(n.propsBlade)), te = ge(() => Object.keys(w.input).map(Number).sort((ie, B) => ie - B).map((ie) => w.input[ie]));
    return nt(() => ({ ...w.input }), (ie, B) => {
      if (w.isError = !1, a("setFormErrorStatus", w.isError), !T.isBegin) {
        T.isBegin = !0;
        return;
      }
      for (let I in ie)
        for (let ee in ie[I])
          ee in ie[I] && !["id"].includes(ee) && (w.error[I][ee] = "", ue(Number(I), ee, ie[I][ee]));
    }, { deep: !0 }), nt(() => n.propsIsReset, (ie, B) => {
      ie && W();
    }, { deep: !0 }), nt(() => n.propsIsSubmit, (ie, B) => {
      ie && (a("setFormListData", n.propsFormId, w.input), T.isBegin = !1);
    }, { deep: !0 }), (ie, B) => (C(), k("div", fk, [
      L("span", pk, [
        L("div", {
          class: $e(["d-flex align-items-end d-grid gap-1", { "justify-content-end": !e.propsTitle }])
        }, [
          e.propsTitle ? (C(), k("label", hk, _e(e.propsTitle), 1)) : q("", !0),
          e.propsIsViewOnly ? q("", !0) : (C(), k(De, { key: 1 }, [
            L("a", {
              href: "javascript:void(0)",
              class: $e(["btn btn-outline-success btn-icon-text my-2", { disabled: w.isSubmit || T.totalRecords == e.propsMaxRecord }]),
              onClick: B[0] || (B[0] = (I) => D("add")),
              disabled: w.isSubmit || T.totalRecords == e.propsMaxRecord
            }, [
              B[7] || (B[7] = L("i", { class: "far fa-plus-square me-1" }, null, -1)),
              Gt(_e(ie.$t("add")), 1)
            ], 10, xk),
            e.propsIsDeleteAble ? (C(), k("a", {
              key: 0,
              href: "javascript:void(0)",
              class: $e(["btn btn-outline-danger btn-icon-text my-2", { disabled: w.isSubmit || !T.selected.length }]),
              onClick: B[1] || (B[1] = (I) => D("del")),
              disabled: w.isSubmit || !T.selected.length
            }, [
              B[8] || (B[8] = L("i", { class: "far fa-minus-square me-1" }, null, -1)),
              Gt(_e(ie.$t("delete")), 1)
            ], 10, vk)) : q("", !0)
          ], 64)),
          be(ie.$slots, "custom-btn")
        ], 2),
        L("div", {
          class: $e(["table-form", { "table-responsive": R(l).getDeviceMode() == "mobile" }])
        }, [
          L("table", Sk, [
            L("thead", null, [
              L("tr", null, [
                (C(!0), k(De, null, rt(F.value, (I, ee) => (C(), k("th", {
                  key: ee,
                  width: I.width,
                  innerHTML: I.label ? ie.$t(I.label) : ""
                }, null, 8, bk))), 128))
              ])
            ]),
            L("tbody", null, [
              (C(!0), k(De, null, rt(te.value, (I, ee) => (C(), k("tr", {
                key: I.id,
                "data-id": ee,
                draggable: e.propsIsDragAble,
                onDragstart: (Se) => e.propsIsDragAble ? R(p)(ee) : null,
                onDragover: (Se) => e.propsIsDragAble ? R(h)(Se, ee) : null,
                onDragleave: B[5] || (B[5] = (Se) => e.propsIsDragAble ? R(v)() : null),
                onDrop: (Se) => e.propsIsDragAble ? R(A)(ee) : null,
                onDragend: B[6] || (B[6] = (Se) => e.propsIsDragAble ? R(S)() : null),
                class: $e({ dragging: R(c) === ee, draggable: e.propsIsDragAble })
              }, [
                (C(!0), k(De, null, rt(F.value, (Se, pe) => (C(), k(De, { key: pe }, [
                  Se.type == "" && e.propsIsEditAble ? (C(), k("td", wk, [
                    e.propsIsViewOnly ? q("", !0) : (C(), k("label", _k, [
                      L("input", {
                        type: "checkbox",
                        class: "custom-control-input",
                        checked: E(ee),
                        onClick: (Ke) => Y(ee)
                      }, null, 8, Tk),
                      B[9] || (B[9] = L("span", { class: "custom-control-label" }, null, -1))
                    ]))
                  ])) : q("", !0),
                  Se.type == "text" || Se.type == "order" ? (C(), k("td", Ak, [
                    Qt(L("input", ht({
                      type: "text",
                      name: pe,
                      class: ["form-control", Se.classes ? Se.classes : ""],
                      placeholder: Se.placeholder ? ie.$t(Se.placeholder) : ""
                    }, { ref_for: !0 }, Se?.attributes, {
                      disabled: R(u)(Se?.attributes, w.isSubmit),
                      "onUpdate:modelValue": (Ke) => I[pe] = Ke
                    }), null, 16, Pk), [
                      [Io, I[pe]]
                    ]),
                    w.error[ee][pe] ? (C(), k("small", Mk, _e(w.error[ee][pe]), 1)) : q("", !0)
                  ])) : q("", !0),
                  Se.type == "decimal" ? (C(), k("td", $k, [
                    Qt(L("input", ht({
                      type: "text",
                      name: pe,
                      class: ["form-control", Se.classes ? Se.classes : ""],
                      placeholder: Se.placeholder ? ie.$t(Se.placeholder) : ""
                    }, { ref_for: !0 }, Se?.attributes, {
                      disabled: R(u)(Se?.attributes, w.isSubmit),
                      "onUpdate:modelValue": (Ke) => I[pe] = Ke,
                      onKeypress: (Ke) => R(s)(Se.attributes, Ke),
                      onPaste: (Ke) => Q(Ke, Se.type)
                    }), null, 16, Ck), [
                      [Io, I[pe]]
                    ]),
                    w.error[ee][pe] ? (C(), k("small", Lk, _e(w.error[ee][pe]), 1)) : q("", !0)
                  ])) : q("", !0),
                  Se.type == "number" ? (C(), k("td", Ek, [
                    Qt(L("input", ht({
                      type: "text",
                      name: pe,
                      class: ["form-control", Se.classes ? Se.classes : ""],
                      placeholder: Se.placeholder ? ie.$t(Se.placeholder) : ""
                    }, { ref_for: !0 }, Se?.attributes, {
                      disabled: R(u)(Se?.attributes, w.isSubmit),
                      "onUpdate:modelValue": (Ke) => I[pe] = Ke,
                      onKeypress: B[2] || (B[2] = //@ts-ignore
                      (...Ke) => R(va) && R(va)(...Ke)),
                      onPaste: (Ke) => Q(Ke, Se.type)
                    }), null, 16, Ok), [
                      [Io, I[pe]]
                    ]),
                    w.error[ee][pe] ? (C(), k("small", Nk, _e(w.error[ee][pe]), 1)) : q("", !0)
                  ])) : q("", !0),
                  Se.type == "select" ? (C(), k("td", Dk, [
                    vt(R(Wa), ht({
                      name: pe
                    }, { ref_for: !0 }, R(i)(Se?.attributes), {
                      placeholder: ie.$t("select_option"),
                      disabled: R(u)(Se?.attributes, w.isSubmit) || m(I, Se?.attributes),
                      modelValue: I[pe],
                      "onUpdate:modelValue": (Ke) => I[pe] = Ke,
                      options: O(pe, Se, ee),
                      id: `ms-${ee}-${pe}`,
                      "data-id": `ms-${ee}-${pe}`,
                      onOpen: B[3] || (B[3] = (Ke) => Ce(Ke, !0)),
                      onClose: B[4] || (B[4] = (Ke, Oe) => Ce(Oe, !1)),
                      onSelect: xe
                    }), {
                      noOptions: je(() => [
                        Gt(_e(ie.$t("option_empty")), 1)
                      ]),
                      noResult: je(() => [
                        Gt(_e(ie.$t("option_no_result")), 1)
                      ]),
                      _: 1
                    }, 16, ["name", "placeholder", "disabled", "modelValue", "onUpdate:modelValue", "options", "id", "data-id"]),
                    w.error[ee][pe] ? (C(), k("small", kk, _e(w.error[ee][pe]), 1)) : q("", !0)
                  ])) : q("", !0),
                  Se.type == "datetime" ? (C(), k("td", Gk, [
                    vt(R(fi), ht({
                      name: pe
                    }, { ref_for: !0 }, X(T.dateSettings, Se?.attributes), {
                      placeholder: Se.placeholder ? ie.$t(Se.placeholder) : "",
                      disabled: R(u)(Se?.attributes, w.isSubmit) || m(I, Se?.attributes),
                      modelValue: I[pe],
                      "onUpdate:modelValue": (Ke) => I[pe] = Ke
                    }), null, 16, ["name", "placeholder", "disabled", "modelValue", "onUpdate:modelValue"]),
                    w.error[ee][pe] ? (C(), k("small", Bk, _e(w.error[ee][pe]), 1)) : q("", !0)
                  ])) : q("", !0),
                  Se.type == "switch" ? (C(), k("td", Ik, [
                    L("div", Rk, [
                      L("label", Fk, [
                        Qt(L("input", ht({
                          type: "checkbox",
                          name: pe,
                          class: ["custom-switch-input", Se.classes ? Se.classes : ""]
                        }, { ref_for: !0 }, Se?.attributes, {
                          disabled: R(u)(Se?.attributes, w.isSubmit),
                          "onUpdate:modelValue": (Ke) => I[pe] = Ke
                        }), null, 16, Vk), [
                          [Mp, I[pe]]
                        ]),
                        B[10] || (B[10] = L("span", { class: "custom-switch-indicator" }, null, -1)),
                        L("span", Hk, _e(ie.$t("allow")), 1)
                      ])
                    ])
                  ])) : q("", !0)
                ], 64))), 128))
              ], 42, yk))), 128))
            ]),
            e.propsIsFooter ? (C(), k("tfoot", Uk, [
              (C(!0), k(De, null, rt(F.value, (I, ee) => (C(), k(De, {
                key: `footer-${ee}`
              }, [
                "summary" in I ? (C(), k("td", {
                  key: 0,
                  width: I.width,
                  class: $e(["table-form-footer", I.summary.classes])
                }, [
                  L("strong", null, _e(_(ee, I.summary)), 1)
                ], 10, Xk)) : (C(), k("td", {
                  key: 1,
                  width: I.width,
                  class: "table-form-footer"
                }, null, 8, Wk))
              ], 64))), 128))
            ])) : q("", !0)
          ])
        ], 2)
      ])
    ]));
  }
}), Yk = {
  class: /* @__PURE__ */ $e(["card-body", "shimmer"])
}, Kk = { class: "row row-sm" }, Qk = /* @__PURE__ */ wt({
  __name: "FormSkeleton",
  props: {
    propsBlade: {
      type: Object,
      required: !0
    },
    propsBladeInit: {
      type: Function,
      required: !0
    },
    propsButton: {
      type: Array,
      default: [
        "btn-primary"
      ]
    },
    propsCustomBlade: {
      type: Object,
      default: {}
    },
    propsFormAlign: {
      type: String,
      default: "column"
    },
    propsIsEdit: {
      type: Boolean,
      required: !0
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = dt({
      keys: {},
      select: {}
    }), o = dt({
      action: "",
      blade: {},
      id: "skeletonForm"
    });
    Nn(() => {
      let l = 0, i = {}, s = { ...t.propsBlade, ...t.propsCustomBlade };
      s = JSON.parse(JSON.stringify(s));
      for (let u in s) {
        const c = `loading${l++}`;
        o.blade[c] = s[u], o.blade[c].label = "table.loadingRecords", o.blade[c].placeholder = "table.loadingRecords", o.blade[c].type == "select" && (r.select[c] = {
          options: []
        }), o.blade[c].type == "switch" ? o.blade[c].attributes = {
          disabled: !0,
          checkboxLabel: "table.loadingRecords"
        } : o.blade[c].attributes = {
          disabled: !0
        }, i[c] = "";
      }
      r.keys = i;
    });
    const n = () => r.keys, a = ge(() => t.propsFormAlign === "column" ? "justify-content-end" : "justify-content-center");
    return (l, i) => (C(), k(De, null, [
      be(l.$slots, "header"),
      L("div", Yk, [
        be(l.$slots, "top-skeleton"),
        L("div", Kk, [
          vt(I0, {
            "props-blade": o.blade,
            "props-blade-init": n,
            "props-form-align": e.propsFormAlign,
            "props-form-option": {},
            "props-is-disable": !0,
            "props-is-edit": e.propsIsEdit,
            "props-model": o.action,
            "props-select-option": r.select,
            "props-store": e.propsStore
          }, null, 8, ["props-blade", "props-form-align", "props-is-edit", "props-model", "props-select-option", "props-store"])
        ]),
        be(l.$slots, "btm-skeleton")
      ]),
      e.propsButton.length ? (C(), k("div", {
        key: 0,
        class: $e(["card-footer d-grid gap-1 d-flex mb-1", a.value])
      }, [
        (C(!0), k(De, null, rt(e.propsButton, (s, u) => (C(), k("span", {
          key: u,
          href: "javascript:void(0)",
          class: $e(["btn", s])
        }, _e(l.$t("table.loadingRecords")), 3))), 128))
      ], 2)) : q("", !0)
    ], 64));
  }
}), jk = {}, Zk = {
  href: "javascript:history.back();",
  class: "btn ripple btn-outline-light btn-sm"
};
function zk(e, t) {
  return C(), k("strong", null, [
    L("a", Zk, [
      t[0] || (t[0] = L("i", { class: "fas fa-arrow-left pe-1" }, null, -1)),
      Gt(_e(e.$t("back")), 1)
    ])
  ]);
}
const qk = /* @__PURE__ */ _m(jk, [["render", zk]]), Jk = { class: "breadcrumb-wrap" }, eG = { class: "main-content-title tx-20 text-uppercase mg-b-5" }, tG = { class: "breadcrumb" }, rG = {
  key: 0,
  class: "breadcrumb-item"
}, oG = ["innerHTML"], nG = {
  key: 2,
  class: "breadcrumb-item active",
  "aria-current": "page"
}, aG = ["innerHTML"], dw = /* @__PURE__ */ wt({
  __name: "Breadcrumb",
  props: {
    propsBreadcrumb: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = (a) => /<[^>]+>/.test(a), o = ge(() => t.propsBreadcrumb.action), n = ge(() => t.propsBreadcrumb?.custom ?? "");
    return (a, l) => (C(), k("div", Jk, [
      L("h2", eG, _e(a.$t(t.propsBreadcrumb.title)), 1),
      L("ol", tG, [
        l[0] || (l[0] = L("li", { class: "breadcrumb-item" }, [
          L("a", { href: "javascript:void(0)" }, [
            L("i", { class: "fas fa-home" })
          ])
        ], -1)),
        t.propsBreadcrumb.parent ? (C(), k("li", rG, _e(a.$t(t.propsBreadcrumb.parent)), 1)) : q("", !0),
        r(o.value) ? (C(), k("li", {
          key: 1,
          class: "breadcrumb-item active",
          "aria-current": "page",
          innerHTML: o.value
        }, null, 8, oG)) : (C(), k("li", nG, _e(a.$t(o.value)), 1)),
        n.value ? (C(!0), k(De, { key: 3 }, rt(n.value, (i, s) => (C(), k("li", {
          key: s,
          class: "breadcrumb-item custom",
          innerHTML: i
        }, null, 8, aG))), 128)) : q("", !0)
      ])
    ]));
  }
}), lG = { class: "main-content side-content pt-0" }, iG = { class: "main-container container-fluid" }, sG = { class: "inner-body" }, dG = { class: "page-header" }, uG = {
  key: 0,
  class: "form-wrapper"
}, cG = { class: "row row-sm" }, mG = { class: "col-md-12 col-lg-12" }, gG = { class: "card custom-card" }, fG = {
  key: 0,
  class: "form-wrapper"
}, pG = { class: "row row-sm" }, hG = { class: "col-md-12 col-lg-12" }, xG = { class: "card custom-card" }, vG = /* @__PURE__ */ wt({
  __name: "FormWrapper",
  props: {
    propsBreadcrumb: {
      type: Object,
      required: !0
    },
    propsBlade: {
      type: Object,
      required: !0
    },
    propsBladeInit: {
      type: Function,
      required: !0
    },
    propsButton: {
      type: Array,
      default: [
        "btn-primary"
      ]
    },
    propsCustomBlade: {
      type: Object,
      default: {}
    },
    propsFormAlign: {
      type: String,
      default: "column"
    },
    propsIsEdit: {
      type: Boolean,
      required: !0
    },
    propsLoading: {
      type: Boolean,
      required: !0
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, r) => (C(), k("div", lG, [
      L("div", iG, [
        L("div", sG, [
          L("div", dG, [
            vt(dw, { "props-breadcrumb": e.propsBreadcrumb }, null, 8, ["props-breadcrumb"]),
            vt(qk)
          ]),
          vt(un, { name: "form-inout" }, {
            default: je(() => [
              e.propsLoading ? (C(), k("div", uG, [
                L("div", cG, [
                  L("div", mG, [
                    L("div", gG, [
                      vt(Qk, {
                        "props-blade": e.propsBlade,
                        "props-blade-init": e.propsBladeInit,
                        "props-button": e.propsButton,
                        "props-custom-blade": e.propsCustomBlade,
                        "props-form-align": e.propsFormAlign,
                        "props-is-edit": e.propsIsEdit,
                        "props-store": e.propsStore
                      }, {
                        header: je(() => [
                          be(t.$slots, "header-skeleton")
                        ]),
                        "top-skeleton": je(() => [
                          be(t.$slots, "top-skeleton")
                        ]),
                        "btm-skeleton": je(() => [
                          be(t.$slots, "btm-skeleton")
                        ]),
                        _: 3
                      }, 8, ["props-blade", "props-blade-init", "props-button", "props-custom-blade", "props-form-align", "props-is-edit", "props-store"])
                    ])
                  ])
                ]),
                be(t.$slots, "custom-card-skeleton")
              ])) : q("", !0)
            ]),
            _: 3
          }),
          vt(un, { name: "form-inout" }, {
            default: je(() => [
              e.propsLoading ? q("", !0) : (C(), k("div", fG, [
                L("div", pG, [
                  L("div", hG, [
                    L("div", xG, [
                      r[0] || (r[0] = L("template", null, null, -1)),
                      be(t.$slots, "header"),
                      be(t.$slots, "form")
                    ])
                  ])
                ]),
                be(t.$slots, "custom-card")
              ]))
            ]),
            _: 3
          })
        ])
      ])
    ]));
  }
});
const Zn = typeof window < "u";
let ln, pi;
if (process.env.NODE_ENV !== "production") {
  const e = Zn && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (ln = (t) => {
    e.mark(t);
  }, pi = (t, r, o) => {
    e.measure(t, r, o), e.clearMarks(r), e.clearMarks(o);
  });
}
const SG = /\{([0-9a-zA-Z]+)\}/g;
function Tm(e, ...t) {
  return t.length === 1 && Bt(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(SG, (r, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const Aa = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), bG = (e, t, r) => yG({ l: e, k: t, s: r }), yG = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Xr = (e) => typeof e == "number" && isFinite(e);
function Cl(e, t) {
  return Je(t) || Xr(t) ? `${e}:${t}` : e;
}
const uw = (e) => F0(e) === "[object Date]", Us = (e) => F0(e) === "[object RegExp]", R0 = (e) => rr(e) && Object.keys(e).length === 0, oo = Object.assign, wG = Object.create, mr = (e = null) => wG(e);
let I1;
const Am = () => I1 || (I1 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : mr()), _G = Object.prototype.hasOwnProperty;
function Mn(e, t) {
  return _G.call(e, t);
}
const vr = Array.isArray, xr = (e) => typeof e == "function", Je = (e) => typeof e == "string", Wt = (e) => typeof e == "boolean", Bt = (e) => e !== null && typeof e == "object", TG = (e) => Bt(e) && xr(e.then) && xr(e.catch), cw = Object.prototype.toString, F0 = (e) => cw.call(e), rr = (e) => F0(e) === "[object Object]", AG = (e) => e == null ? "" : vr(e) || rr(e) && e.toString === cw ? JSON.stringify(e, null, 2) : String(e);
function V0(e, t = "") {
  return e.reduce((r, o, n) => n === 0 ? r + o : r + t + o, "");
}
const R1 = 2;
function PG(e, t = 0, r = e.length) {
  const o = e.split(/\r?\n/);
  let n = 0;
  const a = [];
  for (let l = 0; l < o.length; l++)
    if (n += o[l].length + 1, n >= t) {
      for (let i = l - R1; i <= l + R1 || r > n; i++) {
        if (i < 0 || i >= o.length)
          continue;
        const s = i + 1;
        a.push(`${s}${" ".repeat(3 - String(s).length)}|  ${o[i]}`);
        const u = o[i].length;
        if (i === l) {
          const c = t - (n - u) + 1, g = Math.max(1, r > n ? u - c : r - t);
          a.push("   |  " + " ".repeat(c) + "^".repeat(g));
        } else if (i > l) {
          if (r > n) {
            const c = Math.max(Math.min(r - n, u), 1);
            a.push("   |  " + "^".repeat(c));
          }
          n += u + 1;
        }
      }
      break;
    }
  return a.join(`
`);
}
function ya(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const F1 = {};
function H0(e) {
  F1[e] || (F1[e] = !0, ya(e));
}
function V1(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function MG(e) {
  return e.replace(/&(?![a-z0-9#]{2,6};)/gi, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const $G = /^javascript:/i, CG = /^(?:href|src|action|formaction)$/i, LG = /&#(?:x([0-9a-f]+)|(\d+));?/gi, EG = /&(?:Tab|NewLine);/g, OG = /&colon;?/gi, NG = /[\u0000-\u0020\u007f-\u009f]/g, DG = /(?:^|[\s"'<>/])on\w+\s*=\s*["']?[^"'>]+["']?/i, kG = /(^|[\s"'<>/])on(\w+\s*=)/gi, GG = /(^|[\s"'<>/])((?:href|src|action|formaction)\s*=\s*)([^\s"'=<>`]+)/gi;
function BG(e, t, r) {
  const o = t || r;
  if (!o)
    return e;
  const n = Number.parseInt(o, t ? 16 : 10);
  return n <= 127 ? String.fromCharCode(n) : e;
}
function U0(e) {
  const t = e.replace(LG, BG).replace(EG, "").replace(OG, ":").replace(NG, "");
  return $G.test(t);
}
function IG(e) {
  const t = /url\s*\(/gi;
  let r = "", o = 0, n;
  for (; (n = t.exec(e)) !== null; ) {
    const a = n.index, l = t.lastIndex - 1;
    let i = l + 1, s = 1, u = null;
    for (; i < e.length; i++) {
      const p = e[i];
      if (u) {
        p === u && (u = null);
        continue;
      }
      if (p === '"' || p === "'")
        u = p;
      else if (p === "(")
        s++;
      else if (p === ")" && (s--, s === 0))
        break;
    }
    if (s !== 0)
      break;
    const c = e.slice(l + 1, i).trim(), g = c.startsWith('"') && c.endsWith('"') || c.startsWith("'") && c.endsWith("'") ? c.slice(1, -1).trim() : c;
    r += e.slice(o, a), r += U0(g) ? "url(about:blank)" : e.slice(a, i + 1), o = i + 1;
  }
  return r + e.slice(o);
}
function H1(e, t) {
  if (CG.test(e) && U0(t))
    return "about:blank";
  const r = e.toLowerCase() === "style" ? IG(t) : t;
  return MG(r);
}
function RG(e) {
  return e = e.replace(/([\w:-]+)\s*=\s*"([^"]*)"/g, (t, r, o) => `${r}="${H1(r, o)}"`), e = e.replace(/([\w:-]+)\s*=\s*'([^']*)'/g, (t, r, o) => `${r}='${H1(r, o)}'`), DG.test(e) && (process.env.NODE_ENV !== "production" && ya("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(kG, "$1&#111;n$2")), e = e.replace(GG, (t, r, o, n) => U0(n) ? `${r}${o}about:blank` : t), e;
}
function Pm() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(r, o) {
      const n = e.get(r);
      n && n.push(o) || e.set(r, [o]);
    },
    off(r, o) {
      const n = e.get(r);
      n && n.splice(n.indexOf(o) >>> 0, 1);
    },
    emit(r, o) {
      (e.get(r) || []).slice().map((n) => n(o)), (e.get("*") || []).slice().map((n) => n(r, o));
    }
  };
}
const U1 = (e) => !Bt(e) || vr(e);
function xc(e, t) {
  if (U1(e) || U1(t))
    throw new Error("Invalid value");
  const r = [{ src: e, des: t }];
  for (; r.length; ) {
    const { src: o, des: n } = r.pop();
    Object.keys(o).forEach((a) => {
      if (a === "__proto__")
        return;
      const l = o[a];
      if (vr(l)) {
        const i = [];
        i.length = l.length, n[a] = i, r.push({ src: l, des: i });
      } else Bt(l) ? ((!Bt(n[a]) || vr(n[a])) && (n[a] = mr()), r.push({ src: l, des: n[a] })) : n[a] = l;
    });
  }
}
function FG(e, t, r) {
  return { line: e, column: t, offset: r };
}
function zf(e, t, r) {
  return { start: e, end: t };
}
const _t = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, VG = 17, HG = {
  // tokenizer error messages
  [_t.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [_t.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [_t.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [_t.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [_t.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [_t.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [_t.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [_t.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [_t.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [_t.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [_t.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [_t.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [_t.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [_t.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [_t.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [_t.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function id(e, t, r = {}) {
  const { domain: o, messages: n, args: a } = r, l = process.env.NODE_ENV !== "production" ? Tm((n || HG)[e] || "", ...a || []) : e, i = new SyntaxError(String(l));
  return i.code = e, t && (i.location = t), i.domain = o, i;
}
function UG(e) {
  throw e;
}
const XG = /<\/?[\w\s="/.':;#-\/]+>/, WG = (e) => XG.test(e), sa = " ", YG = "\r", To = `
`, KG = "\u2028", QG = "\u2029";
function jG(e) {
  const t = e;
  let r = 0, o = 1, n = 1, a = 0;
  const l = (_) => t[_] === YG && t[_ + 1] === To, i = (_) => t[_] === To, s = (_) => t[_] === QG, u = (_) => t[_] === KG, c = (_) => l(_) || i(_) || s(_) || u(_), g = () => r, p = () => o, h = () => n, v = () => a, A = (_) => l(_) || s(_) || u(_) ? To : t[_], S = () => A(r), b = () => A(r + a);
  function T() {
    return a = 0, c(r) && (o++, n = 0), l(r) && r++, r++, n++, t[r];
  }
  function w() {
    return l(r + a) && a++, a++, t[r + a];
  }
  function N() {
    r = 0, o = 1, n = 1, a = 0;
  }
  function O(_ = 0) {
    a = _;
  }
  function m() {
    const _ = r + a;
    for (; _ !== r; )
      T();
    a = 0;
  }
  return {
    index: g,
    line: p,
    column: h,
    peekOffset: v,
    charAt: A,
    currentChar: S,
    currentPeek: b,
    next: T,
    peek: w,
    reset: N,
    resetPeek: O,
    skipToPeek: m
  };
}
const Da = void 0, ZG = ".", X1 = "'", zG = "tokenizer";
function qG(e, t = {}) {
  const r = t.location !== !1, o = jG(e), n = () => o.index(), a = () => FG(o.line(), o.column(), o.index()), l = a(), i = n(), s = {
    currentType: 13,
    offset: i,
    startLoc: l,
    endLoc: l,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: l,
    lastEndLoc: l,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, u = () => s, { onError: c } = t;
  function g(re, ne, Le, ...He) {
    const ze = u();
    if (ne.column += Le, ne.offset += Le, c) {
      const se = r ? zf(ze.startLoc, ne) : null, Fe = id(re, se, {
        domain: zG,
        args: He
      });
      c(Fe);
    }
  }
  function p(re, ne, Le) {
    re.endLoc = a(), re.currentType = ne;
    const He = { type: ne };
    return r && (He.loc = zf(re.startLoc, re.endLoc)), Le != null && (He.value = Le), He;
  }
  const h = (re) => p(
    re,
    13
    /* TokenTypes.EOF */
  );
  function v(re, ne) {
    return re.currentChar() === ne ? (re.next(), ne) : (g(_t.EXPECTED_TOKEN, a(), 0, ne), "");
  }
  function A(re) {
    let ne = "";
    for (; re.currentPeek() === sa || re.currentPeek() === To; )
      ne += re.currentPeek(), re.peek();
    return ne;
  }
  function S(re) {
    const ne = A(re);
    return re.skipToPeek(), ne;
  }
  function b(re) {
    if (re === Da)
      return !1;
    const ne = re.charCodeAt(0);
    return ne >= 97 && ne <= 122 || // a-z
    ne >= 65 && ne <= 90 || // A-Z
    ne === 95;
  }
  function T(re) {
    if (re === Da)
      return !1;
    const ne = re.charCodeAt(0);
    return ne >= 48 && ne <= 57;
  }
  function w(re, ne) {
    const { currentType: Le } = ne;
    if (Le !== 2)
      return !1;
    A(re);
    const He = b(re.currentPeek());
    return re.resetPeek(), He;
  }
  function N(re, ne) {
    const { currentType: Le } = ne;
    if (Le !== 2)
      return !1;
    A(re);
    const He = re.currentPeek() === "-" ? re.peek() : re.currentPeek(), ze = T(He);
    return re.resetPeek(), ze;
  }
  function O(re, ne) {
    const { currentType: Le } = ne;
    if (Le !== 2)
      return !1;
    A(re);
    const He = re.currentPeek() === X1;
    return re.resetPeek(), He;
  }
  function m(re, ne) {
    const { currentType: Le } = ne;
    if (Le !== 7)
      return !1;
    A(re);
    const He = re.currentPeek() === ".";
    return re.resetPeek(), He;
  }
  function _(re, ne) {
    const { currentType: Le } = ne;
    if (Le !== 8)
      return !1;
    A(re);
    const He = b(re.currentPeek());
    return re.resetPeek(), He;
  }
  function X(re, ne) {
    const { currentType: Le } = ne;
    if (!(Le === 7 || Le === 11))
      return !1;
    A(re);
    const He = re.currentPeek() === ":";
    return re.resetPeek(), He;
  }
  function $(re, ne) {
    const { currentType: Le } = ne;
    if (Le !== 9)
      return !1;
    const He = () => {
      const se = re.currentPeek();
      return se === "{" ? b(re.peek()) : se === "@" || se === "|" || se === ":" || se === "." || se === sa || !se ? !1 : se === To ? (re.peek(), He()) : D(re, !1);
    }, ze = He();
    return re.resetPeek(), ze;
  }
  function E(re) {
    A(re);
    const ne = re.currentPeek() === "|";
    return re.resetPeek(), ne;
  }
  function D(re, ne = !0) {
    const Le = (ze = !1, se = "") => {
      const Fe = re.currentPeek();
      return Fe === "{" || Fe === "@" || !Fe ? ze : Fe === "|" ? !(se === sa || se === To) : Fe === sa ? (re.peek(), Le(!0, sa)) : Fe === To ? (re.peek(), Le(!0, To)) : !0;
    }, He = Le();
    return ne && re.resetPeek(), He;
  }
  function U(re, ne) {
    const Le = re.currentChar();
    return Le === Da ? Da : ne(Le) ? (re.next(), Le) : null;
  }
  function Y(re) {
    const ne = re.charCodeAt(0);
    return ne >= 97 && ne <= 122 || // a-z
    ne >= 65 && ne <= 90 || // A-Z
    ne >= 48 && ne <= 57 || // 0-9
    ne === 95 || // _
    ne === 36;
  }
  function G(re) {
    return U(re, Y);
  }
  function K(re) {
    const ne = re.charCodeAt(0);
    return ne >= 97 && ne <= 122 || // a-z
    ne >= 65 && ne <= 90 || // A-Z
    ne >= 48 && ne <= 57 || // 0-9
    ne === 95 || // _
    ne === 36 || // $
    ne === 45;
  }
  function W(re) {
    return U(re, K);
  }
  function xe(re) {
    const ne = re.charCodeAt(0);
    return ne >= 48 && ne <= 57;
  }
  function Ce(re) {
    return U(re, xe);
  }
  function Q(re) {
    const ne = re.charCodeAt(0);
    return ne >= 48 && ne <= 57 || // 0-9
    ne >= 65 && ne <= 70 || // A-F
    ne >= 97 && ne <= 102;
  }
  function ue(re) {
    return U(re, Q);
  }
  function V(re) {
    let ne = "", Le = "";
    for (; ne = Ce(re); )
      Le += ne;
    return Le;
  }
  function ae(re) {
    let ne = "";
    for (; ; ) {
      const Le = re.currentChar();
      if (Le === "\\") {
        const He = re.peek();
        He === "{" || He === "}" || He === "@" || He === "|" || He === "\\" ? (ne += Le + He, re.next(), re.next()) : (re.resetPeek(), ne += Le, re.next());
      } else {
        if (Le === "{" || Le === "}" || Le === "@" || Le === "|" || !Le)
          break;
        if (Le === sa || Le === To)
          if (D(re))
            ne += Le, re.next();
          else {
            if (E(re))
              break;
            ne += Le, re.next();
          }
        else
          ne += Le, re.next();
      }
    }
    return ne;
  }
  function F(re) {
    S(re);
    let ne = "", Le = "";
    for (; ne = W(re); )
      Le += ne;
    const He = re.currentChar();
    if (He && He !== "}" && He !== Da && He !== sa && He !== To && He !== "　") {
      const ze = Se(re);
      return g(_t.INVALID_TOKEN_IN_PLACEHOLDER, a(), 0, Le + ze), Le + ze;
    }
    return re.currentChar() === Da && g(_t.UNTERMINATED_CLOSING_BRACE, a(), 0), Le;
  }
  function le(re) {
    S(re);
    let ne = "";
    return re.currentChar() === "-" ? (re.next(), ne += `-${V(re)}`) : ne += V(re), re.currentChar() === Da && g(_t.UNTERMINATED_CLOSING_BRACE, a(), 0), ne;
  }
  function te(re) {
    return re !== X1 && re !== To;
  }
  function ie(re) {
    S(re), v(re, "'");
    let ne = "", Le = "";
    for (; ne = U(re, te); )
      ne === "\\" ? Le += B(re) : Le += ne;
    const He = re.currentChar();
    return He === To || He === Da ? (g(_t.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, a(), 0), He === To && (re.next(), v(re, "'")), Le) : (v(re, "'"), Le);
  }
  function B(re) {
    const ne = re.currentChar();
    switch (ne) {
      case "\\":
      case "'":
        return re.next(), `\\${ne}`;
      case "u":
        return I(re, ne, 4);
      case "U":
        return I(re, ne, 6);
      default:
        return g(_t.UNKNOWN_ESCAPE_SEQUENCE, a(), 0, ne), "";
    }
  }
  function I(re, ne, Le) {
    v(re, ne);
    let He = "";
    for (let ze = 0; ze < Le; ze++) {
      const se = ue(re);
      if (!se) {
        g(_t.INVALID_UNICODE_ESCAPE_SEQUENCE, a(), 0, `\\${ne}${He}${re.currentChar()}`);
        break;
      }
      He += se;
    }
    return `\\${ne}${He}`;
  }
  function ee(re) {
    return re !== "{" && re !== "}" && re !== sa && re !== To;
  }
  function Se(re) {
    S(re);
    let ne = "", Le = "";
    for (; ne = U(re, ee); )
      Le += ne;
    return Le;
  }
  function pe(re) {
    let ne = "", Le = "";
    for (; ne = G(re); )
      Le += ne;
    return Le;
  }
  function Ke(re) {
    const ne = (Le) => {
      const He = re.currentChar();
      return He === "{" || He === "@" || He === "|" || He === "(" || He === ")" || !He || He === sa ? Le : (Le += He, re.next(), ne(Le));
    };
    return ne("");
  }
  function Oe(re) {
    S(re);
    const ne = v(
      re,
      "|"
      /* TokenChars.Pipe */
    );
    return S(re), ne;
  }
  function Be(re, ne) {
    let Le = null;
    switch (re.currentChar()) {
      case "{":
        return ne.braceNest >= 1 && g(_t.NOT_ALLOW_NEST_PLACEHOLDER, a(), 0), re.next(), Le = p(
          ne,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), S(re), ne.braceNest++, Le;
      case "}":
        return ne.braceNest > 0 && ne.currentType === 2 && g(_t.EMPTY_PLACEHOLDER, a(), 0), re.next(), Le = p(
          ne,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), ne.braceNest--, ne.braceNest > 0 && S(re), ne.inLinked && ne.braceNest === 0 && (ne.inLinked = !1), Le;
      case "@":
        return ne.braceNest > 0 && g(_t.UNTERMINATED_CLOSING_BRACE, a(), 0), Le = j(re, ne) || h(ne), ne.braceNest = 0, Le;
      default: {
        let ze = !0, se = !0, Fe = !0;
        if (E(re))
          return ne.braceNest > 0 && g(_t.UNTERMINATED_CLOSING_BRACE, a(), 0), Le = p(ne, 1, Oe(re)), ne.braceNest = 0, ne.inLinked = !1, Le;
        if (ne.braceNest > 0 && (ne.currentType === 4 || ne.currentType === 5 || ne.currentType === 6))
          return g(_t.UNTERMINATED_CLOSING_BRACE, a(), 0), ne.braceNest = 0, Qe(re, ne);
        if (ze = w(re, ne))
          return Le = p(ne, 4, F(re)), S(re), Le;
        if (se = N(re, ne))
          return Le = p(ne, 5, le(re)), S(re), Le;
        if (Fe = O(re, ne))
          return Le = p(ne, 6, ie(re)), S(re), Le;
        if (!ze && !se && !Fe)
          return Le = p(ne, 12, Se(re)), g(_t.INVALID_TOKEN_IN_PLACEHOLDER, a(), 0, Le.value), S(re), Le;
        break;
      }
    }
    return Le;
  }
  function j(re, ne) {
    const { currentType: Le } = ne;
    let He = null;
    const ze = re.currentChar();
    switch ((Le === 7 || Le === 8 || Le === 11 || Le === 9) && (ze === To || ze === sa) && g(_t.INVALID_LINKED_FORMAT, a(), 0), ze) {
      case "@":
        return re.next(), He = p(
          ne,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), ne.inLinked = !0, He;
      case ".":
        return S(re), re.next(), p(
          ne,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return S(re), re.next(), p(
          ne,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return E(re) ? (He = p(ne, 1, Oe(re)), ne.braceNest = 0, ne.inLinked = !1, He) : m(re, ne) || X(re, ne) ? (S(re), j(re, ne)) : _(re, ne) ? (S(re), p(ne, 11, pe(re))) : $(re, ne) ? (S(re), ze === "{" ? Be(re, ne) || He : p(ne, 10, Ke(re))) : (Le === 7 && g(_t.INVALID_LINKED_FORMAT, a(), 0), ne.braceNest = 0, ne.inLinked = !1, Qe(re, ne));
    }
  }
  function Qe(re, ne) {
    let Le = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (ne.braceNest > 0)
      return Be(re, ne) || h(ne);
    if (ne.inLinked)
      return j(re, ne) || h(ne);
    switch (re.currentChar()) {
      case "{":
        return Be(re, ne) || h(ne);
      case "}":
        return g(_t.UNBALANCED_CLOSING_BRACE, a(), 0), re.next(), p(
          ne,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return j(re, ne) || h(ne);
      default: {
        if (E(re))
          return Le = p(ne, 1, Oe(re)), ne.braceNest = 0, ne.inLinked = !1, Le;
        if (D(re))
          return p(ne, 0, ae(re));
        break;
      }
    }
    return Le;
  }
  function Ae() {
    const { currentType: re, offset: ne, startLoc: Le, endLoc: He } = s;
    return s.lastType = re, s.lastOffset = ne, s.lastStartLoc = Le, s.lastEndLoc = He, s.offset = n(), s.startLoc = a(), o.currentChar() === Da ? p(
      s,
      13
      /* TokenTypes.EOF */
    ) : Qe(o, s);
  }
  return {
    nextToken: Ae,
    currentOffset: n,
    currentPosition: a,
    context: u
  };
}
const JG = "parser", eB = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g, tB = /\\([\\@{}|])/g;
function rB(e, t) {
  return t;
}
function oB(e, t, r) {
  switch (e) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || r, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function nB(e = {}) {
  const t = e.location !== !1, { onError: r } = e;
  function o(b, T, w, N, ...O) {
    const m = b.currentPosition();
    if (m.offset += N, m.column += N, r) {
      const _ = t ? zf(w, m) : null, X = id(T, _, {
        domain: JG,
        args: O
      });
      r(X);
    }
  }
  function n(b, T, w) {
    const N = { type: b };
    return t && (N.start = T, N.end = T, N.loc = { start: w, end: w }), N;
  }
  function a(b, T, w, N) {
    t && (b.end = T, b.loc && (b.loc.end = w));
  }
  function l(b, T) {
    const w = b.context(), N = n(3, w.offset, w.startLoc);
    return N.value = T.replace(tB, rB), a(N, b.currentOffset(), b.currentPosition()), N;
  }
  function i(b, T) {
    const w = b.context(), { lastOffset: N, lastStartLoc: O } = w, m = n(5, N, O);
    return m.index = parseInt(T, 10), b.nextToken(), a(m, b.currentOffset(), b.currentPosition()), m;
  }
  function s(b, T) {
    const w = b.context(), { lastOffset: N, lastStartLoc: O } = w, m = n(4, N, O);
    return m.key = T, b.nextToken(), a(m, b.currentOffset(), b.currentPosition()), m;
  }
  function u(b, T) {
    const w = b.context(), { lastOffset: N, lastStartLoc: O } = w, m = n(9, N, O);
    return m.value = T.replace(eB, oB), b.nextToken(), a(m, b.currentOffset(), b.currentPosition()), m;
  }
  function c(b) {
    const T = b.nextToken(), w = b.context(), { lastOffset: N, lastStartLoc: O } = w, m = n(8, N, O);
    return T.type !== 11 ? (o(b, _t.UNEXPECTED_EMPTY_LINKED_MODIFIER, w.lastStartLoc, 0), m.value = "", a(m, N, O), {
      nextConsumeToken: T,
      node: m
    }) : (T.value == null && o(b, _t.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, da(T)), m.value = T.value || "", a(m, b.currentOffset(), b.currentPosition()), {
      node: m
    });
  }
  function g(b, T) {
    const w = b.context(), N = n(7, w.offset, w.startLoc);
    return N.value = T, a(N, b.currentOffset(), b.currentPosition()), N;
  }
  function p(b) {
    const T = b.context(), w = n(6, T.offset, T.startLoc);
    let N = b.nextToken();
    if (N.type === 8) {
      const O = c(b);
      w.modifier = O.node, N = O.nextConsumeToken || b.nextToken();
    }
    switch (N.type !== 9 && o(b, _t.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, da(N)), N = b.nextToken(), N.type === 2 && (N = b.nextToken()), N.type) {
      case 10:
        N.value == null && o(b, _t.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, da(N)), w.key = g(b, N.value || "");
        break;
      case 4:
        N.value == null && o(b, _t.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, da(N)), w.key = s(b, N.value || "");
        break;
      case 5:
        N.value == null && o(b, _t.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, da(N)), w.key = i(b, N.value || "");
        break;
      case 6:
        N.value == null && o(b, _t.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, da(N)), w.key = u(b, N.value || "");
        break;
      default: {
        o(b, _t.UNEXPECTED_EMPTY_LINKED_KEY, T.lastStartLoc, 0);
        const O = b.context(), m = n(7, O.offset, O.startLoc);
        return m.value = "", a(m, O.offset, O.startLoc), w.key = m, a(w, O.offset, O.startLoc), {
          nextConsumeToken: N,
          node: w
        };
      }
    }
    return a(w, b.currentOffset(), b.currentPosition()), {
      node: w
    };
  }
  function h(b) {
    const T = b.context(), w = T.currentType === 1 ? b.currentOffset() : T.offset, N = T.currentType === 1 ? T.endLoc : T.startLoc, O = n(2, w, N);
    O.items = [];
    let m = null;
    do {
      const $ = m || b.nextToken();
      switch (m = null, $.type) {
        case 0:
          $.value == null && o(b, _t.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, da($)), O.items.push(l(b, $.value || ""));
          break;
        case 5:
          $.value == null && o(b, _t.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, da($)), O.items.push(i(b, $.value || ""));
          break;
        case 4:
          $.value == null && o(b, _t.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, da($)), O.items.push(s(b, $.value || ""));
          break;
        case 6:
          $.value == null && o(b, _t.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, da($)), O.items.push(u(b, $.value || ""));
          break;
        case 7: {
          const E = p(b);
          O.items.push(E.node), m = E.nextConsumeToken || null;
          break;
        }
      }
    } while (T.currentType !== 13 && T.currentType !== 1);
    const _ = T.currentType === 1 ? T.lastOffset : b.currentOffset(), X = T.currentType === 1 ? T.lastEndLoc : b.currentPosition();
    return a(O, _, X), O;
  }
  function v(b, T, w, N) {
    const O = b.context();
    let m = N.items.length === 0;
    const _ = n(1, T, w);
    _.cases = [], _.cases.push(N);
    do {
      const X = h(b);
      m || (m = X.items.length === 0), _.cases.push(X);
    } while (O.currentType !== 13);
    return m && o(b, _t.MUST_HAVE_MESSAGES_IN_PLURAL, w, 0), a(_, b.currentOffset(), b.currentPosition()), _;
  }
  function A(b) {
    const T = b.context(), { offset: w, startLoc: N } = T, O = h(b);
    return T.currentType === 13 ? O : v(b, w, N, O);
  }
  function S(b) {
    const T = qG(b, oo({}, e)), w = T.context(), N = n(0, w.offset, w.startLoc);
    return t && N.loc && (N.loc.source = b), N.body = A(T), e.onCacheKey && (N.cacheKey = e.onCacheKey(b)), w.currentType !== 13 && o(T, _t.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, b[w.offset] || ""), a(N, T.currentOffset(), T.currentPosition()), N;
  }
  return { parse: S };
}
function da(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function aB(e, t = {}) {
  const r = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => r, helper: (a) => (r.helpers.add(a), a) };
}
function W1(e, t) {
  for (let r = 0; r < e.length; r++)
    X0(e[r], t);
}
function X0(e, t) {
  switch (e.type) {
    case 1:
      W1(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      W1(e.items, t);
      break;
    case 6: {
      X0(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function lB(e, t = {}) {
  const r = aB(e);
  r.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && X0(e.body, r);
  const o = r.context();
  e.helpers = Array.from(o.helpers);
}
function iB(e) {
  const t = e.body;
  return t.type === 2 ? Y1(t) : t.cases.forEach((r) => Y1(r)), e;
}
function Y1(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let r = 0; r < e.items.length; r++) {
      const o = e.items[r];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = V0(t);
      for (let r = 0; r < e.items.length; r++) {
        const o = e.items[r];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const sB = "minifier";
function vs(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      vs(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, r = t.cases;
      for (let o = 0; o < r.length; o++)
        vs(r[o]);
      t.c = r, delete t.cases;
      break;
    }
    case 2: {
      const t = e, r = t.items;
      for (let o = 0; o < r.length; o++)
        vs(r[o]);
      t.i = r, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      vs(t.key), t.k = t.key, delete t.key, t.modifier && (vs(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw id(_t.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: sB,
          args: [e.type]
        });
  }
  delete e.type;
}
const dB = "parser";
function uB(e, t) {
  const { filename: r, breakLineCode: o, needIndent: n } = t, a = t.location !== !1, l = {
    filename: r,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: n,
    indentLevel: 0
  };
  a && e.loc && (l.source = e.loc.source);
  const i = () => l;
  function s(A, S) {
    l.code += A;
  }
  function u(A, S = !0) {
    const b = S ? o : "";
    s(n ? b + "  ".repeat(A) : b);
  }
  function c(A = !0) {
    const S = ++l.indentLevel;
    A && u(S);
  }
  function g(A = !0) {
    const S = --l.indentLevel;
    A && u(S);
  }
  function p() {
    u(l.indentLevel);
  }
  return {
    context: i,
    push: s,
    indent: c,
    deindent: g,
    newline: p,
    helper: (A) => `_${A}`,
    needIndent: () => l.needIndent
  };
}
function cB(e, t) {
  const { helper: r } = e;
  e.push(`${r(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Xs(e, t.key), t.modifier ? (e.push(", "), Xs(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function mB(e, t) {
  const { helper: r, needIndent: o } = e;
  e.push(`${r(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const n = t.items.length;
  for (let a = 0; a < n && (Xs(e, t.items[a]), a !== n - 1); a++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function gB(e, t) {
  const { helper: r, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${r(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const n = t.cases.length;
    for (let a = 0; a < n && (Xs(e, t.cases[a]), a !== n - 1); a++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function fB(e, t) {
  t.body ? Xs(e, t.body) : e.push("null");
}
function Xs(e, t) {
  const { helper: r } = e;
  switch (t.type) {
    case 0:
      fB(e, t);
      break;
    case 1:
      gB(e, t);
      break;
    case 2:
      mB(e, t);
      break;
    case 6:
      cB(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${r(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${r(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${r(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${r(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw id(_t.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: dB,
          args: [t.type]
        });
  }
}
const pB = (e, t = {}) => {
  const r = Je(t.mode) ? t.mode : "normal", o = Je(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const n = t.breakLineCode != null ? t.breakLineCode : r === "arrow" ? ";" : `
`, a = t.needIndent ? t.needIndent : r !== "arrow", l = e.helpers || [], i = uB(e, {
    filename: o,
    breakLineCode: n,
    needIndent: a
  });
  i.push(r === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(a), l.length > 0 && (i.push(`const { ${V0(l.map((c) => `${c}: _${c}`), ", ")} } = ctx`), i.newline()), i.push("return "), Xs(i, e), i.deindent(a), i.push("}"), delete e.helpers;
  const { code: s, map: u } = i.context();
  return {
    ast: e,
    code: s,
    map: u ? u.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function hB(e, t = {}) {
  const r = oo({}, t), o = !!r.jit, n = !!r.minify, a = r.optimize == null ? !0 : r.optimize, i = nB(r).parse(e);
  return o ? (a && iB(i), n && vs(i), { ast: i, code: "" }) : (lB(i, r), pB(i, r));
}
function xB() {
  typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Am().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function Cn(e) {
  return Bt(e) && W0(e) === 0 && (Mn(e, "b") || Mn(e, "body"));
}
const mw = ["b", "body"];
function vB(e) {
  return Dl(e, mw);
}
const gw = ["c", "cases"];
function SB(e) {
  return Dl(e, gw, []);
}
const fw = ["s", "static"];
function bB(e) {
  return Dl(e, fw);
}
const pw = ["i", "items"];
function yB(e) {
  return Dl(e, pw, []);
}
const hw = ["t", "type"];
function W0(e) {
  return Dl(e, hw);
}
const xw = ["v", "value"];
function zu(e, t) {
  const r = Dl(e, xw);
  if (r != null)
    return r;
  throw jd(t);
}
const vw = ["m", "modifier"];
function wB(e) {
  return Dl(e, vw);
}
const Sw = ["k", "key"];
function _B(e) {
  const t = Dl(e, Sw);
  if (t)
    return t;
  throw jd(
    6
    /* NodeTypes.Linked */
  );
}
function Dl(e, t, r) {
  for (let o = 0; o < t.length; o++) {
    const n = t[o];
    if (Mn(e, n) && e[n] != null)
      return e[n];
  }
  return r;
}
const bw = [
  ...mw,
  ...gw,
  ...fw,
  ...pw,
  ...Sw,
  ...vw,
  ...xw,
  ...hw
];
function jd(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Gg(e) {
  return (r) => TB(r, e);
}
function TB(e, t) {
  const r = vB(t);
  if (r == null)
    throw jd(
      0
      /* NodeTypes.Resource */
    );
  if (W0(r) === 1) {
    const a = SB(r);
    return e.plural(a.reduce((l, i) => [
      ...l,
      K1(e, i)
    ], []));
  } else
    return K1(e, r);
}
function K1(e, t) {
  const r = bB(t);
  if (r != null)
    return e.type === "text" ? r : e.normalize([r]);
  {
    const o = yB(t).reduce((n, a) => [...n, qf(e, a)], []);
    return e.normalize(o);
  }
}
function qf(e, t) {
  const r = W0(t);
  switch (r) {
    case 3:
      return zu(t, r);
    case 9:
      return zu(t, r);
    case 4: {
      const o = t;
      if (Mn(o, "k") && o.k)
        return e.interpolate(e.named(o.k));
      if (Mn(o, "key") && o.key)
        return e.interpolate(e.named(o.key));
      throw jd(r);
    }
    case 5: {
      const o = t;
      if (Mn(o, "i") && Xr(o.i))
        return e.interpolate(e.list(o.i));
      if (Mn(o, "index") && Xr(o.index))
        return e.interpolate(e.list(o.index));
      throw jd(r);
    }
    case 6: {
      const o = t, n = wB(o), a = _B(o);
      return e.linked(qf(e, a), n ? qf(e, n) : void 0, e.type);
    }
    case 7:
      return zu(t, r);
    case 8:
      return zu(t, r);
    default:
      throw new Error(`unhandled node on format message part: ${r}`);
  }
}
const AB = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function PB(e, t) {
  t && WG(e) && ya(Tm(AB, { source: e }));
}
const MB = (e) => e;
let qu = mr();
function $B(e, t = {}) {
  let r = !1;
  const o = t.onError || UG;
  return t.onError = (n) => {
    r = !0, o(n);
  }, { ...hB(e, t), detectError: r };
}
// @__NO_SIDE_EFFECTS__
function CB(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && Je(e)) {
    const r = Wt(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && PB(e, r);
    const n = (t.onCacheKey || MB)(e), a = qu[n];
    if (a)
      return a;
    const { ast: l, detectError: i } = $B(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), s = Gg(l);
    return i ? s : qu[n] = s;
  } else {
    if (process.env.NODE_ENV !== "production" && !Cn(e))
      return ya(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), (() => e);
    const r = e.cacheKey;
    if (r) {
      const o = qu[r];
      return o || (qu[r] = Gg(e));
    } else
      return Gg(e);
  }
}
let Zd = null;
function LB(e) {
  Zd = e;
}
function EB(e, t, r) {
  Zd && Zd.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: r
  });
}
const OB = /* @__PURE__ */ NB("function:translate");
function NB(e) {
  return (t) => Zd && Zd.emit(e, t);
}
const Mo = {
  INVALID_ARGUMENT: VG,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, DB = 24;
function Ra(e) {
  return id(e, null, process.env.NODE_ENV !== "production" ? { messages: kB } : void 0);
}
const kB = {
  [Mo.INVALID_ARGUMENT]: "Invalid arguments",
  [Mo.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Mo.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Mo.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Mo.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Mo.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Mo.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Y0(e, t) {
  return t.locale != null ? Q1(t.locale) : Q1(e.locale);
}
let Bg;
function Q1(e) {
  if (Je(e))
    return e;
  if (xr(e)) {
    if (e.resolvedOnce && Bg != null)
      return Bg;
    if (e.constructor.name === "Function") {
      const t = e();
      if (TG(t))
        throw Ra(Mo.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Bg = t;
    } else
      throw Ra(Mo.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Ra(Mo.NOT_SUPPORT_LOCALE_TYPE);
}
function GB(e, t, r) {
  return [.../* @__PURE__ */ new Set([
    r,
    ...vr(t) ? t : Bt(t) ? Object.keys(t).filter((o) => o !== "default") : Je(t) ? [t] : [r]
  ])];
}
function Jf(e, t, r) {
  const o = Je(r) ? r : zd, n = e;
  let a;
  Bt(t) ? (n.__localeChainObjectCache || (n.__localeChainObjectCache = /* @__PURE__ */ new WeakMap()), a = n.__localeChainObjectCache.get(t), a || (a = /* @__PURE__ */ new Map(), n.__localeChainObjectCache.set(t, a))) : (n.__localeChainCache || (n.__localeChainCache = /* @__PURE__ */ new Map()), a = n.__localeChainCache.get(t), a || (a = /* @__PURE__ */ new Map(), n.__localeChainCache.set(t, a)));
  const l = a.get(o);
  if (l)
    return l;
  const i = [];
  let s = [r];
  for (; vr(s); )
    s = j1(i, s, t);
  const u = vr(t) || !rr(t) ? t : t.default ? t.default : null;
  return s = Je(u) ? [u] : u, vr(s) && j1(i, s, !1), a.set(o, i), i;
}
function j1(e, t, r) {
  let o = !0;
  for (let n = 0; n < t.length && Wt(o); n++) {
    const a = t[n];
    Je(a) && (o = BB(e, t[n], r));
  }
  return o;
}
function BB(e, t, r) {
  let o;
  const n = t.split("-");
  do {
    const a = n.join("-");
    o = IB(e, a, r), n.splice(-1, 1);
  } while (n.length && o === !0);
  return o;
}
function IB(e, t, r) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const n = t.replace(/!/g, "");
    e.push(n), (vr(r) || rr(r)) && r[n] && (o = r[n]);
  }
  return o;
}
const kl = [];
kl[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
kl[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
kl[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
kl[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
kl[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
kl[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
kl[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const RB = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function FB(e) {
  return RB.test(e);
}
function VB(e) {
  const t = e.charCodeAt(0), r = e.charCodeAt(e.length - 1);
  return t === r && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function HB(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function UB(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : FB(t) ? VB(t) : "*" + t;
}
function XB(e) {
  const t = [];
  let r = -1, o = 0, n = 0, a, l, i, s, u, c, g;
  const p = [];
  p[
    0
    /* Actions.APPEND */
  ] = () => {
    l === void 0 ? l = i : l += i;
  }, p[
    1
    /* Actions.PUSH */
  ] = () => {
    l !== void 0 && (t.push(l), l = void 0);
  }, p[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    p[
      0
      /* Actions.APPEND */
    ](), n++;
  }, p[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (n > 0)
      n--, o = 4, p[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (n = 0, l === void 0 || (l = UB(l), l === !1))
        return !1;
      p[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function h() {
    const v = e[r + 1];
    if (o === 5 && v === "'" || o === 6 && v === '"')
      return r++, i = "\\" + v, p[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (r++, a = e[r], !(a === "\\" && h())) {
      if (s = HB(a), g = kl[o], u = g[s] || g.l || 8, u === 8 || (o = u[0], u[1] !== void 0 && (c = p[u[1]], c && (i = a, c() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const Z1 = /* @__PURE__ */ new Map();
function WB(e, t) {
  return Bt(e) ? e[t] : null;
}
function YB(e, t) {
  if (!Bt(e))
    return null;
  let r = Z1.get(t);
  if (r || (r = XB(t), r && Z1.set(t, r)), !r)
    return null;
  const o = r.length;
  let n = e, a = 0;
  for (; a < o; ) {
    const l = r[a];
    if (bw.includes(l) && Cn(n) || !Bt(n) || !Mn(n, l))
      return null;
    const i = n[l];
    if (i === void 0 || xr(n))
      return null;
    n = i, a++;
  }
  return n;
}
const mo = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  INVALID_NUMBER_ARGUMENT: 8,
  INVALID_DATE_ARGUMENT: 9
}, Ki = 10, KB = {
  [mo.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [mo.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [mo.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [mo.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [mo.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [mo.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [mo.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.",
  [mo.INVALID_NUMBER_ARGUMENT]: "Invalid argument for number formatting: expected a number but received '{value}'.",
  [mo.INVALID_DATE_ARGUMENT]: "Invalid argument for datetime formatting: expected a Date, number, or ISO string but received '{value}'."
};
function Ll(e, ...t) {
  return Tm(KB[e], ...t);
}
const QB = "11.4.12", Mm = -1, zd = "en-US", Ws = "", z1 = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function jB() {
  return {
    upper: (e, t) => t === "text" && Je(e) ? e.toUpperCase() : t === "vnode" && Bt(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && Je(e) ? e.toLowerCase() : t === "vnode" && Bt(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && Je(e) ? z1(e) : t === "vnode" && Bt(e) && "__v_isVNode" in e ? z1(e.children) : e
  };
}
let yw;
function ZB(e) {
  yw = e;
}
let ww;
function zB(e) {
  ww = e;
}
let _w;
function qB(e) {
  _w = e;
}
let Tw = null;
const JB = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Tw = e;
}, eI = /* @__NO_SIDE_EFFECTS__ */ () => Tw;
let Aw = null;
const q1 = (e) => {
  Aw = e;
}, J1 = () => Aw;
let ex = 0;
function tI(e = {}) {
  const t = xr(e.onWarn) ? e.onWarn : ya, r = Je(e.version) ? e.version : QB, o = Je(e.locale) || xr(e.locale) ? e.locale : zd, n = xr(o) ? zd : o, a = vr(e.fallbackLocale) || rr(e.fallbackLocale) || Je(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : n, l = rr(e.messages) ? e.messages : Ig(n), i = rr(e.datetimeFormats) ? e.datetimeFormats : Ig(n), s = rr(e.numberFormats) ? e.numberFormats : Ig(n), u = oo(mr(), e.modifiers, jB()), c = e.pluralRules || mr(), g = xr(e.missing) ? e.missing : null, p = Wt(e.missingWarn) || Us(e.missingWarn) ? e.missingWarn : !0, h = Wt(e.fallbackWarn) || Us(e.fallbackWarn) ? e.fallbackWarn : !0, v = !!e.fallbackFormat, A = !!e.unresolving, S = xr(e.postTranslation) ? e.postTranslation : null, b = rr(e.processor) ? e.processor : null, T = Wt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, w = !!e.escapeParameter, N = xr(e.messageCompiler) ? e.messageCompiler : yw;
  process.env.NODE_ENV !== "production" && xr(e.messageCompiler) && H0(Ll(mo.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const O = xr(e.messageResolver) ? e.messageResolver : ww || WB, m = xr(e.localeFallbacker) ? e.localeFallbacker : _w || GB, _ = Bt(e.fallbackContext) ? e.fallbackContext : void 0, X = e, $ = Bt(X.__datetimeFormatters) ? X.__datetimeFormatters : /* @__PURE__ */ new Map(), E = Bt(X.__numberFormatters) ? X.__numberFormatters : /* @__PURE__ */ new Map(), D = Bt(X.__meta) ? X.__meta : {};
  ex++;
  const U = {
    version: r,
    cid: ex,
    locale: o,
    fallbackLocale: a,
    messages: l,
    modifiers: u,
    pluralRules: c,
    missing: g,
    missingWarn: p,
    fallbackWarn: h,
    fallbackFormat: v,
    unresolving: A,
    postTranslation: S,
    processor: b,
    warnHtmlMessage: T,
    escapeParameter: w,
    messageCompiler: N,
    messageResolver: O,
    localeFallbacker: m,
    fallbackContext: _,
    onWarn: t,
    __meta: D
  };
  return U.datetimeFormats = i, U.numberFormats = s, U.__datetimeFormatters = $, U.__numberFormatters = E, process.env.NODE_ENV !== "production" && (U.__v_emitter = X.__v_emitter != null ? X.__v_emitter : void 0), process.env.NODE_ENV !== "production" && EB(U, r, D), U;
}
const Ig = (e) => ({ [e]: mr() });
function K0(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Pw(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Mw(e, t, r, o, n) {
  const { missing: a, onWarn: l } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: r,
      key: t,
      type: n,
      groupId: Cl(n, t)
    });
  }
  if (a !== null) {
    const i = a(e, r, t, n);
    return Je(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && Pw(o, t) && l(Ll(mo.NOT_FOUND_KEY, { key: t, locale: r })), t;
}
function tx(e, t) {
  const r = e;
  Bt(t) ? r.__localeChainObjectCache?.delete(t) : r.__localeChainCache?.delete(t);
}
function Ju(e, t, r) {
  tx(e, r), e.fallbackContext && tx(e.fallbackContext, r), e.localeFallbacker(e, r, t);
}
function $w(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function rI(e, t) {
  const r = t.indexOf(e);
  if (r === -1)
    return !1;
  for (let o = r + 1; o < t.length; o++)
    if ($w(e, t[o]))
      return !0;
  return !1;
}
function Cw(e, t, r, o, n, a, l) {
  const { fallbackLocale: i, localeFallbacker: s, onWarn: u } = e, c = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    r
  );
  let g = r;
  for (let p = 0; p < c.length; p++) {
    const h = c[p];
    if (process.env.NODE_ENV !== "production" && r !== h && K0(a, t) && u(Ll(l === "datetime format" ? mo.FALLBACK_TO_DATE_FORMAT : mo.FALLBACK_TO_NUMBER_FORMAT, {
      key: t,
      target: h
    })), process.env.NODE_ENV !== "production" && r !== h) {
      const A = e.__v_emitter;
      A && A.emit("fallback", {
        type: l,
        key: t,
        from: g,
        to: h,
        groupId: Cl(l, t)
      });
    }
    const v = (o[h] || {})[t];
    if (rr(v) && Je(h))
      return h;
    Mw(e, t, h, n, l), g = h;
  }
  return null;
}
function Lw(e, t, r) {
  let o = `${e}__${t}`;
  return rr(r) && !R0(r) && (o = `${o}__${JSON.stringify(r)}`), o;
}
function Ew(e, t, r) {
  for (const o in r) {
    const n = `${t}__${o}`;
    for (const a of e.keys())
      (a === n || a.startsWith(`${n}__`)) && e.delete(a);
  }
}
function Ow(e, t, r, o) {
  const [, n, a, l] = e;
  let i = r;
  return Je(n) ? t.key = n : rr(n) && Object.keys(n).forEach((s) => {
    o.includes(s) ? i[s] = n[s] : t[s] = n[s];
  }), Je(a) ? t.locale = a : rr(a) && (i = a), rr(l) && (i = l), i;
}
const rx = typeof Intl < "u", Nw = {
  dateTimeFormat: rx && typeof Intl.DateTimeFormat < "u",
  numberFormat: rx && typeof Intl.NumberFormat < "u"
};
function ox(e, ...t) {
  const { datetimeFormats: r, unresolving: o, onWarn: n } = e, { __datetimeFormatters: a } = e;
  if (process.env.NODE_ENV !== "production" && !Nw.dateTimeFormat)
    return n(Ll(mo.CANNOT_FORMAT_DATE)), Ws;
  if (!Je(t[0]) && !uw(t[0]) && !Xr(t[0]))
    return process.env.NODE_ENV !== "production" && n(Ll(mo.INVALID_DATE_ARGUMENT, {
      value: String(t[0])
    })), Ws;
  const [l, i, s, u] = ep(...t), c = Wt(s.missingWarn) ? s.missingWarn : e.missingWarn, g = Wt(s.fallbackWarn) ? s.fallbackWarn : e.fallbackWarn, p = !!s.part, h = Y0(e, s);
  if (!Je(l) || l === "") {
    const T = new Intl.DateTimeFormat(h.replace(/!/g, ""), u);
    return p ? T.formatToParts(i) : T.format(i);
  }
  const v = Cw(e, l, h, r, c, g, "datetime format");
  if (!Je(v))
    return o ? Mm : l;
  const A = r[v][l], S = Lw(v, l, u);
  let b = a.get(S);
  return b || (b = new Intl.DateTimeFormat(v, oo({}, A, u)), a.set(S, b)), p ? b.formatToParts(i) : b.format(i);
}
const Dw = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function ep(...e) {
  const [t] = e, r = mr(), o = mr();
  let n;
  if (Je(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw Ra(Mo.INVALID_ISO_DATE_ARGUMENT);
    const i = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    n = new Date(i);
    try {
      n.toISOString();
    } catch {
      throw Ra(Mo.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (uw(t)) {
    if (isNaN(t.getTime()))
      throw Ra(Mo.INVALID_DATE_ARGUMENT);
    n = t;
  } else if (Xr(t))
    n = t;
  else
    throw Ra(Mo.INVALID_ARGUMENT);
  const a = Ow(e, r, o, Dw);
  return [r.key || "", n, r, a];
}
function nx(e, t, r) {
  Ew(e.__datetimeFormatters, t, r);
}
function ax(e, ...t) {
  const { numberFormats: r, unresolving: o, onWarn: n } = e, { __numberFormatters: a } = e;
  if (process.env.NODE_ENV !== "production" && !Nw.numberFormat)
    return n(Ll(mo.CANNOT_FORMAT_NUMBER)), Ws;
  if (!Xr(t[0]))
    return process.env.NODE_ENV !== "production" && n(Ll(mo.INVALID_NUMBER_ARGUMENT, {
      value: String(t[0])
    })), Ws;
  const [l, i, s, u] = tp(...t), c = Wt(s.missingWarn) ? s.missingWarn : e.missingWarn, g = Wt(s.fallbackWarn) ? s.fallbackWarn : e.fallbackWarn, p = !!s.part, h = Y0(e, s);
  if (!Je(l) || l === "") {
    const T = new Intl.NumberFormat(h.replace(/!/g, ""), u);
    return p ? T.formatToParts(i) : T.format(i);
  }
  const v = Cw(e, l, h, r, c, g, "number format");
  if (!Je(v))
    return o ? Mm : l;
  const A = r[v][l], S = Lw(v, l, u);
  let b = a.get(S);
  return b || (b = new Intl.NumberFormat(v, oo({}, A, u)), a.set(S, b)), p ? b.formatToParts(i) : b.format(i);
}
const kw = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function tp(...e) {
  const [t] = e, r = mr(), o = mr();
  if (!Xr(t))
    throw Ra(Mo.INVALID_ARGUMENT);
  const n = t, a = Ow(e, r, o, kw);
  return [r.key || "", n, r, a];
}
function lx(e, t, r) {
  Ew(e.__numberFormatters, t, r);
}
const oI = (e) => e, nI = (e) => "", aI = "text", lI = (e) => e.length === 0 ? "" : V0(e), iI = AG;
function Rg(e, t) {
  return e = Math.abs(e), t === 2 ? e === 1 ? 0 : 1 : Math.min(e, 2);
}
function sI(e) {
  const t = Xr(e.pluralIndex) ? e.pluralIndex : -1;
  return Xr(e.named?.count) ? e.named.count : Xr(e.named?.n) ? e.named.n : t;
}
function dI(e = {}) {
  const t = e.locale, r = sI(e), o = Je(t) && xr(e.pluralRules?.[t]) ? e.pluralRules[t] : Rg, n = o === Rg ? void 0 : Rg, a = (b) => b[o(r, b.length, n)], l = e.list || [], i = (b) => l[b], s = e.named || mr();
  Xr(e.pluralIndex) && (s.count ||= e.pluralIndex, s.n ||= e.pluralIndex);
  const u = (b) => s[b];
  function c(b, T) {
    const w = xr(e.messages) ? e.messages(b, !!T) : Bt(e.messages) ? e.messages[b] : !1;
    return w || (e.parent ? e.parent.message(b) : nI);
  }
  const g = (b) => e.modifiers ? e.modifiers[b] : oI, p = xr(e.processor?.normalize) ? e.processor.normalize : lI, h = xr(e.processor?.interpolate) ? e.processor.interpolate : iI, v = Je(e.processor?.type) ? e.processor.type : aI, S = {
    list: i,
    named: u,
    plural: a,
    linked: (b, ...T) => {
      const [w, N] = T;
      let O = "text", m = "";
      T.length === 1 ? Bt(w) ? (m = w.modifier || m, O = w.type || O) : Je(w) && (m = w || m) : T.length === 2 && (Je(w) && (m = w || m), Je(N) && (O = N || O));
      const _ = c(b, !0)(S), X = _ === "" || _ === void 0 ? b : _, $ = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        O === "vnode" && vr(X) && m ? X[0] : X
      );
      return m ? g(m)($, O) : $;
    },
    message: c,
    type: v,
    interpolate: h,
    normalize: p,
    values: oo(mr(), l, s)
  };
  return S;
}
const ix = () => "", wn = (e) => xr(e);
function sx(e, ...t) {
  const { fallbackFormat: r, postTranslation: o, unresolving: n, messageCompiler: a, fallbackLocale: l, messages: i } = e, [s, u] = rp(...t), c = Wt(u.missingWarn) ? u.missingWarn : e.missingWarn, g = Wt(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, p = Wt(u.escapeParameter) ? u.escapeParameter : e.escapeParameter, h = !!u.resolvedMessage, v = Je(u.default) || Wt(u.default) ? Wt(u.default) ? a ? s : () => s : u.default : r ? a ? s : () => s : null, A = r || v != null && (Je(v) || xr(v)), S = Y0(e, u);
  p && uI(u);
  let [b, T, w] = h ? [
    s,
    S,
    i[S] || mr()
  ] : Gw(e, s, S, l, g, c), N = b, O = s;
  if (!h && !(Je(N) || Cn(N) || wn(N)) && A && (N = v, O = N), !h && (!(Je(N) || Cn(N) || wn(N)) || !Je(T)))
    return n ? Mm : s;
  if (process.env.NODE_ENV !== "production" && Je(N) && e.messageCompiler == null)
    return ya(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${s}'.`), s;
  let m = !1;
  const _ = () => {
    m = !0;
  }, X = wn(N) ? N : Bw(e, s, T, N, O, _);
  if (m)
    return N;
  const $ = fI(e, T, w, u), E = dI($), D = cI(e, X, E);
  let U = o ? o(D, s) : D;
  if (p && Je(U) && (U = RG(U)), process.env.NODE_ENV !== "production") {
    const Y = {
      timestamp: Date.now(),
      key: Je(s) ? s : wn(N) ? N.key : "",
      locale: T || (wn(N) ? N.locale : ""),
      format: Je(N) ? N : wn(N) ? N.source : "",
      message: U
    };
    Y.meta = oo({}, e.__meta, /* @__PURE__ */ eI() || {}), OB(Y);
  }
  return U;
}
function uI(e) {
  vr(e.list) ? e.list = e.list.map((t) => Je(t) ? V1(t) : t) : Bt(e.named) && Object.keys(e.named).forEach((t) => {
    Je(e.named[t]) && (e.named[t] = V1(e.named[t]));
  });
}
function Gw(e, t, r, o, n, a) {
  const { messages: l, onWarn: i, messageResolver: s, localeFallbacker: u } = e, c = u(e, o, r);
  let g = mr(), p, h = null, v = r, A = null;
  const S = "translate";
  for (let b = 0; b < c.length; b++) {
    p = A = c[b], process.env.NODE_ENV !== "production" && r !== p && !$w(r, p) && K0(n, t) && i(Ll(mo.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: p
    }));
    const T = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
    process.env.NODE_ENV !== "production" && r !== p && T && T.emit("fallback", {
      type: S,
      key: t,
      from: v,
      to: A,
      groupId: Cl(S, t)
    }), g = l[p] || mr();
    let w = null, N, O;
    if (process.env.NODE_ENV !== "production" && Zn && T && (w = window.performance.now(), N = "intlify-message-resolve-start", O = "intlify-message-resolve-end", ln && ln(N)), (h = s(g, t)) === null && (h = g[t]), process.env.NODE_ENV !== "production" && Zn && T) {
      const m = window.performance.now();
      T && w && h && T.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: h,
        time: m - w,
        groupId: Cl(S, t)
      }), N && O && ln && pi && (ln(O), pi("intlify message resolve", N, O));
    }
    if (Je(h) || Cn(h) || wn(h))
      break;
    if (!rI(p, c)) {
      const m = Mw(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        p,
        a,
        S
      );
      m !== t && (h = m);
    }
    v = A;
  }
  return [h, p, g];
}
function Bw(e, t, r, o, n, a) {
  const { messageCompiler: l, warnHtmlMessage: i } = e;
  if (wn(o)) {
    const h = o;
    return h.locale = h.locale || r, h.key = h.key || t, h;
  }
  if (l == null) {
    const h = (() => o);
    return h.locale = r, h.key = t, h;
  }
  const s = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let u = null, c, g;
  process.env.NODE_ENV !== "production" && Zn && s && (u = window.performance.now(), c = "intlify-message-compilation-start", g = "intlify-message-compilation-end", ln && ln(c));
  const p = l(o, mI(e, r, n, o, i, a));
  if (process.env.NODE_ENV !== "production" && Zn && s) {
    const h = window.performance.now();
    s && u && s.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: h - u,
      groupId: Cl("translate", t)
    }), c && g && ln && pi && (ln(g), pi("intlify message compilation", c, g));
  }
  return p.locale = r, p.key = t, p.source = o, p;
}
function cI(e, t, r) {
  const o = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let n = null, a, l;
  process.env.NODE_ENV !== "production" && Zn && o && (n = window.performance.now(), a = "intlify-message-evaluation-start", l = "intlify-message-evaluation-end", ln && ln(a));
  const i = t(r);
  if (process.env.NODE_ENV !== "production" && Zn && o) {
    const s = window.performance.now();
    o && n && o.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: s - n,
      groupId: Cl("translate", t.key)
    }), a && l && ln && pi && (ln(l), pi("intlify message evaluation", a, l));
  }
  return i;
}
function rp(...e) {
  const [t, r, o] = e, n = mr();
  if (!Je(t) && !Xr(t) && !wn(t) && !Cn(t))
    throw Ra(Mo.INVALID_ARGUMENT);
  const a = Xr(t) ? String(t) : (wn(t), t);
  return Xr(r) ? n.plural = r : Je(r) ? n.default = r : rr(r) && !R0(r) ? n.named = r : vr(r) && (n.list = r), Xr(o) ? n.plural = o : Je(o) ? n.default = o : rr(o) && oo(n, o), [a, n];
}
function mI(e, t, r, o, n, a) {
  return {
    locale: t,
    key: r,
    warnHtmlMessage: n,
    onError: (l) => {
      if (a && a(l), process.env.NODE_ENV !== "production") {
        const i = gI(o), s = l.location && i && PG(i, l.location.start.offset, l.location.end.offset), u = e.__v_emitter;
        u && i && u.emit("compile-error", {
          message: i,
          error: l.message,
          start: l.location && l.location.start.offset,
          end: l.location && l.location.end.offset,
          groupId: Cl("translate", r)
        });
        const c = `Message compilation error: ${l.message}`;
        throw new SyntaxError(s ? `${c}
${s}` : c);
      }
      throw l;
    },
    onCacheKey: (l) => bG(t, r, l)
  };
}
function gI(e) {
  if (Je(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function fI(e, t, r, o) {
  const { modifiers: n, pluralRules: a, messageResolver: l, fallbackLocale: i, fallbackWarn: s, missingWarn: u, fallbackContext: c } = e, p = {
    locale: t,
    modifiers: n,
    pluralRules: a,
    messages: (h, v) => {
      let A = l(r, h);
      if (A == null && (c || v)) {
        const [S, , b] = Gw(
          c || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          h,
          t,
          i,
          s,
          u
        );
        A = S ?? l(b, h);
      }
      if (Je(A) || Cn(A)) {
        let S = !1;
        const T = Bw(e, h, t, A, h, () => {
          S = !0;
        });
        return S ? ix : T;
      } else return wn(A) ? A : ix;
    }
  };
  return e.processor && (p.processor = e.processor), o.list && (p.list = o.list), o.named && (p.named = o.named), Xr(o.plural) && (p.pluralIndex = o.plural), p;
}
xB();
function pI() {
  return Iw().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function Iw() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const hI = typeof Proxy == "function", xI = "devtools-plugin:setup", vI = "plugin:settings:set";
let Qi, op;
function SI() {
  var e;
  return Qi !== void 0 || (typeof window < "u" && window.performance ? (Qi = !0, op = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (Qi = !0, op = globalThis.perf_hooks.performance) : Qi = !1), Qi;
}
function bI() {
  return SI() ? op.now() : Date.now();
}
class yI {
  constructor(t, r) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = r;
    const o = {};
    if (t.settings)
      for (const l in t.settings) {
        const i = t.settings[l];
        o[l] = i.defaultValue;
      }
    const n = `__vue-devtools-plugin-settings__${t.id}`;
    let a = Object.assign({}, o);
    try {
      const l = localStorage.getItem(n), i = JSON.parse(l);
      Object.assign(a, i);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return a;
      },
      setSettings(l) {
        try {
          localStorage.setItem(n, JSON.stringify(l));
        } catch {
        }
        a = l;
      },
      now() {
        return bI();
      }
    }, r && r.on(vI, (l, i) => {
      l === this.plugin.id && this.fallbacks.setSettings(i);
    }), this.proxiedOn = new Proxy({}, {
      get: (l, i) => this.target ? this.target.on[i] : (...s) => {
        this.onQueue.push({
          method: i,
          args: s
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (l, i) => this.target ? this.target[i] : i === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(i) ? (...s) => (this.targetQueue.push({
        method: i,
        args: s,
        resolve: () => {
        }
      }), this.fallbacks[i](...s)) : (...s) => new Promise((u) => {
        this.targetQueue.push({
          method: i,
          args: s,
          resolve: u
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const r of this.onQueue)
      this.target.on[r.method](...r.args);
    for (const r of this.targetQueue)
      r.resolve(await this.target[r.method](...r.args));
  }
}
function wI(e, t) {
  const r = e, o = Iw(), n = pI(), a = hI && r.enableEarlyProxy;
  if (n && (o.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !a))
    n.emit(xI, e, t);
  else {
    const l = a ? new yI(r, n) : null;
    (o.__VUE_DEVTOOLS_PLUGINS__ = o.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: r,
      setupFn: t,
      proxy: l
    }), l && t(l.proxiedTarget);
  }
}
const _I = "11.4.12";
function TI() {
  typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Am().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const pr = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: DB,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function Fo(e, ...t) {
  return id(e, null, process.env.NODE_ENV !== "production" ? { messages: AI, args: t } : void 0);
}
const AI = {
  [pr.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [pr.INVALID_ARGUMENT]: "Invalid argument",
  [pr.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [pr.NOT_INSTALLED]: "Need to install with `app.use` function",
  [pr.UNEXPECTED_ERROR]: "Unexpected error",
  [pr.REQUIRED_VALUE]: "Required in value: {0}",
  [pr.INVALID_VALUE]: "Invalid value",
  [pr.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [pr.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [pr.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [pr.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, np = /* @__PURE__ */ Aa("__translateVNode"), ap = /* @__PURE__ */ Aa("__datetimeParts"), lp = /* @__PURE__ */ Aa("__numberParts"), Ka = /* @__PURE__ */ Aa("__enableEmitter"), hi = /* @__PURE__ */ Aa("__disableEmitter"), Rw = Aa("__setPluralRules"), Fw = /* @__PURE__ */ Aa("__injectWithOption"), _s = /* @__PURE__ */ Aa("__dispose"), _n = {
  FALLBACK_TO_ROOT: Ki,
  // 10
  NOT_FOUND_PARENT_SCOPE: Ki + 1,
  IGNORE_OBJ_FLATTEN: Ki + 2,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: Ki + 3,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: Ki + 4,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: Ki + 5
}, PI = {
  [_n.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [_n.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [_n.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [_n.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [_n.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [_n.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function Ys(e, ...t) {
  return Tm(PI[e], ...t);
}
let Vw = null;
{
  const e = Am().__VUE_INSTANCE_SETTERS__;
  vr(e) && e.push((t) => {
    Vw = t;
  });
}
function qd(e) {
  if (!Bt(e) || Cn(e))
    return e;
  for (const t in e)
    if (Mn(e, t))
      if (!t.includes("."))
        Bt(e[t]) && qd(e[t]);
      else {
        const r = t.split("."), o = r.length - 1;
        let n = e, a = !1;
        for (let l = 0; l < o; l++) {
          if (r[l] === "__proto__")
            throw new Error(`unsafe key: ${r[l]}`);
          if (r[l] in n || (n[r[l]] = mr()), !Bt(n[r[l]])) {
            process.env.NODE_ENV !== "production" && ya(Ys(_n.IGNORE_OBJ_FLATTEN, {
              key: r[l]
            })), a = !0;
            break;
          }
          n = n[r[l]];
        }
        if (a || (Cn(n) ? bw.includes(r[o]) || delete e[t] : (n[r[o]] = e[t], delete e[t])), !Cn(n)) {
          const l = n[r[o]];
          Bt(l) && qd(l);
        }
      }
  return e;
}
function Q0(e, t) {
  const { messages: r, __i18n: o, messageResolver: n, flatJson: a } = t, l = rr(r) ? r : vr(o) ? mr() : { [e]: mr() };
  if (vr(o) && o.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: s, resource: u } = i;
      s ? (l[s] = l[s] || mr(), xc(u, l[s])) : xc(u, l);
    } else
      Je(i) && xc(JSON.parse(i), l);
  }), n == null && a)
    for (const i in l)
      Mn(l, i) && qd(l[i]);
  return l;
}
function Hw(e) {
  return e.type;
}
function Uw(e, t, r) {
  let o = Bt(t.messages) ? t.messages : mr();
  "__i18nGlobal" in r && (o = Q0(e.locale.value, {
    messages: o,
    __i18n: r.__i18nGlobal
  }));
  const n = Object.keys(o);
  n.length && n.forEach((a) => {
    e.mergeLocaleMessage(a, o[a]);
  });
  {
    if (Bt(t.datetimeFormats)) {
      const a = Object.keys(t.datetimeFormats);
      a.length && a.forEach((l) => {
        e.mergeDateTimeFormat(l, t.datetimeFormats[l]);
      });
    }
    if (Bt(t.numberFormats)) {
      const a = Object.keys(t.numberFormats);
      a.length && a.forEach((l) => {
        e.mergeNumberFormat(l, t.numberFormats[l]);
      });
    }
  }
}
function dx(e) {
  return vt(nA, null, e, 0);
}
function Ls() {
  return Vw ?? Tp();
}
const ux = "__INTLIFY_META__", cx = () => [], MI = () => !1;
let mx = 0;
function gx(e) {
  return ((t, r, o, n) => e(r, o, Ls() || void 0, n));
}
const $I = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = Ls();
  let t = null;
  return e && (t = Hw(e)[ux]) ? { [ux]: t } : null;
};
function Xc(e = {}) {
  const { __root: t, __injectWithOption: r } = e, o = t === void 0, n = e.flatJson, a = Zn ? Ee : $p;
  let l = Wt(e.inheritLocale) ? e.inheritLocale : !0;
  const i = a(
    // prettier-ignore
    t && l ? t.locale.value : Je(e.locale) ? e.locale : zd
  ), s = a(
    // prettier-ignore
    t && l ? t.fallbackLocale.value : Je(e.fallbackLocale) || vr(e.fallbackLocale) || rr(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), u = a(Q0(i.value, e)), c = a(rr(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), g = a(rr(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let p = t ? t.missingWarn : Wt(e.missingWarn) || Us(e.missingWarn) ? e.missingWarn : !0, h = t ? t.fallbackWarn : Wt(e.fallbackWarn) || Us(e.fallbackWarn) ? e.fallbackWarn : !0, v = t ? t.fallbackRoot : Wt(e.fallbackRoot) ? e.fallbackRoot : !0, A = !!e.fallbackFormat, S = xr(e.missing) ? e.missing : null, b = xr(e.missing) ? gx(e.missing) : null, T = xr(e.postTranslation) ? e.postTranslation : null, w = t ? t.warnHtmlMessage : Wt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, N = !!e.escapeParameter;
  const O = t ? t.modifiers : rr(e.modifiers) ? e.modifiers : {};
  let m = e.pluralRules || t && t.pluralRules, _;
  _ = (() => {
    o && q1(null);
    const ye = {
      version: _I,
      locale: i.value,
      fallbackLocale: s.value,
      messages: u.value,
      modifiers: O,
      pluralRules: m,
      missing: b === null ? void 0 : b,
      missingWarn: p,
      fallbackWarn: h,
      fallbackFormat: A,
      unresolving: !0,
      postTranslation: T === null ? void 0 : T,
      warnHtmlMessage: w,
      escapeParameter: N,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    ye.datetimeFormats = c.value, ye.numberFormats = g.value, ye.__datetimeFormatters = rr(_) ? _.__datetimeFormatters : void 0, ye.__numberFormatters = rr(_) ? _.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (ye.__v_emitter = rr(_) ? _.__v_emitter : void 0);
    const Ne = tI(ye);
    return o && q1(Ne), Ne;
  })(), Ju(_, i.value, s.value);
  function $() {
    return [
      i.value,
      s.value,
      u.value,
      c.value,
      g.value
    ];
  }
  const E = ge({
    get: () => i.value,
    set: (ye) => {
      _.locale = ye, i.value = ye;
    }
  });
  function D(ye) {
    o || (_.fallbackContext = t ? J1() : void 0);
    try {
      Ju(_, i.value, ye);
    } finally {
      o || (_.fallbackContext = void 0);
    }
  }
  const U = ge({
    get: () => s.value,
    set: (ye) => {
      s.value = ye, _.fallbackLocale = s.value, D(s.value);
    }
  }), Y = ge(() => u.value), G = /* @__PURE__ */ ge(() => c.value), K = /* @__PURE__ */ ge(() => g.value);
  function W() {
    return xr(T) ? T : null;
  }
  function xe(ye) {
    T = ye, _.postTranslation = ye;
  }
  function Ce() {
    return S;
  }
  function Q(ye) {
    ye !== null && (b = gx(ye)), S = ye, _.missing = b;
  }
  function ue(ye, Ne) {
    return ye !== "translate" || !Ne.resolvedMessage;
  }
  const V = (ye, Ne, At, Ge, Ie, Ze) => {
    $();
    let et;
    try {
      process.env.NODE_ENV, o || (_.fallbackContext = t ? J1() : void 0), et = ye(_);
    } finally {
      process.env.NODE_ENV, o || (_.fallbackContext = void 0);
    }
    if (At !== "translate exists" && // for not `te` (e.g `t`)
    Xr(et) && et === Mm || At === "translate exists" && !et) {
      const [Lt, Ut] = Ne();
      if (process.env.NODE_ENV !== "production" && t && Je(Lt) && ue(At, Ut) && (v && (K0(h, Lt) || Pw(p, Lt)) && ya(Ys(_n.FALLBACK_TO_ROOT, {
        key: Lt,
        type: At
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: fr } = _;
        fr && v && fr.emit("fallback", {
          type: At,
          key: Lt,
          to: "global",
          groupId: Cl(At, Lt)
        });
      }
      return t && v ? Ge(t) : Ie(Lt);
    } else {
      if (Ze(et))
        return et;
      throw Fo(pr.UNEXPECTED_RETURN_TYPE);
    }
  };
  function ae(...ye) {
    return V((Ne) => Reflect.apply(sx, null, [Ne, ...ye]), () => rp(...ye), "translate", (Ne) => Reflect.apply(Ne.t, Ne, [...ye]), (Ne) => Ne, (Ne) => Je(Ne));
  }
  function F(...ye) {
    const [Ne, At, Ge] = ye;
    if (Ge && !Bt(Ge))
      throw Fo(pr.INVALID_ARGUMENT);
    return ae(Ne, At, oo({ resolvedMessage: !0 }, Ge || {}));
  }
  function le(...ye) {
    return V((Ne) => Reflect.apply(ox, null, [Ne, ...ye]), () => ep(...ye), "datetime format", (Ne) => Reflect.apply(Ne.d, Ne, [...ye]), () => Ws, (Ne) => Je(Ne) || vr(Ne));
  }
  function te(...ye) {
    return V((Ne) => Reflect.apply(ax, null, [Ne, ...ye]), () => tp(...ye), "number format", (Ne) => Reflect.apply(Ne.n, Ne, [...ye]), () => Ws, (Ne) => Je(Ne) || vr(Ne));
  }
  function ie(ye) {
    return ye.map((Ne) => Je(Ne) || Xr(Ne) || Wt(Ne) ? dx(String(Ne)) : Ne);
  }
  const I = {
    normalize: ie,
    interpolate: (ye) => ye,
    type: "vnode"
  };
  function ee(...ye) {
    return V((Ne) => {
      let At;
      const Ge = Ne;
      try {
        Ge.processor = I, At = Reflect.apply(sx, null, [Ge, ...ye]);
      } finally {
        Ge.processor = null;
      }
      return At;
    }, () => rp(...ye), "translate", (Ne) => Ne[np](...ye), (Ne) => [dx(Ne)], (Ne) => vr(Ne));
  }
  function Se(...ye) {
    return V((Ne) => Reflect.apply(ax, null, [Ne, ...ye]), () => tp(...ye), "number format", (Ne) => Ne[lp](...ye), cx, (Ne) => Je(Ne) || vr(Ne));
  }
  function pe(...ye) {
    return V((Ne) => Reflect.apply(ox, null, [Ne, ...ye]), () => ep(...ye), "datetime format", (Ne) => Ne[ap](...ye), cx, (Ne) => Je(Ne) || vr(Ne));
  }
  function Ke(ye) {
    m = ye, _.pluralRules = m;
  }
  function Oe(ye, Ne) {
    return V(() => {
      if (!ye)
        return !1;
      const At = Je(Ne) ? Ne : i.value, Ge = Je(Ne) ? [At] : Jf(_, s.value, At);
      for (let Ie = 0; Ie < Ge.length; Ie++) {
        const Ze = Qe(Ge[Ie]);
        let et = _.messageResolver(Ze, ye);
        if (et === null && (et = Ze[ye]), Cn(et) || wn(et) || Je(et))
          return !0;
      }
      return !1;
    }, () => [ye], "translate exists", (At) => Reflect.apply(At.te, At, [ye, Ne]), MI, (At) => Wt(At));
  }
  function Be(ye) {
    let Ne = null;
    const At = Jf(_, s.value, i.value);
    for (let Ge = 0; Ge < At.length; Ge++) {
      const Ie = u.value[At[Ge]] || {}, Ze = _.messageResolver(Ie, ye);
      if (Ze != null) {
        Ne = Ze;
        break;
      }
    }
    return Ne;
  }
  function j(ye) {
    const Ne = Be(ye);
    return Ne ?? (t ? t.tm(ye) || {} : {});
  }
  function Qe(ye) {
    return u.value[ye] || {};
  }
  function Ae(ye, Ne) {
    if (n) {
      const At = { [ye]: Ne };
      for (const Ge in At)
        Mn(At, Ge) && qd(At[Ge]);
      Ne = At[ye];
    }
    u.value[ye] = Ne, _.messages = u.value;
  }
  function re(ye, Ne) {
    u.value[ye] = u.value[ye] || {};
    const At = { [ye]: Ne };
    if (n)
      for (const Ge in At)
        Mn(At, Ge) && qd(At[Ge]);
    Ne = At[ye], xc(Ne, u.value[ye]), _.messages = u.value;
  }
  function ne(ye) {
    return c.value[ye] || {};
  }
  function Le(ye, Ne) {
    c.value[ye] = Ne, _.datetimeFormats = c.value, nx(_, ye, Ne);
  }
  function He(ye, Ne) {
    c.value[ye] = oo(c.value[ye] || {}, Ne), _.datetimeFormats = c.value, nx(_, ye, Ne);
  }
  function ze(ye) {
    return g.value[ye] || {};
  }
  function se(ye, Ne) {
    g.value[ye] = Ne, _.numberFormats = g.value, lx(_, ye, Ne);
  }
  function Fe(ye, Ne) {
    g.value[ye] = oo(g.value[ye] || {}, Ne), _.numberFormats = g.value, lx(_, ye, Ne);
  }
  mx++, nt(s, () => D(s.value), { deep: !0, flush: "sync" }), t && Zn && (nt(t.locale, (ye) => {
    l && (i.value = ye, _.locale = ye, Ju(_, i.value, s.value));
  }), nt(t.fallbackLocale, (ye) => {
    l && (s.value = ye, _.fallbackLocale = s.value, Ju(_, i.value, s.value));
  }));
  const qe = {
    id: mx,
    locale: E,
    fallbackLocale: U,
    get inheritLocale() {
      return l;
    },
    set inheritLocale(ye) {
      l = ye, ye && t && (E.value = t.locale.value, U.value = t.fallbackLocale.value);
    },
    get availableLocales() {
      return Object.keys(u.value).sort();
    },
    messages: Y,
    get modifiers() {
      return O;
    },
    get pluralRules() {
      return m || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return p;
    },
    set missingWarn(ye) {
      p = ye, _.missingWarn = p;
    },
    get fallbackWarn() {
      return h;
    },
    set fallbackWarn(ye) {
      h = ye, _.fallbackWarn = h;
    },
    get fallbackRoot() {
      return v;
    },
    set fallbackRoot(ye) {
      v = ye;
    },
    get fallbackFormat() {
      return A;
    },
    set fallbackFormat(ye) {
      A = ye, _.fallbackFormat = A;
    },
    get warnHtmlMessage() {
      return w;
    },
    set warnHtmlMessage(ye) {
      w = ye, _.warnHtmlMessage = ye;
    },
    get escapeParameter() {
      return N;
    },
    set escapeParameter(ye) {
      N = ye, _.escapeParameter = ye;
    },
    t: ae,
    getLocaleMessage: Qe,
    setLocaleMessage: Ae,
    mergeLocaleMessage: re,
    getPostTranslationHandler: W,
    setPostTranslationHandler: xe,
    getMissingHandler: Ce,
    setMissingHandler: Q,
    [Rw]: Ke
  };
  return qe.datetimeFormats = G, qe.numberFormats = K, qe.rt = F, qe.te = Oe, qe.tm = j, qe.d = le, qe.n = te, qe.getDateTimeFormat = ne, qe.setDateTimeFormat = Le, qe.mergeDateTimeFormat = He, qe.getNumberFormat = ze, qe.setNumberFormat = se, qe.mergeNumberFormat = Fe, qe[Fw] = r, qe[np] = ee, qe[ap] = pe, qe[lp] = Se, process.env.NODE_ENV !== "production" && (qe[Ka] = (ye) => {
    _.__v_emitter = ye;
  }, qe[hi] = () => {
    _.__v_emitter = void 0;
  }), qe;
}
const Xw = "vue-i18n: composer properties", Fg = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n DevTools",
  "vue-i18n-resource-inspector": "Vue I18n DevTools",
  "vue-i18n-timeline": "Vue I18n"
}, CI = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, LI = {
  "vue-i18n-timeline": 16764185
};
let ip;
async function EI(e, t) {
  return new Promise((r, o) => {
    try {
      wI({
        id: "vue-devtools-plugin-vue-i18n",
        label: Fg["vue-devtools-plugin-vue-i18n"],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [Xw],
        app: e
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (n) => {
        ip = n, n.on.visitComponentTree(({ componentInstance: l, treeNode: i }) => {
          OI(l, i, t);
        }), n.on.inspectComponent(({ componentInstance: l, instanceData: i }) => {
          l.__VUE_I18N__ && i && (t.mode === "legacy" ? l.__VUE_I18N__ !== t.global.__composer && fx(i, l.__VUE_I18N__) : fx(i, l.__VUE_I18N__));
        }), n.addInspector({
          id: "vue-i18n-resource-inspector",
          label: Fg["vue-i18n-resource-inspector"],
          icon: "language",
          treeFilterPlaceholder: CI["vue-i18n-resource-inspector"]
        }), n.on.getInspectorTree((l) => {
          l.app === e && l.inspectorId === "vue-i18n-resource-inspector" && BI(l, t);
        });
        const a = /* @__PURE__ */ new Map();
        n.on.getInspectorState(async (l) => {
          if (l.app === e && l.inspectorId === "vue-i18n-resource-inspector")
            if (n.unhighlightElement(), RI(l, t), l.nodeId === "global") {
              if (!a.has(l.app)) {
                const [i] = await n.getComponentInstances(l.app);
                a.set(l.app, i);
              }
              n.highlightElement(a.get(l.app));
            } else {
              const i = II(l.nodeId, t);
              i && n.highlightElement(i);
            }
        }), n.on.editInspectorState((l) => {
          l.app === e && l.inspectorId === "vue-i18n-resource-inspector" && VI(l, t);
        }), n.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: Fg["vue-i18n-timeline"],
          color: LI["vue-i18n-timeline"]
        }), r(!0);
      });
    } catch (n) {
      console.error(n), o(!1);
    }
  });
}
function Ww(e) {
  return e.type.name || e.type.displayName || e.type.__file || "Anonymous";
}
function OI(e, t, r) {
  const o = r.mode === "composition" ? r.global : r.global.__composer;
  if (e && e.__VUE_I18N__ && e.__VUE_I18N__ !== o) {
    const n = {
      label: `i18n (${Ww(e)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    t.tags.push(n);
  }
}
function fx(e, t) {
  const r = Xw;
  e.state.push({
    type: r,
    key: "locale",
    editable: !0,
    value: t.locale.value
  }), e.state.push({
    type: r,
    key: "availableLocales",
    editable: !1,
    value: t.availableLocales
  }), e.state.push({
    type: r,
    key: "fallbackLocale",
    editable: !0,
    value: t.fallbackLocale.value
  }), e.state.push({
    type: r,
    key: "inheritLocale",
    editable: !0,
    value: t.inheritLocale
  }), e.state.push({
    type: r,
    key: "messages",
    editable: !1,
    value: j0(t.messages.value)
  }), e.state.push({
    type: r,
    key: "datetimeFormats",
    editable: !1,
    value: t.datetimeFormats.value
  }), e.state.push({
    type: r,
    key: "numberFormats",
    editable: !1,
    value: t.numberFormats.value
  });
}
function j0(e) {
  const t = {};
  return Object.keys(e).forEach((r) => {
    const o = e[r];
    xr(o) && "source" in o ? t[r] = GI(o) : Cn(o) && o.loc && o.loc.source ? t[r] = o.loc.source : Bt(o) ? t[r] = j0(o) : t[r] = o;
  }), t;
}
const NI = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function DI(e) {
  return e.replace(/[<>"&]/g, kI);
}
function kI(e) {
  return NI[e] || e;
}
function GI(e) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${e.source ? `("${DI(e.source)}")` : "(?)"}`
    }
  };
}
function BI(e, t) {
  e.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const r = t.mode === "composition" ? t.global : t.global.__composer;
  for (const [o, n] of t.__instances) {
    const a = t.mode === "composition" ? n : n.__composer;
    r !== a && e.rootNodes.push({
      id: a.id.toString(),
      label: `${Ww(o)} Scope`
    });
  }
}
function II(e, t) {
  let r = null;
  if (e !== "global") {
    for (const [o, n] of t.__instances.entries())
      if (n.id.toString() === e) {
        r = o;
        break;
      }
  }
  return r;
}
function Yw(e, t) {
  if (e === "global")
    return t.mode === "composition" ? t.global : t.global.__composer;
  {
    const r = Array.from(t.__instances.values()).find((o) => o.id.toString() === e);
    return r ? t.mode === "composition" ? r : r.__composer : null;
  }
}
function RI(e, t) {
  const r = Yw(e.nodeId, t);
  return r && (e.state = FI(r)), null;
}
function FI(e) {
  const t = {}, r = "Locale related info", o = [
    {
      type: r,
      key: "locale",
      editable: !0,
      value: e.locale.value
    },
    {
      type: r,
      key: "fallbackLocale",
      editable: !0,
      value: e.fallbackLocale.value
    },
    {
      type: r,
      key: "availableLocales",
      editable: !1,
      value: e.availableLocales
    },
    {
      type: r,
      key: "inheritLocale",
      editable: !0,
      value: e.inheritLocale
    }
  ];
  t[r] = o;
  const n = "Locale messages info", a = [
    {
      type: n,
      key: "messages",
      editable: !1,
      value: j0(e.messages.value)
    }
  ];
  t[n] = a;
  {
    const l = "Datetime formats info", i = [
      {
        type: l,
        key: "datetimeFormats",
        editable: !1,
        value: e.datetimeFormats.value
      }
    ];
    t[l] = i;
    const s = "Datetime formats info", u = [
      {
        type: s,
        key: "numberFormats",
        editable: !1,
        value: e.numberFormats.value
      }
    ];
    t[s] = u;
  }
  return t;
}
function xi(e, t) {
  if (ip) {
    let r;
    t && "groupId" in t && (r = t.groupId, delete t.groupId), ip.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: e,
        groupId: r,
        time: Date.now(),
        meta: {},
        data: t || {},
        logType: e === "compile-error" ? "error" : e === "fallback" || e === "missing" ? "warning" : "default"
      }
    });
  }
}
function VI(e, t) {
  const r = Yw(e.nodeId, t);
  if (r) {
    const [o] = e.path;
    o === "locale" && Je(e.state.value) ? r.locale.value = e.state.value : o === "fallbackLocale" && (Je(e.state.value) || vr(e.state.value) || Bt(e.state.value)) ? r.fallbackLocale.value = e.state.value : o === "inheritLocale" && Wt(e.state.value) && (r.inheritLocale = e.state.value);
  }
}
function HI(e) {
  const t = Je(e.locale) ? e.locale : zd, r = Je(e.fallbackLocale) || vr(e.fallbackLocale) || rr(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : t, o = xr(e.missing) ? e.missing : void 0, n = Wt(e.silentTranslationWarn) || Us(e.silentTranslationWarn) ? !e.silentTranslationWarn : !0, a = Wt(e.silentFallbackWarn) || Us(e.silentFallbackWarn) ? !e.silentFallbackWarn : !0, l = Wt(e.fallbackRoot) ? e.fallbackRoot : !0, i = !!e.formatFallbackMessages, s = rr(e.modifiers) ? e.modifiers : {}, u = e.pluralizationRules, c = xr(e.postTranslation) ? e.postTranslation : void 0, g = Je(e.warnHtmlInMessage) ? e.warnHtmlInMessage !== "off" : !0, p = !!e.escapeParameterHtml, h = Wt(e.sync) ? e.sync : !0;
  let v = e.messages;
  if (rr(e.sharedMessages)) {
    const O = e.sharedMessages;
    v = Object.keys(O).reduce((_, X) => {
      const $ = _[X] || (_[X] = {});
      return oo($, O[X]), _;
    }, v || {});
  }
  const { __i18n: A, __root: S, __injectWithOption: b } = e, T = e.datetimeFormats, w = e.numberFormats, N = e.flatJson;
  return {
    locale: t,
    fallbackLocale: r,
    messages: v,
    flatJson: N,
    datetimeFormats: T,
    numberFormats: w,
    missing: o,
    missingWarn: n,
    fallbackWarn: a,
    fallbackRoot: l,
    fallbackFormat: i,
    modifiers: s,
    pluralRules: u,
    postTranslation: c,
    warnHtmlMessage: g,
    escapeParameter: p,
    messageResolver: e.messageResolver,
    inheritLocale: h,
    __i18n: A,
    __root: S,
    __injectWithOption: b
  };
}
function sp(e = {}) {
  const t = Xc(HI(e)), { __extender: r } = e, o = {
    // id
    id: t.id,
    // locale
    get locale() {
      return t.locale.value;
    },
    set locale(n) {
      t.locale.value = n;
    },
    // fallbackLocale
    get fallbackLocale() {
      return t.fallbackLocale.value;
    },
    set fallbackLocale(n) {
      t.fallbackLocale.value = n;
    },
    // messages
    get messages() {
      return t.messages.value;
    },
    // datetimeFormats
    get datetimeFormats() {
      return t.datetimeFormats.value;
    },
    // numberFormats
    get numberFormats() {
      return t.numberFormats.value;
    },
    // availableLocales
    get availableLocales() {
      return t.availableLocales;
    },
    // missing
    get missing() {
      return t.getMissingHandler();
    },
    set missing(n) {
      t.setMissingHandler(n);
    },
    // silentTranslationWarn
    get silentTranslationWarn() {
      return Wt(t.missingWarn) ? !t.missingWarn : t.missingWarn;
    },
    set silentTranslationWarn(n) {
      t.missingWarn = Wt(n) ? !n : n;
    },
    // silentFallbackWarn
    get silentFallbackWarn() {
      return Wt(t.fallbackWarn) ? !t.fallbackWarn : t.fallbackWarn;
    },
    set silentFallbackWarn(n) {
      t.fallbackWarn = Wt(n) ? !n : n;
    },
    // modifiers
    get modifiers() {
      return t.modifiers;
    },
    // formatFallbackMessages
    get formatFallbackMessages() {
      return t.fallbackFormat;
    },
    set formatFallbackMessages(n) {
      t.fallbackFormat = n;
    },
    // postTranslation
    get postTranslation() {
      return t.getPostTranslationHandler();
    },
    set postTranslation(n) {
      t.setPostTranslationHandler(n);
    },
    // sync
    get sync() {
      return t.inheritLocale;
    },
    set sync(n) {
      t.inheritLocale = n;
    },
    // warnInHtmlMessage
    get warnHtmlInMessage() {
      return t.warnHtmlMessage ? "warn" : "off";
    },
    set warnHtmlInMessage(n) {
      t.warnHtmlMessage = n !== "off";
    },
    // escapeParameterHtml
    get escapeParameterHtml() {
      return t.escapeParameter;
    },
    set escapeParameterHtml(n) {
      t.escapeParameter = n;
    },
    // pluralizationRules
    get pluralizationRules() {
      return t.pluralRules || {};
    },
    // for internal
    __composer: t,
    // t
    t(...n) {
      return Reflect.apply(t.t, t, [...n]);
    },
    // rt
    rt(...n) {
      return Reflect.apply(t.rt, t, [...n]);
    },
    // te
    te(n, a) {
      return t.te(n, a);
    },
    // tm
    tm(n) {
      return t.tm(n);
    },
    // getLocaleMessage
    getLocaleMessage(n) {
      return t.getLocaleMessage(n);
    },
    // setLocaleMessage
    setLocaleMessage(n, a) {
      t.setLocaleMessage(n, a);
    },
    // mergeLocaleMessage
    mergeLocaleMessage(n, a) {
      t.mergeLocaleMessage(n, a);
    },
    // d
    d(...n) {
      return Reflect.apply(t.d, t, [...n]);
    },
    // getDateTimeFormat
    getDateTimeFormat(n) {
      return t.getDateTimeFormat(n);
    },
    // setDateTimeFormat
    setDateTimeFormat(n, a) {
      t.setDateTimeFormat(n, a);
    },
    // mergeDateTimeFormat
    mergeDateTimeFormat(n, a) {
      t.mergeDateTimeFormat(n, a);
    },
    // n
    n(...n) {
      return Reflect.apply(t.n, t, [...n]);
    },
    // getNumberFormat
    getNumberFormat(n) {
      return t.getNumberFormat(n);
    },
    // setNumberFormat
    setNumberFormat(n, a) {
      t.setNumberFormat(n, a);
    },
    // mergeNumberFormat
    mergeNumberFormat(n, a) {
      t.mergeNumberFormat(n, a);
    }
  };
  return o.__extender = r, process.env.NODE_ENV !== "production" && (o.__enableEmitter = (n) => {
    const a = t;
    a[Ka] && a[Ka](n);
  }, o.__disableEmitter = () => {
    const n = t;
    n[hi] && n[hi]();
  }), o;
}
function UI(e, t, r) {
  return {
    beforeCreate() {
      const o = Ls();
      if (!o)
        throw Fo(pr.UNEXPECTED_ERROR);
      const n = this.$options;
      if (n.i18n) {
        const a = n.i18n;
        if (n.__i18n && (a.__i18n = n.__i18n), a.__root = t, this === this.$root)
          this.$i18n = px(e, a);
        else {
          a.__injectWithOption = !0, a.__extender = r.__vueI18nExtend, this.$i18n = sp(a);
          const l = this.$i18n;
          l.__extender && (l.__disposer = l.__extender(this.$i18n));
        }
      } else if (n.__i18n)
        if (this === this.$root)
          this.$i18n = px(e, n);
        else {
          this.$i18n = sp({
            __i18n: n.__i18n,
            __injectWithOption: !0,
            __extender: r.__vueI18nExtend,
            __root: t
          });
          const a = this.$i18n;
          a.__extender && (a.__disposer = a.__extender(this.$i18n));
        }
      else
        this.$i18n = e;
      n.__i18nGlobal && Uw(t, n, n), this.$t = (...a) => this.$i18n.t(...a), this.$rt = (...a) => this.$i18n.rt(...a), this.$te = (a, l) => this.$i18n.te(a, l), this.$d = (...a) => this.$i18n.d(...a), this.$n = (...a) => this.$i18n.n(...a), this.$tm = (a) => this.$i18n.tm(a), r.__setInstance(o, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$i18n) {
        const o = Ls();
        if (!o)
          return;
        const n = this.$i18n;
        o.__VUE_I18N__ = n.__composer;
        const a = this.__v_emitter = Pm();
        n.__enableEmitter && n.__enableEmitter(a), a.on("*", xi);
      }
    },
    unmounted() {
      const o = Ls();
      if (!o)
        throw Fo(pr.UNEXPECTED_ERROR);
      const n = this.$i18n;
      process.env.NODE_ENV !== "production" && o.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", xi), delete this.__v_emitter), n && (n.__disableEmitter && n.__disableEmitter(), delete o.__VUE_I18N__)), n && (delete this.$t, delete this.$rt, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, n?.__disposer && (n.__disposer(), delete n.__disposer, delete n.__extender), r.__deleteInstance(o), delete this.$i18n);
    }
  };
}
function px(e, t) {
  e.locale = t.locale || e.locale, e.fallbackLocale = t.fallbackLocale || e.fallbackLocale, e.missing = t.missing || e.missing, e.silentTranslationWarn = t.silentTranslationWarn || e.silentFallbackWarn, e.silentFallbackWarn = t.silentFallbackWarn || e.silentFallbackWarn, e.formatFallbackMessages = t.formatFallbackMessages || e.formatFallbackMessages, e.postTranslation = t.postTranslation || e.postTranslation, e.warnHtmlInMessage = t.warnHtmlInMessage || e.warnHtmlInMessage, e.escapeParameterHtml = t.escapeParameterHtml || e.escapeParameterHtml, e.sync = t.sync || e.sync, e.__composer[Rw](t.pluralizationRules || e.pluralizationRules);
  const r = Q0(e.locale, {
    messages: t.messages,
    __i18n: t.__i18n
  });
  return Object.keys(r).forEach((o) => e.mergeLocaleMessage(o, r[o])), t.datetimeFormats && Object.keys(t.datetimeFormats).forEach((o) => e.mergeDateTimeFormat(o, t.datetimeFormats[o])), t.numberFormats && Object.keys(t.numberFormats).forEach((o) => e.mergeNumberFormat(o, t.numberFormats[o])), e;
}
const Z0 = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function XI({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, n) => [
    ...o,
    // prettier-ignore
    ...n.type === De ? n.children : [n]
  ], []) : t.reduce((r, o) => {
    const n = e[o];
    return n && (r[o] = n()), r;
  }, mr());
}
function Kw() {
  return De;
}
const WI = /* @__PURE__ */ wt({
  /* eslint-disable */
  name: "i18n-t",
  props: oo({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      validator: (e) => Xr(e) || !isNaN(e)
    }
  }, Z0),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: r, attrs: o } = t, n = e.i18n || Gn({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const a = () => {
        const s = Object.keys(r).filter((g) => g[0] !== "_"), u = mr();
        e.locale && (u.locale = e.locale), e.plural !== void 0 && (u.plural = Je(e.plural) ? +e.plural : e.plural);
        const c = XI(t, s);
        return n[np](e.keypath, c, u);
      }, l = oo(mr(), o), i = Je(e.tag) || Bt(e.tag) ? e.tag : Kw();
      return Bt(i) ? Ds(i, l, { default: a }) : Ds(i, l, a());
    };
  }
}), hx = WI;
function YI(e) {
  return vr(e) && !Je(e[0]);
}
function Qw(e, t, r, o) {
  const { slots: n, attrs: a } = t;
  return () => {
    const l = () => {
      const u = { part: !0 };
      let c = mr();
      e.locale && (u.locale = e.locale), Je(e.format) ? u.key = e.format : Bt(e.format) && (Je(e.format.key) && (u.key = e.format.key), c = Object.keys(e.format).reduce((h, v) => r.includes(v) ? oo(mr(), h, { [v]: e.format[v] }) : h, mr()));
      const g = o(e.value, u, c);
      let p = [u.key];
      return vr(g) ? p = g.map((h, v) => {
        const A = n[h.type], S = A ? A({ [h.type]: h.value, index: v, parts: g }) : [h.value];
        return YI(S) && (S[0].key = `${h.type}-${v}`), S;
      }) : Je(g) && (p = [g]), p;
    }, i = oo(mr(), a), s = Je(e.tag) || Bt(e.tag) ? e.tag : Kw();
    return Bt(s) ? Ds(s, i, { default: l }) : Ds(s, i, l());
  };
}
const KI = /* @__PURE__ */ wt({
  /* eslint-disable */
  name: "i18n-n",
  props: oo({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Z0),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const r = e.i18n || Gn({
      useScope: e.scope,
      __useComponent: !0
    });
    return Qw(e, t, kw, (...o) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      r[lp](...o)
    ));
  }
}), xx = KI;
function QI(e, t) {
  const r = e;
  if (e.mode === "composition")
    return r.__getInstance(t) || e.global;
  {
    const o = r.__getInstance(t);
    return o != null ? o.__composer : e.global.__composer;
  }
}
function jI(e) {
  const t = (l) => {
    process.env.NODE_ENV !== "production" && H0(Ys(_n.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE));
    const { instance: i, value: s } = l;
    if (!i || !i.$)
      throw Fo(pr.UNEXPECTED_ERROR);
    const u = QI(e, i.$), c = vx(s);
    return [
      Reflect.apply(u.t, u, [...Sx(c)]),
      u
    ];
  };
  return {
    created: (l, i) => {
      const [s, u] = t(i);
      Zn && (l.__i18nWatcher = nt(u.locale, () => {
        i.instance && i.instance.$forceUpdate();
      })), l.__composer = u, l.textContent = s;
    },
    unmounted: (l) => {
      Zn && l.__i18nWatcher && (l.__i18nWatcher(), l.__i18nWatcher = void 0, delete l.__i18nWatcher), l.__composer && (l.__composer = void 0, delete l.__composer);
    },
    beforeUpdate: (l, { value: i }) => {
      if (l.__composer) {
        const s = l.__composer, u = vx(i);
        l.textContent = Reflect.apply(s.t, s, [
          ...Sx(u)
        ]);
      }
    },
    getSSRProps: (l) => {
      const [i] = t(l);
      return { textContent: i };
    }
  };
}
function vx(e) {
  if (Je(e))
    return { path: e };
  if (rr(e)) {
    if (!("path" in e))
      throw Fo(pr.REQUIRED_VALUE, "path");
    return e;
  } else
    throw Fo(pr.INVALID_VALUE);
}
function Sx(e) {
  const { path: t, locale: r, args: o, choice: n, plural: a } = e, l = {}, i = o || {};
  return Je(r) && (l.locale = r), Xr(n) && (l.plural = n), Xr(a) && (l.plural = a), [t, i, l];
}
function ZI(e, t, ...r) {
  const o = rr(r[0]) ? r[0] : {};
  (!Wt(o.globalInstall) || o.globalInstall) && ([hx.name, "I18nT"].forEach((a) => e.component(a, hx)), [xx.name, "I18nN"].forEach((a) => e.component(a, xx)), [wx.name, "I18nD"].forEach((a) => e.component(a, wx))), e.directive("t", jI(t));
}
const zI = /* @__PURE__ */ Aa("global-vue-i18n");
function qI(e = {}) {
  const t = Wt(e.legacy) ? e.legacy : !0;
  process.env.NODE_ENV !== "production" && t && H0(Ys(_n.DEPRECATE_LEGACY_MODE));
  const r = Wt(e.globalInjection) ? e.globalInjection : !0, o = /* @__PURE__ */ new Map(), [n, a] = JI(e, t), l = /* @__PURE__ */ Aa(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  function i(g) {
    return o.get(g) || null;
  }
  function s(g, p) {
    o.set(g, p);
  }
  function u(g) {
    o.delete(g);
  }
  const c = {
    // mode
    get mode() {
      return t ? "legacy" : "composition";
    },
    // install plugin
    async install(g, ...p) {
      if (process.env.NODE_ENV !== "production" && (g.__VUE_I18N__ = c), g.__VUE_I18N_SYMBOL__ = l, g.provide(g.__VUE_I18N_SYMBOL__, c), rr(p[0])) {
        const A = p[0];
        c.__composerExtend = A.__composerExtend, c.__vueI18nExtend = A.__vueI18nExtend;
      }
      let h = null;
      !t && r && (h = l4(g, c.global)), ZI(g, c, ...p), t && g.mixin(UI(a, a.__composer, c));
      const v = g.unmount;
      if (g.unmount = () => {
        h && h(), c.dispose(), v();
      }, process.env.NODE_ENV !== "production") {
        if (!await EI(g, c))
          throw Fo(pr.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
        const S = Pm();
        if (t) {
          const b = a;
          b.__enableEmitter && b.__enableEmitter(S);
        } else {
          const b = a;
          b[Ka] && b[Ka](S);
        }
        S.on("*", xi);
      }
    },
    // global accessor
    get global() {
      return a;
    },
    dispose() {
      n.stop();
    },
    // @internal
    __instances: o,
    // @internal
    __getInstance: i,
    // @internal
    __setInstance: s,
    // @internal
    __deleteInstance: u
  };
  return c;
}
function Gn(e = {}) {
  const t = Ls();
  if (t == null)
    throw Fo(pr.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Fo(pr.NOT_INSTALLED);
  const r = e4(t), o = r4(r), n = Hw(t), a = t4(e, n);
  if (a === "global")
    return Uw(o, e, n), o;
  if (a === "parent") {
    let s = bx(r, t, e.__useComponent);
    return s == null && (process.env.NODE_ENV !== "production" && ya(Ys(_n.NOT_FOUND_PARENT_SCOPE)), s = o), s;
  }
  if (a === "isolated") {
    if (r.mode !== "composition")
      throw Fo(pr.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const s = r, u = oo({}, e), c = bx(r, t);
    u.__root = c || o;
    const g = Xc(u);
    s.__composerExtend && (g[_s] = s.__composerExtend(g));
    let p = null;
    if (process.env.NODE_ENV !== "production") {
      p = Pm();
      const v = g;
      v[Ka] && v[Ka](p), p.on("*", xi);
    }
    return Ap() && Pp(() => {
      if (process.env.NODE_ENV !== "production") {
        p && p.off("*", xi);
        const A = g;
        A[hi] && A[hi]();
      }
      const v = g[_s];
      v && (v(), delete g[_s]);
    }), g;
  }
  const l = r;
  let i = l.__getInstance(t);
  if (i == null) {
    const s = oo({}, e);
    "__i18n" in n && (s.__i18n = n.__i18n), o && (s.__root = o), i = Xc(s), l.__composerExtend && (i[_s] = l.__composerExtend(i)), n4(l, t, i), l.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && a === "local" && ya(Ys(_n.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function JI(e, t) {
  const r = oA(), o = t ? r.run(() => sp(e)) : r.run(() => Xc(e));
  if (o == null)
    throw Fo(pr.UNEXPECTED_ERROR);
  return [r, o];
}
function e4(e) {
  const t = Yn(e.isCE ? zI : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw Fo(e.isCE ? pr.NOT_INSTALLED_WITH_PROVIDE : pr.UNEXPECTED_ERROR);
  return t;
}
function t4(e, t) {
  return R0(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function r4(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function bx(e, t, r = !1) {
  let o = null;
  const n = t.root;
  let a = o4(t, r);
  for (; a != null; ) {
    const l = e;
    if (e.mode === "composition")
      o = l.__getInstance(a);
    else {
      const i = l.__getInstance(a);
      i != null && (o = i.__composer, r && o && !o[Fw] && (o = null));
    }
    if (o != null || n === a)
      break;
    a = a.parent;
  }
  return o;
}
function o4(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function n4(e, t, r) {
  let o = null;
  or(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = r, o = Pm();
      const n = r;
      n[Ka] && n[Ka](o), o.on("*", xi);
    }
  }, t), tn(() => {
    const n = r;
    process.env.NODE_ENV !== "production" && (o && o.off("*", xi), n[hi] && n[hi](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const a = n[_s];
    a && (a(), delete n[_s]);
  }, t);
}
const a4 = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], yx = ["t", "rt", "d", "n", "tm", "te"];
function l4(e, t) {
  const r = /* @__PURE__ */ Object.create(null);
  return a4.forEach((n) => {
    const a = Object.getOwnPropertyDescriptor(t, n);
    if (!a)
      throw Fo(pr.UNEXPECTED_ERROR);
    const l = _c(a.value) ? {
      get() {
        return a.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(i) {
        a.value.value = i;
      }
    } : {
      get() {
        return a.get && a.get();
      }
    };
    Object.defineProperty(r, n, l);
  }), e.config.globalProperties.$i18n = r, yx.forEach((n) => {
    const a = Object.getOwnPropertyDescriptor(t, n);
    if (!a || !a.value)
      throw Fo(pr.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${n}`, a);
  }), () => {
    delete e.config.globalProperties.$i18n, yx.forEach((n) => {
      delete e.config.globalProperties[`$${n}`];
    });
  };
}
const i4 = /* @__PURE__ */ wt({
  /* eslint-disable */
  name: "i18n-d",
  props: oo({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Z0),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const r = e.i18n || Gn({
      useScope: e.scope,
      __useComponent: !0
    });
    return Qw(e, t, Dw, (...o) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      r[ap](...o)
    ));
  }
}), wx = i4;
TI();
ZB(CB);
zB(YB);
qB(Jf);
if (process.env.NODE_ENV !== "production") {
  const e = Am();
  e.__INTLIFY__ = !0, LB(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function s4(e) {
  return Ap() ? (Pp(e), !0) : !1;
}
const z0 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const d4 = Object.prototype.toString, u4 = (e) => d4.call(e) === "[object Object]", Kl = () => {
}, c4 = /* @__PURE__ */ m4();
function m4() {
  var e, t;
  return z0 && ((e = window?.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window?.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function g4(...e) {
  if (e.length !== 1)
    return Ua(...e);
  const t = e[0];
  return typeof t == "function" ? aA(lA(() => ({ get: t, set: Kl }))) : Ee(t);
}
function Vg(e) {
  return Array.isArray(e) ? e : [e];
}
function f4(e, t, r) {
  return nt(
    e,
    t,
    {
      ...r,
      immediate: !0
    }
  );
}
const jw = z0 ? window : void 0;
function Id(e) {
  var t;
  const r = _l(e);
  return (t = r?.$el) != null ? t : r;
}
function Hg(...e) {
  const t = [], r = () => {
    t.forEach((i) => i()), t.length = 0;
  }, o = (i, s, u, c) => (i.addEventListener(s, u, c), () => i.removeEventListener(s, u, c)), n = ge(() => {
    const i = Vg(_l(e[0])).filter((s) => s != null);
    return i.every((s) => typeof s != "string") ? i : void 0;
  }), a = f4(
    () => {
      var i, s;
      return [
        (s = (i = n.value) == null ? void 0 : i.map((u) => Id(u))) != null ? s : [jw].filter((u) => u != null),
        Vg(_l(n.value ? e[1] : e[0])),
        Vg(R(n.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        _l(n.value ? e[3] : e[2])
      ];
    },
    ([i, s, u, c]) => {
      if (r(), !i?.length || !s?.length || !u?.length)
        return;
      const g = u4(c) ? { ...c } : c;
      t.push(
        ...i.flatMap(
          (p) => s.flatMap(
            (h) => u.map((v) => o(p, h, v, g))
          )
        )
      );
    },
    { flush: "post" }
  ), l = () => {
    a(), r();
  };
  return s4(r), l;
}
let _x = !1;
function El(e, t, r = {}) {
  const { window: o = jw, ignore: n = [], capture: a = !0, detectIframe: l = !1, controls: i = !1 } = r;
  if (!o)
    return i ? { stop: Kl, cancel: Kl, trigger: Kl } : Kl;
  if (c4 && !_x) {
    _x = !0;
    const S = { passive: !0 };
    Array.from(o.document.body.children).forEach((b) => b.addEventListener("click", Kl, S)), o.document.documentElement.addEventListener("click", Kl, S);
  }
  let s = !0;
  const u = (S) => _l(n).some((b) => {
    if (typeof b == "string")
      return Array.from(o.document.querySelectorAll(b)).some((T) => T === S.target || S.composedPath().includes(T));
    {
      const T = Id(b);
      return T && (S.target === T || S.composedPath().includes(T));
    }
  });
  function c(S) {
    const b = _l(S);
    return b && b.$.subTree.shapeFlag === 16;
  }
  function g(S, b) {
    const T = _l(S), w = T.$.subTree && T.$.subTree.children;
    return w == null || !Array.isArray(w) ? !1 : w.some((N) => N.el === b.target || b.composedPath().includes(N.el));
  }
  const p = (S) => {
    const b = Id(e);
    if (S.target != null && !(!(b instanceof Element) && c(e) && g(e, S)) && !(!b || b === S.target || S.composedPath().includes(b))) {
      if ("detail" in S && S.detail === 0 && (s = !u(S)), !s) {
        s = !0;
        return;
      }
      t(S);
    }
  };
  let h = !1;
  const v = [
    Hg(o, "click", (S) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), p(S));
    }, { passive: !0, capture: a }),
    Hg(o, "pointerdown", (S) => {
      const b = Id(e);
      s = !u(S) && !!(b && !S.composedPath().includes(b));
    }, { passive: !0 }),
    l && Hg(o, "blur", (S) => {
      setTimeout(() => {
        var b;
        const T = Id(e);
        ((b = o.document.activeElement) == null ? void 0 : b.tagName) === "IFRAME" && !T?.contains(o.document.activeElement) && t(S);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), A = () => v.forEach((S) => S());
  return i ? {
    stop: A,
    cancel: () => {
      s = !1;
    },
    trigger: (S) => {
      s = !0, p(S), s = !1;
    }
  } : A;
}
const q0 = () => {
  const { t: e } = Gn();
  let t = Ee();
  const r = (m = {}) => {
    const _ = "fDPlace" in m ? m.fDPlace : 2;
    return [
      {
        className: "select-checkbox",
        defaultContent: "",
        orderable: !1,
        searchable: !1,
        targets: ("tSelect" in m ? m.tSelect : !1) ? 0 : "none"
      },
      {
        targets: "_all",
        defaultContent: "-",
        orderSequence: ["asc", "desc"]
      },
      {
        targets: "number",
        render: function($, E, D, U) {
          return $ > 0 ? $ : $ == null ? "-" : `<span style="color:red">${$}</span>`;
        }
      },
      {
        targets: "number_format_int",
        render: function($, E, D, U) {
          return Number($).toFixed(0);
        }
      },
      {
        targets: "number_format_float",
        render: function($, E, D, U) {
          const G = (U.settings.aoColumns[U.col].sClass || "").match(/decimal-(\d+)/), K = G ? Number(G[1]) : _;
          let W = Number(Number($).toFixed(K)).toLocaleString("en-US", {
            minimumFractionDigits: K
          });
          return $ > 0 ? `<span style="color:green">${W}</span>` : $ == null ? "-" : `<span style="color:red">${W}</span>`;
        }
      },
      {
        targets: "number_float",
        render: function($, E, D, U) {
          const G = (U.settings.aoColumns[U.col].sClass || "").match(/decimal-(\d+)/), K = G ? Number(G[1]) : _;
          let W = Number(Number($).toFixed(K)).toLocaleString("en-US", {
            minimumFractionDigits: K
          });
          return $ == null ? "-" : W;
        }
      },
      {
        targets: "object",
        render: function($, E, D, U) {
          return $ ? `<pre class="mb-0">${JSON.stringify(t0($), null, 2)}</pre>` : "-";
        }
      },
      {
        targets: "date",
        render: function($, E, D, U) {
          return !$ || $ == "-" ? "-" : Ve($).format("YYYY-MM-DD");
        }
      },
      {
        targets: "datetime",
        render: function($, E, D, U) {
          return !$ || $ == "-" ? "-" : Ve($).format("YYYY-MM-DD HH:mm:ss");
        }
      },
      {
        targets: "datetime-break",
        render: function($, E, D, U) {
          return !$ || $ == "-" ? "-" : Ve($).format("YYYY-MM-DD") + "<br>" + Ve($).format("HH:mm:ss");
        }
      },
      {
        targets: "time",
        render: function($, E, D, U) {
          return !$ || $ == "-" ? "-" : Ve($).format("HH:mm:ss");
        }
      }
    ];
  }, o = (m = !1, _) => ({
    info: e("table.info"),
    infoEmpty: e(_ ? "table.loadingRecords" : "table.infoEmpty"),
    infoFiltered: e("table.infoFiltered"),
    lengthMenu: e(_ ? "table.loadingRecords" : "table.lengthMenu"),
    loadingRecords: e("table.loadingRecords"),
    paginate: {
      first: e(_ ? "table.loadingRecords" : "table.paginate.first"),
      last: e(_ ? "table.loadingRecords" : "table.paginate.last"),
      next: m ? ">" : e(_ ? "table.loadingRecords" : "table.paginate.next"),
      previous: m ? "<" : e(_ ? "table.loadingRecords" : "table.paginate.previous")
    },
    // processing: `<i class="fa fa-spinner fa-spin fa-fw mx-auto"></i> <span>${t('table.processing')}</span>`,
    select: {
      rows: {
        _: e("table.selectRows.mul"),
        0: "",
        1: e("table.selectRows.one")
      }
    },
    zeroRecords: e(_ ? "table.loadingRecords" : "table.zeroRecords")
  }), n = (m = !1) => {
    const _ = m ? 0.5 : 0.515;
    return {
      width: window.innerWidth,
      height: window.innerHeight * _
    };
  }, a = (m, _, X) => {
    let $ = {};
    return _.includes(X.column) ? $ = [
      Object.keys(_).find((E) => _[E] === X.column),
      X.direction
    ] : $ = [1, "asc"], [$];
  }, l = dt({
    fPreData: {},
    tBlade: {},
    vColumnsName: [],
    vColumns: [],
    vRenderTerm: {},
    vTAction: {}
  }), i = dt({
    dDateRangeSettings: {
      "auto-range": 0,
      "enable-seconds": !0,
      "enable-time-picker": !1,
      flow: [],
      // 'flow': ['month', 'year', 'calendar'],
      format: "yyyy-MM-dd HH:mm:ss",
      "max-date": Ve().format("YYYY-MM-DD"),
      "month-picker": !1,
      "multi-calendars": !1,
      "multi-dates": !1,
      "prevent-min-max-navigation": !0,
      range: !0,
      teleport: !0,
      "text-input": !1,
      "time-picker": !1,
      "time-picker-inline": !1,
      vertical: !1,
      "week-picker": !1,
      "year-picker": !1
    },
    dSelectSettings: {
      "allow-empty": !1,
      label: "name",
      "open-direction": "bottom",
      "track-by": "code",
      placeholder: "",
      selectLabel: "",
      deselectLabel: "",
      selectedLabel: ""
    },
    dRenderTerm: {
      dateFormat: ["created", "deleted", "last_login", "updated"],
      upperCase: ["action", "is_hidden", "is_master", "is_master_account", "is_superadmin", "status"]
    },
    table: {
      cKey: 0,
      selected: {
        ids: [],
        rows: [],
        total: 0
      }
    }
  }), s = (m, _) => {
    t = m, l.fPreData = "preData" in _ ? _.preData : null, l.tBlade = "tBlade" in _ ? _.tBlade : {}, l.vColumnsName = "tColumnName" in _ ? _.tColumnName : [], l.vColumns = "tColumns" in _ ? _.tColumns : [], l.vRenderTerm = "dataRenderTerm" in _ ? _.dataRenderTerm : {};
  }, u = (m) => b.value.find((_) => _.data == m)?.id, c = (m, _) => {
    let X = { ...m };
    if (typeof _ == "object")
      for (let $ in _)
        $ in X && (X[$] = _[$]), "enable-time-picker" in _ && _["enable-time-picker"] && (X.format = "yyyy-MM-dd HH:mm:ss");
    return X;
  }, g = (m) => {
    if ("filter" in l.vColumns[m] && typeof l.vColumns[m].filter == "object") {
      const $ = { id: "-1", code: "", name: e("all") };
      var _ = [];
      _ = [
        ...l.vColumns[m].filter.options,
        ..._
      ];
      const E = _.find((U) => U.code == ""), D = l.vColumns[m]?.filter?.settings?.multi;
      var X = [];
      return E ? X = _ : (X = _.sort(function(U, Y) {
        return ["FULL"].includes(U.code) ? 1 : ["FULL"].includes(Y.code) ? -1 : U.name.localeCompare(Y.name);
      }), D || X.unshift($)), X = X.map((U) => U.id === "-1" && U.name !== $.name ? $ : U), X;
    }
    return [];
  }, p = () => {
    t.value.$el.querySelector("tbody").addEventListener("contextmenu", (_) => {
      _.preventDefault();
    });
  }, h = (m) => typeof m == "string" ? m ? `${Ve(m).format("YYYY-MM-DD")}` : "" : m ? `${m[0] ? Ve(m[0]).format("YYYY-MM-DD") : ""} ~ ${m[1] ? Ve(m[1]).format("YYYY-MM-DD") : ""}` : "", v = (m) => {
    var _ = 0;
    for (let X of m) {
      for (const $ in X) {
        if ((i.dRenderTerm.upperCase.includes($) || l.vRenderTerm && "upperCase" in l.vRenderTerm && l.vRenderTerm.upperCase.includes($)) && ((typeof m[_][$] == "string" || m[_][$] instanceof String) && (m[_][$] = m[_][$].toUpperCase()), (typeof m[_][$] == "boolean" || m[_][$] instanceof Boolean) && (m[_][$] = String(m[_][$]).toUpperCase())), $ == "meta")
          for (const E in m[_][$])
            (i.dRenderTerm.dateFormat.includes(E) || l.vRenderTerm && "dateFormat" in l.vRenderTerm && l.vRenderTerm.dateFormat.includes(E)) && (E in m[_][$] && m[_][$][E] ? m[_][$][E] = Ve(m[_][$][E]).format("YYYY-MM-DD HH:mm:ss") : m[_][$][E] = "-");
        l.fPreData instanceof Function && (m[_][$] = l.fPreData($, m[_][$], m[_]));
      }
      _++;
    }
    return m;
  }, A = () => {
    i.table.selected = {
      ids: [],
      rows: [],
      total: 0
    };
  }, S = (m, _) => {
    _ && (t = _);
    let X = t.value.$el.querySelector(".dataTables_processing");
    X ? m ? X.classList.contains("d-inline-block") || X.classList.add("d-inline-block") : X.classList.remove("d-inline-block") : (X = t.value.$el.querySelector(".dt-processing"), m ? X.classList.contains("d-flex") || X.classList.add("d-flex") : X.classList.remove("d-flex"));
  }, b = ge(() => l.vColumnsName.map((m, _) => ({
    id: m,
    data: l.vColumns[m].data,
    className: l.vColumns[m].className || "",
    orderable: "orderable" in l.vColumns[m] ? l.vColumns[m].orderable : !!l.vColumns[m].data,
    width: l.vColumns[m].width || "auto",
    render: l.vColumns[m].render,
    createdCell: l.vColumns[m].createdCell
  }), {})), T = ge(
    () => Object.keys(l.tBlade.columns).filter((m) => !l.tBlade.columns[m].exclude).map((m, _) => ({
      label: l.tBlade.columns[m].label,
      className: l.tBlade.columns[m].className || ""
    }), {})
  ), w = ge(() => {
    var m = {
      1: [],
      2: []
    }, _ = [];
    if (N.value.length == 0)
      m[1] = O.value;
    else
      for (const X in l.tBlade.columns)
        l.tBlade.columns[X].exclude || ("group" in l.tBlade.columns[X] && l.tBlade.columns[X].group?.label ? (m[2].push({
          label: l.tBlade.columns[X].label,
          className: l.tBlade.columns[X].className || "",
          colspan: 1,
          rowspan: 1
        }), _.includes(l.tBlade.columns[X].group?.label) || (m[1].push({
          label: l.tBlade.columns[X].group?.label,
          className: l.tBlade.columns[X].className || "",
          colspan: N.value.filter(
            ($) => $ == l.tBlade.columns[X].group?.label
          ).length,
          rowspan: 1
        }), _.push(l.tBlade.columns[X].group?.label))) : m[1].push({
          label: l.tBlade.columns[X].label,
          className: l.tBlade.columns[X].className || "",
          colspan: 1,
          rowspan: 2
        }));
    return m;
  }), N = ge(() => Object.keys(l.tBlade.columns).filter(
    (m) => !l.tBlade.columns[m].exclude && "group" in l.tBlade.columns[m] && l.tBlade.columns[m].group?.label
  ).map((m, _) => l.tBlade.columns[m].group?.label, {})), O = ge(
    () => Object.keys(l.tBlade.columns).filter((m) => !l.tBlade.columns[m].exclude).map((m, _) => ({
      label: l.tBlade.columns[m].label,
      className: l.tBlade.columns[m].className || "",
      colspan: 1,
      rowspan: 1
    }), {})
  );
  return {
    getTableColumnsDefs: r,
    getTableLocale: o,
    getTableScreenSize: n,
    getTableSorting: a,
    mxLGState: i,
    initListGroup: s,
    getColumnKey: u,
    getDateSetting: c,
    getSelectOption: g,
    onDisabledDefaultRightClick: p,
    onFormatDate: h,
    onPreDataRender: v,
    onResetSelection: A,
    onToggleProcessing: S,
    vTableColumns: b,
    vTableFooters: T,
    vTableHeaders: w,
    vTableGroupHeaders: N,
    vTableSoloHeaders: O
  };
}, Zw = () => {
  let e = Ee();
  const t = dt({
    bTSelect: !1,
    vColumns: [],
    vInitHideColumns: {}
  }), r = dt({
    columnsName: [],
    dSelectColumnSettings: {
      "close-on-select": !1,
      disabled: !1,
      label: "name",
      multiple: !0,
      "open-direction": "bottom",
      "preserve-search": !0,
      "track-by": "code",
      selectLabel: "",
      deselectLabel: ""
    },
    initHideColumns: [],
    selectedColumns: []
  }), o = (s, u) => {
    e = s, t.vColumns = "tColumns" in u ? u.tColumns : [], t.bTSelect = "tSelect" in u ? u.tSelect : !1, t.vInitHideColumns = "tHideColumns" in u ? u.tHideColumns : {}, r.columnsName = Object.keys(u.tColumns);
  }, n = (s) => {
    const u = t.vInitHideColumns, c = [], g = [];
    for (const p of s)
      u[p.code] === !0 ? g.push(p) : c.push(p);
    return r.initHideColumns = g, r.selectedColumns = c, { visibleColumns: c, removedColumns: g };
  }, a = (s) => {
    const c = e.value.dt.column(s.id);
    c.visible(!c.visible());
  }, l = (s) => {
    t.vInitHideColumns = s;
  }, i = ge(() => r.columnsName.filter((s) => !t.vColumns[s].exclude && s != "-").map((s, u) => ({
    id: t.bTSelect ? u + 1 : u,
    code: s,
    name: t.vColumns[s].label
  }), {}));
  return {
    mxLGCVState: r,
    initListColumnVisible: o,
    onFilterColumnsAndGetRemovedIds: n,
    onToggleColumn: a,
    onUpdateColumn: l,
    vTableColumnVisibility: i
  };
}, Tx = [
  "childRow",
  "column-sizing",
  "column-visibility",
  "destroy",
  "draw",
  "error",
  "init",
  "length",
  "order",
  "page",
  "preDraw",
  "preInit",
  "preXhr",
  "processing",
  "requestChild",
  "search",
  "stateLoadParams",
  "stateLoaded",
  "stateSaveParams",
  "xhr",
  "autoFill",
  "preAutoFill",
  "buttons-action",
  "buttons-processing",
  "column-reorder",
  "key",
  "key-blur",
  "key-focus",
  "key-refocus",
  "key-return-submit",
  "responsive-display",
  "responsive-resize",
  "rowgroup-datasrc",
  "pre-row-reorder",
  "row-reorder",
  "row-reordered",
  "dtsb-inserted",
  "deselect",
  "select",
  "select-blur",
  "selectItems",
  "selectStyle",
  "user-select",
  "stateRestore-change"
];
let dp;
const p4 = {
  name: "Datatables.netVue",
  inheritAttrs: !1,
  use(e) {
    dp = e;
  }
}, h4 = /* @__PURE__ */ wt({
  ...p4,
  props: {
    ajax: null,
    columns: null,
    data: null,
    options: null
  },
  emits: Tx,
  setup(e, { expose: t }) {
    const r = e, o = Ee(null), n = {}, a = Ee(), l = Ee([]);
    nt(
      () => r.data,
      (g) => {
        let p = a.value;
        p && (c(p), p.clear(), p.rows.add(g).draw(!1));
      },
      {
        deep: !0
      }
    ), or(() => {
      var g, p;
      const h = Tp();
      let v = Object.assign({}, r.options) || {};
      if (r.data && (v.data = r.data, i(v.data)), r.columns && (v.columns = r.columns), v.columns && u(v.columns, h), r.ajax && (v.ajax = r.ajax), v.columnDefs || (v.columnDefs = []), h) {
        let A = Object.keys(h.slots);
        for (let S = 0; S < A.length; S++) {
          let b = A[S];
          if (b.match(/^column\-/)) {
            let T = b.replace("column-", "");
            v.columnDefs.push({
              target: T.match(/^\d+$/) ? parseInt(T) : T + ":name",
              render: "#" + b
            });
          }
        }
        u(v.columnDefs, h);
      }
      if (!dp)
        throw new Error(
          "DataTables library not set. See https://datatables.net/tn/19 for details."
        );
      a.value = new dp(R(o), v), (g = a.value) == null || g.on("preXhr", () => {
        c(a.value);
      }), (p = a.value) == null || p.on("column-reorder", () => {
        c(a.value);
      });
      for (let A of Tx)
        a.value && h && a.value.on(A, function() {
          var S = Array.from(arguments), b = S.shift();
          S.unshift({ event: b, dt: a }), S.unshift(A), h.emit.apply(h, S);
        });
    }), PS(() => {
      var g;
      c(a.value), (g = a.value) == null || g.destroy(!0);
    });
    function i(g) {
      l.value = g.value ? g.value.slice() : g.slice();
    }
    function s(g) {
      return function(p, h, v, A) {
        let S = (A.settings.sTableId || A.settings.tableId) + "," + A.row + "," + A.col;
        if (!n[S]) {
          let b = Ds("div", g({
            cellData: p,
            colIndex: A.col,
            rowData: v,
            rowIndex: A.row,
            type: h
          }));
          n[S] = document.createElement("div"), Ac(b, n[S]);
        }
        return n[S];
      };
    }
    function u(g, p) {
      if (p)
        for (let v = 0; v < g.length; v++) {
          let A = g[v];
          if (typeof A.render == "string" && A.render.charAt(0) === "#") {
            var h = A.render.replace("#", "");
            p.slots[h] && (A.render = s(p.slots[h]));
          } else if (typeof A.render == "object" && typeof A.render.display == "string" && A.render.display.charAt(0) === "#") {
            var h = A.render.display.replace("#", "");
            p.slots[h] && (A.render.display = s(p.slots[h]));
          }
        }
    }
    function c(g) {
      let p = Object.keys(n), h = g.table().node().id;
      for (var v = 0; v < p.length; v++)
        p[v].indexOf(h + ",") === 0 && (Ac(null, n[p[v]]), delete n[p[v]]);
    }
    return t({
      dt: a
    }), (g, p) => p[0] || (Qh(-1), p[0] = L("div", { class: "datatable" }, [
      L("table", ht({
        ref_key: "table",
        ref: o
      }, g.$attrs, { style: { width: "100%" } }), [
        be(g.$slots, "default")
      ], 16)
    ]), Qh(1), p[0]);
  }
}), J0 = /* @__PURE__ */ (() => {
  const e = h4;
  return e.install = (t) => {
    t.component("Datatables.netVue", e);
  }, e;
})();
function x4(e, t) {
  if (typeof e > "u" || !e.document)
    throw new Error("jQuery requires a window with a document");
  var r = [], o = Object.getPrototypeOf, n = r.slice, a = r.flat ? function(d) {
    return r.flat.call(d);
  } : function(d) {
    return r.concat.apply([], d);
  }, l = r.push, i = r.indexOf, s = {}, u = s.toString, c = s.hasOwnProperty, g = c.toString, p = g.call(Object), h = {};
  function v(d) {
    return d == null ? d + "" : typeof d == "object" ? s[u.call(d)] || "object" : typeof d;
  }
  function A(d) {
    return d != null && d === d.window;
  }
  function S(d) {
    var f = !!d && d.length, x = v(d);
    return typeof d == "function" || A(d) ? !1 : x === "array" || f === 0 || typeof f == "number" && f > 0 && f - 1 in d;
  }
  var b = e.document, T = {
    type: !0,
    src: !0,
    nonce: !0,
    noModule: !0
  };
  function w(d, f, x) {
    x = x || b;
    var y, P = x.createElement("script");
    P.text = d;
    for (y in T)
      f && f[y] && (P[y] = f[y]);
    x.head.appendChild(P).parentNode && P.parentNode.removeChild(P);
  }
  var N = "4.0.0", O = /HTML$/i, m = function(d, f) {
    return new m.fn.init(d, f);
  };
  m.fn = m.prototype = {
    // The current version of jQuery being used
    jquery: N,
    constructor: m,
    // The default length of a jQuery object is 0
    length: 0,
    toArray: function() {
      return n.call(this);
    },
    // Get the Nth element in the matched element set OR
    // Get the whole matched element set as a clean array
    get: function(d) {
      return d == null ? n.call(this) : d < 0 ? this[d + this.length] : this[d];
    },
    // Take an array of elements and push it onto the stack
    // (returning the new matched element set)
    pushStack: function(d) {
      var f = m.merge(this.constructor(), d);
      return f.prevObject = this, f;
    },
    // Execute a callback for every element in the matched set.
    each: function(d) {
      return m.each(this, d);
    },
    map: function(d) {
      return this.pushStack(m.map(this, function(f, x) {
        return d.call(f, x, f);
      }));
    },
    slice: function() {
      return this.pushStack(n.apply(this, arguments));
    },
    first: function() {
      return this.eq(0);
    },
    last: function() {
      return this.eq(-1);
    },
    even: function() {
      return this.pushStack(m.grep(this, function(d, f) {
        return (f + 1) % 2;
      }));
    },
    odd: function() {
      return this.pushStack(m.grep(this, function(d, f) {
        return f % 2;
      }));
    },
    eq: function(d) {
      var f = this.length, x = +d + (d < 0 ? f : 0);
      return this.pushStack(x >= 0 && x < f ? [this[x]] : []);
    },
    end: function() {
      return this.prevObject || this.constructor();
    }
  }, m.extend = m.fn.extend = function() {
    var d, f, x, y, P, M, H = arguments[0] || {}, oe = 1, J = arguments.length, de = !1;
    for (typeof H == "boolean" && (de = H, H = arguments[oe] || {}, oe++), typeof H != "object" && typeof H != "function" && (H = {}), oe === J && (H = this, oe--); oe < J; oe++)
      if ((d = arguments[oe]) != null)
        for (f in d)
          y = d[f], !(f === "__proto__" || H === y) && (de && y && (m.isPlainObject(y) || (P = Array.isArray(y))) ? (x = H[f], P && !Array.isArray(x) ? M = [] : !P && !m.isPlainObject(x) ? M = {} : M = x, P = !1, H[f] = m.extend(de, M, y)) : y !== void 0 && (H[f] = y));
    return H;
  }, m.extend({
    // Unique for each copy of jQuery on the page
    expando: "jQuery" + (N + Math.random()).replace(/\D/g, ""),
    // Assume jQuery is ready without the ready module
    isReady: !0,
    error: function(d) {
      throw new Error(d);
    },
    noop: function() {
    },
    isPlainObject: function(d) {
      var f, x;
      return !d || u.call(d) !== "[object Object]" ? !1 : (f = o(d), f ? (x = c.call(f, "constructor") && f.constructor, typeof x == "function" && g.call(x) === p) : !0);
    },
    isEmptyObject: function(d) {
      var f;
      for (f in d)
        return !1;
      return !0;
    },
    // Evaluates a script in a provided context; falls back to the global one
    // if not specified.
    globalEval: function(d, f, x) {
      w(d, { nonce: f && f.nonce }, x);
    },
    each: function(d, f) {
      var x, y = 0;
      if (S(d))
        for (x = d.length; y < x && f.call(d[y], y, d[y]) !== !1; y++)
          ;
      else
        for (y in d)
          if (f.call(d[y], y, d[y]) === !1)
            break;
      return d;
    },
    // Retrieve the text value of an array of DOM nodes
    text: function(d) {
      var f, x = "", y = 0, P = d.nodeType;
      if (!P)
        for (; f = d[y++]; )
          x += m.text(f);
      return P === 1 || P === 11 ? d.textContent : P === 9 ? d.documentElement.textContent : P === 3 || P === 4 ? d.nodeValue : x;
    },
    // results is for internal usage only
    makeArray: function(d, f) {
      var x = f || [];
      return d != null && (S(Object(d)) ? m.merge(
        x,
        typeof d == "string" ? [d] : d
      ) : l.call(x, d)), x;
    },
    inArray: function(d, f, x) {
      return f == null ? -1 : i.call(f, d, x);
    },
    isXMLDoc: function(d) {
      var f = d && d.namespaceURI, x = d && (d.ownerDocument || d).documentElement;
      return !O.test(f || x && x.nodeName || "HTML");
    },
    // Note: an element does not contain itself
    contains: function(d, f) {
      var x = f && f.parentNode;
      return d === x || !!(x && x.nodeType === 1 && // Support: IE 9 - 11+
      // IE doesn't have `contains` on SVG.
      (d.contains ? d.contains(x) : d.compareDocumentPosition && d.compareDocumentPosition(x) & 16));
    },
    merge: function(d, f) {
      for (var x = +f.length, y = 0, P = d.length; y < x; y++)
        d[P++] = f[y];
      return d.length = P, d;
    },
    grep: function(d, f, x) {
      for (var y, P = [], M = 0, H = d.length, oe = !x; M < H; M++)
        y = !f(d[M], M), y !== oe && P.push(d[M]);
      return P;
    },
    // arg is for internal usage only
    map: function(d, f, x) {
      var y, P, M = 0, H = [];
      if (S(d))
        for (y = d.length; M < y; M++)
          P = f(d[M], M, x), P != null && H.push(P);
      else
        for (M in d)
          P = f(d[M], M, x), P != null && H.push(P);
      return a(H);
    },
    // A global GUID counter for objects
    guid: 1,
    // jQuery.support is not used in Core but other projects attach their
    // properties to it so it needs to exist.
    support: h
  }), typeof Symbol == "function" && (m.fn[Symbol.iterator] = r[Symbol.iterator]), m.each(
    "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
    function(d, f) {
      s["[object " + f + "]"] = f.toLowerCase();
    }
  );
  function _(d, f) {
    return d.nodeName && d.nodeName.toLowerCase() === f.toLowerCase();
  }
  var X = r.pop, $ = "[\\x20\\t\\r\\n\\f]", E = b.documentMode, D = E && new RegExp(
    // Support: IE 9 - 11+
    // IE's :disabled selector does not pick up the children of disabled fieldsets
    ":enabled|:disabled|\\[" + $ + "*name" + $ + "*=" + $ + `*(?:''|"")`
  ), U = new RegExp(
    "^" + $ + "+|((?:^|[^\\\\])(?:\\\\.)*)" + $ + "+$",
    "g"
  ), Y = "(?:\\\\[\\da-fA-F]{1,6}" + $ + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", G = new RegExp("^" + $ + "*([>+~]|" + $ + ")" + $ + "*"), K = new RegExp($ + "|>"), W = /[+~]/, xe = b.documentElement, Ce = xe.matches || xe.msMatchesSelector;
  function Q() {
    var d = [];
    function f(x, y) {
      return d.push(x + " ") > m.expr.cacheLength && delete f[d.shift()], f[x + " "] = y;
    }
    return f;
  }
  function ue(d) {
    return d && typeof d.getElementsByTagName < "u" && d;
  }
  var V = "\\[" + $ + "*(" + Y + ")(?:" + $ + // Operator (capture 2)
  "*([*^$|!~]?=)" + $ + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
  `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + Y + "))|)" + $ + "*\\]", ae = ":(" + Y + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + V + ")*)|.*)\\)|)", F = {
    ID: new RegExp("^#(" + Y + ")"),
    CLASS: new RegExp("^\\.(" + Y + ")"),
    TAG: new RegExp("^(" + Y + "|[*])"),
    ATTR: new RegExp("^" + V),
    PSEUDO: new RegExp("^" + ae),
    CHILD: new RegExp(
      "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + $ + "*(even|odd|(([+-]|)(\\d*)n|)" + $ + "*(?:([+-]|)" + $ + "*(\\d+)|))" + $ + "*\\)|)",
      "i"
    )
  }, le = new RegExp(ae), te = new RegExp("\\\\[\\da-fA-F]{1,6}" + $ + "?|\\\\([^\\r\\n\\f])", "g"), ie = function(d, f) {
    var x = "0x" + d.slice(1) - 65536;
    return f || (x < 0 ? String.fromCharCode(x + 65536) : String.fromCharCode(x >> 10 | 55296, x & 1023 | 56320));
  };
  function B(d) {
    return d.replace(te, ie);
  }
  function I(d) {
    m.error("Syntax error, unrecognized expression: " + d);
  }
  var ee = new RegExp("^" + $ + "*," + $ + "*"), Se = Q();
  function pe(d, f) {
    var x, y, P, M, H, oe, J, de = Se[d + " "];
    if (de)
      return f ? 0 : de.slice(0);
    for (H = d, oe = [], J = m.expr.preFilter; H; ) {
      (!x || (y = ee.exec(H))) && (y && (H = H.slice(y[0].length) || H), oe.push(P = [])), x = !1, (y = G.exec(H)) && (x = y.shift(), P.push({
        value: x,
        // Cast descendant combinators to space
        type: y[0].replace(U, " ")
      }), H = H.slice(x.length));
      for (M in F)
        (y = m.expr.match[M].exec(H)) && (!J[M] || (y = J[M](y))) && (x = y.shift(), P.push({
          value: x,
          type: M,
          matches: y
        }), H = H.slice(x.length));
      if (!x)
        break;
    }
    return f ? H.length : H ? I(d) : (
      // Cache the tokens
      Se(d, oe).slice(0)
    );
  }
  var Ke = {
    ATTR: function(d) {
      return d[1] = B(d[1]), d[3] = B(d[3] || d[4] || d[5] || ""), d[2] === "~=" && (d[3] = " " + d[3] + " "), d.slice(0, 4);
    },
    CHILD: function(d) {
      return d[1] = d[1].toLowerCase(), d[1].slice(0, 3) === "nth" ? (d[3] || I(d[0]), d[4] = +(d[4] ? d[5] + (d[6] || 1) : 2 * (d[3] === "even" || d[3] === "odd")), d[5] = +(d[7] + d[8] || d[3] === "odd")) : d[3] && I(d[0]), d;
    },
    PSEUDO: function(d) {
      var f, x = !d[6] && d[2];
      return F.CHILD.test(d[0]) ? null : (d[3] ? d[2] = d[4] || d[5] || "" : x && le.test(x) && // Get excess from tokenize (recursively)
      (f = pe(x, !0)) && // advance to the next closing parenthesis
      (f = x.indexOf(")", x.length - f) - x.length) && (d[0] = d[0].slice(0, f), d[2] = x.slice(0, f)), d.slice(0, 3));
    }
  };
  function Oe(d) {
    for (var f = 0, x = d.length, y = ""; f < x; f++)
      y += d[f].value;
    return y;
  }
  function Be(d, f, x, y, P, M, H) {
    var oe = 0, J = d.length, de = x == null;
    if (v(x) === "object") {
      P = !0;
      for (oe in x)
        Be(d, f, oe, x[oe], !0, M, H);
    } else if (y !== void 0 && (P = !0, typeof y != "function" && (H = !0), de && (H ? (f.call(d, y), f = null) : (de = f, f = function(he, Pe, fe) {
      return de.call(m(he), fe);
    })), f))
      for (; oe < J; oe++)
        f(
          d[oe],
          x,
          H ? y : y.call(d[oe], oe, f(d[oe], x))
        );
    return P ? d : de ? f.call(d) : J ? f(d[0], x) : M;
  }
  var j = /[^\x20\t\r\n\f]+/g;
  m.fn.extend({
    attr: function(d, f) {
      return Be(this, m.attr, d, f, arguments.length > 1);
    },
    removeAttr: function(d) {
      return this.each(function() {
        m.removeAttr(this, d);
      });
    }
  }), m.extend({
    attr: function(d, f, x) {
      var y, P, M = d.nodeType;
      if (!(M === 3 || M === 8 || M === 2)) {
        if (typeof d.getAttribute > "u")
          return m.prop(d, f, x);
        if ((M !== 1 || !m.isXMLDoc(d)) && (P = m.attrHooks[f.toLowerCase()]), x !== void 0) {
          if (x === null || // For compat with previous handling of boolean attributes,
          // remove when `false` passed. For ARIA attributes -
          // many of which recognize a `"false"` value - continue to
          // set the `"false"` value as jQuery <4 did.
          x === !1 && f.toLowerCase().indexOf("aria-") !== 0) {
            m.removeAttr(d, f);
            return;
          }
          return P && "set" in P && (y = P.set(d, x, f)) !== void 0 ? y : (d.setAttribute(f, x), x);
        }
        return P && "get" in P && (y = P.get(d, f)) !== null ? y : (y = d.getAttribute(f), y ?? void 0);
      }
    },
    attrHooks: {},
    removeAttr: function(d, f) {
      var x, y = 0, P = f && f.match(j);
      if (P && d.nodeType === 1)
        for (; x = P[y++]; )
          d.removeAttribute(x);
    }
  }), E && (m.attrHooks.type = {
    set: function(d, f) {
      if (f === "radio" && _(d, "input")) {
        var x = d.value;
        return d.setAttribute("type", f), x && (d.value = x), f;
      }
    }
  });
  var Qe = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
  function Ae(d, f) {
    return f ? d === "\0" ? "�" : d.slice(0, -1) + "\\" + d.charCodeAt(d.length - 1).toString(16) + " " : "\\" + d;
  }
  m.escapeSelector = function(d) {
    return (d + "").replace(Qe, Ae);
  };
  var re = r.sort, ne = r.splice, Le;
  function He(d, f) {
    if (d === f)
      return Le = !0, 0;
    var x = !d.compareDocumentPosition - !f.compareDocumentPosition;
    return x || (x = (d.ownerDocument || d) == (f.ownerDocument || f) ? d.compareDocumentPosition(f) : (
      // Otherwise we know they are disconnected
      1
    ), x & 1 ? d == b || d.ownerDocument == b && m.contains(b, d) ? -1 : f == b || f.ownerDocument == b && m.contains(b, f) ? 1 : 0 : x & 4 ? -1 : 1);
  }
  m.uniqueSort = function(d) {
    var f, x = [], y = 0, P = 0;
    if (Le = !1, re.call(d, He), Le) {
      for (; f = d[P++]; )
        f === d[P] && (y = x.push(P));
      for (; y--; )
        ne.call(d, x[y], 1);
    }
    return d;
  }, m.fn.uniqueSort = function() {
    return this.pushStack(m.uniqueSort(n.apply(this)));
  };
  var ze, se, Fe, qe, ye, Ne = 0, At = 0, Ge = Q(), Ie = Q(), Ze = Q(), et = new RegExp($ + "+", "g"), Lt = new RegExp("^" + Y + "$"), Ut = m.extend({
    // For use in libraries implementing .is()
    // We use this for POS matching in `select`
    needsContext: new RegExp("^" + $ + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + $ + "*((?:-\\d)?\\d*)" + $ + "*\\)|)(?=[^-]|$)", "i")
  }, F), fr = /^(?:input|select|textarea|button)$/i, xn = /^h\d$/i, Pa = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, ve = function() {
    kr();
  }, Ue = no(
    function(d) {
      return d.disabled === !0 && _(d, "fieldset");
    },
    { dir: "parentNode", next: "legend" }
  );
  function tt(d, f, x, y) {
    var P, M, H, oe, J, de, he, Pe = f && f.ownerDocument, fe = f ? f.nodeType : 9;
    if (x = x || [], typeof d != "string" || !d || fe !== 1 && fe !== 9 && fe !== 11)
      return x;
    if (!y && (kr(f), f = f || Fe, ye)) {
      if (fe !== 11 && (J = Pa.exec(d)))
        if (P = J[1]) {
          if (fe === 9)
            return (H = f.getElementById(P)) && l.call(x, H), x;
          if (Pe && (H = Pe.getElementById(P)) && m.contains(f, H))
            return l.call(x, H), x;
        } else {
          if (J[2])
            return l.apply(x, f.getElementsByTagName(d)), x;
          if ((P = J[3]) && f.getElementsByClassName)
            return l.apply(x, f.getElementsByClassName(P)), x;
        }
      if (!Ze[d + " "] && (!D || !D.test(d))) {
        if (he = d, Pe = f, fe === 1 && (K.test(d) || G.test(d))) {
          for (Pe = W.test(d) && ue(f.parentNode) || f, (Pe != f || E) && ((oe = f.getAttribute("id")) ? oe = m.escapeSelector(oe) : f.setAttribute("id", oe = m.expando)), de = pe(d), M = de.length; M--; )
            de[M] = (oe ? "#" + oe : ":scope") + " " + Oe(de[M]);
          he = de.join(",");
        }
        try {
          return l.apply(
            x,
            Pe.querySelectorAll(he)
          ), x;
        } catch {
          Ze(d, !0);
        } finally {
          oe === m.expando && f.removeAttribute("id");
        }
      }
    }
    return ea(d.replace(U, "$1"), f, x, y);
  }
  function St(d) {
    return d[m.expando] = !0, d;
  }
  function Xe(d) {
    return function(f) {
      return _(f, "input") && f.type === d;
    };
  }
  function ut(d) {
    return function(f) {
      return (_(f, "input") || _(f, "button")) && f.type === d;
    };
  }
  function mt(d) {
    return function(f) {
      return "form" in f ? f.parentNode && f.disabled === !1 ? "label" in f ? "label" in f.parentNode ? f.parentNode.disabled === d : f.disabled === d : f.isDisabled === d || // Where there is no isDisabled, check manually
      f.isDisabled !== !d && Ue(f) === d : f.disabled === d : "label" in f ? f.disabled === d : !1;
    };
  }
  function Dr(d) {
    return St(function(f) {
      return f = +f, St(function(x, y) {
        for (var P, M = d([], x.length, f), H = M.length; H--; )
          x[P = M[H]] && (x[P] = !(y[P] = x[P]));
      });
    });
  }
  function kr(d) {
    var f, x = d ? d.ownerDocument || d : b;
    x == Fe || x.nodeType !== 9 || (Fe = x, qe = Fe.documentElement, ye = !m.isXMLDoc(Fe), E && b != Fe && (f = Fe.defaultView) && f.top !== f && f.addEventListener("unload", ve));
  }
  tt.matches = function(d, f) {
    return tt(d, null, null, f);
  }, tt.matchesSelector = function(d, f) {
    if (kr(d), ye && !Ze[f + " "] && (!D || !D.test(f)))
      try {
        return Ce.call(d, f);
      } catch {
        Ze(f, !0);
      }
    return tt(f, Fe, null, [d]).length > 0;
  }, m.expr = {
    // Can be adjusted by the user
    cacheLength: 50,
    createPseudo: St,
    match: Ut,
    find: {
      ID: function(d, f) {
        if (typeof f.getElementById < "u" && ye) {
          var x = f.getElementById(d);
          return x ? [x] : [];
        }
      },
      TAG: function(d, f) {
        return typeof f.getElementsByTagName < "u" ? f.getElementsByTagName(d) : f.querySelectorAll(d);
      },
      CLASS: function(d, f) {
        if (typeof f.getElementsByClassName < "u" && ye)
          return f.getElementsByClassName(d);
      }
    },
    relative: {
      ">": { dir: "parentNode", first: !0 },
      " ": { dir: "parentNode" },
      "+": { dir: "previousSibling", first: !0 },
      "~": { dir: "previousSibling" }
    },
    preFilter: Ke,
    filter: {
      ID: function(d) {
        var f = B(d);
        return function(x) {
          return x.getAttribute("id") === f;
        };
      },
      TAG: function(d) {
        var f = B(d).toLowerCase();
        return d === "*" ? function() {
          return !0;
        } : function(x) {
          return _(x, f);
        };
      },
      CLASS: function(d) {
        var f = Ge[d + " "];
        return f || (f = new RegExp("(^|" + $ + ")" + d + "(" + $ + "|$)")) && Ge(d, function(x) {
          return f.test(
            typeof x.className == "string" && x.className || typeof x.getAttribute < "u" && x.getAttribute("class") || ""
          );
        });
      },
      ATTR: function(d, f, x) {
        return function(y) {
          var P = m.attr(y, d);
          return P == null ? f === "!=" : f ? (P += "", f === "=" ? P === x : f === "!=" ? P !== x : f === "^=" ? x && P.indexOf(x) === 0 : f === "*=" ? x && P.indexOf(x) > -1 : f === "$=" ? x && P.slice(-x.length) === x : f === "~=" ? (" " + P.replace(et, " ") + " ").indexOf(x) > -1 : f === "|=" ? P === x || P.slice(0, x.length + 1) === x + "-" : !1) : !0;
        };
      },
      CHILD: function(d, f, x, y, P) {
        var M = d.slice(0, 3) !== "nth", H = d.slice(-4) !== "last", oe = f === "of-type";
        return y === 1 && P === 0 ? (
          // Shortcut for :nth-*(n)
          function(J) {
            return !!J.parentNode;
          }
        ) : function(J, de, he) {
          var Pe, fe, Te, lt, Mt, yt = M !== H ? "nextSibling" : "previousSibling", Tr = J.parentNode, br = oe && J.nodeName.toLowerCase(), Wo = !he && !oe, wo = !1;
          if (Tr) {
            if (M) {
              for (; yt; ) {
                for (Te = J; Te = Te[yt]; )
                  if (oe ? _(Te, br) : Te.nodeType === 1)
                    return !1;
                Mt = yt = d === "only" && !Mt && "nextSibling";
              }
              return !0;
            }
            if (Mt = [H ? Tr.firstChild : Tr.lastChild], H && Wo) {
              for (fe = Tr[m.expando] || (Tr[m.expando] = {}), Pe = fe[d] || [], lt = Pe[0] === Ne && Pe[1], wo = lt && Pe[2], Te = lt && Tr.childNodes[lt]; Te = ++lt && Te && Te[yt] || // Fallback to seeking `elem` from the start
              (wo = lt = 0) || Mt.pop(); )
                if (Te.nodeType === 1 && ++wo && Te === J) {
                  fe[d] = [Ne, lt, wo];
                  break;
                }
            } else if (Wo && (fe = J[m.expando] || (J[m.expando] = {}), Pe = fe[d] || [], lt = Pe[0] === Ne && Pe[1], wo = lt), wo === !1)
              for (; (Te = ++lt && Te && Te[yt] || (wo = lt = 0) || Mt.pop()) && !((oe ? _(Te, br) : Te.nodeType === 1) && ++wo && (Wo && (fe = Te[m.expando] || (Te[m.expando] = {}), fe[d] = [Ne, wo]), Te === J)); )
                ;
            return wo -= P, wo === y || wo % y === 0 && wo / y >= 0;
          }
        };
      },
      PSEUDO: function(d, f) {
        var x = m.expr.pseudos[d] || m.expr.setFilters[d.toLowerCase()] || I("unsupported pseudo: " + d);
        return x[m.expando] ? x(f) : x;
      }
    },
    pseudos: {
      // Potentially complex pseudos
      not: St(function(d) {
        var f = [], x = [], y = Gl(d.replace(U, "$1"));
        return y[m.expando] ? St(function(P, M, H, oe) {
          for (var J, de = y(P, null, oe, []), he = P.length; he--; )
            (J = de[he]) && (P[he] = !(M[he] = J));
        }) : function(P, M, H) {
          return f[0] = P, y(f, null, H, x), f[0] = null, !x.pop();
        };
      }),
      has: St(function(d) {
        return function(f) {
          return tt(d, f).length > 0;
        };
      }),
      contains: St(function(d) {
        return d = B(d), function(f) {
          return (f.textContent || m.text(f)).indexOf(d) > -1;
        };
      }),
      // "Whether an element is represented by a :lang() selector
      // is based solely on the element's language value
      // being equal to the identifier C,
      // or beginning with the identifier C immediately followed by "-".
      // The matching of C against the element's language value is performed case-insensitively.
      // The identifier C does not have to be a valid language name."
      // https://www.w3.org/TR/selectors/#lang-pseudo
      lang: St(function(d) {
        return Lt.test(d || "") || I("unsupported lang: " + d), d = B(d).toLowerCase(), function(f) {
          var x;
          do
            if (x = ye ? f.lang : f.getAttribute("xml:lang") || f.getAttribute("lang"))
              return x = x.toLowerCase(), x === d || x.indexOf(d + "-") === 0;
          while ((f = f.parentNode) && f.nodeType === 1);
          return !1;
        };
      }),
      // Miscellaneous
      target: function(d) {
        var f = e.location && e.location.hash;
        return f && f.slice(1) === d.id;
      },
      root: function(d) {
        return d === qe;
      },
      focus: function(d) {
        return d === Fe.activeElement && Fe.hasFocus() && !!(d.type || d.href || ~d.tabIndex);
      },
      // Boolean properties
      enabled: mt(!1),
      disabled: mt(!0),
      checked: function(d) {
        return _(d, "input") && !!d.checked || _(d, "option") && !!d.selected;
      },
      selected: function(d) {
        return E && d.parentNode && d.parentNode.selectedIndex, d.selected === !0;
      },
      // Contents
      empty: function(d) {
        for (d = d.firstChild; d; d = d.nextSibling)
          if (d.nodeType < 6)
            return !1;
        return !0;
      },
      parent: function(d) {
        return !m.expr.pseudos.empty(d);
      },
      // Element/input types
      header: function(d) {
        return xn.test(d.nodeName);
      },
      input: function(d) {
        return fr.test(d.nodeName);
      },
      button: function(d) {
        return _(d, "input") && d.type === "button" || _(d, "button");
      },
      text: function(d) {
        return _(d, "input") && d.type === "text";
      },
      // Position-in-collection
      first: Dr(function() {
        return [0];
      }),
      last: Dr(function(d, f) {
        return [f - 1];
      }),
      eq: Dr(function(d, f, x) {
        return [x < 0 ? x + f : x];
      }),
      even: Dr(function(d, f) {
        for (var x = 0; x < f; x += 2)
          d.push(x);
        return d;
      }),
      odd: Dr(function(d, f) {
        for (var x = 1; x < f; x += 2)
          d.push(x);
        return d;
      }),
      lt: Dr(function(d, f, x) {
        var y;
        for (x < 0 ? y = x + f : x > f ? y = f : y = x; --y >= 0; )
          d.push(y);
        return d;
      }),
      gt: Dr(function(d, f, x) {
        for (var y = x < 0 ? x + f : x; ++y < f; )
          d.push(y);
        return d;
      })
    }
  }, m.expr.pseudos.nth = m.expr.pseudos.eq;
  for (ze in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
    m.expr.pseudos[ze] = Xe(ze);
  for (ze in { submit: !0, reset: !0 })
    m.expr.pseudos[ze] = ut(ze);
  function Uo() {
  }
  Uo.prototype = m.expr.pseudos, m.expr.setFilters = new Uo();
  function no(d, f, x) {
    var y = f.dir, P = f.next, M = P || y, H = x && M === "parentNode", oe = At++;
    return f.first ? (
      // Check against closest ancestor/preceding element
      function(J, de, he) {
        for (; J = J[y]; )
          if (J.nodeType === 1 || H)
            return d(J, de, he);
        return !1;
      }
    ) : (
      // Check against all ancestor/preceding elements
      function(J, de, he) {
        var Pe, fe, Te = [Ne, oe];
        if (he) {
          for (; J = J[y]; )
            if ((J.nodeType === 1 || H) && d(J, de, he))
              return !0;
        } else
          for (; J = J[y]; )
            if (J.nodeType === 1 || H)
              if (fe = J[m.expando] || (J[m.expando] = {}), P && _(J, P))
                J = J[y] || J;
              else {
                if ((Pe = fe[M]) && Pe[0] === Ne && Pe[1] === oe)
                  return Te[2] = Pe[2];
                if (fe[M] = Te, Te[2] = d(J, de, he))
                  return !0;
              }
        return !1;
      }
    );
  }
  function Ma(d) {
    return d.length > 1 ? function(f, x, y) {
      for (var P = d.length; P--; )
        if (!d[P](f, x, y))
          return !1;
      return !0;
    } : d[0];
  }
  function pd(d, f, x) {
    for (var y = 0, P = f.length; y < P; y++)
      tt(d, f[y], x);
    return x;
  }
  function Oi(d, f, x, y, P) {
    for (var M, H = [], oe = 0, J = d.length, de = f != null; oe < J; oe++)
      (M = d[oe]) && (!x || x(M, y, P)) && (H.push(M), de && f.push(oe));
    return H;
  }
  function hd(d, f, x, y, P, M) {
    return y && !y[m.expando] && (y = hd(y)), P && !P[m.expando] && (P = hd(P, M)), St(function(H, oe, J, de) {
      var he, Pe, fe, Te, lt = [], Mt = [], yt = oe.length, Tr = H || pd(
        f || "*",
        J.nodeType ? [J] : J,
        []
      ), br = d && (H || !f) ? Oi(Tr, lt, d, J, de) : Tr;
      if (x ? (Te = P || (H ? d : yt || y) ? (
        // ...intermediate processing is necessary
        []
      ) : (
        // ...otherwise use results directly
        oe
      ), x(br, Te, J, de)) : Te = br, y)
        for (he = Oi(Te, Mt), y(he, [], J, de), Pe = he.length; Pe--; )
          (fe = he[Pe]) && (Te[Mt[Pe]] = !(br[Mt[Pe]] = fe));
      if (H) {
        if (P || d) {
          if (P) {
            for (he = [], Pe = Te.length; Pe--; )
              (fe = Te[Pe]) && he.push(br[Pe] = fe);
            P(null, Te = [], he, de);
          }
          for (Pe = Te.length; Pe--; )
            (fe = Te[Pe]) && (he = P ? i.call(H, fe) : lt[Pe]) > -1 && (H[he] = !(oe[he] = fe));
        }
      } else
        Te = Oi(
          Te === oe ? Te.splice(yt, Te.length) : Te
        ), P ? P(null, oe, Te, de) : l.apply(oe, Te);
    });
  }
  function xd(d) {
    for (var f, x, y, P = d.length, M = m.expr.relative[d[0].type], H = M || m.expr.relative[" "], oe = M ? 1 : 0, J = no(function(Pe) {
      return Pe === f;
    }, H, !0), de = no(function(Pe) {
      return i.call(f, Pe) > -1;
    }, H, !0), he = [function(Pe, fe, Te) {
      var lt = !M && (Te || fe != se) || ((f = fe).nodeType ? J(Pe, fe, Te) : de(Pe, fe, Te));
      return f = null, lt;
    }]; oe < P; oe++)
      if (x = m.expr.relative[d[oe].type])
        he = [no(Ma(he), x)];
      else {
        if (x = m.expr.filter[d[oe].type].apply(null, d[oe].matches), x[m.expando]) {
          for (y = ++oe; y < P && !m.expr.relative[d[y].type]; y++)
            ;
          return hd(
            oe > 1 && Ma(he),
            oe > 1 && Oe(
              // If the preceding token was a descendant combinator, insert an implicit any-element `*`
              d.slice(0, oe - 1).concat({ value: d[oe - 2].type === " " ? "*" : "" })
            ).replace(U, "$1"),
            x,
            oe < y && xd(d.slice(oe, y)),
            y < P && xd(d = d.slice(y)),
            y < P && Oe(d)
          );
        }
        he.push(x);
      }
    return Ma(he);
  }
  function Lu(d, f) {
    var x = f.length > 0, y = d.length > 0, P = function(M, H, oe, J, de) {
      var he, Pe, fe, Te = 0, lt = "0", Mt = M && [], yt = [], Tr = se, br = M || y && m.expr.find.TAG("*", de), Wo = Ne += Tr == null ? 1 : Math.random() || 0.1;
      for (de && (se = H == Fe || H || de); (he = br[lt]) != null; lt++) {
        if (y && he) {
          for (Pe = 0, !H && he.ownerDocument != Fe && (kr(he), oe = !ye); fe = d[Pe++]; )
            if (fe(he, H || Fe, oe)) {
              l.call(J, he);
              break;
            }
          de && (Ne = Wo);
        }
        x && ((he = !fe && he) && Te--, M && Mt.push(he));
      }
      if (Te += lt, x && lt !== Te) {
        for (Pe = 0; fe = f[Pe++]; )
          fe(Mt, yt, H, oe);
        if (M) {
          if (Te > 0)
            for (; lt--; )
              Mt[lt] || yt[lt] || (yt[lt] = X.call(J));
          yt = Oi(yt);
        }
        l.apply(J, yt), de && !M && yt.length > 0 && Te + f.length > 1 && m.uniqueSort(J);
      }
      return de && (Ne = Wo, se = Tr), Mt;
    };
    return x ? St(P) : P;
  }
  function Gl(d, f) {
    var x, y = [], P = [], M = Ie[d + " "];
    if (!M) {
      for (f || (f = pe(d)), x = f.length; x--; )
        M = xd(f[x]), M[m.expando] ? y.push(M) : P.push(M);
      M = Ie(
        d,
        Lu(P, y)
      ), M.selector = d;
    }
    return M;
  }
  function ea(d, f, x, y) {
    var P, M, H, oe, J, de = typeof d == "function" && d, he = !y && pe(d = de.selector || d);
    if (x = x || [], he.length === 1) {
      if (M = he[0] = he[0].slice(0), M.length > 2 && (H = M[0]).type === "ID" && f.nodeType === 9 && ye && m.expr.relative[M[1].type]) {
        if (f = (m.expr.find.ID(
          B(H.matches[0]),
          f
        ) || [])[0], f)
          de && (f = f.parentNode);
        else return x;
        d = d.slice(M.shift().value.length);
      }
      for (P = Ut.needsContext.test(d) ? 0 : M.length; P-- && (H = M[P], !m.expr.relative[oe = H.type]); )
        if ((J = m.expr.find[oe]) && (y = J(
          B(H.matches[0]),
          W.test(M[0].type) && ue(f.parentNode) || f
        ))) {
          if (M.splice(P, 1), d = y.length && Oe(M), !d)
            return l.apply(x, y), x;
          break;
        }
    }
    return (de || Gl(d, he))(
      y,
      f,
      !ye,
      x,
      !f || W.test(d) && ue(f.parentNode) || f
    ), x;
  }
  kr(), m.find = tt, tt.compile = Gl, tt.select = ea, tt.setDocument = kr, tt.tokenize = pe;
  function qa(d, f, x) {
    for (var y = [], P = x !== void 0; (d = d[f]) && d.nodeType !== 9; )
      if (d.nodeType === 1) {
        if (P && m(d).is(x))
          break;
        y.push(d);
      }
    return y;
  }
  function Eu(d, f) {
    for (var x = []; d; d = d.nextSibling)
      d.nodeType === 1 && d !== f && x.push(d);
    return x;
  }
  var Ou = m.expr.match.needsContext, Nu = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function Du(d) {
    return d[0] === "<" && d[d.length - 1] === ">" && d.length >= 3;
  }
  function on(d, f, x) {
    return typeof f == "function" ? m.grep(d, function(y, P) {
      return !!f.call(y, P, y) !== x;
    }) : f.nodeType ? m.grep(d, function(y) {
      return y === f !== x;
    }) : typeof f != "string" ? m.grep(d, function(y) {
      return i.call(f, y) > -1 !== x;
    }) : m.filter(f, d, x);
  }
  m.filter = function(d, f, x) {
    var y = f[0];
    return x && (d = ":not(" + d + ")"), f.length === 1 && y.nodeType === 1 ? m.find.matchesSelector(y, d) ? [y] : [] : m.find.matches(d, m.grep(f, function(P) {
      return P.nodeType === 1;
    }));
  }, m.fn.extend({
    find: function(d) {
      var f, x, y = this.length, P = this;
      if (typeof d != "string")
        return this.pushStack(m(d).filter(function() {
          for (f = 0; f < y; f++)
            if (m.contains(P[f], this))
              return !0;
        }));
      for (x = this.pushStack([]), f = 0; f < y; f++)
        m.find(d, P[f], x);
      return y > 1 ? m.uniqueSort(x) : x;
    },
    filter: function(d) {
      return this.pushStack(on(this, d || [], !1));
    },
    not: function(d) {
      return this.pushStack(on(this, d || [], !0));
    },
    is: function(d) {
      return !!on(
        this,
        // If this is a positional/relative selector, check membership in the returned set
        // so $("p:first").is("p:last") won't return true for a doc with two "p".
        typeof d == "string" && Ou.test(d) ? m(d) : d || [],
        !1
      ).length;
    }
  });
  var Ni, Qm = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, jm = m.fn.init = function(d, f) {
    var x, y;
    if (!d)
      return this;
    if (d.nodeType)
      return this[0] = d, this.length = 1, this;
    if (typeof d == "function")
      return Ni.ready !== void 0 ? Ni.ready(d) : (
        // Execute immediately if ready is not present
        d(m)
      );
    if (x = d + "", Du(x))
      x = [null, d, null];
    else if (typeof d == "string")
      x = Qm.exec(d);
    else
      return m.makeArray(d, this);
    if (x && (x[1] || !f))
      if (x[1]) {
        if (f = f instanceof m ? f[0] : f, m.merge(this, m.parseHTML(
          x[1],
          f && f.nodeType ? f.ownerDocument || f : b,
          !0
        )), Nu.test(x[1]) && m.isPlainObject(f))
          for (x in f)
            typeof this[x] == "function" ? this[x](f[x]) : this.attr(x, f[x]);
        return this;
      } else
        return y = b.getElementById(x[2]), y && (this[0] = y, this.length = 1), this;
    else return !f || f.jquery ? (f || Ni).find(d) : this.constructor(f).find(d);
  };
  jm.prototype = m.fn, Ni = m(b);
  var Zm = /^(?:parents|prev(?:Until|All))/, zm = {
    children: !0,
    contents: !0,
    next: !0,
    prev: !0
  };
  m.fn.extend({
    has: function(d) {
      var f = m(d, this), x = f.length;
      return this.filter(function() {
        for (var y = 0; y < x; y++)
          if (m.contains(this, f[y]))
            return !0;
      });
    },
    closest: function(d, f) {
      var x, y = 0, P = this.length, M = [], H = typeof d != "string" && m(d);
      if (!Ou.test(d)) {
        for (; y < P; y++)
          for (x = this[y]; x && x !== f; x = x.parentNode)
            if (x.nodeType < 11 && (H ? H.index(x) > -1 : (
              // Don't pass non-elements to jQuery#find
              x.nodeType === 1 && m.find.matchesSelector(x, d)
            ))) {
              M.push(x);
              break;
            }
      }
      return this.pushStack(M.length > 1 ? m.uniqueSort(M) : M);
    },
    // Determine the position of an element within the set
    index: function(d) {
      return d ? typeof d == "string" ? i.call(m(d), this[0]) : i.call(
        this,
        // If it receives a jQuery object, the first element is used
        d.jquery ? d[0] : d
      ) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    },
    add: function(d, f) {
      return this.pushStack(
        m.uniqueSort(
          m.merge(this.get(), m(d, f))
        )
      );
    },
    addBack: function(d) {
      return this.add(
        d == null ? this.prevObject : this.prevObject.filter(d)
      );
    }
  });
  function ta(d, f) {
    for (; (d = d[f]) && d.nodeType !== 1; )
      ;
    return d;
  }
  m.each({
    parent: function(d) {
      var f = d.parentNode;
      return f && f.nodeType !== 11 ? f : null;
    },
    parents: function(d) {
      return qa(d, "parentNode");
    },
    parentsUntil: function(d, f, x) {
      return qa(d, "parentNode", x);
    },
    next: function(d) {
      return ta(d, "nextSibling");
    },
    prev: function(d) {
      return ta(d, "previousSibling");
    },
    nextAll: function(d) {
      return qa(d, "nextSibling");
    },
    prevAll: function(d) {
      return qa(d, "previousSibling");
    },
    nextUntil: function(d, f, x) {
      return qa(d, "nextSibling", x);
    },
    prevUntil: function(d, f, x) {
      return qa(d, "previousSibling", x);
    },
    siblings: function(d) {
      return Eu((d.parentNode || {}).firstChild, d);
    },
    children: function(d) {
      return Eu(d.firstChild);
    },
    contents: function(d) {
      return d.contentDocument != null && // Support: IE 11+
      // <object> elements with no `data` attribute has an object
      // `contentDocument` with a `null` prototype.
      o(d.contentDocument) ? d.contentDocument : (_(d, "template") && (d = d.content || d), m.merge([], d.childNodes));
    }
  }, function(d, f) {
    m.fn[d] = function(x, y) {
      var P = m.map(this, f, x);
      return d.slice(-5) !== "Until" && (y = x), y && typeof y == "string" && (P = m.filter(y, P)), this.length > 1 && (zm[d] || m.uniqueSort(P), Zm.test(d) && P.reverse()), this.pushStack(P);
    };
  });
  function qm(d) {
    var f = {};
    return m.each(d.match(j) || [], function(x, y) {
      f[y] = !0;
    }), f;
  }
  m.Callbacks = function(d) {
    d = typeof d == "string" ? qm(d) : m.extend({}, d);
    var f, x, y, P, M = [], H = [], oe = -1, J = function() {
      for (P = P || d.once, y = f = !0; H.length; oe = -1)
        for (x = H.shift(); ++oe < M.length; )
          M[oe].apply(x[0], x[1]) === !1 && d.stopOnFalse && (oe = M.length, x = !1);
      d.memory || (x = !1), f = !1, P && (x ? M = [] : M = "");
    }, de = {
      // Add a callback or a collection of callbacks to the list
      add: function() {
        return M && (x && !f && (oe = M.length - 1, H.push(x)), (function he(Pe) {
          m.each(Pe, function(fe, Te) {
            typeof Te == "function" ? (!d.unique || !de.has(Te)) && M.push(Te) : Te && Te.length && v(Te) !== "string" && he(Te);
          });
        })(arguments), x && !f && J()), this;
      },
      // Remove a callback from the list
      remove: function() {
        return m.each(arguments, function(he, Pe) {
          for (var fe; (fe = m.inArray(Pe, M, fe)) > -1; )
            M.splice(fe, 1), fe <= oe && oe--;
        }), this;
      },
      // Check if a given callback is in the list.
      // If no argument is given, return whether or not list has callbacks attached.
      has: function(he) {
        return he ? m.inArray(he, M) > -1 : M.length > 0;
      },
      // Remove all callbacks from the list
      empty: function() {
        return M && (M = []), this;
      },
      // Disable .fire and .add
      // Abort any current/pending executions
      // Clear all callbacks and values
      disable: function() {
        return P = H = [], M = x = "", this;
      },
      disabled: function() {
        return !M;
      },
      // Disable .fire
      // Also disable .add unless we have memory (since it would have no effect)
      // Abort any pending executions
      lock: function() {
        return P = H = [], !x && !f && (M = x = ""), this;
      },
      locked: function() {
        return !!P;
      },
      // Call all callbacks with the given context and arguments
      fireWith: function(he, Pe) {
        return P || (Pe = Pe || [], Pe = [he, Pe.slice ? Pe.slice() : Pe], H.push(Pe), f || J()), this;
      },
      // Call all the callbacks with the given arguments
      fire: function() {
        return de.fireWith(this, arguments), this;
      },
      // To know if the callbacks have already been called at least once
      fired: function() {
        return !!y;
      }
    };
    return de;
  };
  function Ja(d) {
    return d;
  }
  function Di(d) {
    throw d;
  }
  function ku(d, f, x, y) {
    var P;
    try {
      d && typeof (P = d.promise) == "function" ? P.call(d).done(f).fail(x) : d && typeof (P = d.then) == "function" ? P.call(d, f, x) : f.apply(void 0, [d].slice(y));
    } catch (M) {
      x(M);
    }
  }
  m.extend({
    Deferred: function(d) {
      var f = [
        // action, add listener, callbacks,
        // ... .then handlers, argument index, [final state]
        [
          "notify",
          "progress",
          m.Callbacks("memory"),
          m.Callbacks("memory"),
          2
        ],
        [
          "resolve",
          "done",
          m.Callbacks("once memory"),
          m.Callbacks("once memory"),
          0,
          "resolved"
        ],
        [
          "reject",
          "fail",
          m.Callbacks("once memory"),
          m.Callbacks("once memory"),
          1,
          "rejected"
        ]
      ], x = "pending", y = {
        state: function() {
          return x;
        },
        always: function() {
          return P.done(arguments).fail(arguments), this;
        },
        catch: function(M) {
          return y.then(null, M);
        },
        // Keep pipe for back-compat
        pipe: function() {
          var M = arguments;
          return m.Deferred(function(H) {
            m.each(f, function(oe, J) {
              var de = typeof M[J[4]] == "function" && M[J[4]];
              P[J[1]](function() {
                var he = de && de.apply(this, arguments);
                he && typeof he.promise == "function" ? he.promise().progress(H.notify).done(H.resolve).fail(H.reject) : H[J[0] + "With"](
                  this,
                  de ? [he] : arguments
                );
              });
            }), M = null;
          }).promise();
        },
        then: function(M, H, oe) {
          var J = 0;
          function de(he, Pe, fe, Te) {
            return function() {
              var lt = this, Mt = arguments, yt = function() {
                var br, Wo;
                if (!(he < J)) {
                  if (br = fe.apply(lt, Mt), br === Pe.promise())
                    throw new TypeError("Thenable self-resolution");
                  Wo = br && // Support: Promises/A+ section 2.3.4
                  // https://promisesaplus.com/#point-64
                  // Only check objects and functions for thenability
                  (typeof br == "object" || typeof br == "function") && br.then, typeof Wo == "function" ? Te ? Wo.call(
                    br,
                    de(J, Pe, Ja, Te),
                    de(J, Pe, Di, Te)
                  ) : (J++, Wo.call(
                    br,
                    de(J, Pe, Ja, Te),
                    de(J, Pe, Di, Te),
                    de(
                      J,
                      Pe,
                      Ja,
                      Pe.notifyWith
                    )
                  )) : (fe !== Ja && (lt = void 0, Mt = [br]), (Te || Pe.resolveWith)(lt, Mt));
                }
              }, Tr = Te ? yt : function() {
                try {
                  yt();
                } catch (br) {
                  m.Deferred.exceptionHook && m.Deferred.exceptionHook(
                    br,
                    Tr.error
                  ), he + 1 >= J && (fe !== Di && (lt = void 0, Mt = [br]), Pe.rejectWith(lt, Mt));
                }
              };
              he ? Tr() : (m.Deferred.getErrorHook && (Tr.error = m.Deferred.getErrorHook()), e.setTimeout(Tr));
            };
          }
          return m.Deferred(function(he) {
            f[0][3].add(
              de(
                0,
                he,
                typeof oe == "function" ? oe : Ja,
                he.notifyWith
              )
            ), f[1][3].add(
              de(
                0,
                he,
                typeof M == "function" ? M : Ja
              )
            ), f[2][3].add(
              de(
                0,
                he,
                typeof H == "function" ? H : Di
              )
            );
          }).promise();
        },
        // Get a promise for this deferred
        // If obj is provided, the promise aspect is added to the object
        promise: function(M) {
          return M != null ? m.extend(M, y) : y;
        }
      }, P = {};
      return m.each(f, function(M, H) {
        var oe = H[2], J = H[5];
        y[H[1]] = oe.add, J && oe.add(
          function() {
            x = J;
          },
          // rejected_callbacks.disable
          // fulfilled_callbacks.disable
          f[3 - M][2].disable,
          // rejected_handlers.disable
          // fulfilled_handlers.disable
          f[3 - M][3].disable,
          // progress_callbacks.lock
          f[0][2].lock,
          // progress_handlers.lock
          f[0][3].lock
        ), oe.add(H[3].fire), P[H[0]] = function() {
          return P[H[0] + "With"](this === P ? void 0 : this, arguments), this;
        }, P[H[0] + "With"] = oe.fireWith;
      }), y.promise(P), d && d.call(P, P), P;
    },
    // Deferred helper
    when: function(d) {
      var f = arguments.length, x = f, y = Array(x), P = n.call(arguments), M = m.Deferred(), H = function(oe) {
        return function(J) {
          y[oe] = this, P[oe] = arguments.length > 1 ? n.call(arguments) : J, --f || M.resolveWith(y, P);
        };
      };
      if (f <= 1 && (ku(
        d,
        M.done(H(x)).resolve,
        M.reject,
        !f
      ), M.state() === "pending" || typeof (P[x] && P[x].then) == "function"))
        return M.then();
      for (; x--; )
        ku(P[x], H(x), M.reject);
      return M.promise();
    }
  });
  var Jm = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  m.Deferred.exceptionHook = function(d, f) {
    d && Jm.test(d.name) && e.console.warn(
      "jQuery.Deferred exception",
      d,
      f
    );
  }, m.readyException = function(d) {
    e.setTimeout(function() {
      throw d;
    });
  };
  var el = m.Deferred();
  m.fn.ready = function(d) {
    return el.then(d).catch(function(f) {
      m.readyException(f);
    }), this;
  }, m.extend({
    // Is the DOM ready to be used? Set to true once it occurs.
    isReady: !1,
    // A counter to track how many items to wait for before
    // the ready event fires. See trac-6781
    readyWait: 1,
    // Handle when the DOM is ready
    ready: function(d) {
      (d === !0 ? --m.readyWait : m.isReady) || (m.isReady = !0, !(d !== !0 && --m.readyWait > 0) && el.resolveWith(b, [m]));
    }
  }), m.ready.then = el.then;
  function ki() {
    b.removeEventListener("DOMContentLoaded", ki), e.removeEventListener("load", ki), m.ready();
  }
  b.readyState !== "loading" ? e.setTimeout(m.ready) : (b.addEventListener("DOMContentLoaded", ki), e.addEventListener("load", ki));
  var eg = /-([a-z])/g;
  function ra(d, f) {
    return f.toUpperCase();
  }
  function $a(d) {
    return d.replace(eg, ra);
  }
  function Bl(d) {
    return d.nodeType === 1 || d.nodeType === 9 || !+d.nodeType;
  }
  function Il() {
    this.expando = m.expando + Il.uid++;
  }
  Il.uid = 1, Il.prototype = {
    cache: function(d) {
      var f = d[this.expando];
      return f || (f = /* @__PURE__ */ Object.create(null), Bl(d) && (d.nodeType ? d[this.expando] = f : Object.defineProperty(d, this.expando, {
        value: f,
        configurable: !0
      }))), f;
    },
    set: function(d, f, x) {
      var y, P = this.cache(d);
      if (typeof f == "string")
        P[$a(f)] = x;
      else
        for (y in f)
          P[$a(y)] = f[y];
      return x;
    },
    get: function(d, f) {
      return f === void 0 ? this.cache(d) : (
        // Always use camelCase key (gh-2257)
        d[this.expando] && d[this.expando][$a(f)]
      );
    },
    access: function(d, f, x) {
      return f === void 0 || f && typeof f == "string" && x === void 0 ? this.get(d, f) : (this.set(d, f, x), x !== void 0 ? x : f);
    },
    remove: function(d, f) {
      var x, y = d[this.expando];
      if (y !== void 0) {
        if (f !== void 0)
          for (Array.isArray(f) ? f = f.map($a) : (f = $a(f), f = f in y ? [f] : f.match(j) || []), x = f.length; x--; )
            delete y[f[x]];
        (f === void 0 || m.isEmptyObject(y)) && (d.nodeType ? d[this.expando] = void 0 : delete d[this.expando]);
      }
    },
    hasData: function(d) {
      var f = d[this.expando];
      return f !== void 0 && !m.isEmptyObject(f);
    }
  };
  var Pt = new Il(), So = new Il(), tg = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, Gi = /[A-Z]/g;
  function rg(d) {
    return d === "true" ? !0 : d === "false" ? !1 : d === "null" ? null : d === +d + "" ? +d : tg.test(d) ? JSON.parse(d) : d;
  }
  function tl(d, f, x) {
    var y;
    if (x === void 0 && d.nodeType === 1)
      if (y = "data-" + f.replace(Gi, "-$&").toLowerCase(), x = d.getAttribute(y), typeof x == "string") {
        try {
          x = rg(x);
        } catch {
        }
        So.set(d, f, x);
      } else
        x = void 0;
    return x;
  }
  m.extend({
    hasData: function(d) {
      return So.hasData(d) || Pt.hasData(d);
    },
    data: function(d, f, x) {
      return So.access(d, f, x);
    },
    removeData: function(d, f) {
      So.remove(d, f);
    },
    // TODO: Now that all calls to _data and _removeData have been replaced
    // with direct calls to dataPriv methods, these can be deprecated.
    _data: function(d, f, x) {
      return Pt.access(d, f, x);
    },
    _removeData: function(d, f) {
      Pt.remove(d, f);
    }
  }), m.fn.extend({
    data: function(d, f) {
      var x, y, P, M = this[0], H = M && M.attributes;
      if (d === void 0) {
        if (this.length && (P = So.get(M), M.nodeType === 1 && !Pt.get(M, "hasDataAttrs"))) {
          for (x = H.length; x--; )
            H[x] && (y = H[x].name, y.indexOf("data-") === 0 && (y = $a(y.slice(5)), tl(M, y, P[y])));
          Pt.set(M, "hasDataAttrs", !0);
        }
        return P;
      }
      return typeof d == "object" ? this.each(function() {
        So.set(this, d);
      }) : Be(this, function(oe) {
        var J;
        if (M && oe === void 0)
          return J = So.get(M, d), J !== void 0 || (J = tl(M, d), J !== void 0) ? J : void 0;
        this.each(function() {
          So.set(this, d, oe);
        });
      }, null, f, arguments.length > 1, null, !0);
    },
    removeData: function(d) {
      return this.each(function() {
        So.remove(this, d);
      });
    }
  }), m.extend({
    queue: function(d, f, x) {
      var y;
      if (d)
        return f = (f || "fx") + "queue", y = Pt.get(d, f), x && (!y || Array.isArray(x) ? y = Pt.set(d, f, m.makeArray(x)) : y.push(x)), y || [];
    },
    dequeue: function(d, f) {
      f = f || "fx";
      var x = m.queue(d, f), y = x.length, P = x.shift(), M = m._queueHooks(d, f), H = function() {
        m.dequeue(d, f);
      };
      P === "inprogress" && (P = x.shift(), y--), P && (f === "fx" && x.unshift("inprogress"), delete M.stop, P.call(d, H, M)), !y && M && M.empty.fire();
    },
    // Not public - generate a queueHooks object, or return the current one
    _queueHooks: function(d, f) {
      var x = f + "queueHooks";
      return Pt.get(d, x) || Pt.set(d, x, {
        empty: m.Callbacks("once memory").add(function() {
          Pt.remove(d, [f + "queue", x]);
        })
      });
    }
  }), m.fn.extend({
    queue: function(d, f) {
      var x = 2;
      return typeof d != "string" && (f = d, d = "fx", x--), arguments.length < x ? m.queue(this[0], d) : f === void 0 ? this : this.each(function() {
        var y = m.queue(this, d, f);
        m._queueHooks(this, d), d === "fx" && y[0] !== "inprogress" && m.dequeue(this, d);
      });
    },
    dequeue: function(d) {
      return this.each(function() {
        m.dequeue(this, d);
      });
    },
    clearQueue: function(d) {
      return this.queue(d || "fx", []);
    },
    // Get a promise resolved when queues of a certain type
    // are emptied (fx is the type by default)
    promise: function(d, f) {
      var x, y = 1, P = m.Deferred(), M = this, H = this.length, oe = function() {
        --y || P.resolveWith(M, [M]);
      };
      for (typeof d != "string" && (f = d, d = void 0), d = d || "fx"; H--; )
        x = Pt.get(M[H], d + "queueHooks"), x && x.empty && (y++, x.empty.add(oe));
      return oe(), P.promise(f);
    }
  });
  var vd = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, rl = new RegExp("^(?:([+-])=|)(" + vd + ")([a-z%]*)$", "i"), oa = ["Top", "Right", "Bottom", "Left"];
  function Bi(d, f) {
    return d = f || d, d.style.display === "none" || d.style.display === "" && m.css(d, "display") === "none";
  }
  var og = /^[a-z]/, ng = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
  function Rl(d) {
    return og.test(d) && ng.test(d[0].toUpperCase() + d.slice(1));
  }
  function Gu(d, f, x, y) {
    var P, M, H = 20, oe = y ? function() {
      return y.cur();
    } : function() {
      return m.css(d, f, "");
    }, J = oe(), de = x && x[3] || (Rl(f) ? "px" : ""), he = d.nodeType && (!Rl(f) || de !== "px" && +J) && rl.exec(m.css(d, f));
    if (he && he[3] !== de) {
      for (J = J / 2, de = de || he[3], he = +J || 1; H--; )
        m.style(d, f, he + de), (1 - M) * (1 - (M = oe() / J || 0.5)) <= 0 && (H = 0), he = he / M;
      he = he * 2, m.style(d, f, he + de), x = x || [];
    }
    return x && (he = +he || +J || 0, P = x[1] ? he + (x[1] + 1) * x[2] : +x[2], y && (y.unit = de, y.start = he, y.end = P)), P;
  }
  var ag = /^-ms-/;
  function Ii(d) {
    return $a(d.replace(ag, "ms-"));
  }
  var Fl = {};
  function ol(d) {
    var f, x = d.ownerDocument, y = d.nodeName, P = Fl[y];
    return P || (f = x.body.appendChild(x.createElement(y)), P = m.css(f, "display"), f.parentNode.removeChild(f), P === "none" && (P = "block"), Fl[y] = P, P);
  }
  function nl(d, f) {
    for (var x, y, P = [], M = 0, H = d.length; M < H; M++)
      y = d[M], y.style && (x = y.style.display, f ? (x === "none" && (P[M] = Pt.get(y, "display") || null, P[M] || (y.style.display = "")), y.style.display === "" && Bi(y) && (P[M] = ol(y))) : x !== "none" && (P[M] = "none", Pt.set(y, "display", x)));
    for (M = 0; M < H; M++)
      P[M] != null && (d[M].style.display = P[M]);
    return d;
  }
  m.fn.extend({
    show: function() {
      return nl(this, !0);
    },
    hide: function() {
      return nl(this);
    },
    toggle: function(d) {
      return typeof d == "boolean" ? d ? this.show() : this.hide() : this.each(function() {
        Bi(this) ? m(this).show() : m(this).hide();
      });
    }
  });
  var Vl = function(d) {
    return m.contains(d.ownerDocument, d) || d.getRootNode(na) === d.ownerDocument;
  }, na = { composed: !0 };
  xe.getRootNode || (Vl = function(d) {
    return m.contains(d.ownerDocument, d);
  });
  var Bu = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, In = {
    // Table parts need to be wrapped with `<table>` or they're
    // stripped to their contents when put in a div.
    // XHTML parsers do not magically insert elements in the
    // same way that tag soup parsers do, so we cannot shorten
    // this by omitting <tbody> or other required elements.
    thead: ["table"],
    col: ["colgroup", "table"],
    tr: ["tbody", "table"],
    td: ["tr", "tbody", "table"]
  };
  In.tbody = In.tfoot = In.colgroup = In.caption = In.thead, In.th = In.td;
  function bo(d, f) {
    var x;
    return typeof d.getElementsByTagName < "u" ? x = r.slice.call(d.getElementsByTagName(f || "*")) : typeof d.querySelectorAll < "u" ? x = d.querySelectorAll(f || "*") : x = [], f === void 0 || f && _(d, f) ? m.merge([d], x) : x;
  }
  var Iu = /^$|^module$|\/(?:java|ecma)script/i;
  function Sd(d, f) {
    for (var x = 0, y = d.length; x < y; x++)
      Pt.set(
        d[x],
        "globalEval",
        !f || Pt.get(f[x], "globalEval")
      );
  }
  var Ca = /<|&#?\w+;/;
  function bd(d, f, x, y, P) {
    for (var M, H, oe, J, de, he, Pe = f.createDocumentFragment(), fe = [], Te = 0, lt = d.length; Te < lt; Te++)
      if (M = d[Te], M || M === 0)
        if (v(M) === "object" && (M.nodeType || S(M)))
          m.merge(fe, M.nodeType ? [M] : M);
        else if (!Ca.test(M))
          fe.push(f.createTextNode(M));
        else {
          for (H = H || Pe.appendChild(f.createElement("div")), oe = (Bu.exec(M) || ["", ""])[1].toLowerCase(), J = In[oe] || r, he = J.length; --he > -1; )
            H = H.appendChild(f.createElement(J[he]));
          H.innerHTML = m.htmlPrefilter(M), m.merge(fe, H.childNodes), H = Pe.firstChild, H.textContent = "";
        }
    for (Pe.textContent = "", Te = 0; M = fe[Te++]; ) {
      if (y && m.inArray(M, y) > -1) {
        P && P.push(M);
        continue;
      }
      if (de = Vl(M), H = bo(Pe.appendChild(M), "script"), de && Sd(H), x)
        for (he = 0; M = H[he++]; )
          Iu.test(M.type || "") && x.push(M);
    }
    return Pe;
  }
  function lg(d) {
    return d.type = (d.getAttribute("type") !== null) + "/" + d.type, d;
  }
  function Ri(d) {
    return (d.type || "").slice(0, 5) === "true/" ? d.type = d.type.slice(5) : d.removeAttribute("type"), d;
  }
  function al(d, f, x, y) {
    f = a(f);
    var P, M, H, oe, J, de, he = 0, Pe = d.length, fe = Pe - 1, Te = f[0], lt = typeof Te == "function";
    if (lt)
      return d.each(function(Mt) {
        var yt = d.eq(Mt);
        f[0] = Te.call(this, Mt, yt.html()), al(yt, f, x, y);
      });
    if (Pe && (P = bd(f, d[0].ownerDocument, !1, d, y), M = P.firstChild, P.childNodes.length === 1 && (P = M), M || y)) {
      for (H = m.map(bo(P, "script"), lg), oe = H.length; he < Pe; he++)
        J = P, he !== fe && (J = m.clone(J, !0, !0), oe && m.merge(H, bo(J, "script"))), x.call(d[he], J, he);
      if (oe)
        for (de = H[H.length - 1].ownerDocument, m.map(H, Ri), he = 0; he < oe; he++)
          J = H[he], Iu.test(J.type || "") && !Pt.get(J, "globalEval") && m.contains(de, J) && (J.src && (J.type || "").toLowerCase() !== "module" ? m._evalUrl && !J.noModule && m._evalUrl(J.src, {
            nonce: J.nonce,
            crossOrigin: J.crossOrigin
          }, de) : w(J.textContent, J, de));
    }
    return d;
  }
  var ll = /^(?:checkbox|radio)$/i, Ru = /^([^.]*)(?:\.(.+)|)/;
  function La() {
    return !0;
  }
  function Ea() {
    return !1;
  }
  function Fi(d, f, x, y, P, M) {
    var H, oe;
    if (typeof f == "object") {
      typeof x != "string" && (y = y || x, x = void 0);
      for (oe in f)
        Fi(d, oe, x, y, f[oe], M);
      return d;
    }
    if (y == null && P == null ? (P = x, y = x = void 0) : P == null && (typeof x == "string" ? (P = y, y = void 0) : (P = y, y = x, x = void 0)), P === !1)
      P = Ea;
    else if (!P)
      return d;
    return M === 1 && (H = P, P = function(J) {
      return m().off(J), H.apply(this, arguments);
    }, P.guid = H.guid || (H.guid = m.guid++)), d.each(function() {
      m.event.add(this, f, P, y, x);
    });
  }
  m.event = {
    add: function(d, f, x, y, P) {
      var M, H, oe, J, de, he, Pe, fe, Te, lt, Mt, yt = Pt.get(d);
      if (Bl(d))
        for (x.handler && (M = x, x = M.handler, P = M.selector), P && m.find.matchesSelector(xe, P), x.guid || (x.guid = m.guid++), (J = yt.events) || (J = yt.events = /* @__PURE__ */ Object.create(null)), (H = yt.handle) || (H = yt.handle = function(Tr) {
          return typeof m < "u" && m.event.triggered !== Tr.type ? m.event.dispatch.apply(d, arguments) : void 0;
        }), f = (f || "").match(j) || [""], de = f.length; de--; )
          oe = Ru.exec(f[de]) || [], Te = Mt = oe[1], lt = (oe[2] || "").split(".").sort(), Te && (Pe = m.event.special[Te] || {}, Te = (P ? Pe.delegateType : Pe.bindType) || Te, Pe = m.event.special[Te] || {}, he = m.extend({
            type: Te,
            origType: Mt,
            data: y,
            handler: x,
            guid: x.guid,
            selector: P,
            needsContext: P && m.expr.match.needsContext.test(P),
            namespace: lt.join(".")
          }, M), (fe = J[Te]) || (fe = J[Te] = [], fe.delegateCount = 0, (!Pe.setup || Pe.setup.call(d, y, lt, H) === !1) && d.addEventListener && d.addEventListener(Te, H)), Pe.add && (Pe.add.call(d, he), he.handler.guid || (he.handler.guid = x.guid)), P ? fe.splice(fe.delegateCount++, 0, he) : fe.push(he));
    },
    // Detach an event or set of events from an element
    remove: function(d, f, x, y, P) {
      var M, H, oe, J, de, he, Pe, fe, Te, lt, Mt, yt = Pt.hasData(d) && Pt.get(d);
      if (!(!yt || !(J = yt.events))) {
        for (f = (f || "").match(j) || [""], de = f.length; de--; ) {
          if (oe = Ru.exec(f[de]) || [], Te = Mt = oe[1], lt = (oe[2] || "").split(".").sort(), !Te) {
            for (Te in J)
              m.event.remove(d, Te + f[de], x, y, !0);
            continue;
          }
          for (Pe = m.event.special[Te] || {}, Te = (y ? Pe.delegateType : Pe.bindType) || Te, fe = J[Te] || [], oe = oe[2] && new RegExp("(^|\\.)" + lt.join("\\.(?:.*\\.|)") + "(\\.|$)"), H = M = fe.length; M--; )
            he = fe[M], (P || Mt === he.origType) && (!x || x.guid === he.guid) && (!oe || oe.test(he.namespace)) && (!y || y === he.selector || y === "**" && he.selector) && (fe.splice(M, 1), he.selector && fe.delegateCount--, Pe.remove && Pe.remove.call(d, he));
          H && !fe.length && ((!Pe.teardown || Pe.teardown.call(d, lt, yt.handle) === !1) && m.removeEvent(d, Te, yt.handle), delete J[Te]);
        }
        m.isEmptyObject(J) && Pt.remove(d, "handle events");
      }
    },
    dispatch: function(d) {
      var f, x, y, P, M, H, oe = new Array(arguments.length), J = m.event.fix(d), de = (Pt.get(this, "events") || /* @__PURE__ */ Object.create(null))[J.type] || [], he = m.event.special[J.type] || {};
      for (oe[0] = J, f = 1; f < arguments.length; f++)
        oe[f] = arguments[f];
      if (J.delegateTarget = this, !(he.preDispatch && he.preDispatch.call(this, J) === !1)) {
        for (H = m.event.handlers.call(this, J, de), f = 0; (P = H[f++]) && !J.isPropagationStopped(); )
          for (J.currentTarget = P.elem, x = 0; (M = P.handlers[x++]) && !J.isImmediatePropagationStopped(); )
            (!J.rnamespace || M.namespace === !1 || J.rnamespace.test(M.namespace)) && (J.handleObj = M, J.data = M.data, y = ((m.event.special[M.origType] || {}).handle || M.handler).apply(P.elem, oe), y !== void 0 && (J.result = y) === !1 && (J.preventDefault(), J.stopPropagation()));
        return he.postDispatch && he.postDispatch.call(this, J), J.result;
      }
    },
    handlers: function(d, f) {
      var x, y, P, M, H, oe = [], J = f.delegateCount, de = d.target;
      if (J && // Support: Firefox <=42 - 66+
      // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
      // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
      // Support: IE 11+
      // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
      !(d.type === "click" && d.button >= 1)) {
        for (; de !== this; de = de.parentNode || this)
          if (de.nodeType === 1 && !(d.type === "click" && de.disabled === !0)) {
            for (M = [], H = {}, x = 0; x < J; x++)
              y = f[x], P = y.selector + " ", H[P] === void 0 && (H[P] = y.needsContext ? m(P, this).index(de) > -1 : m.find(P, this, null, [de]).length), H[P] && M.push(y);
            M.length && oe.push({ elem: de, handlers: M });
          }
      }
      return de = this, J < f.length && oe.push({ elem: de, handlers: f.slice(J) }), oe;
    },
    addProp: function(d, f) {
      Object.defineProperty(m.Event.prototype, d, {
        enumerable: !0,
        configurable: !0,
        get: typeof f == "function" ? function() {
          if (this.originalEvent)
            return f(this.originalEvent);
        } : function() {
          if (this.originalEvent)
            return this.originalEvent[d];
        },
        set: function(x) {
          Object.defineProperty(this, d, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: x
          });
        }
      });
    },
    fix: function(d) {
      return d[m.expando] ? d : new m.Event(d);
    },
    special: m.extend(/* @__PURE__ */ Object.create(null), {
      load: {
        // Prevent triggered image.load events from bubbling to window.load
        noBubble: !0
      },
      click: {
        // Utilize native event to ensure correct state for checkable inputs
        setup: function(d) {
          var f = this || d;
          return ll.test(f.type) && f.click && _(f, "input") && aa(f, "click", !0), !1;
        },
        trigger: function(d) {
          var f = this || d;
          return ll.test(f.type) && f.click && _(f, "input") && aa(f, "click"), !0;
        },
        // For cross-browser consistency, suppress native .click() on links
        // Also prevent it if we're currently inside a leveraged native-event stack
        _default: function(d) {
          var f = d.target;
          return ll.test(f.type) && f.click && _(f, "input") && Pt.get(f, "click") || _(f, "a");
        }
      },
      beforeunload: {
        postDispatch: function(d) {
          d.result !== void 0 && d.preventDefault();
        }
      }
    })
  };
  function aa(d, f, x) {
    if (!x) {
      Pt.get(d, f) === void 0 && m.event.add(d, f, La);
      return;
    }
    Pt.set(d, f, !1), m.event.add(d, f, {
      namespace: !1,
      handler: function(y) {
        var P, M = Pt.get(this, f);
        if (y.isTrigger & 1 && this[f]) {
          if (M.length)
            (m.event.special[f] || {}).delegateType && y.stopPropagation();
          else if (M = n.call(arguments), Pt.set(this, f, M), this[f](), P = Pt.get(this, f), Pt.set(this, f, !1), M !== P)
            return y.stopImmediatePropagation(), y.preventDefault(), P && P.value;
        } else M.length && (Pt.set(this, f, {
          value: m.event.trigger(
            M[0],
            M.slice(1),
            this
          )
        }), y.stopPropagation(), y.isImmediatePropagationStopped = La);
      }
    });
  }
  m.removeEvent = function(d, f, x) {
    d.removeEventListener && d.removeEventListener(f, x);
  }, m.Event = function(d, f) {
    if (!(this instanceof m.Event))
      return new m.Event(d, f);
    d && d.type ? (this.originalEvent = d, this.type = d.type, this.isDefaultPrevented = d.defaultPrevented ? La : Ea, this.target = d.target, this.currentTarget = d.currentTarget, this.relatedTarget = d.relatedTarget) : this.type = d, f && m.extend(this, f), this.timeStamp = d && d.timeStamp || Date.now(), this[m.expando] = !0;
  }, m.Event.prototype = {
    constructor: m.Event,
    isDefaultPrevented: Ea,
    isPropagationStopped: Ea,
    isImmediatePropagationStopped: Ea,
    isSimulated: !1,
    preventDefault: function() {
      var d = this.originalEvent;
      this.isDefaultPrevented = La, d && !this.isSimulated && d.preventDefault();
    },
    stopPropagation: function() {
      var d = this.originalEvent;
      this.isPropagationStopped = La, d && !this.isSimulated && d.stopPropagation();
    },
    stopImmediatePropagation: function() {
      var d = this.originalEvent;
      this.isImmediatePropagationStopped = La, d && !this.isSimulated && d.stopImmediatePropagation(), this.stopPropagation();
    }
  }, m.each({
    altKey: !0,
    bubbles: !0,
    cancelable: !0,
    changedTouches: !0,
    ctrlKey: !0,
    detail: !0,
    eventPhase: !0,
    metaKey: !0,
    pageX: !0,
    pageY: !0,
    shiftKey: !0,
    view: !0,
    char: !0,
    code: !0,
    charCode: !0,
    key: !0,
    keyCode: !0,
    button: !0,
    buttons: !0,
    clientX: !0,
    clientY: !0,
    offsetX: !0,
    offsetY: !0,
    pointerId: !0,
    pointerType: !0,
    screenX: !0,
    screenY: !0,
    targetTouches: !0,
    toElement: !0,
    touches: !0,
    which: !0
  }, m.event.addProp), m.each({ focus: "focusin", blur: "focusout" }, function(d, f) {
    function x(y) {
      var P = m.event.fix(y);
      P.type = y.type === "focusin" ? "focus" : "blur", P.isSimulated = !0, P.target === P.currentTarget && Pt.get(this, "handle")(P);
    }
    m.event.special[d] = {
      // Utilize native event if possible so blur/focus sequence is correct
      setup: function() {
        if (aa(this, d, !0), E)
          this.addEventListener(f, x);
        else
          return !1;
      },
      trigger: function() {
        return aa(this, d), !0;
      },
      teardown: function() {
        if (E)
          this.removeEventListener(f, x);
        else
          return !1;
      },
      // Suppress native focus or blur if we're currently inside
      // a leveraged native-event stack
      _default: function(y) {
        return Pt.get(y.target, d);
      },
      delegateType: f
    };
  }), m.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function(d, f) {
    m.event.special[d] = {
      delegateType: f,
      bindType: f,
      handle: function(x) {
        var y, P = this, M = x.relatedTarget, H = x.handleObj;
        return (!M || M !== P && !m.contains(P, M)) && (x.type = H.origType, y = H.handler.apply(this, arguments), x.type = f), y;
      }
    };
  }), m.fn.extend({
    on: function(d, f, x, y) {
      return Fi(this, d, f, x, y);
    },
    one: function(d, f, x, y) {
      return Fi(this, d, f, x, y, 1);
    },
    off: function(d, f, x) {
      var y, P;
      if (d && d.preventDefault && d.handleObj)
        return y = d.handleObj, m(d.delegateTarget).off(
          y.namespace ? y.origType + "." + y.namespace : y.origType,
          y.selector,
          y.handler
        ), this;
      if (typeof d == "object") {
        for (P in d)
          this.off(P, f, d[P]);
        return this;
      }
      return (f === !1 || typeof f == "function") && (x = f, f = void 0), x === !1 && (x = Ea), this.each(function() {
        m.event.remove(this, d, x, f);
      });
    }
  });
  var Fu = /<script|<style|<link/i;
  function Vu(d, f) {
    return _(d, "table") && _(f.nodeType !== 11 ? f : f.firstChild, "tr") && m(d).children("tbody")[0] || d;
  }
  function Hu(d, f) {
    var x, y, P, M = Pt.get(d, "events");
    if (f.nodeType === 1) {
      if (M) {
        Pt.remove(f, "handle events");
        for (x in M)
          for (y = 0, P = M[x].length; y < P; y++)
            m.event.add(f, x, M[x][y]);
      }
      So.hasData(d) && So.set(f, m.extend({}, So.get(d)));
    }
  }
  function Uu(d, f, x) {
    for (var y, P = f ? m.filter(f, d) : d, M = 0; (y = P[M]) != null; M++)
      !x && y.nodeType === 1 && m.cleanData(bo(y)), y.parentNode && (x && Vl(y) && Sd(bo(y, "script")), y.parentNode.removeChild(y));
    return d;
  }
  m.extend({
    htmlPrefilter: function(d) {
      return d;
    },
    clone: function(d, f, x) {
      var y, P, M, H, oe = d.cloneNode(!0), J = Vl(d);
      if (E && (d.nodeType === 1 || d.nodeType === 11) && !m.isXMLDoc(d))
        for (H = bo(oe), M = bo(d), y = 0, P = M.length; y < P; y++)
          _(H[y], "textarea") && (H[y].defaultValue = M[y].defaultValue);
      if (f)
        if (x)
          for (M = M || bo(d), H = H || bo(oe), y = 0, P = M.length; y < P; y++)
            Hu(M[y], H[y]);
        else
          Hu(d, oe);
      return H = bo(oe, "script"), H.length > 0 && Sd(H, !J && bo(d, "script")), oe;
    },
    cleanData: function(d) {
      for (var f, x, y, P = m.event.special, M = 0; (x = d[M]) !== void 0; M++)
        if (Bl(x)) {
          if (f = x[Pt.expando]) {
            if (f.events)
              for (y in f.events)
                P[y] ? m.event.remove(x, y) : m.removeEvent(x, y, f.handle);
            x[Pt.expando] = void 0;
          }
          x[So.expando] && (x[So.expando] = void 0);
        }
    }
  }), m.fn.extend({
    detach: function(d) {
      return Uu(this, d, !0);
    },
    remove: function(d) {
      return Uu(this, d);
    },
    text: function(d) {
      return Be(this, function(f) {
        return f === void 0 ? m.text(this) : this.empty().each(function() {
          (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = f);
        });
      }, null, d, arguments.length);
    },
    append: function() {
      return al(this, arguments, function(d) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var f = Vu(this, d);
          f.appendChild(d);
        }
      });
    },
    prepend: function() {
      return al(this, arguments, function(d) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var f = Vu(this, d);
          f.insertBefore(d, f.firstChild);
        }
      });
    },
    before: function() {
      return al(this, arguments, function(d) {
        this.parentNode && this.parentNode.insertBefore(d, this);
      });
    },
    after: function() {
      return al(this, arguments, function(d) {
        this.parentNode && this.parentNode.insertBefore(d, this.nextSibling);
      });
    },
    empty: function() {
      for (var d, f = 0; (d = this[f]) != null; f++)
        d.nodeType === 1 && (m.cleanData(bo(d, !1)), d.textContent = "");
      return this;
    },
    clone: function(d, f) {
      return d = d ?? !1, f = f ?? d, this.map(function() {
        return m.clone(this, d, f);
      });
    },
    html: function(d) {
      return Be(this, function(f) {
        var x = this[0] || {}, y = 0, P = this.length;
        if (f === void 0 && x.nodeType === 1)
          return x.innerHTML;
        if (typeof f == "string" && !Fu.test(f) && !In[(Bu.exec(f) || ["", ""])[1].toLowerCase()]) {
          f = m.htmlPrefilter(f);
          try {
            for (; y < P; y++)
              x = this[y] || {}, x.nodeType === 1 && (m.cleanData(bo(x, !1)), x.innerHTML = f);
            x = 0;
          } catch {
          }
        }
        x && this.empty().append(f);
      }, null, d, arguments.length);
    },
    replaceWith: function() {
      var d = [];
      return al(this, arguments, function(f) {
        var x = this.parentNode;
        m.inArray(this, d) < 0 && (m.cleanData(bo(this)), x && x.replaceChild(f, this));
      }, d);
    }
  }), m.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function(d, f) {
    m.fn[d] = function(x) {
      for (var y, P = [], M = m(x), H = M.length - 1, oe = 0; oe <= H; oe++)
        y = oe === H ? this : this.clone(!0), m(M[oe])[f](y), l.apply(P, y);
      return this.pushStack(P);
    };
  });
  var z = new RegExp("^(" + vd + ")(?!px)[a-z%]+$", "i"), ce = /^--/;
  function ke(d) {
    var f = d.ownerDocument.defaultView;
    return f || (f = e), f.getComputedStyle(d);
  }
  function at(d, f, x) {
    var y, P, M = {};
    for (P in f)
      M[P] = d.style[P], d.style[P] = f[P];
    y = x.call(d);
    for (P in f)
      d.style[P] = M[P];
    return y;
  }
  function dr(d, f, x) {
    var y, P = ce.test(f);
    return x = x || ke(d), x && (y = x.getPropertyValue(f) || x[f], P && y && (y = y.replace(U, "$1") || void 0), y === "" && !Vl(d) && (y = m.style(d, f))), y !== void 0 ? (
      // Support: IE <=9 - 11+
      // IE returns zIndex value as an integer.
      y + ""
    ) : y;
  }
  var Ct = ["Webkit", "Moz", "ms"], Sr = b.createElement("div").style;
  function zr(d) {
    for (var f = d[0].toUpperCase() + d.slice(1), x = Ct.length; x--; )
      if (d = Ct[x] + f, d in Sr)
        return d;
  }
  function Gr(d) {
    return d in Sr ? d : zr(d) || d;
  }
  var hr, yo, qr = b.createElement("table");
  function ao() {
    if (
      // This is a singleton, we need to execute it only once
      !(!qr || // Finish early in limited (non-browser) environments
      !qr.style)
    ) {
      var d, f = b.createElement("col"), x = b.createElement("tr"), y = b.createElement("td");
      if (qr.style.cssText = "position:absolute;left:-11111px;border-collapse:separate;border-spacing:0", x.style.cssText = "box-sizing:content-box;border:1px solid;height:1px", y.style.cssText = "height:9px;width:9px;padding:0", f.span = 2, xe.appendChild(qr).appendChild(f).parentNode.appendChild(x).appendChild(y).parentNode.appendChild(y.cloneNode(!0)), qr.offsetWidth === 0) {
        xe.removeChild(qr);
        return;
      }
      d = e.getComputedStyle(x), yo = E || Math.round(
        parseFloat(
          e.getComputedStyle(f).width
        )
      ) === 18, hr = Math.round(parseFloat(d.height) + parseFloat(d.borderTopWidth) + parseFloat(d.borderBottomWidth)) === x.offsetHeight, xe.removeChild(qr), qr = null;
    }
  }
  m.extend(h, {
    reliableTrDimensions: function() {
      return ao(), hr;
    },
    reliableColDimensions: function() {
      return ao(), yo;
    }
  });
  var Xo = { position: "absolute", visibility: "hidden", display: "block" }, No = {
    letterSpacing: "0",
    fontWeight: "400"
  };
  function Rn(d, f, x) {
    var y = rl.exec(f);
    return y ? (
      // Guard against undefined "subtract", e.g., when used as in cssHooks
      Math.max(0, y[2] - (x || 0)) + (y[3] || "px")
    ) : f;
  }
  function vn(d, f, x, y, P, M) {
    var H = f === "width" ? 1 : 0, oe = 0, J = 0, de = 0;
    if (x === (y ? "border" : "content"))
      return 0;
    for (; H < 4; H += 2)
      x === "margin" && (de += m.css(d, x + oa[H], !0, P)), y ? (x === "content" && (J -= m.css(d, "padding" + oa[H], !0, P)), x !== "margin" && (J -= m.css(d, "border" + oa[H] + "Width", !0, P))) : (J += m.css(d, "padding" + oa[H], !0, P), x !== "padding" ? J += m.css(d, "border" + oa[H] + "Width", !0, P) : oe += m.css(d, "border" + oa[H] + "Width", !0, P));
    return !y && M >= 0 && (J += Math.max(0, Math.ceil(
      d["offset" + f[0].toUpperCase() + f.slice(1)] - M - J - oe - 0.5
      // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
      // Use an explicit zero to avoid NaN (gh-3964)
    )) || 0), J + de;
  }
  function la(d, f, x) {
    var y = ke(d), P = E || x, M = P && m.css(d, "boxSizing", !1, y) === "border-box", H = M, oe = dr(d, f, y), J = "offset" + f[0].toUpperCase() + f.slice(1);
    if (z.test(oe)) {
      if (!x)
        return oe;
      oe = "auto";
    }
    return (
      // Fall back to offsetWidth/offsetHeight when value is "auto"
      // This happens for inline elements with no explicit setting (gh-3571)
      (oe === "auto" || // Support: IE 9 - 11+
      // Use offsetWidth/offsetHeight for when box sizing is unreliable.
      // In those cases, the computed value can be trusted to be border-box.
      E && M || !h.reliableColDimensions() && _(d, "col") || !h.reliableTrDimensions() && _(d, "tr")) && // Make sure the element is visible & connected
      d.getClientRects().length && (M = m.css(d, "boxSizing", !1, y) === "border-box", H = J in d, H && (oe = d[J])), oe = parseFloat(oe) || 0, oe + vn(
        d,
        f,
        x || (M ? "border" : "content"),
        H,
        y,
        // Provide the current computed size to request scroll gutter calculation (gh-3589)
        oe
      ) + "px"
    );
  }
  m.extend({
    // Add in style property hooks for overriding the default
    // behavior of getting and setting a style property
    cssHooks: {},
    // Get and set the style property on a DOM Node
    style: function(d, f, x, y) {
      if (!(!d || d.nodeType === 3 || d.nodeType === 8 || !d.style)) {
        var P, M, H, oe = Ii(f), J = ce.test(f), de = d.style;
        if (J || (f = Gr(oe)), H = m.cssHooks[f] || m.cssHooks[oe], x !== void 0) {
          if (M = typeof x, M === "string" && (P = rl.exec(x)) && P[1] && (x = Gu(d, f, P), M = "number"), x == null || x !== x)
            return;
          M === "number" && (x += P && P[3] || (Rl(oe) ? "px" : "")), E && x === "" && f.indexOf("background") === 0 && (de[f] = "inherit"), (!H || !("set" in H) || (x = H.set(d, x, y)) !== void 0) && (J ? de.setProperty(f, x) : de[f] = x);
        } else
          return H && "get" in H && (P = H.get(d, !1, y)) !== void 0 ? P : de[f];
      }
    },
    css: function(d, f, x, y) {
      var P, M, H, oe = Ii(f), J = ce.test(f);
      return J || (f = Gr(oe)), H = m.cssHooks[f] || m.cssHooks[oe], H && "get" in H && (P = H.get(d, !0, x)), P === void 0 && (P = dr(d, f, y)), P === "normal" && f in No && (P = No[f]), x === "" || x ? (M = parseFloat(P), x === !0 || isFinite(M) ? M || 0 : P) : P;
    }
  }), m.each(["height", "width"], function(d, f) {
    m.cssHooks[f] = {
      get: function(x, y, P) {
        if (y)
          return m.css(x, "display") === "none" ? at(x, Xo, function() {
            return la(x, f, P);
          }) : la(x, f, P);
      },
      set: function(x, y, P) {
        var M, H = ke(x), oe = P && m.css(x, "boxSizing", !1, H) === "border-box", J = P ? vn(
          x,
          f,
          P,
          oe,
          H
        ) : 0;
        return J && (M = rl.exec(y)) && (M[3] || "px") !== "px" && (x.style[f] = y, y = m.css(x, f)), Rn(x, y, J);
      }
    };
  }), m.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function(d, f) {
    m.cssHooks[d + f] = {
      expand: function(x) {
        for (var y = 0, P = {}, M = typeof x == "string" ? x.split(" ") : [x]; y < 4; y++)
          P[d + oa[y] + f] = M[y] || M[y - 2] || M[0];
        return P;
      }
    }, d !== "margin" && (m.cssHooks[d + f].set = Rn);
  }), m.fn.extend({
    css: function(d, f) {
      return Be(this, function(x, y, P) {
        var M, H, oe = {}, J = 0;
        if (Array.isArray(y)) {
          for (M = ke(x), H = y.length; J < H; J++)
            oe[y[J]] = m.css(x, y[J], !1, M);
          return oe;
        }
        return P !== void 0 ? m.style(x, y, P) : m.css(x, y);
      }, d, f, arguments.length > 1);
    }
  });
  function Do(d, f, x, y, P) {
    return new Do.prototype.init(d, f, x, y, P);
  }
  m.Tween = Do, Do.prototype = {
    constructor: Do,
    init: function(d, f, x, y, P, M) {
      this.elem = d, this.prop = x, this.easing = P || m.easing._default, this.options = f, this.start = this.now = this.cur(), this.end = y, this.unit = M || (Rl(x) ? "px" : "");
    },
    cur: function() {
      var d = Do.propHooks[this.prop];
      return d && d.get ? d.get(this) : Do.propHooks._default.get(this);
    },
    run: function(d) {
      var f, x = Do.propHooks[this.prop];
      return this.options.duration ? this.pos = f = m.easing[this.easing](
        d,
        this.options.duration * d,
        0,
        1,
        this.options.duration
      ) : this.pos = f = d, this.now = (this.end - this.start) * f + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), x && x.set ? x.set(this) : Do.propHooks._default.set(this), this;
    }
  }, Do.prototype.init.prototype = Do.prototype, Do.propHooks = {
    _default: {
      get: function(d) {
        var f;
        return d.elem.nodeType !== 1 || d.elem[d.prop] != null && d.elem.style[d.prop] == null ? d.elem[d.prop] : (f = m.css(d.elem, d.prop, ""), !f || f === "auto" ? 0 : f);
      },
      set: function(d) {
        m.fx.step[d.prop] ? m.fx.step[d.prop](d) : d.elem.nodeType === 1 && (m.cssHooks[d.prop] || d.elem.style[Gr(d.prop)] != null) ? m.style(d.elem, d.prop, d.now + d.unit) : d.elem[d.prop] = d.now;
      }
    }
  }, m.easing = {
    linear: function(d) {
      return d;
    },
    swing: function(d) {
      return 0.5 - Math.cos(d * Math.PI) / 2;
    },
    _default: "swing"
  }, m.fx = Do.prototype.init, m.fx.step = {};
  var Fn, Oa, OT = /^(?:toggle|show|hide)$/, NT = /queueHooks$/;
  function ig() {
    Oa && (b.hidden === !1 && e.requestAnimationFrame ? e.requestAnimationFrame(ig) : e.setTimeout(ig, 13), m.fx.tick());
  }
  function kh() {
    return e.setTimeout(function() {
      Fn = void 0;
    }), Fn = Date.now();
  }
  function Xu(d, f) {
    var x, y = 0, P = { height: d };
    for (f = f ? 1 : 0; y < 4; y += 2 - f)
      x = oa[y], P["margin" + x] = P["padding" + x] = d;
    return f && (P.opacity = P.width = d), P;
  }
  function Gh(d, f, x) {
    for (var y, P = (Vn.tweeners[f] || []).concat(Vn.tweeners["*"]), M = 0, H = P.length; M < H; M++)
      if (y = P[M].call(x, f, d))
        return y;
  }
  function DT(d, f, x) {
    var y, P, M, H, oe, J, de, he, Pe = "width" in f || "height" in f, fe = this, Te = {}, lt = d.style, Mt = d.nodeType && Bi(d), yt = Pt.get(d, "fxshow");
    x.queue || (H = m._queueHooks(d, "fx"), H.unqueued == null && (H.unqueued = 0, oe = H.empty.fire, H.empty.fire = function() {
      H.unqueued || oe();
    }), H.unqueued++, fe.always(function() {
      fe.always(function() {
        H.unqueued--, m.queue(d, "fx").length || H.empty.fire();
      });
    }));
    for (y in f)
      if (P = f[y], OT.test(P)) {
        if (delete f[y], M = M || P === "toggle", P === (Mt ? "hide" : "show"))
          if (P === "show" && yt && yt[y] !== void 0)
            Mt = !0;
          else
            continue;
        Te[y] = yt && yt[y] || m.style(d, y);
      }
    if (J = !m.isEmptyObject(f), !(!J && m.isEmptyObject(Te))) {
      Pe && d.nodeType === 1 && (x.overflow = [lt.overflow, lt.overflowX, lt.overflowY], de = yt && yt.display, de == null && (de = Pt.get(d, "display")), he = m.css(d, "display"), he === "none" && (de ? he = de : (nl([d], !0), de = d.style.display || de, he = m.css(d, "display"), nl([d]))), (he === "inline" || he === "inline-block" && de != null) && m.css(d, "float") === "none" && (J || (fe.done(function() {
        lt.display = de;
      }), de == null && (he = lt.display, de = he === "none" ? "" : he)), lt.display = "inline-block")), x.overflow && (lt.overflow = "hidden", fe.always(function() {
        lt.overflow = x.overflow[0], lt.overflowX = x.overflow[1], lt.overflowY = x.overflow[2];
      })), J = !1;
      for (y in Te)
        J || (yt ? "hidden" in yt && (Mt = yt.hidden) : yt = Pt.set(d, "fxshow", { display: de }), M && (yt.hidden = !Mt), Mt && nl([d], !0), fe.done(function() {
          Mt || nl([d]), Pt.remove(d, "fxshow");
          for (y in Te)
            m.style(d, y, Te[y]);
        })), J = Gh(Mt ? yt[y] : 0, y, fe), y in yt || (yt[y] = J.start, Mt && (J.end = J.start, J.start = 0));
    }
  }
  function kT(d, f) {
    var x, y, P, M, H;
    for (x in d)
      if (y = Ii(x), P = f[y], M = d[x], Array.isArray(M) && (P = M[1], M = d[x] = M[0]), x !== y && (d[y] = M, delete d[x]), H = m.cssHooks[y], H && "expand" in H) {
        M = H.expand(M), delete d[y];
        for (x in M)
          x in d || (d[x] = M[x], f[x] = P);
      } else
        f[y] = P;
  }
  function Vn(d, f, x) {
    var y, P, M = 0, H = Vn.prefilters.length, oe = m.Deferred().always(function() {
      delete J.elem;
    }), J = function() {
      if (P)
        return !1;
      for (var Pe = Fn || kh(), fe = Math.max(0, de.startTime + de.duration - Pe), Te = 1 - (fe / de.duration || 0), lt = 0, Mt = de.tweens.length; lt < Mt; lt++)
        de.tweens[lt].run(Te);
      return oe.notifyWith(d, [de, Te, fe]), Te < 1 && Mt ? fe : (Mt || oe.notifyWith(d, [de, 1, 0]), oe.resolveWith(d, [de]), !1);
    }, de = oe.promise({
      elem: d,
      props: m.extend({}, f),
      opts: m.extend(!0, {
        specialEasing: {},
        easing: m.easing._default
      }, x),
      originalProperties: f,
      originalOptions: x,
      startTime: Fn || kh(),
      duration: x.duration,
      tweens: [],
      createTween: function(Pe, fe) {
        var Te = m.Tween(
          d,
          de.opts,
          Pe,
          fe,
          de.opts.specialEasing[Pe] || de.opts.easing
        );
        return de.tweens.push(Te), Te;
      },
      stop: function(Pe) {
        var fe = 0, Te = Pe ? de.tweens.length : 0;
        if (P)
          return this;
        for (P = !0; fe < Te; fe++)
          de.tweens[fe].run(1);
        return Pe ? (oe.notifyWith(d, [de, 1, 0]), oe.resolveWith(d, [de, Pe])) : oe.rejectWith(d, [de, Pe]), this;
      }
    }), he = de.props;
    for (kT(he, de.opts.specialEasing); M < H; M++)
      if (y = Vn.prefilters[M].call(de, d, he, de.opts), y)
        return typeof y.stop == "function" && (m._queueHooks(de.elem, de.opts.queue).stop = y.stop.bind(y)), y;
    return m.map(he, Gh, de), typeof de.opts.start == "function" && de.opts.start.call(d, de), de.progress(de.opts.progress).done(de.opts.done, de.opts.complete).fail(de.opts.fail).always(de.opts.always), m.fx.timer(
      m.extend(J, {
        elem: d,
        anim: de,
        queue: de.opts.queue
      })
    ), de;
  }
  m.Animation = m.extend(Vn, {
    tweeners: {
      "*": [function(d, f) {
        var x = this.createTween(d, f);
        return Gu(x.elem, d, rl.exec(f), x), x;
      }]
    },
    tweener: function(d, f) {
      typeof d == "function" ? (f = d, d = ["*"]) : d = d.match(j);
      for (var x, y = 0, P = d.length; y < P; y++)
        x = d[y], Vn.tweeners[x] = Vn.tweeners[x] || [], Vn.tweeners[x].unshift(f);
    },
    prefilters: [DT],
    prefilter: function(d, f) {
      f ? Vn.prefilters.unshift(d) : Vn.prefilters.push(d);
    }
  }), m.speed = function(d, f, x) {
    var y = d && typeof d == "object" ? m.extend({}, d) : {
      complete: x || f || typeof d == "function" && d,
      duration: d,
      easing: x && f || f && typeof f != "function" && f
    };
    return m.fx.off ? y.duration = 0 : typeof y.duration != "number" && (y.duration in m.fx.speeds ? y.duration = m.fx.speeds[y.duration] : y.duration = m.fx.speeds._default), (y.queue == null || y.queue === !0) && (y.queue = "fx"), y.old = y.complete, y.complete = function() {
      typeof y.old == "function" && y.old.call(this), y.queue && m.dequeue(this, y.queue);
    }, y;
  }, m.fn.extend({
    fadeTo: function(d, f, x, y) {
      return this.filter(Bi).css("opacity", 0).show().end().animate({ opacity: f }, d, x, y);
    },
    animate: function(d, f, x, y) {
      var P = m.isEmptyObject(d), M = m.speed(f, x, y), H = function() {
        var oe = Vn(this, m.extend({}, d), M);
        (P || Pt.get(this, "finish")) && oe.stop(!0);
      };
      return H.finish = H, P || M.queue === !1 ? this.each(H) : this.queue(M.queue, H);
    },
    stop: function(d, f, x) {
      var y = function(P) {
        var M = P.stop;
        delete P.stop, M(x);
      };
      return typeof d != "string" && (x = f, f = d, d = void 0), f && this.queue(d || "fx", []), this.each(function() {
        var P = !0, M = d != null && d + "queueHooks", H = m.timers, oe = Pt.get(this);
        if (M)
          oe[M] && oe[M].stop && y(oe[M]);
        else
          for (M in oe)
            oe[M] && oe[M].stop && NT.test(M) && y(oe[M]);
        for (M = H.length; M--; )
          H[M].elem === this && (d == null || H[M].queue === d) && (H[M].anim.stop(x), P = !1, H.splice(M, 1));
        (P || !x) && m.dequeue(this, d);
      });
    },
    finish: function(d) {
      return d !== !1 && (d = d || "fx"), this.each(function() {
        var f, x = Pt.get(this), y = x[d + "queue"], P = x[d + "queueHooks"], M = m.timers, H = y ? y.length : 0;
        for (x.finish = !0, m.queue(this, d, []), P && P.stop && P.stop.call(this, !0), f = M.length; f--; )
          M[f].elem === this && M[f].queue === d && (M[f].anim.stop(!0), M.splice(f, 1));
        for (f = 0; f < H; f++)
          y[f] && y[f].finish && y[f].finish.call(this);
        delete x.finish;
      });
    }
  }), m.each(["toggle", "show", "hide"], function(d, f) {
    var x = m.fn[f];
    m.fn[f] = function(y, P, M) {
      return y == null || typeof y == "boolean" ? x.apply(this, arguments) : this.animate(Xu(f, !0), y, P, M);
    };
  }), m.each({
    slideDown: Xu("show"),
    slideUp: Xu("hide"),
    slideToggle: Xu("toggle"),
    fadeIn: { opacity: "show" },
    fadeOut: { opacity: "hide" },
    fadeToggle: { opacity: "toggle" }
  }, function(d, f) {
    m.fn[d] = function(x, y, P) {
      return this.animate(f, x, y, P);
    };
  }), m.timers = [], m.fx.tick = function() {
    var d, f = 0, x = m.timers;
    for (Fn = Date.now(); f < x.length; f++)
      d = x[f], !d() && x[f] === d && x.splice(f--, 1);
    x.length || m.fx.stop(), Fn = void 0;
  }, m.fx.timer = function(d) {
    m.timers.push(d), m.fx.start();
  }, m.fx.start = function() {
    Oa || (Oa = !0, ig());
  }, m.fx.stop = function() {
    Oa = null;
  }, m.fx.speeds = {
    slow: 600,
    fast: 200,
    // Default speed
    _default: 400
  }, m.fn.delay = function(d, f) {
    return d = m.fx && m.fx.speeds[d] || d, f = f || "fx", this.queue(f, function(x, y) {
      var P = e.setTimeout(x, d);
      y.stop = function() {
        e.clearTimeout(P);
      };
    });
  };
  var GT = /^(?:input|select|textarea|button)$/i, BT = /^(?:a|area)$/i;
  m.fn.extend({
    prop: function(d, f) {
      return Be(this, m.prop, d, f, arguments.length > 1);
    },
    removeProp: function(d) {
      return this.each(function() {
        delete this[m.propFix[d] || d];
      });
    }
  }), m.extend({
    prop: function(d, f, x) {
      var y, P, M = d.nodeType;
      if (!(M === 3 || M === 8 || M === 2))
        return (M !== 1 || !m.isXMLDoc(d)) && (f = m.propFix[f] || f, P = m.propHooks[f]), x !== void 0 ? P && "set" in P && (y = P.set(d, x, f)) !== void 0 ? y : d[f] = x : P && "get" in P && (y = P.get(d, f)) !== null ? y : d[f];
    },
    propHooks: {
      tabIndex: {
        get: function(d) {
          var f = d.getAttribute("tabindex");
          return f ? parseInt(f, 10) : GT.test(d.nodeName) || // href-less anchor's `tabIndex` property value is `0` and
          // the `tabindex` attribute value: `null`. We want `-1`.
          BT.test(d.nodeName) && d.href ? 0 : -1;
        }
      }
    },
    propFix: {
      for: "htmlFor",
      class: "className"
    }
  }), E && (m.propHooks.selected = {
    get: function(d) {
      var f = d.parentNode;
      return f && f.parentNode && f.parentNode.selectedIndex, null;
    },
    set: function(d) {
      var f = d.parentNode;
      f && (f.selectedIndex, f.parentNode && f.parentNode.selectedIndex);
    }
  }), m.each([
    "tabIndex",
    "readOnly",
    "maxLength",
    "cellSpacing",
    "cellPadding",
    "rowSpan",
    "colSpan",
    "useMap",
    "frameBorder",
    "contentEditable"
  ], function() {
    m.propFix[this.toLowerCase()] = this;
  });
  function Hl(d) {
    var f = d.match(j) || [];
    return f.join(" ");
  }
  function Vi(d) {
    return d.getAttribute && d.getAttribute("class") || "";
  }
  function sg(d) {
    return Array.isArray(d) ? d : typeof d == "string" ? d.match(j) || [] : [];
  }
  m.fn.extend({
    addClass: function(d) {
      var f, x, y, P, M, H;
      return typeof d == "function" ? this.each(function(oe) {
        m(this).addClass(d.call(this, oe, Vi(this)));
      }) : (f = sg(d), f.length ? this.each(function() {
        if (y = Vi(this), x = this.nodeType === 1 && " " + Hl(y) + " ", x) {
          for (M = 0; M < f.length; M++)
            P = f[M], x.indexOf(" " + P + " ") < 0 && (x += P + " ");
          H = Hl(x), y !== H && this.setAttribute("class", H);
        }
      }) : this);
    },
    removeClass: function(d) {
      var f, x, y, P, M, H;
      return typeof d == "function" ? this.each(function(oe) {
        m(this).removeClass(d.call(this, oe, Vi(this)));
      }) : arguments.length ? (f = sg(d), f.length ? this.each(function() {
        if (y = Vi(this), x = this.nodeType === 1 && " " + Hl(y) + " ", x) {
          for (M = 0; M < f.length; M++)
            for (P = f[M]; x.indexOf(" " + P + " ") > -1; )
              x = x.replace(" " + P + " ", " ");
          H = Hl(x), y !== H && this.setAttribute("class", H);
        }
      }) : this) : this.attr("class", "");
    },
    toggleClass: function(d, f) {
      var x, y, P, M;
      return typeof d == "function" ? this.each(function(H) {
        m(this).toggleClass(
          d.call(this, H, Vi(this), f),
          f
        );
      }) : typeof f == "boolean" ? f ? this.addClass(d) : this.removeClass(d) : (x = sg(d), x.length ? this.each(function() {
        for (M = m(this), P = 0; P < x.length; P++)
          y = x[P], M.hasClass(y) ? M.removeClass(y) : M.addClass(y);
      }) : this);
    },
    hasClass: function(d) {
      var f, x, y = 0;
      for (f = " " + d + " "; x = this[y++]; )
        if (x.nodeType === 1 && (" " + Hl(Vi(x)) + " ").indexOf(f) > -1)
          return !0;
      return !1;
    }
  }), m.fn.extend({
    val: function(d) {
      var f, x, y, P = this[0];
      return arguments.length ? (y = typeof d == "function", this.each(function(M) {
        var H;
        this.nodeType === 1 && (y ? H = d.call(this, M, m(this).val()) : H = d, H == null ? H = "" : typeof H == "number" ? H += "" : Array.isArray(H) && (H = m.map(H, function(oe) {
          return oe == null ? "" : oe + "";
        })), f = m.valHooks[this.type] || m.valHooks[this.nodeName.toLowerCase()], (!f || !("set" in f) || f.set(this, H, "value") === void 0) && (this.value = H));
      })) : P ? (f = m.valHooks[P.type] || m.valHooks[P.nodeName.toLowerCase()], f && "get" in f && (x = f.get(P, "value")) !== void 0 ? x : (x = P.value, x ?? "")) : void 0;
    }
  }), m.extend({
    valHooks: {
      select: {
        get: function(d) {
          var f, x, y, P = d.options, M = d.selectedIndex, H = d.type === "select-one", oe = H ? null : [], J = H ? M + 1 : P.length;
          for (M < 0 ? y = J : y = H ? M : 0; y < J; y++)
            if (x = P[y], x.selected && // Don't return options that are disabled or in a disabled optgroup
            !x.disabled && (!x.parentNode.disabled || !_(x.parentNode, "optgroup"))) {
              if (f = m(x).val(), H)
                return f;
              oe.push(f);
            }
          return oe;
        },
        set: function(d, f) {
          for (var x, y, P = d.options, M = m.makeArray(f), H = P.length; H--; )
            y = P[H], (y.selected = m.inArray(m(y).val(), M) > -1) && (x = !0);
          return x || (d.selectedIndex = -1), M;
        }
      }
    }
  }), E && (m.valHooks.option = {
    get: function(d) {
      var f = d.getAttribute("value");
      return f ?? // Support: IE <=10 - 11+
      // option.text throws exceptions (trac-14686, trac-14858)
      // Strip and collapse whitespace
      // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
      Hl(m.text(d));
    }
  }), m.each(["radio", "checkbox"], function() {
    m.valHooks[this] = {
      set: function(d, f) {
        if (Array.isArray(f))
          return d.checked = m.inArray(m(d).val(), f) > -1;
      }
    };
  });
  var Bh = /^(?:focusinfocus|focusoutblur)$/, Ih = function(d) {
    d.stopPropagation();
  };
  m.extend(m.event, {
    trigger: function(d, f, x, y) {
      var P, M, H, oe, J, de, he, Pe, fe = [x || b], Te = c.call(d, "type") ? d.type : d, lt = c.call(d, "namespace") ? d.namespace.split(".") : [];
      if (M = Pe = H = x = x || b, !(x.nodeType === 3 || x.nodeType === 8) && !Bh.test(Te + m.event.triggered) && (Te.indexOf(".") > -1 && (lt = Te.split("."), Te = lt.shift(), lt.sort()), J = Te.indexOf(":") < 0 && "on" + Te, d = d[m.expando] ? d : new m.Event(Te, typeof d == "object" && d), d.isTrigger = y ? 2 : 3, d.namespace = lt.join("."), d.rnamespace = d.namespace ? new RegExp("(^|\\.)" + lt.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, d.result = void 0, d.target || (d.target = x), f = f == null ? [d] : m.makeArray(f, [d]), he = m.event.special[Te] || {}, !(!y && he.trigger && he.trigger.apply(x, f) === !1))) {
        if (!y && !he.noBubble && !A(x)) {
          for (oe = he.delegateType || Te, Bh.test(oe + Te) || (M = M.parentNode); M; M = M.parentNode)
            fe.push(M), H = M;
          H === (x.ownerDocument || b) && fe.push(H.defaultView || H.parentWindow || e);
        }
        for (P = 0; (M = fe[P++]) && !d.isPropagationStopped(); )
          Pe = M, d.type = P > 1 ? oe : he.bindType || Te, de = (Pt.get(M, "events") || /* @__PURE__ */ Object.create(null))[d.type] && Pt.get(M, "handle"), de && de.apply(M, f), de = J && M[J], de && de.apply && Bl(M) && (d.result = de.apply(M, f), d.result === !1 && d.preventDefault());
        return d.type = Te, !y && !d.isDefaultPrevented() && (!he._default || he._default.apply(fe.pop(), f) === !1) && Bl(x) && J && typeof x[Te] == "function" && !A(x) && (H = x[J], H && (x[J] = null), m.event.triggered = Te, d.isPropagationStopped() && Pe.addEventListener(Te, Ih), x[Te](), d.isPropagationStopped() && Pe.removeEventListener(Te, Ih), m.event.triggered = void 0, H && (x[J] = H)), d.result;
      }
    },
    // Piggyback on a donor event to simulate a different one
    // Used only for `focus(in | out)` events
    simulate: function(d, f, x) {
      var y = m.extend(
        new m.Event(),
        x,
        {
          type: d,
          isSimulated: !0
        }
      );
      m.event.trigger(y, null, f);
    }
  }), m.fn.extend({
    trigger: function(d, f) {
      return this.each(function() {
        m.event.trigger(d, f, this);
      });
    },
    triggerHandler: function(d, f) {
      var x = this[0];
      if (x)
        return m.event.trigger(d, f, x, !0);
    }
  });
  var yd = e.location, Rh = { guid: Date.now() }, dg = /\?/;
  m.parseXML = function(d) {
    var f, x;
    if (!d || typeof d != "string")
      return null;
    try {
      f = new e.DOMParser().parseFromString(d, "text/xml");
    } catch {
    }
    return x = f && f.getElementsByTagName("parsererror")[0], (!f || x) && m.error("Invalid XML: " + (x ? m.map(x.childNodes, function(y) {
      return y.textContent;
    }).join(`
`) : d)), f;
  };
  var IT = /\[\]$/, Fh = /\r?\n/g, RT = /^(?:submit|button|image|reset|file)$/i, FT = /^(?:input|select|textarea|keygen)/i;
  function ug(d, f, x, y) {
    var P;
    if (Array.isArray(f))
      m.each(f, function(M, H) {
        x || IT.test(d) ? y(d, H) : ug(
          d + "[" + (typeof H == "object" && H != null ? M : "") + "]",
          H,
          x,
          y
        );
      });
    else if (!x && v(f) === "object")
      for (P in f)
        ug(d + "[" + P + "]", f[P], x, y);
    else
      y(d, f);
  }
  m.param = function(d, f) {
    var x, y = [], P = function(M, H) {
      var oe = typeof H == "function" ? H() : H;
      y[y.length] = encodeURIComponent(M) + "=" + encodeURIComponent(oe ?? "");
    };
    if (d == null)
      return "";
    if (Array.isArray(d) || d.jquery && !m.isPlainObject(d))
      m.each(d, function() {
        P(this.name, this.value);
      });
    else
      for (x in d)
        ug(x, d[x], f, P);
    return y.join("&");
  }, m.fn.extend({
    serialize: function() {
      return m.param(this.serializeArray());
    },
    serializeArray: function() {
      return this.map(function() {
        var d = m.prop(this, "elements");
        return d ? m.makeArray(d) : this;
      }).filter(function() {
        var d = this.type;
        return this.name && !m(this).is(":disabled") && FT.test(this.nodeName) && !RT.test(d) && (this.checked || !ll.test(d));
      }).map(function(d, f) {
        var x = m(this).val();
        return x == null ? null : Array.isArray(x) ? m.map(x, function(y) {
          return { name: f.name, value: y.replace(Fh, `\r
`) };
        }) : { name: f.name, value: x.replace(Fh, `\r
`) };
      }).get();
    }
  });
  var VT = /%20/g, HT = /#.*$/, UT = /([?&])_=[^&]*/, XT = /^(.*?):[ \t]*([^\r\n]*)$/mg, WT = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, YT = /^(?:GET|HEAD)$/, KT = /^\/\//, Vh = {}, cg = {}, Hh = "*/".concat("*"), mg = b.createElement("a");
  mg.href = yd.href;
  function Uh(d) {
    return function(f, x) {
      typeof f != "string" && (x = f, f = "*");
      var y, P = 0, M = f.toLowerCase().match(j) || [];
      if (typeof x == "function")
        for (; y = M[P++]; )
          y[0] === "+" ? (y = y.slice(1) || "*", (d[y] = d[y] || []).unshift(x)) : (d[y] = d[y] || []).push(x);
    };
  }
  function Xh(d, f, x, y) {
    var P = {}, M = d === cg;
    function H(oe) {
      var J;
      return P[oe] = !0, m.each(d[oe] || [], function(de, he) {
        var Pe = he(f, x, y);
        if (typeof Pe == "string" && !M && !P[Pe])
          return f.dataTypes.unshift(Pe), H(Pe), !1;
        if (M)
          return !(J = Pe);
      }), J;
    }
    return H(f.dataTypes[0]) || !P["*"] && H("*");
  }
  function gg(d, f) {
    var x, y, P = m.ajaxSettings.flatOptions || {};
    for (x in f)
      f[x] !== void 0 && ((P[x] ? d : y || (y = {}))[x] = f[x]);
    return y && m.extend(!0, d, y), d;
  }
  function QT(d, f, x) {
    for (var y, P, M, H, oe = d.contents, J = d.dataTypes; J[0] === "*"; )
      J.shift(), y === void 0 && (y = d.mimeType || f.getResponseHeader("Content-Type"));
    if (y) {
      for (P in oe)
        if (oe[P] && oe[P].test(y)) {
          J.unshift(P);
          break;
        }
    }
    if (J[0] in x)
      M = J[0];
    else {
      for (P in x) {
        if (!J[0] || d.converters[P + " " + J[0]]) {
          M = P;
          break;
        }
        H || (H = P);
      }
      M = M || H;
    }
    if (M)
      return M !== J[0] && J.unshift(M), x[M];
  }
  function jT(d, f, x, y) {
    var P, M, H, oe, J, de = {}, he = d.dataTypes.slice();
    if (he[1])
      for (H in d.converters)
        de[H.toLowerCase()] = d.converters[H];
    for (M = he.shift(); M; )
      if (d.responseFields[M] && (x[d.responseFields[M]] = f), !J && y && d.dataFilter && (f = d.dataFilter(f, d.dataType)), J = M, M = he.shift(), M) {
        if (M === "*")
          M = J;
        else if (J !== "*" && J !== M) {
          if (H = de[J + " " + M] || de["* " + M], !H) {
            for (P in de)
              if (oe = P.split(" "), oe[1] === M && (H = de[J + " " + oe[0]] || de["* " + oe[0]], H)) {
                H === !0 ? H = de[P] : de[P] !== !0 && (M = oe[0], he.unshift(oe[1]));
                break;
              }
          }
          if (H !== !0)
            if (H && d.throws)
              f = H(f);
            else
              try {
                f = H(f);
              } catch (Pe) {
                return {
                  state: "parsererror",
                  error: H ? Pe : "No conversion from " + J + " to " + M
                };
              }
        }
      }
    return { state: "success", data: f };
  }
  m.extend({
    // Counter for holding the number of active queries
    active: 0,
    // Last-Modified header cache for next request
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: yd.href,
      type: "GET",
      isLocal: WT.test(yd.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      /*
      timeout: 0,
      data: null,
      dataType: null,
      username: null,
      password: null,
      cache: null,
      throws: false,
      traditional: false,
      headers: {},
      */
      accepts: {
        "*": Hh,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /\bxml\b/,
        html: /\bhtml/,
        json: /\bjson\b/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      // Data converters
      // Keys separate source (or catchall "*") and destination types with a single space
      converters: {
        // Convert anything to text
        "* text": String,
        // Text to html (true = no transformation)
        "text html": !0,
        // Evaluate text as a json expression
        "text json": JSON.parse,
        // Parse text as xml
        "text xml": m.parseXML
      },
      // For options that shouldn't be deep extended:
      // you can add your own custom options here if
      // and when you create one that shouldn't be
      // deep extended (see ajaxExtend)
      flatOptions: {
        url: !0,
        context: !0
      }
    },
    // Creates a full fledged settings object into target
    // with both ajaxSettings and settings fields.
    // If target is omitted, writes into ajaxSettings.
    ajaxSetup: function(d, f) {
      return f ? (
        // Building a settings object
        gg(gg(d, m.ajaxSettings), f)
      ) : (
        // Extending ajaxSettings
        gg(m.ajaxSettings, d)
      );
    },
    ajaxPrefilter: Uh(Vh),
    ajaxTransport: Uh(cg),
    // Main method
    ajax: function(d, f) {
      typeof d == "object" && (f = d, d = void 0), f = f || {};
      var x, y, P, M, H, oe, J, de, he, Pe, fe = m.ajaxSetup({}, f), Te = fe.context || fe, lt = fe.context && (Te.nodeType || Te.jquery) ? m(Te) : m.event, Mt = m.Deferred(), yt = m.Callbacks("once memory"), Tr = fe.statusCode || {}, br = {}, Wo = {}, wo = "canceled", Xt = {
        readyState: 0,
        // Builds headers hashtable if needed
        getResponseHeader: function(zt) {
          var Jr;
          if (J) {
            if (!M)
              for (M = {}; Jr = XT.exec(P); )
                M[Jr[1].toLowerCase() + " "] = (M[Jr[1].toLowerCase() + " "] || []).concat(Jr[2]);
            Jr = M[zt.toLowerCase() + " "];
          }
          return Jr == null ? null : Jr.join(", ");
        },
        // Raw string
        getAllResponseHeaders: function() {
          return J ? P : null;
        },
        // Caches the header
        setRequestHeader: function(zt, Jr) {
          return J == null && (zt = Wo[zt.toLowerCase()] = Wo[zt.toLowerCase()] || zt, br[zt] = Jr), this;
        },
        // Overrides response content-type header
        overrideMimeType: function(zt) {
          return J == null && (fe.mimeType = zt), this;
        },
        // Status-dependent callbacks
        statusCode: function(zt) {
          var Jr;
          if (zt)
            if (J)
              Xt.always(zt[Xt.status]);
            else
              for (Jr in zt)
                Tr[Jr] = [Tr[Jr], zt[Jr]];
          return this;
        },
        // Cancel the request
        abort: function(zt) {
          var Jr = zt || wo;
          return x && x.abort(Jr), Wu(0, Jr), this;
        }
      };
      if (Mt.promise(Xt), fe.url = ((d || fe.url || yd.href) + "").replace(KT, yd.protocol + "//"), fe.type = f.method || f.type || fe.method || fe.type, fe.dataTypes = (fe.dataType || "*").toLowerCase().match(j) || [""], fe.crossDomain == null) {
        oe = b.createElement("a");
        try {
          oe.href = fe.url, oe.href = oe.href, fe.crossDomain = mg.protocol + "//" + mg.host != oe.protocol + "//" + oe.host;
        } catch {
          fe.crossDomain = !0;
        }
      }
      if (Xh(Vh, fe, f, Xt), fe.data && fe.processData && typeof fe.data != "string" && (fe.data = m.param(fe.data, fe.traditional)), J)
        return Xt;
      de = m.event && fe.global, de && m.active++ === 0 && m.event.trigger("ajaxStart"), fe.type = fe.type.toUpperCase(), fe.hasContent = !YT.test(fe.type), y = fe.url.replace(HT, ""), fe.hasContent ? fe.data && fe.processData && (fe.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (fe.data = fe.data.replace(VT, "+")) : (Pe = fe.url.slice(y.length), fe.data && (fe.processData || typeof fe.data == "string") && (y += (dg.test(y) ? "&" : "?") + fe.data, delete fe.data), fe.cache === !1 && (y = y.replace(UT, "$1"), Pe = (dg.test(y) ? "&" : "?") + "_=" + Rh.guid++ + Pe), fe.url = y + Pe), fe.ifModified && (m.lastModified[y] && Xt.setRequestHeader("If-Modified-Since", m.lastModified[y]), m.etag[y] && Xt.setRequestHeader("If-None-Match", m.etag[y])), (fe.data && fe.hasContent && fe.contentType !== !1 || f.contentType) && Xt.setRequestHeader("Content-Type", fe.contentType), Xt.setRequestHeader(
        "Accept",
        fe.dataTypes[0] && fe.accepts[fe.dataTypes[0]] ? fe.accepts[fe.dataTypes[0]] + (fe.dataTypes[0] !== "*" ? ", " + Hh + "; q=0.01" : "") : fe.accepts["*"]
      );
      for (he in fe.headers)
        Xt.setRequestHeader(he, fe.headers[he]);
      if (fe.beforeSend && (fe.beforeSend.call(Te, Xt, fe) === !1 || J))
        return Xt.abort();
      if (wo = "abort", yt.add(fe.complete), Xt.done(fe.success), Xt.fail(fe.error), x = Xh(cg, fe, f, Xt), !x)
        Wu(-1, "No Transport");
      else {
        if (Xt.readyState = 1, de && lt.trigger("ajaxSend", [Xt, fe]), J)
          return Xt;
        fe.async && fe.timeout > 0 && (H = e.setTimeout(function() {
          Xt.abort("timeout");
        }, fe.timeout));
        try {
          J = !1, x.send(br, Wu);
        } catch (zt) {
          if (J)
            throw zt;
          Wu(-1, zt);
        }
      }
      function Wu(zt, Jr, Kh, JT) {
        var il, pg, wd, Hi, Ui, ia = Jr;
        J || (J = !0, H && e.clearTimeout(H), x = void 0, P = JT || "", Xt.readyState = zt > 0 ? 4 : 0, il = zt >= 200 && zt < 300 || zt === 304, Kh && (Hi = QT(fe, Xt, Kh)), !il && m.inArray("script", fe.dataTypes) > -1 && m.inArray("json", fe.dataTypes) < 0 && (fe.converters["text script"] = function() {
        }), Hi = jT(fe, Hi, Xt, il), il ? (fe.ifModified && (Ui = Xt.getResponseHeader("Last-Modified"), Ui && (m.lastModified[y] = Ui), Ui = Xt.getResponseHeader("etag"), Ui && (m.etag[y] = Ui)), zt === 204 || fe.type === "HEAD" ? ia = "nocontent" : zt === 304 ? ia = "notmodified" : (ia = Hi.state, pg = Hi.data, wd = Hi.error, il = !wd)) : (wd = ia, (zt || !ia) && (ia = "error", zt < 0 && (zt = 0))), Xt.status = zt, Xt.statusText = (Jr || ia) + "", il ? Mt.resolveWith(Te, [pg, ia, Xt]) : Mt.rejectWith(Te, [Xt, ia, wd]), Xt.statusCode(Tr), Tr = void 0, de && lt.trigger(
          il ? "ajaxSuccess" : "ajaxError",
          [Xt, fe, il ? pg : wd]
        ), yt.fireWith(Te, [Xt, ia]), de && (lt.trigger("ajaxComplete", [Xt, fe]), --m.active || m.event.trigger("ajaxStop")));
      }
      return Xt;
    },
    getJSON: function(d, f, x) {
      return m.get(d, f, x, "json");
    },
    getScript: function(d, f) {
      return m.get(d, void 0, f, "script");
    }
  }), m.each(["get", "post"], function(d, f) {
    m[f] = function(x, y, P, M) {
      return (typeof y == "function" || y === null) && (M = M || P, P = y, y = void 0), m.ajax(m.extend({
        url: x,
        type: f,
        dataType: M,
        data: y,
        success: P
      }, m.isPlainObject(x) && x));
    };
  }), m.ajaxPrefilter(function(d) {
    var f;
    for (f in d.headers)
      f.toLowerCase() === "content-type" && (d.contentType = d.headers[f] || "");
  }), m._evalUrl = function(d, f, x) {
    return m.ajax({
      url: d,
      // Make this explicit, since user can override this through ajaxSetup (trac-11264)
      type: "GET",
      dataType: "script",
      cache: !0,
      async: !1,
      global: !1,
      scriptAttrs: f.crossOrigin ? { crossOrigin: f.crossOrigin } : void 0,
      // Only evaluate the response if it is successful (gh-4126)
      // dataFilter is not invoked for failure responses, so using it instead
      // of the default converter is kludgy but it works.
      converters: {
        "text script": function() {
        }
      },
      dataFilter: function(y) {
        m.globalEval(y, f, x);
      }
    });
  }, m.fn.extend({
    wrapAll: function(d) {
      var f;
      return this[0] && (typeof d == "function" && (d = d.call(this[0])), f = m(d, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && f.insertBefore(this[0]), f.map(function() {
        for (var x = this; x.firstElementChild; )
          x = x.firstElementChild;
        return x;
      }).append(this)), this;
    },
    wrapInner: function(d) {
      return typeof d == "function" ? this.each(function(f) {
        m(this).wrapInner(d.call(this, f));
      }) : this.each(function() {
        var f = m(this), x = f.contents();
        x.length ? x.wrapAll(d) : f.append(d);
      });
    },
    wrap: function(d) {
      var f = typeof d == "function";
      return this.each(function(x) {
        m(this).wrapAll(f ? d.call(this, x) : d);
      });
    },
    unwrap: function(d) {
      return this.parent(d).not("body").each(function() {
        m(this).replaceWith(this.childNodes);
      }), this;
    }
  }), m.expr.pseudos.hidden = function(d) {
    return !m.expr.pseudos.visible(d);
  }, m.expr.pseudos.visible = function(d) {
    return !!(d.offsetWidth || d.offsetHeight || d.getClientRects().length);
  }, m.ajaxSettings.xhr = function() {
    return new e.XMLHttpRequest();
  };
  var ZT = {
    // File protocol always yields status code 0, assume 200
    0: 200
  };
  m.ajaxTransport(function(d) {
    var f;
    return {
      send: function(x, y) {
        var P, M = d.xhr();
        if (M.open(
          d.type,
          d.url,
          d.async,
          d.username,
          d.password
        ), d.xhrFields)
          for (P in d.xhrFields)
            M[P] = d.xhrFields[P];
        d.mimeType && M.overrideMimeType && M.overrideMimeType(d.mimeType), !d.crossDomain && !x["X-Requested-With"] && (x["X-Requested-With"] = "XMLHttpRequest");
        for (P in x)
          M.setRequestHeader(P, x[P]);
        f = function(H) {
          return function() {
            f && (f = M.onload = M.onerror = M.onabort = M.ontimeout = null, H === "abort" ? M.abort() : H === "error" ? y(
              // File: protocol always yields status 0; see trac-8605, trac-14207
              M.status,
              M.statusText
            ) : y(
              ZT[M.status] || M.status,
              M.statusText,
              // For XHR2 non-text, let the caller handle it (gh-2498)
              (M.responseType || "text") === "text" ? { text: M.responseText } : { binary: M.response },
              M.getAllResponseHeaders()
            ));
          };
        }, M.onload = f(), M.onabort = M.onerror = M.ontimeout = f("error"), f = f("abort");
        try {
          M.send(d.hasContent && d.data || null);
        } catch (H) {
          if (f)
            throw H;
        }
      },
      abort: function() {
        f && f();
      }
    };
  });
  function Wh(d) {
    return d.scriptAttrs || !d.headers && (d.crossDomain || // When dealing with JSONP (`s.dataTypes` include "json" then)
    // don't use a script tag so that error responses still may have
    // `responseJSON` set. Continue using a script tag for JSONP requests that:
    //   * are cross-domain as AJAX requests won't work without a CORS setup
    //   * have `scriptAttrs` set as that's a script-only functionality
    // Note that this means JSONP requests violate strict CSP script-src settings.
    // A proper solution is to migrate from using JSONP to a CORS setup.
    d.async && m.inArray("json", d.dataTypes) < 0);
  }
  m.ajaxSetup({
    accepts: {
      script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
    },
    converters: {
      "text script": function(d) {
        return m.globalEval(d), d;
      }
    }
  }), m.ajaxPrefilter("script", function(d) {
    d.cache === void 0 && (d.cache = !1), Wh(d) && (d.type = "GET");
  }), m.ajaxTransport("script", function(d) {
    if (Wh(d)) {
      var f, x;
      return {
        send: function(y, P) {
          f = m("<script>").attr(d.scriptAttrs || {}).prop({ charset: d.scriptCharset, src: d.url }).on("load error", x = function(M) {
            f.remove(), x = null, M && P(M.type === "error" ? 404 : 200, M.type);
          }), b.head.appendChild(f[0]);
        },
        abort: function() {
          x && x();
        }
      };
    }
  });
  var Yh = [], fg = /(=)\?(?=&|$)|\?\?/;
  m.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function() {
      var d = Yh.pop() || m.expando + "_" + Rh.guid++;
      return this[d] = !0, d;
    }
  }), m.ajaxPrefilter("jsonp", function(d, f, x) {
    var y, P, M, H = d.jsonp !== !1 && (fg.test(d.url) ? "url" : typeof d.data == "string" && (d.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && fg.test(d.data) && "data");
    return y = d.jsonpCallback = typeof d.jsonpCallback == "function" ? d.jsonpCallback() : d.jsonpCallback, H ? d[H] = d[H].replace(fg, "$1" + y) : d.jsonp !== !1 && (d.url += (dg.test(d.url) ? "&" : "?") + d.jsonp + "=" + y), d.converters["script json"] = function() {
      return M || m.error(y + " was not called"), M[0];
    }, d.dataTypes[0] = "json", P = e[y], e[y] = function() {
      M = arguments;
    }, x.always(function() {
      P === void 0 ? m(e).removeProp(y) : e[y] = P, d[y] && (d.jsonpCallback = f.jsonpCallback, Yh.push(y)), M && typeof P == "function" && P(M[0]), M = P = void 0;
    }), "script";
  }), m.ajaxPrefilter(function(d, f) {
    typeof d.data != "string" && !m.isPlainObject(d.data) && !Array.isArray(d.data) && // Don't disable data processing if explicitly set by the user.
    !("processData" in f) && (d.processData = !1), d.data instanceof e.FormData && (d.contentType = !1);
  }), m.parseHTML = function(d, f, x) {
    if (typeof d != "string" && !Du(d + ""))
      return [];
    typeof f == "boolean" && (x = f, f = !1);
    var y, P;
    return f || (f = new e.DOMParser().parseFromString("", "text/html")), y = Nu.exec(d), P = !x && [], y ? [f.createElement(y[1])] : (y = bd([d], f, P), P && P.length && m(P).remove(), m.merge([], y.childNodes));
  }, m.fn.load = function(d, f, x) {
    var y, P, M, H = this, oe = d.indexOf(" ");
    return oe > -1 && (y = Hl(d.slice(oe)), d = d.slice(0, oe)), typeof f == "function" ? (x = f, f = void 0) : f && typeof f == "object" && (P = "POST"), H.length > 0 && m.ajax({
      url: d,
      // If "type" variable is undefined, then "GET" method will be used.
      // Make value of this field explicit since
      // user can override it through ajaxSetup method
      type: P || "GET",
      dataType: "html",
      data: f
    }).done(function(J) {
      M = arguments, H.html(y ? (
        // If a selector was specified, locate the right elements in a dummy div
        // Exclude scripts to avoid IE 'Permission Denied' errors
        m("<div>").append(m.parseHTML(J)).find(y)
      ) : (
        // Otherwise use the full result
        J
      ));
    }).always(x && function(J, de) {
      H.each(function() {
        x.apply(this, M || [J.responseText, de, J]);
      });
    }), this;
  }, m.expr.pseudos.animated = function(d) {
    return m.grep(m.timers, function(f) {
      return d === f.elem;
    }).length;
  }, m.offset = {
    setOffset: function(d, f, x) {
      var y, P, M, H, oe, J, de, he = m.css(d, "position"), Pe = m(d), fe = {};
      he === "static" && (d.style.position = "relative"), oe = Pe.offset(), M = m.css(d, "top"), J = m.css(d, "left"), de = (he === "absolute" || he === "fixed") && (M + J).indexOf("auto") > -1, de ? (y = Pe.position(), H = y.top, P = y.left) : (H = parseFloat(M) || 0, P = parseFloat(J) || 0), typeof f == "function" && (f = f.call(d, x, m.extend({}, oe))), f.top != null && (fe.top = f.top - oe.top + H), f.left != null && (fe.left = f.left - oe.left + P), "using" in f ? f.using.call(d, fe) : Pe.css(fe);
    }
  }, m.fn.extend({
    // offset() relates an element's border box to the document origin
    offset: function(d) {
      if (arguments.length)
        return d === void 0 ? this : this.each(function(P) {
          m.offset.setOffset(this, d, P);
        });
      var f, x, y = this[0];
      if (y)
        return y.getClientRects().length ? (f = y.getBoundingClientRect(), x = y.ownerDocument.defaultView, {
          top: f.top + x.pageYOffset,
          left: f.left + x.pageXOffset
        }) : { top: 0, left: 0 };
    },
    // position() relates an element's margin box to its offset parent's padding box
    // This corresponds to the behavior of CSS absolute positioning
    position: function() {
      if (this[0]) {
        var d, f, x, y = this[0], P = { top: 0, left: 0 };
        if (m.css(y, "position") === "fixed")
          f = y.getBoundingClientRect();
        else {
          for (f = this.offset(), x = y.ownerDocument, d = y.offsetParent || x.documentElement; d && d !== x.documentElement && m.css(d, "position") === "static"; )
            d = d.offsetParent || x.documentElement;
          d && d !== y && d.nodeType === 1 && m.css(d, "position") !== "static" && (P = m(d).offset(), P.top += m.css(d, "borderTopWidth", !0), P.left += m.css(d, "borderLeftWidth", !0));
        }
        return {
          top: f.top - P.top - m.css(y, "marginTop", !0),
          left: f.left - P.left - m.css(y, "marginLeft", !0)
        };
      }
    },
    // This method will return documentElement in the following cases:
    // 1) For the element inside the iframe without offsetParent, this method will return
    //    documentElement of the parent window
    // 2) For the hidden or detached element
    // 3) For body or html element, i.e. in case of the html node - it will return itself
    //
    // but those exceptions were never presented as a real life use-cases
    // and might be considered as more preferable results.
    //
    // This logic, however, is not guaranteed and can change at any point in the future
    offsetParent: function() {
      return this.map(function() {
        for (var d = this.offsetParent; d && m.css(d, "position") === "static"; )
          d = d.offsetParent;
        return d || xe;
      });
    }
  }), m.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(d, f) {
    var x = f === "pageYOffset";
    m.fn[d] = function(y) {
      return Be(this, function(P, M, H) {
        var oe;
        if (A(P) ? oe = P : P.nodeType === 9 && (oe = P.defaultView), H === void 0)
          return oe ? oe[f] : P[M];
        oe ? oe.scrollTo(
          x ? oe.pageXOffset : H,
          x ? H : oe.pageYOffset
        ) : P[M] = H;
      }, d, y, arguments.length);
    };
  }), m.each({ Height: "height", Width: "width" }, function(d, f) {
    m.each({
      padding: "inner" + d,
      content: f,
      "": "outer" + d
    }, function(x, y) {
      m.fn[y] = function(P, M) {
        var H = arguments.length && (x || typeof P != "boolean"), oe = x || (P === !0 || M === !0 ? "margin" : "border");
        return Be(this, function(J, de, he) {
          var Pe;
          return A(J) ? y.indexOf("outer") === 0 ? J["inner" + d] : J.document.documentElement["client" + d] : J.nodeType === 9 ? (Pe = J.documentElement, Math.max(
            J.body["scroll" + d],
            Pe["scroll" + d],
            J.body["offset" + d],
            Pe["offset" + d],
            Pe["client" + d]
          )) : he === void 0 ? (
            // Get width or height on the element, requesting but not forcing parseFloat
            m.css(J, de, oe)
          ) : (
            // Set width or height on the element
            m.style(J, de, he, oe)
          );
        }, f, H ? P : void 0, H);
      };
    });
  }), m.each([
    "ajaxStart",
    "ajaxStop",
    "ajaxComplete",
    "ajaxError",
    "ajaxSuccess",
    "ajaxSend"
  ], function(d, f) {
    m.fn[f] = function(x) {
      return this.on(f, x);
    };
  }), m.fn.extend({
    bind: function(d, f, x) {
      return this.on(d, null, f, x);
    },
    unbind: function(d, f) {
      return this.off(d, null, f);
    },
    delegate: function(d, f, x, y) {
      return this.on(f, d, x, y);
    },
    undelegate: function(d, f, x) {
      return arguments.length === 1 ? this.off(d, "**") : this.off(f, d || "**", x);
    },
    hover: function(d, f) {
      return this.on("mouseenter", d).on("mouseleave", f || d);
    }
  }), m.each(
    "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
    function(d, f) {
      m.fn[f] = function(x, y) {
        return arguments.length > 0 ? this.on(f, null, x, y) : this.trigger(f);
      };
    }
  ), m.proxy = function(d, f) {
    var x, y, P;
    if (typeof f == "string" && (x = d[f], f = d, d = x), typeof d == "function")
      return y = n.call(arguments, 2), P = function() {
        return d.apply(f || this, y.concat(n.call(arguments)));
      }, P.guid = d.guid = d.guid || m.guid++, P;
  }, m.holdReady = function(d) {
    d ? m.readyWait++ : m.ready(!0);
  }, m.expr[":"] = m.expr.filters = m.expr.pseudos, typeof define == "function" && define.amd && define("jquery", [], function() {
    return m;
  });
  var zT = e.jQuery, qT = e.$;
  return m.noConflict = function(d) {
    return e.$ === m && (e.$ = qT), d && e.jQuery === m && (e.jQuery = zT), m;
  }, m;
}
var Su = x4(window);
var Z = Su, me = function(e, t) {
  if (me.factory(e, t))
    return me;
  if (this instanceof me)
    return Z(e).DataTable(t);
  t = e;
  var r = this, o = t === void 0, n = this.length;
  return o && (t = {}), this.api = function() {
    return new kt(this);
  }, this.each(function() {
    var a = {}, l = n > 1 ? (
      // optimisation for single table case
      Dx(a, t, !0)
    ) : t, i = 0, s, u = this.getAttribute("id"), c = me.defaults, g = Z(this);
    if (this.nodeName.toLowerCase() != "table") {
      $n(null, 0, "Non-table node initialisation (" + this.nodeName + ")", 2);
      return;
    }
    l.on && l.on.options && kx(g, "options", l.on.options), g.trigger("options.dt", l), Px(c), t_(c.column), bl(c, c, !0), bl(c.column, c.column, !0), bl(c, Z.extend(l, x_(g.data())), !0);
    var p = me.settings;
    for (i = 0, s = p.length; i < s; i++) {
      var h = p[i];
      if (h.nTable == this || h.nTHead && h.nTHead.parentNode == this || h.nTFoot && h.nTFoot.parentNode == this) {
        var v = l.bRetrieve !== void 0 ? l.bRetrieve : c.bRetrieve, A = l.bDestroy !== void 0 ? l.bDestroy : c.bDestroy;
        if (o || v)
          return h.oInstance;
        if (A) {
          new me.Api(h).destroy();
          break;
        } else {
          $n(h, 0, "Cannot reinitialise DataTable", 3);
          return;
        }
      }
      if (h.sTableId == this.id) {
        p.splice(i, 1);
        break;
      }
    }
    (u === null || u === "") && (u = "DataTables_Table_" + me.ext._unique++, this.id = u), g.children("colgroup").remove();
    var S = Z.extend(!0, {}, me.models.oSettings, {
      sDestroyWidth: g[0].style.width,
      sInstance: u,
      sTableId: u,
      colgroup: Z("<colgroup>"),
      fastData: function(K, W, xe) {
        return Bn(S, K, W, xe);
      }
    });
    S.nTable = this, S.oInit = l, p.push(S), S.api = new kt(S), S.oInstance = r.length === 1 ? r : g.dataTable(), Px(l), l.aLengthMenu && !l.iDisplayLength && (l.iDisplayLength = Array.isArray(l.aLengthMenu[0]) ? l.aLengthMenu[0][0] : Z.isPlainObject(l.aLengthMenu[0]) ? l.aLengthMenu[0].value : l.aLengthMenu[0]), l = Dx(Z.extend(!0, {}, c), l), wl(S.oFeatures, l, [
      "bPaginate",
      "bLengthChange",
      "bFilter",
      "bSort",
      "bSortMulti",
      "bInfo",
      "bProcessing",
      "bAutoWidth",
      "bSortClasses",
      "bServerSide",
      "bDeferRender"
    ]), wl(S, l, [
      "ajax",
      "fnFormatNumber",
      "sServerMethod",
      "aaSorting",
      "aaSortingFixed",
      "aLengthMenu",
      "sPaginationType",
      "iStateDuration",
      "bSortCellsTop",
      "iTabIndex",
      "sDom",
      "fnStateLoadCallback",
      "fnStateSaveCallback",
      "renderer",
      "searchDelay",
      "rowId",
      "caption",
      "layout",
      "orderDescReverse",
      "orderIndicators",
      "orderHandler",
      "titleRow",
      "typeDetect",
      "columnTitleTag",
      ["iCookieDuration", "iStateDuration"],
      // backwards compat
      ["oSearch", "oPreviousSearch"],
      ["aoSearchCols", "aoPreSearchCols"],
      ["iDisplayLength", "_iDisplayLength"]
    ]), wl(S.oScroll, l, [
      ["sScrollX", "sX"],
      ["sScrollXInner", "sXInner"],
      ["sScrollY", "sY"],
      ["bScrollCollapse", "bCollapse"]
    ]), wl(S.oLanguage, l, "fnInfoCallback"), Sn(S, "aoDrawCallback", l.fnDrawCallback), Sn(S, "aoStateSaveParams", l.fnStateSaveParams), Sn(S, "aoStateLoadParams", l.fnStateLoadParams), Sn(S, "aoStateLoaded", l.fnStateLoaded), Sn(S, "aoRowCallback", l.fnRowCallback), Sn(S, "aoRowCreatedCallback", l.fnCreatedRow), Sn(S, "aoHeaderCallback", l.fnHeaderCallback), Sn(S, "aoFooterCallback", l.fnFooterCallback), Sn(S, "aoInitComplete", l.fnInitComplete), Sn(S, "aoPreDrawCallback", l.fnPreDrawCallback), S.rowIdFn = Ks(l.rowId), l.on && Object.keys(l.on).forEach(function(K) {
      kx(g, K, l.on[K]);
    }), _4(S);
    var b = S.oClasses;
    Z.extend(b, me.ext.classes, l.oClasses), g.addClass(b.table), S.oFeatures.bPaginate || (l.iDisplayStart = 0), S.iInitDisplayStart === void 0 && (S.iInitDisplayStart = l.iDisplayStart, S._iDisplayStart = l.iDisplayStart);
    var T = l.iDeferLoading;
    if (T !== null) {
      S.deferLoading = !0;
      var w = Array.isArray(T);
      S._iRecordsDisplay = w ? T[0] : T, S._iRecordsTotal = w ? T[1] : T;
    }
    var N = [], O = this.getElementsByTagName("thead"), m = s_(S, O[0]);
    if (l.aoColumns)
      N = l.aoColumns;
    else if (m.length)
      for (i = 0, s = m[0].length; i < s; i++)
        N.push(null);
    for (i = 0, s = N.length; i < s; i++)
      r_(S);
    P4(S, l.aoColumnDefs, N, m, function(K, W) {
      up(S, K, W);
    });
    var _ = g.children("tbody").find("tr:first-child").eq(0);
    if (_.length) {
      var X = function(K, W) {
        return K.getAttribute("data-" + W) !== null ? W : null;
      };
      Z(_[0]).children("th, td").each(function(K, W) {
        var xe = S.aoColumns[K];
        if (xe || $n(S, 0, "Incorrect column count", 18), xe.mData === K) {
          var Ce = X(W, "sort") || X(W, "order"), Q = X(W, "filter") || X(W, "search");
          (Ce !== null || Q !== null) && (xe.mData = {
            _: K + ".display",
            sort: Ce !== null ? K + ".@data-" + Ce : void 0,
            type: Ce !== null ? K + ".@data-" + Ce : void 0,
            filter: Q !== null ? K + ".@data-" + Q : void 0
          }, xe._isArrayHost = !0, up(S, K));
        }
      });
    }
    Sn(S, "aoDrawCallback", Dm);
    var $ = S.oFeatures;
    if (l.bStateSave && ($.bStateSave = !0), l.aaSorting === void 0) {
      var E = S.aaSorting;
      for (i = 0, s = E.length; i < s; i++)
        E[i][1] = S.aoColumns[i].asSorting[0];
    }
    gp(S), Sn(S, "aoDrawCallback", function() {
      (S.bSorted || gn(S) === "ssp" || $.bDeferRender) && gp(S);
    });
    var D = g.children("caption");
    S.caption && (D.length === 0 && (D = Z("<caption/>").prependTo(g)), D.html(S.caption)), D.length && (D[0]._captionSide = D.css("caption-side"), S.captionNode = D[0]), D.length ? S.colgroup.insertAfter(D) : S.colgroup.prependTo(S.nTable), O.length === 0 && (O = Z("<thead/>").appendTo(g)), S.nTHead = O[0];
    var U = g.children("tbody");
    U.length === 0 && (U = Z("<tbody/>").insertAfter(O)), S.nTBody = U[0];
    var Y = g.children("tfoot");
    Y.length === 0 && (Y = Z("<tfoot/>").appendTo(g)), S.nTFoot = Y[0], S.aiDisplay = S.aiDisplayMaster.slice(), S.bInitialised = !0;
    var G = S.oLanguage;
    Z.extend(!0, G, l.oLanguage), G.sUrl ? Z.ajax({
      dataType: "json",
      url: G.sUrl,
      success: function(K) {
        bl(c.oLanguage, K), Z.extend(!0, G, K, S.oInit.oLanguage), jt(S, null, "i18n", [S], !0), Sc(S);
      },
      error: function() {
        $n(S, 0, "i18n file loading error", 21), Sc(S);
      }
    }) : (jt(S, null, "i18n", [S], !0), Sc(S));
  }), r = null, this;
};
me.ext = go = {
  /**
   * DataTables build type (expanded by the download builder)
   *
   *  @type string
   */
  builder: "-source-",
  /**
   * Buttons. For use with the Buttons extension for DataTables. This is
   * defined here so other extensions can define buttons regardless of load
   * order. It is _not_ used by DataTables core.
   *
   *  @type object
   *  @default {}
   */
  buttons: {},
  /**
   * ColumnControl buttons and content
   *
   *  @type object
   */
  ccContent: {},
  /**
   * Element class names
   *
   *  @type object
   *  @default {}
   */
  classes: {},
  /**
   * Error reporting.
   * 
   * How should DataTables report an error. Can take the value 'alert',
   * 'throw', 'none' or a function.
   *
   *  @type string|function
   *  @default alert
   */
  errMode: "alert",
  /** HTML entity escaping */
  escape: {
    /** When reading data-* attributes for initialisation options */
    attributes: !1
  },
  /**
   * Legacy so v1 plug-ins don't throw js errors on load
   */
  feature: [],
  /**
   * Feature plug-ins.
   * 
   * This is an object of callbacks which provide the features for DataTables
   * to be initialised via the `layout` option.
   */
  features: {},
  /**
   * Row searching.
   * 
   * This method of searching is complimentary to the default type based
   * searching, and a lot more comprehensive as it allows you complete control
   * over the searching logic. Each element in this array is a function
   * (parameters described below) that is called for every row in the table,
   * and your logic decides if it should be included in the searching data set
   * or not.
   *
   * Searching functions have the following input parameters:
   *
   * 1. `{object}` DataTables settings object: see
   *    {@link DataTable.models.oSettings}
   * 2. `{array|object}` Data for the row to be processed (same as the
   *    original format that was passed in as the data source, or an array
   *    from a DOM data source
   * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
   *    can be useful to retrieve the `TR` element if you need DOM interaction.
   *
   * And the following return is expected:
   *
   * * {boolean} Include the row in the searched result set (true) or not
   *   (false)
   *
   * Note that as with the main search ability in DataTables, technically this
   * is "filtering", since it is subtractive. However, for consistency in
   * naming we call it searching here.
   *
   *  @type array
   *  @default []
   *
   *  @example
   *    // The following example shows custom search being applied to the
   *    // fourth column (i.e. the data[3] index) based on two input values
   *    // from the end-user, matching the data in a certain range.
   *    $.fn.dataTable.ext.search.push(
   *      function( settings, data, dataIndex ) {
   *        var min = document.getElementById('min').value * 1;
   *        var max = document.getElementById('max').value * 1;
   *        var version = data[3] == "-" ? 0 : data[3]*1;
   *
   *        if ( min == "" && max == "" ) {
   *          return true;
   *        }
   *        else if ( min == "" && version < max ) {
   *          return true;
   *        }
   *        else if ( min < version && "" == max ) {
   *          return true;
   *        }
   *        else if ( min < version && version < max ) {
   *          return true;
   *        }
   *        return false;
   *      }
   *    );
   */
  search: [],
  /**
   * Selector extensions
   *
   * The `selector` option can be used to extend the options available for the
   * selector modifier options (`selector-modifier` object data type) that
   * each of the three built in selector types offer (row, column and cell +
   * their plural counterparts). For example the Select extension uses this
   * mechanism to provide an option to select only rows, columns and cells
   * that have been marked as selected by the end user (`{selected: true}`),
   * which can be used in conjunction with the existing built in selector
   * options.
   *
   * Each property is an array to which functions can be pushed. The functions
   * take three attributes:
   *
   * * Settings object for the host table
   * * Options object (`selector-modifier` object type)
   * * Array of selected item indexes
   *
   * The return is an array of the resulting item indexes after the custom
   * selector has been applied.
   *
   *  @type object
   */
  selector: {
    cell: [],
    column: [],
    row: []
  },
  /**
   * Legacy configuration options. Enable and disable legacy options that
   * are available in DataTables.
   *
   *  @type object
   */
  legacy: {
    /**
     * Enable / disable DataTables 1.9 compatible server-side processing
     * requests
     *
     *  @type boolean
     *  @default null
     */
    ajax: null
  },
  /**
   * Pagination plug-in methods.
   * 
   * Each entry in this object is a function and defines which buttons should
   * be shown by the pagination rendering method that is used for the table:
   * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
   * buttons are displayed in the document, while the functions here tell it
   * what buttons to display. This is done by returning an array of button
   * descriptions (what each button will do).
   *
   * Pagination types (the four built in options and any additional plug-in
   * options defined here) can be used through the `paginationType`
   * initialisation parameter.
   *
   * The functions defined take two parameters:
   *
   * 1. `{int} page` The current page index
   * 2. `{int} pages` The number of pages in the table
   *
   * Each function is expected to return an array where each element of the
   * array can be one of:
   *
   * * `first` - Jump to first page when activated
   * * `last` - Jump to last page when activated
   * * `previous` - Show previous page when activated
   * * `next` - Show next page when activated
   * * `{int}` - Show page of the index given
   * * `{array}` - A nested array containing the above elements to add a
   *   containing 'DIV' element (might be useful for styling).
   *
   * Note that DataTables v1.9- used this object slightly differently whereby
   * an object with two functions would be defined for each plug-in. That
   * ability is still supported by DataTables 1.10+ to provide backwards
   * compatibility, but this option of use is now decremented and no longer
   * documented in DataTables 1.10+.
   *
   *  @type object
   *  @default {}
   *
   *  @example
   *    // Show previous, next and current page buttons only
   *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
   *      return [ 'previous', page, 'next' ];
   *    };
   */
  pager: {},
  renderer: {
    pageButton: {},
    header: {}
  },
  /**
   * Ordering plug-ins - custom data source
   * 
   * The extension options for ordering of data available here is complimentary
   * to the default type based ordering that DataTables typically uses. It
   * allows much greater control over the data that is being used to
   * order a column, but is necessarily therefore more complex.
   * 
   * This type of ordering is useful if you want to do ordering based on data
   * live from the DOM (for example the contents of an 'input' element) rather
   * than just the static string that DataTables knows of.
   * 
   * The way these plug-ins work is that you create an array of the values you
   * wish to be ordering for the column in question and then return that
   * array. The data in the array much be in the index order of the rows in
   * the table (not the currently ordering order!). Which order data gathering
   * function is run here depends on the `dt-init columns.orderDataType`
   * parameter that is used for the column (if any).
   *
   * The functions defined take two parameters:
   *
   * 1. `{object}` DataTables settings object: see
   *    {@link DataTable.models.oSettings}
   * 2. `{int}` Target column index
   *
   * Each function is expected to return an array:
   *
   * * `{array}` Data for the column to be ordering upon
   *
   *  @type array
   *
   *  @example
   *    // Ordering using `input` node values
   *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
   *    {
   *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
   *        return $('input', td).val();
   *      } );
   *    }
   */
  order: {},
  /**
   * Type based plug-ins.
   *
   * Each column in DataTables has a type assigned to it, either by automatic
   * detection or by direct assignment using the `type` option for the column.
   * The type of a column will effect how it is ordering and search (plug-ins
   * can also make use of the column type if required).
   *
   * @namespace
   */
  type: {
    /**
     * Automatic column class assignment
     */
    className: {},
    /**
     * Type detection functions.
     *
     * The functions defined in this object are used to automatically detect
     * a column's type, making initialisation of DataTables super easy, even
     * when complex data is in the table.
     *
     * The functions defined take two parameters:
     *
        *  1. `{*}` Data from the column cell to be analysed
        *  2. `{settings}` DataTables settings object. This can be used to
        *     perform context specific type detection - for example detection
        *     based on language settings such as using a comma for a decimal
        *     place. Generally speaking the options from the settings will not
        *     be required
     *
     * Each function is expected to return:
     *
     * * `{string|null}` Data type detected, or null if unknown (and thus
     *   pass it on to the other type detection functions.
     *
     *  @type array
     *
     *  @example
     *    // Currency type detection plug-in:
     *    $.fn.dataTable.ext.type.detect.push(
     *      function ( data, settings ) {
     *        // Check the numeric part
     *        if ( ! data.substring(1).match(/[0-9]/) ) {
     *          return null;
     *        }
     *
     *        // Check prefixed by currency
     *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
     *          return 'currency';
     *        }
     *        return null;
     *      }
     *    );
     */
    detect: [],
    /**
     * Automatic renderer assignment
     */
    render: {},
    /**
     * Type based search formatting.
     *
     * The type based searching functions can be used to pre-format the
     * data to be search on. For example, it can be used to strip HTML
     * tags or to de-format telephone numbers for numeric only searching.
     *
     * Note that is a search is not defined for a column of a given type,
     * no search formatting will be performed.
     * 
     * Pre-processing of searching data plug-ins - When you assign the sType
     * for a column (or have it automatically detected for you by DataTables
     * or a type detection plug-in), you will typically be using this for
     * custom sorting, but it can also be used to provide custom searching
     * by allowing you to pre-processing the data and returning the data in
     * the format that should be searched upon. This is done by adding
     * functions this object with a parameter name which matches the sType
     * for that target column. This is the corollary of <i>afnSortData</i>
     * for searching data.
     *
     * The functions defined take a single parameter:
     *
        *  1. `{*}` Data from the column cell to be prepared for searching
     *
     * Each function is expected to return:
     *
     * * `{string|null}` Formatted string that will be used for the searching.
     *
     *  @type object
     *  @default {}
     *
     *  @example
     *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
     *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
     *    }
     */
    search: {},
    /**
     * Type based ordering.
     *
     * The column type tells DataTables what ordering to apply to the table
     * when a column is sorted upon. The order for each type that is defined,
     * is defined by the functions available in this object.
     *
     * Each ordering option can be described by three properties added to
     * this object:
     *
     * * `{type}-pre` - Pre-formatting function
     * * `{type}-asc` - Ascending order function
     * * `{type}-desc` - Descending order function
     *
     * All three can be used together, only `{type}-pre` or only
     * `{type}-asc` and `{type}-desc` together. It is generally recommended
     * that only `{type}-pre` is used, as this provides the optimal
     * implementation in terms of speed, although the others are provided
     * for compatibility with existing JavaScript sort functions.
     *
     * `{type}-pre`: Functions defined take a single parameter:
     *
        *  1. `{*}` Data from the column cell to be prepared for ordering
     *
     * And return:
     *
     * * `{*}` Data to be sorted upon
     *
     * `{type}-asc` and `{type}-desc`: Functions are typical JavaScript sort
     * functions, taking two parameters:
     *
        *  1. `{*}` Data to compare to the second parameter
        *  2. `{*}` Data to compare to the first parameter
     *
     * And returning:
     *
     * * `{*}` Ordering match: <0 if first parameter should be sorted lower
     *   than the second parameter, ===0 if the two parameters are equal and
     *   >0 if the first parameter should be sorted height than the second
     *   parameter.
     * 
     *  @type object
     *  @default {}
     *
     *  @example
     *    // Numeric ordering of formatted numbers with a pre-formatter
     *    $.extend( $.fn.dataTable.ext.type.order, {
     *      "string-pre": function(x) {
     *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
     *        return parseFloat( a );
     *      }
     *    } );
     *
     *  @example
     *    // Case-sensitive string ordering, with no pre-formatting method
     *    $.extend( $.fn.dataTable.ext.order, {
     *      "string-case-asc": function(x,y) {
     *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
     *      },
     *      "string-case-desc": function(x,y) {
     *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
     *      }
     *    } );
     */
    order: {}
  },
  /**
   * Unique DataTables instance counter
   *
   * @type int
   * @private
   */
  _unique: 0,
  //
  // Depreciated
  // The following properties are retained for backwards compatibility only.
  // The should not be used in new projects and will be removed in a future
  // version
  //
  /**
   * Version check function.
   *  @type function
   *  @depreciated Since 1.10
   */
  fnVersionCheck: me.fnVersionCheck,
  /**
   * Index for what 'this' index API functions should use
   *  @type int
   *  @deprecated Since v1.10
   */
  iApiIndex: 0,
  /**
   * Software version
   *  @type string
   *  @deprecated Since v1.10
   */
  sVersion: me.version
};
Z.extend(go, {
  afnFiltering: go.search,
  aTypes: go.type.detect,
  ofnSearch: go.type.search,
  oSort: go.type.order,
  afnSortData: go.order,
  aoFeatures: go.feature,
  oStdClasses: go.classes,
  oPagination: go.pager
});
Z.extend(me.ext.classes, {
  container: "dt-container",
  empty: {
    row: "dt-empty"
  },
  info: {
    container: "dt-info"
  },
  layout: {
    row: "dt-layout-row",
    cell: "dt-layout-cell",
    tableRow: "dt-layout-table",
    tableCell: "",
    start: "dt-layout-start",
    end: "dt-layout-end",
    full: "dt-layout-full"
  },
  length: {
    container: "dt-length",
    select: "dt-input"
  },
  order: {
    canAsc: "dt-orderable-asc",
    canDesc: "dt-orderable-desc",
    isAsc: "dt-ordering-asc",
    isDesc: "dt-ordering-desc",
    none: "dt-orderable-none",
    position: "sorting_"
  },
  processing: {
    container: "dt-processing"
  },
  scrolling: {
    body: "dt-scroll-body",
    container: "dt-scroll",
    footer: {
      self: "dt-scroll-foot",
      inner: "dt-scroll-footInner"
    },
    header: {
      self: "dt-scroll-head",
      inner: "dt-scroll-headInner"
    }
  },
  search: {
    container: "dt-search",
    input: "dt-input"
  },
  table: "dataTable",
  tbody: {
    cell: "",
    row: ""
  },
  thead: {
    cell: "",
    row: ""
  },
  tfoot: {
    cell: "",
    row: ""
  },
  paging: {
    active: "current",
    button: "dt-paging-button",
    container: "dt-paging",
    disabled: "disabled",
    nav: ""
  }
});
var go, kt, ct, sr, Ug = {}, v4 = /[\r\n\u2028]/g, eh = /<([^>]*>)/g, S4 = Math.pow(2, 28), Ax = /^\d{2,4}[./-]\d{1,2}[./-]\d{1,2}([T ]{1}\d{1,2}[:.]\d{2}([.:]\d{2})?)?$/, b4 = new RegExp("(\\" + ["/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^", "-"].join("|\\") + ")", "g"), th = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi, sn = function(e) {
  return !e || e === !0 || e === "-";
}, zw = function(e) {
  var t = parseInt(e, 10);
  return !isNaN(t) && isFinite(e) ? t : null;
}, qw = function(e, t) {
  return Ug[t] || (Ug[t] = new RegExp(mp(t), "g")), typeof e == "string" && t !== "." ? e.replace(/\./g, "").replace(Ug[t], ".") : e;
}, Jd = function(e, t, r, o) {
  var n = typeof e, a = n === "string";
  return n === "number" || n === "bigint" || o && sn(e) ? !0 : (t && a && (e = qw(e, t)), r && a && (e = e.replace(th, "")), !isNaN(parseFloat(e)) && isFinite(e));
}, y4 = function(e) {
  return sn(e) || typeof e == "string";
}, Wc = function(e, t, r, o) {
  if (o && sn(e))
    return !0;
  if (typeof e == "string" && e.match(/<(input|select)/i))
    return null;
  var n = y4(e);
  return n && Jd(Qa(e), t, r, o) ? !0 : null;
}, Eo = function(e, t, r) {
  var o = [], n = 0, a = e.length;
  if (r !== void 0)
    for (; n < a; n++)
      e[n] && e[n][t] && o.push(e[n][t][r]);
  else
    for (; n < a; n++)
      e[n] && o.push(e[n][t]);
  return o;
}, bu = function(e, t, r, o) {
  var n = [], a = 0, l = t.length;
  if (o !== void 0)
    for (; a < l; a++)
      e[t[a]] && e[t[a]][r] && n.push(e[t[a]][r][o]);
  else
    for (; a < l; a++)
      e[t[a]] && n.push(e[t[a]][r]);
  return n;
}, ml = function(e, t) {
  var r = [], o;
  t === void 0 ? (t = 0, o = e) : (o = t, t = e);
  for (var n = t; n < o; n++)
    r.push(n);
  return r;
}, Jw = function(e) {
  for (var t = [], r = 0, o = e.length; r < o; r++)
    e[r] && t.push(e[r]);
  return t;
}, Qa = function(e, t) {
  if (!e || typeof e != "string")
    return e;
  if (e.length > S4)
    throw new Error("Exceeded max str len");
  var r;
  e = e.replace(eh, t || "");
  do
    r = e, e = e.replace(/<script/i, "");
  while (e !== r);
  return r;
}, si = function(e) {
  return Array.isArray(e) && (e = e.join(",")), typeof e == "string" ? e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;") : e;
}, Yc = function(e, t) {
  if (typeof e != "string")
    return e;
  var r = e.normalize ? e.normalize("NFD") : e;
  return r.length !== e.length ? (t === !0 ? e + " " : "") + r.replace(/[\u0300-\u036f]/g, "") : r;
}, w4 = function(e) {
  if (e.length < 2)
    return !0;
  for (var t = e.slice().sort(), r = t[0], o = 1, n = t.length; o < n; o++) {
    if (t[o] === r)
      return !1;
    r = t[o];
  }
  return !0;
}, sd = function(e) {
  if (Array.from && Set)
    return Array.from(new Set(e));
  if (w4(e))
    return e.slice();
  var t = [], r, o, n = e.length, a, l = 0;
  e: for (o = 0; o < n; o++) {
    for (r = e[o], a = 0; a < l; a++)
      if (t[a] === r)
        continue e;
    t.push(r), l++;
  }
  return t;
}, e_ = function(e, t) {
  if (Array.isArray(t))
    for (var r = 0; r < t.length; r++)
      e_(e, t[r]);
  else
    e.push(t);
  return e;
};
function Es(e, t) {
  t && t.split(" ").forEach(function(r) {
    r && e.classList.add(r);
  });
}
me.util = {
  /**
   * Return a string with diacritic characters decomposed
   * @param {*} mixed Function or string to normalize
   * @param {*} both Return original string and the normalized string
   * @returns String or undefined
   */
  diacritics: function(e, t) {
    var r = typeof e;
    if (r !== "function")
      return Yc(e, t);
    Yc = e;
  },
  /**
   * Debounce a function
   *
   * @param {function} fn Function to be called
   * @param {integer} freq Call frequency in mS
   * @return {function} Wrapped function
   */
  debounce: function(e, t) {
    var r;
    return function() {
      var o = this, n = arguments;
      clearTimeout(r), r = setTimeout(function() {
        e.apply(o, n);
      }, t || 250);
    };
  },
  /**
   * Throttle the calls to a function. Arguments and context are maintained
   * for the throttled function.
   *
   * @param {function} fn Function to be called
   * @param {integer} freq Call frequency in mS
   * @return {function} Wrapped function
   */
  throttle: function(e, t) {
    var r = t !== void 0 ? t : 200, o, n;
    return function() {
      var a = this, l = +/* @__PURE__ */ new Date(), i = arguments;
      o && l < o + r ? (clearTimeout(n), n = setTimeout(function() {
        o = void 0, e.apply(a, i);
      }, r)) : (o = l, e.apply(a, i));
    };
  },
  /**
   * Escape a string such that it can be used in a regular expression
   *
   *  @param {string} val string to escape
   *  @returns {string} escaped string
   */
  escapeRegex: function(e) {
    return e.replace(b4, "\\$1");
  },
  /**
   * Create a function that will write to a nested object or array
   * @param {*} source JSON notation string
   * @returns Write function
   */
  set: function(e) {
    if (Z.isPlainObject(e))
      return me.util.set(e._);
    if (e === null)
      return function() {
      };
    if (typeof e == "function")
      return function(r, o, n) {
        e(r, "set", o, n);
      };
    if (typeof e == "string" && (e.indexOf(".") !== -1 || e.indexOf("[") !== -1 || e.indexOf("(") !== -1)) {
      var t = function(r, o, n) {
        for (var a = $x(n), l, i = a[a.length - 1], s, u, c, g, p = 0, h = a.length - 1; p < h; p++) {
          if (a[p] === "__proto__" || a[p] === "constructor")
            throw new Error("Cannot set prototype values");
          if (s = a[p].match(Cd), u = a[p].match(ji), s) {
            if (a[p] = a[p].replace(Cd, ""), r[a[p]] = [], l = a.slice(), l.splice(0, p + 1), g = l.join("."), Array.isArray(o))
              for (var v = 0, A = o.length; v < A; v++)
                c = {}, t(c, o[v], g), r[a[p]].push(c);
            else
              r[a[p]] = o;
            return;
          } else u && (a[p] = a[p].replace(ji, ""), r = r[a[p]](o));
          (r[a[p]] === null || r[a[p]] === void 0) && (r[a[p]] = {}), r = r[a[p]];
        }
        i.match(ji) ? r = r[i.replace(ji, "")](o) : r[i.replace(Cd, "")] = o;
      };
      return function(r, o) {
        return t(r, o, e);
      };
    } else
      return function(r, o) {
        r[e] = o;
      };
  },
  /**
   * Create a function that will read nested objects from arrays, based on JSON notation
   * @param {*} source JSON notation string
   * @returns Value read
   */
  get: function(e) {
    if (Z.isPlainObject(e)) {
      var t = {};
      return Z.each(e, function(o, n) {
        n && (t[o] = me.util.get(n));
      }), function(o, n, a, l) {
        var i = t[n] || t._;
        return i !== void 0 ? i(o, n, a, l) : o;
      };
    } else {
      if (e === null)
        return function(o) {
          return o;
        };
      if (typeof e == "function")
        return function(o, n, a, l) {
          return e(o, n, a, l);
        };
      if (typeof e == "string" && (e.indexOf(".") !== -1 || e.indexOf("[") !== -1 || e.indexOf("(") !== -1)) {
        var r = function(o, n, a) {
          var l, i, s, u;
          if (a !== "")
            for (var c = $x(a), g = 0, p = c.length; g < p; g++) {
              if (l = c[g].match(Cd), i = c[g].match(ji), l) {
                if (c[g] = c[g].replace(Cd, ""), c[g] !== "" && (o = o[c[g]]), s = [], c.splice(0, g + 1), u = c.join("."), Array.isArray(o))
                  for (var h = 0, v = o.length; h < v; h++)
                    s.push(r(o[h], n, u));
                var A = l[0].substring(1, l[0].length - 1);
                o = A === "" ? s : s.join(A);
                break;
              } else if (i) {
                c[g] = c[g].replace(ji, ""), o = o[c[g]]();
                continue;
              }
              if (o === null || o[c[g]] === null)
                return null;
              if (o === void 0 || o[c[g]] === void 0)
                return;
              o = o[c[g]];
            }
          return o;
        };
        return function(o, n) {
          return r(o, n, e);
        };
      } else
        return function(o) {
          return o[e];
        };
    }
  },
  stripHtml: function(e, t) {
    var r = typeof e;
    if (r === "function") {
      Qa = e;
      return;
    } else if (r === "string")
      return Qa(e, t);
    return e;
  },
  escapeHtml: function(e) {
    var t = typeof e;
    if (t === "function") {
      si = e;
      return;
    } else if (t === "string" || Array.isArray(e))
      return si(e);
    return e;
  },
  unique: sd
};
function $m(e) {
  var t = "a aa ai ao as b fn i m o s ", r, o, n = {};
  Z.each(e, function(a) {
    r = a.match(/^([^A-Z]+?)([A-Z])/), r && t.indexOf(r[1] + " ") !== -1 && (o = a.replace(r[0], r[2].toLowerCase()), n[o] = a, r[1] === "o" && $m(e[a]));
  }), e._hungarianMap = n;
}
function bl(e, t, r) {
  e._hungarianMap || $m(e);
  var o;
  Z.each(t, function(n) {
    o = e._hungarianMap[n], o !== void 0 && (r || t[o] === void 0) && (o.charAt(0) === "o" ? (t[o] || (t[o] = {}), Z.extend(!0, t[o], t[n]), bl(e[o], t[o], r)) : t[o] = t[n]);
  });
}
var Ko = function(e, t, r) {
  e[t] !== void 0 && (e[r] = e[t]);
};
function Px(e) {
  Ko(e, "ordering", "bSort"), Ko(e, "orderMulti", "bSortMulti"), Ko(e, "orderClasses", "bSortClasses"), Ko(e, "orderCellsTop", "bSortCellsTop"), Ko(e, "order", "aaSorting"), Ko(e, "orderFixed", "aaSortingFixed"), Ko(e, "paging", "bPaginate"), Ko(e, "pagingType", "sPaginationType"), Ko(e, "pageLength", "iDisplayLength"), Ko(e, "searching", "bFilter"), typeof e.sScrollX == "boolean" && (e.sScrollX = e.sScrollX ? "100%" : ""), typeof e.scrollX == "boolean" && (e.scrollX = e.scrollX ? "100%" : ""), typeof e.bSort == "object" ? (e.orderIndicators = e.bSort.indicators !== void 0 ? e.bSort.indicators : !0, e.orderHandler = e.bSort.handler !== void 0 ? e.bSort.handler : !0, e.bSort = !0) : e.bSort === !1 ? (e.orderIndicators = !1, e.orderHandler = !1) : e.bSort === !0 && (e.orderIndicators = !0, e.orderHandler = !0), typeof e.bSortCellsTop == "boolean" && (e.titleRow = e.bSortCellsTop);
  var t = e.aoSearchCols;
  if (t)
    for (var r = 0, o = t.length; r < o; r++)
      t[r] && bl(me.models.oSearch, t[r]);
  e.serverSide && !e.searchDelay && (e.searchDelay = 400);
}
function t_(e) {
  Ko(e, "orderable", "bSortable"), Ko(e, "orderData", "aDataSort"), Ko(e, "orderSequence", "asSorting"), Ko(e, "orderDataType", "sortDataType");
  var t = e.aDataSort;
  typeof t == "number" && !Array.isArray(t) && (e.aDataSort = [t]);
}
function _4(e) {
  if (!me.__browser) {
    var t = {};
    me.__browser = t;
    var r = Z("<div/>").css({
      position: "fixed",
      top: 0,
      left: -1 * window.pageXOffset,
      // allow for scrolling
      height: 1,
      width: 1,
      overflow: "hidden"
    }).append(
      Z("<div/>").css({
        position: "absolute",
        top: 1,
        left: 1,
        width: 100,
        overflow: "scroll"
      }).append(
        Z("<div/>").css({
          width: "100%",
          height: 10
        })
      )
    ).appendTo("body"), o = r.children(), n = o.children();
    t.barWidth = o[0].offsetWidth - o[0].clientWidth, t.bScrollbarLeft = Math.round(n.offset().left) !== 1, r.remove();
  }
  Z.extend(e.oBrowser, me.__browser), e.oScroll.iBarWidth = me.__browser.barWidth;
}
function r_(e) {
  var t = me.defaults.column, r = e.aoColumns.length, o = Z.extend({}, me.models.oColumn, t, {
    aDataSort: t.aDataSort ? t.aDataSort : [r],
    mData: t.mData ? t.mData : r,
    idx: r,
    searchFixed: {},
    colEl: Z("<col>").attr("data-dt-column", r)
  });
  e.aoColumns.push(o);
  var n = e.aoPreSearchCols;
  n[r] = Z.extend({}, me.models.oSearch, n[r]);
}
function up(e, t, r) {
  var o = e.aoColumns[t];
  if (r != null) {
    t_(r), bl(me.defaults.column, r, !0), r.mDataProp !== void 0 && !r.mData && (r.mData = r.mDataProp), r.sType && (o._sManualType = r.sType), r.className && !r.sClass && (r.sClass = r.className);
    var n = o.sClass;
    Z.extend(o, r), wl(o, r, "sWidth", "sWidthOrig"), n !== o.sClass && (o.sClass = n + " " + o.sClass), r.iDataSort !== void 0 && (o.aDataSort = [r.iDataSort]), wl(o, r, "aDataSort");
  }
  var a = o.mData, l = Ks(a);
  if (o.mRender && Array.isArray(o.mRender)) {
    var i = o.mRender.slice(), s = i.shift();
    o.mRender = me.render[s].apply(window, i);
  }
  o._render = o.mRender ? Ks(o.mRender) : null;
  var u = function(c) {
    return typeof c == "string" && c.indexOf("@") !== -1;
  };
  o._bAttrSrc = Z.isPlainObject(a) && (u(a.sort) || u(a.type) || u(a.filter)), o._setter = null, o.fnGetData = function(c, g, p) {
    var h = l(c, g, void 0, p);
    return o._render && g ? o._render(h, g, c, p) : h;
  }, o.fnSetData = function(c, g, p) {
    return ql(a)(c, g, p);
  }, typeof a != "number" && !o._isArrayHost && (e._rowReadObject = !0), e.oFeatures.bSort || (o.bSortable = !1);
}
function Cm(e) {
  V4(e), T4(e);
  var t = e.oScroll;
  (t.sY !== "" || t.sX !== "") && m_(e), jt(e, null, "column-sizing", [e]);
}
function T4(e) {
  for (var t = e.aoColumns, r = 0; r < t.length; r++) {
    var o = o_(e, [r], !1);
    t[r].colEl.css("width", o), e.oScroll.sX && t[r].colEl.css("min-width", o);
  }
}
function rh(e, t) {
  var r = oh(e, "bVisible");
  return typeof r[t] == "number" ? r[t] : null;
}
function yu(e, t) {
  var r = oh(e, "bVisible"), o = r.indexOf(t);
  return o !== -1 ? o : null;
}
function Lm(e) {
  var t = e.aoHeader, r = e.aoColumns, o = 0;
  if (t.length)
    for (var n = 0, a = t[0].length; n < a; n++)
      r[n].bVisible && Z(t[0][n].cell).css("display") !== "none" && o++;
  return o;
}
function oh(e, t) {
  var r = [];
  return e.aoColumns.map(function(o, n) {
    o[t] && r.push(n);
  }), r;
}
function Xg(e, t) {
  return t === !0 ? e._name : t;
}
function Em(e) {
  var t = e.aoColumns, r = e.aoData, o = me.ext.type.detect, n, a, l, i, s, u, c, g, p;
  for (n = 0, a = t.length; n < a; n++) {
    if (c = t[n], p = [], !c.sType && c._sManualType)
      c.sType = c._sManualType;
    else if (!c.sType) {
      if (!e.typeDetect)
        return;
      for (l = 0, i = o.length; l < i; l++) {
        var h = o[l], v = h.oneOf, A = h.allOf || h, S = h.init, b = !1;
        if (g = null, S && (g = Xg(h, S(e, c, n)), g)) {
          c.sType = g;
          break;
        }
        for (s = 0, u = r.length; s < u && !(r[s] && (p[s] === void 0 && (p[s] = Bn(e, s, n, "type")), v && !b && (b = Xg(h, v(p[s], e))), g = Xg(h, A(p[s], e)), !g && l !== o.length - 3 || g === "html" && !sn(p[s]))); s++)
          ;
        if (v && b && g || !v && g) {
          c.sType = g;
          break;
        }
      }
      c.sType || (c.sType = "string");
    }
    var T = go.type.className[c.sType];
    T && (Mx(e.aoHeader, n, T), Mx(e.aoFooter, n, T));
    var w = go.type.render[c.sType];
    w && !c._render && (c._render = me.util.get(w), A4(e, n));
  }
}
function A4(e, t) {
  for (var r = e.aoData, o = 0; o < r.length; o++)
    if (r[o].nTr) {
      var n = Bn(e, o, t, "display");
      r[o].displayData[t] = n, Kc(r[o].anCells[t], n);
    }
}
function Mx(e, t, r) {
  e.forEach(function(o) {
    o[t] && o[t].unique && Es(o[t].cell, r);
  });
}
function P4(e, t, r, o, n) {
  var a, l, i, s, u, c, g, p = e.aoColumns;
  if (r)
    for (a = 0, l = r.length; a < l; a++)
      r[a] && r[a].name && (p[a].sName = r[a].name);
  if (t)
    for (a = t.length - 1; a >= 0; a--) {
      g = t[a];
      var h = g.target !== void 0 ? g.target : g.targets !== void 0 ? g.targets : g.aTargets;
      for (Array.isArray(h) || (h = [h]), i = 0, s = h.length; i < s; i++) {
        var v = h[i];
        if (typeof v == "number" && v >= 0) {
          for (; p.length <= v; )
            r_(e);
          n(v, g);
        } else if (typeof v == "number" && v < 0)
          n(p.length + v, g);
        else if (typeof v == "string")
          for (u = 0, c = p.length; u < c; u++)
            v === "_all" ? n(u, g) : v.indexOf(":name") !== -1 ? p[u].sName === v.replace(":name", "") && n(u, g) : o.forEach(function(A) {
              if (A[u]) {
                var S = Z(A[u].cell);
                v.match(/^[a-z][\w-]*$/i) && (v = "." + v), S.is(v) && n(u, g);
              }
            });
      }
    }
  if (r)
    for (a = 0, l = r.length; a < l; a++)
      n(a, r[a]);
}
function o_(e, t, r, o) {
  Array.isArray(t) || (t = nh(t));
  for (var n = 0, a, l = e.aoColumns, i = 0, s = t.length; i < s; i++) {
    var u = l[t[i]], c = r ? u.sWidthOrig : u.sWidth;
    if (u.bVisible !== !1) {
      if (c == null)
        return null;
      if (typeof c == "number")
        a = "px", n += c;
      else {
        var g = c.match(/([\d\.]+)([^\d]*)/);
        g && (n += g[1] * 1, a = g.length === 3 ? g[2] : "px");
      }
    }
  }
  return n + a;
}
function nh(e) {
  var t = Z(e).closest("[data-dt-column]").attr("data-dt-column");
  return t ? t.split(",").map(function(r) {
    return r * 1;
  }) : [];
}
function vi(e, t, r, o) {
  var n = e.aoData.length, a = Z.extend(!0, {}, me.models.oRow, {
    src: r ? "dom" : "data",
    idx: n
  });
  a._aData = t, e.aoData.push(a);
  for (var l = e.aoColumns, i = 0, s = l.length; i < s; i++)
    l[i].sType = null;
  e.aiDisplayMaster.push(n);
  var u = e.rowIdFn(t);
  return u !== void 0 && (e.aIds[u] = a), (r || !e.oFeatures.bDeferRender) && a_(e, n, r, o), n;
}
function ah(e, t) {
  var r;
  return t instanceof Z || (t = Z(t)), t.map(function(o, n) {
    return r = n_(e, n), vi(e, r.data, n, r.cells);
  });
}
function Bn(e, t, r, o) {
  o === "search" ? o = "filter" : o === "order" && (o = "sort");
  var n = e.aoData[t];
  if (n) {
    var a = e.iDraw, l = e.aoColumns[r], i = n._aData, s = l.sDefaultContent, u = l.fnGetData(i, o, {
      settings: e,
      row: t,
      col: r
    });
    if (o !== "display" && u && typeof u == "object" && u.nodeName && (u = u.innerHTML), u === void 0)
      return e.iDrawError != a && s === null && ($n(e, 0, "Requested unknown parameter " + (typeof l.mData == "function" ? "{function}" : "'" + l.mData + "'") + " for row " + t + ", column " + r, 4), e.iDrawError = a), s;
    if ((u === i || u === null) && s !== null && o !== void 0)
      u = s;
    else if (typeof u == "function")
      return u.call(i);
    if (u === null && o === "display")
      return "";
    if (o === "filter") {
      var c = me.ext.type.search;
      c[l.sType] && (u = c[l.sType](u));
    }
    return u;
  }
}
function M4(e, t, r, o) {
  var n = e.aoColumns[r], a = e.aoData[t]._aData;
  n.fnSetData(a, o, {
    settings: e,
    row: t,
    col: r
  });
}
function Kc(e, t) {
  t && typeof t == "object" && t.nodeName ? Z(e).empty().append(t) : e.innerHTML = t;
}
var Cd = /\[.*?\]$/, ji = /\(\)$/;
function $x(e) {
  var t = e.match(/(\\.|[^.])+/g) || [""];
  return t.map(function(r) {
    return r.replace(/\\\./g, ".");
  });
}
var Ks = me.util.get, ql = me.util.set;
function Cx(e) {
  return Eo(e.aoData, "_aData");
}
function lh(e) {
  e.aoData.length = 0, e.aiDisplayMaster.length = 0, e.aiDisplay.length = 0, e.aIds = {};
}
function Om(e, t, r, o) {
  var n = e.aoData[t], a, l;
  if (n._aSortData = null, n._aFilterData = null, n.displayData = null, r === "dom" || (!r || r === "auto") && n.src === "dom")
    n._aData = n_(
      e,
      n,
      o,
      o === void 0 ? void 0 : n._aData
    ).data;
  else {
    var i = n.anCells, s = ih(e, t);
    if (i)
      if (o !== void 0)
        Kc(i[o], s[o]);
      else
        for (a = 0, l = i.length; a < l; a++)
          Kc(i[a], s[a]);
  }
  var u = e.aoColumns;
  if (o !== void 0)
    u[o].sType = null, u[o].wideStrings = null;
  else {
    for (a = 0, l = u.length; a < l; a++)
      u[a].sType = null, u[a].wideStrings = null;
    l_(e, n);
  }
}
function n_(e, t, r, o) {
  var n = [], a = t.firstChild, l, i, s = 0, u, c = e.aoColumns, g = e._rowReadObject;
  o = o !== void 0 ? o : g ? {} : [];
  var p = function(T, w) {
    if (typeof T == "string") {
      var N = T.indexOf("@");
      if (N !== -1) {
        var O = T.substring(N + 1), m = ql(T);
        m(o, w.getAttribute(O));
      }
    }
  }, h = function(T) {
    if (r === void 0 || r === s)
      if (i = c[s], u = T.innerHTML.trim(), i && i._bAttrSrc) {
        var w = ql(i.mData._);
        w(o, u), p(i.mData.sort, T), p(i.mData.type, T), p(i.mData.filter, T);
      } else
        g ? (i._setter || (i._setter = ql(i.mData)), i._setter(o, u)) : o[s] = u;
    s++;
  };
  if (a)
    for (; a; )
      l = a.nodeName.toUpperCase(), (l == "TD" || l == "TH") && (h(a), n.push(a)), a = a.nextSibling;
  else {
    n = t.anCells;
    for (var v = 0, A = n.length; v < A; v++)
      h(n[v]);
  }
  var S = t.firstChild ? t : t.nTr;
  if (S) {
    var b = S.getAttribute("id");
    b && ql(e.rowId)(o, b);
  }
  return {
    data: o,
    cells: n
  };
}
function ih(e, t) {
  var r = e.aoData[t], o = e.aoColumns;
  if (!r.displayData) {
    r.displayData = [];
    for (var n = 0, a = o.length; n < a; n++)
      r.displayData.push(
        Bn(e, t, n, "display")
      );
  }
  return r.displayData;
}
function a_(e, t, r, o) {
  var n = e.aoData[t], a = n._aData, l = [], i, s, u, c, g, p, h = e.oClasses.tbody.row;
  if (n.nTr === null) {
    for (i = r || document.createElement("tr"), n.nTr = i, n.anCells = l, Es(i, h), i._DT_RowIndex = t, l_(e, n), c = 0, g = e.aoColumns.length; c < g; c++) {
      u = e.aoColumns[c], p = !(r && o[c]), s = p ? document.createElement(u.sCellType) : o[c], s || $n(e, 0, "Incorrect column count", 18), s._DT_CellIndex = {
        row: t,
        column: c
      }, l.push(s);
      var v = ih(e, t);
      (p || (u.mRender || u.mData !== c) && (!Z.isPlainObject(u.mData) || u.mData._ !== c + ".display")) && Kc(s, v[c]), Es(s, u.sClass), u.bVisible && p ? i.appendChild(s) : !u.bVisible && !p && s.parentNode.removeChild(s), u.fnCreatedCell && u.fnCreatedCell.call(
        e.oInstance,
        s,
        Bn(e, t, c),
        a,
        t,
        c
      );
    }
    jt(e, "aoRowCreatedCallback", "row-created", [i, a, t, l]);
  } else
    Es(n.nTr, h);
}
function l_(e, t) {
  var r = t.nTr, o = t._aData;
  if (r) {
    var n = e.rowIdFn(o);
    if (n && (r.id = n), o.DT_RowClass) {
      var a = o.DT_RowClass.split(" ");
      t.__rowc = t.__rowc ? sd(t.__rowc.concat(a)) : a, Z(r).removeClass(t.__rowc.join(" ")).addClass(o.DT_RowClass);
    }
    o.DT_RowAttr && Z(r).attr(o.DT_RowAttr), o.DT_RowData && Z(r).data(o.DT_RowData);
  }
}
function Lx(e, t) {
  var r = e.oClasses, o = e.aoColumns, n, a, l, i = t === "header" ? e.nTHead : e.nTFoot, s = t === "header" ? "sTitle" : t;
  if (i) {
    if ((t === "header" || Eo(e.aoColumns, s).join("")) && (l = Z("tr", i), l.length || (l = Z("<tr/>").appendTo(i)), l.length === 1)) {
      var u = 0;
      for (Z("td, th", l).each(function() {
        u += this.colSpan;
      }), n = u, a = o.length; n < a; n++)
        Z("<th/>").html(o[n][s] || "").appendTo(l);
    }
    var c = s_(e, i, !0);
    t === "header" ? (e.aoHeader = c, Z("tr", i).addClass(r.thead.row)) : (e.aoFooter = c, Z("tr", i).addClass(r.tfoot.row)), Z(i).children("tr").children("th, td").each(function() {
      Zc(e, t)(
        e,
        Z(this),
        r
      );
    });
  }
}
function i_(e, t, r) {
  var o, n, a, l = [], i = [], s = e.aoColumns, u = s.length, c, g;
  if (t) {
    for (r || (r = ml(u).filter(function(v) {
      return s[v].bVisible;
    })), o = 0; o < t.length; o++)
      l[o] = t[o].slice().filter(function(v, A) {
        return r.includes(A);
      }), i.push([]);
    for (o = 0; o < l.length; o++)
      for (n = 0; n < l[o].length; n++)
        if (c = 1, g = 1, i[o][n] === void 0) {
          for (a = l[o][n].cell; l[o + c] !== void 0 && l[o][n].cell == l[o + c][n].cell; )
            i[o + c][n] = null, c++;
          for (; l[o][n + g] !== void 0 && l[o][n].cell == l[o][n + g].cell; ) {
            for (var p = 0; p < c; p++)
              i[o + p][n + g] = null;
            g++;
          }
          var h = Z(".dt-column-title", a);
          i[o][n] = {
            cell: a,
            colspan: g,
            rowspan: c,
            title: h.length ? h.html() : Z(a).html()
          };
        }
    return i;
  }
}
function Qc(e, t) {
  for (var r = i_(e, t), o, n, a = 0; a < t.length; a++) {
    if (o = t[a].row, o)
      for (; n = o.firstChild; )
        o.removeChild(n);
    for (var l = 0; l < r[a].length; l++) {
      var i = r[a][l];
      i && Z(i.cell).appendTo(o).attr("rowspan", i.rowspan).attr("colspan", i.colspan);
    }
  }
}
function dd(e, t) {
  O4(e);
  var r = jt(e, "aoPreDrawCallback", "preDraw", [e]);
  if (r.indexOf(!1) !== -1) {
    dn(e, !1);
    return;
  }
  var o = [], n = 0, a = gn(e) == "ssp", l = e.aiDisplay, i = e._iDisplayStart, s = e.fnDisplayEnd(), u = e.aoColumns, c = Z(e.nTBody);
  if (e.bDrawing = !0, e.deferLoading)
    e.deferLoading = !1, e.iDraw++, dn(e, !1);
  else if (!a)
    e.iDraw++;
  else if (!e.bDestroying && !t) {
    e.iDraw === 0 && c.empty().append(Ex(e)), N4(e);
    return;
  }
  if (l.length !== 0)
    for (var g = a ? 0 : i, p = a ? e.aoData.length : s, h = g; h < p; h++) {
      var v = l[h], A = e.aoData[v];
      if (A !== null) {
        A.nTr === null && a_(e, v);
        for (var S = A.nTr, b = 0; b < u.length; b++) {
          var T = u[b], w = A.anCells[b];
          Es(w, go.type.className[T.sType]), Es(w, e.oClasses.tbody.cell);
        }
        jt(
          e,
          "aoRowCallback",
          null,
          [S, A._aData, n, h, v]
        ), o.push(S), n++;
      }
    }
  else
    o[0] = Ex(e);
  jt(e, "aoHeaderCallback", "header", [
    Z(e.nTHead).children("tr")[0],
    Cx(e),
    i,
    s,
    l
  ]), jt(e, "aoFooterCallback", "footer", [
    Z(e.nTFoot).children("tr")[0],
    Cx(e),
    i,
    s,
    l
  ]), c[0].replaceChildren ? c[0].replaceChildren.apply(c[0], o) : (c.children().detach(), c.append(Z(o))), Z(e.nTableWrapper).toggleClass("dt-empty-footer", Z("tr", e.nTFoot).length === 0), jt(e, "aoDrawCallback", "draw", [e], !0), e.bSorted = !1, e.bFiltered = !1, e.bDrawing = !1;
}
function Qs(e, t, r) {
  var o = e.oFeatures, n = o.bSort, a = o.bFilter;
  (r === void 0 || r === !0) && (Em(e), n && uh(e), a ? tu(e, e.oPreviousSearch) : e.aiDisplay = e.aiDisplayMaster.slice()), t !== !0 ? e._iDisplayStart = 0 : ch(e), e._drawHold = t, dd(e), e.api.one("draw", function() {
    e._drawHold = !1;
  });
}
function Ex(e) {
  var t = e.oLanguage, r = t.sZeroRecords, o = gn(e);
  return (o === "ssp" || o === "ajax") && !e.json ? r = t.sLoadingRecords : t.sEmptyTable && e.fnRecordsTotal() === 0 && (r = t.sEmptyTable), Z("<tr/>").append(Z("<td />", {
    colSpan: Lm(e),
    class: e.oClasses.empty.row
  }).html(r))[0];
}
function cp(e, t, r) {
  if (Array.isArray(r)) {
    for (var o = 0; o < r.length; o++)
      cp(e, t, r[o]);
    return;
  }
  var n = e[t];
  Z.isPlainObject(r) ? r.features ? (r.rowId && (e.id = r.rowId), r.rowClass && (e.className = r.rowClass), n.id = r.id, n.className = r.className, cp(e, t, r.features)) : Object.keys(r).map(function(a) {
    n.contents.push({
      feature: a,
      opts: r[a]
    });
  }) : n.contents.push(r);
}
function $4(e, t, r) {
  for (var o, n = 0; n < e.length; n++)
    if (o = e[n], o.rowNum === t && (r === "full" && o.full || (r === "start" || r === "end") && (o.start || o.end)))
      return o[r] || (o[r] = {
        contents: []
      }), o;
  return o = {
    rowNum: t
  }, o[r] = {
    contents: []
  }, e.push(o), o;
}
function Ox(e, t, r) {
  var o = [];
  Z.each(t, function(a, l) {
    if (l !== null) {
      var i = a.match(/^([a-z]+)([0-9]*)([A-Za-z]*)$/), s = i[2] ? i[2] * 1 : 0, u = i[3] ? i[3].toLowerCase() : "full";
      if (i[1] === r) {
        var c = $4(o, s, u);
        cp(c, u, l);
      }
    }
  }), o.sort(function(a, l) {
    var i = a.rowNum, s = l.rowNum;
    if (i === s) {
      var u = a.full && !l.full ? -1 : 1;
      return r === "bottom" ? u * -1 : u;
    }
    return s - i;
  }), r === "bottom" && o.reverse();
  for (var n = 0; n < o.length; n++)
    delete o[n].rowNum, C4(e, o[n]);
  return o;
}
function C4(e, t) {
  var r = function(n, a) {
    return go.features[n] || $n(e, 0, "Unknown feature: " + n), go.features[n].apply(this, [e, a]);
  }, o = function(n) {
    if (t[n])
      for (var a = t[n].contents, l = 0, i = a.length; l < i; l++)
        if (a[l]) {
          if (typeof a[l] == "string")
            a[l] = r(a[l], null);
          else if (Z.isPlainObject(a[l]))
            a[l] = r(a[l].feature, a[l].opts);
          else if (typeof a[l].node == "function")
            a[l] = a[l].node(e);
          else if (typeof a[l] == "function") {
            var s = a[l](e);
            a[l] = typeof s.node == "function" ? s.node() : s;
          }
        } else continue;
  };
  o("start"), o("end"), o("full");
}
function L4(e) {
  var t = e.oClasses, r = Z(e.nTable), o = Z("<div/>").attr({
    id: e.sTableId + "_wrapper",
    class: t.container
  }).insertBefore(r);
  if (e.nTableWrapper = o[0], e.sDom)
    E4(e, e.sDom, o);
  else {
    var n = Ox(e, e.layout, "top"), a = Ox(e, e.layout, "bottom"), l = Zc(e, "layout");
    n.forEach(function(i) {
      l(e, o, i);
    }), l(e, o, {
      full: {
        table: !0,
        contents: [c_(e)]
      }
    }), a.forEach(function(i) {
      l(e, o, i);
    });
  }
  F4(e);
}
function E4(e, t, r) {
  for (var o = t.match(/(".*?")|('.*?')|./g), n, a, l, i, s, u = 0; u < o.length; u++) {
    if (n = null, a = o[u], a == "<") {
      if (l = Z("<div/>"), i = o[u + 1], i[0] == "'" || i[0] == '"') {
        s = i.replace(/['"]/g, "");
        var c = "", g;
        if (s.indexOf(".") != -1) {
          var p = s.split(".");
          c = p[0], g = p[1];
        } else s[0] == "#" ? c = s : g = s;
        l.attr("id", c.substring(1)).addClass(g), u++;
      }
      r.append(l), r = l;
    } else a == ">" ? r = r.parent() : a == "t" ? n = c_(e) : me.ext.feature.forEach(function(h) {
      a == h.cFeature && (n = h.fnInit(e));
    });
    n && r.append(n);
  }
}
function s_(e, t, r) {
  var o = e.aoColumns, n = Z(t).children("tr"), a, l, i, s, u, c, g, p, h, v, A = e.titleRow, S = t && t.nodeName.toLowerCase() === "thead", b = [], T, w = function(E, D, U) {
    for (var Y = E[D]; Y[U]; )
      U++;
    return U;
  };
  for (i = 0, c = n.length; i < c; i++)
    b.push([]);
  for (i = 0, c = n.length; i < c; i++)
    for (a = n[i], p = 0, l = a.firstChild; l; ) {
      if (l.nodeName.toUpperCase() == "TD" || l.nodeName.toUpperCase() == "TH") {
        var N = [], O = Z(l);
        if (h = l.getAttribute("colspan") * 1, v = l.getAttribute("rowspan") * 1, h = !h || h === 0 || h === 1 ? 1 : h, v = !v || v === 0 || v === 1 ? 1 : v, g = w(b, i, p), T = h === 1, r) {
          if (T) {
            up(e, g, x_(O.data()));
            var m = o[g], _ = l.getAttribute("width") || null, X = l.style.width.match(/width:\s*(\d+[pxem%]+)/);
            X && (_ = X[1]), m.sWidthOrig = m.sWidth || _, S ? (m.sTitle !== null && !m.autoTitle && (A === !0 && i === 0 || // top row
            A === !1 && i === n.length - 1 || // bottom row
            A === i || // specific row
            A === null) && (l.innerHTML = m.sTitle), !m.sTitle && T && (m.sTitle = Qa(l.innerHTML), m.autoTitle = !0)) : m.footer && (l.innerHTML = m.footer), m.ariaTitle || (m.ariaTitle = O.attr("aria-label") || m.sTitle), m.className && O.addClass(m.className);
          }
          Z(".dt-column-title", l).length === 0 && Z(document.createElement(e.columnTitleTag)).addClass("dt-column-title").append(l.childNodes).appendTo(l), e.orderIndicators && S && O.filter(":not([data-dt-order=disable])").length !== 0 && O.parent(":not([data-dt-order=disable])").length !== 0 && Z(".dt-column-order", l).length === 0 && Z(document.createElement(e.columnTitleTag)).addClass("dt-column-order").appendTo(l);
          var $ = S ? "header" : "footer";
          Z("div.dt-column-" + $, l).length === 0 && Z("<div>").addClass("dt-column-" + $).append(l.childNodes).appendTo(l);
        }
        for (u = 0; u < h; u++) {
          for (s = 0; s < v; s++)
            b[i + s][g + u] = {
              cell: l,
              unique: T
            }, b[i + s].row = a;
          N.push(g + u);
        }
        l.setAttribute("data-dt-column", sd(N).join(","));
      }
      l = l.nextSibling;
    }
  return b;
}
function O4(e) {
  var t = gn(e) == "ssp", r = e.iInitDisplayStart;
  r !== void 0 && r !== -1 && (e._iDisplayStart = t ? r : r >= e.fnRecordsDisplay() ? 0 : r, e.iInitDisplayStart = -1);
}
function sh(e, t, r) {
  var o, n = e.ajax, a = e.oInstance, l = function(c) {
    var g = e.jqXHR ? e.jqXHR.status : null;
    (c === null || typeof g == "number" && g == 204) && (c = {}, eu(e, c, []));
    var p = c.error || c.sError;
    if (p && $n(e, 0, p), c.d && typeof c.d == "string")
      try {
        c = JSON.parse(c.d);
      } catch {
      }
    e.json = c, jt(e, null, "xhr", [e, c, e.jqXHR], !0), r(c);
  };
  if (Z.isPlainObject(n) && n.data) {
    o = n.data;
    var i = typeof o == "function" ? o(t, e) : o;
    t = typeof o == "function" && i ? i : Z.extend(!0, t, i), delete n.data;
  }
  var s = {
    url: typeof n == "string" ? n : "",
    data: t,
    success: l,
    dataType: "json",
    cache: !1,
    type: e.sServerMethod,
    error: function(c, g) {
      var p = jt(
        e,
        null,
        "xhr",
        [e, null, e.jqXHR],
        !0
      );
      p.indexOf(!0) === -1 && (g == "parsererror" ? $n(e, 0, "Invalid JSON response", 1) : c.readyState === 4 && $n(e, 0, "Ajax error", 7)), dn(e, !1);
    }
  };
  if (Z.isPlainObject(n) && Z.extend(s, n), e.oAjaxData = t, jt(e, null, "preXhr", [e, t, s], !0), s.submitAs === "json" && typeof t == "object" && (s.data = JSON.stringify(t), s.contentType || (s.contentType = "application/json; charset=utf-8")), typeof n == "function")
    e.jqXHR = n.call(a, t, l, e);
  else if (n.url === "") {
    var u = {};
    eu(e, u, []), l(u);
  } else
    e.jqXHR = Z.ajax(s);
  o && (n.data = o);
}
function N4(e) {
  e.iDraw++, dn(e, !0), sh(e, D4(e), function(t) {
    k4(e, t);
  });
}
function D4(e) {
  var t = e.aoColumns, r = e.oFeatures, o = e.oPreviousSearch, n = e.aoPreSearchCols, a = function(l, i) {
    return typeof t[l][i] == "function" ? "function" : t[l][i];
  };
  return {
    draw: e.iDraw,
    columns: t.map(function(l, i) {
      return {
        data: a(i, "mData"),
        name: l.sName,
        searchable: l.bSearchable,
        orderable: l.bSortable,
        search: {
          value: n[i].search,
          regex: n[i].regex,
          fixed: Object.keys(l.searchFixed).map(function(s) {
            return {
              name: s,
              term: typeof l.searchFixed[s] != "function" ? l.searchFixed[s].toString() : "function"
            };
          })
        }
      };
    }),
    order: Nm(e).map(function(l) {
      return {
        column: l.col,
        dir: l.dir,
        name: a(l.col, "sName")
      };
    }),
    start: e._iDisplayStart,
    length: r.bPaginate ? e._iDisplayLength : -1,
    search: {
      value: o.search,
      regex: o.regex,
      fixed: Object.keys(e.searchFixed).map(function(l) {
        return {
          name: l,
          term: typeof e.searchFixed[l] != "function" ? e.searchFixed[l].toString() : "function"
        };
      })
    }
  };
}
function k4(e, t) {
  var r = eu(e, t), o = Wg(e, "draw", t), n = Wg(e, "recordsTotal", t), a = Wg(e, "recordsFiltered", t);
  if (o !== void 0) {
    if (o * 1 < e.iDraw)
      return;
    e.iDraw = o * 1;
  }
  r || (r = []), lh(e), e._iRecordsTotal = parseInt(n, 10), e._iRecordsDisplay = parseInt(a, 10);
  for (var l = 0, i = r.length; l < i; l++)
    vi(e, r[l]);
  e.aiDisplay = e.aiDisplayMaster.slice(), Em(e), dd(e, !0), jc(e), dn(e, !1);
}
function eu(e, t, r) {
  var o = "data";
  if (Z.isPlainObject(e.ajax) && e.ajax.dataSrc !== void 0) {
    var n = e.ajax.dataSrc;
    typeof n == "string" || typeof n == "function" ? o = n : n.data !== void 0 && (o = n.data);
  }
  if (!r)
    return o === "data" ? t.aaData || t[o] : o !== "" ? Ks(o)(t) : t;
  ql(o)(t, r);
}
function Wg(e, t, r) {
  var o = Z.isPlainObject(e.ajax) ? e.ajax.dataSrc : null;
  if (o && o[t])
    return Ks(o[t])(r);
  var n = "";
  return t === "draw" ? n = "sEcho" : t === "recordsTotal" ? n = "iTotalRecords" : t === "recordsFiltered" && (n = "iTotalDisplayRecords"), r[n] !== void 0 ? r[n] : r[t];
}
function tu(e, t) {
  var r = e.aoPreSearchCols;
  if (gn(e) != "ssp") {
    R4(e), e.aiDisplay = e.aiDisplayMaster.slice(), ec(e.aiDisplay, e, t.search, t), Z.each(e.searchFixed, function(a, l) {
      ec(e.aiDisplay, e, l, {});
    });
    for (var o = 0; o < r.length; o++) {
      var n = r[o];
      ec(
        e.aiDisplay,
        e,
        n.search,
        n,
        o
      ), Z.each(e.aoColumns[o].searchFixed, function(a, l) {
        ec(e.aiDisplay, e, l, {}, o);
      });
    }
    G4(e);
  }
  e.bFiltered = !0, jt(e, null, "search", [e]);
}
function G4(e) {
  for (var t = me.ext.search, r = e.aiDisplay, o, n, a = 0, l = t.length; a < l; a++) {
    for (var i = [], s = 0, u = r.length; s < u; s++)
      n = r[s], o = e.aoData[n], t[a](e, o._aFilterData, n, o._aData, s) && i.push(n);
    r.length = 0, km(r, i);
  }
}
function ec(e, t, r, o, n) {
  if (r !== "") {
    var a = 0, l = [], i = typeof r == "function" ? r : null, s = r instanceof RegExp ? r : i ? null : B4(r, o);
    for (a = 0; a < e.length; a++) {
      var u = t.aoData[e[a]], c = n === void 0 ? u._sFilterRow : u._aFilterData[n];
      (i && i(c, u._aData, e[a], n) || s && s.test(c)) && l.push(e[a]);
    }
    for (e.length = l.length, a = 0; a < l.length; a++)
      e[a] = l[a];
  }
}
function B4(e, t) {
  var r = [], o = Z.extend({}, {
    boundary: !1,
    caseInsensitive: !0,
    exact: !1,
    regex: !1,
    smart: !0
  }, t);
  if (typeof e != "string" && (e = e.toString()), e = Yc(e), o.exact)
    return new RegExp(
      "^" + mp(e) + "$",
      o.caseInsensitive ? "i" : ""
    );
  if (e = o.regex ? e : mp(e), o.smart) {
    var n = e.match(/!?["\u201C][^"\u201D]+["\u201D]|[^ ]+/g) || [""], a = n.map(function(s) {
      var u = !1, c;
      return s.charAt(0) === "!" && (u = !0, s = s.substring(1)), s.charAt(0) === '"' ? (c = s.match(/^"(.*)"$/), s = c ? c[1] : s) : s.charAt(0) === "“" && (c = s.match(/^\u201C(.*)\u201D$/), s = c ? c[1] : s), u && (s.length > 1 && r.push("(?!" + s + ")"), s = ""), s.replace(/"/g, "");
    }), l = r.length ? r.join("") : "", i = o.boundary ? "\\b" : "";
    e = "^(?=.*?" + i + a.join(")(?=.*?" + i) + ")(" + l + ".)*$";
  }
  return new RegExp(e, o.caseInsensitive ? "i" : "");
}
var mp = me.util.escapeRegex, vc = Z("<div>")[0], I4 = vc.textContent !== void 0;
function R4(e) {
  for (var t = e.aoColumns, r = e.aoData, o, n, a, l, i, s, u = !1, c = 0; c < r.length; c++)
    if (r[c] && (s = r[c], !s._aFilterData)) {
      for (l = [], n = 0, a = t.length; n < a; n++)
        o = t[n], o.bSearchable ? (i = Bn(e, c, n, "filter"), i === null && (i = ""), typeof i != "string" && i.toString && (i = i.toString())) : i = "", i.indexOf && i.indexOf("&") !== -1 && (vc.innerHTML = i, i = I4 ? vc.textContent : vc.innerText), i.replace && (i = i.replace(/[\r\n\u2028]/g, "")), l.push(i);
      s._aFilterData = l, s._sFilterRow = l.join("  "), u = !0;
    }
  return u;
}
function Sc(e) {
  var t, r = e.oInit, o = e.deferLoading, n = gn(e);
  if (!e.bInitialised) {
    setTimeout(function() {
      Sc(e);
    }, 200);
    return;
  }
  Lx(e, "header"), Lx(e, "footer"), Y4(e, r, function() {
    Qc(e, e.aoHeader), Qc(e, e.aoFooter);
    var a = e.iInitDisplayStart;
    if (r.aaData)
      for (t = 0; t < r.aaData.length; t++)
        vi(e, r.aaData[t]);
    else (o || n == "dom") && ah(e, Z(e.nTBody).children("tr"));
    e.aiDisplay = e.aiDisplayMaster.slice(), L4(e), U4(e), g_(e), dn(e, !0), jt(e, null, "preInit", [e], !0), Qs(e), (n != "ssp" || o) && (n == "ajax" ? sh(e, {}, function(l) {
      var i = eu(e, l);
      for (t = 0; t < i.length; t++)
        vi(e, i[t]);
      e.iInitDisplayStart = a, Qs(e), dn(e, !1), jc(e);
    }) : (jc(e), dn(e, !1)));
  });
}
function jc(e) {
  if (e._bInitComplete)
    return;
  var t = [e, e.json];
  let r = Z(e.tfoot);
  r.children().length === 0 && r.remove(), e._bInitComplete = !0, Cm(e), jt(e, null, "plugin-init", t, !0), jt(e, "aoInitComplete", "init", t, !0);
}
function d_(e, t) {
  var r = parseInt(t, 10);
  e._iDisplayLength = r, ch(e), jt(e, null, "length", [e, r]);
}
function dh(e, t, r) {
  var o = e._iDisplayStart, n = e._iDisplayLength, a = e.fnRecordsDisplay();
  if (a === 0 || n === -1)
    o = 0;
  else if (typeof t == "number")
    o = t * n, o > a && (o = 0);
  else if (t == "first")
    o = 0;
  else if (t == "previous")
    o = n >= 0 ? o - n : 0, o < 0 && (o = 0);
  else if (t == "next")
    o + n < a && (o += n);
  else if (t == "last")
    o = Math.floor((a - 1) / n) * n;
  else {
    if (t === "ellipsis")
      return;
    $n(e, 0, "Unknown paging action: " + t, 5);
  }
  var l = e._iDisplayStart !== o;
  return e._iDisplayStart = o, jt(e, null, l ? "page" : "page-nc", [e]), l && r && dd(e), l;
}
function F4(e) {
  var t = e.nTable, r = e.oScroll.sX !== "" || e.oScroll.sY !== "";
  if (e.oFeatures.bProcessing) {
    var o = Z("<div/>", {
      id: e.sTableId + "_processing",
      class: e.oClasses.processing.container,
      role: "status"
    }).html(e.oLanguage.sProcessing).append("<div><div></div><div></div><div></div><div></div></div>");
    r ? o.prependTo(Z("div.dt-scroll", e.nTableWrapper)) : o.insertBefore(t), Z(t).on("processing.dt.DT", function(n, a, l) {
      o.css("display", l ? "block" : "none");
    });
  }
}
function dn(e, t) {
  e.bDrawing && t === !1 || jt(e, null, "processing", [e, t]);
}
function u_(e, t, r) {
  t ? (dn(e, !0), setTimeout(function() {
    r(), dn(e, !1);
  }, 0)) : r();
}
function c_(e) {
  var t = Z(e.nTable), r = e.oScroll;
  if (r.sX === "" && r.sY === "")
    return e.nTable;
  var o = r.sX, n = r.sY, a = e.oClasses.scrolling, l = e.captionNode, i = l ? l._captionSide : null, s = Z(t[0].cloneNode(!1)), u = Z(t[0].cloneNode(!1)), c = t.children("tfoot"), g = "<div/>", p = function(T) {
    return T ? yl(T) : null;
  };
  c.length || (c = null);
  var h = Z(g, { class: a.container }).append(
    Z(g, { class: a.header.self }).css({
      overflow: "hidden",
      position: "relative",
      border: 0,
      width: o ? p(o) : "100%"
    }).append(
      Z(g, { class: a.header.inner }).css({
        "box-sizing": "content-box",
        width: r.sXInner || "100%"
      }).append(
        s.removeAttr("id").css("margin-left", 0).append(i === "top" ? l : null).append(
          t.children("thead")
        )
      )
    )
  ).append(
    Z(g, { class: a.body }).css({
      position: "relative",
      overflow: "auto",
      width: p(o)
    }).append(t)
  );
  c && h.append(
    Z(g, { class: a.footer.self }).css({
      overflow: "hidden",
      border: 0,
      width: o ? p(o) : "100%"
    }).append(
      Z(g, { class: a.footer.inner }).append(
        u.removeAttr("id").css("margin-left", 0).append(i === "bottom" ? l : null).append(
          t.children("tfoot")
        )
      )
    )
  );
  var v = h.children(), A = v[0], S = v[1], b = c ? v[2] : null;
  return Z(S).on("scroll.DT", function() {
    var T = this.scrollLeft;
    A.scrollLeft = T, c && (b.scrollLeft = T);
  }), Z("th, td", A).on("focus", function() {
    var T = A.scrollLeft;
    S.scrollLeft = T, c && (S.scrollLeft = T);
  }), Z(S).css("max-height", n), r.bCollapse || Z(S).css("height", n), e.nScrollHead = A, e.nScrollBody = S, e.nScrollFoot = b, e.aoDrawCallback.push(m_), h[0];
}
function m_(e) {
  var t = e.oScroll, r = t.iBarWidth, o = Z(e.nScrollHead), n = o.children("div"), a = n.children("table"), l = e.nScrollBody, i = Z(l), s = Z(e.nScrollFoot), u = s.children("div"), c = u.children("table"), g = Z(e.nTHead), p = Z(e.nTable), h = e.nTFoot && Z("th, td", e.nTFoot).length ? Z(e.nTFoot) : null, v = e.oBrowser, A, S, b = l.scrollHeight > l.clientHeight;
  if (e.scrollBarVis !== b && e.scrollBarVis !== void 0) {
    e.scrollBarVis = b, Cm(e);
    return;
  } else
    e.scrollBarVis = b;
  if (p.children("thead, tfoot").remove(), A = g.clone().prependTo(p), A.find("th, td").removeAttr("tabindex"), A.find("[id]").removeAttr("id"), h && (S = h.clone().prependTo(p), S.find("[id]").removeAttr("id")), e.aiDisplay.length) {
    var T = null, w = gn(e) !== "ssp" ? e._iDisplayStart : 0;
    for (_ = w; _ < w + e.aiDisplay.length; _++) {
      var N = e.aiDisplay[_], O = e.aoData[N].nTr;
      if (O) {
        T = O;
        break;
      }
    }
    if (T)
      for (var m = Z(T).children("th, td").map(function(Y) {
        return {
          idx: rh(e, Y),
          width: Z(this).outerWidth()
        };
      }), _ = 0; _ < m.length; _++) {
        var X = e.aoColumns[m[_].idx].colEl[0], $ = X.style.width.replace("px", "");
        $ !== m[_].width && (X.style.width = m[_].width + "px", t.sX && (X.style.minWidth = m[_].width + "px"));
      }
  }
  a.find("colgroup").remove(), a.append(e.colgroup.clone()), h && (c.find("colgroup").remove(), c.append(e.colgroup.clone())), Z("th, td", A).each(function() {
    Z(this.childNodes).wrapAll('<div class="dt-scroll-sizing" />');
  }), h && Z("th, td", S).each(function() {
    Z(this.childNodes).wrapAll('<div class="dt-scroll-sizing" />');
  });
  var E = Math.floor(p.height()) > l.clientHeight || i.css("overflow-y") == "scroll", D = "padding" + (v.bScrollbarLeft ? "Left" : "Right"), U = p.outerWidth();
  a.css("width", yl(U)), n.css("width", yl(U)).css(D, E ? r + "px" : "0px"), h && (c.css("width", yl(U)), u.css("width", yl(U)).css(D, E ? r + "px" : "0px")), p.children("colgroup").prependTo(p), p.find("thead, tfoot").find("[tabindex]").removeAttr("tabindex"), p.find("thead, tfoot").find("role").removeAttr("role"), i.trigger("scroll"), (e.bSorted || e.bFiltered) && !e._drawHold && (l.scrollTop = 0);
}
function V4(e) {
  if (e.oFeatures.bAutoWidth) {
    var t = e.nTable, r = e.aoColumns, o = e.oScroll, n = o.sY, a = o.sX, l = o.sXInner, i = oh(e, "bVisible"), s = t.getAttribute("width"), u = t.parentNode, c, g, p, h, v = t.style.width, A = Nx(e);
    if (A === e.containerWidth)
      return !1;
    e.containerWidth = A, !v && !s && (t.style.width = "100%", v = "100%"), v && v.indexOf("%") !== -1 && (s = v), jt(
      e,
      null,
      "column-calc",
      { visible: i },
      !1
    );
    var S = Z(t.cloneNode()).css("visibility", "hidden").css("margin", 0).removeAttr("id");
    S.append("<tbody/>"), S.append(Z(e.nTHead).clone()).append(Z(e.nTFoot).clone()), S.find("tfoot th, tfoot td").css("width", ""), S.find("thead th, thead td").each(function() {
      var K = o_(e, this, !0);
      K ? (this.style.width = K, a && (this.style.minWidth = K, Z(this).append(Z("<div/>").css({
        width: K,
        margin: 0,
        padding: 0,
        border: 0,
        height: 1
      })))) : this.style.width = "";
    });
    var b = [];
    for (c = 0; c < i.length; c++)
      b.push(H4(e, i[c]));
    if (b.length)
      for (c = 0; c < b[0].length; c++) {
        var T = Z("<tr/>").appendTo(S.find("tbody"));
        for (g = 0; g < i.length; g++) {
          h = i[g], p = r[h];
          var w = b[g][c] || "", N = go.type.className[p.sType], O = p.sContentPadding || (a ? "-" : ""), m = w + O, _ = w.indexOf("<") === -1 && w.indexOf("&") === -1 ? document.createTextNode(m) : m;
          Z("<td/>").addClass(N).addClass(p.sClass).append(_).appendTo(T);
        }
      }
    Z("[name]", S).removeAttr("name");
    var X = Z("<div/>").css(
      a || n ? {
        position: "absolute",
        top: 0,
        left: 0,
        height: 1,
        right: 0,
        overflow: "hidden"
      } : {}
    ).append(S).appendTo(u);
    a && l ? S.width(l) : a ? (S.css("width", "auto"), S.removeAttr("width"), S.outerWidth() < u.clientWidth && s && S.outerWidth(u.clientWidth)) : n ? S.outerWidth(u.clientWidth) : s && S.outerWidth(s);
    var $ = 0, E = S.find("tbody tr").eq(0).children();
    for (c = 0; c < i.length; c++) {
      var D = E[c].getBoundingClientRect().width;
      $ += D, r[i[c]].sWidth = yl(D);
    }
    if (t.style.width = yl($), X.remove(), s && (t.style.width = yl(s)), (s || a) && !e._reszEvt) {
      var U = me.util.throttle(function() {
        var K = Nx(e);
        !e.bDestroying && K !== 0 && Cm(e);
      });
      if (window.ResizeObserver) {
        var Y = Z(e.nTableWrapper).is(":visible"), G = Z("<div>").css({
          width: "100%",
          height: 0
        }).addClass("dt-autosize").appendTo(e.nTableWrapper);
        e.resizeObserver = new ResizeObserver(function(K) {
          Y ? Y = !1 : U();
        }), e.resizeObserver.observe(G[0]);
      } else
        Z(window).on("resize.DT-" + e.sInstance, U);
      e._reszEvt = !0;
    }
  }
}
function Nx(e) {
  return Z(e.nTableWrapper).is(":visible") ? Z(e.nTableWrapper).width() : 0;
}
function H4(e, t) {
  var r = e.aoColumns[t];
  if (!r.wideStrings) {
    for (var o = [], n = [], a = 0, l = e.aiDisplayMaster.length; a < l; a++) {
      var i = e.aiDisplayMaster[a], s = ih(e, i)[t], u = s && typeof s == "object" && s.nodeType ? s.innerHTML : s + "";
      u = u.replace(/id=".*?"/g, "").replace(/name=".*?"/g, ""), u = u.replace(/<script[\s\S]*?<\/script>/gi, " ").replace(/<dialog[\s\S]*?<\/dialog>/gi, " ").replace(/<template[\s\S]*?<\/template>/gi, " ");
      var c = Qa(u, " ").replace(/&nbsp;/g, " ");
      n.push({
        str: u,
        len: c.length
      }), o.push(c);
    }
    n.sort(function(p, h) {
      return h.len - p.len;
    }).splice(3), r.wideStrings = n.map(function(p) {
      return p.str;
    });
    let g = o.join(" ").split(" ");
    g.sort(function(p, h) {
      return h.length - p.length;
    }), g.length && r.wideStrings.push(g[0]), g.length > 1 && r.wideStrings.push(g[1]), g.length > 2 && r.wideStrings.push(g[3]);
  }
  return r.wideStrings;
}
function yl(e) {
  return e === null ? "0px" : typeof e == "number" ? e < 0 ? "0px" : e + "px" : e.match(/\d$/) ? e + "px" : e;
}
function g_(e) {
  var t = e.aoColumns;
  for (e.colgroup.empty(), lo = 0; lo < t.length; lo++)
    t[lo].bVisible && e.colgroup.append(t[lo].colEl);
}
function U4(e) {
  var t = e.nTHead, r = t.querySelectorAll("tr"), o = e.titleRow, n = ':not([data-dt-order="disable"]):not([data-dt-order="icon-only"])';
  o === !0 ? t = r[0] : o === !1 ? t = r[r.length - 1] : o !== null && (t = r[o]), e.orderHandler && f_(
    e,
    t,
    t === e.nTHead ? "tr" + n + " th" + n + ", tr" + n + " td" + n : "th" + n + ", td" + n
  );
  var a = [];
  Jl(e, a, e.aaSorting), e.aaSorting = a;
}
function f_(e, t, r, o, n) {
  h_(t, r, function(a) {
    var l = !1, i = o === void 0 ? nh(a.target) : typeof o == "function" ? o() : Array.isArray(o) ? o : [o];
    if (i.length) {
      for (var s = 0, u = i.length; s < u; s++) {
        var c = X4(e, i[s], s, a.shiftKey);
        if (c !== !1 && (l = !0), e.aaSorting.length === 1 && e.aaSorting[0][1] === "")
          break;
      }
      l && u_(e, !0, function() {
        uh(e), p_(e, e.aiDisplay), Qs(e, !1, !1), n && n();
      });
    }
  });
}
function p_(e, t) {
  if (!(t.length < 2)) {
    var r = e.aiDisplayMaster, o = {}, n = {}, a;
    for (a = 0; a < r.length; a++)
      o[r[a]] = a;
    for (a = 0; a < t.length; a++)
      n[t[a]] = o[t[a]];
    t.sort(function(l, i) {
      return n[l] - n[i];
    });
  }
}
function Jl(e, t, r) {
  var o = function(a) {
    if (Z.isPlainObject(a)) {
      if (a.idx !== void 0)
        t.push([a.idx, a.dir]);
      else if (a.name) {
        var l = Eo(e.aoColumns, "sName"), i = l.indexOf(a.name);
        i !== -1 && t.push([i, a.dir]);
      }
    } else
      t.push(a);
  };
  if (Z.isPlainObject(r))
    o(r);
  else if (r.length && typeof r[0] == "number")
    o(r);
  else if (r.length)
    for (var n = 0; n < r.length; n++)
      o(r[n]);
}
function Nm(e) {
  var t, r, o, n = [], a = me.ext.type.order, l = e.aoColumns, i, s, u, c, g = e.aaSortingFixed, p = Z.isPlainObject(g), h = [];
  if (!e.oFeatures.bSort)
    return n;
  for (Array.isArray(g) && Jl(e, h, g), p && g.pre && Jl(e, h, g.pre), Jl(e, h, e.aaSorting), p && g.post && Jl(e, h, g.post), t = 0; t < h.length; t++)
    if (c = h[t][0], l[c])
      for (i = l[c].aDataSort, r = 0, o = i.length; r < o; r++)
        s = i[r], u = l[s].sType || "string", h[t]._idx === void 0 && (h[t]._idx = l[s].asSorting.indexOf(h[t][1])), h[t][1] && n.push({
          src: c,
          col: s,
          dir: h[t][1],
          index: h[t]._idx,
          type: u,
          formatter: a[u + "-pre"],
          sorter: a[u + "-" + h[t][1]]
        });
  return n;
}
function uh(e, t, r) {
  var o, n, a = [], l = me.ext.type.order, i = e.aoData, s, u = e.aiDisplayMaster, c;
  if (Em(e), t !== void 0) {
    var g = e.aoColumns[t];
    c = [{
      src: t,
      col: t,
      dir: r,
      index: 0,
      type: g.sType,
      formatter: l[g.sType + "-pre"],
      sorter: l[g.sType + "-" + r]
    }], u = u.slice();
  } else
    c = Nm(e);
  for (o = 0, n = c.length; o < n; o++)
    s = c[o], W4(e, s.col);
  if (gn(e) != "ssp" && c.length !== 0) {
    for (o = 0, n = u.length; o < n; o++)
      a[o] = o;
    c.length && c[0].dir === "desc" && e.orderDescReverse && a.reverse(), u.sort(function(p, h) {
      var v, A, S, b, T, w = c.length, N = i[p]._aSortData, O = i[h]._aSortData;
      for (S = 0; S < w; S++)
        if (T = c[S], v = N[T.col], A = O[T.col], T.sorter) {
          if (b = T.sorter(v, A), b !== 0)
            return b;
        } else if (b = v < A ? -1 : v > A ? 1 : 0, b !== 0)
          return T.dir === "asc" ? b : -b;
      return v = a[p], A = a[h], v < A ? -1 : v > A ? 1 : 0;
    });
  } else c.length === 0 && u.sort(function(p, h) {
    return p < h ? -1 : p > h ? 1 : 0;
  });
  return t === void 0 && (e.bSorted = !0, e.sortDetails = c, jt(e, null, "order", [e, c])), u;
}
function X4(e, t, r, o) {
  var n = e.aoColumns[t], a = e.aaSorting, l = n.asSorting, i, s = function(c, g) {
    var p = c._idx;
    return p === void 0 && (p = l.indexOf(c[1])), p + 1 < l.length ? p + 1 : g ? null : 0;
  };
  if (!n.bSortable)
    return !1;
  if (typeof a[0] == "number" && (a = e.aaSorting = [a]), (o || r) && e.oFeatures.bSortMulti) {
    var u = Eo(a, "0").indexOf(t);
    u !== -1 ? (i = s(a[u], !0), i === null && a.length === 1 && (i = 0), i === null || l[i] === "" ? a.splice(u, 1) : (a[u][1] = l[i], a[u]._idx = i)) : o ? (a.push([t, l[0], 0]), a[a.length - 1]._idx = 0) : (a.push([t, a[0][1], 0]), a[a.length - 1]._idx = 0);
  } else a.length && a[0][0] == t ? (i = s(a[0]), a.length = 1, a[0][1] = l[i], a[0]._idx = i) : (a.length = 0, a.push([t, l[0]]), a[0]._idx = 0);
}
function gp(e) {
  var t = e.aLastSort, r = e.oClasses.order.position, o = Nm(e), n = e.oFeatures, a, l, i;
  if (n.bSort && n.bSortClasses) {
    for (a = 0, l = t.length; a < l; a++)
      i = t[a].src, Z(Eo(e.aoData, "anCells", i)).removeClass(r + (a < 2 ? a + 1 : 3));
    for (a = 0, l = o.length; a < l; a++)
      i = o[a].src, Z(Eo(e.aoData, "anCells", i)).addClass(r + (a < 2 ? a + 1 : 3));
  }
  e.aLastSort = o;
}
function W4(e, t) {
  var r = e.aoColumns[t], o = me.ext.order[r.sSortDataType], n;
  o && (n = o.call(
    e.oInstance,
    e,
    t,
    yu(e, t)
  ));
  for (var a, l, i = me.ext.type.order[r.sType + "-pre"], s = e.aoData, u = 0; u < s.length; u++)
    s[u] && (a = s[u], a._aSortData || (a._aSortData = []), (!a._aSortData[t] || o) && (l = o ? n[u] : (
      // If there was a custom sort function, use data from there
      Bn(e, u, t, "sort")
    ), a._aSortData[t] = i ? i(l, e) : l));
}
function Dm(e) {
  if (!e._bLoadingState) {
    var t = [];
    Jl(e, t, e.aaSorting);
    var r = e.aoColumns, o = {
      time: +/* @__PURE__ */ new Date(),
      start: e._iDisplayStart,
      length: e._iDisplayLength,
      order: t.map(function(n) {
        return r[n[0]] && r[n[0]].sName ? [r[n[0]].sName, n[1]] : n.slice();
      }),
      search: Z.extend({}, e.oPreviousSearch),
      columns: e.aoColumns.map(function(n, a) {
        return {
          name: n.sName,
          visible: n.bVisible,
          search: Z.extend({}, e.aoPreSearchCols[a])
        };
      })
    };
    e.oSavedState = o, jt(e, "aoStateSaveParams", "stateSaveParams", [e, o]), e.oFeatures.bStateSave && !e.bDestroying && e.fnStateSaveCallback.call(e.oInstance, e, o);
  }
}
function Y4(e, t, r) {
  if (!e.oFeatures.bStateSave) {
    r();
    return;
  }
  var o = function(a) {
    fp(e, a, r);
  }, n = e.fnStateLoadCallback.call(e.oInstance, e, o);
  return n !== void 0 && fp(e, n, r), !0;
}
function fp(e, t, r) {
  var o, n, a = e.aoColumns, l = Eo(e.aoColumns, "sName");
  e._bLoadingState = !0;
  var i = e._bInitComplete ? new me.Api(e) : null;
  if (!t || !t.time) {
    e._bLoadingState = !1, r();
    return;
  }
  var s = e.iStateDuration;
  if (s > 0 && t.time < +/* @__PURE__ */ new Date() - s * 1e3) {
    e._bLoadingState = !1, r();
    return;
  }
  var u = jt(e, "aoStateLoadParams", "stateLoadParams", [e, t]);
  if (u.indexOf(!1) !== -1) {
    e._bLoadingState = !1, r();
    return;
  }
  if (e.oLoadedState = Z.extend(!0, {}, t), jt(e, null, "stateLoadInit", [e, t], !0), t.length !== void 0 && (i ? i.page.len(t.length) : e._iDisplayLength = t.length), t.start !== void 0 && (i === null ? (e._iDisplayStart = t.start, e.iInitDisplayStart = t.start) : dh(e, t.start / e._iDisplayLength)), t.order !== void 0 && (e.aaSorting = [], Z.each(t.order, function(v, A) {
    var S = [A[0], A[1]];
    if (typeof A[0] == "string") {
      var b = l.indexOf(A[0]);
      if (b < 0)
        return;
      S[0] = b;
    } else if (S[0] >= a.length)
      return;
    e.aaSorting.push(S);
  })), t.search !== void 0 && Z.extend(e.oPreviousSearch, t.search), t.columns) {
    var c = t.columns, g = Eo(t.columns, "name");
    if (g.join("").length && g.join("") !== l.join(""))
      for (c = [], o = 0; o < l.length; o++)
        if (l[o] != "") {
          var p = g.indexOf(l[o]);
          p >= 0 ? c.push(t.columns[p]) : c.push({});
        } else
          c.push({});
    if (c.length === a.length) {
      for (o = 0, n = c.length; o < n; o++) {
        var h = c[o];
        h.visible !== void 0 && (i ? i.column(o).visible(h.visible, !1) : a[o].bVisible = h.visible), h.search !== void 0 && Z.extend(e.aoPreSearchCols[o], h.search);
      }
      i && i.one("draw", function() {
        i.columns.adjust();
      });
    }
  }
  e._bLoadingState = !1, jt(e, "aoStateLoaded", "stateLoaded", [e, t]), r();
}
function $n(e, t, r, o) {
  r = "DataTables warning: " + (e ? "table id=" + e.sTableId + " - " : "") + r, o && (r += ". For more information about this error, please see https://datatables.net/tn/" + o);
  {
    var n = me.ext, a = n.sErrMode || n.errMode;
    if (e && jt(e, null, "dt-error", [e, o, r], !0), a == "alert")
      alert(r);
    else {
      if (a == "throw")
        throw new Error(r);
      typeof a == "function" && a(e, o, r);
    }
  }
}
function wl(e, t, r, o) {
  if (Array.isArray(r)) {
    Z.each(r, function(n, a) {
      Array.isArray(a) ? wl(e, t, a[0], a[1]) : wl(e, t, a);
    });
    return;
  }
  o === void 0 && (o = r), t[r] !== void 0 && (e[o] = t[r]);
}
function Dx(e, t, r) {
  var o;
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (o = t[n], Z.isPlainObject(o) ? (Z.isPlainObject(e[n]) || (e[n] = {}), Z.extend(!0, e[n], o)) : r && n !== "data" && n !== "aaData" && Array.isArray(o) ? e[n] = o.slice() : e[n] = o);
  return e;
}
function h_(e, t, r) {
  Z(e).on("click.DT", t, function(o) {
    r(o);
  }).on("keypress.DT", t, function(o) {
    o.which === 13 && (o.preventDefault(), r(o));
  }).on("selectstart.DT", t, function() {
    return !1;
  });
}
function Sn(e, t, r) {
  r && e[t].push(r);
}
function jt(e, t, r, o, n) {
  var a = [];
  if (t && (a = e[t].slice().reverse().map(function(s) {
    return s.apply(e.oInstance, o);
  })), r !== null) {
    var l = Z.Event(r + ".dt"), i = Z(e.nTable);
    l.dt = e.api, i[n ? "trigger" : "triggerHandler"](l, o), n && i.parents("body").length === 0 && Z("body").trigger(l, o), a.push(l.result);
  }
  return a;
}
function ch(e) {
  var t = e._iDisplayStart, r = e.fnDisplayEnd(), o = e._iDisplayLength;
  t >= r && (t = r - o), t -= t % o, (o === -1 || t < 0) && (t = 0), e._iDisplayStart = t;
}
function Zc(e, t) {
  var r = e.renderer, o = me.ext.renderer[t];
  return Z.isPlainObject(r) && r[t] ? o[r[t]] || o._ : typeof r == "string" && o[r] || o._;
}
function gn(e) {
  return e.oFeatures.bServerSide ? "ssp" : e.ajax ? "ajax" : "dom";
}
function mh(e, t, r) {
  var o = e.fnFormatNumber, n = e._iDisplayStart + 1, a = e._iDisplayLength, l = e.fnRecordsDisplay(), i = e.fnRecordsTotal(), s = a === -1;
  return t.replace(/_START_/g, o.call(e, n)).replace(/_END_/g, o.call(e, e.fnDisplayEnd())).replace(/_MAX_/g, o.call(e, i)).replace(/_TOTAL_/g, o.call(e, l)).replace(/_PAGE_/g, o.call(e, s ? 1 : Math.ceil(n / a))).replace(/_PAGES_/g, o.call(e, s ? 1 : Math.ceil(l / a))).replace(/_ENTRIES_/g, e.api.i18n("entries", "", r)).replace(/_ENTRIES-MAX_/g, e.api.i18n("entries", "", i)).replace(/_ENTRIES-TOTAL_/g, e.api.i18n("entries", "", l));
}
function km(e, t) {
  if (t)
    if (t.length < 1e4)
      e.push.apply(e, t);
    else
      for (lo = 0; lo < t.length; lo++)
        e.push(t[lo]);
}
function kx(e, t, r) {
  for (Array.isArray(r) || (r = [r]), lo = 0; lo < r.length; lo++)
    e.on(t + ".dt", r[lo]);
}
function x_(e) {
  return me.ext.escape.attributes && Z.each(e, function(t, r) {
    e[t] = si(r);
  }), e;
}
var gh = [], ko = Array.prototype, K4 = function(e) {
  var t, r, o = me.settings, n = Eo(o, "nTable");
  if (e) {
    if (e.nTable && e.oFeatures)
      return [e];
    if (e.nodeName && e.nodeName.toLowerCase() === "table")
      return t = n.indexOf(e), t !== -1 ? [o[t]] : null;
    if (e && typeof e.settings == "function")
      return e.settings().toArray();
    typeof e == "string" ? r = Z(e).get() : e instanceof Z && (r = e.get());
  } else return [];
  if (r)
    return o.filter(function(a, l) {
      return r.includes(n[l]);
    });
};
kt = function(e, t) {
  if (!(this instanceof kt))
    return new kt(e, t);
  var r, o = [], n = function(a) {
    var l = K4(a);
    l && o.push.apply(o, l);
  };
  if (Array.isArray(e))
    for (r = 0; r < e.length; r++)
      n(e[r]);
  else
    n(e);
  this.context = o.length > 1 ? sd(o) : o, km(this, t), this.selector = {
    rows: null,
    cols: null,
    opts: null
  }, kt.extend(this, this, gh);
};
me.Api = kt;
Z.extend(kt.prototype, {
  any: function() {
    return this.count() !== 0;
  },
  context: [],
  // array of table settings objects
  count: function() {
    return this.flatten().length;
  },
  each: function(e) {
    for (var t = 0, r = this.length; t < r; t++)
      e.call(this, this[t], t, this);
    return this;
  },
  eq: function(e) {
    var t = this.context;
    return t.length > e ? new kt(t[e], this[e]) : null;
  },
  filter: function(e) {
    var t = ko.filter.call(this, e, this);
    return new kt(this.context, t);
  },
  flatten: function() {
    var e = [];
    return new kt(this.context, e.concat.apply(e, this.toArray()));
  },
  get: function(e) {
    return this[e];
  },
  join: ko.join,
  includes: function(e) {
    return this.indexOf(e) !== -1;
  },
  indexOf: ko.indexOf,
  iterator: function(e, t, r, o) {
    var n = [], a, l, i, s, u, c = this.context, g, p, h, v = this.selector;
    for (typeof e == "string" && (o = r, r = t, t = e, e = !1), l = 0, i = c.length; l < i; l++) {
      var A = new kt(c[l]);
      if (t === "table")
        a = r.call(A, c[l], l), a !== void 0 && n.push(a);
      else if (t === "columns" || t === "rows")
        a = r.call(A, c[l], this[l], l), a !== void 0 && n.push(a);
      else if (t === "every" || t === "column" || t === "column-rows" || t === "row" || t === "cell")
        for (p = this[l], t === "column-rows" && (g = Gm(c[l], v.opts)), s = 0, u = p.length; s < u; s++)
          h = p[s], t === "cell" ? a = r.call(A, c[l], h.row, h.column, l, s) : a = r.call(A, c[l], h, l, s, g), a !== void 0 && n.push(a);
    }
    if (n.length || o) {
      var S = new kt(c, e ? n.concat.apply([], n) : n), b = S.selector;
      return b.rows = v.rows, b.cols = v.cols, b.opts = v.opts, S;
    }
    return this;
  },
  lastIndexOf: ko.lastIndexOf,
  length: 0,
  map: function(e) {
    var t = ko.map.call(this, e, this);
    return new kt(this.context, t);
  },
  pluck: function(e) {
    var t = me.util.get(e);
    return this.map(function(r) {
      return t(r);
    });
  },
  pop: ko.pop,
  push: ko.push,
  reduce: ko.reduce,
  reduceRight: ko.reduceRight,
  reverse: ko.reverse,
  // Object with rows, columns and opts
  selector: null,
  shift: ko.shift,
  slice: function() {
    return new kt(this.context, this);
  },
  sort: ko.sort,
  splice: ko.splice,
  toArray: function() {
    return ko.slice.call(this);
  },
  to$: function() {
    return Z(this);
  },
  toJQuery: function() {
    return Z(this);
  },
  unique: function() {
    return new kt(this.context, sd(this.toArray()));
  },
  unshift: ko.unshift
});
function Q4(e, t, r) {
  return function() {
    var o = t.apply(e || this, arguments);
    return kt.extend(o, o, r.methodExt), o;
  };
}
function j4(e, t) {
  for (var r = 0, o = e.length; r < o; r++)
    if (e[r].name === t)
      return e[r];
  return null;
}
window.__apiStruct = gh;
kt.extend = function(e, t, r) {
  if (!(!r.length || !t || !(t instanceof kt) && !t.__dt_wrapper)) {
    var o, n, a;
    for (o = 0, n = r.length; o < n; o++)
      a = r[o], a.name !== "__proto__" && (t[a.name] = a.type === "function" ? Q4(e, a.val, a) : a.type === "object" ? {} : a.val, t[a.name].__dt_wrapper = !0, kt.extend(e, t[a.name], a.propExt));
  }
};
kt.register = ct = function(e, t) {
  if (Array.isArray(e)) {
    for (var r = 0, o = e.length; r < o; r++)
      kt.register(e[r], t);
    return;
  }
  var n, a, l = e.split("."), i = gh, s, u;
  for (n = 0, a = l.length; n < a; n++) {
    u = l[n].indexOf("()") !== -1, s = u ? l[n].replace("()", "") : l[n];
    var c = j4(i, s);
    c || (c = {
      name: s,
      val: {},
      methodExt: [],
      propExt: [],
      type: "object"
    }, i.push(c)), n === a - 1 ? (c.val = t, c.type = typeof t == "function" ? "function" : Z.isPlainObject(t) ? "object" : "other") : i = u ? c.methodExt : c.propExt;
  }
};
kt.registerPlural = sr = function(e, t, r) {
  kt.register(e, r), kt.register(t, function() {
    var o = r.apply(this, arguments);
    return o === this ? this : o instanceof kt ? o.length ? Array.isArray(o[0]) ? new kt(o.context, o[0]) : (
      // Array results are 'enhanced'
      o[0]
    ) : void 0 : o;
  });
};
var v_ = function(e, t) {
  if (Array.isArray(e)) {
    var r = [];
    return e.forEach(function(n) {
      var a = v_(n, t);
      km(r, a);
    }), r.filter(function(n) {
      return n;
    });
  }
  if (typeof e == "number")
    return [t[e]];
  var o = t.map(function(n) {
    return n.nTable;
  });
  return Z(o).filter(e).map(function() {
    var n = o.indexOf(this);
    return t[n];
  }).toArray();
};
ct("tables()", function(e) {
  return e != null ? new kt(v_(e, this.context)) : this;
});
ct("table()", function(e) {
  var t = this.tables(e), r = t.context;
  return r.length ? new kt(r[0]) : t;
});
[
  ["nodes", "node", "nTable"],
  ["body", "body", "nTBody"],
  ["header", "header", "nTHead"],
  ["footer", "footer", "nTFoot"]
].forEach(function(e) {
  sr(
    "tables()." + e[0] + "()",
    "table()." + e[1] + "()",
    function() {
      return this.iterator("table", function(t) {
        return t[e[2]];
      }, 1);
    }
  );
});
[
  ["header", "aoHeader"],
  ["footer", "aoFooter"]
].forEach(function(e) {
  ct("table()." + e[0] + ".structure()", function(t) {
    var r = this.columns(t).indexes().flatten().toArray(), o = this.context[0], n = i_(o, o[e[1]], r), a = r.slice().sort(function(l, i) {
      return l - i;
    });
    return n.map(function(l) {
      return r.map(function(i) {
        return l[a.indexOf(i)];
      });
    });
  });
});
sr("tables().containers()", "table().container()", function() {
  return this.iterator("table", function(e) {
    return e.nTableWrapper;
  }, 1);
});
ct("tables().every()", function(e) {
  var t = this;
  return this.iterator("table", function(r, o) {
    e.call(t.table(o), o);
  });
});
ct("caption()", function(e, t) {
  var r = this.context;
  if (e === void 0) {
    var o = r[0].captionNode;
    return o && r.length ? o.innerHTML : null;
  }
  return this.iterator("table", function(n) {
    var a = Z(n.nTable), l = Z(n.captionNode), i = Z(n.nTableWrapper);
    if (l.length || (l = Z("<caption/>").html(e), n.captionNode = l[0], t || (a.prepend(l), t = l.css("caption-side"))), l.html(e), t && (l.css("caption-side", t), l[0]._captionSide = t), i.find("div.dataTables_scroll").length) {
      var s = t === "top" ? "Head" : "Foot";
      i.find("div.dataTables_scroll" + s + " table").prepend(l);
    } else
      a.prepend(l);
  }, 1);
});
ct("caption.node()", function() {
  var e = this.context;
  return e.length ? e[0].captionNode : null;
});
ct("draw()", function(e) {
  return this.iterator("table", function(t) {
    e === "page" ? dd(t) : (typeof e == "string" && (e = e !== "full-hold"), Qs(t, e === !1));
  });
});
ct("page()", function(e) {
  return e === void 0 ? this.page.info().page : this.iterator("table", function(t) {
    dh(t, e);
  });
});
ct("page.info()", function() {
  if (this.context.length !== 0) {
    var e = this.context[0], t = e._iDisplayStart, r = e.oFeatures.bPaginate ? e._iDisplayLength : -1, o = e.fnRecordsDisplay(), n = r === -1;
    return {
      page: n ? 0 : Math.floor(t / r),
      pages: n ? 1 : Math.ceil(o / r),
      start: t,
      end: e.fnDisplayEnd(),
      length: r,
      recordsTotal: e.fnRecordsTotal(),
      recordsDisplay: o,
      serverSide: gn(e) === "ssp"
    };
  }
});
ct("page.len()", function(e) {
  return e === void 0 ? this.context.length !== 0 ? this.context[0]._iDisplayLength : void 0 : this.iterator("table", function(t) {
    d_(t, e);
  });
});
var S_ = function(e, t, r) {
  if (r) {
    var o = new kt(e);
    o.one("draw", function() {
      r(o.ajax.json());
    });
  }
  if (gn(e) == "ssp")
    Qs(e, t);
  else {
    dn(e, !0);
    var n = e.jqXHR;
    n && n.readyState !== 4 && n.abort(), sh(e, {}, function(a) {
      lh(e);
      for (var l = eu(e, a), i = 0, s = l.length; i < s; i++)
        vi(e, l[i]);
      Qs(e, t), jc(e), dn(e, !1);
    });
  }
};
ct("ajax.json()", function() {
  var e = this.context;
  if (e.length > 0)
    return e[0].json;
});
ct("ajax.params()", function() {
  var e = this.context;
  if (e.length > 0)
    return e[0].oAjaxData;
});
ct("ajax.reload()", function(e, t) {
  return this.iterator("table", function(r) {
    S_(r, t === !1, e);
  });
});
ct("ajax.url()", function(e) {
  var t = this.context;
  return e === void 0 ? t.length === 0 ? void 0 : (t = t[0], Z.isPlainObject(t.ajax) ? t.ajax.url : t.ajax) : this.iterator("table", function(r) {
    Z.isPlainObject(r.ajax) ? r.ajax.url = e : r.ajax = e;
  });
});
ct("ajax.url().load()", function(e, t) {
  return this.iterator("table", function(r) {
    S_(r, t === !1, e);
  });
});
var fh = function(e, t, r, o, n) {
  var a = [], l, i, s, u = typeof t;
  for ((!t || u === "string" || u === "function" || t.length === void 0) && (t = [t]), i = 0, s = t.length; i < s; i++)
    l = r(typeof t[i] == "string" ? t[i].trim() : t[i]), l = l.filter(function(g) {
      return g != null;
    }), l && l.length && (a = a.concat(l));
  var c = go.selector[e];
  if (c.length)
    for (i = 0, s = c.length; i < s; i++)
      a = c[i](o, n, a);
  return sd(a);
}, ph = function(e) {
  return e || (e = {}), e.filter && e.search === void 0 && (e.search = e.filter), Z.extend({
    columnOrder: "implied",
    search: "none",
    order: "current",
    page: "all"
  }, e);
}, hh = function(e) {
  var t = new kt(e.context[0]);
  return e.length && t.push(e[0]), t.selector = e.selector, t.length && t[0].length > 1 && t[0].splice(1), t;
}, Gm = function(e, t) {
  var r, o, n, a = [], l = e.aiDisplay, i = e.aiDisplayMaster, s = t.search, u = t.order, c = t.page;
  if (gn(e) == "ssp")
    return s === "removed" ? [] : ml(0, i.length);
  if (c == "current")
    for (r = e._iDisplayStart, o = e.fnDisplayEnd(); r < o; r++)
      a.push(l[r]);
  else if (u == "current" || u == "applied") {
    if (s == "none")
      a = i.slice();
    else if (s == "applied")
      a = l.slice();
    else if (s == "removed") {
      var g = {};
      for (r = 0, o = l.length; r < o; r++)
        g[l[r]] = null;
      i.forEach(function(h) {
        Object.prototype.hasOwnProperty.call(g, h) || a.push(h);
      });
    }
  } else if (u == "index" || u == "original")
    for (r = 0, o = e.aoData.length; r < o; r++)
      e.aoData[r] && (s == "none" ? a.push(r) : (n = l.indexOf(r), (n === -1 && s == "removed" || n >= 0 && s == "applied") && a.push(r)));
  else if (typeof u == "number") {
    var p = uh(e, u, "asc");
    if (s === "none")
      a = p;
    else
      for (r = 0; r < p.length; r++)
        n = l.indexOf(p[r]), (n === -1 && s == "removed" || n >= 0 && s == "applied") && a.push(p[r]);
  }
  return a;
}, Z4 = function(e, t, r) {
  var o, n = function(l) {
    var i = zw(l), s = e.aoData;
    if (i !== null && !r)
      return [i];
    if (o || (o = Gm(e, r)), i !== null && o.indexOf(i) !== -1)
      return [i];
    if (l == null || l === "")
      return o;
    if (typeof l == "function")
      return o.map(function(v) {
        var A = s[v];
        return l(v, A._aData, A.nTr) ? v : null;
      });
    if (l.nodeName) {
      var u = l._DT_RowIndex, c = l._DT_CellIndex;
      if (u !== void 0)
        return s[u] && s[u].nTr === l ? [u] : [];
      if (c)
        return s[c.row] && s[c.row].nTr === l.parentNode ? [c.row] : [];
      var g = Z(l).closest("*[data-dt-row]");
      return g.length ? [g.data("dt-row")] : [];
    }
    if (typeof l == "string" && l.charAt(0) === "#") {
      var p = e.aIds[l.replace(/^#/, "")];
      if (p !== void 0)
        return [p.idx];
    }
    var h = Jw(
      bu(e.aoData, o, "nTr")
    );
    return Z(h).filter(l).map(function() {
      return this._DT_RowIndex;
    }).toArray();
  }, a = fh("row", t, n, e, r);
  return (r.order === "current" || r.order === "applied") && p_(e, a), a;
};
ct("rows()", function(e, t) {
  e === void 0 ? e = "" : Z.isPlainObject(e) && (t = e, e = ""), t = ph(t);
  var r = this.iterator("table", function(o) {
    return Z4(o, e, t);
  }, 1);
  return r.selector.rows = e, r.selector.opts = t, r;
});
ct("rows().nodes()", function() {
  return this.iterator("row", function(e, t) {
    return e.aoData[t].nTr || void 0;
  }, 1);
});
ct("rows().data()", function() {
  return this.iterator(!0, "rows", function(e, t) {
    return bu(e.aoData, t, "_aData");
  }, 1);
});
sr("rows().cache()", "row().cache()", function(e) {
  return this.iterator("row", function(t, r) {
    var o = t.aoData[r];
    return e === "search" ? o._aFilterData : o._aSortData;
  }, 1);
});
sr("rows().invalidate()", "row().invalidate()", function(e) {
  return this.iterator("row", function(t, r) {
    Om(t, r, e);
  });
});
sr("rows().indexes()", "row().index()", function() {
  return this.iterator("row", function(e, t) {
    return t;
  }, 1);
});
sr("rows().ids()", "row().id()", function(e) {
  for (var t = [], r = this.context, o = 0, n = r.length; o < n; o++)
    for (var a = 0, l = this[o].length; a < l; a++) {
      var i = r[o].rowIdFn(r[o].aoData[this[o][a]]._aData);
      t.push((e === !0 ? "#" : "") + i);
    }
  return new kt(r, t);
});
sr("rows().remove()", "row().remove()", function() {
  return this.iterator("row", function(e, t) {
    var r = e.aoData, o = r[t], n = e.aiDisplayMaster.indexOf(t);
    n !== -1 && e.aiDisplayMaster.splice(n, 1), e._iRecordsDisplay > 0 && e._iRecordsDisplay--, ch(e);
    var a = e.rowIdFn(o._aData);
    a !== void 0 && delete e.aIds[a], r[t] = null;
  }), this;
});
ct("rows.add()", function(e) {
  var t = this.iterator("table", function(o) {
    var n, a, l, i = [];
    for (a = 0, l = e.length; a < l; a++)
      n = e[a], n.nodeName && n.nodeName.toUpperCase() === "TR" ? i.push(ah(o, n)[0]) : i.push(vi(o, n));
    return i;
  }, 1), r = this.rows(-1);
  return r.pop(), km(r, t), r;
});
ct("row()", function(e, t) {
  return hh(this.rows(e, t));
});
ct("row().data()", function(e) {
  var t = this.context;
  if (e === void 0)
    return t.length && this.length && this[0].length ? t[0].aoData[this[0]]._aData : void 0;
  var r = t[0].aoData[this[0]];
  return r._aData = e, Array.isArray(e) && r.nTr && r.nTr.id && ql(t[0].rowId)(e, r.nTr.id), Om(t[0], this[0], "data"), this;
});
ct("row().node()", function() {
  var e = this.context;
  if (e.length && this.length && this[0].length) {
    var t = e[0].aoData[this[0]];
    if (t && t.nTr)
      return t.nTr;
  }
  return null;
});
ct("row.add()", function(e) {
  e instanceof Z && e.length && (e = e[0]);
  var t = this.iterator("table", function(r) {
    return e.nodeName && e.nodeName.toUpperCase() === "TR" ? ah(r, e)[0] : vi(r, e);
  });
  return this.row(t[0]);
});
Z(document).on("plugin-init.dt", function(e, t) {
  var r = new kt(t);
  r.on("stateSaveParams.DT", function(o, n, a) {
    for (var l = n.rowIdFn, i = n.aiDisplayMaster, s = [], u = 0; u < i.length; u++) {
      var c = i[u], g = n.aoData[c];
      g._detailsShow && s.push("#" + l(g._aData));
    }
    a.childRows = s;
  }), r.on("stateLoaded.DT", function(o, n, a) {
    Gx(r, a);
  }), Gx(r, r.state.loaded());
});
var Gx = function(e, t) {
  t && t.childRows && e.rows(t.childRows.map(function(r) {
    return r.replace(/([^:\\]*(?:\\.[^:\\]*)*):/g, "$1\\:");
  })).every(function() {
    jt(e.settings()[0], null, "requestChild", [this]);
  });
}, z4 = function(e, t, r, o) {
  var n = [], a = function(l, i) {
    if (Array.isArray(l) || l instanceof Z) {
      for (var s = 0, u = l.length; s < u; s++)
        a(l[s], i);
      return;
    }
    if (l.nodeName && l.nodeName.toLowerCase() === "tr")
      l.setAttribute("data-dt-row", t.idx), n.push(l);
    else {
      var c = Z("<tr><td></td></tr>").attr("data-dt-row", t.idx).addClass(i);
      Z("td", c).addClass(i).html(l)[0].colSpan = Lm(e), n.push(c[0]);
    }
  };
  a(r, o), t._details && t._details.detach(), t._details = Z(n), t._detailsShow && t._details.insertAfter(t.nTr);
}, b_ = me.util.throttle(
  function(e) {
    Dm(e[0]);
  },
  500
), xh = function(e, t) {
  var r = e.context;
  if (r.length) {
    var o = r[0].aoData[t !== void 0 ? t : e[0]];
    o && o._details && (o._details.detach(), o._detailsShow = void 0, o._details = void 0, Z(o.nTr).removeClass("dt-hasChild"), b_(r));
  }
}, y_ = function(e, t) {
  var r = e.context;
  if (r.length && e.length) {
    var o = r[0].aoData[e[0]];
    o._details && (o._detailsShow = t, t ? (o._details.insertAfter(o.nTr), Z(o.nTr).addClass("dt-hasChild")) : (o._details.detach(), Z(o.nTr).removeClass("dt-hasChild")), jt(r[0], null, "childRow", [t, e.row(e[0])]), q4(r[0]), b_(r));
  }
}, q4 = function(e) {
  var t = new kt(e), r = ".dt.DT_details", o = "draw" + r, n = "column-sizing" + r, a = "destroy" + r, l = e.aoData;
  t.off(o + " " + n + " " + a), Eo(l, "_details").length > 0 && (t.on(o, function(i, s) {
    e === s && t.rows({ page: "current" }).eq(0).each(function(u) {
      var c = l[u];
      c._detailsShow && c._details.insertAfter(c.nTr);
    });
  }), t.on(n, function(i, s) {
    if (e === s)
      for (var u, c = Lm(s), g = 0, p = l.length; g < p; g++)
        u = l[g], u && u._details && u._details.each(function() {
          var h = Z(this).children("td");
          h.length == 1 && h.attr("colspan", c);
        });
  }), t.on(a, function(i, s) {
    if (e === s)
      for (var u = 0, c = l.length; u < c; u++)
        l[u] && l[u]._details && xh(t, u);
  }));
}, J4 = "", wu = J4 + "row().child", Bm = wu + "()";
ct(Bm, function(e, t) {
  var r = this.context;
  return e === void 0 ? r.length && this.length && r[0].aoData[this[0]] ? r[0].aoData[this[0]]._details : void 0 : (e === !0 ? this.child.show() : e === !1 ? xh(this) : r.length && this.length && z4(r[0], r[0].aoData[this[0]], e, t), this);
});
ct([
  wu + ".show()",
  Bm + ".show()"
  // only when `child()` was called with parameters (without
], function() {
  return y_(this, !0), this;
});
ct([
  wu + ".hide()",
  Bm + ".hide()"
  // only when `child()` was called with parameters (without
], function() {
  return y_(this, !1), this;
});
ct([
  wu + ".remove()",
  Bm + ".remove()"
  // only when `child()` was called with parameters (without
], function() {
  return xh(this), this;
});
ct(wu + ".isShown()", function() {
  var e = this.context;
  return e.length && this.length && e[0].aoData[this[0]] && e[0].aoData[this[0]]._detailsShow || !1;
});
var eR = /^([^:]+)?:(name|title|visIdx|visible)$/, vh = function(e, t, r, o, n, a) {
  for (var l = [], i = 0, s = n.length; i < s; i++)
    l.push(Bn(e, n[i], t, a));
  return l;
}, w_ = function(e, t, r) {
  var o = e.aoHeader, n = e.titleRow, a = null;
  if (r !== void 0)
    a = r;
  else if (n === !0)
    a = 0;
  else if (n === !1)
    a = o.length - 1;
  else if (n !== null)
    a = n;
  else {
    for (var l = 0; l < o.length; l++)
      o[l][t].unique && Z(".dt-column-title", o[l][t].cell).text() && (a = l);
    a === null && (a = 0);
  }
  return o[a][t].cell;
}, tR = function(e) {
  for (var t = [], r = 0; r < e.length; r++)
    for (var o = 0; o < e[r].length; o++) {
      var n = e[r][o].cell;
      t.includes(n) || t.push(n);
    }
  return t;
}, rR = function(e, t, r) {
  var o = e.aoColumns, n, a, l = tR(e.aoHeader), i = function(u) {
    var c = zw(u);
    if (u === "")
      return ml(o.length);
    if (c !== null)
      return [
        c >= 0 ? c : (
          // Count from left
          o.length + c
        )
        // Count from right (+ because its a negative value)
      ];
    if (typeof u == "function") {
      var g = Gm(e, r);
      return o.map(function(b, T) {
        return u(
          T,
          vh(e, T, 0, 0, g),
          w_(e, T)
        ) ? T : null;
      });
    }
    var p = typeof u == "string" ? u.match(eR) : "";
    if (p)
      switch (p[2]) {
        case "visIdx":
        case "visible":
          if (p[1] && p[1].match(/^\d+$/)) {
            var h = parseInt(p[1], 10);
            if (h < 0) {
              var v = o.map(function(b, T) {
                return b.bVisible ? T : null;
              });
              return [v[v.length + h]];
            }
            return [rh(e, h)];
          }
          return o.map(function(b, T) {
            return !b.bVisible || b.responsiveVisible === !1 ? null : p[1] ? Z(l[T]).filter(p[1]).length > 0 ? T : null : T;
          });
        case "name":
          return n || (n = Eo(o, "sName")), n.map(function(b, T) {
            return b === p[1] ? T : null;
          });
        case "title":
          return a || (a = Eo(o, "sTitle")), a.map(function(b, T) {
            return b === p[1] ? T : null;
          });
        default:
          return [];
      }
    if (u.nodeName && u._DT_CellIndex)
      return [u._DT_CellIndex.column];
    var A = Z(l).filter(u).map(function() {
      return nh(this);
    }).toArray().sort(function(b, T) {
      return b - T;
    });
    if (A.length || !u.nodeName)
      return A;
    var S = Z(u).closest("*[data-dt-column]");
    return S.length ? [S.data("dt-column")] : [];
  }, s = fh("column", t, i, e, r);
  return r.columnOrder && r.columnOrder === "index" ? s.sort(function(u, c) {
    return u - c;
  }) : s;
}, oR = function(e, t, r) {
  var o = e.aoColumns, n = o[t], a = e.aoData, l, i, s, u;
  if (r === void 0)
    return n.bVisible;
  if (n.bVisible === r)
    return !1;
  if (r) {
    var c = Eo(o, "bVisible").indexOf(!0, t + 1);
    for (i = 0, s = a.length; i < s; i++)
      a[i] && (u = a[i].nTr, l = a[i].anCells, u && u.insertBefore(l[t], l[c] || null));
  } else
    Z(Eo(e.aoData, "anCells", t)).detach();
  return n.bVisible = r, g_(e), !0;
};
ct("columns()", function(e, t) {
  e === void 0 ? e = "" : Z.isPlainObject(e) && (t = e, e = ""), t = ph(t);
  var r = this.iterator("table", function(o) {
    return rR(o, e, t);
  }, 1);
  return r.selector.cols = e, r.selector.opts = t, r;
});
sr("columns().header()", "column().header()", function(e) {
  return this.iterator("column", function(t, r) {
    return w_(t, r, e);
  }, 1);
});
sr("columns().footer()", "column().footer()", function(e) {
  return this.iterator("column", function(t, r) {
    var o = t.aoFooter;
    return o.length ? t.aoFooter[e !== void 0 ? e : 0][r].cell : null;
  }, 1);
});
sr("columns().data()", "column().data()", function() {
  return this.iterator("column-rows", vh, 1);
});
sr("columns().render()", "column().render()", function(e) {
  return this.iterator("column-rows", function(t, r, o, n, a) {
    return vh(t, r, o, n, a, e);
  }, 1);
});
sr("columns().dataSrc()", "column().dataSrc()", function() {
  return this.iterator("column", function(e, t) {
    return e.aoColumns[t].mData;
  }, 1);
});
sr("columns().cache()", "column().cache()", function(e) {
  return this.iterator("column-rows", function(t, r, o, n, a) {
    return bu(
      t.aoData,
      a,
      e === "search" ? "_aFilterData" : "_aSortData",
      r
    );
  }, 1);
});
sr("columns().init()", "column().init()", function() {
  return this.iterator("column", function(e, t) {
    return e.aoColumns[t];
  }, 1);
});
sr("columns().names()", "column().name()", function() {
  return this.iterator("column", function(e, t) {
    return e.aoColumns[t].sName;
  }, 1);
});
sr("columns().nodes()", "column().nodes()", function() {
  return this.iterator("column-rows", function(e, t, r, o, n) {
    return bu(e.aoData, n, "anCells", t);
  }, 1);
});
sr("columns().titles()", "column().title()", function(e, t) {
  return this.iterator("column", function(r, o) {
    typeof e == "number" && (t = e, e = void 0);
    var n = Z(".dt-column-title", this.column(o).header(t));
    return e !== void 0 ? (n.html(e), this) : n.html();
  }, 1);
});
sr("columns().types()", "column().type()", function() {
  return this.iterator("column", function(e, t) {
    var r = e.aoColumns[t], o = r.sType;
    return o || (Em(e), o = r.sType), o;
  }, 1);
});
sr("columns().visible()", "column().visible()", function(e, t) {
  var r = this, o = [], n = this.iterator("column", function(a, l) {
    if (e === void 0)
      return a.aoColumns[l].bVisible;
    oR(a, l, e) && o.push(l);
  });
  return e !== void 0 && this.iterator("table", function(a) {
    Qc(a, a.aoHeader), Qc(a, a.aoFooter), a.aiDisplay.length || Z(a.nTBody).find("td[colspan]").attr("colspan", Lm(a)), Dm(a), r.iterator("column", function(l, i) {
      o.includes(i) && jt(l, null, "column-visibility", [l, i, e, t]);
    }), o.length && (t === void 0 || t) && r.columns.adjust();
  }), n;
});
sr("columns().widths()", "column().width()", function() {
  var e = this.columns(":visible").count(), t = Z("<tr>").html("<td>" + Array(e).join("</td><td>") + "</td>");
  Z(this.table().body()).append(t);
  var r = t.children().map(function() {
    return Z(this).outerWidth();
  });
  return t.remove(), this.iterator("column", function(o, n) {
    var a = yu(o, n);
    return a !== null ? r[a] : 0;
  }, 1);
});
sr("columns().indexes()", "column().index()", function(e) {
  return this.iterator("column", function(t, r) {
    return e === "visible" ? yu(t, r) : r;
  }, 1);
});
ct("columns.adjust()", function() {
  return this.iterator("table", function(e) {
    e.containerWidth = -1, Cm(e);
  }, 1);
});
ct("column.index()", function(e, t) {
  if (this.context.length !== 0) {
    var r = this.context[0];
    if (e === "fromVisible" || e === "toData")
      return rh(r, t);
    if (e === "fromData" || e === "toVisible")
      return yu(r, t);
  }
});
ct("column()", function(e, t) {
  return hh(this.columns(e, t));
});
var nR = function(e, t, r) {
  var o = e.aoData, n = Gm(e, r), a = Jw(bu(o, n, "anCells")), l = Z(e_([], a)), i, s = e.aoColumns.length, u, c, g, p, h, v, A = function(S) {
    var b = typeof S == "function";
    if (S == null || b) {
      for (u = [], c = 0, g = n.length; c < g; c++)
        for (i = n[c], p = 0; p < s; p++)
          h = {
            row: i,
            column: p
          }, b ? (v = o[i], S(h, Bn(e, i, p), v.anCells ? v.anCells[p] : null) && u.push(h)) : u.push(h);
      return u;
    }
    if (Z.isPlainObject(S))
      return S.column !== void 0 && S.row !== void 0 && n.indexOf(S.row) !== -1 ? [S] : [];
    var T = l.filter(S).map(function(w, N) {
      return {
        // use a new object, in case someone changes the values
        row: N._DT_CellIndex.row,
        column: N._DT_CellIndex.column
      };
    }).toArray();
    return T.length || !S.nodeName ? T : (v = Z(S).closest("*[data-dt-row]"), v.length ? [{
      row: v.data("dt-row"),
      column: v.data("dt-column")
    }] : []);
  };
  return fh("cell", t, A, e, r);
};
ct("cells()", function(e, t, r) {
  if (Z.isPlainObject(e) && (e.row === void 0 ? (r = e, e = null) : (r = t, t = null)), Z.isPlainObject(t) && (r = t, t = null), t == null)
    return this.iterator("table", function(p) {
      return nR(p, e, ph(r));
    });
  var o = r ? {
    page: r.page,
    order: r.order,
    search: r.search
  } : {}, n = this.columns(t, o), a = this.rows(e, o), l, i, s, u, c = this.iterator("table", function(p, h) {
    var v = [];
    for (l = 0, i = a[h].length; l < i; l++)
      for (s = 0, u = n[h].length; s < u; s++)
        v.push({
          row: a[h][l],
          column: n[h][s]
        });
    return v;
  }, 1), g = r && r.selected ? this.cells(c, r) : c;
  return Z.extend(g.selector, {
    cols: t,
    rows: e,
    opts: r
  }), g;
});
sr("cells().nodes()", "cell().node()", function() {
  return this.iterator("cell", function(e, t, r) {
    var o = e.aoData[t];
    return o && o.anCells ? o.anCells[r] : void 0;
  }, 1);
});
ct("cells().data()", function() {
  return this.iterator("cell", function(e, t, r) {
    return Bn(e, t, r);
  }, 1);
});
sr("cells().cache()", "cell().cache()", function(e) {
  return e = e === "search" ? "_aFilterData" : "_aSortData", this.iterator("cell", function(t, r, o) {
    return t.aoData[r][e][o];
  }, 1);
});
sr("cells().render()", "cell().render()", function(e) {
  return this.iterator("cell", function(t, r, o) {
    return Bn(t, r, o, e);
  }, 1);
});
sr("cells().indexes()", "cell().index()", function() {
  return this.iterator("cell", function(e, t, r) {
    return {
      row: t,
      column: r,
      columnVisible: yu(e, r)
    };
  }, 1);
});
sr("cells().invalidate()", "cell().invalidate()", function(e) {
  return this.iterator("cell", function(t, r, o) {
    Om(t, r, e, o);
  });
});
ct("cell()", function(e, t, r) {
  return hh(this.cells(e, t, r));
});
ct("cell().data()", function(e) {
  var t = this.context, r = this[0];
  return e === void 0 ? t.length && r.length ? Bn(t[0], r[0].row, r[0].column) : void 0 : (M4(t[0], r[0].row, r[0].column, e), Om(t[0], r[0].row, "data", r[0].column), this);
});
ct("order()", function(e, t) {
  var r = this.context, o = Array.prototype.slice.call(arguments);
  return e === void 0 ? r.length !== 0 ? r[0].aaSorting : void 0 : (typeof e == "number" ? e = [[e, t]] : o.length > 1 && (e = o), this.iterator("table", function(n) {
    var a = [];
    Jl(n, a, e), n.aaSorting = a;
  }));
});
ct("order.listener()", function(e, t, r) {
  return this.iterator("table", function(o) {
    f_(o, e, {}, t, r);
  });
});
ct("order.fixed()", function(e) {
  if (!e) {
    var t = this.context, r = t.length ? t[0].aaSortingFixed : void 0;
    return Array.isArray(r) ? { pre: r } : r;
  }
  return this.iterator("table", function(o) {
    o.aaSortingFixed = Z.extend(!0, {}, e);
  });
});
ct([
  "columns().order()",
  "column().order()"
], function(e) {
  var t = this;
  return e ? this.iterator("table", function(r, o) {
    r.aaSorting = t[o].map(function(n) {
      return [n, e];
    });
  }) : this.iterator("column", function(r, o) {
    for (var n = Nm(r), a = 0, l = n.length; a < l; a++)
      if (n[a].col === o)
        return n[a].dir;
    return null;
  }, 1);
});
sr("columns().orderable()", "column().orderable()", function(e) {
  return this.iterator("column", function(t, r) {
    var o = t.aoColumns[r];
    return e ? o.asSorting : o.bSortable;
  }, 1);
});
ct("processing()", function(e) {
  return this.iterator("table", function(t) {
    dn(t, e);
  });
});
ct("search()", function(e, t, r, o) {
  var n = this.context;
  return e === void 0 ? n.length !== 0 ? n[0].oPreviousSearch.search : void 0 : this.iterator("table", function(a) {
    a.oFeatures.bFilter && (typeof t == "object" ? tu(a, Z.extend(a.oPreviousSearch, t, {
      search: e
    })) : tu(a, Z.extend(a.oPreviousSearch, {
      search: e,
      regex: t === null ? !1 : t,
      smart: r === null ? !0 : r,
      caseInsensitive: o === null ? !0 : o
    })));
  });
});
ct("search.fixed()", function(e, t) {
  var r = this.iterator(!0, "table", function(o) {
    var n = o.searchFixed;
    if (e) {
      if (t === void 0)
        return n[e];
      t === null ? delete n[e] : n[e] = t;
    } else return Object.keys(n);
    return this;
  });
  return e !== void 0 && t === void 0 ? r[0] : r;
});
sr(
  "columns().search()",
  "column().search()",
  function(e, t, r, o) {
    return this.iterator("column", function(n, a) {
      var l = n.aoPreSearchCols;
      if (e === void 0)
        return l[a].search;
      n.oFeatures.bFilter && (typeof t == "object" ? Z.extend(l[a], t, {
        search: e
      }) : Z.extend(l[a], {
        search: e,
        regex: t === null ? !1 : t,
        smart: r === null ? !0 : r,
        caseInsensitive: o === null ? !0 : o
      }), tu(n, n.oPreviousSearch));
    });
  }
);
ct(
  [
    "columns().search.fixed()",
    "column().search.fixed()"
  ],
  function(e, t) {
    var r = this.iterator(!0, "column", function(o, n) {
      var a = o.aoColumns[n].searchFixed;
      if (e) {
        if (t === void 0)
          return a[e] || null;
        t === null ? delete a[e] : a[e] = t;
      } else return Object.keys(a);
      return this;
    });
    return e !== void 0 && t === void 0 ? r[0] : r;
  }
);
ct("state()", function(e, t) {
  if (!e)
    return this.context.length ? this.context[0].oSavedState : null;
  var r = Z.extend(!0, {}, e);
  return this.iterator("table", function(o) {
    t !== !1 && (r.time = +/* @__PURE__ */ new Date() + 100), fp(o, r, function() {
    });
  });
});
ct("state.clear()", function() {
  return this.iterator("table", function(e) {
    e.fnStateSaveCallback.call(e.oInstance, e, {});
  });
});
ct("state.loaded()", function() {
  return this.context.length ? this.context[0].oLoadedState : null;
});
ct("state.save()", function() {
  return this.iterator("table", function(e) {
    Dm(e);
  });
});
var Bx, Ix;
me.use = function(e, t) {
  var r = typeof e == "string" ? t : e, o = typeof t == "string" ? t : e;
  if (r === void 0 && typeof o == "string")
    switch (o) {
      case "lib":
      case "jq":
        return Z;
      case "win":
        return window;
      case "datetime":
        return me.DateTime;
      case "luxon":
        return Ml;
      case "moment":
        return Si;
      case "bootstrap":
        return Bx || window.bootstrap;
      case "foundation":
        return Ix || window.Foundation;
      default:
        return null;
    }
  o === "lib" || o === "jq" || r && r.fn && r.fn.jquery ? Z = r : o === "win" || r && r.document ? (window = r, document = r.document) : o === "datetime" || r && r.type === "DateTime" ? me.DateTime = r : o === "luxon" || r && r.FixedOffsetZone ? Ml = r : o === "moment" || r && r.isMoment ? Si = r : o === "bootstrap" || r && r.Modal && r.Modal.NAME === "modal" ? Bx = r : (o === "foundation" || r && r.Reveal) && (Ix = r);
};
me.factory = function(e, t) {
  var r = !1;
  return e && e.document && (window = e, document = e.document), t && t.fn && t.fn.jquery && (Z = t, r = !0), r;
};
me.versionCheck = function(e, t) {
  for (var r = t ? t.split(".") : me.version.split("."), o = e.split("."), n, a, l = 0, i = o.length; l < i; l++)
    if (n = parseInt(r[l], 10) || 0, a = parseInt(o[l], 10) || 0, n !== a)
      return n > a;
  return !0;
};
me.isDataTable = function(e) {
  var t = Z(e).get(0), r = !1;
  return e instanceof me.Api ? !0 : (Z.each(me.settings, function(o, n) {
    var a = n.nScrollHead ? Z("table", n.nScrollHead)[0] : null, l = n.nScrollFoot ? Z("table", n.nScrollFoot)[0] : null;
    (n.nTable === t || a === t || l === t) && (r = !0);
  }), r);
};
me.tables = function(e) {
  var t = !1;
  Z.isPlainObject(e) && (t = e.api, e = e.visible);
  var r = me.settings.filter(function(o) {
    return !!(!e || e && Z(o.nTable).is(":visible"));
  }).map(function(o) {
    return o.nTable;
  });
  return t ? new kt(r) : r;
};
me.camelToHungarian = bl;
ct("$()", function(e, t) {
  var r = this.rows(t).nodes(), o = Z(r);
  return Z([].concat(
    o.filter(e).toArray(),
    o.find(e).toArray()
  ));
});
Z.each(["on", "one", "off"], function(e, t) {
  ct(t + "()", function() {
    var r = Array.prototype.slice.call(arguments);
    r[0] = r[0].split(/\s/).map(function(n) {
      return n.match(/\.dt\b/) ? n : n + ".dt";
    }).join(" ");
    var o = Z(this.tables().nodes());
    return o[t].apply(o, r), this;
  });
});
ct("clear()", function() {
  return this.iterator("table", function(e) {
    lh(e);
  });
});
ct("error()", function(e) {
  return this.iterator("table", function(t) {
    $n(t, 0, e);
  });
});
ct("settings()", function() {
  return new kt(this.context, this.context);
});
ct("init()", function() {
  var e = this.context;
  return e.length ? e[0].oInit : null;
});
ct("data()", function() {
  return this.iterator("table", function(e) {
    return Eo(e.aoData, "_aData");
  }).flatten();
});
ct("trigger()", function(e, t, r) {
  return this.iterator("table", function(o) {
    return jt(o, null, e, t, r);
  }).flatten();
});
ct("ready()", function(e) {
  var t = this.context;
  return e ? this.tables().every(function() {
    var r = this;
    this.context[0]._bInitComplete ? e.call(r) : this.on("init.dt.DT", function() {
      e.call(r);
    });
  }) : t.length ? t[0]._bInitComplete || !1 : null;
});
ct("destroy()", function(e) {
  return e = e || !1, this.iterator("table", function(t) {
    var r = t.oClasses, o = t.nTable, n = t.nTBody, a = t.nTHead, l = t.nTFoot, i = Z(o), s = Z(n), u = Z(t.nTableWrapper), c = t.aoData.map(function(S) {
      return S ? S.nTr : null;
    }), g = r.order;
    t.bDestroying = !0, jt(t, "aoDestroyCallback", "destroy", [t], !0), e || new kt(t).columns().visible(!0), t.resizeObserver && t.resizeObserver.disconnect(), u.off(".DT").find(":not(tbody *)").off(".DT"), Z(window).off(".DT-" + t.sInstance), o != a.parentNode && (i.children("thead").detach(), i.append(a)), l && o != l.parentNode && (i.children("tfoot").detach(), i.append(l)), Rx(a, "header"), Rx(l, "footer"), t.colgroup.remove(), t.aaSorting = [], t.aaSortingFixed = [], gp(t), Z(i).find("th, td").removeClass(
      Z.map(me.ext.type.className, function(S) {
        return S;
      }).join(" ")
    ), Z("th, td", a).removeClass(
      g.none + " " + g.canAsc + " " + g.canDesc + " " + g.isAsc + " " + g.isDesc
    ).css("width", "").removeAttr("aria-sort"), s.children().detach(), s.append(c);
    var p = t.nTableWrapper.parentNode, h = t.nTableWrapper.nextSibling, v = e ? "remove" : "detach";
    i[v](), u[v](), !e && p && (p.insertBefore(o, h), i.css("width", t.sDestroyWidth).removeClass(r.table));
    var A = me.settings.indexOf(t);
    A !== -1 && me.settings.splice(A, 1);
  });
});
Z.each(["column", "row", "cell"], function(e, t) {
  ct(t + "s().every()", function(r) {
    var o = this.selector.opts, n = this, a, l = 0;
    return this.iterator("every", function(i, s, u) {
      a = n[t](s, o), t === "cell" ? r.call(a, a[0][0].row, a[0][0].column, u, l) : r.call(a, s, u, l), l++;
    });
  });
});
ct("i18n()", function(e, t, r) {
  var o = this.context[0], n = Ks(e)(o.oLanguage);
  return n === void 0 && (n = t), Z.isPlainObject(n) && (n = r !== void 0 && n[r] !== void 0 ? n[r] : r === !1 ? n : n._), typeof n == "string" ? n.replace("%d", r) : n;
});
function Rx(e, t) {
  Z(e).find(".dt-column-order").remove(), Z(e).find(".dt-column-title").each(function() {
    var r = Z(this).html();
    Z(this).parent().parent().append(r), Z(this).remove();
  }), Z(e).find("div.dt-column-" + t).remove(), Z("th, td", e).removeAttr("data-dt-column");
}
me.version = "2.3.8";
me.settings = [];
me.models = {};
me.models.oSearch = {
  /**
   * Flag to whether or not the filtering should be case-insensitive
   */
  caseInsensitive: !0,
  /**
   * Applied search term
   */
  search: "",
  /**
   * Flag to indicate if the search term should be interpreted as a
   * regular expression (true) or not (false) and therefore and special
   * regex characters escaped.
   */
  regex: !1,
  /**
   * Flag to indicate if DataTables is to use its smart filtering or not.
   */
  smart: !0,
  /**
   * Flag to indicate if DataTables should only trigger a search when
   * the return key is pressed.
   */
  return: !1
};
me.models.oRow = {
  /**
   * TR element for the row
   */
  nTr: null,
  /**
   * Array of TD elements for each row. This is null until the row has been
   * created.
   */
  anCells: null,
  /**
   * Data object from the original data source for the row. This is either
   * an array if using the traditional form of DataTables, or an object if
   * using mData options. The exact type will depend on the passed in
   * data from the data source, or will be an array if using DOM a data
   * source.
   */
  _aData: [],
  /**
   * Sorting data cache - this array is ostensibly the same length as the
   * number of columns (although each index is generated only as it is
   * needed), and holds the data that is used for sorting each column in the
   * row. We do this cache generation at the start of the sort in order that
   * the formatting of the sort data need be done only once for each cell
   * per sort. This array should not be read from or written to by anything
   * other than the master sorting methods.
   */
  _aSortData: null,
  /**
   * Per cell filtering data cache. As per the sort data cache, used to
   * increase the performance of the filtering in DataTables
   */
  _aFilterData: null,
  /**
   * Filtering data cache. This is the same as the cell filtering cache, but
   * in this case a string rather than an array. This is easily computed with
   * a join on `_aFilterData`, but is provided as a cache so the join isn't
   * needed on every search (memory traded for performance)
   */
  _sFilterRow: null,
  /**
   * Denote if the original data source was from the DOM, or the data source
   * object. This is used for invalidating data, so DataTables can
   * automatically read data from the original source, unless uninstructed
   * otherwise.
   */
  src: null,
  /**
   * Index in the aoData array. This saves an indexOf lookup when we have the
   * object, but want to know the index
   */
  idx: -1,
  /**
   * Cached display value
   */
  displayData: null
};
me.models.oColumn = {
  /**
   * Column index.
   */
  idx: null,
  /**
   * A list of the columns that sorting should occur on when this column
   * is sorted. That this property is an array allows multi-column sorting
   * to be defined for a column (for example first name / last name columns
   * would benefit from this). The values are integers pointing to the
   * columns to be sorted on (typically it will be a single integer pointing
   * at itself, but that doesn't need to be the case).
   */
  aDataSort: null,
  /**
   * Define the sorting directions that are applied to the column, in sequence
   * as the column is repeatedly sorted upon - i.e. the first value is used
   * as the sorting direction when the column if first sorted (clicked on).
   * Sort it again (click again) and it will move on to the next index.
   * Repeat until loop.
   */
  asSorting: null,
  /**
   * Flag to indicate if the column is searchable, and thus should be included
   * in the filtering or not.
   */
  bSearchable: null,
  /**
   * Flag to indicate if the column is sortable or not.
   */
  bSortable: null,
  /**
   * Flag to indicate if the column is currently visible in the table or not
   */
  bVisible: null,
  /**
   * Store for manual type assignment using the `column.type` option. This
   * is held in store so we can manipulate the column's `sType` property.
   */
  _sManualType: null,
  /**
   * Flag to indicate if HTML5 data attributes should be used as the data
   * source for filtering or sorting. True is either are.
   */
  _bAttrSrc: !1,
  /**
   * Developer definable function that is called whenever a cell is created (Ajax source,
   * etc) or processed for input (DOM source). This can be used as a compliment to mRender
   * allowing you to modify the DOM element (add background colour for example) when the
   * element is available.
   */
  fnCreatedCell: null,
  /**
   * Function to get data from a cell in a column. You should <b>never</b>
   * access data directly through _aData internally in DataTables - always use
   * the method attached to this property. It allows mData to function as
   * required. This function is automatically assigned by the column
   * initialisation method
   */
  fnGetData: null,
  /**
   * Function to set data for a cell in the column. You should <b>never</b>
   * set the data directly to _aData internally in DataTables - always use
   * this method. It allows mData to function as required. This function
   * is automatically assigned by the column initialisation method
   */
  fnSetData: null,
  /**
   * Property to read the value for the cells in the column from the data
   * source array / object. If null, then the default content is used, if a
   * function is given then the return from the function is used.
   */
  mData: null,
  /**
   * Partner property to mData which is used (only when defined) to get
   * the data - i.e. it is basically the same as mData, but without the
   * 'set' option, and also the data fed to it is the result from mData.
   * This is the rendering method to match the data method of mData.
   */
  mRender: null,
  /**
   * The class to apply to all TD elements in the table's TBODY for the column
   */
  sClass: null,
  /**
   * When DataTables calculates the column widths to assign to each column,
   * it finds the longest string in each column and then constructs a
   * temporary table and reads the widths from that. The problem with this
   * is that "mmm" is much wider then "iiii", but the latter is a longer
   * string - thus the calculation can go wrong (doing it properly and putting
   * it into an DOM object and measuring that is horribly(!) slow). Thus as
   * a "work around" we provide this option. It will append its value to the
   * text that is found to be the longest string for the column - i.e. padding.
   */
  sContentPadding: null,
  /**
   * Allows a default value to be given for a column's data, and will be used
   * whenever a null data source is encountered (this can be because mData
   * is set to null, or because the data source itself is null).
   */
  sDefaultContent: null,
  /**
   * Name for the column, allowing reference to the column by name as well as
   * by index (needs a lookup to work by name).
   */
  sName: null,
  /**
   * Custom sorting data type - defines which of the available plug-ins in
   * afnSortData the custom sorting will use - if any is defined.
   */
  sSortDataType: "std",
  /**
   * Class to be applied to the header element when sorting on this column
   */
  sSortingClass: null,
  /**
   * Title of the column - what is seen in the TH element (nTh).
   */
  sTitle: null,
  /**
   * Column sorting and filtering type
   */
  sType: null,
  /**
   * Width of the column
   */
  sWidth: null,
  /**
   * Width of the column when it was first "encountered"
   */
  sWidthOrig: null,
  /** Cached longest strings from a column */
  wideStrings: null,
  /**
   * Store for named searches
   */
  searchFixed: null
};
me.defaults = {
  /**
   * An array of data to use for the table, passed in at initialisation which
   * will be used in preference to any data which is already in the DOM. This is
   * particularly useful for constructing tables purely in JavaScript, for
   * example with a custom Ajax call.
   */
  aaData: null,
  /**
   * If ordering is enabled, then DataTables will perform a first pass sort on
   * initialisation. You can define which column(s) the sort is performed
   * upon, and the sorting direction, with this variable. The `sorting` array
   * should contain an array for each column to be sorted initially containing
   * the column's index and a direction string ('asc' or 'desc').
   */
  aaSorting: [[0, "asc"]],
  /**
   * This parameter is basically identical to the `sorting` parameter, but
   * cannot be overridden by user interaction with the table. What this means
   * is that you could have a column (visible or hidden) which the sorting
   * will always be forced on first - any sorting after that (from the user)
   * will then be performed as required. This can be useful for grouping rows
   * together.
   */
  aaSortingFixed: [],
  /**
   * DataTables can be instructed to load data to display in the table from a
   * Ajax source. This option defines how that Ajax call is made and where to.
   *
   * The `ajax` property has three different modes of operation, depending on
   * how it is defined. These are:
   *
   * * `string` - Set the URL from where the data should be loaded from.
   * * `object` - Define properties for `jQuery.ajax`.
   * * `function` - Custom data get function
   *
   * `string`
   * --------
   *
   * As a string, the `ajax` property simply defines the URL from which
   * DataTables will load data.
   *
   * `object`
   * --------
   *
   * As an object, the parameters in the object are passed to
   * [jQuery.ajax](https://api.jquery.com/jQuery.ajax/) allowing fine control
   * of the Ajax request. DataTables has a number of default parameters which
   * you can override using this option. Please refer to the jQuery
   * documentation for a full description of the options available, although
   * the following parameters provide additional options in DataTables or
   * require special consideration:
   *
   * * `data` - As with jQuery, `data` can be provided as an object, but it
   *   can also be used as a function to manipulate the data DataTables sends
   *   to the server. The function takes a single parameter, an object of
   *   parameters with the values that DataTables has readied for sending. An
   *   object may be returned which will be merged into the DataTables
   *   defaults, or you can add the items to the object that was passed in and
   *   not return anything from the function. This supersedes `fnServerParams`
   *   from DataTables 1.9-.
   *
   * * `dataSrc` - By default DataTables will look for the property `data` (or
   *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
   *   from an Ajax source or for server-side processing - this parameter
   *   allows that property to be changed. You can use JavaScript dotted
   *   object notation to get a data source for multiple levels of nesting, or
   *   it my be used as a function. As a function it takes a single parameter,
   *   the JSON returned from the server, which can be manipulated as
   *   required, with the returned value being that used by DataTables as the
   *   data source for the table.
   *
   * * `success` - Should not be overridden it is used internally in
   *   DataTables. To manipulate / transform the data returned by the server
   *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
   *
   * `function`
   * ----------
   *
   * As a function, making the Ajax call is left up to yourself allowing
   * complete control of the Ajax request. Indeed, if desired, a method other
   * than Ajax could be used to obtain the required data, such as Web storage
   * or an AIR database.
   *
   * The function is given four parameters and no return is required. The
   * parameters are:
   *
   * 1. _object_ - Data to send to the server
   * 2. _function_ - Callback function that must be executed when the required
   *    data has been obtained. That data should be passed into the callback
   *    as the only parameter
   * 3. _object_ - DataTables settings object for the table
   */
  ajax: null,
  /**
   * This parameter allows you to readily specify the entries in the length drop
   * down menu that DataTables shows when pagination is enabled. It can be
   * either a 1D array of options which will be used for both the displayed
   * option and the value, or a 2D array which will use the array in the first
   * position as the value, and the array in the second position as the
   * displayed options (useful for language strings such as 'All').
   *
   * Note that the `pageLength` property will be automatically set to the
   * first value given in this array, unless `pageLength` is also provided.
   */
  aLengthMenu: [10, 25, 50, 100],
  /**
   * The `columns` option in the initialisation parameter allows you to define
   * details about the way individual columns behave. For a full list of
   * column options that can be set, please see
   * {@link DataTable.defaults.column}. Note that if you use `columns` to
   * define your columns, you must have an entry in the array for every single
   * column that you have in your table (these can be null if you don't which
   * to specify any options).
   */
  aoColumns: null,
  /**
   * Very similar to `columns`, `columnDefs` allows you to target a specific
   * column, multiple columns, or all columns, using the `targets` property of
   * each object in the array. This allows great flexibility when creating
   * tables, as the `columnDefs` arrays can be of any length, targeting the
   * columns you specifically want. `columnDefs` may use any of the column
   * options available: {@link DataTable.defaults.column}, but it _must_
   * have `targets` defined in each object in the array. Values in the `targets`
   * array may be:
   *   <ul>
   *     <li>a string - class name will be matched on the TH for the column</li>
   *     <li>0 or a positive integer - column index counting from the left</li>
   *     <li>a negative integer - column index counting from the right</li>
   *     <li>the string "_all" - all columns (i.e. assign a default)</li>
   *   </ul>
   */
  aoColumnDefs: null,
  /**
   * Basically the same as `search`, this parameter defines the individual column
   * filtering state at initialisation time. The array must be of the same size
   * as the number of columns, and each element be an object with the parameters
   * `search` and `escapeRegex` (the latter is optional). 'null' is also
   * accepted and the default will be used.
   */
  aoSearchCols: [],
  /**
   * Enable or disable automatic column width calculation. This can be disabled
   * as an optimisation (it takes some time to calculate the widths) if the
   * tables widths are passed in using `columns`.
   */
  bAutoWidth: !0,
  /**
   * Deferred rendering can provide DataTables with a huge speed boost when you
   * are using an Ajax or JS data source for the table. This option, when set to
   * true, will cause DataTables to defer the creation of the table elements for
   * each row until they are needed for a draw - saving a significant amount of
   * time.
   */
  bDeferRender: !0,
  /**
   * Replace a DataTable which matches the given selector and replace it with
   * one which has the properties of the new initialisation object passed. If no
   * table matches the selector, then the new DataTable will be constructed as
   * per normal.
   */
  bDestroy: !1,
  /**
   * Enable or disable filtering of data. Filtering in DataTables is "smart" in
   * that it allows the end user to input multiple words (space separated) and
   * will match a row containing those words, even if not in the order that was
   * specified (this allow matching across multiple columns). Note that if you
   * wish to use filtering in DataTables this must remain 'true' - to remove the
   * default filtering input box and retain filtering abilities, please use
   * {@link DataTable.defaults.dom}.
   */
  bFilter: !0,
  /**
   * Used only for compatibility with DT1
   * @deprecated
   */
  bInfo: !0,
  /**
   * Used only for compatibility with DT1
   * @deprecated
   */
  bLengthChange: !0,
  /**
   * Enable or disable pagination.
   */
  bPaginate: !0,
  /**
   * Enable or disable the display of a 'processing' indicator when the table is
   * being processed (e.g. a sort). This is particularly useful for tables with
   * large amounts of data where it can take a noticeable amount of time to sort
   * the entries.
   */
  bProcessing: !1,
  /**
   * Retrieve the DataTables object for the given selector. Note that if the
   * table has already been initialised, this parameter will cause DataTables
   * to simply return the object that has already been set up - it will not take
   * account of any changes you might have made to the initialisation object
   * passed to DataTables (setting this parameter to true is an acknowledgement
   * that you understand this). `destroy` can be used to reinitialise a table if
   * you need.
   */
  bRetrieve: !1,
  /**
   * When vertical (y) scrolling is enabled, DataTables will force the height of
   * the table's viewport to the given height at all times (useful for layout).
   * However, this can look odd when filtering data down to a small data set,
   * and the footer is left "floating" further down. This parameter (when
   * enabled) will cause DataTables to collapse the table's viewport down when
   * the result set will fit within the given Y height.
   */
  bScrollCollapse: !1,
  /**
   * Configure DataTables to use server-side processing. Note that the
   * `ajax` parameter must also be given in order to give DataTables a
   * source to obtain the required data for each draw.
   */
  bServerSide: !1,
  /**
   * Enable or disable sorting of columns. Sorting of individual columns can be
   * disabled by the `sortable` option for each column.
   */
  bSort: !0,
  /**
   * Enable or display DataTables' ability to sort multiple columns at the
   * same time (activated by shift-click by the user).
   */
  bSortMulti: !0,
  /**
   * Allows control over whether DataTables should use the top (true) unique
   * cell that is found for a single column, or the bottom (false - default).
   * This is useful when using complex headers.
   */
  bSortCellsTop: null,
  /** Specify which row is the title row in the header. Replacement for bSortCellsTop */
  titleRow: null,
  /**
   * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
   * `sorting\_3` to the columns which are currently being sorted on. This is
   * presented as a feature switch as it can increase processing time (while
   * classes are removed and added) so for large data sets you might want to
   * turn this off.
   */
  bSortClasses: !0,
  /**
   * Enable or disable state saving. When enabled HTML5 `localStorage` will be
   * used to save table display information such as pagination information,
   * display length, filtering and sorting. As such when the end user reloads
   * the page the display will match what thy had previously set up.
   */
  bStateSave: !1,
  /**
   * This function is called when a TR element is created (and all TD child
   * elements have been inserted), or registered if using a DOM source, allowing
   * manipulation of the TR element (adding classes etc).
   */
  fnCreatedRow: null,
  /**
   * This function is called on every 'draw' event, and allows you to
   * dynamically modify any aspect you want about the created DOM.
   */
  fnDrawCallback: null,
  /**
   * Identical to fnHeaderCallback() but for the table footer this function
   * allows you to modify the table footer on every 'draw' event.
   */
  fnFooterCallback: null,
  /**
   * When rendering large numbers in the information element for the table
   * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
   * to have a comma separator for the 'thousands' units (e.g. 1 million is
   * rendered as "1,000,000") to help readability for the end user. This
   * function will override the default method DataTables uses.
   */
  fnFormatNumber: function(e) {
    return e.toString().replace(
      /\B(?=(\d{3})+(?!\d))/g,
      this.oLanguage.sThousands
    );
  },
  /**
   * This function is called on every 'draw' event, and allows you to
   * dynamically modify the header row. This can be used to calculate and
   * display useful information about the table.
   */
  fnHeaderCallback: null,
  /**
   * The information element can be used to convey information about the current
   * state of the table. Although the internationalisation options presented by
   * DataTables are quite capable of dealing with most customisations, there may
   * be times where you wish to customise the string further. This callback
   * allows you to do exactly that.
   */
  fnInfoCallback: null,
  /**
   * Called when the table has been initialised. Normally DataTables will
   * initialise sequentially and there will be no need for this function,
   * however, this does not hold true when using external language information
   * since that is obtained using an async XHR call.
   */
  fnInitComplete: null,
  /**
   * Called at the very start of each table draw and can be used to cancel the
   * draw by returning false, any other return (including undefined) results in
   * the full draw occurring).
   */
  fnPreDrawCallback: null,
  /**
   * This function allows you to 'post process' each row after it have been
   * generated for each table draw, but before it is rendered on screen. This
   * function might be used for setting the row class name etc.
   */
  fnRowCallback: null,
  /**
   * Load the table state. With this function you can define from where, and how, the
   * state of a table is loaded. By default DataTables will load from `localStorage`
   * but you might wish to use a server-side database or cookies.
   */
  fnStateLoadCallback: function(e) {
    try {
      return JSON.parse(
        (e.iStateDuration === -1 ? sessionStorage : localStorage).getItem(
          "DataTables_" + e.sInstance + "_" + location.pathname
        )
      );
    } catch {
      return {};
    }
  },
  /**
   * Callback which allows modification of the saved state prior to loading that state.
   * This callback is called when the table is loading state from the stored data, but
   * prior to the settings object being modified by the saved state. Note that for
   * plug-in authors, you should use the `stateLoadParams` event to load parameters for
   * a plug-in.
   */
  fnStateLoadParams: null,
  /**
   * Callback that is called when the state has been loaded from the state saving method
   * and the DataTables settings object has been modified as a result of the loaded state.
   */
  fnStateLoaded: null,
  /**
   * Save the table state. This function allows you to define where and how the state
   * information for the table is stored By default DataTables will use `localStorage`
   * but you might wish to use a server-side database or cookies.
   */
  fnStateSaveCallback: function(e, t) {
    try {
      (e.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
        "DataTables_" + e.sInstance + "_" + location.pathname,
        JSON.stringify(t)
      );
    } catch {
    }
  },
  /**
   * Callback which allows modification of the state to be saved. Called when the table
   * has changed state a new state save is required. This method allows modification of
   * the state saving object prior to actually doing the save, including addition or
   * other state properties or modification. Note that for plug-in authors, you should
   * use the `stateSaveParams` event to save parameters for a plug-in.
   */
  fnStateSaveParams: null,
  /**
   * Duration for which the saved state information is considered valid. After this period
   * has elapsed the state will be returned to the default.
   * Value is given in seconds.
   */
  iStateDuration: 7200,
  /**
   * Number of rows to display on a single page when using pagination. If
   * feature enabled (`lengthChange`) then the end user will be able to override
   * this to a custom setting using a pop-up menu.
   */
  iDisplayLength: 10,
  /**
   * Define the starting point for data display when using DataTables with
   * pagination. Note that this parameter is the number of records, rather than
   * the page number, so if you have 10 records per page and want to start on
   * the third page, it should be "20".
   */
  iDisplayStart: 0,
  /**
   * By default DataTables allows keyboard navigation of the table (sorting, paging,
   * and filtering) by adding a `tabindex` attribute to the required elements. This
   * allows you to tab through the controls and press the enter key to activate them.
   * The tabindex is default 0, meaning that the tab follows the flow of the document.
   * You can overrule this using this parameter if you wish. Use a value of -1 to
   * disable built-in keyboard navigation.
   */
  iTabIndex: 0,
  /**
   * Classes that DataTables assigns to the various components and features
   * that it adds to the HTML table. This allows classes to be configured
   * during initialisation in addition to through the static
   * {@link DataTable.ext.oStdClasses} object).
   */
  oClasses: {},
  /**
   * All strings that DataTables uses in the user interface that it creates
   * are defined in this object, allowing you to modified them individually or
   * completely replace them all as required.
   */
  oLanguage: {
    /**
     * Strings that are used for WAI-ARIA labels and controls only (these are not
     * actually visible on the page, but will be read by screenreaders, and thus
     * must be internationalised as well).
     */
    oAria: {
      /**
       * ARIA label that is added to the table headers when the column may be sorted
       */
      orderable: ": Activate to sort",
      /**
       * ARIA label that is added to the table headers when the column is currently being sorted
       */
      orderableReverse: ": Activate to invert sorting",
      /**
       * ARIA label that is added to the table headers when the column is currently being 
       * sorted and next step is to remove sorting
       */
      orderableRemove: ": Activate to remove sorting",
      paginate: {
        first: "First",
        last: "Last",
        next: "Next",
        previous: "Previous",
        number: ""
      }
    },
    /**
     * Pagination string used by DataTables for the built-in pagination
     * control types.
     */
    oPaginate: {
      /**
       * Label and character for first page button («)
       */
      sFirst: "«",
      /**
       * Last page button (»)
       */
      sLast: "»",
      /**
       * Next page button (›)
       */
      sNext: "›",
      /**
       * Previous page button (‹)
       */
      sPrevious: "‹"
    },
    /**
     * Plural object for the data type the table is showing
     */
    entries: {
      _: "entries",
      1: "entry"
    },
    /**
     * Page length options
     */
    lengthLabels: {
      "-1": "All"
    },
    /**
     * This string is shown in preference to `zeroRecords` when the table is
     * empty of data (regardless of filtering). Note that this is an optional
     * parameter - if it is not given, the value of `zeroRecords` will be used
     * instead (either the default or given value).
     */
    sEmptyTable: "No data available in table",
    /**
     * This string gives information to the end user about the information
     * that is current on display on the page. The following tokens can be
     * used in the string and will be dynamically replaced as the table
     * display updates. This tokens can be placed anywhere in the string, or
     * removed as needed by the language requires:
     *
     * * `\_START\_` - Display index of the first record on the current page
     * * `\_END\_` - Display index of the last record on the current page
     * * `\_TOTAL\_` - Number of records in the table after filtering
     * * `\_MAX\_` - Number of records in the table without filtering
     * * `\_PAGE\_` - Current page number
     * * `\_PAGES\_` - Total number of pages of data in the table
     */
    sInfo: "Showing _START_ to _END_ of _TOTAL_ _ENTRIES-TOTAL_",
    /**
     * Display information string for when the table is empty. Typically the
     * format of this string should match `info`.
     */
    sInfoEmpty: "Showing 0 to 0 of 0 _ENTRIES-TOTAL_",
    /**
     * When a user filters the information in a table, this string is appended
     * to the information (`info`) to give an idea of how strong the filtering
     * is. The variable _MAX_ is dynamically updated.
     */
    sInfoFiltered: "(filtered from _MAX_ total _ENTRIES-MAX_)",
    /**
     * If can be useful to append extra information to the info string at times,
     * and this variable does exactly that. This information will be appended to
     * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
     * being used) at all times.
     */
    sInfoPostFix: "",
    /**
     * This decimal place operator is a little different from the other
     * language options since DataTables doesn't output floating point
     * numbers, so it won't ever use this for display of a number. Rather,
     * what this parameter does is modify the sort methods of the table so
     * that numbers which are in a format which has a character other than
     * a period (`.`) as a decimal place will be sorted numerically.
     *
     * Note that numbers with different decimal places cannot be shown in
     * the same table and still be sortable, the table must be consistent.
     * However, multiple different tables on the page can use different
     * decimal place characters.
     */
    sDecimal: "",
    /**
     * DataTables has a build in number formatter (`formatNumber`) which is
     * used to format large numbers that are used in the table information.
     * By default a comma is used, but this can be trivially changed to any
     * character you wish with this parameter.
     */
    sThousands: ",",
    /**
     * Detail the action that will be taken when the drop down menu for the
     * pagination length option is changed. The '_MENU_' variable is replaced
     * with a default select list of 10, 25, 50 and 100, and can be replaced
     * with a custom select box if required.
     */
    sLengthMenu: "_MENU_ _ENTRIES_ per page",
    /**
     * When using Ajax sourced data and during the first draw when DataTables is
     * gathering the data, this message is shown in an empty row in the table to
     * indicate to the end user the data is being loaded. Note that this
     * parameter is not used when loading data by server-side processing, just
     * Ajax sourced data with client-side processing.
     */
    sLoadingRecords: "Loading...",
    /**
     * Text which is displayed when the table is processing a user action
     * (usually a sort command or similar).
     */
    sProcessing: "",
    /**
     * Details the actions that will be taken when the user types into the
     * filtering input text box. The variable "_INPUT_", if used in the string,
     * is replaced with the HTML text box for the filtering input allowing
     * control over where it appears in the string. If "_INPUT_" is not given
     * then the input box is appended to the string automatically.
     */
    sSearch: "Search:",
    /**
     * Assign a `placeholder` attribute to the search `input` element
     *  @type string
     *  @default 
     *
     *  @dtopt Language
     *  @name DataTable.defaults.language.searchPlaceholder
     */
    sSearchPlaceholder: "",
    /**
     * All of the language information can be stored in a file on the
     * server-side, which DataTables will look up if this parameter is passed.
     * It must store the URL of the language file, which is in a JSON format,
     * and the object has the same properties as the oLanguage object in the
     * initialiser object (i.e. the above parameters). Please refer to one of
     * the example language files to see how this works in action.
     */
    sUrl: "",
    /**
     * Text shown inside the table records when the is no information to be
     * displayed after filtering. `emptyTable` is shown when there is simply no
     * information in the table at all (regardless of filtering).
     */
    sZeroRecords: "No matching records found"
  },
  /** The initial data order is reversed when `desc` ordering */
  orderDescReverse: !0,
  /**
   * This parameter allows you to have define the global filtering state at
   * initialisation time. As an object the `search` parameter must be
   * defined, but all other parameters are optional. When `regex` is true,
   * the search string will be treated as a regular expression, when false
   * (default) it will be treated as a straight string. When `smart`
   * DataTables will use it's smart filtering methods (to word match at
   * any point in the data), when false this will not be done.
   */
  oSearch: Z.extend({}, me.models.oSearch),
  /**
   * Table and control layout. This replaces the legacy `dom` option.
   */
  layout: {
    topStart: "pageLength",
    topEnd: "search",
    bottomStart: "info",
    bottomEnd: "paging"
  },
  /**
   * Legacy DOM layout option
   */
  sDom: null,
  /**
   * Search delay option. This will throttle full table searches that use the
   * DataTables provided search input element (it does not effect calls to
   * `dt-api search()`, providing a delay before the search is made.
   */
  searchDelay: null,
  /**
   * DataTables features six different built-in options for the buttons to
   * display for pagination control:
   *
   * * `numbers` - Page number buttons only
   * * `simple` - 'Previous' and 'Next' buttons only
   * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
   * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
   * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
   * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
   */
  sPaginationType: "",
  /**
   * Enable horizontal scrolling. When a table is too wide to fit into a
   * certain layout, or you have a large number of columns in the table, you
   * can enable x-scrolling to show the table in a viewport, which can be
   * scrolled. This property can be `true` which will allow the table to
   * scroll horizontally when needed, or any CSS unit, or a number (in which
   * case it will be treated as a pixel measurement). Setting as simply `true`
   * is recommended.
   */
  sScrollX: "",
  /**
   * This property can be used to force a DataTable to use more width than it
   * might otherwise do when x-scrolling is enabled. For example if you have a
   * table which requires to be well spaced, this parameter is useful for
   * "over-sizing" the table, and thus forcing scrolling. This property can by
   * any CSS unit, or a number (in which case it will be treated as a pixel
   * measurement).
   */
  sScrollXInner: "",
  /**
   * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
   * to the given height, and enable scrolling for any data which overflows the
   * current viewport. This can be used as an alternative to paging to display
   * a lot of data in a small area (although paging and scrolling can both be
   * enabled at the same time). This property can be any CSS unit, or a number
   * (in which case it will be treated as a pixel measurement).
   */
  sScrollY: "",
  /**
   * __Deprecated__ The functionality provided by this parameter has now been
   * superseded by that provided through `ajax`, which should be used instead.
   *
   * Set the HTTP method that is used to make the Ajax call for server-side
   * processing or Ajax sourced data.
   */
  sServerMethod: "GET",
  /**
   * DataTables makes use of renderers when displaying HTML elements for
   * a table. These renderers can be added or modified by plug-ins to
   * generate suitable mark-up for a site. For example the Bootstrap
   * integration plug-in for DataTables uses a paging button renderer to
   * display pagination buttons in the mark-up required by Bootstrap.
   *
   * For further information about the renderers available see
   * DataTable.ext.renderer
   */
  renderer: null,
  /**
   * Set the data property name that DataTables should use to get a row's id
   * to set as the `id` property in the node.
   */
  rowId: "DT_RowId",
  /**
   * Caption value
   */
  caption: null,
  /**
   * For server-side processing - use the data from the DOM for the first draw
   */
  iDeferLoading: null,
  /** Event listeners */
  on: null,
  /** Title wrapper element type */
  columnTitleTag: "span"
};
$m(me.defaults);
me.defaults.column = {
  /**
   * Define which column(s) an order will occur on for this column. This
   * allows a column's ordering to take multiple columns into account when
   * doing a sort or use the data from a different column. For example first
   * name / last name columns make sense to do a multi-column sort over the
   * two columns.
   */
  aDataSort: null,
  iDataSort: -1,
  ariaTitle: "",
  /**
   * You can control the default ordering direction, and even alter the
   * behaviour of the sort handler (i.e. only allow ascending ordering etc)
   * using this parameter.
   */
  asSorting: ["asc", "desc", ""],
  /**
   * Enable or disable filtering on the data in this column.
   */
  bSearchable: !0,
  /**
   * Enable or disable ordering on this column.
   */
  bSortable: !0,
  /**
   * Enable or disable the display of this column.
   */
  bVisible: !0,
  /**
   * Developer definable function that is called whenever a cell is created (Ajax source,
   * etc) or processed for input (DOM source). This can be used as a compliment to mRender
   * allowing you to modify the DOM element (add background colour for example) when the
   * element is available.
   */
  fnCreatedCell: null,
  /**
   * This property can be used to read data from any data source property,
   * including deeply nested objects / properties. `data` can be given in a
   * number of different ways which effect its behaviour:
   *
   * * `integer` - treated as an array index for the data source. This is the
   *   default that DataTables uses (incrementally increased for each column).
   * * `string` - read an object property from the data source. There are
   *   three 'special' options that can be used in the string to alter how
   *   DataTables reads the data from the source object:
   *    * `.` - Dotted JavaScript notation. Just as you use a `.` in
   *      JavaScript to read from nested objects, so to can the options
   *      specified in `data`. For example: `browser.version` or
   *      `browser.name`. If your object parameter name contains a period, use
   *      `\\` to escape it - i.e. `first\\.name`.
   *    * `[]` - Array notation. DataTables can automatically combine data
   *      from and array source, joining the data with the characters provided
   *      between the two brackets. For example: `name[, ]` would provide a
   *      comma-space separated list from the source array. If no characters
   *      are provided between the brackets, the original array source is
   *      returned.
   *    * `()` - Function notation. Adding `()` to the end of a parameter will
   *      execute a function of the name given. For example: `browser()` for a
   *      simple function on the data source, `browser.version()` for a
   *      function in a nested property or even `browser().version` to get an
   *      object property if the function called returns an object. Note that
   *      function notation is recommended for use in `render` rather than
   *      `data` as it is much simpler to use as a renderer.
   * * `null` - use the original data source for the row rather than plucking
   *   data directly from it. This action has effects on two other
   *   initialisation options:
   *    * `defaultContent` - When null is given as the `data` option and
   *      `defaultContent` is specified for the column, the value defined by
   *      `defaultContent` will be used for the cell.
   *    * `render` - When null is used for the `data` option and the `render`
   *      option is specified for the column, the whole data source for the
   *      row is used for the renderer.
   * * `function` - the function given will be executed whenever DataTables
   *   needs to set or get the data for a cell in the column. The function
   *   takes three parameters:
   *    * Parameters:
   *      * `{array|object}` The data source for the row
   *      * `{string}` The type call data requested - this will be 'set' when
   *        setting data or 'filter', 'display', 'type', 'sort' or undefined
   *        when gathering data. Note that when `undefined` is given for the
   *        type DataTables expects to get the raw data for the object back<
   *      * `{*}` Data to set when the second parameter is 'set'.
   *    * Return:
   *      * The return value from the function is not required when 'set' is
   *        the type of call, but otherwise the return is what will be used
   *        for the data requested.
   *
   * Note that `data` is a getter and setter option. If you just require
   * formatting of data for output, you will likely want to use `render` which
   * is simply a getter and thus simpler to use.
   *
   * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
   * name change reflects the flexibility of this property and is consistent
   * with the naming of mRender. If 'mDataProp' is given, then it will still
   * be used by DataTables, as it automatically maps the old name to the new
   * if required.
   */
  mData: null,
  /**
   * This property is the rendering partner to `data` and it is suggested that
   * when you want to manipulate data for display (including filtering,
   * sorting etc) without altering the underlying data for the table, use this
   * property. `render` can be considered to be the read only companion to
   * `data` which is read / write (then as such more complex). Like `data`
   * this option can be given in a number of different ways to effect its
   * behaviour:
   *
   * * `integer` - treated as an array index for the data source. This is the
   *   default that DataTables uses (incrementally increased for each column).
   * * `string` - read an object property from the data source. There are
   *   three 'special' options that can be used in the string to alter how
   *   DataTables reads the data from the source object:
   *    * `.` - Dotted JavaScript notation. Just as you use a `.` in
   *      JavaScript to read from nested objects, so to can the options
   *      specified in `data`. For example: `browser.version` or
   *      `browser.name`. If your object parameter name contains a period, use
   *      `\\` to escape it - i.e. `first\\.name`.
   *    * `[]` - Array notation. DataTables can automatically combine data
   *      from and array source, joining the data with the characters provided
   *      between the two brackets. For example: `name[, ]` would provide a
   *      comma-space separated list from the source array. If no characters
   *      are provided between the brackets, the original array source is
   *      returned.
   *    * `()` - Function notation. Adding `()` to the end of a parameter will
   *      execute a function of the name given. For example: `browser()` for a
   *      simple function on the data source, `browser.version()` for a
   *      function in a nested property or even `browser().version` to get an
   *      object property if the function called returns an object.
   * * `object` - use different data for the different data types requested by
   *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
   *   of the object is the data type the property refers to and the value can
   *   defined using an integer, string or function using the same rules as
   *   `render` normally does. Note that an `_` option _must_ be specified.
   *   This is the default value to use if you haven't specified a value for
   *   the data type requested by DataTables.
   * * `function` - the function given will be executed whenever DataTables
   *   needs to set or get the data for a cell in the column. The function
   *   takes three parameters:
   *    * Parameters:
   *      * {array|object} The data source for the row (based on `data`)
   *      * {string} The type call data requested - this will be 'filter',
   *        'display', 'type' or 'sort'.
   *      * {array|object} The full data source for the row (not based on
   *        `data`)
   *    * Return:
   *      * The return value from the function is what will be used for the
   *        data requested.
   */
  mRender: null,
  /**
   * Change the cell type created for the column - either TD cells or TH cells. This
   * can be useful as TH cells have semantic meaning in the table body, allowing them
   * to act as a header for a row (you may wish to add scope='row' to the TH elements).
   */
  sCellType: "td",
  /**
   * Class to give to each cell in this column.
   */
  sClass: "",
  /**
   * When DataTables calculates the column widths to assign to each column,
   * it finds the longest string in each column and then constructs a
   * temporary table and reads the widths from that. The problem with this
   * is that "mmm" is much wider then "iiii", but the latter is a longer
   * string - thus the calculation can go wrong (doing it properly and putting
   * it into an DOM object and measuring that is horribly(!) slow). Thus as
   * a "work around" we provide this option. It will append its value to the
   * text that is found to be the longest string for the column - i.e. padding.
   * Generally you shouldn't need this!
   */
  sContentPadding: "",
  /**
   * Allows a default value to be given for a column's data, and will be used
   * whenever a null data source is encountered (this can be because `data`
   * is set to null, or because the data source itself is null).
   */
  sDefaultContent: null,
  /**
   * This parameter is only used in DataTables' server-side processing. It can
   * be exceptionally useful to know what columns are being displayed on the
   * client side, and to map these to database fields. When defined, the names
   * also allow DataTables to reorder information from the server if it comes
   * back in an unexpected order (i.e. if you switch your columns around on the
   * client-side, your server-side code does not also need updating).
   */
  sName: "",
  /**
   * Defines a data source type for the ordering which can be used to read
   * real-time information from the table (updating the internally cached
   * version) prior to ordering. This allows ordering to occur on user
   * editable elements such as form inputs.
   */
  sSortDataType: "std",
  /**
   * The title of this column.
   */
  sTitle: null,
  /**
   * The type allows you to specify how the data for this column will be
   * ordered. Four types (string, numeric, date and html (which will strip
   * HTML tags before ordering)) are currently available. Note that only date
   * formats understood by JavaScript's Date() object will be accepted as type
   * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
   * 'numeric', 'date' or 'html' (by default). Further types can be adding
   * through plug-ins.
   */
  sType: null,
  /**
   * Defining the width of the column, this parameter may take any CSS value
   * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
   * been given a specific width through this interface ensuring that the table
   * remains readable.
   */
  sWidth: null
};
$m(me.defaults.column);
me.models.oSettings = {
  /**
   * Primary features of DataTables and their enablement state.
   */
  oFeatures: {
    /**
     * Flag to say if DataTables should automatically try to calculate the
     * optimum table and columns widths (true) or not (false).
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bAutoWidth: null,
    /**
     * Delay the creation of TR and TD elements until they are actually
     * needed by a driven page draw. This can give a significant speed
     * increase for Ajax source and JavaScript source data, but makes no
     * difference at all for DOM and server-side processing tables.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bDeferRender: null,
    /**
     * Enable filtering on the table or not. Note that if this is disabled
     * then there is no filtering at all on the table, including fnFilter.
     * To just remove the filtering input use sDom and remove the 'f' option.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bFilter: null,
    /**
     * Used only for compatibility with DT1
     * @deprecated
     */
    bInfo: !0,
    /**
     * Used only for compatibility with DT1
     * @deprecated
     */
    bLengthChange: !0,
    /**
     * Pagination enabled or not. Note that if this is disabled then length
     * changing must also be disabled.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bPaginate: null,
    /**
     * Processing indicator enable flag whenever DataTables is enacting a
     * user request - typically an Ajax request for server-side processing.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bProcessing: null,
    /**
     * Server-side processing enabled flag - when enabled DataTables will
     * get all data from the server for every draw - there is no filtering,
     * sorting or paging done on the client-side.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bServerSide: null,
    /**
     * Sorting enablement flag.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bSort: null,
    /**
     * Multi-column sorting
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bSortMulti: null,
    /**
     * Apply a class to the columns which are being sorted to provide a
     * visual highlight or not. This can slow things down when enabled since
     * there is a lot of DOM interaction.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bSortClasses: null,
    /**
     * State saving enablement flag.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bStateSave: null
  },
  /**
   * Scrolling settings for a table.
   */
  oScroll: {
    /**
     * When the table is shorter in height than sScrollY, collapse the
     * table container down to the height of the table (when true).
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    bCollapse: null,
    /**
     * Width of the scrollbar for the web-browser's platform. Calculated
     * during table initialisation.
     */
    iBarWidth: 0,
    /**
     * Viewport width for horizontal scrolling. Horizontal scrolling is
     * disabled if an empty string.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    sX: null,
    /**
     * Width to expand the table to when using x-scrolling. Typically you
     * should not need to use this.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @deprecated
     */
    sXInner: null,
    /**
     * Viewport height for vertical scrolling. Vertical scrolling is disabled
     * if an empty string.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     */
    sY: null
  },
  /**
   * Language information for the table.
   */
  oLanguage: {
    /**
     * Information callback function. See
     * {@link DataTable.defaults.fnInfoCallback}
     */
    fnInfoCallback: null
  },
  /**
   * Browser support parameters
   */
  oBrowser: {
    /**
     * Determine if the vertical scrollbar is on the right or left of the
     * scrolling container - needed for rtl language layout, although not
     * all browsers move the scrollbar (Safari).
     */
    bScrollbarLeft: !1,
    /**
     * Browser scrollbar width
     */
    barWidth: 0
  },
  ajax: null,
  /**
   * Array referencing the nodes which are used for the features. The
   * parameters of this object match what is allowed by sDom - i.e.
   *   <ul>
   *     <li>'l' - Length changing</li>
   *     <li>'f' - Filtering input</li>
   *     <li>'t' - The table!</li>
   *     <li>'i' - Information</li>
   *     <li>'p' - Pagination</li>
   *     <li>'r' - pRocessing</li>
   *   </ul>
   */
  aanFeatures: [],
  /**
   * Store data information - see {@link DataTable.models.oRow} for detailed
   * information.
   */
  aoData: [],
  /**
   * Array of indexes which are in the current display (after filtering etc)
   */
  aiDisplay: [],
  /**
   * Array of indexes for display - no filtering
   */
  aiDisplayMaster: [],
  /**
   * Map of row ids to data indexes
   */
  aIds: {},
  /**
   * Store information about each column that is in use
   */
  aoColumns: [],
  /**
   * Store information about the table's header
   */
  aoHeader: [],
  /**
   * Store information about the table's footer
   */
  aoFooter: [],
  /**
   * Store the applied global search information in case we want to force a
   * research or compare the old search to a new one.
   * Note that this parameter will be set by the initialisation routine. To
   * set a default use {@link DataTable.defaults}.
   */
  oPreviousSearch: {},
  /**
   * Store for named searches
   */
  searchFixed: {},
  /**
   * Store the applied search for each column - see
   * {@link DataTable.models.oSearch} for the format that is used for the
   * filtering information for each column.
   */
  aoPreSearchCols: [],
  /**
   * Sorting that is applied to the table. Note that the inner arrays are
   * used in the following manner:
   * <ul>
   *   <li>Index 0 - column number</li>
   *   <li>Index 1 - current sorting direction</li>
   * </ul>
   * Note that this parameter will be set by the initialisation routine. To
   * set a default use {@link DataTable.defaults}.
   */
  aaSorting: null,
  /**
   * Sorting that is always applied to the table (i.e. prefixed in front of
   * aaSorting).
   * Note that this parameter will be set by the initialisation routine. To
   * set a default use {@link DataTable.defaults}.
   */
  aaSortingFixed: [],
  /**
   * If restoring a table - we should restore its width
   */
  sDestroyWidth: 0,
  /**
   * Callback functions array for every time a row is inserted (i.e. on a draw).
   */
  aoRowCallback: [],
  /**
   * Callback functions for the header on each draw.
   */
  aoHeaderCallback: [],
  /**
   * Callback function for the footer on each draw.
   */
  aoFooterCallback: [],
  /**
   * Array of callback functions for draw callback functions
   */
  aoDrawCallback: [],
  /**
   * Array of callback functions for row created function
   */
  aoRowCreatedCallback: [],
  /**
   * Callback functions for just before the table is redrawn. A return of
   * false will be used to cancel the draw.
   */
  aoPreDrawCallback: [],
  /**
   * Callback functions for when the table has been initialised.
   */
  aoInitComplete: [],
  /**
   * Callbacks for modifying the settings to be stored for state saving, prior to
   * saving state.
   */
  aoStateSaveParams: [],
  /**
   * Callbacks for modifying the settings that have been stored for state saving
   * prior to using the stored values to restore the state.
   */
  aoStateLoadParams: [],
  /**
   * Callbacks for operating on the settings object once the saved state has been
   * loaded
   */
  aoStateLoaded: [],
  /**
   * Cache the table ID for quick access
   */
  sTableId: "",
  /**
   * The TABLE node for the main table
   */
  nTable: null,
  /**
   * Permanent ref to the thead element
   */
  nTHead: null,
  /**
   * Permanent ref to the tfoot element - if it exists
   */
  nTFoot: null,
  /**
   * Permanent ref to the tbody element
   */
  nTBody: null,
  /**
   * Cache the wrapper node (contains all DataTables controlled elements)
   */
  nTableWrapper: null,
  /**
   * Indicate if all required information has been read in
   */
  bInitialised: !1,
  /**
   * Information about open rows. Each object in the array has the parameters
   * 'nTr' and 'nParent'
   */
  aoOpenRows: [],
  /**
   * Dictate the positioning of DataTables' control elements - see
   * {@link DataTable.model.oInit.sDom}.
   * Note that this parameter will be set by the initialisation routine. To
   * set a default use {@link DataTable.defaults}.
   */
  sDom: null,
  /**
   * Search delay (in mS)
   */
  searchDelay: null,
  /**
   * Which type of pagination should be used.
   * Note that this parameter will be set by the initialisation routine. To
   * set a default use {@link DataTable.defaults}.
   */
  sPaginationType: "two_button",
  /**
   * Number of paging controls on the page. Only used for backwards compatibility
   */
  pagingControls: 0,
  /**
   * The state duration (for `stateSave`) in seconds.
   * Note that this parameter will be set by the initialisation routine. To
   * set a default use {@link DataTable.defaults}.
   */
  iStateDuration: 0,
  /**
   * Array of callback functions for state saving. Each array element is an
   * object with the following parameters:
   *   <ul>
   *     <li>function:fn - function to call. Takes two parameters, oSettings
   *       and the JSON string to save that has been thus far created. Returns
   *       a JSON string to be inserted into a json object
   *       (i.e. '"param": [ 0, 1, 2]')</li>
   *     <li>string:sName - name of callback</li>
   *   </ul>
   */
  aoStateSave: [],
  /**
   * Array of callback functions for state loading. Each array element is an
   * object with the following parameters:
   *   <ul>
   *     <li>function:fn - function to call. Takes two parameters, oSettings
   *       and the object stored. May return false to cancel state loading</li>
   *     <li>string:sName - name of callback</li>
   *   </ul>
   */
  aoStateLoad: [],
  /**
   * State that was saved. Useful for back reference
   */
  oSavedState: null,
  /**
   * State that was loaded. Useful for back reference
   */
  oLoadedState: null,
  /**
   * Note if draw should be blocked while getting data
   */
  bAjaxDataGet: !0,
  /**
   * The last jQuery XHR object that was used for server-side data gathering.
   * This can be used for working with the XHR information in one of the
   * callbacks
   */
  jqXHR: null,
  /**
   * JSON returned from the server in the last Ajax request
   */
  json: void 0,
  /**
   * Data submitted as part of the last Ajax request
   */
  oAjaxData: void 0,
  /**
   * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
   * required).
   * Note that this parameter will be set by the initialisation routine. To
   * set a default use {@link DataTable.defaults}.
   */
  sServerMethod: null,
  /**
   * Format numbers for display.
   * Note that this parameter will be set by the initialisation routine. To
   * set a default use {@link DataTable.defaults}.
   */
  fnFormatNumber: null,
  /**
   * List of options that can be used for the user selectable length menu.
   * Note that this parameter will be set by the initialisation routine. To
   * set a default use {@link DataTable.defaults}.
   */
  aLengthMenu: null,
  /**
   * Counter for the draws that the table does. Also used as a tracker for
   * server-side processing
   */
  iDraw: 0,
  /**
   * Indicate if a redraw is being done - useful for Ajax
   */
  bDrawing: !1,
  /**
   * Draw index (iDraw) of the last error when parsing the returned data
   */
  iDrawError: -1,
  /**
   * Paging display length
   */
  _iDisplayLength: 10,
  /**
   * Paging start point - aiDisplay index
   */
  _iDisplayStart: 0,
  /**
   * Server-side processing - number of records in the result set
   * (i.e. before filtering), Use fnRecordsTotal rather than
   * this property to get the value of the number of records, regardless of
   * the server-side processing setting.
   */
  _iRecordsTotal: 0,
  /**
   * Server-side processing - number of records in the current display set
   * (i.e. after filtering). Use fnRecordsDisplay rather than
   * this property to get the value of the number of records, regardless of
   * the server-side processing setting.
   */
  _iRecordsDisplay: 0,
  /**
   * The classes to use for the table
   */
  oClasses: {},
  /**
   * Flag attached to the settings object so you can check in the draw
   * callback if filtering has been done in the draw. Deprecated in favour of
   * events.
   *  @deprecated
   */
  bFiltered: !1,
  /**
   * Flag attached to the settings object so you can check in the draw
   * callback if sorting has been done in the draw. Deprecated in favour of
   * events.
   *  @deprecated
   */
  bSorted: !1,
  /**
   * Indicate that if multiple rows are in the header and there is more than
   * one unique cell per column. Replaced by titleRow
   */
  bSortCellsTop: null,
  /**
   * Initialisation object that is used for the table
   */
  oInit: null,
  /**
   * Destroy callback functions - for plug-ins to attach themselves to the
   * destroy so they can clean up markup and events.
   */
  aoDestroyCallback: [],
  /**
   * Get the number of records in the current record set, before filtering
   */
  fnRecordsTotal: function() {
    return gn(this) == "ssp" ? this._iRecordsTotal * 1 : this.aiDisplayMaster.length;
  },
  /**
   * Get the number of records in the current record set, after filtering
   */
  fnRecordsDisplay: function() {
    return gn(this) == "ssp" ? this._iRecordsDisplay * 1 : this.aiDisplay.length;
  },
  /**
   * Get the display end point - aiDisplay index
   */
  fnDisplayEnd: function() {
    var e = this._iDisplayLength, t = this._iDisplayStart, r = t + e, o = this.aiDisplay.length, n = this.oFeatures, a = n.bPaginate;
    return n.bServerSide ? a === !1 || e === -1 ? t + o : Math.min(t + e, this._iRecordsDisplay) : !a || r > o || e === -1 ? o : r;
  },
  /**
   * The DataTables object for this table
   */
  oInstance: null,
  /**
   * Unique identifier for each instance of the DataTables object. If there
   * is an ID on the table node, then it takes that value, otherwise an
   * incrementing internal counter is used.
   */
  sInstance: null,
  /**
   * tabindex attribute value that is added to DataTables control elements, allowing
   * keyboard navigation of the table and its controls.
   */
  iTabIndex: 0,
  /**
   * DIV container for the footer scrolling table if scrolling
   */
  nScrollHead: null,
  /**
   * DIV container for the footer scrolling table if scrolling
   */
  nScrollFoot: null,
  /**
   * Last applied sort
   */
  aLastSort: [],
  /**
   * Stored plug-in instances
   */
  oPlugins: {},
  /**
   * Function used to get a row's id from the row's data
   */
  rowIdFn: null,
  /**
   * Data location where to store a row's id
   */
  rowId: null,
  caption: "",
  captionNode: null,
  colgroup: null,
  /** Delay loading of data */
  deferLoading: null,
  /** Allow auto type detection */
  typeDetect: !0,
  /** ResizeObserver for the container div */
  resizeObserver: null,
  /** Keep a record of the last size of the container, so we can skip duplicates */
  containerWidth: -1,
  /** Reverse the initial order of the data set on desc ordering */
  orderDescReverse: null,
  /** Show / hide ordering indicators in headers */
  orderIndicators: !0,
  /** Default ordering listener */
  orderHandler: !0,
  /** Title row indicator */
  titleRow: null,
  /** Title wrapper element type */
  columnTitleTag: "span"
};
var aR = me.ext.pager;
Z.extend(aR, {
  simple: function() {
    return ["previous", "next"];
  },
  full: function() {
    return ["first", "previous", "next", "last"];
  },
  numbers: function() {
    return ["numbers"];
  },
  simple_numbers: function() {
    return ["previous", "numbers", "next"];
  },
  full_numbers: function() {
    return ["first", "previous", "numbers", "next", "last"];
  },
  first_last: function() {
    return ["first", "last"];
  },
  first_last_numbers: function() {
    return ["first", "numbers", "last"];
  },
  // For testing and plug-ins to use
  _numbers: P_,
  // Number of number buttons - legacy, use `numbers` option for paging feature
  numbers_length: 7
});
Z.extend(!0, me.ext.renderer, {
  pagingButton: {
    _: function(e, t, r, o, n) {
      var a = e.oClasses.paging, l = [a.button], i;
      return o && l.push(a.active), n && l.push(a.disabled), t === "ellipsis" ? i = Z('<span class="ellipsis"></span>').html(r)[0] : i = Z("<button>", {
        class: l.join(" "),
        role: "link",
        type: "button"
      }).html(r), {
        display: i,
        clicker: i
      };
    }
  },
  pagingContainer: {
    _: function(e, t) {
      return t;
    }
  }
});
var ud = function(e, t) {
  return function(r) {
    return sn(r) || typeof r != "string" || (r = r.replace(v4, " "), e && (r = Qa(r)), r = Yc(r, !1)), r;
  };
};
function Fx(e, t, r, o, n) {
  return Si ? e[t](n) : Ml ? e[r](n) : o ? e[o](n) : e;
}
var Vx = !1, Ml, Si, lR = /[T\s]\d{2}.*?(Z|[+-]\d{2}(?::?\d{2})?)$/;
function iR() {
  window.luxon && !Ml && (Ml = window.luxon), window.moment && !Si && (Si = window.moment);
}
function zc(e, t, r) {
  var o;
  if (iR(), Si) {
    if (o = Si(e, t, r, !0), !o.isValid())
      return null;
  } else if (Ml) {
    if (o = t && typeof e == "string" ? Ml.DateTime.fromFormat(e, t) : Ml.DateTime.fromISO(e), !o.isValid)
      return null;
    o = o.setLocale(r);
  } else t ? (Vx || alert("DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17"), Vx = !0) : o = new Date(e);
  return o;
}
function Yg(e) {
  return function(t, r, o, n) {
    arguments.length === 0 ? (o = "en", r = null, t = null) : arguments.length === 1 ? (o = "en", r = t, t = null) : arguments.length === 2 && (o = r, r = t, t = null);
    var a = "datetime" + (r ? "-" + r : "");
    return me.ext.type.order[a + "-pre"] || me.type(a, {
      detect: function(l) {
        return l === a ? a : !1;
      },
      order: {
        pre: function(l) {
          return l.valueOf();
        }
      },
      className: "dt-right"
    }), function(l, i) {
      if (l == null)
        if (n === "--now") {
          var s = /* @__PURE__ */ new Date();
          l = new Date(Date.UTC(
            s.getFullYear(),
            s.getMonth(),
            s.getDate(),
            s.getHours(),
            s.getMinutes(),
            s.getSeconds()
          ));
        } else
          l = "";
      if (i === "type")
        return a;
      if (l === "")
        return i !== "sort" ? "" : zc("0000-01-01 00:00:00", null, o);
      if (r !== null && t === r && i !== "sort" && i !== "type" && !(l instanceof Date))
        return l;
      let u = {}, c = typeof l == "string" ? l.match(lR) : null;
      c && (u.timeZone = c[1] === "Z" ? "UTC" : c[1]);
      var g = zc(l, t, o);
      if (g === null)
        return l;
      if (i === "sort")
        return g;
      var p = r === null ? Fx(g, "toDate", "toJSDate", "")[e](
        navigator.language,
        u
      ) : Fx(g, "format", "toFormat", "toISOString", r);
      return i === "display" ? si(p) : p;
    };
  };
}
var __ = ",", T_ = ".";
if (window.Intl !== void 0)
  try {
    for (var Ld = new Intl.NumberFormat().formatToParts(100000.1), lo = 0; lo < Ld.length; lo++)
      Ld[lo].type === "group" ? __ = Ld[lo].value : Ld[lo].type === "decimal" && (T_ = Ld[lo].value);
  } catch {
  }
me.datetime = function(e, t) {
  var r = "datetime-" + e;
  t || (t = "en"), me.ext.type.order[r] || me.type(r, {
    detect: function(o) {
      var n = zc(o, e, t);
      return o === "" || n ? r : !1;
    },
    order: {
      pre: function(o) {
        return zc(o, e, t) || 0;
      }
    },
    className: "dt-right"
  });
};
me.render = {
  date: Yg("toLocaleDateString"),
  datetime: Yg("toLocaleString"),
  time: Yg("toLocaleTimeString"),
  number: function(e, t, r, o, n) {
    return e == null && (e = __), t == null && (t = T_), {
      display: function(a) {
        if (typeof a != "number" && typeof a != "string" || a === "" || a === null)
          return a;
        var l = a < 0 ? "-" : "", i = parseFloat(a), s = Math.abs(i);
        if (s >= 1e11 || s < 1e-4 && s !== 0) {
          var u = i.toExponential(r).split(/e\+?/);
          return u[0] + " x 10<sup>" + u[1] + "</sup>";
        }
        if (isNaN(i))
          return si(a);
        i = i.toFixed(r), a = Math.abs(i);
        var c = parseInt(a, 10), g = r ? t + (a - c).toFixed(r).substring(2) : "";
        return c === 0 && parseFloat(g) === 0 && (l = ""), l + (o || "") + c.toString().replace(
          /\B(?=(\d{3})+(?!\d))/g,
          e
        ) + g + (n || "");
      }
    };
  },
  text: function() {
    return {
      display: si,
      filter: si
    };
  }
};
var Bo = me.ext.type;
me.type = function(e, t, r) {
  if (!t)
    return {
      className: Bo.className[e],
      detect: Bo.detect.find(function(l) {
        return l._name === e;
      }),
      order: {
        pre: Bo.order[e + "-pre"],
        asc: Bo.order[e + "-asc"],
        desc: Bo.order[e + "-desc"]
      },
      render: Bo.render[e],
      search: Bo.search[e]
    };
  var o = function(l, i) {
    Bo[l][e] = i;
  }, n = function(l) {
    Object.defineProperty(l, "_name", { value: e });
    var i = Bo.detect.findIndex(function(s) {
      return s._name === e;
    });
    i === -1 ? Bo.detect.unshift(l) : Bo.detect.splice(i, 1, l);
  }, a = function(l) {
    Bo.order[e + "-pre"] = l.pre, Bo.order[e + "-asc"] = l.asc, Bo.order[e + "-desc"] = l.desc;
  };
  r === void 0 && (r = t, t = null), t === "className" ? o("className", r) : t === "detect" ? n(r) : t === "order" ? a(r) : t === "render" ? o("render", r) : t === "search" ? o("search", r) : t || (r.className && o("className", r.className), r.detect !== void 0 && n(r.detect), r.order && a(r.order), r.render !== void 0 && o("render", r.render), r.search !== void 0 && o("search", r.search));
};
me.types = function() {
  return Bo.detect.map(function(e) {
    return e._name;
  });
};
var pp = function(e, t) {
  return e = e != null ? e.toString().toLowerCase() : "", t = t != null ? t.toString().toLowerCase() : "", e.localeCompare(t, navigator.languages[0] || navigator.language, {
    numeric: !0,
    ignorePunctuation: !0
  });
}, Hx = function(e, t) {
  return e = Qa(e), t = Qa(t), pp(e, t);
};
me.type("string", {
  detect: function() {
    return "string";
  },
  order: {
    pre: function(e) {
      return sn(e) && typeof e != "boolean" ? "" : typeof e == "string" ? e.toLowerCase() : e.toString ? e.toString() : "";
    }
  },
  search: ud(!1)
});
me.type("string-utf8", {
  detect: {
    allOf: function(e) {
      return !0;
    },
    oneOf: function(e) {
      return !sn(e) && navigator.languages && typeof e == "string" && e.match(/[^\x00-\x7F]/);
    }
  },
  order: {
    asc: pp,
    desc: function(e, t) {
      return pp(e, t) * -1;
    }
  },
  search: ud(!1)
});
me.type("html", {
  detect: {
    allOf: function(e) {
      return sn(e) || typeof e == "string" && e.indexOf("<") !== -1;
    },
    oneOf: function(e) {
      return !sn(e) && typeof e == "string" && e.indexOf("<") !== -1;
    }
  },
  order: {
    pre: function(e) {
      return sn(e) ? "" : e.replace ? Qa(e).trim().toLowerCase() : e + "";
    }
  },
  search: ud(!0)
});
me.type("html-utf8", {
  detect: {
    allOf: function(e) {
      return sn(e) || typeof e == "string" && e.indexOf("<") !== -1;
    },
    oneOf: function(e) {
      return navigator.languages && !sn(e) && typeof e == "string" && e.indexOf("<") !== -1 && typeof e == "string" && e.match(/[^\x00-\x7F]/);
    }
  },
  order: {
    asc: Hx,
    desc: function(e, t) {
      return Hx(e, t) * -1;
    }
  },
  search: ud(!0)
});
me.type("date", {
  className: "dt-type-date",
  detect: {
    allOf: function(e) {
      if (e && !(e instanceof Date) && !Ax.test(e))
        return null;
      var t = Date.parse(e);
      return t !== null && !isNaN(t) || sn(e);
    },
    oneOf: function(e) {
      return e instanceof Date || typeof e == "string" && Ax.test(e);
    }
  },
  order: {
    pre: function(e) {
      var t = Date.parse(e);
      return isNaN(t) ? -1 / 0 : t;
    }
  }
});
me.type("html-num-fmt", {
  className: "dt-type-numeric",
  detect: {
    allOf: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Wc(e, r, !0, !1);
    },
    oneOf: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Wc(e, r, !0, !1);
    }
  },
  order: {
    pre: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Im(e, r, eh, th);
    }
  },
  search: ud(!0)
});
me.type("html-num", {
  className: "dt-type-numeric",
  detect: {
    allOf: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Wc(e, r, !1, !0);
    },
    oneOf: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Wc(e, r, !1, !1);
    }
  },
  order: {
    pre: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Im(e, r, eh);
    }
  },
  search: ud(!0)
});
me.type("num-fmt", {
  className: "dt-type-numeric",
  detect: {
    allOf: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Jd(e, r, !0, !0);
    },
    oneOf: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Jd(e, r, !0, !1);
    }
  },
  order: {
    pre: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Im(e, r, th);
    }
  }
});
me.type("num", {
  className: "dt-type-numeric",
  detect: {
    allOf: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Jd(e, r, !1, !0);
    },
    oneOf: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Jd(e, r, !1, !1);
    }
  },
  order: {
    pre: function(e, t) {
      var r = t.oLanguage.sDecimal;
      return Im(e, r);
    }
  }
});
var Im = function(e, t, r, o) {
  if (e !== 0 && (!e || e === "-"))
    return -1 / 0;
  var n = typeof e;
  return n === "number" || n === "bigint" ? e : (t && (e = qw(e, t)), e.replace && (r && (e = e.replace(r, "")), o && (e = e.replace(o, ""))), e * 1);
};
Z.extend(!0, me.ext.renderer, {
  footer: {
    _: function(e, t, r) {
      t.addClass(r.tfoot.cell);
    }
  },
  header: {
    _: function(e, t, r) {
      t.addClass(r.thead.cell), e.oFeatures.bSort || t.addClass(r.order.none);
      var o = e.titleRow, n = t.closest("thead").find("tr"), a = t.parent().index();
      // Cells and rows which have the attribute to disable the icons
      t.attr("data-dt-order") === "disable" || t.parent().attr("data-dt-order") === "disable" || // titleRow support, for defining a specific row in the header
      o === !0 && a !== 0 || o === !1 && a !== n.length - 1 || typeof o == "number" && a !== o || Z(e.nTable).on("order.dt.DT column-visibility.dt.DT", function(l, i, s) {
        if (e === i) {
          var u = i.sortDetails;
          if (u) {
            var c = Eo(u, "col");
            if (!(l.type === "column-visibility" && !c.includes(s))) {
              var g, p = r.order, h = i.api.columns(t), v = e.aoColumns[h.flatten()[0]], A = h.orderable().includes(!0), S = "", b = h.indexes(), T = h.orderable(!0).flatten(), w = e.iTabIndex, N = i.orderHandler && A;
              t.removeClass(
                p.isAsc + " " + p.isDesc
              ).toggleClass(p.none, !A).toggleClass(p.canAsc, N && T.includes("asc")).toggleClass(p.canDesc, N && T.includes("desc"));
              var O = !0;
              for (g = 0; g < b.length; g++)
                c.includes(b[g]) || (O = !1);
              if (O) {
                var m = h.order();
                t.addClass(
                  m.includes("asc") ? p.isAsc : "" + m.includes("desc") ? p.isDesc : ""
                );
              }
              var _ = -1;
              for (g = 0; g < c.length; g++)
                if (e.aoColumns[c[g]].bVisible) {
                  _ = c[g];
                  break;
                }
              if (b[0] == _) {
                var X = u[0], $ = v.asSorting;
                t.attr("aria-sort", X.dir === "asc" ? "ascending" : "descending"), S = $[X.index + 1] ? "Reverse" : "Remove";
              } else
                t.removeAttr("aria-sort");
              if (A) {
                var E = t.find(".dt-column-order");
                E.attr("role", "button").attr(
                  "aria-label",
                  A ? v.ariaTitle + i.api.i18n("oAria.orderable" + S) : v.ariaTitle
                ), w !== -1 && E.attr("tabindex", w);
              }
            }
          }
        }
      });
    }
  },
  layout: {
    _: function(e, t, r) {
      var o = e.oClasses.layout, n = Z("<div/>").attr("id", r.id || null).addClass(r.className || o.row).appendTo(t);
      me.ext.renderer.layout._forLayoutRow(r, function(a, l) {
        if (!(a === "id" || a === "className")) {
          var i = "";
          l.table && (n.addClass(o.tableRow), i += o.tableCell + " "), a === "start" ? i += o.start : a === "end" ? i += o.end : i += o.full, Z("<div/>").attr({
            id: l.id || null,
            class: l.className ? l.className : o.cell + " " + i
          }).append(l.contents).appendTo(n);
        }
      });
    },
    // Shared for use by the styling frameworks
    _forLayoutRow: function(e, t) {
      var r = function(o) {
        switch (o) {
          case "":
            return 0;
          case "start":
            return 1;
          case "end":
            return 2;
          default:
            return 3;
        }
      };
      Object.keys(e).sort(function(o, n) {
        return r(o) - r(n);
      }).forEach(function(o) {
        t(o, e[o]);
      });
    }
  }
});
me.feature = {};
me.feature.register = function(e, t, r) {
  me.ext.features[e] = t, r && go.feature.push({
    cFeature: r,
    fnInit: t
  });
};
function tc(e, t, r) {
  r && (e[t] = r);
}
me.feature.register("div", function(e, t) {
  var r = Z("<div>")[0];
  return t && (tc(r, "className", t.className), tc(r, "id", t.id), tc(r, "innerHTML", t.html), tc(r, "textContent", t.text)), r;
});
me.feature.register("info", function(e, t) {
  if (!e.oFeatures.bInfo)
    return null;
  var r = e.oLanguage, o = e.sTableId, n = Z("<div/>", {
    class: e.oClasses.info.container
  });
  return t = Z.extend({
    callback: r.fnInfoCallback,
    empty: r.sInfoEmpty,
    postfix: r.sInfoPostFix,
    search: r.sInfoFiltered,
    text: r.sInfo
  }, t), e.aoDrawCallback.push(function(a) {
    sR(a, t, n);
  }), e._infoEl || (n.attr({
    "aria-live": "polite",
    id: o + "_info",
    role: "status"
  }), Z(e.nTable).attr("aria-describedby", o + "_info"), e._infoEl = n), n;
}, "i");
function sR(e, t, r) {
  var o = e._iDisplayStart + 1, n = e.fnDisplayEnd(), a = e.fnRecordsTotal(), l = e.fnRecordsDisplay(), i = l ? t.text : t.empty;
  l !== a && (i += " " + t.search), i += t.postfix, i = mh(e, i), t.callback && (i = t.callback.call(
    e.oInstance,
    e,
    o,
    n,
    a,
    l,
    i
  )), r.html(i), jt(e, null, "info", [e, r[0], i]);
}
var Kg = 0;
me.feature.register("search", function(e, t) {
  if (!e.oFeatures.bFilter)
    return null;
  var r = e.oClasses.search, o = e.sTableId, n = e.oLanguage, a = e.oPreviousSearch, l = '<input type="search" class="' + r.input + '"/>';
  t = Z.extend({
    placeholder: n.sSearchPlaceholder,
    processing: !1,
    text: n.sSearch
  }, t), t.text.indexOf("_INPUT_") === -1 && (t.text += "_INPUT_"), t.text = mh(e, t.text);
  var i = t.text.match(/_INPUT_$/), s = t.text.match(/^_INPUT_/), u = t.text.replace(/_INPUT_/, ""), c = "<label>" + t.text + "</label>";
  s ? c = "_INPUT_<label>" + u + "</label>" : i && (c = "<label>" + u + "</label>_INPUT_");
  var g = Z("<div>").addClass(r.container).append(c.replace(/_INPUT_/, l));
  g.find("label").attr("for", "dt-search-" + Kg), g.find("input").attr("id", "dt-search-" + Kg), Kg++;
  var p = function(A) {
    var S = this.value;
    a.return && A.key !== "Enter" || S != a.search && u_(e, t.processing, function() {
      a.search = S, tu(e, a), e._iDisplayStart = 0, dd(e);
    });
  }, h = e.searchDelay !== null ? e.searchDelay : 0, v = Z("input", g).val(a.search).attr("placeholder", t.placeholder).on(
    "keyup.DT search.DT input.DT paste.DT cut.DT",
    h ? me.util.debounce(p, h) : p
  ).on("mouseup.DT", function(A) {
    setTimeout(function() {
      p.call(v[0], A);
    }, 10);
  }).on("keypress.DT", function(A) {
    if (A.keyCode == 13)
      return !1;
  }).attr("aria-controls", o);
  return Z(e.nTable).on("search.dt.DT", function(A, S) {
    e === S && v[0] !== document.activeElement && v.val(
      typeof a.search != "function" ? a.search : ""
    );
  }), g;
}, "f");
me.feature.register("paging", function(e, t) {
  if (!e.oFeatures.bPaginate)
    return null;
  t = Z.extend({
    buttons: me.ext.pager.numbers_length,
    type: e.sPaginationType,
    boundaryNumbers: !0,
    firstLast: !0,
    previousNext: !0,
    numbers: !0
  }, t);
  var r = Z("<div/>").addClass(e.oClasses.paging.container + (t.type ? " paging_" + t.type : "")).append(
    Z("<nav>").attr("aria-label", "pagination").addClass(e.oClasses.paging.nav)
  ), o = function() {
    A_(e, r.children(), t);
  };
  return e.aoDrawCallback.push(o), Z(e.nTable).on("column-sizing.dt.DT", o), r;
}, "p");
function dR(e) {
  var t = [];
  return e.numbers && t.push("numbers"), e.previousNext && (t.unshift("previous"), t.push("next")), e.firstLast && (t.unshift("first"), t.push("last")), t;
}
function A_(e, t, r) {
  if (e._bInitComplete) {
    var o = r.type ? me.ext.pager[r.type] : dR, n = e.oLanguage.oAria.paginate || {}, a = e._iDisplayStart, l = e._iDisplayLength, i = e.fnRecordsDisplay(), s = l === -1, u = s ? 0 : Math.ceil(a / l), c = s ? 1 : Math.ceil(i / l), g = [], p = [], h = o(r).map(function(m) {
      return m === "numbers" ? P_(u, c, r.buttons, r.boundaryNumbers) : m;
    });
    g = g.concat.apply(g, h);
    for (var v = 0; v < g.length; v++) {
      var A = g[v], S = uR(e, A, u, c), b = Zc(e, "pagingButton")(
        e,
        A,
        S.display,
        S.active,
        S.disabled
      ), T = typeof A == "string" ? n[A] : n.number ? n.number + (A + 1) : null;
      Z(b.clicker).attr({
        "aria-controls": e.sTableId,
        "aria-disabled": S.disabled ? "true" : null,
        "aria-current": S.active ? "page" : null,
        "aria-label": T,
        "data-dt-idx": A,
        tabIndex: S.disabled ? -1 : e.iTabIndex && b.clicker[0].nodeName.toLowerCase() !== "span" ? e.iTabIndex : null
        // `0` doesn't need a tabIndex since it is the default
      }), typeof A != "number" && Z(b.clicker).addClass(A), h_(
        b.clicker,
        { action: A },
        function(m) {
          m.preventDefault(), dh(e, m.data.action, !0);
        }
      ), p.push(b.display);
    }
    var w = Zc(e, "pagingContainer")(
      e,
      p
    ), N = t.find(document.activeElement).data("dt-idx");
    if (t.empty().append(w), N !== void 0 && t.find("[data-dt-idx=" + N + "]").trigger("focus"), p.length) {
      var O = Z(p[0]).outerHeight();
      r.buttons > 1 && // prevent infinite
      O > 0 && // will be 0 if hidden
      Z(t).height() >= O * 2 - 10 && A_(e, t, Z.extend({}, r, { buttons: r.buttons - 2 }));
    }
  }
}
function uR(e, t, r, o) {
  var n = e.oLanguage.oPaginate, a = {
    display: "",
    active: !1,
    disabled: !1
  };
  switch (t) {
    case "ellipsis":
      a.display = "&#x2026;";
      break;
    case "first":
      a.display = n.sFirst, r === 0 && (a.disabled = !0);
      break;
    case "previous":
      a.display = n.sPrevious, r === 0 && (a.disabled = !0);
      break;
    case "next":
      a.display = n.sNext, (o === 0 || r === o - 1) && (a.disabled = !0);
      break;
    case "last":
      a.display = n.sLast, (o === 0 || r === o - 1) && (a.disabled = !0);
      break;
    default:
      typeof t == "number" && (a.display = e.fnFormatNumber(t + 1), r === t && (a.active = !0));
      break;
  }
  return a;
}
function P_(e, t, r, o) {
  var n = [], a = Math.floor(r / 2), l = o ? 2 : 1, i = o ? 1 : 0;
  return t <= r ? n = ml(0, t) : r === 1 ? n = [e] : r === 3 ? e <= 1 ? n = [0, 1, "ellipsis"] : e >= t - 2 ? (n = ml(t - 2, t), n.unshift("ellipsis")) : n = ["ellipsis", e, "ellipsis"] : e <= a ? (n = ml(0, r - l), n.push("ellipsis"), o && n.push(t - 1)) : e >= t - 1 - a ? (n = ml(t - (r - l), t), n.unshift("ellipsis"), o && n.unshift(0)) : (n = ml(e - a + l, e + a - i), n.push("ellipsis"), n.unshift("ellipsis"), o && (n.push(t - 1), n.unshift(0))), n;
}
var Qg = 0;
me.feature.register("pageLength", function(e, t) {
  var r = e.oFeatures;
  if (!r.bPaginate || !r.bLengthChange)
    return null;
  t = Z.extend({
    menu: e.aLengthMenu,
    text: e.oLanguage.sLengthMenu
  }, t);
  var o = e.oClasses.length, n = e.sTableId, a = t.menu, l = [], i = [], s;
  if (Array.isArray(a[0]))
    l = a[0], i = a[1];
  else
    for (s = 0; s < a.length; s++)
      Z.isPlainObject(a[s]) ? (l.push(a[s].value), i.push(a[s].label)) : (l.push(a[s]), i.push(a[s]));
  var u = t.text.match(/_MENU_$/), c = t.text.match(/^_MENU_/), g = t.text.replace(/_MENU_/, ""), p = "<label>" + t.text + "</label>";
  c ? p = "_MENU_<label>" + g + "</label>" : u && (p = "<label>" + g + "</label>_MENU_");
  var h = "tmp-" + +/* @__PURE__ */ new Date(), v = Z("<div/>").addClass(o.container).append(
    p.replace("_MENU_", '<span id="' + h + '"></span>')
  ), A = [];
  Array.prototype.slice.call(v.find("label")[0].childNodes).forEach(function(w) {
    w.nodeType === Node.TEXT_NODE && A.push({
      el: w,
      text: w.textContent
    });
  });
  var S = function(w) {
    A.forEach(function(N) {
      N.el.textContent = mh(e, N.text, w);
    });
  }, b = Z("<select/>", {
    "aria-controls": n,
    class: o.select
  });
  for (s = 0; s < l.length; s++) {
    var T = e.api.i18n("lengthLabels." + l[s], null);
    T === null && (T = typeof i[s] == "number" ? e.fnFormatNumber(i[s]) : i[s]), b[0][s] = new Option(T, l[s]);
  }
  return v.find("label").attr("for", "dt-length-" + Qg), b.attr("id", "dt-length-" + Qg), Qg++, v.find("#" + h).replaceWith(b), Z("select", v).val(e._iDisplayLength).on("change.DT", function() {
    d_(e, Z(this).val()), dd(e);
  }), Z(e.nTable).on("length.dt.DT", function(w, N, O) {
    e === N && (Z("select", v).val(O), S(O));
  }), S(e._iDisplayLength), v;
}, "l");
Z.fn.dataTable = me;
me.$ = Z;
Z.fn.dataTableSettings = me.settings;
Z.fn.dataTableExt = me.ext;
Z.fn.DataTable = function(e) {
  return Z(this).dataTable(e).api();
};
Z.each(me, function(e, t) {
  Z.fn.DataTable[e] = t;
});
let ru = Su;
ru.extend(!0, me.defaults, {
  renderer: "bootstrap"
});
ru.extend(!0, me.ext.classes, {
  container: "dt-container dt-bootstrap5",
  search: {
    input: "form-control form-control-sm"
  },
  length: {
    select: "form-select form-select-sm"
  },
  processing: {
    container: "dt-processing card"
  },
  layout: {
    row: "row mt-2 justify-content-between",
    cell: "d-md-flex justify-content-between align-items-center",
    tableCell: "col-12",
    start: "dt-layout-start col-md-auto me-auto",
    end: "dt-layout-end col-md-auto ms-auto",
    full: "dt-layout-full col-md"
  }
});
me.ext.renderer.pagingButton.bootstrap = function(e, t, r, o, n) {
  var a = ["dt-paging-button", "page-item"];
  o && a.push("active"), n && a.push("disabled");
  var l = ru("<li>").addClass(a.join(" ")), i = ru("<button>", {
    class: "page-link",
    role: "link",
    type: "button"
  }).html(r).appendTo(l);
  return {
    display: l,
    clicker: i
  };
};
me.ext.renderer.pagingContainer.bootstrap = function(e, t) {
  return ru("<ul/>").addClass("pagination").append(t);
};
let Mr = Su;
function ei(e, t, r, o) {
  var n = e.splice(t, r);
  n.unshift(0), n.unshift(o < t ? o : o - r + 1), e.splice.apply(e, n);
}
function M_(e) {
  e.rows().invalidate("data"), e.column(0).visible(e.column(0).visible()), e.columns.adjust();
  var t = e.colReorder.order();
  e.trigger("columns-reordered", [
    {
      order: t,
      mapping: Sh(t)
    }
  ]);
}
function $_(e) {
  return e.settings()[0].aoColumns.map(function(t) {
    return t._crOriginalIdx;
  });
}
function Ux(e, t, r, o) {
  for (var n = [], a = 0; a < e.length; a++) {
    var l = e[a];
    ei(l, r[0], r.length, o);
    for (var i = 0; i < l.length; i++) {
      var s = l[i].cell;
      if (!n.includes(s)) {
        var u = s.getAttribute("data-dt-column").split(","), c = u.map(function(g) {
          return t[g];
        }).join(",");
        s.setAttribute("data-dt-column", c), n.push(s);
      }
    }
  }
}
function _u(e) {
  e.columns().iterator("column", function(t, r) {
    var o = t.aoColumns;
    o[r]._crOriginalIdx === void 0 && (o[r]._crOriginalIdx = r);
  });
}
function Sh(e) {
  for (var t = [], r = 0; r < e.length; r++)
    t[e[r]] = r;
  return t;
}
function C_(e, t, r) {
  var o, n, a = e.settings()[0], l = a.aoColumns, i = l.map(function(p, h) {
    return h;
  });
  if (!t.includes(r)) {
    ei(i, t[0], t.length, r);
    var s = Sh(i);
    for (ei(l, t[0], t.length, r), o = 0; o < a.aoData.length; o++) {
      var u = a.aoData[o];
      if (u) {
        var c = u.anCells;
        if (c)
          for (ei(c, t[0], t.length, r), n = 0; n < c.length; n++)
            u.nTr && c[n] && l[n].bVisible && u.nTr.appendChild(c[n]), c[n] && c[n]._DT_CellIndex && (c[n]._DT_CellIndex.column = n);
      }
    }
    for (o = 0; o < l.length; o++) {
      var g = l[o];
      for (n = 0; n < g.aDataSort.length; n++)
        g.aDataSort[n] = s[g.aDataSort[n]];
      g.idx = s[g.idx], g.bVisible && a.colgroup.append(g.colEl);
    }
    Ux(a.aoHeader, s, t, r), Ux(a.aoFooter, s, t, r), ei(a.aoPreSearchCols, t[0], t.length, r), Rd(s, a.aaSorting), Array.isArray(a.aaSortingFixed) ? Rd(s, a.aaSortingFixed) : (a.aaSortingFixed.pre || a.aaSortingFixed.post) && Rd(s, a.aaSortingFixed.pre), a.aLastSort.forEach(function(p) {
      p.src = s[p.src];
    }), e.trigger("column-reorder", [
      e.settings()[0],
      {
        from: t,
        to: r,
        mapping: s
      }
    ]);
  }
}
function Rd(e, t) {
  if (t)
    for (var r = 0; r < t.length; r++) {
      var o = t[r];
      typeof o == "number" ? t[r] = e[o] : Mr.isPlainObject(o) && o.idx !== void 0 ? o.idx = e[o.idx] : Array.isArray(o) && typeof o[0] == "number" && (o[0] = e[o[0]]);
    }
}
function Rm(e, t, r) {
  var o = !1, n;
  if (t.length !== e.columns().count()) {
    e.error("ColReorder - column count mismatch");
    return;
  }
  r && (t = L_(e, t, "toCurrent"));
  var a = Sh(t);
  for (n = 0; n < a.length; n++) {
    var l = a.indexOf(n);
    n !== l && (ei(a, l, 1, n), C_(e, [l], n), o = !0);
  }
  o && M_(e);
}
function cR(e) {
  for (var t = [], r = 0; r < e.length; r++) {
    t.push([]);
    for (var o = 0; o < e[r].length; o++) {
      var n = e[r][o];
      if (n)
        for (var a = 0; a < n.rowspan; a++) {
          t[r + a] || (t[r + a] = []);
          for (var l = 0; l < n.colspan; l++)
            t[r + a][o + l] = n.cell;
        }
    }
  }
  return t;
}
function L_(e, t, r) {
  var o = e.colReorder.order(), n = e.settings()[0].aoColumns;
  return r === "toCurrent" || r === "fromOriginal" ? Array.isArray(t) ? t.map(function(a) {
    return o.indexOf(a);
  }) : o.indexOf(t) : Array.isArray(t) ? t.map(function(a) {
    return n[a]._crOriginalIdx;
  }) : n[t]._crOriginalIdx;
}
function E_(e, t, r) {
  var o = e.columns().count();
  return t[0] < r && r < t[t.length] || t[0] < 0 && t[t.length - 1] > o || r < 0 && r > o ? !1 : t.includes(r) ? !0 : !(!Xx(e.table().header.structure(), t, r) || !Xx(e.table().footer.structure(), t, r));
}
function Xx(e, t, r) {
  var o = cR(e), n;
  for (n = 0; n < o.length; n++)
    ei(o[n], t[0], t.length, r);
  for (n = 0; n < o.length; n++)
    for (var a = [], l = 0; l < o[n].length; l++) {
      var i = o[n][l];
      if (!a.includes(i))
        a.push(i);
      else if (a[a.length - 1] !== i)
        return !1;
    }
  return !0;
}
var O_ = (
  /** @class */
  (function() {
    function e(t, r) {
      this.dom = {
        drag: null
      }, this.c = {
        columns: null,
        enable: null,
        headerRows: null,
        order: null
      }, this.s = {
        dropZones: [],
        mouse: {
          absLeft: -1,
          offset: {
            x: -1,
            y: -1
          },
          start: {
            x: -1,
            y: -1
          },
          target: null,
          targets: []
        },
        scrollInterval: null
      };
      var o = this, n = t.settings()[0];
      if (!n._colReorder) {
        t.settings()[0]._colReorder = this, this.dt = t, Mr.extend(this.c, e.defaults, r), _u(t), t.on("stateSaveParams", function(i, s, u) {
          u.colReorder = $_(t);
        }), t.on("destroy", function() {
          t.off(".colReorder"), t.colReorder.reset();
        });
        var a = t.state.loaded(), l = this.c.order;
        a && a.colReorder && t.columns().count() === a.colReorder.length && (l = a.colReorder), l && t.ready(function() {
          Rm(t, l, !0);
        }), t.table().header.structure().forEach(function(i, s) {
          for (var u = r.headerRows, c = 0; c < i.length; c++)
            (!u || u.includes(s)) && i[c] && i[c].cell && o._addListener(i[c].cell);
        });
      }
    }
    return e.prototype.disable = function() {
      return this.c.enable = !1, this;
    }, e.prototype.enable = function(t) {
      return t === void 0 && (t = !0), t === !1 ? this.disable() : (this.c.enable = !0, this);
    }, e.prototype._addListener = function(t) {
      var r = this;
      Mr(t).on("selectstart.colReorder", function() {
        return !1;
      }).on("mousedown.colReorder touchstart.colReorder", function(o) {
        if (!(o.type === "mousedown" && o.which !== 1) && r.c.enable) {
          var n = Mr("button.dtcc-button_reorder", this);
          n.length && o.target !== n[0] && n.find(o.target).length === 0 || r._mouseDown(o, this);
        }
      });
    }, e.prototype._createDragNode = function() {
      var t = this.s.mouse.target, r = t.parent(), o = r.parent(), n = o.parent(), a = t.clone();
      this.dom.drag = Mr(n[0].cloneNode(!1)).addClass("dtcr-cloned").append(
        Mr(o[0].cloneNode(!1)).append(Mr(r[0].cloneNode(!1)).append(a[0]))
        // Not sure why  it doesn't want to append a jQuery node
      ).css({
        position: "absolute",
        top: 0,
        left: 0,
        width: Mr(t).outerWidth(),
        height: Mr(t).outerHeight()
      }).appendTo("body");
    }, e.prototype._cursorPosition = function(t, r) {
      return t.type.indexOf("touch") !== -1 ? t.originalEvent.touches[0][r] : t[r];
    }, e.prototype._mouseDown = function(t, r) {
      for (var o = this, n = Mr(t.target).closest("th, td"), a = n.offset(), l = this.dt.columns(this.c.columns).indexes().toArray(), i = Mr(r).attr("data-dt-column").split(",").map(function(p) {
        return parseInt(p, 10);
      }), s = 0; s < i.length; s++)
        if (!l.includes(i[s]))
          return !1;
      this.s.mouse.start.x = this._cursorPosition(t, "pageX"), this.s.mouse.start.y = this._cursorPosition(t, "pageY"), this.s.mouse.offset.x = this._cursorPosition(t, "pageX") - a.left, this.s.mouse.offset.y = this._cursorPosition(t, "pageY") - a.top, this.s.mouse.target = n, this.s.mouse.targets = i;
      for (var u = 0; u < i.length; u++) {
        var c = this.dt.cells(null, i[u], { page: "current" }).nodes().to$(), g = "dtcr-moving";
        u === 0 && (g += " dtcr-moving-first"), u === i.length - 1 && (g += " dtcr-moving-last"), c.addClass(g);
      }
      this._regions(i), this._scrollRegions(), Mr(document).on("mousemove.colReorder touchmove.colReorder", function(p) {
        o._mouseMove(p);
      }).on("mouseup.colReorder touchend.colReorder", function(p) {
        o._mouseUp(p);
      });
    }, e.prototype._mouseMove = function(t) {
      if (this.dom.drag === null) {
        if (Math.pow(Math.pow(this._cursorPosition(t, "pageX") - this.s.mouse.start.x, 2) + Math.pow(this._cursorPosition(t, "pageY") - this.s.mouse.start.y, 2), 0.5) < 5)
          return;
        Mr(document.body).addClass("dtcr-dragging"), this._createDragNode();
      }
      this.dom.drag.css({
        left: this._cursorPosition(t, "pageX") - this.s.mouse.offset.x,
        top: this._cursorPosition(t, "pageY") - this.s.mouse.offset.y
      });
      var r = this.dt.table().node(), o = Mr(r).offset().left, n = this._cursorPosition(t, "pageX") - o, a;
      if (this._isRtl()) {
        var l = r.clientWidth;
        a = l - n;
      } else
        a = n;
      var i = this.s.dropZones.find(function(s) {
        return s.inlineStart <= a && a <= s.inlineStart + s.width;
      });
      this.s.mouse.absLeft = this._cursorPosition(t, "pageX"), i && (i.self || this._move(i, a));
    }, e.prototype._mouseUp = function(t) {
      var r = this;
      Mr(document).off(".colReorder"), Mr(document.body).removeClass("dtcr-dragging"), this.dom.drag && (this.dom.drag.remove(), this.dom.drag = null, this.s.mouse.target.on("click.dtcr", function(o) {
        return !1;
      }), setTimeout(function() {
        r.s.mouse.target.off(".dtcr");
      }, 10)), this.s.scrollInterval && clearInterval(this.s.scrollInterval), this.dt.cells(".dtcr-moving").nodes().to$().removeClass("dtcr-moving dtcr-moving-first dtcr-moving-last");
    }, e.prototype._move = function(t, r) {
      var o = this;
      this.dt.colReorder.move(this.s.mouse.targets, t.colIdx), this.s.mouse.targets = Mr(this.s.mouse.target).attr("data-dt-column").split(",").map(function(g) {
        return parseInt(g, 10);
      }), this._regions(this.s.mouse.targets);
      var n = this.s.mouse.targets.filter(function(g) {
        return o.dt.column(g).visible();
      }), a = this.s.dropZones.find(function(g) {
        return g.colIdx === n[0];
      }), l = this.s.dropZones.indexOf(a);
      if (a.inlineStart > r) {
        var i = a.inlineStart - r, s = this.s.dropZones[l - 1];
        a.inlineStart -= i, a.width += i, s && (s.width -= i);
      }
      if (a = this.s.dropZones.find(function(g) {
        return g.colIdx === n[n.length - 1];
      }), a.inlineStart + a.width < r) {
        var u = r - (a.inlineStart + a.width), c = this.s.dropZones[l + 1];
        a.width += u, c && (c.inlineStart += u, c.width -= u);
      }
    }, e.prototype._regions = function(t) {
      var r = this, o = [], n = 0, a = 0, l = this.dt.columns(this.c.columns).indexes().toArray(), i = this.dt.columns().widths();
      this.dt.columns().every(function(s, u, c) {
        if (this.visible()) {
          var g = i[s];
          if (!l.includes(s)) {
            n += g;
            return;
          }
          var p = E_(r.dt, t, s);
          p ? o.push({
            colIdx: s,
            inlineStart: n - a,
            self: t[0] <= s && s <= t[t.length - 1],
            width: g + a
          }) : s < t[0] ? o.length && (o[o.length - 1].width += g) : s > t[t.length - 1] && (a += g), n += g;
        }
      }), this.s.dropZones = o;
    }, e.prototype._isScrolling = function() {
      return this.dt.table().body().parentNode !== this.dt.table().header().parentNode;
    }, e.prototype._scrollRegions = function() {
      if (this._isScrolling()) {
        var t = this, r = Mr(this.dt.table().container()).offset().left, o = Mr(this.dt.table().container()).outerWidth(), n = 75, a = this.dt.table().body().parentElement.parentElement;
        this.s.scrollInterval = setInterval(function() {
          var l = t.s.mouse.absLeft;
          l !== -1 && (l < r + n && a.scrollLeft ? a.scrollLeft -= 5 : l > r + o - n && a.scrollLeft < a.scrollWidth && (a.scrollLeft += 5));
        }, 25);
      }
    }, e.prototype._isRtl = function() {
      return Mr(this.dt.table().node()).css("direction") === "rtl";
    }, e.defaults = {
      columns: "",
      enable: !0,
      headerRows: null,
      order: null
    }, e.version = "2.1.2", e;
  })()
);
me.Api.register("colReorder.enable()", function(e) {
  return this.iterator("table", function(t) {
    t._colReorder && t._colReorder.enable(e);
  });
});
me.Api.register("colReorder.disable()", function() {
  return this.iterator("table", function(e) {
    e._colReorder && e._colReorder.disable();
  });
});
me.Api.register("colReorder.move()", function(e, t) {
  return _u(this), Array.isArray(e) || (e = [e]), E_(this, e, t) ? this.tables().every(function() {
    C_(this, e, t), M_(this);
  }) : (this.error("ColReorder - invalid move"), this);
});
me.Api.register("colReorder.order()", function(e, t) {
  return _u(this), e ? this.tables().every(function() {
    Rm(this, e, t);
  }) : this.context.length ? $_(this) : null;
});
me.Api.register("colReorder.reset()", function() {
  return _u(this), this.tables().every(function() {
    var e = this.columns().every(function(t) {
      return t;
    }).flatten().toArray();
    Rm(this, e, !0);
  });
});
me.Api.register("colReorder.transpose()", function(e, t) {
  return _u(this), t || (t = "toCurrent"), L_(this, e, t);
});
me.ColReorder = O_;
Mr(document).on("stateLoadInit.dt", function(e, t, r) {
  if (e.namespace === "dt") {
    var o = new me.Api(t);
    if (r.colReorder && o.columns().count() === r.colReorder.length) {
      if (o.ready())
        Rm(o, r.colReorder, !0);
      else if (Rd(r.colReorder, r.order), r.columns) {
        for (var n = 0; n < r.columns.length; n++)
          r.columns[n]._cr_sort = r.colReorder[n];
        r.columns.sort(function(a, l) {
          return a._cr_sort - l._cr_sort;
        });
      }
    }
  }
});
Mr(document).on("preInit.dt", function(e, t) {
  if (e.namespace === "dt") {
    var r = t.oInit.colReorder, o = me.defaults.colReorder;
    if (r || o) {
      var n = Mr.extend({}, o, r);
      if (r !== !1) {
        var a = new me.Api(t);
        new O_(a, n);
      }
    }
  }
});
let We = Su;
var jo = function(e, t) {
  if (!me.versionCheck || !me.versionCheck("2"))
    throw "DataTables Responsive requires DataTables 2 or newer";
  this.s = {
    childNodeStore: {},
    columns: [],
    current: [],
    dt: new me.Api(e)
  }, !this.s.dt.settings()[0].responsive && (t && typeof t.details == "string" ? t.details = { type: t.details } : t && t.details === !1 ? t.details = { type: !1 } : t && t.details === !0 && (t.details = { type: "inline" }), this.c = We.extend(
    !0,
    {},
    jo.defaults,
    me.defaults.responsive,
    t
  ), e.responsive = this, this._constructor());
};
We.extend(jo.prototype, {
  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Constructor
   */
  /**
   * Initialise the Responsive instance
   *
   * @private
   */
  _constructor: function() {
    var e = this, t = this.s.dt, r = We(window).innerWidth();
    t.settings()[0]._responsive = this, We(window).on(
      "orientationchange.dtr",
      me.util.throttle(function() {
        var n = We(window).innerWidth();
        n !== r && (e._resize(), r = n);
      })
    ), t.on("row-created.dtr", function(n, a, l, i) {
      We.inArray(!1, e.s.current) !== -1 && We(">td, >th", a).each(function(s) {
        var u = t.column.index("toData", s);
        e.s.current[u] === !1 && We(this).css("display", "none").addClass("dtr-hidden");
      });
    }), t.on("destroy.dtr", function() {
      t.off(".dtr"), We(t.table().body()).off(".dtr"), We(window).off("resize.dtr orientationchange.dtr"), t.cells(".dtr-control").nodes().to$().removeClass("dtr-control"), We(t.table().node()).removeClass("dtr-inline collapsed"), We.each(e.s.current, function(n, a) {
        a === !1 && e._setColumnVis(n, !0);
      });
    }), this.c.breakpoints.sort(function(n, a) {
      return n.width < a.width ? 1 : n.width > a.width ? -1 : 0;
    }), this._classLogic();
    var o = this.c.details;
    o.type !== !1 && (e._detailsInit(), t.on("column-visibility.dtr", function() {
      e._timer && clearTimeout(e._timer), e._timer = setTimeout(function() {
        e._timer = null, e._classLogic(), e._resizeAuto(), e._resize(!0), e._redrawChildren();
      }, 100);
    }), t.on("draw.dtr", function() {
      e._redrawChildren();
    }), We(t.table().node()).addClass("dtr-" + o.type)), t.on("column-calc.dt", function(n, a) {
      for (var l = e.s.current, i = 0; i < l.length; i++) {
        var s = a.visible.indexOf(i);
        l[i] === !1 && s >= 0 && a.visible.splice(s, 1);
      }
    }), t.on("preXhr.dtr", function() {
      var n = [];
      t.rows().every(function() {
        this.child.isShown() && n.push(this.id(!0));
      }), t.one("draw.dtr", function() {
        e._resizeAuto(), e._resize(), t.rows(n).every(function() {
          e._detailsDisplay(this, !1);
        });
      });
    }), t.on("draw.dtr", function() {
      t.page.info().serverSide && (e.s.childNodeStore = {}), e._controlClass();
    }).ready(function() {
      e._resizeAuto(), e._resize(), t.on("column-sizing.dtr", function() {
        e._resizeAuto(), e._resize();
      });
    }), t.on("column-reorder.dtr", function(n, a, l) {
      e._classLogic(), e._resizeAuto(), e._resize(!0);
    });
  },
  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Private methods
   */
  /**
   * Insert a `col` tag into the correct location in a `colgroup`.
   *
   * @param {jQuery} colGroup The `colgroup` tag
   * @param {jQuery} colEl The `col` tag
   */
  _colGroupAttach: function(e, t, r) {
    var o = null;
    if (t[r].get(0).parentNode !== e[0]) {
      for (var n = r + 1; n < t.length; n++)
        if (e[0] === t[n].get(0).parentNode) {
          o = n;
          break;
        }
      o !== null ? t[r].insertBefore(t[o][0]) : e.append(t[r]);
    }
  },
  /**
   * Get and store nodes from a cell - use for node moving renderers
   *
   * @param {*} dt DT instance
   * @param {*} row Row index
   * @param {*} col Column index
   */
  _childNodes: function(e, t, r) {
    var o = t + "-" + r;
    if (this.s.childNodeStore[o])
      return this.s.childNodeStore[o];
    for (var n = [], a = e.cell(t, r).node().childNodes, l = 0, i = a.length; l < i; l++)
      n.push(a[l]);
    return this.s.childNodeStore[o] = n, n;
  },
  /**
   * Restore nodes from the cache to a table cell
   *
   * @param {*} dt DT instance
   * @param {*} row Row index
   * @param {*} col Column index
   */
  _childNodesRestore: function(e, t, r) {
    var o = t + "-" + r;
    if (this.s.childNodeStore[o]) {
      var n = e.cell(t, r).node(), a = this.s.childNodeStore[o];
      if (a.length > 0) {
        for (var l = a[0].parentNode, i = l.childNodes, s = [], u = 0, c = i.length; u < c; u++)
          s.push(i[u]);
        for (var g = 0, p = s.length; g < p; g++)
          n.appendChild(s[g]);
      }
      this.s.childNodeStore[o] = void 0;
    }
  },
  /**
   * Calculate the visibility for the columns in a table for a given
   * breakpoint. The result is pre-determined based on the class logic if
   * class names are used to control all columns, but the width of the table
   * is also used if there are columns which are to be automatically shown
   * and hidden.
   *
   * @param  {string} breakpoint Breakpoint name to use for the calculation
   * @return {array} Array of boolean values initiating the visibility of each
   *   column.
   *  @private
   */
  _columnsVisibility: function(e) {
    var t = this.s.dt, r = this.s.columns, o, n, a = r.map(function(A, S) {
      return {
        columnIdx: S,
        priority: A.priority
      };
    }).sort(function(A, S) {
      return A.priority !== S.priority ? A.priority - S.priority : A.columnIdx - S.columnIdx;
    }), l = We.map(r, function(A, S) {
      return t.column(S).visible() === !1 ? "not-visible" : A.auto && A.minWidth === null ? !1 : A.auto === !0 ? "-" : We.inArray(e, A.includeIn) !== -1;
    }), i = 0;
    for (o = 0, n = l.length; o < n; o++)
      l[o] === !0 && (i += r[o].minWidth);
    var s = t.settings()[0].oScroll, u = s.sY || s.sX ? s.iBarWidth : 0, c = t.table().container().offsetWidth - u, g = c - i;
    for (o = 0, n = l.length; o < n; o++)
      r[o].control && (g -= r[o].minWidth);
    var p = !1;
    for (o = 0, n = a.length; o < n; o++) {
      var h = a[o].columnIdx;
      l[h] === "-" && !r[h].control && r[h].minWidth && (p || g - r[h].minWidth < 0 ? (p = !0, l[h] = !1) : l[h] = !0, g -= r[h].minWidth);
    }
    var v = !1;
    for (o = 0, n = r.length; o < n; o++)
      if (!r[o].control && !r[o].never && l[o] === !1) {
        v = !0;
        break;
      }
    for (o = 0, n = r.length; o < n; o++)
      r[o].control && (l[o] = v), l[o] === "not-visible" && (l[o] = !1);
    return We.inArray(!0, l) === -1 && (l[0] = !0), l;
  },
  /**
   * Create the internal `columns` array with information about the columns
   * for the table. This includes determining which breakpoints the column
   * will appear in, based upon class names in the column, which makes up the
   * vast majority of this method.
   *
   * @private
   */
  _classLogic: function() {
    var e = this, t = this.c.breakpoints, r = this.s.dt, o = r.columns().eq(0).map(function(l) {
      var i = this.column(l), s = i.header().className, u = i.init().responsivePriority, c = i.header().getAttribute("data-priority");
      return u === void 0 && (u = c == null ? 1e4 : c * 1), {
        className: s,
        includeIn: [],
        auto: !1,
        control: !1,
        never: !!s.match(/\b(dtr\-)?never\b/),
        priority: u
      };
    }), n = function(l, i) {
      var s = o[l].includeIn;
      We.inArray(i, s) === -1 && s.push(i);
    }, a = function(l, i, s, u) {
      var c, g, p;
      if (!s)
        o[l].includeIn.push(i);
      else if (s === "max-")
        for (c = e._find(i).width, g = 0, p = t.length; g < p; g++)
          t[g].width <= c && n(l, t[g].name);
      else if (s === "min-")
        for (c = e._find(i).width, g = 0, p = t.length; g < p; g++)
          t[g].width >= c && n(l, t[g].name);
      else if (s === "not-")
        for (g = 0, p = t.length; g < p; g++)
          t[g].name.indexOf(u) === -1 && n(l, t[g].name);
    };
    o.each(function(l, i) {
      for (var s = l.className.split(" "), u = !1, c = 0, g = s.length; c < g; c++) {
        var p = s[c].trim();
        if (p === "all" || p === "dtr-all") {
          u = !0, l.includeIn = We.map(t, function(h) {
            return h.name;
          });
          return;
        } else if (p === "none" || p === "dtr-none" || l.never) {
          u = !0;
          return;
        } else if (p === "control" || p === "dtr-control") {
          u = !0, l.control = !0;
          return;
        }
        We.each(t, function(h, v) {
          var A = v.name.split("-"), S = new RegExp(
            "(min\\-|max\\-|not\\-)?(" + A[0] + ")(\\-[_a-zA-Z0-9])?"
          ), b = p.match(S);
          b && (u = !0, b[2] === A[0] && b[3] === "-" + A[1] ? a(
            i,
            v.name,
            b[1],
            b[2] + b[3]
          ) : b[2] === A[0] && !b[3] && a(i, v.name, b[1], b[2]));
        });
      }
      u || (l.auto = !0);
    }), this.s.columns = o;
  },
  /**
   * Update the cells to show the correct control class / button
   * @private
   */
  _controlClass: function() {
    if (this.c.details.type === "inline") {
      var e = this.s.dt, t = this.s.current, r = We.inArray(!0, t);
      e.cells(
        null,
        function(o) {
          return o !== r;
        },
        { page: "current" }
      ).nodes().to$().filter(".dtr-control").removeClass("dtr-control"), r >= 0 && e.cells(null, r, { page: "current" }).nodes().to$().addClass("dtr-control");
    }
    this._tabIndexes();
  },
  /**
   * Show the details for the child row
   *
   * @param  {DataTables.Api} row    API instance for the row
   * @param  {boolean}        update Update flag
   * @private
   */
  _detailsDisplay: function(e, t) {
    var r = this, o = this.s.dt, n = this.c.details, a = function(s) {
      We(e.node()).toggleClass("dtr-expanded", s !== !1), We(o.table().node()).triggerHandler("responsive-display.dt", [
        o,
        e,
        s,
        t
      ]);
    };
    if (n && n.type !== !1) {
      var l = typeof n.renderer == "string" ? jo.renderer[n.renderer]() : n.renderer, i = n.display(
        e,
        t,
        function() {
          return l.call(
            r,
            o,
            e[0][0],
            r._detailsObj(e[0])
          );
        },
        function() {
          a(!1);
        }
      );
      typeof i == "boolean" && a(i);
    }
  },
  /**
   * Initialisation for the details handler
   *
   * @private
   */
  _detailsInit: function() {
    var e = this, t = this.s.dt, r = this.c.details;
    r.type === "inline" && (r.target = "td.dtr-control, th.dtr-control"), We(t.table().body()).on("keyup.dtr", "td, th", function(a) {
      let l = document.activeElement.nodeName.toLowerCase();
      a.keyCode === 13 && We(this).data("dtr-keyboard") && (l === "td" || l === "th") && We(this).click();
    });
    var o = r.target, n = typeof o == "string" ? o : "td, th";
    (o !== void 0 || o !== null) && We(t.table().body()).on(
      "click.dtr mousedown.dtr mouseup.dtr",
      n,
      function(a) {
        if (We(t.table().node()).hasClass("collapsed") && We.inArray(
          We(this).closest("tr").get(0),
          t.rows().nodes().toArray()
        ) !== -1) {
          if (typeof o == "number") {
            var l = o < 0 ? t.columns().eq(0).length + o : o;
            if (t.cell(this).index().column !== l)
              return;
          }
          var i = t.row(We(this).closest("tr"));
          a.type === "click" ? e._detailsDisplay(i, !1) : a.type === "mousedown" ? We(this).css("outline", "none") : a.type === "mouseup" && We(this).trigger("blur").css("outline", "");
        }
      }
    );
  },
  /**
   * Get the details to pass to a renderer for a row
   * @param  {int} rowIdx Row index
   * @private
   */
  _detailsObj: function(e) {
    var t = this, r = this.s.dt, o = [];
    let n = r.settings()[0];
    return We.map(this.s.columns, function(a, l) {
      if (!(a.never || a.control)) {
        var i = n.aoColumns[l];
        return o[l] || (o[l] = r.column(l)), {
          className: i.sClass,
          columnIndex: l,
          data: n.fastData(e, l, t.c.orthogonal),
          hidden: o[l].visible() && !t.s.current[l],
          rowIndex: e,
          title: o[l].title()
        };
      }
    });
  },
  /**
   * Find a breakpoint object from a name
   *
   * @param  {string} name Breakpoint name to find
   * @return {object}      Breakpoint description object
   * @private
   */
  _find: function(e) {
    for (var t = this.c.breakpoints, r = 0, o = t.length; r < o; r++)
      if (t[r].name === e)
        return t[r];
  },
  /**
   * Re-create the contents of the child rows as the display has changed in
   * some way.
   *
   * @private
   */
  _redrawChildren: function() {
    var e = this, t = this.s.dt;
    t.rows({ page: "current" }).iterator("row", function(r, o) {
      e._detailsDisplay(t.row(o), !0);
    });
  },
  /**
   * Alter the table display for a resized viewport. This involves first
   * determining what breakpoint the window currently is in, getting the
   * column visibilities to apply and then setting them.
   *
   * @param  {boolean} forceRedraw Force a redraw
   * @private
   */
  _resize: function(e) {
    var t = this, r = this.s.dt, o = We(window).innerWidth(), n = this.c.breakpoints, a = n[0].name, l = this.s.columns, i, s, u = this.s.current.slice();
    for (i = n.length - 1; i >= 0; i--)
      if (o <= n[i].width) {
        a = n[i].name;
        break;
      }
    var c = this._columnsVisibility(a);
    this.s.current = c;
    var g = !1;
    for (i = 0, s = l.length; i < s; i++)
      if (c[i] === !1 && !l[i].never && !l[i].control && r.column(i).visible()) {
        g = !0;
        break;
      }
    We(r.table().node()).toggleClass("collapsed", g);
    var p = !1, h = 0, v = r.settings()[0], A = We(r.table().node()).children("colgroup"), S = v.aoColumns.map(function(b) {
      return b.colEl;
    });
    r.columns().eq(0).each(function(b, T) {
      r.column(b).visible() && (c[T] === !0 && h++, (e || c[T] !== u[T]) && (p = !0, t._setColumnVis(b, c[T])), c[T] ? t._colGroupAttach(A, S, T) : S[T].detach());
    }), p && (r.columns.adjust(), this._redrawChildren(), We(r.table().node()).trigger("responsive-resize.dt", [
      r,
      this._responsiveOnlyHidden()
    ]), r.page.info().recordsDisplay === 0 && We("td", r.table().body()).eq(0).attr("colspan", h)), t._controlClass();
  },
  /**
   * Determine the width of each column in the table so the auto column hiding
   * has that information to work with. This method is never going to be 100%
   * perfect since column widths can change slightly per page, but without
   * seriously compromising performance this is quite effective.
   *
   * @private
   */
  _resizeAuto: function() {
    var e = this.s.dt, t = this.s.columns, r = this, o = e.columns().indexes().filter(function(g) {
      return e.column(g).visible();
    });
    if (this.c.auto && We.inArray(
      !0,
      We.map(t, function(g) {
        return g.auto;
      })
    ) !== -1) {
      var n = e.table().node().cloneNode(!1), a = We(e.table().header().cloneNode(!1)).appendTo(
        n
      ), l = We(e.table().footer().cloneNode(!1)).appendTo(
        n
      ), i = We(e.table().body()).clone(!1, !1).empty().appendTo(n);
      n.style.width = "auto", e.table().header.structure(o).forEach((g) => {
        var p = g.filter(function(h) {
          return !!h;
        }).map(function(h) {
          return We(h.cell).clone(!1).css("display", "table-cell").css("width", "auto").css("min-width", 0);
        });
        We("<tr/>").append(p).appendTo(a);
      });
      for (var s = We("<tr/>").appendTo(i), u = 0; u < o.count(); u++)
        s.append("<td/>");
      this.c.details.renderer._responsiveMovesNodes ? e.rows({ page: "current" }).every(function(g) {
        var p = this.node();
        if (p) {
          var h = p.cloneNode(!1);
          e.cells(g, o).every(function(v, A) {
            var S = r.s.childNodeStore[g + "-" + A];
            S ? We(this.node().cloneNode(!1)).append(We(S).clone()).appendTo(h) : We(this.node()).clone(!1).appendTo(h);
          }), i.append(h);
        }
      }) : We(i).append(We(e.rows({ page: "current" }).nodes()).clone(!1)).find("th, td").css("display", ""), i.find("th, td").css("display", ""), e.table().footer.structure(o).forEach((g) => {
        var p = g.filter(function(h) {
          return !!h;
        }).map(function(h) {
          return We(h.cell).clone(!1).css("display", "table-cell").css("width", "auto").css("min-width", 0);
        });
        We("<tr/>").append(p).appendTo(l);
      }), this.c.details.type === "inline" && We(n).addClass("dtr-inline collapsed"), We(n).find("[name]").removeAttr("name"), We(n).css("position", "relative");
      var c = We("<div/>").css({
        width: 1,
        height: 1,
        overflow: "hidden",
        clear: "both"
      }).append(n);
      c.insertBefore(e.table().node()), s.children().each(function(g) {
        var p = e.column.index("fromVisible", g);
        t[p].minWidth = this.offsetWidth || 0;
      }), c.remove();
    }
  },
  /**
   * Get the state of the current hidden columns - controlled by Responsive only
   */
  _responsiveOnlyHidden: function() {
    var e = this.s.dt;
    return We.map(this.s.current, function(t, r) {
      return e.column(r).visible() === !1 ? !0 : t;
    });
  },
  /**
   * Set a column's visibility.
   *
   * We don't use DataTables' column visibility controls in order to ensure
   * that column visibility can Responsive can no-exist. Since only IE8+ is
   * supported (and all evergreen browsers of course) the control of the
   * display attribute works well.
   *
   * @param {integer} col      Column index
   * @param {boolean} showHide Show or hide (true or false)
   * @private
   */
  _setColumnVis: function(e, t) {
    var r = this, o = this.s.dt, n = t ? "" : "none";
    this._setHeaderVis(e, t, o.table().header.structure()), this._setHeaderVis(e, t, o.table().footer.structure()), o.column(e).nodes().to$().css("display", n).toggleClass("dtr-hidden", !t), o.settings()[0].aoColumns[e].responsiveVisible = t, We.isEmptyObject(this.s.childNodeStore) || o.cells(null, e).indexes().each(function(a) {
      r._childNodesRestore(o, a.row, a.column);
    });
  },
  /**
   * Set a column's visibility, taking into account multiple rows
   * in a header / footer and colspan attributes
   * @param {*} col
   * @param {*} showHide
   * @param {*} structure
   */
  _setHeaderVis: function(e, t, r) {
    var o = this, n = t ? "" : "none";
    r.forEach(function(a, l) {
      for (var i = 0; i < a.length; i++)
        if (a[i] && a[i].rowspan > 1)
          for (var s = a[i].rowspan, u = 1; u < s; u++)
            r[l + u][i] = {};
    }), r.forEach(function(a) {
      if (a[e] && a[e].cell)
        We(a[e].cell).css("display", n).toggleClass("dtr-hidden", !t);
      else
        for (var l = e; l >= 0; ) {
          if (a[l] && a[l].cell) {
            a[l].cell.colSpan = o._colspan(a, l);
            break;
          }
          l--;
        }
    });
  },
  /**
   * How many columns should this cell span
   *
   * @param {*} row Header structure row
   * @param {*} idx The column index of the cell to span
   */
  _colspan: function(e, t) {
    for (var r = 1, o = t + 1; o < e.length; o++)
      if (e[o] === null && this.s.current[o])
        r++;
      else if (e[o])
        break;
    return r;
  },
  /**
   * Update the cell tab indexes for keyboard accessibility. This is called on
   * every table draw - that is potentially inefficient, but also the least
   * complex option given that column visibility can change on the fly. Its a
   * shame user-focus was removed from CSS 3 UI, as it would have solved this
   * issue with a single CSS statement.
   *
   * @private
   */
  _tabIndexes: function() {
    var e = this.s.dt, t = e.cells({ page: "current" }).nodes().to$(), r = e.settings()[0], o = this.c.details.target;
    if (t.filter("[data-dtr-keyboard]").removeData("[data-dtr-keyboard]"), typeof o == "number")
      e.cells(null, o, { page: "current" }).nodes().to$().attr("tabIndex", r.iTabIndex).data("dtr-keyboard", 1);
    else {
      o === "td:first-child, th:first-child" && (o = ">td:first-child, >th:first-child");
      var n = e.rows({ page: "current" }).nodes(), a = o === "tr" ? We(n) : We(o, n);
      a.attr("tabIndex", r.iTabIndex).data("dtr-keyboard", 1);
    }
  }
});
jo.breakpoints = [
  { name: "desktop", width: 1 / 0 },
  { name: "tablet-l", width: 1024 },
  { name: "tablet-p", width: 768 },
  { name: "mobile-l", width: 480 },
  { name: "mobile-p", width: 320 }
];
jo.display = {
  childRow: function(e, t, r) {
    var o = We(e.node());
    if (t) {
      if (o.hasClass("dtr-expanded"))
        return e.child(r(), "child").show(), !0;
    } else {
      if (o.hasClass("dtr-expanded"))
        return e.child(!1), !1;
      var n = r();
      return n === !1 ? !1 : (e.child(n, "child").show(), !0);
    }
  },
  childRowImmediate: function(e, t, r) {
    var o = We(e.node());
    if (!t && o.hasClass("dtr-expanded") || !e.responsive.hasHidden())
      return e.child(!1), !1;
    var n = r();
    return n === !1 ? !1 : (e.child(n, "child").show(), !0);
  },
  // This is a wrapper so the modal options for Bootstrap and jQuery UI can
  // have options passed into them. This specific one doesn't need to be a
  // function but it is for consistency in the `modal` name
  modal: function(e) {
    return function(t, r, o, n) {
      var a, l = o();
      if (l === !1)
        return !1;
      if (r)
        if (a = We("div.dtr-modal-content"), a.length && t.index() === a.data("dtr-row-idx"))
          a.empty().append(l);
        else
          return null;
      else {
        var i = function() {
          a.remove(), We(document).off("keypress.dtr"), We(t.node()).removeClass("dtr-expanded"), n();
        };
        a = We('<div class="dtr-modal"/>').append(
          We('<div class="dtr-modal-display"/>').append(
            We('<div class="dtr-modal-content"/>').data("dtr-row-idx", t.index()).append(l)
          ).append(
            We(
              '<div class="dtr-modal-close">&times;</div>'
            ).click(function() {
              i();
            })
          )
        ).append(
          We('<div class="dtr-modal-background"/>').click(
            function() {
              i();
            }
          )
        ).appendTo("body"), We(t.node()).addClass("dtr-expanded"), We(document).on("keyup.dtr", function(s) {
          s.keyCode === 27 && (s.stopPropagation(), i());
        });
      }
      return e && e.header && We("div.dtr-modal-content").prepend(
        "<h2>" + e.header(t) + "</h2>"
      ), !0;
    };
  }
};
jo.renderer = {
  listHiddenNodes: function() {
    var e = function(t, r, o) {
      var n = this, a = We(
        '<ul data-dtr-index="' + r + '" class="dtr-details"/>'
      ), l = !1;
      return We.each(o, function(i, s) {
        if (s.hidden) {
          var u = s.className ? 'class="' + s.className + '"' : "";
          We(
            "<li " + u + ' data-dtr-index="' + s.columnIndex + '" data-dt-row="' + s.rowIndex + '" data-dt-column="' + s.columnIndex + '"><span class="dtr-title">' + s.title + "</span> </li>"
          ).append(
            We('<span class="dtr-data"/>').append(
              n._childNodes(
                t,
                s.rowIndex,
                s.columnIndex
              )
            )
          ).appendTo(a), l = !0;
        }
      }), l ? a : !1;
    };
    return e._responsiveMovesNodes = !0, e;
  },
  listHidden: function() {
    return function(e, t, r) {
      var o = We.map(r, function(n) {
        var a = n.className ? 'class="' + n.className + '"' : "";
        return n.hidden ? "<li " + a + ' data-dtr-index="' + n.columnIndex + '" data-dt-row="' + n.rowIndex + '" data-dt-column="' + n.columnIndex + '"><span class="dtr-title">' + n.title + '</span> <span class="dtr-data">' + n.data + "</span></li>" : "";
      }).join("");
      return o ? We(
        '<ul data-dtr-index="' + t + '" class="dtr-details"/>'
      ).append(o) : !1;
    };
  },
  tableAll: function(e) {
    return e = We.extend(
      {
        tableClass: ""
      },
      e
    ), function(t, r, o) {
      var n = We.map(o, function(a) {
        var l = a.className ? 'class="' + a.className + '"' : "";
        return "<tr " + l + ' data-dt-row="' + a.rowIndex + '" data-dt-column="' + a.columnIndex + '"><td>' + (a.title !== "" ? a.title + ":" : "") + "</td> <td>" + a.data + "</td></tr>";
      }).join("");
      return We(
        '<table class="' + e.tableClass + ' dtr-details" width="100%"/>'
      ).append(n);
    };
  }
};
jo.defaults = {
  /**
   * List of breakpoints for the instance. Note that this means that each
   * instance can have its own breakpoints. Additionally, the breakpoints
   * cannot be changed once an instance has been creased.
   *
   * @type {Array}
   * @default Takes the value of `Responsive.breakpoints`
   */
  breakpoints: jo.breakpoints,
  /**
   * Enable / disable auto hiding calculations. It can help to increase
   * performance slightly if you disable this option, but all columns would
   * need to have breakpoint classes assigned to them
   *
   * @type {Boolean}
   * @default  `true`
   */
  auto: !0,
  /**
   * Details control. If given as a string value, the `type` property of the
   * default object is set to that value, and the defaults used for the rest
   * of the object - this is for ease of implementation.
   *
   * The object consists of the following properties:
   *
   * * `display` - A function that is used to show and hide the hidden details
   * * `renderer` - function that is called for display of the child row data.
   *   The default function will show the data from the hidden columns
   * * `target` - Used as the selector for what objects to attach the child
   *   open / close to
   * * `type` - `false` to disable the details display, `inline` or `column`
   *   for the two control types
   *
   * @type {Object|string}
   */
  details: {
    display: jo.display.childRow,
    renderer: jo.renderer.listHidden(),
    target: 0,
    type: "inline"
  },
  /**
   * Orthogonal data request option. This is used to define the data type
   * requested when Responsive gets the data to show in the child row.
   *
   * @type {String}
   */
  orthogonal: "display"
};
var cd = We.fn.dataTable.Api;
cd.register("responsive()", function() {
  return this;
});
cd.register("responsive.index()", function(e) {
  return e = We(e), {
    column: e.data("dtr-index"),
    row: e.parent().data("dtr-index")
  };
});
cd.register("responsive.rebuild()", function() {
  return this.iterator("table", function(e) {
    e._responsive && e._responsive._classLogic();
  });
});
cd.register("responsive.recalc()", function() {
  return this.iterator("table", function(e) {
    e._responsive && (e._responsive._resizeAuto(), e._responsive._resize());
  });
});
cd.register("responsive.hasHidden()", function() {
  var e = this.context[0];
  return e._responsive ? We.inArray(!1, e._responsive._responsiveOnlyHidden()) !== -1 : !1;
});
cd.registerPlural(
  "columns().responsiveHidden()",
  "column().responsiveHidden()",
  function() {
    return this.iterator(
      "column",
      function(e, t) {
        return e._responsive ? e._responsive._responsiveOnlyHidden()[t] : !1;
      },
      1
    );
  }
);
jo.version = "3.0.8";
We.fn.dataTable.Responsive = jo;
We.fn.DataTable.Responsive = jo;
We(document).on("preInit.dt.dtr", function(e, t, r) {
  if (e.namespace === "dt" && (We(t.nTable).hasClass("responsive") || We(t.nTable).hasClass("dt-responsive") || t.oInit.responsive || me.defaults.responsive)) {
    var o = t.oInit.responsive;
    o !== !1 && new jo(t, We.isPlainObject(o) ? o : {});
  }
});
let xt = Su;
me.select = {};
me.select.classes = {
  checkbox: "dt-select-checkbox"
};
me.select.version = "3.1.3";
me.select.init = function(e) {
  var t = e.settings()[0];
  if (!me.versionCheck("2"))
    throw "Warning: Select requires DataTables 2 or newer";
  if (!t._select) {
    var r = e.state.loaded(), o = function(w, N, O) {
      if (!(O === null || O.select === void 0)) {
        if (e.rows({ selected: !0 }).any() && e.rows().deselect(), O.select.rows !== void 0 && e.rows(O.select.rows).select(), e.columns({ selected: !0 }).any() && e.columns().deselect(), O.select.columns !== void 0 && e.columns(O.select.columns).select(), e.cells({ selected: !0 }).any() && e.cells().deselect(), O.select.cells !== void 0)
          for (var m = 0; m < O.select.cells.length; m++)
            e.cell(O.select.cells[m].row, O.select.cells[m].column).select();
        e.state.save();
      }
    };
    e.on("stateSaveParams", function(w, N, O) {
      O.select = {}, O.select.rows = e.rows({ selected: !0 }).ids(!0).toArray(), O.select.columns = e.columns({ selected: !0 })[0], O.select.cells = e.cells({ selected: !0 })[0].map(function(m) {
        return { row: e.row(m.row).id(!0), column: m.column };
      });
    }).on("stateLoadParams", o).one("init", function() {
      o(void 0, void 0, r);
    });
    var n = t.oInit.select, a = me.defaults.select, l = n === void 0 ? a : n, i = "row", s = "api", u = !1, c = !0, g = null, p = !0, h = "td, th", v = "selected", A = !0, S = !1, b = !1, T = !1;
    t._select = {
      infoEls: []
    }, l === !0 ? (s = "os", S = !0) : typeof l == "string" ? (s = l, S = !0) : xt.isPlainObject(l) && (l.blurable !== void 0 && (u = l.blurable), l.toggleable !== void 0 && (c = l.toggleable), l.info !== void 0 && (p = l.info), l.items !== void 0 && (i = l.items), l.style !== void 0 ? (s = l.style, S = !0) : (s = "os", S = !0), l.selector !== void 0 && (h = l.selector), l.className !== void 0 && (v = l.className), l.headerCheckbox !== void 0 && (A = l.headerCheckbox), l.selectable !== void 0 && (g = l.selectable), l.keys !== void 0 && (b = l.keys), l.keysWrap !== void 0 && (T = l.keysWrap)), e.select.selector(h), e.select.items(i), e.select.style(s), e.select.blurable(u), e.select.toggleable(c), e.select.info(p), e.select.keys(b, T), e.select.selectable(g), t._select.className = v, !S && xt(e.table().node()).hasClass("selectable") && e.select.style("os"), (A || A === "select-page" || A === "select-all") && e.ready(function() {
      mR(e, A);
    });
  }
};
function Wx(e, t, r) {
  var o, n, a, l = function(s, u) {
    if (s > u) {
      var c = u;
      u = s, s = c;
    }
    var g = !1;
    return e.columns(":visible").indexes().filter(function(p) {
      return p === s && (g = !0), p === u ? (g = !1, !0) : g;
    });
  }, i = function(s, u) {
    var c = e.rows({ search: "applied" }).indexes();
    if (c.indexOf(s) > c.indexOf(u)) {
      var g = u;
      u = s, s = g;
    }
    var p = !1;
    return c.filter(function(h) {
      return h === s && (p = !0), h === u ? (p = !1, !0) : p;
    });
  };
  !e.cells({ selected: !0 }).any() && !r ? (n = l(0, t.column), a = i(0, t.row)) : (n = l(r.column, t.column), a = i(r.row, t.row)), o = e.cells(a, n).flatten(), e.cells(t, { selected: !0 }).any() ? e.cells(o).deselect() : e.cells(o).select();
}
function js(e) {
  var t = me.select.classes.checkbox;
  return e ? t.replace(/ /g, ".") : t;
}
function Os(e) {
  var t = e.settings()[0], r = t._select.selector;
  xt(e.table().container()).off("mousedown.dtSelect", r).off("mouseup.dtSelect", r).off("click.dtSelect", r), xt("body").off("click.dtSelect" + bh(e.table().node()));
}
function N_(e) {
  var t = xt(e.table().container()), r = e.settings()[0], o = r._select.selector, n;
  t.on("mousedown.dtSelect", o, function(a) {
    (a.shiftKey || a.metaKey || a.ctrlKey) && t.css("-moz-user-select", "none").one("selectstart.dtSelect", o, function() {
      return !1;
    }), window.getSelection && (n = window.getSelection());
  }).on("mouseup.dtSelect", o, function() {
    t.css("-moz-user-select", "");
  }).on("click.dtSelect", o, function(a) {
    var l = e.select.items(), i;
    if (n) {
      var s = window.getSelection();
      if ((!s.anchorNode || xt(s.anchorNode).closest("table")[0] === e.table().node()) && s !== n)
        return;
    }
    var u = e.settings()[0], c = e.table().container();
    if (xt(a.target).closest("div.dt-container")[0] == c) {
      var g = e.cell(xt(a.target).closest("td, th"));
      if (g.any()) {
        var p = xt.Event("user-select.dt");
        if (wa(e, p, [l, g, a]), !p.isDefaultPrevented()) {
          var h = g.index();
          l === "row" ? (i = h.row, jg(a, e, u, "row", i)) : l === "column" ? (i = g.index().column, jg(a, e, u, "column", i)) : l === "cell" && (i = g.index(), jg(a, e, u, "cell", i)), u._select_lastCell = h;
        }
      }
    }
  }), xt("body").on("click.dtSelect" + bh(e.table().node()), function(a) {
    if (r._select.blurable) {
      if (xt(a.target).parents().filter(e.table().container()).length || xt(a.target).parents("html").length === 0 || xt(a.target).parents("div.DTE").length)
        return;
      var l = xt.Event("select-blur.dt");
      if (wa(e, l, [a.target, a]), l.isDefaultPrevented())
        return;
      Tu(r, !0);
    }
  });
}
function wa(e, t, r, o) {
  o && !e.flatten().length || (typeof t == "string" && (t = t + ".dt"), r.unshift(e), xt(e.table().node()).trigger(t, r));
}
function Fm(e) {
  return e.mRender && e.mRender._name === "selectCheckbox";
}
function Yx(e, t) {
  if (!(e.select.style() === "api" || e.select.info() === !1)) {
    var r = e.settings()[0], o = r._select_set;
    if (!e.page.info().serverSide)
      for (var n = o.length - 1; n >= 0; n--)
        r.aIds[o[n]] || o.splice(n, 1);
    var a = o.length ? o.length : e.rows({ selected: !0 }).count(), l = e.columns({ selected: !0 }).count(), i = e.cells({ selected: !0 }).count();
    r._select_mode === "subtractive" && (a = e.page.info().recordsDisplay - o.length);
    var s = function(p, h, v) {
      p.append(
        xt('<span class="select-item"/>').append(
          e.i18n(
            "select." + h + "s",
            { _: "%d " + h + "s selected", 0: "", 1: "1 " + h + " selected" },
            v
          )
        )
      );
    }, u = xt(t), c = xt('<span class="select-info"/>');
    s(c, "row", a), s(c, "column", l), s(c, "cell", i);
    var g = u.children("span.select-info");
    g.length && g.remove(), c.text() !== "" && u.append(c);
  }
}
function mR(e, t) {
  var r = e.settings()[0], o = r.aoColumns;
  e.columns().iterator("column", function(n, a) {
    var l = o[a];
    if (Fm(l)) {
      var i = e.column(a).header(), s = xt("div.dt-column-header", i);
      if (s.length && (i = s), !xt("input", i).length) {
        var u = xt("<input>").attr({
          class: js(!1),
          type: "checkbox",
          "aria-label": e.i18n("select.aria.headerCheckbox") || "Select all rows"
        }).appendTo(i).on("change", function() {
          this.checked ? t == "select-page" ? e.rows({ page: "current" }).select() : e.rows({ search: "applied" }).select() : t == "select-page" ? e.rows({ page: "current", selected: !0 }).deselect() : e.rows({ selected: !0 }).deselect();
        }).on("click", function(c) {
          c.stopPropagation();
        });
        e.on("draw select deselect", function(c, g, p) {
          if (p === "row" || !p) {
            var h = fR(e, t);
            h.search && h.search <= h.count && h.search === h.available ? u.prop("checked", !0).prop("indeterminate", !1) : h.search === 0 && h.count === 0 ? u.prop("checked", !1).prop("indeterminate", !1) : u.prop("checked", !1).prop("indeterminate", !0);
          }
        });
      }
    }
  });
}
function gR(e) {
  var t = e.settings()[0], r = t._select.keys, o = t._select.keysWrap, n = "dts-keys-" + t.sTableId;
  r ? (xt(e.rows({ page: "current" }).nodes()).attr("tabindex", 0), e.on("draw." + n, function() {
    xt(e.rows({ page: "current" }).nodes()).attr("tabindex", 0);
  }), xt(document).on("keydown." + n, function(a) {
    var l = a.keyCode, i = document.activeElement;
    if ([9, 13, 32, 38, 40].includes(l)) {
      var s = e.rows({ page: "current" }).nodes().toArray(), u = s.indexOf(i), c = !0, g = e.page.info();
      if (u !== -1) {
        if (l === 9)
          a.shift === !1 && u === s.length - 1 ? Zi(e, "next", ":first-child") : a.shift === !0 && u === 0 ? Zi(e, "previous", ":last-child") : c = !1;
        else if (l === 13 || l === 32) {
          var p = e.row(i);
          p.selected() ? p.deselect() : p.select();
        } else l === 38 ? u > 0 ? s[u - 1].focus() : g.start > 0 ? Zi(e, "previous", ":last-child") : o && Zi(e, "last", ":last-child") : u < s.length - 1 ? s[u + 1].focus() : g.page < g.pages - 1 ? Zi(e, "next", ":first-child") : o && Zi(e, "first", ":first-child");
        c && (a.stopPropagation(), a.preventDefault());
      }
    }
  })) : (xt(e.rows().nodes()).removeAttr("tabindex"), e.off("draw." + n), xt(document).off("keydown." + n));
}
function Zi(e, t, r) {
  e.one("draw", function() {
    e.row(r).node().focus();
  }).page(t).draw(!1);
}
function fR(e, t) {
  var r = e.settings()[0], o = r._select.selectable, n = 0, a = t == "select-page" ? e.rows({ page: "current", selected: !0 }).count() : e.rows({ selected: !0 }).count(), l = t == "select-page" ? e.rows({ page: "current", selected: !0 }).count() : e.rows({ search: "applied", selected: !0 }).count();
  if (!o)
    n = t == "select-page" ? e.rows({ page: "current" }).count() : e.rows({ search: "applied" }).count();
  else
    for (var i = t == "select-page" ? e.rows({ page: "current" }).indexes() : e.rows({ search: "applied" }).indexes(), s = 0; s < i.length; s++) {
      var u = r.aoData[i[s]], c = o(u._aData, u.nTr, i[s]);
      c && n++;
    }
  return {
    available: n,
    count: a,
    search: l
  };
}
function pR(e) {
  var t = new me.Api(e);
  e._select_init = !0, e._select_mode = "additive", e._select_set = [], e.aoRowCreatedCallback.push(
    function(r, o, n) {
      var a, l, i = e.aoData[n], s = t.row(n).id();
      for ((i._select_selected || e._select_mode === "additive" && e._select_set.includes(s) || e._select_mode === "subtractive" && !e._select_set.includes(s)) && (i._select_selected = !0, xt(r).addClass(e._select.className).find("input." + js(!0)).prop("checked", !0)), a = 0, l = e.aoColumns.length; a < l; a++)
        (e.aoColumns[a]._select_selected || i._selected_cells && i._selected_cells[a]) && xt(i.anCells[a]).addClass(e._select.className);
    }
  ), hR(t), t.on("info.dt", function(r, o, n) {
    o._select.infoEls.includes(n) || o._select.infoEls.push(n), Yx(t, n);
  }), t.on("select.dtSelect.dt deselect.dtSelect.dt", function() {
    e._select.infoEls.forEach(function(r) {
      Yx(t, r);
    }), t.state.save();
  }), t.on("destroy.dtSelect", function() {
    xt(t.rows({ selected: !0 }).nodes()).removeClass(t.settings()[0]._select.className), xt("input." + js(!0), t.table().header()).remove(), Os(t), t.off(".dtSelect"), xt("body").off(".dtSelect" + bh(t.table().node()));
  });
}
function Kx(e, t, r, o) {
  var n = e[t + "s"]({ search: "applied" }).indexes(), a = n.indexOf(o), l = n.indexOf(r);
  if (!e[t + "s"]({ selected: !0 }).any() && a === -1)
    n.splice(n.indexOf(r) + 1, n.length);
  else {
    if (a > l) {
      var i = l;
      l = a, a = i;
    }
    n.splice(l + 1, n.length), n.splice(0, a);
  }
  e[t](r, { selected: !0 }).any() ? (n.splice(n.indexOf(r), 1), e[t + "s"](n).deselect()) : e[t + "s"](n).select();
}
function Tu(e, t) {
  if (t || e._select.style === "single") {
    var r = new me.Api(e);
    r.rows({ selected: !0 }).deselect(), r.columns({ selected: !0 }).deselect(), r.cells({ selected: !0 }).deselect();
  }
}
function jg(e, t, r, o, n) {
  var a = t.select.style(), l = t.select.toggleable(), i = t[o](n, { selected: !0 }).any();
  if (!(i && !l))
    if (a === "os")
      if (e.ctrlKey || e.metaKey)
        t[o](n).select(!i);
      else if (e.shiftKey)
        o === "cell" ? Wx(t, n, r._select_lastCell || null) : Kx(
          t,
          o,
          n,
          r._select_lastCell ? r._select_lastCell[o] : null
        );
      else {
        var s = t[o + "s"]({ selected: !0 });
        i && s.flatten().length === 1 ? t[o](n).deselect() : (s.deselect(), t[o](n).select());
      }
    else a == "multi+shift" && e.shiftKey ? o === "cell" ? Wx(t, n, r._select_lastCell || null) : Kx(
      t,
      o,
      n,
      r._select_lastCell ? r._select_lastCell[o] : null
    ) : t[o](n).select(!i);
}
function bh(e) {
  return e.id.replace(/[^a-zA-Z0-9\-\_]/g, "-");
}
function hR(e) {
  e.on("select", function(t, r, o, n) {
    if (o === "row") {
      var a = e.settings()[0];
      a._select_mode === "additive" ? Qx(e, a._select_set, n) : jx(e, a._select_set, n);
    }
  }), e.on("deselect", function(t, r, o, n) {
    if (o === "row") {
      var a = e.settings()[0];
      a._select_mode === "additive" ? jx(e, a._select_set, n) : Qx(e, a._select_set, n);
    }
  });
}
function Qx(e, t, r) {
  for (var o = 0; o < r.length; o++) {
    var n = e.row(r[o]).id();
    n && n !== "undefined" && !t.includes(n) && t.push(n);
  }
}
function jx(e, t, r) {
  for (var o = 0; o < r.length; o++) {
    var n = e.row(r[o]).id(), a = t.indexOf(n);
    a !== -1 && t.splice(a, 1);
  }
}
xt.each(
  [
    { type: "row", prop: "aoData" },
    { type: "column", prop: "aoColumns" }
  ],
  function(e, t) {
    me.ext.selector[t.type].push(function(r, o, n) {
      var a = o.selected, l, i = [];
      if (a !== !0 && a !== !1)
        return n;
      for (var s = 0, u = n.length; s < u; s++)
        l = r[t.prop][n[s]], l && (a === !0 && l._select_selected === !0 || a === !1 && !l._select_selected) && i.push(n[s]);
      return i;
    });
  }
);
me.ext.selector.cell.push(function(e, t, r) {
  var o = t.selected, n, a = [];
  if (o === void 0)
    return r;
  for (var l = 0, i = r.length; l < i; l++)
    n = e.aoData[r[l].row], n && (o === !0 && n._selected_cells && n._selected_cells[r[l].column] === !0 || o === !1 && (!n._selected_cells || !n._selected_cells[r[l].column])) && a.push(r[l]);
  return a;
});
var Oo = me.Api.register, md = me.Api.registerPlural;
Oo("select()", function() {
  return this.iterator("table", function(e) {
    me.select.init(new me.Api(e));
  });
});
Oo("select.blurable()", function(e) {
  return e === void 0 ? this.context[0]._select.blurable : this.iterator("table", function(t) {
    t._select.blurable = e;
  });
});
Oo("select.toggleable()", function(e) {
  return e === void 0 ? this.context[0]._select.toggleable : this.iterator("table", function(t) {
    t._select.toggleable = e;
  });
});
Oo("select.info()", function(e) {
  return e === void 0 ? this.context[0]._select.info : this.iterator("table", function(t) {
    t._select.info = e;
  });
});
Oo("select.items()", function(e) {
  return e === void 0 ? this.context[0]._select.items : this.iterator("table", function(t) {
    t._select.items = e, wa(new me.Api(t), "selectItems", [e]);
  });
});
Oo("select.keys()", function(e, t) {
  return e === void 0 ? this.context[0]._select.keys : this.iterator("table", function(r) {
    r._select || me.select.init(new me.Api(r)), r._select.keys = e, r._select.keysWrap = t, gR(new me.Api(r));
  });
});
Oo("select.style()", function(e) {
  return e === void 0 ? this.context[0]._select.style : this.iterator("table", function(t) {
    t._select || me.select.init(new me.Api(t)), t._select_init || pR(t), t._select.style = e;
    var r = new me.Api(t);
    e !== "api" ? r.ready(function() {
      Os(r), N_(r);
    }) : Os(r), wa(new me.Api(t), "selectStyle", [e]);
  });
});
Oo("select.selector()", function(e) {
  return e === void 0 ? this.context[0]._select.selector : this.iterator("table", function(t) {
    var r = new me.Api(t), o = t._select.style;
    Os(r), t._select.selector = e, o && o !== "api" ? r.ready(function() {
      Os(r), N_(r);
    }) : Os(r);
  });
});
Oo("select.selectable()", function(e) {
  let t = this.context[0];
  return e ? (t._select.selectable = e, this) : t._select.selectable;
});
Oo("select.last()", function(e) {
  let t = this.context[0];
  return e ? (t._select_lastCell = e, this) : t._select_lastCell;
});
Oo("select.cumulative()", function(e) {
  if (e)
    return this.iterator("table", function(r) {
      if (r._select_mode !== e) {
        var o = new me.Api(r);
        if (e === "subtractive") {
          var n = o.rows({ selected: !1 }).ids().toArray();
          r._select_mode = e, r._select_set.length = 0, r._select_set.push.apply(r._select_set, n);
        } else {
          var a = o.rows({ selected: !0 }).ids().toArray();
          r._select_mode = e, r._select_set.length = 0, r._select_set.push.apply(r._select_set, a);
        }
      }
    }).draw(!1);
  let t = this.context[0];
  return t && t._select_set ? {
    mode: t._select_mode,
    rows: t._select_set
  } : null;
});
md("rows().select()", "row().select()", function(e) {
  var t = this, r = [];
  return e === !1 ? this.deselect() : (this.iterator("row", function(o, n) {
    Tu(o);
    var a = o.aoData[n], l = o.aoColumns;
    if (o._select.selectable) {
      var i = o._select.selectable(a._aData, a.nTr, n);
      if (i === !1)
        return;
    }
    xt(a.nTr).addClass(o._select.className), a._select_selected = !0, r.push(n);
    for (var s = 0; s < l.length; s++) {
      var u = l[s];
      if (u.sType === null && t.columns().types(), Fm(u)) {
        var c = a.anCells;
        c && c[s] && xt("input." + js(!0), c[s]).prop("checked", !0), a._aSortData !== null && (a._aSortData[s] = null);
      }
    }
  }), this.iterator("table", function(o) {
    wa(t, "select", ["row", r], !0);
  }), this);
});
Oo("row().selected()", function() {
  var e = this.context[0];
  return !!(e && this.length && e.aoData[this[0]] && e.aoData[this[0]]._select_selected);
});
Oo("row().focus()", function() {
  var e = this.context[0];
  e && this.length && e.aoData[this[0]] && e.aoData[this[0]].nTr && e.aoData[this[0]].nTr.focus();
});
Oo("row().blur()", function() {
  var e = this.context[0];
  e && this.length && e.aoData[this[0]] && e.aoData[this[0]].nTr && e.aoData[this[0]].nTr.blur();
});
md("columns().select()", "column().select()", function(e) {
  var t = this;
  return e === !1 ? this.deselect() : (this.iterator("column", function(r, o) {
    Tu(r), r.aoColumns[o]._select_selected = !0;
    var n = new me.Api(r).column(o);
    xt(n.header()).addClass(r._select.className), xt(n.footer()).addClass(r._select.className), n.nodes().to$().addClass(r._select.className);
  }), this.iterator("table", function(r, o) {
    wa(t, "select", ["column", t[o]], !0);
  }), this);
});
Oo("column().selected()", function() {
  var e = this.context[0];
  return !!(e && this.length && e.aoColumns[this[0]] && e.aoColumns[this[0]]._select_selected);
});
md("cells().select()", "cell().select()", function(e) {
  var t = this;
  return e === !1 ? this.deselect() : (this.iterator("cell", function(r, o, n) {
    Tu(r);
    var a = r.aoData[o];
    a._selected_cells === void 0 && (a._selected_cells = []), a._selected_cells[n] = !0, a.anCells && xt(a.anCells[n]).addClass(r._select.className);
  }), this.iterator("table", function(r, o) {
    wa(t, "select", ["cell", t.cells(t[o]).indexes().toArray()], !0);
  }), this);
});
Oo("cell().selected()", function() {
  var e = this.context[0];
  if (e && this.length) {
    var t = e.aoData[this[0][0].row];
    if (t && t._selected_cells && t._selected_cells[this[0][0].column])
      return !0;
  }
  return !1;
});
md("rows().deselect()", "row().deselect()", function() {
  var e = this;
  return this.iterator("row", function(t, r) {
    var o = t.aoData[r], n = t.aoColumns;
    xt(o.nTr).removeClass(t._select.className), o._select_selected = !1, t._select_lastCell = null;
    for (var a = 0; a < n.length; a++) {
      var l = n[a];
      if (l.sType === null && e.columns().types(), Fm(l)) {
        var i = o.anCells;
        i && i[a] && xt("input." + js(!0), o.anCells[a]).prop("checked", !1), o._aSortData !== null && (o._aSortData[a] = null);
      }
    }
  }), this.iterator("table", function(t, r) {
    wa(e, "deselect", ["row", e[r]], !0);
  }), this;
});
md("columns().deselect()", "column().deselect()", function() {
  var e = this;
  return this.iterator("column", function(t, r) {
    t.aoColumns[r]._select_selected = !1;
    var o = new me.Api(t), n = o.column(r);
    xt(n.header()).removeClass(t._select.className), xt(n.footer()).removeClass(t._select.className), o.cells(null, r).indexes().each(function(a) {
      var l = t.aoData[a.row], i = l._selected_cells;
      l.anCells && (!i || !i[a.column]) && xt(l.anCells[a.column]).removeClass(t._select.className);
    });
  }), this.iterator("table", function(t, r) {
    wa(e, "deselect", ["column", e[r]], !0);
  }), this;
});
md("cells().deselect()", "cell().deselect()", function() {
  var e = this;
  return this.iterator("cell", function(t, r, o) {
    var n = t.aoData[r];
    n._selected_cells !== void 0 && (n._selected_cells[o] = !1), n.anCells && !t.aoColumns[o]._select_selected && xt(n.anCells[o]).removeClass(t._select.className);
  }), this.iterator("table", function(t, r) {
    wa(e, "deselect", ["cell", e[r]], !0);
  }), this;
});
function Ss(e, t) {
  return function(r) {
    return r.i18n("buttons." + e, t);
  };
}
function Zg(e) {
  var t = e._eventNamespace;
  return "draw.dt.DT" + t + " select.dt.DT" + t + " deselect.dt.DT" + t;
}
function xR(e, t) {
  return !!(t.limitTo.indexOf("rows") !== -1 && e.rows({ selected: !0 }).any() || t.limitTo.indexOf("columns") !== -1 && e.columns({ selected: !0 }).any() || t.limitTo.indexOf("cells") !== -1 && e.cells({ selected: !0 }).any());
}
var zg = 0;
xt.extend(me.ext.buttons, {
  selected: {
    text: Ss("selected", "Selected"),
    className: "buttons-selected",
    limitTo: ["rows", "columns", "cells"],
    init: function(e, t, r) {
      var o = this;
      r._eventNamespace = ".select" + zg++, e.on(Zg(r), function() {
        o.enable(xR(e, r));
      }), this.disable();
    },
    destroy: function(e, t, r) {
      e.off(r._eventNamespace);
    }
  },
  selectedSingle: {
    text: Ss("selectedSingle", "Selected single"),
    className: "buttons-selected-single",
    init: function(e, t, r) {
      var o = this;
      r._eventNamespace = ".select" + zg++, e.on(Zg(r), function() {
        var n = e.rows({ selected: !0 }).flatten().length + e.columns({ selected: !0 }).flatten().length + e.cells({ selected: !0 }).flatten().length;
        o.enable(n === 1);
      }), this.disable();
    },
    destroy: function(e, t, r) {
      e.off(r._eventNamespace);
    }
  },
  selectAll: {
    text: Ss("selectAll", "Select all"),
    className: "buttons-select-all",
    action: function(e, t, r, o) {
      var n = this.select.items(), a = o.selectorModifier;
      a ? (typeof a == "function" && (a = a.call(t, e, t, r, o)), this[n + "s"](a).select()) : this[n + "s"]().select();
    }
    // selectorModifier can be specified
  },
  selectNone: {
    text: Ss("selectNone", "Deselect all"),
    className: "buttons-select-none",
    action: function() {
      Tu(this.settings()[0], !0);
    },
    init: function(e, t, r) {
      var o = this;
      r._eventNamespace = ".select" + zg++, e.on(Zg(r), function() {
        var n = e.rows({ selected: !0 }).flatten().length + e.columns({ selected: !0 }).flatten().length + e.cells({ selected: !0 }).flatten().length;
        o.enable(n > 0);
      }), this.disable();
    },
    destroy: function(e, t, r) {
      e.off(r._eventNamespace);
    }
  },
  showSelected: {
    text: Ss("showSelected", "Show only selected"),
    className: "buttons-show-selected",
    action: function(e, t) {
      if (t.search.fixed("dt-select"))
        t.search.fixed("dt-select", null), this.active(!1);
      else {
        var r = t.settings()[0].aoData;
        t.search.fixed("dt-select", function(o, n, a) {
          return r[a]._select_selected;
        }), this.active(!0);
      }
      t.draw();
    }
  }
});
xt.each(["Row", "Column", "Cell"], function(e, t) {
  var r = t.toLowerCase();
  me.ext.buttons["select" + t + "s"] = {
    text: Ss("select" + t + "s", "Select " + r + "s"),
    className: "buttons-select-" + r + "s",
    action: function() {
      this.select.items(r);
    },
    init: function(o) {
      var n = this;
      this.active(o.select.items() === r), o.on("selectItems.dt.DT", function(a, l, i) {
        n.active(i === r);
      });
    }
  };
});
me.type("select-checkbox", {
  className: "dt-select",
  detect: me.versionCheck("2.1") ? {
    oneOf: function() {
      return !1;
    },
    allOf: function() {
      return !1;
    },
    init: function(e, t, r) {
      return Fm(t);
    }
  } : function(e) {
    return e === "select-checkbox" ? e : !1;
  },
  order: {
    pre: function(e) {
      return e === "X" ? -1 : 0;
    }
  }
});
xt.extend(!0, me.defaults.oLanguage, {
  select: {
    aria: {
      rowCheckbox: "Select row"
    }
  }
});
me.render.select = function(e, t) {
  var r = e ? me.util.get(e) : null, o = t ? me.util.get(t) : null, n = function(a, l, i, s) {
    var u = s.settings.aoData[s.row], c = u._select_selected, g = s.settings.oLanguage.select.aria.rowCheckbox, p = s.settings._select.selectable;
    if (l === "display") {
      if (p) {
        var h = p(i, u.nTr, s.row);
        if (h === !1)
          return "";
      }
      return xt("<input>").attr({
        "aria-label": g,
        class: js(),
        name: o ? o(i) : null,
        type: "checkbox",
        value: r ? r(i) : null,
        checked: c
      }).on("input", function(v) {
        v.preventDefault(), this.checked = xt(this).closest("tr").hasClass("selected");
      })[0];
    } else {
      if (l === "type")
        return "select-checkbox";
      if (l === "filter")
        return "";
    }
    return c ? "X" : "";
  };
  return n._name = "selectCheckbox", n;
};
me.ext.order["select-checkbox"] = function(e, t) {
  return this.api().column(t, { order: "index" }).nodes().map(function(r) {
    return e._select.items === "row" ? xt(r).parent().hasClass(e._select.className).toString() : e._select.items === "cell" ? xt(r).hasClass(e._select.className).toString() : !1;
  });
};
xt.fn.DataTable.select = me.select;
xt(document).on("i18n.dt.dtSelect preInit.dt.dtSelect", function(e, t) {
  e.namespace === "dt" && me.select.init(new me.Api(t));
});
const vR = { class: "row row-sm list-group" }, SR = { class: "col-md-12 col-lg-12" }, bR = { class: "d-flex align-items-center justify-content-end ps-1 gap-1" }, yR = { class: "multiselect__placeholder" }, wR = { key: 0 }, _R = ["colspan", "rowspan", "innerHTML"], TR = { key: 0 }, AR = ["innerHTML"], PR = { key: 0 }, MR = /* @__PURE__ */ wt({
  __name: "DataGroup",
  props: {
    propsApiCall: {
      type: Boolean,
      default: !1
    },
    propsBlade: {
      type: Object,
      required: !0
    },
    propsData: {
      type: Object,
      default: []
    },
    propsDataRenderTerm: {
      type: Object
    },
    propsDefaultIdx: {
      type: String,
      required: !0
    },
    propsFooterCallback: {
      type: Function
    },
    propsFooterRow: {
      type: Number,
      default: 1
    },
    propsLastElement: {
      type: Boolean,
      default: !1
    },
    propsLoading: {
      type: Object
    },
    propsMeta: {
      type: Object
    },
    propsPreData: {
      type: Function
    },
    propsRowCallback: {
      type: Array
    },
    propsStore: {
      type: Object,
      required: !0
    },
    propsTableAction: {
      type: Object,
      required: !0
    },
    propsTableColumnInitHide: {
      type: Object,
      default: {}
    },
    propsTableColumnReorder: {
      type: Boolean,
      default: !1
    },
    propsTableColumnVisible: {
      type: Boolean,
      default: !1
    },
    propsTableColumnVisibleType: {
      type: String,
      default: "default"
    },
    propsTableOption: {
      type: Object,
      required: !0
    },
    propsTablePreRender: {
      type: Function
    },
    propsTableSelect: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["onLeftClick", "onPostRefresh", "onPostTableRender", "onRightClick", "onRowSelect"],
  setup(e, { emit: t }) {
    const r = t, { t: o } = Gn(), n = J0;
    n.use(me), n.use(me), n.use(me), n.use(me);
    const {
      mxLGState: a,
      initListGroup: l,
      getColumnKey: i,
      getTableColumnsDefs: s,
      getTableLocale: u,
      getTableScreenSize: c,
      getTableSorting: g,
      onDisabledDefaultRightClick: p,
      onPreDataRender: h,
      onResetSelection: v,
      onToggleProcessing: A,
      vTableColumns: S,
      vTableFooters: b,
      vTableHeaders: T
    } = q0(), {
      mxLGCVState: w,
      initListColumnVisible: N,
      onFilterColumnsAndGetRemovedIds: O,
      onToggleColumn: m,
      onUpdateColumn: _,
      vTableColumnVisibility: X
    } = Zw(), $ = e, E = () => {
      const ae = $.propsBlade.columns;
      return Object.keys(ae).filter((F) => !ae[F].exclude);
    }, D = () => "responsive" in $.propsTableOption ? $.propsTableOption.responsive : !1, U = Ee(), Y = Ee(), G = Ee(), K = dt({
      dLoading: $.propsLoading && "dLoading" in $.propsLoading ? $.propsLoading.dLoading : !1,
      pgLoading: $.propsLoading && "loading" in $.propsLoading ? $.propsLoading.loading : !1,
      tableFrame: "bFrame" in $.propsTableOption ? $.propsTableOption.bFrame : !0,
      tableFooterRow: $.propsFooterRow,
      tableInfo: "bInfo" in $.propsTableOption ? $.propsTableOption.bInfo : !0,
      tableLoading: "url" in $.propsTableOption ? $.propsTableOption.url === "-1" : !1,
      tableInitPageLength: "initPLength" in $.propsTableOption ? $.propsTableOption.initPLength : 50,
      tableMeta: $.propsMeta,
      tablePageLength: "pLength" in $.propsTableOption ? $.propsTableOption.pLength : 100,
      tablePaging: "paging" in $.propsTableOption ? $.propsTableOption.paging : !0,
      tableSelect: $.propsTableSelect,
      tableSelectStyle: "tStyle" in $.propsTableOption ? $.propsTableOption.tStyle : "os",
      tableUrl: "url" in $.propsTableOption ? $.propsTableOption.url : $.propsStore.action.getUrlByKey($.propsTableOption.action)
    }), W = dt({
      blade: $.propsBlade,
      datas: $.propsData,
      draw: 0,
      loading: !0,
      options: {
        bInfo: K.tableInfo,
        fixedHeader: !0,
        language: u($o($.propsStore.user), K.tableLoading),
        lengthChange: !0,
        lengthMenu: [[K.tableInitPageLength, 100, 200, -1], [K.tableInitPageLength, 100, 200, o("all")]],
        pageLength: K.tablePageLength,
        paging: K.tablePaging,
        pagingType: "simple_numbers",
        processing: !0,
        ajax: $.propsApiCall ? function(ae, F) {
          let le = K.tableMeta && !En(K.tableMeta);
          $.propsStore.user.getTestMode() && console.debug("ajax callback", {
            data: W.datas,
            recordsTotal: le ? Number(K.tableMeta.total) : W.datas.length,
            recordsFiltered: le ? Number(K.tableMeta.total) : W.datas.length,
            draw: ae.draw
          }), F({
            data: W.datas,
            recordsTotal: le ? Number(K.tableMeta.total) : W.datas.length,
            recordsFiltered: le ? Number(K.tableMeta.total) : W.datas.length,
            draw: ae.draw
          });
        } : !1,
        preDrawCallback: function(ae) {
          if ($.propsStore.user.getTestMode() && console.debug("preDrawCallback", ae), W.loading = !0, $.propsTablePreRender) {
            let F = ae.aoColumns[ae.aaSorting[0][0]].mData;
            if (F.includes(".") && !F.includes("meta"))
              F.includes("attributes") ? F = F.split(".")[1].toString() : F = i(F);
            else if (F.includes(".") && F.includes("meta")) {
              const te = Object.entries($.propsBlade.columns).find(([ie, B]) => B.data === F);
              if (te)
                F = te[0];
              else {
                const ie = ["created", "updated", "last_login"], B = F.split(".")[1].toString();
                F = ie.includes(B) ? B + "_at" : B;
              }
            } else
              F = i(F);
            let le = {
              locale: $.propsStore.user.getLanguage(),
              includes: W.blade.includes,
              page: ae._iDisplayLength ? ae._iDisplayStart / ae._iDisplayLength + 1 : 1,
              perpage: ae._iDisplayLength > 0 ? ae._iDisplayLength : "all",
              sort_field: W.draw ? F : W.blade.sort.column,
              sort_direction: W.draw ? ae.aaSorting[0][1] : W.blade.sort.direction
            };
            $.propsTablePreRender(le, ae.iDraw);
          }
        },
        footerCallback: function(ae, F, le, te, ie) {
          $.propsFooterCallback && a.table.cKey > 0 && $.propsFooterCallback(ae, F, le, te, ie);
        },
        initComplete: function(ae, F) {
          $.propsStore.user.getTestMode() && console.debug("initComplete", ae, F), a.table.cKey === 0 && (W.loading && (W.loading = !1, r("onPostTableRender", { isLoading: W.loading })), $.propsStore.action.setListLoading(!1), a.table.cKey++);
        },
        rowCallback: (ae, F) => {
          ae.addEventListener("mousedown", (le) => {
            if (!(a.table.selected.total > 1) && le.button === 2) {
              F[$.propsDefaultIdx] != a.table.selected.ids[0] ? r("onLeftClick", le) : a.table.selected.ids[0] && r("onRightClick", le);
              return;
            }
          }), ue(ae, F);
        },
        orderCellsTop: !0,
        responsive: D(),
        scrollX: !D(),
        scrollY: D() ? "" : `${c($o($.propsStore.user)).height}px`,
        scrollCollapse: !0,
        searching: !1,
        serverSide: $.propsApiCall,
        select: K.tableSelect ? { style: K.tableSelectStyle } : !1,
        columnDefs: s({ fDPlace: 3, tSelect: K.tableSelect }),
        colReorder: $.propsTableColumnReorder,
        order: K.tableLoading ? [] : g(K.tableSelect, E(), $.propsBlade.sort)
      }
    });
    Nn(() => {
      l(Y, {
        dataRenderTerm: $.propsDataRenderTerm,
        preData: $.propsPreData,
        tBlade: W.blade,
        tColumnName: E(),
        tColumns: $.propsBlade.columns,
        tAction: $.propsTableAction
      }), $.propsTableColumnVisible && (N(Y, {
        tColumns: $.propsBlade.columns,
        tSelect: $.propsTableSelect,
        tHideColumns: $.propsTableColumnInitHide
      }), O(X.value));
    }), or(async () => {
      p(), $.propsTableColumnVisible && (await Kr(), w.initHideColumns.forEach((ae) => {
        m(ae);
      }));
    });
    const xe = (ae, F, le, te) => {
      if (F) {
        let ie = F.rows(te).data().toArray();
        for (let B in ie)
          $.propsDefaultIdx in ie[B] && (a.table.selected.ids.includes(ie[B][$.propsDefaultIdx]) || (a.table.selected.ids.push(ie[B][$.propsDefaultIdx]), a.table.selected.rows.push(ie[B])));
        a.table.selected.total = a.table.selected.ids.length, r("onRowSelect", a.table.selected.rows);
      }
    }, Ce = (ae, F, le, te) => {
      if (F) {
        let ie = F.rows(te).data().toArray();
        for (let B in ie) {
          const I = a.table.selected.ids.indexOf(ie[B][$.propsDefaultIdx]);
          I !== -1 && (a.table.selected.ids.splice(I, 1), a.table.selected.rows.splice(I, 1));
        }
        a.table.selected.total = a.table.selected.ids.length, r("onRowSelect", a.table.selected.rows);
      }
    }, Q = (ae, F) => {
      if ($.propsStore.user.getTestMode() && console.debug("onDrawCallback", ae, F), W.draw > 0 && (v(), r("onPostRefresh", { isDisabled: !1, isReset: !0 }), a.table.cKey))
        for (let le of document.getElementsByClassName("dt-empty"))
          le.innerHTML = W.options.language.zeroRecords;
      W.loading && (W.loading = !1, r("onPostTableRender", { isLoading: W.loading })), $.propsStore.action.setListLoading(!1);
    }, ue = (ae, F) => {
      let le = [
        { className: "table-row-wdanger", column: "status", columnValue: "INACTIVE" }
      ];
      $.propsRowCallback instanceof Array && $.propsRowCallback.forEach((te) => {
        let ie = !1;
        le.forEach((B) => {
          te.column === B.column && "columnValue" in te && "columnValue" in B && te.columnValue === B.columnValue && (B.className = te.className, ie = !0);
        }), ie || le.push(te);
      });
      for (const te of le) {
        let ie, B;
        if ("columnValue" in te) {
          const I = te.column.split("|"), ee = String(te.columnValue).split("|");
          I.every((pe, Ke) => {
            let Oe = F;
            return pe.split(".").forEach((Be) => {
              Oe = Oe?.[Be];
            }), String(Oe) === (ee[Ke] ?? "");
          }) && (ie = te.className);
        }
        if ("condition" in te) {
          const I = te.column.split("|")[0];
          B = F, I.split(".").forEach((ee) => {
            B = B?.[ee];
          }), te.condition?.(B) && (ie = te.className);
        }
        if (ie) {
          typeof ie == "string" ? ae.classList.add(ie) : ae.classList.add(...ie);
          break;
        }
      }
      return () => {
      };
    };
    El(G, (ae) => {
      r("onLeftClick", ae);
    });
    const V = ge(() => h(W.datas));
    return nt(() => $.propsData, (ae) => {
      W.datas = ae, K.tableMeta = $.propsMeta, a.table.cKey && ($.propsApiCall && Y.value.dt.ajax.reload(null, !1), W.draw++);
    }, { immediate: !0 }), nt(() => $.propsFooterRow, (ae) => {
      K.tableFooterRow = ae;
    }), nt(() => $.propsLoading, (ae) => {
      const F = ae && "dLoading" in ae ? ae.dLoading : !1, le = ae && "loading" in ae ? ae.loading : !1;
      K.dLoading || K.pgLoading != le && (K.dLoading = F, K.pgLoading = le, A(K.pgLoading));
    }), nt(() => ({ ...$.propsTableOption }), (ae) => {
      "url" in ae && (K.tableLoading = ae.url === "-1", K.tableUrl = ae.url);
    }, { deep: !0 }), nt(() => $.propsStore.user.getLanguage(), (ae, F) => {
      ae != F && (W.options.language = u($o($.propsStore.user), K.tableLoading), a.table.cKey += 1);
    }), nt(() => $.propsStore.action.lists.isLoaded, (ae) => {
      K.dLoading && A(!ae);
    }), nt(() => $.propsTableColumnInitHide, (ae, F) => {
      if (ae) {
        const le = [], te = [];
        Object.keys(ae).forEach((I) => {
          ae[I] !== F[I] && (ae[I] ? te : le).push(I);
        }), _(ae), O(X.value);
        const ie = w.selectedColumns.filter((I) => le.includes(I.code)), B = w.initHideColumns.filter((I) => te.includes(I.code));
        [...ie, ...B].forEach((I) => {
          m(I);
        });
      }
    }), (ae, F) => (C(), k("div", vR, [
      L("div", SR, [
        L("div", bR, [
          e.propsTableColumnVisible && e.propsTableColumnVisibleType == "default" ? (C(), k("div", {
            key: 0,
            class: "p-none",
            ref_key: "cVisibleDiv",
            ref: U
          }, [
            vt(R(Wa), ht({ name: "t-columns" }, R(w).dSelectColumnSettings, {
              "custom-label": ({ name: le }) => R(ni)(ae.$t(le)),
              placeholder: ae.$t("column_visibility"),
              selectedLabel: ae.$t("selected"),
              options: R(X),
              onSelect: R(m),
              onRemove: R(m),
              modelValue: R(w).selectedColumns,
              "onUpdate:modelValue": F[0] || (F[0] = (le) => R(w).selectedColumns = le)
            }), {
              selection: je(({ values: le, search: te, isOpen: ie }) => [
                L("span", yR, _e(ae.$t("column_visibility")), 1),
                le.length ? (C(), k("span", wR)) : q("", !0)
              ]),
              _: 1
            }, 16, ["custom-label", "placeholder", "selectedLabel", "options", "onSelect", "onRemove", "modelValue"])
          ], 512)) : q("", !0)
        ]),
        L("div", {
          class: $e(["card custom-card mb-2", { "mb-0": e.propsLastElement, shimmer: K.tableLoading }])
        }, [
          L("div", {
            class: $e(["card-body data-group", { "p-1": !K.tableFrame, "m-group": R(T)[2].length }])
          }, [
            be(ae.$slots, "header", {}, void 0, !0),
            be(ae.$slots, "default", {}, void 0, !0),
            F[1] || (F[1] = L("div", { class: "scroll-wrapper" }, [
              L("div", { id: "scroll" })
            ], -1)),
            (C(), ft(R(n), {
              class: "table table-bordered table-hover table-striped dataTable nowrap",
              key: R(a).table.cKey,
              ref_key: "dataTable",
              ref: Y,
              columns: R(S),
              options: W.options,
              onSelect: xe,
              onDeselect: Ce,
              data: V.value,
              onDraw: Q
            }, {
              default: je(() => [
                L("thead", null, [
                  L("tr", null, [
                    (C(!0), k(De, null, rt(R(T)[1], (le, te) => (C(), k("th", {
                      key: te,
                      class: $e(["th-header", le.className]),
                      colspan: le.colspan,
                      rowspan: le.rowspan,
                      innerHTML: le.label ? ae.$t(le.label) : ""
                    }, null, 10, _R))), 128))
                  ]),
                  R(T)[2].length > 0 ? (C(), k("tr", TR, [
                    (C(!0), k(De, null, rt(R(T)[2], (le, te) => (C(), k("th", {
                      key: te,
                      class: $e(["th-header", le.className]),
                      innerHTML: le.label ? ae.$t(le.label) : ""
                    }, null, 10, AR))), 128))
                  ])) : q("", !0)
                ]),
                L("tbody", {
                  ref_key: "dataTableBody",
                  ref: G
                }, null, 512),
                e.propsFooterCallback ? (C(), k("tfoot", PR, [
                  (C(!0), k(De, null, rt(K.tableFooterRow, (le) => (C(), k("tr", null, [
                    (C(!0), k(De, null, rt(R(b), (te, ie) => (C(), k("th", {
                      key: ie,
                      class: $e(["th-footer", te.className])
                    }, null, 2))), 128))
                  ]))), 256))
                ])) : q("", !0)
              ]),
              _: 1
            }, 8, ["columns", "options", "data"]))
          ], 2)
        ], 2)
      ])
    ]));
  }
}), A0e = /* @__PURE__ */ _m(MR, [["__scopeId", "data-v-6e54292c"]]), $R = () => {
  const e = {
    // scrollBody: '.dataTables_scrollBody',
    // scrollHead: '.dataTables_scrollHead',
    // scrollHeadInner: '.dataTables_scrollHeadInner'
    scrollBody: ".dt-scroll-body",
    scrollHead: ".dt-scroll-head",
    scrollHeadInner: ".dt-scroll-headInner"
  }, t = (a) => document.querySelectorAll(a), r = (a) => {
    let l;
    switch (a) {
      case "scrollBody":
        l = t(e.scrollBody);
        break;
      case "scrollHead":
        l = t(e.scrollHead);
        break;
      case "scrollHeadInner":
        l = t(e.scrollHeadInner);
        break;
    }
    return l;
  }, o = (a, l) => {
    const i = r("scrollBody");
    let s = 0;
    a > 0 ? i && i.length !== 0 && (s = 0 - i[0].scrollLeft, l === 0 && (l = 0 - s), n(s, l)) : n(s, l);
  }, n = (a, l) => {
    const i = r("scrollHead"), s = r("scrollHeadInner"), u = r("scrollBody");
    i && i.length !== 0 && (i[0].scrollLeft = u[0].scrollLeft, i[0].style.setProperty("left", a + "px"), s && s.length !== 0 && s[0].style.setProperty("left", l + "px"));
  };
  return {
    onDataTableScroll: o,
    onUpdateScrollHead: n
  };
}, CR = () => {
  const { t: e } = Gn(), { onDataTableScroll: t } = $R();
  let r = Ee();
  const o = dt({
    tBlade: {},
    tDefaultIdx: "",
    tDefer: {},
    tUrl: ""
  }), n = dt({
    bFilter: {
      isShow: !1
    },
    bFilterOpen: {},
    bPreSet: !1,
    bSearching: !1,
    bTableDirectFilter: !0,
    bTableResponsive: !1,
    bTestMode: !1,
    vFilterExcludes: [],
    vFilterCount: 0,
    vLoadCount: 0,
    vTHeadCurrentScroll: 0,
    filter: {},
    oFilter: {},
    sParams: {}
  }), a = (E, D, U = {}) => {
    r = E, o.tBlade = "tBlade" in D ? D.tBlade : {}, o.tDefaultIdx = "tDefaultIdx" in D ? D.tDefaultIdx : "id", o.tDefer = "tDefer" in D ? D.tDefer : { defer: !1, init: !0 }, o.tUrl = "tUrl" in D ? D.tUrl : "", n.bTableDirectFilter = "isTDirectFilter" in U ? U.isTDirectFilter : !0, n.bTableResponsive = "isTResponsive" in U ? U.isTResponsive : !1, n.bTestMode = "isTestMode" in U ? U.isTestMode : !1, n.filter = "filter" in D ? D.filter : [], n.oFilter = n.filter;
  }, l = (E) => !!(typeof E == "object" && "multi" in E && E.multi), i = () => n.sParams, s = () => {
  }, u = () => {
    b();
  }, c = (E) => {
    E in n.filter && (n.filter[E] || (n.filter[E] = ""), delete n.filter[E + "-from"], delete n.filter[E + "-to"], n.bTableDirectFilter && b());
  }, g = () => {
    b(), setTimeout(() => {
    }, 200);
  }, p = (E) => {
    const D = n.filter[E];
    if (D) {
      let U = "", Y = "", G = "", K = "", W = "", xe = "";
      D.length ? (D[0] && (U = ("0" + D[0].getDate()).slice(-2), Y = ("0" + (D[0].getMonth() + 1)).slice(-2), G = D[0].getFullYear(), n.filter[E + "-from"] = `${G}-${Y}-${U}`), D[1] ? (K = ("0" + D[1].getDate()).slice(-2), W = ("0" + (D[1].getMonth() + 1)).slice(-2), xe = D[1].getFullYear(), n.filter[E + "-to"] = `${xe}-${W}-${K}`) : delete n.filter[E + "-to"], n.vFilterExcludes.includes(E) || n.vFilterExcludes.push(E)) : D && (U = ("0" + D.getDate()).slice(-2), Y = ("0" + (D.getMonth() + 1)).slice(-2), G = D.getFullYear(), n.filter[E] = `${G}-${Y}-${U}`), n.bTableDirectFilter && b();
    }
  }, h = (E) => {
    const D = E.target.name, Y = document.getElementsByName(`${D}`)[0];
    n.bTableResponsive || (Y.value = n.filter[Y.name]), n.filter[Y.name] == "" && n.bTableDirectFilter && b();
  }, v = (E) => {
    (E.code || E.code == "") && n.bTableDirectFilter && b();
  }, A = (E, D) => {
    n.bFilterOpen[E] = D == "open", w(D);
  }, S = () => {
    if (!n.bPreSet) {
      for (let E in o.tBlade.conditions)
        o.tBlade.conditions[E] && E in o.tBlade.columns && o.tBlade.columns[E].filter && Jp(o.tBlade.columns[E].filter) && o.tBlade.columns[E].filter.type == "select" && (n.filter[E] = o.tBlade.columns[E].filter.options.find(
          (D) => D.code == o.tBlade.conditions?.[E]
        ));
      n.bPreSet = !0;
    }
  }, b = () => {
    if (n.bSearching)
      return;
    n.bSearching = !0;
    const E = r.value.dt, D = n.bTableDirectFilter ? document.getElementsByClassName("col-filter") : document.getElementsByClassName("drp-filter");
    n.oFilter = { ...n.filter };
    let U = { ...n.filter };
    for (let G of D)
      if (G instanceof HTMLInputElement)
        G.tagName == "INPUT";
      else {
        let K = _(G);
        if ("selName" in K) {
          let W = K.selName;
          if (K.status)
            if ("isMulti" in K && K.isMulti) {
              if (U[W] = [], n.filter[W].length)
                for (const xe of n.filter[W])
                  U[W].push(xe.code);
              U[W] = U[W].toString();
            } else
              U[W] = n.filter[W].code, ["-", "--"].includes(U[W]) && (U[W] = "");
          else
            "isMulti" in K && K.isMulti && (U[W] = "");
        }
      }
    const Y = { ...U };
    for (let G in U)
      if (!U[G]) {
        if (!U[G] && !n.oFilter[G]) {
          delete U[G];
          continue;
        }
        if (!U[G] && "length" in n.oFilter[G] && !n.oFilter[G].length) {
          delete U[G];
          continue;
        }
        if (n.oFilter[G] && "code" in n.oFilter[G] && ["ALL", "", "-", "--"].includes(n.oFilter[G].code)) {
          delete U[G];
          continue;
        }
      }
    if (n.vFilterExcludes.length > 0)
      for (let G of n.vFilterExcludes)
        delete U[G];
    if (o.tBlade?.conditions)
      for (let G in o.tBlade?.conditions)
        G in U && U[G] && delete o.tBlade?.conditions[G], G in Y && !Y[G] && delete o.tBlade?.conditions[G], G.includes("-") && Y[G.split("-")[0]] && (delete Y[G.split("-")[0]], delete U[G.split("-")[0]]);
    if ("defer" in o.tDefer && o.tDefer.defer && (o.tDefer.defer = !1), n.bTestMode && console.debug("params", U), n.sParams = U, !En(U) || n.bTableDirectFilter) {
      const G = new URLSearchParams(U).toString();
      E.ajax.url(`${o.tUrl}?${G}`).load(), n.vLoadCount++;
    } else {
      if (n.vLoadCount > 0) {
        const G = new URLSearchParams({ [o.tDefaultIdx]: "stop-99" }).toString();
        E.ajax.url(`${o.tUrl}?${G}`).load(), n.vLoadCount = 0;
      }
      n.bSearching = !1;
    }
  }, T = () => {
    t(0, n.vTHeadCurrentScroll), setTimeout(() => {
      const E = document.getElementsByClassName("th-header");
      var D = [];
      [].forEach.call(E, function(Y, G) {
        Y.classList.contains("dtr-hidden") && D.push(G);
      });
      const U = document.getElementsByClassName("th-filter");
      [].forEach.call(U, function(Y, G) {
        D.includes(G) ? Y.classList.add("d-none") : Y.classList.remove("d-none");
      });
    }, 100);
  }, w = (E = "", D = !1) => {
    const U = document.querySelectorAll(".dt-scroll"), Y = document.querySelectorAll(".dt-scroll-head"), G = document.querySelectorAll(".dt-scroll-headInner"), K = document.querySelectorAll(".dt-scroll-body");
    Y.length && (E == "open" ? n.vFilterCount++ : (n.vFilterCount--, n.vTHeadCurrentScroll = 0), n.vFilterCount > 0 ? (U[0].classList.add("s-disabled"), Y[0].classList.add("open"), G[0].classList.add("open"), K[0].classList.add("s-disabled"), t(n.vFilterCount, n.vTHeadCurrentScroll)) : (U[0].classList.remove("s-disabled"), Y[0].classList.remove("open"), G[0].classList.remove("open"), K[0].classList.remove("s-disabled"), t(n.vFilterCount, n.vTHeadCurrentScroll)));
  }, N = () => {
    n.bFilter.isShow = !n.bFilter.isShow, n.bTableDirectFilter = !n.bFilter.isShow;
  }, O = (E) => {
    o.tUrl = E;
  }, m = (E, D) => {
    const U = E.target.name, G = document.getElementsByName(`${U}`)[0];
    setTimeout(() => {
      D == "decimal" && !ci(E) && (G.value = n.filter[G.name] = ""), D == "number" && !va(E) && (G.value = n.filter[G.name] = "");
    }, 1);
  }, _ = (E, D = !1) => {
    let U = E.querySelector(".multiselect__input");
    const Y = U.closest(".sel-multi");
    if (U) {
      let G = U.getAttribute("name");
      if (D && (o.tDefer.init ? n.filter[G] || (n.filter[G] = { id: "-1", code: "", name: e("all") }) : Y ? n.filter[G] = [] : n.filter[G] = { id: "-1", code: "--", name: "" }), n.filter[G] && (n.filter[G].code || n.filter[G].code == "")) {
        U.setAttribute("data-type", "select"), U.setAttribute("value", n.filter[G].code);
        const K = U.parentNode?.querySelector(".multiselect__single");
        return K && (K.innerHTML = n.filter[G].name, !o.tDefer.init && n.filter[G].code == "" && setTimeout(() => {
          const W = U.parentNode?.querySelector(
            ".multiselect__placeholder"
          );
          W && (W.innerHTML = e("all"));
        }, 500)), {
          status: !0,
          selName: G
        };
      } else return Y ? n.filter[G] && n.filter[G].length ? {
        status: !0,
        isMulti: !0,
        selName: G
      } : {
        status: !1,
        isMulti: !0,
        selName: G
      } : {
        status: !1,
        selName: G
      };
    }
    return {
      status: !1
    };
  }, X = ge(() => !!n.bFilter.isShow), $ = ge(
    () => Object.keys(o.tBlade.columns).filter((E) => !o.tBlade.columns[E].exclude).map((E, D) => ({
      key: E,
      data: o.tBlade.columns[E].data,
      label: o.tBlade.columns[E].label,
      filter: o.tBlade.columns[E].filter
    }), {})
  );
  return {
    mxLGFTState: n,
    initListGroupFilter: a,
    isMultiSelect: l,
    getSearchParams: i,
    onCardFilterClear: s,
    onCardFilterSearch: u,
    onClearDateRange: c,
    onDropdownFilterSearch: g,
    onFilterDateRange: p,
    onFilterInput: h,
    onFilterSelect: v,
    onFocusSelect: A,
    onPreSetFilter: S,
    onSearch: b,
    onSwitchFilter: T,
    onToggleDatePicker: w,
    onToggleDropdownFilter: N,
    onUpdateUrl: O,
    onValidateInput: m,
    setFilterSelect: _,
    bShowFilter: X,
    vTableSearchHeaders: $
  };
}, D_ = "--vc-auto-duration", LR = `height var(${D_}) cubic-bezier(0.33, 1, 0.68, 1)`, rc = { padding: 0 }, ER = 300, OR = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: "0"
};
function Zx(e) {
  return e.value ? parseFloat(getComputedStyle(e.value).height) : 0;
}
function zx(e) {
  if (!e.value) return {};
  const { transition: t } = getComputedStyle(e.value);
  return t === "all 0s ease 0s" || t === "all" ? { transition: LR } : { transition: t };
}
function qx(e) {
  if (!e.value) return !0;
  const { transition: t } = getComputedStyle(e.value);
  return typeof window.requestAnimationFrame > "u" || window.matchMedia("(prefers-reduced-motion: reduce)").matches || t.includes("none") || t.includes("height 0s");
}
function NR(e = 0) {
  if (e === 0) return 0;
  const t = e / 36, r = Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
  return Number.isFinite(r) ? r : 0;
}
const yh = /* @__PURE__ */ wt({
  inheritAttrs: !0,
  __name: "Collapse",
  props: {
    when: { type: Boolean },
    baseHeight: { default: 0 },
    as: { default: "div" }
  },
  emits: ["collapse", "expand", "collapsed", "expanded"],
  setup(e, { emit: t }) {
    const r = e, o = t, n = Ua(r, "when"), a = Ua(r, "baseHeight"), l = ge(() => ({ overflow: "hidden", height: `${a.value}px` })), i = ge(() => ({
      ...rc,
      ...a.value === 0 ? { display: "none" } : l.value
    })), s = Ee(null), u = Ee(n.value ? "expanded" : "collapsed"), c = (m) => u.value = m;
    function g() {
      return n.value ? rc : a.value === 0 ? OR : i.value;
    }
    const p = $p(g()), h = (m) => p.value = m, v = (m) => h({ ...p.value, ...m }), A = Ee(ER), S = (m) => A.value = m, b = ge(() => ({ [D_]: `${A.value}ms` }));
    let T = NaN;
    function w() {
      h(rc), c("expanded"), o("expanded");
    }
    function N() {
      h(i.value), c("collapsed"), o("collapsed");
    }
    or(() => {
      if (!s.value) return;
      const m = NR(s.value.scrollHeight - a.value);
      m > 0 && S(m), !n.value && a.value === 0 && h(i.value);
    }), nt(n, (m) => {
      if (s.value)
        if (T = NaN, m) {
          if (qx(s)) return w();
          c("expanding"), o("expand"), h({
            ...rc,
            ...l.value,
            ...b.value
          }), requestAnimationFrame(() => {
            if (s.value) {
              if (s.value.scrollHeight === 0) return w();
              T = s.value.scrollHeight, v({
                ...zx(s),
                height: `${T}px`,
                willChange: "height"
              });
            }
          });
        } else {
          if (qx(s) || (c("collapsing"), o("collapse"), v({
            ...b.value,
            height: `${s.value.scrollHeight}px`
          }), s.value.scrollHeight === 0)) return N();
          requestAnimationFrame(() => {
            s.value && v({
              ...l.value,
              ...zx(s),
              willChange: "height"
            });
          });
        }
    }), nt(a, (m) => {
      n.value || (m > 0 ? v({ display: void 0, height: `${m}px` }) : v({ display: "none" }));
    });
    function O(m) {
      s.value && m.target && m.target === s.value && m.propertyName === "height" && (n.value ? Math.abs(s.value.scrollHeight - Zx(s)) < 1 ? w() : T < s.value.scrollHeight && v({
        height: `${s.value.scrollHeight}px`
      }) : Math.abs(a.value - Zx(s)) < 1 && N());
    }
    return (m, _) => (C(), ft(nu(r.as), {
      ref_key: "collapseRef",
      ref: s,
      style: io(p.value),
      onTransitionend: O,
      "data-collapse": u.value
    }, {
      default: je(() => [
        be(m.$slots, "default", Er(fo({ state: u.value })))
      ]),
      _: 3
    }, 40, ["style", "data-collapse"]));
  }
}), DR = () => {
  const e = dt({
    axis: {
      currentY: 0,
      startY: 0,
      translateY: 0
    },
    dragging: !1,
    fDragEnd: {},
    translateYMax: 100
  }), t = (l) => {
    e.fDragEnd = "onPostDragEnd" in l ? l.onPostDragEnd : {}, e.translateYMax = "translateYMax" in l ? l.translateYMax : 100;
  }, r = (l) => {
    e.dragging = !0, e.axis.startY = l.touches[0].clientY;
  }, o = (l) => {
    if (!e.dragging)
      return;
    e.axis.currentY = l.touches[0].clientY;
    const i = e.axis.currentY - e.axis.startY;
    e.axis.translateY = i > 0 ? i : 0;
  }, n = () => {
    e.dragging && (e.dragging = !1, e.axis.translateY > e.translateYMax && e.fDragEnd(), e.axis.translateY = 0);
  }, a = ge(() => e.dragging ? { transform: `translateY(${e.axis.translateY}px)` } : {});
  return {
    initDrag: t,
    onTouchStart: r,
    onTouchMove: o,
    onTouchEnd: n,
    vDragStateStyle: a
  };
}, kR = ["name"], GR = ["name"], BR = ["name"], IR = ["name"], RR = ["id"], FR = { class: "sArtical" }, qg = /* @__PURE__ */ wt({
  __name: "ListFilterGroup",
  props: {
    propsColumn: {
      type: Object,
      required: !0
    },
    propsDarkMode: {
      type: Boolean,
      default: !1
    },
    propsFilterClass: {
      type: String,
      default: "col-filter"
    },
    propsFilterFunction: {
      type: Object,
      required: !0
    },
    propsFilterState: {
      type: Object,
      required: !0
    },
    propsFilterType: {
      type: String,
      default: "column"
      /* card, column, dropdown */
    },
    propsIsMobile: {
      type: Boolean,
      default: !1
    },
    propsListGroupState: {
      type: Object,
      required: !0
    },
    propsLoading: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const { locale: t } = Gn(), r = Ee(null), { initDrag: o, onTouchStart: n, onTouchMove: a, onTouchEnd: l, vDragStateStyle: i } = DR(), s = e;
    Nn(() => {
      o({
        onPostDragEnd: u,
        translateYMax: 100
      });
    });
    const u = () => {
      s.propsFilterState.bFilterOpen[s.propsColumn.key] = !1;
    }, c = () => {
      s.propsFilterType != "column" || !s.propsIsMobile || r.value && r.value.activate();
    }, g = ge(() => {
      const p = s.propsFilterFunction.getSelectOption(s.propsColumn.key) || [];
      return p.length <= 3 ? "xs-short" : p.length <= 4 ? "s-short" : p.length <= 5 ? "m-short" : p.length <= 6 ? "short" : "";
    });
    return nt(t, () => {
      if ("filter" in s.propsColumn && s.propsColumn.filter && s.propsColumn.filter?.type == "select") {
        const p = s.propsFilterState.filter[s.propsColumn.key], h = s.propsFilterFunction.getSelectOption(s.propsColumn.key);
        p != null && p.id == "-1" && h.map((v) => {
          p && v.id == "-1" && v.name !== p.name && (p.name = v.name);
        });
      }
    }, { immediate: !0 }), (p, h) => e.propsLoading ? (C(), k(De, { key: 0 }, [
      e.propsColumn.filter ? (C(), k("input", {
        key: 0,
        type: "text",
        name: e.propsColumn.key,
        class: $e(["form-control", e.propsFilterClass]),
        disabled: !0
      }, null, 10, kR)) : q("", !0)
    ], 64)) : (C(), k(De, { key: 1 }, [
      e.propsColumn.filter && e.propsColumn.filter == "text" ? Qt((C(), k("input", {
        key: 0,
        type: "search",
        name: e.propsColumn.key,
        class: $e(["form-control", e.propsFilterClass]),
        "onUpdate:modelValue": h[0] || (h[0] = (v) => e.propsFilterState.filter[e.propsColumn.key] = v),
        onInput: h[1] || (h[1] = //@ts-ignore
        (...v) => e.propsFilterFunction.onFilterInput && e.propsFilterFunction.onFilterInput(...v))
      }, null, 42, GR)), [
        [Io, e.propsFilterState.filter[e.propsColumn.key]]
      ]) : q("", !0),
      e.propsColumn.filter && e.propsColumn.filter == "decimal" ? Qt((C(), k("input", {
        key: 1,
        type: "search",
        name: e.propsColumn.key,
        class: $e(["form-control", e.propsFilterClass]),
        "onUpdate:modelValue": h[2] || (h[2] = (v) => e.propsFilterState.filter[e.propsColumn.key] = v),
        onInput: h[3] || (h[3] = //@ts-ignore
        (...v) => e.propsFilterFunction.onFilterInput && e.propsFilterFunction.onFilterInput(...v)),
        onPaste: h[4] || (h[4] = (v) => e.propsFilterFunction.onValidateInput(v, e.propsColumn.filter)),
        onKeypress: h[5] || (h[5] = //@ts-ignore
        (...v) => R(ci) && R(ci)(...v))
      }, null, 42, BR)), [
        [Io, e.propsFilterState.filter[e.propsColumn.key]]
      ]) : q("", !0),
      e.propsColumn.filter && e.propsColumn.filter == "number" ? Qt((C(), k("input", {
        key: 2,
        type: "search",
        name: e.propsColumn.key,
        class: $e(["form-control", e.propsFilterClass]),
        "onUpdate:modelValue": h[6] || (h[6] = (v) => e.propsFilterState.filter[e.propsColumn.key] = v),
        onInput: h[7] || (h[7] = //@ts-ignore
        (...v) => e.propsFilterFunction.onFilterInput && e.propsFilterFunction.onFilterInput(...v)),
        onPaste: h[8] || (h[8] = (v) => e.propsFilterFunction.onValidateInput(v, e.propsColumn.filter)),
        onKeypress: h[9] || (h[9] = //@ts-ignore
        (...v) => R(va) && R(va)(...v))
      }, null, 42, IR)), [
        [Io, e.propsFilterState.filter[e.propsColumn.key]]
      ]) : q("", !0),
      e.propsColumn.filter && e.propsColumn.filter.type == "select" ? (C(), k(De, { key: 3 }, [
        vt(R(Wa), ht({
          name: e.propsColumn.key
        }, e.propsListGroupState.dSelectSettings, {
          class: ["sel-filter", e.propsFilterClass, { "sel-multi": e.propsFilterFunction.isMultiSelect(e.propsColumn.filter.settings) }],
          options: e.propsFilterFunction.getSelectOption(e.propsColumn.key),
          multiple: e.propsFilterFunction.isMultiSelect(e.propsColumn.filter.settings),
          "allow-empty": e.propsFilterFunction.isMultiSelect(e.propsColumn.filter.settings),
          "close-on-select": !e.propsFilterFunction.isMultiSelect(e.propsColumn.filter.settings),
          modelValue: e.propsFilterState.filter[e.propsColumn.key],
          "onUpdate:modelValue": h[10] || (h[10] = (v) => e.propsFilterState.filter[e.propsColumn.key] = v),
          onSelect: e.propsFilterFunction.onFilterSelect,
          onOpen: h[11] || (h[11] = (v) => {
            e.propsFilterFunction.onFocusSelect(e.propsColumn.key, "open"), c();
          }),
          onClose: h[12] || (h[12] = (v) => e.propsIsMobile ? null : e.propsFilterFunction.onFocusSelect(e.propsColumn.key, "close"))
        }), null, 16, ["name", "class", "options", "multiple", "allow-empty", "close-on-select", "modelValue", "onSelect"]),
        e.propsIsMobile && e.propsFilterType == "column" ? (C(), ft(_p, {
          key: 0,
          to: "body"
        }, [
          L("div", {
            class: $e(["modal fade backdrop", { show: e.propsFilterState.bFilterOpen[e.propsColumn.key] }]),
            id: `vue-select-${e.propsColumn.key}`
          }, [
            vt(un, { name: "slide-up" }, {
              default: je(() => [
                Qt(L("div", {
                  class: $e(["slideup-sheet", g.value]),
                  style: io(R(i)),
                  onTouchstart: h[15] || (h[15] = //@ts-ignore
                  (...v) => R(n) && R(n)(...v)),
                  onTouchmove: h[16] || (h[16] = //@ts-ignore
                  (...v) => R(a) && R(a)(...v)),
                  onTouchend: h[17] || (h[17] = //@ts-ignore
                  (...v) => R(l) && R(l)(...v))
                }, [
                  L("div", FR, [
                    (C(), ft(R(Wa), ht({
                      ref_key: "vueSelect",
                      ref: r,
                      name: e.propsColumn.key,
                      key: e.propsColumn.key
                    }, e.propsListGroupState.dSelectSettings, {
                      class: ["sel-filter", e.propsFilterClass, { "sel-multi": e.propsFilterFunction.isMultiSelect(e.propsColumn.filter.settings) }],
                      options: e.propsFilterFunction.getSelectOption(e.propsColumn.key),
                      multiple: e.propsFilterFunction.isMultiSelect(e.propsColumn.filter.settings),
                      "allow-empty": e.propsFilterFunction.isMultiSelect(e.propsColumn.filter.settings),
                      "close-on-select": !e.propsFilterFunction.isMultiSelect(e.propsColumn.filter.settings),
                      modelValue: e.propsFilterState.filter[e.propsColumn.key],
                      "onUpdate:modelValue": h[13] || (h[13] = (v) => e.propsFilterState.filter[e.propsColumn.key] = v),
                      onSelect: e.propsFilterFunction.onFilterSelect,
                      onClose: h[14] || (h[14] = (v) => e.propsFilterFunction.onFocusSelect(e.propsColumn.key, "close"))
                    }), null, 16, ["name", "class", "options", "multiple", "allow-empty", "close-on-select", "modelValue", "onSelect"]))
                  ])
                ], 38), [
                  [An, e.propsFilterState.bFilterOpen[e.propsColumn.key]]
                ])
              ]),
              _: 1
            })
          ], 10, RR)
        ])) : q("", !0)
      ], 64)) : q("", !0),
      e.propsFilterType === "column" ? (C(), k(De, { key: 4 }, [
        e.propsColumn.filter && (e.propsColumn.filter == "datetime" || e.propsColumn.filter.type == "datetime") ? (C(), ft(R(fi), ht({ key: 0 }, e.propsFilterFunction.getDateSetting(e.propsListGroupState.dDateRangeSettings, e.propsColumn.filter.settings), {
          dark: e.propsDarkMode,
          modelValue: e.propsFilterState.filter[e.propsColumn.key],
          "onUpdate:modelValue": [
            h[18] || (h[18] = (v) => e.propsFilterState.filter[e.propsColumn.key] = v),
            h[22] || (h[22] = (v) => e.propsFilterFunction.onFilterDateRange(e.propsColumn.key))
          ],
          onOpen: h[19] || (h[19] = (v) => e.propsFilterFunction.onToggleDatePicker("open")),
          onClosed: h[20] || (h[20] = (v) => e.propsFilterFunction.onToggleDatePicker("close")),
          onCleared: h[21] || (h[21] = (v) => e.propsFilterFunction.onClearDateRange(e.propsColumn.key)),
          "always-clearable": !0
        }), null, 16, ["dark", "modelValue"])) : q("", !0)
      ], 64)) : q("", !0),
      e.propsFilterType === "card" || e.propsFilterType === "dropdown" ? (C(), k(De, { key: 5 }, [
        e.propsColumn.filter && (e.propsColumn.filter == "datetime" || e.propsColumn.filter.type == "datetime") ? (C(), ft(R(fi), ht({ key: 0 }, e.propsFilterFunction.getDateSetting(e.propsListGroupState.dDateRangeSettings, e.propsColumn.filter.settings), {
          format: "yyyy-MM-dd",
          position: ["card"].includes(e.propsFilterType) ? "right" : "center",
          modelValue: e.propsFilterState.filter[e.propsColumn.key],
          "onUpdate:modelValue": h[23] || (h[23] = (v) => e.propsFilterState.filter[e.propsColumn.key] = v),
          onOpen: h[24] || (h[24] = (v) => e.propsFilterFunction.onToggleDatePicker("open")),
          onClosed: h[25] || (h[25] = (v) => {
            e.propsFilterFunction.onToggleDatePicker("close"), e.propsFilterFunction.onFilterDateRange(e.propsColumn.key);
          }),
          onCleared: h[26] || (h[26] = (v) => e.propsFilterFunction.onClearDateRange(e.propsColumn.key))
        }), null, 16, ["position", "modelValue"])) : q("", !0)
      ], 64)) : q("", !0)
    ], 64));
  }
}), VR = { class: "row row-sm list-group" }, HR = { class: "col-md-12 col-lg-12" }, UR = { class: "d-flex align-items-center justify-content-between" }, XR = { class: "d-flex align-items-center justify-content-end ps-1 gap-1" }, WR = { class: "multiselect__placeholder" }, YR = { key: 0 }, KR = { class: "dropdown-filter" }, QR = {
  key: 0,
  class: "dropdown-item"
}, jR = ["innerHTML"], ZR = { class: "dropdown-button" }, zR = { class: "dropdown-item d-flex justify-content-end" }, qR = { class: "main-content-label mb-1" }, JR = { class: "row row-sm filterCardColumns" }, eF = {
  key: 0,
  class: "col-md-6"
}, tF = { class: "form-group mb-2" }, rF = ["innerHTML"], oF = { class: "d-grid gap-1 d-flex justify-content-end mt-2" }, nF = ["colspan", "rowspan", "innerHTML"], aF = { key: 0 }, lF = ["innerHTML"], iF = { key: 0 }, sF = /* @__PURE__ */ wt({
  __name: "ListGroup",
  props: {
    propsBlade: {
      type: Object,
      required: !0
    },
    propsBladeInit: {
      type: Object,
      required: !0
    },
    propsDataRenderTerm: {
      type: Object
    },
    propsDefaultIdx: {
      type: String,
      required: !0
    },
    propsFilterInit: {
      type: Function,
      required: !0
    },
    propsFilterType: {
      type: String,
      default: "column"
      /* card, column, dropdown */
    },
    propsFooterCallback: {
      type: Function
    },
    propsFooterRow: {
      type: Number,
      default: 1
    },
    propsLastElement: {
      type: Boolean,
      default: !0
    },
    propsLoading: {
      type: Object
    },
    propsPreData: {
      type: Function
    },
    propsRowCallback: {
      type: Array
    },
    propsStore: {
      type: Object,
      required: !0
    },
    propsTableAction: {
      type: Object,
      required: !0
    },
    propsTableColumnInitHide: {
      type: Object,
      default: {}
    },
    propsTableColumnReorder: {
      type: Boolean,
      default: !1
    },
    propsTableColumnVisible: {
      type: Boolean,
      default: !1
    },
    propsTableDefer: {
      type: Object,
      default: {
        defer: !1,
        init: !0
      }
    },
    propsTableOption: {
      type: Object,
      required: !0
    },
    propsTableReady: {
      type: Boolean,
      default: !0
    },
    propsTableSelect: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["onLeftClick", "onPostRefresh", "onPostTableRender", "onRightClick", "onRowSelect"],
  setup(e, { emit: t }) {
    const r = t, o = J0;
    o.use(me), o.use(me), o.use(me), o.use(me);
    const {
      mxLGState: n,
      initListGroup: a,
      getTableColumnsDefs: l,
      getTableLocale: i,
      getTableScreenSize: s,
      getTableSorting: u,
      getColumnKey: c,
      getDateSetting: g,
      getSelectOption: p,
      onDisabledDefaultRightClick: h,
      onFormatDate: v,
      onPreDataRender: A,
      onResetSelection: S,
      vTableColumns: b,
      vTableFooters: T,
      vTableHeaders: w
    } = q0(), {
      mxLGFTState: N,
      initListGroupFilter: O,
      isMultiSelect: m,
      onCardFilterSearch: _,
      onClearDateRange: X,
      onDropdownFilterSearch: $,
      onFilterDateRange: E,
      onFilterInput: D,
      onFilterSelect: U,
      onFocusSelect: Y,
      onPreSetFilter: G,
      onSearch: K,
      onSwitchFilter: W,
      onToggleDatePicker: xe,
      onToggleDropdownFilter: Ce,
      onUpdateUrl: Q,
      onValidateInput: ue,
      setFilterSelect: V,
      bShowFilter: ae,
      vTableSearchHeaders: F
    } = CR(), {
      mxLGCVState: le,
      initListColumnVisible: te,
      onFilterColumnsAndGetRemovedIds: ie,
      onToggleColumn: B,
      vTableColumnVisibility: I
    } = Zw(), ee = e, Se = ee.propsFilterInit, pe = () => ({
      getSelectOption: p,
      getDateSetting: g,
      isMultiSelect: m,
      onClearDateRange: X,
      onFilterDateRange: E,
      onFilterInput: D,
      onFilterSelect: U,
      onFocusSelect: Y,
      onFormatDate: v,
      onToggleDatePicker: xe,
      onValidateInput: ue
    }), Ke = () => {
      const Ge = ee.propsBlade.columns;
      return Object.keys(Ge).filter((Ie) => !Ge[Ie].exclude);
    }, Oe = () => !1, Be = (Ge = !0) => ze.disableLoad || ze.tableLoading ? function(Ie, Ze) {
      Ze({ data: [], draw: 1, recordsTotal: 0, recordsFiltered: 0 });
    } : {
      type: "GET",
      url: ze.tableUrl,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + ee.propsStore.user.getToken()
      },
      dataType: "json",
      data: function(Ie) {
        let Ze = Ie.columns[Ie.order[0].column].data;
        if (Ze.includes(".") && !Ze.includes("meta"))
          Ze.includes("attributes") ? Ze = Ze.split(".").slice(1).join(".").toString() : Ze = c(Ze);
        else if (Ze.includes(".") && Ze.includes("meta")) {
          const Lt = Object.entries(ee.propsBlade.columns).find(([Ut, fr]) => fr.data === Ze);
          if (Lt)
            Ze = Lt[0];
          else {
            const Ut = ["created", "updated", "last_login"], fr = Ze.split(".")[1].toString();
            Ze = Ut.includes(fr) ? fr + "_at" : fr;
          }
        } else
          Ze = c(Ze);
        let et = {
          locale: ee.propsStore.user.getLanguage(),
          includes: se.blade.includes,
          page: Ie.length ? Ie.start / Ie.length + 1 : 1,
          perpage: Ie.length > 0 ? Ie.length : "all",
          sort_field: se.draw ? Ze : se.blade.sort.column,
          sort_direction: se.draw ? Ie.order[0].dir : se.blade.sort.direction
        };
        return se.blade?.conditions && (et = xa(et, Object.fromEntries(
          Object.entries(se.blade?.conditions).filter(([Lt, Ut]) => Ut !== "")
        ))), ze.tableDeferLoading && se.draw === 0 && (et = xa(et, { [ee.propsDefaultIdx]: "stop-99" })), !En(N.sParams) && ze.tableRefresh && (et = xa(et, N.sParams), ze.tableRefresh = !1), et;
      },
      dataFilter: function(Ie) {
        return Ie = JSON.parse(Ie), se.draw += 1, Ie.data = A(Ie.data), Ie.recordsTotal = Ie.meta.total, Ie.recordsFiltered = Ie.meta.total, Ie.draw = se.draw, se.recordTotal = Ie.recordsTotal, JSON.stringify(Ie);
      },
      dataSrc: function(Ie) {
        return ee.propsStore.user.getTestMode() && console.debug("dataSrc", Ie), Ie.data;
      },
      beforeSend: function(Ie, Ze) {
        console.debug("beforeSend", Ie, Ze), Qe.value && Qe.value.abort(), Qe.value = Ie, j.value && j.value.abort(), j.value = new AbortController();
      },
      error: function(Ie, Ze, et) {
        console.error("Datatable AJAX error:", Ze, et), et == "Unauthorized" && ee.propsStore.action.setComponentAction("prompt-2fa", !0);
      }
    }, j = Ee(new AbortController()), Qe = Ee(null), Ae = Ee(), re = Ee(), ne = Ee(), Le = Ee(), He = Ee(), ze = dt({
      darkMode: ee.propsStore.user.getDarkMode(),
      disableLoad: "url" in ee.propsTableOption ? ee.propsTableOption.url === "d0" : !1,
      filterCard: {
        isShow: !0
      },
      pLoading: ee.propsLoading && "loading" in ee.propsLoading ? ee.propsLoading.loading : !1,
      tableDeferLoading: ee.propsTableDefer.defer,
      tableDirectFilter: ee.propsTableDefer.init,
      tableFooterRow: ee.propsFooterRow,
      tableInfo: "bInfo" in ee.propsTableOption ? ee.propsTableOption.bInfo : !0,
      tableLoading: "url" in ee.propsTableOption ? ee.propsTableOption.url === "-1" : !1,
      tablePaging: "paging" in ee.propsTableOption ? ee.propsTableOption.paging : !0,
      tableReady: ee.propsTableReady,
      tableRefresh: !1,
      tableSelect: ee.propsTableSelect,
      tableSelectStyle: "tStyle" in ee.propsTableOption ? ee.propsTableOption.tStyle : "os",
      tableUrl: "url" in ee.propsTableOption ? ee.propsTableOption.url : ee.propsStore.action.getUrlByKey(ee.propsTableOption.action)
    }), se = dt({
      blade: ee.propsBlade,
      datas: [],
      draw: 0,
      loading: !0,
      options: {
        bInfo: ze.tableInfo,
        fixedHeader: !0,
        language: i($o(ee.propsStore.user), ze.tableLoading),
        lengthChange: !0,
        lengthMenu: [[50, 100, 200], [50, 100, 200]],
        pageLength: 100,
        paging: ze.tablePaging,
        pagingType: "simple_numbers",
        processing: !0,
        serverSide: !0,
        ajax: Be(),
        preDrawCallback: function(Ge) {
          ee.propsStore.user.getTestMode() && console.debug("preDrawCallback", Ge), se.loading = !0;
        },
        footerCallback: function(Ge, Ie, Ze, et, Lt) {
          ee.propsFooterCallback && ee.propsFooterCallback(Ge, Ie, Ze, et, Lt);
        },
        initComplete: function(Ge, Ie) {
          ee.propsStore.user.getTestMode() && console.debug("initComplete", Ge, Ie), se.loading && (se.loading = !1, r("onPostTableRender", { isLoading: se.loading })), ze.pLoading ? ee.propsStore.app.setLoading(ze.pLoading) : ee.propsStore.app.setLoading(!1);
        },
        rowCallback: (Ge, Ie) => {
          Ge.addEventListener("mousedown", (Ze) => {
            if (!(n.table.selected.total > 1) && Ze.button === 2) {
              Ie[ee.propsDefaultIdx] != n.table.selected.ids[0] ? r("onLeftClick", Ze) : n.table.selected.ids[0] && r("onRightClick", Ze);
              return;
            }
          }), At(Ge, Ie);
        },
        orderCellsTop: !0,
        responsive: Oe(),
        scrollX: !0,
        scrollY: `${s($o(ee.propsStore.user)).height}px`,
        //isMobileDevice(props.propsStore.user) ? '220px' : '500px',
        scrollCollapse: !0,
        searching: !1,
        select: ze.tableSelect ? {
          style: ze.tableSelectStyle
          // selector: 'td:first-child'
        } : !1,
        columnDefs: l({ fDPlace: 3, tSelect: ze.tableSelect }),
        colReorder: ee.propsTableColumnReorder,
        // deferRender: !isMobileDevice(props.propsStore.user),
        order: ze.tableLoading ? [] : u(ze.tableSelect, Ke(), ee.propsBlade.sort)
      },
      recordTotal: 0
    });
    Nn(() => {
      window.addEventListener("resize", W), a(re, {
        dataRenderTerm: ee.propsDataRenderTerm,
        preData: ee.propsPreData,
        tBlade: se.blade,
        tColumnName: Ke(),
        tColumns: ee.propsBlade.columns,
        tAction: ee.propsTableAction
      }), O(re, {
        filter: Se(),
        tBlade: se.blade,
        tDefaultIdx: ee.propsDefaultIdx,
        tDefer: ee.propsTableDefer,
        tUrl: ze.tableUrl
      }, {
        isTestMode: ee.propsStore.user.getTestMode(),
        isTDirectFilter: ze.tableDirectFilter,
        isTResponsive: Oe()
      }), ee.propsTableColumnVisible && (te(re, {
        tColumns: ee.propsBlade.columns,
        tSelect: ee.propsTableSelect,
        tHideColumns: ee.propsTableColumnInitHide
      }), ie(I.value));
    }), or(async () => {
      for (let Ge of document.getElementsByClassName("sel-filter"))
        V(Ge, !0);
      h(), ee.propsTableColumnVisible && (await Kr(), le.initHideColumns.forEach((Ge) => {
        B(Ge);
      }));
    }), PS(() => {
      Qe.value && (Qe.value.abort(), Qe.value = null), re.value?.dt?.destroy();
    }), tn(() => {
      window.removeEventListener("resize", W);
    });
    const Fe = () => {
      ze.filterCard.isShow = !ze.filterCard.isShow;
    }, qe = (Ge, Ie, Ze, et) => {
      if (Ie) {
        let Lt = Ie.rows(et).data().toArray();
        for (let Ut in Lt)
          ee.propsDefaultIdx in Lt[Ut] && (n.table.selected.ids.includes(Lt[Ut][ee.propsDefaultIdx]) || (n.table.selected.ids.push(Lt[Ut][ee.propsDefaultIdx]), n.table.selected.rows.push(Lt[Ut])));
        n.table.selected.total = n.table.selected.ids.length, r("onRowSelect", n.table.selected.rows);
      }
    }, ye = (Ge, Ie, Ze, et) => {
      if (Ie) {
        let Lt = Ie.rows(et).data().toArray();
        for (let Ut in Lt) {
          const fr = n.table.selected.ids.indexOf(Lt[Ut][ee.propsDefaultIdx]);
          fr !== -1 && (n.table.selected.ids.splice(fr, 1), n.table.selected.rows.splice(fr, 1));
        }
        n.table.selected.total = n.table.selected.ids.length, r("onRowSelect", n.table.selected.rows);
      }
    }, Ne = (Ge, Ie) => {
      ee.propsStore.user.getTestMode() && console.debug("onDrawCallback", Ge, Ie);
      const Ze = document.getElementsByClassName("select-checkbox dtr-control");
      if ([].forEach.call(Ze, function(et) {
        et.innerHTML = "";
      }), se.draw > 0 && (W(), S(), r("onPostRefresh", { filter: N.sParams, isDisabled: !1, isReset: !0 }), se.draw > 1 && (N.filter = N.oFilter), n.table.cKey))
        for (let et of document.getElementsByClassName("dt-empty"))
          et.innerHTML = se.options.language.zeroRecords;
      se.loading && (se.loading = !1, r("onPostTableRender", { isLoading: se.loading, total: se.recordTotal })), ee.propsStore.action.setListLoading(!1), N.bSearching = !1;
    }, At = (Ge, Ie) => {
      let Ze = [
        { className: "table-row-wdanger", column: "status", columnValue: "INACTIVE" }
      ];
      ee.propsRowCallback instanceof Array && ee.propsRowCallback.forEach((et) => {
        let Lt = !1;
        Ze.forEach((Ut) => {
          et.column === Ut.column && "columnValue" in et && "columnValue" in Ut && et.columnValue === Ut.columnValue && (Ut.className = et.className, Lt = !0);
        }), Lt || Ze.push(et);
      });
      for (const et of Ze) {
        let Lt, Ut;
        if ("columnValue" in et) {
          const fr = et.column.split("|"), xn = String(et.columnValue).split("|");
          fr.every((ve, Ue) => {
            let tt = Ie;
            return ve.split(".").forEach((St) => {
              tt = tt?.[St];
            }), String(tt) === (xn[Ue] ?? "");
          }) && (Lt = et.className);
        }
        if ("condition" in et) {
          const fr = et.column.split("|")[0];
          Ut = Ie, fr.split(".").forEach((xn) => {
            Ut = Ut?.[xn];
          }), et.condition?.(Ut) && (Lt = et.className);
        }
        if (Lt) {
          typeof Lt == "string" ? Ge.classList.add(Lt) : Ge.classList.add(...Lt);
          break;
        }
      }
      return () => {
      };
    };
    return El(He, (Ge) => {
      N.bFilter.isShow = !1, N.bTableDirectFilter = !N.bFilter.isShow;
    }), El(ne, (Ge) => {
      r("onLeftClick", Ge);
    }), nt(() => ({ ...ee.propsBlade }), (Ge, Ie) => {
      if (JSON.stringify(Ge).length != JSON.stringify(Ie).length) {
        n.table.cKey += 1;
        return;
      }
      ee.propsTableReady && se.draw > 0 && K(), G(), se.loading = !0, ee.propsStore.action.setListLoading(!0);
    }, { deep: !0 }), nt(() => ee.propsFooterRow, (Ge) => {
      ze.tableFooterRow = Ge;
    }), nt(() => ({ ...ee.propsLoading }), (Ge) => {
      ze.pLoading = Ge && "loading" in Ge ? Ge.loading : !1;
    }, { deep: !0 }), nt(() => ({ ...ee.propsTableAction }), (Ge, Ie) => {
      Ge != Ie && Ge.isRefresh == !0 && (n.table.selected.ids = [], n.table.selected.rows = [], K());
    }), nt(() => ({ ...ee.propsTableDefer }), (Ge) => {
      ze.tableDeferLoading = Ge.defer, ze.tableDirectFilter = Ge.init;
    }, { deep: !0 }), nt(() => ({ ...ee.propsTableOption }), (Ge) => {
      "url" in Ge && (ze.disableLoad = Ge.url === "d0", ze.tableLoading = Ge.url === "-1", ze.tableUrl = Ge.url, Q(ze.tableUrl), se.options.ajax = Be());
    }, { deep: !0 }), nt(() => ee.propsStore.user.getLanguage(), (Ge, Ie) => {
      Ge != Ie && (se.options.language = i($o(ee.propsStore.user), ze.tableLoading), n.table.cKey += 1, ze.tableRefresh = !0);
    }), nt(() => ee.propsStore.user.getDarkMode(), (Ge, Ie) => {
      Ge != Ie && (ze.darkMode = Ge, n.table.cKey += 1, ze.tableRefresh = !0);
    }), (Ge, Ie) => (C(), k("div", VR, [
      L("div", HR, [
        L("div", UR, [
          Ie[7] || (Ie[7] = L("div", { class: "d-flex align-items-center justify-content-start pe-1 gap-1" }, null, -1)),
          L("div", XR, [
            e.propsTableColumnVisible ? (C(), k("div", {
              key: 0,
              class: "p-none",
              ref_key: "cVisibleDiv",
              ref: Ae
            }, [
              vt(R(Wa), ht({ name: "t-columns" }, R(le).dSelectColumnSettings, {
                "custom-label": ({ name: Ze }) => R(ni)(Ge.$t(Ze)),
                placeholder: Ge.$t("column_visibility"),
                selectedLabel: Ge.$t("selected"),
                options: R(I),
                onSelect: R(B),
                onRemove: R(B),
                modelValue: R(le).selectedColumns,
                "onUpdate:modelValue": Ie[0] || (Ie[0] = (Ze) => R(le).selectedColumns = Ze)
              }), {
                selection: je(({ values: Ze, search: et, isOpen: Lt }) => [
                  L("span", WR, _e(Ge.$t("column_visibility")), 1),
                  Ze.length ? (C(), k("span", YR)) : q("", !0)
                ]),
                _: 1
              }, 16, ["custom-label", "placeholder", "selectedLabel", "options", "onSelect", "onRemove", "modelValue"])
            ], 512)) : q("", !0),
            R(N).filter != null && e.propsFilterType === "dropdown" ? (C(), k("div", {
              key: 1,
              class: "position-relative justify-content-center p-none",
              ref_key: "filterDiv",
              ref: He
            }, [
              L("button", {
                type: "button",
                class: "btn btn-white my-2 btn-icon-text",
                onClick: Ie[1] || (Ie[1] = (Ze) => R(Ce)())
              }, [
                Ie[5] || (Ie[5] = L("i", { class: "fas fa-filter me-2" }, null, -1)),
                Gt(_e(Ge.$t("filters")), 1)
              ]),
              L("div", {
                class: $e(["dropdown-menu filter-menu tx-13", { show: R(ae) }]),
                "data-popper-placement": "bottom-start"
              }, [
                L("div", KR, [
                  (C(!0), k(De, null, rt(R(F), (Ze, et) => (C(), k("div", {
                    key: et,
                    class: "th-filter"
                  }, [
                    Ze.filter ? (C(), k("div", QR, [
                      L("label", {
                        class: "filter-label",
                        innerHTML: R(ni)(Ge.$t(Ze.label))
                      }, null, 8, jR),
                      vt(qg, {
                        "props-column": Ze,
                        "props-dark-mode": ze.darkMode,
                        "props-filter-class": "drp-filter",
                        "props-filter-function": pe(),
                        "props-filter-state": R(N),
                        "props-filter-type": e.propsFilterType,
                        "props-is-mobile": R($o)(ee.propsStore.user),
                        "props-list-group-state": R(n),
                        "props-loading": ze.tableLoading
                      }, null, 8, ["props-column", "props-dark-mode", "props-filter-function", "props-filter-state", "props-filter-type", "props-is-mobile", "props-list-group-state", "props-loading"])
                    ])) : q("", !0)
                  ]))), 128)),
                  be(Ge.$slots, "filter")
                ]),
                L("div", ZR, [
                  L("div", zR, [
                    L("a", {
                      href: "javascript:void(0)",
                      class: "btn btn-outline-primary btn-icon-text mt-2",
                      onClick: Ie[2] || (Ie[2] = //@ts-ignore
                      (...Ze) => R($) && R($)(...Ze))
                    }, [
                      Ie[6] || (Ie[6] = L("i", { class: "fas fa-search me-2" }, null, -1)),
                      Gt(_e(Ge.$t("search")), 1)
                    ])
                  ])
                ])
              ], 2)
            ], 512)) : q("", !0)
          ])
        ]),
        R(N).filter != null && e.propsFilterType === "card" ? (C(), k("div", {
          key: 0,
          class: "card custom-card",
          ref_key: "filterCardDiv",
          ref: Le
        }, [
          L("div", {
            class: $e(["card-body filter-card-body", { filterCardWrap: !ze.filterCard.isShow }])
          }, [
            L("div", {
              class: "filterCardHandler",
              onClick: Fe
            }, [
              L("h6", qR, _e(Ge.$t("filters")), 1)
            ]),
            vt(R(yh), {
              when: ze.filterCard.isShow,
              class: "mt-3"
            }, {
              default: je(() => [
                L("div", JR, [
                  (C(!0), k(De, null, rt(R(F), (Ze, et) => (C(), k(De, { key: et }, [
                    Ze.filter ? (C(), k("span", eF, [
                      L("div", tF, [
                        L("label", {
                          class: "tx-medium tx-13 mb-0",
                          innerHTML: R(ni)(Ge.$t(Ze.label))
                        }, null, 8, rF),
                        vt(qg, {
                          "props-column": Ze,
                          "props-dark-mode": ze.darkMode,
                          "props-filter-class": "drp-filter",
                          "props-filter-function": pe(),
                          "props-filter-state": R(N),
                          "props-filter-type": e.propsFilterType,
                          "props-is-mobile": R($o)(ee.propsStore.user),
                          "props-list-group-state": R(n),
                          "props-loading": ze.tableLoading
                        }, null, 8, ["props-column", "props-dark-mode", "props-filter-function", "props-filter-state", "props-filter-type", "props-is-mobile", "props-list-group-state", "props-loading"])
                      ])
                    ])) : q("", !0)
                  ], 64))), 128)),
                  L("div", oF, [
                    L("a", {
                      href: "javascript:void(0)",
                      class: "btn btn-outline-primary btn-icon-text",
                      onClick: Ie[3] || (Ie[3] = //@ts-ignore
                      (...Ze) => R(_) && R(_)(...Ze))
                    }, [
                      Ie[8] || (Ie[8] = L("i", { class: "fas fa-search me-1" }, null, -1)),
                      Gt(_e(Ge.$t("search")), 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["when"])
          ], 2)
        ], 512)) : q("", !0),
        L("div", {
          class: $e(["card custom-card", { shimmer: ze.tableLoading, "mb-0": e.propsLastElement }])
        }, [
          L("div", {
            class: $e(["card-body list-group", { "m-group": R(w)[2].length }])
          }, [
            be(Ge.$slots, "header"),
            be(Ge.$slots, "default"),
            Ie[9] || (Ie[9] = L("div", { class: "scroll-wrapper" }, [
              L("div", { id: "scroll" })
            ], -1)),
            (C(), ft(R(o), {
              class: "table table-bordered table-hover table-striped dataTable nowrap",
              key: R(n).table.cKey,
              ref_key: "dataTable",
              ref: re,
              columns: R(b),
              options: se.options,
              onSelect: qe,
              onDeselect: ye,
              onDraw: Ne
            }, {
              default: je(() => [
                L("thead", null, [
                  L("tr", null, [
                    (C(!0), k(De, null, rt(R(w)[1], (Ze, et) => (C(), k("th", {
                      key: et,
                      class: $e(["th-header", Ze.className]),
                      colspan: Ze.colspan,
                      rowspan: Ze.rowspan,
                      innerHTML: Ze.label ? Ge.$t(Ze.label) : ""
                    }, null, 10, nF))), 128))
                  ]),
                  R(w)[2].length > 0 ? (C(), k("tr", aF, [
                    (C(!0), k(De, null, rt(R(w)[2], (Ze, et) => (C(), k("th", {
                      key: et,
                      class: $e(["th-header", Ze.className]),
                      innerHTML: Ze.label ? Ge.$t(Ze.label) : ""
                    }, null, 10, lF))), 128))
                  ])) : q("", !0),
                  R(N).filter != null && e.propsFilterType === "column" ? (C(), k("tr", {
                    key: 1,
                    class: "filters",
                    onKeyup: Ie[4] || (Ie[4] = Ao((Ze) => {
                      R(K)();
                    }, ["enter"]))
                  }, [
                    (C(!0), k(De, null, rt(R(F), (Ze, et) => (C(), k("th", {
                      key: et,
                      class: "th-filter"
                    }, [
                      vt(qg, {
                        "props-column": Ze,
                        "props-dark-mode": ze.darkMode,
                        "props-filter-function": pe(),
                        "props-filter-state": R(N),
                        "props-is-mobile": R($o)(ee.propsStore.user),
                        "props-list-group-state": R(n),
                        "props-loading": ze.tableLoading
                      }, null, 8, ["props-column", "props-dark-mode", "props-filter-function", "props-filter-state", "props-is-mobile", "props-list-group-state", "props-loading"])
                    ]))), 128))
                  ], 32)) : q("", !0)
                ]),
                L("tbody", {
                  ref_key: "dataTableBody",
                  ref: ne
                }, null, 512),
                e.propsFooterCallback ? (C(), k("tfoot", iF, [
                  (C(!0), k(De, null, rt(ze.tableFooterRow, (Ze) => (C(), k("tr", null, [
                    (C(!0), k(De, null, rt(R(T), (et, Lt) => (C(), k("th", {
                      key: Lt,
                      class: $e(["th-footer", et.className])
                    }, null, 2))), 128))
                  ]))), 256))
                ])) : q("", !0)
              ]),
              _: 1
            }, 8, ["columns", "options"]))
          ], 2)
        ], 2)
      ])
    ]));
  }
});
const dF = "asc", xo = {
  Ascending: "asc",
  Descending: "desc",
  None: "none"
}, k_ = {
  Records: "records"
}, uF = [10, 20, 30, 40, 50];
var oc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, hp = { exports: {} };
(function(e, t) {
  var r = 200, o = "__lodash_hash_undefined__", n = 1, a = 2, l = 9007199254740991, i = "[object Arguments]", s = "[object Array]", u = "[object AsyncFunction]", c = "[object Boolean]", g = "[object Date]", p = "[object Error]", h = "[object Function]", v = "[object GeneratorFunction]", A = "[object Map]", S = "[object Number]", b = "[object Null]", T = "[object Object]", w = "[object Promise]", N = "[object Proxy]", O = "[object RegExp]", m = "[object Set]", _ = "[object String]", X = "[object Symbol]", $ = "[object Undefined]", E = "[object WeakMap]", D = "[object ArrayBuffer]", U = "[object DataView]", Y = "[object Float32Array]", G = "[object Float64Array]", K = "[object Int8Array]", W = "[object Int16Array]", xe = "[object Int32Array]", Ce = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", ue = "[object Uint16Array]", V = "[object Uint32Array]", ae = /[\\^$.*+?()[\]{}|]/g, F = /^\[object .+?Constructor\]$/, le = /^(?:0|[1-9]\d*)$/, te = {};
  te[Y] = te[G] = te[K] = te[W] = te[xe] = te[Ce] = te[Q] = te[ue] = te[V] = !0, te[i] = te[s] = te[D] = te[c] = te[U] = te[g] = te[p] = te[h] = te[A] = te[S] = te[T] = te[O] = te[m] = te[_] = te[E] = !1;
  var ie = typeof oc == "object" && oc && oc.Object === Object && oc, B = typeof self == "object" && self && self.Object === Object && self, I = ie || B || Function("return this")(), ee = t && !t.nodeType && t, Se = ee && !0 && e && !e.nodeType && e, pe = Se && Se.exports === ee, Ke = pe && ie.process, Oe = (function() {
    try {
      return Ke && Ke.binding && Ke.binding("util");
    } catch {
    }
  })(), Be = Oe && Oe.isTypedArray;
  function j(z, ce) {
    for (var ke = -1, at = z == null ? 0 : z.length, dr = 0, Ct = []; ++ke < at; ) {
      var Sr = z[ke];
      ce(Sr, ke, z) && (Ct[dr++] = Sr);
    }
    return Ct;
  }
  function Qe(z, ce) {
    for (var ke = -1, at = ce.length, dr = z.length; ++ke < at; )
      z[dr + ke] = ce[ke];
    return z;
  }
  function Ae(z, ce) {
    for (var ke = -1, at = z == null ? 0 : z.length; ++ke < at; )
      if (ce(z[ke], ke, z))
        return !0;
    return !1;
  }
  function re(z, ce) {
    for (var ke = -1, at = Array(z); ++ke < z; )
      at[ke] = ce(ke);
    return at;
  }
  function ne(z) {
    return function(ce) {
      return z(ce);
    };
  }
  function Le(z, ce) {
    return z.has(ce);
  }
  function He(z, ce) {
    return z?.[ce];
  }
  function ze(z) {
    var ce = -1, ke = Array(z.size);
    return z.forEach(function(at, dr) {
      ke[++ce] = [dr, at];
    }), ke;
  }
  function se(z, ce) {
    return function(ke) {
      return z(ce(ke));
    };
  }
  function Fe(z) {
    var ce = -1, ke = Array(z.size);
    return z.forEach(function(at) {
      ke[++ce] = at;
    }), ke;
  }
  var qe = Array.prototype, ye = Function.prototype, Ne = Object.prototype, At = I["__core-js_shared__"], Ge = ye.toString, Ie = Ne.hasOwnProperty, Ze = (function() {
    var z = /[^.]+$/.exec(At && At.keys && At.keys.IE_PROTO || "");
    return z ? "Symbol(src)_1." + z : "";
  })(), et = Ne.toString, Lt = RegExp(
    "^" + Ge.call(Ie).replace(ae, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Ut = pe ? I.Buffer : void 0, fr = I.Symbol, xn = I.Uint8Array, Pa = Ne.propertyIsEnumerable, ve = qe.splice, Ue = fr ? fr.toStringTag : void 0, tt = Object.getOwnPropertySymbols, St = Ut ? Ut.isBuffer : void 0, Xe = se(Object.keys, Object), ut = ol(I, "DataView"), mt = ol(I, "Map"), Dr = ol(I, "Promise"), kr = ol(I, "Set"), Uo = ol(I, "WeakMap"), no = ol(Object, "create"), Ma = Ca(ut), pd = Ca(mt), Oi = Ca(Dr), hd = Ca(kr), xd = Ca(Uo), Lu = fr ? fr.prototype : void 0, Gl = Lu ? Lu.valueOf : void 0;
  function ea(z) {
    var ce = -1, ke = z == null ? 0 : z.length;
    for (this.clear(); ++ce < ke; ) {
      var at = z[ce];
      this.set(at[0], at[1]);
    }
  }
  function qa() {
    this.__data__ = no ? no(null) : {}, this.size = 0;
  }
  function Eu(z) {
    var ce = this.has(z) && delete this.__data__[z];
    return this.size -= ce ? 1 : 0, ce;
  }
  function Ou(z) {
    var ce = this.__data__;
    if (no) {
      var ke = ce[z];
      return ke === o ? void 0 : ke;
    }
    return Ie.call(ce, z) ? ce[z] : void 0;
  }
  function Nu(z) {
    var ce = this.__data__;
    return no ? ce[z] !== void 0 : Ie.call(ce, z);
  }
  function Du(z, ce) {
    var ke = this.__data__;
    return this.size += this.has(z) ? 0 : 1, ke[z] = no && ce === void 0 ? o : ce, this;
  }
  ea.prototype.clear = qa, ea.prototype.delete = Eu, ea.prototype.get = Ou, ea.prototype.has = Nu, ea.prototype.set = Du;
  function on(z) {
    var ce = -1, ke = z == null ? 0 : z.length;
    for (this.clear(); ++ce < ke; ) {
      var at = z[ce];
      this.set(at[0], at[1]);
    }
  }
  function Ni() {
    this.__data__ = [], this.size = 0;
  }
  function Qm(z) {
    var ce = this.__data__, ke = Gi(ce, z);
    if (ke < 0)
      return !1;
    var at = ce.length - 1;
    return ke == at ? ce.pop() : ve.call(ce, ke, 1), --this.size, !0;
  }
  function jm(z) {
    var ce = this.__data__, ke = Gi(ce, z);
    return ke < 0 ? void 0 : ce[ke][1];
  }
  function Zm(z) {
    return Gi(this.__data__, z) > -1;
  }
  function zm(z, ce) {
    var ke = this.__data__, at = Gi(ke, z);
    return at < 0 ? (++this.size, ke.push([z, ce])) : ke[at][1] = ce, this;
  }
  on.prototype.clear = Ni, on.prototype.delete = Qm, on.prototype.get = jm, on.prototype.has = Zm, on.prototype.set = zm;
  function ta(z) {
    var ce = -1, ke = z == null ? 0 : z.length;
    for (this.clear(); ++ce < ke; ) {
      var at = z[ce];
      this.set(at[0], at[1]);
    }
  }
  function qm() {
    this.size = 0, this.__data__ = {
      hash: new ea(),
      map: new (mt || on)(),
      string: new ea()
    };
  }
  function Ja(z) {
    var ce = Fl(this, z).delete(z);
    return this.size -= ce ? 1 : 0, ce;
  }
  function Di(z) {
    return Fl(this, z).get(z);
  }
  function ku(z) {
    return Fl(this, z).has(z);
  }
  function Jm(z, ce) {
    var ke = Fl(this, z), at = ke.size;
    return ke.set(z, ce), this.size += ke.size == at ? 0 : 1, this;
  }
  ta.prototype.clear = qm, ta.prototype.delete = Ja, ta.prototype.get = Di, ta.prototype.has = ku, ta.prototype.set = Jm;
  function el(z) {
    var ce = -1, ke = z == null ? 0 : z.length;
    for (this.__data__ = new ta(); ++ce < ke; )
      this.add(z[ce]);
  }
  function ki(z) {
    return this.__data__.set(z, o), this;
  }
  function eg(z) {
    return this.__data__.has(z);
  }
  el.prototype.add = el.prototype.push = ki, el.prototype.has = eg;
  function ra(z) {
    var ce = this.__data__ = new on(z);
    this.size = ce.size;
  }
  function $a() {
    this.__data__ = new on(), this.size = 0;
  }
  function Bl(z) {
    var ce = this.__data__, ke = ce.delete(z);
    return this.size = ce.size, ke;
  }
  function Il(z) {
    return this.__data__.get(z);
  }
  function Pt(z) {
    return this.__data__.has(z);
  }
  function So(z, ce) {
    var ke = this.__data__;
    if (ke instanceof on) {
      var at = ke.__data__;
      if (!mt || at.length < r - 1)
        return at.push([z, ce]), this.size = ++ke.size, this;
      ke = this.__data__ = new ta(at);
    }
    return ke.set(z, ce), this.size = ke.size, this;
  }
  ra.prototype.clear = $a, ra.prototype.delete = Bl, ra.prototype.get = Il, ra.prototype.has = Pt, ra.prototype.set = So;
  function tg(z, ce) {
    var ke = Ri(z), at = !ke && lg(z), dr = !ke && !at && ll(z), Ct = !ke && !at && !dr && Fu(z), Sr = ke || at || dr || Ct, zr = Sr ? re(z.length, String) : [], Gr = zr.length;
    for (var hr in z)
      Ie.call(z, hr) && !(Sr && // Safari 9 has enumerable `arguments.length` in strict mode.
      (hr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      dr && (hr == "offset" || hr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Ct && (hr == "buffer" || hr == "byteLength" || hr == "byteOffset") || // Skip index properties.
      Bu(hr, Gr))) && zr.push(hr);
    return zr;
  }
  function Gi(z, ce) {
    for (var ke = z.length; ke--; )
      if (bd(z[ke][0], ce))
        return ke;
    return -1;
  }
  function rg(z, ce, ke) {
    var at = ce(z);
    return Ri(z) ? at : Qe(at, ke(z));
  }
  function tl(z) {
    return z == null ? z === void 0 ? $ : b : Ue && Ue in Object(z) ? nl(z) : Sd(z);
  }
  function vd(z) {
    return aa(z) && tl(z) == i;
  }
  function rl(z, ce, ke, at, dr) {
    return z === ce ? !0 : z == null || ce == null || !aa(z) && !aa(ce) ? z !== z && ce !== ce : oa(z, ce, ke, at, rl, dr);
  }
  function oa(z, ce, ke, at, dr, Ct) {
    var Sr = Ri(z), zr = Ri(ce), Gr = Sr ? s : na(z), hr = zr ? s : na(ce);
    Gr = Gr == i ? T : Gr, hr = hr == i ? T : hr;
    var yo = Gr == T, qr = hr == T, ao = Gr == hr;
    if (ao && ll(z)) {
      if (!ll(ce))
        return !1;
      Sr = !0, yo = !1;
    }
    if (ao && !yo)
      return Ct || (Ct = new ra()), Sr || Fu(z) ? Rl(z, ce, ke, at, dr, Ct) : Gu(z, ce, Gr, ke, at, dr, Ct);
    if (!(ke & n)) {
      var Xo = yo && Ie.call(z, "__wrapped__"), No = qr && Ie.call(ce, "__wrapped__");
      if (Xo || No) {
        var Rn = Xo ? z.value() : z, vn = No ? ce.value() : ce;
        return Ct || (Ct = new ra()), dr(Rn, vn, ke, at, Ct);
      }
    }
    return ao ? (Ct || (Ct = new ra()), ag(z, ce, ke, at, dr, Ct)) : !1;
  }
  function Bi(z) {
    if (!Fi(z) || bo(z))
      return !1;
    var ce = La(z) ? Lt : F;
    return ce.test(Ca(z));
  }
  function og(z) {
    return aa(z) && Ea(z.length) && !!te[tl(z)];
  }
  function ng(z) {
    if (!Iu(z))
      return Xe(z);
    var ce = [];
    for (var ke in Object(z))
      Ie.call(z, ke) && ke != "constructor" && ce.push(ke);
    return ce;
  }
  function Rl(z, ce, ke, at, dr, Ct) {
    var Sr = ke & n, zr = z.length, Gr = ce.length;
    if (zr != Gr && !(Sr && Gr > zr))
      return !1;
    var hr = Ct.get(z);
    if (hr && Ct.get(ce))
      return hr == ce;
    var yo = -1, qr = !0, ao = ke & a ? new el() : void 0;
    for (Ct.set(z, ce), Ct.set(ce, z); ++yo < zr; ) {
      var Xo = z[yo], No = ce[yo];
      if (at)
        var Rn = Sr ? at(No, Xo, yo, ce, z, Ct) : at(Xo, No, yo, z, ce, Ct);
      if (Rn !== void 0) {
        if (Rn)
          continue;
        qr = !1;
        break;
      }
      if (ao) {
        if (!Ae(ce, function(vn, la) {
          if (!Le(ao, la) && (Xo === vn || dr(Xo, vn, ke, at, Ct)))
            return ao.push(la);
        })) {
          qr = !1;
          break;
        }
      } else if (!(Xo === No || dr(Xo, No, ke, at, Ct))) {
        qr = !1;
        break;
      }
    }
    return Ct.delete(z), Ct.delete(ce), qr;
  }
  function Gu(z, ce, ke, at, dr, Ct, Sr) {
    switch (ke) {
      case U:
        if (z.byteLength != ce.byteLength || z.byteOffset != ce.byteOffset)
          return !1;
        z = z.buffer, ce = ce.buffer;
      case D:
        return !(z.byteLength != ce.byteLength || !Ct(new xn(z), new xn(ce)));
      case c:
      case g:
      case S:
        return bd(+z, +ce);
      case p:
        return z.name == ce.name && z.message == ce.message;
      case O:
      case _:
        return z == ce + "";
      case A:
        var zr = ze;
      case m:
        var Gr = at & n;
        if (zr || (zr = Fe), z.size != ce.size && !Gr)
          return !1;
        var hr = Sr.get(z);
        if (hr)
          return hr == ce;
        at |= a, Sr.set(z, ce);
        var yo = Rl(zr(z), zr(ce), at, dr, Ct, Sr);
        return Sr.delete(z), yo;
      case X:
        if (Gl)
          return Gl.call(z) == Gl.call(ce);
    }
    return !1;
  }
  function ag(z, ce, ke, at, dr, Ct) {
    var Sr = ke & n, zr = Ii(z), Gr = zr.length, hr = Ii(ce), yo = hr.length;
    if (Gr != yo && !Sr)
      return !1;
    for (var qr = Gr; qr--; ) {
      var ao = zr[qr];
      if (!(Sr ? ao in ce : Ie.call(ce, ao)))
        return !1;
    }
    var Xo = Ct.get(z);
    if (Xo && Ct.get(ce))
      return Xo == ce;
    var No = !0;
    Ct.set(z, ce), Ct.set(ce, z);
    for (var Rn = Sr; ++qr < Gr; ) {
      ao = zr[qr];
      var vn = z[ao], la = ce[ao];
      if (at)
        var Do = Sr ? at(la, vn, ao, ce, z, Ct) : at(vn, la, ao, z, ce, Ct);
      if (!(Do === void 0 ? vn === la || dr(vn, la, ke, at, Ct) : Do)) {
        No = !1;
        break;
      }
      Rn || (Rn = ao == "constructor");
    }
    if (No && !Rn) {
      var Fn = z.constructor, Oa = ce.constructor;
      Fn != Oa && "constructor" in z && "constructor" in ce && !(typeof Fn == "function" && Fn instanceof Fn && typeof Oa == "function" && Oa instanceof Oa) && (No = !1);
    }
    return Ct.delete(z), Ct.delete(ce), No;
  }
  function Ii(z) {
    return rg(z, Vu, Vl);
  }
  function Fl(z, ce) {
    var ke = z.__data__;
    return In(ce) ? ke[typeof ce == "string" ? "string" : "hash"] : ke.map;
  }
  function ol(z, ce) {
    var ke = He(z, ce);
    return Bi(ke) ? ke : void 0;
  }
  function nl(z) {
    var ce = Ie.call(z, Ue), ke = z[Ue];
    try {
      z[Ue] = void 0;
      var at = !0;
    } catch {
    }
    var dr = et.call(z);
    return at && (ce ? z[Ue] = ke : delete z[Ue]), dr;
  }
  var Vl = tt ? function(z) {
    return z == null ? [] : (z = Object(z), j(tt(z), function(ce) {
      return Pa.call(z, ce);
    }));
  } : Hu, na = tl;
  (ut && na(new ut(new ArrayBuffer(1))) != U || mt && na(new mt()) != A || Dr && na(Dr.resolve()) != w || kr && na(new kr()) != m || Uo && na(new Uo()) != E) && (na = function(z) {
    var ce = tl(z), ke = ce == T ? z.constructor : void 0, at = ke ? Ca(ke) : "";
    if (at)
      switch (at) {
        case Ma:
          return U;
        case pd:
          return A;
        case Oi:
          return w;
        case hd:
          return m;
        case xd:
          return E;
      }
    return ce;
  });
  function Bu(z, ce) {
    return ce = ce ?? l, !!ce && (typeof z == "number" || le.test(z)) && z > -1 && z % 1 == 0 && z < ce;
  }
  function In(z) {
    var ce = typeof z;
    return ce == "string" || ce == "number" || ce == "symbol" || ce == "boolean" ? z !== "__proto__" : z === null;
  }
  function bo(z) {
    return !!Ze && Ze in z;
  }
  function Iu(z) {
    var ce = z && z.constructor, ke = typeof ce == "function" && ce.prototype || Ne;
    return z === ke;
  }
  function Sd(z) {
    return et.call(z);
  }
  function Ca(z) {
    if (z != null) {
      try {
        return Ge.call(z);
      } catch {
      }
      try {
        return z + "";
      } catch {
      }
    }
    return "";
  }
  function bd(z, ce) {
    return z === ce || z !== z && ce !== ce;
  }
  var lg = vd(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? vd : function(z) {
    return aa(z) && Ie.call(z, "callee") && !Pa.call(z, "callee");
  }, Ri = Array.isArray;
  function al(z) {
    return z != null && Ea(z.length) && !La(z);
  }
  var ll = St || Uu;
  function Ru(z, ce) {
    return rl(z, ce);
  }
  function La(z) {
    if (!Fi(z))
      return !1;
    var ce = tl(z);
    return ce == h || ce == v || ce == u || ce == N;
  }
  function Ea(z) {
    return typeof z == "number" && z > -1 && z % 1 == 0 && z <= l;
  }
  function Fi(z) {
    var ce = typeof z;
    return z != null && (ce == "object" || ce == "function");
  }
  function aa(z) {
    return z != null && typeof z == "object";
  }
  var Fu = Be ? ne(Be) : og;
  function Vu(z) {
    return al(z) ? tg(z) : ng(z);
  }
  function Hu() {
    return [];
  }
  function Uu() {
    return !1;
  }
  e.exports = Ru;
})(hp, hp.exports);
var Jg = hp.exports;
let Jx = {
  a: [
    "a",
    "à",
    "á",
    "â",
    "ã",
    "ä",
    "å",
    "æ",
    "ā",
    "ă",
    "ą",
    "ǎ",
    "ǟ",
    "ǡ",
    "ǻ",
    "ȁ",
    "ȃ",
    "ȧ",
    "ɐ",
    "ɑ",
    "ɒ",
    "ͣ",
    "а",
    "ӑ",
    "ӓ",
    "ᵃ",
    "ᵄ",
    "ᶏ",
    "ḁ",
    "ẚ",
    "ạ",
    "ả",
    "ấ",
    "ầ",
    "ẩ",
    "ẫ",
    "ậ",
    "ắ",
    "ằ",
    "ẳ",
    "ẵ",
    "ặ",
    "ₐ",
    "ⱥ",
    "ａ"
  ],
  b: ["b", "ƀ", "ƃ", "ɓ", "ᖯ", "ᵇ", "ᵬ", "ᶀ", "ḃ", "ḅ", "ḇ", "ｂ"],
  c: ["c", "ç", "ć", "ĉ", "ċ", "č", "ƈ", "ȼ", "ɕ", "ͨ", "ᴄ", "ᶜ", "ḉ", "ↄ", "ｃ"],
  d: [
    "d",
    "ď",
    "đ",
    "Ƌ",
    "ƌ",
    "ȡ",
    "ɖ",
    "ɗ",
    "ͩ",
    "ᵈ",
    "ᵭ",
    "ᶁ",
    "ᶑ",
    "ḋ",
    "ḍ",
    "ḏ",
    "ḑ",
    "ḓ",
    "ｄ"
  ],
  e: [
    "e",
    "è",
    "é",
    "ê",
    "ë",
    "ē",
    "ĕ",
    "ė",
    "ę",
    "ě",
    "ǝ",
    "ȅ",
    "ȇ",
    "ȩ",
    "ɇ",
    "ɘ",
    "ͤ",
    "ᵉ",
    "ᶒ",
    "ḕ",
    "ḗ",
    "ḙ",
    "ḛ",
    "ḝ",
    "ẹ",
    "ẻ",
    "ẽ",
    "ế",
    "ề",
    "ể",
    "ễ",
    "ệ",
    "ₑ",
    "ｅ"
  ],
  f: ["f", "ƒ", "ᵮ", "ᶂ", "ᶠ", "ḟ", "ｆ"],
  g: ["g", "ĝ", "ğ", "ġ", "ģ", "ǥ", "ǧ", "ǵ", "ɠ", "ɡ", "ᵍ", "ᵷ", "ᵹ", "ᶃ", "ᶢ", "ḡ", "ｇ"],
  h: [
    "h",
    "ĥ",
    "ħ",
    "ƕ",
    "ȟ",
    "ɥ",
    "ɦ",
    "ʮ",
    "ʯ",
    "ʰ",
    "ʱ",
    "ͪ",
    "Һ",
    "һ",
    "ᑋ",
    "ᶣ",
    "ḣ",
    "ḥ",
    "ḧ",
    "ḩ",
    "ḫ",
    "ⱨ",
    "ｈ"
  ],
  i: [
    "i",
    "ì",
    "í",
    "î",
    "ï",
    "ĩ",
    "ī",
    "ĭ",
    "į",
    "ǐ",
    "ȉ",
    "ȋ",
    "ɨ",
    "ͥ",
    "ᴉ",
    "ᵎ",
    "ᵢ",
    "ᶖ",
    "ᶤ",
    "ḭ",
    "ḯ",
    "ỉ",
    "ị",
    "ｉ"
  ],
  j: ["j", "ĵ", "ǰ", "ɉ", "ʝ", "ʲ", "ᶡ", "ᶨ", "ｊ"],
  k: ["k", "ķ", "ƙ", "ǩ", "ʞ", "ᵏ", "ᶄ", "ḱ", "ḳ", "ḵ", "ⱪ", "ｋ"],
  l: [
    "l",
    "ĺ",
    "ļ",
    "ľ",
    "ŀ",
    "ł",
    "ƚ",
    "ȴ",
    "ɫ",
    "ɬ",
    "ɭ",
    "ˡ",
    "ᶅ",
    "ᶩ",
    "ᶪ",
    "ḷ",
    "ḹ",
    "ḻ",
    "ḽ",
    "ℓ",
    "ⱡ"
  ],
  m: ["m", "ɯ", "ɰ", "ɱ", "ͫ", "ᴟ", "ᵐ", "ᵚ", "ᵯ", "ᶆ", "ᶬ", "ᶭ", "ḿ", "ṁ", "ṃ", "㎡", "㎥", "ｍ"],
  n: [
    "n",
    "ñ",
    "ń",
    "ņ",
    "ň",
    "ŉ",
    "ƞ",
    "ǹ",
    "ȵ",
    "ɲ",
    "ɳ",
    "ᵰ",
    "ᶇ",
    "ᶮ",
    "ᶯ",
    "ṅ",
    "ṇ",
    "ṉ",
    "ṋ",
    "ⁿ",
    "ｎ"
  ],
  o: [
    "o",
    "ò",
    "ó",
    "ô",
    "õ",
    "ö",
    "ø",
    "ō",
    "ŏ",
    "ő",
    "ơ",
    "ǒ",
    "ǫ",
    "ǭ",
    "ǿ",
    "ȍ",
    "ȏ",
    "ȫ",
    "ȭ",
    "ȯ",
    "ȱ",
    "ɵ",
    "ͦ",
    "о",
    "ӧ",
    "ө",
    "ᴏ",
    "ᴑ",
    "ᴓ",
    "ᴼ",
    "ᵒ",
    "ᶱ",
    "ṍ",
    "ṏ",
    "ṑ",
    "ṓ",
    "ọ",
    "ỏ",
    "ố",
    "ồ",
    "ổ",
    "ỗ",
    "ộ",
    "ớ",
    "ờ",
    "ở",
    "ỡ",
    "ợ",
    "ₒ",
    "ｏ",
    "𐐬"
  ],
  p: ["p", "ᵖ", "ᵱ", "ᵽ", "ᶈ", "ṕ", "ṗ", "ｐ"],
  q: ["q", "ɋ", "ʠ", "ᛩ", "ｑ"],
  r: [
    "r",
    "ŕ",
    "ŗ",
    "ř",
    "ȑ",
    "ȓ",
    "ɍ",
    "ɹ",
    "ɻ",
    "ʳ",
    "ʴ",
    "ʵ",
    "ͬ",
    "ᵣ",
    "ᵲ",
    "ᶉ",
    "ṙ",
    "ṛ",
    "ṝ",
    "ṟ"
  ],
  s: ["s", "ś", "ŝ", "ş", "š", "ș", "ʂ", "ᔆ", "ᶊ", "ṡ", "ṣ", "ṥ", "ṧ", "ṩ", "ｓ"],
  t: [
    "t",
    "ţ",
    "ť",
    "ŧ",
    "ƫ",
    "ƭ",
    "ț",
    "ʇ",
    "ͭ",
    "ᵀ",
    "ᵗ",
    "ᵵ",
    "ᶵ",
    "ṫ",
    "ṭ",
    "ṯ",
    "ṱ",
    "ẗ",
    "ｔ"
  ],
  u: [
    "u",
    "ù",
    "ú",
    "û",
    "ü",
    "ũ",
    "ū",
    "ŭ",
    "ů",
    "ű",
    "ų",
    "ư",
    "ǔ",
    "ǖ",
    "ǘ",
    "ǚ",
    "ǜ",
    "ȕ",
    "ȗ",
    "ͧ",
    "ߎ",
    "ᵘ",
    "ᵤ",
    "ṳ",
    "ṵ",
    "ṷ",
    "ṹ",
    "ṻ",
    "ụ",
    "ủ",
    "ứ",
    "ừ",
    "ử",
    "ữ",
    "ự",
    "ｕ"
  ],
  v: ["v", "ʋ", "ͮ", "ᵛ", "ᵥ", "ᶹ", "ṽ", "ṿ", "ⱱ", "ｖ", "ⱴ"],
  w: ["w", "ŵ", "ʷ", "ᵂ", "ẁ", "ẃ", "ẅ", "ẇ", "ẉ", "ẘ", "ⱳ", "ｗ"],
  x: ["x", "̽", "͓", "ᶍ", "ͯ", "ẋ", "ẍ", "ₓ", "ｘ"],
  y: ["y", "ý", "ÿ", "ŷ", "ȳ", "ɏ", "ʸ", "ẏ", "ỳ", "ỵ", "ỷ", "ỹ", "ｙ"],
  z: [
    "z",
    "ź",
    "ż",
    "ž",
    "ƶ",
    "ȥ",
    "ɀ",
    "ʐ",
    "ʑ",
    "ᙆ",
    "ᙇ",
    "ᶻ",
    "ᶼ",
    "ᶽ",
    "ẑ",
    "ẓ",
    "ẕ",
    "ⱬ",
    "ｚ"
  ]
};
const ev = (function() {
  let e = {};
  for (let t in Jx) {
    let r = Jx[t];
    for (let o in r) {
      let n = r[o];
      n !== t && (e[n] = t);
    }
  }
  return e;
})(), cF = /[^a-z0-9\s,.-]/, ef = (e) => {
  if (e.search(cF) === -1)
    return e;
  let t = "", r = e.length;
  for (var o = 0; o < r; o++) {
    let n = e.charAt(o);
    t += n in ev ? ev[n] : n;
  }
  return t;
}, tv = (e) => e.replace(/[\\^$*+?.()|[\]{}]/g, "\\$&");
var Ns = {
  format(e) {
    return e;
  },
  filterPredicate(e, t, r = !1, o = !1) {
    if (typeof e > "u" || e === null)
      return !1;
    const n = r ? String(e).toLowerCase() : ef(tv(String(e)).toLowerCase()), a = r ? t.toLowerCase() : ef(tv(t).toLowerCase());
    return o ? n === a : n.indexOf(a) > -1;
  },
  compare(e, t) {
    function r(o) {
      return typeof o > "u" || o === null ? "" : ef(String(o).toLowerCase());
    }
    return e = r(e), t = r(t), e < t ? -1 : e > t ? 1 : 0;
  }
}, $i = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [o, n] of t)
    r[o] = n;
  return r;
};
const mF = {
  name: "VgtPaginationPageInfo",
  props: {
    currentPage: {
      default: 1
    },
    lastPage: {
      default: 1
    },
    totalRecords: {
      default: 0
    },
    ofText: {
      default: "of",
      type: String
    },
    pageText: {
      default: "page",
      type: String
    },
    currentPerPage: {},
    mode: {
      default: k_.Records
    },
    infoFn: { default: null }
  },
  data() {
    return {
      id: this.getId()
    };
  },
  computed: {
    pageInfo() {
      return `${this.ofText} ${this.lastPage}`;
    },
    firstRecordOnPage() {
      return (this.currentPage - 1) * this.currentPerPage + 1;
    },
    lastRecordOnPage() {
      return Math.min(this.totalRecords, this.currentPage * this.currentPerPage);
    },
    recordInfo() {
      let e = this.firstRecordOnPage;
      const t = this.lastRecordOnPage;
      return t === 0 && (e = 0), `${e} - ${t} ${this.ofText} ${this.totalRecords}`;
    },
    infoParams() {
      let e = this.firstRecordOnPage;
      const t = this.lastRecordOnPage;
      return t === 0 && (e = 0), {
        firstRecordOnPage: e,
        lastRecordOnPage: t,
        totalRecords: this.totalRecords,
        currentPage: this.currentPage,
        totalPages: this.lastPage
      };
    }
  },
  methods: {
    getId() {
      return `vgt-page-input-${Math.floor(Math.random() * Date.now())}`;
    },
    changePage(e) {
      const t = parseInt(e.target.value, 10);
      if (Number.isNaN(t) || t > this.lastPage || t < 1)
        return e.target.value = this.currentPage, !1;
      e.target.value = t, this.$emit("page-changed", t);
    }
  },
  mounted() {
  },
  components: {}
}, gF = { class: "footer__navigation__page-info" }, fF = { key: 0 }, pF = ["for"], hF = ["id", "value"], xF = { key: 2 };
function vF(e, t, r, o, n, a) {
  return C(), k("div", gF, [
    r.infoFn ? (C(), k(
      "div",
      fF,
      _e(r.infoFn(a.infoParams)),
      1
      /* TEXT */
    )) : r.mode === "pages" ? (C(), k(
      "form",
      {
        key: 1,
        onSubmit: t[1] || (t[1] = Nt(() => {
        }, ["prevent"]))
      },
      [
        L("label", {
          for: n.id,
          class: "page-info__label"
        }, [
          L(
            "span",
            null,
            _e(r.pageText),
            1
            /* TEXT */
          ),
          L("input", {
            id: n.id,
            "aria-describedby": "change-page-hint",
            "aria-controls": "vgb-table",
            class: "footer__navigation__page-info__current-entry",
            type: "text",
            onKeyup: t[0] || (t[0] = Ao(Nt((...l) => a.changePage && a.changePage(...l), ["stop"]), ["enter"])),
            value: r.currentPage
          }, null, 40, hF),
          L(
            "span",
            null,
            _e(a.pageInfo),
            1
            /* TEXT */
          )
        ], 8, pF),
        t[2] || (t[2] = L(
          "span",
          {
            id: "change-page-hint",
            style: { display: "none" }
          },
          " Type a page number and press Enter to change the page. ",
          -1
          /* HOISTED */
        ))
      ],
      32
      /* NEED_HYDRATION */
    )) : (C(), k(
      "div",
      xF,
      _e(a.recordInfo),
      1
      /* TEXT */
    ))
  ]);
}
var SF = /* @__PURE__ */ $i(mF, [["render", vF]]);
const bF = {
  name: "VgtPagination",
  props: {
    styleClass: { default: "table table-bordered" },
    total: { default: null },
    perPage: {},
    rtl: { default: !1 },
    perPageDropdownEnabled: { default: !0 },
    customRowsPerPageDropdown: { default() {
      return [];
    } },
    paginateDropdownAllowAll: { default: !0 },
    mode: { default: k_.Records },
    // text options
    nextText: { default: "Next" },
    prevText: { default: "Prev" },
    rowsPerPageText: { default: "Rows per page:" },
    ofText: { default: "of" },
    pageText: { default: "page" },
    allText: { default: "All" },
    infoFn: { default: null }
  },
  data() {
    return {
      id: this.getId(),
      currentPage: 1,
      prevPage: 0,
      currentPerPage: 10,
      rowsPerPageOptions: []
    };
  },
  watch: {
    perPage: {
      handler(e, t) {
        this.handlePerPage(), this.perPageChanged(t);
      },
      immediate: !0
    },
    customRowsPerPageDropdown: {
      handler() {
        this.handlePerPage();
      },
      deep: !0
    },
    total: {
      handler(e, t) {
        this.rowsPerPageOptions.indexOf(this.currentPerPage) === -1 && (this.currentPerPage = e);
      }
    }
  },
  computed: {
    // Number of pages
    pagesCount() {
      const e = Math.floor(this.total / this.currentPerPage);
      return this.total % this.currentPerPage === 0 ? e : e + 1;
    },
    // Can go to next page
    nextIsPossible() {
      return this.currentPage < this.pagesCount;
    },
    // Can go to previous page
    prevIsPossible() {
      return this.currentPage > 1;
    }
  },
  methods: {
    getId() {
      return `vgt-select-rpp-${Math.floor(Math.random() * Date.now())}`;
    },
    // Change current page
    changePage(e, t = !0) {
      e > 0 && this.total > this.currentPerPage * (e - 1) && (this.prevPage = this.currentPage, this.currentPage = e, this.pageChanged(t));
    },
    // Go to next page
    nextPage() {
      this.nextIsPossible && (this.prevPage = this.currentPage, ++this.currentPage, this.pageChanged());
    },
    // Go to previous page
    previousPage() {
      this.prevIsPossible && (this.prevPage = this.currentPage, --this.currentPage, this.pageChanged());
    },
    // Indicate page changing
    pageChanged(e = !0) {
      const t = {
        currentPage: this.currentPage,
        prevPage: this.prevPage
      };
      e || (t.noEmit = !0), this.$emit("page-changed", t);
    },
    // Indicate per page changing
    perPageChanged(e) {
      e && this.$emit("per-page-changed", { currentPerPage: this.currentPerPage }), this.changePage(1, !1);
    },
    // Handle per page changing
    handlePerPage() {
      if (this.customRowsPerPageDropdown !== null && Array.isArray(this.customRowsPerPageDropdown) && this.customRowsPerPageDropdown.length !== 0 ? this.rowsPerPageOptions = JSON.parse(JSON.stringify(this.customRowsPerPageDropdown)) : this.rowsPerPageOptions = JSON.parse(JSON.stringify(uF)), this.perPage) {
        this.currentPerPage = this.perPage;
        let e = !1;
        for (let t = 0; t < this.rowsPerPageOptions.length; t++)
          this.rowsPerPageOptions[t] === this.perPage && (e = !0);
        !e && this.perPage !== -1 && this.rowsPerPageOptions.unshift(this.perPage);
      } else
        this.currentPerPage = 10;
    }
  },
  mounted() {
  },
  components: {
    "pagination-page-info": SF
  }
}, yF = { class: "vgt-wrap__footer vgt-clearfix" }, wF = {
  key: 0,
  class: "footer__row-count vgt-pull-left"
}, _F = ["for"], TF = ["id"], AF = ["value"], PF = ["value"], MF = { class: "footer__navigation vgt-pull-right" };
function $F(e, t, r, o, n, a) {
  const l = fl("pagination-page-info");
  return C(), k("div", yF, [
    r.perPageDropdownEnabled ? (C(), k("div", wF, [
      L("form", null, [
        L("label", {
          for: n.id,
          class: "footer__row-count__label"
        }, _e(r.rowsPerPageText) + ":", 9, _F),
        Qt(L("select", {
          id: n.id,
          autocomplete: "off",
          name: "perPageSelect",
          class: "footer__row-count__select",
          "onUpdate:modelValue": t[0] || (t[0] = (i) => n.currentPerPage = i),
          onChange: t[1] || (t[1] = (...i) => a.perPageChanged && a.perPageChanged(...i)),
          "aria-controls": "vgt-table"
        }, [
          (C(!0), k(
            De,
            null,
            rt(n.rowsPerPageOptions, (i, s) => (C(), k("option", {
              key: s,
              value: i
            }, _e(i), 9, AF))),
            128
            /* KEYED_FRAGMENT */
          )),
          r.paginateDropdownAllowAll ? (C(), k("option", {
            key: 0,
            value: r.total
          }, _e(r.allText), 9, PF)) : q("v-if", !0)
        ], 40, TF), [
          [iA, n.currentPerPage]
        ])
      ])
    ])) : q("v-if", !0),
    L("div", MF, [
      vt(l, {
        onPageChanged: a.changePage,
        "total-records": r.total,
        "last-page": a.pagesCount,
        "current-page": n.currentPage,
        "current-per-page": n.currentPerPage,
        "of-text": r.ofText,
        "page-text": r.pageText,
        "info-fn": r.infoFn,
        mode: r.mode
      }, null, 8, ["onPageChanged", "total-records", "last-page", "current-page", "current-per-page", "of-text", "page-text", "info-fn", "mode"]),
      L(
        "button",
        {
          type: "button",
          "aria-controls": "vgt-table",
          class: $e(["footer__navigation__page-btn", { disabled: !a.prevIsPossible }]),
          onClick: t[2] || (t[2] = Nt((...i) => a.previousPage && a.previousPage(...i), ["prevent", "stop"]))
        },
        [
          L(
            "span",
            {
              "aria-hidden": "true",
              class: $e(["chevron", { left: !r.rtl, right: r.rtl }])
            },
            null,
            2
            /* CLASS */
          ),
          L(
            "span",
            null,
            _e(r.prevText),
            1
            /* TEXT */
          )
        ],
        2
        /* CLASS */
      ),
      L(
        "button",
        {
          type: "button",
          "aria-controls": "vgt-table",
          class: $e(["footer__navigation__page-btn", { disabled: !a.nextIsPossible }]),
          onClick: t[3] || (t[3] = Nt((...i) => a.nextPage && a.nextPage(...i), ["prevent", "stop"]))
        },
        [
          L(
            "span",
            null,
            _e(r.nextText),
            1
            /* TEXT */
          ),
          L(
            "span",
            {
              "aria-hidden": "true",
              class: $e(["chevron", { right: !r.rtl, left: r.rtl }])
            },
            null,
            2
            /* CLASS */
          )
        ],
        2
        /* CLASS */
      )
    ])
  ]);
}
var CF = /* @__PURE__ */ $i(bF, [["render", $F]]);
const LF = {
  name: "VgtGlobalSearch",
  props: [
    "value",
    "searchEnabled",
    "globalSearchPlaceholder"
  ],
  emits: [
    "input",
    "keyup",
    "enter"
  ],
  data() {
    return {
      globalSearchTerm: null,
      id: this.getId()
    };
  },
  computed: {
    showControlBar() {
      return !!(this.searchEnabled || this.$slots && this.$slots["internal-table-actions"]);
    }
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e), this.$emit("keyup", e);
    },
    entered(e) {
      this.$emit("enter", e);
    },
    getId() {
      return `vgt-search-${Math.floor(Math.random() * Date.now())}`;
    }
  }
}, EF = {
  key: 0,
  class: "vgt-global-search vgt-clearfix"
}, OF = { class: "vgt-global-search__input vgt-pull-left" }, NF = ["for"], DF = ["id", "placeholder", "value"], kF = { class: "vgt-global-search__actions vgt-pull-right" };
function GF(e, t, r, o, n, a) {
  return a.showControlBar ? (C(), k("div", EF, [
    L("div", OF, [
      r.searchEnabled ? (C(), k(
        "form",
        {
          key: 0,
          onSubmit: t[2] || (t[2] = Nt(() => {
          }, ["prevent"])),
          role: "search"
        },
        [
          L("label", { for: n.id }, t[3] || (t[3] = [
            L(
              "span",
              {
                "aria-hidden": "true",
                class: "input__icon"
              },
              [
                L("div", { class: "magnifying-glass" })
              ],
              -1
              /* HOISTED */
            ),
            L(
              "span",
              { class: "sr-only" },
              "Search",
              -1
              /* HOISTED */
            )
          ]), 8, NF),
          L("input", {
            id: n.id,
            type: "text",
            class: "vgt-input vgt-pull-left",
            placeholder: r.globalSearchPlaceholder,
            value: r.value,
            onInput: t[0] || (t[0] = (l) => a.updateValue(l.target.value)),
            onKeyup: t[1] || (t[1] = Ao((l) => a.entered(l.target.value), ["enter"]))
          }, null, 40, DF)
        ],
        32
        /* NEED_HYDRATION */
      )) : q("v-if", !0)
    ]),
    L("div", kF, [
      be(e.$slots, "internal-table-actions")
    ])
  ])) : q("v-if", !0);
}
var BF = /* @__PURE__ */ $i(LF, [["render", GF]]);
const IF = {
  name: "VgtFilterRow",
  props: [
    "lineNumbers",
    "columns",
    "expandRowsEnabled",
    "typedColumns",
    "globalSearchEnabled",
    "selectable",
    "mode"
  ],
  emits: ["filter-changed"],
  watch: {
    columns: {
      handler(e, t) {
        this.populateInitialFilters();
      },
      deep: !0,
      immediate: !0
    }
  },
  data() {
    return {
      columnFilters: {},
      timer: null
    };
  },
  computed: {
    // to create a filter row, we need to
    // make sure that there is atleast 1 column
    // that requires filtering
    hasFilterRow() {
      for (let e = 0; e < this.columns.length; e++) {
        const t = this.columns[e];
        if (t.filterOptions && t.filterOptions.enabled)
          return !0;
      }
      return !1;
    }
  },
  methods: {
    fieldKey(e) {
      return typeof e == "function" && e.name ? e.name : e;
    },
    reset(e = !1) {
      this.columnFilters = {}, e && this.$emit("filter-changed", this.columnFilters);
    },
    isFilterable(e) {
      return e.filterOptions && e.filterOptions.enabled;
    },
    isDropdown(e) {
      return this.isFilterable(e) && e.filterOptions.filterDropdownItems && e.filterOptions.filterDropdownItems.length;
    },
    isDropdownObjects(e) {
      return this.isDropdown(e) && typeof e.filterOptions.filterDropdownItems[0] == "object";
    },
    isDropdownArray(e) {
      return this.isDropdown(e) && typeof e.filterOptions.filterDropdownItems[0] != "object";
    },
    getClasses(e) {
      const t = "filter-th";
      return e.filterOptions && e.filterOptions.styleClass ? [t, ...e.filterOptions.styleClass.split(" ")].join(" ") : t;
    },
    // get column's defined placeholder or default one
    getPlaceholder(e) {
      return this.isFilterable(e) && e.filterOptions.placeholder || `Filter ${e.label}`;
    },
    getName(e) {
      return `vgt-${this.fieldKey(e.field)}`;
    },
    updateFiltersOnEnter(e, t) {
      this.timer && clearTimeout(this.timer), this.updateFiltersImmediately(e.field, t);
    },
    updateFiltersOnKeyup(e, t) {
      e.filterOptions.trigger !== "enter" && this.updateFilters(e, t);
    },
    updateSlotFilter(e, t) {
      let r = e.filterOptions.slotFilterField || e.field;
      typeof e.filterOptions.formatValue == "function" && (t = e.filterOptions.formatValue(t)), this.updateFiltersImmediately(r, t);
    },
    // since vue doesn't detect property addition and deletion, we
    // need to create helper function to set property etc
    updateFilters(e, t) {
      this.timer && clearTimeout(this.timer), this.timer = setTimeout(() => {
        this.updateFiltersImmediately(e.field, t);
      }, 400);
    },
    updateFiltersImmediately(e, t) {
      this.columnFilters[this.fieldKey(e)] = t, this.$emit("filter-changed", this.columnFilters);
    },
    populateInitialFilters() {
      for (let e = 0; e < this.columns.length; e++) {
        const t = this.columns[e];
        this.isFilterable(t) && typeof t.filterOptions.filterValue < "u" && t.filterOptions.filterValue !== null && (this.columnFilters[this.fieldKey(t.field)] = t.filterOptions.filterValue);
      }
      this.$emit("filter-changed", this.columnFilters);
    }
  }
}, RF = { key: 0 }, FF = { key: 0 }, VF = { key: 1 }, HF = { key: 2 }, UF = { key: 0 }, XF = ["name", "placeholder", "value", "onKeyup", "onInput"], WF = ["name", "value", "onChange"], YF = {
  value: "",
  key: "-1"
}, KF = ["value"], QF = ["name", "value", "onChange"], jF = {
  value: "",
  key: "-1"
}, ZF = ["value"];
function zF(e, t, r, o, n, a) {
  return a.hasFilterRow ? (C(), k("tr", RF, [
    r.expandRowsEnabled ? (C(), k("th", FF)) : q("v-if", !0),
    r.lineNumbers ? (C(), k("th", VF)) : q("v-if", !0),
    r.selectable ? (C(), k("th", HF)) : q("v-if", !0),
    (C(!0), k(
      De,
      null,
      rt(r.columns, (l, i) => (C(), k(
        De,
        { key: i },
        [
          l.hidden ? q("v-if", !0) : (C(), k(
            "th",
            {
              key: 0,
              class: $e(a.getClasses(l))
            },
            [
              be(e.$slots, "column-filter", {
                column: l,
                updateFilters: a.updateSlotFilter
              }, () => [
                a.isFilterable(l) ? (C(), k("div", UF, [
                  a.isDropdown(l) ? q("v-if", !0) : (C(), k("input", {
                    key: 0,
                    name: a.getName(l),
                    type: "text",
                    class: "vgt-input",
                    placeholder: a.getPlaceholder(l),
                    value: n.columnFilters[a.fieldKey(l.field)],
                    onKeyup: Ao((s) => a.updateFiltersOnEnter(l, s.target.value), ["enter"]),
                    onInput: (s) => a.updateFiltersOnKeyup(l, s.target.value)
                  }, null, 40, XF)),
                  q(" options are a list of primitives "),
                  a.isDropdownArray(l) ? (C(), k("select", {
                    key: 1,
                    name: a.getName(l),
                    class: "vgt-select",
                    value: n.columnFilters[a.fieldKey(l.field)],
                    onChange: (s) => a.updateFiltersImmediately(l.field, s.target.value)
                  }, [
                    L(
                      "option",
                      YF,
                      _e(a.getPlaceholder(l)),
                      1
                      /* TEXT */
                    ),
                    (C(!0), k(
                      De,
                      null,
                      rt(l.filterOptions.filterDropdownItems, (s, u) => (C(), k("option", {
                        key: u,
                        value: s
                      }, _e(s), 9, KF))),
                      128
                      /* KEYED_FRAGMENT */
                    ))
                  ], 40, WF)) : q("v-if", !0),
                  q(" options are a list of objects with text and value "),
                  a.isDropdownObjects(l) ? (C(), k("select", {
                    key: 2,
                    name: a.getName(l),
                    class: "vgt-select",
                    value: n.columnFilters[a.fieldKey(l.field)],
                    onChange: (s) => a.updateFiltersImmediately(l.field, s.target.value)
                  }, [
                    L(
                      "option",
                      jF,
                      _e(a.getPlaceholder(l)),
                      1
                      /* TEXT */
                    ),
                    (C(!0), k(
                      De,
                      null,
                      rt(l.filterOptions.filterDropdownItems, (s, u) => (C(), k("option", {
                        key: u,
                        value: s.value
                      }, _e(s.text), 9, ZF))),
                      128
                      /* KEYED_FRAGMENT */
                    ))
                  ], 40, QF)) : q("v-if", !0)
                ])) : q("v-if", !0)
              ])
            ],
            2
            /* CLASS */
          ))
        ],
        64
        /* STABLE_FRAGMENT */
      ))),
      128
      /* KEYED_FRAGMENT */
    ))
  ])) : q("v-if", !0);
}
var qF = /* @__PURE__ */ $i(IF, [["render", zF]]);
function Ud(e) {
  return e.firstSortType || dF;
}
function JF(e, t) {
  return e.length === 1 && e[0].field === t.field ? e[0].type : void 0;
}
function G_(e, t) {
  return xo.Descending === Ud(t) && e === xo.Ascending ? xo.None : e === xo.Ascending ? xo.Descending : xo.Descending === Ud(t) && e === xo.Descending ? xo.Ascending : e === xo.Descending ? xo.None : xo.Descending === Ud(t) && e === xo.None ? xo.Descending : xo.Ascending;
}
function e7(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t.field === e[r].field) return r;
  return -1;
}
const t7 = (e, t) => {
  const r = JF(e, t), o = G_(r, t);
  return [{
    field: t.field,
    type: r ? o : Ud(t)
  }];
}, r7 = (e, t) => {
  const r = e7(e, t);
  return r === -1 ? e.push({
    field: t.field,
    type: Ud(t)
  }) : e[r].type = G_(e[r].type, t), e;
}, o7 = {
  name: "VgtTableHeader",
  props: {
    lineNumbers: {
      default: !1,
      type: Boolean
    },
    selectable: {
      default: !1,
      type: Boolean
    },
    allSelected: {
      default: !1,
      type: Boolean
    },
    allSelectedIndeterminate: {
      default: !1,
      type: Boolean
    },
    columns: {
      type: Array
    },
    expandRowsEnabled: {
      default: !1,
      type: Boolean
    },
    mode: {
      type: String
    },
    typedColumns: {},
    //* Sort related
    sortable: {
      type: Boolean
    },
    multipleColumnSort: {
      type: Boolean,
      default: !0
    },
    getClasses: {
      type: Function
    },
    //* search related
    searchEnabled: {
      type: Boolean
    },
    tableRef: {},
    paginated: {}
  },
  emits: [
    "toggle-select-all",
    "toggle-expand-rows-all",
    "sort-change",
    "filter-changed"
  ],
  watch: {
    columns: {
      handler() {
        this.setColumnStyles();
      },
      immediate: !0,
      deep: !0
    },
    tableRef: {
      handler() {
        this.setColumnStyles();
      },
      immediate: !0
    },
    paginated: {
      handler() {
        this.tableRef && this.setColumnStyles();
      },
      deep: !0
    }
  },
  data() {
    return {
      checkBoxThStyle: {},
      lineNumberThStyle: {},
      columnStyles: [],
      sorts: [],
      ro: null
    };
  },
  computed: {},
  methods: {
    reset() {
      this.$refs["filter-row"].reset(!0);
    },
    toggleExpandRowsAll() {
      this.$emit("toggle-expand-rows-all");
    },
    toggleSelectAll() {
      this.$emit("toggle-select-all");
    },
    isSortableColumn(e) {
      const { sortable: t } = e;
      return typeof t == "boolean" ? t : this.sortable;
    },
    sort(e, t) {
      this.isSortableColumn(t) && (e.shiftKey && this.multipleColumnSort ? this.sorts = r7(this.sorts, t) : this.sorts = t7(this.sorts, t), this.$emit("sort-change", this.sorts));
    },
    setInitialSort(e) {
      this.sorts = e, this.$emit("sort-change", this.sorts);
    },
    getColumnSort(e) {
      for (let t = 0; t < this.sorts.length; t += 1)
        if (this.sorts[t].field === e.field)
          return this.sorts[t].type || "asc";
      return null;
    },
    getColumnSortLong(e) {
      return this.getColumnSort(e) === "asc" ? "ascending" : "descending";
    },
    getHeaderClasses(e, t) {
      return Object.assign({}, this.getClasses(t, "th"), {
        sortable: this.isSortableColumn(e),
        "sorting sorting-desc": this.getColumnSort(e) === "desc",
        "sorting sorting-asc": this.getColumnSort(e) === "asc"
      });
    },
    filterRows(e) {
      this.$emit("filter-changed", e);
    },
    getWidthStyle(e) {
      return window && window.getComputedStyle && e ? {
        width: window.getComputedStyle(e, null).width
      } : {
        width: "auto"
      };
    },
    setColumnStyles() {
      const e = [];
      for (let t = 0; t < this.columns.length; t++)
        if (this.tableRef) {
          let r = 0;
          this.selectable && r++, this.lineNumbers && r++;
          const o = this.tableRef.rows[0].cells[t + r];
          e.push(this.getWidthStyle(o));
        } else
          e.push({
            minWidth: this.columns[t].width ? this.columns[t].width : "auto",
            maxWidth: this.columns[t].width ? this.columns[t].width : "auto",
            width: this.columns[t].width ? this.columns[t].width : "auto"
          });
      this.columnStyles = e;
    },
    getColumnStyle(e, t) {
      const r = {
        minWidth: e.width ? e.width : "auto",
        maxWidth: e.width ? e.width : "auto",
        width: e.width ? e.width : "auto"
      };
      if (this.tableRef) {
        this.selectable && t++, this.lineNumbers && t++;
        const o = this.tableRef.rows[0].cells[t], n = window.getComputedStyle(o, null);
        r.width = n.width;
      }
      return r;
    }
  },
  mounted() {
    this.$nextTick(() => {
      "ResizeObserver" in window && (this.ro = new ResizeObserver(() => {
        this.setColumnStyles();
      }), this.ro.observe(this.$parent.$el), this.tableRef && Array.from(this.$parent.$refs["table-header-primary"].$el.children[0].children).forEach((e) => {
        this.ro.observe(e);
      }));
    });
  },
  beforeUnmount() {
    this.ro && this.ro.disconnect();
  },
  components: {
    "vgt-filter-row": qF
  }
}, n7 = {
  key: 0,
  scope: "col",
  class: "line-numbers"
}, a7 = {
  key: 1,
  scope: "col",
  class: "vgt-checkbox-col"
}, l7 = ["checked", ".indeterminate"], i7 = {
  key: 2,
  scope: "col",
  class: "vgt-checkbox-col"
}, s7 = ["title", "aria-sort", "aria-controls"], d7 = ["onClick"], u7 = { class: "sr-only" };
function c7(e, t, r, o, n, a) {
  const l = fl("vgt-filter-row");
  return C(), k("thead", null, [
    L("tr", null, [
      r.lineNumbers ? (C(), k("th", n7)) : q("v-if", !0),
      r.selectable ? (C(), k("th", a7, [
        L("input", {
          type: "checkbox",
          checked: r.allSelected,
          ".indeterminate": r.allSelectedIndeterminate,
          onChange: t[0] || (t[0] = (...i) => a.toggleSelectAll && a.toggleSelectAll(...i))
        }, null, 40, l7)
      ])) : q("v-if", !0),
      r.expandRowsEnabled ? (C(), k("th", i7, [
        L("a", {
          href: "",
          onClick: t[1] || (t[1] = Nt((...i) => a.toggleExpandRowsAll && a.toggleExpandRowsAll(...i), ["prevent"])),
          class: "vgt-wrap__expander"
        }, " (+) ")
      ])) : q("v-if", !0),
      (C(!0), k(
        De,
        null,
        rt(r.columns, (i, s) => (C(), k(
          De,
          { key: s },
          [
            i.hidden ? q("v-if", !0) : (C(), k("th", {
              key: 0,
              scope: "col",
              title: i.tooltip,
              class: $e(a.getHeaderClasses(i, s)),
              style: io(n.columnStyles[s]),
              "aria-sort": a.getColumnSortLong(i),
              "aria-controls": `col-${s}`
            }, [
              be(e.$slots, "table-column", { column: i }, () => [
                Gt(
                  _e(i.label),
                  1
                  /* TEXT */
                )
              ]),
              a.isSortableColumn(i) ? (C(), k("button", {
                key: 0,
                onClick: (u) => a.sort(u, i)
              }, [
                L(
                  "span",
                  u7,
                  " Sort table by " + _e(i.label) + " in " + _e(a.getColumnSortLong(i)) + " order ",
                  1
                  /* TEXT */
                )
              ], 8, d7)) : q("v-if", !0)
            ], 14, s7))
          ],
          64
          /* STABLE_FRAGMENT */
        ))),
        128
        /* KEYED_FRAGMENT */
      ))
    ]),
    vt(l, {
      ref: "filter-row",
      onFilterChanged: a.filterRows,
      "global-search-enabled": r.searchEnabled,
      "line-numbers": r.lineNumbers,
      "expand-rows-enabled": r.expandRowsEnabled,
      selectable: r.selectable,
      columns: r.columns,
      mode: r.mode,
      "typed-columns": r.typedColumns
    }, {
      "column-filter": je((i) => [
        be(e.$slots, "column-filter", {
          column: i.column,
          updateFilters: i.updateFilters
        })
      ]),
      _: 3
      /* FORWARDED */
    }, 8, ["onFilterChanged", "global-search-enabled", "line-numbers", "expand-rows-enabled", "selectable", "columns", "mode", "typed-columns"])
  ]);
}
var m7 = /* @__PURE__ */ $i(o7, [["render", c7]]);
const g7 = {
  name: "VgtHeaderRow",
  props: {
    headerRow: {
      type: Object
    },
    columns: {
      type: Array
    },
    lineNumbers: {
      type: Boolean
    },
    selectable: {
      type: Boolean
    },
    selectAllByGroup: {
      type: Boolean
    },
    collapsable: {
      type: [Boolean, Number],
      default: !1
    },
    collectFormatted: {
      type: Function
    },
    formattedRow: {
      type: Function
    },
    getClasses: {
      type: Function
    },
    fullColspan: {
      type: Number
    },
    groupIndex: {
      type: Number
    }
  },
  emits: [
    "vgtExpand",
    "select-group-change"
  ],
  data() {
    return {};
  },
  computed: {
    allSelected() {
      const { headerRow: e } = this;
      return e.children.filter((t) => t.vgtSelected).length === e.children.length;
    }
  },
  methods: {
    columnCollapsable(e) {
      return this.collapsable === !0 ? e === 0 : e === this.collapsable;
    },
    toggleSelectGroup(e) {
      this.$emit("select-group-change", {
        groupIndex: this.groupIndex,
        checked: e.target.checked
      });
    }
  },
  mounted() {
  },
  components: {}
}, f7 = ["colspan"], p7 = ["checked"], h7 = ["innerHTML"], x7 = { key: 1 }, v7 = {
  key: 1,
  class: "vgt-row-header"
}, S7 = {
  key: 2,
  class: "vgt-row-header"
}, b7 = ["checked"], y7 = ["onClick"], w7 = { key: 0 }, _7 = ["innerHTML"];
function T7(e, t, r, o, n, a) {
  return C(), k("tr", null, [
    r.headerRow.mode === "span" ? (C(), k("th", {
      key: 0,
      class: "vgt-left-align vgt-row-header",
      colspan: r.fullColspan
    }, [
      r.selectAllByGroup ? be(e.$slots, "table-header-group-select", {
        key: 0,
        columns: r.columns,
        row: r.headerRow
      }, () => [
        L("input", {
          type: "checkbox",
          checked: a.allSelected,
          onChange: t[0] || (t[0] = (l) => a.toggleSelectGroup(l))
        }, null, 40, p7)
      ]) : q("v-if", !0),
      L("span", {
        onClick: t[1] || (t[1] = (l) => r.collapsable ? e.$emit("vgtExpand", !r.headerRow.vgtIsExpanded) : () => {
        })
      }, [
        r.collapsable ? (C(), k(
          "span",
          {
            key: 0,
            class: $e(["triangle", { expand: r.headerRow.vgtIsExpanded }])
          },
          null,
          2
          /* CLASS */
        )) : q("v-if", !0),
        be(e.$slots, "table-header-row", { row: r.headerRow }, () => [
          r.headerRow.html ? (C(), k("span", {
            key: 0,
            innerHTML: r.headerRow.label
          }, null, 8, h7)) : (C(), k(
            "span",
            x7,
            _e(r.headerRow.label),
            1
            /* TEXT */
          ))
        ])
      ])
    ], 8, f7)) : q("v-if", !0),
    q(" if the mode is not span, we display every column "),
    r.headerRow.mode !== "span" && r.lineNumbers ? (C(), k("th", v7)) : q("v-if", !0),
    r.headerRow.mode !== "span" && r.selectable ? (C(), k("th", S7, [
      r.selectAllByGroup ? be(e.$slots, "table-header-group-select", {
        key: 0,
        columns: r.columns,
        row: r.headerRow
      }, () => [
        L("input", {
          type: "checkbox",
          checked: a.allSelected,
          onChange: t[2] || (t[2] = (l) => a.toggleSelectGroup(l))
        }, null, 40, b7)
      ]) : q("v-if", !0)
    ])) : q("v-if", !0),
    (C(!0), k(
      De,
      null,
      rt(r.columns, (l, i) => (C(), k(
        De,
        { key: i },
        [
          r.headerRow.mode !== "span" && !l.hidden ? (C(), k("th", {
            key: 0,
            class: $e(["vgt-row-header", r.getClasses(i, "td")]),
            onClick: (s) => a.columnCollapsable(i) ? e.$emit("vgtExpand", !r.headerRow.vgtIsExpanded) : () => {
            }
          }, [
            a.columnCollapsable(i) ? (C(), k(
              "span",
              {
                key: 0,
                class: $e(["triangle", { expand: r.headerRow.vgtIsExpanded }])
              },
              null,
              2
              /* CLASS */
            )) : q("v-if", !0),
            be(e.$slots, "table-header-row", {
              row: r.headerRow,
              column: l,
              formattedRow: r.formattedRow(r.headerRow, !0)
            }, () => [
              l.html ? q("v-if", !0) : (C(), k(
                "span",
                w7,
                _e(r.collectFormatted(r.headerRow, l, !0)),
                1
                /* TEXT */
              )),
              l.html ? (C(), k("span", {
                key: 1,
                innerHTML: r.collectFormatted(r.headerRow, l, !0)
              }, null, 8, _7)) : q("v-if", !0)
            ])
          ], 10, y7)) : q("v-if", !0)
        ],
        64
        /* STABLE_FRAGMENT */
      ))),
      128
      /* KEYED_FRAGMENT */
    ))
  ]);
}
var A7 = /* @__PURE__ */ $i(g7, [["render", T7]]);
function ja(e) {
  "@babel/helpers - typeof";
  return ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ja(e);
}
function en(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Zr(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ho(e) {
  Zr(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || ja(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function P7(e, t) {
  Zr(2, arguments);
  var r = ho(e).getTime(), o = en(t);
  return new Date(r + o);
}
var M7 = {};
function gd() {
  return M7;
}
function B_(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function $7(e, t) {
  Zr(2, arguments);
  var r = ho(e), o = ho(t), n = r.getTime() - o.getTime();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
var C7 = 6e4, L7 = 36e5, E7 = 1e3;
function O7(e) {
  return Zr(1, arguments), e instanceof Date || ja(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function qc(e) {
  if (Zr(1, arguments), !O7(e) && typeof e != "number")
    return !1;
  var t = ho(e);
  return !isNaN(Number(t));
}
function I_(e, t) {
  Zr(2, arguments);
  var r = en(t);
  return P7(e, -r);
}
var N7 = 864e5;
function D7(e) {
  Zr(1, arguments);
  var t = ho(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var o = t.getTime(), n = r - o;
  return Math.floor(n / N7) + 1;
}
function Zs(e) {
  Zr(1, arguments);
  var t = 1, r = ho(e), o = r.getUTCDay(), n = (o < t ? 7 : 0) + o - t;
  return r.setUTCDate(r.getUTCDate() - n), r.setUTCHours(0, 0, 0, 0), r;
}
function R_(e) {
  Zr(1, arguments);
  var t = ho(e), r = t.getUTCFullYear(), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(r + 1, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var n = Zs(o), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var l = Zs(a);
  return t.getTime() >= n.getTime() ? r + 1 : t.getTime() >= l.getTime() ? r : r - 1;
}
function k7(e) {
  Zr(1, arguments);
  var t = R_(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = Zs(r);
  return o;
}
var G7 = 6048e5;
function F_(e) {
  Zr(1, arguments);
  var t = ho(e), r = Zs(t).getTime() - k7(t).getTime();
  return Math.round(r / G7) + 1;
}
function bi(e, t) {
  var r, o, n, a, l, i, s, u;
  Zr(1, arguments);
  var c = gd(), g = en((r = (o = (n = (a = t?.weekStartsOn) !== null && a !== void 0 ? a : t == null || (l = t.locale) === null || l === void 0 || (i = l.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && n !== void 0 ? n : c.weekStartsOn) !== null && o !== void 0 ? o : (s = c.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(g >= 0 && g <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = ho(e), h = p.getUTCDay(), v = (h < g ? 7 : 0) + h - g;
  return p.setUTCDate(p.getUTCDate() - v), p.setUTCHours(0, 0, 0, 0), p;
}
function wh(e, t) {
  var r, o, n, a, l, i, s, u;
  Zr(1, arguments);
  var c = ho(e), g = c.getUTCFullYear(), p = gd(), h = en((r = (o = (n = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (l = t.locale) === null || l === void 0 || (i = l.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && n !== void 0 ? n : p.firstWeekContainsDate) !== null && o !== void 0 ? o : (s = p.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(g + 1, 0, h), v.setUTCHours(0, 0, 0, 0);
  var A = bi(v, t), S = /* @__PURE__ */ new Date(0);
  S.setUTCFullYear(g, 0, h), S.setUTCHours(0, 0, 0, 0);
  var b = bi(S, t);
  return c.getTime() >= A.getTime() ? g + 1 : c.getTime() >= b.getTime() ? g : g - 1;
}
function B7(e, t) {
  var r, o, n, a, l, i, s, u;
  Zr(1, arguments);
  var c = gd(), g = en((r = (o = (n = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (l = t.locale) === null || l === void 0 || (i = l.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && n !== void 0 ? n : c.firstWeekContainsDate) !== null && o !== void 0 ? o : (s = c.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), p = wh(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(p, 0, g), h.setUTCHours(0, 0, 0, 0);
  var v = bi(h, t);
  return v;
}
var I7 = 6048e5;
function V_(e, t) {
  Zr(1, arguments);
  var r = ho(e), o = bi(r, t).getTime() - B7(r, t).getTime();
  return Math.round(o / I7) + 1;
}
function ar(e, t) {
  for (var r = e < 0 ? "-" : "", o = Math.abs(e).toString(); o.length < t; )
    o = "0" + o;
  return r + o;
}
var R7 = {
  // Year
  y: function(t, r) {
    var o = t.getUTCFullYear(), n = o > 0 ? o : 1 - o;
    return ar(r === "yy" ? n % 100 : n, r.length);
  },
  // Month
  M: function(t, r) {
    var o = t.getUTCMonth();
    return r === "M" ? String(o + 1) : ar(o + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return ar(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var o = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return o.toUpperCase();
      case "aaa":
        return o;
      case "aaaaa":
        return o[0];
      default:
        return o === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return ar(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return ar(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return ar(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return ar(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var o = r.length, n = t.getUTCMilliseconds(), a = Math.floor(n * Math.pow(10, o - 3));
    return ar(a, r.length);
  }
}, ul = R7, zi = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, F7 = {
  // Era
  G: function(t, r, o) {
    var n = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return o.era(n, {
          width: "narrow"
        });
      default:
        return o.era(n, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, o) {
    if (r === "yo") {
      var n = t.getUTCFullYear(), a = n > 0 ? n : 1 - n;
      return o.ordinalNumber(a, {
        unit: "year"
      });
    }
    return ul.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, o, n) {
    var a = wh(t, n), l = a > 0 ? a : 1 - a;
    if (r === "YY") {
      var i = l % 100;
      return ar(i, 2);
    }
    return r === "Yo" ? o.ordinalNumber(l, {
      unit: "year"
    }) : ar(l, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var o = R_(t);
    return ar(o, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var o = t.getUTCFullYear();
    return ar(o, r.length);
  },
  // Quarter
  Q: function(t, r, o) {
    var n = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return ar(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return o.ordinalNumber(n, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, o) {
    var n = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return ar(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return o.ordinalNumber(n, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, o) {
    var n = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return ul.M(t, r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return o.ordinalNumber(n + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return o.month(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, o) {
    var n = t.getUTCMonth();
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return ar(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return o.ordinalNumber(n + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return o.month(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, o, n) {
    var a = V_(t, n);
    return r === "wo" ? o.ordinalNumber(a, {
      unit: "week"
    }) : ar(a, r.length);
  },
  // ISO week of year
  I: function(t, r, o) {
    var n = F_(t);
    return r === "Io" ? o.ordinalNumber(n, {
      unit: "week"
    }) : ar(n, r.length);
  },
  // Day of the month
  d: function(t, r, o) {
    return r === "do" ? o.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : ul.d(t, r);
  },
  // Day of year
  D: function(t, r, o) {
    var n = D7(t);
    return r === "Do" ? o.ordinalNumber(n, {
      unit: "dayOfYear"
    }) : ar(n, r.length);
  },
  // Day of week
  E: function(t, r, o) {
    var n = t.getUTCDay();
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return o.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return o.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, o, n) {
    var a = t.getUTCDay(), l = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(l);
      // Padded numerical value
      case "ee":
        return ar(l, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return o.ordinalNumber(l, {
          unit: "day"
        });
      case "eee":
        return o.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return o.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return o.day(a, {
          width: "short",
          context: "formatting"
        });
      default:
        return o.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, o, n) {
    var a = t.getUTCDay(), l = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (same as in `e`)
      case "c":
        return String(l);
      // Padded numerical value
      case "cc":
        return ar(l, r.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return o.ordinalNumber(l, {
          unit: "day"
        });
      case "ccc":
        return o.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return o.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return o.day(a, {
          width: "short",
          context: "standalone"
        });
      default:
        return o.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, o) {
    var n = t.getUTCDay(), a = n === 0 ? 7 : n;
    switch (r) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return ar(a, r.length);
      // 2nd
      case "io":
        return o.ordinalNumber(a, {
          unit: "day"
        });
      // Tue
      case "iii":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return o.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return o.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, o) {
    var n = t.getUTCHours(), a = n / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return o.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return o.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return o.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return o.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, o) {
    var n = t.getUTCHours(), a;
    switch (n === 12 ? a = zi.noon : n === 0 ? a = zi.midnight : a = n / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return o.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return o.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return o.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return o.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, o) {
    var n = t.getUTCHours(), a;
    switch (n >= 17 ? a = zi.evening : n >= 12 ? a = zi.afternoon : n >= 4 ? a = zi.morning : a = zi.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return o.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, o) {
    if (r === "ho") {
      var n = t.getUTCHours() % 12;
      return n === 0 && (n = 12), o.ordinalNumber(n, {
        unit: "hour"
      });
    }
    return ul.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, o) {
    return r === "Ho" ? o.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : ul.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, o) {
    var n = t.getUTCHours() % 12;
    return r === "Ko" ? o.ordinalNumber(n, {
      unit: "hour"
    }) : ar(n, r.length);
  },
  // Hour [1-24]
  k: function(t, r, o) {
    var n = t.getUTCHours();
    return n === 0 && (n = 24), r === "ko" ? o.ordinalNumber(n, {
      unit: "hour"
    }) : ar(n, r.length);
  },
  // Minute
  m: function(t, r, o) {
    return r === "mo" ? o.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : ul.m(t, r);
  },
  // Second
  s: function(t, r, o) {
    return r === "so" ? o.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : ul.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return ul.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, o, n) {
    var a = n._originalDate || t, l = a.getTimezoneOffset();
    if (l === 0)
      return "Z";
    switch (r) {
      // Hours and optional minutes
      case "X":
        return ov(l);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Ql(l);
      // Hours and minutes with `:` delimiter
      default:
        return Ql(l, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, o, n) {
    var a = n._originalDate || t, l = a.getTimezoneOffset();
    switch (r) {
      // Hours and optional minutes
      case "x":
        return ov(l);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Ql(l);
      // Hours and minutes with `:` delimiter
      default:
        return Ql(l, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, o, n) {
    var a = n._originalDate || t, l = a.getTimezoneOffset();
    switch (r) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + rv(l, ":");
      default:
        return "GMT" + Ql(l, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, o, n) {
    var a = n._originalDate || t, l = a.getTimezoneOffset();
    switch (r) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + rv(l, ":");
      default:
        return "GMT" + Ql(l, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, o, n) {
    var a = n._originalDate || t, l = Math.floor(a.getTime() / 1e3);
    return ar(l, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, o, n) {
    var a = n._originalDate || t, l = a.getTime();
    return ar(l, r.length);
  }
};
function rv(e, t) {
  var r = e > 0 ? "-" : "+", o = Math.abs(e), n = Math.floor(o / 60), a = o % 60;
  if (a === 0)
    return r + String(n);
  var l = t;
  return r + String(n) + l + ar(a, 2);
}
function ov(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + ar(Math.abs(e) / 60, 2);
  }
  return Ql(e, t);
}
function Ql(e, t) {
  var r = t || "", o = e > 0 ? "-" : "+", n = Math.abs(e), a = ar(Math.floor(n / 60), 2), l = ar(n % 60, 2);
  return o + a + r + l;
}
var V7 = F7, nv = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    default:
      return r.date({
        width: "full"
      });
  }
}, H_ = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    default:
      return r.time({
        width: "full"
      });
  }
}, H7 = function(t, r) {
  var o = t.match(/(P+)(p+)?/) || [], n = o[1], a = o[2];
  if (!a)
    return nv(t, r);
  var l;
  switch (n) {
    case "P":
      l = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      l = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      l = r.dateTime({
        width: "long"
      });
      break;
    default:
      l = r.dateTime({
        width: "full"
      });
      break;
  }
  return l.replace("{{date}}", nv(n, r)).replace("{{time}}", H_(a, r));
}, U7 = {
  p: H_,
  P: H7
}, xp = U7, X7 = ["D", "DD"], W7 = ["YY", "YYYY"];
function U_(e) {
  return X7.indexOf(e) !== -1;
}
function X_(e) {
  return W7.indexOf(e) !== -1;
}
function Jc(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Y7 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, K7 = function(t, r, o) {
  var n, a = Y7[t];
  return typeof a == "string" ? n = a : r === 1 ? n = a.one : n = a.other.replace("{{count}}", r.toString()), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "in " + n : n + " ago" : n;
}, Q7 = K7;
function tf(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, o = e.formats[r] || e.formats[e.defaultWidth];
    return o;
  };
}
var j7 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Z7 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, z7 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, q7 = {
  date: tf({
    formats: j7,
    defaultWidth: "full"
  }),
  time: tf({
    formats: Z7,
    defaultWidth: "full"
  }),
  dateTime: tf({
    formats: z7,
    defaultWidth: "full"
  })
}, J7 = q7, e8 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, t8 = function(t, r, o, n) {
  return e8[t];
}, r8 = t8;
function Ed(e) {
  return function(t, r) {
    var o = r != null && r.context ? String(r.context) : "standalone", n;
    if (o === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, l = r != null && r.width ? String(r.width) : a;
      n = e.formattingValues[l] || e.formattingValues[a];
    } else {
      var i = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      n = e.values[s] || e.values[i];
    }
    var u = e.argumentCallback ? e.argumentCallback(t) : t;
    return n[u];
  };
}
var o8 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, n8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, a8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, l8 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, i8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, s8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, d8 = function(t, r) {
  var o = Number(t), n = o % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return o + "st";
      case 2:
        return o + "nd";
      case 3:
        return o + "rd";
    }
  return o + "th";
}, u8 = {
  ordinalNumber: d8,
  era: Ed({
    values: o8,
    defaultWidth: "wide"
  }),
  quarter: Ed({
    values: n8,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Ed({
    values: a8,
    defaultWidth: "wide"
  }),
  day: Ed({
    values: l8,
    defaultWidth: "wide"
  }),
  dayPeriod: Ed({
    values: i8,
    defaultWidth: "wide",
    formattingValues: s8,
    defaultFormattingWidth: "wide"
  })
}, c8 = u8;
function Od(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.width, n = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], a = t.match(n);
    if (!a)
      return null;
    var l = a[0], i = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(i) ? g8(i, function(g) {
      return g.test(l);
    }) : m8(i, function(g) {
      return g.test(l);
    }), u;
    u = e.valueCallback ? e.valueCallback(s) : s, u = r.valueCallback ? r.valueCallback(u) : u;
    var c = t.slice(l.length);
    return {
      value: u,
      rest: c
    };
  };
}
function m8(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function g8(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function f8(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = t.match(e.matchPattern);
    if (!o) return null;
    var n = o[0], a = t.match(e.parsePattern);
    if (!a) return null;
    var l = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    l = r.valueCallback ? r.valueCallback(l) : l;
    var i = t.slice(n.length);
    return {
      value: l,
      rest: i
    };
  };
}
var p8 = /^(\d+)(th|st|nd|rd)?/i, h8 = /\d+/i, x8 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, v8 = {
  any: [/^b/i, /^(a|c)/i]
}, S8 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, b8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, y8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, w8 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, _8 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, T8 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, A8 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, P8 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, M8 = {
  ordinalNumber: f8({
    matchPattern: p8,
    parsePattern: h8,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Od({
    matchPatterns: x8,
    defaultMatchWidth: "wide",
    parsePatterns: v8,
    defaultParseWidth: "any"
  }),
  quarter: Od({
    matchPatterns: S8,
    defaultMatchWidth: "wide",
    parsePatterns: b8,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Od({
    matchPatterns: y8,
    defaultMatchWidth: "wide",
    parsePatterns: w8,
    defaultParseWidth: "any"
  }),
  day: Od({
    matchPatterns: _8,
    defaultMatchWidth: "wide",
    parsePatterns: T8,
    defaultParseWidth: "any"
  }),
  dayPeriod: Od({
    matchPatterns: A8,
    defaultMatchWidth: "any",
    parsePatterns: P8,
    defaultParseWidth: "any"
  })
}, $8 = M8, C8 = {
  code: "en-US",
  formatDistance: Q7,
  formatLong: J7,
  formatRelative: r8,
  localize: c8,
  match: $8,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, W_ = C8, L8 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, E8 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, O8 = /^'([^]*?)'?$/, N8 = /''/g, D8 = /[a-zA-Z]/;
function k8(e, t, r) {
  var o, n, a, l, i, s, u, c, g, p, h, v, A, S;
  Zr(2, arguments);
  var b = String(t), T = gd(), w = (o = (n = void 0) !== null && n !== void 0 ? n : T.locale) !== null && o !== void 0 ? o : W_, N = en((a = (l = (i = (s = void 0) !== null && s !== void 0 ? s : void 0) !== null && i !== void 0 ? i : T.firstWeekContainsDate) !== null && l !== void 0 ? l : (u = T.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(N >= 1 && N <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var O = en((g = (p = (h = (v = void 0) !== null && v !== void 0 ? v : void 0) !== null && h !== void 0 ? h : T.weekStartsOn) !== null && p !== void 0 ? p : (A = T.locale) === null || A === void 0 || (S = A.options) === null || S === void 0 ? void 0 : S.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(O >= 0 && O <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!w.localize)
    throw new RangeError("locale must contain localize property");
  if (!w.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var m = ho(e);
  if (!qc(m))
    throw new RangeError("Invalid time value");
  var _ = B_(m), X = I_(m, _), $ = {
    firstWeekContainsDate: N,
    weekStartsOn: O,
    locale: w,
    _originalDate: m
  }, E = b.match(E8).map(function(D) {
    var U = D[0];
    if (U === "p" || U === "P") {
      var Y = xp[U];
      return Y(D, w.formatLong);
    }
    return D;
  }).join("").match(L8).map(function(D) {
    if (D === "''")
      return "'";
    var U = D[0];
    if (U === "'")
      return G8(D);
    var Y = V7[U];
    if (Y)
      return X_(D) && Jc(D, t, String(e)), U_(D) && Jc(D, t, String(e)), Y(X, D, w.localize, $);
    if (U.match(D8))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + U + "`");
    return D;
  }).join("");
  return E;
}
function G8(e) {
  var t = e.match(O8);
  return t ? t[1].replace(N8, "'") : e;
}
function B8(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
}
function av(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, o = Array(t); r < t; r++) o[r] = e[r];
  return o;
}
function I8(e, t) {
  if (e) {
    if (typeof e == "string") return av(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? av(e, t) : void 0;
  }
}
function lv(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = I8(e)) || t) {
      r && (e = r);
      var o = 0, n = function() {
      };
      return {
        s: n,
        n: function() {
          return o >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[o++]
          };
        },
        e: function(u) {
          throw u;
        },
        f: n
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, l = !0, i = !1;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var u = r.next();
      return l = u.done, u;
    },
    e: function(u) {
      i = !0, a = u;
    },
    f: function() {
      try {
        l || r.return == null || r.return();
      } finally {
        if (i) throw a;
      }
    }
  };
}
function st(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vp(e, t) {
  return vp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, vp(e, t);
}
function Yt(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && vp(e, t);
}
function em(e) {
  return em = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, em(e);
}
function Y_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Y_ = function() {
    return !!e;
  })();
}
function R8(e, t) {
  if (t && (ja(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return st(e);
}
function Kt(e) {
  var t = Y_();
  return function() {
    var r, o = em(e);
    if (t) {
      var n = em(this).constructor;
      r = Reflect.construct(o, arguments, n);
    } else r = o.apply(this, arguments);
    return R8(this, r);
  };
}
function Ft(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function F8(e, t) {
  if (ja(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var o = r.call(e, t);
    if (ja(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function K_(e) {
  var t = F8(e, "string");
  return ja(t) == "symbol" ? t : t + "";
}
function V8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var o = t[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, K_(o.key), o);
  }
}
function Vt(e, t, r) {
  return t && V8(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ot(e, t, r) {
  return (t = K_(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var H8 = 10, Q_ = /* @__PURE__ */ (function() {
  function e() {
    Ft(this, e), ot(this, "priority", void 0), ot(this, "subPriority", 0);
  }
  return Vt(e, [{
    key: "validate",
    value: function(r, o) {
      return !0;
    }
  }]), e;
})(), U8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r(o, n, a, l, i) {
    var s;
    return Ft(this, r), s = t.call(this), s.value = o, s.validateValue = n, s.setValue = a, s.priority = l, i && (s.subPriority = i), s;
  }
  return Vt(r, [{
    key: "validate",
    value: function(n, a) {
      return this.validateValue(n, this.value, a);
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return this.setValue(n, a, this.value, l);
    }
  }]), r;
})(Q_), X8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", H8), ot(st(o), "subPriority", -1), o;
  }
  return Vt(r, [{
    key: "set",
    value: function(n, a) {
      if (a.timestampIsSet)
        return n;
      var l = /* @__PURE__ */ new Date(0);
      return l.setFullYear(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()), l.setHours(n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds(), n.getUTCMilliseconds()), l;
    }
  }]), r;
})(Q_), tr = /* @__PURE__ */ (function() {
  function e() {
    Ft(this, e), ot(this, "incompatibleTokens", void 0), ot(this, "priority", void 0), ot(this, "subPriority", void 0);
  }
  return Vt(e, [{
    key: "run",
    value: function(r, o, n, a) {
      var l = this.parse(r, o, n, a);
      return l ? {
        setter: new U8(l.value, this.validate, this.set, this.priority, this.subPriority),
        rest: l.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, o, n) {
      return !0;
    }
  }]), e;
})(), W8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 140), ot(st(o), "incompatibleTokens", ["R", "u", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return l.era(n, {
            width: "abbreviated"
          }) || l.era(n, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return l.era(n, {
            width: "narrow"
          });
        default:
          return l.era(n, {
            width: "wide"
          }) || l.era(n, {
            width: "abbreviated"
          }) || l.era(n, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return a.era = l, n.setUTCFullYear(l, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr), Wr = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, fa = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Yr(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Cr(e, t) {
  var r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function pa(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var o = r[1] === "+" ? 1 : -1, n = r[2] ? parseInt(r[2], 10) : 0, a = r[3] ? parseInt(r[3], 10) : 0, l = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: o * (n * L7 + a * C7 + l * E7),
    rest: t.slice(r[0].length)
  };
}
function j_(e) {
  return Cr(Wr.anyDigitsSigned, e);
}
function Nr(e, t) {
  switch (e) {
    case 1:
      return Cr(Wr.singleDigit, t);
    case 2:
      return Cr(Wr.twoDigits, t);
    case 3:
      return Cr(Wr.threeDigits, t);
    case 4:
      return Cr(Wr.fourDigits, t);
    default:
      return Cr(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function tm(e, t) {
  switch (e) {
    case 1:
      return Cr(Wr.singleDigitSigned, t);
    case 2:
      return Cr(Wr.twoDigitsSigned, t);
    case 3:
      return Cr(Wr.threeDigitsSigned, t);
    case 4:
      return Cr(Wr.fourDigitsSigned, t);
    default:
      return Cr(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function _h(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    default:
      return 0;
  }
}
function Z_(e, t) {
  var r = t > 0, o = r ? t : 1 - t, n;
  if (o <= 50)
    n = e || 100;
  else {
    var a = o + 50, l = Math.floor(a / 100) * 100, i = e >= a % 100;
    n = e + l - (i ? 100 : 0);
  }
  return r ? n : 1 - n;
}
function z_(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var Y8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 130), ot(st(o), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      var i = function(u) {
        return {
          year: u,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return Yr(Nr(4, n), i);
        case "yo":
          return Yr(l.ordinalNumber(n, {
            unit: "year"
          }), i);
        default:
          return Yr(Nr(a.length, n), i);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      var i = n.getUTCFullYear();
      if (l.isTwoDigitYear) {
        var s = Z_(l.year, i);
        return n.setUTCFullYear(s, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
      }
      var u = !("era" in a) || a.era === 1 ? l.year : 1 - l.year;
      return n.setUTCFullYear(u, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr), K8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 130), ot(st(o), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      var i = function(u) {
        return {
          year: u,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return Yr(Nr(4, n), i);
        case "Yo":
          return Yr(l.ordinalNumber(n, {
            unit: "year"
          }), i);
        default:
          return Yr(Nr(a.length, n), i);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(n, a, l, i) {
      var s = wh(n, i);
      if (l.isTwoDigitYear) {
        var u = Z_(l.year, s);
        return n.setUTCFullYear(u, 0, i.firstWeekContainsDate), n.setUTCHours(0, 0, 0, 0), bi(n, i);
      }
      var c = !("era" in a) || a.era === 1 ? l.year : 1 - l.year;
      return n.setUTCFullYear(c, 0, i.firstWeekContainsDate), n.setUTCHours(0, 0, 0, 0), bi(n, i);
    }
  }]), r;
})(tr), Q8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 130), ot(st(o), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a) {
      return tm(a === "R" ? 4 : a.length, n);
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      var i = /* @__PURE__ */ new Date(0);
      return i.setUTCFullYear(l, 0, 4), i.setUTCHours(0, 0, 0, 0), Zs(i);
    }
  }]), r;
})(tr), j8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 130), ot(st(o), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a) {
      return tm(a === "u" ? 4 : a.length, n);
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCFullYear(l, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr), Z8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 120), ot(st(o), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return Nr(a.length, n);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return l.ordinalNumber(n, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return l.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return l.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return l.quarter(n, {
            width: "wide",
            context: "formatting"
          }) || l.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCMonth((l - 1) * 3, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr), z8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 120), ot(st(o), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return Nr(a.length, n);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return l.ordinalNumber(n, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return l.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return l.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        default:
          return l.quarter(n, {
            width: "wide",
            context: "standalone"
          }) || l.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCMonth((l - 1) * 3, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr), q8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ot(st(o), "priority", 110), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      var i = function(u) {
        return u - 1;
      };
      switch (a) {
        // 1, 2, ..., 12
        case "M":
          return Yr(Cr(Wr.month, n), i);
        // 01, 02, ..., 12
        case "MM":
          return Yr(Nr(2, n), i);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return Yr(l.ordinalNumber(n, {
            unit: "month"
          }), i);
        // Jan, Feb, ..., Dec
        case "MMM":
          return l.month(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.month(n, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return l.month(n, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return l.month(n, {
            width: "wide",
            context: "formatting"
          }) || l.month(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.month(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCMonth(l, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr), J8 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 110), ot(st(o), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      var i = function(u) {
        return u - 1;
      };
      switch (a) {
        // 1, 2, ..., 12
        case "L":
          return Yr(Cr(Wr.month, n), i);
        // 01, 02, ..., 12
        case "LL":
          return Yr(Nr(2, n), i);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return Yr(l.ordinalNumber(n, {
            unit: "month"
          }), i);
        // Jan, Feb, ..., Dec
        case "LLL":
          return l.month(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.month(n, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return l.month(n, {
            width: "narrow",
            context: "standalone"
          });
        default:
          return l.month(n, {
            width: "wide",
            context: "standalone"
          }) || l.month(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.month(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCMonth(l, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr);
function e6(e, t, r) {
  Zr(2, arguments);
  var o = ho(e), n = en(t), a = V_(o, r) - n;
  return o.setUTCDate(o.getUTCDate() - a * 7), o;
}
var t6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 100), ot(st(o), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "w":
          return Cr(Wr.week, n);
        case "wo":
          return l.ordinalNumber(n, {
            unit: "week"
          });
        default:
          return Nr(a.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(n, a, l, i) {
      return bi(e6(n, l, i), i);
    }
  }]), r;
})(tr);
function r6(e, t) {
  Zr(2, arguments);
  var r = ho(e), o = en(t), n = F_(r) - o;
  return r.setUTCDate(r.getUTCDate() - n * 7), r;
}
var o6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 100), ot(st(o), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "I":
          return Cr(Wr.week, n);
        case "Io":
          return l.ordinalNumber(n, {
            unit: "week"
          });
        default:
          return Nr(a.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return Zs(r6(n, l));
    }
  }]), r;
})(tr), n6 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], a6 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], l6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 90), ot(st(o), "subPriority", 1), ot(st(o), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "d":
          return Cr(Wr.date, n);
        case "do":
          return l.ordinalNumber(n, {
            unit: "date"
          });
        default:
          return Nr(a.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      var l = n.getUTCFullYear(), i = z_(l), s = n.getUTCMonth();
      return i ? a >= 1 && a <= a6[s] : a >= 1 && a <= n6[s];
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCDate(l), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr), i6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 90), ot(st(o), "subpriority", 1), ot(st(o), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "D":
        case "DD":
          return Cr(Wr.dayOfYear, n);
        case "Do":
          return l.ordinalNumber(n, {
            unit: "date"
          });
        default:
          return Nr(a.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      var l = n.getUTCFullYear(), i = z_(l);
      return i ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCMonth(0, l), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr);
function Th(e, t, r) {
  var o, n, a, l, i, s, u, c;
  Zr(2, arguments);
  var g = gd(), p = en((o = (n = (a = (l = r?.weekStartsOn) !== null && l !== void 0 ? l : r == null || (i = r.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : g.weekStartsOn) !== null && n !== void 0 ? n : (u = g.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && o !== void 0 ? o : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ho(e), v = en(t), A = h.getUTCDay(), S = v % 7, b = (S + 7) % 7, T = (b < p ? 7 : 0) + v - A;
  return h.setUTCDate(h.getUTCDate() + T), h;
}
var s6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 90), ot(st(o), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return l.day(n, {
            width: "wide",
            context: "formatting"
          }) || l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(n, a, l, i) {
      return n = Th(n, l, i), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr), d6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 90), ot(st(o), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l, i) {
      var s = function(c) {
        var g = Math.floor((c - 1) / 7) * 7;
        return (c + i.weekStartsOn + 6) % 7 + g;
      };
      switch (a) {
        // 3
        case "e":
        case "ee":
          return Yr(Nr(a.length, n), s);
        // 3rd
        case "eo":
          return Yr(l.ordinalNumber(n, {
            unit: "day"
          }), s);
        // Tue
        case "eee":
          return l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return l.day(n, {
            width: "wide",
            context: "formatting"
          }) || l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(n, a, l, i) {
      return n = Th(n, l, i), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr), u6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 90), ot(st(o), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l, i) {
      var s = function(c) {
        var g = Math.floor((c - 1) / 7) * 7;
        return (c + i.weekStartsOn + 6) % 7 + g;
      };
      switch (a) {
        // 3
        case "c":
        case "cc":
          return Yr(Nr(a.length, n), s);
        // 3rd
        case "co":
          return Yr(l.ordinalNumber(n, {
            unit: "day"
          }), s);
        // Tue
        case "ccc":
          return l.day(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.day(n, {
            width: "short",
            context: "standalone"
          }) || l.day(n, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return l.day(n, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return l.day(n, {
            width: "short",
            context: "standalone"
          }) || l.day(n, {
            width: "narrow",
            context: "standalone"
          });
        default:
          return l.day(n, {
            width: "wide",
            context: "standalone"
          }) || l.day(n, {
            width: "abbreviated",
            context: "standalone"
          }) || l.day(n, {
            width: "short",
            context: "standalone"
          }) || l.day(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(n, a, l, i) {
      return n = Th(n, l, i), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr);
function c6(e, t) {
  Zr(2, arguments);
  var r = en(t);
  r % 7 === 0 && (r = r - 7);
  var o = 1, n = ho(e), a = n.getUTCDay(), l = r % 7, i = (l + 7) % 7, s = (i < o ? 7 : 0) + r - a;
  return n.setUTCDate(n.getUTCDate() + s), n;
}
var m6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 90), ot(st(o), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      var i = function(u) {
        return u === 0 ? 7 : u;
      };
      switch (a) {
        // 2
        case "i":
        case "ii":
          return Nr(a.length, n);
        // 2nd
        case "io":
          return l.ordinalNumber(n, {
            unit: "day"
          });
        // Tue
        case "iii":
          return Yr(l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          }), i);
        // T
        case "iiiii":
          return Yr(l.day(n, {
            width: "narrow",
            context: "formatting"
          }), i);
        // Tu
        case "iiiiii":
          return Yr(l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          }), i);
        default:
          return Yr(l.day(n, {
            width: "wide",
            context: "formatting"
          }) || l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          }), i);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n = c6(n, l), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
})(tr), g6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 80), ot(st(o), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return l.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCHours(_h(l), 0, 0, 0), n;
    }
  }]), r;
})(tr), f6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 80), ot(st(o), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return l.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCHours(_h(l), 0, 0, 0), n;
    }
  }]), r;
})(tr), p6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 80), ot(st(o), "incompatibleTokens", ["a", "b", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        default:
          return l.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCHours(_h(l), 0, 0, 0), n;
    }
  }]), r;
})(tr), h6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 70), ot(st(o), "incompatibleTokens", ["H", "K", "k", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "h":
          return Cr(Wr.hour12h, n);
        case "ho":
          return l.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return Nr(a.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      var i = n.getUTCHours() >= 12;
      return i && l < 12 ? n.setUTCHours(l + 12, 0, 0, 0) : !i && l === 12 ? n.setUTCHours(0, 0, 0, 0) : n.setUTCHours(l, 0, 0, 0), n;
    }
  }]), r;
})(tr), x6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 70), ot(st(o), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "H":
          return Cr(Wr.hour23h, n);
        case "Ho":
          return l.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return Nr(a.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCHours(l, 0, 0, 0), n;
    }
  }]), r;
})(tr), v6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 70), ot(st(o), "incompatibleTokens", ["h", "H", "k", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "K":
          return Cr(Wr.hour11h, n);
        case "Ko":
          return l.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return Nr(a.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      var i = n.getUTCHours() >= 12;
      return i && l < 12 ? n.setUTCHours(l + 12, 0, 0, 0) : n.setUTCHours(l, 0, 0, 0), n;
    }
  }]), r;
})(tr), S6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 70), ot(st(o), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "k":
          return Cr(Wr.hour24h, n);
        case "ko":
          return l.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return Nr(a.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      var i = l <= 24 ? l % 24 : l;
      return n.setUTCHours(i, 0, 0, 0), n;
    }
  }]), r;
})(tr), b6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 60), ot(st(o), "incompatibleTokens", ["t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "m":
          return Cr(Wr.minute, n);
        case "mo":
          return l.ordinalNumber(n, {
            unit: "minute"
          });
        default:
          return Nr(a.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCMinutes(l, 0, 0), n;
    }
  }]), r;
})(tr), y6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 50), ot(st(o), "incompatibleTokens", ["t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a, l) {
      switch (a) {
        case "s":
          return Cr(Wr.second, n);
        case "so":
          return l.ordinalNumber(n, {
            unit: "second"
          });
        default:
          return Nr(a.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCSeconds(l, 0), n;
    }
  }]), r;
})(tr), w6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 30), ot(st(o), "incompatibleTokens", ["t", "T"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a) {
      var l = function(s) {
        return Math.floor(s * Math.pow(10, -a.length + 3));
      };
      return Yr(Nr(a.length, n), l);
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return n.setUTCMilliseconds(l), n;
    }
  }]), r;
})(tr), _6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 10), ot(st(o), "incompatibleTokens", ["t", "T", "x"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a) {
      switch (a) {
        case "X":
          return pa(fa.basicOptionalMinutes, n);
        case "XX":
          return pa(fa.basic, n);
        case "XXXX":
          return pa(fa.basicOptionalSeconds, n);
        case "XXXXX":
          return pa(fa.extendedOptionalSeconds, n);
        default:
          return pa(fa.extended, n);
      }
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return a.timestampIsSet ? n : new Date(n.getTime() - l);
    }
  }]), r;
})(tr), T6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 10), ot(st(o), "incompatibleTokens", ["t", "T", "X"]), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n, a) {
      switch (a) {
        case "x":
          return pa(fa.basicOptionalMinutes, n);
        case "xx":
          return pa(fa.basic, n);
        case "xxxx":
          return pa(fa.basicOptionalSeconds, n);
        case "xxxxx":
          return pa(fa.extendedOptionalSeconds, n);
        default:
          return pa(fa.extended, n);
      }
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return a.timestampIsSet ? n : new Date(n.getTime() - l);
    }
  }]), r;
})(tr), A6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 40), ot(st(o), "incompatibleTokens", "*"), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n) {
      return j_(n);
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return [new Date(l * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
})(tr), P6 = /* @__PURE__ */ (function(e) {
  Yt(r, e);
  var t = Kt(r);
  function r() {
    var o;
    Ft(this, r);
    for (var n = arguments.length, a = new Array(n), l = 0; l < n; l++)
      a[l] = arguments[l];
    return o = t.call.apply(t, [this].concat(a)), ot(st(o), "priority", 20), ot(st(o), "incompatibleTokens", "*"), o;
  }
  return Vt(r, [{
    key: "parse",
    value: function(n) {
      return j_(n);
    }
  }, {
    key: "set",
    value: function(n, a, l) {
      return [new Date(l), {
        timestampIsSet: !0
      }];
    }
  }]), r;
})(tr), M6 = {
  G: new W8(),
  y: new Y8(),
  Y: new K8(),
  R: new Q8(),
  u: new j8(),
  Q: new Z8(),
  q: new z8(),
  M: new q8(),
  L: new J8(),
  w: new t6(),
  I: new o6(),
  d: new l6(),
  D: new i6(),
  E: new s6(),
  e: new d6(),
  c: new u6(),
  i: new m6(),
  a: new g6(),
  b: new f6(),
  B: new p6(),
  h: new h6(),
  H: new x6(),
  K: new v6(),
  k: new S6(),
  m: new b6(),
  s: new y6(),
  S: new w6(),
  X: new _6(),
  x: new T6(),
  t: new A6(),
  T: new P6()
}, $6 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, C6 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, L6 = /^'([^]*?)'?$/, E6 = /''/g, O6 = /\S/, N6 = /[a-zA-Z]/;
function q_(e, t, r, o) {
  var n, a, l, i, s, u, c, g, p, h, v, A, S, b;
  Zr(3, arguments);
  var T = String(e), w = String(t), N = gd(), O = (n = (a = void 0) !== null && a !== void 0 ? a : N.locale) !== null && n !== void 0 ? n : W_;
  if (!O.match)
    throw new RangeError("locale must contain match property");
  var m = en((l = (i = (s = (u = void 0) !== null && u !== void 0 ? u : void 0) !== null && s !== void 0 ? s : N.firstWeekContainsDate) !== null && i !== void 0 ? i : (c = N.locale) === null || c === void 0 || (g = c.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && l !== void 0 ? l : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var _ = en((p = (h = (v = (A = void 0) !== null && A !== void 0 ? A : void 0) !== null && v !== void 0 ? v : N.weekStartsOn) !== null && h !== void 0 ? h : (S = N.locale) === null || S === void 0 || (b = S.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(_ >= 0 && _ <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (w === "")
    return T === "" ? ho(r) : /* @__PURE__ */ new Date(NaN);
  var X = {
    firstWeekContainsDate: m,
    weekStartsOn: _,
    locale: O
  }, $ = [new X8()], E = w.match(C6).map(function(le) {
    var te = le[0];
    if (te in xp) {
      var ie = xp[te];
      return ie(le, O.formatLong);
    }
    return le;
  }).join("").match($6), D = [], U = lv(E), Y;
  try {
    var G = function() {
      var te = Y.value;
      !(o != null && o.useAdditionalWeekYearTokens) && X_(te) && Jc(te, w, e), !(o != null && o.useAdditionalDayOfYearTokens) && U_(te) && Jc(te, w, e);
      var ie = te[0], B = M6[ie];
      if (B) {
        var I = B.incompatibleTokens;
        if (Array.isArray(I)) {
          var ee = D.find(function(pe) {
            return I.includes(pe.token) || pe.token === ie;
          });
          if (ee)
            throw new RangeError("The format string mustn't contain `".concat(ee.fullToken, "` and `").concat(te, "` at the same time"));
        } else if (B.incompatibleTokens === "*" && D.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(te, "` and any other token at the same time"));
        D.push({
          token: ie,
          fullToken: te
        });
        var Se = B.run(T, te, O.match, X);
        if (!Se)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        $.push(Se.setter), T = Se.rest;
      } else {
        if (ie.match(N6))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + ie + "`");
        if (te === "''" ? te = "'" : ie === "'" && (te = D6(te)), T.indexOf(te) === 0)
          T = T.slice(te.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (U.s(); !(Y = U.n()).done; ) {
      var K = G();
      if (ja(K) === "object") return K.v;
    }
  } catch (le) {
    U.e(le);
  } finally {
    U.f();
  }
  if (T.length > 0 && O6.test(T))
    return /* @__PURE__ */ new Date(NaN);
  var W = $.map(function(le) {
    return le.priority;
  }).sort(function(le, te) {
    return te - le;
  }).filter(function(le, te, ie) {
    return ie.indexOf(le) === te;
  }).map(function(le) {
    return $.filter(function(te) {
      return te.priority === le;
    }).sort(function(te, ie) {
      return ie.subPriority - te.subPriority;
    });
  }).map(function(le) {
    return le[0];
  }), xe = ho(r);
  if (isNaN(xe.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var Ce = I_(xe, B_(xe)), Q = {}, ue = lv(W), V;
  try {
    for (ue.s(); !(V = ue.n()).done; ) {
      var ae = V.value;
      if (!ae.validate(Ce, X))
        return /* @__PURE__ */ new Date(NaN);
      var F = ae.set(Ce, Q, X);
      Array.isArray(F) ? (Ce = F[0], B8(Q, F[1])) : Ce = F;
    }
  } catch (le) {
    ue.e(le);
  } finally {
    ue.f();
  }
  return Ce;
}
function D6(e) {
  return e.match(L6)[1].replace(E6, "'");
}
const Vm = Object.assign({}, Ns);
Vm.isRight = !0;
Vm.compare = function(e, t, r) {
  function o(n) {
    if (r && r.dateInputFormat)
      return q_(`${n}`, `${r.dateInputFormat}`, /* @__PURE__ */ new Date());
    if (typeof n == "string")
      try {
        return Date.parse(n);
      } catch {
        return n;
      }
    return n;
  }
  return e = o(e), t = o(t), qc(e) ? qc(t) ? $7(e, t) : 1 : -1;
};
Vm.format = function(e, t) {
  if (e == null) return "";
  const r = q_(e, t.dateInputFormat, /* @__PURE__ */ new Date());
  return qc(r) ? k8(r, t.dateOutputFormat) : (console.error(`Not a valid date: "${e}"`), null);
};
var k6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Vm
});
const yi = Object.assign({}, Ns);
yi.isRight = !0;
yi.filterPredicate = function(e, t) {
  return yi.compare(e, t) === 0;
};
yi.compare = function(e, t) {
  function r(o) {
    return o == null ? -1 / 0 : o.indexOf(".") >= 0 ? parseFloat(o) : parseInt(o, 10);
  }
  return e = typeof e == "number" ? e : r(e), t = typeof t == "number" ? t : r(t), e < t ? -1 : e > t ? 1 : 0;
};
var G6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yi
});
const J_ = Object.assign({}, yi);
J_.format = function(e) {
  return e == null ? "" : parseFloat(Math.round(e * 100) / 100).toFixed(2);
};
var B6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: J_
});
const eT = Object.assign({}, yi);
eT.format = function(e) {
  return e == null ? "" : `${parseFloat(e * 100).toFixed(2)}%`;
};
var I6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: eT
});
const ou = Object.assign({}, Ns);
ou.isRight = !0;
ou.filterPredicate = function(e, t) {
  return ou.compare(e, t) === 0;
};
ou.compare = function(e, t) {
  function r(o) {
    return typeof o == "boolean" ? o ? 1 : 0 : typeof o == "string" ? o === "true" ? 1 : 0 : -1 / 0;
  }
  return e = r(e), t = r(t), e < t ? -1 : e > t ? 1 : 0;
};
var R6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ou
}), F6 = {
  date: k6,
  decimal: B6,
  number: G6,
  percentage: I6,
  boolean: R6
};
const tT = {}, iv = F6;
Object.keys(iv).forEach((e) => {
  const t = e.replace(/^\.\//, "").replace(/\.js/, "");
  tT[t] = iv[e].default;
});
const V6 = {
  name: "vue-good-table",
  props: {
    isLoading: { default: null, type: Boolean },
    maxHeight: { default: null, type: String },
    fixedHeader: Boolean,
    theme: { default: "" },
    mode: { default: "local" },
    // could be remote
    totalRows: {},
    // required if mode = 'remote'
    styleClass: { default: "vgt-table bordered" },
    columns: {},
    rows: {},
    lineNumbers: Boolean,
    responsive: { default: !0, type: Boolean },
    rtl: Boolean,
    rowStyleClass: { default: null, type: [Function, String] },
    compactMode: Boolean,
    enableRowExpand: { default: !1, type: Boolean },
    expandRowsOptions: {
      default() {
        return {
          enabled: !1
        };
      }
    },
    groupOptions: {
      default() {
        return {
          enabled: !1,
          collapsable: !1,
          rowKey: null
        };
      }
    },
    selectOptions: {
      default() {
        return {
          enabled: !1,
          selectionInfoClass: "",
          selectionText: (e) => e + " row" + (e !== 1 ? "s" : "") + " selected",
          clearSelectionText: "clear",
          disableSelectInfo: !1,
          selectAllByGroup: !1,
          alwaysShowSelectionInfo: !1
        };
      }
    },
    // sort
    sortOptions: {
      default() {
        return {
          enabled: !0,
          multipleColumns: !0,
          initialSortBy: {}
        };
      }
    },
    // pagination
    paginationOptions: {
      default() {
        return {
          enabled: !1,
          position: "bottom",
          perPage: 10,
          perPageDropdown: null,
          perPageDropdownEnabled: !0,
          dropdownAllowAll: !0,
          mode: "records",
          // or pages
          infoFn: null
        };
      }
    },
    searchOptions: {
      default() {
        return {
          enabled: !1,
          trigger: null,
          externalQuery: null,
          searchFn: null,
          placeholder: "Search Table"
        };
      }
    },
    expandedRowClasses: {
      default: "",
      type: String
    },
    expandedRowDetailClasses: {
      default: "",
      type: String
    }
  },
  data: () => ({
    // loading state for remote mode
    tableLoading: !1,
    // text options
    nextText: "Next",
    prevText: "Previous",
    rowsPerPageText: "Rows per page",
    ofText: "of",
    allText: "All",
    pageText: "page",
    // internal select options
    selectable: !1,
    selectOnCheckboxOnly: !1,
    selectAllByPage: !0,
    disableSelectInfo: !1,
    selectionInfoClass: "",
    selectionText: (e) => e + " row" + (e !== 1 ? "s" : "") + " selected",
    clearSelectionText: "clear",
    alwaysShowSelectionInfo: !1,
    // keys for rows that are currently expanded
    maintainExpanded: !0,
    expandedRowKeys: /* @__PURE__ */ new Set(),
    // internal sort options
    sortable: !0,
    defaultSortBy: null,
    multipleColumnSort: !0,
    // internal search options
    searchEnabled: !1,
    searchTrigger: null,
    externalSearchQuery: null,
    searchFn: null,
    searchPlaceholder: "Search Table",
    searchSkipDiacritics: !1,
    // internal pagination options
    perPage: null,
    paginate: !1,
    paginateOnTop: !1,
    paginateOnBottom: !0,
    customRowsPerPageDropdown: [],
    paginateDropdownAllowAll: !0,
    paginationMode: "records",
    paginationInfoFn: null,
    currentPage: 1,
    currentPerPage: 10,
    sorts: [],
    globalSearchTerm: "",
    filteredRows: [],
    columnFilters: {},
    forceSearch: !1,
    sortChanged: !1,
    dataTypes: tT || {},
    expandedRowIndex: null
  }),
  emits: [
    "select-all",
    "selected-rows-change",
    "search",
    "per-page-change",
    "page-change",
    "update:isLoading",
    "sort-change",
    "row-click",
    "row-dblclick",
    "row-aux-click",
    "cell-click",
    "row-mouseenter",
    "row-mouseleave",
    "column-filter"
  ],
  watch: {
    rows: {
      handler() {
        this.$emit("update:isLoading", !1), this.filterRows(this.columnFilters, !1);
      },
      deep: !0,
      immediate: !0
    },
    selectOptions: {
      handler() {
        this.initializeSelect();
      },
      deep: !0,
      immediate: !0
    },
    paginationOptions: {
      handler(e, t) {
        Jg(e, t) || this.initializePagination();
      },
      deep: !0,
      immediate: !0
    },
    expandRowsOptions: {
      handler(e, t) {
        this.initializeExpandRows();
      },
      deep: !0,
      immediate: !0
    },
    searchOptions: {
      handler() {
        this.searchOptions.externalQuery !== void 0 && this.searchOptions.externalQuery !== this.searchTerm && (this.externalSearchQuery = this.searchOptions.externalQuery, this.handleSearch()), this.initializeSearch();
      },
      deep: !0,
      immediate: !0
    },
    sortOptions: {
      handler(e, t) {
        Jg(e, t) || this.initializeSort();
      },
      deep: !0
    },
    selectedRows(e, t) {
      Jg(e, t) || this.$emit("selected-rows-change", {
        selectedRows: this.selectedRows
      });
    }
  },
  computed: {
    tableStyles() {
      return this.compactMode ? this.tableStyleClasses + "vgt-compact" : this.tableStyleClasses;
    },
    hasFooterSlot() {
      return !!this.$slots["table-actions-bottom"];
    },
    wrapperStyles() {
      return {
        overflow: "scroll-y",
        maxHeight: this.maxHeight ? this.maxHeight : "auto"
      };
    },
    rowKeyField() {
      return this.groupOptions.rowKey || "vgt_header_id";
    },
    hasHeaderRowTemplate() {
      return !!this.$slots["table-header-row"];
    },
    showEmptySlot() {
      return !this.paginated.length || this.paginated[0].label === "no groups" && !this.paginated[0].children.length;
    },
    allSelected() {
      return this.selectedRowCount > 0 && (this.selectAllByPage && this.selectedPageRowsCount === this.totalPageRowCount || !this.selectAllByPage && this.selectedRowCount === this.totalRowCount);
    },
    allSelectedIndeterminate() {
      return !this.allSelected && (this.selectAllByPage && this.selectedPageRowsCount > 0 || !this.selectAllByPage && this.selectedRowCount > 0);
    },
    selectionInfo() {
      return typeof this.selectionText == "function" ? this.selectionText(this.selectedRowCount) : `${this.selectedRowCount} ${this.selectionText}`;
    },
    selectedRowCount() {
      return this.selectedRows.length;
    },
    selectedPageRowsCount() {
      return this.selectedPageRows.length;
    },
    selectedPageRows() {
      const e = [];
      return this.paginated.forEach((t) => {
        t.children.forEach((r) => {
          r.vgtSelected && e.push(r);
        });
      }), e;
    },
    selectedRows() {
      const e = [];
      return this.processedRows.forEach((t) => {
        t.children.forEach((r) => {
          r.vgtSelected && e.push(r);
        });
      }), e.sort((t, r) => t.originalIndex - r.originalIndex);
    },
    fullColspan() {
      let e = 0;
      for (let t = 0; t < this.columns.length; t += 1)
        this.columns[t].hidden || (e += 1);
      return this.lineNumbers && e++, this.selectable && e++, this.expandRowsEnabled && e++, e;
    },
    groupHeaderOnTop() {
      return this.groupOptions && this.groupOptions.enabled && this.groupOptions.headerPosition && this.groupOptions.headerPosition === "bottom" ? !1 : !!(this.groupOptions && this.groupOptions.enabled);
    },
    groupHeaderOnBottom() {
      return !!(this.groupOptions && this.groupOptions.enabled && this.groupOptions.headerPosition && this.groupOptions.headerPosition === "bottom");
    },
    totalRowCount() {
      return this.processedRows.reduce((t, r) => {
        const o = r.children ? r.children.length : 0;
        return t + o;
      }, 0);
    },
    totalPageRowCount() {
      return this.paginated.reduce((t, r) => {
        const o = r.children ? r.children.length : 0;
        return t + o;
      }, 0);
    },
    wrapStyleClasses() {
      let e = "vgt-wrap";
      return this.rtl && (e += " rtl"), e += ` ${this.theme}`, e;
    },
    tableStyleClasses() {
      let e = this.styleClass;
      return e += ` ${this.theme}`, e;
    },
    searchTerm() {
      return this.externalSearchQuery != null ? this.externalSearchQuery : this.globalSearchTerm;
    },
    //
    globalSearchAllowed() {
      return this.searchEnabled && this.globalSearchTerm && this.searchTrigger !== "enter" || this.externalSearchQuery != null && this.searchTrigger !== "enter" ? !0 : this.forceSearch ? (this.forceSearch = !1, !0) : !1;
    },
    // this is done everytime sortColumn
    // or sort type changes
    //----------------------------------------
    processedRows() {
      let e = this.filteredRows;
      if (this.mode === "remote")
        return e;
      if (this.globalSearchAllowed) {
        const t = [];
        this.filteredRows.forEach((o) => {
          t.push(...o.children);
        });
        const r = [];
        t.forEach((o) => {
          for (let n = 0; n < this.columns.length; n += 1) {
            const a = this.columns[n];
            if (!a.globalSearchDisabled) {
              if (this.searchFn) {
                if (this.searchFn(
                  o,
                  a,
                  this.collectFormatted(o, a),
                  this.searchTerm
                )) {
                  r.push(o);
                  break;
                }
              } else if (Ns.filterPredicate(
                this.collectFormatted(o, a),
                this.searchTerm,
                this.searchSkipDiacritics
              )) {
                r.push(o);
                break;
              }
            }
          }
        }), this.$emit("search", {
          searchTerm: this.searchTerm,
          rowCount: r.length
        }), e = [], this.filteredRows.forEach((o) => {
          const n = o.vgt_header_id, a = r.filter((l) => l.vgt_id === n);
          if (a.length) {
            const l = JSON.parse(JSON.stringify(o));
            l.children = a, e.push(l);
          }
        });
      }
      return this.sorts.length && e.forEach((t) => {
        t.children.sort((r, o) => {
          let n;
          for (let a = 0; a < this.sorts.length; a += 1) {
            const l = this.sorts[a];
            if (l.type === xo.None)
              n = n || r.originalIndex - o.originalIndex;
            else {
              const i = this.getColumnForField(l.field), s = this.collect(r, l.field), u = this.collect(o, l.field), { sortFn: c } = i;
              c && typeof c == "function" ? n = n || c(s, u, i, r, o) * (l.type === xo.Descending ? -1 : 1) : n = n || i.typeDef.compare(s, u, i) * (l.type === xo.Descending ? -1 : 1);
            }
          }
          return n;
        });
      }), this.searchTrigger === "enter" && (this.filteredRows = e), e;
    },
    paginated() {
      if (!this.processedRows.length) return [];
      if (this.mode === "remote")
        return this.processedRows;
      let e = [];
      if (this.processedRows.forEach((r) => {
        this.groupOptions.enabled && e.push(r), e.push(...r.children);
      }), this.paginate) {
        let r = (this.currentPage - 1) * this.currentPerPage;
        (r >= e.length || this.currentPerPage === -1) && (this.currentPage = 1, r = 0);
        let o = e.length + 1;
        this.currentPerPage !== -1 && (o = this.currentPage * this.currentPerPage), e = e.slice(r, o);
      }
      const t = [];
      return e.forEach((r) => {
        if (r.vgt_header_id !== void 0) {
          this.handleExpanded(r);
          const o = JSON.parse(JSON.stringify(r));
          o.children = [], t.push(o);
        } else {
          let o = t.find(
            (n) => n.vgt_header_id === r.vgt_id
          );
          o || (o = this.processedRows.find(
            (n) => n.vgt_header_id === r.vgt_id
          ), o && (o = JSON.parse(JSON.stringify(o)), o.children = [], t.push(o))), o.children.push(r);
        }
      }), t;
    },
    originalRows() {
      const e = JSON.parse(JSON.stringify(this.rows));
      let t = [];
      this.groupOptions.enabled ? t = this.handleGrouped(e) : t = this.handleGrouped([
        {
          label: "no groups",
          children: e
        }
      ]);
      let r = 0;
      return t.forEach((o) => {
        o.children.forEach((n) => {
          n.originalIndex = r++;
        });
      }), t;
    },
    typedColumns() {
      const e = this.columns;
      for (let t = 0; t < this.columns.length; t++) {
        const r = e[t];
        r.typeDef = this.dataTypes[r.type] || Ns;
      }
      return e;
    },
    hasRowClickListener() {
      return this.$attrs && this.$attrs.onRowClick;
    }
  },
  methods: {
    //* we need to check for expanded row state here
    //* to maintain it when sorting/filtering
    handleExpanded(e) {
      this.maintainExpanded && this.expandedRowKeys.has(e[this.rowKeyField]) ? e.vgtIsExpanded = !0 : e.vgtIsExpanded = !1;
    },
    toggleExpand(e) {
      const t = this.filteredRows.find(
        (r) => r[this.rowKeyField] === e
      );
      t && (t.vgtIsExpanded = !t.vgtIsExpanded), this.maintainExpanded && t.vgtIsExpanded ? this.expandedRowKeys.add(t[this.rowKeyField]) : this.expandedRowKeys.delete(t[this.rowKeyField]);
    },
    expandAll() {
      this.filteredRows.forEach((e) => {
        e.vgtIsExpanded = !0, this.maintainExpanded && this.expandedRowKeys.add(e[this.rowKeyField]);
      });
    },
    collapseAll() {
      this.filteredRows.forEach((e) => {
        e.vgtIsExpanded = !1, this.expandedRowKeys.clear();
      });
    },
    getColumnForField(e) {
      for (let t = 0; t < this.typedColumns.length; t += 1)
        if (this.typedColumns[t].field === e) return this.typedColumns[t];
    },
    handleSearch() {
      this.resetTable(), this.mode === "remote" && this.$emit("search", {
        searchTerm: this.searchTerm
      });
    },
    reset() {
      this.initializeSort(), this.changePage(1), this.$refs["table-header-primary"].reset(!0), this.$refs["table-header-secondary"] && this.$refs["table-header-secondary"].reset(!0);
    },
    emitSelectedRows() {
      this.$emit("select-all", {
        selected: this.selectedRowCount === this.totalRowCount,
        selectedRows: this.selectedRows
      });
    },
    unselectAllInternal(e) {
      (this.selectAllByPage && !e ? this.paginated : this.filteredRows).forEach((r, o) => {
        r.children.forEach((n, a) => {
          n.vgtSelected = !1;
        });
      }), this.emitSelectedRows();
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.unselectAllInternal();
        return;
      }
      (this.selectAllByPage ? this.paginated : this.filteredRows).forEach((t) => {
        t.children.forEach((r) => {
          r.vgtSelected = !0;
        });
      }), this.emitSelectedRows();
    },
    toggleExpandRowsAll() {
      for (let e of this.rows)
        e.expandedRow ? e.expanded = !e.expanded : e.expanded = !1;
      this.$emit("toggle-expand-rows-all", {});
    },
    toggleSelectGroup(e, t) {
      t.children.forEach((r) => {
        r.vgtSelected = e.checked;
      });
    },
    changePage(e) {
      const t = this.paginate;
      let { paginationBottom: r, paginationTop: o } = this.$refs;
      t && (this.paginateOnTop && o && (o.currentPage = e), this.paginateOnBottom && r && (r.currentPage = e), this.currentPage = e);
    },
    pageChangedEvent() {
      return {
        currentPage: this.currentPage,
        currentPerPage: this.currentPerPage,
        total: Math.floor(this.totalRowCount / this.currentPerPage)
      };
    },
    pageChanged(e) {
      if (this.currentPage = e.currentPage, !e.noEmit) {
        const t = this.pageChangedEvent();
        t.prevPage = e.prevPage, this.$emit("page-change", t), this.mode === "remote" && this.$emit("update:isLoading", !0);
      }
    },
    perPageChanged(e) {
      this.currentPerPage = e.currentPerPage;
      let t = this.paginationOptions.position;
      this.$refs.paginationTop && (t === "top" || t === "both") && (this.$refs.paginationTop.currentPerPage = this.currentPerPage), this.$refs.paginationBottom && (t === "bottom" || t === "both") && (this.$refs.paginationBottom.currentPerPage = this.currentPerPage);
      const r = this.pageChangedEvent();
      this.$emit("per-page-change", r), this.mode === "remote" && this.$emit("update:isLoading", !0);
    },
    changeSort(e) {
      if (this.sorts = e, this.$emit("sort-change", e), this.changePage(1), this.mode === "remote") {
        this.$emit("update:isLoading", !0);
        return;
      }
      this.sortChanged = !0;
    },
    toggleRowExpand(e, t) {
      this.expandedRowIndex === t ? this.expandedRowIndex = null : this.expandedRowIndex = t;
    },
    // checkbox click should always do the following
    onCheckboxClicked(e, t, r) {
      this.enableRowExpand && this.toggleRowExpand(e, t), e.vgtSelected = !e.vgtSelected, this.$emit("row-click", {
        row: e,
        pageIndex: t,
        selected: !!e.vgtSelected,
        event: r
      });
    },
    toggleExpandRow(e) {
      e.expanded = !e.expanded;
    },
    onRowDoubleClicked(e, t, r) {
      this.$emit("row-dblclick", {
        row: e,
        pageIndex: t,
        selected: !!e.vgtSelected,
        event: r
      });
    },
    onRowClicked(e, t, r) {
      this.enableRowExpand && this.toggleRowExpand(e, t), this.selectable && !this.selectOnCheckboxOnly && (e.vgtSelected = !e.vgtSelected), this.$emit("row-click", {
        row: e,
        pageIndex: t,
        selected: !!e.vgtSelected,
        event: r
      });
    },
    onRowAuxClicked(e, t, r) {
      this.$emit("row-aux-click", {
        row: e,
        pageIndex: t,
        selected: !!e.vgtSelected,
        event: r
      });
    },
    onCellClicked(e, t, r, o) {
      this.$emit("cell-click", {
        row: e,
        column: t,
        rowIndex: r,
        event: o
      });
    },
    onMouseenter(e, t) {
      this.$emit("row-mouseenter", {
        row: e,
        pageIndex: t
      });
    },
    onMouseleave(e, t) {
      this.$emit("row-mouseleave", {
        row: e,
        pageIndex: t
      });
    },
    searchTableOnEnter() {
      this.searchTrigger === "enter" && (this.handleSearch(), this.filteredRows = JSON.parse(JSON.stringify(this.originalRows)), this.forceSearch = !0, this.sortChanged = !0);
    },
    searchTableOnKeyUp() {
      this.searchTrigger !== "enter" && this.handleSearch();
    },
    resetTable() {
      this.unselectAllInternal(!0), this.changePage(1);
    },
    // field can be:
    // 1. function (passed as a string using function.name. For example: 'bound myFunction')
    // 2. regular property - ex: 'prop'
    // 3. nested property path - ex: 'nested.prop'
    collect(e, t) {
      function r(o, n) {
        let a = o;
        const l = n.split(".");
        for (let i = 0; i < l.length; i++) {
          if (typeof a > "u" || a === null)
            return;
          a = a[l[i]];
        }
        return a;
      }
      if (typeof t == "function") return t(e);
      if (typeof t == "string") return r(e, t);
    },
    collectFormatted(e, t, r = !1) {
      let o;
      if (r && t.headerField ? o = this.collect(e, t.headerField) : o = this.collect(e, t.field), o === void 0) return "";
      if (t.formatFn && typeof t.formatFn == "function")
        return t.formatFn(o, e);
      let n = t.typeDef;
      n || (n = this.dataTypes[t.type] || Ns);
      let a = n.format(o, t);
      return this.compactMode && (a == "" || a == null) ? "-" : a;
    },
    formattedRow(e, t = !1) {
      const r = {};
      for (let o = 0; o < this.typedColumns.length; o++) {
        const n = this.typedColumns[o];
        n.field && (r[n.field] = this.collectFormatted(
          e,
          n,
          t
        ));
      }
      return r;
    },
    // Get classes for the given column index & element.
    getClasses(e, t, r) {
      const { typeDef: o, [`${t}Class`]: n } = this.typedColumns[e];
      let { isRight: a } = o;
      this.rtl && (a = !0);
      const l = {
        "vgt-right-align": a,
        "vgt-left-align": !a
      };
      return typeof n == "function" ? l[n(r)] = !0 : typeof n == "string" && (l[n] = !0), l;
    },
    // method to filter rows
    filterRows(e, t = !0) {
      this.columnFilters = e;
      let r = JSON.parse(JSON.stringify(this.originalRows)), o = !1;
      if (this.columnFilters && Object.keys(this.columnFilters).length) {
        if ((this.mode !== "remote" || t) && this.changePage(1), t && this.$emit("column-filter", {
          columnFilters: this.columnFilters
        }), this.mode === "remote") {
          t ? this.$emit("update:isLoading", !0) : this.filteredRows = r;
          return;
        }
        const n = (a) => typeof a == "function" && a.name ? a.name : a;
        for (let a = 0; a < this.typedColumns.length; a++) {
          const l = this.typedColumns[a];
          this.columnFilters[n(l.field)] && (o = !0, r.forEach((i) => {
            const s = i.children.filter((u) => {
              if (l.filterOptions && typeof l.filterOptions.filterFn == "function")
                return l.filterOptions.filterFn(
                  this.collect(u, l.field),
                  this.columnFilters[n(l.field)]
                );
              const { typeDef: c } = l;
              return c.filterPredicate(
                this.collect(u, l.field),
                this.columnFilters[n(l.field)],
                !1,
                l.filterOptions && typeof l.filterOptions.filterDropdownItems == "object"
              );
            });
            i.children = s;
          }));
        }
      }
      o ? this.filteredRows = r.filter(
        (n) => n.children && n.children.length
      ) : this.filteredRows = r;
    },
    getCurrentIndex(e) {
      let t = 0, r = !1;
      for (let o = 0; o < this.paginated.length; o += 1) {
        const n = this.paginated[o], { children: a } = n;
        if (a && a.length)
          for (let l = 0; l < a.length; l += 1) {
            if (a[l].originalIndex === e) {
              r = !0;
              break;
            }
            t += 1;
          }
        if (r) break;
      }
      return (this.currentPage - 1) * this.currentPerPage + t + 1;
    },
    getRowStyleClass(e) {
      let t = "";
      this.hasRowClickListener && (t += "clickable");
      let r;
      return typeof this.rowStyleClass == "function" ? r = this.rowStyleClass(e) : r = this.rowStyleClass, r && (t += ` ${r}`), this.expandedRowIndex === e.originalIndex && (t += ` ${this.expandedRowClasses}`), t;
    },
    handleGrouped(e) {
      return e.forEach((t, r) => {
        t.vgt_header_id = r, this.groupOptions.maintainExpanded && this.expandedRowKeys.has(t[this.groupOptions.rowKey]) && (t.vgtIsExpanded = !0), t.children.forEach((o) => {
          o.vgt_id = r;
        });
      }), e;
    },
    initializePagination() {
      const {
        enabled: e,
        perPage: t,
        position: r,
        perPageDropdown: o,
        perPageDropdownEnabled: n,
        dropdownAllowAll: a,
        nextLabel: l,
        prevLabel: i,
        rowsPerPageLabel: s,
        ofLabel: u,
        pageLabel: c,
        allLabel: g,
        setCurrentPage: p,
        mode: h,
        infoFn: v
      } = this.paginationOptions;
      typeof e == "boolean" && (this.paginate = e), typeof t == "number" && (this.perPage = t), r === "top" ? (this.paginateOnTop = !0, this.paginateOnBottom = !1) : r === "both" && (this.paginateOnTop = !0, this.paginateOnBottom = !0), Array.isArray(o) && o.length && (this.customRowsPerPageDropdown = o, this.perPage || ([this.perPage] = o)), typeof n == "boolean" && (this.perPageDropdownEnabled = n), typeof a == "boolean" && (this.paginateDropdownAllowAll = a), typeof h == "string" && (this.paginationMode = h), typeof l == "string" && (this.nextText = l), typeof i == "string" && (this.prevText = i), typeof s == "string" && (this.rowsPerPageText = s), typeof u == "string" && (this.ofText = u), typeof c == "string" && (this.pageText = c), typeof g == "string" && (this.allText = g), typeof p == "number" && setTimeout(() => {
        this.changePage(p);
      }, 500), typeof v == "function" && (this.paginationInfoFn = v);
    },
    initializeExpandRows() {
      const { enabled: e } = this.expandRowsOptions;
      typeof e == "boolean" && (this.expandRowsEnabled = e);
    },
    initializeSearch() {
      const {
        enabled: e,
        trigger: t,
        externalQuery: r,
        searchFn: o,
        placeholder: n,
        skipDiacritics: a
      } = this.searchOptions;
      typeof e == "boolean" && (this.searchEnabled = e), t === "enter" && (this.searchTrigger = t), typeof r == "string" && (this.externalSearchQuery = r), typeof o == "function" && (this.searchFn = o), typeof n == "string" && (this.searchPlaceholder = n), typeof a == "boolean" && (this.searchSkipDiacritics = a);
    },
    initializeSort() {
      const { enabled: e, initialSortBy: t, multipleColumns: r } = this.sortOptions, o = JSON.parse(JSON.stringify(t || {}));
      if (typeof e == "boolean" && (this.sortable = e), typeof r == "boolean" && (this.multipleColumnSort = r), typeof o == "object") {
        const n = this.fixedHeader ? this.$refs["table-header-secondary"] : this.$refs["table-header-primary"];
        Array.isArray(o) ? n.setInitialSort(o) : Object.prototype.hasOwnProperty.call(
          o,
          "field"
        ) && n.setInitialSort([o]);
      }
    },
    initializeSelect() {
      const {
        enabled: e,
        selectionInfoClass: t,
        selectionText: r,
        clearSelectionText: o,
        selectOnCheckboxOnly: n,
        selectAllByPage: a,
        disableSelectInfo: l,
        selectAllByGroup: i,
        alwaysShowSelectionInfo: s
      } = this.selectOptions;
      typeof e == "boolean" && (this.selectable = e), typeof n == "boolean" && (this.selectOnCheckboxOnly = n), typeof a == "boolean" && (this.selectAllByPage = a), typeof i == "boolean" && (this.selectAllByGroup = i), typeof l == "boolean" && (this.disableSelectInfo = l), typeof t == "string" && (this.selectionInfoClass = t), (typeof r == "string" || typeof r == "function") && (this.selectionText = r), typeof s == "boolean" && (this.alwaysShowSelectionInfo = s), typeof o == "string" && (this.clearSelectionText = o);
    }
  },
  mounted() {
    this.perPage && (this.currentPerPage = this.perPage), this.initializeSort();
  },
  components: {
    "vgt-pagination": CF,
    "vgt-global-search": BF,
    "vgt-header-row": A7,
    "vgt-table-header": m7
  }
}, H6 = {
  key: 0,
  class: "vgt-loading vgt-center-align"
}, U6 = { class: "vgt-selection-info-row__actions vgt-pull-right" }, X6 = { class: "vgt-fixed-header" }, W6 = ["id"], Y6 = ["id"], K6 = ["onMouseenter", "onMouseleave", "onDblclick", "onClick", "onAuxclick"], Q6 = {
  key: 0,
  class: "line-numbers"
}, j6 = ["onClick"], Z6 = ["disabled", "checked"], z6 = ["onClick", "data-label"], q6 = { key: 0 }, J6 = ["innerHTML"], e9 = ["colspan"], t9 = ["colspan"], r9 = { key: 0 }, o9 = ["colspan"], n9 = {
  key: 2,
  class: "vgt-wrap__actions-footer"
};
function a9(e, t, r, o, n, a) {
  const l = fl("vgt-pagination"), i = fl("vgt-global-search"), s = fl("vgt-table-header"), u = fl("vgt-header-row");
  return C(), k(
    "div",
    {
      class: $e(a.wrapStyleClasses)
    },
    [
      r.isLoading ? (C(), k("div", H6, [
        be(e.$slots, "loadingContent", {}, () => [
          t[2] || (t[2] = L(
            "span",
            { class: "vgt-loading__content" },
            " Loading... ",
            -1
            /* HOISTED */
          ))
        ])
      ])) : q("v-if", !0),
      L(
        "div",
        {
          class: $e(["vgt-inner-wrap", { "is-loading": r.isLoading }])
        },
        [
          e.paginate && e.paginateOnTop ? be(e.$slots, "pagination-top", {
            key: 0,
            pageChanged: a.pageChanged,
            perPageChanged: a.perPageChanged,
            total: r.totalRows || a.totalRowCount
          }, () => [
            vt(l, {
              ref: "paginationTop",
              onPageChanged: a.pageChanged,
              onPerPageChanged: a.perPageChanged,
              perPage: e.perPage,
              rtl: r.rtl,
              total: r.totalRows || a.totalRowCount,
              mode: e.paginationMode,
              nextText: e.nextText,
              prevText: e.prevText,
              rowsPerPageText: e.rowsPerPageText,
              perPageDropdownEnabled: r.paginationOptions.perPageDropdownEnabled,
              customRowsPerPageDropdown: e.customRowsPerPageDropdown,
              paginateDropdownAllowAll: e.paginateDropdownAllowAll,
              ofText: e.ofText,
              pageText: e.pageText,
              allText: e.allText,
              "info-fn": e.paginationInfoFn
            }, null, 8, ["onPageChanged", "onPerPageChanged", "perPage", "rtl", "total", "mode", "nextText", "prevText", "rowsPerPageText", "perPageDropdownEnabled", "customRowsPerPageDropdown", "paginateDropdownAllowAll", "ofText", "pageText", "allText", "info-fn"])
          ]) : q("v-if", !0),
          vt(i, {
            onKeyup: a.searchTableOnKeyUp,
            onEnter: a.searchTableOnEnter,
            value: e.globalSearchTerm,
            onInput: t[0] || (t[0] = (c) => e.globalSearchTerm = c),
            "search-enabled": e.searchEnabled && e.externalSearchQuery == null,
            "global-search-placeholder": e.searchPlaceholder
          }, so({
            _: 2
            /* DYNAMIC */
          }, [
            e.$slots["table-actions"] ? {
              name: "internal-table-actions",
              fn: je(() => [
                be(e.$slots, "table-actions")
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["onKeyup", "onEnter", "value", "search-enabled", "global-search-placeholder"]),
          e.alwaysShowSelectionInfo || a.selectedRowCount && !e.disableSelectInfo ? (C(), k(
            "div",
            {
              key: 1,
              class: $e(["vgt-selection-info-row clearfix", e.selectionInfoClass])
            },
            [
              Gt(
                _e(a.selectionInfo) + " ",
                1
                /* TEXT */
              ),
              L(
                "a",
                {
                  href: "",
                  onClick: t[1] || (t[1] = Nt((c) => a.unselectAllInternal(!0), ["prevent"]))
                },
                _e(e.clearSelectionText),
                1
                /* TEXT */
              ),
              L("div", U6, [
                be(e.$slots, "selected-row-actions")
              ])
            ],
            2
            /* CLASS */
          )) : q("v-if", !0),
          L("div", X6, [
            r.fixedHeader ? (C(), k(
              "table",
              {
                key: 0,
                id: "vgt-table",
                class: $e(a.tableStyleClasses)
              },
              [
                L("colgroup", null, [
                  (C(!0), k(
                    De,
                    null,
                    rt(r.columns, (c, g) => (C(), k("col", {
                      key: g,
                      id: `col-${g}`
                    }, null, 8, W6))),
                    128
                    /* KEYED_FRAGMENT */
                  ))
                ]),
                q(" Table header "),
                vt(s, {
                  ref: "table-header-secondary",
                  onToggleSelectAll: a.toggleSelectAll,
                  onToggleExpandRowsAll: a.toggleExpandRowsAll,
                  onSortChange: a.changeSort,
                  onFilterChanged: a.filterRows,
                  columns: r.columns,
                  "line-numbers": r.lineNumbers,
                  selectable: e.selectable,
                  "all-selected": a.allSelected,
                  "all-selected-indeterminate": a.allSelectedIndeterminate,
                  mode: r.mode,
                  sortable: e.sortable,
                  "multiple-column-sort": e.multipleColumnSort,
                  "typed-columns": a.typedColumns,
                  getClasses: a.getClasses,
                  searchEnabled: e.searchEnabled,
                  paginated: a.paginated,
                  "table-ref": e.$refs.table
                }, {
                  "table-column": je((c) => [
                    be(e.$slots, "table-column", {
                      column: c.column
                    }, () => [
                      L(
                        "span",
                        null,
                        _e(c.column.label),
                        1
                        /* TEXT */
                      )
                    ])
                  ]),
                  "column-filter": je((c) => [
                    be(e.$slots, "column-filter", {
                      column: c.column,
                      updateFilters: c.updateFilters
                    })
                  ]),
                  _: 3
                  /* FORWARDED */
                }, 8, ["onToggleSelectAll", "onToggleExpandRowsAll", "onSortChange", "onFilterChanged", "columns", "line-numbers", "selectable", "all-selected", "all-selected-indeterminate", "mode", "sortable", "multiple-column-sort", "typed-columns", "getClasses", "searchEnabled", "paginated", "table-ref"])
              ],
              2
              /* CLASS */
            )) : q("v-if", !0)
          ]),
          L(
            "div",
            {
              class: $e({ "vgt-responsive": r.responsive }),
              style: io(a.wrapperStyles)
            },
            [
              L(
                "table",
                {
                  id: "vgt-table",
                  ref: "table",
                  class: $e(a.tableStyles)
                },
                [
                  L("colgroup", null, [
                    (C(!0), k(
                      De,
                      null,
                      rt(r.columns, (c, g) => (C(), k("col", {
                        key: g,
                        id: `col-${g}`
                      }, null, 8, Y6))),
                      128
                      /* KEYED_FRAGMENT */
                    ))
                  ]),
                  q(" Table header "),
                  vt(s, {
                    ref: "table-header-primary",
                    onToggleSelectAll: a.toggleSelectAll,
                    onToggleExpandRowsAll: a.toggleExpandRowsAll,
                    onSortChange: a.changeSort,
                    onFilterChanged: a.filterRows,
                    columns: r.columns,
                    "line-numbers": r.lineNumbers,
                    selectable: e.selectable,
                    "all-selected": a.allSelected,
                    "all-selected-indeterminate": a.allSelectedIndeterminate,
                    mode: r.mode,
                    sortable: e.sortable,
                    "multiple-column-sort": e.multipleColumnSort,
                    "typed-columns": a.typedColumns,
                    getClasses: a.getClasses,
                    searchEnabled: e.searchEnabled
                  }, {
                    "table-column": je((c) => [
                      be(e.$slots, "table-column", {
                        column: c.column
                      }, () => [
                        L(
                          "span",
                          null,
                          _e(c.column.label),
                          1
                          /* TEXT */
                        )
                      ])
                    ]),
                    "column-filter": je((c) => [
                      be(e.$slots, "column-filter", {
                        column: c.column,
                        updateFilters: c.updateFilters
                      })
                    ]),
                    _: 3
                    /* FORWARDED */
                  }, 8, ["onToggleSelectAll", "onToggleExpandRowsAll", "onSortChange", "onFilterChanged", "columns", "line-numbers", "selectable", "all-selected", "all-selected-indeterminate", "mode", "sortable", "multiple-column-sort", "typed-columns", "getClasses", "searchEnabled"]),
                  q(" Table body starts here "),
                  (C(!0), k(
                    De,
                    null,
                    rt(a.paginated, (c, g) => (C(), k("tbody", { key: g }, [
                      q(" if group row header is at the top "),
                      a.groupHeaderOnTop ? (C(), ft(u, {
                        key: 0,
                        onVgtExpand: (p) => a.toggleExpand(c[a.rowKeyField]),
                        "header-row": c,
                        columns: r.columns,
                        "line-numbers": r.lineNumbers,
                        selectable: e.selectable,
                        "select-all-by-group": e.selectAllByGroup,
                        collapsable: r.groupOptions.collapsable,
                        "collect-formatted": a.collectFormatted,
                        "formatted-row": a.formattedRow,
                        class: $e(a.getRowStyleClass(c)),
                        "get-classes": a.getClasses,
                        "full-colspan": a.fullColspan,
                        groupIndex: g,
                        onSelectGroupChange: (p) => a.toggleSelectGroup(p, c)
                      }, so({
                        _: 2
                        /* DYNAMIC */
                      }, [
                        a.hasHeaderRowTemplate ? {
                          name: "table-header-row",
                          fn: je((p) => [
                            be(e.$slots, "table-header-row", {
                              column: p.column,
                              formattedRow: p.formattedRow,
                              row: p.row
                            })
                          ]),
                          key: "0"
                        } : void 0
                      ]), 1032, ["onVgtExpand", "header-row", "columns", "line-numbers", "selectable", "select-all-by-group", "collapsable", "collect-formatted", "formatted-row", "class", "get-classes", "full-colspan", "groupIndex", "onSelectGroupChange"])) : q("v-if", !0),
                      q(" normal rows here. we loop over all rows "),
                      (C(!0), k(
                        De,
                        null,
                        rt(c.children, (p, h) => (C(), k(
                          De,
                          null,
                          [
                            !r.groupOptions.collapsable || c.vgtIsExpanded ? (C(), k("tr", {
                              key: p.originalIndex,
                              class: $e(a.getRowStyleClass(p)),
                              onMouseenter: (v) => a.onMouseenter(p, h),
                              onMouseleave: (v) => a.onMouseleave(p, h),
                              onDblclick: (v) => a.onRowDoubleClicked(p, h, v),
                              onClick: (v) => a.onRowClicked(p, h, v),
                              onAuxclick: (v) => a.onRowAuxClicked(p, h, v)
                            }, [
                              r.lineNumbers ? (C(), k(
                                "th",
                                Q6,
                                _e(a.getCurrentIndex(p.originalIndex)),
                                1
                                /* TEXT */
                              )) : q("v-if", !0),
                              e.selectable ? (C(), k("th", {
                                key: 1,
                                onClick: Nt((v) => a.onCheckboxClicked(p, h, v), ["stop"]),
                                class: "vgt-checkbox-col"
                              }, [
                                L("input", {
                                  type: "checkbox",
                                  disabled: p.vgtDisabled,
                                  checked: p.vgtSelected
                                }, null, 8, Z6)
                              ], 8, j6)) : q("v-if", !0),
                              (C(!0), k(
                                De,
                                null,
                                rt(r.columns, (v, A) => (C(), k(
                                  De,
                                  null,
                                  [
                                    !v.hidden && v.field ? (C(), k("td", {
                                      key: A,
                                      onClick: (S) => a.onCellClicked(p, v, h, S),
                                      class: $e(a.getClasses(A, "td", p)),
                                      "data-label": r.compactMode ? v.label : void 0
                                    }, [
                                      be(e.$slots, "table-row", {
                                        row: p,
                                        column: v,
                                        formattedRow: a.formattedRow(p),
                                        index: h,
                                        expandedRow: e.expandedRowIndex === h
                                      }, () => [
                                        v.html ? (C(), k("span", {
                                          key: 1,
                                          innerHTML: a.collect(p, v.field)
                                        }, null, 8, J6)) : (C(), k(
                                          "span",
                                          q6,
                                          _e(a.collectFormatted(p, v)),
                                          1
                                          /* TEXT */
                                        ))
                                      ])
                                    ], 10, z6)) : q("v-if", !0)
                                  ],
                                  64
                                  /* STABLE_FRAGMENT */
                                ))),
                                256
                                /* UNKEYED_FRAGMENT */
                              ))
                            ], 42, K6)) : q("v-if", !0),
                            e.expandedRowIndex === h ? (C(), k(
                              "tr",
                              {
                                class: $e(r.expandedRowDetailClasses),
                                key: p.originalIndex
                              },
                              [
                                L("td", { colspan: a.fullColspan }, [
                                  be(e.$slots, "row-details", {
                                    row: p,
                                    formattedRow: a.formattedRow(p),
                                    index: h
                                  })
                                ], 8, e9)
                              ],
                              2
                              /* CLASS */
                            )) : q("v-if", !0),
                            p.expanded ? (C(), k("tr", {
                              key: p.originalIndex
                            }, [
                              L("td", { colspan: a.fullColspan }, _e(p.expandedRow), 9, t9)
                            ])) : q("v-if", !0)
                          ],
                          64
                          /* STABLE_FRAGMENT */
                        ))),
                        256
                        /* UNKEYED_FRAGMENT */
                      )),
                      q(" if group row header is at the bottom "),
                      a.groupHeaderOnBottom ? (C(), ft(u, {
                        key: 1,
                        "header-row": c,
                        columns: r.columns,
                        "line-numbers": r.lineNumbers,
                        selectable: e.selectable,
                        "select-all-by-group": e.selectAllByGroup,
                        "collect-formatted": a.collectFormatted,
                        "formatted-row": a.formattedRow,
                        "get-classes": a.getClasses,
                        "full-colspan": a.fullColspan,
                        groupIndex: e.index,
                        onSelectGroupChange: (p) => a.toggleSelectGroup(p, c)
                      }, so({
                        _: 2
                        /* DYNAMIC */
                      }, [
                        a.hasHeaderRowTemplate ? {
                          name: "table-header-row",
                          fn: je((p) => [
                            be(e.$slots, "table-header-row", {
                              column: p.column,
                              formattedRow: p.formattedRow,
                              row: p.row
                            })
                          ]),
                          key: "0"
                        } : void 0
                      ]), 1032, ["header-row", "columns", "line-numbers", "selectable", "select-all-by-group", "collect-formatted", "formatted-row", "get-classes", "full-colspan", "groupIndex", "onSelectGroupChange"])) : q("v-if", !0)
                    ]))),
                    128
                    /* KEYED_FRAGMENT */
                  )),
                  a.showEmptySlot ? (C(), k("tbody", r9, [
                    L("tr", null, [
                      L("td", { colspan: a.fullColspan }, [
                        be(e.$slots, "emptystate", {}, () => [
                          t[3] || (t[3] = L(
                            "div",
                            { class: "vgt-center-align vgt-text-disabled" },
                            " No data for table ",
                            -1
                            /* HOISTED */
                          ))
                        ])
                      ], 8, o9)
                    ])
                  ])) : q("v-if", !0)
                ],
                2
                /* CLASS */
              )
            ],
            6
            /* CLASS, STYLE */
          ),
          a.hasFooterSlot ? (C(), k("div", n9, [
            be(e.$slots, "table-actions-bottom")
          ])) : q("v-if", !0),
          e.paginate && e.paginateOnBottom ? be(e.$slots, "pagination-bottom", {
            key: 3,
            pageChanged: a.pageChanged,
            perPageChanged: a.perPageChanged,
            total: r.totalRows || a.totalRowCount
          }, () => [
            vt(l, {
              ref: "paginationBottom",
              onPageChanged: a.pageChanged,
              onPerPageChanged: a.perPageChanged,
              perPage: e.perPage,
              rtl: r.rtl,
              total: r.totalRows || a.totalRowCount,
              mode: e.paginationMode,
              nextText: e.nextText,
              prevText: e.prevText,
              rowsPerPageText: e.rowsPerPageText,
              perPageDropdownEnabled: r.paginationOptions.perPageDropdownEnabled,
              customRowsPerPageDropdown: e.customRowsPerPageDropdown,
              paginateDropdownAllowAll: e.paginateDropdownAllowAll,
              ofText: e.ofText,
              pageText: e.pageText,
              allText: e.allText,
              "info-fn": e.paginationInfoFn
            }, null, 8, ["onPageChanged", "onPerPageChanged", "perPage", "rtl", "total", "mode", "nextText", "prevText", "rowsPerPageText", "perPageDropdownEnabled", "customRowsPerPageDropdown", "paginateDropdownAllowAll", "ofText", "pageText", "allText", "info-fn"])
          ]) : q("v-if", !0)
        ],
        2
        /* CLASS */
      )
    ],
    2
    /* CLASS */
  );
}
var l9 = /* @__PURE__ */ $i(V6, [["render", a9]]);
const i9 = /* @__PURE__ */ wt({
  __name: "VueGoodTable",
  props: {
    propsColumns: {
      type: Array,
      default: []
    },
    propsLoading: {
      type: Object
    },
    propsPaginationOption: {
      type: Object,
      default: {}
    },
    propsRows: {
      type: Array,
      default: []
    },
    propsRowStyleClass: {
      type: Function
    },
    propsSearchOption: {
      type: Object,
      default: {
        enabled: !1
      }
    },
    propsSortOption: {
      type: Object,
      default: {}
    },
    propsStyleClass: {
      type: String,
      default: ""
    },
    propsTableOption: {
      type: Object,
      required: !0
    },
    propsTheme: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, r = dt({
      fixedHeader: "fixedHeader" in t.propsTableOption ? t.propsTableOption.fixedHeader : !1,
      lineNumber: "lineNumber" in t.propsTableOption ? t.propsTableOption.lineNumber : !1,
      maxHeight: "maxHeight" in t.propsTableOption ? t.propsTableOption.maxHeight : "200px",
      rtl: "rtl" in t.propsTableOption ? t.propsTableOption.rtl : !1
    });
    return (o, n) => (C(), ft(R(l9), {
      columns: e.propsColumns,
      rows: e.propsRows,
      "pagination-options": e.propsPaginationOption,
      "search-options": e.propsSearchOption,
      "sort-options": e.propsSortOption,
      theme: e.propsTheme,
      styleClass: e.propsStyleClass,
      "fixed-header": r.fixedHeader,
      "line-numbers": r.lineNumber,
      "max-height": r.maxHeight,
      rtl: r.rtl,
      "row-style-class": e.propsRowStyleClass
    }, {
      "table-row": je((a) => [
        be(o.$slots, "table-row", Er(fo(a)))
      ]),
      "table-actions-bottom": je(() => [
        be(o.$slots, "table-actions-bottom")
      ]),
      emptystate: je(() => [
        be(o.$slots, "emptystate")
      ]),
      _: 3
    }, 8, ["columns", "rows", "pagination-options", "search-options", "sort-options", "theme", "styleClass", "fixed-header", "line-numbers", "max-height", "rtl", "row-style-class"]));
  }
}), s9 = { class: "module-permission-list" }, d9 = {
  key: 0,
  class: "d-flex justify-content-start mb-2"
}, u9 = { class: "master-module-name" }, c9 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center no-word"
}, m9 = {
  key: 0,
  class: "custom-control custom-checkbox"
}, g9 = ["disabled", "onUpdate:modelValue", "onChange"], f9 = {
  key: 1,
  class: "d-flex justify-content-between"
}, p9 = {
  key: 0,
  class: "custom-control custom-checkbox"
}, h9 = ["checked", "disabled", "onChange"], P0e = /* @__PURE__ */ wt({
  __name: "ModulePermission",
  props: {
    propsId: {
      type: String
    },
    propsIsEdit: {
      type: Boolean,
      required: !0
    },
    propsIsCreateAble: {
      type: Boolean,
      default: !0
    },
    propsIsEditAble: {
      type: Boolean,
      default: !0
    },
    propsIsViewOnly: {
      type: Boolean,
      default: !1
    },
    propsModulePermission: {
      type: Object,
      default: {
        action: "",
        from_module: ""
      },
      required: !0
    },
    propsModules: {
      type: Object,
      default: {}
    },
    propsProfilePermissions: {
      type: Object,
      default: {}
    },
    propsSelectedModules: {
      type: Object,
      default: {}
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  emits: ["onPermissionPost"],
  async setup(e, { emit: t }) {
    let r, o;
    const n = e, { t: a } = Gn(), l = n.propsStore.user, i = n.propsStore.action, s = ([r, o] = ri(() => Yn("onDirectRequest")), r = await r, o(), r), u = t, c = dt({
      paginationOption: {
        enabled: !1
      },
      tableOption: {
        fixedHeader: !1
      },
      modules: {},
      modulePermissions: [],
      moduleSelectedPermissions: [],
      modulePermission: []
    }), g = {};
    let p = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Set();
    Nn(async () => {
      n.propsIsEdit && (c.moduleSelectedPermissions = n.propsProfilePermissions.map((D) => ({
        module_id: D.module_id,
        module_permission_id: D.module_permission_id
      })), h = new Set(
        c.moduleSelectedPermissions.map(
          (D) => `${D.module_id}_${D.module_permission_id}`
        )
      ));
      const E = await s({
        sort_field: "id",
        sort_direction: "asc",
        includes: "modules",
        from_module: n.propsModulePermission.from_module
      }, {
        action: n.propsModulePermission.action,
        method: "get",
        stores: { user: l, action: i }
      });
      E.status && (c.modules = n.propsModules, c.modulePermissions = E.data, !En(c.modules) && c.modulePermissions.length && A());
    });
    const v = (E) => {
      const D = {};
      E.childs.forEach((U) => {
        U.permissions.forEach((Y) => {
          D[Y.permissionkey] = D[Y.permissionkey] ? D[Y.permissionkey] : Y;
        });
      }), g[E.id] = Object.values(D).map(
        (U) => ({
          label: U.name,
          field: U.permissionkey,
          sortable: !1,
          thClass: "text-center",
          isPermission: !0
        })
      );
    }, A = () => {
      const E = [], D = {};
      c.modulePermissions.forEach((U) => {
        U.modules?.length ? U.modules.forEach(({ id: Y }) => {
          (D[Y] ??= []).push(U);
        }) : E.push(U);
      }), Object.values(c.modules).forEach((U) => {
        U.childs.forEach((Y) => {
          Y.permissions = [...E, ...D[Y.id] || []];
        });
      }), p = new Map(
        c.modulePermissions.flatMap((U) => U.modules?.length ? U.modules.map((Y) => [
          `${U.permissionkey}_${Y.id}`,
          U
        ]) : [[`${U.permissionkey}_${U.module_id}`, U]])
      );
    }, S = (E) => E.childs.length ? [
      {
        label: "",
        field: "module",
        sortable: !1,
        thClass: "text-center"
      },
      ...g[E.id]
    ] : [], b = (E) => {
      const D = g[E.id].map((U) => U.field);
      return E.childs.map((U) => {
        let Y = {
          module: a(U.name.toLowerCase().replace(/\s/g, "_")),
          module_id: U.id
        };
        const G = c.modulePermission.find(
          (K) => K.module_id === U.id
        );
        return D.forEach((K) => {
          if (!U.permissions.some(
            (Ce) => Ce.permissionkey === K
          )) {
            Y[K] = "";
            return;
          }
          const xe = p.get(`${K}_${U.id}`) ?? p.get(`${K}_0`);
          if (!xe) {
            Y[K] = "";
            return;
          }
          G ? Y[K] = G[K] ?? !1 : Y[K] = h.has(`${U.id}_${xe.id}`);
        }), Y;
      });
    }, T = (E) => Object.values(E).filter((D) => typeof D == "boolean").every(Boolean), w = () => {
      const E = !$.value;
      Object.values(_.value).forEach((D) => {
        b(D).forEach((Y) => {
          Object.keys(Y).forEach((G) => {
            typeof Y[G] == "boolean" && (Y[G] = E);
          }), m(Y);
        });
      });
    }, N = (E) => {
      m(E);
    }, O = (E) => {
      const D = Object.keys(E).filter((Y) => typeof E[Y] == "boolean"), U = D.every((Y) => E[Y]);
      D.forEach((Y) => E[Y] = !U), m(E);
    }, m = (E) => {
      const D = c.modulePermission.findIndex(
        (Q) => Q.module_id === E.module_id
      );
      D !== -1 ? c.modulePermission[D] = { ...E } : "module_id" in E && c.modulePermission.push({ ...E });
      const U = c.modulePermission.flatMap(
        (Q) => c.modulePermissions.filter((ue) => Q[ue.permissionkey] === !0).map((ue) => ({
          module_id: Q.module_id,
          module_permission_id: ue.id
        }))
      ), Y = c.moduleSelectedPermissions.filter((Q) => n.propsSelectedModules.includes(Q.module_id)).map((Q) => ({
        module_id: Q.module_id,
        module_permission_id: Q.module_permission_id
      })), G = new Set(U.map((Q) => Q.module_id)), W = [...Y.filter(
        (Q) => !G.has(Q.module_id)
      ), ...U], xe = /* @__PURE__ */ new Map();
      W.forEach((Q) => {
        xe.has(Q.module_id) || xe.set(Q.module_id, /* @__PURE__ */ new Set()), xe.get(Q.module_id).add(Q.module_permission_id);
      }), c.modulePermission.forEach((Q) => {
        xe.has(Q.module_id) ? Object.keys(Q).filter((V) => typeof Q[V] == "boolean").some((V) => Q[V] === !0) || xe.set(Q.module_id, /* @__PURE__ */ new Set()) : xe.set(Q.module_id, /* @__PURE__ */ new Set());
      });
      const Ce = Array.from(xe.entries()).map(([Q, ue]) => ({
        module_id: Q,
        module_permission_ids: Array.from(ue)
      }));
      u("onPermissionPost", Ce);
    }, _ = ge(() => {
      const E = n.propsSelectedModules || [];
      return Object.fromEntries(
        Object.entries(c.modules).map(([D, U]) => {
          const Y = U.childs.filter(
            (G) => E.includes(G.id)
          );
          if (Y.length) {
            const G = { ...U, childs: Y };
            return v(G), [D, G];
          }
        }).filter(Boolean)
      );
    }), X = ge(() => ({
      "far fa-check-square": $.value,
      "far fa-square": !$.value
    })), $ = ge(() => {
      const E = Object.values(_.value).flatMap((D) => b(D));
      return E.length ? E.every((D) => {
        let U = !1;
        for (const Y of Object.values(D))
          if (typeof Y == "boolean" && (U = !0, !Y))
            return !1;
        return U;
      }) : !1;
    });
    return nt(() => n.propsSelectedModules, (E) => {
      E && (c.modulePermission = c.modulePermission.filter((D) => E.includes(D.module_id)), h = new Set(
        [...h].filter((D) => {
          const U = Number(D.split("_")[0]);
          return E.includes(U);
        })
      ), c.moduleSelectedPermissions = c.moduleSelectedPermissions.filter((D) => E.includes(D.module_id)), m({}));
    }, { deep: !0 }), (E, D) => (C(), k("div", s9, [
      !e.propsIsEdit && e.propsIsCreateAble || e.propsIsEdit && e.propsIsEditAble ? (C(), k("div", d9, [
        L("a", {
          href: "javascript:void(0)",
          class: "btn btn-outline-primary",
          onClick: w
        }, [
          L("i", {
            class: $e(["me-1", X.value])
          }, null, 2),
          Gt(_e(E.$t("select_all_permissions")), 1)
        ])
      ])) : q("", !0),
      (C(!0), k(De, null, rt(_.value, (U, Y) => (C(), k("div", {
        key: Y,
        class: "module-permission-wrapper"
      }, [
        L("div", u9, [
          L("span", null, _e(E.$t(U.name.toLowerCase().replace(/\s/g, "_"))), 1)
        ]),
        vt(i9, {
          "props-columns": S(U),
          "props-rows": b(U),
          "props-pagination-option": c.paginationOption,
          "props-style-class": "vgt-table condensed bordered tx-13",
          "props-theme": R(l).getDarkMode() ? "nocturnal" : "",
          "props-table-option": c.tableOption
        }, {
          "table-row": je((G) => [
            G.column.isPermission ? (C(), k("div", c9, [
              typeof G.row[G.column.field] == "boolean" ? (C(), k("label", m9, [
                Qt(L("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  disabled: e.propsIsViewOnly,
                  "onUpdate:modelValue": (K) => G.row[G.column.field] = K,
                  onChange: (K) => N(G.row)
                }, null, 40, g9), [
                  [Mp, G.row[G.column.field]]
                ]),
                D[0] || (D[0] = L("span", { class: "custom-control-label" }, null, -1))
              ])) : q("", !0)
            ])) : (C(), k("div", f9, [
              L("span", null, _e(G.row.module), 1),
              e.propsIsViewOnly ? q("", !0) : (C(), k("label", p9, [
                L("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  checked: T(G.row),
                  disabled: e.propsIsViewOnly,
                  onChange: (K) => O(G.row)
                }, null, 40, h9),
                D[1] || (D[1] = L("span", { class: "custom-control-label" }, null, -1))
              ]))
            ]))
          ]),
          _: 2
        }, 1032, ["props-columns", "props-rows", "props-pagination-option", "props-theme", "props-table-option"])
      ]))), 128))
    ]));
  }
}), x9 = { key: 0 }, v9 = {
  key: 0,
  class: "option-group-label"
}, S9 = {
  key: 1,
  class: "text-danger option-disabled"
}, b9 = ["innerHTML"], y9 = ["innerHTML"], w9 = ["innerHTML"], _9 = ["name", "placeholder"], T9 = {
  key: 3,
  class: "form-error"
}, nc = "-1", sv = /* @__PURE__ */ wt({
  __name: "ReportFilter",
  props: {
    propsFilter: {
      type: Object,
      required: !0
    },
    propsFilterError: {
      type: String,
      required: !0
    },
    propsFilterInput: {
      type: Object,
      required: !0
    },
    propsFilterType: {
      type: String,
      default: "dropdown"
    },
    propsFilterFunction: {
      type: Object,
      required: !0
    },
    propsId: {
      type: String,
      required: !0
    },
    propsSelectOption: {
      type: Array,
      default: []
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  emits: ["onDateRangeSelect", "update:propsFilterInput"],
  setup(e, { emit: t }) {
    const r = e, { t: o } = Gn(), n = t, a = {
      selectSettings: {
        label: "name",
        "open-direction": "bottom",
        "track-by": "code",
        placeholder: o("select_option"),
        "select-label": "",
        "selected-label": "✔",
        "deselect-label": "✖"
      }
    }, l = () => r.propsSelectOption.filter((p) => p.id !== nc), i = (p) => p?.placeholder ?? o("select_option"), s = (p) => {
      n("onDateRangeSelect", p);
    }, u = (p, h) => {
      if (!r.propsFilterFunction.isMultiSelect(r.propsFilter.attributes))
        return;
      const v = l();
      if (p.id === nc) {
        if (v.length === r.propsFilterInput[r.propsId].length - 1) {
          r.propsFilterInput[r.propsId] = [];
          return;
        }
        r.propsFilterInput[r.propsId] = [...v];
        return;
      }
      const S = (r.propsFilterInput[r.propsId] || []).filter(
        (b) => b.id !== nc
      );
      r.propsFilterInput[r.propsId] = S;
    }, c = (p, h) => {
      r.propsFilterFunction.isMultiSelect(r.propsFilter.attributes) && (r.propsFilterInput[r.propsId] = (r.propsFilterInput[r.propsId] || []).filter(
        (v) => v.id !== nc
      ));
    }, g = ge(() => r.propsFilterType === "dropdown" || r.propsFilter.attributes?.collapse || $o(r.propsStore.user));
    return (p, h) => (C(), k(De, null, [
      e.propsFilter.type === "date-range" ? (C(), k(De, { key: 0 }, [
        e.propsFilter.dValue ? be(p.$slots, "date-range", {
          propsId: e.propsId,
          attributes: e.propsFilter.attributes,
          dValue: e.propsFilter.dValue,
          onDateRangeSelect: s
        }, void 0, void 0, 0) : be(p.$slots, "date-range", {
          propsId: e.propsId,
          attributes: e.propsFilter.attributes,
          dValue: void 0,
          onDateRangeSelect: s
        }, void 0, void 0, 1)
      ], 64)) : q("", !0),
      e.propsFilter.type === "select" ? (C(), ft(R(Wa), ht({
        key: 1,
        id: e.propsFilter.attributes.id,
        name: e.propsId
      }, a.selectSettings, {
        placeholder: i(e.propsFilter.attributes),
        options: e.propsSelectOption,
        multiple: e.propsFilterFunction.isMultiSelect(e.propsFilter.attributes),
        "close-on-select": !e.propsFilterFunction.isMultiSelect(e.propsFilter.attributes),
        "allow-empty": e.propsFilterFunction.isAllowEmpty(e.propsFilter.attributes),
        modelValue: e.propsFilterInput[e.propsId],
        "onUpdate:modelValue": h[0] || (h[0] = (v) => e.propsFilterInput[e.propsId] = v),
        onSelect: u,
        onRemove: c
      }), {
        option: je(({ option: v }) => [
          g.value ? (C(), k("div", x9, [
            v.$isLabel ? (C(), k("div", v9, _e(v.$groupLabel), 1)) : q("", !0),
            v.isDisabled ? (C(), k("div", S9, _e(v.name), 1)) : (C(), k("div", {
              key: 2,
              innerHTML: v.name
            }, null, 8, b9))
          ])) : q("", !0)
        ]),
        selection: je(({ values: v, search: A, isOpen: S }) => [
          v.length && g.value ? Qt((C(), k("span", {
            key: 0,
            class: "multiselect__single",
            innerHTML: p.$t("selected_options").replace("n ", `${v.length} `)
          }, null, 8, y9)), [
            [An, !S]
          ]) : q("", !0)
        ]),
        singleLabel: je(({ option: v }) => [
          g.value ? (C(), k("span", {
            key: 0,
            innerHTML: v.name
          }, null, 8, w9)) : q("", !0)
        ]),
        _: 1
      }, 16, ["id", "name", "placeholder", "options", "multiple", "close-on-select", "allow-empty", "modelValue"])) : q("", !0),
      e.propsFilter.type === "text" ? Qt((C(), k("input", {
        key: 2,
        type: "search",
        name: e.propsId,
        class: $e(["form-control"]),
        placeholder: e.propsFilter ? p.$t(e.propsFilter.placeholder) : "",
        "onUpdate:modelValue": h[1] || (h[1] = (v) => r.propsFilterInput[e.propsId] = v)
      }, null, 8, _9)), [
        [Io, r.propsFilterInput[e.propsId]]
      ]) : q("", !0),
      e.propsFilterError ? (C(), k("small", T9, _e(p.$t(e.propsFilterError)), 1)) : q("", !0)
    ], 64));
  }
}), A9 = { class: "form-group mb-1" }, P9 = { class: "d-flex justify-content-start align-items-center" }, M9 = ["innerHTML"], $9 = {
  key: 0,
  class: "text-danger ms-1"
}, C9 = {
  key: 0,
  class: "dropdown-item"
}, L9 = ["innerHTML"], E9 = {
  key: 0,
  class: "text-danger ms-1"
}, M0e = /* @__PURE__ */ wt({
  __name: "ReportFilterGroup",
  props: {
    propsFilter: {
      type: Object,
      required: !0
    },
    propsFilterType: {
      type: String,
      default: "dropdown"
    },
    propsInitialFilter: {
      type: Function,
      required: !0
    },
    propsIsProcessing: {
      type: Boolean,
      default: !1
    },
    propsSelectOption: {
      type: Object,
      default: {}
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  emits: ["setSelectedVal"],
  setup(e, { expose: t, emit: r }) {
    const o = e, { t: n } = Gn(), a = r, { isAllowEmpty: l, isMultiSelect: i, isRequired: s } = v0(), u = o.propsInitialFilter, c = () => ({
      isAllowEmpty: l,
      isMultiSelect: i
    }), g = dt({
      draw: 0,
      isFilterAble: !1,
      relationUpdate: [],
      select: o.propsSelectOption
    }), p = dt({
      blade: {},
      data: { ...u() },
      error: { ...u() },
      input: {},
      reset: !1
    }), h = (S) => {
      const b = Object.keys(S)[0].split(".")[0].trim();
      p.input[b] = S;
    };
    t({
      setFilterInput: (S, b) => {
        if (S === "date") {
          p.input[S] = {
            [`${S}.from`]: b,
            [`${S}.to`]: b
          };
          return;
        }
        p.input[S] = b;
      }
    });
    const A = ge(() => o.propsFilter ? p.blade = Object.keys(o.propsFilter).filter((S) => o.propsFilter && !o.propsFilter[S].exclude && o.propsFilter[S].divClasses != "d-none").reduce((S, b) => Object.assign(S, { [b]: o.propsFilter[b] }), {}) : {});
    return nt(() => p.blade, (S) => {
      for (let b in S)
        p.blade[b].type != "date-range" && (p.input[b] = "value" in S[b] ? S[b].value : "");
    }, { deep: !0 }), nt(() => p.input, (S) => {
      if (Object.keys(A.value).length === 1 && g.draw++, g.draw === 0) {
        g.draw++;
        return;
      }
      g.isFilterAble = !0;
      for (let b in S)
        if (!(S[b] && p.data[b] === S[b]) && b in p.blade) {
          if (p.blade[b].type === "date-range" && s(p.blade[b].attributes)) {
            const T = JSON.parse(JSON.stringify(S[b]));
            !T[`${b}.from`] || !T[`${b}.to`] ? (p.error[b] = "select_date", g.isFilterAble = !1) : p.error[b] = "";
          }
          if (p.blade[b].type === "select" && s(p.blade[b].attributes) && (S[b] ? p.error[b] = "" : (p.error[b] = "select_option_type", g.isFilterAble = !1)), p.blade[b].relation && S[b])
            for (let T in p.blade[b].relation) {
              const w = p.blade[b].relation[T];
              p.input[w] && (p.blade[b].type !== "select" || "code" in p.input[w]) && g.relationUpdate.push(w);
            }
        }
      p.data = { ...S }, g.draw++, a("setSelectedVal", S, g.isFilterAble);
    }, { deep: !0 }), nt(() => o.propsIsProcessing, (S, b) => {
      !S && b && g.relationUpdate.length && g.relationUpdate.forEach((T, w) => {
        if (T in g.select) {
          const N = g.select[T].options;
          N.some((m) => m.code == p.input[T]?.code) || (N.length && N.some((m) => m.code === "") ? p.input[T] = { id: "-1", code: "", name: n("all") } : p.input[T] = "");
        } else
          p.input[T] = "";
      });
    }), (S, b) => (C(), k(De, null, [
      be(S.$slots, "add-on-filter"),
      e.propsFilterType === "card" ? (C(!0), k(De, { key: 0 }, rt(A.value, (T, w) => (C(), k("span", {
        key: w,
        class: $e(T.divClasses || "col-md-6")
      }, [
        L("div", A9, [
          L("span", P9, [
            L("label", {
              class: "form-label tx-medium mb-0",
              innerHTML: R(ni)(S.$t(T.label))
            }, null, 8, M9),
            R(s)(T.attributes) ? (C(), k("span", $9, "*")) : q("", !0)
          ]),
          vt(sv, {
            "props-filter": T,
            "props-filter-error": p.error[w],
            "props-filter-input": p.input,
            "props-filter-type": e.propsFilterType,
            "props-filter-function": c(),
            "props-id": String(w),
            "props-select-option": w in g.select ? g.select[w].options : [],
            "props-store": e.propsStore,
            onOnDateRangeSelect: h
          }, {
            "date-range": je((N) => [
              be(S.$slots, "date-range", ht({ ref_for: !0 }, N))
            ]),
            _: 3
          }, 8, ["props-filter", "props-filter-error", "props-filter-input", "props-filter-type", "props-filter-function", "props-id", "props-select-option", "props-store"])
        ])
      ], 2))), 128)) : q("", !0),
      e.propsFilterType === "dropdown" ? (C(!0), k(De, { key: 1 }, rt(A.value, (T, w) => (C(), k(De, { key: w }, [
        "divClasses" in T && T.divClasses.includes("d-none") ? q("", !0) : (C(), k("div", C9, [
          L("label", {
            class: "filter-label",
            innerHTML: R(ni)(S.$t(T.label))
          }, null, 8, L9),
          R(s)(T.attributes) ? (C(), k("span", E9, "*")) : q("", !0),
          vt(sv, {
            "props-filter": T,
            "props-filter-error": p.error[w],
            "props-filter-input": p.input,
            "props-filter-type": e.propsFilterType,
            "props-filter-function": c(),
            "props-id": String(w),
            "props-select-option": w in g.select ? g.select[w].options : [],
            "props-store": e.propsStore,
            onOnDateRangeSelect: h
          }, {
            "date-range": je((N) => [
              be(S.$slots, "date-range", ht({ ref_for: !0 }, N))
            ]),
            _: 3
          }, 8, ["props-filter", "props-filter-error", "props-filter-input", "props-filter-type", "props-filter-function", "props-id", "props-select-option", "props-store"])
        ]))
      ], 64))), 128)) : q("", !0)
    ], 64));
  }
}), O9 = { class: "main-content side-content pt-0" }, N9 = { class: "main-container container-fluid" }, D9 = { class: "inner-body mb-3" }, k9 = { class: "page-header mb-lg-2" }, G9 = {
  key: 0,
  class: "d-flex"
}, B9 = {
  key: 0,
  class: "filterCardHandler"
}, I9 = { class: "main-content-label mb-0" }, $0e = /* @__PURE__ */ wt({
  __name: "ReportWrapper",
  props: {
    propsBreadcrumb: {
      type: Object,
      required: !0
    },
    propsFilterType: {
      type: String,
      default: "dropdown"
    },
    propsIsFilter: {
      type: Boolean,
      default: !0,
      required: !1
    },
    propsIsFilterAble: {
      type: Boolean,
      default: !0
    }
  },
  setup(e, { expose: t }) {
    const r = e, o = Ee(), n = dt({
      filter: {
        isShow: !1
      },
      filterCard: {
        isShow: !0
      }
    }), a = () => {
      n.filterCard.isShow = !n.filterCard.isShow;
    }, l = () => {
      r.propsIsFilterAble && (n.filter.isShow = !n.filter.isShow);
    };
    El(o, (s) => {
      n.filter.isShow = !1;
    }), t({
      onHandleCollapse: a,
      onToggleFilter: l
    });
    const i = ge(() => n.filter.isShow);
    return (s, u) => (C(), k("div", O9, [
      L("div", N9, [
        L("div", D9, [
          L("div", k9, [
            vt(dw, {
              "props-breadcrumb": r.propsBreadcrumb
            }, null, 8, ["props-breadcrumb"]),
            e.propsFilterType === "dropdown" ? (C(), k("div", G9, [
              L("div", {
                class: "position-relative justify-content-center",
                ref_key: "filterDiv",
                ref: o
              }, [
                be(s.$slots, "button"),
                r.propsIsFilter ? (C(), k("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-white my-2 btn-icon-text",
                  onClick: u[0] || (u[0] = (c) => l())
                }, [
                  u[2] || (u[2] = L("i", { class: "fas fa-filter me-1" }, null, -1)),
                  Gt(_e(s.$t("filters")), 1)
                ])) : q("", !0),
                L("div", {
                  class: $e(["dropdown-menu filter-menu tx-13", { show: i.value }]),
                  "data-popper-placement": "bottom-start"
                }, [
                  be(s.$slots, "filter")
                ], 2)
              ], 512)
            ])) : q("", !0),
            be(s.$slots, "button")
          ]),
          e.propsFilterType === "card" ? (C(), k("div", {
            key: 0,
            class: "card custom-card mb-2 mx-1 mx-lg-0",
            onClick: a
          }, [
            L("div", {
              class: $e(["card-body filter-card-body", { filterCardWrap: !n.filterCard.isShow }])
            }, [
              n.filterCard.isShow ? q("", !0) : (C(), k("div", B9, [
                L("h6", I9, _e(s.$t("filters")), 1),
                u[3] || (u[3] = L("span", { class: "card-direction" }, [
                  L("i", { class: "fas fa-chevron-right angle" })
                ], -1))
              ])),
              vt(R(yh), {
                when: n.filterCard.isShow,
                class: "mt-2"
              }, {
                default: je(() => [
                  L("div", {
                    class: "row row-sm filterCardColumns",
                    onClick: u[1] || (u[1] = Nt(() => {
                    }, ["stop"]))
                  }, [
                    be(s.$slots, "filter")
                  ])
                ]),
                _: 3
              }, 8, ["when"])
            ], 2)
          ])) : q("", !0),
          be(s.$slots, "report")
        ])
      ])
    ]));
  }
}), R9 = { class: "row row-sm list-group" }, F9 = { class: "s-wrap-left" }, V9 = { class: "main-content-label mb-1" }, H9 = { class: "d-block text-muted tx-12 mb-0" }, U9 = { class: "s-wrap-right" }, C0e = /* @__PURE__ */ wt({
  __name: "SummaryGroup",
  props: {
    propsBlade: {
      type: Object,
      required: !0
    },
    propsData: {
      type: Object,
      required: !0
    },
    propsHeader: {
      type: Object
    },
    propsLastElement: {
      type: Boolean,
      default: !0
    },
    propsLoading: {
      type: Object
    },
    propsRowCallback: {
      type: Array
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  emits: ["onPostTableRender"],
  setup(e, { emit: t }) {
    const r = t, { t: o } = Gn(), n = J0;
    n.use(me), n.use(me);
    const { mxLGState: a, getTableColumnsDefs: l, getTableLocale: i, onToggleProcessing: s } = q0(), u = e, c = Ee(null), g = dt({
      dLoading: u.propsLoading && "dLoading" in u.propsLoading ? u.propsLoading.dLoading : !1,
      isCollaped: !1,
      pgLoading: u.propsLoading && "loading" in u.propsLoading ? u.propsLoading.loading : !1,
      summaryWrap: {
        isShow: !0
      },
      tableLoading: u.propsLoading && "tLoading" in u.propsLoading ? u.propsLoading.tLoading : !1
    }), p = dt({
      blade: u.propsBlade,
      datas: u.propsData,
      draw: 0,
      loading: !0,
      options: {
        bInfo: !1,
        fixedHeader: !0,
        language: i($o(u.propsStore.user), g.tableLoading),
        paging: !1,
        processing: !0,
        preDrawCallback: function(O) {
          u.propsStore.user.getTestMode() && console.debug("preDrawCallback", O), p.loading = !0;
        },
        initComplete: function(O, m) {
          u.propsStore.user.getTestMode() && console.debug("initComplete", O, m), p.loading && (p.draw++, p.loading = !1, r("onPostTableRender", { isLoading: p.loading }));
        },
        rowCallback: (O, m) => {
          A(O, m);
        },
        orderCellsTop: !0,
        responsive: u.propsStore.user.getDeviceMode() != "mobile",
        scrollX: u.propsStore.user.getDeviceMode() == "mobile",
        searching: !1,
        columnDefs: l({ fDPlace: 4 }),
        ordering: !1,
        order: []
      }
    }), h = (O, m) => {
      if (u.propsStore.user.getTestMode() && console.debug("onDrawCallback", O, m), p.draw > 0 && a.table.cKey)
        for (let _ of document.getElementsByClassName("dt-empty"))
          _.innerHTML = p.options.language.zeroRecords;
      p.loading && (p.draw++, p.loading = !1, r("onPostTableRender", { isLoading: p.loading })), u.propsStore.action.setListLoading(!1);
    }, v = () => {
      g.summaryWrap.isShow = !g.summaryWrap.isShow;
    }, A = (O, m) => {
      let _ = [
        { className: "table-row-wdanger", column: "status", columnValue: "INACTIVE" }
      ];
      return u.propsRowCallback instanceof Array && u.propsRowCallback.forEach((X) => {
        let $ = !1;
        _.forEach((E) => {
          X.column === E.column && "columnValue" in X && X.columnValue === E.columnValue && (E.className = X.className, $ = !0);
        }), $ || _.push(X);
      }), _.forEach(function(X) {
        let $, E;
        X.column.includes(".") ? X.column.split(".").forEach(function(D) {
          E = E ? E[D] : m[D];
        }) : E = m[X.column], "columnValue" in X && E === X.columnValue && ($ = X.className), "condition" in X && X.condition && X.condition(E) && ($ = X.className), $ && (typeof $ == "string" && O.classList.add($), typeof $ == "object" && O.classList.add(...$));
      }), () => {
      };
    }, S = ge(() => Object.keys(p.blade.columns).filter((O) => !p.blade.columns[O].exclude && p.blade.columns[O].isSummary).map((O, m) => {
      const _ = "orderable" in p.blade.columns[O] ? p.blade.columns[O].orderable : !1;
      return p.options.ordering || (p.options.ordering = _ || !1), {
        className: p.blade.columns[O].className || "",
        orderable: _,
        width: p.blade.columns[O].width || "auto",
        render: p.blade.columns[O].render
      };
    }, {})), b = ge(() => p.datas), T = ge(() => Object.keys(p.blade.columns).filter((O) => !p.blade.columns[O].exclude && p.blade.columns[O].isSummary).map((O, m) => g.tableLoading ? {
      label: "table.loadingRecords",
      className: "table.loadingRecords"
    } : {
      label: p.blade.columns[O].summary?.label || p.blade.columns[O].label,
      className: p.blade.columns[O].className || ""
    }, {})), w = ge(() => g.tableLoading ? o("table.loadingRecords") : u.propsHeader ? "title" in u.propsHeader ? o(u.propsHeader.title) : "" : o("summary")), N = ge(() => g.tableLoading ? o("table.loadingRecords") : u.propsHeader ? "desc" in u.propsHeader ? o(u.propsHeader.desc) : "" : o("summary_desc"));
    return nt(() => u.propsData, (O) => {
      p.datas = O;
    }, { immediate: !0 }), nt(() => u.propsLoading, (O) => {
      const m = O && "dLoading" in O ? O.dLoading : !1, _ = O && "loading" in O ? O.loading : !1;
      g.dLoading || g.pgLoading != _ && (g.dLoading = m, g.pgLoading = _, s(g.pgLoading, c));
    }), nt(() => u.propsStore.user.getLanguage(), (O, m) => {
      O != m && (p.options.language = i($o(u.propsStore.user), g.tableLoading), a.table.cKey += 1);
    }), nt(() => u.propsStore.action.lists.isLoaded, (O) => {
      g.dLoading && s(!O, c);
    }), (O, m) => (C(), k("div", R9, [
      L("div", {
        class: $e(["col-md-12 col-lg-12", { shimmer: g.tableLoading }])
      }, [
        L("div", {
          class: $e(["card custom-card", { "mb-0": e.propsLastElement }])
        }, [
          L("div", {
            class: $e(["card-body summary-group", { summaryWrap: !g.summaryWrap.isShow }])
          }, [
            L("div", {
              class: "summaryHandler d-flex justify-content-between",
              onClick: v
            }, [
              L("div", F9, [
                L("h6", V9, _e(w.value), 1),
                L("p", H9, _e(N.value), 1)
              ]),
              L("div", U9, [
                be(O.$slots, "buttons")
              ])
            ]),
            vt(R(yh), {
              when: g.summaryWrap.isShow,
              class: "mt-3"
            }, {
              default: je(() => [
                (C(), ft(R(n), {
                  class: "table table-bordered table-hover table-striped dataTable nowrap",
                  key: R(a).table.cKey,
                  ref_key: "summaryTable",
                  ref: c,
                  columns: S.value,
                  options: p.options,
                  data: b.value,
                  onDraw: h
                }, {
                  default: je(() => [
                    L("thead", null, [
                      L("tr", null, [
                        (C(!0), k(De, null, rt(T.value, (_, X) => (C(), k("th", {
                          key: X,
                          class: $e(["th-header text-center", _.className])
                        }, _e(_.label ? O.$t(_.label) : ""), 3))), 128))
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["columns", "options", "data"]))
              ]),
              _: 1
            }, 8, ["when"])
          ], 2)
        ], 2)
      ], 2)
    ]));
  }
}), X9 = {
  key: 0,
  class: "card-footer d-grid gap-1 d-flex mb-1"
}, W9 = { class: "d-grid gap-1 d-flex me-auto" }, Y9 = { class: "d-grid gap-1 d-flex" }, K9 = ["disabled"], Q9 = /* @__PURE__ */ wt({
  __name: "Button",
  props: {
    propsBtnClass: {
      type: String,
      default: "btn-primary"
    },
    propsFunction: {
      type: Function,
      required: !0
    },
    propsIsDisabled: {
      type: Boolean,
      default: !1
    },
    propsIsHide: {
      type: Boolean,
      default: !1
    },
    propsIsSubmit: {
      type: Boolean,
      required: !0
    },
    propsText: {
      type: String,
      default: "save"
    }
  },
  setup(e) {
    return (t, r) => e.propsIsHide ? q("", !0) : (C(), k("div", X9, [
      L("div", W9, [
        be(t.$slots, "button-left")
      ]),
      L("div", Y9, [
        be(t.$slots, "button-before"),
        L("a", {
          href: "javascript:void(0)",
          class: $e(["btn", e.propsBtnClass, "btn-loader", { disabled: e.propsIsDisabled, "btn-loading": e.propsIsSubmit }]),
          onClick: r[0] || (r[0] = (o) => e.propsFunction()),
          disabled: e.propsIsDisabled
        }, [
          L("span", null, _e(t.$t(e.propsText)), 1),
          r[1] || (r[1] = L("span", { class: "ms-2 loading" }, [
            L("i", { class: "fas fa-spinner" })
          ], -1))
        ], 10, K9),
        be(t.$slots, "button-after")
      ])
    ]));
  }
}), j9 = { class: "main-menu main-sidebar main-sidebar-sticky side-menu sidemenu-scroll" }, Z9 = { class: "main-sidebar-header" }, z9 = {
  key: 1,
  class: "sidemenu-logo"
}, q9 = { class: "main-logo" }, J9 = { class: "main-sidebar-body" }, eV = {
  class: /* @__PURE__ */ $e(["shimmer", "menu-nav nav"])
}, tV = { class: "nav-header" }, rV = { class: "nav-label" }, oV = { class: "nav-item" }, nV = {
  class: "router-link-active router-link-exact-active nav-link",
  href: "javascript:void(0)"
}, aV = { class: "sidemenu-label" }, lV = { class: "nav-header" }, iV = { class: "nav-label" }, sV = {
  class: "nav-link",
  href: "javascript:void(0)"
}, dV = { class: "sidemenu-label" }, uV = /* @__PURE__ */ wt({
  __name: "AsideSkeleton",
  props: {
    propsImage: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, r) => (C(), k("div", j9, [
      L("div", Z9, [
        "noImage" in e.propsImage && e.propsImage.noImage ? be(t.$slots, "sidemenu-logo", {}, void 0, void 0, 0) : (C(), k("div", z9, [
          L("a", q9, [
            L("img", ht({ class: "header-brand-img desktop-logo" }, e.propsImage.logoLight), null, 16),
            L("img", ht({ class: "header-brand-img icon-logo" }, e.propsImage.iconLight), null, 16)
          ])
        ])),
        L("div", J9, [
          L("ul", eV, [
            L("span", null, [
              L("li", tV, [
                L("span", rV, _e(t.$t("table.loadingRecords")), 1)
              ]),
              L("li", oV, [
                L("a", nV, [
                  r[0] || (r[0] = L("span", { class: "shape1" }, null, -1)),
                  r[1] || (r[1] = L("span", { class: "shape2" }, null, -1)),
                  r[2] || (r[2] = L("i", { class: "sidemenu-icon menu-icon fas fa-spinner" }, null, -1)),
                  L("span", aV, _e(t.$t("table.loadingRecords")), 1)
                ])
              ]),
              (C(), k(De, null, rt(2, (o) => (C(), k(De, { key: o }, [
                L("li", lV, [
                  L("span", iV, _e(t.$t("table.loadingRecords")), 1)
                ]),
                (C(), k(De, null, rt(3, (n) => L("li", {
                  key: n,
                  class: "nav-item"
                }, [
                  L("a", sV, [
                    r[3] || (r[3] = L("span", { class: "shape1" }, null, -1)),
                    r[4] || (r[4] = L("span", { class: "shape2" }, null, -1)),
                    r[5] || (r[5] = L("i", { class: "sidemenu-icon menu-icon fas fa-spinner" }, null, -1)),
                    L("span", dV, _e(t.$t("table.loadingRecords")), 1)
                  ])
                ])), 64))
              ], 64))), 64))
            ])
          ])
        ])
      ])
    ]));
  }
}), cV = {
  key: 1,
  class: "sidemenu-logo"
}, mV = { class: "main-logo" }, gV = { class: "main-sidebar-body" }, fV = { class: "menu-nav nav" }, pV = {
  key: 0,
  class: "nav-header"
}, hV = { class: "nav-label" }, xV = { class: "sidemenu-label" }, vV = ["onClick"], SV = { class: "sidemenu-label" }, bV = ["id"], yV = ["onClick"], L0e = /* @__PURE__ */ wt({
  __name: "Aside",
  props: {
    propsImage: {
      type: Object,
      required: !0
    },
    propsHideParent: {
      type: Boolean,
      default: !1
    },
    propsRoute: {
      type: Object,
      required: !0
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = t.propsStore.app, o = t.propsStore.user, n = t.propsStore.action, a = t.propsStore.menu, { menus: l } = om(a), i = Ee(), s = dt({
      activeMenu: "",
      isLoading: !0,
      isMobile: $o(o),
      menuList: {}
    });
    or(async () => {
      await c(), v();
    });
    const u = (T) => "child" in T, c = async () => {
      const T = await a.getMenus();
      En(T) || (s.menuList = JSON.parse(JSON.stringify(T)), s.isLoading = !1);
    }, g = (T = "", w) => {
      w.stopPropagation(), !(r.getLoading() || s.activeMenu == T) && (r.setLoading(!0), document.querySelectorAll(".nav-sub").forEach((N) => {
        N.classList.remove("open"), N.closest(".nav-item")?.classList.remove("open");
      }));
    }, p = () => {
      document.body.classList.remove("main-sidebar-show"), document.body.classList.add("main-sidebar-hide"), n.setComponentAction("aside", !1);
    }, h = (T, w) => {
      w.stopPropagation();
      const N = document.getElementById(T), O = N?.classList.contains("open") ?? !1;
      document.querySelectorAll(".nav-sub.open, .nav-item.open").forEach((m) => {
        m.classList.remove("open");
      }), !O && N && (N.classList.add("open"), N.closest(".nav-item")?.classList.add("open"));
    }, v = () => {
      document.querySelectorAll(".nav-item").forEach((T) => {
        const w = T.querySelector(".nav-link")?.classList.contains("with-sub"), N = T.querySelector(".nav-sub")?.classList.contains("open");
        (!w || !N) && T.classList.remove("active");
      }), Kr(() => {
        document.querySelectorAll(".router-link-active").forEach((T) => {
          const w = T.closest(".nav-item"), N = T.closest(".nav-sub");
          T.classList.contains("nav-sub-link") ? (N?.classList.contains("open") || (N?.classList.add("open"), w?.classList.add("open")), w && !w.classList.contains("active") && w.classList.add("active")) : w?.classList.add("active"), s.activeMenu = T.getAttribute("data-key") ?? "";
        });
      });
    };
    El(i, (T) => {
      s.isMobile && p();
    });
    const A = ge(() => s.isLoading), S = ge(() => s.menuList), b = ge(() => !s.isMobile || n.getComponentAction("aside"));
    return nt(l, (T) => {
      En(T) || (s.menuList = JSON.parse(JSON.stringify(T)), s.isLoading = !1);
    }, { deep: !0 }), nt(() => t.propsRoute.path, () => {
      v(), s.isMobile && p();
    }), (T, w) => {
      const N = fl("router-link");
      return A.value ? (C(), ft(un, {
        key: 0,
        name: "aside"
      }, {
        default: je(() => [
          vt(uV, { "props-image": e.propsImage }, null, 8, ["props-image"])
        ]),
        _: 1
      })) : (C(), ft(un, {
        key: 1,
        name: "aside"
      }, {
        default: je(() => [
          Qt(L("div", {
            class: "main-menu main-sidebar main-sidebar-sticky side-menu sidemenu-scroll",
            ref_key: "asideDiv",
            ref: i
          }, [
            "noImage" in e.propsImage && e.propsImage.noImage ? be(T.$slots, "sidemenu-logo", {}, void 0, void 0, 0) : (C(), k("div", cV, [
              L("a", mV, [
                L("img", ht({ class: "header-brand-img desktop-logo" }, e.propsImage.logoLight), null, 16),
                L("img", ht({ class: "header-brand-img icon-logo" }, e.propsImage.iconLight), null, 16)
              ])
            ])),
            L("div", gV, [
              L("ul", fV, [
                Object.keys(S.value).length > 0 ? (C(!0), k(De, { key: 0 }, rt(S.value, (O, m) => (C(), k("span", { key: m }, [
                  e.propsHideParent ? q("", !0) : (C(), k("li", pV, [
                    L("span", hV, _e(T.$t(m)), 1)
                  ])),
                  (C(!0), k(De, null, rt(O, (_, X) => (C(), k("li", {
                    key: X,
                    class: $e(["nav-item", { "mt-0": e.propsHideParent && X == 0 }])
                  }, [
                    u(_) ? (C(), k(De, { key: 1 }, [
                      L("a", {
                        class: "nav-link with-sub",
                        href: "javascript:void(0)",
                        onClick: ($) => h(_.key, $)
                      }, [
                        w[4] || (w[4] = L("span", { class: "shape1" }, null, -1)),
                        w[5] || (w[5] = L("span", { class: "shape2" }, null, -1)),
                        L("i", {
                          class: $e(["sidemenu-icon menu-icon", _.icon])
                        }, null, 2),
                        L("span", SV, _e(T.$t(_.name)), 1),
                        w[6] || (w[6] = L("i", { class: "fas fa-chevron-right angle" }, null, -1))
                      ], 8, vV),
                      L("ul", {
                        class: "nav-sub",
                        id: _.key,
                        onClick: w[1] || (w[1] = Nt(() => {
                        }, ["stop"]))
                      }, [
                        (C(!0), k(De, null, rt(_.child, ($, E) => (C(), k("li", {
                          class: "nav-sub-item",
                          key: E,
                          onClick: (D) => g($.key, D)
                        }, [
                          u($) ? q("", !0) : (C(), ft(N, {
                            key: 0,
                            class: "nav-sub-link",
                            to: $.path,
                            "data-key": $.key,
                            onClick: w[0] || (w[0] = Nt(() => {
                            }, ["stop"]))
                          }, {
                            default: je(() => [
                              Gt(_e(T.$t($.name)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "data-key"]))
                        ], 8, yV))), 128))
                      ], 8, bV)
                    ], 64)) : (C(), ft(N, {
                      key: 0,
                      class: $e(["nav-link", { disabled: R(r).getLoading() }]),
                      to: _.path,
                      "data-key": _.key,
                      onClick: ($) => g(_.key, $)
                    }, {
                      default: je(() => [
                        w[2] || (w[2] = L("span", { class: "shape1" }, null, -1)),
                        w[3] || (w[3] = L("span", { class: "shape2" }, null, -1)),
                        L("i", {
                          class: $e(["sidemenu-icon menu-icon", _.icon])
                        }, null, 2),
                        L("span", xV, _e(T.$t(_.name)), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "to", "data-key", "onClick"]))
                  ], 2))), 128))
                ]))), 128)) : q("", !0)
              ])
            ])
          ], 512), [
            [An, b.value]
          ])
        ]),
        _: 3
      }));
    };
  }
}), wV = { class: "main-footer text-center text-md-end" }, _V = { class: "main-container container-fluid" }, TV = { class: "row row-sm" }, AV = { class: "col-md-12" }, PV = ["innerHTML"], E0e = /* @__PURE__ */ wt({
  __name: "Footer",
  props: {
    propsStore: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = ge(() => t.propsStore.app.getCopyright());
    return (o, n) => (C(), k("div", wV, [
      L("div", _V, [
        L("div", TV, [
          L("div", AV, [
            L("span", {
              class: "tx-12",
              innerHTML: r.value
            }, null, 8, PV)
          ])
        ])
      ])
    ]));
  }
}), rT = () => {
  const { locale: e } = Gn({ useScope: "global" }), t = {
    cn: "simplified",
    en: "english",
    es: "spanish",
    id: "indonesian",
    jp: "japanese",
    kr: "korean",
    pt: "portuguese",
    th: "thai",
    vn: "vietnamese"
  }, r = () => ({
    cn: { isActive: !1 },
    en: { isActive: !1 }
  });
  let o = {};
  const n = dt({}), a = dt({
    langs: {}
  }), l = (h, v = {}) => {
    Object.assign(n, h), o = En(v) ? r() : v, a.langs = dt(o);
  }, i = (h) => Object.keys(t).find((v) => t[v] === h) || "en", s = (h) => {
    try {
      e.value = h, n.user.setLanguage(t[h] || "english");
    } catch (v) {
      throw console.error("Error setting language:", v), new Error(`Unable to set locale to ${h}. Please try again.`);
    }
  };
  return {
    mxLocalesState: a,
    setLocale: s,
    getLocale: i,
    initLocale: l,
    onSwitchLang: async (h) => {
      const v = i(n.user.getLanguage());
      try {
        v != h && (n.app.toggleLoader(!0), await s(h), n.app.toggleLoader(!1));
      } catch (A) {
        throw console.error("Error switching language:", A), n.app.toggleLoader(!1), new Error("There was an error switching the language. Please contact the administrator.");
      }
    },
    setActiveLocale: (h) => {
      a.langs = JSON.parse(JSON.stringify(o)), a.langs[i(h)].isActive = !0;
    },
    getActiveLocale: () => e.value,
    autoDetectLanguage: () => {
      const h = navigator.language.split("-")[0], A = Object.keys(t).includes(h) ? h : "en";
      s(A);
    }
  };
}, MV = {
  href: "javascript:void(0)",
  class: "nav-link icon country-Flag"
}, $V = { class: "dropdown-menu" }, CV = ["onClick"], LV = { class: "avatar align-self-center bg-transparent me-3" }, EV = { class: "d-flex" }, OV = { class: "mt-2" }, NV = ["onClick"], DV = { class: "language" }, kV = { class: "align-middle" }, oT = /* @__PURE__ */ wt({
  __name: "Locales",
  props: {
    propsImages: {
      type: Object,
      default: {
        en: {
          src: "../images/flag/en.svg",
          alt: "English"
        },
        cn: {
          src: "../images/flag/cn.svg",
          alt: "Simplified"
        }
      }
    },
    propsLangs: {
      type: Object,
      default: {
        en: {
          flag: "flag-us",
          label: "english"
        },
        cn: {
          flag: "flag-china",
          label: "simplified"
        }
      }
    },
    propsStore: {
      type: Object,
      required: !0
    },
    propsTemplate2: {
      type: Array,
      default: [
        "login"
      ]
    }
  },
  setup(e) {
    const t = e, r = t.propsStore.app, o = t.propsStore.user, { device: n } = om(o), { initLocale: a, onSwitchLang: l, setActiveLocale: i, getActiveLocale: s } = rT(), u = Ee(), c = dt({
      activeLang: "",
      dropdown: {
        langDrp: {
          isShow: !1
        }
      }
    }), g = {
      images: {},
      langs: {},
      template2: []
    };
    Nn(() => {
      g.images = t.propsImages, g.langs = t.propsLangs, g.template2 = t.propsTemplate2, a({ app: r, user: o });
    }), or(() => {
      i(o.getLanguage());
    });
    const p = (S, b = null) => {
      c.dropdown[S] && (b !== null ? c.dropdown[S].isShow = b : c.dropdown[S].isShow = !c.dropdown[S].isShow);
    };
    El(u, (S) => p("langDrp", !1));
    const h = ge(() => s()), v = ge(() => g.langs), A = ge(() => !g.template2.includes(o.getPage()));
    return nt(() => n.value.language, (S) => {
      i(S);
    }), (S, b) => (C(), k(De, null, [
      A.value ? (C(), k("div", {
        key: 0,
        class: $e(["dropdown flag-dropdown", { show: c.dropdown.langDrp.isShow }]),
        ref_key: "langDropdown",
        ref: u,
        "data-name": "langDrp",
        onClick: b[0] || (b[0] = (T) => {
          p("langDrp");
        })
      }, [
        L("a", MV, [
          L("img", Er(fo(g.images[h.value])), null, 16)
        ]),
        L("div", $V, [
          (C(!0), k(De, null, rt(v.value, (T, w) => (C(), k("a", {
            key: w,
            href: "javascript:void(0)",
            class: $e(["dropdown-item d-flex", { active: h.value == w }]),
            onClick: (N) => {
              R(l)(w);
            }
          }, [
            L("span", LV, [
              L("img", ht({ ref_for: !0 }, g.images[w]), null, 16)
            ]),
            L("div", EV, [
              L("span", OV, _e(S.$t(`translations.${T.label}`)), 1)
            ])
          ], 10, CV))), 128))
        ])
      ], 2)) : q("", !0),
      A.value ? q("", !0) : (C(), k("div", {
        key: 1,
        class: "dropdown langDropdown",
        ref_key: "langDropdown",
        ref: u,
        "data-name": "langDrp"
      }, [
        L("button", {
          type: "button",
          class: $e(["btn btn-outline-light btn-sm dropdown-toggle", { show: c.dropdown.langDrp.isShow }]),
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false",
          onClick: b[1] || (b[1] = (T) => {
            p("langDrp");
          })
        }, [...b[2] || (b[2] = [
          L("i", { class: "fas fa-language" }, null, -1)
        ])], 2),
        L("ul", {
          class: $e(["dropdown-menu dropdown-menu-end shadow", { show: c.dropdown.langDrp.isShow }]),
          "aria-labelledby": "localization"
        }, [
          (C(!0), k(De, null, rt(v.value, (T, w) => (C(), k("li", { key: w }, [
            L("a", {
              href: "javascript:void(0)",
              class: $e(["dropdown-item", { active: h.value == w }]),
              onClick: (N) => {
                R(l)(w), p("langDrp", !1);
              }
            }, [
              L("div", DV, [
                L("i", {
                  class: $e(["flag align-middle", T.flag])
                }, null, 2),
                L("span", kV, _e(S.$t(`translations.${T.label}`)), 1)
              ])
            ], 10, NV)
          ]))), 128))
        ], 2)
      ], 512))
    ], 64));
  }
}), GV = { class: "main-header side-header sticky" }, BV = { class: "main-container container-fluid" }, IV = { class: "main-header-right" }, RV = { class: "navbar navbar-expand-lg nav-item navbar-nav-right responsive-navbar navbar-dark" }, FV = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent-4"
}, VV = { class: "d-flex align-items-center order-lg-2 ms-auto" }, HV = {
  key: 0,
  class: "dropdown d-flex main-header-theme"
}, UV = { class: "nav-link icon layout-setting" }, XV = {
  href: "javascript:void(0)",
  class: "nav-link icon"
}, WV = {
  class: "d-flex",
  href: "javascript:void(0)"
}, YV = { class: "main-img-user" }, KV = { class: "header-navheading" }, QV = { class: "main-notification-title" }, jV = { class: "main-notification-text" }, O0e = /* @__PURE__ */ wt({
  __name: "Header",
  props: {
    propsFunction: {
      type: Object,
      required: !0
    },
    propsImage: {
      type: Object,
      default: {
        user: {
          src: "../images/avatar/user.png",
          alt: "avatar"
        }
      }
    },
    propsOption: {
      type: Array,
      default: [
        "locales",
        "profile"
      ]
    },
    propsStore: {
      type: Object,
      required: !0
    },
    propsUserName: {
      type: String
    },
    propsUserTitle: {
      type: String,
      required: !0
    }
  },
  setup(e, { expose: t }) {
    const r = e, o = r.propsStore.app, n = r.propsStore.user, a = r.propsStore.action, l = Ee(), i = Ee(), s = dt({
      dropdown: {
        notificationDrp: {
          isShow: !1
        },
        profileDrp: {
          isShow: !1
        }
      }
    });
    Nn(() => {
      window.addEventListener("resize", p);
    }), or(() => {
      p();
    }), tn(() => {
      window.removeEventListener("resize", p);
    });
    const u = () => {
      let S = !1;
      document.body.classList.contains("main-sidebar-show") ? (document.body.classList.remove("main-sidebar-show"), document.body.classList.add("main-sidebar-hide"), a.setComponentAction("aside", !1), S = !0) : (document.body.classList.add("main-sidebar-show"), document.body.classList.remove("main-sidebar-hide"), a.setComponentAction("aside", !0)), S ? document.cookie = "min-sidebar=true; path=/" : document.cookie = "min-sidebar=false; path=/";
    }, c = (S, b = null) => {
      s.dropdown[S] && (s.dropdown[S].isShow = b ?? !s.dropdown[S].isShow);
    }, g = (S) => {
      n.setDarkMode(S === "dark");
    }, p = () => {
      const { offsetWidth: S } = document.querySelector("#app");
      S <= 991 ? (document.body.classList.remove("main-sidebar-show"), a.setComponentAction("aside", !1)) : (document.body.classList.add("main-sidebar-show"), document.body.classList.remove("main-sidebar-hide"), a.setComponentAction("aside", !0));
    };
    El(l, (S) => c("notificationDrp", !1)), El(i, (S) => c("profileDrp", !1)), t({
      onToggleDropdown: c
    });
    const h = ge(() => r.propsUserName ? r.propsUserName : n.getInfoByKey("username")), v = ge(() => r.propsUserTitle), A = ge(() => r.propsFunction?.getNotificationCount?.() ?? 0);
    return (S, b) => {
      const T = fl("router-link");
      return C(), k("div", GV, [
        L("div", BV, [
          L("div", {
            class: "main-header-left",
            onClick: b[0] || (b[0] = (w) => {
              u();
            })
          }, [...b[10] || (b[10] = [
            L("a", {
              class: "main-header-menu-icon",
              href: "javascript:void(0)"
            }, [
              L("span")
            ], -1)
          ])]),
          b[17] || (b[17] = L("div", { class: "main-header-center" }, null, -1)),
          L("div", IV, [
            L("div", RV, [
              L("div", FV, [
                L("div", VV, [
                  be(S.$slots, "top-options"),
                  e.propsOption.includes("theme") ? (C(), k("div", HV, [
                    L("a", UV, [
                      L("span", {
                        class: "dark-layout",
                        onClick: b[1] || (b[1] = (w) => {
                          g("light");
                        })
                      }, [...b[11] || (b[11] = [
                        L("i", { class: "far fa-sun header-icons" }, null, -1)
                      ])]),
                      L("span", {
                        class: "light-layout",
                        onClick: b[2] || (b[2] = (w) => {
                          g("dark");
                        })
                      }, [...b[12] || (b[12] = [
                        L("i", { class: "far fa-moon header-icons" }, null, -1)
                      ])])
                    ])
                  ])) : q("", !0),
                  e.propsOption.includes("locales") ? (C(), ft(oT, {
                    key: 1,
                    "props-store": { app: R(o), user: R(n) }
                  }, null, 8, ["props-store"])) : q("", !0),
                  e.propsOption.includes("notification") ? (C(), k("div", {
                    key: 2,
                    ref_key: "notificationDropdown",
                    ref: l,
                    "data-name": "notificationDrp",
                    class: $e(["dropdown main-header-notification", { show: s.dropdown.notificationDrp.isShow }]),
                    onClick: b[4] || (b[4] = (w) => {
                      c("notificationDrp");
                    })
                  }, [
                    L("a", XV, [
                      b[13] || (b[13] = L("i", { class: "far fa-bell header-icons" }, null, -1)),
                      L("span", {
                        class: $e(["badge bg-danger nav-link-badge", { pulse: A.value }])
                      }, _e(A.value), 3)
                    ]),
                    L("div", {
                      class: "dropdown-menu",
                      onClick: b[3] || (b[3] = Nt(() => {
                      }, ["stop"]))
                    }, [
                      be(S.$slots, "notification")
                    ])
                  ], 2)) : q("", !0),
                  e.propsOption.includes("profile") ? (C(), k("div", {
                    key: 3,
                    ref_key: "profileDropdown",
                    ref: i,
                    "data-name": "profileDrp",
                    class: $e(["dropdown main-profile-menu", { show: s.dropdown.profileDrp.isShow }]),
                    onClick: b[9] || (b[9] = (w) => {
                      c("profileDrp");
                    })
                  }, [
                    L("a", WV, [
                      L("span", YV, [
                        L("img", Er(fo(e.propsImage.user)), null, 16)
                      ])
                    ]),
                    L("div", {
                      class: "dropdown-menu",
                      onClick: b[8] || (b[8] = Nt(() => {
                      }, ["stop"]))
                    }, [
                      L("div", KV, [
                        L("h6", QV, _e(h.value), 1),
                        L("p", jV, _e(S.$t(v.value)), 1)
                      ]),
                      e.propsOption.includes("only-signout") ? q("", !0) : (C(), ft(T, {
                        key: 0,
                        class: "dropdown-item border-top",
                        to: { path: R(n).getType() + "MyProfile" },
                        onClick: b[5] || (b[5] = (w) => {
                          c("profileDrp");
                        })
                      }, {
                        default: je(() => [
                          b[14] || (b[14] = L("i", { class: "fas fa-user" }, null, -1)),
                          Gt(_e(S.$t("my_profile")), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])),
                      e.propsOption.includes("only-signout") ? q("", !0) : (C(), ft(T, {
                        key: 1,
                        class: "dropdown-item",
                        to: { path: "changePassword" },
                        onClick: b[6] || (b[6] = (w) => {
                          c("profileDrp");
                        })
                      }, {
                        default: je(() => [
                          b[15] || (b[15] = L("i", { class: "fas fa-edit" }, null, -1)),
                          Gt(_e(S.$t("change_password")), 1)
                        ]),
                        _: 1
                      })),
                      L("a", {
                        class: $e(["dropdown-item", { "border-top": e.propsOption.includes("only-signout") }]),
                        href: "javascript:void(0)",
                        onClick: b[7] || (b[7] = (w) => {
                          e.propsFunction.onLogout(R(n).getType()), c("profileDrp");
                        })
                      }, [
                        b[16] || (b[16] = L("i", { class: "fas fa-power-off" }, null, -1)),
                        Gt(_e(S.$t("signout")), 1)
                      ], 2)
                    ])
                  ], 2)) : q("", !0)
                ])
              ])
            ])
          ])
        ])
      ]);
    };
  }
}), ZV = {
  key: 0,
  class: "page-move-btn"
}, N0e = /* @__PURE__ */ wt({
  __name: "Scroll",
  props: {
    propsStore: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = dt({
      isScrollAble: !1,
      isVisible: !1
    });
    or(() => {
      window.addEventListener("scroll", o), window.addEventListener("resize", l), setTimeout(() => {
        l();
      }, 1e3);
    }), tn(() => {
      window.removeEventListener("scroll", o), window.removeEventListener("resize", l);
    });
    const o = () => {
      r.isVisible = window.scrollY > 50;
    }, n = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }, a = () => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth"
      });
    }, l = () => {
      document.getElementsByClassName("main-content").length && (r.isScrollAble = document.getElementsByClassName("main-content")[0].clientHeight > window.innerHeight);
    };
    return nt(() => t.propsStore.app.isLoading, (i) => {
      i || l();
    }), (i, s) => r.isScrollAble ? (C(), k("div", ZV, [
      r.isVisible ? (C(), k("span", {
        key: 1,
        onClick: n
      }, [...s[1] || (s[1] = [
        L("i", { class: "fas fa-arrow-up" }, null, -1)
      ])])) : (C(), k("span", {
        key: 0,
        onClick: a
      }, [...s[0] || (s[0] = [
        L("i", { class: "fas fa-arrow-down" }, null, -1)
      ])]))
    ])) : q("", !0);
  }
}), zV = { class: "row row-sm" }, qV = { class: "col-md-12" }, JV = { class: "d-flex align-items-end d-grid gap-1" }, eH = { class: "tx-medium me-auto" }, tH = { class: "table text-nowrap text-md-nowrap table-bordered mg-b-0" }, rH = ["width"], oH = ["data-id"], nH = {
  key: 0,
  class: "row-select"
}, aH = { key: 1 }, lH = ["name"], iH = { key: 2 }, sH = ["name"], dH = { key: 3 }, uH = ["name"], cH = { key: 4 }, mH = { key: 5 }, gH = {
  key: 6,
  class: "row-switch"
}, fH = { class: "form-check form-switch" }, pH = { class: "custom-switch" }, hH = ["name"], xH = { class: "ms-2 custom-switch-description" }, D0e = /* @__PURE__ */ wt({
  __name: "FormListGroupSkeleton",
  props: {
    propsBlade: {
      type: Object,
      required: !0
    },
    propsBladeInit: {
      type: Function,
      required: !0
    },
    propsIsEditAble: {
      type: Boolean,
      required: !1
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = t.propsStore.user, o = t.propsBladeInit, n = dt({
      totalRecords: 1
    }), a = dt({
      input: {},
      blade: t.propsBlade
    });
    Nn(() => {
      for (let i = n.totalRecords - 1; i < n.totalRecords; i++)
        a.input[i] = { ...o() };
    });
    const l = ge(() => Object.keys(t.propsBlade).filter((i) => !t.propsBlade[i].exclude).reduce((i, s) => Object.assign(i, { [s]: a.blade[s] }), {}));
    return (i, s) => (C(), k("div", zV, [
      L("span", qV, [
        L("div", JV, [
          L("label", eH, _e(i.$t("table.loadingRecords")), 1),
          e.propsIsEditAble ? (C(), k(De, { key: 0 }, [
            L("a", {
              href: "javascript:void(0)",
              class: $e(["btn btn-outline-success btn-icon-text my-2", { disabled: !0 }]),
              disabled: !0
            }, [
              s[0] || (s[0] = L("i", { class: "far fa-plus-square me-1" }, null, -1)),
              Gt(_e(i.$t("table.loadingRecords")), 1)
            ]),
            L("a", {
              href: "javascript:void(0)",
              class: $e(["btn btn-outline-danger btn-icon-text my-2", { disabled: !0 }]),
              disabled: !0
            }, [
              s[1] || (s[1] = L("i", { class: "far fa-minus-square me-1" }, null, -1)),
              Gt(_e(i.$t("table.loadingRecords")), 1)
            ])
          ], 64)) : q("", !0)
        ]),
        L("div", {
          class: $e(["table-form", { "table-responsive": R(r).getDeviceMode() == "mobile" }])
        }, [
          L("table", tH, [
            L("thead", null, [
              L("tr", null, [
                (C(!0), k(De, null, rt(l.value, (u, c) => (C(), k("th", {
                  key: c,
                  width: u.width
                }, [
                  u.type != "" ? (C(), k(De, { key: 0 }, [
                    Gt(_e(i.$t("table.loadingRecords")), 1)
                  ], 64)) : q("", !0)
                ], 8, rH))), 128))
              ])
            ]),
            L("tbody", null, [
              (C(!0), k(De, null, rt(a.input, (u, c) => (C(), k("tr", {
                key: c,
                "data-id": c
              }, [
                (C(!0), k(De, null, rt(l.value, (g, p) => (C(), k(De, { key: p }, [
                  g.type == "" ? (C(), k("td", nH, [...s[2] || (s[2] = [
                    L("label", { class: "custom-control custom-checkbox" }, [
                      L("input", {
                        type: "checkbox",
                        class: "custom-control-input"
                      }),
                      L("span", { class: "custom-control-label" })
                    ], -1)
                  ])])) : q("", !0),
                  g.type == "text" || g.type == "order" ? (C(), k("td", aH, [
                    L("input", {
                      type: "text",
                      name: p,
                      class: $e(["form-control", g.classes ? g.classes : ""]),
                      disabled: !0
                    }, null, 10, lH)
                  ])) : q("", !0),
                  g.type == "decimal" ? (C(), k("td", iH, [
                    L("input", ht({
                      type: "text",
                      name: p,
                      class: ["form-control", g.classes ? g.classes : ""]
                    }, { ref_for: !0 }, g?.attributes, { disabled: !0 }), null, 16, sH)
                  ])) : q("", !0),
                  g.type == "number" ? (C(), k("td", dH, [
                    L("input", ht({
                      type: "text",
                      name: p,
                      class: ["form-control", g.classes ? g.classes : ""]
                    }, { ref_for: !0 }, g?.attributes, { disabled: !0 }), null, 16, uH)
                  ])) : q("", !0),
                  g.type == "select" ? (C(), k("td", cH, [
                    vt(R(Wa), {
                      name: p,
                      placeholder: i.$t("table.loadingRecords"),
                      disabled: !0,
                      options: []
                    }, null, 8, ["name", "placeholder"])
                  ])) : q("", !0),
                  g.type == "datetime" ? (C(), k("td", mH, [
                    vt(R(fi), ht({
                      name: p
                    }, { ref_for: !0 }, g?.attributes, { disabled: !0 }), null, 16, ["name"])
                  ])) : q("", !0),
                  g.type == "switch" ? (C(), k("td", gH, [
                    L("div", fH, [
                      L("label", pH, [
                        L("input", {
                          type: "checkbox",
                          name: p,
                          class: "custom-switch-input",
                          disabled: !0
                        }, null, 8, hH),
                        s[3] || (s[3] = L("span", { class: "custom-switch-indicator" }, null, -1)),
                        L("span", xH, _e(i.$t("table.loadingRecords")), 1)
                      ])
                    ])
                  ])) : q("", !0)
                ], 64))), 128))
              ], 8, oH))), 128))
            ])
          ])
        ], 2)
      ])
    ]));
  }
}), k0e = /* @__PURE__ */ wt({
  __name: "ListGroupSkeleton",
  props: {
    propsBlade: {
      type: Object,
      required: !0
    },
    propsBladeInit: {
      type: Object,
      required: !0
    },
    propsFilterInit: {
      type: Function,
      required: !0
    },
    propsTableAction: {
      type: Object,
      required: !0
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = dt({
      init: {
        url: {
          create: "",
          edit: "",
          list: "",
          download: ""
        }
      },
      action: "",
      blade: {
        columns: {},
        includes: "",
        sort: {
          column: "",
          direction: ""
        }
      },
      id: "skeletonTable"
    });
    return Nn(() => {
      let o = 0;
      const n = JSON.parse(JSON.stringify(t.propsBlade));
      for (let a in n.columns) {
        const l = `loading${o++}`;
        r.blade.columns[l] = JSON.parse(JSON.stringify(n.columns[a])), r.blade.columns[l].data = "", r.blade.columns[l].label = a == "-" ? "" : "table.loadingRecords", typeof n.columns[a].filter == "object" && n.columns[a].filter?.type === "select" && (r.blade.columns[l].filter.options = [{
          id: "-1",
          code: "",
          name: "Loading..."
        }]);
      }
    }), (o, n) => (C(), ft(sF, {
      "props-blade": r.blade,
      "props-blade-init": e.propsBladeInit,
      "props-default-idx": "",
      "props-filter-init": e.propsFilterInit,
      "props-loading": { loading: !0 },
      "props-table-action": e.propsTableAction,
      "props-table-option": { url: "-1" },
      "props-store": e.propsStore
    }, null, 8, ["props-blade", "props-blade-init", "props-filter-init", "props-table-action", "props-store"]));
  }
});
function Ah(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var qi = {}, rf, dv;
function vH() {
  return dv || (dv = 1, rf = function() {
    return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
  }), rf;
}
var of = {}, cl = {}, uv;
function Ci() {
  if (uv) return cl;
  uv = 1;
  let e;
  const t = [
    0,
    // Not used
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
  ];
  return cl.getSymbolSize = function(o) {
    if (!o) throw new Error('"version" cannot be null or undefined');
    if (o < 1 || o > 40) throw new Error('"version" should be in range from 1 to 40');
    return o * 4 + 17;
  }, cl.getSymbolTotalCodewords = function(o) {
    return t[o];
  }, cl.getBCHDigit = function(r) {
    let o = 0;
    for (; r !== 0; )
      o++, r >>>= 1;
    return o;
  }, cl.setToSJISFunction = function(o) {
    if (typeof o != "function")
      throw new Error('"toSJISFunc" is not a valid function.');
    e = o;
  }, cl.isKanjiModeEnabled = function() {
    return typeof e < "u";
  }, cl.toSJIS = function(o) {
    return e(o);
  }, cl;
}
var nf = {}, cv;
function Ph() {
  return cv || (cv = 1, (function(e) {
    e.L = { bit: 1 }, e.M = { bit: 0 }, e.Q = { bit: 3 }, e.H = { bit: 2 };
    function t(r) {
      if (typeof r != "string")
        throw new Error("Param is not a string");
      switch (r.toLowerCase()) {
        case "l":
        case "low":
          return e.L;
        case "m":
        case "medium":
          return e.M;
        case "q":
        case "quartile":
          return e.Q;
        case "h":
        case "high":
          return e.H;
        default:
          throw new Error("Unknown EC Level: " + r);
      }
    }
    e.isValid = function(o) {
      return o && typeof o.bit < "u" && o.bit >= 0 && o.bit < 4;
    }, e.from = function(o, n) {
      if (e.isValid(o))
        return o;
      try {
        return t(o);
      } catch {
        return n;
      }
    };
  })(nf)), nf;
}
var af, mv;
function SH() {
  if (mv) return af;
  mv = 1;
  function e() {
    this.buffer = [], this.length = 0;
  }
  return e.prototype = {
    get: function(t) {
      const r = Math.floor(t / 8);
      return (this.buffer[r] >>> 7 - t % 8 & 1) === 1;
    },
    put: function(t, r) {
      for (let o = 0; o < r; o++)
        this.putBit((t >>> r - o - 1 & 1) === 1);
    },
    getLengthInBits: function() {
      return this.length;
    },
    putBit: function(t) {
      const r = Math.floor(this.length / 8);
      this.buffer.length <= r && this.buffer.push(0), t && (this.buffer[r] |= 128 >>> this.length % 8), this.length++;
    }
  }, af = e, af;
}
var lf, gv;
function bH() {
  if (gv) return lf;
  gv = 1;
  function e(t) {
    if (!t || t < 1)
      throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t);
  }
  return e.prototype.set = function(t, r, o, n) {
    const a = t * this.size + r;
    this.data[a] = o, n && (this.reservedBit[a] = !0);
  }, e.prototype.get = function(t, r) {
    return this.data[t * this.size + r];
  }, e.prototype.xor = function(t, r, o) {
    this.data[t * this.size + r] ^= o;
  }, e.prototype.isReserved = function(t, r) {
    return this.reservedBit[t * this.size + r];
  }, lf = e, lf;
}
var sf = {}, fv;
function yH() {
  return fv || (fv = 1, (function(e) {
    const t = Ci().getSymbolSize;
    e.getRowColCoords = function(o) {
      if (o === 1) return [];
      const n = Math.floor(o / 7) + 2, a = t(o), l = a === 145 ? 26 : Math.ceil((a - 13) / (2 * n - 2)) * 2, i = [a - 7];
      for (let s = 1; s < n - 1; s++)
        i[s] = i[s - 1] - l;
      return i.push(6), i.reverse();
    }, e.getPositions = function(o) {
      const n = [], a = e.getRowColCoords(o), l = a.length;
      for (let i = 0; i < l; i++)
        for (let s = 0; s < l; s++)
          i === 0 && s === 0 || // top-left
          i === 0 && s === l - 1 || // bottom-left
          i === l - 1 && s === 0 || n.push([a[i], a[s]]);
      return n;
    };
  })(sf)), sf;
}
var df = {}, pv;
function wH() {
  if (pv) return df;
  pv = 1;
  const e = Ci().getSymbolSize, t = 7;
  return df.getPositions = function(o) {
    const n = e(o);
    return [
      // top-left
      [0, 0],
      // top-right
      [n - t, 0],
      // bottom-left
      [0, n - t]
    ];
  }, df;
}
var uf = {}, hv;
function _H() {
  return hv || (hv = 1, (function(e) {
    e.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };
    const t = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };
    e.isValid = function(n) {
      return n != null && n !== "" && !isNaN(n) && n >= 0 && n <= 7;
    }, e.from = function(n) {
      return e.isValid(n) ? parseInt(n, 10) : void 0;
    }, e.getPenaltyN1 = function(n) {
      const a = n.size;
      let l = 0, i = 0, s = 0, u = null, c = null;
      for (let g = 0; g < a; g++) {
        i = s = 0, u = c = null;
        for (let p = 0; p < a; p++) {
          let h = n.get(g, p);
          h === u ? i++ : (i >= 5 && (l += t.N1 + (i - 5)), u = h, i = 1), h = n.get(p, g), h === c ? s++ : (s >= 5 && (l += t.N1 + (s - 5)), c = h, s = 1);
        }
        i >= 5 && (l += t.N1 + (i - 5)), s >= 5 && (l += t.N1 + (s - 5));
      }
      return l;
    }, e.getPenaltyN2 = function(n) {
      const a = n.size;
      let l = 0;
      for (let i = 0; i < a - 1; i++)
        for (let s = 0; s < a - 1; s++) {
          const u = n.get(i, s) + n.get(i, s + 1) + n.get(i + 1, s) + n.get(i + 1, s + 1);
          (u === 4 || u === 0) && l++;
        }
      return l * t.N2;
    }, e.getPenaltyN3 = function(n) {
      const a = n.size;
      let l = 0, i = 0, s = 0;
      for (let u = 0; u < a; u++) {
        i = s = 0;
        for (let c = 0; c < a; c++)
          i = i << 1 & 2047 | n.get(u, c), c >= 10 && (i === 1488 || i === 93) && l++, s = s << 1 & 2047 | n.get(c, u), c >= 10 && (s === 1488 || s === 93) && l++;
      }
      return l * t.N3;
    }, e.getPenaltyN4 = function(n) {
      let a = 0;
      const l = n.data.length;
      for (let s = 0; s < l; s++) a += n.data[s];
      return Math.abs(Math.ceil(a * 100 / l / 5) - 10) * t.N4;
    };
    function r(o, n, a) {
      switch (o) {
        case e.Patterns.PATTERN000:
          return (n + a) % 2 === 0;
        case e.Patterns.PATTERN001:
          return n % 2 === 0;
        case e.Patterns.PATTERN010:
          return a % 3 === 0;
        case e.Patterns.PATTERN011:
          return (n + a) % 3 === 0;
        case e.Patterns.PATTERN100:
          return (Math.floor(n / 2) + Math.floor(a / 3)) % 2 === 0;
        case e.Patterns.PATTERN101:
          return n * a % 2 + n * a % 3 === 0;
        case e.Patterns.PATTERN110:
          return (n * a % 2 + n * a % 3) % 2 === 0;
        case e.Patterns.PATTERN111:
          return (n * a % 3 + (n + a) % 2) % 2 === 0;
        default:
          throw new Error("bad maskPattern:" + o);
      }
    }
    e.applyMask = function(n, a) {
      const l = a.size;
      for (let i = 0; i < l; i++)
        for (let s = 0; s < l; s++)
          a.isReserved(s, i) || a.xor(s, i, r(n, s, i));
    }, e.getBestMask = function(n, a) {
      const l = Object.keys(e.Patterns).length;
      let i = 0, s = 1 / 0;
      for (let u = 0; u < l; u++) {
        a(u), e.applyMask(u, n);
        const c = e.getPenaltyN1(n) + e.getPenaltyN2(n) + e.getPenaltyN3(n) + e.getPenaltyN4(n);
        e.applyMask(u, n), c < s && (s = c, i = u);
      }
      return i;
    };
  })(uf)), uf;
}
var ac = {}, xv;
function nT() {
  if (xv) return ac;
  xv = 1;
  const e = Ph(), t = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
  ], r = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
  ];
  return ac.getBlocksCount = function(n, a) {
    switch (a) {
      case e.L:
        return t[(n - 1) * 4 + 0];
      case e.M:
        return t[(n - 1) * 4 + 1];
      case e.Q:
        return t[(n - 1) * 4 + 2];
      case e.H:
        return t[(n - 1) * 4 + 3];
      default:
        return;
    }
  }, ac.getTotalCodewordsCount = function(n, a) {
    switch (a) {
      case e.L:
        return r[(n - 1) * 4 + 0];
      case e.M:
        return r[(n - 1) * 4 + 1];
      case e.Q:
        return r[(n - 1) * 4 + 2];
      case e.H:
        return r[(n - 1) * 4 + 3];
      default:
        return;
    }
  }, ac;
}
var cf = {}, Nd = {}, vv;
function TH() {
  if (vv) return Nd;
  vv = 1;
  const e = new Uint8Array(512), t = new Uint8Array(256);
  return (function() {
    let o = 1;
    for (let n = 0; n < 255; n++)
      e[n] = o, t[o] = n, o <<= 1, o & 256 && (o ^= 285);
    for (let n = 255; n < 512; n++)
      e[n] = e[n - 255];
  })(), Nd.log = function(o) {
    if (o < 1) throw new Error("log(" + o + ")");
    return t[o];
  }, Nd.exp = function(o) {
    return e[o];
  }, Nd.mul = function(o, n) {
    return o === 0 || n === 0 ? 0 : e[t[o] + t[n]];
  }, Nd;
}
var Sv;
function AH() {
  return Sv || (Sv = 1, (function(e) {
    const t = TH();
    e.mul = function(o, n) {
      const a = new Uint8Array(o.length + n.length - 1);
      for (let l = 0; l < o.length; l++)
        for (let i = 0; i < n.length; i++)
          a[l + i] ^= t.mul(o[l], n[i]);
      return a;
    }, e.mod = function(o, n) {
      let a = new Uint8Array(o);
      for (; a.length - n.length >= 0; ) {
        const l = a[0];
        for (let s = 0; s < n.length; s++)
          a[s] ^= t.mul(n[s], l);
        let i = 0;
        for (; i < a.length && a[i] === 0; ) i++;
        a = a.slice(i);
      }
      return a;
    }, e.generateECPolynomial = function(o) {
      let n = new Uint8Array([1]);
      for (let a = 0; a < o; a++)
        n = e.mul(n, new Uint8Array([1, t.exp(a)]));
      return n;
    };
  })(cf)), cf;
}
var mf, bv;
function PH() {
  if (bv) return mf;
  bv = 1;
  const e = AH();
  function t(r) {
    this.genPoly = void 0, this.degree = r, this.degree && this.initialize(this.degree);
  }
  return t.prototype.initialize = function(o) {
    this.degree = o, this.genPoly = e.generateECPolynomial(this.degree);
  }, t.prototype.encode = function(o) {
    if (!this.genPoly)
      throw new Error("Encoder not initialized");
    const n = new Uint8Array(o.length + this.degree);
    n.set(o);
    const a = e.mod(n, this.genPoly), l = this.degree - a.length;
    if (l > 0) {
      const i = new Uint8Array(this.degree);
      return i.set(a, l), i;
    }
    return a;
  }, mf = t, mf;
}
var gf = {}, ff = {}, pf = {}, yv;
function aT() {
  return yv || (yv = 1, pf.isValid = function(t) {
    return !isNaN(t) && t >= 1 && t <= 40;
  }), pf;
}
var ua = {}, wv;
function lT() {
  if (wv) return ua;
  wv = 1;
  const e = "[0-9]+", t = "[A-Z $%*+\\-./:]+";
  let r = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
  r = r.replace(/u/g, "\\u");
  const o = "(?:(?![A-Z0-9 $%*+\\-./:]|" + r + `)(?:.|[\r
]))+`;
  ua.KANJI = new RegExp(r, "g"), ua.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), ua.BYTE = new RegExp(o, "g"), ua.NUMERIC = new RegExp(e, "g"), ua.ALPHANUMERIC = new RegExp(t, "g");
  const n = new RegExp("^" + r + "$"), a = new RegExp("^" + e + "$"), l = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
  return ua.testKanji = function(s) {
    return n.test(s);
  }, ua.testNumeric = function(s) {
    return a.test(s);
  }, ua.testAlphanumeric = function(s) {
    return l.test(s);
  }, ua;
}
var _v;
function Li() {
  return _v || (_v = 1, (function(e) {
    const t = aT(), r = lT();
    e.NUMERIC = {
      id: "Numeric",
      bit: 1,
      ccBits: [10, 12, 14]
    }, e.ALPHANUMERIC = {
      id: "Alphanumeric",
      bit: 2,
      ccBits: [9, 11, 13]
    }, e.BYTE = {
      id: "Byte",
      bit: 4,
      ccBits: [8, 16, 16]
    }, e.KANJI = {
      id: "Kanji",
      bit: 8,
      ccBits: [8, 10, 12]
    }, e.MIXED = {
      bit: -1
    }, e.getCharCountIndicator = function(a, l) {
      if (!a.ccBits) throw new Error("Invalid mode: " + a);
      if (!t.isValid(l))
        throw new Error("Invalid version: " + l);
      return l >= 1 && l < 10 ? a.ccBits[0] : l < 27 ? a.ccBits[1] : a.ccBits[2];
    }, e.getBestModeForData = function(a) {
      return r.testNumeric(a) ? e.NUMERIC : r.testAlphanumeric(a) ? e.ALPHANUMERIC : r.testKanji(a) ? e.KANJI : e.BYTE;
    }, e.toString = function(a) {
      if (a && a.id) return a.id;
      throw new Error("Invalid mode");
    }, e.isValid = function(a) {
      return a && a.bit && a.ccBits;
    };
    function o(n) {
      if (typeof n != "string")
        throw new Error("Param is not a string");
      switch (n.toLowerCase()) {
        case "numeric":
          return e.NUMERIC;
        case "alphanumeric":
          return e.ALPHANUMERIC;
        case "kanji":
          return e.KANJI;
        case "byte":
          return e.BYTE;
        default:
          throw new Error("Unknown mode: " + n);
      }
    }
    e.from = function(a, l) {
      if (e.isValid(a))
        return a;
      try {
        return o(a);
      } catch {
        return l;
      }
    };
  })(ff)), ff;
}
var Tv;
function MH() {
  return Tv || (Tv = 1, (function(e) {
    const t = Ci(), r = nT(), o = Ph(), n = Li(), a = aT(), l = 7973, i = t.getBCHDigit(l);
    function s(p, h, v) {
      for (let A = 1; A <= 40; A++)
        if (h <= e.getCapacity(A, v, p))
          return A;
    }
    function u(p, h) {
      return n.getCharCountIndicator(p, h) + 4;
    }
    function c(p, h) {
      let v = 0;
      return p.forEach(function(A) {
        const S = u(A.mode, h);
        v += S + A.getBitsLength();
      }), v;
    }
    function g(p, h) {
      for (let v = 1; v <= 40; v++)
        if (c(p, v) <= e.getCapacity(v, h, n.MIXED))
          return v;
    }
    e.from = function(h, v) {
      return a.isValid(h) ? parseInt(h, 10) : v;
    }, e.getCapacity = function(h, v, A) {
      if (!a.isValid(h))
        throw new Error("Invalid QR Code version");
      typeof A > "u" && (A = n.BYTE);
      const S = t.getSymbolTotalCodewords(h), b = r.getTotalCodewordsCount(h, v), T = (S - b) * 8;
      if (A === n.MIXED) return T;
      const w = T - u(A, h);
      switch (A) {
        case n.NUMERIC:
          return Math.floor(w / 10 * 3);
        case n.ALPHANUMERIC:
          return Math.floor(w / 11 * 2);
        case n.KANJI:
          return Math.floor(w / 13);
        case n.BYTE:
        default:
          return Math.floor(w / 8);
      }
    }, e.getBestVersionForData = function(h, v) {
      let A;
      const S = o.from(v, o.M);
      if (Array.isArray(h)) {
        if (h.length > 1)
          return g(h, S);
        if (h.length === 0)
          return 1;
        A = h[0];
      } else
        A = h;
      return s(A.mode, A.getLength(), S);
    }, e.getEncodedBits = function(h) {
      if (!a.isValid(h) || h < 7)
        throw new Error("Invalid QR Code version");
      let v = h << 12;
      for (; t.getBCHDigit(v) - i >= 0; )
        v ^= l << t.getBCHDigit(v) - i;
      return h << 12 | v;
    };
  })(gf)), gf;
}
var hf = {}, Av;
function $H() {
  if (Av) return hf;
  Av = 1;
  const e = Ci(), t = 1335, r = 21522, o = e.getBCHDigit(t);
  return hf.getEncodedBits = function(a, l) {
    const i = a.bit << 3 | l;
    let s = i << 10;
    for (; e.getBCHDigit(s) - o >= 0; )
      s ^= t << e.getBCHDigit(s) - o;
    return (i << 10 | s) ^ r;
  }, hf;
}
var xf = {}, vf, Pv;
function CH() {
  if (Pv) return vf;
  Pv = 1;
  const e = Li();
  function t(r) {
    this.mode = e.NUMERIC, this.data = r.toString();
  }
  return t.getBitsLength = function(o) {
    return 10 * Math.floor(o / 3) + (o % 3 ? o % 3 * 3 + 1 : 0);
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(o) {
    let n, a, l;
    for (n = 0; n + 3 <= this.data.length; n += 3)
      a = this.data.substr(n, 3), l = parseInt(a, 10), o.put(l, 10);
    const i = this.data.length - n;
    i > 0 && (a = this.data.substr(n), l = parseInt(a, 10), o.put(l, i * 3 + 1));
  }, vf = t, vf;
}
var Sf, Mv;
function LH() {
  if (Mv) return Sf;
  Mv = 1;
  const e = Li(), t = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
  ];
  function r(o) {
    this.mode = e.ALPHANUMERIC, this.data = o;
  }
  return r.getBitsLength = function(n) {
    return 11 * Math.floor(n / 2) + 6 * (n % 2);
  }, r.prototype.getLength = function() {
    return this.data.length;
  }, r.prototype.getBitsLength = function() {
    return r.getBitsLength(this.data.length);
  }, r.prototype.write = function(n) {
    let a;
    for (a = 0; a + 2 <= this.data.length; a += 2) {
      let l = t.indexOf(this.data[a]) * 45;
      l += t.indexOf(this.data[a + 1]), n.put(l, 11);
    }
    this.data.length % 2 && n.put(t.indexOf(this.data[a]), 6);
  }, Sf = r, Sf;
}
var bf, $v;
function EH() {
  if ($v) return bf;
  $v = 1;
  const e = Li();
  function t(r) {
    this.mode = e.BYTE, typeof r == "string" ? this.data = new TextEncoder().encode(r) : this.data = new Uint8Array(r);
  }
  return t.getBitsLength = function(o) {
    return o * 8;
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(r) {
    for (let o = 0, n = this.data.length; o < n; o++)
      r.put(this.data[o], 8);
  }, bf = t, bf;
}
var yf, Cv;
function OH() {
  if (Cv) return yf;
  Cv = 1;
  const e = Li(), t = Ci();
  function r(o) {
    this.mode = e.KANJI, this.data = o;
  }
  return r.getBitsLength = function(n) {
    return n * 13;
  }, r.prototype.getLength = function() {
    return this.data.length;
  }, r.prototype.getBitsLength = function() {
    return r.getBitsLength(this.data.length);
  }, r.prototype.write = function(o) {
    let n;
    for (n = 0; n < this.data.length; n++) {
      let a = t.toSJIS(this.data[n]);
      if (a >= 33088 && a <= 40956)
        a -= 33088;
      else if (a >= 57408 && a <= 60351)
        a -= 49472;
      else
        throw new Error(
          "Invalid SJIS character: " + this.data[n] + `
Make sure your charset is UTF-8`
        );
      a = (a >>> 8 & 255) * 192 + (a & 255), o.put(a, 13);
    }
  }, yf = r, yf;
}
var wf = { exports: {} }, Lv;
function NH() {
  return Lv || (Lv = 1, (function(e) {
    var t = {
      single_source_shortest_paths: function(r, o, n) {
        var a = {}, l = {};
        l[o] = 0;
        var i = t.PriorityQueue.make();
        i.push(o, 0);
        for (var s, u, c, g, p, h, v, A, S; !i.empty(); ) {
          s = i.pop(), u = s.value, g = s.cost, p = r[u] || {};
          for (c in p)
            p.hasOwnProperty(c) && (h = p[c], v = g + h, A = l[c], S = typeof l[c] > "u", (S || A > v) && (l[c] = v, i.push(c, v), a[c] = u));
        }
        if (typeof n < "u" && typeof l[n] > "u") {
          var b = ["Could not find a path from ", o, " to ", n, "."].join("");
          throw new Error(b);
        }
        return a;
      },
      extract_shortest_path_from_predecessor_list: function(r, o) {
        for (var n = [], a = o; a; )
          n.push(a), r[a], a = r[a];
        return n.reverse(), n;
      },
      find_path: function(r, o, n) {
        var a = t.single_source_shortest_paths(r, o, n);
        return t.extract_shortest_path_from_predecessor_list(
          a,
          n
        );
      },
      /**
       * A very naive priority queue implementation.
       */
      PriorityQueue: {
        make: function(r) {
          var o = t.PriorityQueue, n = {}, a;
          r = r || {};
          for (a in o)
            o.hasOwnProperty(a) && (n[a] = o[a]);
          return n.queue = [], n.sorter = r.sorter || o.default_sorter, n;
        },
        default_sorter: function(r, o) {
          return r.cost - o.cost;
        },
        /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */
        push: function(r, o) {
          var n = { value: r, cost: o };
          this.queue.push(n), this.queue.sort(this.sorter);
        },
        /**
         * Return the highest priority element in the queue.
         */
        pop: function() {
          return this.queue.shift();
        },
        empty: function() {
          return this.queue.length === 0;
        }
      }
    };
    e.exports = t;
  })(wf)), wf.exports;
}
var Ev;
function DH() {
  return Ev || (Ev = 1, (function(e) {
    const t = Li(), r = CH(), o = LH(), n = EH(), a = OH(), l = lT(), i = Ci(), s = NH();
    function u(b) {
      return unescape(encodeURIComponent(b)).length;
    }
    function c(b, T, w) {
      const N = [];
      let O;
      for (; (O = b.exec(w)) !== null; )
        N.push({
          data: O[0],
          index: O.index,
          mode: T,
          length: O[0].length
        });
      return N;
    }
    function g(b) {
      const T = c(l.NUMERIC, t.NUMERIC, b), w = c(l.ALPHANUMERIC, t.ALPHANUMERIC, b);
      let N, O;
      return i.isKanjiModeEnabled() ? (N = c(l.BYTE, t.BYTE, b), O = c(l.KANJI, t.KANJI, b)) : (N = c(l.BYTE_KANJI, t.BYTE, b), O = []), T.concat(w, N, O).sort(function(_, X) {
        return _.index - X.index;
      }).map(function(_) {
        return {
          data: _.data,
          mode: _.mode,
          length: _.length
        };
      });
    }
    function p(b, T) {
      switch (T) {
        case t.NUMERIC:
          return r.getBitsLength(b);
        case t.ALPHANUMERIC:
          return o.getBitsLength(b);
        case t.KANJI:
          return a.getBitsLength(b);
        case t.BYTE:
          return n.getBitsLength(b);
      }
    }
    function h(b) {
      return b.reduce(function(T, w) {
        const N = T.length - 1 >= 0 ? T[T.length - 1] : null;
        return N && N.mode === w.mode ? (T[T.length - 1].data += w.data, T) : (T.push(w), T);
      }, []);
    }
    function v(b) {
      const T = [];
      for (let w = 0; w < b.length; w++) {
        const N = b[w];
        switch (N.mode) {
          case t.NUMERIC:
            T.push([
              N,
              { data: N.data, mode: t.ALPHANUMERIC, length: N.length },
              { data: N.data, mode: t.BYTE, length: N.length }
            ]);
            break;
          case t.ALPHANUMERIC:
            T.push([
              N,
              { data: N.data, mode: t.BYTE, length: N.length }
            ]);
            break;
          case t.KANJI:
            T.push([
              N,
              { data: N.data, mode: t.BYTE, length: u(N.data) }
            ]);
            break;
          case t.BYTE:
            T.push([
              { data: N.data, mode: t.BYTE, length: u(N.data) }
            ]);
        }
      }
      return T;
    }
    function A(b, T) {
      const w = {}, N = { start: {} };
      let O = ["start"];
      for (let m = 0; m < b.length; m++) {
        const _ = b[m], X = [];
        for (let $ = 0; $ < _.length; $++) {
          const E = _[$], D = "" + m + $;
          X.push(D), w[D] = { node: E, lastCount: 0 }, N[D] = {};
          for (let U = 0; U < O.length; U++) {
            const Y = O[U];
            w[Y] && w[Y].node.mode === E.mode ? (N[Y][D] = p(w[Y].lastCount + E.length, E.mode) - p(w[Y].lastCount, E.mode), w[Y].lastCount += E.length) : (w[Y] && (w[Y].lastCount = E.length), N[Y][D] = p(E.length, E.mode) + 4 + t.getCharCountIndicator(E.mode, T));
          }
        }
        O = X;
      }
      for (let m = 0; m < O.length; m++)
        N[O[m]].end = 0;
      return { map: N, table: w };
    }
    function S(b, T) {
      let w;
      const N = t.getBestModeForData(b);
      if (w = t.from(T, N), w !== t.BYTE && w.bit < N.bit)
        throw new Error('"' + b + '" cannot be encoded with mode ' + t.toString(w) + `.
 Suggested mode is: ` + t.toString(N));
      switch (w === t.KANJI && !i.isKanjiModeEnabled() && (w = t.BYTE), w) {
        case t.NUMERIC:
          return new r(b);
        case t.ALPHANUMERIC:
          return new o(b);
        case t.KANJI:
          return new a(b);
        case t.BYTE:
          return new n(b);
      }
    }
    e.fromArray = function(T) {
      return T.reduce(function(w, N) {
        return typeof N == "string" ? w.push(S(N, null)) : N.data && w.push(S(N.data, N.mode)), w;
      }, []);
    }, e.fromString = function(T, w) {
      const N = g(T, i.isKanjiModeEnabled()), O = v(N), m = A(O, w), _ = s.find_path(m.map, "start", "end"), X = [];
      for (let $ = 1; $ < _.length - 1; $++)
        X.push(m.table[_[$]].node);
      return e.fromArray(h(X));
    }, e.rawSplit = function(T) {
      return e.fromArray(
        g(T, i.isKanjiModeEnabled())
      );
    };
  })(xf)), xf;
}
var Ov;
function kH() {
  if (Ov) return of;
  Ov = 1;
  const e = Ci(), t = Ph(), r = SH(), o = bH(), n = yH(), a = wH(), l = _H(), i = nT(), s = PH(), u = MH(), c = $H(), g = Li(), p = DH();
  function h(m, _) {
    const X = m.size, $ = a.getPositions(_);
    for (let E = 0; E < $.length; E++) {
      const D = $[E][0], U = $[E][1];
      for (let Y = -1; Y <= 7; Y++)
        if (!(D + Y <= -1 || X <= D + Y))
          for (let G = -1; G <= 7; G++)
            U + G <= -1 || X <= U + G || (Y >= 0 && Y <= 6 && (G === 0 || G === 6) || G >= 0 && G <= 6 && (Y === 0 || Y === 6) || Y >= 2 && Y <= 4 && G >= 2 && G <= 4 ? m.set(D + Y, U + G, !0, !0) : m.set(D + Y, U + G, !1, !0));
    }
  }
  function v(m) {
    const _ = m.size;
    for (let X = 8; X < _ - 8; X++) {
      const $ = X % 2 === 0;
      m.set(X, 6, $, !0), m.set(6, X, $, !0);
    }
  }
  function A(m, _) {
    const X = n.getPositions(_);
    for (let $ = 0; $ < X.length; $++) {
      const E = X[$][0], D = X[$][1];
      for (let U = -2; U <= 2; U++)
        for (let Y = -2; Y <= 2; Y++)
          U === -2 || U === 2 || Y === -2 || Y === 2 || U === 0 && Y === 0 ? m.set(E + U, D + Y, !0, !0) : m.set(E + U, D + Y, !1, !0);
    }
  }
  function S(m, _) {
    const X = m.size, $ = u.getEncodedBits(_);
    let E, D, U;
    for (let Y = 0; Y < 18; Y++)
      E = Math.floor(Y / 3), D = Y % 3 + X - 8 - 3, U = ($ >> Y & 1) === 1, m.set(E, D, U, !0), m.set(D, E, U, !0);
  }
  function b(m, _, X) {
    const $ = m.size, E = c.getEncodedBits(_, X);
    let D, U;
    for (D = 0; D < 15; D++)
      U = (E >> D & 1) === 1, D < 6 ? m.set(D, 8, U, !0) : D < 8 ? m.set(D + 1, 8, U, !0) : m.set($ - 15 + D, 8, U, !0), D < 8 ? m.set(8, $ - D - 1, U, !0) : D < 9 ? m.set(8, 15 - D - 1 + 1, U, !0) : m.set(8, 15 - D - 1, U, !0);
    m.set($ - 8, 8, 1, !0);
  }
  function T(m, _) {
    const X = m.size;
    let $ = -1, E = X - 1, D = 7, U = 0;
    for (let Y = X - 1; Y > 0; Y -= 2)
      for (Y === 6 && Y--; ; ) {
        for (let G = 0; G < 2; G++)
          if (!m.isReserved(E, Y - G)) {
            let K = !1;
            U < _.length && (K = (_[U] >>> D & 1) === 1), m.set(E, Y - G, K), D--, D === -1 && (U++, D = 7);
          }
        if (E += $, E < 0 || X <= E) {
          E -= $, $ = -$;
          break;
        }
      }
  }
  function w(m, _, X) {
    const $ = new r();
    X.forEach(function(G) {
      $.put(G.mode.bit, 4), $.put(G.getLength(), g.getCharCountIndicator(G.mode, m)), G.write($);
    });
    const E = e.getSymbolTotalCodewords(m), D = i.getTotalCodewordsCount(m, _), U = (E - D) * 8;
    for ($.getLengthInBits() + 4 <= U && $.put(0, 4); $.getLengthInBits() % 8 !== 0; )
      $.putBit(0);
    const Y = (U - $.getLengthInBits()) / 8;
    for (let G = 0; G < Y; G++)
      $.put(G % 2 ? 17 : 236, 8);
    return N($, m, _);
  }
  function N(m, _, X) {
    const $ = e.getSymbolTotalCodewords(_), E = i.getTotalCodewordsCount(_, X), D = $ - E, U = i.getBlocksCount(_, X), Y = $ % U, G = U - Y, K = Math.floor($ / U), W = Math.floor(D / U), xe = W + 1, Ce = K - W, Q = new s(Ce);
    let ue = 0;
    const V = new Array(U), ae = new Array(U);
    let F = 0;
    const le = new Uint8Array(m.buffer);
    for (let ee = 0; ee < U; ee++) {
      const Se = ee < G ? W : xe;
      V[ee] = le.slice(ue, ue + Se), ae[ee] = Q.encode(V[ee]), ue += Se, F = Math.max(F, Se);
    }
    const te = new Uint8Array($);
    let ie = 0, B, I;
    for (B = 0; B < F; B++)
      for (I = 0; I < U; I++)
        B < V[I].length && (te[ie++] = V[I][B]);
    for (B = 0; B < Ce; B++)
      for (I = 0; I < U; I++)
        te[ie++] = ae[I][B];
    return te;
  }
  function O(m, _, X, $) {
    let E;
    if (Array.isArray(m))
      E = p.fromArray(m);
    else if (typeof m == "string") {
      let K = _;
      if (!K) {
        const W = p.rawSplit(m);
        K = u.getBestVersionForData(W, X);
      }
      E = p.fromString(m, K || 40);
    } else
      throw new Error("Invalid data");
    const D = u.getBestVersionForData(E, X);
    if (!D)
      throw new Error("The amount of data is too big to be stored in a QR Code");
    if (!_)
      _ = D;
    else if (_ < D)
      throw new Error(
        `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + D + `.
`
      );
    const U = w(_, X, E), Y = e.getSymbolSize(_), G = new o(Y);
    return h(G, _), v(G), A(G, _), b(G, X, 0), _ >= 7 && S(G, _), T(G, U), isNaN($) && ($ = l.getBestMask(
      G,
      b.bind(null, G, X)
    )), l.applyMask($, G), b(G, X, $), {
      modules: G,
      version: _,
      errorCorrectionLevel: X,
      maskPattern: $,
      segments: E
    };
  }
  return of.create = function(_, X) {
    if (typeof _ > "u" || _ === "")
      throw new Error("No input text");
    let $ = t.M, E, D;
    return typeof X < "u" && ($ = t.from(X.errorCorrectionLevel, t.M), E = u.from(X.version), D = l.from(X.maskPattern), X.toSJISFunc && e.setToSJISFunction(X.toSJISFunc)), O(_, E, $, D);
  }, of;
}
var _f = {}, Tf = {}, Nv;
function iT() {
  return Nv || (Nv = 1, (function(e) {
    function t(r) {
      if (typeof r == "number" && (r = r.toString()), typeof r != "string")
        throw new Error("Color should be defined as hex string");
      let o = r.slice().replace("#", "").split("");
      if (o.length < 3 || o.length === 5 || o.length > 8)
        throw new Error("Invalid hex color: " + r);
      (o.length === 3 || o.length === 4) && (o = Array.prototype.concat.apply([], o.map(function(a) {
        return [a, a];
      }))), o.length === 6 && o.push("F", "F");
      const n = parseInt(o.join(""), 16);
      return {
        r: n >> 24 & 255,
        g: n >> 16 & 255,
        b: n >> 8 & 255,
        a: n & 255,
        hex: "#" + o.slice(0, 6).join("")
      };
    }
    e.getOptions = function(o) {
      o || (o = {}), o.color || (o.color = {});
      const n = typeof o.margin > "u" || o.margin === null || o.margin < 0 ? 4 : o.margin, a = o.width && o.width >= 21 ? o.width : void 0, l = o.scale || 4;
      return {
        width: a,
        scale: a ? 4 : l,
        margin: n,
        color: {
          dark: t(o.color.dark || "#000000ff"),
          light: t(o.color.light || "#ffffffff")
        },
        type: o.type,
        rendererOpts: o.rendererOpts || {}
      };
    }, e.getScale = function(o, n) {
      return n.width && n.width >= o + n.margin * 2 ? n.width / (o + n.margin * 2) : n.scale;
    }, e.getImageWidth = function(o, n) {
      const a = e.getScale(o, n);
      return Math.floor((o + n.margin * 2) * a);
    }, e.qrToImageData = function(o, n, a) {
      const l = n.modules.size, i = n.modules.data, s = e.getScale(l, a), u = Math.floor((l + a.margin * 2) * s), c = a.margin * s, g = [a.color.light, a.color.dark];
      for (let p = 0; p < u; p++)
        for (let h = 0; h < u; h++) {
          let v = (p * u + h) * 4, A = a.color.light;
          if (p >= c && h >= c && p < u - c && h < u - c) {
            const S = Math.floor((p - c) / s), b = Math.floor((h - c) / s);
            A = g[i[S * l + b] ? 1 : 0];
          }
          o[v++] = A.r, o[v++] = A.g, o[v++] = A.b, o[v] = A.a;
        }
    };
  })(Tf)), Tf;
}
var Dv;
function GH() {
  return Dv || (Dv = 1, (function(e) {
    const t = iT();
    function r(n, a, l) {
      n.clearRect(0, 0, a.width, a.height), a.style || (a.style = {}), a.height = l, a.width = l, a.style.height = l + "px", a.style.width = l + "px";
    }
    function o() {
      try {
        return document.createElement("canvas");
      } catch {
        throw new Error("You need to specify a canvas element");
      }
    }
    e.render = function(a, l, i) {
      let s = i, u = l;
      typeof s > "u" && (!l || !l.getContext) && (s = l, l = void 0), l || (u = o()), s = t.getOptions(s);
      const c = t.getImageWidth(a.modules.size, s), g = u.getContext("2d"), p = g.createImageData(c, c);
      return t.qrToImageData(p.data, a, s), r(g, u, c), g.putImageData(p, 0, 0), u;
    }, e.renderToDataURL = function(a, l, i) {
      let s = i;
      typeof s > "u" && (!l || !l.getContext) && (s = l, l = void 0), s || (s = {});
      const u = e.render(a, l, s), c = s.type || "image/png", g = s.rendererOpts || {};
      return u.toDataURL(c, g.quality);
    };
  })(_f)), _f;
}
var Af = {}, kv;
function BH() {
  if (kv) return Af;
  kv = 1;
  const e = iT();
  function t(n, a) {
    const l = n.a / 255, i = a + '="' + n.hex + '"';
    return l < 1 ? i + " " + a + '-opacity="' + l.toFixed(2).slice(1) + '"' : i;
  }
  function r(n, a, l) {
    let i = n + a;
    return typeof l < "u" && (i += " " + l), i;
  }
  function o(n, a, l) {
    let i = "", s = 0, u = !1, c = 0;
    for (let g = 0; g < n.length; g++) {
      const p = Math.floor(g % a), h = Math.floor(g / a);
      !p && !u && (u = !0), n[g] ? (c++, g > 0 && p > 0 && n[g - 1] || (i += u ? r("M", p + l, 0.5 + h + l) : r("m", s, 0), s = 0, u = !1), p + 1 < a && n[g + 1] || (i += r("h", c), c = 0)) : s++;
    }
    return i;
  }
  return Af.render = function(a, l, i) {
    const s = e.getOptions(l), u = a.modules.size, c = a.modules.data, g = u + s.margin * 2, p = s.color.light.a ? "<path " + t(s.color.light, "fill") + ' d="M0 0h' + g + "v" + g + 'H0z"/>' : "", h = "<path " + t(s.color.dark, "stroke") + ' d="' + o(c, u, s.margin) + '"/>', v = 'viewBox="0 0 ' + g + " " + g + '"', S = '<svg xmlns="http://www.w3.org/2000/svg" ' + (s.width ? 'width="' + s.width + '" height="' + s.width + '" ' : "") + v + ' shape-rendering="crispEdges">' + p + h + `</svg>
`;
    return typeof i == "function" && i(null, S), S;
  }, Af;
}
var Gv;
function IH() {
  if (Gv) return qi;
  Gv = 1;
  const e = vH(), t = kH(), r = GH(), o = BH();
  function n(a, l, i, s, u) {
    const c = [].slice.call(arguments, 1), g = c.length, p = typeof c[g - 1] == "function";
    if (!p && !e())
      throw new Error("Callback required as last argument");
    if (p) {
      if (g < 2)
        throw new Error("Too few arguments provided");
      g === 2 ? (u = i, i = l, l = s = void 0) : g === 3 && (l.getContext && typeof u > "u" ? (u = s, s = void 0) : (u = s, s = i, i = l, l = void 0));
    } else {
      if (g < 1)
        throw new Error("Too few arguments provided");
      return g === 1 ? (i = l, l = s = void 0) : g === 2 && !l.getContext && (s = i, i = l, l = void 0), new Promise(function(h, v) {
        try {
          const A = t.create(i, s);
          h(a(A, l, s));
        } catch (A) {
          v(A);
        }
      });
    }
    try {
      const h = t.create(i, s);
      u(null, a(h, l, s));
    } catch (h) {
      u(h);
    }
  }
  return qi.create = t.create, qi.toCanvas = n.bind(null, r.render), qi.toDataURL = n.bind(null, r.renderToDataURL), qi.toString = n.bind(null, function(a, l, i) {
    return o.render(a, i);
  }), qi;
}
var RH = IH();
const FH = /* @__PURE__ */ Ah(RH);
function VH(e, t) {
  const r = g4(e), o = $p("");
  return nt(
    r,
    async (n) => {
      r.value && z0 && (o.value = await FH.toDataURL(n, t));
    },
    { immediate: !0 }
  ), o;
}
const HH = (e, t = !0) => e() === t ? Promise.resolve() : new Promise((r) => {
  const o = nt(
    e,
    (n) => {
      n === t && (o(), r());
    },
    { immediate: !0 }
  );
}), UH = (e, t = 300) => new Promise((r) => {
  let o;
  const n = nt(
    e,
    () => {
      clearTimeout(o), o = setTimeout(() => {
        n(), r();
      }, t);
    },
    { immediate: !0 }
  );
}), Mh = async () => new Promise((e) => {
  const t = setInterval(() => {
    ro.isVisible() || (clearInterval(t), e());
  }, 100);
}), G0e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  waitForBool: HH,
  waitForSwalClose: Mh,
  waitForVarToStabilize: UH
}, Symbol.toStringTag, { value: "Module" })), Hm = async (e, t) => {
  ro.isVisible() && await Mh();
  const r = await ro.fire({
    title: `<h5 class="fw-normal">${e.app.getText("one_time_password_enter")}</h5>`,
    input: "password",
    inputLabel: e.app.getText("one_time_password"),
    inputPlaceholder: "",
    inputAttributes: {
      maxlength: "6",
      autocapitalize: "off",
      autocorrect: "off",
      required: "true"
    },
    allowEnterKey: !0,
    allowOutsideClick: !1,
    showDenyButton: !!t,
    confirmButtonText: e.app.getText("submit"),
    denyButtonText: e.app.getText("signout"),
    customClass: {
      container: "form-group",
      title: "loginSwalTitle",
      inputLabel: "loginSwalInputLabel",
      input: "form-control w-auto",
      confirmButton: "btn ripple btn-main-primary",
      denyButton: "btn ripple btn-white"
    }
  });
  return r.isDenied && t && (t(e.user.getType()), e.user.setLoggedIn(!1)), r.isConfirmed ? r.value : "";
}, $h = async (e, t, r, o) => {
  const n = {
    action: r("check"),
    method: "post",
    stores: { user: e.user, action: e.action }
  };
  try {
    const a = await o(t, n);
    if (!a)
      return hc("error", e.app.getText("errors.server_unavailable")), {};
    if (a.status && a.data)
      return a.data;
    const l = a.http_status === 403 ? a.error : a.message;
    return hc("error", l || e.app.getText("errors.unexpected_error")), {};
  } catch (a) {
    return console.error("Request get2FaRequired failed", a), hc("error", e.app.getText("errors.request_failed")), {};
  }
}, XH = async (e, t) => {
  if (!t || t === "undefined")
    return;
  const r = await VH(t), n = $o(e.user) ? 180 : 200;
  ro.fire({
    title: e.app.getText("important"),
    text: e.app.getText("2FA_qr_notice"),
    imageUrl: r.value,
    imageWidth: n,
    imageHeight: n,
    imageAlt: "2FA QR",
    confirmButtonText: e.app.getText("done"),
    focusConfirm: !0,
    customClass: {
      title: "qrSwalTitle",
      htmlContainer: "qrSwalContainer",
      image: "qrSwalImg",
      confirmButton: "btn ripple btn-main-primary"
    }
  });
}, WH = async (e, t, r) => {
  const o = await Hm(e), n = {
    action: t("verify"),
    method: "post",
    stores: { user: e.user, action: e.action }
  };
  return !!(await r({ one_time_password: o, no_expires: !0 }, n)).status;
}, B0e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get2FaOTP: Hm,
  get2FaRequired: $h,
  show2FaQR: XH,
  verifyOTP: WH
}, Symbol.toStringTag, { value: "Module" }));
let Pf = !1;
const YH = async (e, t) => {
  const r = Yn("checkAppVersion");
  if (!r) {
    console.warn('[useAppVersionCheck] Missing "checkAppVersion" injection.');
    return;
  }
  const o = Ee(!1), n = async () => {
    if (!o.value) {
      o.value = !0;
      try {
        if ((await r(t)).isNew)
          KH(e);
        else if (ro.isVisible()) {
          const l = ro.getPopup();
          if (l) {
            const i = l.querySelector("label.loginSwalInputLabel");
            i && i.innerText === e.app.getText("one_time_password") || ro.close();
          }
        }
      } catch (a) {
        console.error("[useAppVersionCheck] Version check failed:", a);
      } finally {
        o.value = !1;
      }
    }
  };
  or(() => {
    Pf || (window.addEventListener("focus", n), Pf = !0);
  }), tn(() => {
    window.removeEventListener("focus", n), Pf = !1;
  });
}, KH = (e) => {
  ro.fire({
    toast: !0,
    position: "top-end",
    icon: "info",
    title: `🔄 ${e.app.getText("new_version_available")}`,
    showConfirmButton: !0,
    confirmButtonText: e.app.getText("refresh_now"),
    // timer: 3000,
    // timerProgressBar: true,
    customClass: {
      popup: "version-update",
      confirmButton: "btn ripple btn-main-primary"
    },
    didOpen: (t) => {
      t.addEventListener("mouseenter", ro.stopTimer), t.addEventListener("mouseleave", ro.resumeTimer);
    }
  }).then((t) => {
    t.isConfirmed && window.location.reload();
  });
}, I0e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  appVersionCheck: YH
}, Symbol.toStringTag, { value: "Module" })), R0e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), F0e = () => {
  const e = Yn("onDirectRequest"), t = "two_factor_channel", r = /* @__PURE__ */ new Set(["0", "1", "2"]);
  let o = null, n;
  const a = dt({}), l = dt({
    cookies: {},
    router: {},
    fLogout: () => {
    },
    fGet2FaUrl: () => {
    },
    fGetCookieName: () => {
    }
  }), i = Ee(!1), s = Ee(!1), u = Ee(null);
  or(() => {
    typeof window < "u" && "BroadcastChannel" in window && (o = new BroadcastChannel(t), o.addEventListener("message", v)), T();
  }), tn(() => {
    O(), o && (o.removeEventListener("message", v), o.close(), o = null);
  });
  const c = async (E, D) => {
    Object.assign(a, E), l.cookies = "cookies" in D ? D.cookies : {}, l.router = "router" in D ? D.router : {}, l.fLogout = "onLogout" in D ? D.onLogout : () => {
    }, l.fGet2FaUrl = "get2FaUrl" in D ? D.get2FaUrl : () => {
    }, l.fGetCookieName = "getCookieName" in D ? D.getCookieName : () => {
    };
  }, g = () => typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).substring(2)}`, p = () => {
    const E = a.user.getType();
    return {
      cdt: l.fGetCookieName(E),
      challengeId: l.fGetCookieName(E, { cType: "fa_challenge_id" }),
      expires: l.fGetCookieName(E, { cType: "fa_expires" }),
      status: l.fGetCookieName(E, { cType: "fa_status" })
    };
  }, h = () => {
    const { challengeId: E, expires: D, status: U } = p();
    return {
      status: l.cookies?.get(U),
      expiresAt: l.cookies?.get(D),
      challengeId: l.cookies?.get(E)
    };
  }, v = (E) => {
    if (A(E.data))
      S(E.data);
    else {
      const { cdt: D } = p();
      l.cookies?.isKey(D) || window.location.reload();
    }
  }, A = (E) => {
    if (typeof E != "object" || E === null)
      return !1;
    const D = E;
    return !(!r.has(D.status) || D.expiresAt !== void 0 && typeof D.expiresAt != "string" || D.challengeId !== void 0 && typeof D.challengeId != "string");
  }, S = (E) => {
    if (!E) return;
    const D = u.value?.challengeId, U = E.challengeId;
    D && U && D !== U && E.status !== "2" || (u.value = E, E.status === "2" ? i.value = !0 : E.status === "1" ? i.value && (i.value = !1, xy()) : E.status === "0" && (i.value || (i.value = !0, $())));
  }, b = () => {
    o?.postMessage({});
  }, T = () => {
    const E = h();
    if (E.expiresAt)
      try {
        if (!A(E)) {
          console.error("Invalid 2fa states");
          return;
        }
        if (E.status === "2" && !Ve(E.expiresAt).isAfter(Ve())) {
          w({ ...E, status: "0" });
          return;
        }
      } catch (D) {
        console.error("loadState error", D);
      }
  }, w = (E) => {
    o?.postMessage(E), S(E);
  }, N = (E) => {
    if (s.value) return;
    const D = h(), U = D.challengeId ?? g();
    D.challengeId || l.cookies?.set(E, U), w({
      status: D.status,
      expiresAt: D.expiresAt,
      challengeId: U
    });
  }, O = () => {
    m();
    const { expires: E, status: D } = p();
    l.cookies?.remove(E), l.cookies?.remove(D), i.value = !1, s.value = !1, u.value = null;
  }, m = () => {
    n !== void 0 && (clearTimeout(n), n = void 0);
  }, _ = () => {
    w({
      status: "0",
      challengeId: u.value?.challengeId
    });
  }, X = () => {
    w({
      status: "1",
      challengeId: u.value?.challengeId
    });
  }, $ = async (E) => {
    const D = a.user.getType(), U = { app: a.app, user: a.user, action: a.action }, { expires: Y, status: G } = p(), K = await $h(
      U,
      { username: a.user.getInfoByKey("username") },
      l.fGet2FaUrl,
      e
    );
    if (!En(K) && !K["2FAToken"]) {
      l.cookies?.isKey(Y) && l.cookies?.remove(Y);
      return;
    }
    l.cookies?.set(G, 0);
    const W = await Hm(U, l.fLogout);
    if (W) {
      const xe = {
        action: l.fGet2FaUrl("verify"),
        method: "post",
        stores: U
      }, Ce = await e({ one_time_password: W }, xe);
      if (Ce.status)
        l.cookies?.set(G, 1), E?.isReload ? (l.cookies?.set(Y, Ce.data.expires_at), location.reload()) : (a.user.setExpires(Ce.data.expires_at), a.action.setComponentAction("active-2fa", !0));
      else {
        const Q = Ce.status === "undefined" || Ce.status === void 0;
        if (Q || Q && Ce.message.toLowerCase().includes("unauthenticated")) {
          l.fLogout(D);
          return;
        }
        $(E);
      }
    }
  };
  return nt(
    () => a.action?.getComponentAction("active-2fa"),
    (E) => {
      if (!E) return;
      const { cdt: D, challengeId: U, expires: Y, status: G } = p();
      a.user?.getExpires() && (l.cookies?.set(Y, a.user.getExpires()), a.user.setExpires("")), m();
      const K = l.cookies?.get(Y), W = Ve(K).diff(Ve());
      console.debug("expires_at", W, K), Number.isNaN(W) && l.cookies?.remove(Y), W > 0 && (n = setTimeout(() => {
        n = void 0, l.cookies?.isKey(D) ? (l.cookies?.set(G, "0"), _()) : a.user.setLoggedIn(!1);
      }, W), l.cookies?.set(G, "1"), s.value ? X() : (N(U), s.value = !0)), a.action.setComponentAction("active-2fa", !1);
    },
    { deep: !0 }
  ), nt(
    () => a.action?.getComponentAction("deactive-2fa"),
    (E) => {
      E && (O(), a.action.setComponentAction("deactive-2fa", !1));
    },
    { deep: !0 }
  ), nt(
    () => a.action?.getComponentAction("prompt-2fa"),
    (E) => {
      E && ($({ isReload: !0 }), a.action.setComponentAction("prompt-2fa", !1));
    },
    { deep: !0 }
  ), nt(
    () => a.action?.getComponentAction("force-logout"),
    (E) => {
      if (!E) return;
      O();
      const D = l.fGetCookieName(a.user.getType(), { isAll: !0 });
      hy(l.cookies, D), a.action.setComponentAction("force-logout", !1), l.router.push("login"), a.app.toggleLoader(!1), b();
    },
    { deep: !0 }
  ), {
    init2FaAuth: c,
    onPromptOTP: $
  };
}, QH = () => {
  const e = dt({}), t = dt({
    fGetModulePermission: () => {
    }
  }), r = dt({
    bDefault: !0,
    dLoadingT: 300
  });
  Nn(() => {
    e.app.setLoading(!0);
  }), or(() => {
    r.bDefault && setTimeout(() => {
      e.app.setLoading(!1);
    }, r.dLoadingT);
  });
  const o = async (h, v) => {
    Object.assign(e, h), t.fGetModulePermission = v?.getModulePermission ?? (() => {
    });
  }, n = (h) => {
    r.dLoadingT = h;
  }, a = (h) => {
    r.bDefault = h;
  }, l = () => {
    setTimeout(() => {
      e.app.setLoading(!1);
    }, r.dLoadingT);
  }, i = ge(() => t.fGetModulePermission("create", "mxFormWrapper")), s = ge(() => t.fGetModulePermission("edit", "mxFormWrapper")), u = ge(() => e.app.getLoading()), c = ge(() => e.user.getInfoByKey("is_master_account") ?? !1), g = ge(() => e.user.getInfoByKey("is_owner") ?? !1), p = ge(() => e.user.getInfoByKey("is_superadmin") ?? !1);
  return {
    mxFormWrapperState: r,
    initFormWrapper: o,
    setDLoadingT: n,
    setFormLoaded: l,
    setIsDefault: a,
    isCreateAble: i,
    isEditAble: s,
    isLoading: u,
    isMasterAccount: c,
    isOwner: g,
    isSuperAdmin: p
  };
};
function sT(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: jH } = Object.prototype, { getPrototypeOf: Ch } = Object, { iterator: Um, toStringTag: dT } = Symbol, Xm = /* @__PURE__ */ ((e) => (t) => {
  const r = jH.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Jn = (e) => (e = e.toLowerCase(), (t) => Xm(t) === e), Wm = (e) => (t) => typeof t === e, { isArray: fd } = Array, zs = Wm("undefined");
function Au(e) {
  return e !== null && !zs(e) && e.constructor !== null && !zs(e.constructor) && qo(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const uT = Jn("ArrayBuffer");
function ZH(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && uT(e.buffer), t;
}
const zH = Wm("string"), qo = Wm("function"), cT = Wm("number"), Pu = (e) => e !== null && typeof e == "object", qH = (e) => e === !0 || e === !1, bc = (e) => {
  if (Xm(e) !== "object")
    return !1;
  const t = Ch(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(dT in e) && !(Um in e);
}, JH = (e) => {
  if (!Pu(e) || Au(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, eU = Jn("Date"), tU = Jn("File"), rU = (e) => !!(e && typeof e.uri < "u"), oU = (e) => e && typeof e.getParts < "u", nU = Jn("Blob"), aU = Jn("FileList"), lU = (e) => Pu(e) && qo(e.pipe);
function iU() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Bv = iU(), Iv = typeof Bv.FormData < "u" ? Bv.FormData : void 0, sU = (e) => {
  let t;
  return e && (Iv && e instanceof Iv || qo(e.append) && ((t = Xm(e)) === "formdata" || // detect form-data instance
  t === "object" && qo(e.toString) && e.toString() === "[object FormData]"));
}, dU = Jn("URLSearchParams"), [uU, cU, mU, gU] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Jn), fU = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Mu(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, n;
  if (typeof e != "object" && (e = [e]), fd(e))
    for (o = 0, n = e.length; o < n; o++)
      t.call(null, e[o], o, e);
  else {
    if (Au(e))
      return;
    const a = r ? Object.getOwnPropertyNames(e) : Object.keys(e), l = a.length;
    let i;
    for (o = 0; o < l; o++)
      i = a[o], t.call(null, e[i], i, e);
  }
}
function mT(e, t) {
  if (Au(e))
    return null;
  t = t.toLowerCase();
  const r = Object.keys(e);
  let o = r.length, n;
  for (; o-- > 0; )
    if (n = r[o], t === n.toLowerCase())
      return n;
  return null;
}
const ti = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, gT = (e) => !zs(e) && e !== ti;
function Sp() {
  const { caseless: e, skipUndefined: t } = gT(this) && this || {}, r = {}, o = (n, a) => {
    if (a === "__proto__" || a === "constructor" || a === "prototype")
      return;
    const l = e && mT(r, a) || a;
    bc(r[l]) && bc(n) ? r[l] = Sp(r[l], n) : bc(n) ? r[l] = Sp({}, n) : fd(n) ? r[l] = n.slice() : (!t || !zs(n)) && (r[l] = n);
  };
  for (let n = 0, a = arguments.length; n < a; n++)
    arguments[n] && Mu(arguments[n], o);
  return r;
}
const pU = (e, t, r, { allOwnKeys: o } = {}) => (Mu(
  t,
  (n, a) => {
    r && qo(n) ? Object.defineProperty(e, a, {
      value: sT(n, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, a, {
      value: n,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: o }
), e), hU = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), xU = (e, t, r, o) => {
  e.prototype = Object.create(t.prototype, o), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, vU = (e, t, r, o) => {
  let n, a, l;
  const i = {};
  if (t = t || {}, e == null) return t;
  do {
    for (n = Object.getOwnPropertyNames(e), a = n.length; a-- > 0; )
      l = n[a], (!o || o(l, e, t)) && !i[l] && (t[l] = e[l], i[l] = !0);
    e = r !== !1 && Ch(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, SU = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const o = e.indexOf(t, r);
  return o !== -1 && o === r;
}, bU = (e) => {
  if (!e) return null;
  if (fd(e)) return e;
  let t = e.length;
  if (!cT(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, yU = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Ch(Uint8Array)), wU = (e, t) => {
  const o = (e && e[Um]).call(e);
  let n;
  for (; (n = o.next()) && !n.done; ) {
    const a = n.value;
    t.call(e, a[0], a[1]);
  }
}, _U = (e, t) => {
  let r;
  const o = [];
  for (; (r = e.exec(t)) !== null; )
    o.push(r);
  return o;
}, TU = Jn("HTMLFormElement"), AU = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, o, n) {
  return o.toUpperCase() + n;
}), Rv = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), PU = Jn("RegExp"), fT = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), o = {};
  Mu(r, (n, a) => {
    let l;
    (l = t(n, a, e)) !== !1 && (o[a] = l || n);
  }), Object.defineProperties(e, o);
}, MU = (e) => {
  fT(e, (t, r) => {
    if (qo(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const o = e[r];
    if (qo(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, $U = (e, t) => {
  const r = {}, o = (n) => {
    n.forEach((a) => {
      r[a] = !0;
    });
  };
  return fd(e) ? o(e) : o(String(e).split(t)), r;
}, CU = () => {
}, LU = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function EU(e) {
  return !!(e && qo(e.append) && e[dT] === "FormData" && e[Um]);
}
const OU = (e) => {
  const t = new Array(10), r = (o, n) => {
    if (Pu(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (Au(o))
        return o;
      if (!("toJSON" in o)) {
        t[n] = o;
        const a = fd(o) ? [] : {};
        return Mu(o, (l, i) => {
          const s = r(l, n + 1);
          !zs(s) && (a[i] = s);
        }), t[n] = void 0, a;
      }
    }
    return o;
  };
  return r(e, 0);
}, NU = Jn("AsyncFunction"), DU = (e) => e && (Pu(e) || qo(e)) && qo(e.then) && qo(e.catch), pT = ((e, t) => e ? setImmediate : t ? ((r, o) => (ti.addEventListener(
  "message",
  ({ source: n, data: a }) => {
    n === ti && a === r && o.length && o.shift()();
  },
  !1
), (n) => {
  o.push(n), ti.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", qo(ti.postMessage)), kU = typeof queueMicrotask < "u" ? queueMicrotask.bind(ti) : typeof process < "u" && process.nextTick || pT, GU = (e) => e != null && qo(e[Um]), we = {
  isArray: fd,
  isArrayBuffer: uT,
  isBuffer: Au,
  isFormData: sU,
  isArrayBufferView: ZH,
  isString: zH,
  isNumber: cT,
  isBoolean: qH,
  isObject: Pu,
  isPlainObject: bc,
  isEmptyObject: JH,
  isReadableStream: uU,
  isRequest: cU,
  isResponse: mU,
  isHeaders: gU,
  isUndefined: zs,
  isDate: eU,
  isFile: tU,
  isReactNativeBlob: rU,
  isReactNative: oU,
  isBlob: nU,
  isRegExp: PU,
  isFunction: qo,
  isStream: lU,
  isURLSearchParams: dU,
  isTypedArray: yU,
  isFileList: aU,
  forEach: Mu,
  merge: Sp,
  extend: pU,
  trim: fU,
  stripBOM: hU,
  inherits: xU,
  toFlatObject: vU,
  kindOf: Xm,
  kindOfTest: Jn,
  endsWith: SU,
  toArray: bU,
  forEachEntry: wU,
  matchAll: _U,
  isHTMLForm: TU,
  hasOwnProperty: Rv,
  hasOwnProp: Rv,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: fT,
  freezeMethods: MU,
  toObjectSet: $U,
  toCamelCase: AU,
  noop: CU,
  toFiniteNumber: LU,
  findKey: mT,
  global: ti,
  isContextDefined: gT,
  isSpecCompliantForm: EU,
  toJSONObject: OU,
  isAsyncFn: NU,
  isThenable: DU,
  setImmediate: pT,
  asap: kU,
  isIterable: GU
};
let Tt = class hT extends Error {
  static from(t, r, o, n, a, l) {
    const i = new hT(t.message, r || t.code, o, n, a);
    return i.cause = t, i.name = t.name, t.status != null && i.status == null && (i.status = t.status), l && Object.assign(i, l), i;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(t, r, o, n, a) {
    super(t), Object.defineProperty(this, "message", {
      value: t,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), o && (this.config = o), n && (this.request = n), a && (this.response = a, this.status = a.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: we.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
Tt.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
Tt.ERR_BAD_OPTION = "ERR_BAD_OPTION";
Tt.ECONNABORTED = "ECONNABORTED";
Tt.ETIMEDOUT = "ETIMEDOUT";
Tt.ERR_NETWORK = "ERR_NETWORK";
Tt.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
Tt.ERR_DEPRECATED = "ERR_DEPRECATED";
Tt.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
Tt.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
Tt.ERR_CANCELED = "ERR_CANCELED";
Tt.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
Tt.ERR_INVALID_URL = "ERR_INVALID_URL";
const BU = null;
function bp(e) {
  return we.isPlainObject(e) || we.isArray(e);
}
function xT(e) {
  return we.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Mf(e, t, r) {
  return e ? e.concat(t).map(function(n, a) {
    return n = xT(n), !r && a ? "[" + n + "]" : n;
  }).join(r ? "." : "") : t;
}
function IU(e) {
  return we.isArray(e) && !e.some(bp);
}
const RU = we.toFlatObject(we, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Ym(e, t, r) {
  if (!we.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = we.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(A, S) {
      return !we.isUndefined(S[A]);
    }
  );
  const o = r.metaTokens, n = r.visitor || c, a = r.dots, l = r.indexes, s = (r.Blob || typeof Blob < "u" && Blob) && we.isSpecCompliantForm(t);
  if (!we.isFunction(n))
    throw new TypeError("visitor must be a function");
  function u(v) {
    if (v === null) return "";
    if (we.isDate(v))
      return v.toISOString();
    if (we.isBoolean(v))
      return v.toString();
    if (!s && we.isBlob(v))
      throw new Tt("Blob is not supported. Use a Buffer instead.");
    return we.isArrayBuffer(v) || we.isTypedArray(v) ? s && typeof Blob == "function" ? new Blob([v]) : Buffer.from(v) : v;
  }
  function c(v, A, S) {
    let b = v;
    if (we.isReactNative(t) && we.isReactNativeBlob(v))
      return t.append(Mf(S, A, a), u(v)), !1;
    if (v && !S && typeof v == "object") {
      if (we.endsWith(A, "{}"))
        A = o ? A : A.slice(0, -2), v = JSON.stringify(v);
      else if (we.isArray(v) && IU(v) || (we.isFileList(v) || we.endsWith(A, "[]")) && (b = we.toArray(v)))
        return A = xT(A), b.forEach(function(w, N) {
          !(we.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            l === !0 ? Mf([A], N, a) : l === null ? A : A + "[]",
            u(w)
          );
        }), !1;
    }
    return bp(v) ? !0 : (t.append(Mf(S, A, a), u(v)), !1);
  }
  const g = [], p = Object.assign(RU, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: bp
  });
  function h(v, A) {
    if (!we.isUndefined(v)) {
      if (g.indexOf(v) !== -1)
        throw Error("Circular reference detected in " + A.join("."));
      g.push(v), we.forEach(v, function(b, T) {
        (!(we.isUndefined(b) || b === null) && n.call(t, b, we.isString(T) ? T.trim() : T, A, p)) === !0 && h(b, A ? A.concat(T) : [T]);
      }), g.pop();
    }
  }
  if (!we.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function Fv(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(o) {
    return t[o];
  });
}
function Lh(e, t) {
  this._pairs = [], e && Ym(e, this, t);
}
const vT = Lh.prototype;
vT.append = function(t, r) {
  this._pairs.push([t, r]);
};
vT.toString = function(t) {
  const r = t ? function(o) {
    return t.call(this, o, Fv);
  } : Fv;
  return this._pairs.map(function(n) {
    return r(n[0]) + "=" + r(n[1]);
  }, "").join("&");
};
function FU(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function ST(e, t, r) {
  if (!t)
    return e;
  const o = r && r.encode || FU, n = we.isFunction(r) ? {
    serialize: r
  } : r, a = n && n.serialize;
  let l;
  if (a ? l = a(t, n) : l = we.isURLSearchParams(t) ? t.toString() : new Lh(t, n).toString(o), l) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + l;
  }
  return e;
}
class Vv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    we.forEach(this.handlers, function(o) {
      o !== null && t(o);
    });
  }
}
const Eh = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, VU = typeof URLSearchParams < "u" ? URLSearchParams : Lh, HU = typeof FormData < "u" ? FormData : null, UU = typeof Blob < "u" ? Blob : null, XU = {
  isBrowser: !0,
  classes: {
    URLSearchParams: VU,
    FormData: HU,
    Blob: UU
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Oh = typeof window < "u" && typeof document < "u", yp = typeof navigator == "object" && navigator || void 0, WU = Oh && (!yp || ["ReactNative", "NativeScript", "NS"].indexOf(yp.product) < 0), YU = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", KU = Oh && window.location.href || "http://localhost", QU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Oh,
  hasStandardBrowserEnv: WU,
  hasStandardBrowserWebWorkerEnv: YU,
  navigator: yp,
  origin: KU
}, Symbol.toStringTag, { value: "Module" })), Co = {
  ...QU,
  ...XU
};
function jU(e, t) {
  return Ym(e, new Co.classes.URLSearchParams(), {
    visitor: function(r, o, n, a) {
      return Co.isNode && we.isBuffer(r) ? (this.append(o, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function ZU(e) {
  return we.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function zU(e) {
  const t = {}, r = Object.keys(e);
  let o;
  const n = r.length;
  let a;
  for (o = 0; o < n; o++)
    a = r[o], t[a] = e[a];
  return t;
}
function bT(e) {
  function t(r, o, n, a) {
    let l = r[a++];
    if (l === "__proto__") return !0;
    const i = Number.isFinite(+l), s = a >= r.length;
    return l = !l && we.isArray(n) ? n.length : l, s ? (we.hasOwnProp(n, l) ? n[l] = [n[l], o] : n[l] = o, !i) : ((!n[l] || !we.isObject(n[l])) && (n[l] = []), t(r, o, n[l], a) && we.isArray(n[l]) && (n[l] = zU(n[l])), !i);
  }
  if (we.isFormData(e) && we.isFunction(e.entries)) {
    const r = {};
    return we.forEachEntry(e, (o, n) => {
      t(ZU(o), n, r, 0);
    }), r;
  }
  return null;
}
function qU(e, t, r) {
  if (we.isString(e))
    try {
      return (t || JSON.parse)(e), we.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (r || JSON.stringify)(e);
}
const $u = {
  transitional: Eh,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(t, r) {
      const o = r.getContentType() || "", n = o.indexOf("application/json") > -1, a = we.isObject(t);
      if (a && we.isHTMLForm(t) && (t = new FormData(t)), we.isFormData(t))
        return n ? JSON.stringify(bT(t)) : t;
      if (we.isArrayBuffer(t) || we.isBuffer(t) || we.isStream(t) || we.isFile(t) || we.isBlob(t) || we.isReadableStream(t))
        return t;
      if (we.isArrayBufferView(t))
        return t.buffer;
      if (we.isURLSearchParams(t))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
      let i;
      if (a) {
        if (o.indexOf("application/x-www-form-urlencoded") > -1)
          return jU(t, this.formSerializer).toString();
        if ((i = we.isFileList(t)) || o.indexOf("multipart/form-data") > -1) {
          const s = this.env && this.env.FormData;
          return Ym(
            i ? { "files[]": t } : t,
            s && new s(),
            this.formSerializer
          );
        }
      }
      return a || n ? (r.setContentType("application/json", !1), qU(t)) : t;
    }
  ],
  transformResponse: [
    function(t) {
      const r = this.transitional || $u.transitional, o = r && r.forcedJSONParsing, n = this.responseType === "json";
      if (we.isResponse(t) || we.isReadableStream(t))
        return t;
      if (t && we.isString(t) && (o && !this.responseType || n)) {
        const l = !(r && r.silentJSONParsing) && n;
        try {
          return JSON.parse(t, this.parseReviver);
        } catch (i) {
          if (l)
            throw i.name === "SyntaxError" ? Tt.from(i, Tt.ERR_BAD_RESPONSE, this, null, this.response) : i;
        }
      }
      return t;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Co.classes.FormData,
    Blob: Co.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
we.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  $u.headers[e] = {};
});
const JU = we.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), eX = (e) => {
  const t = {};
  let r, o, n;
  return e && e.split(`
`).forEach(function(l) {
    n = l.indexOf(":"), r = l.substring(0, n).trim().toLowerCase(), o = l.substring(n + 1).trim(), !(!r || t[r] && JU[r]) && (r === "set-cookie" ? t[r] ? t[r].push(o) : t[r] = [o] : t[r] = t[r] ? t[r] + ", " + o : o);
  }), t;
}, Hv = /* @__PURE__ */ Symbol("internals");
function Dd(e) {
  return e && String(e).trim().toLowerCase();
}
function yc(e) {
  return e === !1 || e == null ? e : we.isArray(e) ? e.map(yc) : String(e).replace(/[\r\n]+$/, "");
}
function tX(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = r.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const rX = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function $f(e, t, r, o, n) {
  if (we.isFunction(o))
    return o.call(this, t, r);
  if (n && (t = r), !!we.isString(t)) {
    if (we.isString(o))
      return t.indexOf(o) !== -1;
    if (we.isRegExp(o))
      return o.test(t);
  }
}
function oX(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, o) => r.toUpperCase() + o);
}
function nX(e, t) {
  const r = we.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + r, {
      value: function(n, a, l) {
        return this[o].call(this, t, n, a, l);
      },
      configurable: !0
    });
  });
}
let Jo = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, o) {
    const n = this;
    function a(i, s, u) {
      const c = Dd(s);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const g = we.findKey(n, c);
      (!g || n[g] === void 0 || u === !0 || u === void 0 && n[g] !== !1) && (n[g || s] = yc(i));
    }
    const l = (i, s) => we.forEach(i, (u, c) => a(u, c, s));
    if (we.isPlainObject(t) || t instanceof this.constructor)
      l(t, r);
    else if (we.isString(t) && (t = t.trim()) && !rX(t))
      l(eX(t), r);
    else if (we.isObject(t) && we.isIterable(t)) {
      let i = {}, s, u;
      for (const c of t) {
        if (!we.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        i[u = c[0]] = (s = i[u]) ? we.isArray(s) ? [...s, c[1]] : [s, c[1]] : c[1];
      }
      l(i, r);
    } else
      t != null && a(r, t, o);
    return this;
  }
  get(t, r) {
    if (t = Dd(t), t) {
      const o = we.findKey(this, t);
      if (o) {
        const n = this[o];
        if (!r)
          return n;
        if (r === !0)
          return tX(n);
        if (we.isFunction(r))
          return r.call(this, n, o);
        if (we.isRegExp(r))
          return r.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = Dd(t), t) {
      const o = we.findKey(this, t);
      return !!(o && this[o] !== void 0 && (!r || $f(this, this[o], o, r)));
    }
    return !1;
  }
  delete(t, r) {
    const o = this;
    let n = !1;
    function a(l) {
      if (l = Dd(l), l) {
        const i = we.findKey(o, l);
        i && (!r || $f(o, o[i], i, r)) && (delete o[i], n = !0);
      }
    }
    return we.isArray(t) ? t.forEach(a) : a(t), n;
  }
  clear(t) {
    const r = Object.keys(this);
    let o = r.length, n = !1;
    for (; o--; ) {
      const a = r[o];
      (!t || $f(this, this[a], a, t, !0)) && (delete this[a], n = !0);
    }
    return n;
  }
  normalize(t) {
    const r = this, o = {};
    return we.forEach(this, (n, a) => {
      const l = we.findKey(o, a);
      if (l) {
        r[l] = yc(n), delete r[a];
        return;
      }
      const i = t ? oX(a) : String(a).trim();
      i !== a && delete r[a], r[i] = yc(n), o[i] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return we.forEach(this, (o, n) => {
      o != null && o !== !1 && (r[n] = t && we.isArray(o) ? o.join(", ") : o);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const o = new this(t);
    return r.forEach((n) => o.set(n)), o;
  }
  static accessor(t) {
    const o = (this[Hv] = this[Hv] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function a(l) {
      const i = Dd(l);
      o[i] || (nX(n, l), o[i] = !0);
    }
    return we.isArray(t) ? t.forEach(a) : a(t), this;
  }
};
Jo.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
we.reduceDescriptors(Jo.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[r] = o;
    }
  };
});
we.freezeMethods(Jo);
function Cf(e, t) {
  const r = this || $u, o = t || r, n = Jo.from(o.headers);
  let a = o.data;
  return we.forEach(e, function(i) {
    a = i.call(r, a, n.normalize(), t ? t.status : void 0);
  }), n.normalize(), a;
}
function yT(e) {
  return !!(e && e.__CANCEL__);
}
let Cu = class extends Tt {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(t, r, o) {
    super(t ?? "canceled", Tt.ERR_CANCELED, r, o), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function wT(e, t, r) {
  const o = r.config.validateStatus;
  !r.status || !o || o(r.status) ? e(r) : t(
    new Tt(
      "Request failed with status code " + r.status,
      [Tt.ERR_BAD_REQUEST, Tt.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
      r.config,
      r.request,
      r
    )
  );
}
function aX(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function lX(e, t) {
  e = e || 10;
  const r = new Array(e), o = new Array(e);
  let n = 0, a = 0, l;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const u = Date.now(), c = o[a];
    l || (l = u), r[n] = s, o[n] = u;
    let g = a, p = 0;
    for (; g !== n; )
      p += r[g++], g = g % e;
    if (n = (n + 1) % e, n === a && (a = (a + 1) % e), u - l < t)
      return;
    const h = c && u - c;
    return h ? Math.round(p * 1e3 / h) : void 0;
  };
}
function iX(e, t) {
  let r = 0, o = 1e3 / t, n, a;
  const l = (u, c = Date.now()) => {
    r = c, n = null, a && (clearTimeout(a), a = null), e(...u);
  };
  return [(...u) => {
    const c = Date.now(), g = c - r;
    g >= o ? l(u, c) : (n = u, a || (a = setTimeout(() => {
      a = null, l(n);
    }, o - g)));
  }, () => n && l(n)];
}
const rm = (e, t, r = 3) => {
  let o = 0;
  const n = lX(50, 250);
  return iX((a) => {
    const l = a.loaded, i = a.lengthComputable ? a.total : void 0, s = l - o, u = n(s), c = l <= i;
    o = l;
    const g = {
      loaded: l,
      total: i,
      progress: i ? l / i : void 0,
      bytes: s,
      rate: u || void 0,
      estimated: u && i && c ? (i - l) / u : void 0,
      event: a,
      lengthComputable: i != null,
      [t ? "download" : "upload"]: !0
    };
    e(g);
  }, r);
}, Uv = (e, t) => {
  const r = e != null;
  return [
    (o) => t[0]({
      lengthComputable: r,
      total: e,
      loaded: o
    }),
    t[1]
  ];
}, Xv = (e) => (...t) => we.asap(() => e(...t)), sX = Co.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, Co.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(Co.origin),
  Co.navigator && /(msie|trident)/i.test(Co.navigator.userAgent)
) : () => !0, dX = Co.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, o, n, a, l) {
      if (typeof document > "u") return;
      const i = [`${e}=${encodeURIComponent(t)}`];
      we.isNumber(r) && i.push(`expires=${new Date(r).toUTCString()}`), we.isString(o) && i.push(`path=${o}`), we.isString(n) && i.push(`domain=${n}`), a === !0 && i.push("secure"), we.isString(l) && i.push(`SameSite=${l}`), document.cookie = i.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function uX(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function cX(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function _T(e, t, r) {
  let o = !uX(t);
  return e && (o || r == !1) ? cX(e, t) : t;
}
const Wv = (e) => e instanceof Jo ? { ...e } : e;
function wi(e, t) {
  t = t || {};
  const r = {};
  function o(u, c, g, p) {
    return we.isPlainObject(u) && we.isPlainObject(c) ? we.merge.call({ caseless: p }, u, c) : we.isPlainObject(c) ? we.merge({}, c) : we.isArray(c) ? c.slice() : c;
  }
  function n(u, c, g, p) {
    if (we.isUndefined(c)) {
      if (!we.isUndefined(u))
        return o(void 0, u, g, p);
    } else return o(u, c, g, p);
  }
  function a(u, c) {
    if (!we.isUndefined(c))
      return o(void 0, c);
  }
  function l(u, c) {
    if (we.isUndefined(c)) {
      if (!we.isUndefined(u))
        return o(void 0, u);
    } else return o(void 0, c);
  }
  function i(u, c, g) {
    if (g in t)
      return o(u, c);
    if (g in e)
      return o(void 0, u);
  }
  const s = {
    url: a,
    method: a,
    data: a,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    withXSRFToken: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    beforeRedirect: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: i,
    headers: (u, c, g) => n(Wv(u), Wv(c), g, !0)
  };
  return we.forEach(Object.keys({ ...e, ...t }), function(c) {
    if (c === "__proto__" || c === "constructor" || c === "prototype") return;
    const g = we.hasOwnProp(s, c) ? s[c] : n, p = g(e[c], t[c], c);
    we.isUndefined(p) && g !== i || (r[c] = p);
  }), r;
}
const TT = (e) => {
  const t = wi({}, e);
  let { data: r, withXSRFToken: o, xsrfHeaderName: n, xsrfCookieName: a, headers: l, auth: i } = t;
  if (t.headers = l = Jo.from(l), t.url = ST(
    _T(t.baseURL, t.url, t.allowAbsoluteUrls),
    e.params,
    e.paramsSerializer
  ), i && l.set(
    "Authorization",
    "Basic " + btoa(
      (i.username || "") + ":" + (i.password ? unescape(encodeURIComponent(i.password)) : "")
    )
  ), we.isFormData(r)) {
    if (Co.hasStandardBrowserEnv || Co.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if (we.isFunction(r.getHeaders)) {
      const s = r.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(s).forEach(([c, g]) => {
        u.includes(c.toLowerCase()) && l.set(c, g);
      });
    }
  }
  if (Co.hasStandardBrowserEnv && (o && we.isFunction(o) && (o = o(t)), o || o !== !1 && sX(t.url))) {
    const s = n && a && dX.read(a);
    s && l.set(n, s);
  }
  return t;
}, mX = typeof XMLHttpRequest < "u", gX = mX && function(e) {
  return new Promise(function(r, o) {
    const n = TT(e);
    let a = n.data;
    const l = Jo.from(n.headers).normalize();
    let { responseType: i, onUploadProgress: s, onDownloadProgress: u } = n, c, g, p, h, v;
    function A() {
      h && h(), v && v(), n.cancelToken && n.cancelToken.unsubscribe(c), n.signal && n.signal.removeEventListener("abort", c);
    }
    let S = new XMLHttpRequest();
    S.open(n.method.toUpperCase(), n.url, !0), S.timeout = n.timeout;
    function b() {
      if (!S)
        return;
      const w = Jo.from(
        "getAllResponseHeaders" in S && S.getAllResponseHeaders()
      ), O = {
        data: !i || i === "text" || i === "json" ? S.responseText : S.response,
        status: S.status,
        statusText: S.statusText,
        headers: w,
        config: e,
        request: S
      };
      wT(
        function(_) {
          r(_), A();
        },
        function(_) {
          o(_), A();
        },
        O
      ), S = null;
    }
    "onloadend" in S ? S.onloadend = b : S.onreadystatechange = function() {
      !S || S.readyState !== 4 || S.status === 0 && !(S.responseURL && S.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, S.onabort = function() {
      S && (o(new Tt("Request aborted", Tt.ECONNABORTED, e, S)), S = null);
    }, S.onerror = function(N) {
      const O = N && N.message ? N.message : "Network Error", m = new Tt(O, Tt.ERR_NETWORK, e, S);
      m.event = N || null, o(m), S = null;
    }, S.ontimeout = function() {
      let N = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const O = n.transitional || Eh;
      n.timeoutErrorMessage && (N = n.timeoutErrorMessage), o(
        new Tt(
          N,
          O.clarifyTimeoutError ? Tt.ETIMEDOUT : Tt.ECONNABORTED,
          e,
          S
        )
      ), S = null;
    }, a === void 0 && l.setContentType(null), "setRequestHeader" in S && we.forEach(l.toJSON(), function(N, O) {
      S.setRequestHeader(O, N);
    }), we.isUndefined(n.withCredentials) || (S.withCredentials = !!n.withCredentials), i && i !== "json" && (S.responseType = n.responseType), u && ([p, v] = rm(u, !0), S.addEventListener("progress", p)), s && S.upload && ([g, h] = rm(s), S.upload.addEventListener("progress", g), S.upload.addEventListener("loadend", h)), (n.cancelToken || n.signal) && (c = (w) => {
      S && (o(!w || w.type ? new Cu(null, e, S) : w), S.abort(), S = null);
    }, n.cancelToken && n.cancelToken.subscribe(c), n.signal && (n.signal.aborted ? c() : n.signal.addEventListener("abort", c)));
    const T = aX(n.url);
    if (T && Co.protocols.indexOf(T) === -1) {
      o(
        new Tt(
          "Unsupported protocol " + T + ":",
          Tt.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    S.send(a || null);
  });
}, fX = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let o = new AbortController(), n;
    const a = function(u) {
      if (!n) {
        n = !0, i();
        const c = u instanceof Error ? u : this.reason;
        o.abort(
          c instanceof Tt ? c : new Cu(c instanceof Error ? c.message : c)
        );
      }
    };
    let l = t && setTimeout(() => {
      l = null, a(new Tt(`timeout of ${t}ms exceeded`, Tt.ETIMEDOUT));
    }, t);
    const i = () => {
      e && (l && clearTimeout(l), l = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(a) : u.removeEventListener("abort", a);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", a));
    const { signal: s } = o;
    return s.unsubscribe = () => we.asap(i), s;
  }
}, pX = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let o = 0, n;
  for (; o < r; )
    n = o + t, yield e.slice(o, n), o = n;
}, hX = async function* (e, t) {
  for await (const r of xX(e))
    yield* pX(r, t);
}, xX = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: o } = await t.read();
      if (r)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, Yv = (e, t, r, o) => {
  const n = hX(e, t);
  let a = 0, l, i = (s) => {
    l || (l = !0, o && o(s));
  };
  return new ReadableStream(
    {
      async pull(s) {
        try {
          const { done: u, value: c } = await n.next();
          if (u) {
            i(), s.close();
            return;
          }
          let g = c.byteLength;
          if (r) {
            let p = a += g;
            r(p);
          }
          s.enqueue(new Uint8Array(c));
        } catch (u) {
          throw i(u), u;
        }
      },
      cancel(s) {
        return i(s), n.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Kv = 64 * 1024, { isFunction: lc } = we, vX = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(we.global), { ReadableStream: Qv, TextEncoder: jv } = we.global, Zv = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, SX = (e) => {
  e = we.merge.call(
    {
      skipUndefined: !0
    },
    vX,
    e
  );
  const { fetch: t, Request: r, Response: o } = e, n = t ? lc(t) : typeof fetch == "function", a = lc(r), l = lc(o);
  if (!n)
    return !1;
  const i = n && lc(Qv), s = n && (typeof jv == "function" ? /* @__PURE__ */ ((v) => (A) => v.encode(A))(new jv()) : async (v) => new Uint8Array(await new r(v).arrayBuffer())), u = a && i && Zv(() => {
    let v = !1;
    const A = new Qv(), S = new r(Co.origin, {
      body: A,
      method: "POST",
      get duplex() {
        return v = !0, "half";
      }
    }).headers.has("Content-Type");
    return A.cancel(), v && !S;
  }), c = l && i && Zv(() => we.isReadableStream(new o("").body)), g = {
    stream: c && ((v) => v.body)
  };
  n && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((v) => {
    !g[v] && (g[v] = (A, S) => {
      let b = A && A[v];
      if (b)
        return b.call(A);
      throw new Tt(
        `Response type '${v}' is not supported`,
        Tt.ERR_NOT_SUPPORT,
        S
      );
    });
  });
  const p = async (v) => {
    if (v == null)
      return 0;
    if (we.isBlob(v))
      return v.size;
    if (we.isSpecCompliantForm(v))
      return (await new r(Co.origin, {
        method: "POST",
        body: v
      }).arrayBuffer()).byteLength;
    if (we.isArrayBufferView(v) || we.isArrayBuffer(v))
      return v.byteLength;
    if (we.isURLSearchParams(v) && (v = v + ""), we.isString(v))
      return (await s(v)).byteLength;
  }, h = async (v, A) => {
    const S = we.toFiniteNumber(v.getContentLength());
    return S ?? p(A);
  };
  return async (v) => {
    let {
      url: A,
      method: S,
      data: b,
      signal: T,
      cancelToken: w,
      timeout: N,
      onDownloadProgress: O,
      onUploadProgress: m,
      responseType: _,
      headers: X,
      withCredentials: $ = "same-origin",
      fetchOptions: E
    } = TT(v), D = t || fetch;
    _ = _ ? (_ + "").toLowerCase() : "text";
    let U = fX(
      [T, w && w.toAbortSignal()],
      N
    ), Y = null;
    const G = U && U.unsubscribe && (() => {
      U.unsubscribe();
    });
    let K;
    try {
      if (m && u && S !== "get" && S !== "head" && (K = await h(X, b)) !== 0) {
        let V = new r(A, {
          method: "POST",
          body: b,
          duplex: "half"
        }), ae;
        if (we.isFormData(b) && (ae = V.headers.get("content-type")) && X.setContentType(ae), V.body) {
          const [F, le] = Uv(
            K,
            rm(Xv(m))
          );
          b = Yv(V.body, Kv, F, le);
        }
      }
      we.isString($) || ($ = $ ? "include" : "omit");
      const W = a && "credentials" in r.prototype, xe = {
        ...E,
        signal: U,
        method: S.toUpperCase(),
        headers: X.normalize().toJSON(),
        body: b,
        duplex: "half",
        credentials: W ? $ : void 0
      };
      Y = a && new r(A, xe);
      let Ce = await (a ? D(Y, E) : D(A, xe));
      const Q = c && (_ === "stream" || _ === "response");
      if (c && (O || Q && G)) {
        const V = {};
        ["status", "statusText", "headers"].forEach((te) => {
          V[te] = Ce[te];
        });
        const ae = we.toFiniteNumber(Ce.headers.get("content-length")), [F, le] = O && Uv(
          ae,
          rm(Xv(O), !0)
        ) || [];
        Ce = new o(
          Yv(Ce.body, Kv, F, () => {
            le && le(), G && G();
          }),
          V
        );
      }
      _ = _ || "text";
      let ue = await g[we.findKey(g, _) || "text"](
        Ce,
        v
      );
      return !Q && G && G(), await new Promise((V, ae) => {
        wT(V, ae, {
          data: ue,
          headers: Jo.from(Ce.headers),
          status: Ce.status,
          statusText: Ce.statusText,
          config: v,
          request: Y
        });
      });
    } catch (W) {
      throw G && G(), W && W.name === "TypeError" && /Load failed|fetch/i.test(W.message) ? Object.assign(
        new Tt(
          "Network Error",
          Tt.ERR_NETWORK,
          v,
          Y,
          W && W.response
        ),
        {
          cause: W.cause || W
        }
      ) : Tt.from(W, W && W.code, v, Y, W && W.response);
    }
  };
}, bX = /* @__PURE__ */ new Map(), AT = (e) => {
  let t = e && e.env || {};
  const { fetch: r, Request: o, Response: n } = t, a = [o, n, r];
  let l = a.length, i = l, s, u, c = bX;
  for (; i--; )
    s = a[i], u = c.get(s), u === void 0 && c.set(s, u = i ? /* @__PURE__ */ new Map() : SX(t)), c = u;
  return u;
};
AT();
const Nh = {
  http: BU,
  xhr: gX,
  fetch: {
    get: AT
  }
};
we.forEach(Nh, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const zv = (e) => `- ${e}`, yX = (e) => we.isFunction(e) || e === null || e === !1;
function wX(e, t) {
  e = we.isArray(e) ? e : [e];
  const { length: r } = e;
  let o, n;
  const a = {};
  for (let l = 0; l < r; l++) {
    o = e[l];
    let i;
    if (n = o, !yX(o) && (n = Nh[(i = String(o)).toLowerCase()], n === void 0))
      throw new Tt(`Unknown adapter '${i}'`);
    if (n && (we.isFunction(n) || (n = n.get(t))))
      break;
    a[i || "#" + l] = n;
  }
  if (!n) {
    const l = Object.entries(a).map(
      ([s, u]) => `adapter ${s} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let i = r ? l.length > 1 ? `since :
` + l.map(zv).join(`
`) : " " + zv(l[0]) : "as no adapter specified";
    throw new Tt(
      "There is no suitable adapter to dispatch the request " + i,
      "ERR_NOT_SUPPORT"
    );
  }
  return n;
}
const PT = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: wX,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Nh
};
function Lf(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Cu(null, e);
}
function qv(e) {
  return Lf(e), e.headers = Jo.from(e.headers), e.data = Cf.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), PT.getAdapter(e.adapter || $u.adapter, e)(e).then(
    function(o) {
      return Lf(e), o.data = Cf.call(e, e.transformResponse, o), o.headers = Jo.from(o.headers), o;
    },
    function(o) {
      return yT(o) || (Lf(e), o && o.response && (o.response.data = Cf.call(
        e,
        e.transformResponse,
        o.response
      ), o.response.headers = Jo.from(o.response.headers))), Promise.reject(o);
    }
  );
}
const MT = "1.14.0", Km = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Km[e] = function(o) {
    return typeof o === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Jv = {};
Km.transitional = function(t, r, o) {
  function n(a, l) {
    return "[Axios v" + MT + "] Transitional option '" + a + "'" + l + (o ? ". " + o : "");
  }
  return (a, l, i) => {
    if (t === !1)
      throw new Tt(
        n(l, " has been removed" + (r ? " in " + r : "")),
        Tt.ERR_DEPRECATED
      );
    return r && !Jv[l] && (Jv[l] = !0, console.warn(
      n(
        l,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(a, l, i) : !0;
  };
};
Km.spelling = function(t) {
  return (r, o) => (console.warn(`${o} is likely a misspelling of ${t}`), !0);
};
function _X(e, t, r) {
  if (typeof e != "object")
    throw new Tt("options must be an object", Tt.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let n = o.length;
  for (; n-- > 0; ) {
    const a = o[n], l = t[a];
    if (l) {
      const i = e[a], s = i === void 0 || l(i, a, e);
      if (s !== !0)
        throw new Tt(
          "option " + a + " must be " + s,
          Tt.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new Tt("Unknown option " + a, Tt.ERR_BAD_OPTION);
  }
}
const wc = {
  assertOptions: _X,
  validators: Km
}, bn = wc.validators;
let di = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Vv(),
      response: new Vv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (o) {
      if (o instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const a = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          o.stack ? a && !String(o.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (o.stack += `
` + a) : o.stack = a;
        } catch {
        }
      }
      throw o;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = wi(this.defaults, r);
    const { transitional: o, paramsSerializer: n, headers: a } = r;
    o !== void 0 && wc.assertOptions(
      o,
      {
        silentJSONParsing: bn.transitional(bn.boolean),
        forcedJSONParsing: bn.transitional(bn.boolean),
        clarifyTimeoutError: bn.transitional(bn.boolean),
        legacyInterceptorReqResOrdering: bn.transitional(bn.boolean)
      },
      !1
    ), n != null && (we.isFunction(n) ? r.paramsSerializer = {
      serialize: n
    } : wc.assertOptions(
      n,
      {
        encode: bn.function,
        serialize: bn.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), wc.assertOptions(
      r,
      {
        baseUrl: bn.spelling("baseURL"),
        withXsrfToken: bn.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let l = a && we.merge(a.common, a[r.method]);
    a && we.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (v) => {
      delete a[v];
    }), r.headers = Jo.concat(l, a);
    const i = [];
    let s = !0;
    this.interceptors.request.forEach(function(A) {
      if (typeof A.runWhen == "function" && A.runWhen(r) === !1)
        return;
      s = s && A.synchronous;
      const S = r.transitional || Eh;
      S && S.legacyInterceptorReqResOrdering ? i.unshift(A.fulfilled, A.rejected) : i.push(A.fulfilled, A.rejected);
    });
    const u = [];
    this.interceptors.response.forEach(function(A) {
      u.push(A.fulfilled, A.rejected);
    });
    let c, g = 0, p;
    if (!s) {
      const v = [qv.bind(this), void 0];
      for (v.unshift(...i), v.push(...u), p = v.length, c = Promise.resolve(r); g < p; )
        c = c.then(v[g++], v[g++]);
      return c;
    }
    p = i.length;
    let h = r;
    for (; g < p; ) {
      const v = i[g++], A = i[g++];
      try {
        h = v(h);
      } catch (S) {
        A.call(this, S);
        break;
      }
    }
    try {
      c = qv.call(this, h);
    } catch (v) {
      return Promise.reject(v);
    }
    for (g = 0, p = u.length; g < p; )
      c = c.then(u[g++], u[g++]);
    return c;
  }
  getUri(t) {
    t = wi(this.defaults, t);
    const r = _T(t.baseURL, t.url, t.allowAbsoluteUrls);
    return ST(r, t.params, t.paramsSerializer);
  }
};
we.forEach(["delete", "get", "head", "options"], function(t) {
  di.prototype[t] = function(r, o) {
    return this.request(
      wi(o || {}, {
        method: t,
        url: r,
        data: (o || {}).data
      })
    );
  };
});
we.forEach(["post", "put", "patch"], function(t) {
  function r(o) {
    return function(a, l, i) {
      return this.request(
        wi(i || {}, {
          method: t,
          headers: o ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: a,
          data: l
        })
      );
    };
  }
  di.prototype[t] = r(), di.prototype[t + "Form"] = r(!0);
});
let TX = class $T {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const o = this;
    this.promise.then((n) => {
      if (!o._listeners) return;
      let a = o._listeners.length;
      for (; a-- > 0; )
        o._listeners[a](n);
      o._listeners = null;
    }), this.promise.then = (n) => {
      let a;
      const l = new Promise((i) => {
        o.subscribe(i), a = i;
      }).then(n);
      return l.cancel = function() {
        o.unsubscribe(a);
      }, l;
    }, t(function(a, l, i) {
      o.reason || (o.reason = new Cu(a, l, i), r(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (o) => {
      t.abort(o);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new $T(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
};
function AX(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function PX(e) {
  return we.isObject(e) && e.isAxiosError === !0;
}
const wp = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(wp).forEach(([e, t]) => {
  wp[t] = e;
});
function CT(e) {
  const t = new di(e), r = sT(di.prototype.request, t);
  return we.extend(r, di.prototype, t, { allOwnKeys: !0 }), we.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(n) {
    return CT(wi(e, n));
  }, r;
}
const Qr = CT($u);
Qr.Axios = di;
Qr.CanceledError = Cu;
Qr.CancelToken = TX;
Qr.isCancel = yT;
Qr.VERSION = MT;
Qr.toFormData = Ym;
Qr.AxiosError = Tt;
Qr.Cancel = Qr.CanceledError;
Qr.all = function(t) {
  return Promise.all(t);
};
Qr.spread = AX;
Qr.isAxiosError = PX;
Qr.mergeConfig = wi;
Qr.AxiosHeaders = Jo;
Qr.formToJSON = (e) => bT(we.isHTMLForm(e) ? new FormData(e) : e);
Qr.getAdapter = PT.getAdapter;
Qr.HttpStatusCode = wp;
Qr.default = Qr;
const {
  Axios: X0e,
  AxiosError: W0e,
  CanceledError: Y0e,
  isCancel: K0e,
  CancelToken: Q0e,
  VERSION: j0e,
  all: Z0e,
  Cancel: z0e,
  isAxiosError: q0e,
  spread: J0e,
  toFormData: ehe,
  AxiosHeaders: the,
  HttpStatusCode: rhe,
  formToJSON: ohe,
  getAdapter: nhe,
  mergeConfig: ahe
} = Qr, lhe = () => {
  const { getLocale: e, initLocale: t, setLocale: r } = rT(), o = dt({}), n = dt({
    cookies: {}
  }), a = (S, b = {}) => {
    Object.assign(o, S), n.cookies = "cookies" in b ? b.cookies : {};
  }, l = (S) => {
    let T = o.user.getInfo()?.allowed_modules || [];
    return S.reduce((w, N) => {
      if (N.child) {
        let O = N.child;
        Jp(O) && (O = Object.values(O));
        const m = l(O), _ = m.map((X) => X.key);
        o.menu.setParentMenus(N.key, _), T.includes(N.key) && m.length > 0 && w.push({
          ...N,
          child: m
        });
      } else
        T.includes(N.key) && w.push(N);
      return w;
    }, []);
  }, i = () => {
    const S = o.user.getLanguage() || n.cookies?.get("language") || "english";
    if (n.cookies?.get("language") != o.user.getLanguage()) {
      const b = e(S);
      n.cookies?.set("language", S), p(S), t({ app: o.app, user: o.user }), r(b);
    }
  }, s = async (S) => {
    S && await fetch(`/menu/${S}.json${o.app.getJSONVersion()}`).then((b) => b.json()).then((b) => {
      o.menu.setAllMenu(b);
    }).catch((b) => {
      console.error(`${S} menu loaded with an error,`, b);
    });
  }, u = () => {
    try {
      const S = o.menu.getAllMenus();
      let b = {};
      Object.keys(S).forEach((T) => {
        if (Array.isArray(S[T])) {
          const w = l(S[T]);
          w.length && (b[T] = w);
        }
      }), o.menu.setMenus(b), c();
    } catch (S) {
      console.error("App menu setup error,", S);
    }
  }, c = () => {
    const S = "min-sidebar";
    n.cookies?.isKey(S) && n.cookies?.get(S) === "true" && document.body.classList.contains("main-sidebar-show") && (document.body.classList.remove("main-sidebar-show"), document.body.classList.add("main-sidebar-hide"), o.action.setComponentAction("aside", !1));
  }, g = (S = o.user.getDarkMode()) => {
    S ? (document.body.classList.remove("light-theme"), document.body.classList.add("dark-theme")) : (document.body.classList.remove("dark-theme"), document.body.classList.add("light-theme"));
  }, p = (S) => {
    const b = e(S);
    document.documentElement.setAttribute("lang", b), document.body.classList.remove(...o.app.getLocales()), document.body.classList.add(b);
  };
  return {
    initMainApp: a,
    setAppLocale: i,
    setAppMenuPathKey: s,
    setAppMenus: u,
    setAppTheme: g,
    setBodyLocaleClass: p,
    setTestMode: () => {
      const S = o.user.getInfoByKey("accountcode");
      o.user.setTestMode(o.setting.getTestCodes().includes(S));
    },
    setUserData: async (S) => {
      if (S)
        try {
          await Qr.get(o.action.getUrlByKey(S), {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + o.user.getToken()
            },
            params: {
              includes: "allowed_modules,allowed_module_permissions"
            }
          }).then((b) => {
            o.user.getTestMode() && console.debug("setUserData response", b.data), o.user.setInfo(b.data.data);
          }).catch((b) => {
            console.error("setUserData error", b), ([401, 403, 500].includes(b.response.status) || [401, 403, 500].includes(b.response.data.data.http_status)) && (o.action.setResponse({
              action: S,
              status: !1,
              message: b.response.data.message,
              data: null,
              error: null
            }), o.user.setLoggedIn(!1));
          });
        } catch (b) {
          console.error("setUserData catch error", b);
        }
    },
    setUserSettings: (S) => {
      S.length >= 3 ? (o.user.setType(S[1]), o.user.setPage(S[2])) : o.user.getDefaultType() && (o.user.setType(o.user.getDefaultType()), o.user.setPage(S[1] || ""));
    }
  };
}, ihe = () => {
  const e = dt({}), t = dt({
    modals: {
      default: {
        isShow: !1
      }
    },
    options: {
      "click-outside-close": !0
    }
  }), r = async (u) => {
    Object.assign(e, u);
  }, o = (u) => Object.prototype.hasOwnProperty.call(t.modals, u);
  return {
    mxModalState: t,
    initModal: r,
    isModalExists: o,
    isModalOpen: (u) => e.action.getModalStatus(u),
    onCreateModal: (u) => {
      e.action.setModal(u), t.modals = e.action.getModal();
    },
    onRemoveModal: (u) => {
      o(u) && e.action.removeModal(u);
    },
    onHideModal: (u) => {
      e.action.getModalStatus(u) && e.action.toggleModal(u, !1);
    },
    onShowModal: (u) => {
      e.action.toggleModal(u, !0);
    }
  };
}, she = () => {
  let e;
  const t = () => ({
    name: "",
    is_superadmin: ""
  }), r = () => ({
    1: !1,
    2: !1,
    3: !1
  }), o = ge(() => ({
    "far fa-check-square": n.value,
    "far fa-square": !n.value
  })), n = ge(() => {
    for (const Y in u.modules) {
      const G = u.modules[Y];
      if (G && !G.childs.map((W) => W.id).every((W) => u.checkBox.selected.includes(W)))
        return !1;
    }
    return !0;
  }), a = ge(() => !s.masterAcc && En(u.modules)), l = ge(() => s.masterAcc), i = dt({}), s = dt({
    fGetModulePermission: () => {
    },
    id: "0",
    idKey: "",
    isEdit: !1,
    rule: "",
    masterAcc: !1,
    modulePermissionTable: ""
  }), u = dt({
    checkBox: {
      selected: []
    },
    currentStep: 1,
    maxStep: 3,
    modules: {},
    childModules: [],
    parentModules: [],
    parentModuleIds: [],
    subModules: {},
    subModulePermission: {},
    steps: r()
  }), c = dt({
    action: "",
    blade: {
      name: {
        type: "text",
        label: "name",
        attributes: {
          disabled: a.value,
          required: !0,
          maxlength: 255
        },
        placeholder: "",
        value: "",
        classes: "",
        divClasses: ""
      },
      is_superadmin: {
        type: "switch",
        label: "is_superadmin",
        attributes: {
          required: !0,
          checkboxLabel: "superadmin_set_as"
        },
        placeholder: "",
        value: "",
        classes: "",
        divClasses: l.value ? "col-md-6" : "d-none"
      }
    },
    data: {},
    id: "",
    isSubmit: !1
  }), g = (Y = !1) => {
    let G = {
      action: c.action,
      method: s.isEdit ? Y ? "put" : "get" : "post",
      language: i.user.getLanguage(),
      ruler: {
        extend: !1,
        url: s.rule
      },
      stores: { user: i.user, action: i.action }
    };
    return s.isEdit && (G.id = s.id), G;
  }, p = (Y, G, K, W) => {
    Object.assign(i, Y);
    const {
      getModulePermission: xe = () => {
      },
      isEdit: Ce = !1,
      id: Q = 0,
      idKey: ue = "",
      rule: V = "",
      masterAcc: ae = !1,
      maxStep: F = 3,
      modulePermissionTable: le = ""
    } = G;
    s.fGetModulePermission = xe, s.id = Ce ? Q : 0, s.idKey = ue, s.isEdit = Ce, s.rule = V, s.masterAcc = ae, s.modulePermissionTable = le, c.action = G?.form?.action ?? "", c.id = G?.form?.id ?? "", c.blade = W?.tBlade ?? c.blade, u.maxStep = F, u.parentModules = Object.keys(i.menu.getParentMenus()), u.childModules = Object.values(i.menu.getParentMenus()).flat(), e = K;
  }, h = (Y) => !!u.checkBox.selected.includes(Y), v = (Y, G) => u.childModules.includes(Y), A = (Y, G) => {
    const K = u.parentModules.includes(Y);
    return K && u.parentModuleIds.push(G), K;
  }, S = (Y) => {
    c.isSubmit || (c.isSubmit = !0, e(c.id, g(c.isSubmit), Y));
  }, b = (Y) => {
    u.subModulePermission = Y;
  }, T = (Y) => {
    Y.data.reduce(function(K, W) {
      return W.master_id == 0 || W.is_master ? (K.push(W), u.modules[W.id] = {
        id: W.id,
        childs: [],
        name: W.name,
        key: W.modulekey
      }) : K.length && "childs" in u.modules[W.master.id] && (W.master.id in u.subModules || (u.subModules[W.master.id] = []), u.subModules[W.master.id].push(W.id), "all" in u.subModules || (u.subModules.all = []), u.subModules.all.push(W.id), u.modules[W.master.id].childs.push({
        id: W.id,
        name: W.name,
        key: W.modulekey,
        sequence: W.sequence
      })), K;
    }, []);
  }, w = (Y) => {
    "isSubmit" in Y && (c.isSubmit = Y.isSubmit, Y?.isError && N(1)), "status" in Y && Y.status && (s.isEdit || (u.checkBox.selected = [], N(1))), "resp" in Y && Y.resp && Y.resp.id === i.user.getInfoByKey(s.idKey) && i.action.setComponentAction("menu-change", !0);
  }, N = (Y) => {
    if (typeof Y == "number") {
      if (!O(Y)) return;
      u.currentStep = Y;
    } else {
      if (Y === "next" && u.currentStep < u.maxStep) {
        if (!O(u.currentStep + 1)) return;
        u.currentStep++;
      }
      Y === "previous" && u.currentStep > 1 && u.currentStep--;
    }
    u.steps = r(), u.steps[u.currentStep] = !0;
  }, O = (Y) => u.maxStep === 3 ? u.checkBox.selected.length > 0 || Y < 3 : !0, m = () => {
    s.isEdit && typeof $.value == "boolean" && !$.value || (n.value ? u.checkBox.selected = [] : u.checkBox.selected = u.subModules.all);
  }, _ = (Y) => {
    s.isEdit && typeof $.value == "boolean" && !$.value || Y in u.subModules && (X(Y) ? u.checkBox.selected = u.checkBox.selected.filter((G) => !u.subModules[Y].includes(G)) : u.checkBox.selected.push(...u.subModules[Y]));
  }, X = (Y) => Y in u.subModules ? u.subModules[Y].every(
    (G) => u.checkBox.selected.includes(G)
  ) : !1, $ = ge(() => s.fGetModulePermission("edit", "mxProfile")), E = ge(() => s.modulePermissionTable in c.data ? c.data[s.modulePermissionTable] : []), D = ge(() => u.checkBox.selected.filter((Y) => !u.parentModuleIds.includes(Number(Y)))), U = ge(() => u.subModulePermission.length ? { module_permissions: JSON.parse(JSON.stringify(u.subModulePermission)) } : {});
  return nt(
    () => a.value,
    (Y, G) => {
      "attributes" in c.blade.name && c.blade.name.attributes && (c.blade.name.attributes.disabled = Y);
    }
  ), nt(
    () => l.value,
    (Y, G) => {
      "is_superadmin" in c.blade && (c.blade.is_superadmin.divClasses = Y ? "col-md-6" : "d-none");
    }
  ), {
    getInitialForm: t,
    mxProfileState: u,
    mxProfileForm: c,
    getOptions: g,
    initProfile: p,
    isChecked: h,
    isChildMenu: v,
    isParentMenu: A,
    onSubmitForm: S,
    onPermissionPost: b,
    onPopulateModuletOption: T,
    onPostSubmit: w,
    onTogglePage: N,
    toggleSelectAllModules: m,
    toggleSelectAllSubModules: _,
    isAllSubModulesSelected: X,
    isModuleReadonly: a,
    getSelectAllButtonClass: o,
    profileModulePermissions: E,
    selectedProfileModule: D,
    selectedProfileModulePermission: U
  };
}, dhe = () => {
  let e = Ee();
  const t = dt({}), r = dt({
    fPreSelectVal: () => {
    },
    fPostRender: () => {
    },
    fPostSelectVal: () => {
    },
    fSelectVal: () => {
    },
    fSetSelectedVal: () => {
    },
    reports: {}
  }), o = dt({
    cReport: "",
    defaultLoading: !0,
    defaultrParams: {},
    filterParams: {},
    isBegin: !1,
    isDSearch: !1,
    isFilterAble: !0,
    isFilterAlter: !1,
    isFiltering: !1,
    isLoading: !1,
    reports: {},
    selected: {}
  }), n = async (_, X, $) => {
    Object.assign(t, _), e = X, o.cReport = "sReport" in $ ? $.sReport : "", o.isFilterAlter = !1, r.fPreSelectVal = "preSelectVal" in $ ? $.preSelectVal : {}, r.fPostSelectVal = "postSelectVal" in $ ? $.postSelectVal : {}, r.fPostRender = "customPostRender" in $ ? $.customPostRender : {}, r.fSelectVal = "selectVal" in $ ? $.selectVal : {}, r.fSetSelectedVal = "customSetSelectedVal" in $ ? $.customSetSelectedVal : {}, r.reports = "reports" in $ ? $.reports : {};
  }, a = () => ({
    "max-date": Ve().format("YYYY-MM-DD"),
    "min-date": Ve().subtract(1.5, "years").startOf("day").format("YYYY-MM-DD"),
    "year-range": [Ve().subtract(1.5, "years").startOf("day").format("YYYY"), Ve().format("YYYY")]
  }), l = () => ({
    "max-date": Ve().toDate(),
    "min-date": Ve().subtract(1.5, "years").startOf("day").toDate(),
    "year-range": [Ve().subtract(1.5, "years").format("YYYY"), Ve().format("YYYY")]
  }), i = (_ = !0) => {
    o.isFiltering || (_ && !o.isBegin && (o.isBegin = !0), o.isFilterAble && (o.isFiltering = !0, t.action.setListLoading(!0), o.defaultLoading || A(!0), _ && e.value.onToggleFilter()));
  }, s = (_) => {
    o.isFiltering = !1, o.defaultLoading || A(!1), o.isDSearch && (o.isDSearch = !1), r.fPostRender instanceof Function && r.fPostRender(_);
  }, u = (_) => (o.reports[_] || (v(), o.cReport = _, o.reports[_] = !0), _), c = (_) => {
    o.defaultLoading = _;
  }, g = (_, X) => {
    o.isDSearch && i(!1), JSON.stringify(o.defaultrParams) !== JSON.stringify(_) && (o.defaultrParams = _, o.isBegin && X > 0 && setTimeout(() => {
      i(!1);
    }, 100));
  }, p = (_) => {
    o.isDSearch = _, o.isDSearch && !o.isFiltering && i(!1);
  }, h = (_, X) => {
    o.filterParams = _;
  }, v = () => {
    o.reports = { ...r.reports };
  }, A = (_) => {
    o.isLoading = _;
  }, S = () => {
    t.app.setLoading(!1);
  }, b = (_, X) => {
    if (o.isFilterAble = X, r.fPreSelectVal instanceof Function && r.fPreSelectVal(_, o.selected), o.isFilterAble) {
      let $ = [];
      for (let E in _) {
        const D = Xd(o.selected[E]), U = _[E];
        Oc(D, U) || (o.selected[E] = Ec(U), $.push(E));
      }
      $.includes("from_to") && (o.filterParams.from = o.selected.created_at["created_at.from"].split(" ")[0].trim(), o.filterParams.to = o.selected.created_at["created_at.to"].split(" ")[0].trim(), $ = $.filter((E) => E !== "created_at")), r.fSetSelectedVal instanceof Function && ($ = r.fSetSelectedVal($)), r.fSelectVal instanceof Function && r.fSelectVal($), r.fPostSelectVal instanceof Function && r.fPostSelectVal();
    }
  }, T = ge(() => o.isLoading), w = ge(() => t.user.getInfoByKey("is_master_account") ?? !1), N = ge(() => t.user.getInfoByKey("is_owner") ?? !1), O = ge(() => t.user.getInfoByKey("is_superadmin") ?? !1), m = ge(() => t.app.getLoading());
  return {
    mxProps: r,
    mxRptState: o,
    initReport: n,
    getMinMaxDateJoined: a,
    getMinMaxDateTimeJoined: l,
    onFilterSearch: i,
    onPostRenderData: s,
    onToggleReport: u,
    setDefaultLoading: c,
    setDefaultParams: g,
    setDefaultSearch: p,
    setFilterParams: h,
    setReports: v,
    setReportLoading: A,
    setReportWrapLoaded: S,
    setSelectedVal: b,
    isLoading: T,
    isMasterAccount: w,
    isOwner: N,
    isSuperAdmin: O,
    isWrapLoading: m
  };
}, uhe = () => {
  const e = dt({
    columns: [],
    reportIdx: 0,
    selectedColumns: []
  }), t = {
    selectSettings: {
      "close-on-select": !1,
      disabled: !1,
      label: "name",
      multiple: !0,
      "open-direction": "bottom",
      placeholder: "",
      "preserve-search": !0,
      "track-by": "code",
      selectLabel: "",
      deselectLabel: ""
    }
  }, r = async (a) => {
    e.columns = "columns" in a ? a.columns : [];
  }, o = (a, l) => {
    e.reportIdx++;
  }, n = ge(() => e.columns);
  return {
    mxRptColState: e,
    mxRptColData: t,
    initReportCols: r,
    onToggleColumn: o,
    vTableColumnVisibility: n
  };
};
var Ji = {}, es = {}, kd = {}, ic = {}, eS;
function MX() {
  return eS || (eS = 1, Object.defineProperty(ic, "__esModule", { value: !0 }), ic.trim = (e, t) => e.replace(new RegExp("^[" + t + "]+|[" + t + "]+$", "g"), "")), ic;
}
var tS;
function Ei() {
  if (tS) return kd;
  tS = 1, Object.defineProperty(kd, "__esModule", { value: !0 });
  const e = MX();
  return kd.formatVersion = (t, r) => {
    if (t === void 0)
      return "";
    const o = e.trim(t, ". ").replace(new RegExp("_", "g"), "."), n = o.split(".");
    return /^\d+$/.test(n.join("")) ? r !== 0 && Number.isInteger(parseFloat(o)) ? parseInt(o, 10).toFixed(1) : n.length > 1 && r !== null ? n.slice(0, r + 1).join(".") : o : o;
  }, kd.parseBrowserEngineVersion = (t, r) => {
    if (!r)
      return "";
    if (r === "Gecko") {
      const a = /[ ](?:rv[: ]([0-9\.]+)).*gecko\/[0-9]{8,10}/i, l = t.match(a);
      if (l)
        return l.pop();
    }
    const o = new RegExp(`${r}\\s*\\/?\\s*((?:(?=\\d+\\.\\d)\\d+[.\\d]*|\\d{1,7}(?=(?:\\D|$))))`, "i"), n = t.match(o);
    return n ? n.pop() : "";
  }, kd;
}
var sc = {}, rS;
function rn() {
  return rS || (rS = 1, Object.defineProperty(sc, "__esModule", { value: !0 }), sc.variableReplacement = (e, t) => {
    const r = new RegExp("\\$\\d", "g");
    return e == null ? "" : e.replace(r, (o) => {
      const n = parseInt(o.substr(1), 10);
      return t[n - 1] || "";
    });
  }), sc;
}
var dc = {}, uc = {}, oS;
function $X() {
  return oS || (oS = 1, Object.defineProperty(uc, "__esModule", { value: !0 }), uc.memoryCache = () => {
    const e = {};
    return {
      set: (o, n) => {
        e[o] = n;
      },
      get: (o) => {
        if (e.hasOwnProperty(o))
          return e[o];
      }
    };
  }), uc;
}
var nS;
function vo() {
  if (nS) return dc;
  nS = 1, Object.defineProperty(dc, "__esModule", { value: !0 });
  const t = $X().memoryCache(), r = (o) => {
    const n = t.get(o);
    if (n)
      return n.value;
    const a = RegExp(`(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(?:${o})`, "i");
    return t.set(o, {
      value: a
    }), a;
  };
  return dc.userAgentParser = (o, n) => {
    try {
      const l = r(o).exec(n);
      return l ? l.slice(1) : null;
    } catch {
      return null;
    }
  }, dc;
}
const CX = /* @__PURE__ */ JSON.parse('[{"regex":"Helio/(\\\\d+[\\\\.\\\\d]+)","name":"Helio","version":"$1","engine":{"default":"Blink"}},{"regex":"7654Browser/(\\\\d+[\\\\.\\\\d]+)","name":"7654 Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Qazweb/(\\\\d+[\\\\.\\\\d]+)","name":"Qazweb","version":"$1","engine":{"default":"Gecko"}},{"regex":"Degdegan/(\\\\d+[\\\\.\\\\d]+)","name":"deg-degan","version":"$1","engine":{"default":"Blink"}},{"regex":"JavaFX/(\\\\d+[\\\\.\\\\d]+)","name":"JavaFX","version":"$1","engine":{"default":"WebKit"}},{"regex":"Chedot/(\\\\d+[\\\\.\\\\d]+)","name":"Chedot","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome/(\\\\d+[\\\\.\\\\d]+) \\\\(Chromium GOST\\\\)","name":"Chromium GOST","version":"$1","engine":{"default":"Blink"}},{"regex":"(?:DeledaoPersonal|DeledaoFamily)/(\\\\d+[\\\\.\\\\d]+)","name":"Deledao","version":"$1","engine":{"default":"Blink"}},{"regex":"HasBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"HasBrowser","version":"$1","engine":{"default":"Blink"}},{"regex":"Byffox/(\\\\d+[\\\\.\\\\d]+)","name":"Byffox","version":"$1","engine":{"default":"Gecko"}},{"regex":"Chrome/(\\\\d+[\\\\.\\\\d]+).+AgentWeb.+UCBrowser","name":"CoolBrowser","version":"$1","engine":{"default":"Blink"}},{"regex":"DotBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"Dot Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"CravingExplorer/(\\\\d+[\\\\.\\\\d]+)","name":"Craving Explorer","version":"$1","engine":{"default":"Blink"}},{"regex":"DeskBrowse/(\\\\d+[\\\\.\\\\d]+)","name":"DeskBrowse","version":"$1"},{"regex":"Lolifox/(\\\\d+[\\\\.\\\\d]+)","name":"Lolifox","version":"$1"},{"regex":"qutebrowser/(\\\\d+[\\\\.\\\\d]+).+Chrome","name":"Qutebrowser","version":"$1","engine":{"default":"Blink"}},{"regex":"qutebrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Qutebrowser","version":"$1"},{"regex":"flast/(\\\\d+[\\\\.\\\\d]+)","name":"Flast","version":"$1","engine":{"default":"Blink"}},{"regex":"PolyBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"PolyBrowser","version":"$1","engine":{"default":"Gecko"}},{"regex":"Chrome.+BriskBard/(\\\\d+[\\\\.\\\\d]+)","name":"BriskBard","version":"$1","engine":{"default":"Blink"}},{"regex":"BriskBard(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"BriskBard","version":"$1"},{"regex":"GinxDroidBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"GinxDroid Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"AviraScout/(\\\\d+[\\\\.\\\\d]+)","name":"Avira Scout","version":"$1","engine":{"default":"Blink"}},{"regex":"VenusBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"Venus Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome.+Otter(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Otter Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Otter(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Otter Browser","version":"$1"},{"regex":"Chrome.+Smooz/(\\\\d+[\\\\.\\\\d]+)","name":"Smooz","version":"$1","engine":{"default":"Blink"}},{"regex":"Smooz/(\\\\d+[\\\\.\\\\d]+)","name":"Smooz","version":"$1"},{"regex":"Cornowser/(\\\\d+[\\\\.\\\\d]+)","name":"Cornowser","version":"$1","engine":{"default":"Blink"}},{"regex":"Orca/(\\\\d+[\\\\.\\\\d]+)","name":"Orca","version":"$1"},{"regex":"Flow/(?:(\\\\d+[\\\\.\\\\d]+))","name":"Flow","version":"$1","engine":{"default":"EkiohFlow"}},{"regex":"Ekioh/(?:(\\\\d+[\\\\.\\\\d]+))","name":"Flow","version":"$1","engine":{"default":"EkiohFlow"}},{"regex":"xStand/(\\\\d+[\\\\.\\\\d]+)","name":"xStand","version":"$1","engine":{"default":"WebKit"}},{"regex":"Biyubi/(\\\\d+[\\\\.\\\\d]+)","name":"Biyubi","version":"$1"},{"regex":"(?:Perfect%20Browser(?:-iPad)?|Perfect(?:BrowserPro)?)/(\\\\d+[\\\\.\\\\d]+)","name":"Perfect Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"Browser/Phantom/V(\\\\d+[\\\\.\\\\d]+)","name":"Phantom Browser","version":"$1"},{"regex":"AwoX(?:/(\\\\d+[\\\\.\\\\d]+))? Browser","name":"AwoX","version":"$1"},{"regex":"Zetakey/(\\\\d+[\\\\.\\\\d]+)","name":"Zetakey","version":"$1","engine":{"default":"WebKit"}},{"regex":"PlayFreeBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"PlayFree Browser","version":"$1"},{"regex":"(?:chimlac_browser|chimlac)/(?:(\\\\d+[\\\\.\\\\d]+))","name":"Chim Lac","version":"$1","engine":{"default":"Blink"}},{"regex":"Odin/(?:(\\\\d+[\\\\.\\\\d]+))","name":"Odin","version":"$1","engine":{"default":"Blink"}},{"regex":"Tbrowser/(\\\\d+[\\\\.\\\\d]+)","name":"T-Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"SFive(?:_Android)?/.+ Chrome/(\\\\d+[\\\\.\\\\d]+)","name":"SFive","version":"$1","engine":{"default":"Blink"}},{"regex":"SFive_IOS/(\\\\d+[\\\\.\\\\d]+)","name":"SFive","version":"$1"},{"regex":"Navigateur web/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Navigateur Web","version":"$1"},{"regex":"Sraf(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Seraphic Sraf","version":"$1","engine":{"default":"Blink"}},{"regex":"SeewoBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Seewo Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"(?:Kode(?:iOS)?/(?:(\\\\d+[\\\\.\\\\d]+))?|TansoDL)","name":"Kode Browser","version":"$1"},{"regex":"UR/(?:(\\\\d+[\\\\.\\\\d]+))","name":"UR Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"OceanHero/([\\\\.\\\\d]+)","name":"OceanHero","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome/.+ SLBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Smart Lenovo Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"SLBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Smart Lenovo Browser","version":"$1"},{"regex":"Browzar","name":"Browzar","version":""},{"regex":"Stargon/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Stargon","version":"$1","engine":{"default":"Blink"}},{"regex":"NFSBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"NFS Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Borealis/(\\\\d+[\\\\.\\\\d]+)","name":"Borealis Navigator","version":"$1"},{"regex":"YoloBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Yolo Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"PHX/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Phoenix Browser","version":"$1"},{"regex":"PrivacyWall/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"PrivacyWall","version":"$1"},{"regex":"Ghostery:?(\\\\d+[\\\\.\\\\d]+)?","name":"Ghostery Privacy Browser","version":"$1"},{"regex":"Firefox/.*(?:Turkcell-)?YaaniBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Yaani Browser","version":"$1","engine":{"default":"Gecko"}},{"regex":"(?:Turkcell-)?YaaniBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Yaani Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"SEB/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Safe Exam Browser","version":"$1"},{"regex":"Colibri/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Colibri","version":"$1"},{"regex":"Xvast/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Xvast","version":"$1"},{"regex":"TungstenBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Tungsten","version":"$1"},{"regex":"Lulumi-browser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Lulumi","version":"$1"},{"regex":"ybrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Yahoo! Japan Browser","version":"$1"},{"regex":"iLunascapeLite/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Lunascape Lite","version":"$1"},{"regex":"Polypane/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Polypane","version":"$1"},{"regex":"OhHaiBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"OhHai Browser","version":"$1"},{"regex":"Sizzy/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Sizzy","version":"$1"},{"regex":"GlassBrowser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Glass Browser","version":"$1"},{"regex":"ToGate/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"ToGate","version":"$1"},{"regex":"AirWatch Browser v(?:(\\\\d+[\\\\.\\\\d]+))?","name":"VMware AirWatch","version":"$1"},{"regex":"ADG/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"AOL Desktop","version":"$1"},{"regex":"Elements Browser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Elements Browser","version":"$1"},{"regex":"Light/(\\\\d+[\\\\.\\\\d]+)","name":"Light","version":"$1"},{"regex":"Valve Steam GameOverlay/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Steam In-Game Overlay","version":"$1"},{"regex":"115Browser/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"115 Browser","version":"$1"},{"regex":"Atom/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Atom","version":"$1"},{"regex":"Mobile VR.+Firefox","name":"Firefox Reality","version":""},{"regex":"AVG(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"AVG Secure Browser","version":"$1"},{"regex":"Start/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"START Internet Browser","version":"$1"},{"regex":"Lovense(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Lovense Browser","version":"$1"},{"regex":"com.airfind.deltabrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Delta Browser","version":"$1"},{"regex":"(?:Ordissimo|webissimo3)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Ordissimo","version":"$1"},{"regex":"CCleaner(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"CCleaner","version":"$1"},{"regex":"AlohaLite(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Aloha Browser Lite","version":"$1","engine":{"default":"Blink"}},{"regex":"TaoBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Tao Browser","version":"$1"},{"regex":"Falkon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Falkon","version":"$1"},{"regex":"mCent(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"mCent","version":"$1"},{"regex":"SalamWeb(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"SalamWeb","version":"$1"},{"regex":"BlackHawk(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"BlackHawk","version":"$1"},{"regex":"Minimo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Minimo","version":"$1"},{"regex":"WIB(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Wear Internet Browser","version":"$1"},{"regex":"Origyn Web Browser","name":"Origyn Web Browser","version":""},{"regex":"Kinza(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Kinza","version":"$1"},{"regex":"Beamrise(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Beamrise","version":"$1"},{"regex":"Faux(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Faux Browser","version":"$1"},{"regex":"splash Version(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Splash","version":"$1"},{"regex":"MZBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Meizu Browser","version":"$1"},{"regex":"COSBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"COS Browser","version":"$1"},{"regex":"Crusta(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Crusta","version":"$1"},{"regex":"Hawk/TurboBrowser(?:/v?(\\\\d+[\\\\.\\\\d]+))?","name":"Hawk Turbo Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"FreeU(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"FreeU","version":"$1","engine":{"default":"Blink"}},{"regex":"NoxBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Nox Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Basilisk(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Basilisk","version":"$1","engine":{"default":"Goanna"}},{"regex":"SputnikBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Sputnik Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"TNSBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"K.Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"OculusBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Oculus Browser","version":"$1"},{"regex":"Jio(?:Browser|Pages)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Jio Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome/.+ Hola(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"hola! Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Slimjet/(?:(\\\\d+[\\\\.\\\\d]+))","name":"Slimjet","version":"$1","engine":{"default":"Blink"}},{"regex":"7Star/(?:(\\\\d+[\\\\.\\\\d]+))","name":"7Star","version":"$1","engine":{"default":"Blink"}},{"regex":"MxNitro/(?:(\\\\d+[\\\\.\\\\d]+))","name":"MxNitro","version":"$1","engine":{"default":"Blink"}},{"regex":"HuaweiBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Huawei Browser","version":"$1"},{"regex":"VivoBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"vivo Browser","version":"$1"},{"regex":"RealmeBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Realme Browser","version":"$1"},{"regex":"Beaker ?Browser(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Beaker Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"QwantiOS/(\\\\d+[\\\\.\\\\d]+)","name":"Qwant Mobile","version":"$1","engine":{"default":"WebKit"}},{"regex":"QwantMobile(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Qwant Mobile","version":"$1","engine":{"default":"Gecko"}},{"regex":"Qwant/(\\\\d+[\\\\.\\\\d]+)","name":"Qwant Mobile","version":"$1","engine":{"default":"Gecko"}},{"regex":"TenFourFox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"TenFourFox","version":"$1","engine":{"default":"Gecko"}},{"regex":"AOLShield(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"AOL Shield","version":"$1","engine":{"default":"Gecko"}},{"regex":"Edge[ /](\\\\d+[\\\\.\\\\d]+)","name":"Microsoft Edge","version":"$1","engine":{"default":"Edge"}},{"regex":"EdgiOS[ /](\\\\d+[\\\\.\\\\d]+)","name":"Microsoft Edge","version":"$1","engine":{"default":"WebKit"}},{"regex":"EdgA[ /](\\\\d+[\\\\.\\\\d]+)","name":"Microsoft Edge","version":"$1","engine":{"default":"Blink"}},{"regex":"Edg[ /](\\\\d+[\\\\.\\\\d]+)","name":"Microsoft Edge","version":"$1","engine":{"default":"Blink"}},{"regex":"QIHU 360[ES]E","name":"360 Browser","version":""},{"regex":"360 Aphone Browser(?: \\\\((\\\\d+[\\\\.\\\\d]+)(?:beta)?\\\\))?","name":"360 Phone Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"SailfishBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Sailfish Browser","version":"$1","engine":{"default":"Gecko"}},{"regex":"IceCat(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"IceCat","version":"$1","engine":{"default":"Gecko"}},{"regex":"Mobicip","name":"Mobicip","version":"","engine":{"default":"Gecko"}},{"regex":"Camino(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Camino","version":"$1","engine":{"default":"Gecko"}},{"regex":"Waterfox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Waterfox","version":"$1","engine":{"default":"Gecko"}},{"regex":"Chrome/.+ AlohaBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Aloha Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"AlohaBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Aloha Browser","version":"$1"},{"regex":"(?:Avast|ASW|Safer)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Avast Secure Browser","version":"$1"},{"regex":"Epic(?:/(\\\\d+[\\\\.\\\\d]+))","name":"Epic","version":"$1","engine":{"default":"Gecko"}},{"regex":"Fennec(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Fennec","version":"$1","engine":{"default":"Gecko"}},{"regex":"Firefox.*Tablet browser (\\\\d+[\\\\.\\\\d]+)","name":"MicroB","version":"$1","engine":{"default":"Gecko"}},{"regex":"Maemo Browser(?: (\\\\d+[\\\\.\\\\d]+))?","name":"MicroB","version":"$1","engine":{"default":"Gecko"}},{"regex":"Deepnet Explorer (\\\\d+[\\\\.\\\\d]+)?","name":"Deepnet Explorer","version":"$1"},{"regex":"Avant ?Browser","name":"Avant Browser","version":"","engine":{"default":""}},{"regex":"OppoBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Oppo Browser","version":"$1"},{"regex":"Chrome/(\\\\d+[\\\\.\\\\d]+).*MRCHROME","name":"Amigo","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"AtomicBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Atomic Web Browser","version":"$1"},{"regex":"Bunjalloo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Bunjalloo","version":"$1"},{"regex":"Brave(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Brave","version":"$1","engine":{"default":"Blink"}},{"regex":"Iridium(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Iridium","version":"$1"},{"regex":"Iceweasel(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Iceweasel","version":"$1","engine":{"default":"Gecko"}},{"regex":"WebPositive","name":"WebPositive","version":"","engine":{"default":"WebKit"}},{"regex":".*Goanna.*PaleMoon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Pale Moon","version":"$1","engine":{"default":"Goanna"}},{"regex":"PaleMoon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Pale Moon","version":"$1","engine":{"default":"Gecko"}},{"regex":"CometBird(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"CometBird","version":"$1","engine":{"default":"Gecko"}},{"regex":"IceDragon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"IceDragon","version":"$1","engine":{"default":"Gecko"}},{"regex":"Flock(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Flock","version":"$1","engine":{"default":"Gecko","versions":{"3":"WebKit"}}},{"regex":"JigBrowserPlus/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Jig Browser Plus","version":"$1"},{"regex":"jig browser(?: web;|9i?)?(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Jig Browser","version":"$1"},{"regex":"Kapiko(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Kapiko","version":"$1","engine":{"default":"Gecko"}},{"regex":"Kylo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Kylo","version":"$1","engine":{"default":"Gecko"}},{"regex":"Origin/(?:(\\\\d+[\\\\.\\\\d]+))?","name":"Origin In-Game Overlay","version":"$1"},{"regex":"Cunaguaro(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Cunaguaro","version":"$1"},{"regex":"(?:TO-Browser/TOB|DT-Browser/DTB)(\\\\d+[\\\\.\\\\d]+)","name":"t-online.de Browser","version":"$1"},{"regex":"Kazehakase(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Kazehakase","version":"$1","engine":{"default":""}},{"regex":"ArcticFox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Arctic Fox","version":"$1","engine":{"default":"Goanna"}},{"regex":"Mypal(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Mypal","version":"$1","engine":{"default":"Goanna"}},{"regex":"Centaury(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Centaury","version":"$1","engine":{"default":"Goanna"}},{"regex":"(?:Focus|Klar)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firefox Focus","version":"$1"},{"regex":"Cyberfox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Cyberfox","version":"$1","engine":{"default":"Gecko"}},{"regex":"Firefox/(\\\\d+[\\\\.\\\\d]+).*\\\\(Swiftfox\\\\)","name":"Swiftfox","version":"$1","engine":{"default":"Gecko"}},{"regex":"(?:Mobile|Tablet).*Servo.*Firefox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firefox Mobile","version":"$1","engine":{"default":"Servo"}},{"regex":"(?:Mobile|Tablet).*Firefox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firefox Mobile","version":"$1","engine":{"default":"Gecko"}},{"regex":"FxiOS/(\\\\d+[\\\\.\\\\d]+)","name":"Firefox Mobile iOS","version":"$1","engine":{"default":"WebKit"}},{"regex":".*Servo.*Firefox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firefox","version":"$1","engine":{"default":"Servo"}},{"regex":"(?!.*Opera[ /])Firefox(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firefox","version":"$1","engine":{"default":"Gecko"}},{"regex":"(?:BonEcho|GranParadiso|Lorentz|Minefield|Namoroka|Shiretoko)/(\\\\d+[\\\\.\\\\d]+)","name":"Firefox","version":"$1","engine":{"default":"Gecko"}},{"regex":"ANTFresco(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"ANT Fresco","version":"$1"},{"regex":"ANTGalio(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"ANTGalio","version":"$1"},{"regex":"(?:Espial|Escape)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Espial TV Browser","version":"$1"},{"regex":"RockMelt(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"RockMelt","version":"$1","engine":{"default":"WebKit"}},{"regex":"Fireweb Navigator(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Fireweb Navigator","version":"$1"},{"regex":"Fireweb(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Fireweb","version":"$1"},{"regex":"(?:Navigator|Netscape6?)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Netscape","version":"$1","engine":{"default":""}},{"regex":"(?:Polarity)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Polarity","version":"$1"},{"regex":"(?:QupZilla)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"QupZilla","version":"$1"},{"regex":"(?:Dooble)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Dooble","version":"$1"},{"regex":"Whale/(\\\\d+[\\\\.\\\\d]+)","name":"Whale Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Obigo[ ]?(?:InternetBrowser|Browser)?(?:[ /]([a-z0-9]*))?","name":"Obigo","version":"$1"},{"regex":"Obigo|Teleca","name":"Obigo","version":""},{"regex":"UCBrowserHD/(\\\\d[\\\\d\\\\.]+)","name":"UC Browser HD","version":"$1"},{"regex":"UCMini(?:[ /]?(\\\\d+[\\\\.\\\\d]+))?","name":"UC Browser Mini","version":"$1"},{"regex":"UC[ ]?Browser.* \\\\(UCMini\\\\)","name":"UC Browser Mini","version":""},{"regex":"UCTurbo(?:[ /]?(\\\\d+[\\\\.\\\\d]+))?","name":"UC Browser Turbo","version":"$1"},{"regex":"UC[ ]?Browser.* \\\\(UCTurbo\\\\)","name":"UC Browser Turbo","version":""},{"regex":"OPRGX(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Opera GX","version":"$1","engine":{"default":"Blink"}},{"regex":"(?:Opera Tablet.*Version|Opera/.+Opera Mobi.+Version|Mobile.+OPR)/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Mobile","version":"$1","engine":{"default":"Presto","versions":{"15":"Blink"}}},{"regex":"MMS/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Neon","version":"$1","engine":{"default":"Blink"}},{"regex":"OMI/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Devices","version":"$1","engine":{"default":"Blink"}},{"regex":"Opera%20Touch/(\\\\d+[\\\\.\\\\d]+)? CFNetwork/.+Darwin/.+(?!.*x86_64)","name":"Opera Touch","version":"$1","engine":{"default":"WebKit"}},{"regex":"OPT/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Touch","version":"$1","engine":{"default":"Blink"}},{"regex":"Opera/(\\\\d+[\\\\.\\\\d]+).+Opera Mobi","name":"Opera Mobile","version":"$1","engine":{"default":"Presto","versions":{"15":"Blink"}}},{"regex":"Opera ?Mini/(?:att/)?(\\\\d+[\\\\.\\\\d]+)","name":"Opera Mini","version":"$1","engine":{"default":"Presto"}},{"regex":"Opera ?Mini.+Version/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Mini","version":"$1","engine":{"default":"Presto"}},{"regex":"OPiOS/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Mini iOS","version":"$1","engine":{"default":"WebKit"}},{"regex":"Opera%20Mini/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Opera Mini iOS","version":"$1","engine":{"default":"WebKit"}},{"regex":"Opera.+Edition Next.+Version/(\\\\d+[\\\\.\\\\d]+)","name":"Opera Next","version":"$1","engine":{"default":"Presto","versions":{"15":"Blink"}}},{"regex":"(?:Opera|OPR)[/ ](?:9.80.*Version/)?(\\\\d+[\\\\.\\\\d]+).+Edition Next","name":"Opera Next","version":"$1","engine":{"default":"Presto","versions":{"15":"Blink"}}},{"regex":"(?:Opera[/ ]?|OPR[/ ])(?:9.80.*Version/)?(\\\\d+[\\\\.\\\\d]+)","name":"Opera","version":"$1","engine":{"default":"","versions":{"7":"Presto","15":"Blink","3.5":"Elektra"}}},{"regex":"rekonq(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Rekonq","version":"$1","engine":{"default":"WebKit"}},{"regex":"CoolNovo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"CoolNovo","version":"$1","engine":{"default":""}},{"regex":"(?:Comodo[ _])?Dragon(?!fruit)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Comodo Dragon","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"ChromePlus(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"ChromePlus","version":"$1","engine":{"default":""}},{"regex":"Conkeror(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Conkeror","version":"$1","engine":{"default":"Gecko"}},{"regex":"Konqueror(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Konqueror","version":"$1","engine":{"default":"KHTML","versions":{"4":""}}},{"regex":"(?:baidubrowser|bdbrowser(?:(?:hd)?_i18n)?|FlyFlow|BaiduHD)(?:[/ ](\\\\d+[\\\\.\\\\d]*))?","name":"Baidu Browser","version":"$1"},{"regex":"(?:(?:BD)?Spark(?:Safe)?|BIDUBrowser)[/ ](\\\\d+[\\\\.\\\\d]*)","name":"Baidu Spark","version":"$1"},{"regex":"YaBrowser(?:/(\\\\d+[\\\\.\\\\d]*)) \\\\(lite\\\\)?","name":"Yandex Browser Lite","version":"$1","engine":{"default":"Blink"}},{"regex":"YaBrowser(?:/(\\\\d+[\\\\.\\\\d]*))(?: \\\\((alpha|beta)\\\\))?","name":"Yandex Browser","version":"$1 $2","engine":{"default":"Blink"}},{"regex":"Ya(?:ndex)?SearchBrowser(?:/(\\\\d+[\\\\.\\\\d]*))","name":"Yandex Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Vivaldi(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Vivaldi","version":"$1","engine":{"default":"Blink"}},{"regex":"TweakStyle(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"TweakStyle","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome.+Midori Browser/(\\\\d+[\\\\.\\\\d]+)","name":"Midori","version":"$1","engine":{"default":"Blink"}},{"regex":"Midori(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Midori","version":"$1","engine":{"default":"WebKit"}},{"regex":"Mercury(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Mercury","version":"$1"},{"regex":"Chrome.+Maxthon(?:.+\\\\(portable\\\\))?/(\\\\d+[\\\\.\\\\d]+)","name":"Maxthon","version":"$1","engine":{"default":"WebKit","versions":{"5.2":"Blink"}}},{"regex":"(?:Maxthon(?:%20Browser)?|MxBrowser(?:-inhouse|-iPhone)?)[ /](\\\\d+[\\\\.\\\\d]+)","name":"Maxthon","version":"$1","engine":{"default":"","versions":{"3":"WebKit"}}},{"regex":"(?:Maxthon|MyIE2)","name":"Maxthon","version":"","engine":{"default":""}},{"regex":"Puffin(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Puffin","version":"$1"},{"regex":"MobileIron(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Iron Mobile","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome(?:/(\\\\d+[\\\\.\\\\d]+))?.*Iron","name":"Iron","version":"$1","engine":{"default":"WebKit"}},{"regex":"Iron(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Iron","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"Epiphany(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"GNOME Web","version":"$1","engine":{"default":"Gecko","versions":{"2.9.16":"","2.28":"WebKit"}}},{"regex":"LieBaoFast(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"LieBaoFast","version":"$1"},{"regex":"LBBrowser(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Cheetah Browser","version":"$1"},{"regex":"SE (\\\\d+[\\\\.\\\\d]+)","name":"Sogou Explorer","version":"$1"},{"regex":"QQBrowserLite/([\\\\d\\\\.]+)","name":"QQ Browser Lite","version":"$1"},{"regex":"M?QQBrowser/Mini([\\\\.\\\\d]+)?","name":"QQ Browser Mini","version":"$1","engine":{"default":""}},{"regex":"M?QQBrowser(?:/([\\\\.\\\\d]+))?","name":"QQ Browser","version":"$1","engine":{"default":""}},{"regex":"(?:MIUIBrowser|MiuiBrowser)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"MIUI Browser","version":"$1","engine":{"default":""}},{"regex":"(?:coc_coc_browser|coccocbrowser|CocCoc)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Coc Coc","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"DuckDuckGo/(\\\\d+[\\\\.\\\\d]*)","name":"DuckDuckGo Privacy Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"Samsung ?Browser(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Samsung Browser","version":"$1"},{"regex":"(?:SFB(?:rowser)?)/(\\\\d+[\\\\.\\\\d]+)","name":"Super Fast Browser","version":"$1"},{"regex":"com.browser.tssomas(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Super Fast Browser","version":"$1"},{"regex":"EUI Browser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"EUI Browser","version":"$1"},{"regex":"UBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"UBrowser","version":"$1"},{"regex":"Streamy(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Streamy","version":"$1","engine":{"default":"WebKit"}},{"regex":"isivioo","name":"Isivioo","version":"","engine":{"default":"WebKit"}},{"regex":"UC[ ]?Browser(?:[ /]?(\\\\d+[\\\\.\\\\d]+))?","name":"UC Browser","version":"$1"},{"regex":"UCWEB(?:[ /]?(\\\\d+[\\\\.\\\\d]+))?","name":"UC Browser","version":"$1"},{"regex":"UC AppleWebKit","name":"UC Browser","version":""},{"regex":"Tenta/(\\\\d+[\\\\.\\\\d]+)","name":"Tenta Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"Rocket/(\\\\d+[\\\\.\\\\d]+)","name":"Firefox Rocket","version":"$1","engine":{"default":"WebKit"}},{"regex":"Web Explorer/(\\\\d+[\\\\.\\\\d]+).*Chrome","name":"Web Explorer","version":"$1","engine":{"default":"WebKit"}},{"regex":"SznProhlizec/(\\\\d+[\\\\.\\\\d]+)","name":"Seznam Browser","version":"$1","engine":{"default":"Blink"}},{"regex":"SogouMobileBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"Sogou Mobile Browser","version":"$1","engine":{"default":""}},{"regex":"Mint Browser/(\\\\d+[\\\\.\\\\d]+)","name":"Mint Browser","version":"$1","engine":{"default":""}},{"regex":"Ecosia (?:android|ios)@(\\\\d+[\\\\.\\\\d]+)","name":"Ecosia","version":"$1","engine":{"default":""}},{"regex":"ACHEETAHI","name":"CM Browser","version":"","engine":{"default":""}},{"regex":"Kiwi Chrome","name":"Kiwi","version":"","engine":{"default":""}},{"regex":"Mb2345Browser/(\\\\d+[\\\\.\\\\d]+)","name":"2345 Browser","version":"$1","engine":{"default":""}},{"regex":"QtWebEngine/(\\\\d+[\\\\.\\\\d]+)","name":"QtWebEngine","version":"$1","engine":{"default":""}},{"regex":"Silk/(\\\\d+[\\\\.\\\\d]+) like Chrome","name":"Mobile Silk","version":"$1","engine":{"default":"Blink"}},{"regex":"Silk(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Mobile Silk","version":"$1","engine":{"default":"WebKit"}},{"regex":"IBrowse(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"IBrowse","version":"$1"},{"regex":"UP.Browser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Openwave Mobile Browser","version":"$1"},{"regex":"Openwave(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Openwave Mobile Browser","version":"$1"},{"regex":"OneBrowser(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"ONE Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"(?:NokiaBrowser|BrowserNG)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Nokia Browser","version":"$1"},{"regex":"Series60/5\\\\.0","name":"Nokia Browser","version":"7.0"},{"regex":"Series60/(\\\\d+[\\\\.\\\\d]+)","name":"Nokia OSS Browser","version":"$1"},{"regex":"S40OviBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"Nokia Ovi Browser","version":"$1"},{"regex":"^Nokia|Nokia[EN]?\\\\d+","name":"Nokia Browser","version":""},{"regex":"Sleipnir(?:(?:%20Browser)?[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Sleipnir","version":"$1","engine":{"default":""}},{"regex":"NTENTBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NTENT Browser","version":"$1"},{"regex":"TV Bro/(\\\\d+[\\\\.\\\\d]+)","name":"TV Bro","version":"$1"},{"regex":"Chrome/.+ Quark(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Quark","version":"$1","engine":{"default":"WebKit"}},{"regex":"MonumentBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Monument Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"BlueBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Blue Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"JAPAN Browser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Japan Browser","version":"$1","engine":{"default":"WebKit"}},{"regex":"Version/.* Chrome(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chrome Webview","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"CrMo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chrome Mobile","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"CriOS(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chrome Mobile iOS","version":"$1","engine":{"default":"WebKit"}},{"regex":"Chrome(?:/(\\\\d+[\\\\.\\\\d]+))? Mobile","name":"Chrome Mobile","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"chromeframe(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chrome Frame","version":"$1","engine":{"default":"WebKit"}},{"regex":"Chromium(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chromium","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"HeadlessChrome(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Headless Chrome","version":"$1","engine":{"default":"Blink"}},{"regex":"Chrome(?!book)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Chrome","version":"$1","engine":{"default":"WebKit","versions":{"28":"Blink"}}},{"regex":"(?:Tizen|SLP) Browser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Tizen Browser","version":"$1"},{"regex":"Blazer(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Palm Blazer","version":"$1"},{"regex":"Pre/(\\\\d+[\\\\.\\\\d]+)","name":"Palm Pre","version":"$1"},{"regex":"(?:hpw|web)OS/(\\\\d+[\\\\.\\\\d]+)","name":"wOSBrowser","version":"$1"},{"regex":"WebPro(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Palm WebPro","version":"$1"},{"regex":"Palmscape(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Palmscape","version":"$1"},{"regex":"Jasmine(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Jasmine","version":"$1"},{"regex":"Lynx(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Lynx","version":"$1","engine":{"default":"Text-based"}},{"regex":"NCSA_Mosaic(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NCSA Mosaic","version":"$1"},{"regex":"ABrowse(?: (\\\\d+[\\\\.\\\\d]+))?","name":"ABrowse","version":"$1"},{"regex":"amaya(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Amaya","version":"$1"},{"regex":"AmigaVoyager(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Amiga Voyager","version":"$1"},{"regex":"Amiga-Aweb(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Amiga Aweb","version":"$1"},{"regex":"Arora(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Arora","version":"$1","engine":{"default":"WebKit"}},{"regex":"Beonex(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Beonex","version":"$1","engine":{"default":"Gecko"}},{"regex":"bline(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"B-Line","version":"$1","engine":{"default":"WebKit"}},{"regex":"BrowseX \\\\((\\\\d+[\\\\.\\\\d]+)","name":"BrowseX","version":"$1"},{"regex":"Charon(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Charon","version":"$1"},{"regex":"Cheshire(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Cheshire","version":"$1"},{"regex":"dbrowser","name":"dbrowser","version":"","engine":{"default":"WebKit"}},{"regex":"Dillo(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Dillo","version":"$1","engine":{"default":"Dillo"}},{"regex":"Dolfin(?:/(\\\\d+[\\\\.\\\\d]+))?|dolphin","name":"Dolphin","version":"$1","engine":{"default":"WebKit"}},{"regex":"Elinks(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Elinks","version":"$1","engine":{"default":"Text-based"}},{"regex":"Element Browser(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Element Browser","version":"$1"},{"regex":"eZBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"eZ Browser","version":"$1"},{"regex":"Firebird(?! Build)(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Firebird","version":"$1","engine":{"default":"Gecko"}},{"regex":"Fluid(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Fluid","version":"$1","engine":{"default":"WebKit"}},{"regex":"Galeon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Galeon","version":"$1","engine":{"default":"Gecko"}},{"regex":"Google Earth(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Google Earth","version":"$1","engine":{"default":"WebKit"}},{"regex":"HotJava(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"HotJava","version":"$1"},{"regex":"iCabMobile(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"iCab Mobile","version":"$1","engine":{"default":"WebKit"}},{"regex":"iCab(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"iCab","version":"$1","engine":{"default":"iCab","versions":{"4":"WebKit"}}},{"regex":"i?Lunascape(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Lunascape","version":"$1","engine":{"default":""}},{"regex":"Crazy Browser (\\\\d+[\\\\.\\\\d]+)","name":"Crazy Browser","version":"$1","engine":{"default":"Trident"}},{"regex":"IEMobile[ /](\\\\d+[\\\\.\\\\d]+)","name":"IE Mobile","version":"$1","engine":{"default":"Trident"}},{"regex":"MSIE (\\\\d+[\\\\.\\\\d]+).*XBLWP7","name":"IE Mobile","version":"$1","engine":{"default":"Trident"}},{"regex":"MSIE.*Trident/4.0","name":"Internet Explorer","version":"8.0","engine":{"default":"Trident"}},{"regex":"MSIE.*Trident/5.0","name":"Internet Explorer","version":"9.0","engine":{"default":"Trident"}},{"regex":"MSIE.*Trident/6.0","name":"Internet Explorer","version":"10.0","engine":{"default":"Trident"}},{"regex":"Trident/[78].0","name":"Internet Explorer","version":"11.0","engine":{"default":"Trident"}},{"regex":"MSIE (\\\\d+[\\\\.\\\\d]+)","name":"Internet Explorer","version":"$1","engine":{"default":"Trident"}},{"regex":"IE[ /](\\\\d+[\\\\.\\\\d]+)","name":"Internet Explorer","version":"$1","engine":{"default":"Trident"}},{"regex":"Kindle/(\\\\d+[\\\\.\\\\d]+)","name":"Kindle Browser","version":"$1"},{"regex":"K-meleon(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"K-meleon","version":"$1","engine":{"default":"Gecko"}},{"regex":"Links(?: \\\\((\\\\d+[\\\\.\\\\d]+))?","name":"Links","version":"$1","engine":{"default":"Text-based"}},{"regex":"LG Browser(?:/(\\\\d+[\\\\.\\\\d]+))","name":"LG Browser","version":"$1"},{"regex":"LuaKit(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"LuaKit","version":"$1"},{"regex":"OmniWeb(?:/[v]?(\\\\d+[\\\\.\\\\d]+))?","name":"OmniWeb","version":"$1","engine":{"default":"WebKit"}},{"regex":"Phoenix(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Phoenix","version":"$1"},{"regex":"NetFrontLifeBrowser(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NetFront Life","version":"$1","engine":{"default":"NetFront"}},{"regex":"NetFront(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NetFront","version":"$1","engine":{"default":"NetFront"}},{"regex":"PLAYSTATION|NINTENDO 3|AppleWebKit.+ N[XF]/\\\\d+\\\\.\\\\d+\\\\.\\\\d+","name":"NetFront","version":""},{"regex":"NetPositive(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NetPositive","version":"$1"},{"regex":"Odyssey Web Browser(?:.*OWB/(\\\\d+[\\\\.\\\\d]+))?","name":"Odyssey Web Browser","version":"$1"},{"regex":"OffByOne","name":"Off By One","version":""},{"regex":"(?:Oregano|OreganMediaBrowser)(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Oregano","version":"$1"},{"regex":"(?:Polaris|Embider)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Polaris","version":"$1"},{"regex":"SEMC-Browser(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"SEMC-Browser","version":"$1"},{"regex":"Shiira(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Shiira","version":"$1","engine":{"default":"WebKit"}},{"regex":"Skyfire(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Skyfire","version":"$1"},{"regex":"Snowshoe(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Snowshoe","version":"$1","engine":{"default":"WebKit"}},{"regex":"Sunrise(?:Browser)?(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Sunrise","version":"$1"},{"regex":"SuperBird(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"SuperBird","version":"$1"},{"regex":"Vision-Browser(?:/(\\\\d+[\\\\.\\\\d]+))","name":"Vision Mobile Browser","version":"$1"},{"regex":"WeTab-Browser","name":"WeTab Browser","version":""},{"regex":"Xiino(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Xiino","version":"$1"},{"regex":"BlackBerry|PlayBook|BB10","name":"BlackBerry Browser","version":""},{"regex":"Android","name":"Android Browser","version":"","engine":{"default":"WebKit"}},{"regex":"Coast(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Coast","version":"$1"},{"regex":"Surf(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"surf","version":"$1","engine":{"default":"WebKit"}},{"regex":"(?:(?:iPod|iPad|iPhone).+Version|MobileSafari)/(\\\\d+[\\\\.\\\\d]+)","name":"Mobile Safari","version":"$1","engine":{"default":"WebKit"}},{"regex":"(?:Version/(\\\\d+[\\\\.\\\\d]+).*)?Mobile.*Safari/","name":"Mobile Safari","version":"$1","engine":{"default":"WebKit"}},{"regex":"(?:iPod|iPhone|iPad)","name":"Mobile Safari","version":"","engine":{"default":"WebKit"}},{"regex":"Version/(\\\\d+[\\\\.\\\\d]+).*Safari/|Safari/?\\\\d+","name":"Safari","version":"$1","engine":{"default":"WebKit"}},{"regex":"Dorado WAP-Browser[/ ](\\\\d+[\\\\.\\\\d]+)","name":"Dorado","version":"$1"},{"regex":"NetSurf(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"NetSurf","version":"$1","engine":{"default":"NetSurf"}},{"regex":"Uzbl","name":"Uzbl","version":""},{"regex":"SimpleBrowser","name":"SimpleBrowser","version":""},{"regex":"Zvu(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"Zvu","version":"$1","engine":{"default":"Gecko"}},{"regex":"GOGGalaxyClient/(\\\\d+[\\\\.\\\\d]+)?","name":"GOG Galaxy","version":"$1"},{"regex":"WAP Browser/MAUI|(?:\\\\w+)?Maui Wap Browser|MAUI[- ]Browser","name":"MAUI WAP Browser","version":""},{"regex":"SP%20Browser/(\\\\d+[\\\\.\\\\d]+)","name":"SP Browser","version":"$1","engine":{"default":"WebKit"}}]'), LX = [
  {
    regex: "NetFront",
    name: "NetFront"
  },
  {
    regex: "Edge",
    name: "Edge"
  },
  {
    regex: "Trident",
    name: "Trident"
  },
  {
    regex: "(?<!SmartHu)Blink",
    name: "Blink"
  },
  {
    regex: "(?:Apple)?WebKit",
    name: "WebKit"
  },
  {
    regex: "Presto",
    name: "Presto"
  },
  {
    regex: "Goanna",
    name: "Goanna"
  },
  {
    regex: "(?<!like )Gecko",
    name: "Gecko"
  },
  {
    regex: "KHTML",
    name: "KHTML"
  },
  {
    regex: "NetSurf",
    name: "NetSurf"
  },
  {
    regex: "Servo",
    name: "Servo"
  },
  {
    regex: "Goanna",
    name: "Goanna"
  },
  {
    regex: "Ekioh(?:Flow)?",
    name: "EkiohFlow"
  }
], EX = "Avant Browser", OX = "ABrowse", NX = "ANT Fresco", DX = "ANTGalio", kX = "Aloha Browser", GX = "Aloha Browser Lite", BX = "Amaya", IX = "Amigo", RX = "Android Browser", FX = "AOL Desktop", VX = "AOL Shield", HX = "Arora", UX = "Arctic Fox", XX = "Amiga Voyager", WX = "Amiga Aweb", YX = "Atom", KX = "Atomic Web Browser", QX = "Avast Secure Browser", jX = "AVG Secure Browser", ZX = "Avira Scout", zX = "AwoX", qX = "Beaker Browser", JX = "Beamrise", eW = "BlackBerry Browser", tW = "Baidu Browser", rW = "Baidu Spark", oW = "Basilisk", nW = "Beonex", aW = "BlackHawk", lW = "Bunjalloo", iW = "B-Line", sW = "Blue Browser", dW = "Borealis Navigator", uW = "Brave", cW = "BriskBard", mW = "BrowseX", gW = "Browzar", fW = "Biyubi", pW = "Byffox", hW = "Camino", xW = "CCleaner", vW = "Chedot", SW = "Centaury", bW = "Coc Coc", yW = "CoolBrowser", wW = "Colibri", _W = "Comodo Dragon", TW = "Coast", AW = "Charon", PW = "CM Browser", MW = "Chrome Frame", $W = "Headless Chrome", CW = "Chrome", LW = "Chrome Mobile iOS", EW = "Conkeror", OW = "Chrome Mobile", NW = "CoolNovo", DW = "CometBird", kW = "COS Browser", GW = "Cornowser", BW = "Chim Lac", IW = "ChromePlus", RW = "Chromium", FW = "Chromium GOST", VW = "Cyberfox", HW = "Cheshire", UW = "Crusta", XW = "Craving Explorer", WW = "Crazy Browser", YW = "Cunaguaro", KW = "Chrome Webview", QW = "dbrowser", jW = "Deepnet Explorer", ZW = "deg-degan", zW = "Deledao", qW = "Delta Browser", JW = "DeskBrowse", eY = "Dolphin", tY = "Dorado", rY = "Dot Browser", oY = "Dooble", nY = "Dillo", aY = "DuckDuckGo Privacy Browser", lY = "Ecosia", iY = "Epic", sY = "Elinks", dY = "Element Browser", uY = "Elements Browser", cY = "eZ Browser", mY = "EUI Browser", gY = "GNOME Web", fY = "Espial TV Browser", pY = "Falkon", hY = "Faux Browser", xY = "Firefox Mobile iOS", vY = "Firebird", SY = "Fluid", bY = "Fennec", yY = "Firefox", wY = "Firefox Focus", _Y = "Firefox Reality", TY = "Firefox Rocket", AY = "Flock", PY = "Flow", MY = "Firefox Mobile", $Y = "Fireweb", CY = "Fireweb Navigator", LY = "Flast", EY = "FreeU", OY = "Galeon", NY = "Ghostery Privacy Browser", DY = "GinxDroid Browser", kY = "Glass Browser", GY = "Google Earth", BY = "GOG Galaxy", IY = "HasBrowser", RY = "Hawk Turbo Browser", FY = "Helio", VY = "hola! Browser", HY = "HotJava", UY = "Huawei Browser", XY = "IBrowse", WY = "iCab", YY = "iCab Mobile", KY = "Iridium", QY = "Iron Mobile", jY = "IceCat", ZY = "IceDragon", zY = "Isivioo", qY = "Iceweasel", JY = "Internet Explorer", eK = "IE Mobile", tK = "Iron", rK = "Japan Browser", oK = "Jasmine", nK = "JavaFX", aK = "Jig Browser", lK = "Jig Browser Plus", iK = "Jio Browser", sK = "K.Browser", dK = "Kindle Browser", uK = "K-meleon", cK = "Konqueror", mK = "Kapiko", gK = "Kinza", fK = "Kiwi", pK = "Kode Browser", hK = "Kylo", xK = "Kazehakase", vK = "Cheetah Browser", SK = "LieBaoFast", bK = "LG Browser", yK = "Light", wK = "Links", _K = "Lolifox", TK = "Lovense Browser", AK = "LuaKit", PK = "Lulumi", MK = "Lunascape", $K = "Lunascape Lite", CK = "Lynx", LK = "mCent", EK = "MicroB", OK = "NCSA Mosaic", NK = "Meizu Browser", DK = "Mercury", kK = "Mobile Safari", GK = "Midori", BK = "Mobicip", IK = "MIUI Browser", RK = "Mobile Silk", FK = "Minimo", VK = "Mint Browser", HK = "Maxthon", UK = "MxNitro", XK = "Mypal", WK = "Monument Browser", YK = "MAUI WAP Browser", KK = "Navigateur Web", QK = "NFS Browser", jK = "Nokia Browser", ZK = "Nokia OSS Browser", zK = "Nokia Ovi Browser", qK = "Nox Browser", JK = "NetSurf", eQ = "NetFront", tQ = "NetFront Life", rQ = "NetPositive", oQ = "Netscape", nQ = "NTENT Browser", aQ = "Oculus Browser", lQ = "Opera Mini iOS", iQ = "Obigo", sQ = "Odin", dQ = "OceanHero", uQ = "Odyssey Web Browser", cQ = "Off By One", mQ = "OhHai Browser", gQ = "ONE Browser", fQ = "Opera GX", pQ = "Opera Neon", hQ = "Opera Devices", xQ = "Opera Mini", vQ = "Opera Mobile", SQ = "Opera", bQ = "Opera Next", yQ = "Opera Touch", wQ = "Orca", _Q = "Ordissimo", TQ = "Oregano", AQ = "Origin In-Game Overlay", PQ = "Origyn Web Browser", MQ = "Openwave Mobile Browser", $Q = "OmniWeb", CQ = "Otter Browser", LQ = "Palm Blazer", EQ = "Pale Moon", OQ = "Polypane", NQ = "Oppo Browser", DQ = "Palm Pre", kQ = "Puffin", GQ = "Palm WebPro", BQ = "Palmscape", IQ = "Perfect Browser", RQ = "Phantom Browser", FQ = "Phoenix", VQ = "Phoenix Browser", HQ = "PlayFree Browser", UQ = "Polaris", XQ = "Polarity", WQ = "PolyBrowser", YQ = "PrivacyWall", KQ = "Microsoft Edge", QQ = "Qazweb", jQ = "QQ Browser Lite", ZQ = "QQ Browser Mini", zQ = "QQ Browser", qQ = "Qutebrowser", JQ = "Quark", ej = "QupZilla", tj = "Qwant Mobile", rj = "QtWebEngine", oj = "Realme Browser", nj = "Rekonq", aj = "RockMelt", lj = "Samsung Browser", ij = "Sailfish Browser", sj = "Seewo Browser", dj = "SEMC-Browser", uj = "Sogou Explorer", cj = "Safari", mj = "Safe Exam Browser", gj = "SalamWeb", fj = "SFive", pj = "Shiira", hj = "SimpleBrowser", xj = "Sizzy", vj = "Skyfire", Sj = "Seraphic Sraf", bj = "Sleipnir", yj = "Slimjet", wj = "SP Browser", _j = "Smart Lenovo Browser", Tj = "Smooz", Aj = "Snowshoe", Pj = "Sogou Mobile Browser", Mj = "Splash", $j = "Sputnik Browser", Cj = "Sunrise", Lj = "SuperBird", Ej = "Super Fast Browser", Oj = "surf", Nj = "Stargon", Dj = "START Internet Browser", kj = "Steam In-Game Overlay", Gj = "Streamy", Bj = "Swiftfox", Ij = "Seznam Browser", Rj = "T-Browser", Fj = "t-online.de Browser", Vj = "Tao Browser", Hj = "TenFourFox", Uj = "Tenta Browser", Xj = "Tizen Browser", Wj = "Tungsten", Yj = "ToGate", Kj = "TweakStyle", Qj = "TV Bro", jj = "UBrowser", Zj = "UC Browser", zj = "UC Browser HD", qj = "UC Browser Mini", Jj = "UC Browser Turbo", eZ = "UR Browser", tZ = "Uzbl", rZ = "Venus Browser", oZ = "Vivaldi", nZ = "vivo Browser", aZ = "Vision Mobile Browser", lZ = "VMware AirWatch", iZ = "Wear Internet Browser", sZ = "Web Explorer", dZ = "WebPositive", uZ = "Waterfox", cZ = "Whale Browser", mZ = "wOSBrowser", gZ = "WeTab Browser", fZ = "Yahoo! Japan Browser", pZ = "Yandex Browser", hZ = "Yandex Browser Lite", xZ = "Yaani Browser", vZ = "Yolo Browser", SZ = "xStand", bZ = "Xiino", yZ = "Xvast", wZ = "Zetakey", _Z = "Zvu", TZ = {
  36: "360 Phone Browser",
  "1B": "115 Browser",
  "2B": "2345 Browser",
  "3B": "360 Browser",
  "7B": "7654 Browser",
  AA: EX,
  AB: OX,
  AF: NX,
  AG: DX,
  AL: kX,
  AH: GX,
  AM: BX,
  AO: IX,
  AN: RX,
  AE: FX,
  AD: VX,
  AR: HX,
  AX: UX,
  AV: XX,
  AW: WX,
  A0: YX,
  AT: KX,
  AS: QX,
  VG: jX,
  AC: ZX,
  A1: zX,
  BA: qX,
  BM: JX,
  BB: eW,
  BD: tW,
  BS: rW,
  BI: oW,
  BE: nW,
  BH: aW,
  BJ: lW,
  BL: iW,
  BU: sW,
  BN: dW,
  BR: uW,
  BK: cW,
  BX: mW,
  BZ: gW,
  BY: fW,
  BF: pW,
  CA: hW,
  CL: xW,
  C6: vW,
  C0: SW,
  CC: bW,
  C4: yW,
  C2: wW,
  CD: _W,
  C1: TW,
  CX: AW,
  CE: PW,
  CF: MW,
  HC: $W,
  CH: CW,
  CI: LW,
  CK: EW,
  CM: OW,
  CN: NW,
  CO: DW,
  CB: kW,
  CW: GW,
  C3: BW,
  CP: IW,
  CR: RW,
  C5: FW,
  CY: VW,
  CS: HW,
  CT: UW,
  CG: XW,
  CZ: WW,
  CU: YW,
  CV: KW,
  DB: QW,
  DE: jW,
  DG: ZW,
  DA: zW,
  DT: qW,
  DS: JW,
  DF: eY,
  DO: tY,
  DR: rY,
  DL: oY,
  DI: nY,
  DD: aY,
  EC: lY,
  EI: iY,
  EL: sY,
  EB: dY,
  EE: uY,
  EZ: cY,
  EU: mY,
  EP: gY,
  ES: fY,
  FA: pY,
  FX: hY,
  F1: xY,
  FB: vY,
  FD: SY,
  FE: bY,
  FF: yY,
  FK: wY,
  FY: _Y,
  FR: TY,
  FL: AY,
  FO: PY,
  FM: MY,
  FW: $Y,
  FN: CY,
  FS: LY,
  FU: EY,
  GA: OY,
  GH: NY,
  GI: DY,
  GB: kY,
  GE: GY,
  GO: BY,
  HS: IY,
  HA: RY,
  HE: FY,
  HO: VY,
  HJ: HY,
  HU: UY,
  IB: XY,
  IC: WY,
  I2: YY,
  I1: KY,
  I3: QY,
  I4: jY,
  ID: ZY,
  IV: zY,
  IW: qY,
  IE: JY,
  IM: eK,
  IR: tK,
  JB: rK,
  JS: oK,
  JA: nK,
  JI: aK,
  JP: lK,
  JO: iK,
  KB: sK,
  KI: dK,
  KM: uK,
  KO: cK,
  KP: mK,
  KN: gK,
  KW: fK,
  KD: pK,
  KY: hK,
  KZ: xK,
  LB: vK,
  LF: SK,
  LG: bK,
  LH: yK,
  LI: wK,
  IF: _K,
  LO: TK,
  LU: AK,
  LL: PK,
  LS: MK,
  LN: $K,
  LX: CK,
  M1: LK,
  MB: EK,
  MC: OK,
  MZ: NK,
  ME: DK,
  MF: kK,
  MI: GK,
  MO: BK,
  MU: IK,
  MS: RK,
  MN: FK,
  MT: VK,
  MX: HK,
  NM: UK,
  MY: XK,
  MR: WK,
  MW: YK,
  NW: KK,
  NR: QK,
  NB: jK,
  NO: ZK,
  NV: zK,
  NX: qK,
  NE: JK,
  NF: eQ,
  NL: tQ,
  NP: rQ,
  NS: oQ,
  NT: nQ,
  OC: aQ,
  O1: lQ,
  OB: iQ,
  O2: sQ,
  H2: dQ,
  OD: uQ,
  OF: cQ,
  HH: mQ,
  OE: gQ,
  OX: fQ,
  OG: pQ,
  OH: hQ,
  OI: xQ,
  OM: vQ,
  OP: SQ,
  ON: bQ,
  OO: yQ,
  OA: wQ,
  OS: _Q,
  OR: TQ,
  O0: AQ,
  OY: PQ,
  OV: MQ,
  OW: $Q,
  OT: CQ,
  PL: LQ,
  PM: EQ,
  PY: OQ,
  PP: NQ,
  PR: DQ,
  PU: kQ,
  PW: GQ,
  PA: BQ,
  PE: IQ,
  PH: RQ,
  PX: FQ,
  PB: VQ,
  PF: HQ,
  PO: UQ,
  PT: XQ,
  LY: WQ,
  PI: YQ,
  PS: KQ,
  QA: QQ,
  Q2: jQ,
  Q1: ZQ,
  QQ: zQ,
  QT: qQ,
  QU: JQ,
  QZ: ej,
  QM: tj,
  QW: rj,
  RE: oj,
  RK: nj,
  RM: aj,
  SB: lj,
  SA: ij,
  S8: sj,
  SC: dj,
  SE: uj,
  SF: cj,
  S5: mj,
  SW: gj,
  SV: fj,
  SH: pj,
  S1: hj,
  SY: xj,
  SK: vj,
  SS: Sj,
  SL: bj,
  S6: yj,
  S7: wj,
  "7S": "7Star",
  LE: _j,
  OZ: Tj,
  SN: Aj,
  SO: Pj,
  S2: Mj,
  SI: $j,
  SR: Cj,
  SP: Lj,
  SU: Ej,
  S3: Oj,
  SG: Nj,
  S0: Dj,
  S4: kj,
  ST: Gj,
  SX: Bj,
  SZ: Ij,
  TR: Rj,
  TO: Fj,
  TA: Vj,
  TF: Hj,
  TB: Uj,
  TZ: Xj,
  TU: Wj,
  TG: Yj,
  TS: Kj,
  TV: Qj,
  UB: jj,
  UC: Zj,
  UH: zj,
  UM: qj,
  UT: Jj,
  UR: eZ,
  UZ: tZ,
  VE: rZ,
  VI: oZ,
  VV: nZ,
  VB: aZ,
  VM: lZ,
  WI: iZ,
  WP: sZ,
  WE: dZ,
  WF: uZ,
  WH: cZ,
  WO: mZ,
  WT: gZ,
  YJ: fZ,
  YA: pZ,
  YL: hZ,
  YN: xZ,
  YB: vZ,
  XS: SZ,
  XI: bZ,
  XV: yZ,
  ZE: wZ,
  ZV: _Z
}, AZ = [
  "36",
  "OC",
  "PU",
  "SK",
  "MF",
  "OI",
  "OM",
  "DD",
  "DB",
  "ST",
  "BL",
  "IV",
  "FM",
  "C1",
  "C4",
  "SA",
  "SB",
  "FR",
  "WP",
  "HA",
  "NX",
  "HU",
  "VV",
  "RE",
  "CB",
  "MZ",
  "UM",
  "FK",
  "FX",
  "WI",
  "MN",
  "M1",
  "AH",
  "SU",
  "EU",
  "EZ",
  "UT",
  "DT",
  "S0",
  "QU",
  "YN",
  "JB",
  "GH",
  "PI",
  "SG",
  "KD",
  "PE",
  "UH",
  "S7",
  "CW",
  "OZ",
  "GI",
  "VE"
];
var aS;
function LT() {
  if (aS) return es;
  aS = 1;
  var e = es && es.__importDefault || function(u) {
    return u && u.__esModule ? u : { default: u };
  };
  Object.defineProperty(es, "__esModule", { value: !0 });
  const t = Ei(), r = rn(), o = vo(), n = e(CX), a = e(LX), l = e(TZ), i = e(AZ);
  class s {
    constructor(c) {
      this.options = {
        versionTruncation: 1
      }, this.parse = (g) => {
        const p = {
          type: "",
          name: "",
          version: "",
          engine: "",
          engineVersion: ""
        };
        for (const h of n.default) {
          const v = o.userAgentParser(h.regex, g);
          if (!v)
            continue;
          const A = r.variableReplacement(h.version, v), S = t.formatVersion(A, this.options.versionTruncation), b = S && parseFloat(t.formatVersion(A, 1)) || "";
          if (h.engine && (p.engine = h.engine.default, h.engine && h.engine.versions && b)) {
            const T = Object.entries(h.engine.versions).sort((w, N) => parseFloat(w[0]) > parseFloat(N[0]) ? 1 : -1);
            for (const [w, N] of T)
              parseFloat(w) <= b && (p.engine = N || "");
          }
          p.type = "browser", p.name = r.variableReplacement(h.name, v), p.version = S;
          break;
        }
        if (!p.engine)
          for (const h of a.default) {
            let v = null;
            try {
              v = RegExp(h.regex, "i").exec(g);
            } catch {
            }
            if (v) {
              p.engine = h.name;
              break;
            }
          }
        return p.engineVersion = t.formatVersion(t.parseBrowserEngineVersion(g, p.engine), this.options.versionTruncation), p;
      }, this.options = Object.assign(Object.assign({}, this.options), c);
    }
  }
  return es.default = s, s.getBrowserShortName = (u) => {
    for (const [c, g] of Object.entries(l.default))
      if (g === u)
        return c;
    return "";
  }, s.isMobileOnlyBrowser = (u) => i.default.includes(s.getBrowserShortName(u)), es;
}
var ts = {};
const PZ = /* @__PURE__ */ JSON.parse('[{"regex":"AndroidDownloadManager(?:[ /]([\\\\d\\\\.]+))?","name":"AndroidDownloadManager","version":"$1"},{"regex":"(?:Apple)?News(?:[ /][\\\\d\\\\.]+)? Version(?:[ /]([\\\\d\\\\.]+))?","name":"Apple News","version":"$1"},{"regex":"bPod","name":"bPod","version":""},{"regex":"MessengerLiteForiOS.(?:FBAV)(?:[ /]([\\\\d\\\\.]+))?","name":"Facebook Messenger Lite","version":"$1"},{"regex":"(?:MessengerForiOS|MESSENGER).(?:FBAV)(?:[ /]([\\\\d\\\\.]+))?","name":"Facebook Messenger","version":"$1"},{"regex":"(?:FBAV|com.facebook.katana)(?:[ /]([\\\\d\\\\.]+))?","name":"Facebook","version":"$1"},{"regex":"(?:FBAN|FBSV|FBID|FBBV)/","name":"Facebook","version":""},{"regex":"FeedR(?:/([\\\\d\\\\.]+))?","name":"FeedR","version":"$1"},{"regex":"com.google.android.apps.searchlite","name":"Google Go","version":""},{"regex":"com.google.android.apps.magazines","name":"Google Play Newsstand","version":""},{"regex":"com.google.GooglePlus","name":"Google Plus","version":""},{"regex":"MicroMessenger/([^; ]+)","name":"WeChat","version":"$1"},{"regex":"WeChatShareExtensionNew/([\\\\d\\\\.]+)","name":"WeChat Share Extension","version":"$1"},{"regex":"DingTalk/([0-9\\\\.]+)","name":"DingTalk","version":"$1"},{"regex":".*__weibo__([0-9\\\\.]+)__","name":"Sina Weibo","version":"$1"},{"regex":"Pinterest(?: for (?:Android|iOS))?(?:/([\\\\d\\\\.]+))?","name":"Pinterest","version":"$1"},{"regex":"Podcatcher Deluxe","name":"Podcatcher Deluxe","version":""},{"regex":"com.google.android.youtube(?:/([\\\\d\\\\.]+))?","name":"YouTube","version":"$1"},{"regex":"([^/]+)/(\\\\d+(?:\\\\.\\\\d+)+) \\\\((?:iPhone|iPad); iOS [0-9\\\\.]+; Scale/[0-9\\\\.]+\\\\)","name":"$1","version":"$2"},{"regex":"WhatsApp(?:[ /]([\\\\d\\\\.]+))?","name":"WhatsApp","version":"$1"},{"regex":"Line(?:[ /]([\\\\d\\\\.]+))","name":"Line","version":"$1"},{"regex":"Instacast(?:HD)?/(\\\\d\\\\.[\\\\d\\\\.abc]+) CFNetwork/([\\\\d\\\\.]+) Darwin/([\\\\d\\\\.]+)","name":"Instacast","version":"$1"},{"regex":"Podcasts/([\\\\d\\\\.]+)","name":"Podcasts","version":"$1"},{"regex":"Pocket Casts(?:, (?:Android|iOS) v([\\\\d\\\\.]+))?","name":"Pocket Casts","version":"$1"},{"regex":"Podcat/([\\\\d\\\\.]+)","name":"Podcat","version":"$1"},{"regex":"BeyondPod","name":"BeyondPod","version":null},{"regex":"AntennaPod/?([\\\\d\\\\.]+)?","name":"AntennaPod","version":"$1"},{"regex":"Overcast/([\\\\d\\\\.]+)","name":"Overcast","version":"$1"},{"regex":"(?:CastBox|fm.castbox.audiobook.radio.podcast)/?([\\\\d\\\\.]+)?","name":"CastBox","version":"$1"},{"regex":"Player FM","name":"Player FM","version":""},{"regex":"Podkicker(?: Pro)?/([\\\\d\\\\.]+)","name":"Podkicker","version":"$1"},{"regex":"PodcastRepublic/([\\\\d\\\\.]+)","name":"Podcast Republic","version":"$1"},{"regex":"Castro/(\\\\d+)","name":"Castro","version":"$1"},{"regex":"Castro 2 ([\\\\d\\\\.]+)/[\\\\d]+ Like iTunes","name":"Castro 2","version":"$1"},{"regex":"Castro 2","name":"Castro 2","version":""},{"regex":"DoggCatcher","name":"DoggCatcher","version":null},{"regex":"PodcastAddict/v([\\\\d]+)","name":"Podcast & Radio Addict","version":"$1"},{"regex":"Podcat(?:%202)?/([\\\\d]+) CFNetwork","name":"Podcat","version":"$1"},{"regex":"iCatcher[^\\\\d]+([\\\\d\\\\.]+)","name":"iCatcher","version":"$1"},{"regex":"YelpApp/([\\\\d\\\\.]+)","name":"Yelp Mobile","version":"$1"},{"regex":"jp.co.yahoo.android.yjtop/([\\\\d\\\\.]+)","name":"Yahoo! Japan","version":"$1"},{"regex":"RSSRadio/([\\\\d]+)?","name":"RSSRadio","version":"$1"},{"regex":"SogouSearch Android[\\\\d\\\\.]+ version([\\\\d\\\\.]+)?","name":"SogouSearch App","version":"$1"},{"regex":"NewsArticle/([\\\\d\\\\.]+)?","name":"NewsArticle App","version":"$1"},{"regex":"tieba/([\\\\d\\\\.]+)?","name":"tieba","version":"$1"},{"regex":"com\\\\.douban\\\\.group/([\\\\d\\\\.]+)?","name":"douban App","version":"$1"},{"regex":"BingWeb/([\\\\d\\\\.]+)?","name":"BingWebApp","version":"$1"},{"regex":"(?:com.google.GoogleMobile|GSA)/([\\\\d\\\\.]+)?","name":"Google Search App","version":"$1"},{"regex":"Flipboard/([\\\\d\\\\.]+)?","name":"Flipboard App","version":"$1"},{"regex":"Instagram[ /]([\\\\d\\\\.]+)?","name":"Instagram App","version":"$1"},{"regex":"baiduboxapp/([\\\\d\\\\.]+)?","name":"Baidu Box App","version":"$1"},{"regex":"Crosswalk(?!.*(?:Streamy|QwantMobile))/([\\\\d\\\\.]+)?","name":"CrosswalkApp","version":"$1"},{"regex":"Twitter for iPhone[/]?([\\\\d\\\\.]+)?","name":"Twitter","version":"$1"},{"regex":"Twitter/([\\\\d\\\\.]+)","name":"Twitter","version":"$1"},{"regex":"TwitterAndroid[/]?([\\\\d\\\\.]+)?","name":"Twitter","version":"$1"},{"regex":"TopBuzz/([\\\\d\\\\.]+)","name":"TopBuzz","version":"$1"},{"regex":"Snapchat/([\\\\d\\\\.]+)","name":"Snapchat","version":"$1"},{"regex":"UnityPlayer/([\\\\d\\\\.]+)","name":"UnityPlayer","version":"$1"},{"regex":"UCURSOS/v([\\\\d\\\\.]+)","name":"U-Cursos","version":"$1"},{"regex":"HeyTapBrowser/([\\\\d\\\\.]+)","name":"HeyTapBrowser","version":"$1"},{"regex":"RobloxApp/([\\\\d\\\\.]+)","name":"Roblox","version":"$1"},{"regex":"Viber/([\\\\d\\\\.]+)","name":"Viber","version":"$1"},{"regex":"Siri/1","name":"Siri","version":"1.0"},{"regex":"LinkedIn/([\\\\d\\\\.]+)","name":"LinkedIn","version":"$1"},{"regex":"Instapaper/([\\\\d\\\\.]+)","name":"Instapaper","version":"$1"},{"regex":"Keeper/([\\\\d\\\\.]+)","name":"Keeper Password Manager","version":"$1"},{"regex":"Skyeng Teachers/([\\\\d\\\\.]+)","name":"Skyeng Teachers","version":"$1"},{"regex":"Kik/([\\\\d\\\\.]+) \\\\(Android","name":"Kik","version":"$1"},{"regex":"Procast/?([\\\\d\\\\.]+)?","name":"Procast","version":"$1"},{"regex":"DeviantArt/([\\\\d\\\\.]+)","name":"DeviantArt","version":""},{"regex":"Discord/([\\\\d\\\\.]+)","name":"Discord","version":""},{"regex":"Covenant%20Eyes/([\\\\d\\\\.]+)","name":"Covenant Eyes","version":"$1"},{"regex":"HP%20Smart/([\\\\d\\\\.]+)","name":"HP Smart","version":""},{"regex":"Bitsboard/([\\\\d\\\\.]+)","name":"Bitsboard","version":"$1"},{"regex":"Betbull/([\\\\d\\\\.]+)","name":"BetBull","version":""},{"regex":"U-Cursos/([\\\\d\\\\.]+)","name":"U-Cursos","version":""},{"regex":"1PasswordThumbs/([\\\\d\\\\.]+)","name":"1Password","version":"$1"},{"regex":"(?:Microsoft Office )?(Access|Excel|OneDrive for Business|OneNote|PowerPoint|Project|Publisher|Visio|Word)[ /]([\\\\d\\\\.]+)","name":"Microsoft Office $1","version":"$2"},{"regex":"OneDriveiOSApp/([\\\\d\\\\.]+)","name":"Microsoft OneDrive","version":"$1"},{"regex":"Microsoft Office Mobile/([\\\\d\\\\.]+)","name":"Microsoft Office Mobile","version":"$1"},{"regex":"OC/([\\\\d\\\\.]+) \\\\(Skype for Business\\\\)","name":"Skype for Business","version":"$1"},{"regex":"TikTok[/ ](\\\\d+\\\\.(?:[\\\\.\\\\d]+))?","name":"TikTok","version":"$1"},{"regex":"NAVER/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Naver","version":"$1"},{"regex":"Copied/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Copied","version":""},{"regex":"Pic%20Collage/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Pic Collage","version":"$1"},{"regex":"Papers/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Papers","version":"$1"},{"regex":"RoboForm/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"RoboForm","version":""},{"regex":"Slack/(\\\\d+[\\\\.\\\\d]+) CFNetwork","name":"Slack","version":""},{"regex":"KAKAOTALK (\\\\d+\\\\.(?:[\\\\.\\\\d]+))?","name":"KakaoTalk","version":"$1"},{"regex":"ShopeeVN/([\\\\d\\\\.]+)","name":"Shopee","version":"$1"},{"regex":"SPORT1/([\\\\d\\\\.]+)","name":"SPORT1","version":""},{"regex":"Clovia/([\\\\d\\\\.]+)","name":"Clovia","version":"$1"},{"regex":"ShowMe/([\\\\d\\\\.]+)","name":"ShowMe","version":"$1"},{"regex":"Wattpad/([\\\\d\\\\.]+)","name":"Wattpad","version":"$1"},{"regex":"WSJ/([\\\\d\\\\.]+)","name":"The Wall Street Journal","version":""},{"regex":"WH%20Questions/([\\\\d\\\\.]+)","name":"WH Questions","version":"$1"},{"regex":"whisper/([\\\\d\\\\.]+)","name":"Whisper","version":""},{"regex":"Opal/([\\\\d\\\\.]+)","name":"Opal Travel","version":"$1"},{"regex":"Zalo/([\\\\d\\\\.]+)","name":"Zalo","version":"$1"},{"regex":"Yandex/([\\\\d\\\\.]+)","name":"Yandex","version":""},{"regex":"Zoho%20Chat/([\\\\d\\\\.]+)","name":"Zoho Chat","version":"$1"},{"regex":"Thunder/(\\\\d+[\\\\.\\\\d]+)","name":"Thunder","version":"$1"},{"regex":"CGNBrowser/(\\\\d+[\\\\.\\\\d]+)","name":"CGN","version":"$1"},{"regex":"Podbean/.+App (\\\\d+[\\\\.\\\\d]+)","name":"Podbean","version":"$1"},{"regex":"AlexaMediaPlayer/(\\\\d+[\\\\.\\\\d]+)","name":"Alexa Media Player","version":"$1"},{"regex":"TuneIn Radio Pro(?:[^/]+)?/(\\\\d+[\\\\.\\\\d]+)","name":"TuneIn Radio Pro","version":"$1"},{"regex":"TuneIn Radio(?:[^/]+)?/(\\\\d+[\\\\.\\\\d]+)","name":"TuneIn Radio","version":"$1"},{"regex":"Podcaster/(\\\\d+[\\\\.\\\\d]+)","name":"Podcaster","version":"$1"},{"regex":"Swoot/(\\\\d+[\\\\.\\\\d]+)","name":"Swoot","version":"$1"},{"regex":"RadioPublic/android-(\\\\d+[\\\\.\\\\d]+)","name":"RadioPublic","version":"$1"},{"regex":"Podimo/(\\\\d+[\\\\.\\\\d]+)","name":"Podimo","version":"$1"},{"regex":"com.evolve.podcast/(\\\\d+[\\\\.\\\\d]+)","name":"Evolve Podcast","version":"$1"},{"regex":" Rocket.Chat\\\\+?/(\\\\d+[\\\\.\\\\d]+)","name":"Rocket Chat","version":"$1"},{"regex":"^Pandora Audio.+Android","name":"Pandora","version":""},{"regex":"^NPROneAndroid","name":"NPR One","version":""},{"regex":"^WirtschaftsWoche-iOS-(\\\\d+[\\\\.\\\\d]+)","name":"Wirtschafts Woche","version":"$1"},{"regex":"^Outlook-iOS/.+\\\\((\\\\d+[\\\\.\\\\d]+)\\\\)$","name":"Microsoft Outlook","version":"$1"},{"regex":"^TVirl/(\\\\d+[\\\\.\\\\d]+)","name":"TVirl","version":"$1"},{"regex":"2?chMate/(\\\\d+[\\\\.\\\\d]+)","name":"ChMate","version":"$1"},{"regex":"2tch/(\\\\d+[\\\\.\\\\d]+)","name":"2tch","version":"$1"},{"regex":"Ciisaa/(\\\\d+[\\\\.\\\\d]+)","name":"Ciisaa","version":"$1"},{"regex":"BB2C (\\\\d+[\\\\.\\\\d]+)","name":"BB2C","version":"$1"},{"regex":"twinkle/(\\\\d+[\\\\.\\\\d]+)","name":"twinkle","version":"$1"},{"regex":"JaneStyle_iOS/(\\\\d+[\\\\.\\\\d]+)","name":"JaneStyle","version":"$1"}]');
var lS;
function MZ() {
  if (lS) return ts;
  lS = 1;
  var e = ts && ts.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(ts, "__esModule", { value: !0 });
  const t = e(PZ), r = Ei(), o = rn(), n = vo();
  class a {
    constructor(i) {
      this.options = {
        versionTruncation: 1
      }, this.parse = (s) => {
        const u = {
          type: "",
          name: "",
          version: ""
        };
        for (const c of t.default) {
          const g = n.userAgentParser(c.regex, s);
          if (g) {
            u.type = "mobile app", u.name = o.variableReplacement(c.name, g), u.version = r.formatVersion(o.variableReplacement(c.version, g), this.options.versionTruncation);
            break;
          }
        }
        return u;
      }, this.options = Object.assign(Object.assign({}, this.options), i);
    }
  }
  return ts.default = a, ts;
}
var rs = {};
const $Z = [
  {
    regex: "Akregator(?:/(\\d+[\\.\\d]+))?",
    name: "Akregator",
    version: "$1",
    url: "http://userbase.kde.org/Akregator",
    type: "Feed Reader"
  },
  {
    regex: "Apple-PubSub(?:/(\\d+[\\.\\d]+))?",
    name: "Apple PubSub",
    version: "$1",
    url: "https://developer.apple.com/library/mac/documentation/Darwin/Reference/ManPages/man1/pubsub.1.html",
    type: "Feed Reader"
  },
  {
    regex: "BashPodder",
    name: "BashPodder",
    version: "",
    url: "http://lincgeek.org/bashpodder/",
    type: "Feed Reader"
  },
  {
    regex: "Breaker/v([\\d\\.]+)",
    name: "Breaker",
    version: "$1",
    url: "https://www.breaker.audio/",
    type: "Feed Reader App"
  },
  {
    regex: "Downcast/([\\d\\.]+)",
    name: "Downcast",
    version: "$1",
    url: "http://downcastapp.com/",
    type: "Feed Reader App"
  },
  {
    regex: "FeedDemon(?:/(\\d+[\\.\\d]+))?",
    name: "FeedDemon",
    version: "$1",
    url: "http://www.feeddemon.com/",
    type: "Feed Reader"
  },
  {
    regex: "Feeddler(?:RSS|PRO)(?:[/ ](\\d+[\\.\\d]+))?",
    name: "Feeddler RSS Reader",
    version: "$1",
    url: "http://www.chebinliu.com/projects/iphone/feeddler-rss-reader/",
    type: "Feed Reader App"
  },
  {
    regex: "QuiteRSS(?:[/ ](\\d+[\\.\\d]+))?",
    name: "QuiteRSS",
    version: "$1",
    url: "https://quiterss.org",
    type: "Feed Reader App"
  },
  {
    regex: "gPodder/([\\d\\.]+)",
    name: "gPodder",
    version: "$1",
    url: "http://gpodder.org/",
    type: "Feed Reader App"
  },
  {
    regex: "JetBrains Omea Reader(?:[/ ](\\d+[\\.\\d]+))?",
    name: "JetBrains Omea Reader",
    version: "$1",
    url: "http://www.jetbrains.com/omea/reader/",
    type: "Feed Reader"
  },
  {
    regex: "Liferea(?:[/ ](\\d+[\\.\\d]+))?",
    name: "Liferea",
    version: "$1",
    url: "http://liferea.sf.net/",
    type: "Feed Reader"
  },
  {
    regex: "(?:NetNewsWire|Evergreen.+MacOS)(?:[/ ](\\d+[\\.\\d]+))?",
    name: "NetNewsWire",
    version: "$1",
    url: "http://netnewswireapp.com/",
    type: "Feed Reader"
  },
  {
    regex: "NewsBlur (?:iPhone|iPad) App(?: v(\\d+[\\.\\d]+))?",
    name: "NewsBlur Mobile App",
    version: "$1",
    url: "http://www.newsblur.com",
    type: "Feed Reader App"
  },
  {
    regex: "NewsBlur(?:/(\\d+[\\.\\d]+))",
    name: "NewsBlur",
    version: "$1",
    url: "http://www.newsblur.com",
    type: "Feed Reader"
  },
  {
    regex: "newsbeuter(?:[/ ](\\d+[\\.\\d]+))?",
    name: "Newsbeuter",
    version: "$1",
    url: "http://www.newsbeuter.org/",
    type: "Feed Reader"
  },
  {
    regex: "PritTorrent/([\\d\\.]+)",
    name: "PritTorrent",
    version: "$1",
    url: "http://bitlove.org",
    type: "Feed Reader"
  },
  {
    regex: "Pulp[/ ](\\d+[\\.\\d]+)",
    name: "Pulp",
    version: "$1",
    url: "http://www.acrylicapps.com/pulp/",
    type: "Feed Reader App"
  },
  {
    regex: "ReadKit(?:[/ ](\\d+[\\.\\d]+))?",
    name: "ReadKit",
    version: "$1",
    url: "http://readkitapp.com/",
    type: "Feed Reader App"
  },
  {
    regex: "Reeder[/ ](\\d+[\\.\\d]+)",
    name: "Reeder",
    version: "$1",
    url: "http://reederapp.com/",
    type: "Feed Reader App"
  },
  {
    regex: "RSSBandit(?:[/ ](\\d+[\\.\\d]+))?",
    name: "RSS Bandit",
    version: "$1",
    url: "http://www.rssbandit.org)",
    type: "Feed Reader"
  },
  {
    regex: "RSS Junkie(?:[/ ](\\d+[\\.\\d]+))?",
    name: "RSS Junkie",
    version: "$1",
    url: "https://play.google.com/store/apps/details?id=com.bitpowder.rssjunkie",
    type: "Feed Reader App"
  },
  {
    regex: "RSSOwl(?:[/ ](\\d+[\\.\\d]+))?",
    name: "RSSOwl",
    version: "$1",
    url: "http://www.rssowl.org/",
    type: "Feed Reader"
  },
  {
    regex: "Stringer",
    name: "Stringer",
    version: "",
    url: "https://github.com/swanson/stringer",
    type: "Feed Reader"
  }
];
var iS;
function CZ() {
  if (iS) return rs;
  iS = 1;
  var e = rs && rs.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(rs, "__esModule", { value: !0 });
  const t = e($Z), r = Ei(), o = rn(), n = vo();
  class a {
    constructor(i) {
      this.options = {
        versionTruncation: 1
      }, this.parse = (s) => {
        const u = {
          type: "",
          name: "",
          version: "",
          url: ""
        };
        for (const c of t.default) {
          const g = n.userAgentParser(c.regex, s);
          if (g) {
            u.type = "feed reader", u.name = o.variableReplacement(c.name, g), u.version = r.formatVersion(o.variableReplacement(c.version, g), this.options.versionTruncation), u.url = c.url;
            break;
          }
        }
        return u;
      }, this.options = Object.assign(Object.assign({}, this.options), i);
    }
  }
  return rs.default = a, rs;
}
var os = {};
const LZ = [
  {
    regex: "Wget(?:/(\\d+[\\.\\d]+))?",
    name: "Wget",
    version: "$1"
  },
  {
    regex: "Guzzle(?:/(\\d+[\\.\\d]+))?",
    name: "Guzzle (PHP HTTP Client)",
    version: "$1"
  },
  {
    regex: "(?:lib)?curl(?:/(\\d+[\\.\\d]+))?",
    name: "curl",
    version: "$1"
  },
  {
    regex: "python-requests(?:/(\\d+[\\.\\d]+))?",
    name: "Python Requests",
    version: "$1"
  },
  {
    regex: "Python-urllib(?:/?(\\d+[\\.\\d]+))?",
    name: "Python urllib",
    version: "$1"
  },
  {
    regex: "Java(?:/?(\\d+[\\.\\d]+))?",
    name: "Java",
    version: "$1"
  },
  {
    regex: "(?:perlclient|libwww-perl)(?:/?(\\d+[\\.\\d]+))?",
    name: "Perl",
    version: "$1"
  },
  {
    regex: "okhttp/([\\d\\.]+)",
    name: "OkHttp",
    version: "$1"
  },
  {
    regex: "HTTP_Request2(?:/(\\d+[\\.\\d]+))?",
    name: "HTTP_Request2",
    version: "$1"
  },
  {
    regex: "HTTP_Request2(?:/(\\d+[\\.\\d]+))?",
    name: "HTTP_Request2",
    version: "$1",
    url: "http://pear.php.net/package/http_request2"
  },
  {
    regex: "Mechanize(?:/(\\d+[\\.\\d]+))?",
    name: "Mechanize",
    version: "$1",
    url: "http://github.com/sparklemotion/mechanize/"
  },
  {
    regex: "aiohttp(?:/(\\d+[\\.\\d]+))?",
    name: "aiohttp",
    version: "$1"
  },
  {
    regex: "Google-HTTP-Java-Client(?:/(\\d+[\\.\\d\\w-]+))?",
    name: "Google HTTP Java Client",
    version: "$1"
  },
  {
    regex: "WWW-Mechanize(?:/(\\d+[\\.\\d]+))?",
    name: "WWW-Mechanize",
    version: "$1"
  },
  {
    regex: "Faraday(?: v(\\d+[\\.\\d]+))?",
    name: "Faraday",
    version: "$1"
  },
  {
    regex: "(?:Go-http-client|Go )/?(?:(\\d+[\\.\\d]+))?(?: package http)?",
    name: "Go-http-client",
    version: "$1"
  },
  {
    regex: "urlgrabber(?:/(\\d+[\\.\\d]+))?",
    name: "urlgrabber (yum)",
    version: "$1"
  },
  {
    regex: "libdnf(?:/(\\d+[\\.\\d]+))?",
    name: "libdnf",
    version: "$1"
  },
  {
    regex: "HTTPie(?:/(\\d+[\\.\\d]+))?",
    name: "HTTPie",
    version: "$1"
  },
  {
    regex: "rest-client/(\\d+[\\.\\d]+).*ruby",
    name: "REST Client for Ruby",
    version: "$1"
  },
  {
    regex: "RestSharp/(\\d+[\\.\\d]+)",
    name: "RestSharp",
    version: "$1",
    url: "http://restsharp.org/"
  },
  {
    regex: "scalaj-http/(\\d+[\\.\\d]+)",
    name: "ScalaJ HTTP",
    version: "$1",
    url: "https://github.com/scalaj/scalaj-http"
  },
  {
    regex: "REST::Client/(\\d+)",
    name: "Perl REST::Client",
    version: "$1",
    url: "https://metacpan.org/pod/REST::Client"
  },
  {
    regex: "node-fetch/(\\d+[\\.\\d]+)",
    name: "Node Fetch",
    version: "$1",
    url: "https://github.com/node-fetch/node-fetch"
  },
  {
    regex: "ReactorNetty/(\\d+[\\.\\d]+)",
    name: "ReactorNetty",
    version: "$1",
    url: "https://github.com/reactor/reactor-netty"
  },
  {
    regex: "PostmanRuntime(?:/(\\d+[\\.\\d]+))?",
    name: "Postman Desktop",
    version: "$1",
    url: "https://github.com/postmanlabs/postman-runtime"
  },
  {
    regex: "Jakarta Commons-HttpClient/([\\.\\d]+)",
    name: "Jakarta Commons HttpClient",
    version: "$1",
    url: "https://hc.apache.org/httpclient-3.x"
  },
  {
    regex: "WinHttp.WinHttpRequest.+([\\.\\d]+)",
    name: "WinHttp WinHttpRequest",
    version: "$1"
  },
  {
    regex: "Embarcadero URI Client/([\\.\\d]+)",
    name: "Embarcadero URI Client",
    version: "$1"
  },
  {
    regex: "Mikrotik/([\\.\\d]+)",
    name: "Mikrotik Fetch",
    version: "$1"
  },
  {
    regex: "GRequests(?:/(\\d+[\\.\\d]+))?",
    name: "GRequests",
    version: "$1"
  },
  {
    regex: "akka-http/([\\.\\d]+)",
    name: "Akka HTTP",
    version: "$1"
  }
];
var sS;
function EZ() {
  if (sS) return os;
  sS = 1;
  var e = os && os.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(os, "__esModule", { value: !0 });
  const t = e(LZ), r = Ei(), o = rn(), n = vo();
  class a {
    constructor(i) {
      this.options = {
        versionTruncation: 1
      }, this.parse = (s) => {
        const u = {
          type: "",
          name: "",
          version: "",
          url: ""
        };
        for (const c of t.default) {
          const g = n.userAgentParser(c.regex, s);
          if (g) {
            u.type = "library", u.name = o.variableReplacement(c.name, g), u.version = r.formatVersion(o.variableReplacement(c.version, g), this.options.versionTruncation), u.url = c.url || "";
            break;
          }
        }
        return u;
      }, this.options = Object.assign(Object.assign({}, this.options), i);
    }
  }
  return os.default = a, os;
}
var ns = {};
const OZ = [
  {
    regex: "Audacious(?:[ /]([\\d\\.]+))?",
    name: "Audacious",
    version: "$1"
  },
  {
    regex: "Banshee(?:[ /]([\\d\\.]+))?",
    name: "Banshee",
    version: "$1"
  },
  {
    regex: "Boxee(?:[ /]([\\d\\.]+))?",
    name: "Boxee",
    version: "$1"
  },
  {
    regex: "Clementine(?:[ /]([\\d\\.]+))?",
    name: "Clementine",
    version: "$1"
  },
  {
    regex: "Deezer(?:/([\\d\\.]+))?",
    name: "Deezer",
    version: "$1"
  },
  {
    regex: "iTunes(?:-iPhone|-iPad)?(?:/([\\d\\.]+))?",
    name: "iTunes",
    version: "$1"
  },
  {
    regex: "FlyCast(?:/([\\d\\.]+))?",
    name: "FlyCast",
    version: "$1"
  },
  {
    regex: "foobar2000(?:/([\\d\\.]+))?",
    name: "Foobar2000",
    version: "$1"
  },
  {
    regex: "MediaMonkey(?:[ /](\\d+[\\.\\d]+))?",
    name: "MediaMonkey",
    version: "$1"
  },
  {
    regex: "Miro(?:/(\\d+[\\.\\d]+))?",
    name: "Miro",
    version: "$1"
  },
  {
    regex: "NexPlayer(?:/(\\d+[\\.\\d]+))?",
    name: "NexPlayer",
    version: "$1"
  },
  {
    regex: "Nightingale(?:/([\\d\\.]+))?",
    name: "Nightingale",
    version: "$1"
  },
  {
    regex: "QuickTime(?:(?:(?:.+qtver=)|(?:(?: E-)?[\\./]))([\\d\\.]+))?",
    name: "QuickTime",
    version: "$1"
  },
  {
    regex: "Songbird(?:/([\\d\\.]+))?",
    name: "Songbird",
    version: "$1"
  },
  {
    regex: "SubStream(?:/([\\d\\.]+))?",
    name: "SubStream",
    version: "$1"
  },
  {
    regex: "Sonos/([\\d\\.]+)?",
    name: "SONOS",
    version: "$1"
  },
  {
    regex: "(?:Lib)?VLC(?:/([\\d\\.]+))?",
    name: "VLC",
    version: "$1"
  },
  {
    regex: "Winamp(?:MPEG)?(?:/(\\d+[\\.\\d]+))?",
    name: "Winamp",
    version: "$1"
  },
  {
    regex: "(?:Windows-Media-Player|NSPlayer)(?:/(\\d+[\\.\\d]+))?",
    name: "Windows Media Player",
    version: "$1"
  },
  {
    regex: "XBMC(?:/([\\d\\.]+))?",
    name: "XBMC",
    version: "$1"
  },
  {
    regex: "Kodi(?:/([\\d\\.]+))?",
    name: "Kodi",
    version: "$1"
  },
  {
    regex: "stagefright(?:/([\\d\\.]+))?",
    name: "Stagefright",
    version: "$1"
  },
  {
    regex: "GoogleChirp(?:/(\\d+[\\.\\d]+))?",
    name: "Google Podcasts",
    version: "$1"
  },
  {
    regex: "Music Player Daemon (?:(\\d+[\\.\\d]+))?",
    name: "Music Player Daemon",
    version: "$1"
  },
  {
    regex: "mpv (?:(\\d+[\\.\\d]+))?",
    name: "mpv",
    version: "$1"
  }
];
var dS;
function NZ() {
  if (dS) return ns;
  dS = 1;
  var e = ns && ns.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(ns, "__esModule", { value: !0 });
  const t = e(OZ), r = Ei(), o = rn(), n = vo();
  class a {
    constructor(i) {
      this.options = {
        versionTruncation: 1
      }, this.parse = (s) => {
        const u = {
          type: "",
          name: "",
          version: ""
        };
        for (const c of t.default) {
          const g = n.userAgentParser(c.regex, s);
          if (g) {
            u.type = "media player", u.name = o.variableReplacement(c.name, g), u.version = r.formatVersion(o.variableReplacement(c.version, g), this.options.versionTruncation);
            break;
          }
        }
        return u;
      }, this.options = Object.assign(Object.assign({}, this.options), i);
    }
  }
  return ns.default = a, ns;
}
var as = {};
const DZ = [
  {
    regex: "Outlook-Express(?:/(\\d+[\\.\\d]+))?",
    name: "Outlook Express",
    version: "$1"
  },
  {
    regex: "Microsoft Outlook(?:[/ ](\\d+[\\.\\d]+))?",
    name: "Microsoft Outlook",
    version: "$1"
  },
  {
    regex: "(?:Thunderbird|Icedove|Shredder)(?:/(\\d+[\\.\\d]+))?",
    name: "Thunderbird",
    version: "$1"
  },
  {
    regex: "Airmail(?: (\\d+[\\.\\d]+))?",
    name: "Airmail",
    version: "$1"
  },
  {
    regex: "Lotus-Notes(?:/(\\d+[\\.\\d]+))?",
    name: "Lotus Notes",
    version: "$1"
  },
  {
    regex: "Barca(?:Pro)?(?:[/ ](\\d+[\\.\\d]+))?",
    name: "Barca",
    version: "$1"
  },
  {
    regex: "Postbox(?:[/ ](\\d+[\\.\\d]+))?",
    name: "Postbox",
    version: "$1"
  },
  {
    regex: "MailBar(?:[/ ](\\d+[\\.\\d]+))?",
    name: "MailBar",
    version: "$1"
  },
  {
    regex: "The Bat!(?: Voyager)?(?:[/ ](\\d+[\\.\\d]+))?",
    name: "The Bat!",
    version: "$1"
  },
  {
    regex: "DAVdroid(?:/(\\d+[\\.\\d]+))?",
    name: "DAVdroid",
    version: "$1"
  },
  {
    regex: "(?:SeaMonkey|Iceape)(?:/(\\d+[\\.\\d]+))?",
    name: "SeaMonkey",
    version: "$1"
  },
  {
    regex: "Live5ch/(\\d+[\\.\\d]+)",
    name: "Live5ch",
    version: "$1"
  },
  {
    regex: "JaneView/",
    name: "JaneView",
    version: ""
  },
  {
    regex: "BathyScaphe/",
    name: "BathyScaphe",
    version: ""
  }
];
var uS;
function kZ() {
  if (uS) return as;
  uS = 1;
  var e = as && as.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(as, "__esModule", { value: !0 });
  const t = e(DZ), r = Ei(), o = rn(), n = vo();
  class a {
    constructor(i) {
      this.options = {
        versionTruncation: 1
      }, this.parse = (s) => {
        const u = {
          type: "",
          name: "",
          version: ""
        };
        for (const c of t.default) {
          const g = n.userAgentParser(c.regex, s);
          if (g) {
            u.type = "personal information manager", u.name = o.variableReplacement(c.name, g), u.version = r.formatVersion(o.variableReplacement(c.version, g), this.options.versionTruncation);
            break;
          }
        }
        return u;
      }, this.options = Object.assign(Object.assign({}, this.options), i);
    }
  }
  return as.default = a, as;
}
var cS;
function GZ() {
  if (cS) return Ji;
  cS = 1;
  var e = Ji && Ji.__importDefault || function(u) {
    return u && u.__esModule ? u : { default: u };
  };
  Object.defineProperty(Ji, "__esModule", { value: !0 });
  const t = e(LT()), r = e(MZ()), o = e(CZ()), n = e(EZ()), a = e(NZ()), l = e(kZ()), i = [
    o.default,
    r.default,
    a.default,
    l.default,
    t.default,
    n.default
  ];
  class s {
    constructor(c) {
      this.options = {
        versionTruncation: 1
      }, this.parse = (g) => {
        for (const p of i) {
          const v = new p(this.options).parse(g);
          if (v.type !== "")
            return v;
        }
        return null;
      }, this.options = Object.assign(Object.assign({}, this.options), c);
    }
  }
  return Ji.default = s, Ji;
}
var ls = {}, is = {};
const BZ = { regex: "Coolpix S800c", device: "camera", model: "Coolpix S800c" }, IZ = { regex: "EK-G[CN][0-9]{3}", device: "camera", models: [{ regex: "EK-GN120", model: "Galaxy NX" }, { regex: "EK-GC100", model: "Galaxy Camera" }, { regex: "EK-GC110", model: "Galaxy Camera WiFi only" }, { regex: "EK-GC200", model: "Galaxy Camera 2" }, { regex: "EK-GC([0-9]{3})", model: "Galaxy Camera $1" }] }, RZ = {
  Nikon: BZ,
  Samsung: IZ
};
var mS;
function FZ() {
  if (mS) return is;
  mS = 1;
  var e = is && is.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(is, "__esModule", { value: !0 });
  const t = e(RZ), r = rn(), o = vo();
  class n {
    constructor() {
      this.parse = (l) => {
        const i = {
          type: "",
          brand: "",
          model: ""
        };
        for (const [s, u] of Object.entries(t.default)) {
          const c = o.userAgentParser(u.regex, l);
          if (c) {
            if (i.type = "camera", i.brand = s, "model" in u && u.model)
              i.model = r.variableReplacement(u.model, c).trim();
            else if ("models" in u && u.models)
              for (const g of u.models) {
                const p = o.userAgentParser(g.regex, l);
                if (p) {
                  i.model = r.variableReplacement(g.model, p).trim();
                  break;
                }
              }
            break;
          }
        }
        return i;
      };
    }
  }
  return is.default = n, is;
}
var ss = {};
const VZ = { regex: "(?:BUZZ [12]|BUZZ 2|CLEVER 1|URBAN 1(?: Pro)?)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "BUZZ ([12]) Lite", model: "Buzz $1 Lite" }, { regex: "BUZZ ([12]) Plus", model: "Buzz $1 Plus" }, { regex: "BUZZ ([12])", model: "Buzz $1" }, { regex: "CLEVER 1", model: "Clever 1" }, { regex: "URBAN 1 Pro", model: "Urban 1 Pro" }, { regex: "URBAN 1", model: "Urban 1" }] }, HZ = { regex: "StarShine|StarTrail|STARADDICT|StarText|StarNaute|StarXtrem|StarTab", device: "smartphone", models: [{ regex: "StarXtrem II(?:[);/ ]|$)", model: "StarXtrem 2" }, { regex: "StarXtrem ?([3-6])(?:[);/ ]|$)", model: "StarXtrem $1" }, { regex: "StarXtrem(?:[);/ ]|$)", model: "StarXtrem" }, { regex: "StarTrail III(?:[);/ ]|$)", model: "StarTrail 3" }, { regex: "StarTrail II(?:[);/ ]|$)", model: "StarTrail 2" }, { regex: "StarTrail[ _]?([1-9])[ _]([34])G(?:[);/ ]|$)", model: "StarTrail $1 $2G" }, { regex: "StarTrail[ _]?([1-9])(?:[);/ ]|$)", model: "StarTrail $1" }, { regex: "StarTrail(?:[);/ ]|$)", model: "StarTrail" }, { regex: "StarShine II(?:[);/ ]|$)", model: "StarShine 2" }, { regex: "StarShine(?:[);/ ]|$)", model: "StarShine" }, { regex: "STARADDICT 4(?:[);/ ]|$)", model: "Staraddict 4" }, { regex: "STARADDICT III(?:[);/ ]|$)", model: "Staraddict 3" }, { regex: "STARADDICT II Plus(?:[);/ ]|$)", model: "Staraddict 2 Plus" }, { regex: "STARADDICT II(?:[);/ ]|$)", model: "Staraddict 2" }, { regex: "STARADDICT(?:[);/ ]|$)", model: "Staraddict" }, { regex: "StarText II(?:[);/ ]|$)", model: "StarText 2" }, { regex: "StarText(?:[);/ ]|$)", model: "StarText" }, { regex: "StarNaute II(?:[);/ ]|$)", model: "StarNaute 2" }, { regex: "StarNaute(?:[);/ ]|$)", model: "StarNaute" }, { regex: "StarTab", model: "StarTab", device: "tablet" }, { regex: "((?:StarShine|StarTrail|STARADDICT|StarText|StarNaute|StarXtrem)[^;/]*) Build", model: "$1" }] }, UZ = { regex: "HTC|Sprint (?:APA|ATP)|ADR(?!910L)[a-z0-9]+|NexusHD2|Amaze[ _]4G(?:[);/ ]|$)|(Desire|Sensation|Evo ?3D|IncredibleS|Wildfire|Butterfly)[ _]?([^;/)]+)(?: Build|\\))|(Amaze[ _]4G|(?<!BLU LIFE )One ?[XELSV\\+]+)(?:[);/ ]|$)|SPV E6[05]0|(One M8|One Mini 2|X525a|PG86100|PC36100|XV6975|PJ83100|2PYB2|2PS64|2PZC5|0PJA10|0PJA2|HTV33|0PM92|0PCV1|601HT|0PAJ5|HTL2[23]|HTV3[12]|2PQ93|X2-HT|EXODUS 1|ISW13HT)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "2PZC5(?:[);/ ]|$)", model: "U11" }, { regex: "XV6975(?:[);/ ]|$)", model: "Imagio" }, { regex: "PG86100(?:[);/ ]|$)", model: "Evo 3G" }, { regex: "PC36100(?:[);/ ]|$)", model: "Evo 4G" }, { regex: "(?:HTV33|601HT)(?:[);/ ]|$)", model: "U11" }, { regex: "(?:801e|802[wdt])", model: "One" }, { regex: "PJ83100(?:[);/ ]|$)", model: "One X" }, { regex: "One Mini 2(?:[);/ ]|$)", model: "One Mini 2" }, { regex: "X2-HT(?:[);/ ]|$)", model: "One X2" }, { regex: "ISW13HT(?:[);/ ]|$)", model: "J" }, { regex: "HTL22(?:[);/ ]|$)", model: "J One" }, { regex: "HTL23(?:[);/ ]|$)", model: "J Butterfly" }, { regex: "(?:0PJA2|0PJA10)(?:[);/ ]|$)", model: "One M9" }, { regex: "X525a(?:[);/ ]|$)", model: "One X+" }, { regex: "2PQ93(?:[);/ ]|$)", model: "One A9" }, { regex: "ADR6300", model: "Droid Incredible" }, { regex: "ADR6400L", model: "ThunderBolt" }, { regex: "ADR6410LRA", model: "Droid Incredible 3" }, { regex: "SPV E600", model: "Excalibur" }, { regex: "SPV E650", model: "Vox" }, { regex: "2PYB2", model: "Bolt" }, { regex: "2PS64", model: "10" }, { regex: "0PM92(?:[);/ ]|$)", model: "Desire 626S" }, { regex: "0PCV1(?:[);/ ]|$)", model: "Desire 510" }, { regex: "608t(?:[);/ ]|$)", model: "Desire 608t" }, { regex: "EXODUS 1(?:[);/ ]|$)", model: "Exodus 1" }, { regex: "NexusHD2", model: "HD2" }, { regex: "HTC[ _\\-]P715a", device: "tablet", model: "P715a" }, { regex: "HTC[ _\\-]Flyer Build", device: "tablet", model: "Flyer" }, { regex: "HTC[ _\\-]Flyer[ _\\-]([\\w]{1,5})", device: "tablet", model: "Flyer $1" }, { regex: "HTC[ _\\-]One[ _\\-]max(?:[);/ ]|$)", device: "phablet", model: "One max" }, { regex: "HTC[ _]([^/;]+) [0-9]+(?:\\.[0-9]+)+ Build", model: "$1" }, { regex: "HTC[ _]([^/;]+) Build", model: "$1" }, { regex: "HTC[ _]([a-z0-9]+[ _\\-]?(?:[a-z0-9_+\\-])*)", model: "$1" }, { regex: "USCCHTC(\\d+)", model: "$1" }, { regex: "Sprint (ATP.*) Build", device: "tablet", model: "$1 (Sprint)" }, { regex: "Sprint (APA.*) Build", model: "$1 (Sprint)" }, { regex: "(?:HTC-)?HTC(?:[\\-/ ])?([a-z0-9\\-_]+)", model: "$1" }, { regex: "HTC;(?: )?([a-z0-9 ]+)", model: "$1" }, { regex: "(Desire|Sensation|Evo ?3D|IncredibleS|Wildfire|Butterfly)[ _]?([^;/)]+)(?: Build|\\))", model: "$1 $2" }, { regex: "(Amaze[ _]4G|One ?[XELSV\\+]*) Build", model: "$1" }, { regex: "(ADR[^;/]+) Build", model: "$1" }, { regex: "(ADR[a-z0-9]+)", model: "$1" }, { regex: "(One M8)", model: "$1" }, { regex: "0PAJ5(?:[);/ ]|$)", model: "One E8" }, { regex: "HTV32(?:[);/ ]|$)", model: "10" }, { regex: "HTV31(?:[);/ ]|$)", model: "J Butterfly" }] }, XZ = { regex: "KIN\\.(One|Two)|RM-(?:1010|1031|106[57]|107[23467]|1089|109[02]|1096|1099|1109|111[348]|1127|1141|115[24]|994)|Microsoft; Lumia|Lumia (?:1530|1320|950|850|650|640|550|535|435)|Corporation/Surface", device: "smartphone", models: [{ regex: "KIN\\.(One|Two)", device: "feature phone", model: "Kin $1" }, { regex: "RM-1099|Lumia 430", model: "Lumia 430" }, { regex: "RM-1114|Lumia 435", model: "Lumia 435" }, { regex: "RM-1031|Lumia 532", model: "Lumia 532" }, { regex: "Lumia 535 Dual SIM", model: "Lumia 535 Dual SIM" }, { regex: "RM-109[02]|RM-1089|Lumia 535", model: "Lumia 535" }, { regex: "RM-1141|Lumia 540", model: "Lumia 540" }, { regex: "RM-1127|Lumia 550", model: "Lumia 550" }, { regex: "RM-1010", model: "Lumia 638" }, { regex: "Lumia 640 XL LTE", model: "Lumia 640 XL LTE", device: "phablet" }, { regex: "RM-106[57]|RM-1096|Lumia 640 XL", model: "Lumia 640 XL", device: "phablet" }, { regex: "Lumia 640 LTE Dual SIM", model: "Lumia 640 LTE Dual SIM" }, { regex: "Lumia 640 LTE", model: "Lumia 640 LTE" }, { regex: "Lumia 640 Dual SIM", model: "Lumia 640 Dual SIM" }, { regex: "RM-1109|RM-1113|RM-107[23467]|Lumia 640", model: "Lumia 640" }, { regex: "RM-1154|Lumia 650", model: "Lumia 650" }, { regex: "RM-1152", model: "Lumia 650 SS" }, { regex: "Lumia 850", model: "Lumia 850" }, { regex: "Lumia 950 XL Dual SIM", model: "Lumia 950 XL Dual SIM", device: "phablet" }, { regex: "Lumia 950 XL", model: "Lumia 950 XL", device: "phablet" }, { regex: "Lumia 950 Dual SIM", model: "Lumia 950 Dual SIM" }, { regex: "Lumia 950|RM-1118", model: "Lumia 950" }, { regex: "RM-994|Lumia 1320", model: "Lumia 1320" }, { regex: "Lumia 1530", model: "Lumia 1530" }, { regex: "Surface Book 3", device: "desktop", model: "Surface Book 3" }, { regex: "Surface Pro( [34])?", device: "desktop", model: "Surface Pro$1" }, { regex: "Microsoft; Lumia ([^;/)]+)(?:[;/)]|$)", model: "Lumia $1" }] }, WZ = { regex: "Nokia(?!Browser|Webview|; GT-I8750)|Lumia|Maemo RX|portalmmm/2\\.0 N7|portalmmm/2\\.0 NK|nok[0-9]+|Symbian.*\\s([a-z0-9]+)$|RX-51 N900|TA-[0-9]{4}|ARM; 909", device: "smartphone", models: [{ regex: "TA-10(07|23|29|35)", model: "2" }, { regex: "TA-10(20|28|32|38)", model: "3" }, { regex: "TA-10(24|27|44|53)", model: "5" }, { regex: "TA-10(00|03|21|25|33|39|54)", model: "6" }, { regex: "TA-1041", model: "7" }, { regex: "TA-10(04|12|52)", model: "8" }, { regex: "Nokia 8\\.1", model: "8.1" }, { regex: "Nokia 8 Sirocco", model: "8 Sirocco" }, { regex: "Nokia 7\\.1", model: "7.1" }, { regex: "Nokia 7 plus", model: "7 plus" }, { regex: "Nokia 6\\.1 Plus", model: "6.1 Plus" }, { regex: "Nokia 6\\.1", model: "6.1" }, { regex: "Nokia 5\\.1 Plus", model: "5.1 Plus" }, { regex: "Nokia 5\\.1", model: "5.1" }, { regex: "Nokia 3\\.1 Plus", model: "3.1 Plus" }, { regex: "Nokia 3\\.1", model: "3.1" }, { regex: "Nokia 2\\.1", model: "2.1" }, { regex: "Nokia 1 Plus", model: "1 Plus" }, { regex: "Nokia 1", model: "1" }, { regex: "RX-51 N900", model: "N900" }, { regex: "(?: )?(Nokia500|nokiaasha500(?:dualsim)?)(?: Build|[_);/])", model: "Asha 500" }, { regex: "Nokia5130c(?:-2)?", model: "5130 XpressMusic" }, { regex: "Nokia5230", model: "Nuron" }, { regex: "Nokia5233", model: "5233" }, { regex: "Nokia5800d-1", model: "5800 XpressMusic" }, { regex: "Nokia6210Navigator", model: "Navigator" }, { regex: "Nokia8800e?", model: "Sapphire Arte" }, { regex: "NOKIA-RH-17", model: "2280" }, { regex: "NOKIA-RH-27", model: "6225" }, { regex: "NOKIA-RH-34", model: "6585" }, { regex: "NOKIA-RH-48", model: "3105" }, { regex: "NOKIA-RM-11", model: "3205" }, { regex: "Nokia808 PureView", model: "808 PureView" }, { regex: "Nokia ?([0-9]{4})c(?:-)?", model: "$1 Classic" }, { regex: "Nokia ?([0-9]{4})s(?:-)?", model: "$1 Slide" }, { regex: "Nokia ?([0-9]{4})", model: "$1" }, { regex: "(?: )?Nokia([235][0-9]{2})(?: Build|[_);/])", model: "Asha $1" }, { regex: "Nokia([CEX]-?[0-9]{1,2}i?)-[0-9]{1,2}u?(?: Build|[_);/])", model: "$1" }, { regex: "Nokia;? 520T", model: "Lumia 520T" }, { regex: "RM-91[45]", model: "Lumia 520" }, { regex: "RM-997|Nokia 526", model: "Lumia 526" }, { regex: "RM-846", model: "Lumia 620" }, { regex: "RM-97[68]", model: "Lumia 630" }, { regex: "RM-97[45]", model: "Lumia 635" }, { regex: "RM-1027", model: "Lumia 636" }, { regex: "NOKIA;? 710", model: "Lumia 710" }, { regex: "Nokia;? 720T", model: "Lumia 720T" }, { regex: "RM-885", model: "Lumia 720" }, { regex: "Lumia 730", model: "Lumia 730" }, { regex: "RM-103[89]", model: "Lumia 735" }, { regex: "Nokia;? 800C", model: "Lumia 800C" }, { regex: "Nokia;? 800", model: "Lumia 800" }, { regex: "Nokia 820", model: "Lumia 820" }, { regex: "RM-984", model: "Lumia 830" }, { regex: "Nokia;? 900", model: "Lumia 900" }, { regex: "(RM-82[12]|Nokia;? 920)(?: Build|[_);/])", model: "Lumia 920" }, { regex: "(RM-89[23]|RM-910|Nokia;? 925)(?: Build|[a_);/])", model: "Lumia 925" }, { regex: "Lumia 929", model: "Lumia Icon" }, { regex: "RM-1045", model: "Lumia 930" }, { regex: "(ARM; 909|NOKIA;? 909|NOKIA; id300)(?: Build|[_);/])", model: "Lumia 1020" }, { regex: "NOKIA;? 1520\\.1", model: "Lumia 1520.1" }, { regex: "Nokia ([A-Za-z0-9\\. ]+)(?: Build|\\))", model: "$1" }, { regex: "Nokia(N[0-9]+)", model: "$1" }, { regex: "Nokia-([a-z0-9]+)", model: "N$1" }, { regex: "NOKIA; (?!Qt;)([a-z0-9\\- ]+)", model: "$1" }, { regex: "NOKIA[ _]?([a-z0-9\\-]+)", model: "$1" }, { regex: "NOKIA/([a-z0-9 ]+)", model: "$1" }, { regex: "(Lumia [a-z0-9\\-]+ XL)", device: "phablet", model: "$1" }, { regex: "(Lumia [a-z0-9\\-]+)", model: "$1" }, { regex: "Maemo RX-51 ([a-z0-9]+)", model: "$1" }, { regex: "Maemo RX-34", model: "N800" }, { regex: "NokiaInternal|Nokia-WAP-Toolkit|Nokia-MIT-Browser|Nokia Mobile|Nokia Browser|Nokia/Series", model: "" }, { regex: "portalmmm/2\\.0 (N7[37]|NK[a-z0-9]+)", model: "$1" }, { regex: "nok([0-9]+)", model: "$1" }, { regex: "Symbian.*\\s([a-z0-9]+)$", device: "feature phone", model: "$1" }] }, YZ = { regex: "CnM", device: "tablet", models: [{ regex: "CnM[ \\-](?:Touchpad|TP)[ \\-]([0-9\\.]+)", model: "Touchpad $1" }] }, KZ = { regex: "BB10;|BlackBerry|rim[0-9]+|PlayBook|STV100-[1234]|STH100-[12]|BBA100-[12]|BBB100-[1234567]|BBD100-[126]|BB[EF]100-[123456789]|BB[CGH]100-1", device: "smartphone", models: [{ regex: "BBA100-[12]", model: "BlackBerry DTEK60" }, { regex: "BBB100-[1234567]", model: "KEYone" }, { regex: "BBC100-1", model: "Aurora" }, { regex: "BBD100-[126]", model: "Motion" }, { regex: "BBE100-[123456789]", model: "KEY2 LE" }, { regex: "BBF100-[1234567]", model: "KEY2" }, { regex: "BBF100-8", model: "KEY2 Silver" }, { regex: "BBF100-9", model: "KEY2 Black" }, { regex: "BBG100-1", model: "Evolve" }, { regex: "BBH100-1", model: "Evolve X" }, { regex: "STV100-[1234]", model: "BlackBerry Priv" }, { regex: "STH100-[12]", model: "BlackBerry DTEK50" }, { regex: "BB10; ([a-z0-9\\- ]+)\\)", model: "BlackBerry $1" }, { regex: "PlayBook.+RIM Tablet OS", model: "BlackBerry Playbook", device: "tablet" }, { regex: "BlackBerry(?: )?([a-z0-9]+)", model: "BlackBerry $1" }, { regex: "rim([0-9]+)", model: "BlackBerry $1" }, { regex: "9000", model: "Bold 9000" }, { regex: "9300", model: "Curve 3G 9300" }, { regex: "(8520|8530|9220|9320|9360)", model: "Curve $1" }, { regex: "9630", model: "Tour 9630" }, { regex: "9720", model: "9720" }, { regex: "(9800|9860)", model: "Torch $1" }, { regex: "BlackBerry", model: "BlackBerry" }] }, QZ = { regex: "(SVEGLIO[ _][QH]1|TREO_TAB8G|GTA7WF)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "SVEGLIO[ _]([QH]1)", model: "Sveglio $1" }, { regex: "TREO_TAB8G", device: "tablet", model: "TREO TAB8G" }, { regex: "GTA7WF", device: "tablet", model: "GTA7WF" }] }, jZ = { regex: "(?:Pre|Pixi)/(\\d+)\\.(\\d+)|Palm|Treo|Xiino", device: "smartphone", models: [{ regex: "((?:Pre|Pixi))/(\\d+\\.\\d+)", model: "$1 $2" }, { regex: "Palm(?:[ \\-])?((?!OS|Source|scape)[a-z0-9]+)", model: "$1" }, { regex: "Treo([a-z0-9]+)", model: "Treo $1" }, { regex: "Tungsten", model: "Tungsten" }, { regex: "Xiino|Palmscape", model: "" }] }, ZZ = { regex: "Hewlett-Packard|HP/HP|HP EliteBook 820|TouchPad/\\d+\\.\\d+|hp-tablet|HP ?iPAQ|webOS.*P160U|HP (?:Pro )?Slate|HP [78]|HP 10 Plus|Compaq [7|8]|HP; [^;/)]+", device: "smartphone", models: [{ regex: "HP Slate 6 Voice Tab", model: "Slate 6 VoiceTab", device: "phablet" }, { regex: "HP 10 Plus", model: "10 Plus", device: "tablet" }, { regex: "HP ([78][^)/;]*)(?: Build|\\))", model: "Slate $1", device: "tablet" }, { regex: "Compaq ([78][^/;]*) Build", model: "Compaq $1", device: "tablet" }, { regex: "HP Pro Slate 8", model: "Pro Slate 8", device: "tablet" }, { regex: "HP Slate ?(.+) Build", model: "Slate $1", device: "tablet" }, { regex: "HP Slate ?([0-9]+)", model: "Slate $1", device: "tablet" }, { regex: "TouchPad/(\\d+\\.\\d+)|hp-tablet", model: "TouchPad", device: "tablet" }, { regex: "HP; ([^;/)]+)", model: "$1" }, { regex: "HP ?iPAQ ?([a-z0-9]+)", model: "iPAQ $1" }, { regex: "webOS.*(P160U)", model: "Veer" }, { regex: "HP ProBook (6560b)", device: "desktop", model: "ProBook $1" }, { regex: "HP EliteBook 820 G2", device: "desktop", model: "EliteBook 820 G2" }, { regex: "Z240 Tower Workstation", device: "desktop", model: "Z240 Tower Workstation" }] }, zZ = { regex: "TiPhone ?([a-z0-9]+)", device: "smartphone", model: "$1" }, qZ = /* @__PURE__ */ JSON.parse('{"regex":"(?:iTunes-)?Apple[ _]?TV|Apple/|(?:Apple-|iTunes-)?(?<!like )(?:iPad|iPhone)|iPh[0-9],[0-9]|CFNetwork|HomePod|Watch ?OS|Watch1,[12]|MDCR_Mac|ICRU_iP(?:ad|hone)","models":[{"regex":"HomePod","device":"smart speaker","model":"HomePod"},{"regex":"Watch1,1","device":"wearable","model":"Watch 38mm"},{"regex":"Watch1,2","device":"wearable","model":"Watch 42mm"},{"regex":"Watch2,6","device":"wearable","model":"Watch Series 1 38mm"},{"regex":"Watch2,7","device":"wearable","model":"Watch Series 1 42mm"},{"regex":"Watch2,3","device":"wearable","model":"Watch Series 2 38mm"},{"regex":"Watch2,4","device":"wearable","model":"Watch Series 2 42mm"},{"regex":"Watch3,[13]","device":"wearable","model":"Watch Series 3 38mm"},{"regex":"Watch3,[24]","device":"wearable","model":"Watch Series 3 42mm"},{"regex":"Watch5,(?:9|11)","device":"wearable","model":"Watch SE 40mm"},{"regex":"Watch5,1[02]","device":"wearable","model":"Watch SE 44mm"},{"regex":"Watch([456]),[13]","device":"wearable","model":"Watch Series $1 40mm"},{"regex":"Watch([456]),[24]","device":"wearable","model":"Watch Series $1 44mm"},{"regex":"(?:.+_)?MacBook7(?:%2C|,)1","device":"desktop","model":"MacBook 13\\" (2010)"},{"regex":"(?:.+_)?MacPro5(?:%2C|,)1","device":"desktop","model":"Mac Pro (2010-2012)"},{"regex":"(?:.+_)?iMac12(?:%2C|,)1","device":"desktop","model":"iMac 21.5\\" (2011)"},{"regex":"(?:.+_)?iMac17(?:%2C|,)1","device":"desktop","model":"iMac 27\\" (2015)"},{"regex":"(?:.+_)?iMac19(?:%2C|,)2","device":"desktop","model":"iMac 21.5\\" (2019)"},{"regex":"(?:.+_)?iMac19(?:%2C|,)1","device":"desktop","model":"iMac 27\\" (2019)"},{"regex":"(?:.+_)?iMac20(?:%2C|,)[12]","device":"desktop","model":"iMac 27\\" (2020)"},{"regex":"(?:.+_)?iMac14(?:%2C|,)2","device":"desktop","model":"iMac 27\\" (2013)"},{"regex":"(?:.+_)?iMac14(?:%2C|,)4","device":"desktop","model":"iMac 21.5\\" (2014)"},{"regex":"(?:.+_)?iMac14(?:%2C|,)1","device":"desktop","model":"iMac 21.5\\" (2013)"},{"regex":"(?:.+_)?MacBook6(?:%2C|,)1","device":"desktop","model":"MacBook 13\\" (2009)"},{"regex":"(?:.+_)?MacBook8(?:%2C|,)1","device":"desktop","model":"MacBook 12\\" (2015)"},{"regex":"(?:.+_)?MacBook9(?:%2C|,)1","device":"desktop","model":"MacBook 12\\" (2016)"},{"regex":"(?:.+_)?iMac10(?:%2C|,)1","device":"desktop","model":"iMac (2009)"},{"regex":"(?:.+_)?MacBookAir2(?:%2C|,)1","device":"desktop","model":"MacBook Air (2009)"},{"regex":"(?:.+_)?MacBookAir3(?:%2C|,)1","device":"desktop","model":"MacBook Air 11\\" (2010)"},{"regex":"(?:.+_)?MacBookAir3(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2010)"},{"regex":"(?:.+_)?MacBookAir4(?:%2C|,)1","device":"desktop","model":"MacBook Air 11\\" (2011)"},{"regex":"(?:.+_)?MacBookAir4(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2011)"},{"regex":"(?:.+_)?MacBookAir5(?:%2C|,)1","device":"desktop","model":"MacBook Air 11\\" (2012)"},{"regex":"(?:.+_)?MacBookAir5(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2012)"},{"regex":"(?:.+_)?MacBookAir6(?:%2C|,)1","device":"desktop","model":"MacBook Air 11\\" (2013-2014)"},{"regex":"(?:.+_)?MacBookAir6(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2013-2014)"},{"regex":"(?:.+_)?MacBookAir7(?:%2C|,)1","device":"desktop","model":"MacBook Air 11\\" (2015)"},{"regex":"(?:.+_)?MacBookAir7(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2015-2017)"},{"regex":"(?:.+_)?MacBookAir8(?:%2C|,)1","device":"desktop","model":"MacBook Air 13\\" (2018)"},{"regex":"(?:.+_)?MacBookAir8(?:%2C|,)2","device":"desktop","model":"MacBook Air 13\\" (2019)"},{"regex":"(?:.+_)?MacBookAir9(?:%2C|,)1","device":"desktop","model":"MacBook Air 13\\" (2020)"},{"regex":"(?:.+_)?MacBookAir10(?:%2C|,)1","device":"desktop","model":"MacBook Air 13\\" (2020)"},{"regex":"(?:.+_)?MacBookPro1(?:%2C|,)1","device":"desktop","model":"MacBook Pro 15\\" (2006)"},{"regex":"(?:.+_)?MacBookPro1(?:%2C|,)2","device":"desktop","model":"MacBook Pro 17\\" (2006)"},{"regex":"(?:.+_)?MacBookPro2(?:%2C|,)1","device":"desktop","model":"MacBook Pro 17\\" (2007)"},{"regex":"(?:.+_)?MacBookPro2(?:%2C|,)2","device":"desktop","model":"MacBook Pro 15\\" (2007)"},{"regex":"(?:.+_)?MacBookPro[34](?:%2C|,)1","device":"desktop","model":"MacBook Pro (2008)"},{"regex":"(?:.+_)?MacBookPro5(?:%2C|,)1","device":"desktop","model":"MacBook Pro 15\\" (2008)"},{"regex":"(?:.+_)?MacBookPro5(?:%2C|,)2","device":"desktop","model":"MacBook Pro 17\\" (2009)"},{"regex":"(?:.+_)?MacBookPro5(?:%2C|,)[34]","device":"desktop","model":"MacBook Pro 15\\" (2009)"},{"regex":"(?:.+_)?MacBookPro5(?:%2C|,)5","device":"desktop","model":"MacBook Pro 13\\" (2009)"},{"regex":"(?:.+_)?MacBookPro6(?:%2C|,)1","device":"desktop","model":"MacBook Pro 17\\" (2010)"},{"regex":"(?:.+_)?MacBookPro6(?:%2C|,)2","device":"desktop","model":"MacBook Pro 15\\" (2010)"},{"regex":"(?:.+_)?MacBookPro7(?:%2C|,)1","device":"desktop","model":"MacBook Pro 13\\" (2010)"},{"regex":"(?:.+_)?MacBookPro8(?:%2C|,)1","device":"desktop","model":"MacBook Pro 13\\" (2011)"},{"regex":"(?:.+_)?MacBookPro8(?:%2C|,)2","device":"desktop","model":"MacBook Pro 15\\" (2011)"},{"regex":"(?:.+_)?MacBookPro8(?:%2C|,)3","device":"desktop","model":"MacBook Pro 17\\" (2011)"},{"regex":"(?:.+_)?MacBookPro9(?:%2C|,)1","device":"desktop","model":"MacBook Pro 15\\" (2012)"},{"regex":"(?:.+_)?MacBookPro9(?:%2C|,)2","device":"desktop","model":"MacBook Pro 13\\" (2012)"},{"regex":"(?:.+_)?MacBookPro10(?:%2C|,)1","device":"desktop","model":"MacBook Pro 15\\" (2012-2013)"},{"regex":"(?:.+_)?MacBookPro10(?:%2C|,)2","device":"desktop","model":"MacBook Pro 13\\" (2012-2013)"},{"regex":"(?:.+_)?MacBookPro11(?:%2C|,)1","device":"desktop","model":"MacBook Pro 13\\" (2013-2014)"},{"regex":"(?:.+_)?MacBookPro11(?:%2C|,)[23]","device":"desktop","model":"MacBook Pro 15\\" (2013-2014)"},{"regex":"(?:.+_)?MacBookPro11(?:%2C|,)[45]","device":"desktop","model":"MacBook Pro 15\\" (2015)"},{"regex":"(?:.+_)?MacBookPro12(?:%2C|,)1","device":"desktop","model":"MacBook Pro 13\\" (2015)"},{"regex":"(?:.+_)?MacBookPro13(?:%2C|,)[12]","device":"desktop","model":"MacBook Pro 13\\" (2016)"},{"regex":"(?:.+_)?MacBookPro13(?:%2C|,)3","device":"desktop","model":"MacBook Pro 15\\" (2016)"},{"regex":"(?:.+_)?MacBookPro14(?:%2C|,)[12]","device":"desktop","model":"MacBook Pro 13\\" (2017)"},{"regex":"(?:.+_)?MacBookPro14(?:%2C|,)3","device":"desktop","model":"MacBook Pro 15\\" (2017)"},{"regex":"(?:.+_)?MacBookPro15(?:%2C|,)1","device":"desktop","model":"MacBook Pro 15\\" (2018-2019)"},{"regex":"(?:.+_)?MacBookPro15(?:%2C|,)2","device":"desktop","model":"MacBook Pro 13\\" (2018-2019)"},{"regex":"(?:.+_)?MacBookPro15(?:%2C|,)3","device":"desktop","model":"MacBook Pro 15\\" (2019)"},{"regex":"(?:.+_)?MacBookPro15(?:%2C|,)4","device":"desktop","model":"MacBook Pro 13\\" (2019)"},{"regex":"(?:.+_)?MacBookPro16(?:%2C|,)[14]","device":"desktop","model":"MacBook Pro 16\\" (2019)"},{"regex":"(?:.+_)?MacBookPro16(?:%2C|,)[23]","device":"desktop","model":"MacBook Pro 13\\" (2020)"},{"regex":"(?:.+_)?MacBookPro17(?:%2C|,)1","device":"desktop","model":"MacBook Pro 13\\" (2020)"},{"regex":"(?:.+_)?Macmini8(?:%2C|,)1","device":"desktop","model":"Mac Mini (2018)"},{"regex":"(?:.+_)?Macmini9(?:%2C|,)1","device":"desktop","model":"Mac Mini (2020)"},{"regex":"(?:.+_)?Macmini7(?:%2C|,)1","device":"desktop","model":"Mac Mini (2014)"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?1[C,_]1","model":"iPhone","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?1[C,_]2","model":"iPhone 3G","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?2[C,_]1| 3GS\\\\)$","model":"iPhone 3GS","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?3[C,_][123]","model":"iPhone 4","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?4[C,_]1|1C2%254enohPi| 4S\\\\)$","model":"iPhone 4S","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?5[C,_][12]| 5\\\\)$","model":"iPhone 5","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?5[C,_][34]","model":"iPhone 5C","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?6[C,_][12]| 5S\\\\)$","model":"iPhone 5S","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?7[C,_]1|1C2%257enohPi| 6PLUS\\\\)$","model":"iPhone 6 Plus","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?7[C,_]2| 6\\\\)$","model":"iPhone 6","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?8[C,_]2| 6SPLUS\\\\)$","model":"iPhone 6s Plus","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?8[C,_]1|iPhone 6s| 6S\\\\)$","model":"iPhone 6s","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?8[C,_]4| SE\\\\)$","model":"iPhone SE","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?9[C,_][13]| 7\\\\)$","model":"iPhone 7","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?9[C,_][24]| 7PLUS\\\\)$","model":"iPhone 7 Plus","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?10[C,_][14]| 8\\\\)$","model":"iPhone 8","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?10[C,_][25]| 8PLUS\\\\)$","model":"iPhone 8 Plus","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?10[C,_][36]|iPhone X| X\\\\)$","model":"iPhone X","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?11[C,_][2]| XS\\\\)$","model":"iPhone XS","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?11[C,_][46]| XSMAX\\\\)$","model":"iPhone XS Max","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?11[C,_][8]| XR\\\\)$","model":"iPhone XR","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?12[C,_][1]| 11\\\\)$","model":"iPhone 11","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?12[C,_][3]| 11PRO\\\\)$","model":"iPhone 11 Pro","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?12[C,_][5]| 11PROMAX\\\\)$","model":"iPhone 11 Pro Max","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?12[C,_][8]","model":"iPhone SE (2020)","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?13[C,_][1]","model":"iPhone 12 Mini","device":"smartphone"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?13[C,_][2]","model":"iPhone 12","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?13[C,_][3]","model":"iPhone 12 Pro","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPh(?:one)?13[C,_][4]","model":"iPhone 12 Pro Max","device":"phablet"},{"regex":"(?:Apple-|.+_)?iPad1[C,_]1","model":"iPad","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad2[C,_][1234]","model":"iPad 2","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad2[C,_][567]","model":"iPad Mini","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad3[C,_][123]","model":"iPad 3","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad3[C,_][456]","model":"iPad 4","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad4[C,_][123]","model":"iPad Air","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad4[C,_][456]","model":"iPad Mini 2","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad4[C,_][789]","model":"iPad Mini 3","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad5[C,_][12]","model":"iPad Mini 4","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad5[C,_][34]","model":"iPad Air 2","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad6[C,_][34]","model":"iPad Pro 9.7","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad6[C,_][78]","model":"iPad Pro 12.9","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad6[C,_](?:11|12)","model":"iPad 5 9.7","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad7[C,_][12]","model":"iPad Pro 2 12.9","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad7[C,_][34]","model":"iPad Pro 10.5","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad7[C,_][56]","model":"iPad 6 9.7","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad7[C,_](?:11|12)","model":"iPad 7 10.2","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad8[C,_](?:9|10)","model":"iPad Pro 2 11\\"","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad8[C,_]1[12]","model":"iPad Pro 4 12.9\\"","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad8[C,_][1-4]","model":"iPad Pro 3 11.0","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad8[C,_][5-8]","model":"iPad Pro 3 12.9","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad11[C,_][12]","model":"iPad Mini 5","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad11[C,_][34]","model":"iPad Air 3","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad11[C,_][67]","model":"iPad 8 10.2\\"","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad13[C,_][12]","model":"iPad Air 4","device":"tablet"},{"regex":"Apple-?TV2[C,_]1","model":"Apple TV 2","device":"tv"},{"regex":"Apple-?TV3[C,_][12]","model":"Apple TV 3","device":"tv"},{"regex":"Apple-?TV5[C,_]3","model":"Apple TV 4","device":"tv"},{"regex":"Apple-?TV6[C,_]2","model":"Apple TV 4K","device":"tv"},{"regex":"(?:iTunes-)?Apple[ _]?TV","model":"Apple TV","device":"tv"},{"regex":"HomePod","model":"HomePod","device":"smart speaker"},{"regex":"iTunes-iPad/[0-9]+(?:\\\\.[0-9]+)* \\\\(([^;]+);","model":"iPad $1","device":"tablet"},{"regex":"(?:Apple-|.+_)?iPad","model":"iPad","device":"tablet"},{"regex":"iTunes-iPhone/[0-9]+(?:\\\\.[0-9]+)* \\\\(([^;]+);","model":"iPhone $1","device":"smartphone"},{"regex":"(?:Apple-)?iPhone ?(3GS?|4S?|5[CS]?|6(:? Plus)?)?","model":"iPhone $1","device":"smartphone"}]}'), JZ = { regex: "(?:MicroMax[ \\-\\_]?[a-z0-9]+|Q327)|4560MMX|P70221|(?:YU(?:5040|5530)|AQ5001(?: Canvas Power)?|N8216|N8301)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "AQ5001 Canvas Power", model: "Canvas Power" }, { regex: "AQ5001", model: "Canvas Juice 2" }, { regex: "4560MMX(?:[);/ ]|$)", model: "4560MMX" }, { regex: "E481", model: "Canvas 5" }, { regex: "P70221(?:[);/ ]|$)", model: "Canvas Tab", device: "tablet" }, { regex: "Q327", model: "Bolt" }, { regex: "Q417", model: "Canvas Mega" }, { regex: "Q402\\+", model: "Bolt Pace" }, { regex: "YU5040(?:[);/ ]|$)", model: "YU Yureka YU5040" }, { regex: "YU5530(?:[);/ ]|$)", model: "YU Yureka S YU5530" }, { regex: "Q424", model: "Bolt Selfie" }, { regex: "Q426", model: "Canvas Mega 2" }, { regex: "N8216", model: "Infinity N11" }, { regex: "N8301", model: "Infinity N12" }, { regex: "MicroMax(?:[ \\-\\_])?(X291|X246|X252|X458|X312)", model: "$1", device: "feature phone" }, { regex: "MicroMax(?:[ \\-\\_])?(P[a-z0-9]+)", model: "$1", device: "tablet" }, { regex: "MicroMax(?:[ \\-\\_])?([a-z0-9]+)", model: "$1" }] }, ez = { regex: "BLECK", device: "tablet", model: "Bleck" }, tz = { regex: "Alba ?(?:57|4|10 TABLET|(?:7|10)(?:Nou|Pie))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Alba 57", model: "5.7" }, { regex: "Alba (4)", model: "$1" }, { regex: "10 TABLET", device: "tablet", model: "10 Tablet" }, { regex: "Alba((?:7|10)(?:Nou|Pie))", device: "tablet", model: "$1" }] }, rz = { regex: "AllCall_|Heat[34]|Rio_X(?:[);/ ]|$)|Hot ?[125][^;/]+ Build", device: "smartphone", models: [{ regex: "AllCall_(Alpha|Atom|Bro|Madrid)", model: "$1" }, { regex: "AllCall_S1_X", model: "S1 X" }, { regex: "AllCall_S1", model: "S1" }, { regex: "AllCall_RIO_S", model: "Rio S" }, { regex: "AllCall_RIO_PRO", model: "Rio Pro" }, { regex: "AllCall_RIO", model: "Rio" }, { regex: "Heat([34])", model: "Heat $1" }, { regex: "Rio_X(?:[);/ ]|$)", model: "Rio X" }, { regex: "Hot ?([125][^;/]+) Build", model: "Hot $1" }] }, oz = { regex: "Bravis[ _]|A501 Bright|A552 JOY Max|A504 Trace|A505 JOY Plus|A503 Joy|NB(?:106M|10[1-8]|751|7[145]|8[57]1|76)|NP101|NB961|NP 104 3G|B501|N1-570 Space|Atlas A551|A512 Harmony Pro|A510_Jeans_4G|A509_Jeans|N1_550_Cruiser", device: "smartphone", models: [{ regex: "A501 BRIGHT", model: "A501 Bright" }, { regex: "Bravis[_ ]X500", model: "Trace Pro" }, { regex: "Bravis[_ ]A506", model: "Crystal" }, { regex: "Bravis[_ ]A553", model: "Discovery" }, { regex: "BRAVIS[ _]TAU", model: "Tau" }, { regex: "BRAVIS[ _]DELTA", model: "Delta" }, { regex: "BRAVIS[ _]TREND", model: "Trend" }, { regex: "B501", model: "Easy" }, { regex: "N1-570", model: "Space" }, { regex: "BRAVIS[ ]A554", model: "A554 Grand" }, { regex: "BRAVIS[ ]S500", model: "S500 Diamond" }, { regex: "A505 JOY Plus", model: "A505 Joy Plus" }, { regex: "A552 JOY Max", model: "A552 Joy Max" }, { regex: "Atlas A551", model: "A551 Atlas" }, { regex: "A503 Joy", model: "A503 Joy" }, { regex: "A504 Trace", model: "A504 Trace" }, { regex: "A512 Harmony Pro", model: "A512 Harmony Pro" }, { regex: "A510_Jeans_4G", model: "A510 Jeans 4G" }, { regex: "A509_Jeans", model: "A509 Jeans" }, { regex: "BRAVIS NEO", model: "A401 Neo" }, { regex: "N1_550_Cruiser", model: "N1-550 Cruiser" }, { regex: "BRAVIS OMEGA", model: "Omega" }, { regex: "BRAVIS BIZ", model: "Biz" }, { regex: "BRAVIS POWER", model: "Power" }, { regex: "BRAVIS[ _]SPARK", model: "Spark" }, { regex: "BRAVIS[ _]SLIM[ _]3G", model: "Slim 3G", device: "tablet" }, { regex: "NP 104 3G", model: "NP104 3G", device: "tablet" }, { regex: "BRAVIS NP 103", model: "NP103", device: "tablet" }, { regex: "BRAVIS NP 844", model: "NP844", device: "tablet" }, { regex: "Bravis[_ ]([^;\\)]+) Build", model: "$1" }, { regex: "(NB(?:106M|10[1-8]|751|7[145]|8[57]1|76)|NP101|NB961)", model: "$1", device: "tablet" }] }, nz = { regex: "acer|(?<!Satellite |ZTE BLADE |ImSmart |ERGO |X-Style Tab )a(?:101|110|2[10]0|211|50[10]|51[10]|70[10])(?:[);/ ]|$)|Android.*V3[67]0(?:[);/ ]|$)|Android.*Z1[23456]0 Build|Android.*Z5\\d{2} Build|Android.*T0[234678] Build|Android.*S55(?:[);/ ]|$)|(?:A1-(713(HD)?|7[23]4|830|841|840FHD|81[01])|A3-A[1234][01]|B1-(7[1235-8][01](HD)?|7[23]3|7A0|8[1235]0|A71|860A)|TPA60W|B3-(A[125]0|A3[02]|A40FHD)|E39)(?:[);/ ]|$)|S5[12]0 Build|(DA[0-9]+HQ?L|Aspire (?:V5-121|XC-704G|V5-573G)|Chromebook 14 \\(CB3-431\\)|Predator G9-793|GT-810|B1-870|B3-A4[02]|B3-A50FHD)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "DA220HQL(?:[);/ ]|$)", model: "DA220HQL", device: "smart display" }, { regex: "DA241HL(?:[);/ ]|$)", model: "DA241HL", device: "smart display" }, { regex: "(DA[0-9]+HQ?L)(?:[);/ ]|$)", model: "$1", device: "smart display" }, { regex: "A1-81[01]", model: "Iconia A", device: "tablet" }, { regex: "TPA60W", model: "TPA60W", device: "tablet" }, { regex: "A1-84(1|0FHD)", model: "Iconia Tab 8", device: "tablet" }, { regex: "A1-713(HD)?", model: "Iconia Tab 7", device: "tablet" }, { regex: "A1-830", model: "Iconia A1", device: "tablet" }, { regex: "A1-7[23]4", model: "Iconia Talk S", device: "tablet" }, { regex: "A3-A[12][01]", model: "Iconia A3", device: "tablet" }, { regex: "A3-A[34]0", model: "Iconia Tab 10", device: "tablet" }, { regex: "B1-7(?:[5678]0|30HD|A0)", model: "Iconia One 7", device: "tablet" }, { regex: "B1-7[123][01]|B1-A71", model: "Iconia B1", device: "tablet" }, { regex: "B1-7[23]3", model: "Iconia Talk 7", device: "tablet" }, { regex: "B1-8[123567]0", model: "Iconia One 8", device: "tablet" }, { regex: "B3-A([125]0|3[02]|[45]0FHD|4[02])", model: "Iconia One 10", device: "tablet" }, { regex: "A101", model: "Vangogh", device: "tablet" }, { regex: "A200", model: "Picasso E", device: "tablet" }, { regex: "A50[01]", model: "Picasso", device: "tablet" }, { regex: "Acer One 7", model: "One 7", device: "tablet" }, { regex: "GT-810", model: "Predator 8", device: "tablet" }, { regex: "E39(?:[);/ ]|$)", model: "Liquid E700" }, { regex: "E310(?:[);/ ]|$)", model: "Liquid Mini" }, { regex: "E320(?:-orange)?(?:[);/ ]|$)", model: "Liquid Express" }, { regex: "E310(?:[);/ ]|$)", model: "beTouch E210" }, { regex: "Android.*V360(?:[);/ ]|$)", model: "Liquid E1 Duo" }, { regex: "Android.*V370(?:[);/ ]|$)", model: "Liquid E2 Duo" }, { regex: "S510(?:[);/ ]|$)", model: "Liquid S1" }, { regex: "S520(?:[);/ ]|$)", model: "Liquid S2" }, { regex: "(?:Acer_)?P400(?:[);/ ]|$)", model: "neoTouch P400" }, { regex: "(?:Acer_)?P300(?:[);/ ]|$)", model: "neoTouch P300" }, { regex: "(?:Acer_)?S200(?:[);/ ]|$)", model: "neoTouch S200" }, { regex: "(?:Acer_)?E100(?:[);/ ]|$)", model: "beTouch E100" }, { regex: "Android.*Z1([234])0(?:[);/ ]|$)", model: "Liquid Z$1" }, { regex: "Android.*Z110(?:[);/ ]|$)", model: "Liquid Z110" }, { regex: "Android.*Z150(?:[);/ ]|$)", model: "Liquid Z5 Duo" }, { regex: "Android.*Z160(?:[);/ ]|$)", model: "Liquid Z4 Duo" }, { regex: "Android.*Z(5\\d{2})(?:[);/ ]|$)", model: "Liquid Z$1" }, { regex: "Android.*S57(?:[);/ ]|$)", model: "Liquid Jade Z" }, { regex: "Android.*T02(?:[);/ ]|$)", model: "Liquid Z530" }, { regex: "Android.*T03(?:[);/ ]|$)", model: "Liquid Z630" }, { regex: "Android.*T04(?:[);/ ]|$)", model: "Liquid Z630S" }, { regex: "Android.*T06(?:[);/ ]|$)", model: "Liquid Zest" }, { regex: "Android.*T07(?:[);/ ]|$)", model: "Liquid Zest 4G" }, { regex: "Android.*T08(?:[);/ ]|$)", model: "Liquid Zest Plus" }, { regex: "TM01(?:[);/ ]|$)", model: "Liquid M330" }, { regex: "M220(?:[);/ ]|$)", model: "Liquid M220" }, { regex: "AcerTD600", model: "TD600" }, { regex: "Android.*S55(?:[);/ ]|$)", model: "Liquid Jade" }, { regex: "(?:Acer )?(Chromebook R1[13])", model: "$1", device: "desktop" }, { regex: "(?:Acer )?(Chromebook 14)", model: "$1", device: "desktop" }, { regex: "(Aspire (?:V5-121|XC-704G|V5-573G|A515-51G))", model: "$1", device: "desktop" }, { regex: "(Predator G9-793|Aspire E5-511)", model: "$1", device: "desktop" }, { regex: "Acer; ?([^;\\(\\)/]+)", model: "$1" }, { regex: "Acer(?! ?inc)[ _\\-]?([^;\\(\\)/]+)[();/ ]", model: "$1" }, { regex: "acer[\\-_]([a-z0-9]+)", model: "$1" }, { regex: "a(101|110|2[10]0|211|50[10]|51[10]|70[10])(?:[);/ ]|$)", model: "Iconia Tab A$1", device: "tablet" }] }, az = { regex: "(?:ADVAN (?:M4|S40)|i7U|S45E|S50H|I7D|i55[KD]|i4U|S7D|S4Z|i5[KE]|S5E[ _]NXT|S5J\\+|S4\\+)(?:[);/ ]|$)|[ ](?:50(?:[46]1|59)|600[24])(?: Build|\\) AppleWebKit)|(?:E1C_3G)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ADVAN M4", model: "M4" }, { regex: "ADVAN S40", model: "S40" }, { regex: "i7U", model: "I Lite i7U" }, { regex: "S5E[ _]NXT", model: "S5E NXT" }, { regex: "i(55[KD]|5[KE])", model: "I$1" }, { regex: "i4U", model: "I4U" }, { regex: " 6004(?: Build|\\) AppleWebKit)", model: "G2 Pro" }, { regex: " 6002(?: Build|\\) AppleWebKit)", model: "G3 Pro" }, { regex: "(S45E|50[46]1|5059|S50H|I7D|S7D|S4Z|S5J\\+|S4\\+)(?:[);/ ]|$)", model: "$1" }, { regex: "E1C_3G", device: "tablet", model: "E1C 3G" }] }, lz = { regex: "Hollogram|(?:HL(?:4936|6246|[56]575|5[67]67)|IntroTr3544|Pr(?:61(?:4[56]|50)|60[27]0|5[69]50)|Tr3845)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "IntroTr3544|Tr3845", model: "Intro", device: "tablet" }, { regex: "Pr(61(?:4[56]|50)|60[27]0|5[69]50)", model: "Prime PR$1", device: "tablet" }, { regex: "HL(4936|6246|[56]575|5[67]67)", model: "Hollogram HL$1" }, { regex: "Hollogram ([^;/)]+)(?: Build|[;)])", model: "Hollogram $1" }] }, iz = { regex: "AGM ([^/;)]+)(?: Build|[;)])", device: "smartphone", model: "$1" }, sz = { regex: "AIRNESS-([\\w]+)", device: "feature phone", model: "$1" }, dz = { regex: "(?:AW790|M300|AWM(?:533|50[19]|561)|AW500)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "AW790(?:[);/ ]|$)", model: "AW790" }, { regex: "AW500(?:[);/ ]|$)", model: "AW500" }, { regex: "AWM(533|50[19]|561)(?:[);/ ]|$)", model: "AWM$1" }, { regex: "M300(?:[);/ ]|$)", model: "M300", device: "phablet" }] }, uz = { regex: "AKAI,|Akai[ _-]|Eco[ _]E2|Glory[ _](?:G[1235]|L[123]|O[125])|TAB-[79]8[03]0Q?|X6 METAL|AKTB-703MZ", device: "smartphone", models: [{ regex: "TAB-([79]8[03]0Q?)", device: "tablet", model: "TAB $1" }, { regex: "AKTB-703MZ", device: "tablet", model: "AKTB-703MZ" }, { regex: "X6 METAL", model: "iLike" }, { regex: "Glory[ _](G[1235]|L[123]|O[125])", model: "Glory $1" }, { regex: "Eco[ _]E2", model: "Eco E2" }, { regex: "Akai[ _-]([^;/)]+)(?: Build|[;)])", model: "$1" }, { regex: "AKAI,(AK3219NF)", device: "tv", model: "$1" }, { regex: "Si2157LG32", device: "tv", model: "Si2157LG32" }] }, cz = /* @__PURE__ */ JSON.parse('{"regex":"Alcatel|Alc(?!or )[a-z0-9]+|One[ _]?Touch|idol3|TIMXL|(?:(?:4003[AJ]|4009[ADEFIKMSX]|4013[DEJKMX]|4014[ADEKMX]|4015[ADNTX]|4016[ADX]|4017[ADEFSX]|4018[ADEFMX]|4024[EDX]|4027[ADNX]|4028[AEJS]|4032[ADEX]|4034[ADEFGXTL]|4035[ADXY]|4045[ADEX]|4047[ADFGNX]|4049[DEGMX]|4060[SW]|A466BG|A621BL|4114E|4087U|5001[ADJTU]|5002[ADFH]|5003[ADGU]|5006D|5007[AU]|5008[ADUYT]|5009[AD]|5010[DEGSUX]|5011A|5012[DFG]|5015[ADEX]|5016[AXJ]|5017[ABDEOX]|5019D|5022[EDX]|5023[EF]|5024[ADJF]|5025[DEG]|5026[ADJ]|5027B|5028[AYD]|5029[EYD]|5030[DE]|5032W|5033[AEFXDJGMOTXYQS]|5034D|5036D|5038[ADEX]|5039[DY]|5041[CD]|5042[ADEFGWXT]|5044[ADGIKOPSTY]|5045[ADFGIJTXY]|5046[ADGIJSTUY]|5047[DIUY]|5048[AYUI]|5049[EGSWZ]|5050[ASXY]|5051[ADEJMTWX]|5052[ADY]|5053[ADKY]|5054[ADNSTWX]|5056[ADEGIJMNTUWX]|5057M|5058[AIY]|5059[ADJXYZIST]|5060[ADJ]|5061[KU]|5065[ADNWX]|5070D|5080[ADFQUX]|5085[ABCDGHIJNOQY]|5086[ADY]|5090[AIY]|5095[IKY]|5098[OS]|5099[ADYUI]|5116J|5145A|6016[ADEX]|6036[AXY]|6037[BKY]|6039[AHJKY]|6042D|6043[AD]|6044D|6045[BFIKOYX]|6050[AFY]|6055[ABDHIKPUYZ]|6058[ADX]|6060[SX]|6062W|6070K|7040[ADEFKRT]|7041[DX]|7042A|7043[AEKY]|7044[AX]|7045Y|7048[ASWX]|7053D|7055A|7070X|7071[ADX]|8030Y|8050[DEGX]|8063|8088[XQM]|9001[DIX]|9002X|9003[AX]|9024O|9005X|9026X|9007[ATX]|9008[ADIJNTUX]|9009G|9010X|9020A|9022X|9027[FTWX]|9029Z|9203A|A(?:464BG|570BL|50[13]DL|57[17]VL|574BL)|I213|I216X|(?<!\\\\.)80(?:82|6[78])|A576CC)(?:_(?:EEA|RU))?|P360X)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"4087U","model":"1SE Light"},{"regex":"5022[EDX]|5070D","model":"One Touch Pop Star"},{"regex":"6044D","model":"One Touch Pop Up"},{"regex":"4015[ATX]|4016A","model":"One Touch Pop C1"},{"regex":"4015[DN]|4016[DX]","model":"One Touch Pop C1 Dual SIM"},{"regex":"4032[AX]","model":"One Touch Pop C2"},{"regex":"4032[DE]","model":"One Touch Pop C2 Dual SIM"},{"regex":"5036D","model":"One Touch Pop C5 Dual SIM"},{"regex":"7040[AFK]|7041X|7042A","model":"One Touch Pop C7"},{"regex":"7040[DE]|7041D","model":"One Touch Pop C7 Dual SIM"},{"regex":"4018[ADEFMX]","model":"One Touch Pop D1"},{"regex":"4035[ADXY]","model":"One Touch Pop D3"},{"regex":"5038[ADEX]","model":"One Touch Pop D5"},{"regex":"4045[AX]","model":"One Touch Pop 2 4\\""},{"regex":"4045[DE]","model":"One Touch Pop 2 4\\" Dual SIM"},{"regex":"5042[AFGWX]","model":"One Touch Pop 2 4.5\\""},{"regex":"5042[DE]","model":"One Touch Pop 2 4.5\\" Dual SIM"},{"regex":"7043[AY]|7044[AX]","model":"One Touch Pop 2 5\\""},{"regex":"7043[EK]","model":"One Touch Pop 2 5\\" Dual SIM"},{"regex":"50[16]5X","model":"One Touch Pop 3"},{"regex":"5015[AE]|5016[AJ]|5065[ADWX]|5116J","model":"One Touch Pop 3 5\\""},{"regex":"5025[DEG]|5054[ADSTX]","model":"One Touch Pop 3 5.5\\""},{"regex":"5015D","model":"One Touch Pop 3 Dual SIM"},{"regex":"5051[AEJMTWX]","model":"One Touch Pop 4"},{"regex":"5051D","model":"One Touch Pop 4 Dual SIM"},{"regex":"5095[IKY]","model":"One Touch Pop 4S"},{"regex":"5056[ADEGJMTUX]","model":"One Touch Pop 4+"},{"regex":"7070X","model":"One Touch Pop 4 6\\""},{"regex":"5057M","model":"One Touch Pop Mirage"},{"regex":"5050[ASXY]","model":"One Touch Pop S3"},{"regex":"7045Y","model":"One Touch Pop S7"},{"regex":"6037[BKY]","model":"One Touch Idol 2"},{"regex":"5042T","model":"One Touch Astro"},{"regex":"5027B","model":"One Touch Dawn"},{"regex":"5024[ADF]|5028Y","model":"1S"},{"regex":"7071[ADX]","model":"A7 XL"},{"regex":"5002[ADH]","model":"1B (2020)"},{"regex":"4034T","model":"1E"},{"regex":"5002F","model":"1A (2020)"},{"regex":"5034D","model":"3L"},{"regex":"A576CC","model":"Kora A576CC"},{"regex":"7040[RT]","model":"One Touch Fierce 2"},{"regex":"5056[NW]","model":"One Touch Fierce 4"},{"regex":"5054N","model":"One Touch Fierce XL"},{"regex":"6042D","model":"One Touch Flash"},{"regex":"6016[AX]","model":"One Touch Idol 2 mini"},{"regex":"6016[DE]","model":"One Touch Idol 2 mini Dual SIM"},{"regex":"6036[AXY]","model":"One Touch Idol 2 mini S"},{"regex":"6050[AFY]","model":"One Touch Idol 2S"},{"regex":"6039[AHJKY]|idol3","model":"One Touch Idol 3"},{"regex":"6045[BFIKOYX]","model":"One Touch Idol 3 5.5\\""},{"regex":"6055[ABDHIKPUYZ]","model":"One Touch Idol 4"},{"regex":"6070K","model":"One Touch Idol 4S"},{"regex":"6058[ADX]","model":"One Touch Idol 5"},{"regex":"6060[SX]","model":"One Touch Idol 5S"},{"regex":"6043[AD]","model":"One Touch Idol X+"},{"regex":"8030Y","model":"One Touch Hero 2"},{"regex":"7055A","model":"One Touch Hero 2C"},{"regex":"7053D","model":"One Touch X1"},{"regex":"5065N","model":"TRU"},{"regex":"A574BL","model":"Raven"},{"regex":"A577VL","model":"Zip"},{"regex":"A466BG","model":"Pixi Unite"},{"regex":"5056I","model":"One Touch Optus X Smart"},{"regex":"A570BL","model":"One Touch Pixi Avion LTE"},{"regex":"A571VL","model":"One Touch Pixi Avion 4G LTE"},{"regex":"4024[DEX]","model":"One Touch Pixi First"},{"regex":"A464BG","model":"One Touch Pixi Glitz"},{"regex":"A621BL","model":"One Touch Pixi Glory"},{"regex":"4014D","model":"One Touch Pixi 2"},{"regex":"4009[AFIKMSX]","model":"One Touch Pixi 3 3.5\\""},{"regex":"4009[DE]","model":"One Touch Pixi 3 3.5\\" Dual SIM"},{"regex":"4003[AJ]|4013[DEJKMX]|4014[AEKMX]|4114E","model":"One Touch Pixi 3 4\\""},{"regex":"4027[ADNX]|4028[AEJS]|5019D","model":"One Touch Pixi 3 4.5\\""},{"regex":"5017[ABDEOX]","model":"One Touch Pixi 3 4.5\\" 4G"},{"regex":"9002X","model":"One Touch Pixi 3 7\\"","device":"phablet"},{"regex":"9007A","model":"One Touch Pixi 3 7\\"","device":"tablet"},{"regex":"9007[TX]","model":"One Touch Pixi 3 7\\" 4G","device":"tablet"},{"regex":"9009G","model":"1T","device":"tablet"},{"regex":"(?!<\\\\.)8082(?:_(?:EEA|RU))?(?:[);/ ]|$)","model":"1T 10","device":"tablet"},{"regex":"(?!<\\\\.)806[78](?:_(?:EEA|RU))?(?:[);/ ]|$)","model":"1T 7","device":"tablet"},{"regex":"9022X","model":"One Touch Pixi 3 8\\"","device":"phablet"},{"regex":"9010X","model":"One Touch Pixi 3 10\\"","device":"tablet"},{"regex":"4017[ADEFSX]","model":"One Touch Pixi 4 3.5\\""},{"regex":"4034[ADEFGXL]","model":"One Touch Pixi 4 4\\""},{"regex":"4060[SW]","model":"One Touch Pixi 4 4.5\\""},{"regex":"5023[EF]","model":"One Touch Pixi 4 Plus Power"},{"regex":"5010[DEGSUX]","model":"One Touch Pixi 4 5\\" 3G"},{"regex":"5041D","model":"One Touch Pixi 4 5.0\\""},{"regex":"5012[DFG]","model":"One Touch Pixi 4 5.5\\" 3G"},{"regex":"5045[ADFGIJTXY]|5145A","model":"One Touch Pixi 4 5\\" 4G"},{"regex":"5098O","model":"One Touch Pixi Theatre"},{"regex":"A501DL","model":"A1"},{"regex":"A503DL","model":"A1X"},{"regex":"5046[ADIJTUY]","model":"A3"},{"regex":"5011A|5049[EG]","model":"A3 Plus"},{"regex":"9008[ADIJNTUX]","model":"A3 XL"},{"regex":"9203A","model":"A3 7\\" 3G","device":"tablet"},{"regex":"9027[FTWX]","model":"3T 8.0\\"","device":"tablet"},{"regex":"9026X","model":"A3 10\\"","device":"tablet"},{"regex":"5085[BQ]","model":"A5"},{"regex":"5085[ADHIJY]","model":"A5 LED"},{"regex":"5085N","model":"A5 Max LED"},{"regex":"5090[AIY]","model":"A7"},{"regex":"5046[GS]","model":"A30"},{"regex":"5049S","model":"A30 Plus"},{"regex":"5049Z","model":"A30 Fierce"},{"regex":"5085[GO]","model":"A50"},{"regex":"5048[AYUI]","model":"3X (2019)"},{"regex":"5049W","model":"Revvl"},{"regex":"8050[GX]","model":"One Touch Pixi 4 6\\" 3G"},{"regex":"8050[ED]","model":"One Touch Pixi 4 6\\" 3G Dual SIM"},{"regex":"5098S|9001[DIX]","model":"One Touch Pixi 4 6\\" 4G"},{"regex":"9003[AX]","model":"One Touch Pixi 4 7\\" 3G","device":"tablet"},{"regex":"8063","model":"One Touch Pixi 4 7\\" WiFi","device":"tablet"},{"regex":"9024O","model":"One Touch Pixi 5","device":"tablet"},{"regex":"I216X","model":"One Touch Pixi 7","device":"tablet"},{"regex":"I213","model":"One Touch Pixi 7","device":"tablet"},{"regex":"9005X","model":"One Touch Pixi 8","device":"tablet"},{"regex":"P320X","model":"One Touch POP 8","device":"tablet"},{"regex":"P310X","model":"One Touch POP 7","device":"tablet"},{"regex":"9020A","model":"One Touch Trek HD","device":"tablet"},{"regex":"7048[ASWX]","model":"One Touch Go Play"},{"regex":"(?:Alcatel-)?OT-802","model":"Wave"},{"regex":"ALCATEL_ONE_TOUCH_768T","model":"Island"},{"regex":"(?:TRIBE_)?3075A","model":"One Touch Tribe"},{"regex":"ALCATEL_one_touch_585","model":"One Touch 585"},{"regex":"ALCATEL_ONE_TOUCH_838","model":"One Touch 838"},{"regex":"ALCATEL_one_touch_813d","model":"One Touch 813D"},{"regex":"ALCATEL_one_touch_813","model":"One Touch 813"},{"regex":"OT871A","model":"One Touch 871A"},{"regex":"P360X","model":"One Touch Pop 10"},{"regex":"(?:Alcatel[ _])?One[ _]?Touch[ _]((?:T[0-9]+|TAB[^/;]+|EVO[78](?:HD)?)) Build","device":"tablet","model":"One Touch $1"},{"regex":"(?:Alcatel[ _])?One[ _]?Touch([^/;]*) Build","model":"One Touch$1"},{"regex":"(?:Alcatel[ _])?One[ _]?Touch([^/;\\\\)]*)\\\\)","model":"One Touch$1"},{"regex":"5080[ADFQUX]","model":"Shine Lite"},{"regex":"TIMXL","model":"TIM XL"},{"regex":"5085C","model":"PulseMix"},{"regex":"4049[DEGMX]","model":"U3"},{"regex":"5044[ADIKOPTY]","model":"U5"},{"regex":"4047[DFXN]","model":"U5 3G"},{"regex":"5047[DIUY]","model":"U5 HD"},{"regex":"4047G","model":"U5 Lite"},{"regex":"4047A","model":"U5 Plus"},{"regex":"4044[CV]","model":"Quick Flip"},{"regex":"4044O","model":"Cingular Flip 2"},{"regex":"(?:Alcatel)?4044[MNT]","model":"Go Flip"},{"regex":"5044[GS]","model":"U50"},{"regex":"5033[ADXJEFGMOTXYQS]","model":"1"},{"regex":"5009[AD]","model":"1C"},{"regex":"5008[ADUYT]","model":"1X (2019)"},{"regex":"5007[AU]","model":"1V (2020)"},{"regex":"5003[ADGU]","model":"1C (2019)"},{"regex":"5006D","model":"3C (2019)"},{"regex":"5024J","model":"1S"},{"regex":"5028[AD]","model":"1S (2020)"},{"regex":"5030[DE]","model":"1SE (2020)"},{"regex":"5001[ADJTU]","model":"1V"},{"regex":"5059[ADJXYZIT]","model":"1X"},{"regex":"5059S","model":"Avalon V"},{"regex":"5060[ADJ]","model":"5V","device":"phablet"},{"regex":"5052[ADY]|5053[ADKY]","model":"3"},{"regex":"5029E","model":"3 (2020)"},{"regex":"5029[DY]","model":"3L (2020)"},{"regex":"5032W|5099[ADYUI]","model":"3V"},{"regex":"5026[ADJ]","model":"3C"},{"regex":"5039[DY]","model":"3L","device":"phablet"},{"regex":"5058[AIY]","model":"3X"},{"regex":"5061[KU]","model":"3X (2020)"},{"regex":"5086[ADY]","model":"5"},{"regex":"6062W","model":"7"},{"regex":"8088[XQM]","model":"3T 10","device":"tablet"},{"regex":"9029Z","model":"Joy Tab","device":"tablet"},{"regex":"9029Z","model":"Joy Tab","device":"tablet"},{"regex":"Alcatel UP","model":""},{"regex":"(?:ALCATEL_)?A383G","model":"Big Easy Plus"},{"regex":"5041C","model":"TETRA"},{"regex":"ALCATEL([^/;]+) Build","model":"$1"},{"regex":"ALCATEL[ \\\\-]?([^/;\\\\)]+)","model":"$1"},{"regex":"ALCATEL_([^/;\\\\)]+)","model":"$1"},{"regex":"Alc([a-z0-9]+)","model":"$1"}]}'), mz = { regex: "Allview|A4You|H1003_LTE_PRO|A5_(?:Easy(?:_TM)?|Ready(?:_TM)?|Quad|Quad_Plus_TM)|A[5-9]_Lite|A5Smiley|A6_Duo|A10_Lite_2019|A10_(?:Plus|Max)|AX2_Frenzy|AX4Nano|AX5NanoQ|C6_Duo|E[23]_Living|E3_(?:Jump|Sign)|E4_Lite|M9_Connect|P(?:43_Easy|[5689]_Energy|6_Energy_Lite|[68]_Energy_Mini(?:_TM)?|(41|[458])_eMagic(?:_TM)?|[589](?:_)?Life(?:_TM)?|[567]_Lite(?:_TM)?|6_plus|[45678]_Pro|7_Seon|10_Life|10_Max|10_Style|7_Xtreme|6_Qmax|4_Quad)|V(?:[134]_Viper|1_Viper_I|2_Viper_(?:E|I|S|X|X_plus|Xe))|X4_Soul_Vision|X(?:[1-46]_Soul_Xtreme|[1-5]_Soul|3_Soul_Lite|[2-6]_Soul_Mini(?:_TM)?|4_Soul_Mini_S(?:_TM)?|[2-5]_Soul_Style(?:_TM)?|2_Soul_Style_Plus|2_Twin)|Viva_(?:H801|100[13]G|(?:H100[12]|H701|H802)_LTE|C701|i701G)", device: "smartphone", models: [{ regex: "A4You", model: "A4 You" }, { regex: "AX2_Frenzy", model: "AX2 Frenzy", device: "tablet" }, { regex: "AX4Nano", model: "AX4 Nano" }, { regex: "AX5NanoQ", model: "AX5 Nano Q", device: "tablet" }, { regex: "C6_Duo", model: "C6 Duo" }, { regex: "E([23])_Living", model: "E$1 Living" }, { regex: "E3_Jump", model: "E3 Jump" }, { regex: "E3_Sign", model: "E3 Sign" }, { regex: "E4_Lite", model: "E4 Lite" }, { regex: "M9_Connect", model: "M9 Connect" }, { regex: "P43_Easy", model: "P43 Easy" }, { regex: "P(41|[458])_eMagic(?:_TM)?", model: "P$1 eMagic" }, { regex: "P([567])_Lite(?:_TM)?", model: "P$1 Lite" }, { regex: "P6_plus", model: "P6 Plus" }, { regex: "P6_Qmax", model: "P6 Qmax" }, { regex: "P([45678])_Pro", model: "P$1 Pro" }, { regex: "P4_Quad", model: "P4 Quad" }, { regex: "P9_Energy_Lite_2017", model: "P9 Energy Lite (2017)" }, { regex: "P9_Energy_S", model: "P9 Energy S" }, { regex: "P([69])_Energy_Lite", model: "P$1 Energy Lite" }, { regex: "P8_Energy_PRO", model: "P8 Energy Pro" }, { regex: "P([689])_Energy_mini(?:_TM)?", model: "P$1 Energy Mini" }, { regex: "P([5689])_Energy", model: "P$1 Energy" }, { regex: "P7_Seon", model: "P7 Seon" }, { regex: "P7_Xtreme", model: "P7 Xtreme" }, { regex: "P([589])(?:_)?Life(?:_TM)?", model: "P$1 Life" }, { regex: "P10_Life", model: "P10 Life" }, { regex: "P10_Max", model: "P10 Max" }, { regex: "P10_Style", model: "P10 Style" }, { regex: "V([12])_Viper_I4G(?:_TM)?", model: "V$1 Viper I 4G" }, { regex: "V1_Viper_I", model: "V1 Viper I" }, { regex: "V([134])_Viper", model: "V$1 Viper" }, { regex: "V2_Viper_X_plus", model: "V2 Viper X Plus" }, { regex: "V2_Viper_(E|I|S|X(?:e)?)", model: "V2 Viper $1" }, { regex: "X4_Soul_Vision", model: "X4 Soul Vision" }, { regex: "X([1246])_Soul_Xtreme", model: "X$1 Soul Xtreme" }, { regex: "X4_Soul_Infinity_(L|N|S|Z)", model: "X4 Soul Infinity $1" }, { regex: "X([34])_Soul_Lite", model: "X$1 Soul Lite" }, { regex: "X4_Soul_Mini_S(?:_TM)?", model: "X4 Soul Mini S" }, { regex: "X([23456])_Soul_Mini(?:_TM)?", model: "X$1 Soul Mini" }, { regex: "X3_Soul_PLUS", model: "X3 Soul Plus" }, { regex: "X([35])_Soul_Pro", model: "X$1 Soul Pro" }, { regex: "X2_Soul_Style_Plus", model: "X2 Soul Style Plus" }, { regex: "X([2345])_Soul_Style(?:_TM)?", model: "X$1 Soul Style" }, { regex: "X([12345])_Soul", model: "X$1 Soul" }, { regex: "X2_Twin", model: "X2 Twin" }, { regex: "A5_Easy(?:_TM)?", model: "A5 Easy" }, { regex: "A([56789])_Lite", model: "A$1 Lite" }, { regex: "A5_Ready(?:_TM)?", model: "A5 Ready" }, { regex: "A5Smiley", model: "A5 Smiley" }, { regex: "A5_Quad_Plus_TM", model: "A5 Quad Plus" }, { regex: "A5_Quad", model: "A5 Quad" }, { regex: "A6_Duo", model: "A6 Duo" }, { regex: "A10_Lite_2019", model: "A10 Lite (2019)" }, { regex: "A10_Plus", model: "A10 Plus" }, { regex: "A10_Max", model: "A10 Max" }, { regex: "Impera S", model: "Impera S" }, { regex: "ALLVIEW P4i", model: "AllDro P4" }, { regex: "Allview_P2", model: "AllDro" }, { regex: "AllviewCityPlus", device: "tablet", model: "City Plus" }, { regex: "AllviewCity", device: "tablet", model: "City" }, { regex: "AllviewAX2Frenzy", device: "tablet", model: "AX2 Frenzy" }, { regex: "Allview2SpeedDuo", device: "tablet", model: "Alldro 2 Speed Duo" }, { regex: "Allview3SpeedQuad", device: "tablet", model: "Alldro 3 Speed Quad" }, { regex: "H1003_LTE_PRO", device: "tablet", model: "Viva H1003 LTE Pro" }, { regex: "Viva_(H801|100[13]G|(?:H802|H100[12]|H701)_LTE|C701|i701G)", device: "tablet", model: "Viva $1" }, { regex: "ALLVIEW ?SPEEDI", device: "tablet", model: "Speed I" }, { regex: "ALLVIEW ?SPEED", device: "tablet", model: "Speed" }, { regex: "ALLVIEWSPEED", device: "tablet", model: "Speed" }, { regex: "AX4Nano", device: "tablet", model: "AX4 Nano" }, { regex: "ALLVIEW_TX1_Quasar", device: "tablet", model: "TX1 Quasar" }, { regex: "Allview[ _-]([^;/]+) Build", model: "$1" }, { regex: "Allview[ _-]([^;/]+)(?:[;/)]|$)", model: "$1" }] }, gz = { regex: "(?:QUAD-CORE (?:A64 p3|A33 y3|T3 K2001M)|ZY-07B|UltraOcta-T8|OCTA-CORE T8)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "QUAD-CORE A64 p3", model: "A64 QUAD-CORE p3" }, { regex: "QUAD-CORE A33 y3", model: "A33 QUAD-CORE y3" }, { regex: "ZY-07B", model: "ZY-07B" }, { regex: "UltraOcta-T8", device: "car browser", model: "Ultra Octa T8" }, { regex: "QUAD-CORE T3 K2001M", device: "car browser", model: "QUAD-CORE T3 K2001M" }, { regex: "OCTA-CORE T8", device: "car browser", model: "OCTA-CORE T8" }] }, fz = { regex: "(AL-555|GI-626|OB[_-](?:421|728|627))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "AL-555", model: "AL-555" }, { regex: "OB[_-](421|728|627)", model: "OB-$1" }, { regex: "GI-626", device: "phablet", model: "GI-626" }] }, pz = { regex: "AM(350|355|40[257]|41[025]|450|50[89]|52[037]|51[58]|53[05])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "AM350", model: "Jack Pro" }, { regex: "AM(355|407)", model: "Tigo" }, { regex: "AM402", model: "Pronto" }, { regex: "AM410", model: "Unico" }, { regex: "AM450", model: "Swift" }, { regex: "AM508", model: "Fuego" }, { regex: "AM509", model: "Uno" }, { regex: "AM515", model: "D1" }, { regex: "AM518", model: "C1" }, { regex: "AM520", model: "Pro" }, { regex: "AM523", model: "Plus" }, { regex: "AM527", model: "Geo" }, { regex: "AM530", model: "A1" }, { regex: "AM535", model: "P1" }, { regex: "AM([0-9]{3})", model: "AM$1" }] }, hz = { regex: "Amoi|(?:A862W|Clever[ -]?(?:Gem S52|Gleam S45|Pad P7|Wave S50|Touch S46|JOY S40|Lite S41))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Clever Pad P7", model: "Clever Pad P7" }, { regex: "A862W", model: "A862W" }, { regex: "CLEVER JOY S40", model: "Clever Joy S40" }, { regex: "Clever[ -]?(Gleam S45|Gem S52|Wave S50|Touch S46|Lite S41)", model: "Clever $1" }, { regex: "Amoi[\\- /]([a-z0-9]+)", model: "$1" }, { regex: "Amoisonic-([a-z0-9]+)", model: "$1" }] }, xz = { regex: "Numy|novo[0-9]|Novo 10 Hero|AX10PRO|NUMY3GAX9|NOVO10 Spark|Aurora-II", device: "tablet", models: [{ regex: "Numy 3G AX1", model: "Novo 7 Numy AX1 3G" }, { regex: "Numy[_ ]?3G[_ ]?Sword", model: "Numy 3G Sword" }, { regex: "NOVO10 Spark", model: "Novo 10 Spark" }, { regex: "AX10PRO", model: "Numy AX10 Pro" }, { regex: "Numy_3G_AX3", model: "Numy AX3 Sword" }, { regex: "Numy3GTalos", model: "Numy 3G Talos" }, { regex: "Numy_3G_BW1", model: "Numy 3G Talos 2" }, { regex: "NUMY3GAX9(?:[);/ ]|$)", model: "Numy 3G AX9" }, { regex: "Numy3G_AX10(?:[);/ ]|$)", model: "Numy 3G AX10" }, { regex: "(Novo 10 Hero QuadCore)", model: "$1" }, { regex: "Aurora-II", model: "Novo 7 Aurora II" }, { regex: "Novo7 Flame(?:[);/ ]|$)", model: "Novo 7 Flame" }, { regex: "NOVO7(?:[);/ ]|$)", model: "Novo 7" }, { regex: "Numy[ _]([^;/]+) Build", model: "Numy $1" }, { regex: "Novo([0-9]+)[ \\-]([^;/]+) Build", model: "Novo $1 $2" }] }, vz = { regex: "(?:YL-)?Archos|(?:A50TI|AC101BHE)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Archos (Oxygen (?:63|57|68XL))(?:[);/ ]|$)", model: "$1" }, { regex: "A50TI(?:[);/ ]|$)", model: "50 Titanium 4G" }, { regex: "Archos ?5(?:[);/ ]|$)", device: "tablet", model: "5" }, { regex: "AC101BHE(?:[);/ ]|$)", device: "tablet", model: "101B Helium 4G" }, { regex: "(?:YL-)?Archos ([^/;]*(?:PAD)[^/;]*) Build", device: "tablet", model: "$1" }, { regex: "Archos ((?:[789]|10)[0-9]?[a-z]* ?(?:G9|G10|Helium|Titanium|Cobalt|Platinum|Xenon|Carbon|Neon|XS|IT)[^/;]*) Build", device: "tablet", model: "$1" }, { regex: "(?:YL-)?Archos ([a-z0-9 ]+) Build", model: "$1" }, { regex: "(?:YL-)?Archos ([a-z0-9]+)", model: "$1" }] }, Sz = { regex: "Axxion ATAB-[0-9]+(?:[);/ ]|$)", device: "tablet", models: [{ regex: "Axxion ATAB-([0-9]+)(?:[);/ ]|$)", model: "ATAB-$1" }] }, bz = { regex: "MEU ([a-z0-9]+) Build", device: "smartphone", model: "$1" }, yz = { regex: "arnova|ARCHM901|AN7CG2|AN7G2(DTE|I)?|AN7[BCDFH]?G3|A80KSC|AN8G2|AN8[BC]?G3|AN9G2I?|AN9G3|A101[BC]|AN10G2|AN10BG2(DT|I)?|AN10BG3(DT)?|AN10[CD]G3", device: "tablet", models: [{ regex: "ARCHM901", model: "M901" }, { regex: "AN7CG2", model: "7c G2" }, { regex: "AN7G2I|AN7G2|AN7G2DTE", model: "7 G2" }, { regex: "AN7G3", model: "7 G3" }, { regex: "AN7BG3", model: "7b G3" }, { regex: "AN7CG3", model: "7c G3" }, { regex: "AN7DG3-CP", model: "Childpad" }, { regex: "AN7DG3", model: "7d G3" }, { regex: "AN7FG3", model: "7f G3" }, { regex: "AN7HG3", model: "7h G3" }, { regex: "A80KSC", model: "8" }, { regex: "AN8G2", model: "8 G2" }, { regex: "AN8G3", model: "8 G3" }, { regex: "AN8BG3", model: "8b G3" }, { regex: "AN8CG3", model: "8c G3" }, { regex: "AN9G2I", model: "9i G2" }, { regex: "AN9G2", model: "9 G2" }, { regex: "AN9G3", model: "9 G3" }, { regex: "A101B2|A101C|AN10G2", model: "10 G2" }, { regex: "A101B", model: "10" }, { regex: "AN10BG2|AN10BG2DT|AN10BG2I", model: "10b G2" }, { regex: "AN10BG3|AN10BG3DT|AN10BG3-LZ", model: "10b G3" }, { regex: "AN10CG3", model: "10c G3" }, { regex: "AN10DG3", model: "10d G3" }, { regex: "ARNOVA 90G3", model: "90 G3" }, { regex: "ARNOVA 90 G4", model: "90 G4" }, { regex: "ARNOVA 97G4", model: "97 G4" }, { regex: "ARNOVA 101 G4", model: "101 G4" }, { regex: "Arnova ([^/;]*) Build", model: "$1" }] }, wz = { regex: "ARRIS", device: "tv", models: [{ regex: "ARRIS[,;] ([^),;/]+)", model: "$1" }] }, _z = { regex: "ASK[ _]", device: "smartphone", models: [{ regex: "ASK[ _]791SP[ _]3G", model: "791SP 3G", device: "tablet" }, { regex: "ASK[_ ]([^/;]*) Build", model: "$1" }] }, Tz = { regex: "UL40 Build", device: "smartphone", model: "UL40" }, Az = { regex: "AOC,", device: "tv", models: [{ regex: "(LE(?:32|43)S5970(?:s)?-20|LE55U7970-30|LE43S5977-20|U60856)", model: "$1" }] }, Pz = { regex: "(AS[-_](?:50[123]|543[1-6]|44[12]1|541[12]|54[23]1|6431|[46]01L)|AP-(?:109|115G|721N|753G|7[25]7G|10[68]|107G|110N|941|719))[;/)_ ]", device: "smartphone", models: [{ regex: "AS[-_]401L(?:[);/ ]|$)", model: "Asper" }, { regex: "AS-5432(?:[);/ ]|$)", model: "Agio" }, { regex: "AS[-_](?:5434|501)(?:[);/ ]|$)", model: "Club" }, { regex: "AS_601L(?:[);/ ]|$)", model: "AS-601L" }, { regex: "AS-5433 Secret(?:[);/ ]|$)", model: "Secret" }, { regex: "AS-5433(?:[);/ ]|$)", model: "Max Secret" }, { regex: "AS-5421(?:[);/ ]|$)", model: "Surf" }, { regex: "AS-44[12]1(?:[);/ ]|$)", model: "Unami" }, { regex: "AS-5431(?:[);/ ]|$)", model: "Prima" }, { regex: "AS-502(?:[);/ ]|$)", model: "Shot" }, { regex: "AS-503(?:[);/ ]|$)", model: "Target" }, { regex: "AS-5435(?:[);/ ]|$)", model: "Shine" }, { regex: "AS-5436[ _]", model: "Grid" }, { regex: "AS-6431(?:[);/ ]|$)", model: "Rider" }, { regex: "AS-5411[_ ]", model: "Max Ritm" }, { regex: "AS-5412 Max(?:[);/ ]|$)", model: "AS-5412 Max" }, { regex: "AP-721N(?:[);/ ]|$)", model: "AP-721N Force", device: "tablet" }, { regex: "AP-941(?:[);/ ]|$)", model: "AP-941", device: "tablet" }, { regex: "AP-108(?:[);/ ]|$)", model: "Cetus", device: "tablet" }, { regex: "AP-106(?:[);/ ]|$)", model: "AP-106 Force", device: "tablet" }, { regex: "(AP-(?:109|115G|7[25]7G|753G|107G|110N|719))(?:[);/ ]|$)", device: "tablet", model: "$1" }] }, Mz = { regex: "(ARK[_ -])?Benefit[_ -]([^/;]*)(?: Build|\\))|EDGE A5HD|Elf_S8|ICON (R40\\+|R45)|Impulse[ _](P[12])|Wizard_[12](?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:ARK[_ -])?Benefit[_ -]([^/;]*)(?: Build|\\))", model: "Benefit $1" }, { regex: "Impulse[ _]P1\\+", model: "Impulse P1 Plus" }, { regex: "Impulse[ _](P[12])", model: "Impulse $1" }, { regex: "EDGE (A5HD)", model: "Edge $1" }, { regex: "ICON (R40\\+|R45)", model: "Icon $1" }, { regex: "Wizard_([12])", model: "Wizard $1" }, { regex: "Elf_S8(?:[);/ ]|$)", model: "Elf S8" }] }, $z = { regex: "Asus|Transformer|ZenFone Max|TF300T|Slider SL101|PadFone|ME302(?:C|KL)|ME301T|ME371MG|ME17(?:1|2V|3X)|(?:K0[01][0-9a-z]|P(?:00[18ACIL]|01[MTVWYZ]|01MA|01T_1|02[13478])(?: Build|\\))|X015D|X018D|X003|X00[7ABT]D|Z00D|Z00[MTY]D|Z01[7FGHKMR]D)(?:[);/ ]|$)|G55[023]KL|ZB(631|602|633|55[135]|50[01])KL|ZC(55[134]|520|600)KL|ZA550KL|ZE(5[02]0|620|55[2345])KL|ZD55[23]KL|ZS6(?:61|7[01])KS|ZS(6[0236]0|55[10])KL|ZB(500KG|601KL)|MeMo Pad FHD 10 LTE|Z00[SV]D", device: "smartphone", models: [{ regex: "ME171(?:[);/ ]|$)", model: "Eee Pad MeMO 171", device: "tablet" }, { regex: "ASUS Z906(?:[);/ ]|$)", model: 'Z906 10.1"', device: "tablet" }, { regex: "ME172V", model: "MeMO Pad", device: "tablet" }, { regex: "ME302C(?:[);/ ]|$)", model: "MeMO Pad FHD 10", device: "tablet" }, { regex: "(ME302KL|MeMo Pad FHD 10 LTE)(?:[);/ ]|$)", model: "MeMO Pad FHD 10 LTE", device: "tablet" }, { regex: "ME301T(?:[);/ ]|$)", model: "MeMO Pad Smart 10", device: "tablet" }, { regex: "Z101(?:[);/ ]|$)", model: "Z101", device: "tablet" }, { regex: "X Pad 10 LTE(?:[);/ ]|$)", model: "X Pad 10 LTE", device: "tablet" }, { regex: "(?:K01[3A]|K007|K00R)(?:[);/ ]|$)|MeMO Pad 7", model: "MeMO Pad 7", device: "tablet" }, { regex: "K01E(?:[);/ ]|$)", model: "MeMO Pad 10 ME103K", device: "tablet" }, { regex: "K00U|ME173X(?:[);/ ]|$)", model: "MeMO Pad HD 7", device: "tablet" }, { regex: "(?:K011|K00L)(?:[);/ ]|$)", model: "MeMO Pad 8", device: "tablet" }, { regex: "K014(?:[);/ ]|$)", model: "MeMO Pad 8.9", device: "tablet" }, { regex: "K00S(?:[);/ ]|$)", model: "MeMO Pad HD 7 Dual SIM", device: "tablet" }, { regex: "K00F(?:[);/ ]|$)", model: "MeMO Pad 10", device: "tablet" }, { regex: "K00C(?:[);/ ]|$)", model: "Transformer Pad TF701T", device: "tablet" }, { regex: "K010(?:[);/ ]|$)", model: "Transformer Pad TF103C", device: "tablet" }, { regex: "K018(?:[);/ ]|$)", model: "Transformer Pad TF103CG", device: "tablet" }, { regex: "TF300T(?:[);/ ]|$)", model: "Transformer Pad TF300T", device: "tablet" }, { regex: "K01B(?:[);/ ]|$)", model: "Transformer Pad TF303K", device: "tablet" }, { regex: "Slider SL101", model: "Eee Pad Slider SL101", device: "tablet" }, { regex: "P01[YZ]", model: "ZenPad C 7.0", device: "tablet" }, { regex: "P008 Build", model: "ZenPad Z8", device: "tablet" }, { regex: "P001", model: "ZenPad Z10", device: "tablet" }, { regex: "(?:ASUS_)?P00J", model: "ZenPad Z8s", device: "tablet" }, { regex: "P01[VW]", model: "ZenPad 7.0", device: "tablet" }, { regex: "(?:P024|P00A)(?:[);/ ]|$)", model: "ZenPad 8.0", device: "tablet" }, { regex: "P01MA(?: Build|\\))|P01M(?: Build|\\))", model: "ZenPad S 8.0", device: "tablet" }, { regex: "P027", model: "ZenPad 3S 10", device: "tablet" }, { regex: "(?:ASUS_)?P00I", model: "ZenPad 3S 10 LTE", device: "tablet" }, { regex: "(?:ASUS_)?P00C|P02[138]|P00L|P01T_1", model: "ZenPad 10", device: "tablet" }, { regex: "ASUS Tablet P1801-T", model: 'Transformer AiO P1801 18.4"', device: "tablet" }, { regex: "ASUS TAB A8", model: "TAB A8", device: "tablet" }, { regex: "ME371MG(?:[);/ ]|$)", model: "Fonepad", device: "phablet" }, { regex: "K00G(?:[);/ ]|$)", model: "Fonepad Note 6", device: "phablet" }, { regex: "(?:K012|K00E)(?:[);/ ]|$)", model: "Fonepad 7", device: "phablet" }, { regex: "K00Z(?:[);/ ]|$)", model: "Fonepad 7 Dual SIM", device: "phablet" }, { regex: "K016(?:[);/ ]|$)", model: "Fonepad 8", device: "phablet" }, { regex: "(?:ASUS_)?T00N", model: "PadFone S" }, { regex: "(?:ASUS_)?T00[CE]", model: "PadFone Mini" }, { regex: "(?:ASUS[-_])?T00T", model: "PadFone X Mini" }, { regex: "PadFone T008", model: "PadFone E" }, { regex: "PadFone T004", model: "PadFone Infinity" }, { regex: "(?:ASUS_)?A002(A)?", model: "ZenFone AR" }, { regex: "(?:ASUS_)?A006", model: "ZenFone V" }, { regex: "(?:ASUS_)?A009", model: "ZenFone V Live" }, { regex: "(?:ASUS_)?Z007", model: "ZenFone C" }, { regex: "(?:ASUS_)?(X00P[SD]|ZB555KL)", model: "ZenFone Max M1" }, { regex: "(?:ASUS_)?(?:ZB60[12]KL)|ZenFone Max Pro M1", model: "ZenFone Max Pro M1" }, { regex: "(?:ASUS_)?(X01([AB]D)|ZB633KL)(?:[);/ ]|$)", model: "ZenFone Max M2" }, { regex: "(?:ASUS_)?(?:Z00[AD]|Z008D|Z008|Z00AD[AB]?|ZE551ML)", model: "ZenFone 2" }, { regex: "(?:ASUS_)?(?:ZenFone 2E)", model: "ZenFone 2E" }, { regex: "(?:ASUS_)?(?:A007|Z00YD|ZA550KL|ZB553KL|ZB501KL)(?:[);/ ]|$)", model: "ZenFone Live" }, { regex: "(?:ASUS_)?(?:X00RD|G552KL)", model: "ZenFone Live L1" }, { regex: "G553KL", model: "ZenFone Lite L1" }, { regex: "(?:ASUS_)?(?:Z00[ERLMTW]D|Z011D|ZE500KL)", model: "ZenFone 2 Laser" }, { regex: "(?:ASUS_)?(?:T00[IQ1]|Z01KD)", model: "ZenFone 4" }, { regex: "(?:ASUS_)?(?:T00[JF]|X00QD|X00QSA|ZE620KL)", model: "ZenFone 5" }, { regex: "(?:ASUS_)?T00P", model: "ZenFone 5 LTE" }, { regex: "(?:ASUS_)?(?:T00K|X017DA|X017D|ZC600KL)", model: "ZenFone 5 Lite" }, { regex: "(?:ASUS_)?(?:Z01RD|ZS620KL)", model: "ZenFone 5Z" }, { regex: "(?:ASUS_)?(?:T00G|Z002|ZS630KL|I01WD[X]?)", model: "ZenFone 6" }, { regex: "(?:ASUS_)?ZS671KS", model: "ZenFone 7 Pro" }, { regex: "(?:ASUS_)?(?:ZS670KS|I002D)(?:[);/ ]|$)", model: "ZenFone 7" }, { regex: "(?:ASUS_)?Z010D", model: "ZenFone Max" }, { regex: "(?:ASUS_)?X018D", model: "ZenFone Max Plus M1" }, { regex: "(?:ASUS_)?X00TD?", model: "ZenFone Max Pro M1" }, { regex: "(?:ASUS_)?(?:X01BDA|ZB631KL|Zenfone Max Pro M2)", model: "ZenFone Max Pro M2" }, { regex: "(?:ASUS_)?X014D", model: "ZenFone Go Plus" }, { regex: "(?:ASUS_)?(L001|X00[7AB]D|X009[DB][DA]|X009D|Z00[SV]D|ZB500K[LG]|ZB551KL)", model: "ZenFone Go" }, { regex: "(?:ASUS_)?X013D", model: "ZenFone Go Life" }, { regex: "(?:ASUS_)?G550KL", model: "ZenFone Go TV" }, { regex: "(?:ASUS_)?Z00[SV]D", model: "ZenFone Go" }, { regex: "(?:ASUS_)?(X00[23])", model: "ZenFone Pegasus" }, { regex: "(?:ASUS_)?X005", model: "ZenFone Pegasus 5000" }, { regex: "(?:ASUS_)?X550", model: "ZenFone Pegasus 2 Plus" }, { regex: "(?:ASUS_)?(X00GD)", model: "ZenFone Pegasus 3S Max" }, { regex: "(?:ASUS_)?(?:X00D[DS]|X008D)|ZC553KL", model: "ZenFone 3 Max" }, { regex: "(?:ASUS_)?(X008)", model: "ZenFone 3 Pegasus" }, { regex: "(?:ASUS_)?(ZE553KL|Z01HD)", model: "ZenFone 3 Zoom" }, { regex: "(?:ASUS_)?ZS550KL", model: "ZenFone 3 Deluxe" }, { regex: "(?:ASUS_)?Z00UD", model: "ZenFone Selfie" }, { regex: "(?:ASUS_)?(Z016[DS]|Z01FD)", model: "ZenFone 3 Deluxe" }, { regex: "(?:ASUS_)?(Z017DA|ZE520KL|ZE552KL|Z017D|Z012(D|S))", model: "ZenFone 3" }, { regex: "(?:ASUS_)?Z01B[DS]|ZC551KL", model: "ZenFone 3 Laser" }, { regex: "(?:ASUS_)?A001", model: "ZenFone 3 Ultra" }, { regex: "(?:ASUS_)?(?:ZD552KL|Z01MDA?)(?:[);/ ]|$)", model: "ZenFone 4 Selfie Pro" }, { regex: "(?:ASUS_)?(?:X00LDA|ZD553KL)", model: "ZenFone 4 Selfie" }, { regex: "(?:ASUS_)?(?:X00LD|Z01KS|Z01KDA|ZE554KL)", model: "ZenFone 4" }, { regex: "(?:ASUS_)?X00(?:[HIK]D|IS)|ZC554KL|ZC520KL", model: "ZenFone 4 Max" }, { regex: "(?:ASUS_)?X015D", model: "ZenFone 4 Max Plus" }, { regex: "(?:ASUS_)?(:?Z01G[DS]|ZS551KL)", model: "ZenFone 4 Pro" }, { regex: "(?:ASUS_)?Z00XS", model: "ZenFone Zoom" }, { regex: "(?:ASUS_)?(?:Z01QD|ZS600KL)", model: "ROG Phone" }, { regex: "(?:ASUS_)?(?:I001D[ABCE]?|ZS660KL)", model: "ROG Phone 2" }, { regex: "(?:ASUS_)?(?:I003DD?|ZS661KS)", model: "ROG Phone 3" }, { regex: "(?:ASUS_)?(?:I005DA)", model: "ROG Phone 5" }, { regex: "ZN220IC", device: "desktop", model: "Zen AiO ZN220IC" }, { regex: "(?:ASUS_)?ZenWatch( 2)?", device: "wearable", model: "ZenWatch$1" }, { regex: "Asus(?:-|;)?([a-z0-9]+)", model: "$1" }, { regex: "(PadFone(?: [^;/]+)?) Build", model: "$1" }, { regex: "(PadFone(?: [a-z0-9]+)?)", model: "$1" }, { regex: "(?:Asus|Transformer) ((?:Pad |Prime )?TF[0-9a-z]+)", device: "tablet", model: "Transformer $1" }, { regex: "Chromebook Flip (C10[01]PA|C302)", device: "desktop", model: "Chromebook Flip $1" }] }, Cz = { regex: "Audiovox|CDM|UTS(?:TARCOM)?\\-|audio(?!book)[a-z0-9\\-]+", device: "smartphone", models: [{ regex: "Audiovox[_\\-]([a-z0-9\\-]+)", model: "$1" }, { regex: "CDM(?:-)?([a-z0-9]+)", model: "CDM-$1" }, { regex: "UTS(?:TARCOM)?-([a-z0-9\\-]+)", model: "CDM-$1" }, { regex: "audio([a-z0-9\\-]+)", model: "CDM-$1" }] }, Lz = { regex: "Excer[ _]", device: "tablet", models: [{ regex: "Excer[ _]G5.3", model: "Excer G5.3" }, { regex: "Excer[ _]G5", model: "Excer G5" }, { regex: "Excer[ _]10[ _]PRO", model: "Excer 10 Pro" }, { regex: "Excer[ _]8", model: "Excer 8" }] }, Ez = { regex: "Avvio[ _]?([a-z0-9\\-]+)|(?:CHIVAS_55|Colombia_2018|Mint_M353)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "CHIVAS_55", model: "Chivas 55" }, { regex: "Mint_M353", model: "Mint M353" }, { regex: "Colombia_2018", model: "Colombia (2018)" }, { regex: "Avvio[ _]PAD", model: "PAD", device: "tablet" }, { regex: "Avvio[ _]?([a-z0-9\\-]+)", model: "$1" }] }, Oz = { regex: "(?!Positivo )BGH ([^/;\\)]+)(?: Build|\\))", device: "smartphone", models: [{ regex: "Y([17]00|2[01]0|1010)", device: "tablet", model: "Y$1" }, { regex: "BGH (\\+Simple|Mini)", device: "tablet", model: "$1" }, { regex: "Y710 KIDS", device: "tablet", model: "Y710 Kids" }, { regex: "JOY X2", model: "Joy X2" }, { regex: "BGH ([^/;\\)]+)(?: Build|\\))", model: "$1" }] }, Nz = { regex: "Bitel[ _-]([^/;]+) Build|(?:B(?:840[5-9]|841[0456]|850[2346]|860[146]|9401|950[1-5])|S8402L?|S8501L?)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(B(?:840[5789]|841[0456]|850[2346]|860[146]|9401|950[12345])|S8402L?|S8501L?)", model: "$1" }, { regex: "Bitel[ _-]([^/;]+) Build", model: "$1" }] }, Dz = { regex: "BLU[ _]|(?:blu|Dash)[ _]([^/;)]+)(?: Build|[;)])|(?:Studio[ _](5.0K|5.5|View XL|Mega|C 8\\+8|[CGM][ _]HD|[CGX]|SELFIE|Selfie LTE|Touch|M5 Plus|J[1258]|X8 HD)|Advance (4.0 ?[LM]|5.[02](?: HD)?|A4|L[45])|ENERGY (DIAMOND|XL)|Energy X 2|LIFE XL|B110DL|Dash (?:X[2L]|L3)|PURE (?:X[LR]|MINI)|Life One X2|G90(?: PRO)?|Grand M3|GRAND (?:5.5 HD|XL LTE)|R1 (?:HD|PLUS)|Tank Xtreme [45].0|Tank Xtreme Pro|Touchbook M7 Pro|DASH X PLUS|C[456] 2019|BOLD N1|B130DL|Vivo 5 Mini)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Advance (4.0 ?[LM]|4.0|5.[02](?: HD)?|A4|L[54])", model: "Advance $1" }, { regex: "(?:BLU[_ ])?Studio[ _](5.0 C|5.5|View XL|Mega|C 8\\+8|[CG][ _]HD|C|G|Touch|M HD|M5 Plus|J[1258]|X8 HD|X5|XL|X)(?:[);/ ]|$)", model: "Studio $1" }, { regex: "(?:BLU[_ ])?Studio[ _]5.0 ?K(?:[);/ ]|$)", model: "Studio 5.0 K" }, { regex: "STUDIO SELFIE LTE", model: "Studio Selfie LTE" }, { regex: "STUDIO ONE", model: "Studio One" }, { regex: "STUDIO SELFIE ([23]|LTE)", model: "Studio Selfie $1" }, { regex: "STUDIO SELFIE", model: "Studio Selfie" }, { regex: "(?:BLU[_ ])?NEO_ENERGY_MINI", model: "Neo Energy Mini" }, { regex: "ENERGY DIAMOND", model: "Energy Diamond" }, { regex: "ENERGY XL", model: "Energy XL" }, { regex: "Energy X 2", model: "Energy X 2" }, { regex: "ENERGY X PLUS 2", model: "Energy X Plus 2" }, { regex: "ENERGY X PLUS", model: "Energy X Plus" }, { regex: "LIFE XL", model: "Life XL" }, { regex: "DASH[ _]X[ _]PLUS[ _]LTE", model: "Dash X Plus LTE" }, { regex: "DASH X PLUS", model: "Dash X Plus" }, { regex: "DASH 4.5", model: "Dash 4.5" }, { regex: "Dash XL", model: "Dash XL" }, { regex: "PURE (X[LR])", model: "Pure $1" }, { regex: "PURE MINI", model: "Pure Mini" }, { regex: "BOLD N1", model: "Bold N1" }, { regex: "Life One X2", model: "Life One X2" }, { regex: "LIFE ONE X", model: "Life One X" }, { regex: "LIFE ONE", model: "Life One" }, { regex: "LIFE MARK", model: "Life Mark" }, { regex: "NEO X PLUS", model: "Neo X Plus" }, { regex: "NEO (XL|X)", model: "Neo $1" }, { regex: "G90 PRO", model: "G90 Pro" }, { regex: "G90", model: "G90" }, { regex: "GRAND 5.5 HD", model: "Grand 5.5 HD" }, { regex: "Grand X LTE", model: "Grand X LTE" }, { regex: "Grand XL LTE", model: "Grand XL LTE" }, { regex: "Grand M3", model: "Grand M3" }, { regex: "B110DL", model: "View Mega" }, { regex: "B130DL", model: "View 2" }, { regex: "R1 HD", model: "R1 HD" }, { regex: "R1 PLUS", model: "R1 Plus" }, { regex: "C([456]) (2019)", model: "C$1 ($2)" }, { regex: "Tank Xtreme ([45]).0", model: 'Tank Xtreme $1.0"' }, { regex: "Tank Xtreme Pro", model: "Tank Xtreme Pro" }, { regex: "VIVO AIR LTE", model: "Vivo Air LTE" }, { regex: "Touchbook G7", model: "Touchbook G7" }, { regex: "(?:BLU[_ ])?VIVO[ _]SELFIE", model: "Vivo Selfie" }, { regex: "(?:BLU[_ ])?Vivo 5 Mini", model: "Vivo 5 Mini" }, { regex: "Touchbook M7 Pro", model: "Touchbook M7 Pro", device: "tablet" }, { regex: "STUDIO 7.0 II", model: 'Studio 7.0" II', device: "tablet" }, { regex: "DASH (L[45] LTE|5.0|L[45]X|L3|X2|[LMX])(?:[);/ ]|$)", model: "Dash $1" }, { regex: "DASH[ _]([^)/;]+)(?: Build|\\))", model: "Dash $1" }, { regex: "blu[ _]([^/;]+)( Build|[);])", model: "$1" }] }, kz = { regex: "BLUEGOOD", device: "smartphone", models: [{ regex: "V6", model: "V6" }] }, Gz = { regex: "Blackview|(BV([24-9]000|[46]900|(5[1589]|9[15689])00|6[138]00)(?:[ _](?:PRO))?|(P10000(?:[ _](?:PRO))?)|omega[ _]pro|Alife[ _][PS]1|Heatwave|DM550|BV9700Pro|(?<!Lenovo[_ ])A[68]0(?:Pro)?\\))|A[86]0Plus|BL6000Pro", device: "smartphone", models: [{ regex: "A60Pro\\)", model: "A60 Pro" }, { regex: "A60\\)", model: "A60" }, { regex: "A80Pro(?:[);/ ]|$)", model: "A80 Pro" }, { regex: "A([86]0)Plus(?:[);/ ]|$)", model: "A$1 Plus" }, { regex: "(BV6000S)", model: "$1" }, { regex: "(BV9700|BL6000)Pro", model: "$1 Pro" }, { regex: "Blackview (A[78]|E7S)", model: "$1" }, { regex: "BV9000Pro-F", model: "BV9000 Pro F" }, { regex: "(BV([48]000|9[56]00|6[83]00))Pro", model: "$1 Pro" }, { regex: "(BV6[13]00)(?:[);/ ]|$)", model: "$1", device: "phablet" }, { regex: "(BV([24-9]000|6900|4900|(5[1589]|9[15689])00)(?:[ _](?:PRO))?)", model: "$1" }, { regex: "(P10000(?:[ _](?:PRO))?)", model: "$1" }, { regex: "omega[ _]pro", model: "Omega Pro" }, { regex: "(Alife[ _][PS]1|DM550|Heatwave)", model: "$1" }] }, Bz = { regex: "Bluboo|Xfire|Picasso 4G|Maya Build", device: "smartphone", models: [{ regex: "Maya Build", model: "Maya" }, { regex: "Xfire2", model: "Xfire 2" }, { regex: "Picasso 4G", model: "Picasso 4G" }, { regex: "Xfire", model: "Xfire" }, { regex: "Bluboo[ _-]?([^;/)]+) Build", model: "$1" }, { regex: "Bluboo[ _-]?([^;/)]+)", model: "$1" }] }, Iz = { regex: "BO-(FRSP4|LFSPBS5|LFSP4|LFSPSL4|LFSPBS5|LFSPSL6QCI)", device: "smartphone", models: [{ regex: "BO-LFSP4", model: "LifeStyle 4DC" }, { regex: "BO-LFSPSL4", model: "LifeStyle 4SL" }, { regex: "BO-LFSPBS5", model: "LifeStyle 5BS" }, { regex: "BO-LFSPSL6QCI", model: "LifeStyle 6QC" }, { regex: "BO-(FRSP4)", model: "$1" }] }, Rz = { regex: "(?:sprd-)?(BOWAY)", device: "smartphone", models: [{ regex: "BOWAY[ _-]([^/;]+)[ _]Build", model: "$1" }, { regex: "([^/;]+) Build/BOWAY", model: "$1" }, { regex: ".*BOWAY[ _-]([^/;]+)/", model: "$1" }] }, Fz = { regex: "Brondi[ _]|(?:CENTURION|GLADIATOR| GLORY|LUXURY|SENSUELLE|VICTORY)(?:[ _-]?[2-6])?(?:[);/ ]|$)|Surfing Tab|501 SZ", device: "smartphone", models: [{ regex: "(?:Brondi[ _])?(620 SZ|730_4G_HD|501 SZ)(?:[);/ ]|$)", model: "$1" }, { regex: "CENTURION(?:[ _-]?([2-6]))?(?:[);/ ]|$)", model: "CENTURION $1" }, { regex: "GLADIATOR(?:[ _-]?([2-6]))?(?:[);/ ]|$)", model: "GLADIATOR $1" }, { regex: "GLORY(?:[ _-]?([2-6]))?(?:[);/ ]|$)", model: "GLORY $1" }, { regex: "LUXURY(?:[ _-]?([2-6]))?(?:[);/ ]|$)", model: "LUXURY $1" }, { regex: "SENSUELLE(?:[ _-]?([2-6]))?(?:[);/ ]|$)", model: "SENSUELLE $1" }, { regex: "VICTORY(?:[ _-]?([2-6]))?(?:[);/ ]|$)", model: "VICTORY $1" }, { regex: "Surfing Tab ([^;/]+) Build", model: "SURFING TAB $1", device: "tablet" }, { regex: "Surfing Tab ([^;/)]+)[;/)]", model: "SURFING TAB $1", device: "tablet" }] }, Vz = { regex: "((?:VIV-|BBG-)?(?<!FBCR/)vivo(?!(?:Browser)))|(?:V1730(D[AT]|GA)|V18(18CA|01A0|13B[AT]|18T|09[AT]|1[346][AT]|[13]8[AT]|14A|24[B]?A|2[19][AT]|3[12][AT]|36[AT])|V1731CA|V1732[AT]|V1818CT|V19[01]1[AT]|V1932[AT]|V191[3469][AT]|V192[1348]A|V193[04]A|V194[15]A|V1938CT|V1955A|V1938T|V1730EA|V19[26]2A|V196[35]A|V198[16]A|V1936A[L]?|V19[59]0A|V200[125]A|1819|V201[12]A|V202[0345]C?A|V202[235-9]|V2054A|V203[026]|V204[03]|V2049A|X50 Pro\\+|I1927)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "V1824[B]?A(?:[);/ ]|$)", model: "iQOO" }, { regex: "V1955A(?:[);/ ]|$)", model: "iQOO 3" }, { regex: "I1927(?:[);/ ]|$)", model: "iQOO 3 5G" }, { regex: "V2049A(?:[);/ ]|$)", model: "iQOO 7" }, { regex: "V1922A(?:[);/ ]|$)", model: "iQOO Pro" }, { regex: "V1916A(?:[);/ ]|$)", model: "iQOO Pro 5G" }, { regex: "V1914A(?:[);/ ]|$)", model: "iQOO Neo" }, { regex: "V1981A(?:[);/ ]|$)", model: "iQOO Neo 3" }, { regex: "V1936A[L]?(?:[);/ ]|$)", model: "iQOO Neo 855" }, { regex: "V1986A(?:[);/ ]|$)", model: "iQOO Z1" }, { regex: "V2012A(?:[);/ ]|$)", model: "iQOO Z1x" }, { regex: "V1919A(?:[);/ ]|$)", model: "iQOO Z5x" }, { regex: "V2023A(?:[);/ ]|$)", model: "iQOO U1" }, { regex: "V2024A(?:[);/ ]|$)", model: "iQOO 5" }, { regex: "V2025A(?:[);/ ]|$)", model: "iQOO 5 Pro" }, { regex: "V2025(?:[);/ ]|$)", model: "V20" }, { regex: "V2040(?:[);/ ]|$)", model: "V20 (2021)" }, { regex: "vivo 1805(?:[);/ ]|$)", model: "Nex" }, { regex: "V1923A(?:[);/ ]|$)", model: "Nex 3" }, { regex: "V1924A(?:[);/ ]|$)", model: "Nex 3 5G" }, { regex: "V1950A(?:[);/ ]|$)", model: "Nex 3S" }, { regex: "V1821[AT](?:[);/ ]|$)", model: "Nex Dual Display" }, { regex: "Vivo ONE(?:[);/ ]|$)", model: "One" }, { regex: "V1831[AT](?:[);/ ]|$)", model: "S1" }, { regex: "V1832[AT](?:[);/ ]|$)", model: "S1 Pro" }, { regex: "V1932[AT](?:[);/ ]|$)", model: "S5" }, { regex: "V1962A(?:[);/ ]|$)", model: "S6 5G" }, { regex: "V2020C?A(?:[);/ ]|$)", model: "S7" }, { regex: "V1941A(?:[);/ ]|$)", model: "U3" }, { regex: "V1928A(?:[);/ ]|$)", model: "U3X" }, { regex: "vivo 1804(?:[);/ ]|$)", model: "V11 Pro" }, { regex: "vivo 1806(?:[);/ ]|$)", model: "V11i" }, { regex: "1819(?:[);/ ]|$)", model: "V15" }, { regex: "vivo 1818(?:[);/ ]|$)", model: "V15 Pro" }, { regex: "vivo 1909(?:[);/ ]|$)", model: "V17 Pro" }, { regex: "V2022(?:[);/ ]|$)", model: "V20 SE" }, { regex: "(?:VIV-|BBG-)?vivo[ _]1601(?:[);/ ]|$)", model: "V5" }, { regex: "vivo 1609(?:[);/ ]|$)", model: "V5 Lite" }, { regex: "vivo 1611(?:[);/ ]|$)", model: "V5 Plus" }, { regex: "vivo (1713|1612)(?:[);/ ]|$)", model: "V5s" }, { regex: "vivo 1718(?:[);/ ]|$)", model: "V7" }, { regex: "vivo 1716(?:[);/ ]|$)", model: "V7 Plus" }, { regex: "vivo 1723(?:[);/ ]|$)", model: "V9" }, { regex: "vivo 1727(?:[);/ ]|$)", model: "V9 Youth" }, { regex: "vivo 1721(?:[);/ ]|$)", model: "X20" }, { regex: "X20Plus(?:[);/ ]|$)", model: "X20 Plus" }, { regex: "vivo 1725(?:[);/ ]|$)", model: "X21" }, { regex: "V1814[AT](?:[);/ ]|$)", model: "X21S" }, { regex: "V1809[AT](?:[);/ ]|$)", model: "X23" }, { regex: "V1816[AT](?:[);/ ]|$)", model: "X23" }, { regex: "V18(38|29)[AT](?:[);/ ]|$)", model: "X27" }, { regex: "V1836[AT](?:[);/ ]|$)", model: "X27 Pro" }, { regex: "V1938CT(?:[);/ ]|$)", model: "X30" }, { regex: "V1938T(?:[);/ ]|$)", model: "X30 Pro" }, { regex: "V2001A(?:[);/ ]|$)", model: "X50" }, { regex: "V2005A(?:[);/ ]|$)", model: "X50 Pro" }, { regex: "(?:V2011A|X50 Pro\\+)(?:[);/ ]|$)", model: "X50 Pro Plus" }, { regex: "X9Plus(?:[);/ ]|$)", model: "X9 Plus" }, { regex: "vivo 1902(?:[);/ ]|$)", model: "Y17" }, { regex: "vivo 1915(?:[);/ ]|$)", model: "Y19" }, { regex: "V202[79](?:[);/ ]|$)", model: "Y20" }, { regex: "V2028(?:[);/ ]|$)", model: "Y11s" }, { regex: "V2043(?:[);/ ]|$)", model: "Y20 (2021)" }, { regex: "V2032(?:[);/ ]|$)", model: "Y20i" }, { regex: "V2023(?:[);/ ]|$)", model: "V20 SE" }, { regex: "V1901[AT](?:[);/ ]|$)", model: "Y3" }, { regex: "V1930A(?:[);/ ]|$)", model: "Y3 Standard" }, { regex: "V2036(?:[);/ ]|$)", model: "Y31" }, { regex: "V1934A(?:[);/ ]|$)", model: "Y5s" }, { regex: "V1965A(?:[);/ ]|$)", model: "Y50" }, { regex: "V2030(?:[);/ ]|$)", model: "Y51" }, { regex: "V2054A(?:[);/ ]|$)", model: "Y31s" }, { regex: "vivo 1606(?:[);/ ]|$)", model: "Y53i" }, { regex: "vivo 1603(?:[);/ ]|$)", model: "Y55l" }, { regex: "vivo 1610(?:[);/ ]|$)", model: "Y55s" }, { regex: "vivo 1719(?:[);/ ]|$)", model: "Y65" }, { regex: "vivo 1714(?:[);/ ]|$)", model: "Y69" }, { regex: "V2002A(?:[);/ ]|$)", model: "Y70s" }, { regex: "vivo 1724(?:[);/ ]|$)", model: "Y71" }, { regex: "vivo 1801(?:[);/ ]|$)", model: "Y71i" }, { regex: "V1731CA(?:[);/ ]|$)", model: "Y73" }, { regex: "V1913[AT](?:[);/ ]|$)", model: "Y7s" }, { regex: "vivo 180([38]|8i)(?:[);/ ]|$)", model: "Y81" }, { regex: "vivo 1812(?:[);/ ]|$)", model: "Y81i" }, { regex: "V1732[AT](?:[);/ ]|$)", model: "Y81s" }, { regex: "vivo 1726(?:[);/ ]|$)", model: "Y83 Pro" }, { regex: "V1730EA(?:[);/ ]|$)", model: "Y89" }, { regex: "vivo 181[17](?:[);/ ]|$)", model: "Y91" }, { regex: "V1945A(?:[);/ ]|$)", model: "Y9s" }, { regex: "V2026(?:[);/ ]|$)", model: "Y12s" }, { regex: "vivo 18(16|20)(?:[);/ ]|$)", model: "Y91i" }, { regex: "(V1818[AT]|vivo 181[45])(?:[);/ ]|$)", model: "Y93" }, { regex: "V1818C[AT](?:[);/ ]|$)", model: "Y93s" }, { regex: "vivo 1807(?:[);/ ]|$)", model: "Y95" }, { regex: "V1813[AT](?:[);/ ]|$)", model: "Y97" }, { regex: "V1801A0(?:[);/ ]|$)", model: "Z1" }, { regex: "V1730D[AT](?:[);/ ]|$)", model: "Z1i" }, { regex: "vivo 1917(?:[);/ ]|$)", model: "Z1x" }, { regex: "V1813B[AT](?:[);/ ]|$)", model: "Z3" }, { regex: "V1730GA(?:[);/ ]|$)", model: "Z3x" }, { regex: "V1921A(?:[);/ ]|$)", model: "Z5" }, { regex: "V1911A(?:[);/ ]|$)", model: "Z5x" }, { regex: "V1990A(?:[);/ ]|$)", model: "Z5x (2020)" }, { regex: "V1963A(?:[);/ ]|$)", model: "Z6" }, { regex: "(?:VIV-|BBG-)?vivo[ _]([^/;]+) Build", model: "$1" }, { regex: "(?:VIV-|BBG-)?vivo[ _]([^);/]+)(?:[);/]|$)", model: "$1" }] }, Hz = { regex: "(XA Pro) Build", device: "smartphone", model: "$1" }, Uz = { regex: "BIRD[\\-. _]([^;/]+)", device: "feature phone", models: [{ regex: "BIRD[\\-. _]([^;/]+) Build", model: "$1" }, { regex: "BIRD[\\-. _]([^;/]+)", model: "$1" }] }, Xz = { regex: "Becker-([a-z0-9]+)", device: "feature phone", model: "$1" }, Wz = { regex: "Beeline", device: "smartphone", models: [{ regex: "Beeline[_ ]Pro[_ ]([2436])", model: "Pro $1" }, { regex: "Tab (Fast|Pro)", model: "Tab $1", device: "tablet" }, { regex: "Tab ([0-9])", model: "Tab $1", device: "tablet" }, { regex: "Tab", model: "Tab", device: "tablet" }, { regex: "E700", model: "E700" }, { regex: "Smart2", model: "Smart 2" }, { regex: "Smart ([0-9])", model: "Smart $1" }, { regex: "Smart Dual", model: "Smart Dual" }, { regex: "(?:Beeline[_ ])?Fast[_ ]2(?:[);/ ]|$)", model: "Fast 2" }, { regex: "Fast(?:[);/ ]|$)", model: "Fast" }] }, Yz = { regex: "Beetel ([a-z0-9]+)", device: "feature phone", model: "$1" }, Kz = { regex: "BENQ(?:[ \\-])?([a-z0-9]+)|F52_09(?:[);/ ]|$)", device: "feature phone", models: [{ regex: "F52_09(?:[);/ ]|$)", model: "F52" }, { regex: "BENQ(?:[ \\-])?([a-z0-9]+)", model: "$1" }] }, Qz = { regex: "Blaupunkt|Soundphone S2|Atlantis[_ ](?:1001A|1010A|A10\\.G40[23])|SLplus02|Discovery[_ ](?:A10_302|111C|1000C|1001A?)|Endeavour[_ ](?:785|101[GLM]|1000|1001|101[03]|1100)|Polaris[_ ]803|BP_6010", device: "tablet", models: [{ regex: "Discovery[_ ]111C", model: "Discovery 111C" }, { regex: "Discovery[_ ]A10_302", model: "Discovery A10.302" }, { regex: "Discovery[_ ]1000C", model: "Discovery 1000C" }, { regex: "Discovery[_ ]1001A", model: "Discovery 1001A" }, { regex: "Discovery[_ ]1001", model: "Discovery 1001" }, { regex: "Soundphone S2", model: "Soundphone S2" }, { regex: "Endeavour[_ ](101[GLM]|785|100[01]|101[03]|1100)", model: "Endeavour $1" }, { regex: "Polaris[_ ](803)", model: "Polaris $1" }, { regex: "Atlantis[_ ](1001A|1010A|A10\\.G40[23])", model: "Atlantis $1" }, { regex: "SLplus02", model: "SL Plus 02" }, { regex: "(BP_6010)", model: "$1" }, { regex: "Blaupunkt[_ ](SL[_ ]0[124]|SM[_ ]0[12])", device: "smartphone", model: "$1" }, { regex: "(4K Android TV)", device: "tv", model: "$1" }] }, jz = { regex: "Bmobile[_ ]|AX-?(?:[1-9][0-9]{2,3}[eEO+]?|7OO)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "AX-?([1-9][0-9]{2,3}[eEO+]?)", model: "AX$1" }, { regex: "AX7OO", model: "AX700" }, { regex: "Bmobile[_ ]([^/;]+) Build", model: "$1" }, { regex: "Bmobile[_ ]([a-z0-9]+)", model: "$1" }] }, Zz = /* @__PURE__ */ JSON.parse('{"regex":"Aquaris|bq [^/;]+ Build|BQS[-_]([0-9]{4})|(BQ(ru)?[_ -][0-9]{3,4})|BQ5059|BQ1008G|BQru_BQru-","device":"smartphone","models":[{"regex":"BQ(?:ru)?-(?:5209L|5044)(?:[);/ ]|$)","model":"Strike LTE"},{"regex":"BQ(?:ru)?-(?:6035L)(?:[);/ ]|$)","model":"Strike Power Max"},{"regex":"BQ(?:ru)?-(?:5535L)(?:[);/ ]|$)","model":"Strike Power Plus"},{"regex":"BQ(S|ru)?-(?:5070|6040L)(?:[);/ ]|$)","model":"Magic"},{"regex":"BQ(S|ru)?-(?:6424L)(?:[);/ ]|$)","model":"Magic O"},{"regex":"BQ(?:S|ru)?-(?:5730L)(?:[);/ ]|$)","model":"Magic C"},{"regex":"BQ(?:S|ru)?-(?:5731L)(?:[);/ ]|$)","model":"Magic S"},{"regex":"BQ(?:S|ru)?-5745L(?:[);/ ]|$)","model":"Clever"},{"regex":"BQ(?:S|ru)?-5533G(?:[);/ ]|$)","model":"Fresh"},{"regex":"BQ(?:S|ru)?-5031G(?:[);/ ]|$)","model":"Fun"},{"regex":"BQ(?:S|ru)?-(?:5732L)(?:[);/ ]|$)","model":"Aurora SE"},{"regex":"BQ(?:S|ru)?-6430L(?:[);/ ]|$)","model":"Aurora"},{"regex":"BQ(?:S|ru)?-6630L(?:[);/ ]|$)","model":"Magic L"},{"regex":"BQ-9011[G]?(?:[);/ ]|$)","model":"Vision","device":"tablet"},{"regex":"BQ-8068L(?:[);/ ]|$)","model":"Hornet Plus Pro"},{"regex":"BQ-8067L","model":"Hornet Plus","device":"tablet"},{"regex":"BQ-8052G","model":"BQ-8052G","device":"tablet"},{"regex":"BQ-8041L","model":"Art","device":"tablet"},{"regex":"BQ-7084G","model":"Simple","device":"tablet"},{"regex":"BQ-7061G","model":"Andros","device":"tablet"},{"regex":"BQ(ru)?-(7082)","model":"Armor","device":"tablet"},{"regex":"BQ-7051G","model":"Elba","device":"tablet"},{"regex":"BQ-7036L","model":"Hornet","device":"tablet"},{"regex":"BQ-7022(G)?","model":"Canion","device":"tablet"},{"regex":"BQ-7021G","model":"Hit","device":"tablet"},{"regex":"BQ-7010G","model":"Max","device":"tablet"},{"regex":"BQ-7006G","model":"Union","device":"tablet"},{"regex":"BQ-7003","model":"Jamaica","device":"tablet"},{"regex":"BQ-6200L|BQ-6000L","model":"Aurora"},{"regex":"BQ-6631G","model":"Surf"},{"regex":"BQ-6022G","model":"Aura"},{"regex":"BQ(ru)?[ -]6015L","model":"Universe"},{"regex":"BQ(?:S|ru)?-(?:5525|6030G|6010G)","model":"Practic"},{"regex":"BQ-6001L|BQ-6050","model":"Jumbo"},{"regex":"BQ-5707G(?:[);/ ]|$)","model":"Next Music"},{"regex":"BQ-5702(?:[);/ ]|$)","model":"Spring"},{"regex":"BQ-5700L(?:[);/ ]|$)","model":"Space X"},{"regex":"BQ-(?:5591|551[89]G)(?:[);/ ]|$)","model":"Jeans"},{"regex":"BQ-5522","model":"Next"},{"regex":"BQ-5520L(?:[);/ ]|$)","model":"Silk"},{"regex":"BQ-5519L(?:[);/ ]|$)","model":"Fast Plus"},{"regex":"BQ-5540L(?:[);/ ]|$)","model":"Fast Pro"},{"regex":"BQ-5517L(?:[);/ ]|$)","model":"Twin Pro"},{"regex":"BQ-5516L(?:[);/ ]|$)","model":"Twin"},{"regex":"BQS-5515(?:[);/ ]|$)","model":"Wide"},{"regex":"BQ-5515[L]?(?:[);/ ]|$)","model":"Fast"},{"regex":"BQ-(?:5512L|5528L)(?:[);/ ]|$)","model":"Strike Forward"},{"regex":"BQ-5511L(?:[);/ ]|$)","model":"Bliss"},{"regex":"BQS[_ ]5505(?:[);/ ]|$)","model":"Amsterdam"},{"regex":"BQ(?:ru)?-5510(?:[);/ ]|$)","model":"Strike Power Max 4G"},{"regex":"BQ(?:ru)?-(?:5521|5594)(?:[);/ ]|$)","model":"Strike Power Max"},{"regex":"BQ-5508L(?:[);/ ]|$)","model":"Next LTE"},{"regex":"BQ-5507L(?:[);/ ]|$)","model":"Iron Max"},{"regex":"BQ(?:ru)?-5504(?:[);/ ]|$)","model":"Strike Selfie Max"},{"regex":"BQ(?:ru)?-5503(?:[);/ ]|$)","model":"Nice 2"},{"regex":"BQ(?:ru)?-6045L(?:[);/ ]|$)","model":"Nice"},{"regex":"BQ(?:ru)?-4030G(?:[);/ ]|$)","model":"Nice Mini"},{"regex":"BQS-5502(?:[);/ ]|$)","model":"Hammer"},{"regex":"BQS-5501(?:[);/ ]|$)","model":"Kawasaki"},{"regex":"BQS-5500(?:[);/ ]|$)","model":"Vancouver"},{"regex":"BQ-5500L(?:[);/ ]|$)","model":"Advance"},{"regex":"BQ-5302G(?:[);/ ]|$)","model":"Velvet 2"},{"regex":"BQ-5301(?:[);/ ]|$)","model":"Strike View"},{"regex":"BQ-5300G(?:[);/ ]|$)","model":"Velvet View"},{"regex":"BQ(ru|S)?-(?:5211|5020)(?:[);/ ]|$)","model":"Strike"},{"regex":"BQ-5206L(?:[);/ ]|$)","model":"Balance"},{"regex":"BQ(?:ru|S)?-(?:5204|5050)(?:[);/ ]|$)","model":"Strike Selfie"},{"regex":"BQ(?:ru)?-5203(?:[);/ ]|$)","model":"Vision"},{"regex":"BQ(?:ru)?-5202(?:[);/ ]|$)","model":"Space Lite"},{"regex":"BQ(?:ru)?-5201(?:[);/ ]|$)","model":"Space"},{"regex":"BQ-5082(?:[);/ ]|$)","model":"Sense 2"},{"regex":"BQ-5045L(?:[);/ ]|$)","model":"Wallet"},{"regex":"BQ-5047L(?:[);/ ]|$)","model":"Like"},{"regex":"BQ-5071(?:[);/ ]|$)","model":"Belief"},{"regex":"BQ[S]?-(?:5065|5340)(?:[);/ ]|$)","model":"Choice"},{"regex":"BQ(?:S|ru)?-5046L(?:[);/ ]|$)","model":"Choice LTE"},{"regex":"BQ(?:ru)?-?(?:5059|5514G)(?:[);/ ]|$)","model":"Strike Power"},{"regex":"(?:BQru_)?BQ(?:ru)?-5058(?:[);/ ]|$)","model":"Strike Power Easy"},{"regex":"BQ(?:ru)?-5057(?:[);/ ]|$)","model":"Strike 2"},{"regex":"BQ[S]?-(?:5056|5030)(?:[);/ ]|$)","model":"Fresh"},{"regex":"BQ-6042l(?:[);/ ]|$)","model":"Magic E"},{"regex":"BQS-5055(?:[);/ ]|$)","model":"Turbo Plus"},{"regex":"BQ(?:ru)?-5054(?:[);/ ]|$)","model":"Crystal"},{"regex":"BQ-5052(?:[);/ ]|$)","model":"Sense"},{"regex":"BQ[S]?-5045(?:[);/ ]|$)","model":"Fast"},{"regex":"BQ(?:ru)?-(?:5037|5514L)(?:[);/ ]|$)","model":"Strike Power 4G"},{"regex":"BQ(?:ru)?-5035(?:[);/ ]|$)","model":"Velvet"},{"regex":"BQ(?:ru)?-5033(?:[);/ ]|$)","model":"Shark"},{"regex":"BQ-5541L(?:[);/ ]|$)","model":"Shark Rush"},{"regex":"BQ-5032(?:[);/ ]|$)","model":"Element"},{"regex":"BQS-5025(?:[);/ ]|$)","model":"High Way"},{"regex":"BQ(?:ru)?-5022(?:[);/ ]|$)","model":"Bond"},{"regex":"BQ-5015L(?:[);/ ]|$)","model":"First"},{"regex":"BQ-5016G(?:[);/ ]|$)","model":"Choice"},{"regex":"BQ-5012L(?:[);/ ]|$)","model":"Rich"},{"regex":"BQ-5521L(?:[);/ ]|$)","model":"Rich Max"},{"regex":"BQS-5011(?:[);/ ]|$)","model":"Monte Carlo"},{"regex":"BQ-5010G(?:[);/ ]|$)","model":"Spot"},{"regex":"BQ-5000G(?:[);/ ]|$)","model":"Velvet Easy"},{"regex":"BQS-5010(?:[);/ ]|$)","model":"Prague"},{"regex":"BQ-5009L(?:[);/ ]|$)","model":"Trend"},{"regex":"BQS-500[59](?:[);/ ]|$)","model":"Sydney"},{"regex":"BQ-5008L(?:[);/ ]|$)","model":"Brave"},{"regex":"BQ-5007L(?:[);/ ]|$)","model":"Iron"},{"regex":"BQS-5006(?:[);/ ]|$)","model":"Los Angeles"},{"regex":"BQ-(?:5005L|5530L)(?:[);/ ]|$)","model":"Intense"},{"regex":"BQS-5004(?:[);/ ]|$)","model":"Paris"},{"regex":"BQ-5003L(?:[);/ ]|$)","model":"Shark Pro"},{"regex":"BQ-5002G(?:[);/ ]|$)","model":"Fun"},{"regex":"BQS-5002(?:[);/ ]|$)","model":"Colombo"},{"regex":"BQS-5003(?:[);/ ]|$)","model":"Colombo II"},{"regex":"BQ-5001L(?:[);/ ]|$)","model":"Contact"},{"regex":"BQS-5001(?:[);/ ]|$)","model":"Milan"},{"regex":"BQ(?:ru|S)?-5000(?:[);/ ]|$)","model":"Tokyo"},{"regex":"BQS-4800(?:[);/ ]|$)","model":"Blade"},{"regex":"BQS-4707(?:[);/ ]|$)","model":"Montreal"},{"regex":"BQS-4702(?:[);/ ]|$)","model":"Оsaka"},{"regex":"BQS-4701(?:[);/ ]|$)","model":"Venice"},{"regex":"BQ-(?:4585|5011G)(?:[);/ ]|$)","model":"Fox View"},{"regex":"BQ(?:ru)?-4583(?:[);/ ]|$)","model":"Fox Power"},{"regex":"BQS-4570(?:[);/ ]|$)","model":"Drive"},{"regex":"BQS-4560(?:[);/ ]|$)","model":"Golf"},{"regex":"BQS-4555(?:[);/ ]|$)","model":"Turbo"},{"regex":"BQS-4550(?:[);/ ]|$)","model":"Richmond"},{"regex":"BQ(?:ru)?-(?:4526|5004G)(?:[);/ ]|$)","model":"Fox"},{"regex":"BQS-4525(?:[);/ ]|$)","model":"Vienna"},{"regex":"BQS-4516(?:[);/ ]|$)","model":"Singapore"},{"regex":"BQS-4515(?:[);/ ]|$)","model":"Moscow"},{"regex":"BQS-4510(?:[);/ ]|$)","model":"Florence"},{"regex":"BQS-4505(?:[);/ ]|$)","model":"Santiago"},{"regex":"BQS-4503(?:[);/ ]|$)","model":"Dubai"},{"regex":"BQS-4502(?:[);/ ]|$)","model":"Kingston"},{"regex":"BQS-4501 Bristol","model":"Bristol"},{"regex":"BQ-4501G(?:[);/ ]|$)","model":"Fox Easy"},{"regex":"BQ(?:ru)?-4500(?:[);/ ]|$)","model":"Fox LTE"},{"regex":"BQ-4077(?:[);/ ]|$)","model":"Shark Mini"},{"regex":"BQ(?:ru)?-4072(?:[);/ ]|$)","model":"Strike Mini"},{"regex":"BQ(?:ru)?[- ]402[68](?:[);/ ]|$)","model":"Up!"},{"regex":"BQS-4010(?:[);/ ]|$)","model":"Aspen"},{"regex":"BQS-4009(?:[);/ ]|$)","model":"Orleans"},{"regex":"BQS-4008(?:[);/ ]|$)","model":"Shanghai"},{"regex":"BQS-4007(?:[);/ ]|$)","model":"Valencia"},{"regex":"BQS-4005(?:[);/ ]|$)","model":"Seoul"},{"regex":"BQS-4004(?:[);/ ]|$)","model":"Dusseldorf"},{"regex":"BQS-4003(?:[);/ ]|$)","model":"Verona"},{"regex":"BQ-4001G(?:[);/ ]|$)","model":"Cool"},{"regex":"BQS-4001(?:[);/ ]|$)","model":"Oxford"},{"regex":"BQS-3510(?:[);/ ]|$)","model":"Aspen Mini"},{"regex":"BQS-3503(?:[);/ ]|$)","model":"Bombay"},{"regex":"BQ-1085L(?:[);/ ]|$)","model":"Hornet Max Pro","device":"tablet"},{"regex":"BQ-1084L(?:[);/ ]|$)","model":"Hornet Max","device":"tablet"},{"regex":"BQ-1083G(?:[);/ ]|$)","model":"Armor Pro Plus","device":"tablet"},{"regex":"BQ-1082G(?:[);/ ]|$)","model":"Armor Pro","device":"tablet"},{"regex":"BQ-1077L(?:[);/ ]|$)","model":"Armor Pro LTE","device":"tablet"},{"regex":"BQ(?:ru)?-1057L(?:[);/ ]|$)","model":"Passion","device":"tablet"},{"regex":"BQ-1051G(?:[);/ ]|$)","model":"Corsika","device":"tablet"},{"regex":"BQ-1050G(?:[);/ ]|$)","model":"Hawaii","device":"tablet"},{"regex":"BQ[-]?1008G(?:[);/ ]|$)","model":"Grace","device":"tablet"},{"regex":"Aquaris M8","model":"Aquaris M8","device":"tablet"},{"regex":"Aquaris_([AM])4.5","model":"Aquaris $14.5"},{"regex":"BQ(?:ru)?[_ -](?:5590|5740G)(?:[);/ ]|$)","model":"Spring"},{"regex":"BQ[S]?-(?:6016L|5520)(?:[);/ ]|$)","model":"Mercury"},{"regex":"BQ(?:S|ru)?-(?:5701L|5060)(?:[);/ ]|$)","model":"Slim"},{"regex":"(BQ-7850|BQ-700[12]G|BQ-8002G|BQ-905[12]G|BQ-9702G|BQ-7056G)","model":"$1","device":"tablet"},{"regex":"BQ-8006G(?:[);/ ]|$)","model":"Java","device":"tablet"},{"regex":"BQ-7062G(?:[);/ ]|$)","model":"Fiji","device":"tablet"},{"regex":"BQ(?:ru)?-1081G(?:[);/ ]|$)","model":"Grace 3G","device":"tablet"},{"regex":"BQ-7802G(?:[);/ ]|$)","model":"Luzon","device":"tablet"},{"regex":"BQ-7008G(?:[);/ ]|$)","model":"Clarion","device":"tablet"},{"regex":"BQ-7064G(?:[);/ ]|$)","model":"Fusion","device":"tablet"},{"regex":"BQ-7050G(?:[);/ ]|$)","model":"Malta","device":"tablet"},{"regex":"BQ-7000G(?:[);/ ]|$)","model":"Сharm","device":"tablet"},{"regex":"BQ-7040G(?:[);/ ]|$)","model":"Сharm Plus","device":"tablet"},{"regex":"BQ-7038G(?:[);/ ]|$)","model":"Light Plus","device":"tablet"},{"regex":"BQ-7005G(?:[);/ ]|$)","model":"Maui","device":"tablet"},{"regex":"BQ-7098G(?:[);/ ]|$)","model":"Armor Power","device":"tablet"},{"regex":"BQ-1007(?:[);/ ]|$)","model":"Necker","device":"tablet"},{"regex":"BQ-1045[G]?(?:[);/ ]|$)","model":"Orion","device":"tablet"},{"regex":"BQ-(?:1054L|1020L)(?:[);/ ]|$)","model":"Nexion","device":"tablet"},{"regex":"BQ-7083G(?:[);/ ]|$)","model":"Light","device":"tablet"},{"regex":"BQ-8077L(?:[);/ ]|$)","model":"Exion Plus","device":"tablet"},{"regex":"BQ(?:ru)?-7083(?:[);/ ]|$)","model":"7083","device":"tablet"},{"regex":"BQ(?:ru)?-1056L(?:[);/ ]|$)","model":"1056L","device":"tablet"},{"regex":"BQ(?:ru)?-1022l(?:[);/ ]|$)","model":"Armor Pro LTE+","device":"tablet"},{"regex":"BQ(?:ru)?-1024L(?:[);/ ]|$)","model":"Exion Pro","device":"tablet"},{"regex":"BQ(?:ru)?-7081(?:[);/ ]|$)","model":"Charm","device":"tablet"},{"regex":"(?:bq )?(Aquaris[^/;]*) Build","model":"$1"},{"regex":"Aquaris (E(4.5|[56])|M(5|10)|U2 Lite|U2|U (Lite|Plus)|V Plus|X5 Plus|X2? Pro|X[25]|[CMUVX])","model":"Aquaris $1"},{"regex":"bq ([^/;]+) Build","model":"$1","device":"tablet"}]}'), zz = { regex: "Bush[ _-]|Bush10Nou", device: "smartphone", models: [{ regex: "Bush10Nou", device: "tablet", model: "10Nou" }, { regex: "BUSH ([^;/)]+)Tablet(?: Build|[);])", model: "$1Tablet", device: "tablet" }, { regex: "BUSH ([^;/)]+)(?: Build|[);])", model: "$1" }] }, qz = { regex: "CAGI-", device: "smartphone", models: [{ regex: "CAGI-OMEGA", model: "Omega" }, { regex: "CAGI-([a-z0-9_\\-]+)", model: "$1" }] }, Jz = { regex: "Capitel-([a-z0-9]+)", device: "feature phone", model: "$1" }, eq = { regex: "Captiva[ _-]([^;/)]+)(?: Build|\\))", device: "tablet", model: "Pad $1" }, tq = { regex: "(C811|C7[57]1)(?: 4G)?(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "C751(?:[);/ ]|$)", model: "G'zOne Ravine" }, { regex: "C771(?:[);/ ]|$)", model: "G'zOne Commando" }, { regex: "C811 4G(?:[);/ ]|$)", model: "G'zOne Commando 4G LTE" }] }, rq = { regex: "CASPER[_ ]|VIA[- _](T7D|A[34]|E3|F[123]|G4|M4|[LS]8|S7|P2|V8C|A1_Plus(?:_64)?|A1(?:_1)?|S[13]0|S|T17_M|T1[07]|T7|T7-3G|T8B|T8D-3G|S1[78])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:CASPER[_ ])?VIA_A1_Plus(?:_64)?", model: "VIA A1 Plus" }, { regex: "(?:CASPER[_ ])?VIA[_ ](G1_Plus|G1|E1|[AE]2|M[123]|V[35689]|V10|G3|V6X|A[34]|E3|F[123]|G4|M4|P2|S|V8C|A1(?:_1)?)(?:[);/ ]|$)", model: "VIA $1" }, { regex: "CASPER_VIA_E1c", model: "VIA E1C" }, { regex: "CASPER_L10_4.5G", model: "L10 4.5G", device: "tablet" }, { regex: "CASPER_(S[23]8)(?:[);/ ]|$)", model: "$1", device: "tablet" }, { regex: "VIA[- _](T7|T8D)-3G", model: "VIA $1 3G", device: "tablet" }, { regex: "VIA[- _](T7D|S[13]0|[LS]8|S7|T17_M|T1[07]|T7|T8B|S1[78])(?:[);/ ]|$)", model: "VIA $1", device: "tablet" }] }, oq = { regex: "Cat ?(tablet|stargate|nova)|B15Q|CAT B35|CAT-B100", device: "tablet", models: [{ regex: "B15Q", model: "B15Q", device: "smartphone" }, { regex: "CAT B35", model: "B35", device: "smartphone" }, { regex: "Cat ?(?:tablet)? ?((?:Galactica|Nova|StarGate|PHOENIX)[^/;]*) Build", model: "$1" }, { regex: "Cat ?tablet", model: "Nova" }, { regex: "CAT-(B100)", device: "feature phone", model: "$1" }] }, nq = { regex: "CT(?:10[0123]0|7[12]0|820)(?:W|FR)?(?:[);/ ]|$)", device: "tablet", models: [{ regex: "CT820", model: "Touch Tablet Neo2" }, { regex: "CT(10[0123]0(?:W|FR)?)", model: "CT$1" }, { regex: "CT(7[12]0(?:W|FR)?)", model: "CT$1" }] }, aq = { regex: "Celkon|Millennia Hero", device: "smartphone", models: [{ regex: "Celkon[ _*](C[78]20)", model: "$1", device: "tablet" }, { regex: "Millennia Hero", model: "Millennia Hero" }, { regex: "Celkon[ _*](CT[^;/]+) Build", model: "$1", device: "tablet" }, { regex: "Celkon[ _*]([^;/]+) Build", model: "$1" }, { regex: "Celkon[\\. _*]([^;/\\)]+)[\\)/]", model: "$1" }] }, lq = { regex: "Changhong", device: "smartphone", models: [{ regex: "Changhong[ ]?(X1-K|X6|R8|Z9S?|Z1S|S18)(?:[);/ ]|$)", model: "$1" }, { regex: "ChangHong Android TV", device: "tv", model: "" }, { regex: "(?:Opera TV.+)Changhong-([^);/]+)", device: "tv", model: "$1" }] }, iq = { regex: "Comio|CT701G PLUS|CT701W|GT100", device: "smartphone", models: [{ regex: "GT100", model: "GT100", device: "tablet" }, { regex: "CT701W", model: "CT701W", device: "tablet" }, { regex: "CT701G PLUS", model: "CT701G Plus", device: "tablet" }, { regex: "Comio[ _-]?([^;/)]+)(?: Build|[);])", model: "$1" }] }, sq = { regex: "Compal-[a-z0-9]+", device: "feature phone", model: "$1" }, dq = { regex: "Artel[_ ]|\\w+_ARTEL_\\w+|GAP YOQ(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "GAP YOQ(?:[);/ ]|$)", model: "Gap Yo Q" }, { regex: "Artel[_ ](Quadro(?: Pro)?|Tesla|Air|Tomchi|Premium|U3_4G|Z5|Sentinel (?:X 8G|X D5|X)|T10)", model: "$1" }, { regex: "Artel[_ ]Komi3", model: "Komi 3" }, { regex: "Artel[_ ](Star|Nova|Connect|Choice|Style)", model: "$1", device: "tablet" }, { regex: "(?:\\w+_)?ARTEL_([FVM]5|X[45])_\\w+", device: "feature phone", model: "$1" }] }, uq = { regex: "ConCorde ([^/;]+) Build|Concorde_Raptor_Z55(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Concorde_(Raptor_Z55)(?:[);/ ]|$)", model: "$1" }, { regex: "ConCorde Tab ?([^/;]+) Build", model: "Tab $1", device: "tablet" }, { regex: "ConCorde ReadMan ?([^/;]+) Build", model: "ReadMan $1", device: "tablet" }, { regex: "ConCorde ([^/;]+) Build", model: "$1" }] }, cq = { regex: "Allure (?:M[13]|X)|Griffe T[2356789]|TFX712G|TRA-901G|TGW[-]?(710G|709)|(?:PGN\\-?[456][012][0-9]|PHS\\-601|PHQ519|PHQ52[056]|TB105L|TB717G|PKT\\-301|Plume (?:H1|L[1-468]|P8|P6 PRO LTE))(?:[);/ ]|$)|CTAB[^/;]+ Build", device: "smartphone", models: [{ regex: "CTAB([^/;]+) Build", device: "tablet", model: "CTAB $1" }, { regex: "(TGW)-?(710G|709)(?:[);/ ]|$)", device: "tablet", model: "$1 $2" }, { regex: "(TFX712G|TB105L|TB717G)(?:[);/ ]|$)", device: "tablet", model: "$1" }, { regex: "(TRA)-(901G)(?:[);/ ]|$)", device: "tablet", model: "$1 $2" }, { regex: "PHS\\-601", model: "C8" }, { regex: "PGN\\-?403", model: "C4+ Noir" }, { regex: "PGN\\-?404", model: "C7 Mini" }, { regex: "PGN\\-?409", model: "Plume P4" }, { regex: "PKT\\-?301", model: "C2" }, { regex: "PGN\\-?504", model: "C5" }, { regex: "PGN\\-?505", model: "C8S" }, { regex: "PGN\\-?506", model: "C7" }, { regex: "(Allure (?:M[13]|X))", model: "$1" }, { regex: "PGN\\-?507", model: "Allure A9" }, { regex: "PGN\\-?508", model: "C6+" }, { regex: "PGN\\-?509", model: "C6 Pro" }, { regex: "PGN\\-?511", model: "Allure A9 Plus" }, { regex: "PGN\\-?513", model: "Griffe G4" }, { regex: "PHQ519", model: "Griffe G4S" }, { regex: "PHQ520", model: "Griffe G5" }, { regex: "PHQ525", model: "Griffe G6" }, { regex: "PHQ526", model: "Griffe G6 Pro" }, { regex: "PGN\\-?514", model: "Plume P7" }, { regex: "PGN\\-?515", model: "Plume P4 Pro" }, { regex: "PGN\\-?516", model: "Plume P5" }, { regex: "PGN\\-?51[78]", model: "Plume P6" }, { regex: "PGN\\-?521", model: "Griffe G4 Plus" }, { regex: "Griffe T3 ?pro", model: "Griffe T3 Pro" }, { regex: "Griffe T([0-9]) Plus", model: "Griffe T$1 Plus" }, { regex: "Griffe T([0-9])", model: "Griffe T$1" }, { regex: "PGN\\-?522", model: "P6 Plus" }, { regex: "PGN\\-?523", model: "P7 Plus" }, { regex: "PGN\\-?527", model: "Plume P4 Plus" }, { regex: "PGN\\-?528|PLUME P6 PRO LTE", model: "Plume P6 Pro LTE" }, { regex: "PGN\\-?605", model: "Plume P8" }, { regex: "PGN\\-?606", model: "Allure A55" }, { regex: "PGN\\-?607", model: "Allure A100" }, { regex: "PGN\\-?608", model: "Allure A55 Slim" }, { regex: "PGN\\-?609", model: "Allure A100 Lite" }, { regex: "PGN\\-?610", model: "Plume P8 Lite" }, { regex: "PGN\\-?611", model: "Allure A8" }, { regex: "PGN\\-?612", model: "Allure A8 Plus" }, { regex: "PGN\\-?613", model: "Allure A55 Plus" }, { regex: "Plume H1", model: "Plume H1" }, { regex: "Plume L([2468]) Pro", model: "Plume L$1 Pro" }, { regex: "Plume L3 Plus", model: "Plume L3 Plus" }, { regex: "Plume L3 Smart", model: "Plume L3 Smart" }, { regex: "Plume L([1-4])", model: "Plume L$1" }, { regex: "Plume P8 Pro", model: "Plume P8 Pro" }, { regex: "PGN\\-?([0-9]{3})", model: "PGN-$1" }] }, mq = { regex: "(?:YL-)?Coolpad|(?:Cool_9S|1824-S0|8190Q|1831-A0|8676-[AM]01|CP8298_I00|CP3648A|CP8676_I0[23]|REVVLPLUS C3701A|VCR-[AI]0|C105-E0|C106-[79]| C106|MTS-T0|cp3705A[S]?|ORL-C0|DLS-E0|8298-M02|5560S)(?:[);/ ]|$)|(8295|5860S) Build", device: "smartphone", models: [{ regex: "VCR-[AI]0", model: "Cool Play 6" }, { regex: "1831-A0(?:[);/ ]|$)", model: "Cool Play C7" }, { regex: "REVVLPLUS C3701A", model: "REVVL Plus", device: "phablet" }, { regex: "8190Q(?:[);/ ]|$)", model: "8190Q" }, { regex: "DLS-E0(?:[);/ ]|$)", model: "N5" }, { regex: "1824-S0(?:[);/ ]|$)", model: "N5C" }, { regex: "CP3705A[S]?(?:[);/ ]|$)", model: "Legacy" }, { regex: "CP3648A(?:[);/ ]|$)", model: "Legacy S" }, { regex: "MTS-T0(?:[);/ ]|$)", model: "N2M" }, { regex: "C106-[79](?:[);/ ]|$)", model: "Cool 1" }, { regex: "C105-E0(?:[);/ ]|$)", model: "Cool S1" }, { regex: "ORL-C0(?:[);/ ]|$)", model: "Cool 9" }, { regex: "Cool_9S(?:[);/ ]|$)", model: "Cool 9S" }, { regex: "5560S(?:[);/ ]|$)", model: "Arise" }, { regex: "(5860S|8295) Build", model: "$1" }, { regex: "CP8676_I02(?:[);/ ]|$)", model: "Note 3" }, { regex: "CP8676_I03(?:[);/ ]|$)", model: "Note 3 Plus" }, { regex: "CP8298_I00(?:[);/ ]|$)", model: "Note 3 Lite" }, { regex: "(8676-[AM]01|8298-M02)(?:[);/ ]|$)", model: "$1" }, { regex: "(?:YL-)?Coolpad[ _\\-]?([^/;]+) Build", model: "$1" }, { regex: "(?:YL-)?Coolpad[ _\\-]?([a-z0-9\\-]+)", model: "$1" }] }, gq = { regex: "Clarmin", device: "smartphone", models: [{ regex: "Clarmin[_ ](B[65]|C1)", model: "$1" }] }, fq = { regex: "CORN ", device: "smartphone", models: [{ regex: "CORN R20", model: "R20" }] }, pq = { regex: "Cosmote", device: "smartphone", models: [{ regex: "Cosmote_My_mini_Tab", device: "tablet", model: "My Mini Tab" }] }, hq = { regex: "Cricket-([a-z0-9]+)|U705AC(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "U705AC", model: "Ovation" }, { regex: "Cricket-([a-z0-9]+)", device: "feature phone", model: "$1" }] }, xq = { regex: "Crosscall|ODYSSEY_Plus|Odyssey S1|Trekker-[MSX][1234]|Action-X3|Core-X3", device: "smartphone", models: [{ regex: "Action-X3", model: "Action-X3" }, { regex: "Core-X3", model: "Core-X3" }, { regex: "Crosscall ([^;/]+) Build", model: "$1" }, { regex: "ODYSSEY_Plus", model: "ODYSSEY+" }, { regex: "Odyssey S1", model: "ODYSSEY S1" }, { regex: "Trekker-([MSX][1234](?: Core)?)", model: "Trekker-$1" }] }, vq = { regex: "(?:T1001XS?|T1006S?|iPlay_[24]0|U1006H?)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "T1001XS(?:[);/ ]|$)", model: "M5XS" }, { regex: "T1006S(?:[);/ ]|$)", model: "M5S" }, { regex: "T1006(?:[);/ ]|$)", model: "M5" }, { regex: "T1001X(?:[);/ ]|$)", model: "M5X" }, { regex: "U1006H?(?:[);/ ]|$)", model: 'iPlay 10 Pro 10.1"' }, { regex: "iPlay_([24]0)(?:[);/ ]|$)", model: "iPlay $1" }] }, Sq = { regex: "(<!myPhone ?)Cube|(U[0-9]+GT|K8GT)|(?:T8-PLUSM?S?|T8PLUSML|I1-TF[BD]?|I1-TC|i1002S|Iwork10 Flagship|iwork10 Pro)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "U27GT", model: "Talk 8" }, { regex: "(?:T8-PLUSM?S?|T8PLUSML)(?:[);/ ]|$)", model: "T8 Ultimate" }, { regex: "U55GT", model: "Talk 79" }, { regex: "U65GT", model: "Talk 9X" }, { regex: "I1-TF[BD]?(?:[);/ ]|$)", model: "iWork 8 Air" }, { regex: "I1-TC(?:[);/ ]|$)", model: "iWork 8 Ultimate" }, { regex: "(?:i1002S|iwork10 Pro)(?:[);/ ]|$)", model: "iWork 10 Pro" }, { regex: "Iwork10 Flagship(?:[);/ ]|$)", model: "iWork 10 Flagship" }, { regex: "(U[0-9]+GT[^;/]*) Build", model: "$1" }, { regex: "(U[0-9]+GT(?:[0-9]|[\\-_][a-z]+)?)", model: "$1" }, { regex: "(K8GT)", model: "$1" }] }, bq = { regex: "CUBOT|RAINBOW 2|KING_KONG_3|ZORRO 001|KINGKONG[_ ]MINI2?|KING KONG CS|(?<!QUMO )QUEST(?!(?:[0-9]|\\s[0-9]))(?: LITE)?|NOTE 20 PRO", device: "smartphone", models: [{ regex: "CHEETAH 2", model: "Cheetah 2" }, { regex: "RAINBOW 2", model: "Rainbow 2" }, { regex: "RAINBOW", model: "Rainbow" }, { regex: "DINOSAUR", model: "Dinosaur" }, { regex: "KINGKONG MINI2", model: "King Kong Mini 2" }, { regex: "KINGKONG_MINI", model: "King Kong Mini" }, { regex: "KING_KONG_3", model: "King Kong 3" }, { regex: "KING KONG CS", model: "King Kong CS" }, { regex: "KING KONG", model: "King Kong" }, { regex: "QUEST LITE", model: "Quest Lite" }, { regex: "QUEST", model: "Quest" }, { regex: "ZORRO 001", model: "Zorro 001" }, { regex: "CUBOT[ _]Echo", model: "Echo" }, { regex: "CUBOT[ _]MANITO", model: "Manito" }, { regex: "CUBOT[ _]MAGIC", model: "Magic" }, { regex: "CUBOT[ _]MAX", model: "Max" }, { regex: "NOTE Plus", model: "Note Plus" }, { regex: "NOTE 20 PRO", model: "Note 20 Pro" }, { regex: "CUBOT[_ ]NOTE[_ ]S", model: "Note S" }, { regex: "CUBOT_NOVA", model: "Nova" }, { regex: "CUBOT_POWER", model: "Power" }, { regex: "CUBOT_X18_Plus", model: "X18 Plus" }, { regex: "CUBOT[ _](A5|C6W|H3|J3|P7|P20|[RXJ]9|R11|X18)(?:[);/ ]|$)", model: "$1" }, { regex: "CUBOT ([^;/]+) Build", model: "$1" }, { regex: "([^;/]+) Build/CUBOT", model: "$1" }] }, yq = { regex: "Hind[ _]5\\.1|X417[ _]Amaze|X418[ _]Zest|X421[ _]Nova|X422[ ]Exotic|X425[ _]Shavit|X428[ _]Astute", device: "smartphone", models: [{ regex: "Hind[ _]5\\.1", model: "Hind 5.1" }, { regex: "X417[ _]Amaze", model: "X417 Amaze" }, { regex: "X418[ _]Zest", model: "X418 Zest" }, { regex: "X421[ _]Nova", model: "X421 Nova" }, { regex: "X422[ _]Exotic", model: "X422 Exotic" }, { regex: "X425[ _]Shavit", model: "X425 Shavit" }, { regex: "X428[ _]Astute", model: "X428 Astute" }] }, wq = { regex: "Concord[ _-]|(?:Flyfix 6|C-721|Plus-7_C777|Plus_M19_C779|Plus-9_C778)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "M10", model: "M10" }, { regex: "Flyfix 6", model: "Flyfix 6" }, { regex: "C-721", model: "Flyfix Q", device: "tablet" }, { regex: "Plus[-_]([79]|M19)_(C77[789])(?:[);/ ]|$)", model: "Plus-$1 $2", device: "tablet" }] }, _q = { regex: "WING 5|WING9|Venus[ _][14]", device: "smartphone", models: [{ regex: "WING 5", model: "Wing 5" }, { regex: "WING9", model: "Wing 9" }, { regex: "Venus[ _]([14])", model: "Venus $1" }] }, Tq = { regex: "Cyrus[ _-]", device: "smartphone", models: [{ regex: "Cyrus[ _-]?([^;/)]+) Build", model: "$1" }, { regex: "Cyrus[ _-]?([^;/)]+)(?:[);/ ]|$)", model: "$1" }] }, Aq = { regex: "DATANG", device: "smartphone", models: [{ regex: "(?:DATANG[ _-])+([^;/]+) Build", model: "$1" }, { regex: "(?:DATANG[ _-])+([^;/)]+)(?:[;/)]|$)", model: "$1" }] }, Pq = { regex: "DATSUN", device: "smartphone", models: [{ regex: "DATSUN_D5500", model: "D5500" }, { regex: "Datsun_D5001", model: "D5001" }] }, Mq = { regex: "Dslide ?([^;/]+) Build|Konnect_?(?:402|50[246]|60[127])|GEODROID_A5", device: "smartphone", models: [{ regex: "Konnect_?(402|50[246]|60[127])", model: "Konnect $1" }, { regex: "Dslide ?([^;/]+) Build", device: "tablet", model: "DSlide $1" }, { regex: "GEODROID_A5", device: "tablet", model: "Geodroid A5" }] }, $q = { regex: "(?:TA[CDQ]-[0-9]+)|P(?:.+)TAQ-(?:[0-9]+)|SDQ[_-](?:550[24]4L|52001G|50002G|57004L)", device: "tablet", models: [{ regex: "P(?:.+)TAQ-(10213GMK2|10172MK3|10242MK2|70242MK2|[0-9]+)(?:[);/ ]|$)", model: "TAQ-$1" }, { regex: "(TA[CDQ]-[0-9]+)", model: "$1" }, { regex: "SDQ[_-](550[24]4L|52001G|50002G|57004L)", device: "smartphone", model: "SDQ-$1" }] }, Cq = { regex: "Dell[^a-z]|Venue|XCD35", device: "smartphone", models: [{ regex: "XCD35", model: "XCD35" }, { regex: "Venue (8 7840|10 7040|8 3830)", model: "Venue $1", device: "tablet" }, { regex: "(?:Dell )?Venue Build", model: "Venue" }, { regex: "Dell; Venue Pro", model: "Venue Pro" }, { regex: "(OptiPlex (?:3050|7010))", device: "desktop", model: "$1" }, { regex: "(?:Dell )?(Streak|Venue) ?([^/;]*) Build", model: "$1 $2", device: "tablet" }, { regex: "(?:Dell Inc./)?(XPS 13 9360|Latitude 7480)(?:[);/ ]|$)", device: "desktop", model: "$1" }, { regex: "Dell; ((?:Streak|Venue)[^;/\\)]*)", model: "$1", device: "tablet" }, { regex: "Dell; ([^;/\\)]+)", model: "$1" }, { regex: "Dell[ _\\-]([^/;]+) Build", model: "$1" }] }, Lq = { regex: "Desay", device: "smartphone", models: [{ regex: "Desay[ _-]?([^;/)]+) Build", model: "$1" }, { regex: "Desay[ _-]?([^;/)]+)(?:[);/ ]|$)", model: "$1" }] }, Eq = { regex: "DEXP|(?:Ursus|Ixion)[ _]([^;/)]+)|H135[ _]Build|Larus_TV1|Ixion(?:ML4.7|ES250)|M150Storm|(?:SENIOR|F4[38]D8000K|VA[12]10|VA170|ML450|MS[56]50|BL[123]50|BS155|BS160|BS[1256]50|AL[12]40|AL[23]50|AS155|AS260|GS15[035]| (?:N280i|P380i|R110|BL160|B450|B340|A1[45]0|A340|AS160|GL[23]55|ES750))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Ixion[_ ]([^;/]+)(?: Build|\\))", model: "Ixion $1" }, { regex: "(ML450|MS[56]50|ES750)(?:[);/ ]|$)", model: "Ixion $1" }, { regex: "IxionES250(?:[);/ ]|$)", model: "Ixion ES250 Rage" }, { regex: "IxionML4.7(?:[);/ ]|$)", model: 'Ixion ML 4.7"' }, { regex: "M150Storm(?:[);/ ]|$)", model: "Ixion M150 Storm" }, { regex: "AL250(?:[);/ ]|$)", model: '4.5" AL250' }, { regex: "AL350(?:[);/ ]|$)", model: '5.0" AL350' }, { regex: "AS155(?:[);/ ]|$)", model: '5.45" AS155' }, { regex: "AS260(?:[);/ ]|$)", model: '5.85" AS260', device: "phablet" }, { regex: "Ursus ([^;/)]+)(?: Build|\\))", model: "Ursus $1", device: "tablet" }, { regex: "(VA[21]10|VA170|R110|N280i|P380i)(?:[);/ ]|$)", model: "Ursus $1", device: "tablet" }, { regex: " (B450|B340|BL160|A340)(?:[);/ ]|$)", model: "$1" }, { regex: "SENIOR(?:[);/ ]|$)", model: "Senior" }, { regex: "Larus_TV1", device: "feature phone", model: "Larus_TV1" }, { regex: "H135[ _]Build", model: "Atlas", device: "desktop" }, { regex: "(BL[123]50|BS155|BS160|BS[1256]50|AL[12]40|A1[45]0|GS15[035]|AS160|GL[23]55)(?:[);/ ]|$)", model: "$1" }, { regex: "DEXP[ _]([^;/]+) Build", model: "$1" }, { regex: "DEXP[ _]([^);/]+)(?:[);/ ]|$)", model: "$1" }, { regex: "(F4[38]D8000K)(?:[);/ ]|$)", device: "tv", model: "$1" }] }, Oq = { regex: "DBTEL(?:[\\-/])?([a-z0-9]+)", device: "feature phone", model: "$1" }, Nq = { regex: "Dialog ?([^;/]+) Build", device: "smartphone", model: "$1" }, Dq = { regex: "DICAM-([a-z0-9]+)", device: "feature phone", model: "$1" }, kq = { regex: "(?<!FBCR/)Digi[ _]([^);/]+)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Gq = { regex: "DIGICEL", device: "smartphone", models: [{ regex: "DL810", model: "DL810" }, { regex: "DIGICEL ([^/;]+) Build", model: "$1" }] }, Bq = { regex: "(?:DL1008M|DL(?:1023|9002|[78]006))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "DL1008M", model: "DL1008M" }, { regex: "DL(1023|9002|[78]006)", model: "DL$1" }] }, Iq = { regex: "Digma[_ ]([^;/]+) Build|HIT HT707[10]MG|CITI (?:7 E401 4G|8 E400 4G|ATL 4G|Kids|Octa [178]0|1902 3G|10 E402|Z530 3G)|(CITI[_ ](?:[A-Z0-9]+)[_ ][34]G)[ _][TC][ST](606[32]ML|111[46]ML|11[459]4MG|1117PG|1207MG|1210MG|1195MG|1196ML|3001ML|4024PG|5009PL|5021ML|5026PL|500[67]PG|7052PG|706[56]MG|709[68]PL|7097MG|720[48]MG|7140ML|7141MG|7113PL|7193MG|820[69]MG|7153MG|8139ML|8143MG|8152ML|1050PL|8205PG|7203MG|106[24]ML|1115MG)|HIT 4G|HT7074ML|IDX5|(iDx10|iDx7)|MVM900H(?:WZ|C)|MVM908HCZ|(iDxD8 3G|iDxD10 3G|iDrQ10 3G|iDxD[45]|iDxQ5|iD[nx]D7(?:[_ ]3G)?)|PS604M|PT452E|LINX B510 3G LT5037MG|LINX A452 3G LT4030PG|LINX A453 3G LT4038PG|LINX A420 3G LS4019PG|LINX A450 3G LT4028PG|Linx A400 3G LT4001PG|Linx C500 3G LT5001PG|Linx PS474S|LS504[01]PL|LT40(47|54)MG|PS1043MG|LS405[01]MG|LS5053ML|LT5048MG|HT7071MG|LT5052ML|HT5035PG|HT4039PG|LT4049PG|NS6902QL|NS9797MG|TS7854M|TS1012E 3G|TT1004PG|TT702[045]MG|TT1002MG|TT7026MW|((?:Optima|Platina|Plane)[ _](?:[EM])?(?:[0-9\\.ST]+|Prime)(?:[ _][43]G)?)|(VOX[ _](?:[0-9\\.A-Z]+)[_ ][43]G)", device: "smartphone", models: [{ regex: "HIT(?: 3G)? HT707[10]MG", model: "HIT 3G", device: "tablet" }, { regex: "iDx5", model: "iDx5" }, { regex: "HT5035PG", model: "HIT Q500 3G" }, { regex: "HT4039PG", model: "HIT Q401 3G" }, { regex: "(VOX[ _](?:[0-9\\.A-Z]+)[_ ][43]G)", model: "$1" }, { regex: "PS604M", model: "Linx 6.0" }, { regex: "LT4049PG", model: "Linx Atom 3G" }, { regex: "LT5048MG", model: "Linx Joy 3G" }, { regex: "LT5052ML", model: "Linx Base 4G" }, { regex: "LT4047MG", model: "Linx Alfa 3G" }, { regex: "LS4050MG", model: "Linx X1 3G" }, { regex: "LS4051MG", model: "Linx X1 Pro 3G" }, { regex: "LT4054MG", model: "Linx Argo 3G" }, { regex: "LS5041PL", model: "Linx Trix 4G" }, { regex: "LS5040PL", model: "Linx Rage 4G" }, { regex: "LS5053ML", model: "Linx Pay 4G" }, { regex: "Linx ([A-Z][0-9]{3}) 3G (?:LT4028PG|LS4019PG|LT4001PG|LT5001PG|LT4038PG|LT5037MG|LT4030PG)", model: "Linx $1 3G" }, { regex: "(Linx PS474S)", model: "$1" }, { regex: "PT452E", model: "Linx 4.5" }, { regex: "CITI ATL 4G CS5029ML", model: "CITI ATL 4G" }, { regex: "(CITI Z530 3G)", model: "$1" }, { regex: "(CITI [A-Z0-9]+ [34]G) C[ST](?:606[32]ML|4024PG|5009PL|5021ML|5026PL)", model: "$1" }, { regex: "TS7854M", model: 'Plane 8.1" 3G', device: "tablet" }, { regex: "PS1043MG", model: 'Plane 10.3" 3G', device: "tablet" }, { regex: "TS1012E 3G", model: 'Plane 10.1" 3G', device: "tablet" }, { regex: "MVM900H(?:WZ|C)", model: "iDx8", device: "tablet" }, { regex: "MVM908HCZ", model: "iDx9", device: "tablet" }, { regex: "(iD(?:xD10|rQ10|xD7)[_ ]3G)", model: "$1", device: "tablet" }, { regex: "(iDx10|iDx7)", model: "$1" }, { regex: "(iDxD[45]|iDxQ5)", model: "$1" }, { regex: "HIT 4G HT7074ML", model: "HIT 4G", device: "tablet" }, { regex: "CITI[_ ](1902 3G|Kids|8527_4G|Octa [178]0|10 E402 4G|8 E400 4G|7 E401 4G)", model: "CITI $1", device: "tablet" }, { regex: "(CITI[ _](?:[A-Z0-9]+)[ _][34]G)[ _][TC][ST](?:106[24]ML|111[46]ML|1115MG|1117PG|1207MG|1210MG|3001ML|500[67]PG|7052PG|706[567]MG|7097MG|720[48]MG|820[69]MG|11[459]4MG|1195MG|1196ML|3001ML|8152ML|1050PL|709[68]PL|7113PL|7193MG|7216MG|8205PG|7203MG|8143MG|7153MG|7141MG|7140ML)", model: "$1", device: "tablet" }, { regex: "iDxD8 3G", model: "D-Plane2 8", device: "tablet" }, { regex: "(iDnD7)", model: "$1", device: "tablet" }, { regex: "NS6902QL", model: "Platina 7.2 4G", device: "tablet" }, { regex: "NS9797MG", model: "Platina 7.2 3G", device: "tablet" }, { regex: "TT1004PG", model: 'Optima 10.4" 3G', device: "tablet" }, { regex: "TT1002MG", model: 'Optima D 10.4" 3G', device: "tablet" }, { regex: "TT7025MG", model: 'Optima 7.5" 3G', device: "tablet" }, { regex: "TT7026MW", model: 'Optima 7.6" 3G', device: "tablet" }, { regex: "TT7020MG", model: 'Optima 7.3" 3G', device: "tablet" }, { regex: "TT7024MG", model: 'Optima 7.4" 3G', device: "tablet" }, { regex: "((?:Optima|Platina|Plane)[ _](?:[EM])?(?:[0-9\\.STNM]+|Prime)(?:[ _][43]G)?)", model: "$1", device: "tablet" }, { regex: "Digma[_ ]([^;/]+) Build", model: "$1", device: "tablet" }] }, Rq = { regex: "DoCoMo|\\;FOMA|KGT/1\\.0", device: "feature phone", models: [{ regex: "DoCoMo/.+MST.+(SH2101V)", model: "$1" }, { regex: "DoCoMo/[12]\\.0[/ ]([a-z0-9]+)", model: "$1" }, { regex: "([a-z0-9]+)(?:_W)?\\;FOMA", model: "$1" }, { regex: "KGT/1\\.0 ([a-z0-9]+)", model: "$1" }] }, Fq = { regex: "DOOGEE[ _-]|Valencia2_Y100_?(?:pro|plus)|Y100_Plus|X5max(?:[_ ]PRO)?|Shoot_[12]|x5_doogee|(KISSME|BIGBOY|COLLO[23]?|DAGGER|DISCOVERY2?|FIND|HOTWIND|LATTE|MAX|MINT|MOON|PIXELS|RAINBOX|TURBO|VALENCIA|VOYAGER2?|TITANS2?)[ -_](DG[0-9]+C?)(?:[);/ ]|$)|(?:BL12000|BL5500[_ ]Lite|X9 Mini|LEO_DG280|Y9Plus|Hitman_DG850|S(?:[568]8|9[056]|59|40)Pro|X95Pro|S40Lite|BL[579]000|N20Pro|(?<!Lenovo )S90C|Ibiza_F2)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:Valencia2_)?Y100_Plus(?:[);/ ]|$)", model: "Valencia2 Y100 Plus" }, { regex: "Valencia2_Y100pro", model: "Valencia2 Y100 Pro" }, { regex: "LEO_(DG280)", model: "Leo $1" }, { regex: "(BL[579]000|S90C)(?:[);/ ]|$)", model: "$1" }, { regex: "X95Pro(?:[);/ ]|$)", model: "X95 Pro" }, { regex: "N20Pro(?:[);/ ]|$)", model: "N20 Pro" }, { regex: "BL12000 PRO", model: "BL12000 Pro" }, { regex: "BL5500[_ ]Lite", model: "BL5500 Lite" }, { regex: "BL12000", model: "BL12000" }, { regex: "S([568]8|9[056]|59|40)Pro", model: "S$1 Pro" }, { regex: "S40Lite", model: "S40 Lite" }, { regex: "KISSME-DG580", model: "Kissme DG580" }, { regex: "Hitman_DG850", model: "Hitman DG580" }, { regex: "X9 Mini", model: "X9 Mini" }, { regex: "x5_doogee", model: "X5" }, { regex: "Shoot_([12])", model: "Shoot $1" }, { regex: "Ibiza_F2", model: "Ibiza F2" }, { regex: "(X5max(?:[_ ]PRO)?)", model: "$1" }, { regex: "(?:DOOGEE[ _-])?(BIGBOY|COLLO[23]?|DAGGER|DISCOVERY2?|FIND|HOTWIND|LATTE|MAX|MINT|MOON|PIXELS|RAINBOX|TURBO|VALENCIA|Valencia2_Y100pro|VOYAGER2?|TITANS2?)[ -_](DG[0-9]+C?)(?:[);/ ]|$)", model: "$1 $2" }, { regex: "DOOGEE[ _-]([^);/]+) Build", model: "$1" }, { regex: "DOOGEE[ _-]([^);/]+)(?:[);/ ]|$)", model: "$1" }, { regex: "Y9Plus(?:[);/ ]|$)", model: "Y9 Plus" }] }, Vq = { regex: "(?:Doov-)?Doov[ _]", device: "smartphone", models: [{ regex: "(?:Doov-)?Doov[ _]([^;/]+) Build", model: "$1" }, { regex: "(?:Doov-)?Doov[ _]([^);/]+)(?:[);/ ]|$)", model: "$1" }] }, Hq = { regex: "Dopod(?: )?([a-z0-9]+)", device: "feature phone", model: "$1" }, Uq = { regex: "Doro", device: "smartphone", models: [{ regex: "Doro[ _-]?([^;/)]+) Build", model: "$1" }, { regex: "Doro[ _-]([0-9a-z]+)", model: "$1" }] }, Xq = { regex: "(?:DNS|AirTab)[ _\\-]([^;/)]+)|(?:S4505M|S4004M|SD01M)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:DNS[_ ])?(S4505M|S4004M|SD01M|S4502|S4003|S4003)(?:[);/ ]|$)", model: "$1" }, { regex: "AirTab[ _\\-]([^;/]+)(?: Build|[);])", model: "AirTab $1", device: "tablet" }, { regex: "DNS[ _\\-]([^;/]+)(?: Build|[);])", model: "$1" }] }, Wq = { regex: "EasyPad|EasyPhone", device: "smartphone", models: [{ regex: "(EasyPhone[^/;]+) Build", model: "$1" }, { regex: "EasyPad ([^/;)]+)(?: Build|[;)])", model: "EasyPad $1", device: "tablet" }] }, Yq = { regex: "EBEST", device: "smartphone", models: [{ regex: "EBEST[ _-]?([^;/)]+) Build", model: "$1" }, { regex: "EBEST[ _-]?([^;/)]+)(?:[);/ ]|$)", model: "$1" }] }, Kq = { regex: "(?:TA10CA3|TM105A?|TR10[CR]S1)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "TA10CA3(?:[);/ ]|$)", model: "TA10CA3" }, { regex: "(TR10[CR]S1)(?:[);/ ]|$)", model: "$1" }, { regex: "TM105A(?:[);/ ]|$)", model: "TM105A" }, { regex: "TM105(?:[);/ ]|$)", model: "TM105" }] }, Qq = { regex: "Hawk_from_EE", device: "smartphone", models: [{ regex: "Hawk_from_EE", model: "Hawk" }] }, jq = { regex: "EK-(?:5040|5336|5540|5937|6020|8680|MII|T7020)", device: "tablet", models: [{ regex: "EK-(MII|T7020)", model: "EK-$1" }, { regex: "EK-(5040|5336|5540|5937|6020|8680)", device: "smartphone", model: "EK-$1" }] }, Zq = { regex: "Elephone|P6000( ?Pro| ?Plus|\\+| ?02| 5.0 01)?", device: "smartphone", models: [{ regex: "Elephone Trunk(?:[);/ ]|$)", model: "Trunk" }, { regex: "P6000(\\+| ?Plus)(?:[);/ ]|$)", model: "P6000 Plus" }, { regex: "P6000 02(?:[);/ ]|$)", model: "P6000 02" }, { regex: "P6000 5.0 01(?:[);/ ]|$)", model: "P6000 01" }, { regex: "P6000 ?Pro(?:[);/ ]|$)", model: "P6000 Pro" }, { regex: "(?:Elephone[ _])?(P[768]000|S2)(?:[);/ ]|$)", model: "$1" }, { regex: "Elephone[ _\\-]([^/;]+)(?: Build|[;)])", model: "$1" }] }, zq = { regex: "AFTRS", model: "Element 4K (2017)", device: "tv" }, qq = { regex: "(TAB(?:101|728)[ _]3G|TAB7(?:[03]8|16|40|3[30]))(?:[);/ ]|$)", device: "tablet", model: "$1" }, Jq = { regex: "Ericy-([a-z0-9]+)", device: "feature phone", model: "$1" }, eJ = { regex: "PH-1[ )]", device: "smartphone", models: [{ regex: "PH-1[ )]", model: "PH-1" }] }, tJ = { regex: "EVERCOSS[ _]|(A75A\\*|U50A_PLUS|M50 STAR|A75 MAX)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "A75A\\*(?:[);/ ]|$)", model: "A75A Star" }, { regex: "A75 MAX*(?:[);/ ]|$)", model: "A75 Max" }, { regex: "U50A_PLUS(?:[);/ ]|$)", model: "U50A Plus" }, { regex: "M50 STAR(?:[);/ ]|$)", model: "M50 Star" }, { regex: "EVERCOSS[ _](A7[BRLZ]|A65|A74A|A5Z)(?:[);/ ]|$)", model: "$1" }] }, rJ = { regex: "(ET7002C-H12|Onyx-[13]S)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Onyx-([13]S)(?:[);/ ]|$)", model: "Onyx $1" }, { regex: "ET7002C-H12(?:[);/ ]|$)", model: "ePad 4S", device: "tablet" }] }, oJ = { regex: "Eton", device: "smartphone", models: [{ regex: "Eton[ _-]?([^;/)]+) Build", model: "$1" }, { regex: "Eton[ _-]?([^;/)]+)(?:[);/ ]|$)", model: "$1" }] }, nJ = { regex: "(?:Wooze[_ ]?(?:I55?|I45|X?L)|HEYOU(?:[135]|30))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "HEYOU([135]|30)(?:[);/ ]|$)", model: "HEYou $1" }, { regex: "Wooze[_ ]?((?:I55?|I45|X?L))(?:[);/ ]|$)", model: "Wooze $1" }] }, aJ = { regex: "PortalTV", device: "tv", model: "Portal TV" }, lJ = { regex: "MK(80[28][^/;]*) Build", device: "tv", model: "MK$1" }, iJ = { regex: "Rinno (R(?:400|505))", device: "smartphone", model: "$1" }, sJ = { regex: "RIVIERA ", device: "smartphone", models: [{ regex: "F23", model: "F23" }] }, dJ = { regex: "SENSEIT[ _]?([^;/)]+)( Build|\\))", device: "smartphone", model: "$1" }, uJ = /* @__PURE__ */ JSON.parse('{"regex":"Sony(?: ?Ericsson)?|SGP|Xperia|(?:[4-9]0[12])SO|C1[569]0[45]|C2[01]0[45]|C230[45]|C530[236]|C550[23]|C6[56]0[236]|C6616|C68(?:0[26]|[34]3)|C69(?:0[236]|16|43)|D200[45]|D21(?:0[45]|14)|D22(?:0[236]|12|43)|D230[2356]|D240[36]|D25(?:02|33)|D510[236]|D530[36]|D5316|D5322|D5503|D58[03]3|D65(?:0[23]|43|63)|D66[03458]3|D66[14]6|D6708|E(?:20[0345]3|2006|210[45]|2115|2124|230[36]|2312|23[356]3|530[36]|53[3456]3|5506|55[356]3|56[46305][36]|58[02]3|65[35]3|66[0358]3|68[358]3)|I[34]312|I4332|F311[12356]|F331[13]|F321[12356]|F5[13]21|F5122|F813[12]|F833[12]|G312[135]|G311[26]|G322[136]|G3212|G331[123]|G3412|G3416|G342[136]|G823[12]|G834[123]|G8[14]4[12]|H(?:3113|3123|3133|3213|3223|3311|3321|4113|4133|4213|4233|4311|4331|4413|4433|82[167]6|83[12]4|8416|9436)|(?:WT|LT|SO|ST|SK|MK)[0-9]+[a-z]+[0-9]*(?: Build|\\\\))|X?L39H|XM50[ht]|W960|portalmmm/2\\\\.0 K|S3[69]h|SOG01|SOL2[2346]|SOV3[1-9]|SOV4[0-3]|X10[ia]v?|E1[05][ai]v?|MT[0-9]{2}[a-z]? Build|SO-0(?:[12]C|[345]D|[234]E|[1-5]F|[1-5]G|[1-4]H|[1-4]J|[1-5]K|1M|[1-3]L)|R800[aix]|J3173|J82[17]0|J9110|J92[16]0|J81[17]0|I[34]113|I3[12]23|I42[19]3|H9493|H8296|H8166|H4493|G2299|LiveWithWalkman|BRAVIA|SGP771|E3 Dual|A001SO|I4193|E6508|SOT31|SO-[45]1A|SO-52A|XQ-A[DT]51|XQ-A[TU]42|XQ-AS[67]2|XQ-A[TSU]52|SOL25|SOG02|A002SO|NW-(A100|Z1000)Series|J3273","device":"smartphone","models":[{"regex":"(?:Sony(?:Ericsson)?)?E10[ai]v?","model":"Xperia X10 mini","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?U20","model":"Xperia X10 mini pro","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?E15[ai]v?","model":"Xperia X8","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?(LT15[ai]?v?|SO-01C)","model":"Xperia arc","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?LT18[ai]v?","model":"Xperia arc S","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?MT11","model":"Xperia neo V","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?MT15","model":"Xperia neo","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?MT27","model":"Xperia Sola","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?MK16[ai]","model":"Xperia pro","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?ST15[ai]","model":"Xperia mini","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?ST17[ai]","model":"Xperia active","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?SO-02L","model":"Xperia Ace","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?ST18[ai]","model":"Xperia ray","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?SK17[ai]?","model":"Xperia mini pro","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?X10[ai]v?","model":"Xperia X10","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)M1","model":"Aspen","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?R800","model":"Xperia PLAY","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?WT19|LiveWithWalkman","model":"Live with Walkman","brand":"Sony Ericsson"},{"regex":"(?:Sony(?:Ericsson)?)?CK13i","model":"txt","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?CK15[ai]","model":"txt pro","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?F100i","model":"Jalou","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?J105","model":"Naite","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?J108","model":"Cedar","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?J10","model":"Elm","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?J20","model":"Hazel","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?U10","model":"Aino","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?U100","model":"Yari","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?U1","model":"Satio","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?U5","model":"Vivaz","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?U8","model":"Vivaz pro","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?W20","model":"Zylo","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?W100","model":"Spiro","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?W150","model":"Yendo","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?W960","model":"W960","brand":"Sony Ericsson","device":"feature phone"},{"regex":"(?:Sony(?:Ericsson)?)?WT13","model":"Mix Walkman","brand":"Sony Ericsson","device":"feature phone"},{"regex":"SO-04F","model":"Xperia A2"},{"regex":"G2299","model":"Xperia R1 Plus"},{"regex":"SO-04G","model":"Xperia A4"},{"regex":"(?:Sony(?:Ericsson)?)?I(?:4113|31[12]3)","model":"Xperia 10"},{"regex":"(?:Sony(?:Ericsson)?)?J3173(?:[);/ ]|$)","model":"Xperia Ace"},{"regex":"(?:A001SO|XQ-A[TU]52|XQ-AU42|SO-41A|SOV43)(?:[);/ ]|$)","model":"Xperia 10 II"},{"regex":"(?:Sony(?:Ericsson)?)?I(?:42[19]3|3223)","model":"Xperia 10 Plus"},{"regex":"(?:Sony(?:Ericsson)?)?I4193","model":"Xperia 10 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:J(?:9110|81[17]0)|SOV40|SO-03L|802SO)","model":"Xperia 1"},{"regex":"(?:Sony(?:Ericsson)?)?(?:SOG01|SO-51A|XQ-AT42|XQ-AT51)(?:[);/ ]|$)","model":"Xperia 1 II"},{"regex":"(?:Sony(?:Ericsson)?)?LT22i|Xperia P","model":"Xperia P"},{"regex":"(?:Sony(?:Ericsson)?)?LT25i|Xperia V","model":"Xperia V"},{"regex":"(?:Sony(?:Ericsson)?)?J92[16]0","model":"Xperia 5 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:J82[17]0|SO-01M|SOV41|901SO)","model":"Xperia 5"},{"regex":"(?:Sony(?:Ericsson)?)?(?:SOG02|A002SO|XQ-AS[567]2|SO-52A)","model":"Xperia 5 II"},{"regex":"(?:Sony(?:Ericsson)?)?(?:SOV42|902SO)","model":"Xperia 8"},{"regex":"(?:Sony(?:Ericsson)?)?J3273","model":"Xperia 8 Lite"},{"regex":"(?:Sony(?:Ericsson)?)?LT26ii","model":"Xperia SL"},{"regex":"(?:Sony(?:Ericsson)?)?LT26i|Xperia S(?:[);/ ]|$)","model":"Xperia S"},{"regex":"(?:Sony(?:Ericsson)?)?SO-02C","model":"Xperia arco"},{"regex":"(?:Sony(?:Ericsson)?)?SO-03D","model":"Xperia arco HD"},{"regex":"(?:Sony(?:Ericsson)?)?LT26w","model":"Xperia arco S"},{"regex":"(?:Sony(?:Ericsson)?)?LT28[aih]","model":"Xperia ion"},{"regex":"(?:Sony(?:Ericsson)?)?LT29i|Xperia TX(?:[);/ ]|$)","model":"Xperia TX"},{"regex":"(?:Sony(?:Ericsson)?)?LT30a","model":"Xperia T LTE"},{"regex":"(?:Sony(?:Ericsson)?)?LT30p","model":"Xperia T"},{"regex":"(?:Sony(?:Ericsson)?)?ST21[ia]2","model":"Xperia tipo dual"},{"regex":"(?:Sony(?:Ericsson)?)?ST21[ia]","model":"Xperia tipo"},{"regex":"(?:Sony(?:Ericsson)?)?ST23[ia]","model":"Xperia miro"},{"regex":"(?:Sony(?:Ericsson)?)?ST25[ia]","model":"Xperia U"},{"regex":"(?:Sony(?:Ericsson)?)?SOL22","model":"Xperia UL"},{"regex":"(?:Sony(?:Ericsson)?)?ST26[ia]","model":"Xperia J"},{"regex":"(?:Sony(?:Ericsson)?)?ST27[ia]","model":"Xperia go"},{"regex":"(?:Sony(?:Ericsson)?)?C150[45]","model":"Xperia E"},{"regex":"(?:Sony(?:Ericsson)?)?C160[45]","model":"Xperia E Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E210[45]|E2115|E2124)","model":"Xperia E4"},{"regex":"(?:Sony(?:Ericsson)?)?E20[05]3|E2006","model":"Xperia E4G"},{"regex":"(?:Sony(?:Ericsson)?)?C190[45]","model":"Xperia M"},{"regex":"(?:Sony(?:Ericsson)?)?C200[45]","model":"Xperia M Dual"},{"regex":"(?:Sony(?:Ericsson)?)?C210[45]|S36h","model":"Xperia L"},{"regex":"(?:Sony(?:Ericsson)?)?C230[45]|S39h","model":"Xperia C"},{"regex":"(?:Sony(?:Ericsson)?)?C530[236]|Xperia SP(?:[);/ ]|$)","model":"Xperia SP"},{"regex":"(?:Sony(?:Ericsson)?)?C550[23]","model":"Xperia ZR"},{"regex":"(?:Sony(?:Ericsson)?)?C650[236]|Xperia ZL(?:[);/ ]|$)","model":"Xperia ZL"},{"regex":"(?:Sony(?:Ericsson)?)?SOL25(?:[);/ ]|$)","model":"Xperia ZL2"},{"regex":"(?:Sony(?:Ericsson)?)?(?:C66(?:0[236]|16)|SO-02E)","model":"Xperia Z"},{"regex":"(?:Sony(?:Ericsson)?)?(?:C68(?:0[26]|[34]3)|XL39H|SOL24)|Xperia Z Ultra(?:[);/ ]|$)","device":"phablet","model":"Xperia Z Ultra"},{"regex":"Xperia Z(?:[);/ ]|$)","model":"Xperia Z"},{"regex":"(?:Sony(?:Ericsson)?)?D200[45]","model":"Xperia E1"},{"regex":"(?:Sony(?:Ericsson)?)?D21(?:0[45]|14)","model":"Xperia E1 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?D22(?:0[236]|43)","model":"Xperia E3"},{"regex":"(?:Sony(?:Ericsson)?)?D2212|E3 Dual","model":"Xperia E3 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?E20[34]3","model":"Xperia E4g Dual"},{"regex":"H33[12]1","model":"Xperia L2"},{"regex":"H43[13]1","model":"Xperia L2 Dual"},{"regex":"I3312","model":"Xperia L3"},{"regex":"I43[13]2","model":"Xperia L3 Dual"},{"regex":"XQ-AD51","model":"Xperia L4"},{"regex":"(?:Sony(?:Ericsson)?)?D2302","model":"Xperia M2 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?D230[356]","model":"Xperia M2"},{"regex":"(?:Sony(?:Ericsson)?)?D240[36]","model":"Xperia M2 Aqua"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E230[36]|E23[35]3)","model":"Xperia M4 Aqua"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E2312|E2363)","model":"Xperia M4 Aqua Dual"},{"regex":"(?:Sony(?:Ericsson)?)?E56[05][36]","model":"Xperia M5"},{"regex":"(?:Sony(?:Ericsson)?)?E56[436]3","model":"Xperia M5 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?D2502","model":"Xperia C3 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?D2533","model":"Xperia C3"},{"regex":"(?:Sony(?:Ericsson)?)?E53[05]3|E5306","model":"Xperia C4"},{"regex":"(?:Sony(?:Ericsson)?)?E53[0346]3","model":"Xperia C4 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?E5506|E5553","model":"Xperia C5 Ultra"},{"regex":"(?:Sony(?:Ericsson)?)?E55[36]3","model":"Xperia C5 Ultra Dual"},{"regex":"(?:Sony(?:Ericsson)?)?D510[236]","model":"Xperia T3"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D530[36]|D5316|XM50[ht])","model":"Xperia T2 Ultra","device":"phablet"},{"regex":"(?:Sony(?:Ericsson)?)?D5322","model":"Xperia T2 Ultra Dual","device":"phablet"},{"regex":"(?:Sony(?:Ericsson)?)?D5503|Xperia Z1 Compact","model":"Xperia Z1 Compact"},{"regex":"(?:Sony(?:Ericsson)?)?(?:C69(?:0[236]|16|43)|SOL23|L39H|SO-0[12]F)|Xperia Z1(?:[);/ ]|$)","model":"Xperia Z1"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D58[03]3|SO-02G)|Xperia Z3 Compact(?:[);/ ]|$)","model":"Xperia Z3 Compact"},{"regex":"Xperia Z2 Tablet Wifi","model":"Xperia Z2 Tablet WiFi","device":"tablet"},{"regex":"SGP561","model":"Xperia Z2 Tablet","device":"tablet"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D65(?:0[23]|43)|SO-03F)|Xperia Z2(?:[);/ ]|$)","model":"Xperia Z2"},{"regex":"D6563","model":"Xperia Z2a"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D66[045]3|D66[14]6|SO-01G|SOL26|401SO)|Xperia Z3(?:[);/ ]|$)","model":"Xperia Z3"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D6633|D6683)","model":"Xperia Z3 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E65[35]3)","model":"Xperia Z3+"},{"regex":"(?:Sony(?:Ericsson)?)?(?:D6708)","model":"Xperia Z3v"},{"regex":"SOV31|402SO|SO-03G","model":"Xperia Z4"},{"regex":"E6508","model":"Xperia Z4v"},{"regex":"SGP771|SOT31|SO-05G","model":"Xperia Z4","device":"tablet"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E58[02]3|SO-02H)","model":"Xperia Z5 Compact"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E66[05]3|SOV32|501SO|SO-01H)","model":"Xperia Z5"},{"regex":"(?:Sony(?:Ericsson)?)?E66[38]3","model":"Xperia Z5 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:E68[58]3|SO-03H)","model":"Xperia Z5 Premium"},{"regex":"(?:Sony(?:Ericsson)?)?E6833","model":"Xperia Z5 Premium Dual"},{"regex":"(?:Sony(?:Ericsson)?)?F311[135]","model":"Xperia XA"},{"regex":"(?:Sony(?:Ericsson)?)?F311[26]","model":"Xperia XA Dual"},{"regex":"(?:Sony(?:Ericsson)?)?F321[135]","model":"Xperia XA Ultra"},{"regex":"(?:Sony(?:Ericsson)?)?F321[26]","model":"Xperia XA Ultra Dual"},{"regex":"(?:Sony(?:Ericsson)?)?F833[12]|SOV34|601SO|SO-01J","model":"Xperia XZ"},{"regex":"(?:Sony(?:Ericsson)?)?(?:701SO|SOV36|G834[123]|SO-01K)","model":"Xperia XZ1"},{"regex":"(?:Sony(?:Ericsson)?)?G8441|SO-02K","model":"Xperia XZ1 Compact"},{"regex":"(?:Sony(?:Ericsson)?)?F331[13]","model":"Xperia E5"},{"regex":"(?:Sony(?:Ericsson)?)?G312[135]|G311[26]","model":"Xperia XA1"},{"regex":"(?:Sony(?:Ericsson)?)?G341[26]|G342[13]","model":"Xperia XA1 Plus"},{"regex":"(?:Sony(?:Ericsson)?)?G3426","model":"Xperia XA1 Plus Dual"},{"regex":"(?:Sony(?:Ericsson)?)?G322[136]|G3212","model":"Xperia XA1 Ultra"},{"regex":"(?:Sony(?:Ericsson)?)?H31[123]3","model":"Xperia XA2"},{"regex":"(?:Sony(?:Ericsson)?)?H41[13]3","model":"Xperia XA2 Dual"},{"regex":"H44[19]3","model":"Xperia XA2 Plus Dual"},{"regex":"H4433","model":"H4433"},{"regex":"(?:Sony(?:Ericsson)?)?H(?:3213|3223|4213|4233)","model":"Xperia XA2 Ultra"},{"regex":"(?:Sony(?:Ericsson)?)?G823[12]|SOV35|602SO|SO-03J","model":"Xperia XZs"},{"regex":"(?:Sony(?:Ericsson)?)?G814[12]|SO-04[JK]","model":"Xperia XZ Premium"},{"regex":"(?:Sony(?:Ericsson)?)?(?:H83[12]4|H82[17]6|SOV37|SO-03K|H8296|702SO)","model":"Xperia XZ2"},{"regex":"H8266","model":"Xperia XZ2 Dual"},{"regex":"SO-05K","model":"Xperia XZ2 Compact"},{"regex":"(?:H8166|SOV38)(?:[);/ ]|$)","model":"Xperia XZ2 Premium Dual"},{"regex":"(?:Sony(?:Ericsson)?)?(?:H(8416|9436|9493)|SO-01L|SOV39|801SO)","model":"Xperia XZ3"},{"regex":"(?:Sony(?:Ericsson)?)?G331[13]","model":"Xperia L1"},{"regex":"(?:Sony(?:Ericsson)?)?G3312","model":"Xperia L1 Dual"},{"regex":"(?:Sony(?:Ericsson)?)?SO-04E","model":"Xperia A"},{"regex":"(?:Sony(?:Ericsson)?)?SO-04D","model":"Xperia GX"},{"regex":"(?:Sony(?:Ericsson)?)?SO-05D","model":"Xperia SX"},{"regex":"(?:Sony(?:Ericsson)?)?F5121","model":"Xperia X"},{"regex":"(?:Sony(?:Ericsson)?)?F5122","model":"Xperia X Dual"},{"regex":"(?:Sony(?:Ericsson)?)?F5321|SO-02J","model":"Xperia X Compact"},{"regex":"(?:Sony(?:Ericsson)?)?(?:F8131|502SO|SOV33|SO-04H)","model":"Xperia X Performance"},{"regex":"(?:Sony(?:Ericsson)?)?F8132","model":"Xperia X Performance Dual"},{"regex":"SGP(?:311|312|321)(?:[);/ ]|$)|SO-03E","model":"Xperia Tablet Z","device":"tablet"},{"regex":"SGP712(?:[);/ ]|$)","model":"Xperia Tablet Z4","device":"tablet"},{"regex":"SGP(?:511|512|521)(?:[);/ ]|$)|SO-05F","model":"Xperia Tablet Z2","device":"tablet"},{"regex":"SGP(?:6[124]1|612)(?:[);/ ]|$)","model":"Xperia Tablet Z3 Compact","device":"tablet"},{"regex":"SGPT(?:12|121|122|123|13|131|132|133)(?:[);/ ]|$)","model":"Xperia Tablet S","device":"tablet"},{"regex":"(?:BRAVIA )(2K GB ATV3|4K UR2|4K GB ATV3|4K GB|4K 2015|2015)(?:[);/ ]|$)","model":"Bravia $1","device":"tv"},{"regex":"NW-A100Series","model":"Walkman A100","device":"portable media player"},{"regex":"NW-Z1000Series","model":"Walkman Z1000","device":"portable media player"},{"regex":"SonyBDP|SonyDBV","model":"Blu-ray Player","device":"tv"},{"regex":"(?:Sony-)?(KDL?-?[0-9a-z]+)","model":"$1","device":"tv"},{"regex":"Opera TV Store.*(?:Sony-)([0-9a-z\\\\-_]+)","model":"$1","device":"tv"},{"regex":"((?:WT|SO|ST|SK|MK)[0-9]+[a-z]*[0-9]*)(?: Build|\\\\))","model":"$1","brand":"Sony Ericsson"},{"regex":"(MT[0-9]{2}[a-z]?)(?:[);/ ]|$)","model":"$1","brand":"Sony Ericsson"},{"regex":"portalmmm/2.0 K([a-z0-9]+)","model":"K$1","brand":"Sony Ericsson"},{"regex":"Sony ?Ericsson?([^/;]*) Build","model":"$1","brand":"Sony Ericsson"},{"regex":"SonyEricsson([CGJKPTWZ][0-9]+[a-z]+)/","model":"$1","brand":"Sony Ericsson","device":"feature phone"},{"regex":"Sony ?Ericsson ?([a-z0-9\\\\-]+)","model":"$1","brand":"Sony Ericsson"},{"regex":"Sony (Tablet[^/;]*) Build","model":"$1","device":"tablet"},{"regex":"(SGP[^/;]*) Build","model":"$1","device":"tablet"},{"regex":"Xperia ([^/;]*Tablet[^/;]*) Build","model":"Xperia $1","device":"tablet"},{"regex":"Xperia ([^;/]+) Build","model":"Xperia $1"},{"regex":"Sony[ -]?([^/;]*) Build","model":"$1"},{"regex":"Sony[ -]?([a-z0-9\\\\-]+)","model":"$1"}]}'), cJ = { regex: "ERGO|(V550[_ ]Vision|B502 Basic|B504[_ ]Unit|A502[_ ]Aurum|A503[ _]Optima|Prime B400|A551 Sky 4G|A553 Power|A555 Universe|Force F500|GoTab GBT9|GoTab Gti8|F501_Magic|V551[ _]Aura|V540_Level|V570_BIG_BEN|B506[_ ]INTRO|A503-Optima|B505_Unit_4G)", device: "smartphone", models: [{ regex: "F501_Magic", model: "F501 Magic" }, { regex: "B502 Basic", model: "B502 Basic" }, { regex: "A503-Optima", model: "A503 Optima" }, { regex: "B506[_ ]INTRO", model: "B506 Intro" }, { regex: "V550[_ ]Vision", model: "V550 Vision" }, { regex: "B504[_ ]Unit", model: "B504 Unit" }, { regex: "B505_Unit_4G", model: "B505 Unit 4G" }, { regex: "V551[ _]Aura", model: "V551 Aura" }, { regex: "V540_Level", model: "V540 Level" }, { regex: "V570_BIG_BEN", model: "V570 Big Ben" }, { regex: "Ergo F502", model: "F502 Platinum" }, { regex: "(ERGO_)?A500[ _]Best", model: "A500 Best" }, { regex: "(ERGO_)?A550[ _]Maxx", model: "A550 Maxx" }, { regex: "Prime B400", model: "Prime B400" }, { regex: "A502[_ ]Aurum", model: "A502 Aurum" }, { regex: "A503[ _]Optima", model: "A503 Optima" }, { regex: "A551 Sky 4G", model: "A551 Sky 4G" }, { regex: "A553 Power", model: "A553 Power" }, { regex: "A555 Universe", model: "A555 Universe" }, { regex: "ERGO[_ ]A556", model: "A556" }, { regex: "ERGO[_ ]F500", model: "F500" }, { regex: "ERGO[_ ]F501", model: "F501" }, { regex: "B500 First", model: "B500 First" }, { regex: "Force F500", model: "Force F500" }, { regex: "GoTab GBT9", model: "GoTab GBT9", device: "tablet" }, { regex: "GoTab Gti8", model: "GoTab GTi8", device: "tablet" }, { regex: "ERGO[_ ]Tab[ _]Crystal[ _]Lite", model: "Tab Crystal Lite", device: "tablet" }, { regex: "ERGO[_ ]Tab[ _]Hero[ _]II", model: "Tab Hero II", device: "tablet" }, { regex: "ERGO[_ ](B700)", model: "Tab $1", device: "tablet" }, { regex: "ERGO SmartBox SX", model: "SmartBox SX", device: "tv" }] }, mJ = { regex: "(?:Ericsson(?:/ )?[a-z0-9]+)|(?:R380 2.0 WAP1.1)", device: "feature phone", models: [{ regex: "Ericsson(?:/ )?([a-z0-9]+)", model: "$1" }, { regex: "R380 2.0 WAP1.1", model: "R380" }] }, gJ = { regex: "PowerMax|ENERGY[_ ]?(?:[45]00|400S|S[56]00|E12|E5[02]0S?)(?:[_ ](?:LTE|EU))?", device: "smartphone", models: [{ regex: "PowerMax(P[0-9]+S?)", model: "Power Max $1" }, { regex: "ENERGY[_ ]([45]00|E520)[_ ]LTE", model: "Energy $1 LTE" }, { regex: "ENERGY[_ ]400S", model: "Energy 400S" }, { regex: "ENERGY400", model: "Energy 400" }, { regex: "ENERGY[_ ]S([56]00)", model: "Energy S$1" }, { regex: "ENERGY[_ ]?(E500S|E500|E12)", model: "Energy $1" }] }, fJ = { regex: "eTouch ?([a-z0-9]+)", device: "smartphone", model: "$1" }, pJ = { regex: "(ETL-S(?:3520|4521|5042|5084|6022)|ETL-T(?:752G|882G|9[78]0))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(ETL-S(?:[^/); ]+))", model: "$1" }, { regex: "(ETL-T(?:[^/); ]+))", device: "tablet", model: "$1" }] }, hJ = { regex: "eZee[^a-z]*Tab ?([^;/]*) Build|STOREX LinkBox", device: "tablet", models: [{ regex: "eZee[^a-z]*Tab ?([^;/]*) Build", model: "eZee'Tab$1" }, { regex: "STOREX LinkBox", model: "LinkBox", device: "tv" }] }, xJ = { regex: "(Ever(?:Glory|Shine|Miracle|Mellow|Classic|Trendy|Fancy|Vivid|Slim|Glow|Magic|Smart|Star)[^/;]*) Build|E70[25]0HD|E805[01]HD|E9054HD|E8050HG|E7914HG", device: "smartphone", models: [{ regex: "(E70[25]0HD|E805[01]HD|E9054HD|E8050HG|E7914HG)", device: "tablet", model: "Everpad $1" }, { regex: "(Ever(?:Glory|Shine|Miracle|Mellow|Classic|Trendy|Fancy|Vivid|Slim|Glow|Magic|Smart|Star)[^/;]*) Build", model: "$1" }] }, vJ = { regex: "Evolio|M4MAGIC", device: "smartphone", models: [{ regex: "M4MAGIC", model: "M4 Magic" }, { regex: "Evolio_M5Pro", model: "M5 Pro" }, { regex: "Evolio[ _](M6|S4 Cobalt|S5|X10|Yuppi)", model: "$1" }] }, SJ = { regex: "EVOLVEO|StrongPhone", device: "smartphone", models: [{ regex: "EVOLVEO MultiMedia Box M4", device: "tv", model: "MultiMedia Box M4" }, { regex: "Smart TV ([^;/]*) Build", device: "tv", model: "Smart TV $1" }, { regex: "EVOLVEO StrongPhone G([248])", model: "StrongPhone G$1" }, { regex: "(?:EVOLVEO[ _])?StrongPhone[ _]?Q([679])(_LTE)?", model: "StrongPhone Q$1$2" }, { regex: "EVOLVEO[ _]([^;/]*) Build", model: "$1" }] }, bJ = { regex: "Explay|[\\w]+-EXPLAY-FIN|ActiveD[ _]|Atlant |Informer[ _][0-9]+|CinemaTV 3G|Surfer[ _][0-9\\.]|sQuad[ _][0-9\\.]|Onliner[1-3]|RioPlay|Leader|Pulsar|Infinityll|Imperium[78]|Indigo|Lagoon", device: "tablet", models: [{ regex: "ActiveD[ _]7.4[ _]3G", model: "ActiveD 7.4 3G" }, { regex: "Imperium([78])(?:[);/ ]|$)", model: "Imperium $1 3G" }, { regex: "ActiveD[ _]8.2[ _]3G", model: "ActiveD 8.2 3G" }, { regex: "CinemaTV[ _]3G", model: "CinemaTV 3G" }, { regex: "Infinityll", model: "Infinity II" }, { regex: "Informer[ _]([0-9]+(?:[ _]3G)?)", model: "Informer $1" }, { regex: "Surfer[ _]([0-9\\.]+(?:[ _]3G)?)", model: "Surfer $1" }, { regex: "sQuad[ _]([0-9\\.]+(?:[ _]3G)?)", model: "sQuad $1" }, { regex: "Onliner([1-3])", model: "Onliner $1" }, { regex: "Atlant(?:[);/ ]|$)", device: "smartphone", model: "Atlant" }, { regex: "Indigo(?:[);/ ]|$)", device: "smartphone", model: "Indigo" }, { regex: "Pulsar(?:[);/ ]|$)", device: "smartphone", model: "Pulsar" }, { regex: "[\\w]+-EXPLAY-FIN", device: "feature phone", model: "Fin" }, { regex: "Lagoon(?:[);/ ]|$)", model: "Lagoon" }, { regex: "Explay[ _-]([^;/]+)(?: Build|[;)])", model: "$1" }, { regex: "RioPlay(?:[);/ ]|$)", device: "smartphone", model: "Rio Play" }, { regex: "Leader", model: "Leader" }] }, yJ = { regex: "EVROMEDIA|Playpad[ _]|PLAY_PAD_PRO_XL", device: "tablet", models: [{ regex: "Playpad 3G GOO", model: "Play Pad 3G Goo" }, { regex: "Play Pad 3G 2Goo", model: "Play Pad 3G 2Goo" }, { regex: "Play Pad PRO", model: "Play Pad Pro" }, { regex: "PLAY_PAD_PRO_XL", model: "Play Pad Pro XL" }, { regex: "PlayPad 3GTab XL", model: "Play Pad 3G Tab XL" }] }, wJ = { regex: "EKO", device: "smartphone", models: [{ regex: "EKO[ _-]?([^;/)]+) Build", model: "$1" }, { regex: "EKO[ _-]?([^;/)]+)(?:[);/ ]|$)", model: "$1" }] }, _J = { regex: "Rock X9+|ROCK_X11", device: "smartphone", models: [{ regex: "Rock X9+", model: "Rock X9+" }, { regex: "ROCK_X11", model: "Rock X11" }] }, TJ = { regex: "EZZE-|EZ(?!Browser)[a-z0-9]+", device: "feature phone", models: [{ regex: "EZZE-([a-z0-9]+)", model: "$1" }, { regex: "EZ([a-z0-9]+)", model: "EZ$1" }] }, AJ = { regex: "EZIO-([a-z0-9]+)", device: "feature phone", model: "$1" }, PJ = { regex: "Amosta ?3G5", device: "smartphone", models: [{ regex: "Amosta ?3G5", model: "Amosta 3G5" }] }, MJ = { regex: "InFocus M[0-9]+[a-z]?", device: "smartphone", models: [{ regex: "InFocus M([0-9]+[a-z]?)", model: "InFocus M$1" }] }, $J = { regex: "Fondi[- _]([^;/)]+)|(T702|Q008B|Q010B|Q718B|Q902|T602B|T707G|T708B|T725B|T725B1|T907B)(?:\\)| Build)", device: "smartphone", models: [{ regex: "(T702|T602B)", model: "$1" }, { regex: "(Q008B|Q010B|Q718B|Q902|T707G|T708B|T725B|T725B1|T907B)", device: "tablet", model: "$1" }, { regex: "Fondi[- _]([^;/)]+)", model: "$1" }] }, CJ = { regex: "(FP(?:1U?|2))(?:[);/ ]|$)", device: "smartphone", model: "$1" }, LJ = { regex: "(FX[123]00)", device: "smartphone", model: "$1" }, EJ = { regex: "ATRIUM II F55L2|TRIO F40LT|CENTRIC S50G|EPIC F50G|Gravity X55L|Orion M50L|ULTRA M50G|M405B|VIRTUE3|F55L Build", device: "smartphone", models: [{ regex: "ATRIUM II F55L2", model: "Atrium II" }, { regex: "(F55L)", model: "$1" }, { regex: "TRIO F40LT", model: "Trio F40LT" }, { regex: "EPIC F50G", model: "Epic F50G" }, { regex: "(Gravity X55L|Orion M50L)", model: "$1" }, { regex: "ULTRA M50G", model: "Prime" }, { regex: "M405B_8GB", model: "Virtue II 8GB" }, { regex: "M405B", model: "Virtue II" }, { regex: "VIRTUE3", model: "Virtue III" }, { regex: "CENTRIC S50G", model: "Centric S50G" }] }, OJ = { regex: "ConeXis (A[12]|X[12])|SP5045V", device: "smartphone", models: [{ regex: "SP5045V", model: "SP5045V" }, { regex: "ConeXis A1", model: "ConeXis A1" }, { regex: "ConeXis A2", model: "ConeXis A2" }, { regex: "ConeXis X1", model: "ConeXis X1" }, { regex: "ConeXis X2", model: "ConeXis X2" }] }, NJ = { regex: "(?:F-01[FHJKLM]|F-02[EFGHLK]|F-03[DEFGKHL]|F-04[EGFHKJ]|F-05[DEFJG]|F-06[EF]|F-07[DE]|F-08D|F-09[DE]|F-10D|F-[45]1A|F-[45]2A|F-11D|F-12C|M532|FARTM933KZ|901FJ|arrows(?:RX|M03|M0[45](?:-PREMIUM)?)|801FJ|FJL2[12])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "F-51A(?:[);/ ]|$)", model: "Arrows 5G F-51A" }, { regex: "F-01F(?:[);/ ]|$)", model: "Arrows NX F-01F" }, { regex: "(F-01[LM]|F-06F|F-03K|F-42A)(?:[);/ ]|$)", model: "Easy Phone $1" }, { regex: "F-03L(?:[);/ ]|$)", model: "Arrows Phone F-03L" }, { regex: "F-01J(?:[);/ ]|$)", model: "Arrows NX F-01J" }, { regex: "F-01K(?:[);/ ]|$)", model: "Arrows NX F-01K" }, { regex: "F-01H(?:[);/ ]|$)", model: "Arrows Fit F-01H" }, { regex: "F-02E(?:[);/ ]|$)", model: "Arrows X F-02E" }, { regex: "F-02G(?:[);/ ]|$)", model: "Arrows NX F-02G" }, { regex: "FJL21(?:[);/ ]|$)", model: "Arrows EF FJL21" }, { regex: "FJL22(?:[);/ ]|$)", model: "Arrows Z FJL22" }, { regex: "F-02H(?:[);/ ]|$)", model: "Arrows NX F-02H" }, { regex: "F-52A(?:[);/ ]|$)", model: "Arrows NX9 F-52A" }, { regex: "F-03D(?:[);/ ]|$)", model: "Arrows Kiss F-03D" }, { regex: "F-03E(?:[);/ ]|$)", model: "Arrows Kiss F-03E" }, { regex: "F-03F(?:[);/ ]|$)", model: "Disney Mobile F-03F" }, { regex: "F-03H(?:[);/ ]|$)", model: "Arrows SV F-03H" }, { regex: "901FJ(?:[);/ ]|$)", model: "Arrows J 901FJ" }, { regex: "F-04E(?:[);/ ]|$)", model: "Arrows V F-04E" }, { regex: "F-04G(?:[);/ ]|$)", model: "Arrows NX F-04G" }, { regex: "F-05D(?:[);/ ]|$)", model: "Arrows X LTE F-05D" }, { regex: "F-05F(?:[);/ ]|$)", model: "Arrows NX F-05F" }, { regex: "F-05J(?:[);/ ]|$)", model: "Arrows Be F-05J" }, { regex: "F-05G(?:[);/ ]|$)", model: "Arrows K-tai" }, { regex: "F-04K(?:[);/ ]|$)", model: "Arrows Be F-04K" }, { regex: "F-02L(?:[);/ ]|$)", model: "Arrows Be 3 F-02L" }, { regex: "F-41A(?:[);/ ]|$)", model: "Arrows Be 4 F-41A" }, { regex: "F-06E(?:[);/ ]|$)", model: "Arrows NX F-06E" }, { regex: "F-07D(?:[);/ ]|$)", model: "Arrows μ F-07D" }, { regex: "801FJ(?:[);/ ]|$)", model: "Arrows U 801FJ" }, { regex: "F-07E(?:[);/ ]|$)", model: "Disney Mobile F-07E" }, { regex: "F-08D(?:[);/ ]|$)", model: "Disney Mobile F-08D" }, { regex: "F-09D(?:[);/ ]|$)", model: "ANTEPRIMA F-09D" }, { regex: "F-09E(?:[);/ ]|$)", model: "Raku-Raku Smartphone Premium F-09E" }, { regex: "F-10D(?:[);/ ]|$)", model: "Arrows X F-10D" }, { regex: "F-11D(?:[);/ ]|$)", model: "Arrows Me F-11D" }, { regex: "F-12C(?:[);/ ]|$)", model: "F-12C" }, { regex: "(F-04[JF])(?:[);/ ]|$)", model: "$1" }, { regex: "arrowsM03(?:[);/ ]|$)", model: "Arrows M03" }, { regex: "arrowsRX(?:[);/ ]|$)", model: "Arrows RX" }, { regex: "arrowsM04-PREMIUM(?:[);/ ]|$)", model: "Arrows M04 Premium" }, { regex: "arrowsM(0[45])(?:[);/ ]|$)", model: "Arrows M$1" }, { regex: "(F-0[32]F|F-03G|F-04H|F-05E|F-02K)(?:[);/ ]|$)", model: "Arrows Tab $1", device: "tablet" }, { regex: "FARTM933KZ", model: "Arrows Tab M504/HA4", device: "tablet" }, { regex: "M532(?:[);/ ]|$)", model: "Stylistic", device: "tablet" }] }, DJ = { regex: "(GEM[0-9]+[a-z]*)", device: "tablet", model: "$1" }, kJ = { regex: "GEOTEL[ _]?", device: "smartphone", models: [{ regex: "G1", model: "G1" }, { regex: "GEOTEL[ _]?Note", model: "Note" }, { regex: "GEOTEL[ _]AMIGO", model: "Amigo" }] }, GJ = { regex: "GHIA|QS702|VECTOR10\\.1", device: "smartphone", models: [{ regex: "QS702", model: "QS702" }, { regex: "GHIA_ZEUS_3G", model: "Zeus 3G" }, { regex: "GHIA_AXIS7", model: "Axis 7", device: "tablet" }, { regex: "VECTOR10\\.1", model: 'Vector 10.1"', device: "tablet" }] }, BJ = { regex: "GSmart[ _][a-z0-9 ]+(?: Build|\\))|Gigabyte-[a-z0-9]+|Simba SX1|GSmart_Classic_Lite|(?<!Eagle )Classic[_ ](?:Joy|Pro)", device: "smartphone", models: [{ regex: "(GSmart[ _][a-z0-9 ]+)(?: Build|[);])", model: "$1" }, { regex: "Gigabyte-([a-z0-9]+)", model: "$1" }, { regex: "(Classic[ _](?:Joy|Pro)|GSmart_Classic_Lite)", model: "$1" }, { regex: "Simba SX1", model: "GSmart Simba SX1" }] }, IJ = { regex: "Gigaset|(?: GS80|GS1[0189]0|GS1[89]5|GS2[89]0|GS5[357]-6|GS[23]70(?:_Plus)?)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Gigaset QV(1030|830)", model: "Gigaset QV$1", device: "tablet" }, { regex: "G(S[23]70)[_ ]Plus(?:[);/ ]|$)", model: "G$1 Plus" }, { regex: "GS([23]70|1[0189]0|1[89]5|2[89]0|80)(?:[);/ ]|$)", model: "GS$1" }, { regex: "GS57-6", model: "ME Pro" }, { regex: "GS55-6", model: "ME" }, { regex: "GS53-6", model: "ME Pure" }, { regex: "Gigaset ([^;/]+) Build", model: "$1" }, { regex: "Gigaset ([^;/)]+)(?:[);/]|$)", model: "$1" }] }, RJ = { regex: "GINZZU[_ ]|((?:RS(?:7[14]|81|9[67])D)|S5002|(?<!Wave Pro )S5021|S5230|S50[45]0|S5120|RS(6[12]|9[45])D|S40[23]0|RS850[12]|RS9602)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "GINZZU[_ ]?(S40[17]0|S4710|ST60[14]0|ST6120)", model: "$1" }, { regex: "GINZZU[_ ]?(GT-(?:1050|7105|70[1-4]0|7115|7210|[WX]831|X[78]70|7810|8[01]10|X853))", model: "$1", device: "tablet" }, { regex: "(RS6[12]D) ULTIMATE", model: "$1 Ultimate" }, { regex: "(?:GINZZU[ _])?((?:RS(?:7[14]|81|9[4-7])D)|S50[45]0|S5002|S5021|S5230|S5120|S40[23]0|RS850[12]|RS9602|RS94D)(?:[);/ ]|$)", model: "$1" }] }, FJ = { regex: "(?:GIO-)?GIONEE[ _-]?[a-z0-9]+|(?:Dream_D1|V188S?|GN[0-9]{3,4}[a-z]?)(?:[);/ ]|$)|F103(?: Pro)?(?: Build|\\))|P5 mini Build|P7 Max Build|(M7 Power|F106L|F100A|F103S|F103 Pro)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "GN810(?:[);/ ]|$)", model: "GN810", device: "phablet" }, { regex: "GN([0-9]{3,4}[a-z]?)(?:[);/ ]|$)", model: "GN$1" }, { regex: "(F106L|F100A|V188S|V188|F103S)(?:[);/ ]|$)", model: "$1" }, { regex: "M7 Power(?:[);/ ]|$)", model: "M7 Power" }, { regex: "P5 mini Build", model: "P5 mini" }, { regex: "P7 Max Build", model: "P7 Max" }, { regex: "(S11) Lite(?:[);/ ]|$)", model: "$1 Lite" }, { regex: "F103( Pro)?( BUILD|\\))", model: "F103$1" }, { regex: "(?:(?:GIO-)?GIONEE[ _-])?Dream_D1(?:[);/ ]|$)", model: "Dream D1" }, { regex: "(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+).*Android", model: "$1" }, { regex: "Android.*(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+)", model: "$1" }, { regex: "(?:GIO-)?GIONEE[ _-]?([a-z0-9]+)", model: "$1", device: "feature phone" }] }, VJ = { regex: "(?:Grape[ _])?GTM-5([^;/]+) Build", device: "smartphone", model: "GTM-5$1" }, HJ = { regex: "Vizio|VAP430|VTAB1008", device: "tv", models: [{ regex: "VAP430", model: "VAP430" }, { regex: "VTAB1008", device: "tablet", model: "VTAB1008" }] }, UJ = { regex: "GOCLEVER|QUANTUM_[0-9]{3}|QUANTUM [0-9]{1}|QUANTUM 700N|Quantum2 500|QUANTUM_(1010N|1010M|900)|ARIES|INSIGNIA|ORION_|ELIPSO|LIBRA[ _]97", device: "smartphone", models: [{ regex: "QUANTUM_(1010N|1010M|900)", model: "QUANTUM $1", device: "tablet" }, { regex: "INSIGNIA_(785_PRO|1010M|800M)", model: "INSIGNIA $1", device: "tablet" }, { regex: "(ORION|ARIES|ELIPSO)[_ ](71|101|102)", model: "$1 $2", device: "tablet" }, { regex: "TQ700N", model: "QUANTUM 700N", device: "tablet" }, { regex: "Quantum2 500", model: "Quantum 2 500" }, { regex: "((?:QUANTUM|ARIES|INSIGNIA|ORION|ELIPSO)[ _-]?[^;/]+)(?: Build|\\))", model: "$1" }, { regex: "GOCLEVER[ _-]TAB[ _-]?([^;/]+) Build", model: "TAB $1", device: "tablet" }, { regex: "GOCLEVER[ _-]?([^;/]+) Build", model: "$1" }, { regex: "TAB ([^;/)]+) Build/GOCLEVER", model: "TAB $1", device: "tablet" }, { regex: "([^;/)]+) Build/GOCLEVER", model: "$1" }, { regex: "GOCLEVER[ _-]?TAB[ _-]([^;/)]+)(?:[;/)]|$)", model: "TAB $1", device: "tablet" }, { regex: "GOCLEVER[ _-]?([^;/)]+)(?:[;/)]|$)", model: "$1" }, { regex: "LIBRA[ _]97", model: "Libra 97", device: "tablet" }] }, XJ = { regex: "GO Onyx|GO[0-9]{3,4}", device: "smartphone", models: [{ regex: "GO Onyx", model: "Go Onyx" }, { regex: "GO([0-9]{3,4})", model: "Go$1" }] }, WJ = { regex: "Goly[ _-]", device: "smartphone", models: [{ regex: "Goly[ _-]([^;/]+) Build", model: "$1" }, { regex: "Goly[ _-]([^;/)]+)(?:[;/)]|$)", model: "$1" }] }, YJ = { regex: "Nexus|GoogleTV|Glass(?<!Browser)|CrKey[^a-z0-9]|Pixel(?: Build|\\))|Pixel (?:XL|C|[2-5]|[2-4] XL)|Google 2XL|G011A", device: "smartphone", models: [{ regex: "Glass", model: "Glass" }, { regex: "Galaxy Nexus", model: "Galaxy Nexus" }, { regex: "(Nexus (?:S|4|5X?|One))", model: "$1" }, { regex: "(Nexus (?:6P?))", device: "phablet", model: "$1" }, { regex: "(Nexus (?:7|9|10))", device: "tablet", model: "$1" }, { regex: "CrKey[^a-z0-9]", model: "Chromecast", device: "tv" }, { regex: "GoogleTV", device: "tv", model: "GoogleTV" }, { regex: "Pixel(?: Build|\\))", model: "Pixel" }, { regex: "Pixel XL", model: "Pixel XL" }, { regex: "Pixel 3 XL", model: "Pixel 3 XL" }, { regex: "Pixel 2 XL", model: "Pixel 2 XL" }, { regex: "Pixel 3a XL", model: "Pixel 3a XL" }, { regex: "Pixel 3a", model: "Pixel 3a" }, { regex: "Pixel 4 XL", model: "Pixel 4 XL" }, { regex: "Pixel 4a \\(5G\\)", model: "Pixel 4a (5G)" }, { regex: "pixel 4a", model: "Pixel 4a" }, { regex: "G011A", model: "Pixel 2" }, { regex: "Google 2XL", model: "Pixel 2 XL" }, { regex: "pixel ([2-5])", model: "Pixel $1" }, { regex: "Pixel C", device: "tablet", model: "Pixel C" }] }, KJ = { regex: "GRADIENTE", device: "feature phone", models: [{ regex: "GRADIENTE-([a-z0-9]+)", model: "$1" }, { regex: "GRADIENTE ([a-z0-9\\-]+)", model: "$1" }] }, QJ = { regex: "GR?-TB[0-9]+[a-z]*|GRUNDIG|portalmmm/2\\.0 G|AFTEU(?:011|014|FF014)", device: "tv", models: [{ regex: "(GR?-TB[0-9]+[a-z]*)", device: "tablet", model: "$1" }, { regex: "GRUNDIG ([a-z0-9]+)", model: "$1" }, { regex: "portalmmm/2\\.0 G([a-z0-9]+)", model: "G$1" }, { regex: "AFTEU014", model: "Vision 7 4K (2019)" }, { regex: "AFTEUFF014", model: "OLED 4K (2019)" }, { regex: "AFTEU011", model: "Vision 6 HD (2019)" }] }, jJ = { regex: "HAFURY", device: "smartphone", models: [{ regex: "(MIX|UMAX)", model: "$1" }] }, ZJ = { regex: "Haier|I6_Infinity|Titan[ _]T[135]|(?:HW-)?W(?:71[67]|757|860|970)(?:[);/ ]|$)|S5 Silk|(?:HM-)?(N505|N700|G(?:152|303|353|552|70[01])?-FL|HM-N501-FL|G(?:303)?-W|I(?:557)?-FL)|(?:PAD[ _](?:D71|G781|d85))|A2_Lite_NFC", device: "smartphone", models: [{ regex: "A2_Lite_NFC", model: "Alpha A2 Lite NFC" }, { regex: "HM-N505-FL", model: "I8" }, { regex: "S5 Silk", model: "S5 Silk" }, { regex: "HM-N700-FL", model: "L7" }, { regex: "HM-N501-FL", model: "L56" }, { regex: "(?:HM-)?(G(?:152|353|552|70[01])|G(?:303)|I(?:557))", model: "$1" }, { regex: "(Titan[_ ]T[135]|I6_Infinity)", model: "$1" }, { regex: "(?:HW-)?W(71[67]|757|860|970)(?:[);/ ]|$)", model: "W$1" }, { regex: "PAD[ -_](D71|G781|d85)", device: "tablet", model: "$1" }, { regex: "Haier[ _\\-](H[WT]-[^/;]+) Build", model: "$1" }, { regex: "Haier[ _\\-](H[WT]-[a-z0-9_\\-]+)", model: "$1" }, { regex: "Haier[ _\\-](sy[0-9]+)", model: "$1" }, { regex: "Haier[ _\\-]([a-z0-9\\-]+)", model: "$1", device: "feature phone" }] }, zJ = { regex: "(HSG[0-9]{4})|SN97T41W|SN1AT71W\\(B\\)|SN70T51A|SN70T31?|T7-QC", device: "tablet", models: [{ regex: "(HSG[0-9]{4})", model: "$1" }, { regex: "SN1AT71W\\(B\\)", model: "SN1AT71W(B)" }, { regex: "SN70T31", model: "SN70T31" }, { regex: "SN70T3", model: "SN70T3" }, { regex: "SN70T51A", model: "SN70T51A" }, { regex: "SN97T41W", model: "SN97T41W" }, { regex: "T7-QC", model: "SNAT71BUE" }] }, qJ = { regex: "Hasee", device: "smartphone", models: [{ regex: "Hasee ([^;/]+) Build", model: "$1" }, { regex: "Hasee ([^;/)]+)(?:[);/ ]|$)", model: "$1" }] }, JJ = { regex: "(?:HS-)?Hisense ([^;/]+) Build|Hisense [^);/]+|HISENSE; |HS-(?:G|U|EG?|I|L|T|X)[0-9]+[a-z0-9\\-]*|E270BSA|HWCD100E|HITV300C|M470BS[AE]|EG98|E2281|EG680|I46D1G|HAT4KDTV|HLTE([237]00T|200M|203T|202N|21[023567]T|22[67]T|22[13]E|230E|310[TM]|31[16]T|500T|501N|510[TM]|7[23]0T)", device: "smartphone", models: [{ regex: "E270BSA", device: "tablet", model: "Sero 7" }, { regex: "M470BS[AE]", device: "tablet", model: "Sero 7 Pro" }, { regex: "E2281", device: "tablet", model: "Sero 8" }, { regex: "HLTE202N", model: "A5" }, { regex: "HLTE203T", model: "A5 Pro CC" }, { regex: "HLTE700T", model: "A6" }, { regex: "HLTE730T", model: "A6L" }, { regex: "HLTE221E", model: "E Max" }, { regex: "HLTE501N", model: "V Plus" }, { regex: "HLTE223E", model: "H30" }, { regex: "I46D1G", model: "Smartfren Andromax R" }, { regex: "EG680", model: "Smartfren Andromax Z" }, { regex: "EG98", model: "Smartfren Andromax U2" }, { regex: "HLTE200T(?:[);/ ]|$)", model: "F26" }, { regex: "HLTE210T(?:[);/ ]|$)", model: "F28" }, { regex: "HLTE215T(?:[);/ ]|$)", model: "F29" }, { regex: "HLTE213T(?:[);/ ]|$)", model: "King Kong 4" }, { regex: "HLTE311T(?:[);/ ]|$)", model: "King Kong 4 Pro" }, { regex: "HLTE216T(?:[);/ ]|$)", model: "King Kong 5" }, { regex: "HLTE316T(?:[);/ ]|$)", model: "King Kong 5 Pro" }, { regex: "HLTE226T(?:[);/ ]|$)", model: "King Kong 6" }, { regex: "HLTE217T(?:[);/ ]|$)", model: "F30S" }, { regex: "HLTE227T(?:[);/ ]|$)", model: "F40" }, { regex: "HLTE310[TM](?:[);/ ]|$)", model: "H18" }, { regex: "HLTE510[TM](?:[);/ ]|$)", model: "H20" }, { regex: "HLTE500T(?:[);/ ]|$)", model: "H11" }, { regex: "HLTE230E(?:[);/ ]|$)", model: "H40 Lite" }, { regex: "HLTE720T(?:[);/ ]|$)", model: "U30", device: "phablet" }, { regex: "HWCD100E(?:[);/ ]|$)", model: "U40 Lite" }, { regex: "(HLTE300T|HLTE200M|HLTE212T)(?:[);/ ]|$)", model: "$1" }, { regex: "HITV300C(?:[);/ ]|$)", model: "E9" }, { regex: "E260T\\+(?:[);/ ]|$)", model: "Nana" }, { regex: "(HS-(?:G|U|EG?|I|L|T|X)[0-9]+[a-z0-9\\-]*)", model: "$1" }, { regex: "(HAT4KDTV)(?:[);/ ]|$)", device: "tv", model: "$1" }, { regex: "(?:HS-)?Hisense ([^;/]+) Build", model: "$1" }, { regex: "Hisense ([^);/]+)", model: "$1" }] }, eee = { regex: "(HOFFMANN|Neo[_ ]A[1379]00)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Neo[_ ](A[1379]00)", model: "Neo $1" }, { regex: "HOFFMANN[ _]X[-_ ](Prime|Twist|Max)", model: "X $1" }] }, tee = { regex: "Homtom|(?:HT[0-9]{1,2})(?: ?Pro)?(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:Homtom[_ ])?HT ?([0-9]{1,2}(?: ?Pro)?)(?:[);/ ]|$)", model: "HT$1" }, { regex: "Homtom ([^;/]+) Build", model: "$1" }] }, ree = { regex: "HOSIN[ _-]", device: "smartphone", models: [{ regex: "HOSIN[ _-]([^;/]+) Build", model: "$1" }, { regex: "HOSIN[ _-]([^;/]+)(?:[;/)]|$)", model: "$1" }] }, oee = { regex: "(?:HOOZO[_ ](MT232|MT116|MT Pad 116 LTE|X1001)|HZ0010)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "HOOZO[_ ](MT232|MT116|MT Pad 116 LTE|X1001)(?:[);/ ]|$)", model: "$1" }, { regex: "(HZ0010)(?:[);/ ]|$)", model: "$1" }] }, nee = { regex: "NEO-(?:X8-H|U9-H|X[57]-mini|X8H-PLUS|X88-?I|X7-216A|X5-116A|X[68]|U1|Z64)(?:[);/ ]|$)", device: "tv", models: [{ regex: "NEO-X8-H(?:[);/ ]|$)", model: "NEO X8H" }, { regex: "NEO-X([57])-mini(?:[);/ ]|$)", model: "NEO X$1 Mini" }, { regex: "NEO-X8H-PLUS(?:[);/ ]|$)", model: "NEO X8H Plus" }, { regex: "NEO-X88-?I(?:[);/ ]|$)", model: "NEO X88i" }, { regex: "NEO-X7-216A(?:[);/ ]|$)", model: "NEO X7" }, { regex: "NEO-X5-116A(?:[);/ ]|$)", model: "NEO X5" }, { regex: "NEO-X([68])(?:[);/ ]|$)", model: "NEO X$1" }, { regex: "NEO-U1(?:[);/ ]|$)", model: "NEO U1" }, { regex: "NEO-Z64(?:[);/ ]|$)", model: "NEO Z64" }, { regex: "NEO-U9-H(?:[);/ ]|$)", model: "NEO U9H" }] }, aee = /* @__PURE__ */ JSON.parse('{"regex":"(HW-)?(?:Huawei|MediaPad T1|Ideos|Honor[ _]?|(?:(?:AGS|AGS2|ALE|ALP|AMN|ANA|ANE|ARE|ARS|ASK|ATH|ATU|AUM|BAC|BAH[23]?|BG2|BGO|B[ZK]K|BKL|BL[ALN]|BND|BTV|CA[GMNZ]|CH[CM]|CHE[12]?|CLT|CMR|COL|COR|CPN|CRO|CRR|CUN|DIG|DLI|DRA|DUA|DUB|DUK|EDI|ELE|EML|EVA|EVR|FDR|FIG|FLA|FRD|FRL|GEM|GRA|HDN|HLK|HMA|Hol|HRY|HWI|H[36]0|INE|JAT|JEF|JDN|JDN2|JKM|JMM|JSN|KII|KIW|KNT|KOB|KSA|LDN|LEO|LIO|LLD|LND|LON|LRA|LUA|LY[AO]|MAR|MHA|MRD|MYA|NCE|NEM|NEO|NXT|PAR|PCT|PIC|PLE|PLK|POT|PPA|PRA|RIO|RNE|RVL|SCC|SCL|SCM|SEA|SHT|SLA|SNE|SPN|STF|STK|TAG|TIT|TNY|TRT|VCE|VEN|VIE|VKY|VNS|VOG|VRD|VTR|WAS|YAL|G(?:527|620S|621|630|735)|Y(?:221|330|550|6[23]5))-(?:[A-Z]{0,2}[0-9]{1,4}[A-Z]{0,3}?)|H1711|U(?:8230|8500|8661|8665|8667|8800|8818|8860|9200|9508))(?:[);/ ]|$))|hi6210sft|PE-(UL00|TL[12]0|TL00M)|T1-(A21[Lw]|A23L|701u|823L)|G7-(?:L01|TL00)|HW-01K|JNY-(LX[12]|AL10)|OXF-AN[01]0|TAS-(A[LN]00|L29|TL00)|WLZ-(AL10|AN00)|NIC-LX1A|MRX-(AL09|W09)|CDY-(?:[AT]N00|AN90|NX9A)|GLK-(?:[AT]L00|LX1U)|JER-[AT]N10|ELS-(?:[AT]N[10]0|NX9|N39|N04)|AKA-(AL10|L29)|MON-(W|AL)19|BMH-AN[12]0|AQM-([AT]L[01]0|LX1)|MOA-(AL[02]0|LX9N)|NTS-AL00|ART-(?:[AT]L00[xm]|L29N?|L28)|MED-(?:[AT]L00|LX9N?)|EBG-(?:AN[01]0|TN00)|ANA-(?:[AT]N00|NX9)|BZ[AK]-W00|BZT-(W09|AL[01]0)|HDL-(AL09|W09)|HWV3[123]|HW-02L|TEL-[AT]N(?:00a?|10)|KKG-AN00|MXW-AN00|JKM-AL00[ab]|TAH-(?:N29|AN00)m|C8817D|T1-821W|d-01[JK]|d-02[HK]|KRJ-W09|HWT31|Y320-U10|Y541-U02|VAT-L19|70[14]HW|60[58]HW|NOH-(?:NX9|AN00)|TNNH-AN00|LIO-(?:[TA]L00|[LN]29|AN00)|KOB2-[LW]09|AGS3-[WL]09|DNN-LX9|NEY-NX9|LON-AL00|HLK-L41|503HW|AGR-[LW]09|PPA-LX[12]|ANG-AN00|NOP-AN00","device":"smartphone","models":[{"regex":"POT-[TA]L00a(?:[);/ ]|$)","model":"9S"},{"regex":"U9500(?:[);/ ]|$)","model":"Ascend D1"},{"regex":"Z100-UL00(?:[);/ ]|$)","model":"Ascend D3"},{"regex":"Y320-(?:U10|T00|U05)(?:[);/ ]|$)","model":"Ascend Y320"},{"regex":"Y330-U05(?:[);/ ]|$)","model":"Ascend Y330"},{"regex":"Y541-U02(?:[);/ ]|$)","model":"Ascend Y5C"},{"regex":"U8818(?:[);/ ]|$)","model":"Ascend G300"},{"regex":"G527-U081(?:[);/ ]|$)","model":"Ascend G527"},{"regex":"(G620S-L0[13]|C8817D)(?:[);/ ]|$)","model":"Ascend G620S"},{"regex":"G630-U251(?:[);/ ]|$)","model":"Ascend G630"},{"regex":"G7-(?:L01|TL00)(?:[);/ ]|$)","model":"Ascend G7"},{"regex":"P7-L10(?:[);/ ]|$)","model":"Ascend P7"},{"regex":"G730-C00(?:[);/ ]|$)","model":"Ascend G730"},{"regex":"U9200(?:[);/ ]|$)","model":"Ascend P1"},{"regex":"H1711(?:[);/ ]|$)","model":"Ascend XT2"},{"regex":"Y221-U(?:[12]2|[0345]3)(?:[);/ ]|$)","model":"Ascend Y221"},{"regex":"Y550-L03(?:[);/ ]|$)","model":"Ascend Y550"},{"regex":"ART-[AT]L00[xm](?:[);/ ]|$)","model":"Enjoy 10"},{"regex":"STK-[AT]L00(?:[);/ ]|$)","model":"Enjoy 10 Plus"},{"regex":"MED-[AT]L00(?:[);/ ]|$)","model":"Enjoy 10E"},{"regex":"AQM-[AT]L00(?:[);/ ]|$)","model":"Enjoy 10S"},{"regex":"TAG-[ACT]L00(?:[);/ ]|$)","model":"Enjoy 5S"},{"regex":"NCE-(AL[10]0|TL10)(?:[);/ ]|$)","model":"Enjoy 6"},{"regex":"DIG-(?:TL10|AL00)(?:[);/ ]|$)","model":"Enjoy 6S"},{"regex":"SLA-(?:AL00|TL10)(?:[);/ ]|$)","model":"Enjoy 7"},{"regex":"FIG-(?:[AT]L[10]0)(?:[);/ ]|$)","model":"Enjoy 7S"},{"regex":"(?:TRT-AL00[A]?|TRT-TL10A)(?:[);/ ]|$)","model":"Enjoy 7 Plus"},{"regex":"LDN-(?:AL[12]0|TL[02]0)(?:[);/ ]|$)","model":"Enjoy 8"},{"regex":"FLA-AL10(?:[);/ ]|$)","model":"Enjoy 8 Plus"},{"regex":"ATU-[AT]L10(?:[);/ ]|$)","model":"Enjoy 8e"},{"regex":"MRD-[TA]L00(?:[);/ ]|$)","model":"Enjoy 9e"},{"regex":"DVC-TN20(?:[);/ ]|$)","model":"Enjoy 20 Pro"},{"regex":"U8665(?:[);/ ]|$)","model":"Fusion 2"},{"regex":"MED-LX9N?(?:[);/ ]|$)","model":"Y6p"},{"regex":"G735-L(?:03|12|23)(?:[);/ ]|$)","model":"G Play"},{"regex":"CHC-U(?:0[13]|23)(?:[);/ ]|$)","model":"G Play Mini"},{"regex":"(?:Honor_|HW-)?G621-TL00M?(?:[);/ ]|$)","model":"G621"},{"regex":"DIG-L2[12](?:[);/ ]|$)","model":"GR3 (2017)"},{"regex":"KII-L21(?:[);/ ]|$)","model":"GR5"},{"regex":"BLL-L2[12](?:[);/ ]|$)","model":"GR5 (2017)"},{"regex":"RIO-L03(?:[);/ ]|$)","model":"GX8"},{"regex":"U8860(?:[);/ ]|$)","model":"Honor"},{"regex":"COL-(?:AL[01]0|TL[01]0|L29)(?:[);/ ]|$)","model":"Honor 10"},{"regex":"HRY-(?:[AT]L00[A]?|LX[12]|LX1MEB)(?:[);/ ]|$)","model":"Honor 10 Lite"},{"regex":"HRY-LX1T(?:[);/ ]|$)","model":"Honor 10I"},{"regex":"U9508(?:[);/ ]|$)","model":"Honor 2"},{"regex":"YAL-(?:L21|[AT]L00)(?:[);/ ]|$)","model":"Honor 20"},{"regex":"LRA-AL00(?:[);/ ]|$)","model":"Honor 20 Lite"},{"regex":"(HRY-AL00T[a]?)(?:[);/ ]|$)","model":"Honor 20I"},{"regex":"YAL-(L41|AL10)(?:[);/ ]|$)","model":"Honor 20 Pro"},{"regex":"(MAR-LX1H|YAL-AL50)(?:[);/ ]|$)","model":"Honor 20S"},{"regex":"(?:BMH-AN[12]0|MXW-AN00)(?:[);/ ]|$)","model":"Honor 30"},{"regex":"EBG-[AT]N00(?:[);/ ]|$)","model":"Honor 30 Pro"},{"regex":"EBG-AN10(?:[);/ ]|$)","model":"Honor 30 Pro Plus"},{"regex":"CDY-(?:AN90|NX9A)(?:[);/ ]|$)","model":"Honor 30S"},{"regex":"LRA-LX1(?:[);/ ]|$)","model":"Honor 30I"},{"regex":"(?:Honor_|HW-)?H30-(?:C00|L01M?|L02|U10|T00|T10)(?:_TD)?(?:[);/ ]|$)","model":"Honor 3C"},{"regex":"Hol-U19(?:[);/ ]|$)","model":"Honor 3C Lite"},{"regex":"G750-T01(?:[);/ ]|$)","model":"Honor 3X"},{"regex":"(?:Honor_|HW-)?SCL-(?:AL00|CL00|TL00H?)(?:_TD)?(?:[);/ ]|$)","model":"Honor 4A"},{"regex":"(?:Honor_|HW-)?CHM-U01(?:_TD)?(?:[);/ ]|$)","model":"Honor 4C"},{"regex":"Honor 4c Pro(?:[);/ ]|$)","model":"Honor 4C Pro"},{"regex":"AQM-AL10(?:[);/ ]|$)","model":"Honor 4T Pro"},{"regex":"(CHE2?-[UT]L00[HM]?|CHE1-CL[12]0|CHE2-L(?:1[12]|23)|Che1-L04|CHE-TL00)(?:[);/ ]|$)","model":"Honor 4X"},{"regex":"(?:Honor_|HW-)?CUN-[AT]L00(?:[);/ ]|$)","model":"Honor 5 Play"},{"regex":"(?:Honor_|HW-)?CAM-(?:AL00|TL00H|TL00)(?:_TD)?(?:[);/ ]|$)","model":"Honor 5A"},{"regex":"(?:Honor_|HW-)?NEM-(?:AL10|L51|UL10|TL00)(?:[);/ ]|$)","model":"Honor 5C"},{"regex":"(?:Honor_|HW-)?NEM-(?:L22|TL00H)(?:[);/ ]|$)","model":"Honor 5C Dual SIM"},{"regex":"(?:Honor_|HW-)?KIW-(?:AL10|TL00H|[TC]L00|L2[1-4]|UL00)(?:_TD)?(?:[);/ ]|$)","model":"Honor 5X"},{"regex":"((?:Honor_|HW-)?H60-L(?:01|02|03|04|11|12)(?:_TD)?|HW-H60-J1)(?:[);/ ]|$)","model":"Honor 6"},{"regex":"MYA-TL10(?:[);/ ]|$)","model":"Honor 6 Play"},{"regex":"PE-(UL00|TL[12]0|TL00M)(?:[);/ ]|$)","model":"Honor 6 Plus"},{"regex":"(?:HONOR[ _]?)?DLI-(?:AL10|L[24]2|TL20)(?:[);/ ]|$)","model":"Honor 6A"},{"regex":"DIG-L21HN(?:[);/ ]|$)","model":"Honor 6C"},{"regex":"JMM-L22(?:[);/ ]|$)","model":"Honor 6C Pro"},{"regex":"(?:HONOR[ _]?)?BLN-(?:L2[124]|AL[1234]0|TL[01]0(?:[);/ ]|$))","model":"Honor 6X"},{"regex":"(?:Honor[_]?|HW-)?PLK-(?:AL10|CL00|TL00|TL01H?|UL00|L01)(?:[);/ ]|$)","model":"Honor 7"},{"regex":"(?:Honor_|HW-)?NEM-L21(?:[);/ ]|$)","model":"Honor 7 Lite"},{"regex":"AUM-(?:AL[20]0|L33[A]?|TL20)(?:[);/ ]|$)","model":"Honor 7A"},{"regex":"AUM-L29(?:[);/ ]|$)","model":"Honor 7A Pro"},{"regex":"(?:Honor_|HW-)?(?:LND-(?:AL[34]0|L29|TL40)|AUM-L41)(?:[);/ ]|$)","model":"Honor 7C"},{"regex":"ATH-(?:[CAU]L00|TL00H)(?:[);/ ]|$)","model":"Honor 7i"},{"regex":"(?:Honor_|HW-)?DUA-(?:L22|LX3)(?:[);/ ]|$)","model":"Honor 7S"},{"regex":"(?:HONOR[ _]?)?BND-(?:AL[01]0|TL10|L2[14]|L31)(?:[);/ ]|$)","model":"Honor 7X"},{"regex":"(?:FRD-(?:AL[01]0|L0[249]|L1[49]|DL00)|VAT-L19)(?:[);/ ]|$)","model":"Honor 8"},{"regex":"PRA-(?:AL00X|AL00|TL10)(?:[);/ ]|$)","model":"Honor 8 Lite"},{"regex":"DUK-(?:L09|TL30)(?:[);/ ]|$)","model":"Honor 8 Pro"},{"regex":"VEN-L22(?:[);/ ]|$)","model":"Honor 8 Smart"},{"regex":"JAT-L(29|X[13])(?:[);/ ]|$)","model":"Honor 8A"},{"regex":"JAT-L41(?:[);/ ]|$)","model":"Honor 8A Pro"},{"regex":"BKK-(?:AL[10]0|L21|L22|LX2|TL00)(?:[);/ ]|$)","model":"Honor 8C"},{"regex":"KSA-(LX[239]|AL00)(?:[);/ ]|$)","model":"Honor 8S"},{"regex":"JSN-L(?:2[123]|42)|JSN-[TA]L00[a]?(?:[);/ ]|$)","model":"Honor 8X"},{"regex":"ARE-(?:AL[10]0|L22(?:HN)?|TL00)(?:[);/ ]|$)","model":"Honor 8X Max"},{"regex":"STF-(?:AL[10]0|L09S?|TL10)(?:[);/ ]|$)","model":"Honor 9"},{"regex":"MOA-LX9N(?:[);/ ]|$)","model":"Honor 9A"},{"regex":"AKA-L29(?:[);/ ]|$)","model":"Honor 9C"},{"regex":"LLD-(?:AL[01]0|L[23]1|TL10)(?:[);/ ]|$)","model":"Honor 9 Lite"},{"regex":"LLD-AL[23]0(?:[);/ ]|$)","model":"Honor 9i"},{"regex":"DUA-LX9(?:[);/ ]|$)","model":"Honor 9S"},{"regex":"HLK-AL00a?(?:[);/ ]|$)","model":"Honor 9X"},{"regex":"HLK-(?:AL10|L4[12])(?:[);/ ]|$)","model":"Honor 9X Pro"},{"regex":"CAM-UL00(?:[);/ ]|$)","model":"Honor Holly 3"},{"regex":"NTS-AL00(?:[);/ ]|$)","model":"Honor Magic"},{"regex":"TNY-[AT]L00(?:[);/ ]|$)","model":"Honor Magic 2"},{"regex":"RVL-AL09(?:[);/ ]|$)","model":"Honor Note 10"},{"regex":"EDI-AL10(?:[);/ ]|$)","model":"Honor Note 8"},{"regex":"VKY-TL00(?:[);/ ]|$)","model":"Honor P10 Plus"},{"regex":"VOG-AL00(?:[);/ ]|$)","model":"Honor P30 Pro"},{"regex":"ANA-(?:[AT]N00|NX9)(?:[);/ ]|$)","model":"Honor P40"},{"regex":"COR-(?:AL[01]0|L29|TL10)(?:[);/ ]|$)","model":"Honor Play"},{"regex":"ASK-AL00x(?:[);/ ]|$)","model":"Honor Play 3"},{"regex":"KSA-AL10(?:[);/ ]|$)","model":"Honor Play 3E"},{"regex":"TNNH-AN00(?:[);/ ]|$)","model":"Honor Play 4"},{"regex":"CHM-[CUT]L00[HM]?(?:[);/ ]|$)","model":"Honor Play 4C"},{"regex":"AKA-AL10(?:[);/ ]|$)","model":"Honor Play 4T"},{"regex":"DUA-[TA]L00(?:[);/ ]|$)","model":"Honor Play 7"},{"regex":"JAT-[AT]L00(?:[);/ ]|$)","model":"Honor Play 8A"},{"regex":"MOA-AL[02]0(?:[);/ ]|$)","model":"Honor Play 9A"},{"regex":"BKL-(?:AL00|AL20|AL30|L09|TL10)(?:[);/ ]|$)","model":"Honor V10"},{"regex":"PCT-[TA]L10(?:[);/ ]|$)","model":"Honor V20"},{"regex":"KNT-(?:AL[12]0|[TU]L10)(?:[);/ ]|$)","model":"Honor V8"},{"regex":"DUK-AL20(?:[);/ ]|$)","model":"Honor V9"},{"regex":"JMM-[AT]L[01]0(?:[);/ ]|$)","model":"Honor V9 Play"},{"regex":"BKL-L04(?:[);/ ]|$)","model":"Honor View 10"},{"regex":"PCT-L29(?:[);/ ]|$)","model":"Honor View 20"},{"regex":"OXF-AN00(?:[);/ ]|$)","model":"Honor View 30"},{"regex":"OXF-AN10(?:[);/ ]|$)","model":"Honor View 30 Pro"},{"regex":"(?:Honor_|HW-)?SCL-L(01|32)(?:_TD)?(?:[);/ ]|$)","model":"Honor Y6"},{"regex":"(?:Honor_|HW-)?LYO-L21(?:[);/ ]|$)","model":"Honor Y6 II Compact"},{"regex":"TEL-(?:AN(?:00a?|10)|TN00)(?:[);/ ]|$)","model":"Honor X10"},{"regex":"KKG-AN00(?:[);/ ]|$)","model":"Honor X10 Max"},{"regex":"DNN-LX9(?:[);/ ]|$)","model":"Honor X10 Lite"},{"regex":"U8500(?:[);/ ]|$)","model":"Ideos X2"},{"regex":"U8510(?:[);/ ]|$)","model":"Ideos X3"},{"regex":"U8800(?:[);/ ]|$)","model":"Ideos X5"},{"regex":"MLA-AL10(?:[);/ ]|$)","model":"Maimang 5"},{"regex":"POT-AL10(?:[);/ ]|$)","model":"Maimang 8"},{"regex":"TAH-(?:N29|AN00)m(?:[);/ ]|$)","model":"Mate XS"},{"regex":"ALP-(?:[TA]L00|L[02]9)(?:[);/ ]|$)","model":"Mate 10"},{"regex":"RNE-(?:AL00|L(?:01|03|21|23))(?:[);/ ]|$)","model":"Mate 10 Lite"},{"regex":"BLA-(?:A09|L[02]9|[TA]L00)(?:[);/ ]|$)","model":"Mate 10 Pro"},{"regex":"HMA-(?:[AT]L00|L[02]9)(?:[);/ ]|$)","model":"Mate 20"},{"regex":"SNE-(?:AL00|LX[0-3])(?:[);/ ]|$)","model":"Mate 20 Lite"},{"regex":"LYA-(?:AL[01]0|L[02]9|L0C|TL00)(?:[);/ ]|$)","model":"Mate 20 Pro"},{"regex":"LYA-AL00P(?:[);/ ]|$)","model":"Mate 20 RS"},{"regex":"EVR-(?:[TA]L00|L29|N29|AN00)(?:[);/ ]|$)","model":"Mate 20 X"},{"regex":"TAS-([AT]L00|L29)(?:[);/ ]|$)","model":"Mate 30"},{"regex":"TAS-AN00(?:[);/ ]|$)","model":"Mate 30 5G"},{"regex":"SPN-AL00(?:[);/ ]|$)","model":"Mate 30 Lite"},{"regex":"LIO-(?:[TA]L00|L29|AN00)(?:[);/ ]|$)","model":"Mate 30 Pro"},{"regex":"LIO-N29(?:[);/ ]|$)","model":"Mate 30 Pro 5G"},{"regex":"NOH-(?:NX9|AN00)(?:[);/ ]|$)","model":"Mate 40 Pro"},{"regex":"NOP-AN00(?:[);/ ]|$)","model":"Mate 40 Pro+"},{"regex":"NXT-(?:AL10|L29)(?:[);/ ]|$)","model":"Mate 8"},{"regex":"MHA-(?:L[02]9|[AT]L00)(?:[);/ ]|$)","model":"Mate 9"},{"regex":"BLL-L23(?:[);/ ]|$)","model":"Mate 9 Lite"},{"regex":"LON-(?:AL00(?:-PD)?|L29)(?:[);/ ]|$)","model":"Mate 9 Pro"},{"regex":"NEO-AL00(?:[);/ ]|$)","model":"Mate RS"},{"regex":"NEO-L29(?:[);/ ]|$)","model":"Mate RS Porsche Design"},{"regex":"CRR-(?:L09|UL00)(?:[);/ ]|$)","model":"Mate S"},{"regex":"BND-L34(?:[);/ ]|$)","model":"Mate SE"},{"regex":"(CAZ-(?:AL[01]0|TL[12]0)|CAN-L[01][1-3])(?:[);/ ]|$)","model":"Nova"},{"regex":"608HW(?:[);/ ]|$)","model":"Nova Lite"},{"regex":"(?:PIC-(?:[AT]L00|LX9)|HWV31)(?:[);/ ]|$)","model":"Nova 2"},{"regex":"704HW(?:[);/ ]|$)","model":"Nova 2 Lite"},{"regex":"BAC-(?:L01|TL00)(?:[);/ ]|$)","model":"Nova 2 Plus"},{"regex":"BAC-(?:AL00|L2[12])(?:[);/ ]|$)","model":"Nova 2 Plus Dual SIM"},{"regex":"RNE-L[02]2(?:[);/ ]|$)","model":"Nova 2I"},{"regex":"HWI-[AT]L00(?:[);/ ]|$)","model":"Nova 2S"},{"regex":"PAR-(?:[AT]L00|LX[19]|LX1M|TL20)(?:[);/ ]|$)","model":"Nova 3"},{"regex":"ANE-AL00(?:[);/ ]|$)","model":"Nova 3e"},{"regex":"INE-(?:AL00|LX[12]r|LX[12]|TL00)(?:[);/ ]|$)","model":"Nova 3i"},{"regex":"VCE-(L22|[AT]L00)(?:[);/ ]|$)","model":"Nova 4"},{"regex":"MAR-AL00(?:[);/ ]|$)","model":"Nova 4e"},{"regex":"SEA-AL00(?:[);/ ]|$)","model":"Nova 5"},{"regex":"SEA-AL10(?:[);/ ]|$)","model":"Nova 5 Pro"},{"regex":"GLK-(?:[AT]L00|LX1U)(?:[);/ ]|$)","model":"Nova 5i"},{"regex":"SPN-TL00(?:[);/ ]|$)","model":"Nova 5i Pro"},{"regex":"WLZ-AL10(?:[);/ ]|$)","model":"Nova 6"},{"regex":"WLZ-AN00(?:[);/ ]|$)","model":"Nova 6 5G"},{"regex":"JNY-AL10(?:[);/ ]|$)","model":"Nova 6 SE"},{"regex":"JEF-(?:[AT]N00|AN20|NX9)(?:[);/ ]|$)","model":"Nova 7 5G"},{"regex":"JER-[AT]N10(?:[);/ ]|$)","model":"Nova 7 Pro 5G"},{"regex":"CDY-(?:[AT]N00|NX9B)(?:[);/ ]|$)","model":"Nova 7 SE 5G"},{"regex":"JNY-LX2(?:[);/ ]|$)","model":"Nova 7i"},{"regex":"ANG-AN00(?:[);/ ]|$)","model":"Nova 8 5G"},{"regex":"DIG-L01(?:[);/ ]|$)","model":"Nova Smart"},{"regex":"WAS-AL00(?:[);/ ]|$)","model":"Nova Youth"},{"regex":"FIG-L(?:A1|X[123])(?:[);/ ]|$)","model":"P smart"},{"regex":"POT-(?:LX(?:[13]|1T|2J|1AF)|AL00)(?:[);/ ]|$)","model":"P smart (2019)"},{"regex":"POT-LX1A(?:[);/ ]|$)","model":"P smart (2020)"},{"regex":"PPA-LX[12](?:[);/ ]|$)","model":"P smart (2021)"},{"regex":"STK-LX1(?:[);/ ]|$)","model":"P smart Z"},{"regex":"VTR-(?:L[02]9|AL00|TL00)(?:[);/ ]|$)","model":"P10"},{"regex":"WAS-(?:L(?:X1|X1A|X2|X2J|X3|03T)|TL10)(?:[);/ ]|$)","model":"P10 Lite"},{"regex":"VKY-(?:AL00|L09|L29)(?:[);/ ]|$)","model":"P10 Plus"},{"regex":"BAC-L[02]3(?:[);/ ]|$)","model":"P10 Selfie"},{"regex":"EML-(?:[TA]L00|L[02]9)(?:[);/ ]|$)","model":"P20"},{"regex":"(?:ANE-(?:LX[123]|LX2J|TL00)|HWV32)(?:[);/ ]|$)","model":"P20 Lite"},{"regex":"(?:CLT-(?:AL0[01]|TL0[01]|L(?:04|[02]9))|HW-01K)(?:[);/ ]|$)","model":"P20 Pro"},{"regex":"(ELE-L(?:04|09|29)|ELE-[AT]L00)(?:[);/ ]|$)","model":"P30"},{"regex":"(?:MAR-(?:LX(?:1[BM]|2J?|3BM)|TL00)|NIC-LX1A|HWV33)(?:[);/ ]|$)","model":"P30 Lite"},{"regex":"MAR-LX[13]Am?(?:[);/ ]|$)","model":"P30 Lite Dual SIM"},{"regex":"(?:VOG-(?:L(?:04|09|29)|TL00|AL10)|HW-02L)(?:[);/ ]|$)","model":"P30 Pro"},{"regex":"ANA-LX4(?:[);/ ]|$)","model":"P40"},{"regex":"JNY-LX1(?:[);/ ]|$)","model":"P40 Lite"},{"regex":"ART-L29(?:[);/ ]|$)","model":"P40 Lite E"},{"regex":"ART-L29N(?:[);/ ]|$)","model":"P40 Lite E NFC"},{"regex":"(?:ELS-(?:[AT]N00|NX9|N04)|NEY-NX9)(?:[);/ ]|$)","model":"P40 Pro"},{"regex":"ELS-(?:AN10|N39)(?:[);/ ]|$)","model":"P40 Pro Plus"},{"regex":"GRA-(?:L09|UL00)(?:[);/ ]|$)","model":"P8"},{"regex":"(?:ALE-L(?:02|21|23)|ALE-UL00|ALE-TL00|503HW)(?:[);/ ]|$)","model":"P8 Lite (2015)"},{"regex":"(?:PRA-L(?:A1|X2|X1|X3)|hi6210sft)(?:[);/ ]|$)","model":"P8 Lite (2017)"},{"regex":"EVA-(?:AL[10]0|L[012]9|[TCD]L00)(?:[);/ ]|$)","model":"P9"},{"regex":"VNS-L(?:[23]1|[26]2)(?:[);/ ]|$)","model":"P9 Lite"},{"regex":"SLA-L(?:02|03|22|23)(?:[);/ ]|$)","model":"P9 Lite Mini"},{"regex":"DIG-L(?:03|23)(?:[);/ ]|$)","model":"P9 Lite Smart"},{"regex":"VIE-(?:AL10|L[02]9)(?:[);/ ]|$)","model":"P9 Plus"},{"regex":"ATH-UL0[16](?:[);/ ]|$)","model":"ShotX"},{"regex":"U(8230|8661|8667)(?:[);/ ]|$)","model":"U$1"},{"regex":"ARS-([AT]L00|L22)(?:[);/ ]|$)","model":"Y Max"},{"regex":"CRO-(?:L[02]2|U00)(?:[);/ ]|$)","model":"Y3 (2017)"},{"regex":"CAG-L[02]2(?:[);/ ]|$)","model":"Y3 (2018)"},{"regex":"LUA-(U22|L2[12]|U03)(?:[);/ ]|$)","model":"Y3II"},{"regex":"MYA-(?:L(?:02|03|2[23])|U29)(?:[);/ ]|$)","model":"Y5 (2017)"},{"regex":"DRA-L(?:01|03|21|23|X3)(?:[);/ ]|$)","model":"Y5 (2018)"},{"regex":"AMN-LX[1239](?:[);/ ]|$)","model":"Y5 (2019)"},{"regex":"DRA-LX5(?:[);/ ]|$)","model":"Y5 lite"},{"regex":"DRA-LX9(?:[);/ ]|$)","model":"Y5p"},{"regex":"CRO-L[02]3(?:[);/ ]|$)","model":"Y5 Lite (2017)"},{"regex":"CAG-L[02]3(?:[);/ ]|$)","model":"Y5 Lite (2018)"},{"regex":"DRA-(?:LX2|[AT]L00)(?:[);/ ]|$)","model":"Y5 Prime (2018)"},{"regex":"MYA-L13(?:[);/ ]|$)","model":"Y5 Pro (2017)"},{"regex":"CUN-(?:L(?:0[123]|2[123]|33)|U29)(?:[);/ ]|$)","model":"Y5II"},{"regex":"(?:SCC-U21|SCL-U31)(?:[);/ ]|$)","model":"Y6"},{"regex":"MYA-L11(?:[);/ ]|$)","model":"Y6 (2016)"},{"regex":"MYA-(L41|AL10)(?:[);/ ]|$)","model":"Y6 (2017)"},{"regex":"ATU-L(?:11|21|22|X3)(?:[);/ ]|$)","model":"Y6 (2018)"},{"regex":"MRD-L(?:X1[NF]?|X3)(?:[);/ ]|$)","model":"Y6 (2019)"},{"regex":"ATU-L(?:31|42)(?:[);/ ]|$)","model":"Y6 Prime (2018)"},{"regex":"TIT-(?:AL00|L01|U02)(?:[);/ ]|$)","model":"Y6 Pro"},{"regex":"MRD-LX2(?:[);/ ]|$)","model":"Y6 Pro (2019)"},{"regex":"Y625-U03(?:[);/ ]|$)","model":"Y625"},{"regex":"Y635-L0[123](?:[);/ ]|$)","model":"Y635"},{"regex":"Y635-L21(?:[);/ ]|$)","model":"Y635 Dual SIM"},{"regex":"CAM-L(?:03|21|23|32)(?:[);/ ]|$)","model":"Y6II"},{"regex":"TRT-LX[123](?:[);/ ]|$)","model":"Y7 (2017)"},{"regex":"LDN-L(?:01|X3)(?:[);/ ]|$)","model":"Y7 (2018)"},{"regex":"(?:HUAWEI[ _]?)?DUB-(?:LX[13]|TL00)(?:[);/ ]|$)","model":"Y7 (2019)"},{"regex":"(LDN-(?:AL00|L21)|TRT-TL10)(?:[);/ ]|$)","model":"Y7 Prime"},{"regex":"(LDN-(?:LX2|TL10)|TRT-(?:L21A|L53))(?:[);/ ]|$)","model":"Y7 Prime (2018)"},{"regex":"DUB-(?:LX2|AL00)(?:[);/ ]|$)","model":"Y7 Pro (2019)"},{"regex":"DUB-AL00a(?:[);/ ]|$)","model":"Enjoy 9"},{"regex":"DUB-AL20(?:[);/ ]|$)","model":"Y7 Pro (2019)"},{"regex":"PPA-LX3(?:[);/ ]|$)","model":"Y7a"},{"regex":"ART-L28(?:[);/ ]|$)","model":"Y7p"},{"regex":"AQM-LX1(?:[);/ ]|$)","model":"Y8p"},{"regex":"FLA-(LX[123]|AL20|TL10)(?:[);/ ]|$)","model":"Y9 (2018)"},{"regex":"JKM-(?:[TA]L00[ab]?|LX[123])(?:[);/ ]|$)","model":"Y9 (2019)"},{"regex":"STK-(L2[12]|LX3)(?:[);/ ]|$)","model":"Y9 Prime (2019)"},{"regex":"FRL-L2[23](?:[);/ ]|$)","model":"Y9a"},{"regex":"HWT31(?:[);/ ]|$)","model":"Qua Tab 02 10.1\\"","device":"tablet"},{"regex":"HDN-[LW]09(?:[);/ ]|$)","model":"Honor Water Play 10.1","device":"tablet"},{"regex":"BAH3-(?:AL00|[LW]09)(?:[);/ ]|$)","model":"MatePad 10.4\\"","device":"tablet"},{"regex":"BAH3-W59(?:[);/ ]|$)","model":"MatePad 10.4\\" WiFi","device":"tablet"},{"regex":"AGS3-[WL]09(?:[);/ ]|$)","model":"MatePad T10s","device":"tablet"},{"regex":"HDL-(?:W09|AL09)(?:[);/ ]|$)","model":"Honor Water Play 8.0","device":"tablet"},{"regex":"JDN-(?:AL00|W09)(?:[);/ ]|$)","model":"Honor Pad 2","device":"tablet"},{"regex":"KRJ-W09(?:[);/ ]|$)","model":"Honor Pad V6","device":"tablet"},{"regex":"MON-(W|AL)19(?:[);/ ]|$)","device":"tablet","model":"MatePad C5 8"},{"regex":"BZA-W00(?:[);/ ]|$)","device":"tablet","model":"C3 9.6"},{"regex":"M2-801L(?:[);/ ]|$)","device":"tablet","model":"MediaPad M2 8.0\\""},{"regex":"MRX-(AL09|W09)(?:[);/ ]|$)","device":"tablet","model":"MatePad Pro"},{"regex":"CMR-(?:AL[01]9|W09)(?:[);/ ]|$)","device":"tablet","model":"MediaPad M5 10.8"},{"regex":"CMR-W19(?:[);/ ]|$)","device":"tablet","model":"MediaPad M5 Pro 10.8"},{"regex":"SCM-AL09(?:[);/ ]|$)","device":"tablet","model":"MediaPad M5 Pro"},{"regex":"GEM-70[1-3]L(?:[);/ ]|$)","device":"tablet","model":"MediaPad X2"},{"regex":"(?:JDN2-(:?[WL]09|AL[50]0)|BAH2-(?:AL[01]0|L09|W[01]9))(?:[);/ ]|$)","device":"tablet","model":"MediaPad M5 Lite"},{"regex":"SHT-(?:AL|W)09(?:[);/ ]|$)","device":"tablet","model":"MediaPad M5 8.4"},{"regex":"VRD-(?:(AL|W)09|AL10|W10)(?:[);/ ]|$)","device":"tablet","model":"MediaPad M6 8.4"},{"regex":"SCM-W09(?:[);/ ]|$)","device":"tablet","model":"MediaPad M6 10"},{"regex":"BTV-W09(?:[);/ ]|$)","device":"tablet","model":"MediaPad M3 8"},{"regex":"(BAH-W09|CPN-(?:L|W)09|CPN-AL00|701HW)(?:[);/ ]|$)","device":"tablet","model":"MediaPad M3 Lite"},{"regex":"BAH-(?:L09|AL00)(?:[);/ ]|$)","device":"tablet","model":"MediaPad M3 Lite 10"},{"regex":"BTV-DL09","device":"tablet","model":"MediaPad M3"},{"regex":"(AGS2-AL00|JDN2-W09)HN(?:[);/ ]|$)","device":"tablet","model":"Honor Tab 5"},{"regex":"AGS2-(?:[LW]09|W19|L03)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T5 10"},{"regex":"KOB2-[LW]09(?:[);/ ]|$)","device":"tablet","model":"MediaPad T 8.0\\""},{"regex":"AGR-[LW]09(?:[);/ ]|$)","device":"tablet","model":"MediaPad T 10"},{"regex":"AGS-(?:L0[39]|W09)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T3 10"},{"regex":"(KOB-(?:L|W)09|BZK-[LW]00)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T3 8"},{"regex":"BG2-(?:U0[13]|W09)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T3 7"},{"regex":"BGO-L03(?:[);/ ]|$)","device":"tablet","model":"MediaPad T2 7.0"},{"regex":"(?:BGO-DL09|PLE-70[13]L)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T2 7.0 Pro"},{"regex":"JDN-L01(?:[);/ ]|$)","device":"tablet","model":"MediaPad T2 8.0 Pro"},{"regex":"(?:FDR-(A01[LW]|A03L)|605HW)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T2 10.0\\" Pro"},{"regex":"T1-(?:A21[LW]|A23L)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T1 10"},{"regex":"T1-701u(?:[);/ ]|$)","device":"tablet","model":"MediaPad T1 7"},{"regex":"(?:T1-82(?:3L|1W)|MediaPad T1 8.0)(?:[);/ ]|$)","device":"tablet","model":"MediaPad T1 8"},{"regex":"AGS2-AL00(?:[);/ ]|$)","device":"tablet","model":"Enjoy Tablet 10.1"},{"regex":"BZT-(W09|AL[01]0)(?:[);/ ]|$)","device":"tablet","model":"MediaPad C5 10.1"},{"regex":"(?:d-01J|d-02[HK])(?:[);/ ]|$)","device":"tablet","model":"D Tab Compact"},{"regex":"(d-01K)(?:[);/ ]|$)","device":"tablet","model":"dtab d-01K"},{"regex":"LEO-BX9(?:[);/ ]|$)","device":"wearable","model":"Smart Watch 2"},{"regex":"(MediaPad[^/;]*) Build","device":"tablet","model":"$1"},{"regex":"Ideos([^;/]*) Build","model":"Ideos$1"},{"regex":"(?:HUAWEI )?MT([0-9]+)","device":"phablet","model":"Ascend Mate $1"},{"regex":"Huawei[ _\\\\-]?([^/;]*) Build","model":"$1"},{"regex":"(?:HW-)?Huawei(?!Browser)(?:/1\\\\.0/0?(?:Huawei))?[_\\\\- /]?([a-z0-9\\\\-_]+)","model":"$1"},{"regex":"Huawei; ([a-z0-9 \\\\-]+)","model":"$1"}]}'), lee = { regex: "Hyundai|Ultra (?:Active|Air|Charm|Dream|Energy|Latitude|Link|Live|Shadow|Shine|Storm|Style|Sync|Trend|Vision|Wave)|G(24027|2552[34])K|W25042L|HP554O|Seoul S8|L503F Plus|HT0701L16|HT0704K08|HT1004L16|HT1004LI16|Koral_8W2|Eternity[_ ]G25", device: "smartphone", models: [{ regex: "Ultra (Active|Air|Charm|Dream|Energy Lite|Energy Plus|Energy|Latitude|Link|Live II|Live|Shadow|Shine|Storm|Style|Sync|Trend|Vision|Wave)", model: "Ultra $1" }, { regex: "Seoul S8", model: "Seoul S8" }, { regex: "G25523K", model: "Eternity G23" }, { regex: "Eternity[_ ]G25", model: "Eternity G25" }, { regex: "G25524K", model: "Eternity G24" }, { regex: "G24027K", model: "Eternity G27" }, { regex: "W25042L", model: "Eternity W42" }, { regex: "HP554O", model: "HP554O" }, { regex: "L503F Plus", model: "L503F Plus" }, { regex: "L503F Plus", model: "L503F Plus" }, { regex: "(?:Hyundai_)?(Eternity_G57L)", model: "$1" }, { regex: "HT0701L16", model: "Koral 7XL", device: "tablet" }, { regex: "HT1004LI16", model: "Koral 10XL", device: "tablet" }, { regex: "Koral_8W2", model: "Koral 8W2", device: "tablet" }, { regex: "HT1004L16", model: "Koral 10XL", device: "tablet" }, { regex: "HT0704K08", model: "Koral 7M4", device: "tablet" }, { regex: "Hyundai ([^;/]+) Build", model: "$1", device: "tablet" }, { regex: "Hyundai[ _\\-]?([a-z0-9_-]+)", model: "$1", device: "tablet" }] }, iee = { regex: "iBall[ _]([^;/)]+)[ _]Build|iBall_Slide|(?:Snap[_ ]4G2|6351-Q400i|iT-KSA0003|iT-KSA0012|iT-KSA0066|Avid|Twinkle_i5|Gorgeo[_ ]4GL|Brisk 4G2|Blaze_V4|Wondro 10|Q27 4G|Andi (?:Wink|5G Blink) 4G)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "Andi Wink 4G", device: "smartphone", model: "Andi Wink 4G" }, { regex: "Andi 5G Blink 4G", device: "smartphone", model: "Andi 5G Blink 4G" }, { regex: "(Snap[_ ]4G2|Avid|Twinkle_i5|Gorgeo[_ ]4GL|Blaze_V4|Wondro 10|Q27 4G|Brisk 4G2)(?:[);/ ]|$)", model: "$1" }, { regex: "6351-Q400i(?:[);/ ]|$)", model: "Slide" }, { regex: "iT-KSA0003(?:[);/ ]|$)", model: "iTAB BizniZ" }, { regex: "iT-KSA0066(?:[);/ ]|$)", model: "iTAB BizniZ Mini" }, { regex: "iT-KSA0012(?:[);/ ]|$)", model: "iTAB Moviez Pro" }, { regex: "iBall[ _]([^;/)]+)(?:[ _]Build|\\))", model: "$1" }] }, see = { regex: "iRola ([^/;]+) Build|(DX758|DX752|DX752|DX758[ _]?Pro) Build", device: "tablet", models: [{ regex: "DX758[ _]?Pro", model: "DX758 Pro" }, { regex: "(DX758|DX752)", model: "$1" }, { regex: "iRola ([^/;]+) Build", model: "$1" }] }, dee = { regex: "iRULU[ _-](X11|V[34]|U2|AL101)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "iRULU[ _-](X11|V[34]|AL101)(?:[);/ ]|$)", model: "$1" }, { regex: "iRULU[ _](U2)(?:[);/ ]|$)", device: "smartphone", model: "$1" }] }, uee = { regex: "IRBIS|TZ(1(?:0[04]|42|5[01]|84|65|7[01345-89]|8[356]|9[12578])|49|55|72|22|7(?:1[124679]|2[021567]|37|4[257]|5[23457]|6[12]|72|7[17]|8[1]|9[147])|8(?:[34]1|5[3-8]|6[45]|7[2478]|8[1-5]|9[0127])|96[0-9])|TZ85|TZ13|TZ(?:one|art|HIT|81L)|(SP(?:0[56]|2[01]|4[1-36]|40[12]|45[345]|49[34]|50|51[0147]|531|54[12]|55[0124]|571))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(TZ(?:[0-9]+)|TZ(?:one|art|HIT|81L))(?:[);/ ]|$)", model: "$1" }, { regex: "(SP[0-9]+)(?:[);/ ]|$)", device: "smartphone", model: "$1" }] }, cee = { regex: "AUXUS ([^/;]+) Build", device: "smartphone", models: [{ regex: "AUXUS (Core[^/;]+) Build", device: "tablet", model: "$1" }, { regex: "AUXUS ([^/;]+) Build", model: "$1" }] }, mee = { regex: "iHunt|One_ Love_|TITAN_P11000_PRO|Like_(3|4U|3_Pro)|X300 Elite|S10_Tank_2019|S60_Discovery_2019|AlienXLite2020|Alien X Lite|Alien_X|S20 Ultra ApeX 2021", device: "smartphone", models: [{ regex: "iHunt_Like", model: "Like" }, { regex: "S10_Tank_2019", model: "S10 Tank (2019)" }, { regex: "One_ Love_", model: "One Love" }, { regex: "TITAN_P11000_PRO", model: "Titan P11000 Pro" }, { regex: "Like_3_Pro", model: "Like 3 Pro" }, { regex: "Like_3", model: "Like 3" }, { regex: "Like_4U", model: "Like 4U" }, { regex: "X300 Elite", model: "X300 Elite" }, { regex: "S60_Discovery_2019", model: "S60 Discovery (2019)" }, { regex: "AlienXLite2020", model: "Alien X Lite (2020)" }, { regex: "Alien X Lite PRO", model: "Alien X Lite Pro" }, { regex: "Alien X Lite", model: "Alien X Lite" }, { regex: "Alien_X_ApeX", model: "Alien X ApeX" }, { regex: "Alien_X", model: "Alien X" }, { regex: "S20 Ultra ApeX 2021", model: "S20 Ultra ApeX (2021)" }] }, gee = { regex: "IconBIT|NT-(3506M|0704S|0909T|1009T|10[01]1T|1017T|3601P/3602P|3603P|3702S|3805C|3905T|3701S|0701S|0805C|0902S|370[23]M)|XDS[789]4K|Omnicast UHD|Movie Smart 4K|Movie IPTV Quad", device: "tablet", models: [{ regex: "NT-3506M", device: "smartphone", model: "NetTAB Mercury Quad FHD" }, { regex: "NT-0704S", model: "NetTAB Sky LE" }, { regex: "NT-0909T", model: "NetTAB Thor IZ" }, { regex: "NT-1009T", model: "NetTAB Thor quad II" }, { regex: "NT-10[01]1T", model: "NetTAB Thor LE" }, { regex: "NT-1017T", model: "NetTAB Thor 3G quad" }, { regex: "NT-3601P/3602P", model: "NetTAB Pocket 3G" }, { regex: "NT-3603P", model: "NetTAB Pocket 3G Slim" }, { regex: "NT-3702S", model: "NetTAB Sky HD 3G" }, { regex: "NT-3805C", model: "NetTAB Skat 3G quad" }, { regex: "NT-3701S", model: "NetTAB Sky 3G duo" }, { regex: "NT-3905T", model: "NetTAB Thor ZX 3G" }, { regex: "NT-0701S", model: "NetTAB Sky net" }, { regex: "NT-0805C", model: "NetTAB Skat MX" }, { regex: "NT-0902S", model: "NetTAB Space quad RX" }, { regex: "NT-3702M", model: "NetTAB Matrix 3G duo" }, { regex: "NT-3703M", model: "NetTAB Matrix 3GT" }, { regex: "(?:iconBIT )?(Movie Smart 4K|Movie IPTV Quad|Movie Ultra HD 4K|XDS[789]4K|Omnicast UHD)", model: "$1", device: "tv" }] }, fee = { regex: "(LYF[ _])?LS-[456][0-9]{3}|LYF/[^/]+/", device: "smartphone", models: [{ regex: "LS-4004", model: "Flame 2" }, { regex: "LS-5501", model: "Earth 1" }, { regex: "LS-5021", model: "Earth 2" }, { regex: "LS-5505", model: "Water F1" }, { regex: "LS-4503", model: "Flame LS-4503" }, { regex: "LS-4001", model: "Flame 3" }, { regex: "LS-4003", model: "Flame 4" }, { regex: "LS-4002", model: "Flame 5" }, { regex: "LS-4005", model: "Flame 6" }, { regex: "(LYF[ _])?LS-4006", model: "Flame 7" }, { regex: "LS-4008", model: "Flame 7S" }, { regex: "LS-450[58]", model: "Flame 8" }, { regex: "LS-5002", model: "Water 1" }, { regex: "LS-5005", model: "Water 4" }, { regex: "LS-5006", model: "Water 6" }, { regex: "LS-5008", model: "Water 2" }, { regex: "LS-5009", model: "Wind 6" }, { regex: "LS-5013", model: "Wind 5" }, { regex: "LS-5014", model: "Wind 4" }, { regex: "LS-5010", model: "Wind 1" }, { regex: "LS-5015", model: "Water 8" }, { regex: "LS-5016", model: "Wind 7" }, { regex: "LS-5504", model: "Water 7" }, { regex: "LS-5507", model: "Water 7S" }, { regex: "LS-5017", model: "Water 11" }, { regex: "LS-5018", model: "Wind 4S" }, { regex: "LS-5020", model: "Water 10" }, { regex: "LS-5201", model: "Water F1S" }, { regex: "LS-5502", model: "Wind 3" }, { regex: "LS-5503", model: "Water 3" }, { regex: "LS-5506", model: "Water 9" }, { regex: "LS-6001", model: "Wind 2" }, { regex: "LYF/([^/]+)/", model: "$1" }] }, pee = { regex: "LUMUS Shell|(?:NEO(SR620|SC600)|INNOSR545|Lumus[_ ]Ion)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "NEO(SR620|SC600)(?:[);/ ]|$)", model: "Neo $1" }, { regex: "INNO(SR545)(?:[);/ ]|$)", model: "INNO $1" }, { regex: "Lumus[_ ]Ion(?:[);/ ]|$)", model: "Ion" }, { regex: "LUMUS Shell [0-9A-Z]+", device: "tv", model: "" }] }, hee = { regex: "M4 SS[0-9]{4}(?:-R)?|M4_B[23]", device: "smartphone", models: [{ regex: "SS1050", model: "Joy" }, { regex: "SS1060", model: "Live" }, { regex: "SS1070", model: "Sense" }, { regex: "SS1080", model: "Max One" }, { regex: "SS1090", model: "Max Ultra" }, { regex: "SS4020", model: "Play" }, { regex: "SS4040", model: "In Touch" }, { regex: "SS4045", model: "Style" }, { regex: "SS4345", model: "Soul Mini" }, { regex: "SS4350", model: "Soul" }, { regex: "SS4445", model: "Style Access" }, { regex: "SS4450", model: "Share" }, { regex: "SS4451", model: "Believe" }, { regex: "SS4452", model: "Dream" }, { regex: "SS4453", model: "Inspiration" }, { regex: "SS4455", model: "Excite" }, { regex: "SS4456", model: "Evolution" }, { regex: "SS4457-R", model: "Ever" }, { regex: "SS4457", model: "Elegance" }, { regex: "SS4458-R", model: "Feel Plus" }, { regex: "SS4458", model: "Attitude" }, { regex: "M4_B([23])", model: "B$1" }] }, xee = { regex: "iLA[-_ ](Silk|X)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, vee = { regex: "iNew|(?:V7A|V3 Plus|V3-?E|V3C|FIRE_Tab_6)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "V3C(?:[);/ ]|$)", model: "V3C" }, { regex: "V3-?E(?:[);/ ]|$)", model: "V3-E" }, { regex: "V3 Plus(?:[);/ ]|$)", model: "V3 Plus" }, { regex: "V7A(?:[);/ ]|$)", model: "V7A" }, { regex: "FIRE_Tab_6(?:[);/ ]|$)", device: "tablet", model: "Fire Tab 6" }, { regex: "iNew[ -_]([^;/]+) Build", model: "$1" }] }, See = { regex: "(?:Kylin[ _]5.[05]S?|KYLIN40|Jade[78]s|Amber[67]S?|Amber5S_Pro|Phonenix50S|Zafiro)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Kylin_5.0S", model: "Kylin 5.0S" }, { regex: "Kylin (5.[05])", model: "Kylin $1" }, { regex: "KYLIN40", model: "Kylin 40" }, { regex: "Jade([78])s", model: "Jade $1s" }, { regex: "Amber7S", model: "Amber 7S" }, { regex: "Amber5S_Pro", model: "Amber 5S Pro" }, { regex: "Amber6", model: "Amber 6" }, { regex: "Phonenix50S", model: "Phonenix 50S" }, { regex: "Zafiro", model: "Zafiro" }] }, bee = { regex: "Infinix", device: "smartphone", models: [{ regex: "Infinix[ _-]X260", model: "Buzz" }, { regex: "Infinix[ _-]X502", model: "Alpha Marvel" }, { regex: "Infinix[ _-]X570", model: "Alpha" }, { regex: "Infinix[ _-]X350", model: "Surf Smart" }, { regex: "Infinix[ _-]X351", model: "Surf Smart 3G" }, { regex: "Infinix[ _-]X352", model: "Surf Smart 2" }, { regex: "Infinix[ _-]X403", model: "Surf Spice" }, { regex: "Infinix[ _-]X503", model: "Surf Bravo" }, { regex: "Infinix[ _-]X511", model: "Surf Noir" }, { regex: "Infinix[ _-]X400", model: "Race" }, { regex: "Infinix[ _-]X401", model: "Race Lite" }, { regex: "Infinix[ _-]X450", model: "Race Bolt" }, { regex: "Infinix[ _-]X451", model: "Race Bolt Q" }, { regex: "Infinix[ _-]X454", model: "Race Bolt 2" }, { regex: "Infinix[ _-]X500", model: "Race Eagle" }, { regex: "Infinix[ _-]X501", model: "Race Jet" }, { regex: "Infinix[ _-]X506", model: "Zero" }, { regex: "Infinix[ _-]X509", model: "Zero 2" }, { regex: "Infinix[ _-]X552", model: "Zero 3" }, { regex: "Infinix[ _-]X555", model: "Zero 4" }, { regex: "Infinix[ _-]X(?:574|602)", model: "Zero 4 Plus" }, { regex: "Infinix[ _-]X603", model: "Zero 5" }, { regex: "Infinix[ _-]X603B", model: "Zero 5 Pro" }, { regex: "Infinix[ _-]X620", model: "Zero 6" }, { regex: "Infinix[ _-]X507", model: "Hot" }, { regex: "Infinix[ _-]X510", model: "Hot 2" }, { regex: "Infinix[ _-]X55[34]", model: "Hot 3" }, { regex: "Infinix[ _-]X521", model: "Hot S" }, { regex: "Infinix[ _-]X522", model: "Hot S2" }, { regex: "Infinix[ _-]X557", model: "Hot 4" }, { regex: "Infinix[ _-]X556", model: "Hot 4 Pro" }, { regex: "Infinix[ _-]X559c", model: "Hot 5" }, { regex: "Infinix[ _-]X559", model: "Hot 5 Lite" }, { regex: "Infinix[ _-]X606[BC]?", model: "Hot 6" }, { regex: "Infinix[ _-]X608", model: "Hot 6 Pro" }, { regex: "Infinix[ _-]X624", model: "Hot 7" }, { regex: "Infinix[ _-]X650", model: "Hot 8" }, { regex: "Infinix[ _-]X680", model: "Hot 9 Play" }, { regex: "Infinix[ _-]X573B?", model: "Hot S3" }, { regex: "Infinix[ _-]X5010", model: "Smart" }, { regex: "Infinix[ _-]X5515F", model: "Smart 2" }, { regex: "Infinix[ _-]X5514D", model: "Smart 2 Pro" }, { regex: "Infinix[ _-]X653", model: "Smart 4" }, { regex: "Infinix[ _-]X626", model: "S4" }, { regex: "Infinix[ _-]X652", model: "S5" }, { regex: "Infinix[ _-]X660", model: "S5 Pro" }, { regex: "Infinix[ _-]X551", model: "Hot Note", device: "phablet" }, { regex: "Infinix[ _-]X600", model: "Note 2", device: "phablet" }, { regex: "Infinix[ _-]X601", model: "Note 3", device: "phablet" }, { regex: "Infinix[ _-]X572", model: "Note 4", device: "phablet" }, { regex: "Infinix[ _-]X571", model: "Note 4 Pro", device: "phablet" }, { regex: "Infinix[ _-]X604", model: "Note 5", device: "phablet" }, { regex: "Infinix[ _-]X610", model: "Note 6", device: "phablet" }, { regex: "Infinix[ _-]X690", model: "Note 7", device: "phablet" }, { regex: "Infinix[ _-]X656", model: "Note 7 Lite", device: "phablet" }, { regex: "Infinix HOT ([a-z]?[1-6])( (?:Lite|Plus|Pro))?", model: "Hot $1$2" }, { regex: "Infinix[ _-](X[78]00)", device: "tablet", model: "$1" }, { regex: "Infinix[ _-](X\\d+)", model: "$1" }, { regex: "Infinix[ _-]([a-z0-9_\\-]+)", model: "$1" }] }, yee = { regex: "IF(900[1237]|902[19]|903[15])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "IF9001", model: "Turbo 5" }, { regex: "IF9007", model: "A3" }, { regex: "IF9021", model: "Turbo 5 Plus" }, { regex: "IF9035", model: "A2" }, { regex: "IF9002", model: "M5s" }, { regex: "IF9003", model: "M6s" }, { regex: "IF9031", model: "Vision 3" }, { regex: "IF9029", model: "Vision 3 Pro" }] }, wee = { regex: "InnJoo|(?:Halo Plus|Halo X|Halo[ _]4(?:[ _]mini[ _]LTE)?|Halo2 3G|Fire2 Plus LTE)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "InnJoo[ _]X3(?:[);/ ]|$)", model: "X3" }, { regex: "Halo[ _]X[ _]LTE(?:[);/ ]|$)", model: "Halo X LTE" }, { regex: "InnJoo[ _]X(?:[);/ ]|$)", model: "X" }, { regex: "Halo Plus(?:[);/ ]|$)", model: "Halo Plus" }, { regex: "Halo[ _]4[ _]mini[ _]LTE(?:[);/ ]|$)", model: "Halo 4 Mini LTE" }, { regex: "Halo 4(?:[);/ ]|$)", model: "Halo 4" }, { regex: "Halo2 3G(?:[);/ ]|$)", model: "Halo 2 3G" }, { regex: "InnJoo[ _]Pro2(?:[);/ ]|$)", model: "Pro 2" }, { regex: "Innjoo ONE 3G(?:[);/ ]|$)", model: "One 3G" }, { regex: "Innjoo[ _]2[ _]LTE(?:[);/ ]|$)", model: "2 LTE" }, { regex: "InnJoo[ _]([2-4])", model: "$1" }, { regex: "Fire2 Plus LTE", model: "Fire 2 Plus LTE" }] }, _ee = { regex: "intki[ _]([^/;]*)[ _]Build", device: "smartphone", model: "$1" }, Tee = { regex: "Innos_?(D6000)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Aee = { regex: "INNO([a-z0-9]+)", device: "feature phone", model: "INNO$1" }, Pee = { regex: "NS-(P11A8100|P10A8100|P10A6100|P16AT08|P16AT10|P16AT785HD|P08A7100|P10A7100)(?:[);/ ]|$)|AFTEAMR311|AFTJMST12", device: "tablet", models: [{ regex: "NS-P11A8100", model: '11.6"' }, { regex: "NS-(P10A6100|P16AT10)", model: 'Flex 10.1"' }, { regex: "NS-P16AT08", model: 'Flex 8"' }, { regex: "NS-P08A7100", model: '8"' }, { regex: "NS-(P10A8100|P10A7100)", model: '10.1"' }, { regex: "NS-P16AT785HD", model: 'Flex Elite 7.85"' }, { regex: "AFTEAMR311", model: "HD (2018)", device: "tv" }, { regex: "AFTJMST12", model: "4K (2018)", device: "tv" }] }, Mee = { regex: "INQ[/ ]", device: "feature phone", models: [{ regex: "INQ/([a-z0-9\\-]+)", model: "$1" }, { regex: "INQ ([^;/]+) Build", model: "$1", device: "smartphone" }] }, $ee = { regex: "Intex|(Aqua|Cloud[ _][XY][0-9]{1}|Cloud (?:Fame|Glory) 4G)|IM0318ND(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "IM0318ND", model: "Aqua Lions 3" }, { regex: "Intex[ _]([^/;]*)[ _]Build", model: "$1" }, { regex: "(Cloud (?:Fame|Glory) 4G)", model: "$1" }, { regex: "(Aqua|Cloud)[ _\\.]([^/;\\)]+)(?:[ _]Build|(?<!Build)/|\\))", model: "$1 $2" }, { regex: "Intex[ _]([a-z0-9_+\\-]+)", model: "$1" }] }, Cee = { regex: "iKoMo ([a-z0-9]+)", device: "feature phone", model: "$1" }, Lee = { regex: "iOCEAN|M6752|W180|X7[ _]?S|X8 mini", device: "smartphone", models: [{ regex: "X7S-T", model: "X7S-T" }, { regex: "X8 mini pro", model: "X8 Mini Pro" }, { regex: "X8 mini", model: "X8 Mini" }, { regex: "X7[ _]?S", model: "X7S Elite" }, { regex: "(M6752|W180) Build", model: "$1" }, { regex: "iOCEAN[ _\\-]?([^/;]+) Build", model: "$1" }, { regex: "iOCEAN[ _\\-]?([^);/ ]+)", model: "$1" }] }, Eee = { regex: "(733TPC|730TPC|769TPCII|930TPC)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Oee = { regex: "(?:Impression[ _\\-]?([^/;]+)|A502|I10\\-LE|ImPad[ _]?(.*)|ImSmart[ _]?(.*))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(A502)", model: "$1", device: "smartphone" }, { regex: "ImSmart[ _]?([^/;)]+)(?: Build|\\))", model: "ImSmart $1", device: "smartphone" }, { regex: "ImPad[ _]?([^/;)]+)(?: Build|\\))", model: "ImPad $1" }, { regex: "(I10\\-LE)", model: "$1", device: "smartphone" }, { regex: "Impression[ _\\-]?([^/;)]+)(?: Build|\\))", model: "$1" }] }, Nee = { regex: "(ITELL[_ ](?:K3300|K3500N?|K4700))(?:[);/ ]|$)", device: "tablet", model: "$1" }, Dee = { regex: "itel|iNote|GP10X2019(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "W6502", device: "phablet", model: "S16" }, { regex: "W5505", model: "A36" }, { regex: "W6002E?", model: "S15" }, { regex: "L5502", model: "A44 Air" }, { regex: "L5505", model: "A47" }, { regex: "L6006", model: "A48" }, { regex: "L6003P", model: "A55 LTE" }, { regex: "L6002P", model: "S15 Pro" }, { regex: "L5002", model: "A22" }, { regex: "L5503", model: "A46" }, { regex: "L6004", model: "A56 LTE" }, { regex: "W6004P", model: "A56 Pro" }, { regex: "W6001", model: "P33 Plus" }, { regex: "W6003", model: "A55" }, { regex: "L6005", model: "Vision 1" }, { regex: "L6501", model: "Vision 1 Plus" }, { regex: "L6502", model: "Vision 1 Pro" }, { regex: "GP10X2019", model: "GP10X2019" }, { regex: "iNote ([^/;]*)Build", model: "iNote $1" }, { regex: "iNote_([a-z0-9\\-_]+)", model: "iNote $1" }, { regex: "itel-it(1410|1512|1520)(?:[);/ ]|$)", model: "it$1" }, { regex: "itel-it1553(?:[);/ ]|$)", model: "Power Pro" }, { regex: "itel[- ](A14|A16 Plus|A44 Power|A23S|A52 Lite)", model: "$1" }, { regex: "itel it1701", device: "tablet", model: "iNote Prime" }, { regex: "itel it170([23])", device: "tablet", model: "iNote Prime $1" }, { regex: "iTel ([^/;]*)Build", model: "$1" }, { regex: "iTel[_ ]([a-z0-9\\-_]*)", model: "$1" }] }, kee = { regex: "(Mi7_HERO_(?:BETA|TAB))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "Mi7[_ ]HERO[_ ]BETA(?:[);/ ]|$)", model: "MI7 Hero Beta" }, { regex: "Mi7[_ ]HERO[_ ]TAB(?:[);/ ]|$)", model: "MI7 Hero Tab" }] }, Gee = { regex: "JIAYU[ _-]|(?:JY-G4[\\\\_]G5|(?:JY-[a-z0-9]+)|JY_G4C)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:JIAYU G4_G5|JY-G4[\\\\_]G5)(?:[);/ ]|$)", model: "G4/G5" }, { regex: "JIAYU[ _-](G4[S]?|G2F|G3[S]?|S[23])(?:[);/ ]|$)", model: "$1" }, { regex: "JY[-_]([a-z0-9]+|G4C)(?:[);/ ]|$)", model: "JY-$1" }] }, Bee = { regex: "Jolla", device: "smartphone", model: "" }, Iee = { regex: "JUST5(-)?SPACER(s)?|COSMO[_ ](L707|L808)|BLASTER|FREEDOM[ _](C100|M303|X1)|Freedom", device: "smartphone", models: [{ regex: "COSMO[_ ](L707|L808)", model: "Cosmo $1" }, { regex: "FREEDOM[ _](C100|M303|X1)", model: "Freedom $1" }, { regex: "Freedom", model: "Freedom" }, { regex: "JUST5(-)?SPACER2s", model: "Spacer 2S" }, { regex: "JUST5(-)?SPACER2", model: "Spacer 2" }, { regex: "JUST5SPACER", model: "Spacer" }, { regex: "BLASTER 2", model: "Blaster 2" }, { regex: "BLASTER", model: "Blaster" }] }, Ree = { regex: "KALLEY|(?:ELEMENT (?:MAX|Q)|ELEMENT_PRO_2|K-BOOK(?:8MG|73G))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ELEMENT MAX", model: "Element Max" }, { regex: "ELEMENT Q", model: "Element Q" }, { regex: "ELEMENT_PRO_2", model: "Element Pro 2" }, { regex: "K-BOOK(8MG|73G)", device: "tablet", model: "K-BOOK$1" }, { regex: "KALLEY,(55D1240)", device: "tv", model: "$1" }] }, Fee = { regex: "KAAN[ _](N[12]|A1)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Vee = { regex: "Kazam|Trooper_X[0-9][0-9](?:[);/ ]|$)|Tornado 348|TROOPER 4\\.0", device: "smartphone", models: [{ regex: "Tornado 348", model: "Tornado 348" }, { regex: "Thunder 450W", model: "Thunder 450W" }, { regex: "TROOPER 4\\.0", model: "Trooper X4.0" }, { regex: "Trooper_X([0-9])([0-9])(?:[);/ ]|$)", model: "Trooper X$1.$2" }, { regex: "Kazam[; _]([^;/)]+)(?: Build|\\))", model: "$1" }] }, Hee = { regex: "KENEKSI|(?:Hemera|Teta Dual|Helios)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(Hemera|Teta Dual|Helios)(?:[);/ ]|$)", model: "$1" }, { regex: "KENEKSI[ _-]liberty", model: "Liberty" }, { regex: "KENEKSI[ _-]FLASH", model: "Flash" }, { regex: "KENEKSI[ _-]SUN", model: "Sun" }, { regex: "KENEKSI[ _-]ZETA", model: "Zeta" }, { regex: "KENEKSI[ _-]SIGMA", model: "Sigma" }, { regex: "KENEKSI[ _-](Moon|Libra_Dual|Glass|Amber|Chance|Amulet|Choice|Crystal|Dream|Delta[_ ]Dual|Norma 2|Norma|Sky|Fire 2|Fire|Flame|Flora|Rock|Solo|Soul|Step|Smart|Star|Storm|Wind)", model: "$1" }] }, Uee = { regex: "Kiano|Elegance_[45]_[015](?:_PRO)?|Elegance 6|CORE 10.1 DUAL 3G|Intelect ?(7|8|10)|Slim ?Tab ?\\d+(?:[_ ]3GR?)?(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Slim ?Tab ?(\\d+)(?:[_ ]3GR?)?", model: "Slim Tab $1", device: "tablet" }, { regex: "CORE 10.1 DUAL 3G", model: "CORE 10.1 DUAL 3G", device: "tablet" }, { regex: "Elegance_(5)_([51])_Pro", model: 'Elegance $1.$2" Pro' }, { regex: "Elegance_([45])_([015])", model: 'Elegance $1.$2"' }, { regex: "Elegance 6", model: 'Elegance 6 5.85"' }, { regex: "(Kiano)?(Intelect|Elegance) ?(7|8|10)?", model: "$2 $3", device: "tablet" }, { regex: "Kiano[ _]([^;/]+) Build", model: "$1" }] }, Xee = { regex: "Kingsun[ _-]", device: "smartphone", models: [{ regex: "Kingsun[ _-]([^;/]+) Build", model: "$1" }, { regex: "Kingsun[ -]((?!Build)[a-z0-9_-]+)", model: "$1" }] }, Wee = { regex: "Kocaso|M(?:729|7[357][026][hw]?|76[01236][bw]?|83[016]|8[567]0|1050s|106[012368]w?|1070|X736(?:-kit)?|X780)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "M729(?:[);/ ]|$)", model: "M729" }, { regex: "M(7[357][026])[hw]?(?:[);/ ]|$)", model: "M$1" }, { regex: "M(76[01236])[bw]?(?:[);/ ]|$)", model: "M$1" }, { regex: "MX780(?:[);/ ]|$)", model: "MX780" }, { regex: "M(83[016])(?:[);/ ]|$)", model: "M$1" }, { regex: "M(8[567]0)(?:[);/ ]|$)", model: "M$1" }, { regex: "M851(?:[);/ ]|$)", model: "M851" }, { regex: "M1050S(?:[);/ ]|$)", model: "M1050s" }, { regex: "M(106[012368])W?(?:[);/ ]|$)", model: "M$1" }, { regex: "M1070(?:[);/ ]|$)", model: "M1070" }, { regex: "MX736(?:-kit)?(?:[);/ ]|$)", model: "MX736" }, { regex: "MX780(?:[);/ ]|$)", model: "MX780" }, { regex: "Kocaso[ _\\-]?([^;/]+) Build", model: "$1" }, { regex: "Kocaso[ _\\-]?([a-z0-9_-]+)", model: "$1" }] }, Yee = { regex: "Kogan", device: "smartphone", models: [{ regex: "Kogan[ _-]([^;/]+) Build", model: "$1" }, { regex: "Kogan[ _-]([a-z0-9_-]+)", model: "$1" }] }, Kee = { regex: "Komu[ -]", device: "smartphone", models: [{ regex: "Komu[ -]([^;/]+) Build", model: "$1" }, { regex: "Komu[ -]([a-z0-9_-]+)", model: "$1" }] }, Qee = { regex: "Koobee", device: "smartphone", models: [{ regex: "Koobee[ _\\-]?([^;/]+) Build", model: "$1" }, { regex: "Koobee[ _\\-]?([a-z0-9_-]+)", model: "$1" }] }, jee = { regex: "(?:KM-)?Kumai", device: "smartphone", models: [{ regex: "(?:KM-)?Kumai[ _\\-]?([^;/]+) Build", model: "$1" }, { regex: "(?:KM-)?Kumai[ _\\-]?([a-z0-9_-]+)", model: "$1" }] }, Zee = { regex: "kddi-([a-z0-9]+)", device: "feature phone", model: "$1" }, zee = { regex: "KODAK|(?:IM5|Ektra|Smartway_T1)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "IM5", model: "IM5" }, { regex: "Ektra(?:[);/ ]|$)", model: "Ektra" }, { regex: "(?:KODAK[_ ])?SMARTWAY[_ ]([MTX]1)", model: "Smartway $1" }, { regex: "Tablet (7|10)", device: "tablet", model: "Tablet $1" }] }, qee = { regex: "KOPO[ _-]", device: "smartphone", models: [{ regex: "KOPO[ _\\-]?([^/;]+) Build", model: "$1" }, { regex: "KOPO[ _\\-]?([^);/ ]+)", model: "$1" }] }, Jee = { regex: "KORIDY[ _-]([^/;]+) Build", device: "smartphone", model: "$1" }, ete = { regex: "NET1100|NET_(?:TITAN|VOLT)", device: "smartphone", models: [{ regex: "NET1100", model: "NET 1100" }, { regex: "NET_(TITAN|VOLT)", model: "NET $1" }] }, tte = { regex: "(QC-(?:703GN|704GA|803GN|1013G|7BHD))(?:[);/ ]|$)", device: "tablet", model: "$1" }, rte = { regex: "Kyocera|KWC-|QC-[0-9]{4}|(?:QC6035|NP501KC|302KC|503KC|602KC|705KC|901KC|C51[27]0|C5155|C5215|C67[35]0|C6522N?|C6530N|C6740N?|C6743|E6[89]10|KYL2[13]|KYV3[13-9]|KYT3[123]|KYF3[123579]|KYF40|KYX31|KYG01|KYY2[1-4]|S2151|KC-S701|S[468]-KC|KYV40U?|KYV4[1-8]|KYV4[47]|KC-S301AE|X3-KC|E6560[CT]|E6782[L]?|E6790(?:TM)?|[47]04KC|A001KC|WX10K|URBANO PROGRESSO|E7110)(?:[-_]u2?)?(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "C5120(?:[);/ ]|$)", model: "Milano" }, { regex: "S4-KC(?:[);/ ]|$)", model: "One S4" }, { regex: "S6-KC(?:[);/ ]|$)", model: "One S6" }, { regex: "S8-KC(?:[);/ ]|$)", model: "One S8" }, { regex: "C5155(?:[);/ ]|$)", model: "Rise" }, { regex: "602KC(?:[);/ ]|$)", model: "Digno G" }, { regex: "503KC(?:[);/ ]|$)", model: "Digno E" }, { regex: "404KC(?:[);/ ]|$)", model: "Digno C" }, { regex: "704KC(?:[);/ ]|$)", model: "Digno J" }, { regex: "302KC(?:[);/ ]|$)", model: "Digno T" }, { regex: "NP501KC(?:[);/ ]|$)", model: "Digno" }, { regex: "WX10K(?:[);/ ]|$)", model: "Digno Dual 2" }, { regex: "KYV36(?:[);/ ]|$)", model: "Digno Rafre" }, { regex: "901KC(?:[);/ ]|$)", model: "Digno BX" }, { regex: "KYV39(?:[);/ ]|$)", model: "Miraie F" }, { regex: "KYX31(?:[);/ ]|$)", model: "Infobar XV" }, { regex: "C5170(?:[);/ ]|$)", model: "Hydro" }, { regex: "C5215(?:[);/ ]|$)", model: "Hydro EDGE" }, { regex: "C6522N?", model: "Hydro XTRM" }, { regex: "C6730", model: "Hydro ICON" }, { regex: "C6750", model: "Hydro ELITE" }, { regex: "C6530N", model: "Hydro LIFE" }, { regex: "C6740(N)?", model: "Hydro WAVE" }, { regex: "C6743", model: "Hydro Reach" }, { regex: "E6560[CT]", model: "DuraForce" }, { regex: "E6810", model: "DuraForce Pro" }, { regex: "E6910", model: "DuraForce Pro 2" }, { regex: "E7110", model: "DuraForce Ultra 5G" }, { regex: "KC-S701", model: "Torque" }, { regex: "KYG01", model: "Torque 5G" }, { regex: "KYL21(?:[);/ ]|$)", model: "Digno S" }, { regex: "KYL23(?:[);/ ]|$)", model: "Miraie" }, { regex: "KYY24(?:[);/ ]|$)", model: "Torque G01" }, { regex: "KYF32(?:[);/ ]|$)", model: "Easy Mobile Phone" }, { regex: "KYF35(?:[);/ ]|$)", model: "Marvera" }, { regex: "KYF40(?:[);/ ]|$)", model: "Mamorino 5" }, { regex: "KYF3[179](?:[);/ ]|$)", model: "Gratina 4G" }, { regex: "KYV48(?:[);/ ]|$)", model: "Gratina KYV48" }, { regex: "KYF33(?:[);/ ]|$)", model: "Torque X01" }, { regex: "KYV35(?:[);/ ]|$)", model: "Torque G02" }, { regex: "KYV41(?:[);/ ]|$)", model: "Torque G03" }, { regex: "KYV46(?:[);/ ]|$)", model: "Torque G04" }, { regex: "KYV47(?:-u)?(?:[);/ ]|$)", model: "Basio 4" }, { regex: "KYV43(?:[);/ ]|$)", model: "Basio 3" }, { regex: "705KC(?:[);/ ]|$)", model: "Kantan Sumaho" }, { regex: "KYV37(?:[);/ ]|$)", model: "Qua Phone" }, { regex: "KYV42(?:_u)?(?:[);/ ]|$)", model: "Qua Phone QX" }, { regex: "KYV44(?:_u2?)?(?:[);/ ]|$)", model: "Qua Phone QZ" }, { regex: "KYT33(?:[);/ ]|$)", model: "Qua Tab QZ10", device: "tablet" }, { regex: "KYT32(?:[);/ ]|$)", model: "Qua Tab QZ8", device: "tablet" }, { regex: "KYT31(?:[);/ ]|$)", model: "Qua Tab 01", device: "tablet" }, { regex: "KYV40U?(?:[);/ ]|$)", model: "Rafre" }, { regex: "KYV33(?:[);/ ]|$)", model: "Infobar A03" }, { regex: "KYY21(?:[);/ ]|$)", model: "Urbano L01" }, { regex: "KYY22(?:[);/ ]|$)", model: "Urbano L02" }, { regex: "KYY23(?:[);/ ]|$)", model: "Urbano L03" }, { regex: "KYV31(?:[);/ ]|$)", model: "Urbano V01" }, { regex: "KYV34(?:[);/ ]|$)", model: "Urbano V02" }, { regex: "KYV(?:45|38)(?:[);/ ]|$)", model: "Urbano V03" }, { regex: "(?:Kyocera-)?E6790(?:TM)?", model: "DuraForce XD" }, { regex: "X3-KC(?:[);/ ]|$)", model: "One X3" }, { regex: "E6782(?:[);/ ]|$)", model: "Brigadier" }, { regex: "E6782L(?:[);/ ]|$)", model: "DuraScout" }, { regex: "(KC-S301AE)(?:[);/ ]|$)", model: "$1" }, { regex: "A001KC(?:[);/ ]|$)", model: "Katan Sumaho 2" }, { regex: "URBANO PROGRESSO(?:[);/ ]|$)", model: "Urbano Progresso" }, { regex: "S2151", model: "Coast", device: "feature phone" }, { regex: "Kyocera-KZ-([a-z0-9]+)", model: "KZ $1" }, { regex: "Kyocera(?:[\\-/])?([a-z0-9]+)", model: "$1" }, { regex: "(KWC|QC)-?([a-z0-9]+)", model: "$1-$2" }] }, ote = { regex: "LAIQ", device: "smartphone", models: [{ regex: "(Glam|New York|Dubai)(?:[);/ ]|$)", model: "$1" }] }, nte = { regex: "iris708|Kingcomm C500", device: "smartphone", models: [{ regex: "iris708", model: "LAVA PRO 4.5" }, { regex: "Kingcomm C500", model: "Super Smart Plus X3" }] }, ate = { regex: "Lava[ _]|LAVAA1|(?:DISCOVER136|KKT QUADRA)|iris[ _]?([^/;]+)(?:\\)| Build)|A(?:67|76) Build|X1 Selfie Build|X41 Plus Build|(?:Flair Z1|PixelV1|Pixel V2|Z61_2GB|A97 IPS|A97 2GB PLUS|L[EH]9920(?:[_ ]P)?|L[NEH]9910|LH9810|Ivory(?:S1|S4G)?|A76Plus)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Flair Z1(?:[);/ ]|$)", model: "Flair Z1" }, { regex: "A97 IPS(?:[);/ ]|$)", model: "A97 IPS" }, { regex: "A97 2GB PLUS(?:[);/ ]|$)", model: "A97 2GB Plus" }, { regex: "A76Plus(?:[);/ ]|$)", model: "A76 Plus" }, { regex: "Pixel ?V([12])(?:[);/ ]|$)", model: "Pixel V$1" }, { regex: "X1 Selfie(?:[);/ ]|$)", model: "Iris X1 Selfie" }, { regex: "X41 Plus(?:[);/ ]|$)", model: "X41 Plus" }, { regex: "(?:LAVA[_ ]?)?A([13]|67|76)(?:[);/ ]|$)", model: "A$1" }, { regex: "LAVA_R1", model: "R1" }, { regex: "Z61_2GB(?:[);/ ]|$)", model: "Z61" }, { regex: "LE9920[ _]P(?:[);/ ]|$)", model: "V7" }, { regex: "LE9920(?:[);/ ]|$)", model: "Z53" }, { regex: "LH9910(?:[);/ ]|$)", model: "Z52" }, { regex: "LH9810(?:[);/ ]|$)", model: "Iris 52" }, { regex: "LN9910(?:[);/ ]|$)", model: "Z41" }, { regex: "LE9910(?:[);/ ]|$)", model: "V8" }, { regex: "LH9920(?:[);/ ]|$)", model: "V+6" }, { regex: "DISCOVER136", device: "feature phone", model: "Discover 136" }, { regex: "KKT QUADRA", device: "feature phone", model: "KKT Quadra" }, { regex: "KKT40[ ]?Power[P\\+]", device: "feature phone", model: "KKT40 Power Plus" }, { regex: "Ivory(S1|S4G)?(?:[);/ ]|$)", device: "tablet", model: "Ivory $1" }, { regex: "iris[ _]?([^/;]+)(?:\\)| Build)", model: "Iris $1" }, { regex: "Lava[ _]?([^/;]+)(?:/| Build)", model: "$1" }] }, lte = { regex: "(Modern[ _](?:S10?|S[3679]))(?:[);/ ]|$)", device: "smartphone", model: "$1" }, ite = { regex: "XM[123]00|(?<!Blade )S6 Build", device: "smartphone", models: [{ regex: "S6 Build", model: "S6" }, { regex: "XM([123])00([^/;]*) Build", model: "XM$100$2" }] }, ste = { regex: "LANIX-([a-z0-9]+)|Ilium[ _]|IliumPad|X120C|Alpha 950", device: "smartphone", models: [{ regex: "ILIUM[ _]?PAD[ _]?([^;/]+)(?: Build|[;)])", model: "Ilium Pad $1", device: "tablet" }, { regex: "X120C", model: "Ilium X120C" }, { regex: "Ilium[ _](Alpha [15]s|Alpha [379]|L(?:200|6[12]0|9[0125]0|1[0124]00|1050|1120)|LT5[012]0|M[13579]|S(?:106|520|6[27]0)|X(?:1[12]0|2[0126]0|5[12]0|500B|710)|M[579]s)(?:[);/ ]|$)", model: "Ilium $1" }, { regex: "ILIUM[ _]([^;/]+) Build", model: "Ilium $1" }, { regex: "Alpha 950", model: "Ilium Alpha 950" }, { regex: "LANIX-([a-z0-9]+)", device: "feature phone", model: "$1" }] }, dte = { regex: "(Lark|Cumulus|Evolution|FreeMe|Ultimate (?:X4|7i))[ _-]|Build/Lark|Bjorn[_ ]SP-500|FreeBird 5WiFi", device: "tablet", models: [{ regex: "Cumulus[ _](5\\.5|[56])[ _]HD", model: "Cumulus $1 HD", device: "smartphone" }, { regex: "FreeMe X2 ([79]) (?:ver|v)?\\.([23])", model: "FreeMe X2 $1 Version $2" }, { regex: "FreeMe X4 7 3G HD", model: "FreeMe X4 7HD 3G" }, { regex: "FreeMe[ _]X2[ _]([7-9])", model: "FreeMe X2 $1" }, { regex: "FreeMe X4[ _]7[_ ]HD", model: "FreeMe X4 7HD" }, { regex: "FreeMe X4[ _]9", model: "FreeMe X4 9" }, { regex: "FreeBird 5WiFi", model: "FreeBird 5 WiFi" }, { regex: "(?:Lark[ _-])?Evolution[ _](X2 7 3G-GPS|X4[_ ]10\\.1|10|X4[_ ]7[ _]IPS)", model: "Evolution $1" }, { regex: "Ul(?:ti|it)mate (X4 10\\.1 3G IPS|X4 8s 3G|7i)", model: "Ultimate $1" }, { regex: "PHABLET 7", model: "Phablet 7" }, { regex: "Phablet 6\\.0", model: "Phablet 6.0", device: "smartphone" }, { regex: "Bjorn[_ ]SP-500", model: "Bjorn SP-500", device: "smartphone" }, { regex: "Cirrus[ _](4\\.5|[45])", model: "Cirrus $1", device: "smartphone" }, { regex: "Lark[ _](Stratus[_ ]5)", model: "$1", device: "smartphone" }] }, ute = { regex: "LCT_([a-z0-9]+)", device: "feature phone", model: "$1" }, cte = { regex: "(?:MY)?LEAGOO[ _-]?|(?:M5 EDGE|KIICAA (POWER|MIX)|Leapad[ _](?:X|7s)|Elite [15]|Venture 1|Z10-E)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "LEAGOO[- _]M8[_-]?Pro(?:[);/ ]|$)", model: "M8 Pro" }, { regex: "LEAGOO[- _](Z[156]|M[58]|T1)(?:[);/ ]|$)", model: "$1" }, { regex: "M5 EDGE", model: "M5 Edge" }, { regex: "LEAGOO[_ ]Lead([57])", model: "Lead $1" }, { regex: "KIICAA POWER", model: "KICCAA Power" }, { regex: "KIICAA MIX", model: "KICCAA Mix" }, { regex: "Elite ([15])(?:[);/ ]|$)", model: "Elite $1" }, { regex: "Venture 1(?:[);/ ]|$)", model: "Venture 1" }, { regex: "(?:LEAGOO[- _])?(Z10-E|M6)(?:[);/ ]|$)", model: "$1" }, { regex: "(?:My)?Leagoo[- _](E4)(?:[);/ ]|$)", model: "$1" }, { regex: "(?:Leapad[ _])(7s|10|X)", model: "LeaPad $1", device: "tablet" }] }, mte = { regex: "(?:Ledstar[_ ])?(?:Trendy 5.0|Novus_Premium_6.0)", device: "smartphone", models: [{ regex: "Trendy 5.0", model: "Trendy 5.0" }, { regex: "Ledstar_Novus_Premium_6.0(?:[);/ ]|$)", model: 'Novus Premium 6.0"' }] }, gte = { regex: "Letv|LeEco|Le ?X[0-9][^;/]+|Le Max|Le [12]|Le2[_ ]x527|X900 Build|(?:X[89]00\\+|X52[67])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "X800\\+", model: "Le 1 Pro" }, { regex: "X900\\+", model: "Max X900+" }, { regex: "X50[10]", model: "Le 1S" }, { regex: "(X910)", model: "$1" }, { regex: "X900 Build", model: "Le X900" }, { regex: "(?:Le ?X526|Le2[_ ]x527|Le 2|X52[67])(?:[);/ ]|$)", model: "Le 2" }, { regex: "Le ?X([^;/]+) Build", model: "Le X$1" }, { regex: "Le ?X([^) ;/]+)", model: "Le X$1" }, { regex: "Le ?([12][^;/]+) Build", model: "Le $1" }, { regex: "Le Max([^;/]*) Build", model: "Le Max$1" }, { regex: "Le Max([^ ;/]*)", model: "Le Max$1" }, { regex: "LeEco ([^;/]+) Build", model: "$1" }] }, fte = { regex: "LESPH501[14]|LESPH5003B|SUPERNOVA (Qi16|Qi32|i3G96[X]?)", device: "smartphone", models: [{ regex: "LESPH5011", model: "Argon e250" }, { regex: "LESPH5003B", model: "Argon A250B" }, { regex: "LESPH5014", model: "Krypton K150" }, { regex: "SUPERNOVA (Qi16|Qi32|i3G96[X]?)", device: "tablet", model: "Supernova $1" }] }, pte = { regex: "lephone[ _]|lephoneP1", device: "smartphone", models: [{ regex: "lephone[ _](K7|K10)", device: "feature phone", model: "$1" }, { regex: "lephone(?:[ _])?(W(1[0125]|[279])|T2|P1)(?:[);/ ]|$)", model: "$1" }, { regex: "lephone_W7_plus", model: "W7 Plus" }] }, hte = { regex: "Lenco ([^/;]*) Build", device: "tablet", model: "$1" }, xte = { regex: "(?:LNV-)?Lenovo|IdeaTab|IdeaPad|Thinkpad|Yoga Tablet|Tab2A[0-9]-[0-9]{2}[a-z]?|ZUK[ -_]|(?:TB2-X30L|TB3-710I|YT3-X50[ML]|K50a40|TB-(?:X103F|8504F|X304F|X704V|X704A)|A5500-H|A2107A-H|A3500-HV|A2109A|S6000|Z2 Plus|Vibe[ _](?:P1|S6i Plus|S[23567]i|C|[ZX]2|K5(?: Plus)?|V7)|P2A42|L38011|L18011|[5-8]01LV|[67]02LV|Z2131|K350t|K31-t3|TAB 2 A8-50LC|S90-A|P70-A|VR-1541F)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Lenovo ?G780", model: "G780", device: "desktop" }, { regex: "Lenovo ?A3500-FL", model: "IdeaTab A7-40", device: "tablet" }, { regex: "(?:Lenovo ?)?A3500-(?:H|HV|F)", model: "IdeaTab A7-50", device: "tablet" }, { regex: "(?:Lenovo[ _])?A5500-[HF]", model: "IdeaTab A8-50", device: "tablet" }, { regex: "Lenovo ?A7600-[HF]", model: "IdeaTab A10-70", device: "tablet" }, { regex: "A2107A-H", model: "A2107", device: "tablet" }, { regex: "A2109A", model: "IdeaTab A2109A", device: "tablet" }, { regex: "TB2-X30[FL]", model: "Tab 2 A10-30", device: "tablet" }, { regex: "YT3-X50[FLM]", model: "Yoga Tab 3", device: "tablet" }, { regex: "TB3-730X", model: "TAB3 7", device: "tablet" }, { regex: "TB3-710[IF]", model: "TAB3 7 Essential", device: "tablet" }, { regex: "TB-7703X", model: "TAB3 7 Plus", device: "tablet" }, { regex: "TB3-X70L", model: "TAB3 10 Plus", device: "tablet" }, { regex: "TB-8703X", model: "TAB3 8 Plus", device: "tablet" }, { regex: "TAB 2 A8-50LC", model: "TAB2 A8-50LC", device: "tablet" }, { regex: "501LV(?:[);/ ]|$)", model: 'TAB2 8.0"', device: "tablet" }, { regex: "TAB 2 A10-70L(?:[);/ ]|$)", model: "TAB 2 A10", device: "tablet" }, { regex: "(?:TB3-850[FM]|601LV)(?:[);/ ]|$)", model: "TAB3 8", device: "tablet" }, { regex: "602LV(?:[);/ ]|$)", model: "TAB3 8 Dual", device: "tablet" }, { regex: "TB-X304[FL]", model: "TAB4 10", device: "tablet" }, { regex: "TB-8504X", model: "TAB4 8", device: "tablet" }, { regex: "TB-8704X", model: "TAB4 8 Plus", device: "tablet" }, { regex: "(?:TB-X704[FVL]|70[12]LV)(?:[);/ ]|$)", model: "TAB4 10 Plus", device: "tablet" }, { regex: "801LV(?:[);/ ]|$)", model: 'TAB5 10.1"', device: "tablet" }, { regex: "TB-X103F(?:[);/ ]|$)", model: 'TAB10 10.1"', device: "tablet" }, { regex: "TB-X704A(?:[);/ ]|$)", model: "Moto Tab", device: "tablet" }, { regex: "TB-X605F(?:[);/ ]|$)", model: "Tab M10", device: "tablet" }, { regex: "TB-X705F(?:[);/ ]|$)", model: "Tab P10", device: "tablet" }, { regex: "TB-X705F(?:[);/ ]|$)", model: "Tab P10", device: "tablet" }, { regex: "TB-7104I(?:[);/ ]|$)", model: "Tab E7", device: "tablet" }, { regex: "TB-8304F1(?:[);/ ]|$)", model: "Tab E8", device: "tablet" }, { regex: "TB-7304X(?:[);/ ]|$)", model: "Tab 7 Essential", device: "tablet" }, { regex: "TB-7504X(?:[);/ ]|$)", model: "Tab 7", device: "tablet" }, { regex: "TB-X606[FXV](?:[);/ ]|$)", model: "Tab M10 FHD Plus", device: "tablet" }, { regex: "Lenovo ?B8000(-[FH])?", model: "Yoga Tablet 10", device: "tablet" }, { regex: "YOGA Tablet 2 Pro-1380[FL]", model: 'Yoga Tablet 2 Pro 13.3"', device: "tablet" }, { regex: "YOGA Tablet 2-1050[FL]", model: 'Yoga Tablet 2 10.1"', device: "tablet" }, { regex: "YOGA Tablet 2-830(?:[FL]|LC)", model: 'Yoga Tablet 2 8.0"', device: "tablet" }, { regex: "Lenovo ?B6000(-[FH])?", model: "Yoga Tablet 8", device: "tablet" }, { regex: "YT3-X90(L|F|X)", model: "Yoga 3 Pro", device: "tablet" }, { regex: "YT3-850[FL]", model: "Yoga Tab 3 8", device: "tablet" }, { regex: "YT3-850M", model: "Yoga Tab 3 10", device: "tablet" }, { regex: "YT-X703L", model: "Yoga Tab 3 Plus", device: "tablet" }, { regex: "S6000(?:[);/ ]|$)", model: "IdeaTab S6000", device: "tablet" }, { regex: "Lenovo ([ASB][0-9]{4})[A-Z]?\\-[EHF]", model: "IdeaTab $1", device: "tablet" }, { regex: "ThinkPadTablet_(A[0-9]{3})_", model: "ThinkPad Tablet $1", device: "tablet" }, { regex: "ThinkPad ?Tablet([^;/]*) Build", model: "ThinkPad Tablet$1", device: "tablet" }, { regex: "Lenovo ?A3300-(?:GV|H)", model: "TAB 2 A7-30", device: "tablet" }, { regex: "TAB 2 A7-30[HGD]C", model: "TAB 2 A7", device: "tablet" }, { regex: "TB-8504F", model: "TAB 4 8", device: "tablet" }, { regex: "TB-X304X", model: 'Tab 4 10.1"', device: "tablet" }, { regex: "TB-X304X", model: 'Tab 4 10.1"', device: "tablet" }, { regex: "TB-X304F", model: "TAB4 10", device: "tablet" }, { regex: "TB-X505[FX]", model: "M10", device: "tablet" }, { regex: "TB-X104[FXL]", model: "E10", device: "tablet" }, { regex: "Tab2A([0-9]-[0-9]{2}[a-z]?)", model: "TAB 2 A$1", device: "tablet" }, { regex: "IdeaTab[ \\-_]?([a-z0-9]+)", model: "IdeaTab $1", device: "tablet" }, { regex: "Yoga Tablet([^;/]+) Build", model: "Yoga Tablet$1", device: "tablet" }, { regex: "TB-8505F", model: "Tab M8", device: "tablet" }, { regex: "TB-8705F", model: "Tab M8 FHD", device: "tablet" }, { regex: "TB-8705F", model: "Tab M8 FHD", device: "tablet" }, { regex: "Lenovo (TB[0-9]?\\-[a-z0-9\\-]+) Build", model: "$1", device: "tablet" }, { regex: "L18011(?:[);/ ]|$)", model: "A5" }, { regex: "Z2 Plus", model: "Z2 Plus" }, { regex: "Z2151", model: "ZUK Edge" }, { regex: "Z213[12]", model: "ZUK Z2" }, { regex: "Z2121", model: "ZUK Z2 Pro" }, { regex: "ZUK[ -_]([^/;]*)(?: Build|\\))", model: "ZUK $1" }, { regex: "K10a40(?:[);/ ]|$)", model: "C2" }, { regex: "k50a40(?:[);/ ]|$)", model: "K3 Note" }, { regex: "A7010a48(?:[);/ ]|$)", model: "K4 Note" }, { regex: "K350t(?:[);/ ]|$)", model: "K5" }, { regex: "L38011(?:[);/ ]|$)", model: "K5 Play" }, { regex: "A7020a4[08](?:[);/ ]|$)", model: "K5 Note" }, { regex: "K31-t3(?:[);/ ]|$)", model: "K31" }, { regex: "(?:A6020a46|Vibe K5 Plus)(?:[);/ ]|$)", model: "Vibe K5 Plus" }, { regex: "(?:Lenovo-)?(?:A6020(?:a40|l36)|Vibe K5)(?:[);/ ]|$)", model: "Vibe K5" }, { regex: "VIBE Z2(?:[);/ ]|$)", model: "Vibe Z2" }, { regex: "VIBE C(?:[);/ ]|$)", model: "Vibe C" }, { regex: "VIBE X2(?:[);/ ]|$)", model: "Vibe X2" }, { regex: "VIBE V7(?:[);/ ]|$)", model: "Vibe V7" }, { regex: "VIBE S6i Plus(?:[);/ ]|$)", model: "Vibe S6i Plus" }, { regex: "VIBE[ _]S([23567])i(?:[);/ ]|$)", model: "Vibe S$1i" }, { regex: "k33a48(?:[);/ ]|$)", model: "K6" }, { regex: "P2A42(?:[);/ ]|$)", model: "P2" }, { regex: "k53a48(?:[);/ ]|$)", model: "K6 Note" }, { regex: "K33a42(?:[);/ ]|$)", model: "K6 Power" }, { regex: "P1ma40(?:[);/ ]|$)", model: "Vibe P1m" }, { regex: "Vibe P1 Turbo(?:[);/ ]|$)", model: "Vibe P1 Turbo" }, { regex: "(?:P1(?:a42|c72)|Vibe P1)(?:[);/ ]|$)", model: "Vibe P1" }, { regex: "A2016a40(?:[);/ ]|$)", model: "Vibe B" }, { regex: "A1010a20(?:[);/ ]|$)", model: "A Plus" }, { regex: "Z90a40(?:[);/ ]|$)", model: "Vibe Shot" }, { regex: "S1a40(?:[);/ ]|$)", model: "Vibe S1" }, { regex: "L78071(?:[);/ ]|$)", model: "Z5s" }, { regex: "L58041(?:[);/ ]|$)", model: "S5 Pro" }, { regex: "L18021(?:[);/ ]|$)", model: "A3" }, { regex: "PB2-670M(?:[);/ ]|$)", model: "Phab 2" }, { regex: "(S90-A|P70-A)(?:[);/ ]|$)", model: "$1" }, { regex: "IdeaPad ?([^;/]*) Build", model: "IdeaPad $1", device: "tablet" }, { regex: "VR-1541F", device: "wearable", model: "Mirage Solo" }, { regex: "LENOVO/81W8(?:[);/ ]|$)", device: "desktop", model: "IdeaPad S145-15IIL" }, { regex: "LENOVO/81MV(?:[);/ ]|$)", device: "desktop", model: "IdeaPad S145-15IWL" }, { regex: "LENOVO/81SS(?:[);/ ]|$)", device: "desktop", model: "Flex 14API 81SS" }, { regex: "Lenovo TAB ?([^/;]*) Build", model: "TAB $1", device: "tablet" }, { regex: "Lenovo ([^/;]*) Build", model: "$1" }, { regex: "(?:LNV-|Lenovo-)?Lenovo[ \\-_]?([a-z0-9_+\\-]+)", model: "$1" }] }, vte = { regex: "(?:SC7 PRO HD|S5A[1-4]|S4A[1-5]|S6A1|A811|A802)(?:[);/ ]|$)|Lexand ([^;/]+) Build", device: "smartphone", models: [{ regex: "A(811|802)", device: "tablet", model: "A$1" }, { regex: "S4A1", model: "Vega" }, { regex: "S4A2", model: "Irida" }, { regex: "S4A3", model: "Pallada" }, { regex: "S4A5", model: "Oxygen" }, { regex: "S4A4 NEON", model: "S4A4 Neon" }, { regex: "S5A1", model: "Callisto" }, { regex: "S5A2", model: "Overon" }, { regex: "S5A3", model: "Capella" }, { regex: "S5A4", model: "Argon" }, { regex: "S6A1", model: "Antares" }, { regex: "SC7 PRO HD", model: "SC7 PRO HD" }, { regex: "Lexand ([^;/]+) Build", model: "$1" }] }, Ste = { regex: "(MFC[0-9]{3}[a-z]{2,})", device: "tablet", models: [{ regex: "MFC191FR", model: "Tablet Ultra 3 XL" }, { regex: "MFC045FR", model: "TabTab" }, { regex: "MFC163FR", model: "Tablet Master 3" }, { regex: "MFC142FR", model: "Tablet Kids" }, { regex: "MFC250FR", model: "Tablet Junior" }, { regex: "MFC270FR", model: "Tablet Junior Power Touch" }, { regex: "MFC280FR", model: "Tablet Junior 2" }, { regex: "MFC156FR", model: "Tablet One" }, { regex: "MFC155FR", model: "Tablet Master" }, { regex: "MFC157FR", model: "Tablet Master 2" }, { regex: "MFC17[05]FR", model: "Tablet Ultra" }, { regex: "MFC375FR", model: "Tablet Ultra 2" }, { regex: "MFC162FR", model: "Power Tablet" }, { regex: "MFC180FR", model: "Tablet Advanced" }, { regex: "MFC181FR", model: "Tablet Advanced 2" }, { regex: "MFC500FR", model: "Tablet XL" }, { regex: "MFC190BBFR", model: "Barbie Tablet" }, { regex: "MFC195DCFR", model: "Tablet Disney Cars HD" }, { regex: "MFC195FUFR", model: "Furby Tablet" }, { regex: "MFC195DPFR", model: "Tablet Disney Princesse HD" }, { regex: "MFC140FR", model: "LapTab" }, { regex: "MFC141FR", model: "LapTab 2" }, { regex: "(MFC[0-9]{3}[a-z]{2,})", model: "$1" }] }, bte = { regex: "LG|Web0S; Linux/SmartTV|portalmmm/2\\.0 (?:KE|KG|KP|L3)|(?:VX[0-9]+|L-0[12]D|L-07C|P713|(LM-[A-Z][0-9]{3}[A-Z]{0,3}(?:\\(FGN?\\)|\\(G\\)|\\.FN|\\.F(?:GN?)?)?)|LM-(X625N1|G820QM[0127]))(?:[);/ ]|$)|NetCast|RS98[78]|RS500|VS(?:50[01]|835|876|880|98[0578]|99[056]|(410|415|425|500|880)PP)|VS820|VS870 4G|Nexsus 5|LML(41[34]D|211B|713D|212V)L|VK810 4G|VK815|X5-LG|L-05[DE]|L-03K|L-01[LJK]|L-52A|L-[45]1A|901LG|A001LG|80[12]LG|402LG|LGT32|L-02K|L-01F|LM-V40|DM-01K|LMX130IM", device: "smartphone", models: [{ regex: "DM-01K", model: "Disney Mobile DM-01K" }, { regex: "LG-D325", model: "L70" }, { regex: "LG-D340F8", model: "L70 Tri" }, { regex: "LM-X210APM", model: "Phoenix 4" }, { regex: "LG-P505R", model: "Phoenix" }, { regex: "LM-X210VPP", model: "Zone 4" }, { regex: "LM-X220PM", model: "Tribute Empire" }, { regex: "VS980|L-01F", model: "G2" }, { regex: "LG-D6(?:18|20)", model: "G2 Mini" }, { regex: "LG-D85[01258]|VS985", model: "G3" }, { regex: "LG-D72[2458]", model: "G3 Beat" }, { regex: "LG-H81[158]", model: "G4" }, { regex: "LG-H525n?", model: "G4c" }, { regex: "LG-(?:H540|H542|H630)", model: "G4 Stylus" }, { regex: "LG-H736", model: "G4s" }, { regex: "LG-H735", model: "G4 Beat" }, { regex: "LG-H8(?:20|3[01]|5[08]|6[08])|VS987|RS988", model: "G5" }, { regex: "LG-H84[05]", model: "G5 SE" }, { regex: "VS988|LG-H87(?:0DS|3)", model: "G6" }, { regex: "LM-Q850", model: "G7 Fit" }, { regex: "LM-Q910", model: "G7 One" }, { regex: "LM-G820(N|QM[0127]|UMB)?", model: "G8" }, { regex: "LM-G850", model: "G8X ThinQ" }, { regex: "LM-G810", model: "G8S ThinQ" }, { regex: "901LG(?:[);/ ]|$)", model: "G8X ThinQ" }, { regex: "VS501|LM-X120", model: "K20" }, { regex: "(?:LG-)?H502", model: "Magna" }, { regex: "(?:LG-)?H343", model: "Risio" }, { regex: "(?:LG-)?H650", model: "Zero" }, { regex: "(?:LG-)?M154", model: "Risio 2" }, { regex: "(?:LG-)?P500H", model: "Optimus One" }, { regex: "(L-05[DE])(?:[);/ ]|$)", model: "Optimus it $1" }, { regex: "LG-L160L(?:[);/ ]|$)", model: "Optimus LTE 2" }, { regex: "P713(?:[);/ ]|$)", model: "Optimus L7II" }, { regex: "L-01D(?:[);/ ]|$)", model: "Optimus LTE L-01D" }, { regex: "L-02D(?:[);/ ]|$)", model: "PRADA phone L-02D" }, { regex: "L-07C", model: "Optimus Bright L-07C" }, { regex: "(?:LG-)?F800(?:S|K|L)?", model: "V20" }, { regex: "LM-Q710(?:\\(FGN\\)|[\\.]?FGN)", model: "Q Stylus Plus" }, { regex: "801LG", model: "Q Stylus" }, { regex: "LM-Q[67]10\\.FG(?:[);/ ]|$)", model: "Q7" }, { regex: "LM-(Q725[KL]|Q610.FGN)(?:[);/ ]|$)", model: "Q7+" }, { regex: "LM-Q815[SL](?:[);/ ]|$)", model: "Q8+" }, { regex: "LM-Q925L(?:[);/ ]|$)", model: "Q9" }, { regex: "LM-Q730N(?:[);/ ]|$)", model: "Q70" }, { regex: "LGV33(?:[);/ ]|$)", model: "Qua Phone PX" }, { regex: "L-03K(?:[);/ ]|$)", model: "Style" }, { regex: "L-01L(?:[);/ ]|$)", model: "Style 2" }, { regex: "VS835(?:[);/ ]|$)", model: "Stylo 2 V" }, { regex: "L-41A(?:[);/ ]|$)", model: "Style 3" }, { regex: "LM-Q710|LML713DL", model: "Stylo 4" }, { regex: "(?:LM-Q720|LGL722DL)(?:[);/ ]|$)", model: "Stylo 5" }, { regex: "LM-Q730(?:[);/ ]|$)", model: "Stylo 6" }, { regex: "LM-G710(N|VM)?", model: "G7 ThinQ" }, { regex: "LM-X210CM", model: "Fortune 2" }, { regex: "LM-X410\\.F(?:[);/ ]|$)", model: "Premier Pro" }, { regex: "LML41[34]DL(?:[);/ ]|$)", model: "Premier Pro LTE" }, { regex: "LM-X525", model: "Q60" }, { regex: "LM-X210K", model: "X2" }, { regex: "LG-K580", model: "X Cam" }, { regex: "LM-X510WM", model: "X Power 3" }, { regex: "LM-X(?:41[05]K|410S)", model: "X4" }, { regex: "LM-X(415[LS]|410L)", model: "X4+" }, { regex: "LM-X410(?:\\.FN|\\(FG\\))", model: "K11" }, { regex: "LM-X(?:320|410[UP]M)", model: "K30" }, { regex: "LMX130IM", model: "W10" }, { regex: "LM-X410", model: "LM-X410" }, { regex: "LM-X420N", model: "X4 (2019)" }, { regex: "LG-X230", model: "K4" }, { regex: "LM-X420", model: "K40" }, { regex: "LM-X430(?:[);/ ]|$)", model: "K40S" }, { regex: "LG-X220", model: "K5" }, { regex: "LM-X540", model: "K50S" }, { regex: "(?:802LG|LM-X520)(?:[);/ ]|$)", model: "K50" }, { regex: "402LG", model: "Spray" }, { regex: "L-02K", model: "JoJo" }, { regex: "(?:LM-X510[KLS]|X5-LG)", model: "X5" }, { regex: "LM-X625N1", model: "X6" }, { regex: "LM-X625N", model: "X6 (2019)" }, { regex: "LGMS210", model: "Aristo" }, { regex: "LM-X210[G]?", model: "Aristo 2" }, { regex: "LM-X220", model: "Aristo 3" }, { regex: "LM-V40(?:5|9N)?(?:[);/ ]|$)", model: "V40 ThinQ" }, { regex: "LM-(?:V500N|V450)(?:[);/ ]|$)", model: "V50 ThinQ" }, { regex: "LM-V510N", model: "V50S ThinQ" }, { regex: "LM-Q920N", model: "Q92" }, { regex: "LM-Q927L", model: "Q9 One" }, { regex: "(?:LG-)?(?:RS987|H901|H96[0128]|VS990)", model: "V10" }, { regex: "LG-X240", model: "K8 (2017)" }, { regex: "(?:LG-)?RS500", model: "K8 4G" }, { regex: "(?:LG-)?VS500", model: "K8 V" }, { regex: "LM-X212\\(G\\)", model: "K8 (2018)" }, { regex: "(?:LG-)?H91[058]", model: "V20" }, { regex: "(?:LG-)?H990(?:DS|N|T)?", model: "V20" }, { regex: "(?:LG-)?LS997", model: "V20" }, { regex: "(?:LG-)?VS995", model: "V20" }, { regex: "(?:LG-)?US999", model: "V20" }, { regex: "(?:VS996|LG-(?:H933|H93[012]|H932PR|[LU]S998|AS998)|LGM-V300[KLS])(?:[);/ ]|$)", model: "V30" }, { regex: "L-01J(?:[);/ ]|$)", model: "V20 Pro" }, { regex: "(?:L-01K|LGV35)(?:[);/ ]|$)", model: "V30 Plus" }, { regex: "L-51A(?:[);/ ]|$)", model: "V60" }, { regex: "(?:L-52A|LM-G900N?)(?:[);/ ]|$)", model: "Velvet 5G" }, { regex: "(?:LM-G910)(?:[);/ ]|$)", model: "Velvet 4G" }, { regex: "(?:A001LG|LM-V600)(?:[);/ ]|$)", model: "V60 ThinQ 5G" }, { regex: "(?:LG-)?VS410PP", model: "Optimus Zone" }, { regex: "LM-V350[N]?", model: "V35" }, { regex: "(?:LG-)?VS415PP", model: "Optimus Zone 2" }, { regex: "(?:LG-)?VS425PP", model: "Optimus Zone 3" }, { regex: "(?:LG-)?K100", model: "K3" }, { regex: "(?:LG-?)?(?:K|MS)33[02]", model: "K7" }, { regex: "(?:LG-?)?(?:K|MS)350", model: "K8" }, { regex: "VS500PP", model: "K8 V" }, { regex: "(?:LG-)?K420(?:N)?", model: "K10" }, { regex: "(?:LG-)?K430(?:DS|DSF|DSY)?", model: "K10" }, { regex: "(?:LG-)?M250N?", model: "K10 (2017)" }, { regex: "(?:LG-)?F670[KLS]?", model: "K10" }, { regex: "(?:LG-)?M255", model: "K20" }, { regex: "(?:LG-?)?[MT]P260", model: "K20 Plus" }, { regex: "LM-K200(?:[);/ ]|$)", model: "K22" }, { regex: "LM-K300(?:[);/ ]|$)", model: "K31" }, { regex: "LM-K420(?:[);/ ]|$)", model: "K42" }, { regex: "LM-K500(?:[);/ ]|$)", model: "K51" }, { regex: "LM-K520(?:[);/ ]|$)", model: "K52" }, { regex: "LM-Q510N(?:[);/ ]|$)", model: "Q51" }, { regex: "LM-Q630N?(?:[);/ ]|$)", model: "Q61" }, { regex: "(?:LG-)?M700(?:N|A|DSK|AN)?", model: "Q6" }, { regex: "LM-X440IM", model: "W30" }, { regex: "(?:LG-?)?K220", model: "X Power" }, { regex: "(?:LG-?)?M320", model: "X Power 2" }, { regex: "(?:LG-)?K371", model: "Phoenix 2" }, { regex: "(?:LG-)?M150", model: "Phoenix 3" }, { regex: "(?:LG-)?F100[SL]", model: "Optimus Vu" }, { regex: "(?:LG-)?P880", model: "Optimus 4X HD" }, { regex: "(?:LG-)?(H340n?|H324)", model: "Leon" }, { regex: "(?:LG-)?H342", model: "Leon 4G LTE" }, { regex: "(?:LG-)?H422", model: "Spirit" }, { regex: "(?:LG)?C660", model: "Optimus Pro" }, { regex: "LML21(?:1B|2V)L", model: "Rebel 4" }, { regex: "VS876", model: "Lucid 3" }, { regex: "VS880(PP)?", model: "G Vista" }, { regex: "VS820", model: "Lancet" }, { regex: "VS870 4G", model: "Lucid 2" }, { regex: "LM-F100N?(?:[);/ ]|$)", device: "phablet", model: "WING" }, { regex: "LGUK410", model: 'G Pad 7.0" LTE', device: "tablet" }, { regex: "LGLK430", model: 'G Pad F 7.0"', device: "tablet" }, { regex: "LGLK430", model: 'G Pad F 7.0"', device: "tablet" }, { regex: "LG-V490", model: "G Pad 8.0", device: "tablet" }, { regex: "LGT01", model: 'G Pad 8.0" LTE', device: "tablet" }, { regex: "LG-V500", model: "G Pad 8.3", device: "tablet" }, { regex: "LG-V700", model: "G Pad 10.1", device: "tablet" }, { regex: "LG-V935", model: "G Pad II 10.1", device: "tablet" }, { regex: "LG-V521", model: "G Pad X 8.0", device: "tablet" }, { regex: "VK810", model: "G Pad 8.3 LTE", device: "tablet" }, { regex: "VK815", model: "G Pad X 8.3", device: "tablet" }, { regex: "LGT32", model: "Qua Tad PZ", device: "tablet" }, { regex: "LGT31", model: "Qua Tad PX", device: "tablet" }, { regex: "webOS.TV", device: "tv", model: "WebOS TV" }, { regex: "LGE_DLNA_SDK|NetCast", device: "tv", model: "NetCast" }, { regex: "LG Watch Urbane", device: "wearable", model: "Watch Urbane" }, { regex: "(LM-[A-Z]{1}[0-9]{3}([A-Z]{1,3})?)", model: "$1" }, { regex: "LGE(?: |-LG| LG-AX|-)([a-z0-9]+)", model: "$1" }, { regex: "FBDV/LG-([a-z0-9]+);FBSV", model: "$1" }, { regex: "LGE;([a-z0-9\\-]+)", model: "$1" }, { regex: "LG[ _\\-](V90.*|Optimus[ _\\-]Pad.*) Build", device: "tablet", model: "$1" }, { regex: "LG(?:/|-LG| |-)?([^/;]*) Build", model: "$1" }, { regex: "LG(?:/|-LG| |-)?([a-z0-9]+)", model: "$1" }, { regex: "LG; ([a-z0-9 ]+)", model: "$1" }, { regex: "portalmmm/2.0 ((?:KE|KG|KP|L3)[a-z0-9]+)", model: "$1" }, { regex: "(VX[0-9]+)", model: "$1" }, { regex: "Web0S; Linux/SmartTV", device: "tv", model: "" }] }, yte = { regex: "Lingwin[ _\\-]", device: "smartphone", models: [{ regex: "Lingwin[ _\\-]?([^/;]+) Build", model: "$1" }, { regex: "Lingwin[ _\\-]?([^);/ ]+)", model: "$1" }] }, wte = { regex: "LOGICOM[_ ]|(TAB950|TAB1062|E731|E812|E912|E1031|POWER BOT|La[ _]Tab[ _](?:7[24]|10[57]|114)|(?:B|C|M|ID|VR)[ _]?BOT[ _]?(?:TAB[ _])?([0-9]+\\+?)(?:PLUS)?|KT712A_4\\.4|L-?IXIR[0-9]*|L-ITE|L-EGANTONE(?:-R)?|L-?EMENT.+|Le[ _]?(?:Hop|Hello|Lift|Hola|Moov[2]?|Must(?: 2)?|Starter L|Fit FR|Spark|Prime|Smooth(?: FR)?))[_);/ ]", device: "tablet", models: [{ regex: "La[ _]Tab[ _](7[24]|10[57]|114)(?:[);/ ]|$)", model: "La Tab $1" }, { regex: "LOGICOM_LA_TAB_LINK_71", model: "La Tab Link 71" }, { regex: "KT712A_4.4|L-IXIR TAB 701 3G", model: "L-ixir Tab 701 3G" }, { regex: "LIXIR1041", model: "L-ixir Tab 1041" }, { regex: "L-?IXIR[ _]TAB[ _]([^);/]+)( Build|[);])", model: "L-ixir Tab $1" }, { regex: "L-ITE[ _](400M|452|50[46] HD|506R HD|552 HD)(?:[);/ ]|$)", device: "smartphone", model: "L-ite $1" }, { regex: "L-ITE[ _]([^;/]+) Build", model: "L-ite Tab $1" }, { regex: "L-?EMENT[ _]?(350|451|40[103]|55[013]|50[15]|500L?)(?:[);/ ]|$)", model: "L-ement $1", device: "smartphone" }, { regex: "L-?EMENT[ _](?:TAB)[ )]?([^);/]+)(?: Build|[);])", model: "L-ement Tab $1" }, { regex: "L-?EMENT[ _]?(74[01])(?:[);/ ]|$)", model: "L-ement Tab $1" }, { regex: "(TAB950|TAB1062|E731|E812|E912|E1031)(?:[);/ ]|$)", model: "$1" }, { regex: "POWER BOT", model: "POWER BOT" }, { regex: "((?:B|C|M|ID|VR))[ _]?BOT[ _]?((?:TAB[ _])?([0-9]+\\+?)(?:PLUS)?)", model: "$1 BOT $2" }, { regex: "Le Lift", model: "Le Lift", device: "smartphone" }, { regex: "Le Hola FR(?:[);/ ]|$)", model: "Le Hola FR", device: "smartphone" }, { regex: "Le[ _]Hola(?:[);/ ]|$)", model: "Le Hola", device: "smartphone" }, { regex: "LeMoov2(?:[);/ ]|$)", model: "Le Moov 2", device: "smartphone" }, { regex: "LeMoov(?:[);/ ]|$)", model: "Le Moov", device: "smartphone" }, { regex: "Le Fit FR(?:[);/ ]|$)", model: "Le Fit FR", device: "smartphone" }, { regex: "Le Hop(?:[);/ ]|$)", model: "Le Hop", device: "smartphone" }, { regex: "Le[ _]Hello(?:[);/ ]|$)", model: "Le Hello", device: "smartphone" }, { regex: "Le Smooth FR(?:[);/ ]|$)", model: "Le Smooth FR", device: "smartphone" }, { regex: "Le Smooth(?:[);/ ]|$)", model: "Le Smooth", device: "smartphone" }, { regex: "Le Must 2(?:[);/ ]|$)", device: "smartphone", model: "Le Must 2" }, { regex: "Le Must(?:[);/ ]|$)", model: "Le Must", device: "smartphone" }, { regex: "Le Starter L(?:[);/ ]|$)", model: "Le Starter L", device: "smartphone" }, { regex: "Le[ _]Spark(?:[);/ ]|$)", model: "Le Spark", device: "smartphone" }, { regex: "Le[ _]Prime(?:[);/ ]|$)", model: "Le Prime", device: "smartphone" }, { regex: "L-EGANTONE-R", model: "L-Egant One R", device: "smartphone" }, { regex: "L-EGANTONE", model: "L-Egant One", device: "smartphone" }] }, _te = { regex: "KONKA[_ ]([a-z0-9]+)", device: "smartphone", models: [{ regex: "E5660S", model: "Viva 5660s" }, { regex: "W830", model: "Tango 830" }, { regex: "W(9[67]0)", model: "Expose $1" }, { regex: "W990", model: "Tuxedo 990" }, { regex: "KONKA[_ ]([a-z0-9]+)", device: "feature phone", model: "$1" }] }, Tte = { regex: "(?:BIGCOOL|COOLFIVE|COOL-K|Just5|Link5|EASY(?:5|62)|CITY55|Cool55)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "BIGCOOL(?:[);/ ]|$)", model: "BigCool" }, { regex: "COOL-K(?:[);/ ]|$)", model: "Cool-K" }, { regex: "Cool55(?:[);/ ]|$)", model: "Cool 55" }, { regex: "COOLFIVE(?:[);/ ]|$)", model: "Cool Five" }, { regex: "Just5(?:[);/ ]|$)", model: "Just 5" }, { regex: "Link5(?:[);/ ]|$)", model: "Link 5" }, { regex: "EASY(5|62)(?:[);/ ]|$)", model: "Easy $1" }, { regex: "CITY55(?:[);/ ]|$)", model: "City 55" }] }, Ate = { regex: "(?:Browser-)?Karbonn|K9 Kavach 4G|K9[_ ]Viraat[_ ]Plus|K9 Music 4G|K9 Smart|K9 VIRAAT 4G|Aura (?:Sleek Plus|Power 4G Plus|Note Play)|Titanium[ _](?:3D-Plex|Octane Plus|Vista 4G|Jumbo|S360|S1[059]|S35|S20[13]|S22|S[15]|S200 HD|Frames S7|MOGHUL|S9)|K-lite F3|Sparkle V|Alfa A114 Quad|Quattro L55 HD", device: "smartphone", models: [{ regex: "K9 Kavach 4G", model: "K9 Kavach 4G" }, { regex: "K9 Music 4G", model: "K9 Music 4G" }, { regex: "K9 Smart 1GB", model: "K9 Smart" }, { regex: "K9 Smart 4G", model: "K9 Smart 4G" }, { regex: "K9 Smart Grand", model: "K9 Smart Grand" }, { regex: "K9 Smart Yuva", model: "K9 Smart Yuva" }, { regex: "K9 Smart", model: "K9 Smart" }, { regex: "K9[_ ]Viraat[_ ]Plus", model: "K9 Viraat Plus" }, { regex: "Aura Sleek Plus", model: "Aura Sleek Plus" }, { regex: "Aura Power 4G Plus", model: "Aura Power 4G Plus" }, { regex: "Aura Note Play", model: "Aura Note Play" }, { regex: "Alfa A114 Quad", model: "Alfa A114 Quad" }, { regex: "karbonnK9 Viraat 4G|K9 VIRAAT 4G", model: "K9 Viraat 4G" }, { regex: "Titanium[ _]S2[ _]Plus", model: "Titanium S2 Plus" }, { regex: "Titanium_S9Plus", model: "Titanium S9 Plus" }, { regex: "Titanium[_ ]S(99|360|1[059]|109|35|200 HD|20[13]|22|[15])(?:[);/ ]|$)", model: "Titanium S$1" }, { regex: "Titanium Vista 4G", model: "Titanium Vista 4G" }, { regex: "Titanium Jumbo 2", model: "Titanium Jumbo 2" }, { regex: "Titanium Jumbo", model: "Titanium Jumbo" }, { regex: "Titanium[ _]MOGHUL", model: "Titanium Moghul" }, { regex: "Titanium Frames S7", model: "Titanium Frames S7" }, { regex: "Titanium Octane Plus", model: "Titanium Octane Plus" }, { regex: "Titanium[ _]3D-Plex", model: "Titanium 3D Plex" }, { regex: "K-lite F3", model: "K-Lite F3" }, { regex: "Sparkle V", model: "Sparkle V" }, { regex: "Quattro L55 HD", model: "Quattro L55 HD" }, { regex: "Karbonn ([a-z0-9]+) WAP-Browser", model: "$1", device: "feature phone" }, { regex: "WAP Browser-Karbonn ([a-z0-9]+)/", model: "$1", device: "feature phone" }, { regex: "Karbonn_([^;/)]+)", model: "$1" }, { regex: "Karbonn ([^;/]+) Build", model: "$1" }, { regex: "Karbonn ([^;/]+)/", model: "$1" }] }, Pte = { regex: "SAGEM|portalmmm/2.0 (?:SG|my)", device: "smartphone", models: [{ regex: "SAGEM-(my[a-z0-9\\-]+)", model: "$1", device: "feature phone" }, { regex: "SAGEM ([a-z0-9]+)", model: "$1" }, { regex: "SAGEM-([a-z0-9\\-]+)", model: "$1" }, { regex: "portalmmm/2.0 ((?:SG|my)[a-z0-9]+)", model: "$1" }] }, Mte = { regex: "(?:MPQC|MPDC)[0-9]+|PH(?:150|340|350|360|451|500|520|544|604)|(?:MID(?:7C|74C|82C|84C|801|811|701|711|170|77C|43C|102C|103C|104C|114C)|MP100i OCTA|MP(?:843|717|718|1010|7007|7008|843|888|959|969)|MGP7)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "((?:MPQC|MPDC)[0-9]+[^/;)]+)(?: Build|\\))", model: "$1" }, { regex: "MP100i OCTA(?:[);/ ]|$)", model: "MP100i OCTA" }, { regex: "(MID(?:7C|74C|82C|84C|801|811|701|711|170|77C|43C|102C|103C|104C|114C)|MP(?:843|717|718|1010|7007|7008|843|888|959|969)|MGP7)(?:[);/ ]|$)", model: "$1" }, { regex: "(PH(?:150|340|350|360|451|500|520|544|604))", model: "$1", device: "smartphone" }] }, $te = { regex: "MAJESTIC[ _-]|CRONO ?[0-9]+|TAB (?:647|411) 3G|URANO 77LTE", device: "smartphone", models: [{ regex: "URANO 77LTE(?:[);/ ]|$)", model: "Urano 77 LTE" }, { regex: "TAB (647|411) 3G", model: "Tab $1 3G", device: "tablet" }, { regex: "MAJESTIC[ _]Tab([^;/]+)Build", model: "Tab$1", device: "tablet" }, { regex: "MAJESTIC[ _]Tab([^);/]+)(?:[);/]|$)", model: "Tab$1", device: "tablet" }, { regex: "MAJESTIC[ _]([^;/]+)Build", model: "$1" }, { regex: "MAJESTIC[ _]([^);/]+)(?:(?:[);/ ]|$)|$)", model: "$1" }, { regex: "CRONO ?([0-9]+) Build", model: "Crono $1" }, { regex: "CRONO ?([0-9]+)(?:[);/]|$)", model: "Crono $1" }] }, Cte = { regex: "Masstel", device: "smartphone", models: [{ regex: "Masstel[_ ](Juno[_ ]Q3|X9|N4[56]0|N5[2458]0|N536|M05|M1[29]0|M1[125]|M250|M25)(?:[);/ ]|$)", model: "$1" }, { regex: "Masstel[_ ]\\((M18)\\)", model: "$1" }, { regex: "Masstel_Tab7LTE(?:[);/ ]|$)", model: "Tab 7 LTE", device: "tablet" }, { regex: "Masstel Tab (840|700i)(?:[);/ ]|$)", model: "Tab $1", device: "tablet" }] }, Lte = { regex: "(?:Astro[_ ](?:5N_LTE|X4|5_GO_LTE|X55s)|Virtue Z5|Nitro[_ ](?:4S?|55R|5[XR]|[45] GO|4s LTE)|Gravity_55?_GO|Nitro_Phablet_9s)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Astro_5N_LTE", model: "Astro 5N LTE" }, { regex: "Astro_5_GO_LTE", model: "Astro 5 Go LTE" }, { regex: "Virtue Z5", model: "Virtue Z5" }, { regex: "Astro X55s", model: "Astro X55s" }, { regex: "Astro[_ ]X4", model: "Astro X4" }, { regex: "Nitro ([45]) GO", model: "Nitro $1 GO" }, { regex: "Nitro 4s LTE", model: "Nitro 4s LTE" }, { regex: "Nitro[ _]4s", model: "Nitro 4s" }, { regex: "Nitro_(4|55R|5[XR])", model: "Nitro $1" }, { regex: "Gravity_(55?)_GO", model: "Gravity $1 GO" }, { regex: "Nitro_Phablet_9s", device: "tablet", model: "Nitro Phablet 9s" }] }, Ete = { regex: "(?:Alpha[_ ]X|Maze Alpha)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Alpha[_ ]X(?:[);/ ]|$)", model: "Alpha X" }, { regex: "Maze Alpha(?:[);/ ]|$)", model: "Alpha" }] }, Ote = { regex: "(?:SmartPad7503G|M-SP10MXA|M-PPAB500|SmartPad970s2(?:3G)?|M[_-][MPS]P[0-9a-z]+|M-IPRO[0-9a-z]+|1AEC)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "SmartPad7503G(?:[);/ ]|$)", model: "SmartPad 750 3G" }, { regex: "SmartPad970s23G(?:[);/ ]|$)", model: "SmartPad 970 S2 3G" }, { regex: "SmartPad970s2(?:[);/ ]|$)", model: "SmartPad 970 S2" }, { regex: "M-MP84[02]M(?:[);/ ]|$)", model: 'SmartPad 8.0" Mobile' }, { regex: "M-MP940M(?:[);/ ]|$)", model: 'SmartPad 9.7" Mobile' }, { regex: "M-SP10MXA(?:[);/ ]|$)", model: 'SmartPad MX 10.1"' }, { regex: "M-SP8MXA(?:[);/ ]|$)", model: 'SmartPad MX 8.0"' }, { regex: "M-SP7HXAH(?:[);/ ]|$)", model: 'SmartPad HX 7.0"' }, { regex: "M-SP8HXAH(?:[);/ ]|$)", model: 'SmartPad HX 8.0" HD' }, { regex: "M-MP(?:710|720|725|726|740)GOx?(?:[);/ ]|$)", model: 'SmartPad 7.0" Go' }, { regex: "M-MP876S2(?:[);/ ]|$)", model: 'SmartPad 8.0" S2' }, { regex: "M-MP8S2[AB]?3G(?:[);/ ]|$)", model: 'SmartPad 8.0" S2 3G' }, { regex: "M-MP(101|102|860|875)S2[BW]?(?:[);/ ]|$)", model: "SmartPad $1 S2" }, { regex: "M-MP85S23G(?:[);/ ]|$)", model: "SmartPad 875 S2 3G" }, { regex: "M-SP1AGO3G", model: "SmartPad 10 Go 3G" }, { regex: "M-SP7xGO3G", model: 'SmartPad 10.1" iPro 3G' }, { regex: "1AEC", model: "SmartPad 10 Eclipse" }, { regex: "M-MP10[45][01]S2(?:[);/ ]|$)", model: 'SmartPad 10.1" S2' }, { regex: "M-MP1S2[AB]3G(?:[);/ ]|$)", model: 'SmartPad 10.1" S2 3G' }, { regex: "M-MP8[24]S4(?:[);/ ]|$)", model: 'SmartPad 8.0" S4' }, { regex: "M-MP8S4[AB]3G(?:[);/ ]|$)", model: 'SmartPad 8.0" S4 3G' }, { regex: "M-MP9S4A3G(?:[);/ ]|$)", model: 'SmartPad 9.7" S4 3G' }, { regex: "M-MP1[02]S4(?:[);/ ]|$)", model: 'SmartPad 10.1" S4' }, { regex: "M-MP1040MC?(?:[);/ ]|$)", model: 'SmartPad 10.1" HD S4 3G' }, { regex: "M-MP1S4[AB]3G(?:[);/ ]|$)", model: 'SmartPad 10.1" S4 3G' }, { regex: "M-SP10HXxH(?:[);/ ]|$)", model: 'SmartPad 10.1" HX HD' }, { regex: "M-SP10MXHA(?:[);/ ]|$)", model: 'SmartPad 10.1" MX' }, { regex: "M-SP10MXHL(?:[);/ ]|$)", model: 'SmartPad 10.1" MX Lite' }, { regex: "M-MP8PA3G(?:[);/ ]|$)", model: 'SmartPad 8.0" HD Pro 3G' }, { regex: "M-MP10PA(?:[);/ ]|$)", model: 'SmartPad 10.1" HD Pro' }, { regex: "M-MP10PA3G(?:[);/ ]|$)", model: 'SmartPad 10.1" HD Pro 3G' }, { regex: "M-IPRO([18][01]0)[BW](?:[);/ ]|$)", model: 'SmartPad 8.0" HD iPro$1 3G' }, { regex: "(?:M-MP75S23G|M-MP72[01]M)(?:[);/ ]|$)", model: 'SmartPad 7.0" Mobile', device: "phablet" }, { regex: "M-MP7S2[ABDK]3G(?:[);/ ]|$)", model: 'SmartPad 7.0" S2 3G', device: "phablet" }, { regex: "M-MP5303G(?:[);/ ]|$)", model: "SmartPad Mini Mobile", device: "phablet" }, { regex: "M-PPxB400(?:[);/ ]|$)", model: "PhonePad Duo B400", device: "phablet" }, { regex: "M-PPAG550(?:[);/ ]|$)", model: "PhonePad Duo G550", device: "phablet" }, { regex: "M-PPAB500(?:[);/ ]|$)", model: "PhonePad Duo B500", device: "phablet" }, { regex: "M-PP2G530(?:[);/ ]|$)", model: "PhonePad Duo G530", device: "phablet" }, { regex: "M-PPG700(?:[);/ ]|$)", model: "PhonePad Duo G700", device: "phablet" }, { regex: "M-PPxS531(?:[);/ ]|$)", model: "PhonePad Duo S531", device: "phablet" }, { regex: "M-PP2S550(?:[);/ ]|$)", model: "PhonePad Duo S550", device: "phablet" }, { regex: "M-PP2S650C?(?:[);/ ]|$)", model: "PhonePad Duo S650", device: "phablet" }, { regex: "M-PPxS551U(?:[);/ ]|$)", model: "PhonePad Duo S551U", device: "phablet" }, { regex: "M-PPAG4(?:[);/ ]|$)", model: "PhonePad Duo G4", device: "smartphone" }, { regex: "M-PP[ABC]G500(?:[);/ ]|$)", model: "PhonePad Duo G500", device: "smartphone" }, { regex: "M-PP2S500[BC]?(?:[);/ ]|$)", model: "PhonePad Duo S500", device: "smartphone" }, { regex: "M[_-]PP[Ax]X(470|510|520)U(?:[);/ ]|$)", model: "PhonePad Duo X$1U", device: "smartphone" }, { regex: "M-PPxG(400|501|[457][PM]?)(?:[);/ ]|$)", model: "PhonePad Duo G$1", device: "smartphone" }, { regex: "M-PPxS(532[LU]|470|501|5P?|7P?)(?:[);/ ]|$)", model: "PhonePad Duo S$1", device: "smartphone" }, { regex: "M-PPxG(450)(?:[);/ ]|$)", model: "PhonePad Duo G$1", device: "smartphone" }, { regex: "M-MP([0-9a-z]+)", model: "SmartPad $1" }] }, Nte = { regex: "Medion|(?:MD_)?LIFETAB|([SPX]10[0-9]{2}X|E10[45]1X|X5001|P851X|P850X|E691X|E1050X)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:MD_)?LIFETAB_([a-z0-9]+)", device: "tablet", model: "Lifetab $1" }, { regex: "(E450[46]|E5004|S5004|X5001|E5020|P5015)(?:[);/ ]|$)", model: "Life $1" }, { regex: "(B5530)(?:[);/ ]|$)", model: "$1" }, { regex: "(E10[45]1X)(?:[);/ ]|$)", device: "tablet", model: "$1" }, { regex: "([SPX]10[0-9]{2}X|P851X|P850X|E691X|E1050X)(?:[);/ ]|$)", model: "Lifetab $1", device: "tablet" }, { regex: "Medion(?: Smartphone)? ([^/;]+) Build", model: "$1" }] }, Dte = { regex: "MEEG[ _-]", device: "smartphone", models: [{ regex: "MEEG[ _\\-]?([^/;]+) Build", model: "$1" }, { regex: "MEEG[ _\\-]?([^);/ ]+)", model: "$1" }] }, kte = { regex: "(?:EASYSMARTM3|EasySmart M2)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "EASY ?SMART ?M([32])", model: "Easy Smart M$1" }] }, Gte = { regex: "Meizu|MZ-[a-z]|(?<!POCO )(M04[05]|MZ-16th(?: Plus)?|MZ-16[st]|M7[12]1C|M35[1356]|M612C|M578CA|M181[36]|M1822|M681C|M6T|MX[ -]?[2345](?: Pro)?|(?:MZ-)?m[1-6] note|M621C|M1852|M57[18]C|M3[ESX]|M031|m1 metal|M1 E|M2|M2 E|M5s Build|PRO [67]|PRO 7-[HS]| 15 Lite| 16th|MZ-15 (?:Lite|Plus)|MZ-16 X)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:MZ-)?M571C", device: "phablet", model: "M2 Note" }, { regex: "(?:MZ-|Meizu-)?m([1-6])[_ ]note(?:[);/ ]|$)", device: "phablet", model: "M$1 Note" }, { regex: "M1 E(?:[);/ ]|$)", model: "M1E" }, { regex: "M2 E(?:[);/ ]|$)", model: "M2E" }, { regex: "(?:MZ-)?M578C[A]?|M2(?:[);/ ]|$)", model: "M2" }, { regex: "M681C(?:[);/ ]|$)", model: "M3 Note", device: "phablet" }, { regex: "M621C(?:[);/ ]|$)", model: "M5 Note", device: "phablet" }, { regex: "M711C(?:[);/ ]|$)", model: "M6" }, { regex: "M721C(?:[);/ ]|$)", model: "M6 Note", device: "phablet" }, { regex: "M6T", model: "M6T" }, { regex: "M3E", model: "M3E" }, { regex: "M3S", model: "M3S" }, { regex: "M3X", model: "M3X" }, { regex: "M5S|M612C", model: "M5S" }, { regex: "(M04[05]|MX[ -]?2)(?:[);/ ]|$)", model: "MX2" }, { regex: "(M35[1356]|MX[ -]?3)(?:[);/ ]|$)", model: "MX3" }, { regex: "MX[ -]?4 Pro(?:[);/ ]|$)", model: "MX4 Pro" }, { regex: "MX[ -]?4(?:[);/ ]|$)", model: "MX4" }, { regex: "(Meizu[- _])?MX[ -]?5(?:[);/ ]|$)", model: "MX5" }, { regex: "m1 metal", model: "M1 Metal" }, { regex: "M1813(?:[);/ ]|$)", model: "M8" }, { regex: "M1816(?:[);/ ]|$)", model: "M8 Lite" }, { regex: "PRO 7-[HS](?:[);/ ]|$)", model: "PRO 7" }, { regex: "PRO 7 Plus(?:[);/ ]|$)", model: "Pro 7 Plus" }, { regex: "PRO ([67])", model: "PRO $1" }, { regex: "M031(?:[);/ ]|$)", model: "MX Dual Core" }, { regex: "M1852(?:[);/ ]|$)", model: "X8" }, { regex: "M1822(?:[);/ ]|$)", model: "Note 8" }, { regex: "MZ-16T(?:[);/ ]|$)", model: "16T" }, { regex: "(?:MZ-)?16th Plus(?:[);/ ]|$)", model: "16th Plus" }, { regex: "MZ-15 Plus(?:[);/ ]|$)", model: "15 Plus" }, { regex: "(?:MZ-15 Lite| 15 Lite)(?:[);/ ]|$)", model: "15 Lite" }, { regex: "MZ-16th| 16th(?:[);/ ]|$)", model: "16th" }, { regex: "MZ-16 X(?:[);/ ]|$)", model: "16X" }, { regex: "Meizu[_ ]note([89])(?:[);/ ]|$)", device: "phablet", model: "Note $1" }, { regex: "(?:MZ-)?Meizu[_ ]([^/;]+) Build", model: "$1" }, { regex: "(?:MZ-)?Meizu[_ ]([a-z0-9_]+)", model: "$1" }, { regex: "MZ-([^/;]+) Build", model: "$1" }] }, Bte = { regex: "(?:(?<!MI CC 9 )Meitu[2]?|MP1503|MP1512|MP160[235]|MP170[19]|MP171[138])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "MP1503(?:[);/ ]|$)", model: "M6" }, { regex: "MP1512(?:[);/ ]|$)", model: "M6s" }, { regex: "MP1602(?:[);/ ]|$)", model: "T8" }, { regex: "MP1605(?:[);/ ]|$)", model: "V6" }, { regex: "MP17(?:01|13)(?:[);/ ]|$)", model: "T8s" }, { regex: "MP1718(?:[);/ ]|$)", model: "T9" }, { regex: "MP1603(?:[);/ ]|$)", model: "M8" }, { regex: "MP17(?:09|11)(?:[);/ ]|$)", model: "M8s" }, { regex: "Meitu2(?:[);/ ]|$)", model: "2" }, { regex: "Meitu (Kiss|[MV]4)(?:[);/ ]|$)", model: "$1" }] }, Ite = { regex: "SlidePad ?([^;/]*) Build|SPNG?[0-9]{2,4}[a-z]{0,2}(?:[);/ ]|$)|SP704CE?|SP-NG708-3G", device: "tablet", models: [{ regex: "SlidePad ?([^;/]*) Build", model: "SlidePad $1" }, { regex: "SPNG([0-9]{2,4}[a-z]{0,2})(?:[);/ ]|$)", model: "SlidePad NG$1" }, { regex: "SP-NG(708)-3G(?:[);/ ]|$)", model: "SlidePad NG$1 3G" }, { regex: "SP704(CE?)", model: "SlidePad 704$1" }] }, Rte = { regex: "(M785|800P3[12]C|101P51C|X1010)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "M785(?:[);/ ]|$)", model: "Xpress Smartlife M785" }, { regex: "X1010(?:[);/ ]|$)", model: "X1010" }, { regex: "800P31C(?:[);/ ]|$)", model: "Xpress Smartlife 800P31C" }, { regex: "800P32C(?:[);/ ]|$)", model: "Xpress Smartlife 800P32C" }, { regex: "101P51C(?:[);/ ]|$)", model: "Xpress Smartlife 101P51C" }] }, Fte = { regex: "MIO(?:/)?([a-z0-9]+)|(?:MOBIX M6|Mio TouchPad 7 Quad Core)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "MOBIX M6(?:[);/ ]|$)", model: "Mobix M6" }, { regex: "MIO(?:/)?([a-z0-9]+)", model: "$1" }, { regex: "Mio TouchPad 7 Quad Core", device: "tablet", model: "TouchPad 7 Quad Core" }] }, Vte = { regex: "MIDM[_-]|MPM[_-]", device: "smartphone", models: [{ regex: "MIDM[_-]([a-z0-9]+)", model: "MIDM $1", device: "tablet" }, { regex: "MPM[_-]([a-z0-9]+)", model: "MPM $1" }] }, Hte = { regex: "MITSU|portalmmm/[12]\\.0 M", device: "feature phone", models: [{ regex: "MITSU/[a-z0-9.]+ \\(([a-z0-9]+)\\)", model: "$1" }, { regex: "MITSU[ \\-]?([a-z0-9]+)", model: "$1" }, { regex: "portalmmm/[12]\\.0 (M[a-z0-9]+)", model: "$1" }] }, Ute = { regex: "(M35|M20|G7106|G7108)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(M[0-9]{1,2})(?:[);/ ]|$)", model: "$1" }, { regex: "(G[0-9]{4})(?:[);/ ]|$)", model: "$1" }] }, Xte = { regex: "(MS5[50]X6|MS55X5|MS55L1|MS50L1|MS43A3000|MS45A4000|MS50A4000|MS50A4500|MS50A5000|MS50A6000|MS50B11000|MB-2900 QUATTRO|POLYS[_ ]MS45L1|Wave5)", device: "smartphone", models: [{ regex: "MS50X6", model: "Atmos II" }, { regex: "POLYS[_ ]MS45L1", model: "Polys MS45L1" }, { regex: "MS55X6", model: "Atmos Pro II" }, { regex: "MS55X5", model: "Atmos Pro" }, { regex: "MS55L1", model: "GAIA" }, { regex: "MS50L1", model: "Inti" }, { regex: "MB-2900 QUATTRO", model: "MB-2900 Quattro" }, { regex: "MS43A3000", model: "MS43A3000" }, { regex: "MS45A4000", model: "eOn 45" }, { regex: "MS50A4000", model: "eOn 50" }, { regex: "MS50A4500", model: "eOn 50 Elegance" }, { regex: "MS50A5000", model: "eOn 50 Quad 8" }, { regex: "MS50A6000", model: "eOn 50 Quad 16" }, { regex: "MS50B11000", model: "MS50B11000" }, { regex: "Wave5", model: "Wave 5" }] }, Wte = { regex: "Mobicel_(R1)|(?:HYPE|DANDY(?:_ZAM)?|(?<!SMADL )Matrix|TRENDY PLUS|FENDY_DS|TANGO_LITE|BLINK|BERRY[_ ]?(?:[12]|PLUS))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Matrix", model: "Matrix" }, { regex: "BLINK", model: "Blink" }, { regex: "BERRY1", model: "Berry 1" }, { regex: "BERRY 2", model: "Berry 2" }, { regex: "BERRY[_ ]PLUS", model: "Berry Plus" }, { regex: "TRENDY PLUS", model: "Trendy Plus" }, { regex: "HYPE", model: "Hype" }, { regex: "DANDY_ZAM", model: "Dandy Zam" }, { regex: "DANDY", model: "Dandy" }, { regex: "TANGO_LITE", model: "Tango Lite" }, { regex: "FENDY_DS", model: "Fendy DS" }, { regex: "Mobicel_(R1)", model: "$1" }] }, Yte = { regex: "Mobiistar|Zumbo[ _]S|PRIME X MAX|X1 Notch|E1 Selfie", device: "smartphone", models: [{ regex: "X1 Notch(?:[);/ ]|$)", model: "X1 Notch" }, { regex: "E1 Selfie(?:[);/ ]|$)", model: "E1 Selfie" }, { regex: "mobiistar_LAI_Zumbo(?:[);/ ]|$)", model: "Zumbo" }, { regex: "Zumbo[_ ]S[_ ]2017[_ ]Lite(?:[);/ ]|$)", model: "Lai Zumbo S Lite (2017)" }, { regex: "Zumbo[_ ]S[_ ]2017(?:[);/ ]|$)", model: "Lai Zumbo S (2017)" }, { regex: "mobiistar ZUMBO S2( Dual)", model: "Zumbo S2" }, { regex: "Mobiistar_LAI_Zumbo_J_2017(?:[);/ ]|$)", model: "Lai Zumbo J (2017)" }, { regex: "Mobiistar_LAI_Zumbo_J(?:[);/ ]|$)", model: "Lai Zumbo J" }, { regex: "Mobiistar_Zumbo_J2", model: "Lai Zumbo J2" }, { regex: "Mobiistar[_ ]Zumbo[_ ]S2", model: "Zumbo S2" }, { regex: "mobiistar ZUMBO Power", model: "Zumbo Power" }, { regex: "mobiistar[ _]LAI[ _]YUNA[ _]([1XCS])", model: "Lai Yuna $1" }, { regex: "mobiistar LAI Yuki", model: "Lai Yuki" }, { regex: "mobiistar[ _]LAI[ _]ZORO[ _]([23])", model: "Lai Zoro $1" }, { regex: "mobiistar[ _]LAI[ _]Zena", model: "Lai Zena" }, { regex: "mobiistar[ _]LAI[ _]Z([12])?", model: "Lai Z$1" }, { regex: "mobiistar_ZORO_4G", model: "Zoro 4G" }, { regex: "mobiistar touch LAI 512", model: "Touch Lai 512" }, { regex: "mobiistar LAI 504([KC])", model: "Lai 504$1" }, { regex: "mobiistar LAI Y", model: "Lai Y" }, { regex: "mobiistar PRIME X 2017", model: "Prime X" }, { regex: "mobiistar[ _]PRIME[ _](X1|558|X[ _]Plus|X[ _]Grand) Build", model: "Prime $1" }, { regex: "PRIME X MAX 2018", model: "Prime X Max" }, { regex: "mobiistar[ _]KOOL([ _]Lite)?", model: "Kool$1" }, { regex: "mobiistar KAT 452 Build", model: "Kat 452" }, { regex: "mobiistar_LAI_YOLLO Build", model: "Lai Yollo" }, { regex: "Mobiistar[ _]([^;/)]+)(?: Build|[;)])", model: "$1" }] }, Kte = { regex: "Primo ?(?:9[13]|81|76)|Enjoy 7 Plus", device: "tablet", models: [{ regex: "Primo ?(9[13]|76|81)", model: "Primo $1" }, { regex: "Enjoy 7 Plus", model: "Enjoy 7 Plus" }] }, Qte = { regex: "MLLED[ _]", device: "smartphone", models: [{ regex: "MLLED[ _]([^;/]+)Build", model: "$1" }, { regex: "MLLED[ _]([^);/]+)(?:[);/]|$)", model: "$1" }] }, jte = { regex: "(Cynus[ _][^/;)]+)( Build|\\))", device: "smartphone", model: "$1" }, Zte = { regex: "(?:KM9PRO|BB2 PRO|K[I]{1,3} PRO|KI PLUS|KM9_TV_BOX|M8SPROW|M8S (?:PLUS|PRO) (?:DVB|[LW]|PLUS)|M8S (?:MAX|PRO))(?:[);/ ]|$)", device: "tv", models: [{ regex: "KM9PRO(?:[);/ ]|$)", model: "KM9 Pro" }, { regex: "KM9_TV_BOX(?:[);/ ]|$)", model: "KM9 TV Box" }, { regex: "BB2 PRO(?:[);/ ]|$)", model: "BB2 Pro" }, { regex: "(K[I]{1,3}) PRO(?:[);/ ]|$)", model: "$1 Pro" }, { regex: "KI PLUS(?:[);/ ]|$)", model: "KI Plus" }, { regex: "M8SPROW(?:[);/ ]|$)", model: "M8S Pro W" }, { regex: "M8S PLUS DVB(?:[);/ ]|$)", model: "M8S Plus DVB" }, { regex: "M8S PLUS ([LW])(?:[);/ ]|$)", model: "M8S Plus $1" }, { regex: "M8S PRO ([LW])(?:[);/ ]|$)", model: "M8S Pro $1" }, { regex: "M8S PRO PLUS(?:[);/ ]|$)", model: "M8S Pro Plus" }, { regex: "M8S PRO(?:[);/ ]|$)", model: "M8S Pro" }, { regex: "M8S MAX(?:[);/ ]|$)", model: "M8S Max" }] }, zte = { regex: "Modecom|Free(?:Way )?Tab|xino z[\\d]+ x[\\d]+", device: "tablet", models: [{ regex: "xino Z([\\d]+) X([\\d]+)", model: "Xino Z$1 X$2", device: "smartphone" }, { regex: "FreeTab[ _\\-]?([^/;]+)? Build", model: "FreeTab $1" }, { regex: "FreeTab[ _\\-]?((?!Build)[^);/ ]+)?", model: "FreeTab $1" }, { regex: "FreeWay Tab[ _\\-]?([^/;]+) Build", model: "FreeWay Tab $1" }, { regex: "FreeWay Tab[ _\\-]?((?!Build)[^);/ ]+)", model: "FreeWay Tab $1" }] }, qte = { regex: "Mofut", device: "smartphone", models: [{ regex: "Mofut[ _\\-]?([^/;]+) Build", model: "$1" }, { regex: "Mofut[ _\\-]?((?!Build)[^);/ ]+)", model: "$1" }] }, Jte = { regex: "BrightSign", device: "tv", models: [{ regex: "(HD1023|XD233|XD230|XD1030|XT114[34]|4K1142|LS424)", model: "$1" }] }, ere = { regex: "MOT(?!TO)|(?<!AN)DROID ?(?:Build|[a-z0-9]+)|portalmmm/2.0 (?:E378i|L6|L7|v3)|XOOM [^;/]*Build|XT1941-2|XT1924-9|XT1925-10|XT1965-6|XT1970-5|XT1799-2|XT1021|XT1710-08|XT180[3-5]|XT194[23]-1|XT1929-15|(?:XT|MZ|MB|ME)[0-9]{3,4}[a-z]?(?:\\(Defy\\)|-0[1-5])?(?:[;]? Build|\\))", device: "smartphone", models: [{ regex: "MOT-V360", model: "V360", device: "feature phone" }, { regex: "(?:MOT-|Motorola-)?XT300", model: "Spice" }, { regex: "(?:MOT-|Motorola-)?XT30[35]", model: "Motosmart ME" }, { regex: "(?:MOT-|Motorola-)?XT31[16]", model: "Fire" }, { regex: "(?:MOT-|Motorola-)?XT32[01]", model: "Defy Mini" }, { regex: "(?:MOT-|Motorola-)?XT3(?:89|90)", model: "Motosmart" }, { regex: "(?:MOT-|Motorola-)?XT502", model: "Quench" }, { regex: "(?:MOT-|Motorola-)?XT531", model: "Fire XT" }, { regex: "(?:MOT-|Motorola-)?XT535", model: "Defy" }, { regex: "(?:MOT-|Motorola-)?XT55[567]C?", model: "Defy XT" }, { regex: "(?:MOT-|Motorola-)?XT603", model: "Admiral" }, { regex: "(?:MOT-|Motorola-)?XT610", model: "Droid Pro" }, { regex: "(?:MOT-|Motorola-)?XT615", model: "Motoluxe" }, { regex: "(?:MOT-|Motorola-)?XT621", model: "Primus" }, { regex: "(?:MOT-|Motorola-)?XT626", model: "IronRock" }, { regex: "(?:MOT-|Motorola-)?XT682", model: "Atrix" }, { regex: "(?:MOT-|Motorola-)?XT685", model: "Motoluxe Dual-SIM" }, { regex: "(?:MOT-|Motorola-)?XT687", model: "Atrix TV" }, { regex: "(?:MOT-|Motorola-)?XT720", model: "Milestone" }, { regex: "(?:MOT-|Motorola-)?XT800W", model: "Glam" }, { regex: "(?:MOT-|Motorola-)?XT860", model: "Milestone 3" }, { regex: "(?:MOT-|Motorola-)?XT881", model: "Electrify 2" }, { regex: "(?:MOT-|Motorola-)?XT882", model: "Moto XT882" }, { regex: "(?:MOT-|Motorola-)?XT88[56]", model: "Droid RAZR V" }, { regex: "(?:MOT-|Motorola-)?XT890", model: "Droid RAZR i" }, { regex: "(?:MOT-|Motorola-)?XT894", model: "Droid 4" }, { regex: "(?:MOT-|Motorola-)?XT897", model: "Photon Q" }, { regex: "(?:MOT-|Motorola-)?XT901", model: "Electrify M" }, { regex: "(?:MOT-|Motorola-)?XT90[567]", model: "Droid RAZR M" }, { regex: "(?:MOT-|Motorola-)?XT910S?", model: "Droid RAZR" }, { regex: "(?:MOT-|Motorola-)?XT91[4568]", model: "Droid RAZR D1" }, { regex: "(?:MOT-|Motorola-)?XT9(?:19|20)", model: "Droid RAZR D3" }, { regex: "(?:MOT-|Motorola-)?XT925", model: "Droid RAZR HD" }, { regex: "(?:MOT-|Motorola-)?XT102[12]", model: "Moto E" }, { regex: "(?:MOT-|Motorola-)?XT1706", model: "Moto E3 Power" }, { regex: "(?:MOT-|Motorola-)?XT1924-9|moto e5 plus", model: "Moto E5 Plus" }, { regex: "Moto E5 Play", model: "Moto E5 Play" }, { regex: "Moto E5 go(?:[);/ ]|$)", model: "Moto E5 Go" }, { regex: "Moto E6(?:[);/ ]|$)", model: "Moto E6" }, { regex: "(?:MOT-|Motorola-)?XT1030", model: "Droid Mini" }, { regex: "(?:MOT-|Motorola-)?XT1096", model: "Moto X2" }, { regex: "(?:MOT-|Motorola-)?XT1254", model: "Droid Turbo" }, { regex: "(?:MOT-|Motorola-)?XT10(?:28|3[1234]|68|69)", model: "Moto G" }, { regex: "(?:MOT-|Motorola-)?XT1799-2", model: "Moto G5s" }, { regex: "(?:MOT-|Motorola-)?XT180[3-5]", model: "Moto G5s Plus" }, { regex: "(?:MOT-|Motorola-)?XT168[57]", model: "Moto G5 Plus" }, { regex: "(?:MOT-|Motorola-)?XT1670", model: "Moto G5" }, { regex: "(?:MOT-|Motorola-)?XT1925-10", model: "Moto G6" }, { regex: "(?:MOT-|Motorola-)?XT1965-6", model: "Moto G7 Plus" }, { regex: "(?:MOT-|Motorola-)?XT10(?:49|5[23568]|60|9[23457])", model: "Moto X" }, { regex: "(?:MOT-|Motorola-)?XT1562", model: "Moto X Play" }, { regex: "(?:MOT-|Motorola-)?XT1572", model: "Moto X Style" }, { regex: "(?:MOT-|Motorola-)?XT1080", model: "Droid Ultra" }, { regex: "(?:MOT-|Motorola-)?XT1650-05", model: "Moto Z" }, { regex: "moto z4(?:[);/ ]|$)", model: "Moto Z4" }, { regex: "(?:MOT-|Motorola-)?XT1635(?:-0[1-3])?", model: "Moto Z Play" }, { regex: "(?:MOT-|Motorola-)?XT1710-(?:-0[28])?", model: "Moto Z2 Play" }, { regex: "(?:MOT-|Motorola-)?XT1789-05", model: "Moto Z2 Force" }, { regex: "(?:MOT-|Motorola-)?XT1929-15", model: "Moto Z3" }, { regex: "(?:MOT-|Motorola-)?XT1663", model: "Moto M" }, { regex: "(?:MOT-|Motorola-)?XT1943-1", model: "P30" }, { regex: "(?:MOT-|Motorola-)?XT1941-2", model: "P30 Play" }, { regex: "(?:MOT-|Motorola-)?XT1942-1", model: "P30 Note" }, { regex: "(?:MOT-|Motorola-)?XT1970-5", model: "One Vision" }, { regex: "(?:MOT-|Motorola-)?one zoom", model: "One Zoom" }, { regex: "motorola one action", model: "One Action" }, { regex: "motorola one macro", model: "One Macro" }, { regex: "motorola one 5G UW", model: "One 5G UW" }, { regex: "moto g power", model: "Moto G Power" }, { regex: "moto g\\(([0-9])\\) power lite", model: "Moto G$1 Power Lite" }, { regex: "moto g\\(([0-9])\\) power", model: "Moto G$1 Power" }, { regex: "moto g\\(([0-9])\\) supra", model: "Moto G$1 Supra" }, { regex: "moto g\\(([0-9])\\) plus", model: "Moto G$1 Plus" }, { regex: "moto g\\(([0-9]+)\\) play", model: "Moto G$1 Play" }, { regex: "moto g\\(([0-9]+)\\)", model: "Moto G$1" }, { regex: "Moto ([CGEXZ]) ?\\(([a-z0-9]+)\\)( Plus| Play)?", model: "Moto $1$2$3" }, { regex: "Moto ?([CGEXZ])([0-9]+)( Plus| Play)?", model: "Moto $1$2$3" }, { regex: "(?:Motorola-)?Moto[ _]?([CGEXZ])([ _](?:Plus|Play))?", model: "Moto $1$2" }, { regex: "MotoroiX", model: "MotoroiX" }, { regex: "Motorola[ _\\-]([^/;]+)(?: Build|[);])", model: "$1" }, { regex: "MOTORAZR[ _\\-]([a-z0-9]+)", model: "RAZR $1" }, { regex: "MOTORIZR[ _\\-]([a-z0-9]+)", model: "RIZR $1" }, { regex: "MOT(?!OROLA)[O]?[_\\-]?([a-z0-9.]+)", model: "$1" }, { regex: "(?<!AN)DROID ?([a-z0-9 ]*) Build", model: "DROID $1" }, { regex: "(?<!AN)DROID ?([a-z0-9]+)", model: "DROID $1" }, { regex: "portalmmm/2.0 ((?:E378i|L6|L7|V3)[a-z0-9]+)", model: "$1" }, { regex: "(XOOM [^;/]*)Build", device: "tablet", model: "$1" }, { regex: "(MZ[0-9]{3})(?:[);/ ]|$)", device: "tablet", model: "$1" }, { regex: "((?:ME|MB|XT)[0-9]{3,4}(?:\\(Defy\\))?)(?:[);/ ]|$)", model: "$1" }] }, tre = { regex: "MOVIC", device: "smartphone", models: [{ regex: "MOVIC[ -]W([2345])", model: "W$1" }] }, rre = { regex: "MTN-", device: "smartphone", models: [{ regex: "MTN-(L860|S620)", model: "Sm@rt Mini $1" }, { regex: "MTN-8978P", device: "tablet", model: "Steppa" }, { regex: "MTN-([a-z0-9_\\-]+)", model: "MTN-$1" }] }, ore = { regex: "MyTAB[ _-](?:8 MINI Dual Core|U55GT)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "MyTAB[ _-]8 MINI Dual Core(?:[);/ ]|$)", model: "8 Mini Dual Core" }, { regex: "MyTAB-U55GT(?:[);/ ]|$)", model: "U55GT" }] }, nre = { regex: "(?:MyPhone|MyPad|MyTab)[ _][^;/)]+( Build|\\))|Cube_LTE|myTab10II|HAMMER[ _](Blade2_PRO|IRON_3|Explorer|ENERGY|Titan 2|AXE[_ ](?:M[_ ]LTE|Pro)|Iron 2|Active[2]?(_LTE)?)|C-Smart_pix|myPhone_Fun_8|FUN_18x9|MyPhoneMY27|Prime_4_Lite|myA17|myX12|Pocket_2|Prime_18x9|Prime3Lite|myT6 DTV|myXI1 (?:Plus|Pro)|myXI3|Q_Smart_BE", device: "smartphone", models: [{ regex: "MyPad[ _]([^;/]+) Build", model: "MyPad $1", device: "tablet" }, { regex: "MyTab[ _]([^;/]+) Build", model: "MyTab $1", device: "tablet" }, { regex: "myTab_10III", model: "MyTab 10 III", device: "tablet" }, { regex: "myTab10II", model: "MyTab 10 II", device: "tablet" }, { regex: "myT6 DTV", model: "myT6 DTV", device: "tablet" }, { regex: "Cube_LTE", model: "Cube LTE" }, { regex: "Prime_4_Lite", model: "Prime 4 Lite" }, { regex: "HAMMER[ _]ENERGY", model: "Hammer Energy" }, { regex: "HAMMER_AXE[_ ]M[_ ]LTE", model: "Hammer Axe M LTE" }, { regex: "Hammer Titan 2", model: "Hammer Titan 2" }, { regex: "Hammer[ _]Iron[ _](2|3)", model: "Hammer Iron $1" }, { regex: "Hammer[ _]Explorer", model: "Hammer Explorer" }, { regex: "Hammer Active(?:[);/ ]|$)", model: "Hammer Active" }, { regex: "Hammer_Active2(?:[);/ ]|$)", model: "Hammer Active 2" }, { regex: "Hammer_Active2_LTE(?:[);/ ]|$)", model: "Hammer Active 2 LTE" }, { regex: "Hammer AXE Pro", model: "Hammer Axe Pro" }, { regex: "Hammer_Blade2_PRO", model: "Hammer Blade 2 Pro" }, { regex: "C-Smart_pix", model: "C-Smart Pix" }, { regex: "Pocket_2(?:[);/ ]|$)", model: "Pocket 2" }, { regex: "myA17(?:[);/ ]|$)", model: "myA17" }, { regex: "(?:myPhone_)?Fun_(8|18x9)", model: "FUN $1" }, { regex: "MyPhoneMY27", model: "my27" }, { regex: "myX12(?:[);/ ]|$)", model: "myX12" }, { regex: "myXI1 Plus(?:[);/ ]|$)", model: "myXI1 Plus" }, { regex: "myXI1 Pro(?:[);/ ]|$)", model: "myXI1 Pro" }, { regex: "myXI3(?:[);/ ]|$)", model: "myXI3" }, { regex: "Q_Smart_BE(?:[);/ ]|$)", model: "Q-Smart BE" }, { regex: "Prime_18x9(_LTE)?(?:[);/ ]|$)", model: "Prime 18x9$1" }, { regex: "Prime3Lite(?:[);/ ]|$)", model: "Prime 3 Lite" }, { regex: "MyPhone[ _]([^;/)]+)( Build|\\))", model: "$1" }] }, are = { regex: "MyWigo ", device: "smartphone", models: [{ regex: "City3", model: "City 3" }] }, lre = { regex: "(E70 Ultra)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, ire = { regex: " (Myria_[^/;]+|502M|Cozy|Easy tab 9|Grand) Build|Myria_FIVE|Myria_Grand_4G|Myria_Wide_2|Myria_Wide_4G", device: "smartphone", models: [{ regex: "Myria_([^/;]+) Build", model: "$1" }, { regex: "Myria_FIVE", model: "Five" }, { regex: "(502M|Grand)", model: "$1" }, { regex: "Myria_Grand_4G", model: "Grand 4G" }, { regex: "Myria_Wide_4G", model: "Wide 4G" }, { regex: "Myria_Wide_2", model: "Wide 2" }, { regex: "(Cozy|Easy tab 9)", model: "$1", device: "tablet" }] }, sre = { regex: "Navon[_ ]|(?:Vision_Tab_(?:7|10)|Superme_Max|Predator (?:10|3G)|Platinum[_ ]10[_ ]3G(?:_V2)?|Supreme[_ ](?:Fine(?:[_ ]Micro)?|Chief|Pure|Pro)(?:[_ ](?:Mini|Plus))?)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "M505 LTE(?:[);/ ]|$)", model: "Mizu M505 LTE" }, { regex: "(F552|D504)(?:[);/ ]|$)", model: "Mizu $1" }, { regex: "Superme_Max(?:[);/ ]|$)", model: "Supreme Max" }, { regex: "Supreme_Fine_Mini(?:[);/ ]|$)", model: "Supreme Fine Mini" }, { regex: "Supreme_Fine_Micro(?:[);/ ]|$)", model: "Supreme Fine Micro" }, { regex: "Supreme[_ ]Fine[_ ]Plus(?:[);/ ]|$)", model: "Supreme Fine Plus" }, { regex: "Supreme_Fine(?:[);/ ]|$)", model: "Supreme Fine" }, { regex: "Supreme[_ ]Chief(?:[);/ ]|$)", model: "Supreme Chief" }, { regex: "Supreme[_ ]Pure[ _]Plus(?:[);/ ]|$)", model: "Supreme Pure Plus" }, { regex: "Supreme Pure(?:[);/ ]|$)", model: "Supreme Pure" }, { regex: "Supreme[_ ]Pro(?:[);/ ]|$)", model: "Supreme Pro" }, { regex: "Navon[_ ]Infinity(?:[);/ ]|$)", model: "Infinity" }, { regex: "(?:Navon[_ ])?Platinum[ _]10[ _]3G(_V2)?(?:[);/ ]|$)", device: "tablet", model: 'Platinum 10.1" 3G$1' }, { regex: "(?:Navon[_ ])?Orpheus[ _]3G(?:[);/ ]|$)", device: "tablet", model: "Orpheus 3G" }, { regex: "Predator (3G|10)(?:[);/ ]|$)", device: "tablet", model: "Predator $1" }, { regex: "Vision_Tab_(7|10)(?:[);/ ]|$)", device: "tablet", model: "Vision Tab $1" }] }, dre = { regex: "(?:NOA-)?NOA[ _]|Hummer(?:_2019_R|LE)|NextSE", device: "smartphone", models: [{ regex: "NOA[_ ]CORE[_ ]FORTE", model: "Core Forte" }, { regex: "HummerLE", model: "Hummer LE" }, { regex: "Hummer_2019_R", model: "Hummer R (2019)" }, { regex: "NOA[_ ]Hummer[_ ]Lite", model: "Hummer Lite" }, { regex: "NOA[_ ]MOVEse", model: "Move SE" }, { regex: "NextSE", model: "Next SE" }, { regex: "NOA[_ ]NEXT", model: "Next" }, { regex: "NOA[_ ]VISION[_ ]H3SE", model: "Vision H3SE" }, { regex: "NOA[_ ]VISION[_ ]H3", model: "Vision H3" }, { regex: "NOA[_ ]LOOP", model: "Loop" }, { regex: "(?:NOA-)?NOA[_ ]H4se", model: "H4SE" }, { regex: "NOA[_ ]Mg12", model: "MG12" }, { regex: "NOA[_ ]H44SE", model: "H44SE" }, { regex: "NOA[_ ]H10LE", model: "H10LE" }, { regex: "NOA[_ ]([^;)/ ]+)", model: "$1" }] }, ure = { regex: "Nobby[ ](S500|X800|S300(?: Pro)?)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, cre = { regex: "NEC[ _\\-]|KGT/2\\.0|PC-TE508(?:S1|[BH]AW)|PC-TE510(?:HAW|BAL|S1)|PC-TS708T1W|PC-TS507N1S|PC-TE507JAW|portalmmm/1\\.0 (?:DB|N)|(?:portalmmm|o2imode)/2.0[ ,]N|(?:N-06C|N-02E|LAVIE Tab E (?:10|8)FHD1)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "N-06C(?:[);/ ]|$)", model: "Medias Amadana" }, { regex: "N-02E(?:[);/ ]|$)", model: "Medias U" }, { regex: "(?:NEC[ _\\-]|KGT/2\\.0 )([a-z0-9]+)", model: "$1" }, { regex: "portalmmm/1\\.0 ((?:DB|N)[a-z0-9]+)", model: "$1" }, { regex: "(?:portalmmm|o2imode)/2\\.0[ ,](N[a-z0-9]+)", model: "$1" }, { regex: "PC-TE508[BH]AW(?:[);/ ]|$)", device: "tablet", model: "LAVIE Tab E TE508" }, { regex: "PC-TE510(?:BAL|HAW|S1)(?:[);/ ]|$)", device: "tablet", model: "LAVIE Tab E TE510" }, { regex: "PC-TS507N1S(?:[);/ ]|$)", device: "tablet", model: "LAVIE Tab S TS507" }, { regex: "PC-TS708T1W(?:[);/ ]|$)", device: "tablet", model: "LAVIE Tab S TS708" }, { regex: "PC-TE507JAW(?:[);/ ]|$)", device: "tablet", model: "LAVIE Tab E TS507" }, { regex: "PC-TE508S1(?:[);/ ]|$)", device: "tablet", model: "LAVIE Tab E TE508" }, { regex: "(LAVIE Tab E (?:10|8)FHD1)(?:[);/ ]|$)", device: "tablet", model: "$1" }] }, mre = { regex: "Neffos|(TP601A)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "TP601A(?:[);/ ]|$)", model: "C5L" }, { regex: "Neffos[_ ]Y50", model: "Y50" }, { regex: "Neffos X20 Pro", model: "X20 Pro" }, { regex: "Neffos[_ ]((?:[YNCXA])[0-9][A-Z]?(?: Max| Lite)?)", model: "$1" }] }, gre = { regex: "Nextbit|(?:Robin)(?: Build|\\))", device: "smartphone", models: [{ regex: "(Robin)(?:[);/ ]|$)", model: "$1" }] }, fre = { regex: "NEWGEN\\-([a-z0-9]+)", device: "feature phone", model: "$1" }, pre = { regex: "GTV100", device: "tv", models: [{ regex: "GTV100", model: "NeoTV Prime" }] }, hre = { regex: "NIM-", device: "smartphone", models: [{ regex: "NIM-(450D|550O|600Q)", model: "$1" }] }, xre = { regex: "Next[0-9]|NX(?:785QC8G|M900MC|008HD8G|010HI8G|M908HC|M726|16A8116K|A8QC116|16A10132S|16A11264)", device: "tablet", models: [{ regex: "NX008HD8G", model: "Premium 8 HD" }, { regex: "NXA8QC116", model: "Ares 8" }, { regex: "NX16A8116K", model: "Ares A8" }, { regex: "NX16A10132S", model: "Ares A10" }, { regex: "NX16A11264", model: "Ares A11" }, { regex: "NXM908HC", model: "Premium 9" }, { regex: "NX010HI8G", model: "Premium 10 Hi" }, { regex: "NX785QC8G", model: "8" }, { regex: "NXM900MC", model: "8 HD" }, { regex: "NXM726", model: "Premium 7" }, { regex: "Next([0-9]+[^;/]+) Build", model: "Next $1" }] }, vre = { regex: "NGM[_ ][a-z0-9]+|(Forward|Dynamic)[ _]?[^/;]+(?:Build|/)", device: "smartphone", models: [{ regex: "(Forward|Dynamic)[ _]?([^/;]+) Build", model: "$1 $2" }, { regex: "(Forward|Dynamic)[ _]?([^/;]+)/", model: "$1 $2" }, { regex: "NGM ([^;/]+) Build", model: "$1" }, { regex: "NGM_([a-z0-9]+)", model: "$1" }] }, Sre = { regex: "S?Nexian", device: "smartphone", models: [{ regex: "S?Nexian[ ]?([a-z0-9\\-]+)", model: "$1" }, { regex: "S?Nexian-([a-z0-9]+)", model: "$1" }] }, bre = { regex: "NOAIN", device: "smartphone", models: [{ regex: "NOAIN[ _-]([^;/]+) Build", model: "$1" }, { regex: "NOAIN[ _-]([^;/)]+)(?:[;/)]|$)", model: "$1" }] }, yre = { regex: "Noblex|NBX-", device: "smartphone", models: [{ regex: "(?:Noblex|NBX)[ _-]([^;/]+) Build", model: "$1" }, { regex: "(?:Noblex|NBX)[ _-]([^;/)]+)(?:[;/)]|$)", model: "$1" }] }, wre = { regex: "Nomu[ _-](?:T18|S30mini|S10)(?:[);/ ]|$)|V1600S(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Nomu[ _-]T18(?:[);/ ]|$)", model: "T18" }, { regex: "Nomu[ _-]s10(?:[);/ ]|$)", model: "S10" }, { regex: "Nomu[ _-]S30mini(?:[);/ ]|$)", model: "S30 Mini" }, { regex: "(V1600S)(?:[);/ ]|$)", model: "$1" }] }, _re = { regex: "Nomi[ _-]|(C101010 Ultra2|i501[234]|i5032|i50[57]0|i5510|i5532|C0(700(?:[02358]|2HD)|7850)|C1010[0-3])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "i501[23](?:[);/ ]|$)", model: "Evo M2" }, { regex: "I5070(?:[);/ ]|$)", model: "Iron-X" }, { regex: "i5014(?:[);/ ]|$)", model: "Evo M4" }, { regex: "i5032(?:[);/ ]|$)", model: "Evo X2" }, { regex: "i5050(?:[);/ ]|$)", model: "Evo Z" }, { regex: "Nomi_i4510(?:[);/ ]|$)", model: "Beat M" }, { regex: "i5532(?:[);/ ]|$)", model: "Space X2" }, { regex: "i5510(?:[);/ ]|$)", model: "Space M" }, { regex: "C101010 Ultra2", model: "Ultra 2", device: "tablet" }, { regex: "(C0(?:700(?:[02358]|2HD)|7850)|C1010[0-3])(?:[);/ ]|$)", model: "$1", device: "tablet" }, { regex: "Nomi[ _-]([^;/]+) Build", model: "$1" }, { regex: "Nomi[ _-]([^;/)]+)(?:[;/)]|$)", model: "$1" }] }, Tre = { regex: "(?:NS(?:[356]|500[2-68]|5511|5502)|NS 5511)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "NS 5511(?:[);/ ]|$)", model: "NS5511" }, { regex: "(NS[0-9]{1,4})(?:[);/ ]|$)", model: "$1" }] }, Are = { regex: "NVIDIA|SHIELD Tablet K1|SHIELD Android TV|Tegra(Note-P1640| Note 7)", device: "tablet", models: [{ regex: "TegraNote-P1640", model: "Tegra Note P1640" }, { regex: "(SHIELD Tablet K1|Tegra Note 7)(?: Build|[;)])", model: "$1" }, { regex: "SHIELD Android TV", model: "SHIELD Android TV", device: "tv" }, { regex: "NVIDIA_SHIELD_PRO_2019", model: "SHIELD TV Pro", device: "tv" }, { regex: "NVIDIA Shield", model: "SHIELD TV", device: "tv" }] }, Pre = { regex: "Xda|(?<!FBCR/)O2[ \\-]|COCOON", device: "smartphone", models: [{ regex: "(Xda[ _][a-z0-9_]+)", model: "$1" }, { regex: "(COCOON)", model: "$1" }, { regex: "O2 ([a-z0-9 ]+)", model: "$1" }, { regex: "O2-([a-z0-9]+)", model: "$1" }] }, Mre = { regex: "ODYS[ _-]|IEOS[_ ]([^/;]+)|NOON(?:_PRO)? Build|SPACE10_(?:PLUS|PRO)_3G|THOR_?10|TAO_X10|RAPID_?(?:10|7)_?LTE|MAVEN_?10_|CONNECT[78]|ELEMENT10_PLUS_3G|XELIO[_0-9P]|ADM816HC|ADM8000KP|NEO6_LTE|EOS10|AEON|FALCON_10_PLUS_3G|FUSION|THANOS_10|MAVEN_X10_HD(?:_LTE)?|JUNIOR_8_PRO|JuniorT8Pro|(?:NOVA|PYRO)_X?7_PLUS_3G|UNO_X8|SLADE_X55|XELIO_PRO_10_LTE|NOTOSplus3G", device: "tablet", models: [{ regex: "XELIO[_ ]A10", model: "Xelio A10" }, { regex: "XELIOPHONETAB3", model: "Xelio Phonetab 3" }, { regex: "THANOS_10", model: "Thanos 10" }, { regex: "XELIO_NEXT_10_PLUS_3G", model: "Xelio Next 10 Plus 3G" }, { regex: "XELIO_PHONE_TAB7_3G", model: "Xelio Phonetab 7 3G" }, { regex: "XELIO10EXTREME", model: "Xelio 10 Xtreme" }, { regex: "XELIO10_PLUS_3G", model: "Xelio 10 Plus 3G" }, { regex: "XELIO10_HD_PLUS_3G", model: "Xelio 10 HD Plus 3G" }, { regex: "XELIO_10_HD", model: "Xelio 10 HD" }, { regex: "XELIO_PRO_10_LTE", model: "Xelio Pro 10 LTE" }, { regex: "ELEMENT10_PLUS_3G", model: "Element 10 Plus 3G" }, { regex: "CONNECT8PLUS", model: "Connect 8 Plus" }, { regex: "CONNECT7PRO", model: "Connect 7 Pro" }, { regex: "MAVEN_X10_HD_LTE", model: "Maven X10 HD LTE" }, { regex: "MAVEN_X10_HD", model: "Maven X10 HD" }, { regex: "MAVEN_?10_PRO_PLUS_3G", model: "Maven 10 Pro Plus 3G" }, { regex: "MAVEN_?10_?PLUS", model: "Maven 10 Plus" }, { regex: "MAVEN_?10_?PRO", model: "Maven 10 Pro" }, { regex: "MAVEN_?10_?HD", model: "Maven 10 HD" }, { regex: "RAPID_?7_?LTE", model: "Rapid 7 LTE" }, { regex: "RAPID_?10_?LTE", model: "Rapid 10 LTE" }, { regex: "TAO_X10", model: "Tao X10" }, { regex: "SPACE10_PLUS_3G", model: "Space 10 Plus 3G" }, { regex: "SPACE10_PRO_3G", model: "Space 10 Pro 3G" }, { regex: "THOR_?10 Build", model: "Thor 10" }, { regex: "JuniorT8Pro", model: "Junior T8 Pro" }, { regex: "JUNIOR_8_PRO", model: "Junior 8 Pro" }, { regex: "ADM816HC", model: "Neo X" }, { regex: "EOS10", model: "EOS 10" }, { regex: "AEON", model: "Aeon" }, { regex: "FALCON_10_PLUS_3G", model: "Falcon 10 Plus 3G" }, { regex: "FUSION", model: "Fusion 7" }, { regex: "UNO_X8", model: "Uno X8" }, { regex: "ADM8000KP", model: "Titan" }, { regex: "PYRO_7_PLUS_3G", model: "Pyro 7 Plus 3G" }, { regex: "NOVA_X7_PLUS_3G", model: "Nova X7 Plus 3G" }, { regex: "ODYS_NOVA_X7", model: "Nova X7" }, { regex: "THOR_?10_PLUS_3G", model: "Thor 10 Plus 3G" }, { regex: "NOTOSplus3G", model: "Notos Plus 3G" }, { regex: "NEO6[_ ]LTE", model: "Neo 6 LTE", device: "smartphone" }, { regex: "SLADE_X55", model: "Slade X55", device: "smartphone" }, { regex: "IEOS[ _]([^/;]+) Build", model: "Ieos $1" }, { regex: "(?:ODYS[ _-])?NOON Build", model: "Noon" }, { regex: "(?:ODYS[ _-])?NOON_PRO Build", model: "Noon Pro" }, { regex: "Odys[ _-]([^/;]+) Build", model: "$1" }] }, $re = { regex: "Obi[ _-]|(SJ1\\.5|SJ2\\.6|S400|S452\\+|S451|S453|S501|S502|S503\\+?|S507|S520|S550|S551|falcon)[ _]", device: "smartphone", models: [{ regex: "SJ2\\.6", model: "SJ2.6" }, { regex: "SJ1\\.5", model: "SJ1.5" }, { regex: "(?:Obi_)?S400", model: "Skipper" }, { regex: "(?:Obi_)?S451|falcon", model: "Flacon" }, { regex: "(?:Obi_)?S452\\+", model: "Python" }, { regex: "(?:Obi_)?S453", model: "Fox" }, { regex: "(?:Obi_)?S501", model: "Wolverine" }, { regex: "(?:Obi_)?S502", model: "Leopard" }, { regex: "(?:Obi_)?S503\\+", model: "Boa Plus" }, { regex: "(?:Obi_)?S503", model: "Boa" }, { regex: "(?:Obi_)?S507", model: "Pelican" }, { regex: "(?:Obi_)?S520", model: "Octopus" }, { regex: "(?:Obi_)?S550", model: "Crane" }, { regex: "(?:Obi_)?S551", model: "Hornbill" }, { regex: "(?:Obi_)?S454", model: "Alligator" }, { regex: "Obi[ _-]([^;/]+) Build", model: "$1" }, { regex: "Obi[ _-]([^;/)]+)(?:[;/)]|$)", model: "$1" }] }, Cre = { regex: "Signature (?:L|Pro|Touch)", device: "smartphone", models: [{ regex: "Signature (L|Pro|Touch)", model: "Signature $1" }] }, Lre = { regex: "Onda|(?:(?:V820w|V891[w]?|V919(?: 3G)? Air)[ _-]DualOS|(?:V919 4G Air|V989 Air|V972) Core[48]|T2101L2B1C| V10 4G|OBOOK (?:20 SE|20 PLUS DUALOS)|OBOOK10 SE|V919 Air CH DualOS)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ONDA[ _]MID", model: "MID", device: "tablet" }, { regex: "V820w[ _-]DualOS", model: "V820W Dual OS", device: "tablet" }, { regex: "V891W[ _-]DualOS", model: "V891W Dual OS", device: "tablet" }, { regex: "V891[ _-]DualOS", model: "V891 Dual OS", device: "tablet" }, { regex: "V919 3G Air[ _-]DualOS", model: "V919 3G Air Dual OS", device: "tablet" }, { regex: "V919 Air[ _-]DualOS", model: "V919 Air Dual OS", device: "tablet" }, { regex: "V919 Air CH DualOS", model: "V919 Air CH Dual OS", device: "tablet" }, { regex: "V919 4G Air Core8", model: "V919 4G Air Core 8", device: "tablet" }, { regex: "V972 Core4", model: "V919 Core 4", device: "tablet" }, { regex: "V989 Air Core8", model: "V989 Air Core 8", device: "tablet" }, { regex: "T2101L2B1C|OBOOK 20 PLUS DUALOS", model: "oBook 20 Plus Dual OS", device: "tablet" }, { regex: " V10 4G(?:[);/ ]|$)", model: 'V10 10.1" 4G', device: "tablet" }, { regex: "OBOOK 20 SE(?:[);/ ]|$)", model: "oBook 20 SE", device: "tablet" }, { regex: "OBOOK10 SE(?:[);/ ]|$)", model: "oBook 10 SE", device: "tablet" }, { regex: "([a-z0-9]+)[ _]Onda", model: "$1" }, { regex: "Onda ([a-z0-9]+)", model: "$1" }] }, Ere = { regex: "(?:du_)?ONEPLUS|(?:A0001|A200[135]|AC200[13]|A300[03]|A3010|A5000|A600[03]|A601[03]|BE201[1235]|BE2025|BE202[89]|E100[135]|GM191[03517]|GM190[0135]|GM192[05]|HD191[013]|HD190[01357]|HD1925|IN201[013579]|IN202[0135]|KB200[01357]|LE2117|LE212[03])(?: Build|\\))", device: "smartphone", models: [{ regex: "AC200[13](?:[);/ ]|$)", model: "Nord 5G" }, { regex: "BE2012(?:[);/ ]|$)", model: "Clover" }, { regex: "BE201[135](?:[);/ ]|$)", model: "Nord N100" }, { regex: "BE2025(?:[);/ ]|$)", model: "Nord N10" }, { regex: "BE2029(?:[);/ ]|$)", model: "Nord N10 5G" }, { regex: "BE2028(?:[);/ ]|$)", model: "Nord N10 Lite" }, { regex: "IN202[0135](?:[);/ ]|$)", model: "8 Pro" }, { regex: "KB2000(?:[);/ ]|$)", model: "8T" }, { regex: "IN201[01357](?:[);/ ]|$)", model: "8" }, { regex: "IN2019(?:[);/ ]|$)", model: "8 5G UW" }, { regex: "LE2117(?:[);/ ]|$)", model: "9" }, { regex: "LE212[03](?:[);/ ]|$)", model: "9 Pro" }, { regex: "(?:GM191[01357]|OnePlus 7 Pro)(?:[);/ ]|$)", model: "7 Pro" }, { regex: "GM190[0135](?:[);/ ]|$)", model: "7" }, { regex: "HD190[01357](?:[);/ ]|$)", model: "7T" }, { regex: "(?:HD191[013]|OnePlus 7T Pro)(?:[);/ ]|$)", model: "7T Pro" }, { regex: "(?:HD1925|GM192[05])(?:[);/ ]|$)", model: "7T Pro 5G" }, { regex: "KB200[1357](?:[);/ ]|$)", model: "8T" }, { regex: "A0001(?:[);/ ]|$)", model: "One" }, { regex: "A200[135]|OnePlus2", model: "2" }, { regex: "E100[135](?:[);/ ]|$)", model: "X" }, { regex: "A3010|OnePlus3T", model: "3T" }, { regex: "A300[03]|OnePlus3", model: "3" }, { regex: "A5010|OnePlus[ ]?5T", model: "5T" }, { regex: "A5000|OnePlus5", model: "5" }, { regex: "A600[03]|OnePlus6", model: "6" }, { regex: "A601[03](?:[);/ ]|$)", model: "6T" }, { regex: "(?:du_)?ONEPLUS ?([^;/]+) Build", model: "$1" }] }, Ore = { regex: "Realme[ _]|(?:RMX(?:19(03|4[1235]|19|9[23]|2[157]|[01379]1|73)|20(?:[025-7]1|[037]2|2[57]|63|7[56]|8[156]|[2-5]0)|21(?:0[13]|17|[12]1|4[24]|5[15]|6[13]|7[60]|8[059]|9[35])|2200|18(0[1579]|11|3[13]|2[157]|[45]1|45)|3201|30[38]1|3063)|(?:OPPO[ _]?)?CPH1861)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:OPPO[ _]?)?CPH1861(?:[);/ ]|$)", model: "1" }, { regex: "RMX180[59]", model: "2" }, { regex: "RMX180[17]", model: "2 Pro" }, { regex: "RMX(1833|182[15])", model: "3" }, { regex: "RMX1827", model: "3i" }, { regex: "RMX1851", model: "3 Pro" }, { regex: "RMX190[13]|Realme X(?:[);/ ]|$)", model: "X" }, { regex: "RMX199[12]", model: "X2" }, { regex: "RMX1993", model: "X2 Dual" }, { regex: "RMX1931|Realme X2 Pro(?:[);/ ]|$)", model: "X2 Pro" }, { regex: "RMX2117", model: "Q2 5G" }, { regex: "RMX2176(?:[);/ ]|$)", model: "X7 5G" }, { regex: "RMX2121(?:[);/ ]|$)", model: "X7 Pro 5G" }, { regex: "RMX1921|Realme XT(?:[);/ ]|$)", model: "XT" }, { regex: "RMX19(1[19]|27)", model: "5" }, { regex: "RMX197[13]", model: "5 Pro" }, { regex: "RMX203[02]", model: "5i" }, { regex: "RMX2001", model: "6" }, { regex: "RMX2040", model: "6I" }, { regex: "RMX2002", model: "6S" }, { regex: "RMX206[13](?:[);/ ]|$)", model: "6 Pro" }, { regex: "RMX215[15]", model: "7" }, { regex: "RMX2103", model: "7I" }, { regex: "RMX2170", model: "7 Pro" }, { regex: "RMX3081", model: "8 Pro" }, { regex: "RMX1925(?:[);/ ]|$)", model: "5S" }, { regex: "RMX1811(?:[);/ ]|$)", model: "C1" }, { regex: "RMX194[1235](?:[);/ ]|$)", model: "C2" }, { regex: "RMX202[107](?:[);/ ]|$)", model: "C3" }, { regex: "RMX2185(?:[);/ ]|$)", model: "C11" }, { regex: "RMX2189(?:[);/ ]|$)", model: "C12" }, { regex: "RMX2180(?:[);/ ]|$)", model: "C15" }, { regex: "RMX2195(?:[);/ ]|$)", model: "C15 Qualcomm Edition" }, { regex: "RMX2101(?:[);/ ]|$)", model: "C17" }, { regex: "RMX3063(?:[);/ ]|$)", model: "C20" }, { regex: "RMX3031(?:[);/ ]|$)", model: "GT Neo" }, { regex: "RMX216[13](?:[);/ ]|$)", model: "Narzo 20 Pro" }, { regex: "RMX2193(?:[);/ ]|$)", model: "Narzo 20" }, { regex: "RMX2050(?:[);/ ]|$)", model: "Narzo 20A" }, { regex: "RMX1831(?:[);/ ]|$)", model: "U1" }, { regex: "RMX(?:20(?:51|[2]5)|2144)(?:[);/ ]|$)", model: "X50 5G" }, { regex: "RMX2071(?:[);/ ]|$)", model: "X50 Pro" }, { regex: "RMX207[56](?:[);/ ]|$)", model: "X50 Pro 5G" }, { regex: "RMX2072(?:[);/ ]|$)", model: "X50 Pro Player" }, { regex: "RMX(2142|2081)(?:[);/ ]|$)", model: "X3" }, { regex: "RMX208[56](?:[);/ ]|$)", model: "X3 Super Zoom" }, { regex: "RMX2111", model: "V5 5G" }, { regex: "RMX2200", model: "V3 5G" }, { regex: "RMX3201", model: "C21" }, { regex: "Realme[ _]([1-9])[ _]Pro(?:[);/ ]|$)", model: "$1 Pro" }] }, Nre = { regex: "(?:OB-)?OPPO[ _]?([a-z0-9]+)|N1T|R8001|OPG01|A00[12]OP|(?:X90[07][0679]|U70[57]T?|X909T?|R(?:10[01]1|2001|201[07]|6007|7005|7007|80[13579]|81[13579]|82[01379]|83[013]|800[067]|8015|810[679]|811[13]|820[057])[KLSTW]?|N520[79]|N5117|A33f|A33fw|A37fw?|PAAM00|PAAT00|PAC[TM]00)(?:[);/ ]|$)|R7kf|R7plusf|R7Plusm|A1601|CPH[0-9]{4}|CPH19(69|79|23|1[179])|PB(A[TM]00|CT10|BT30|CM[13]0|[FD]M00)|P(DAM10|ADM00|AF[TM]00|ADT00|AHM00|BBM[03]0|BBT00|BDT00|BFT00|[CB]E[MT]00|CA[MT]00|C[CDG]M00|CA[MT]10|[CD]PM00|CRM00|CDT00|CD[TM]10|CHM[013]0|CKM[08]0|CLM[15]0|DEM[13]0|DHM00|DK[TM]00|DPT00|DB[TM]00|DCM00|[CD]NM00|DVM00|DY[TM]20|DNT00|EA[TM]00)|PDSM00", device: "smartphone", models: [{ regex: "PCHM10(?:[);/ ]|$)", model: "A11" }, { regex: "(?:CPH2083|CPH2077)(?:[);/ ]|$)", model: "A12" }, { regex: "PCHM00(?:[);/ ]|$)", model: "A11x" }, { regex: "CPH1923(?:[);/ ]|$)", model: "A1K" }, { regex: "(?:OPPO[ _]?)?(CPH1837|PAD[TM]00)(?:[);/ ]|$)", model: "A3" }, { regex: "(?:OPPO[ _]?)?A37f(w)(?:[);/ ]|$)", model: "A37f$1" }, { regex: "A37f(?:[);/ ]|$)", model: "A37f" }, { regex: "(?:OPPO[ _]?)?CPH1605(?:[);/ ]|$)", model: "A39" }, { regex: "CPH20(?:81|73|31|15)(?:[);/ ]|$)", model: "A31" }, { regex: "(?:OPPO[ _]?)?(?:CPH18(?:0[35]|53)|PBBM30)(?:[);/ ]|$)", model: "A3s" }, { regex: "(?:OPPO[ _]?)?(?:CPH1809|PBA[TM]00|PBBT30)(?:[);/ ]|$)", model: "A5" }, { regex: "CPH19(?:3[13]|43)(?:[);/ ]|$)", model: "A5 (2020)" }, { regex: "PDVM00(?:[);/ ]|$)", model: "A32" }, { regex: "(?:PDAM10|CPH2069|CPH2061)(?:[);/ ]|$)", model: "A52" }, { regex: "CPH2127(?:[);/ ]|$)", model: "A53" }, { regex: "(?:OPPO[ _]?)?CPH170[15](?:[);/ ]|$)", model: "A57" }, { regex: "CPH19(?:09|1[02])(?:[);/ ]|$)", model: "A5S" }, { regex: "(?:OPPO[ _]?)?(?:CPH190[15]|PBF[TM]00)(?:[);/ ]|$)", model: "A7" }, { regex: "(?:OPPO[ _]?)?(CPH1801|CPH1717)(?:[);/ ]|$)", model: "A71" }, { regex: "(?:OPPO[ _]?)?(?:PDY[TM]20|CPH2067)(?:[);/ ]|$)", model: "A72" }, { regex: "(?:OPPO[ _]?)?CPH1715(?:[);/ ]|$)", model: "A77" }, { regex: "PCD[TM]00(?:[);/ ]|$)", model: "A7n" }, { regex: "(PBBT00|PBBM00)(?:[);/ ]|$)", model: "A7x" }, { regex: "(?:OPPO[ _]?)?(?:PDBM00)(?:[);/ ]|$)", model: "A8" }, { regex: "(?:OPPO[ _]?)?CPH1729(?:[);/ ]|$)", model: "A83" }, { regex: "(?:OPPO[ _]?)?CPH1827(?:[);/ ]|$)", model: "A83 (2018)" }, { regex: "PCA[TM]10(?:[);/ ]|$)", model: "A9" }, { regex: "(CPH1937|CPH1941|PCHM30)(?:[);/ ]|$)", model: "A9 (2020)" }, { regex: "(?:OPPO[ _]?)?CPH1938(?:[);/ ]|$)", model: "A9 (EN)" }, { regex: "(?:PCPM00|CPH20[02]1)(?:[);/ ]|$)", model: "A91" }, { regex: "CPH2059(?:[);/ ]|$)", model: "A92" }, { regex: "PDKT00(?:[);/ ]|$)", model: "A92s" }, { regex: "PDKM00(?:[);/ ]|$)", model: "A93s" }, { regex: "PCE[TM]00(?:[);/ ]|$)", model: "A9x" }, { regex: "(?:OPPO[ _]?)?CPH1851(?:[);/ ]|$)", model: "AX5" }, { regex: "CPH1920(?:[);/ ]|$)", model: "AX5s" }, { regex: "(?:OPPO[ _]?)?CPH1903(?:[);/ ]|$)", model: "AX7" }, { regex: "(?:OPPO[ _]?)?X9009(?:[);/ ]|$)", model: "F1 Plus" }, { regex: "CPH191[135](?:[);/ ]|$)", model: "F11" }, { regex: "CPH19(?:69|87)(?:[);/ ]|$)", model: "F11 Pro" }, { regex: "(?:OPPO[ _]?)?(?:CPH2119)(?:[);/ ]|$)", model: "F17 Pro" }, { regex: "(?:OPPO[ _]?)?A1601(?:[);/ ]|$)", model: "F1s" }, { regex: "(?:OPPO[ _]?)?CPH1609(?:[);/ ]|$)", model: "F3" }, { regex: "(?:OPPO[ _]?)?CPH1613(?:[);/ ]|$)", model: "F3 Plus" }, { regex: "(?:OPPO[ _]?)?CPH172[37](?:[);/ ]|$)", model: "F5" }, { regex: "(?:OPPO[ _]?)?CPH1725(?:[);/ ]|$)", model: "F5 Youth" }, { regex: "(?:OPPO[ _]?)?CPH(1859|18(?:19|21))(?:[);/ ]|$)", model: "F7" }, { regex: "(?:OPPO[ _]?)?(?:CPH1825|CPH1881)(?:[);/ ]|$)", model: "F9" }, { regex: "(?:OPPO[ _]?)?CPH1823(?:[);/ ]|$)", model: "F9 Pro" }, { regex: "(?:OPPO[ _]?)?X909T?(?:[);/ ]|$)", model: "Find 5" }, { regex: "(?:OPPO[ _]?)?R827T?(?:[);/ ]|$)", model: "Find 5 Mini" }, { regex: "(?:OPPO[ _]?)?X907[067](?:[);/ ]|$)", model: "Find 7" }, { regex: "(?:OPPO[ _]?)?X900[067](?:[);/ ]|$)", model: "Find 7a" }, { regex: "(?:OPPO[ _]?)?R815[TW]?(?:[);/ ]|$)", model: "Find Clover" }, { regex: "(?:OPPO[ _]?)?R8015(?:[);/ ]|$)", model: "Find Guitar" }, { regex: "(?:OPPO[ _]?)?R8111(?:[);/ ]|$)", model: "Find Melody" }, { regex: "(?:OPPO[ _]?)?R821T?(?:[);/ ]|$)", model: "Find Muse" }, { regex: "(?:OPPO[ _]?)?U707T?(?:[);/ ]|$)", model: "Find Way S" }, { regex: "(?:OPPO[ _]?)?U705T(?:[);/ ]|$)", model: "Ulike 2" }, { regex: "(?:OPPO[ _]?)?(?:CPH187[15]|PAF[MT]00)(?:[);/ ]|$)", model: "Find X" }, { regex: "(?:OPPO[ _]?)?(?:PAHM00)(?:[);/ ]|$)", model: "Find X Lamborghini" }, { regex: "(?:OPPO[ _]?)?(?:PDEM10|CPH2023)(?:[);/ ]|$)", model: "Find X2" }, { regex: "(?:OPPO[ _]?)?CPH2005(?:[);/ ]|$)", model: "Find X2 Lite" }, { regex: "(?:OPPO[ _]?)?(?:PDEM30|OPG01|CPH2025)(?:[);/ ]|$)", model: "Find X2 Pro" }, { regex: "(?:OPPO[ _]?)?R1011 Build", model: "Joy Plus" }, { regex: "(?:OPPO[ _]?)?(PBC(?:M30|T10))(?:[);/ ]|$)", model: "K1" }, { regex: "CPH1955(?:[);/ ]|$)", model: "K3" }, { regex: "(?:OPPO[ _]?)?(PCNM00)(?:[);/ ]|$)", model: "K5" }, { regex: "(?:OPPO[ _]?)?(PCLM50)(?:[);/ ]|$)", model: "K7" }, { regex: "(?:OPPO[ _]?)?N5117(?:[);/ ]|$)", model: "N1 Mini" }, { regex: "(?:OPPO[ _]?)?N520[79](?:[);/ ]|$)", model: "N3" }, { regex: "(?:OPPO[ _]?)?R831T?(?:[);/ ]|$)", model: "Neo" }, { regex: "(?:OPPO[ _]?)?R831K(?:[);/ ]|$)", model: "Neo 3" }, { regex: "(?:OPPO[ _]?)?R831[SL](?:[);/ ]|$)", model: "Neo 5" }, { regex: "(?:OPPO[ _]?)?A33f(?:[);/ ]|$)", model: "Neo 7" }, { regex: "(?:OPPO[ _]?)?A33fw(?:[);/ ]|$)", model: "Neo 7s" }, { regex: "(?:OPPO[ _]?)?R8113(?:[);/ ]|$)", model: "Piano" }, { regex: "(?:OPPO[ _]?)?CPH1707(?:[);/ ]|$)", model: "R11" }, { regex: "R8001(?:[);/ ]|$)", model: "R1K" }, { regex: "(?:OPPO[ _]?)?CPH1719(?:[);/ ]|$)", model: "R11s" }, { regex: "(?:OPPO[ _]?)?CPH1721(?:[);/ ]|$)", model: "R11s Plus" }, { regex: "(?:OPPO[ _]?)?(?:CPH1835|PAC[TM]00|PAAM00)(?:[);/ ]|$)", model: "R15" }, { regex: "(?:OPPO[ _]?)?(?:CPH183[13]|PAAT00)(?:[);/ ]|$)", model: "R15 Pro" }, { regex: "PBCM10(?:[);/ ]|$)", model: "R15x" }, { regex: "(?:OPPO[ _]?)?(?:CPH1879|PBE[MT]00)(?:[);/ ]|$)", model: "R17" }, { regex: "(?:OPPO[ _]?)?(?:CPH1893)(?:[);/ ]|$)", model: "R17 Neo" }, { regex: "(?:OPPO[ _]?)?(?:CPH1877|PBD[MT]00)(?:[);/ ]|$)", model: "R17 Pro" }, { regex: "(?:OPPO[ _]?)?R8006(?:[);/ ]|$)", model: "R1L" }, { regex: "(?:OPPO[ _]?)?R800[07](?:[);/ ]|$)", model: "R1S" }, { regex: "(?:OPPO[ _]?)?R810[679](?:[);/ ]|$)", model: "R5" }, { regex: "(?:OPPO[ _]?)?R7kf(?:[);/ ]|$)", model: "R7 Lite" }, { regex: "(?:OPPO[ _]?)?R7Plusm(?:[);/ ]|$)", model: "R7 Plus" }, { regex: "(?:OPPO[ _]?)?R7Plusf(?:[);/ ]|$)", model: "R7 Plus F" }, { regex: "(?:OPPO[ _]?)?X9079(?:[);/ ]|$)", model: "R9 Plus" }, { regex: "(?:OPPO[ _]?)?CPH1607(?:[);/ ]|$)", model: "R9s" }, { regex: "(?:OPPO[ _]?)?(?:CPH1611|R9s Plus)(?:[);/ ]|$)", model: "R9s Plus" }, { regex: "(?:CPH1917|PCA[MT]00)(?:[);/ ]|$)", model: "Reno" }, { regex: "CPH1983(?:[);/ ]|$)", model: "Reno A" }, { regex: "PCCM00(?:[);/ ]|$)", model: "Reno 10X" }, { regex: "CPH1919(?:[);/ ]|$)", model: "Reno 10X Zoom" }, { regex: "(?:PCKM00|CPH1907)(?:[);/ ]|$)", model: "Reno 2" }, { regex: "CPH1989(?:[);/ ]|$)", model: "Reno 2F" }, { regex: "(?:PCKM80|CPH1945|CPH1951)(?:[);/ ]|$)", model: "Reno 2Z" }, { regex: "CPH2043(?:[);/ ]|$)", model: "Reno 3" }, { regex: "(?:CPH2013|A002OP)(?:[);/ ]|$)", model: "Reno 3A" }, { regex: "(?:PDCM00|A001OP)(?:[);/ ]|$)", model: "Reno 3 5G" }, { regex: "(?:PCRM00|CPH203[57]|CPH2009)", model: "Reno 3 Pro" }, { regex: "CPH2113(?:[);/ ]|$)", model: "Reno 4 4G" }, { regex: "CPH2125(?:[);/ ]|$)", model: "Reno 4 Lite" }, { regex: "CPH2109(?:[);/ ]|$)", model: "Reno 4 Pro 4G" }, { regex: "PDP[TM]00(?:[);/ ]|$)", model: "Reno 4 5G" }, { regex: "PEA[TM]00(?:[);/ ]|$)", model: "Reno 4 SE 5G " }, { regex: "PDN[TM]00(?:[);/ ]|$)", model: "Reno 4 Pro 5G" }, { regex: "PDSM00(?:[);/ ]|$)", model: "Reno 5 Pro 5G" }, { regex: "CPH192[15]", model: "Reno 5G" }, { regex: "PCLM10(?:[);/ ]|$)", model: "Reno Ace" }, { regex: "PDHM00(?:[);/ ]|$)", model: "Reno Ace 2" }, { regex: "PCGM00(?:[);/ ]|$)", model: "Reno K3" }, { regex: "(?:OPPO[ _]?)?(?:CPH1979|PCD[TM]10)(?:[);/ ]|$)", model: "Reno Z" }, { regex: "N1T?(?:[);/ ]|$)", model: "N1T", device: "phablet" }, { regex: "R([0-9]{3,4}[KSTW]?)(?:[);/ ]|$)", model: "R$1" }, { regex: "(CPH[0-9]{4})", model: "$1" }, { regex: "(?:OB-)?OPPO[ _]?((?!Browser)[a-z0-9]+)", model: "$1" }] }, Dre = { regex: "Opsson|IUSAI", device: "smartphone", models: [{ regex: "IUSAI[ _]([^/;]+) Build", model: "Iusai $1" }, { regex: "IUSAI[ _]([^/;\\)]+)[/;\\)]", model: "Iusai $1" }, { regex: "Opsson[ _]([^/;]+) Build", model: "$1" }, { regex: "(?:Opsson-)?Opsson[ -_]([^/;]+)/", model: "$1" }] }, kre = { regex: "SPV[ \\-]?([a-z0-9]+)|(?<!FBCR/)Orange[ _-](?!Tahiti-LS\\))([^/;]+)( Build|\\))(?<!Tahiti-LS\\))|SC/IHD92|Nura 2|FunTab ([^/;]+) Build|Orange Mahpee", device: "smartphone", models: [{ regex: "SC/IHD92", model: "Livebox Play", device: "tv" }, { regex: "Nura 2", model: "Nura 2" }, { regex: "Sego", model: "Sego", device: "tablet" }, { regex: "FunTab ([^/;]+) Build", model: "FunTab $1", device: "tablet" }, { regex: "Orange[ _-](Rise)(3[12]|5[12])(?:[);/ ]|$)", model: "$1 $2" }, { regex: "Orange[ _-](Dive)72(?:[);/ ]|$)", model: "$1 72" }, { regex: "Orange[ _-](Daytona|Dive (30|7[13])|Dublin|Fova|Gova|Hi 4G|Hiro|Kivo|Monte Carlo|Neva 80|Neva play|Nura|Reyo|Rise[_ ](3[034]|40|5[345])|Rono|Roya|San Francisco|Tactile internet 2|Tado|Yomi|Yumo|Zali|Mahpee)(?:[);/ ]|$)", model: "$1" }, { regex: "SPV[ \\-]?([a-z0-9]+)", model: "SPV $1" }] }, Gre = { regex: "OUKITEL|(?:(?:C15|C16|K10000|K[46]000)(?:[ _]Pro)|K4000Pro|U16 Max|U7 Max|U7 Plus|U11[_ ]Plus|U20_Plus|OK6000 Plus|WP5000|WP[58] Pro|K[46]000[ _](?:Plus|Lite)|Y4800|K10000|K[4-8]000| WP[5-7])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(C15|C16|K10000|K[46]000|WP[258]|U15)[ _]?Pro(?:[);/ ]|$)", model: "$1 Pro" }, { regex: "OUKITEL K([37])(?:[);/ ]|$)", model: "K$1" }, { regex: "(K10000|U16|U7)[ _]Max(?:[);/ ]|$)", model: "$1 Max" }, { regex: "(U20|K[46]000|U7|U11|OK6000)[_ ]?Plus(?:[);/ ]|$)", model: "$1 Plus" }, { regex: "(K4000)[_ ]Lite(?:[);/ ]|$)", model: "$1 Lite" }, { regex: "(Y4800|K10000|K[4-8]000|WP2|WP5000|[CU]2|U10)(?:[);/ ]|$)", model: "$1" }, { regex: " (WP[5-7])(?:[);/ ]|$)", model: "$1" }, { regex: "OUKITEL; ([^;]+);", model: "$1" }] }, Bre = { regex: "OKWU SIGMA(?:[);/ ]|$)", device: "smartphone", model: "Sigma" }, Ire = { regex: "OUKI|OK[AU][0-9]+[a-z]* Build", device: "smartphone", models: [{ regex: "OUKI[ _-]?([^;/]+) Build", model: "$1" }, { regex: "([^;/)]+) Build/OUKI", model: "$1" }, { regex: "OUKI[ _-]?([^;/)]+)(?:[;/)]|$)", model: "$1" }, { regex: "(OK[AU][0-9]+[a-z]*) Build", model: "$1" }] }, Rre = { regex: "OV-[a-z]+(?:[^;(/]*)[();/ ]|Qualcore 10(?:10|27)|Vertis 5021 Aim|OV1027[34]G", device: "tablet", models: [{ regex: "OV-V10", model: "Vertis Yard", device: "smartphone" }, { regex: "Vertis 5021 Aim", model: "Vertis 5021 Aim", device: "smartphone" }, { regex: "OV-Vertis[ _-]([^;/]+) Build", model: "Vertis $1", device: "smartphone" }, { regex: "Qualcore 1010", model: "Qualcore 1010", device: "tablet" }, { regex: "Qualcore 1027 4G", model: "Qualcore 1027 4G", device: "tablet" }, { regex: "OV1027([34])G", model: "Qualcore 1027 $1G", device: "tablet" }, { regex: "(OV-[a-z]+(?:[^;(/]*))(?<!Build)[();/ ]", model: "$1" }] }, Fre = { regex: "Oysters|T84ERI[ _]3G|T72HM(s_)?3G|T102MS_3G|T102ER3G|(T74HMi|T84Bi)[_ ]4G|T74MR4G|T84Ni[_ ][34]G|Pacific[ ]?800i|T104B_[34]G|IndianV|T72HA_3G|T74D_3G|T74N_3G|T74SC_3G|T74Mai_3G|T104MBi_3G|T104SCi_3G|T104ER4G|Atlantic4G|AntarcticE|T7V 3G", device: "tablet", models: [{ regex: "Pacific[ ]?800i", device: "smartphone", model: "Pacific 800i" }, { regex: "Atlantic4G", device: "smartphone", model: "Atlantic 4G" }, { regex: "AntarcticE", device: "smartphone", model: "Antarctic E" }, { regex: "IndianV", device: "smartphone", model: "Indian V" }, { regex: "Oysters[_ ]PacificV", device: "smartphone", model: "Pacific V" }, { regex: "Oysters ((?:Arctic|Indian|Atlantic|Pacific)[^/;]+) Build", device: "smartphone", model: "$1" }, { regex: "(T84ERI[ _]3G|T72HM(s_)?3G|(?:(T74HMi|T84Bi)[_ ]4G)|T84Ni[_ ][34]G)", model: "$1" }, { regex: "(T74MR|T102MS|T104B|T74SC|T74[DN]|T72HA|T102ER|T104SCi|T104MBi|T104ER|T7V)[ _]?([34]G)", model: "$1 $2" }, { regex: "T74Mai_3G", model: "T74MAi 3G" }, { regex: "Oysters ([^/;]+)( Build|\\))", model: "$1" }] }, Vre = { regex: "T-i708D", device: "smartphone", models: [{ regex: "T-i708D", device: "tablet", model: "T-i708D" }] }, Hre = { regex: "Panasonic|PANATV[0-9]+|Viera/|(?:P902i|P-0[28]D|FZ-B2D|FZ-[NX]1|DMC-CM1|P-01J|P-03E)(?:[);/ ]|$)|Eluga[ _]|P55 Novo 4G", device: "smartphone", models: [{ regex: "P-01J(?:[);/ ]|$)", model: "P-smart Keitai" }, { regex: "P-03E(?:[);/ ]|$)", model: "Eluga P" }, { regex: "Eluga[ _-]([^;/]+) Build", model: "Eluga $1" }, { regex: "Eluga[ _-]([^);/]+)[;/)]", model: "Eluga $1" }, { regex: "(DMC-CM1)", model: "Lumix $1", device: "camera" }, { regex: "P-02D(?:[);/ ]|$)", model: "Lumix Phone P-02D" }, { regex: "(FZ-[XN]1)(?:[);/ ]|$)", model: "Toughpad $1" }, { regex: "FZ-B2D(?:[);/ ]|$)", model: "Toughpad FZ-B2D", device: "tablet" }, { regex: "P55 Novo 4G", model: "P55 Novo 4G" }, { regex: "P902i(?:[);/ ]|$)", device: "feature phone", model: "P902i" }, { regex: "Panasonic MIL DLNA", device: "tv", model: "Viera Cast" }, { regex: "PANATV[0-9]+|Viera/", device: "tv", model: "Smart TV" }, { regex: "(43D1200|(?:32|43)D1270|32D1280)", device: "tv", model: "$1" }, { regex: "Panasonic[ _\\-]?([a-z0-9]+)", model: "$1" }, { regex: "portalmmm/2.0 (P[a-z0-9]+)", model: "$1" }, { regex: "P-08D(?:[);/ ]|$)", model: 'Eluga Live 10.1"', device: "tablet" }] }, Ure = { regex: "Art-PCB-V116|Bee-PCB-V216|Clap-PCB-I316|PCB-T(103|715)", device: "smartphone", models: [{ regex: "Art-PCB-V116", model: "Art" }, { regex: "Bee-PCB-V216", model: "Bee" }, { regex: "Clap-PCB-I316", model: "Clap" }, { regex: "PCB-T103", device: "tablet", model: "Curi Lite" }, { regex: "PCB-T715", device: "tablet", model: "T715" }] }, Xre = { regex: "PH4001", device: "smartphone", models: [{ regex: "PH4001", model: "PH4001" }] }, Wre = { regex: "(TSD Octa A0520P|TSD Quadra A050[59]P)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Yre = { regex: "Pentagram|Quadra|Monster X5", device: "tablet", models: [{ regex: "(?:PENTAGRAM[_ ])?EON[_ ]PRIX", model: "Eon Prix" }, { regex: "Quadra 7(?: UltraSlim)?", model: "Quadra 7 UltraSlim" }, { regex: "Monster X5?", model: "Monster X5", device: "smartphone" }, { regex: "Quadra ?([^);/]*) Build", model: "Quadra $1" }, { regex: "Pentagram ?TAB ?([^);/]*) Build", model: "Tab $1" }, { regex: "Pentagram ?([^);/]*) Build", model: "$1", device: "smartphone" }] }, Kre = { regex: "TCL,|TCL[_ -][a-z0-9]+|(?:TCL[_ -][^;/]+ Build)|(?:TCLGalaG60(?:\\(9108A\\))?|A502DL|T78[02]H|5199I|7040N|5133A|5159[AJ]|5152D|T770H|T671H|T790Y|T766H_EEA|T766A|T799[BH]|Percee TV)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "TCLGalaG60(?:\\(9108A\\))?(?:[);/ ]|$)", model: "Gala G60" }, { regex: "5199I(?:[);/ ]|$)", model: "C9" }, { regex: "5152D(?:[);/ ]|$)", model: "C5" }, { regex: "5133A(?:[);/ ]|$)", model: "L5" }, { regex: "T780H(?:[);/ ]|$)", model: "Plex" }, { regex: "T782H(?:[);/ ]|$)", model: "10 Plus" }, { regex: "T790Y(?:[);/ ]|$)", model: "10 5G" }, { regex: "TCL[_ -]([^;/]+) Build", model: "$1" }, { regex: "TCL[_ -]([a-z0-9]+)", model: "$1" }, { regex: "(7040N)(?:[);/ ]|$)", model: "$1" }, { regex: "A502DL(?:[);/ ]|$)", model: "LX" }, { regex: "5159[AJ](?:[);/ ]|$)", model: "L9" }, { regex: "T770H(?:[);/ ]|$)", model: "10L" }, { regex: "T766[HA](?:_EEA)?(?:[);/ ]|$)", model: "10 SE" }, { regex: "T671H(?:_EEA)?(?:[);/ ]|$)", model: "20 SE" }, { regex: "T799[BH](?:[);/ ]|$)", model: "10 Pro" }, { regex: "(Percee TV)(?:[);/ ]|$)", device: "tv", model: "$1" }, { regex: "((?:43|55)S62FS|(?:43|50)P65US|U(?:43|60)P60|65P4USM|(?:40|49)S62|L32S6|55P610|50P8S|55S62|(?:43|50)P6US|55DP60)", device: "tv", model: "$1" }] }, Qre = { regex: "JVC[;,]|JVC Shell", device: "tv", models: [{ regex: "JVC Shell [0-9A-Z]+", model: "" }, { regex: "JVC[;,](32D1290)", model: "$1" }] }, jre = { regex: "phoneOne[ \\-]?([a-z0-9]+)", device: "smartphone", model: "$1" }, Zre = { regex: "PD\\-(3127NC|3127) Build", device: "tablet", models: [{ regex: "PD\\-3127NC Build", model: "PD-3127NC" }, { regex: "PD\\-3127 Build", model: "PD-3127" }] }, zre = { regex: "Pioneer|.*; R1 Build|dvr700pi|XDP-300R", device: "smartphone", models: [{ regex: ".*; R1 Build", model: "R1", device: "tablet" }, { regex: "Pioneer[ _-]?([^;/]+) Build", model: "$1" }, { regex: "Pioneer[ _-]?([^;/)]+)(?:[;/)]|$)", model: "$1" }, { regex: "dvr700pi", model: 'DVR700PI 7.0"', device: "tablet" }, { regex: "(XDP-300R)", device: "portable media player", model: "$1" }] }, qre = { regex: "Pixus|(hiPower|Ride[_ ][34]G|Play[ _]Three[ _]v(?:[24].0|3.1))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "Ride[_ ]([34])G", model: "Ride $1G" }, { regex: "Play[ _]Three[ _]v([24].0|3.1)", model: "Play Three v$1" }, { regex: "Play Two", model: "Play Two" }, { regex: "Play Five", model: "Play Five" }, { regex: "hiPower", model: "hiPower" }, { regex: "Pixus[ _]Sprint", model: "Sprint" }, { regex: "Touch 7 3G", model: "Touch 7 3G" }, { regex: "Pixus[ _]hiMax", model: 'HiMax 9.6"' }, { regex: "Pixus[ _]Blast", model: 'Blast 10.1"' }, { regex: "Pixus[ _]Joker", model: 'Joker 10.1"' }, { regex: "Pixus Blaze 10.1 3G", model: 'Blaze 10.1" 3G' }, { regex: "Raze", model: "Raze", device: "smartphone" }, { regex: "Pixus_Jet", model: "Jet", device: "smartphone" }, { regex: "pixus hit 2", model: "Hit 2", device: "smartphone" }] }, Jre = { regex: "PULID[ _]|F1[01357]\\+? Build", device: "smartphone", models: [{ regex: "F(1[01357]\\+?) Build", model: "F$1" }, { regex: "PULID[ _]([^;/]+) Build", model: "$1" }, { regex: "PULID[ _]([a-z0-9_]+)\\)", model: "$1" }] }, eoe = { regex: "POMP[ _-]", device: "smartphone", models: [{ regex: "POMP[ _-]([^;/]+) Build", model: "$1" }, { regex: "POMP[ _-]([^;/)]+)(?:[;/)]|$)", model: "$1" }] }, toe = { regex: "(KING 7S?)", device: "smartphone", model: "$1" }, roe = { regex: "PLT([^;/]+) Build|PLT(?:777[45]|9774|1074)G(?:[);/ ]|$)", device: "tablet", models: [{ regex: "PLT([^;/]+) Build", model: "PLT$1" }, { regex: "PLT(777[45]|9774|1074)G", model: "PLT$1G" }] }, ooe = { regex: "Readboy[ _-]", device: "tablet", models: [{ regex: "Readboy[ _-]([^;/)]+)(?: Build|[;)])", model: "$1" }] }, noe = { regex: "Roku/DVP", device: "tv", model: "Digital Video Player" }, aoe = { regex: "IO Pro", device: "smartphone", models: [{ regex: "IO Pro", model: "IO Pro" }] }, loe = { regex: "(Rombica|SSQ-A0500|Smart Box v[0-9]+)(?:[);/ ]|$)", device: "tv", models: [{ regex: "SSQ-A0500(?:[);/ ]|$)", model: "Smart Stick 4K" }, { regex: "(Infinity K8|Smart Box (?:v00[345789]|Quad|Ultra HD v002|4K V001))(?:[);/ ]|$)", model: "$1" }] }, ioe = { regex: "Rover ([0-9]+)", device: "feature phone", model: "$1" }, soe = { regex: "(?:Rover[ ]?Pad|RoverPhone|Sky 7.85 3G)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "RoverPhone(?:[);/ ]|$)", model: "", device: "smartphone" }, { regex: "(?:Rover[ ]?Pad)?sky 7.85(?: 3G)?(?:[);/ ]|$)", model: 'Sky 7.85" 3G' }, { regex: "RoverPad (10.4|Air S70|9.7 3G|Sky 9.7|3W A73|3W7|3WT70|3W9.4)(?:[);/ ]|$)", model: "$1" }] }, doe = { regex: "Roadrover ChangAn S", device: "tablet", model: "ChangAn S" }, uoe = { regex: "NEON_RAY", device: "smartphone", models: [{ regex: "NEON_RAY", model: "Neon Ray" }] }, coe = { regex: "(?:SANTIN|BiTBiZ_V58|ACTOMA ACE|DREAMPLUS03A|Candy U7 Pro)[);/_ ]", device: "smartphone", models: [{ regex: "BiTBiZ_V58(?:[);/ ]|$)", model: "BiTBiZ V58" }, { regex: "Candy U7 Pro(?:[);/ ]|$)", model: "Candy U7 Pro" }, { regex: "DREAMPLUS03A(?:[);/ ]|$)", model: "Dream Plus 03A" }, { regex: "GreenOrange(?:[);/ ]|$)", model: "Green Orange" }, { regex: "halove(?:[);/ ]|$)", model: "Halove" }, { regex: "ACTOMA ACE(?:[);/ ]|$)", model: "Actoma Ace" }, { regex: "monica(?:[);/ ]|$)", model: "Monica" }, { regex: "POWER(?:[);/ ]|$)", model: "Power" }, { regex: "GALAZ(?:[);/ ]|$)", model: "Galaz" }, { regex: "NEWDUN(?:[);/ ]|$)", model: "Newdun" }, { regex: "SANTIN[ _][#]?(Dante|Candy U7|Armor|YSL-Y7|ANT.W|N[13]|JS|S6|V9|Life Shine)(?:[);/ ]|$)", model: "$1" }] }, moe = { regex: "SIEMENS|SIE-|portalmmm/2\\.0 SI|(?:S55|SL45i)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:SIE-)?(S[56]5|S40|C45|ME45|SLIK)(?:[);/ ]|$)", device: "feature phone", model: "$1" }, { regex: "SIEMENS[ \\-]([a-z0-9]+)", model: "$1" }, { regex: "SIE(?:MENS )?[\\-]?([a-z0-9]+)", model: "$1" }, { regex: "(?:SIE-)?(SL45i)", model: "$1" }, { regex: "portalmmm/2.0 (SI[a-z0-9]+)", model: "$1" }] }, goe = { regex: "((?:SM-LED32M(?:11|04)S)(?:_-Ver01)?|SM-LED40M04S)(?:[);/ ]|$)", device: "tv", model: "$1" }, foe = /* @__PURE__ */ JSON.parse('{"regex":"SAMSUNG(?! ?Browser)|Maple (?!III)|SC-(?:01[FGHKLM]|02[CGHJKLM]|03[JKL]|04[EJL]|05[GL]|(?:4[12]|5[1234])A)|N[57]100|N5110|N9100|S(?:CH|GH|PH|EC|AM|HV|HW|M)-|SMART-TV|GT-|(?<!GOG|GOG )Galaxy|(?:portalmmm|o2imode)/2\\\\.0 [SZ]|sam[rua]|vollo Vi86(?:[);/ ]|$)|(?:OTV-)?SMT-E5015|ISW11SC|SCV4[0-9]|SCV3[1-9]|40[34]SC|SCL2[234]|SCG0[1-7]|SCT21","device":"smartphone","models":[{"regex":"GT-B9150","device":"tv","model":"Home Sync"},{"regex":"(?:OTV-)?SMT-E5015","device":"tv","model":"SMT-E5015"},{"regex":"Maple ","device":"tv","model":""},{"regex":"(?:SAMSUNG-)?(?:GT-)?N5100","device":"tablet","model":"Galaxy Note 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T677(?:[ATV]|N[KL])?(?:[);/ ]|$)","device":"tablet","model":"Galaxy View 18.4\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T670(?:[);/ ]|$)","device":"tablet","model":"Galaxy View 18.4\\" WiFi"},{"regex":"(?:SAMSUNG-)?(?:GT-)?N5110","device":"tablet","model":"Galaxy Note 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?GT-N5120","device":"tablet","model":"Galaxy Note 8.0\\" LTE"},{"regex":"(?:SAMSUNG-)?(?:GT|SM)-N8000","device":"tablet","model":"Galaxy Note 10.1\\""},{"regex":"(?:SAMSUNG-)?GT-N8010","device":"tablet","model":"Galaxy Note 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?GT-N8020","device":"tablet","model":"Galaxy Note 10.1\\" LTE"},{"regex":"(?:SAMSUNG-)?GT-P1000M?|SCH-I800","device":"tablet","model":"Galaxy Tab"},{"regex":"(?:SAMSUNG-)?GT-P3100B?","device":"tablet","model":"Galaxy Tab 2 7\\""},{"regex":"(?:SAMSUNG-)?GT-P311[03]","device":"tablet","model":"Galaxy Tab 2 7\\" WiFi"},{"regex":"(?:SAMSUNG-)?GT-P5100|SCH-I915","device":"tablet","model":"Galaxy Tab 2 10.1\\""},{"regex":"(?:SAMSUNG-)?GT-P511[03]","device":"tablet","model":"Galaxy Tab 2 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T217T","device":"tablet","model":"Galaxy Tab 3 7.0\\" 4G"},{"regex":"(?:SAMSUNG-)?GT-P5200","device":"tablet","model":"Galaxy Tab 3 10.1\\""},{"regex":"(?:SAMSUNG-)?GT-P5210","device":"tablet","model":"Galaxy Tab 3 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?GT-P5220","device":"tablet","model":"Galaxy Tab 3 10.1\\" LTE"},{"regex":"(?:SAMSUNG-)?GT-P6200","device":"tablet","model":"Galaxy Tab 7\\" Plus"},{"regex":"(?:SAMSUNG-)?GT-P6201","device":"tablet","model":"Galaxy Tab 7\\" Plus N"},{"regex":"(?:SAMSUNG-)?GT-P6810","device":"tablet","model":"Galaxy Tab 7.7\\""},{"regex":"(?:SAMSUNG-)?GT-P7100","device":"tablet","model":"Galaxy Tab 10.1v"},{"regex":"(?:SAMSUNG-)?GT-P75[01]0","device":"tablet","model":"Galaxy Tab 10.1\\""},{"regex":"(?:SAMSUNG-)?SM-P600","device":"tablet","model":"Galaxy Note 10.1\\" 2014 Edition WiFi"},{"regex":"(?:SAMSUNG-)?SM-P60[12]","device":"tablet","model":"Galaxy Note 10.1\\" 2014 Edition"},{"regex":"(?:SAMSUNG-)?SM-(?:P605|P607T)","device":"tablet","model":"Galaxy Note 10.1\\" 2014 Edition LTE"},{"regex":"(?:SAMSUNG-)?SM-P900","device":"tablet","model":"Galaxy NotePRO 12.2\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-P901","device":"tablet","model":"Galaxy NotePRO 12.2\\""},{"regex":"(?:SAMSUNG-)?SM-P905","device":"tablet","model":"Galaxy NotePRO 12.2\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:P587|P588C)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A 10.1\\" with S Pen (2016) LTE"},{"regex":"(?:SAMSUNG-)?SM-P583(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A 10.1\\" with S Pen (2016) WiFi"},{"regex":"(?:SAMSUNG-)?SM-P205(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A 8.0\\" with S Pen (2019) LTE"},{"regex":"(?:SAMSUNG-)?SM-P200(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A 8.0\\" with S Pen (2019) WiFi"},{"regex":"(?:SAMSUNG-)?SM-T307U(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A 8.4\\" (2020) LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:T505[CN]?|T507)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A7 10.4\\" (2020) LTE"},{"regex":"(?:SAMSUNG-)?SM-T500(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab A7 10.4\\" (2020) WiFi"},{"regex":"(?:SAMSUNG-)?SM-T11[03]","device":"tablet","model":"Galaxy Tab 3 Lite 7.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T830[X]?|T837R4)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S4 10.5\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T837P(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S4 10.5\\" with S Pen"},{"regex":"(?:SAMSUNG-)?SM-(?:T835[CN]?|T837[VTA]?)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S4 10.5\\""},{"regex":"(?:SAMSUNG-)?SM-(?:T725[CN]?|T720X|T727(?:R4|[AUV])?)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S5e 10.5\\""},{"regex":"(?:SAMSUNG-)?SM-T720(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S5e 10.5\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T865N?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 10.5\\""},{"regex":"(?:SAMSUNG-)?SM-T867(?:R4|[VU])?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 10.5\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:P615[CN]?|P617)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 Lite 10.4\\""},{"regex":"(?:SAMSUNG-)?SM-P610X?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 Lite 10.4\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T860(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 10.5\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T866N(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S6 10.5\\" 5G"},{"regex":"(?:SAMSUNG-)?SM-T111[M]?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab 3 Lite 7.0\\""},{"regex":"(?:SAMSUNG-)?SM-T116(?:BU|NU|NY)?","device":"tablet","model":"Galaxy Tab 3 V"},{"regex":"(?:SAMSUNG-)?SM-(?:T2105|T212)","device":"tablet","model":"Galaxy Tab 3 7.0\\" Kids"},{"regex":"(?:SAMSUNG-)?SM-T210R?","device":"tablet","model":"Galaxy Tab 3 7.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T21(?:[15]|7[AS])","device":"tablet","model":"Galaxy Tab 3 7.0\\""},{"regex":"(?:SAMSUNG-)?SM-T230(?:NU)?","device":"tablet","model":"Galaxy Tab 4 7.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T23[15]|403SC","device":"tablet","model":"Galaxy Tab 4 7.0\\" 3G"},{"regex":"(?:SAMSUNG-)?SM-(?:T239|T237[PV])","device":"tablet","model":"Galaxy Tab 4 7.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T232(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab 4 7.0\\" WiFi + 3G"},{"regex":"(?:SAMSUNG-)?SM-T310","device":"tablet","model":"Galaxy Tab 3 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T311","device":"tablet","model":"Galaxy Tab 3 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T315","device":"tablet","model":"Galaxy Tab 3 8.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T330","device":"tablet","model":"Galaxy Tab 4 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T33[215]|T337[AVT])","device":"tablet","model":"Galaxy Tab 4 8.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T520","device":"tablet","model":"Galaxy TabPRO 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T53[15]|T537[AV])","device":"tablet","model":"Galaxy Tab 4 10.1\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T536(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab 4 10.1\\" Advanced"},{"regex":"(?:SAMSUNG-)?SM-T532(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab 4 10.1\\""},{"regex":"(?:SAMSUNG-)?SM-T320","device":"tablet","model":"Galaxy TabPRO 8.4\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T325","device":"tablet","model":"Galaxy TabPRO 8.4\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T525","device":"tablet","model":"Galaxy TabPRO 10.1\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:T530(?:NU)?|T533)","device":"tablet","model":"Galaxy Tab 4 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T700","device":"tablet","model":"Galaxy Tab S 8.4\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T705|T707[AV])","device":"tablet","model":"Galaxy Tab S 8.4\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T800","device":"tablet","model":"Galaxy Tab S 10.5\\" WiFi"},{"regex":"(?:SAMSUNG-)?(?:SM-(?:T805|T807[PV]?)|SCT21)","device":"tablet","model":"Galaxy Tab S 10.5\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:T813|T810)","device":"tablet","model":"Galaxy Tab S2 9.7\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T719[CY]?|T715(?:N0|[CY])?)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S2 8.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:T71[03]|T710X)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S2 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T815|T817[ATW]?|T818[ATVW]?|T819[Y]?)","device":"tablet","model":"Galaxy Tab S2 9.7\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T820","device":"tablet","model":"Galaxy Tab S3 9.7\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T82[57]","device":"tablet","model":"Galaxy Tab S3 9.7\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T975N?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7+ 12.4\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T970(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7+ 12.4\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T976[BN]|T978U)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7+ 12.4\\" 5G"},{"regex":"(?:SAMSUNG-)?SM-T870(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7 11.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T875N?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7 11.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T878U(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab S7 11.0\\" 5G"},{"regex":"(?:SAMSUNG-)?SM-T900","device":"tablet","model":"Galaxy TabPRO 12.2\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T280","device":"tablet","model":"Galaxy Tab A 7.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T285","device":"tablet","model":"Galaxy Tab A 7.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T3[58]0","device":"tablet","model":"Galaxy Tab A 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:P350|T3[58]5|T357[TW])","device":"tablet","model":"Galaxy Tab A 8.0\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-T387(?:AA|R4|VK|[TVW])","device":"tablet","model":"Galaxy Tab A 8.0\\" LTE (2018)"},{"regex":"(?:SAMSUNG-)?SM-T295","device":"tablet","model":"Galaxy Tab A 8.0\\" LTE (2019)"},{"regex":"(?:SAMSUNG-)?SM-T290","device":"tablet","model":"Galaxy Tab A 8.0\\" WiFi (2019)"},{"regex":"(?:SAMSUNG-)?SM-(?:P355([MY])?|T550)","device":"tablet","model":"Galaxy Tab A 9.7\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:P550|P555(M)?|T555)","device":"tablet","model":"Galaxy Tab A 9.7\\" LTE"},{"regex":"(?:SAMSUNG-)?SM-(?:T58[05]|P58[05])","device":"tablet","model":"Galaxy Tab A 10.1\\" WiFi (2016)"},{"regex":"(?:SAMSUNG-)?SM-T587[P]?","device":"tablet","model":"Galaxy Tab A 10.1\\" LTE (2016)"},{"regex":"(?:SAMSUNG-)?SM-T59[057]","device":"tablet","model":"Galaxy Tab A 10.5\\" LTE (2018)"},{"regex":"(?:SAMSUNG-)?SM-T51(?:7P|[057])","device":"tablet","model":"Galaxy Tab A 10.1\\" (2019)"},{"regex":"(?:SAMSUNG-)?SM-(?:T37[57]|T378[KLSV])","device":"tablet","model":"Galaxy Tab E 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T56[02]","device":"tablet","model":"Galaxy Tab E 9.6\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-T561","device":"tablet","model":"Galaxy Tab E 9.6\\" 3G"},{"regex":"(?:SAMSUNG-)?SM-T567V","device":"tablet","model":"Galaxy Tab E 9.6\\" 4G"},{"regex":"(?:SAMSUNG-)?SM-T365(?:F0|[MY])?(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T360(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T395[CN]?|T397U)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 2 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T390(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 2 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T575N?|T577U?)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 3 8.0\\""},{"regex":"(?:SAMSUNG-)?SM-T570(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active 3 8.0\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:T545|T547U?)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active Pro 10.1\\""},{"regex":"(?:SAMSUNG-)?SM-T540(?:[);/ ]|$)","device":"tablet","model":"Galaxy Tab Active Pro 10.1\\" WiFi"},{"regex":"(?:SAMSUNG-)?SM-(?:P902|P907A)(?:[);/ ]|$)","device":"tablet","model":"Galaxy Note Pro 12.2\\""},{"regex":"(?:SAMSUNG[- ])?SM-T2519","model":"Galaxy Tab Q","device":"tablet"},{"regex":"(?:SAMSUNG )?SM-R820","device":"wearable","model":"Galaxy Watch Active 2"},{"regex":"(?:SAMSUNG-)?SM-G850(?:8S|[AFKLMSWXY])","model":"Galaxy Alpha"},{"regex":"(?:SAMSUNG-)?GT-B5330","model":"Galaxy Chat"},{"regex":"(?:SAMSUNG-)?SM-A605K","model":"Galaxy Jean"},{"regex":"(?:SAMSUNG-)?SM-A202K","model":"Galaxy Jean 2"},{"regex":"(?:SAMSUNG-)?GT-B5510","model":"Galaxy Y Pro"},{"regex":"(?:SAMSUNG-)?GT-B5512","model":"Galaxy Y Pro Duos"},{"regex":"(?:SAMSUNG-)?GT-B7510","model":"Galaxy Pro"},{"regex":"(?:SAMSUNG-)?GT-I5700","model":"Galaxy Spica"},{"regex":"(?:SAMSUNG-)?GT-I5801","model":"Galaxy Apollo"},{"regex":"(?:SAMSUNG-)?GT-I5800","model":"Galaxy 3"},{"regex":"(?:SAMSUNG-)?GT-I8000","model":"Omnia II"},{"regex":"(?:SAMSUNG-)?(?:GT-I8150|SM-T255S)","model":"Galaxy W"},{"regex":"SC-01H(?:[);/ ]|$)","model":"Galaxy Active Neo"},{"regex":"(?:SAMSUNG-)?GT-S5830","model":"Galaxy Ace"},{"regex":"(?:SAMSUNG-)?SM-(?:G357(?:FZ|M)|G310HN)","model":"Galaxy Ace Style"},{"regex":"(?:SAMSUNG-)?GT-I8160","model":"Galaxy Ace 2"},{"regex":"(?:SAMSUNG-)?SM-G313(?:HY|M[LUY]|[FM])","model":"Galaxy Ace 4"},{"regex":"(?:SAMSUNG-)?SM-G316M","model":"Galaxy Ace 4 Duos"},{"regex":"(?:SAMSUNG-)?SM-G313[HU]","model":"Galaxy Ace 4 Lite"},{"regex":"(?:SAMSUNG-)?SM-(?:G316U|G318(?:H|ML))(?:[);/ ]|$)","model":"Galaxy Ace 4 Neo"},{"regex":"(?:SAMSUNG-)?SM-G9100(?:[);/ ]|$)","model":"Galaxy S II"},{"regex":"(?:SAMSUNG-)?SHV-E120S(?:[);/ ]|$)","model":"Galaxy S II HD LTE"},{"regex":"(?:SAMSUNG-)?GT-I8190","model":"Galaxy S III mini"},{"regex":"(?:SAMSUNG-)?GT-I8200","model":"Galaxy S III mini Value Edition"},{"regex":"(?:SAMSUNG-)?GT-I826[02]","model":"Galaxy Core"},{"regex":"(?:SAMSUNG-)?SM-G386W","model":"Galaxy Core LTE"},{"regex":"(?:SAMSUNG-)?SM-G3589W","model":"Galaxy Core Lite LTE"},{"regex":"(?:SAMSUNG-)?GT-I8320","model":"H1"},{"regex":"(?:SAMSUNG-)?GT-I85[23]0","model":"Galaxy Beam"},{"regex":"(?:SAMSUNG-)?SM-G3858","model":"Galaxy Beam 2"},{"regex":"(?:SAMSUNG-)?SM-G600S","model":"Galaxy Wide"},{"regex":"(?:SAMSUNG-)?GT-I855[028]","model":"Galaxy Win"},{"regex":"(?:SAMSUNG-)?SM-G381[28]","model":"Galaxy Win Pro"},{"regex":"(?:SAMSUNG-)?GT-I8580","model":"Galaxy Core Advance"},{"regex":"(?:SAMSUNG-)?GT-I8730","model":"Galaxy Express"},{"regex":"(?:SAMSUNG-)?SM-(?:E500(?:HQ|YZ|[0FHM])|S978L)","model":"Galaxy E5"},{"regex":"(?:SAMSUNG-)?SM-E700[09FHM]","model":"Galaxy E7"},{"regex":"(?:SAMSUNG-)?GT-I90(?:00|08|18|88)","model":"Galaxy S"},{"regex":"(?:SAMSUNG-)?GT-I9001","model":"Galaxy S Plus"},{"regex":"(?:SAMSUNG-)?GT-I9003","model":"Galaxy SL"},{"regex":"(?:SAMSUNG-)?GT-I9010","model":"Galaxy S Giorgio Armani"},{"regex":"(?:SAMSUNG-)?GT-I9070","model":"Galaxy S Advance"},{"regex":"(?:SAMSUNG-)?GT-I910[08]","model":"Galaxy S II"},{"regex":"(?:SAMSUNG-)?ISW11SC","model":"Galaxy S II WiMAX"},{"regex":"(?:SAMSUNG-)?GT-I9103","model":"Galaxy R"},{"regex":"(?:SAMSUNG-)?GT-I9105","model":"Galaxy S II Plus"},{"regex":"(?:SAMSUNG-)?SM-G730(?:W8|[AV])","model":"Galaxy S3 mini"},{"regex":"(?:SAMSUNG-)?(?:GT-I919[025]|SCH-I435)","model":"Galaxy S4 mini"},{"regex":"(?:SAMSUNG-)?GT-I9515","model":"Galaxy S4 Value Edition"},{"regex":"(?:SAMSUNG-)?GT-I9295","model":"Galaxy S4 ACTIVE"},{"regex":"(?:SAMSUNG-)?(?:GT-I9300|SCH-(?:I535|I939|L710))","model":"Galaxy S III"},{"regex":"(?:SAMSUNG-)?(?:GT-I9305|SCH-R530)","model":"Galaxy S III LTE"},{"regex":"(?:SAMSUNG-)?(?:SM-S975L|GT-I950[025]|SC-04E|SCH-(?:I545|I959|R970)|SGH-M919N?|Galaxy-S4)","model":"Galaxy S4"},{"regex":"(?:SAMSUNG-)?GT-I9506","model":"Galaxy S4 with LTE+"},{"regex":"(?:SAMSUNG-)?GT-S5280","model":"Galaxy STAR"},{"regex":"(?:SAMSUNG-)?GT-S5301","model":"Galaxy POCKET Plus"},{"regex":"(?:SAMSUNG-)?GT-S5310","model":"Galaxy POCKET Neo"},{"regex":"(?:SAMSUNG-)?SM-G110[BHM]","model":"Galaxy POCKET 2"},{"regex":"(?:SAMSUNG-)?GT-S5360","model":"Galaxy Y Hello Kitty"},{"regex":"(?:SAMSUNG-)?GT-S6310","model":"Galaxy Young"},{"regex":"(?:SAMSUNG-)?GT-S6312","model":"Galaxy Young DUOS"},{"regex":"(?:SAMSUNG-)?SM-G130(?:BT|HN|[EHMU])","model":"Galaxy Young 2"},{"regex":"(?:SAMSUNG-)?SM-G130BU","model":"Galaxy Young 2 Pro"},{"regex":"(?:SAMSUNG-)?GT-S6790","model":"Galaxy FAME Lite with NFC"},{"regex":"(?:SAMSUNG-)?GT-S6810","model":"Galaxy FAME"},{"regex":"(?:SAMSUNG-)?GT-S6812","model":"Galaxy FAME Duos"},{"regex":"SC-04J(?:[);/ ]|$)","model":"Galaxy Feel"},{"regex":"SC-02L(?:[);/ ]|$)","model":"Galaxy Feel 2"},{"regex":"(?:SAMSUNG-)?GT-S7275","model":"Galaxy ACE 3"},{"regex":"(?:SAMSUNG-)?GT-S7500","model":"Galaxy ACE Plus"},{"regex":"(?:SAMSUNG-)?(?:GT-S7560|SCH-I699)","model":"Galaxy Trend"},{"regex":"(?:SAMSUNG-)?GT-S7390","model":"Galaxy Trend Lite"},{"regex":"(?:SAMSUNG-)?GT-S7580","model":"Galaxy Trend Plus"},{"regex":"(?:SAMSUNG-)?SCH-I739","model":"Galaxy Trend 2"},{"regex":"(?:SAMSUNG-)?(?:GT-S7562|SCH-I919)","model":"Galaxy S DUOS"},{"regex":"(?:SAMSUNG-)?GT-S7582","model":"Galaxy S DUOS 2"},{"regex":"(?:SAMSUNG-)?SM-(?:G31[36]HU|G313HZ)","model":"Galaxy S DUOS 3"},{"regex":"(?:SAMSUNG-)?GT-S7710","model":"Galaxy Xcover 2"},{"regex":"(?:SAMSUNG-)?SM-G388F","model":"Galaxy Xcover 3"},{"regex":"(?:SAMSUNG-)?SM-G389F","model":"Galaxy Xcover 3 VE"},{"regex":"(?:SAMSUNG-)?SM-G390[FWY]","model":"Galaxy Xcover 4"},{"regex":"(?:SAMSUNG-)?SM-G398FN","model":"Galaxy Xcover 4s"},{"regex":"(?:SAMSUNG-)?SM-G715(?:FN|U1|[AUW])","model":"Galaxy Xcover Pro"},{"regex":"(?:SAMSUNG-)?SM-G889(?:YB|[AFG])","model":"Galaxy Xcover FieldPro"},{"regex":"(?:SAMSUNG-)?GT-S8500","model":"Wave"},{"regex":"(?:SAMSUNG-)?GT-S8530","model":"Wave II"},{"regex":"(?:SAMSUNG-)?GT-S8600","model":"Wave 3"},{"regex":"(?:SAMSUNG-)?GT-S5380","model":"Wave Y"},{"regex":"(?:SAMSUNG-)?GT-S7250","model":"Wave M"},{"regex":"(?:SAMSUNG-)?GT-S5250","model":"Wave 525"},{"regex":"(?:SAMSUNG-)?GT-S5330","model":"Wave 533"},{"regex":"(?:SAMSUNG-)?GT-S5780","model":"Wave 578"},{"regex":"(?:SAMSUNG-)?GT-S7230","model":"Wave 723"},{"regex":"(?:SAMSUNG-)?SM-(?:C101|C105([AL])?)","model":"Galaxy S4 zoom"},{"regex":"(?:SAMSUNG-)?SM-(?:C111(M)?|C115)","model":"Galaxy K zoom"},{"regex":"(?:SAMSUNG-)?SM-G318[HM]Z","model":"Galaxy V Plus"},{"regex":"(?:SAMSUNG-)?SM-G355(?:6D|[89HM])","model":"Galaxy Core 2"},{"regex":"(?:SAMSUNG-)?SM-G350","model":"Galaxy Core Plus"},{"regex":"(?:SAMSUNG-)?SM-(?:G360[FH]?|S820L)","model":"Galaxy Core Prime"},{"regex":"(?:SAMSUNG-)?SM-G361[FH]?","model":"Galaxy Core Prime Value Edition"},{"regex":"(?:SAMSUNG-)?SM-(?:G386F|G3518(?:_TD)?|G3586V)","model":"Galaxy Core LTE"},{"regex":"(?:SAMSUNG-)?SM-G3568V","model":"Galaxy Core Mini 4G"},{"regex":"(?:SAMSUNG-)?SM-G5108Q?","model":"Galaxy Core Max"},{"regex":"(?:SAMSUNG-)?SM-G3815","model":"Galaxy EXPRESS II"},{"regex":"(?:SAMSUNG-)?SM-G800","model":"Galaxy S5 mini"},{"regex":"(?:SAMSUNG-)?SM-G9009D","model":"Galaxy S5 Dual-SIM"},{"regex":"(?:SAMSUNG-)?SM-(?:G900|G906[KLS]|S902L|S903VL)|Galaxy-S5|SCL23","model":"Galaxy S5"},{"regex":"(?:SAMSUNG-)?SM-G901F","model":"Galaxy S5 LTE+"},{"regex":"(?:SAMSUNG-)?SM-G870[AFW]|SC-02G","model":"Galaxy S5 Active"},{"regex":"(?:SAMSUNG-)?SM-G903[FMW]","model":"Galaxy S5 Neo"},{"regex":"(?:SAMSUNG-)?SM-G860P","model":"Galaxy S5 K Sport"},{"regex":"(?:SAMSUNG-)?(?:SM-G920(?:F[DQ]|W8|[089AFIKLPRSTVX])?|SM-S906L|SM-S907VL)|SC-05G","model":"Galaxy S6"},{"regex":"(?:SAMSUNG-)?SM-G890A","model":"Galaxy S5 Active"},{"regex":"(?:SAMSUNG-)?SM-G925[0ADFIKLPRSTVWX]|SCV31|404SC","model":"Galaxy S6 Edge"},{"regex":"(?:SAMSUNG-)?SM-G928(?:7C|N0|R4|W8|[07ACFGIKLPSTVX])","model":"Galaxy S6 Edge+"},{"regex":"(?:SAMSUNG-)?SM-G930(?:AZ|FD|R[467]|T1|V[CL]|W8|[0AFKLPRSTUVX8])?(?:[);/ ]|$)","model":"Galaxy S7"},{"regex":"(?:SAMSUNG-)?SM-G935(?:R4|W8|[0AFKLPSTUVX])|SC-02H|SCV33","model":"Galaxy S7 Edge"},{"regex":"(?:SAMSUNG-)?SM-G891A","model":"Galaxy S7 Active"},{"regex":"(?:SAMSUNG-)?SM-G950[08FNUW]?|SCV36|SC-02J","model":"Galaxy S8"},{"regex":"(?:SAMSUNG-)?SM-G8750","model":"Galaxy S8 Lite"},{"regex":"(?:SAMSUNG-)?SM-G892[AU]","model":"Galaxy S8 Active"},{"regex":"(?:SAMSUNG-)?SM-G955[0AFKLNPRTUVWX]?|SCV35|SC-03J","model":"Galaxy S8+"},{"regex":"(?:SAMSUNG-)?SM-G960[0FNUWX]?|SCV38|SC-02K","model":"Galaxy S9"},{"regex":"(?:SAMSUNG-)?SM-G965[0FNUWX]|SCV39|SC-03K","model":"Galaxy S9+"},{"regex":"(?:SAMSUNG-)?(?:SM-(?:G973|G977[BNPTU])|SCV41|SC-03L)","model":"Galaxy S10"},{"regex":"(?:SAMSUNG-)?SM-(?:S10 Lite|G770(?:U1|F))","model":"Galaxy S10 Lite"},{"regex":"(?:SAMSUNG-)?(?:SM-G975[08FUNWX]|SCV42|SC-04L)","model":"Galaxy S10+"},{"regex":"SC-05L","model":"Galaxy S10+ Olympic Games Edition"},{"regex":"(?:SAMSUNG-)?SM-G970(?:U1|[08FUNWX])(?:[);/ ]|$)","model":"Galaxy S10e"},{"regex":"(?:SAMSUNG-)?SM-G980F","model":"Galaxy S20"},{"regex":"(?:SAMSUNG-)?SM-G981(?:U1|[0BNUVW])|SCG01|SC-51A","model":"Galaxy S20 5G"},{"regex":"(?:SAMSUNG-)?SM-G780F","model":"Galaxy S20 FE"},{"regex":"(?:SAMSUNG-)?SM-G781(?:U1|[0BNUVW])","model":"Galaxy S20 FE 5G"},{"regex":"(?:SAMSUNG-)?SM-G988(?:U1|[0BNQUW])|SCG03","model":"Galaxy S20 Ultra 5G"},{"regex":"(?:SAMSUNG-)?SM-G985F|SCG02","model":"Galaxy S20+"},{"regex":"(?:SAMSUNG-)?SM-G986(?:U1|[0BNUW])|SC-52A","model":"Galaxy S20+ 5G"},{"regex":"(?:SAMSUNG-)?SM-G991(?:U1|[0BNW])","model":"Galaxy S21 5G"},{"regex":"(?:SAMSUNG-)?SM-G998(?:U1|[0BNUW])","model":"Galaxy S21 Ultra 5G"},{"regex":"(?:SAMSUNG-)?SM-G996(?:U1|[0BNWU])","model":"Galaxy S21+ 5G"},{"regex":"(?:SAMSUNG-)?SM-F700(?:U1|[0FNUW])|SCV47","model":"Galaxy Z Flip"},{"regex":"(?:SAMSUNG-)?SM-F707(?:U1|[0BNUW])|SCG04","model":"Galaxy Z Flip 5G"},{"regex":"(?:SAMSUNG-)?SCH-I200","model":"Galaxy Stellar"},{"regex":"(?:SAMSUNG-)?SCH-I829","model":"Galaxy Style Duos"},{"regex":"(?:SAMSUNG-)?(?:SCH-R740|SGH-S730)","model":"Galaxy Discover"},{"regex":"(?:SAMSUNG-)?SCH-S738","model":"Galaxy Centura"},{"regex":"vollo Vi86(?:[);/ ]|$)","model":"Vollo Vi86"},{"regex":"(?:SAMSUNG-)?SM-G386(?:T1|T)","model":"Galaxy Avant"},{"regex":"(?:SAMSUNG-)?SM-A716S","model":"Galaxy A Quantum"},{"regex":"(?:SAMSUNG-)?SM-(?:A015(?:DL|[TU]1|[AFGMUV])|S111DL)","model":"Galaxy A01"},{"regex":"(?:SAMSUNG-)?SM-A013[FGM]","model":"Galaxy A01 Core"},{"regex":"(?:SAMSUNG-)?SM-A025[FGM]","model":"Galaxy A02s"},{"regex":"(?:SAMSUNG-)?SM-A022G","model":"Galaxy A02"},{"regex":"(?:SAMSUNG-)?SM-A260[FG]","model":"Galaxy A2 Core"},{"regex":"(?:SAMSUNG-)?SM-A300(?:FU|YZ|XU|XZ|[09FGHMXY])","model":"Galaxy A3 (2015)"},{"regex":"(?:SAMSUNG-)?SM-A310(?:N0|[FMXY])","model":"Galaxy A3 (2016)"},{"regex":"(?:SAMSUNG-)?SM-A320(?:FL|[FXY])","model":"Galaxy A3 (2017)"},{"regex":"(?:SAMSUNG-)?SM-A430F","model":"Galaxy A4"},{"regex":"(?:SAMSUNG-)?SM-A500(?:YZ|[9LSWY])?(?:[);/ ]|$)","model":"Galaxy A5"},{"regex":"(?:SAMSUNG-)?SM-A500[0FGHKM]","model":"Galaxy A5 Duos"},{"regex":"(?:SAMSUNG-)?SM-A500(?:FU|X)","model":"Galaxy A5 (2015)"},{"regex":"(?:SAMSUNG-)?SM-A510[08FKLMSXY]","model":"Galaxy A5 (2016)"},{"regex":"(?:SAMSUNG-)?SM-A520[FKLSWX]","model":"Galaxy A5 (2017)"},{"regex":"(?:SAMSUNG-)?SM-A525F","model":"Galaxy A52"},{"regex":"(?:SAMSUNG-)?SM-A600(?:AZ|FN|GN|T1|[AFGNPTUX])","model":"Galaxy A6"},{"regex":"(?:SAMSUNG-)?SM-A605(?:[FG]N|[08FGX])","model":"Galaxy A6+"},{"regex":"(?:SAMSUNG-)?SM-G6200","model":"Galaxy A6s (2018)"},{"regex":"(?:SAMSUNG-)?SM-A606[0Y]","model":"Galaxy A60"},{"regex":"(?:SAMSUNG-)?SM-A700(?:YD|[09FHKLSX])","model":"Galaxy A7"},{"regex":"(?:SAMSUNG-)?SM-A710[08FKLMSXY]","model":"Galaxy A7 (2016)"},{"regex":"(?:SAMSUNG-)?SM-A720[FMSX]","model":"Galaxy A7 (2017)"},{"regex":"(?:SAMSUNG-)?SM-A750(?:GN|[CFGNX])","model":"Galaxy A7 (2018)"},{"regex":"(?:SAMSUNG-)?SM-A71(?:5[FW])?(?:[);/ ]|$)","model":"Galaxy A71"},{"regex":"(?:SAMSUNG-)?SM-A725F(?:[);/ ]|$)","model":"Galaxy A72"},{"regex":"(?:SAMSUNG-)?SM-A716(?:U1|[0BUV])(?:[);/ ]|$)","model":"Galaxy A71 5G"},{"regex":"(?:SAMSUNG-)?SM-A(?:530F|800[0FISXY])|SCV32","model":"Galaxy A8"},{"regex":"(?:SAMSUNG-)?SM-G885[FSY]","model":"Galaxy A8 Star"},{"regex":"(?:SAMSUNG-)?SM-A810(?:YZ|[FS])","model":"Galaxy A8 (2016)"},{"regex":"(?:SAMSUNG-)?SM-(?:A8s|G887[0F])","model":"Galaxy A8s"},{"regex":"(?:SAMSUNG-)?SM-A530[MNWX]","model":"Galaxy A8 (2018)"},{"regex":"(?:SAMSUNG-)?SM-A730[FX]","model":"Galaxy A8+ (2018)"},{"regex":"(?:SAMSUNG-)?SM-A900[0F]","model":"Galaxy A9"},{"regex":"SM-A9\\\\[7\\\\]","model":"Galaxy A9 7"},{"regex":"(?:SAMSUNG-)?SM-A920[0FXN]","model":"Galaxy A9 (2018)"},{"regex":"(?:SAMSUNG-)?SM-G885[08]","model":"Galaxy A9 Star"},{"regex":"(?:SAMSUNG-)?SM-(?:A9 Pro|A910[0F]|G887N)","model":"Galaxy A9 Pro"},{"regex":"(?:SAMSUNG-)?SM-A105[FGMN]","model":"Galaxy A10"},{"regex":"(?:SAMSUNG-)?SM-A107[FM]","model":"Galaxy A10s"},{"regex":"(?:SAMSUNG-)?SM-(?:S102DL|A102[NUW])","model":"Galaxy A10e"},{"regex":"(?:SAMSUNG-)?SM-A115(?:A[PZ]|U1|[AFMUW])","model":"Galaxy A11"},{"regex":"(?:SAMSUNG-)?SM-A125[FM]","model":"Galaxy A12"},{"regex":"(?:SAMSUNG-)?SM-(?:A205(?:U1|YN|[FGSWU])|S205DL)|SC-02M|SCV46","model":"Galaxy A20"},{"regex":"(?:SAMSUNG-)?(?:SM-A215(?:DL|U1|[UW])|SC-42A|SCV49)(?:[);/ ]|$)","model":"Galaxy A21"},{"regex":"(?:SAMSUNG-)?SM-A217[FMN](?:[);/ ]|$)","model":"Galaxy A21s"},{"regex":"(?:SAMSUNG-)?SM-A202[FG]","model":"Galaxy A20e"},{"regex":"(?:SAMSUNG-)?SM-A207[0FM]","model":"Galaxy A20s"},{"regex":"(?:SAMSUNG-)?(?:SM-A305(?:[FGY]N|GT|[FGN])|SCV43)","model":"Galaxy A30"},{"regex":"(?:SAMSUNG-)?SM-A307(?:FN|GN|GT|[FG])","model":"Galaxy A30s"},{"regex":"(?:SAMSUNG-)?SM-A315[FGN](?:[);/ ]|$)","model":"Galaxy A31"},{"regex":"(?:SAMSUNG-)?SM-A325F(?:[);/ ]|$)","model":"Galaxy A32"},{"regex":"(?:SAMSUNG-)?SM-A326(?:BR|B)","model":"Galaxy A32 5G"},{"regex":"(?:SAMSUNG-)?SM-A405(?:F[NM]|S)","model":"Galaxy A40"},{"regex":"(?:SAMSUNG-)?SM-A305[018](?:[);/ ]|$)","model":"Galaxy A40s"},{"regex":"(?:SAMSUNG-)?(?:SM-A415F|SC-41A|SCV48)(?:[);/ ]|$)","model":"Galaxy A41"},{"regex":"(?:SAMSUNG-)?SM-A426[0BN](?:[);/ ]|$)","model":"Galaxy A42 5G"},{"regex":"(?:SAMSUNG-)?SM-(?:A505(?:F[GN]|U1|YN|[FGNUWX])|S506DL|505FN)","model":"Galaxy A50"},{"regex":"(?:SAMSUNG-)?SM-A5070(?:[);/ ]|$)","model":"Galaxy A50s"},{"regex":"(?:SAMSUNG-)?SM-A507FN","model":"Galaxy A50s"},{"regex":"(?:SAMSUNG-)?SM-(?:A515[FUW]|S515DL)","model":"Galaxy A51"},{"regex":"(?:SAMSUNG-)?(?:SM-A516(?:U1|[0BNUV])|SC-54A|SCG07)","model":"Galaxy A51 5G"},{"regex":"(?:SAMSUNG-)?SM-A705(?:GM|[MYF]N|[0FUWX])","model":"Galaxy A70"},{"regex":"(?:SAMSUNG-)?SM-A707[0F]","model":"Galaxy A70s"},{"regex":"(?:SAMSUNG-)?SM-A805[0FNX]","model":"Galaxy A80"},{"regex":"(?:SAMSUNG-)?SM-A908[BN]","model":"Galaxy A90"},{"regex":"(?:SAMSUNG-)?SM-A9080","model":"Galaxy A90 5G"},{"regex":"(?:SAMSUNG-)?SM-F127G(?:[);/ ]|$)","model":"Galaxy F12"},{"regex":"(?:SAMSUNG-)?SM-F415F(?:[);/ ]|$)","model":"Galaxy F41"},{"regex":"(?:SAMSUNG-)?GT-I9301I","model":"Galaxy S III Neo"},{"regex":"(?:SAMSUNG-)?SM-S120VL(?:[);/ ]|$)","model":"Galaxy Luna"},{"regex":"(?:SAMSUNG-)?SM-(?:J100(?:FN|VPP|MU|[FGHMY])|S777C)","model":"Galaxy J1"},{"regex":"(?:SAMSUNG-)?SM-J105[BFHYM]","model":"Galaxy J1 Mini"},{"regex":"(?:SAMSUNG-)?SM-J106[BFHM]","model":"Galaxy J1 mini Prime"},{"regex":"(?:SAMSUNG-)?SM-(?:J120(?:ZN|[AFGHMPTW])|J05H)","model":"Galaxy J1 (2016)"},{"regex":"(?:SAMSUNG-)?SM-(?:J110[FGHLM]|J111[FM])","model":"Galaxy J1 Ace"},{"regex":"(?:SAMSUNG-)?SM-J200[FGHMY]","model":"Galaxy J2"},{"regex":"(?:SAMSUNG-)?SM-J200BT","model":"Galaxy J2 Duos"},{"regex":"(?:SAMSUNG-)?SM-J260AZ","model":"Galaxy J2 Pure"},{"regex":"(?:SAMSUNG-)?SM-(?:J260([AFGMY]|T1)|S260DL)","model":"Galaxy J2 Core"},{"regex":"(?:SAMSUNG-)?SM-J(?:210F|250[FGMNY])","model":"Galaxy J2 Pro"},{"regex":"(?:SAMSUNG-)?SM-(?:S367VL|S357BL)","model":"Galaxy J3 Orbit"},{"regex":"(?:SAMSUNG-)?SM-J311(?:[09]|9S)","model":"Galaxy J3 Pro"},{"regex":"(?:SAMSUNG-)?SM-S320VL(?:[);/ ]|$)","model":"Galaxy J3 Sky"},{"regex":"(?:SAMSUNG-)?SM-S327VL(?:[);/ ]|$)","model":"Galaxy J3 Luna Pro"},{"regex":"(?:SAMSUNG-)?SM-J327(?:T1|[ATW])(?:[);/ ]|$)","model":"Galaxy J3 Prime"},{"regex":"(?:SAMSUNG-)?SM-J327(?:[FP]|R4)","model":"Galaxy J3 Emerge"},{"regex":"(?:SAMSUNG-)?SM-J337R4(?:[);/ ]|$)","model":"Galaxy J3 Aura"},{"regex":"(?:SAMSUNG-)?SM-J337T(?:[);/ ]|$)","model":"Galaxy J3 Star"},{"regex":"(?:SAMSUNG-)?SM-J327V","model":"Galaxy J3 Eclipse"},{"regex":"(?:SAMSUNG-)?SM-S337TL","model":"Galaxy J3 Luna Pro"},{"regex":"(?:SAMSUNG-)?SM-J3109","model":"Galaxy J3 (2015)"},{"regex":"(?:SAMSUNG-)?SM-(?:J300H|J320(?:[ZF]N|R4|W8|YZ|[AFGHMNPVY]))","model":"Galaxy J3 (2016)"},{"regex":"(?:SAMSUNG-)?SM-(?:J330(?:FN|[08FGLN])|J327(?:R7|U))(?:[);/ ]|$)","model":"Galaxy J3 (2017)"},{"regex":"(?:SAMSUNG-)?SM-J337(?:VPP|[AWPUV])(?:[);/ ]|$)","model":"Galaxy J3 (2018)"},{"regex":"(?:SAMSUNG-)?SM-(?:G400[FG]|J400[FGM])","model":"Galaxy J4"},{"regex":"(?:SAMSUNG-)?SM-J500(?:FN|N0|[78FGHMY])(?:[);/ ]|$)","model":"Galaxy J5 (2015)"},{"regex":"(?:SAMSUNG-)?SM-(?:J510(?:[FGMU]N|FQ|[8FGHKLSY])|5108|G510H)(?:[);/ ]|$)","model":"Galaxy J5 (2016)"},{"regex":"(?:SAMSUNG-)?SM-J530","model":"Galaxy J5 (2017)"},{"regex":"(?:SAMSUNG-)?SM-G570[0FMY]","model":"Galaxy J5 Prime"},{"regex":"(?:SAMSUNG-)?SM-J600[FGLN]","model":"Galaxy J6"},{"regex":"(?:SAMSUNG-)?SM-J610[FG]","model":"Galaxy J6+"},{"regex":"(?:SAMSUNG-)?SM-J410[FG]","model":"Galaxy J4 Core"},{"regex":"(?:SAMSUNG-)?SM-J415(?:[FG]N|[FGN])","model":"Galaxy J4+"},{"regex":"(?:SAMSUNG-)?SM-J7[01]0(?:FN|MN|[8FHKM])","model":"Galaxy J7"},{"regex":"(?:SAMSUNG-)?SM-J700P","model":"Galaxy J7 (2015)"},{"regex":"(?:SAMSUNG-)?SM-(?:J700(?:T1|T)|J710GN|J7109)","model":"Galaxy J7 (2016)"},{"regex":"(?:SAMSUNG-)?SM-(?:J730[K]|J727(?:R4|[AFSU]))(?:[);/ ]|$)","model":"Galaxy J7 (2017)"},{"regex":"(?:SAMSUNG-)?SM-J737(?:R4|T1|VPP|[APSTUV])(?:[);/ ]|$)","model":"Galaxy J7 (2018)"},{"regex":"(?:SAMSUNG-)?SM-C710F","model":"Galaxy J7+ (C7)"},{"regex":"(?:SAMSUNG-)?SM-G610[FMY]","model":"Galaxy J7 Prime"},{"regex":"(?:SAMSUNG-)?SM-G611(?:FF|MT|M)","model":"Galaxy J7 Prime 2"},{"regex":"(?:SAMSUNG-)?SM-G615F","model":"Galaxy J7 Max"},{"regex":"(?:SAMSUNG-)?SM-(?:S727VL|S737TL)","model":"Galaxy J7 Sky Pro"},{"regex":"(?:SAMSUNG-)?SM-(?:J7 Pro|J730(?:GM|[FG]))","model":"Galaxy J7 Pro"},{"regex":"(?:SAMSUNG-)?SM-J701[FM]","model":"Galaxy J7 Core"},{"regex":"(?:SAMSUNG-)?SM-J720[FM]","model":"Galaxy J7 Duo"},{"regex":"(?:SAMSUNG-)?SM-(?:S767VL|S757BL)","model":"Galaxy J7 Crown"},{"regex":"(?:SAMSUNG-)?SM-J727[PTV]","model":"Galaxy J7 V"},{"regex":"SM-J7\\\\[7\\\\]","model":"Galaxy J7 7"},{"regex":"(?:SAMSUNG-)?SM-J810","model":"Galaxy J8"},{"regex":"SM-J8 Plus","model":"Galaxy J8 Plus"},{"regex":"SM-J8 Pro","model":"Galaxy J8 Pro"},{"regex":"SM-J9\\\\[7\\\\] Prime","model":"Galaxy J9 7 Prime"},{"regex":"SM-J9\\\\[8\\\\] Pro","model":"Galaxy J9 8 Pro"},{"regex":"(?:SAMSUNG-)?SM-M015[FG]","model":"Galaxy M01"},{"regex":"(?:SAMSUNG-)?SM-M013F","model":"Galaxy M01 Core"},{"regex":"(?:SAMSUNG-)?SM-M017F","model":"Galaxy M01s"},{"regex":"(?:SAMSUNG-)?SM-M025F","model":"Galaxy M02s"},{"regex":"(?:SAMSUNG-)?SM-M105[FGMY]","model":"Galaxy M10"},{"regex":"(?:SAMSUNG-)?SM-M107F","model":"Galaxy M10s"},{"regex":"(?:SAMSUNG-)?SM-M115[FM]","model":"Galaxy M11"},{"regex":"(?:SAMSUNG-)?SM-M127[FG]","model":"Galaxy M12"},{"regex":"(?:SAMSUNG-)?SM-(?:M205(?:[FGMN]|FN)|M20)(?:[);/ ]|$)","model":"Galaxy M20"},{"regex":"(?:SAMSUNG-)?SM-M215F","model":"Galaxy M21"},{"regex":"(?:SAMSUNG-)?SM-(?:M307(?:FN|[0F])|M30s)","model":"Galaxy M30s"},{"regex":"(?:SAMSUNG-)?SM-M305?","model":"Galaxy M30"},{"regex":"(?:SAMSUNG-)?SM-M315F","model":"Galaxy M31"},{"regex":"(?:SAMSUNG-)?SM-M317F","model":"Galaxy M31s"},{"regex":"(?:SAMSUNG-)?SM-M405","model":"Galaxy M40"},{"regex":"(?:SAMSUNG-)?SM-M515F","model":"Galaxy M51"},{"regex":"(?:SAMSUNG-)?SM-W201([689])","model":"Galaxy W201$1"},{"regex":"(?:SAMSUNG-)?SM-W2015","model":"Galaxy Golden 2"},{"regex":"(?:SAMSUNG-)?SM-G910S","model":"Galaxy Round"},{"regex":"(?:SAMSUNG-)?SM-(?:G550(?:FY|T[12]?)|S550TL|G55[01]0|G5520)","model":"Galaxy On5"},{"regex":"(?:SAMSUNG-)?SM-G5528","model":"Galaxy On5 (2016)"},{"regex":"(?:SAMSUNG-)?SM-G600(?:FY|[0F])","model":"Galaxy On7"},{"regex":"(?:SAMSUNG-)?SM-G610[0KLS]","model":"Galaxy On7 (2016)"},{"regex":"(?:SAMSUNG-)?SM-G611[FKLS]","model":"Galaxy On7 Prime"},{"regex":"(?:SAMSUNG-)?SM-C500[0X]","model":"Galaxy C5"},{"regex":"(?:SAMSUNG-)?SM-C501[08]","model":"Galaxy C5 Pro"},{"regex":"(?:SAMSUNG-)?SM-C700[0X]","model":"Galaxy C7"},{"regex":"(?:SAMSUNG-)?SM-C701[08FX]","model":"Galaxy C7 Pro"},{"regex":"(?:SAMSUNG-)?SM-C710[08]","model":"Galaxy C8"},{"regex":"(?:SAMSUNG-)?SM-C900[08FY]","model":"Galaxy C9 Pro"},{"regex":"(?:SAMSUNG-)?SM-Z130H","model":"Galaxy Z1"},{"regex":"(?:SAMSUNG-)?SM-Z200[FMY]","model":"Galaxy Z2"},{"regex":"(?:SAMSUNG-)?SM-Z300H","model":"Galaxy Z3"},{"regex":"(?:SAMSUNG-)?SM-Z400[FY]","model":"Galaxy Z4"},{"regex":"(?:SAMSUNG-)?SM-(?:G150(?:N[0KLS])?|G155S)(?:[);/ ]|$)","model":"Galaxy Folder"},{"regex":"(?:SAMSUNG-)?(?:SM-G16(?:0N|[05]0?|5N))(?:[);/ ]|$)","model":"Galaxy Folder 2"},{"regex":"(?:SAMSUNG-)?SM-J321AZ(?:[);/ ]|$)","model":"Galaxy Sol"},{"regex":"(?:SAMSUNG-)?SM-J326AZ(?:[);/ ]|$)","model":"Galaxy Sol 2"},{"regex":"(?:SAMSUNG-)?SM-J336AZ(?:[);/ ]|$)","model":"Galaxy Sol 3"},{"regex":"(?:SAMSUNG-)?SM-J727AZ(?:[);/ ]|$)","model":"Galaxy Halo"},{"regex":"(?:SAMSUNG-)?SM-J327AZ","model":"Galaxy Amp Prime 2"},{"regex":"(?:SAMSUNG-)?SM-J337AZ","model":"Galaxy Amp Prime 3 (2018)"},{"regex":"(?:SAMSUNG-)?SM-(?:F900[0FUW]|F907[BN])|SCV44","model":"Galaxy Fold","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-F916(?:U1|[0BNQUW])|SCG05","model":"Galaxy Z Fold 2 5G","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I9060(?:[);/ ]|$)","model":"Galaxy Grand Neo","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I9063","model":"Galaxy Grand Neo Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I9(?:080|128)","model":"Galaxy Grand","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I9168","model":"Galaxy Grand Neo+","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I9082","model":"Galaxy Grand Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-N7000","model":"Galaxy Note","device":"phablet"},{"regex":"(?:SC-01G|SCL24)(?:[);/ ]|$)","model":"Galaxy Note Edge","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N935[FSLK](?:[);/ ]|$)","model":"Galaxy Note Fan Edition","device":"phablet"},{"regex":"(?:SAMSUNG-)?(?:(?:GT-)?N7100|SCH-(?:I605|N719|R950)|SPH-L900)(?:[);/ ]|$)","model":"Galaxy Note II","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-N7105","model":"Galaxy Note II LTE","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G710(?:2T|5[HL]|[25689KLS])?(?:[);/ ]|$)","model":"Galaxy Grand 2","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G720(?:AX|N0|[02])(?:[);/ ]|$)","model":"Galaxy Grand Max"},{"regex":"(?:SAMSUNG-)?SM-(?:G530(?:[689]W|[AF]Z|BT|MU|R[47]|[AFHMPTWY])|G531[FH]|S920L)(?:[);/ ]|$)","model":"Galaxy Grand Prime","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G531(?:BT|[MY])(?:[);/ ]|$)","model":"Galaxy Grand Prime VE Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G532F(?:[);/ ]|$)","model":"Galaxy Grand Prime Plus","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G532MT(?:[);/ ]|$)","model":"Galaxy J2 Prime (TV)","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G532[MG](?:[);/ ]|$)","model":"Galaxy J2 Prime","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N7502(?:[);/ ]|$)","model":"Galaxy Note 3 Neo Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N750[05LQ]?","model":"Galaxy Note 3 Neo","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N9002(?:[);/ ]|$)","model":"Galaxy Note 3 Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-9005(?:[);/ ]|$)","model":"Galaxy Note 3 LTE","device":"phablet"},{"regex":"(?:SAMSUNG-)?(?:SM-N900(?:W8|[05689][VQ]?|[AKLPSTV])?|SCL22|SC-01F(?:[);/ ]|$))","model":"Galaxy Note 3","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-(?:N910|910U)|N9100(?:[);/ ]|$)","model":"Galaxy Note 4","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N916[KLS]","model":"Galaxy Note 4 LTE","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N915","model":"Galaxy Note 4 Edge","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N920(?:R[467]|W8|[0ACFGIKLPSTVX])","model":"Galaxy Note 5","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-N9208","model":"Galaxy Note 5 Duos","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-G750(?:8Q|[9AFH])","model":"Galaxy Mega 2","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I915[028]","model":"Galaxy Mega 5.8","device":"phablet"},{"regex":"(?:SAMSUNG-)?GT-I920[05]","model":"Galaxy Mega 6.3","device":"phablet"},{"regex":"(?:SAMSUNG-)?(?:SM-N930(?:R[467]|W8|[0AFKLPSTUVX])|SCV34)","model":"Galaxy Note 7","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?SM-N950|SCV37|SC-01K","model":"Galaxy Note 8","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N960|SCV40|SC-01L)","model":"Galaxy Note 9","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?SM-(?:N970(?:U1|W8|[089DFJKLSUWX])|N971N)","model":"Galaxy Note 10","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?SM-N770[FX]","model":"Galaxy Note 10 Lite","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N975(?:U1|XU|[0CFUWX])|SM-N976[0BVNQU]|SC-01M|SCV45)","model":"Galaxy Note 10+","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N980(?:F/DS|F))","model":"Galaxy Note 20","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N981(?:B/DS|U1|[0BNUW]))","model":"Galaxy Note 20 5G","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N985(?:F/DS|F))","model":"Galaxy Note 20 Ultra","device":"phablet"},{"regex":"(?:SAMSUNG[- ])?(?:SM-N986(?:B/DS|U1|[0BNUW])|SC-53A|SCG06)","model":"Galaxy Note 20 Ultra 5G","device":"phablet"},{"regex":"(?:SAMSUNG-)?SM-W750V","model":"Ativ SE"},{"regex":"(?:SAMSUNG-)?SM-G310R5","model":"GreatCall Touch 3"},{"regex":"(?:SAMSUNG-)?GT-E2152","model":"E2152","device":"feature phone"},{"regex":"(?:SAMSUNG-)?(GT-(P|N8|N5)[0-9]+[a-z]?)","device":"tablet","model":"$1"},{"regex":"SC-02C","model":"Galaxy S II"},{"regex":"(?:SAMSUNG-)?((?:SM-[TNP]|GT-P)[a-z0-9_\\\\-]+)","device":"tablet","model":"$1"},{"regex":"((?:SCH|SGH|SPH|SHV|SHW|GT|SM)-[a-z0-9_\\\\-]+)","model":"$1"},{"regex":"SMART-TV","device":"tv","model":"Smart TV"},{"regex":"Galaxy ([^/;]+) Build","model":"Galaxy $1"},{"regex":"Galaxy ([a-z0-9]+)","model":"Galaxy $1"},{"regex":"SAMSUNG[\\\\-][ ]?([a-z0-9]+[\\\\-_][a-z0-9]+)","model":"$1"},{"regex":"SAMSUNG;[ ]?([a-z0-9]+[\\\\-_][a-z0-9]+)","model":"$1"},{"regex":"SAMSUNG[ _/\\\\-]?([a-z0-9\\\\-]+)","model":"$1"},{"regex":"SAMSUNG;[ ]?([a-z0-9 ]+)","model":"$1"},{"regex":"SEC-([a-z0-9]+)","model":"$1"},{"regex":"SAM-([a-z0-9]+)","model":"SCH-$1"},{"regex":"(?:portalmmm|o2imode)/2\\\\.0 ([SZ][a-z0-9]+)","model":"$1"},{"regex":"sam([rua][0-9]+)","model":"SCH-$1"}]}'), poe = { regex: "(?:8312D|G(60[25]|70[3568]G?|785|803)|N83(?:-2cpu)?|N91) Build", device: "smartphone", models: [{ regex: "N83", model: "N83" }, { regex: "N91", model: "N91" }, { regex: "8312D", model: "G101" }, { regex: "G(60[25]|70[3568]G?|785|803)", model: "G$1" }] }, hoe = { regex: "SELFIX", device: "smartphone", models: [{ regex: "SELFIX_SLASH6", model: "Slash 6" }, { regex: "VOYAGER-V45", model: "Voyager V45" }] }, xoe = { regex: "Sencor|ELEMENT[ _]?(?:7|8|9\\.7|10[ _]1)(?:[ _]?V[23])?(?:[);/ ]|$)|ELEMENT[ _]?(?:P[0-9]+|10.1 Q001)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(?:SENCOR[ _])?Element (10\\.1) (Q001)", model: 'Element $1" $2' }, { regex: "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V3", model: "Element 7 V3" }, { regex: "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V2[ _]BASIC", model: "Element 7 V2 Basic" }, { regex: "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V2", model: "Element 7 V2" }, { regex: "(?:SENCOR[ _])?ELEMENT[ _]8[ _]?V3", model: "Element 8 V3" }, { regex: "(?:SENCOR[ _])?ELEMENT[ _]8[ _]?V2", model: "Element 8 V2" }, { regex: "(?:SENCOR[ _])?ELEMENT8", model: "Element 8" }, { regex: "(?:SENCOR[ _])?ELEMENT[ _]9\\.7[ _]?V3", model: "Element 9.7 V3" }, { regex: "(?:SENCOR[ _])?ELEMENT[ _]9\\.7[ _]?V2", model: "Element 9.7 V2" }, { regex: "(?:SENCOR[ _])?ELEMENT[ _]9\\.7", model: "Element 9.7" }, { regex: "(?:SENCOR[ _])?ELEMENT10[ _]1", model: "Element 10.1" }, { regex: "(?:SENCOR[ _])?(7Q105)(?:[);/ ]|$)", model: "$1" }, { regex: "(?:SENCOR[ _])?ELEMENT[ _]?P([0-9]+)", model: "Element P$1", device: "smartphone" }, { regex: "Sencor[ _]([^;/]+) Build", model: "$1" }] }, voe = { regex: "Senwa|(?:S\\-?(?:471|7[12]5|6[01]5|915|905TL|1000|5018)|V705B|LS50F| LS50?|LS5518H|LS5718)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "S-?471(?:[);/ ]|$)", model: "Jazz" }, { regex: "S-?605(?:[);/ ]|$)", model: "City" }, { regex: "S-?905TL(?:[);/ ]|$)", model: "Odin" }, { regex: "S-?1000(?:[);/ ]|$)", model: "Odin" }, { regex: "S-?5018(?:[);/ ]|$)", model: "Inizio" }, { regex: "S-?(615|7[12]5|915)(?:[);/ ]|$)", model: "S$1" }, { regex: "V705B(?:[);/ ]|$)", model: "V705B" }, { regex: "LS50F(?:[);/ ]|$)", model: "Evolution" }, { regex: " LS50(?:[);/ ]|$)", model: "Pegasus" }, { regex: " LS5(?:[);/ ]|$)", model: "Thor" }, { regex: "LS5518H(?:[);/ ]|$)", model: "Sparkly" }, { regex: "LS5718(?:[);/ ]|$)", model: "Diamond" }, { regex: "Senwa[ _-]*([^;/]+)(?: Build|[;)])", model: "$1" }] }, Soe = { regex: "(?:SKY|Elite|Fuego)[_ ][3-7]\\.[05](?:[A-Z]{1,2})?|Elite[ _](?:5_0T|M45|[45]T|45T|GO|M5Plus|T55|T[46]|[AB]5|5_5_Octa)|Platinum[_ ](?:5.0M|5\\.5C|5\\.0+|M5|[ABCM]4|[ACG]55|[ABDEFG]5|A57|P9|X|UNO|VIEW2|O|4\\.0|4_0Plus)|PLATINUMVIEW|SKY[ _](?:55M|Pro_III)", device: "smartphone", models: [{ regex: "Platinum[_ ](?:5\\.0M|M5)", model: "Platinum 5.0M" }, { regex: "Platinum[_ ]5\\.5C", model: "Platinum 5.5C" }, { regex: "Platinum[_ ]5\\.0\\+", model: "Platinum 5.0 Plus" }, { regex: "Platinum_4_0Plus", model: "Platinum 4.0 Plus" }, { regex: "Platinum[ _]4\\.0", model: "Platinum 4.0" }, { regex: "Platinum[_ ](P9) Pro(?:[);/ ]|$)", model: "Platinum $1 Pro" }, { regex: "Platinum[_ ]([ABCM]4|[ACG]55|[ABDEFG]5|A57|P9|X|UNO|O)(?:[);/ ]|$)", model: "Platinum $1" }, { regex: "Platinum[_ ]?VIEW(2)?(?:[);/ ]|$)", device: "tablet", model: "Platinum View$1" }, { regex: "Elite_5_5_Octa", model: "Elite 5.5 Octa" }, { regex: "Elite M5Plus", model: "Elite M5 Plus" }, { regex: "Elite[ _](M45|Go|[45]T|T[46]|T55|[AB]5|A55|45T)(?:[);/ ]|$)", model: "Elite $1" }, { regex: "Elite[_ ]([3-7])[\\._]([05](?:[A-Z]{1,2})?\\+?)", model: "Elite $1.$2" }, { regex: "Fuego[_ ]([3-7]\\.[05](?:[A-Z]{1,2})?\\+?)", model: "Fuego $1" }, { regex: "SKY_Pro_III", model: "Pro III" }, { regex: "SKY 55M", model: "55M" }, { regex: "SKY[_ ]([3-7]\\.[05](?:[A-Z]{1,2})?)", model: "$1" }] }, boe = { regex: "Sky_?worth", device: "tv", models: [{ regex: "Sky_?worth ([^;/]+) Build", model: "$1" }] }, yoe = { regex: "Smartfren|Androtab|Andromax|PD6D1J|AD682J|AD68[89]G|AD6B1H|AD9A1H|AD682H|AD683G", device: "smartphone", models: [{ regex: "S7 Build", model: "Andromax Tab 7.0", device: "tablet" }, { regex: "PD6D1J", model: "Andromax V3s" }, { regex: "AD682J", model: "Andromax T" }, { regex: "AD688G", model: "Andromax C2" }, { regex: "AD689G", model: "Andromax i3" }, { regex: "AD682H", model: "Andromax i3s" }, { regex: "AD6B1H", model: "Andromax G2 Hot" }, { regex: "AD9A1H", model: "Andromax G2" }, { regex: "AD683G", model: "Andromax I" }, { regex: "New Andromax-i", model: "New Andromax I" }, { regex: "Andromax[ _\\-]([^/;]+) Build", model: "Andromax $1" }, { regex: "Andromax[ _\\-]([a-z0-9]+)", model: "Andromax $1" }, { regex: "Smartfren[ _\\-]([^/;\\)]+)(?: Build|[/;\\)])", model: "$1" }, { regex: "(Androtab[^/;]+) Build", model: "$1", device: "tablet" }] }, woe = { regex: "(SM(?:70[15]|[89]01|919)|OD10[35]|YQ60[1357]|DE106|DT1901A|O[CE]106|OS103|O[CS]105)[ /;\\)]", device: "smartphone", models: [{ regex: "SM70[15]", model: "T1" }, { regex: "SM801", model: "T2" }, { regex: "SM901", model: "M1" }, { regex: "SM919", model: "M1L" }, { regex: "YQ60[1357]", model: "U1" }, { regex: "OD10[35]", model: "Pro" }, { regex: "OS105[ /;\\)]", model: "Pro 2" }, { regex: "DE106[ /;\\)]", model: "R1" }, { regex: "OE106[ /;\\)]", model: "Nut Pro 2s" }, { regex: "OC10[56][ /;\\)]", model: "Nut 3" }, { regex: "DT1901A[ /;\\)]", model: "Nut Pro 3" }, { regex: "OS103[ /;\\)]", model: "JianGuo Pro 2" }] }, _oe = { regex: "STK[_ ]", device: "smartphone", models: [{ regex: "STK[_ ]([^/;]+) Build", model: "$1" }, { regex: "STK[_ ]([a-z0-9]+)", model: "$1" }] }, Toe = { regex: "STX[ -]([^;/]+)|STONE EVO", device: "smartphone", models: [{ regex: "STX[ -]([^;/]+) Build", model: "$1" }, { regex: "STX[ -]([a-z0-9_-]+)", model: "$1" }] }, Aoe = { regex: "(SC-[0-9]+[a-z]+)", device: "tablet", model: "$1" }, Poe = { regex: "SUPRA|NVTAB 7.0 3G", device: "smartphone", models: [{ regex: "SUPRA[ _]([^;/)]+)(?: Build|[;)])", device: "tablet", model: "$1" }, { regex: "(NVTAB 7.0 3G)", device: "tablet", model: "$1" }] }, Moe = { regex: "(Cyclone [^/;]+) Build", device: "tablet", model: "$1" }, $oe = { regex: "SUNVAN[ _\\-]", device: "smartphone", models: [{ regex: "SUNVAN[ _\\-]?([^/;]+) Build", model: "$1" }, { regex: "SUNVAN[ _\\-]?([^);/ ]+)", model: "$1" }] }, Coe = { regex: "(?:SCHR9GR|PRA(?:U8|100)|ZUR(?:722M|70016W?|700[RW]|805A))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "SCHR9GR", model: "SCHON R9" }, { regex: "PRA(U8|100)", model: "PRA$1" }, { regex: "ZUR722M", device: "phablet", model: "Z72 go" }, { regex: "ZUR(70016W?|700[RW]|805A)(?:[);/ ]|$)", device: "tablet", model: "ZUR$1" }] }, Loe = { regex: "(?:Primo(7|8)|QM73[45]-8G|QM734-2|QM736-8G\\(HD\\)|(?<!\\.)8950|MID1002|5014G|TEO7RK|Friendly_TH101|Delight TH201)(?:[);/ ]|$)|(?:Tlink|Every)[0-9]+|THOMSON,", device: "tablet", models: [{ regex: "Primo(7|8)", model: "Primo $1" }, { regex: "QM734-2", model: "QM734-2" }, { regex: "QM734-8G", model: "QM734-8G" }, { regex: "QM735-8G", model: "QM735-8G" }, { regex: "QM736-8G\\(HD\\)", model: "QM736-8G (HD)" }, { regex: "(?<!\\.)8950(?:[);/ ]|$)", model: "3G 8950" }, { regex: "TEO7RK(?:[);/ ]|$)", model: "TEO7RK" }, { regex: "5014G(?:[);/ ]|$)", device: "smartphone", model: "5014G" }, { regex: "Tlink([0-9]+)", device: "smartphone", model: "Tlink$1" }, { regex: "Every([0-9]+)", device: "smartphone", model: "Every$1" }, { regex: "Delight TH201", device: "smartphone", model: "Delight TH201" }, { regex: "Friendly_TH101", device: "smartphone", model: "Friendly TH101" }, { regex: "((?:49|55)UC6306|55UC63|32HD55|40FD54|55UD63)", device: "tv", model: "$1" }] }, Eoe = { regex: "TX5 MAX(?:[);/ ]|$)", device: "tv", model: "TX5 Max" }, Ooe = { regex: "Pantech|P[GN]-|PT-[a-z0-9]{3,}|(?<!Winmax )TX[T]?[0-9]+|IM-[a-z0-9]+(?:[);/ ]|$)|ADR910L", device: "smartphone", models: [{ regex: "ADR910L", model: "Star Q" }, { regex: "IM-A870K", model: "Vega Iron" }, { regex: "Pantech[ \\-]?([a-z0-9]+)", model: "$1" }, { regex: "Pantech_([a-z0-9\\-]+)", model: "$1" }, { regex: "(P[GTN]-[a-z0-9]+)", model: "$1" }, { regex: "(TX[T]?[0-9]+)", model: "$1" }, { regex: "(IM-[a-z0-9]+)(?:[);/ ]|$)", model: "$1" }] }, Noe = { regex: "MOMO([0-9]|[ ]?mini[ ]?(?:S|3GS)?)", device: "tablet", models: [{ regex: "MOMOminiS", model: "MOMO mini S" }, { regex: "momo mini 3GS", model: "MOMO Mini 3GS" }, { regex: "MOMO([0-9][^);/]*) Build", model: "MOMO $1" }, { regex: "MOMO([0-9][^);/]*)(?:[);/]|$)", model: "MOMO $1" }] }, Doe = { regex: "PLUM[ _]", device: "smartphone", models: [{ regex: "Z405", model: "Gator 3" }, { regex: "Z407", model: "Axe 4" }, { regex: "Z516", model: "Compass" }, { regex: "Z811", device: "tablet", model: "Optimax 11" }, { regex: "Z709", device: "tablet", model: "Optimax 7" }, { regex: "Z712", device: "tablet", model: "Optimax 12" }] }, koe = { regex: "Polaroid|(?:PMID|MIDC)[0-9a-z]+(?:[);/ ]|$)|MID(?:1014|0714)|PRO[VG]?(?:[0-9]{3,}[a-z]*|[0-9]{2}[a-z])|(?:P(?:400[56]|4526|500[56]|502[56]|504[67]|552[56])A|P902/A900|PSPC(?:505|550|[MZL]20A0|K2[01]NA)|SIGMA 5|MIDS145PXE|MIDS747PX|MID4004JBL|MIDS185PR|PSPTD21NA)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "P4005A", model: "Turbo C4" }, { regex: "P5005A", model: "Turbo C5" }, { regex: "P4006A", model: "Turbo D4" }, { regex: "PSPTD21NA", model: "Turbo D2 Plus" }, { regex: "P4526A", model: "Turbo E" }, { regex: "PSPC(505|550)", model: "Cosmo $1" }, { regex: "P5006A", model: "Cosmo K" }, { regex: "P5526A", model: "Cosmo K Plus" }, { regex: "PSPCK20NA", model: "Cosmo K2" }, { regex: "PSPCK21NA", model: "Cosmo K2 Plus" }, { regex: "P5026A", model: "Cosmo L" }, { regex: "PSPCL20A0", model: "Cosmo L2" }, { regex: "PSPCM20A0", model: "Cosmo M2" }, { regex: "P5046A", model: "Cosmo P5s" }, { regex: "P5525A", model: "Cosmo Q5s" }, { regex: "P5047A", model: "Cosmo Z" }, { regex: "PSPCZ20A0", model: "Cosmo Z2" }, { regex: "P5025A", model: "L5s" }, { regex: "PRO4611(?:PR201)?", model: "Pro4611" }, { regex: "PROV400", model: "Agate" }, { regex: "PROV350", model: "ProV350" }, { regex: "SIGMA 5(?:[);/ ]|$)", model: "Sigma 5" }, { regex: "PRO([VG]?(?:[0-9]{3,}[a-z]*|[0-9]{2}[a-z]))", model: "Pro$1" }, { regex: "PSPT350", model: "Turbo 350 Gris" }, { regex: "MIDS185PR", model: 'Pure 10.1"' }, { regex: "(MID(?:1014|0714|S145PXE|S747PX|4004JBL))", model: "$1", device: "tablet" }, { regex: "((?:PMID|MIDC)[0-9a-z]+)(?:[);/ ]|$)", model: "$1", device: "tablet" }, { regex: "(P902/A900)(?:[);/ ]|$)", model: "$1", device: "tablet" }, { regex: "Polaroid", model: "", device: "tablet" }] }, Goe = { regex: "POLY ?PAD", device: "tablet", models: [{ regex: "POLY ?PAD[_ \\.]([a-z0-9]+)(?:[);/ ]|$)", model: "$1" }, { regex: "POLY ?PAD[_\\.]([a-z0-9]+)", model: "$1" }] }, Boe = { regex: "POLYTRON|W8480|W7430|PW1100S|W7550|W7531|W8570|R2401", device: "smartphone", models: [{ regex: "R2508", model: "Rocket" }, { regex: "POLYTRON[ _]R1500", model: "Rocket Q-Five" }, { regex: "R2401", model: "Rocket 2X" }, { regex: "POLYTRON[ _-]R2402", model: "Rocket R2402" }, { regex: "POLYTRON[ _-]R2403", model: "Rocket R1" }, { regex: "POLYTRON[ _-]R2406", model: "Rocket R2" }, { regex: "POLYTRON[ _-]R2407", model: "Rocket R3" }, { regex: "POLYTRON[ _-]R2452", model: "Rocket S1" }, { regex: "POLYTRON[ _-]R2457", model: "Rocket S2" }, { regex: "POLYTRON[ _-]R2501", model: "Rocket T1" }, { regex: "POLYTRON[ _-]R2507", model: "Rocket T3" }, { regex: "POLYTRON[ _-]R2509SE", model: "Rocket T6 SE" }, { regex: "POLYTRON[ _-]R2509", model: "Rocket T6" }, { regex: "POLYTRON[ _-]R250A", model: "Rocket T7" }, { regex: "POLYTRON[ _-]R2506", model: "Rocket T4" }, { regex: "POLYTRON[ _-](?:R3450|W1400)", model: "Rocket Jetz" }, { regex: "POLYTRON[ _-]R3500", model: "Rocket Jetz 5.0" }, { regex: "4G450", model: "Zap 5" }, { regex: "W6500", model: "Quadra Rocket" }, { regex: "W7452", model: "Quadra S2" }, { regex: "W7550", model: "Quadra V5" }, { regex: "W8570", model: "Quadra V7" }, { regex: "POLYTRON[ _]L501", model: "Rocket L501" }, { regex: "POLYTRON[ _]P520", model: "Prime 7S" }, { regex: "POLYTRON[ _]P552", model: "Prime 7 Pro" }, { regex: "4G500", model: "Zap 6 Cleo" }, { regex: "W8480", model: "Crystal 4 W8480" }, { regex: "W7531", model: "Wizard V" }, { regex: "W7430", model: "Quadra Mini W7430" }, { regex: "POLYTRON[ _]4G501", model: "Zap 6 Posh" }, { regex: "POLYTRON[ _]4G502", model: "Zap 6 Power" }, { regex: "POLYTRON[ _]4G503", model: "Zap 6 Flaz" }, { regex: "POLYTRON[_ ]?[ _]4G550", model: "Zap 6 Note" }, { regex: "POLYTRON[ _]4G551", model: "Zap 6 Posh Note" }, { regex: "PW1100S", model: "PW1100S" }, { regex: "Q2352", model: "Q2352" }, { regex: "POLYTRON[ _]T7800", model: "Cosmica T7800", device: "tablet" }, { regex: "POLYTRON[ _]T7700", model: "Rocket Pad", device: "tablet" }] }, Ioe = { regex: "YPY_S450", device: "smartphone", models: [{ regex: "YPY_S450", model: "YPY S450" }] }, Roe = { regex: "Prestigio 5500 DUO|(?:PMP|PAP|PMT|PSP|PGPS)[0-9]+[a-z0-9_]+(?:[);/ ]|$)|Muze C3", device: "tablet", models: [{ regex: "PMT3277_3G", model: "MultiPad Ranger 7.0 3G" }, { regex: "PGPS7799CIS08GBPG(?:[);/ ]|$)", model: "Geo Vision Tour 3" }, { regex: "PGPS7797(?:[);/ ]|$)", model: "Geo Vision Tour 2" }, { regex: "PMT3201_4G", model: "Grace 4G" }, { regex: "PSP5551DUO", model: "Grace S5" }, { regex: "PMT3287_3G", model: "MultiPad Ranger 8.0 3G" }, { regex: "Prestigio 5500 DUO", model: "MultiPhone 5500 Duo", device: "smartphone" }, { regex: "PMT3208[_ ]3G", model: "MultiPad Wize 8.0 3G" }, { regex: "PSP7546DUO([ _][A-Z]{2})?", model: "X Pro" }, { regex: "PSP7610DUO([ _][A-Z]{2})?", model: "S Max" }, { regex: "(PM[PT][0-9]+[a-z0-9_]+)(?:[);/ ]|$)", model: "$1" }, { regex: "((?:PAP|PSP)[0-9]+[a-z0-9_]+(?: DUO)?)(?:[);/ ]|$)", model: "$1", device: "smartphone" }, { regex: "Muze C3(?:[);/ ]|$)", model: "Muze C3", device: "smartphone" }] }, Foe = { regex: "Sanyo|MobilePhone[ ;]", device: "feature phone", models: [{ regex: "SCP-?6750", model: "Katana Eclipse X" }, { regex: "SCP-?6760", model: "Incognito" }, { regex: "SCP-?6780", model: "Innuendo" }, { regex: "SANYO[ /_-]([a-z0-9\\-]+)", model: "$1" }, { regex: "MobilePhone ([a-z0-9\\-]+)", model: "$1" }] }, Voe = { regex: "Qilive [0-9][^;/]*|Q(7S5[5]?IN4G|7T10INP|8T10IN|8S55IN4G2|8S[56]IN4G|9T9IN|9T(?:7|10)IN4G|9S55IN4G|10S5[37]IN4G|10S[56]IN4G|10S[56]IN4GR|9S5IN4G|6T7IN)", device: "smartphone", models: [{ regex: "Q7S5IN4G", model: 'Q7 5.0" 4G' }, { regex: "Q7S55IN4G", model: 'Q7 5.5" 4G' }, { regex: "Q8S55IN4G2", model: 'Q8 5.5" 4G' }, { regex: "Q8S6IN4G", model: 'Q8 6.0" 4G' }, { regex: "Q8S5IN4GP", model: 'Q8 5.1" 4G' }, { regex: "Q9S5IN4G", model: 'Q9 5.0" 4G' }, { regex: "Q9S55IN4G", model: 'Q9 5.5" 4G' }, { regex: "Q10S53IN4G", model: 'Q10 5.3" 4G' }, { regex: "Q10S57IN4G", model: 'Q10 5.7" 4G' }, { regex: "Q10S5IN4G[R]?", model: 'Q10 5.0" 4G' }, { regex: "Q10S6IN4G", model: 'Q10 6.0" 4G' }, { regex: "Q6T7IN", model: "Q6", device: "tablet" }, { regex: "Q7T10INP", model: 'Q7 10.1"', device: "tablet" }, { regex: "Q8T10IN", model: 'Q8 10.1"', device: "tablet" }, { regex: "Q9T7IN4G", model: 'Q9 7.0" 4G', device: "tablet" }, { regex: "Q9T9IN", model: 'Q9 9.0"', device: "tablet" }, { regex: "Q9T10IN4G", model: 'Q9 10.1" 4G', device: "tablet" }, { regex: "Qilive ([0-5][^;/]*) Build", model: "$1" }, { regex: "Qilive ([0-5][^;/]*)/", model: "$1" }, { regex: "Qilive ([6-9][^;/]*) Build", model: "$1", device: "tablet" }, { regex: "Qilive ([6-9][^;/]*)/", model: "$1", device: "tablet" }] }, Hoe = { regex: "QMobile|QTab(?!10EW)|Q-Smart|(?:E2 Noir|Noir X1S|LUNA PRO|NICE S|JazzX JS(?:[27]|10)(?: PRO)?|LT[57]00 PRO|LT950|Q Infinity|Hot Pro 2)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "JazzX JS7 PRO", model: "Jazz X JS7 Pro" }, { regex: "JazzX JS(2|10)", model: "Jazz X JS$1" }, { regex: "Noir X1S", model: "Noir X1S" }, { regex: "E2 Noir", model: "E2 Noir" }, { regex: "Hot Pro 2", model: "Hot Pro 2" }, { regex: "LT([57]00) PRO", model: "Noir LT$1 Pro" }, { regex: "LUNA PRO", model: "Luna Pro" }, { regex: "NICE S", model: "Nice S" }, { regex: "Q Infinity PRO", model: "Q Infinity Pro" }, { regex: "Q Infinity E Lite", model: "Q Infinity E Lite" }, { regex: "Q Infinity ([FCB])", model: "Q Infinity $1" }, { regex: "(LT950)(?:[);/ ]|$)", model: "$1" }, { regex: "QTab[ _-]([^;/]+) Build", model: "$1 Tab", device: "tablet" }, { regex: "QTab[ _-]([^;/)]+)(?:[;/)]|$)", model: "$1 Tab", device: "tablet" }, { regex: "(?:QMobile|Q-Smart)[ _-]([^;/]+) Build", model: "$1" }, { regex: "(?:QMobile|Q-Smart)[ _-]([^;/)]+)(?:[;/)]|$)", model: "$1" }, { regex: "Q Infinity", model: "Q Infinity" }] }, Uoe = { regex: "Maximus[ _]|(Noir X)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:Maximus[ _])?(Noir X|D1)(?:[);/ ]|$)", model: "$1" }, { regex: "Maximus_(T2)", device: "tablet", model: "$1" }] }, Xoe = { regex: "Quantum (?:Fit|MUV (?:PRO|UP)|Go|Mini|V|You [2E])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Quantum (Fit|Go|Mini|V|You [2E])(?:[);/ ]|$)", model: "$1" }, { regex: "Quantum MUV PRO(?:[);/ ]|$)", model: "MUV Pro" }, { regex: "Quantum MUV UP(?:[);/ ]|$)", model: "MUV Up" }] }, Woe = { regex: "Quechua Phone 5", device: "smartphone", model: "Quechua Phone 5" }, Yoe = { regex: "Ramos ?([^/;]+) Build|MOS1(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(MOS1)(?:[);/ ]|$)", model: "$1" }, { regex: "Ramos ?([^/;]+) Build", model: "$1" }] }, Koe = { regex: "Phone 2", device: "smartphone", model: "Phone 2" }, Qoe = { regex: "Sendo([a-z0-9]+)", device: "feature phone", model: "$1" }, joe = { regex: "Turbo[_ ]?(?:X5[_ ]?(?:Max|Black|Space|Hero)|X8|X6[ _]Z|X[ _]Ray)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "TurboX5Space(?:[);/ ]|$)", model: "X5 Space" }, { regex: "TurboX5Hero(?:[);/ ]|$)", model: "X5 Hero" }, { regex: "TurboX[ _]Ray(?:[);/ ]|$)", model: "X Ray" }, { regex: "Turbo[ _]?X5[ _]?Black(?:[);/ ]|$)", model: "X5 Black" }, { regex: "Turbo[ _]X5[ _]Max(?:[);/ ]|$)", model: "X5 Max" }, { regex: "Turbo[ _]X6[ _]Z(?:[);/ ]|$)", model: "X6 Z" }, { regex: "Turbo[ _]X8(?:[);/ ]|$)", model: "X8" }] }, Zoe = { regex: "Sigma(?!Designs)|(X[_-]Style[ _]?Tab[_ ]A([0-9]{2,3})|X[-_ ]?treme[-_ ]?PQ[0-9]{2}|X-Style_S5501)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:Sigma[ _])?X[-_ ]?treme[-_ ]?PQ([0-9]{2})(?:[);/ ]|$)", model: "X-Treme PQ$1" }, { regex: "X[_-]Style[ _]?Tab[_ ]A([0-9]{2,3})(?:[);/ ]|$)", model: "X-Style Tab A$1", device: "tablet" }, { regex: "(?:Sigma[ _])?X[-_ ]?Style[-_ ]S([0-9]+)(?:[);/ ]|$)", model: "X-Style S$1" }] }, zoe = { regex: "(?<![\\d];)Spice", device: "smartphone", models: [{ regex: "Spice[ _\\-]?([^/;]+)(?:[\\)]| Build)", model: "$1" }, { regex: "Spice[ _\\-]?([^/;]+)(?:/|$)", model: "$1" }] }, qoe = { regex: "SHARP|SBM|SH-?[0-9]+[a-z]?(?:[);/ ]|$)|AQUOS|(?:SH-M0[14-9]|SH-M1[1-6](?:-y)?|S[357]-SH|SH-[MZ](10|01)|SH-[CL]02|SH-RM(?:1[125]|02)|[34]04SH|401SH|[45]02SH|306SH|[36]05SH|70[1246]SH|80[138]SH|90[1678]SH|50[3679]SH|SHL2[25]|SHV4[0-8]|SHV3[1-9](?:[-_]u)?|FS80(?:1[08]|32|28|0[29])|TG-L900S|NP601SH|403SH|603SH|SHF3[134]|SHV4[035][-_]u|SW001SH|SHG0[123]|X4-SH|A002SH|SH-A01|DM-01J|SH-D01|A001SH|606SH|FS801[56]|d-41A|NP80[567]SH|NP501SH)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "506SH(?:[);/ ]|$)", model: "Aquos Xx3" }, { regex: "603SH(?:[);/ ]|$)", model: "Aquos Xx3 Mini" }, { regex: "50[23]SH(?:[);/ ]|$)", model: "Aquos Xx2" }, { regex: "[34]04SH(?:[);/ ]|$)", model: "Aquos Xx" }, { regex: "606SH(?:[);/ ]|$)", model: "Aquos ea" }, { regex: "507SH(?:[);/ ]|$)", model: "Android One" }, { regex: "S3-SH(?:[);/ ]|$)", model: "Android One S3" }, { regex: "S5-SH(?:[);/ ]|$)", model: "Android One S5" }, { regex: "S7-SH(?:[);/ ]|$)", model: "Android One S7" }, { regex: "X4-SH(?:[);/ ]|$)", model: "Android One X4" }, { regex: "SH-M04(?:[);/ ]|$)", model: "Aquos SH-M04" }, { regex: "SH-M05(?:[);/ ]|$)", model: "Aquos Sense Lite" }, { regex: "SH-M07(?:[);/ ]|$)", model: "Aquos Sense Plus" }, { regex: "SHG03(?:[);/ ]|$)", model: "Aquos Sense 5G" }, { regex: "SH-D01(?:[);/ ]|$)", model: "Aquos D10" }, { regex: "SH-M12(?:-y)?(?:[);/ ]|$)", model: "Aquos S3 Dual SIM" }, { regex: "(?:SH-[MZ]10|801SH)(?:[);/ ]|$)", model: "Aquos Zero" }, { regex: "(?:SH-M13|906SH)(?:[);/ ]|$)", model: "Aquos Zero 2" }, { regex: "(?:SHG02|A002SH)(?:[);/ ]|$)", model: "Aquos Zero 5G Basic" }, { regex: "SH-Z01(?:[);/ ]|$)", model: "Aquos S2 (C10)" }, { regex: "(?:SH-02E|SH-01[GH]|SH-04H)(?:[);/ ]|$)", model: "Aquos Phone Zeta" }, { regex: "SH-?06D(?:[);/ ]|$)", model: "Aquos Phone SH-06D" }, { regex: "(SHL2[25]|SH-M01)(?:[);/ ]|$)", model: "Aquos Phone $1" }, { regex: "SH-L02(?:[);/ ]|$)", model: "Aquos L2" }, { regex: "(?:605SH|SH-03J|SHV39)(?:[);/ ]|$)", model: "Aquos R" }, { regex: "(?:605SH|SH-03J|SHV39)(?:[);/ ]|$)", model: "Aquos R" }, { regex: "(?:701SH|SHV41|SH-M06)(?:[);/ ]|$)", model: "Aquos R Compact" }, { regex: "(?:SH-M09|SHV42|706SH|SH-03K)(?:[);/ ]|$)", model: "Aquos R2" }, { regex: "803SH(?:[);/ ]|$)", model: "Aquos R2 Compact" }, { regex: "(?:908SH|SHG01|SH-M14)(?:[);/ ]|$)", model: "Aquos R5G" }, { regex: "SH-M16(?:[);/ ]|$)", model: "Aquos S4 Plus" }, { regex: "SH-M15(?:[);/ ]|$)", model: "Aquos S4 SIM" }, { regex: "SH-C02(?:[);/ ]|$)", model: "Aquos V" }, { regex: "(SHF3[134])(?:[);/ ]|$)", model: "Aquos K $1" }, { regex: "704SH(?:[);/ ]|$)", model: "Simple Smartphone 4" }, { regex: "(?:SH-02J|SH-04G)(?:[);/ ]|$)", model: "Aquos Ever" }, { regex: "SH-02H(?:[);/ ]|$)", model: "Aquos Compact" }, { regex: "30[56]SH(?:[);/ ]|$)", model: "Aquos Crystal" }, { regex: "402SH(?:[);/ ]|$)", model: "Aquos Crystal X" }, { regex: "403SH(?:[);/ ]|$)", model: "Aquos Crystal 2" }, { regex: "509SH(?:[);/ ]|$)", model: "Aquos 3" }, { regex: "NP601SH(?:[);/ ]|$)", model: "Aquos 2" }, { regex: "(?:SHV40|SHV3[24])(?:_u)?(?:[);/ ]|$)", model: "Aquos S" }, { regex: "702SH(?:[);/ ]|$)", model: "Aquos S Basic" }, { regex: "SHV3[183](?:[);/ ]|$)", model: "Aquos S Mini" }, { regex: "(?:FS8010|SH-M08|SHV43(?:-u)?|SH-01[KL])(?:[);/ ]|$)", model: "Aquos S2" }, { regex: "FS8016(?:[);/ ]|$)", model: "Aquos S2 Plus" }, { regex: "(?:SHV46|SH-R?M11|901SH)(?:[);/ ]|$)", model: "Aquos S3 Plus" }, { regex: "(?:SHV44|808SH|SH-04L|SH-03G)(?:[);/ ]|$)", model: "Aquos R3" }, { regex: "(?:FS8032|FS8015|SH-02M|SHV45(?:-U)?)(?:[);/ ]|$)", model: "Aquos S3" }, { regex: "FS8018(?:[);/ ]|$)", model: "Aquos S3 Mini" }, { regex: "(?:SHV48|907SH)(?:[);/ ]|$)", model: "Aquos S3 Basic" }, { regex: "SH-RM12(?:[);/ ]|$)", model: "Aquos S3 Lite" }, { regex: "SH-RM15(?:[);/ ]|$)", model: "Aquos S4 Lite" }, { regex: "SH-51A(?:[);/ ]|$)", model: "Aquos R5G" }, { regex: "SHV3[57](?:_u)?(?:[);/ ]|$)", model: "Aquos U" }, { regex: "TG-L900S(?:[);/ ]|$)", model: "Luna S" }, { regex: "SH-A01(?:[);/ ]|$)", model: "B10" }, { regex: "(?:FS8002|SHV47)(?:[);/ ]|$)", model: "Z2" }, { regex: "FS8009(?:[);/ ]|$)", model: "Z3" }, { regex: "FS8028(?:[);/ ]|$)", model: "R1S" }, { regex: "SHV36(?:[);/ ]|$)", model: "Basio 2" }, { regex: "SW001SH(?:[);/ ]|$)", model: "Star Wars" }, { regex: "SH-RM02", model: "Aquos SH-RM02" }, { regex: "401SH", model: "Aquos 401SH" }, { regex: "DM-01J", model: "Disney Mobile DM-01J" }, { regex: "A001SH", model: "Simple Sumaho 5" }, { regex: "NP80[56]SH", model: "Aquos Keitai 3" }, { regex: "NP807SH", model: "Aquos Keitai 10" }, { regex: "NP501SH", model: "Aquos Keitai" }, { regex: "SH-08E(?:[);/ ]|$)", device: "tablet", model: "Sharp Aquos Pad" }, { regex: "d-41A(?:[);/ ]|$)", device: "tablet", model: "dtab d-41A" }, { regex: "(LC-(?:[0-9]{2})[a-z0-9]+)(?:[);/ ]|$)", device: "tv", model: "$1" }, { regex: "SHARP-AQUOS|AQUOSBrowser", device: "tv", model: "Aquos Net Plus" }, { regex: "SHARP[ \\-]([a-z0-9\\-]+)", model: "$1" }, { regex: "(?:SHARP|SBM)([a-z0-9]+)", model: "$1" }, { regex: "(SH-?[0-9]+[a-z]?)(?:[);/ ]|$)", model: "$1" }] }, Joe = { regex: "(NP602SI)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, ene = { regex: "Softbank|J-PHONE", device: "smartphone", models: [{ regex: "Softbank/[12]\\.0/([a-z0-9]+)", model: "$1" }, { regex: "([a-z0-9]+);Softbank;", model: "$1" }, { regex: "J-PHONE/[0-9]\\.[0-9]/([a-z0-9\\-]+)", model: "$1" }] }, tne = { regex: "Sonim[ -]|XP(?:[67]7|88)00(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Sonim-XP3400", model: "XP3400", device: "feature phone" }, { regex: "XP6700(?:[);/ ]|$)", model: "XP6700" }, { regex: "XP7700(?:[);/ ]|$)", model: "XP7700" }, { regex: "XP8800(?:[);/ ]|$)", model: "XP8" }] }, rne = { regex: "N(9[5678]00|8800|9000|9977)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "N9000", model: "Note 3" }, { regex: "N(9[5678]00|8800|9977)(?:[);/ ]|$)", model: "N$1" }] }, one = { regex: "(?:Starmobile (?:Play (?:Neo|Spark|GO|Click))|UP[_ ](?:Sense|Rave|Groove|Prime|Selfie|Xtreme|XL))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Starmobile PLAY GO(?:[);/ ]|$)", model: "Play Go" }, { regex: "Starmobile Play (Neo|Spark|Click)(?:[);/ ]|$)", model: "Play $1" }, { regex: "UP[_ ](Sense|Rave|Groove|Prime|Selfie|Xtreme|XL)(?:[);/ ]|$)", model: "UP $1" }] }, nne = { regex: "KF(?:OT|ONWI|TT|JWI|JWA|[DFS]OWI|A[PRSU]WI|T[BH]WI|SAW[IA]|GIWI|KAWI|MAWI|MEWI|MUWI|SUWI)(?:[);/ ]|$)|Kindle|Silk/\\d+\\.\\d+|AlexaMediaPlayer|Amazon (?:Tate|Jem)|AFT[ABMNRST]|SD4930UR|AEO(BC|KN)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "AFTA", model: "Fire TV Cube (Gen 1)", device: "tv" }, { regex: "AFTR", model: "Fire TV Cube (Gen 2)", device: "tv" }, { regex: "AFTN", model: "Fire TV (Gen 3)", device: "tv" }, { regex: "AFTB", model: "Fire TV", device: "tv" }, { regex: "AFT[MST]", model: "Fire TV stick", device: "tv" }, { regex: "KFFOWI(?:[);/ ]|$)", model: 'Fire 7"' }, { regex: "KFMUWI(?:[);/ ]|$)", model: 'Fire 7" (2019)' }, { regex: "KFTT(?:[);/ ]|$)", model: "Kindle Fire HD" }, { regex: "KFJWI(?:[);/ ]|$)|Amazon Jem", model: 'Kindle Fire HD 8.9" WiFi' }, { regex: "KFJWA(?:[);/ ]|$)", model: 'Kindle Fire HD 8.9" 4G' }, { regex: "KFSOWI(?:[);/ ]|$)|Amazon Tate", model: 'Kindle Fire HD 7" WiFi' }, { regex: "KFTHWI(?:[);/ ]|$)", model: 'Kindle Fire HDX 7" WiFi' }, { regex: "KFTHWA(?:[);/ ]|$)", model: 'Kindle Fire HDX 7" 4G' }, { regex: "KFAPWI(?:[);/ ]|$)", model: 'Kindle Fire HDX 8.9" WiFi' }, { regex: "KFAPWA(?:[);/ ]|$)", model: 'Kindle Fire HDX 8.9" 4G' }, { regex: "KFARWI(?:[);/ ]|$)", model: "Fire HD 6" }, { regex: "KFASWI(?:[);/ ]|$)", model: "Fire HD 7" }, { regex: "KFAUWI(?:[);/ ]|$)", model: "Fire HD 7 (2017)" }, { regex: "KFMEWI(?:[);/ ]|$)", model: "Fire HD 8 (2015)" }, { regex: "KFGIWI(?:[);/ ]|$)", model: "Fire HD 8 (2016)" }, { regex: "KFDOWI(?:[);/ ]|$)", model: "Fire HD 8 (2017)" }, { regex: "KFKAWI(?:[);/ ]|$)", model: "Fire HD 8 (2018)" }, { regex: "KFONWI(?:[);/ ]|$)", model: "Fire HD 8 (2020)" }, { regex: "KFSAWI(?:[);/ ]|$)", model: "Fire HDX 8.9" }, { regex: "KFSAWA(?:[);/ ]|$)", model: "Fire HDX 8.9 4G" }, { regex: "KFTBWI(?:[);/ ]|$)", model: "Fire HD 10" }, { regex: "KFSUWI(?:[);/ ]|$)", model: "Fire HD 10 (2017)" }, { regex: "KFMAWI(?:[);/ ]|$)", model: "Fire HD 10 (2019)" }, { regex: "SD4930UR", model: "Fire Phone", device: "smartphone" }, { regex: "KFOT|Kindle Fire|Silk/\\d+\\.\\d+", model: "Kindle Fire" }, { regex: "Kindle", model: "Kindle" }, { regex: "AEO(BC|KN)(?:[);/ ]|$)", model: "Echo", device: "smart speaker" }, { regex: "AlexaMediaPlayer", model: "Alexa", device: "smart speaker" }] }, ane = { regex: "SYMPHONY[ \\_]([a-z0-9]+)|(?:roar[ _](?:V20|V78|E80|V150))|roarV95|ZVIII(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ZVIII", model: "ZVIII" }, { regex: "roar[ _]?(V20|E80|V78|V95|V150)(?:[);/ ]|$)", model: "Roar $1" }, { regex: "SYMPHONY[ \\_]([a-z0-9]+)", model: "$1" }] }, lne = { regex: "Helio (S60|S5)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, ine = { regex: "(SYX-(?:T70[04]|T10[12]))(?:[);/ ]|$)", device: "tablet", model: "$1" }, sne = { regex: "Qtek[ _]?([a-z0-9]+)", device: "smartphone", model: "$1" }, dne = { regex: "Teclast|TLA002|TLA016|X98 Air III|M20_4G|X98 Air II\\(HG5N\\)|Tbook|X80 Power\\(B2N4\\)|(?:T30|P80X|P20HD|P10_HD|M40)_(?:ROW|EEA)|T10\\(E3C6\\)|P10S\\(N4H5\\)|98\\(M1E[45789]\\)|98\\(M3E3\\)", device: "tablet", models: [{ regex: "Tbook[_ -]([^;/]+) Build", model: "Tbook $1" }, { regex: "T10\\(E3C6\\)", model: "T10" }, { regex: "T30_(ROW|EEA)", model: "T30 $1" }, { regex: "P80X_(ROW|EEA)", model: "P80X $1" }, { regex: "P10S\\(N4H5\\)", model: "P10S" }, { regex: "P20HD_(?:ROW|EEA)", model: "P20HD" }, { regex: "M40_(?:ROW|EEA)", model: "M40" }, { regex: "P10_HD_(?:ROW|EEA)", model: "P10HD" }, { regex: "M20_4G", model: "M20 4G" }, { regex: "TLA002", model: "M30 4G" }, { regex: "TLA016", model: "M16" }, { regex: "98\\(M1E[45789]\\)|98\\(M3E3\\)", model: 'TPad 98 10.1" 4G' }, { regex: "X80 Power\\(B2N4\\)(?:[);/ ]|$)", model: "X98 Power" }, { regex: "X98 Air III(?:[);/ ]|$)", model: "X98 Air III" }, { regex: "X98 Air II\\(HG5N\\)(?:[);/ ]|$)", model: "X98 Air II" }, { regex: "Teclast[_ -]([^;/]+) Build", model: "$1" }] }, une = { regex: "Tech ?pad|XTAB[ _-]|Dual C1081HD|S813G", device: "tablet", models: [{ regex: "S813G", model: "S813G" }, { regex: "TechPad10QC", model: "10QC" }, { regex: "TechPad_10xx", model: "10XX" }, { regex: "TechPad703", model: "703" }, { regex: "TechPad[_ ](10Y|9x|i700)", model: "$1" }, { regex: "TechPad[_ ]3Gx", model: "3Gx" }, { regex: "Dual C1081HD", model: "XTAB C1081HD" }, { regex: "XTAB[ _-]([^/;]+) Build", model: "XTAB $1" }, { regex: "Tech ?pad[ _-]([^/;)]+)(?: Build|[;)])", model: "$1", device: "smartphone" }] }, cne = { regex: "Hudl (?:[^/;]+)(?: Build|[;)])|W032i-C3(?:[);/ ]|$)", device: "tablet", models: [{ regex: "Hudl ([^/;]+)(?: Build|[;)])", model: "Hudl $1" }, { regex: "W032i-C3(?:[);/ ]|$)", model: "Op3n Dott" }] }, mne = { regex: "Texet|(NaviPad [^/;]*) Build|TM-(?:1046|1058|1057|1067|3000|3200R|3500|4003|4071|450[34]|451[30]|4377|4082R|508[34]|550[358]|5010|5017|507[4-7]|5[23]77|6003|6906|702[13]|7055HD|709[69]|9747BT|9758|9751HD|9767|5513|520[410]|507[13]|558[134]|570[23]|7859|8044|9748[ _]3G|9720|7047HD[ _]3G|9757|9740|4982|4515|4083|500[3567]|5571|3204R|5016|8043|7047HD[ _]3G|8041HD|8066|705[23]|7041|8041HD|8051|8048|974[96]|973[78]W|974[170]|9743W|9750HD|7043XD|7049|7887|7037W|702[46])|TB-(771A|711A)|X-Force[\\(-]?TM-5009\\)?|X-Plus[\\(-]?TM-5577\\)?|TM_5011|X-pad (?:AIR 8|iX 7|NAVI 7.[35]|NAVI 10|SKY 8.1|STYLE 8|STYLE 10.1|HIT|LITE 7.[12]|QUAD (?:7.2|10|7)|SHINE 8.1)(?: 3G)?", device: "tablet", models: [{ regex: "TM-9749", model: "X-pad Plus 7.1 3G" }, { regex: "TM-9746", model: "X-pad Plus 7 3G" }, { regex: "TM-8051", model: "X-pad Force 8i 3G" }, { regex: "TM-1058", model: "X-Force 10 3G" }, { regex: "TM-8048", model: "X-pad Force 8 3G" }, { regex: "(NaviPad [^/;]*) Build", model: "$1" }, { regex: "TM-7055HD", model: "NaviPad 3G" }, { regex: "TM-9758", model: 'X-pad Style 10.0"' }, { regex: "X-pad SHINE 8.1 3G", model: 'X-pad Shine 8.1" 3G' }, { regex: "X-pad QUAD 10 3G", model: 'X-pad Quad 10.0" 3G' }, { regex: "X-pad QUAD 7 3G", model: 'X-pad Quad 7.0" 3G' }, { regex: "X-pad QUAD 7.2 3G", model: 'X-pad Quad 7.2" 3G' }, { regex: "X-pad STYLE 8 3G", model: 'X-pad Style 8.0" 3G' }, { regex: "X-pad HIT 3G", model: "X-pad Hit 3G" }, { regex: "X-pad LITE (7.[12])", model: 'X-pad Lite $1"' }, { regex: "TM-9767", model: 'X-pad Style 10.0" 3G' }, { regex: "X-pad STYLE 10.1 3G", model: 'X-pad Style 10.1" 3G' }, { regex: "(X-pad (?:AIR 8|iX 7) 3G)", model: "$1" }, { regex: "TM-7096|X-pad NAVI 7.3 3G", model: 'X-pad NAVI 7.3" 3G' }, { regex: "TM-7099", model: 'X-pad NAVI 7.4" 3G' }, { regex: "X-pad NAVI 7.5 3G", model: 'X-pad NAVI 7.5" 3G' }, { regex: "X-pad SKY 8.1 3G", model: 'X-pad Sky 8.1" 3G' }, { regex: "TM-1046|X-pad NAVI 10 3G", model: 'X-pad NAVI 10.0" 3G' }, { regex: "TM-7859", model: 'X-pad NAVI 8.2" 3G' }, { regex: "TM-7049", model: "NaviPad TM-7049 3G" }, { regex: "TM-7887", model: "NaviPad TM-7887 3G" }, { regex: "TM-8066", model: 'X-pad Rapid 8.2" 4G' }, { regex: "(TM-(?:1057|1067|6906|8043|9748[_ ]3G|9740|9757(?:[_ ]3G)?|7047HD[ _]3G|9747BT|9751HD|702[13]|705[23]|7041|9720|7047HD[_ ]3G|8044|8041HD|973[78]W|9743W|974[710]|9750HD|7043XD|7037W|702[46])|TB-(?:771A|711A|8041HD))", model: "$1" }, { regex: "TM-4503", device: "smartphone", model: "X-Quad" }, { regex: "(TM-(?:3000|3200R|4003|4083|4377|4504|451[30]|500[35]|5[23]77|5571|3204R|520[04]|5581|5505|5017|507[13-7]|5081|6003|5513))", device: "smartphone", model: "$1" }, { regex: "TM-5006", device: "smartphone", model: "X-Line" }, { regex: "TM-5007", device: "smartphone", model: "X-Shine" }, { regex: "TM_5011", device: "smartphone", model: "X-Omega" }, { regex: "TM-508(3|4)", device: "smartphone", model: "Pay $1G" }, { regex: "TM-558(3|4)", device: "smartphone", model: 'Pay 5.5" $1G' }, { regex: "TM-5702", device: "smartphone", model: 'Pay 5.7" 3G' }, { regex: "TM-5703", device: "smartphone", model: 'Pay 5.7" Pro' }, { regex: "TM-5201", device: "smartphone", model: "Rock" }, { regex: "TM-4515", device: "smartphone", model: "X-Style" }, { regex: "TM-(5016|3500)", device: "smartphone", model: "X-Maxi 2" }, { regex: "TM-4071", device: "smartphone", model: "X-Smart" }, { regex: "TM-4982", device: "smartphone", model: "iX-Maxi" }, { regex: "TEXET[_ ]IX-MINI", device: "smartphone", model: "iX-Mini" }, { regex: "TM-5010", device: "smartphone", model: "X-Selfie" }, { regex: "TM-4082R", device: "smartphone", model: "X-Driver Quad" }, { regex: "TM-5503", device: "smartphone", model: "X-Mage" }, { regex: "TM-5508", device: "smartphone", model: "X-Cosmo" }, { regex: "X-Force[\\(-]?TM-5009\\)?", device: "smartphone", model: "X-Force" }, { regex: "X-Plus[\\(-]?TM-5577\\)?", device: "smartphone", model: "X-Plus" }, { regex: "teXet[_ ]X-medium[_ ]plus", device: "smartphone", model: "X-Medium Plus" }] }, gne = { regex: "TELEFUNKEN|Foxtrot|TEL-1013GIQA|TF-SP(?:500[12]|4002)|(TF-MID(?:[78]02G|70[78]G|80[46]G|9705RG|9707G|7805G|100[57]G|1010G))|(TF-LED(?:65S75T2SU|32S39T2S|32S5[289]T2S|32S70T2S|40S63T2S))", device: "tablet", models: [{ regex: "TEL-1013GIQA", model: "Giqa 10.1 3G" }, { regex: "Foxtrot2", model: "Foxtrot 2", device: "smartphone" }, { regex: "(?:TELEFUNKEN)?(TF-SP(?:500[12]|4002)|Outdoor LTE|Foxtrot)", model: "$1", device: "smartphone" }, { regex: "(TF-MID(?:[78]02G|70[78]G|80[46]G|9705RG|9707G|7805G|100[57]G|1010G))", model: "$1" }, { regex: "(TF-LED(?:65S75T2SU|32S39T2S|32S5[289]T2S|32S70T2S|40S63T2S))", model: "$1", device: "tv" }] }, fne = { regex: "TELEGO", device: "smartphone", models: [{ regex: "TELEGO-W503", model: "W503" }, { regex: "Telego_JOY2", model: "Joy 2" }, { regex: "Telego[ _]Mate", model: "Mate" }] }, pne = { regex: "(?<!FBCR/)Telenor|Infinity E5", device: "smartphone", models: [{ regex: "Telenor[ _]([^;/]+)(?: Build|[;)])", model: "$1" }, { regex: "Infinity E5", model: "Infinity E5" }] }, hne = { regex: "Telit", device: "feature phone", models: [{ regex: "Telit_Mobile_Terminals-([a-z0-9]+)", model: "$1" }, { regex: "Telit[\\-_]?([a-z0-9]+)", model: "$1" }] }, xne = { regex: "ThL[ _-]|Knight 2", device: "smartphone", models: [{ regex: "Knight 2", model: "Knight 2" }, { regex: "ThL[ _-]*([^;/]+) Build", model: "$1" }, { regex: "ThL[ _-]*([^ ;/)]+)(?:[);/ ]|$)", model: "$1" }] }, vne = { regex: "TIANYU", device: "feature phone", models: [{ regex: "TIANYU ([a-z0-9]+)", model: "$1" }, { regex: "TIANYU-KTOUCH/([a-z0-9]+)", model: "$1" }] }, Sne = { regex: "Tmovi[ _]|(?:Infinit_Lite_2|Vision_PRO|VISION ULTRA|Epix)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Tmovi[ _]Prime", model: "Prime" }, { regex: "TMOVI_YEAH_BEAT", model: "Yeah Beat" }, { regex: "YeahLIVE", model: "Yeah LIVE" }, { regex: "Infinit Lite", model: "Infinit Lite" }, { regex: "Infinit_Lite_2", model: "Infinit Lite 2" }, { regex: "Vision_PRO", model: "Vision Pro" }, { regex: "VISION ULTRA", model: "Vision Ultra" }, { regex: "Epix", model: "Epix" }] }, bne = { regex: "TOOKY", device: "smartphone", models: [{ regex: "TOOKY (A19|W1|T8[368]|T1982)(?:[);/ ]|$)", model: "$1" }, { regex: "TOOKY A9PLUS(?:[);/ ]|$)", model: "A9 Plus" }] }, yne = { regex: "Tolino Tab ([^/;]+) Build", device: "tablet", model: "Tolino Tab $1" }, wne = { regex: "Toplux ([a-z0-9]+)", device: "feature phone", model: "$1" }, _ne = { regex: "TOUCHMATE|(TM-(?:MID1050WKD|MID1020A|MID794C|MID795|MID710|MID798|MID792|MID788D|SM500N|SM410|MID1010))", device: "smartphone", models: [{ regex: "(TM-(?:MID1020A|MID794C|MID795|MID710|MID798|MID792|MID788D|MID1010))", device: "tablet", model: "$1" }, { regex: "TM-MID1050WKD", device: "tablet", model: 'Mega Matrix 10.1" 3G' }, { regex: "(TM-(?:SM500N|SM410))", model: "$1" }, { regex: "Touchmate ([^/;]+) Build", model: "$1" }] }, Tne = { regex: "(?:TrekStor|Surftab) ([^/;]+)(?: Build|\\))|Surftab[^;\\)]*(?:[;\\)]|$)|ST10216-2A|ST13416-1|VT10416-[12]|TFMTKAW01232", device: "tablet", models: [{ regex: "ST10216-2A|VT10416-[12]", model: "SurfTab 10.1" }, { regex: "ST13416-1", model: 'SurfTab Theatre 13.4"' }, { regex: "PrimeTab P10", model: "PrimeTab P10" }, { regex: "TrekStor ([^/;]+) Build", model: "$1" }, { regex: "Surftab ([^/;]+) Build", model: "SurfTab $1" }, { regex: "Surftab[ _]([^;\\)]*)(?:[;\\)]|$)", model: "SurfTab $1" }, { regex: "TFMTKAW01232", model: "SurfTab L15" }] }, Ane = { regex: "Trevi[ _]|TAB[ _]10[ _]3G[ _]V16|TAB[ _](7|8)[ _]3G[ _]V8|TAB9 3G|MINITAB 3GV|Phablet[ _](?:4|4\\.5|5|5\\,3|6)[ _]?[CSQ]|REVERSE[ _]5\\.5[ _]?Q", device: "tablet", models: [{ regex: "TAB[ _]?(7|8)[ _]3G[ _]V8", model: "TAB $1 3G V8" }, { regex: "TAB[ _]?9[ _]3G[ _]V8", model: "TAB 9 3G V8" }, { regex: "TAB[ _]?9[ _]3G", model: "TAB 9 3G" }, { regex: "TAB[ _]10[ _]3G[ _]V16", model: "TAB 10 3G V16" }, { regex: "MINITAB 3GV", model: "MINITAB 3G V" }, { regex: "(?:Trevi_)?Phablet[ _]4[ _]?C", model: "Phablet 4 C", device: "smartphone" }, { regex: "(?:Trevi_)?Phablet[ _]4[ _]?S", model: "Phablet 4 S", device: "smartphone" }, { regex: "(?:Trevi_)?Phablet[ _]4.5[ _]?Q", model: "Phablet 4.5Q", device: "smartphone" }, { regex: "(?:Trevi_)?PHABLET[ _]5[ _]?S", model: "Phablet 5 S", device: "smartphone" }, { regex: "(?:Trevi_)?PHABLET[ _]5,3[ _]?Q", model: "Phablet 5.3 Q", device: "phablet" }, { regex: "(?:Trevi_)?REVERSE[ _]5.5[ _]?Q", model: "Phablet 5.5 Q REVERSE", device: "phablet" }, { regex: "(?:Trevi_)?PHABLET[ _]6[ _]?S", model: "Phablet 6 S", device: "phablet" }, { regex: "Trevi[_]([^;/]+) Build", model: "$1" }] }, Pne = { regex: "(NuclearSX-SP5)", device: "smartphone", model: "Nuclear SX-SP5" }, Mne = { regex: "Uhappy|UP?580|UP350|UP[35679]20", device: "smartphone", models: [{ regex: "UP([35679]20)", model: "UP$1" }, { regex: "UP350", model: "UP350" }, { regex: "UP580", model: "UP580" }, { regex: "U580", model: "U580" }, { regex: "Uhappy[ _-]([^;/]+) Build", model: "$1" }, { regex: "Uhappy[ _-]?([^;/)]+)(?:[);/ ]|$)", model: "$1" }] }, $ne = { regex: "U((?:67[013]|680)C|(?:452|504)TL|683CL|693CL)(?:[);/ ]|$)", device: "smartphone", model: "U$1" }, Cne = { regex: "QOOQ ", device: "tablet", model: "QOOQ" }, Lne = { regex: "utstar[ _-]?([a-z0-9]+)", device: "feature phone", model: "$1" }, Ene = { regex: "Ulefone|Gemini Pro|Power_[356]|S10_Pro|(?:Note [89]P|Armor(?:[ _](?:[2367]|2S|X[236]|6[SE]|3WT|3W|X))?|U00[78][ _]Pro|Be[ _]X|Be[ _]Touch(?:[ _][23])?|Be[ _](?:One|Pure)(?:[ _]Lite)?)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "S10_Pro", model: "S10 Pro" }, { regex: "Be[ _]Touch([ _][23])?", model: "Be Touch$1" }, { regex: "Be[ _]Pure[ _]Lite", model: "Be Pure Lite" }, { regex: "Be[ _]Pure", model: "Be Pure" }, { regex: "Be[ _]One[ _]Lite", model: "Be One Lite" }, { regex: "Be[ _]One", model: "Be One" }, { regex: "Be[ _]X", model: "Be X" }, { regex: "U007 Pro", model: "U007 Pro" }, { regex: "U008 Pro", model: "U008 Pro" }, { regex: "Armor[ _]X([236])(?:[);/ ]|$)", model: "Armor X$1" }, { regex: "Armor[ _]6S(?:[);/ ]|$)", model: "Armor 6S" }, { regex: "Armor[ _]([679])E(?:[);/ ]|$)", model: "Armor $1E" }, { regex: "Armor[ _]X([57]) Pro(?:[);/ ]|$)", model: "Armor X$1 Pro" }, { regex: "Armor[ _]X([578])(?:[);/ ]|$)", model: "Armor X$1" }, { regex: "Armor[ _]([25])S(?:[);/ ]|$)", model: "Armor $1S" }, { regex: "Armor[ _]X(?:[);/ ]|$)", model: "Armor X" }, { regex: "Armor[ _]3W(?:[);/ ]|$)", model: "Armor 3W" }, { regex: "Armor[ _]3WT(?:[);/ ]|$)", model: "Armor 3WT" }, { regex: "Armor[ _]([236789])(?:[);/ ]|$)", model: "Armor $1" }, { regex: "Armor(?:[);/ ]|$)", model: "Armor" }, { regex: "Gemini Pro(?:[);/ ]|$)", model: "Gemini Pro" }, { regex: "Power[_ ]([356])", model: "Power $1" }, { regex: "Note 8P(?:[);/ ]|$)", model: "Note 8P" }, { regex: "Note 9P(?:[);/ ]|$)", device: "phablet", model: "Note 9P" }, { regex: "Ulefone[_ ](X|S1[ _]Pro|S[17])(?:[);/ ]|$)", model: "$1" }, { regex: "Ulefone[ _-]?([^;/]+) Build", model: "$1" }, { regex: "Ulefone[ _-]?([^;/)]+)(?:[;/)]|$)", model: "$1" }] }, One = { regex: "UMI(?:DIGI)?[ _]|(?:A5_Pro|ROME[_ ]X|BISON|hammer_S)(?:[;/) ]|$)", device: "smartphone", models: [{ regex: "A5_Pro", model: "A5 Pro" }, { regex: "UMI TOUCH X", model: "Touch X" }, { regex: "UMI TOUCH", model: "Touch" }, { regex: "ROME[_ ]X", model: "Rome X" }, { regex: "BISON", model: "Bison" }, { regex: "hammer_S", model: "Hammer S" }, { regex: "UMI_(London|Diamond(?:_X)?)", model: "$1" }, { regex: "UMI(?:DIGI)?[ _]([^/;)]+)(?: Build|[;)])", model: "$1" }] }, Nne = { regex: "Uniscope", device: "smartphone", models: [{ regex: "Uniscope[ _\\-]?([^/;]+) Build", model: "$1" }, { regex: "Uniscope[ _\\-]?([^);/ ]+)", model: "$1" }] }, Dne = { regex: "Unnecto|(?:U513|U5151|U61[1356]|U7[12]0|U-830|U90[35])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "U513", model: "Drone XT" }, { regex: "U5151", model: "Bolt" }, { regex: "U611", model: "Quattro X" }, { regex: "U613", model: "Quattro S" }, { regex: "U615", model: "Quattro M" }, { regex: "U616", model: "U616" }, { regex: "U710", model: "Quattro U710" }, { regex: "U720", model: "Quattro Z" }, { regex: "U-830", model: "Rush" }, { regex: "U903", model: "Air" }, { regex: "U905", model: "Air 5.5" }] }, kne = { regex: "Unonu[ _-]", device: "smartphone", models: [{ regex: "Unonu[ _-]([^;/]+) Build", model: "$1" }, { regex: "Unonu[ _-]?([^;/)]+)(?:[);/ ]|$)", model: "$1" }] }, Gne = { regex: "UTOK (45[01]D)", device: "smartphone", model: "$1" }, Bne = { regex: "(M910A|M783K|M783K-16G|M1072R-3G)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Ine = { regex: "ViewSonic|VSD[0-9]+(?:[);/ ]|$)|ViewPad|ViewPhone", device: "smart display", models: [{ regex: "(?:ViewSonic-)?V500(?:[);/ ]|$)", model: "V500", device: "smartphone" }, { regex: "ViewSonic A8\\+(?:[);/ ]|$)", model: "A8 Plus", device: "smartphone" }, { regex: "(?:ViewSonic-)?ViewPhone ?([^;/]+) Build", model: "ViewPhone $1", device: "smartphone" }, { regex: "(?:ViewSonic-)?ViewPad ?([^;/]+) Build", model: "ViewPad $1", device: "tablet" }, { regex: "(VSD[0-9]+)(?:[);/ ]|$)", model: "$1" }] }, Rne = { regex: "Vitelcom|portalmmm/[12].0 TSM", device: "feature phone", models: [{ regex: "TSM-([a-z0-9]+)", model: "$1" }, { regex: "TSM([a-z0-9\\-]+)", model: "$1" }, { regex: "portalmmm/[12].0 (TSM[a-z0-9 ]+)", model: "$1" }] }, Fne = { regex: "(vKB011B|vKB004L)", device: "tablet", model: "$1" }, Vne = { regex: "Vernee|Mars Pro|Apollo[ _](?:Lite|X)|Thor (?:E|Plus)|X2_euro", device: "smartphone", models: [{ regex: "Apollo[ _]Lite", model: "Apollo Lite" }, { regex: "Apollo[ _]X", model: "Apollo X" }, { regex: "Mars Pro", model: "Mars Pro" }, { regex: "Thor E", model: "Thor E" }, { regex: "Thor Plus", model: "Thor Plus" }, { regex: "Vernee_M5", model: "M5" }, { regex: "X2_euro", model: "X2" }, { regex: "Vernee[ _-]([^;/]+) Build", model: "$1" }, { regex: "Vernee[ _-]([a-z0-9_-]+)", model: "$1" }] }, Hne = { regex: "Vertu[ ]?([a-z0-9]+)|(?:ASTER P|CONSTELLATION X)(?:[);/ ]|$)", device: "feature phone", models: [{ regex: "ASTER P(?:[);/ ]|$)", device: "smartphone", model: "Aster P" }, { regex: "CONSTELLATION X(?:[);/ ]|$)", device: "smartphone", model: "Constellation X" }, { regex: "Vertu[ ]?([a-z0-9]+)", model: "$1" }] }, Une = { regex: "(?:CX-508|CX-551|Reiv 500|Creon F5|Isprit U50|Isprit-U50-LTE)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Isprit U50|Isprit-U50-LTE", model: "Isprit U50" }, { regex: "(CX-508|CX-551|Reiv 500|Creon F5)", model: "$1" }] }, Xne = { regex: "QTA(SUN[12]|XIA1|QZ3|QZ3KID|IR7)|QMV7B", device: "tablet", models: [{ regex: "QTAXIA1|QTAIR7", model: "Ellipsis 10" }, { regex: "QTASUN1", model: "Ellipsis 8 HD" }, { regex: "QTASUN2", model: "Ellipsis 8 HD 4G LTE" }, { regex: "QTAQZ3KID", model: "Ellipsis Kids LTE" }, { regex: "QTAQZ3", model: "Ellipsis 8" }, { regex: "QMV7B", model: "Ellipsis 7" }] }, Wne = { regex: "verykool", device: "smartphone", models: [{ regex: "verykoolS5004", model: "Lotus JR." }, { regex: "verykoolS5005", model: "Lotus II" }, { regex: "verykool[ _]?([^/;]+) Build", model: "$1" }, { regex: "verykool[ _]?([^/;]+);", model: "$1" }] }, Yne = { regex: "Vestel[ _]|Venus[ _](GO|E[2-5]|V[1-9]|Z[1-9]0)|(?<!Winnovo )V_?TAB|VP74|VT97PRO|VSP145M|VSP250[GS]|VSP355[GS]|V3_5580_Dual", device: "smartphone", models: [{ regex: "VT97PRO", model: "VTab 9.7 Pro", device: "tablet" }, { regex: "VP74", model: "VTab Lite II", device: "tablet" }, { regex: "VTAB10", model: "VTab 10", device: "tablet" }, { regex: "V_TAB_7_ECO_III ", model: "VTab 7 Eco 3", device: "tablet" }, { regex: "V_TAB_([0-9]{4}[A-Z]?)", model: "VTab $1", device: "tablet" }, { regex: "V3_5580_Dual", model: "Venus V3 5580 Dual" }, { regex: "VSP145M", model: "Venus 4.5" }, { regex: "VSP250G", model: "Venus 5.0V" }, { regex: "VSP250S", model: "Venus 5.0X" }, { regex: "VSP355G", model: "Venus 5.5V" }, { regex: "VSP355S", model: "Venus 5.5X" }, { regex: "Venus[ _]V([1-9])", model: "Venus V$1" }, { regex: "Venus[ _]Z([1-9]0)", model: "Venus Z$1" }, { regex: "Venus[ _]GO", model: "Venus Go" }, { regex: "Venus E2 Plus Dual", model: "Venus E2 Plus Dual" }, { regex: "Venus[ _]E2 Plus", model: "Venus E2 Plus" }, { regex: "Venus[ _]E([345])", model: "Venus E$1" }, { regex: "Vestel_5000_Dual", model: "5000 Dual" }, { regex: "Vestel_5000_2gb", model: "5000 2GB" }, { regex: "Vestel[ _](5000|5530)", model: "$1" }] }, Kne = { regex: "Videocon[_ \\-]|(?:VT75C|V406018|V512930|V50(?:2430|3630|5024|5430|4630|5[98]20)|Z45_(?:Dazzle|Amaze)|Z45Q Star|Z50 Nova)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Videocon_V1585", device: "feature phone", model: "V1585" }, { regex: "Videocon[_ \\-]([a-z0-9]+)", model: "$1" }, { regex: "VT75C(?:[);/ ]|$)", model: "VT75C", device: "tablet" }, { regex: "V502430(?:[);/ ]|$)", model: "Kryton 3" }, { regex: "V505024(?:[);/ ]|$)", model: "Kryton 22 Plus" }, { regex: "V503630(?:[);/ ]|$)", model: "Delite 11" }, { regex: "V505920(?:[);/ ]|$)", model: "Metal Pro 2" }, { regex: "V505820(?:[);/ ]|$)", model: "Metal Pro 1" }, { regex: "V406018(?:[);/ ]|$)", model: "Starr 100" }, { regex: "V512930(?:[);/ ]|$)", model: "Ultra 50" }, { regex: "(V505430|V504630)(?:[);/ ]|$)", model: "$1" }, { regex: "Z45_(Dazzle|Amaze)(?:[);/ ]|$)", model: "Infinium Z45 $1" }, { regex: "Z45Q Star(?:[);/ ]|$)", model: "Infinium Z45Q Star" }, { regex: "Z50 Nova(?:[);/ ]|$)", model: "Infinium Z50 Nova" }] }, Qne = { regex: "(?<!FBCR/)Vodafone[ _-]|Smart ?Tab ?(?:III? ?)?(?:|4G|7|10)[);/ -]|VodafoneSmartChat|VFD[ _][0-9]+(?:[);/ ]|$)|VFD320|VF6[89]5|VF-(696|1397|795|895N|1497)", device: "smartphone", models: [{ regex: "VFD 100", model: "Smart Mini" }, { regex: "VF685", model: "Smart Kicka" }, { regex: "VF695", model: "Smart First 6" }, { regex: "VFD 200", model: "Smart First 7" }, { regex: "VFD 300", model: "Smart Mini 7" }, { regex: "VFD 50[02]", model: "Smart Turbo 7" }, { regex: "VFD 51[013]", model: "Smart E8" }, { regex: "VFD 600", model: "Smart Prime 7" }, { regex: "VFD320", model: "Smart C9" }, { regex: "VFD 820", model: "Smart X9" }, { regex: "VFD 610", model: "Smart N8" }, { regex: "Smart ultra 6", model: "Smart Ultra 6" }, { regex: "VFD 700", model: "Smart Ultra 7" }, { regex: "VFD 720", model: "Smart N9" }, { regex: "VFD 900", model: "Smart Platinum 7" }, { regex: "Vodafone[ _]875(?:[);/ ]|$)", model: "Smart Mini" }, { regex: "Vodafone[ _]975N?(?:[);/ ]|$)", model: "Smart 3" }, { regex: "Vodafone[ _]785(?:[);/ ]|$)", model: "Smart 4 Mini" }, { regex: "Vodafone[ _]890N(?:[);/ ]|$)", model: "Smart 4 Turbo" }, { regex: "Vodafone[ _]985N(?:[);/ ]|$)", model: "Smart 4 Power" }, { regex: "VodafoneSmartChat", model: "Smart Chat" }, { regex: "VF-696", model: "Smart Grand 6" }, { regex: "VF-795", model: "Smart Speed 6" }, { regex: "VF-895N", model: "Smart Prime 6" }, { regex: "VF-1397", model: "Tab Speed 6", device: "tablet" }, { regex: "VF-1497", model: "Tab Prime 6", device: "tablet" }, { regex: "VFD 1100", device: "tablet", model: "Tab Mini 7" }, { regex: "VFD 1300", device: "tablet", model: "Smart Tab N8" }, { regex: "VFD 1400", device: "tablet", model: "Tab Prime 7" }, { regex: "Smart ?Tab ?3G", device: "tablet", model: "Smart Tab 3G" }, { regex: "Smart ?Tab ?4G", device: "tablet", model: "Smart Tab 4G" }, { regex: "Smart ?Tab ?4", model: "Smart Tab 4", device: "tablet" }, { regex: "SmartTab7[);/ -]", model: "Smart Tab 7", device: "tablet" }, { regex: "SmartTab10[);/ -]", model: "Smart Tab 10", device: "tablet" }, { regex: "Smart ?Tab ?II ?7", model: "Smart Tab II 7", device: "tablet" }, { regex: "Smart ?Tab ?II ?10", model: "Smart Tab II 10", device: "tablet" }, { regex: "Smart ?Tab ?III ?7", model: "Smart Tab III 7", device: "tablet" }, { regex: "Smart ?Tab ?III ?10", model: "Smart Tab III 10", device: "tablet" }, { regex: "VFD[ _]([0-9]+)(?:[);/ ]|$)", model: "VFD $1" }, { regex: "Vodafone[ _-]([^;/]+) Build", model: "$1" }, { regex: "Vodafone[ _-]([a-z0-9_-]+)", model: "$1" }] }, jne = { regex: "Vonino|Epic (?:E8|P7)|Gyga[ _](?:X|S|QS|XS)|Jax[ _](?:QS|[SXQN]|Mini)|Magnet[ _]M[19]|Navo_QS|Onyx_(QS|Z)|Orin_QS|Pluri[ _](?:[BCMQ]7|[CQM]8)|Sirius_QS|Volt[ _][XS]|Xavy_(T7|L8)|Xylo[ _][XSPQT]|Zun[ _]X[OS]?|JAX_N", device: "smartphone", models: [{ regex: "Zun[ _]XO", model: "Zun XO" }, { regex: "Zun[ _]XS", model: "Zun XS" }, { regex: "Zun[ _]X", model: "Zun X" }, { regex: "Xylo[ _]([PSXQT])", model: "Xylo $1" }, { regex: "Volt[ _]S_A7", model: "Volt S A7" }, { regex: "Volt[ _]S", model: "Volt S" }, { regex: "Volt[ _]X", model: "Volt X" }, { regex: "Gyga[ _]QS", model: "Gyga QS" }, { regex: "Gyga[ _]XS", model: "Gyga XS" }, { regex: "Gyga[ _](S|X)", model: "Gyga $1" }, { regex: "Jax[ _]QS", model: "Jax QS" }, { regex: "Jax[ _]S_A7", model: "Jax S A7" }, { regex: "Jax[ _]([SQXN])", model: "Jax $1" }, { regex: "Jax[ _]Mini", model: "Jax Mini" }, { regex: "Epic (E8|P7)", model: "Epic $1", device: "tablet" }, { regex: "Pluri[ _](B|C|M|Q)7", model: "Pluri $17", device: "tablet" }, { regex: "Pluri[ _]([CQM])8", model: "Pluri $18", device: "tablet" }, { regex: "Magnet[ _]M([19])", model: "Magnet M$1", device: "tablet" }, { regex: "Navo_QS", model: "Navo QS", device: "tablet" }, { regex: "Onyx_(QS|Z)", model: "Onyx $1", device: "tablet" }, { regex: "Orin_QS", model: "Orin QS", device: "tablet" }, { regex: "Sirius_QS", model: "Sirius QS", device: "tablet" }, { regex: "Xavy_T7", model: "Xavy T7", device: "tablet" }, { regex: "Xavy_L8", model: "Xavy L8", device: "tablet" }] }, Zne = { regex: "VORAGO", device: "smartphone", models: [{ regex: "CELL-500", model: "CELL-500" }] }, zne = { regex: "VOTO[ _\\-]|VT8[89]8(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "VOTO[ _\\-]?([^/;]+) Build", model: "$1" }, { regex: "VOTO[ _\\-]?([^);/ ]+)", model: "$1" }, { regex: "(VT8[89]8)(?:[);/ ]|$)", model: "$1" }] }, qne = { regex: "Voxtel_([a-z0-9]+)", device: "feature phone", model: "$1" }, Jne = { regex: "(?:VP5004A|HT0704W08|VS5513|VS4011|VR6031)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(VP5004A|VR6031)(?:[);/ ]|$)", model: "$1" }, { regex: "VS5513(?:[);/ ]|$)", model: "Tempo S13" }, { regex: "VS4011(?:[);/ ]|$)", model: "Tempo S11" }, { regex: "HT0704W08", model: "Koral 7W4", device: "tablet" }] }, eae = { regex: "Walton|Walpad|Primo[ _](C[1234]?|D[1-689]|E[1-589]|F8s|S7|EF[23]?|EM|F[1-79]i?|G[1-9]|GF[234]?|GH[23]?|GM|H[2-689M]|H7s|N[F1]?|NX2?|R[1-46]|R[HM]2?|RX[23]?|S[1-6]|V1|X[1-4]|Z|ZX)", device: "smartphone", models: [{ regex: "Walpad ([^;/]+) Build", device: "tablet", model: "Primo Walpad $1" }, { regex: "Primo S6 infinity", model: "Primo S6 Infinity" }, { regex: "Primo H8 Pro(?:[);/ ]|$)", model: "Primo H8 Pro" }, { regex: "Primo H8(?:[);/ ]|$)", model: "Primo H8 Turbo" }, { regex: "Primo[ _]([^;/)]+)(?: Build|[;)])", model: "Primo $1" }, { regex: "Walton[ _]([^;/)]+)(?: Build|[;)])", model: "$1" }] }, tae = { regex: "WELLCOM[ _\\-/]([a-z0-9]+)", device: "smartphone", model: "$1" }, rae = { regex: "Wexler|(?:ULTIMA 7 TWIST PLUS|TAB10iQ3G|TAB[ _]10Q)(?:[);/ ]|$)|ZEN[ _](?:4\\.[57]|5)", device: "tablet", models: [{ regex: "(?:Wexler[ _\\-\\.])?ZEN[ _]4\\.5(?:[);/ ]|$)", model: "ZEN 4.5", device: "smartphone" }, { regex: "(?:Wexler[ _\\-\\.])?ZEN[ _]4\\.7(?:[);/ ]|$)", model: "ZEN 4.7", device: "smartphone" }, { regex: "(?:Wexler[ _\\-\\.])?ZEN[ _]5(?:[);/ ]|$)", model: "ZEN 5", device: "smartphone" }, { regex: "(?:Wexler[ _\\-\\.])?TAB[ _]10Q(?:[);/ ]|$)", model: "TAB 10Q" }, { regex: "TAB10iQ3G(?:[);/ ]|$)", model: "TAB 10iQ 3G" }, { regex: "Wexler[ _\\-\\.]([^;/]+) Build", model: "$1" }, { regex: "Wexler[ _\\-\\.]([^);/]+)(?:[);/]|$)", model: "$1" }, { regex: "(ULTIMA 7 TWIST PLUS)(?:[);/ ]|$)", model: "$1" }] }, oae = { regex: "(?:Inco[ _](Aurora II|Sphere|Plain[_ ]2S?|Plain2 S|Flex 2S|S4|Bloom 2)|(Horizon_S|Horizon \\+))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:Inco[ _])?(Plain[_ ]2S?|Horizon_S|Horizon \\+|Aurora II|Flex 2S|S4|Bloom 2)(?:[);/ ]|$)", model: "$1" }, { regex: "Plain2 S", model: "Plain 2S" }, { regex: "Inco Sphere(?:[);/ ]|$)", device: "tablet", model: "Sphere" }] }, nae = { regex: "(?<!mismart )Wink[_ ]", device: "smartphone", models: [{ regex: "Wink[_ ]((?:Glory|World|Share|City)(?:[_ ](?:SE|S))?)(?:[);/ ]|$)", model: "$1" }, { regex: "Wink[ _](Primo|Highway)(?:[);/ ]|$)", device: "tablet", model: "$1" }] }, aae = { regex: "(?:WIKO[_ -])|(?:WIKO-)?CINK_[a-z0-9_]+|(?:WIKO-)?HIGHWAY_[a-z0-9_]+|(?:WIKO-)?(?:Cink([^/;]*)|Highway([^/;]*)|Iggy|Stairway|Rainbow ?(Jam|Lite|Up)?|Darkside|Darkmoon|Darkfull|Darknight|Freddy|FEVER|Jerry[2]?|Sublim|Ozzy|JIMMY|Barry|Birdy|Bloom|Getaway|Goa(?!nna)|Kite|Robby|Lenny[2-9]?|Slide|Sunset[2-9]?|Sunny[2-9]?|Tommy[2-9]?|PULP(?: Fab)?|Wax|HARRY|Ridge(?: Fab)?|U FEEL(?: Prime| Lite)?|U PULSE(?: LITE)?|View2 Go|View XL|View Prime)(?: Plus)?(?: 4G)?(?: Build|$)?|W_(?:C8[06]0|K[346]00|P130|P200|C200SN)|WC300|W-(?:V7[23]0|V8[30]0|P[36]11|K420|K510S?|K130)-(?:TMV|TIM|TVM|EEA|SUN|SWI|OPE|BYT|DU|TH)|WIM Lite|W-K360-TV|W-V600|W-K200|W-U300|U307AS|CINK PEAX 2|HIGHWAY PURE|C210AE|v3913", device: "smartphone", models: [{ regex: "(?:WIKO-)?Cink Peax 2", model: "Cink Peax 2" }, { regex: "(?:Wiko-)?Cink([^/;]*) Build", model: "Cink$1" }, { regex: "(?:WIKO-)?CINK_([a-z0-9_]+)", model: "Cink $1" }, { regex: "(?:WIKO-)?HIGHWAY PURE", model: "Highway Pure" }, { regex: "(?:WIKO-)?HIGHWAY STAR", model: "Highway Star" }, { regex: "(?:Wiko-)?Highway([^/;]*) Build", model: "Highway$1" }, { regex: "(?:WIKO-)?HIGHWAY_([a-z0-9_]+)", model: "Highway $1" }, { regex: "(?:WIKO-)?Iggy", model: "Iggy" }, { regex: "(?:WIKO-)?FEVER", model: "Fever" }, { regex: "(?:WIKO-)?Stairway", model: "Stairway" }, { regex: "(?:WIKO-)?Ridge Fab 4G", model: "Ridge Fab 4G" }, { regex: "(?:WIKO-)?Ridge 4G", model: "Ridge 4G" }, { regex: "(?:WIKO-)?Ridge", model: "Ridge" }, { regex: "(?:WIKO-)?Rainbow ([^/;]+) Build", model: "Rainbow $1" }, { regex: "(?:WIKO-)?Rainbow", model: "Rainbow" }, { regex: "(?:WIKO-)?Darkside", model: "Darkside" }, { regex: "(?:WIKO-)?Darkmoon", model: "Darkmoon" }, { regex: "(?:WIKO-)?Darkfull", model: "Darkfull" }, { regex: "(?:WIKO-)?Darknight", model: "Darknight" }, { regex: "(?:WIKO-)?Sublim", model: "Sublim" }, { regex: "(?:WIKO-)?Ozzy", model: "Ozzy" }, { regex: "(?:WIKO-)?Barry", model: "Barry" }, { regex: "(?:WIKO-)?Birdy", model: "Birdy" }, { regex: "(?:WIKO-)?Bloom", model: "Bloom" }, { regex: "(?:WIKO-)?JIMMY", model: "Jimmy" }, { regex: "JERRY MAX", model: "Jerry Max" }, { regex: "W_K300", model: "Jerry 3" }, { regex: "W-K420-TVM", model: "Jerry 4" }, { regex: "(?:WIKO-)?Jerry2", model: "Jerry 2" }, { regex: "(?:WIKO-)?Jerry", model: "Jerry" }, { regex: "(?:WIKO-)?Getaway", model: "Getaway" }, { regex: "(?:WIKO-)?Goa(?!nna)", model: "Goa" }, { regex: "(?:WIKO-)?Freddy", model: "Freddy" }, { regex: "(?:WIKO-)?Kite", model: "Kite" }, { regex: "W_K400", model: "Lenny 5" }, { regex: "C210AE(?:[);/ ]|$)", model: "Life" }, { regex: "U307AS(?:[);/ ]|$)", model: "Life 2" }, { regex: "v3913(?:[);/ ]|$)", model: "Kenny" }, { regex: "(?:WIKO-)?Lenny[ -_]?3 Max", model: "Lenny 3 Max" }, { regex: "(?:WIKO-)?Lenny[ -_]?4 Plus", model: "Lenny 4 Plus" }, { regex: "(?:WIKO-)?Lenny[ -_]?([2-9])", model: "Lenny $1" }, { regex: "(?:WIKO-)?Lenny", model: "Lenny" }, { regex: "(?:WIKO-)?Slide", model: "Slide" }, { regex: "(?:WIKO-)?Sunset2", model: "Sunset 2" }, { regex: "(?:WIKO-)?Sunset", model: "Sunset" }, { regex: "(?:WIKO-)?Sunny3", model: "Sunny 3" }, { regex: "W-K200", model: "Sunny 3 Plus" }, { regex: "(?:WIKO-)?Sunny2 Plus", model: "Sunny 2 Plus" }, { regex: "(?:WIKO-)?Sunny2", model: "Sunny 2" }, { regex: "W-K360-TV", model: "Sunny 4 Plus" }, { regex: "W-K130-TMV", model: "Sunny 4" }, { regex: "(?:WIKO-)?Sunny", model: "Sunny" }, { regex: "(?:W_K600|Tommy3|W_C200SN)", model: "Tommy 3" }, { regex: "(?:WIKO-)?Tommy2 Plus", model: "Tommy 2 Plus" }, { regex: "(?:WIKO-)?Tommy2", model: "Tommy 2" }, { regex: "(?:WIKO-)?Tommy", model: "Tommy" }, { regex: "(?:WIKO-)?Wax", model: "Wax" }, { regex: "(?:WIKO-)?HARRY", model: "Harry" }, { regex: "W-V600", model: "Harry 2" }, { regex: "(?:WIKO-)?WIM Lite", model: "WIM Lite" }, { regex: "(?:WIKO-)?Pulp Fab 4G", model: "Pulp Fab 4G" }, { regex: "(?:WIKO-)?Pulp Fab", model: "Pulp Fab" }, { regex: "(?:WIKO-)?Pulp 4G", model: "Pulp 4G" }, { regex: "(?:WIKO-)?Pulp", model: "Pulp" }, { regex: "(?:WIKO-)?Robby", model: "Robby" }, { regex: "(?:WIKO-)?U PULSE LITE", model: "U Pulse Lite" }, { regex: "(?:WIKO-)?U PULSE", model: "U Pulse" }, { regex: "(?:WIKO-)?U FEEL LITE", model: "U Feel Lite" }, { regex: "(?:WIKO-)?U FEEL PRIME", model: "U Feel Prime" }, { regex: "(?:WIKO-)?U FEEL", model: "U Feel" }, { regex: "(?:WIKO-)?View2 Go", model: "View 2 Go" }, { regex: "(?:WIKO-)?View XL", model: "View XL" }, { regex: "(?:WIKO-)?View Prime", model: "View Prime" }, { regex: "WC300", model: "View Lite" }, { regex: "W_C800", model: "View 2" }, { regex: "W_C860", model: "View 2 Pro" }, { regex: "W_P200", model: "View Max" }, { regex: "W_P130", model: "View Go" }, { regex: "W-V800-(TVM|TIM|EEA|OPE|DU)", model: "View 3 Lite" }, { regex: "W-K130-(?:OPE|EEA)", model: "Y50" }, { regex: "W-K420-EEA", model: "Y50" }, { regex: "W-K510-(?:TVM|EEA|OPE|SUN|BYT|TH)|W-K510S-SWI", model: "Y60" }, { regex: "W-V720-(?:EEA|OPE|SUN)", model: "Y80" }, { regex: "W-P311-(?:EEA|OPE|TVM)", model: "View 3" }, { regex: "W-P611-(?:EEA|OPE)", model: "View 3 Pro" }, { regex: "W-V830-EEA", model: "View 4" }, { regex: "W-V730-EEA", model: "View 4 Lite" }, { regex: "W-U300(?:[);/ ]|$)", model: "Ride" }, { regex: "Wiko ([^/;]+) Build", model: "$1" }, { regex: "Wiko ([^/; ]+)", model: "$1" }] }, lae = { regex: "Wieppo (S6 Lite|S[658]|E1)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, iae = { regex: "weplus_3", device: "smartphone", models: [{ regex: "weplus_3", model: "WePlus 3" }] }, sae = { regex: "(?:Wileyfox [^/]+)|Swift 2(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Wileyfox Spark \\+", model: "Spark +" }, { regex: "Wileyfox Spark X", model: "Spark X" }, { regex: "Wileyfox (Spark|Swift)", model: "$1" }, { regex: "Wileyfox ([^/)]+)(?: Build|\\))", model: "$1" }, { regex: "Swift 2 (X|Plus)(?:[);/ ]|$)", model: "Swift 2 $1" }, { regex: "Swift 2(?:[);/ ]|$)", model: "Swift 2" }] }, dae = { regex: "miSmart|miTab|WIAM \\#24|WOLDER", device: "smartphone", models: [{ regex: "WIAM \\#24", model: "Wiam #24" }, { regex: "WOLDER_WIAM_65", model: "Wiam #65" }, { regex: "miSmart[ \\-_]?([^/]+) Build", model: "miSmart $1" }, { regex: "miTab[ \\-_]?([^/)]+)(?: Build|\\))", device: "tablet", model: "miTab $1" }] }, uae = { regex: "AT[ _-]AS([0-9A-Z]+)(?:[);/ ]|$)", device: "smartphone", model: "AT-AS$1" }, cae = { regex: "Wonu ([a-z0-9]+)", device: "feature phone", model: "$1" }, mae = { regex: "SP5026i-Scorpio", device: "smartphone", models: [{ regex: "SP5026i-Scorpio", model: "Scorpio" }] }, gae = { regex: "Woxter[ _]([^/;)]+)(?: Build|\\))|Nimbus 101Q", device: "tablet", models: [{ regex: "Nimbus 101Q", model: "Nimbus 101Q" }, { regex: "Woxter[ _]([^/;)]+)(?: Build|\\))", model: "$1" }] }, fae = { regex: "(?:POCO[ _](?:X[23]|F2 PRO|M[32])|M2010J19C[GI]|M2007J20C[ITG]|M2012K11AG|M2006C3MI|M2004J19PI|M2102J20SG)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "POCO X2(?:[);/ ]|$)", model: "X2" }, { regex: "(?:M2010J19C[GI]|POCO M3)(?:[);/ ]|$)", model: "M3" }, { regex: "M2012K11AG(?:[);/ ]|$)", model: "F3" }, { regex: "M2004J19PI(?:[);/ ]|$)", model: "M2" }, { regex: "POCO M2 Pro(?:[);/ ]|$)", model: "M2 Pro" }, { regex: "(?:M2007J20C[GT]|POCO X3 NFC)(?:[);/ ]|$)", model: "X3 NFC" }, { regex: "(?:M2007J20CI|POCO X3)(?:[);/ ]|$)", model: "X3" }, { regex: "M2102J20SG(?:[);/ ]|$)", model: "X3 Pro" }, { regex: "M2006C3MI(?:[);/ ]|$)", model: "C3" }, { regex: "POCO F2 PRO(?:[);/ ]|$)", model: "F2 Pro" }] }, pae = { regex: "Xiaomi(?!/(?:Miui|Mint[ ])Browser)|Mi9 Pro 5G|(?:MI [a-z0-9]+|Mi-4c|MI-One[ _]?[a-z0-9]+|MIX(?: 2S?)?)(?:[);/ ]|$)|HM (?:[^/;]+) (?:Build|MIUI)|(?:2014501|2014011|201481[12378]|201302[23]|2013061) Build|Redmi|POCOPHONE|(?:SHARK )?(KLE|MBU)-[AH]0|SKR-[AH]0|SKW-[AH]0|POCO F1|DLT-[AH]0|MIBOX[234]([_ ]PRO)?|MiTV4[CSX]?|MiTV-(MSSP[01]|AXSO0)|AWM-A0|MI CC 9 Meitu Edition|MiBOX1S|MiTV4A|M2006J10C|M2006C3(?:L[IGC]|LVG|MN?G)|M2007J1(?:7[CGI]|SC)|M2002J9[EG]|HM2014819|WT88047|M2004J(?:7[AB]|19)C|M2012K11C|M2011K2[CG]|M2006C3[ML]II|M2003J15SC|M2007J3S[ICYGP]|M2007J22[CG]|M2101K6[GI]|M2101K(?:[79]AG|7AI)|M2010J19S[CGYI]|HM NOTE 1(?:LTE|W)|MI[_ ]PLAY|XIG01|MI_(NOTE_Pro|5X|4i|(?:A2|8)_Lite)", device: "smartphone", models: [{ regex: "SKR-[AH]0", model: "Black Shark" }, { regex: "AWM-A0", model: "Black Shark Helo" }, { regex: "SKW-[AH]0", model: "Black Shark 2" }, { regex: "DLT-[AH]0", model: "Black Shark 2 Pro" }, { regex: "(?:SHARK )?KLE-A0", model: "Black Shark 3" }, { regex: "(?:SHARK )?KLE-H0", model: "Black Shark 3 5G" }, { regex: "(?:SHARK )?MBU-H0", model: "Black Shark 3 Pro 5G" }, { regex: "(?:SHARK )?MBU-A0", model: "Black Shark 3 Pro" }, { regex: "Xiaomi_2014501|2014501 Build", model: "Hongmi 4G" }, { regex: "Xiaomi_2014011|2014011 Build", model: "Hongmi 1S" }, { regex: "Xiaomi_201302[23]|201302[23] Build", model: "Hongmi" }, { regex: "Xiaomi[_-]2014818|2014818 Build", model: "Hongmi 2 3G" }, { regex: "Xiaomi_2014817|2014817 Build", model: "Hongmi 2" }, { regex: "Xiaomi[_-]201481[123]|201481[123] Build", model: "Hongmi 2 4G" }, { regex: "MI[_ ]PLAY(?:[);/ ]|$)", model: "MI Play" }, { regex: "Mi 9 SE(?:[);/ ]|$)", model: "MI 9 SE" }, { regex: "MI CC 9 Meitu Edition(?:[);/ ]|$)", model: "MI CC 9" }, { regex: "Xiaomi_M2001J2E_TD-LTE(?:[);/ ]|$)", model: "MI 10" }, { regex: "M2011K2[CG](?:[);/ ]|$)", model: "MI 11" }, { regex: "M2007J3S[CYP](?:[);/ ]|$)", model: "MI 10T 5G" }, { regex: "M2007J3S[GI](?:[);/ ]|$)", model: "MI 10T Pro 5G" }, { regex: "M2007J17G(?:[);/ ]|$)", model: "MI 10T Lite 5G" }, { regex: "M2007J1SC(?:[);/ ]|$)", model: "MI 10 Ultra 5G" }, { regex: "(?:M2002J9[EG]|XIG01)(?:[);/ ]|$)", model: "MI 10 Lite 5G" }, { regex: "M2007J17I(?:[);/ ]|$)", model: "MI 10i" }, { regex: "M2101K9AG(?:[);/ ]|$)", model: "MI 11 Lite" }, { regex: "MI[ _]8[ _]Lite(?:[);/ ]|$)", model: "MI 8 Lite" }, { regex: "Mi 9T Pro(?:[);/ ]|$)", model: "MI 9T Pro" }, { regex: "Mi9 Pro 5G(?:[);/ ]|$)", model: "MI 9 Pro 5G" }, { regex: "MI ([89]) Lite(?:[);/ ]|$)", model: "MI $1 Lite" }, { regex: "MI 5s Plus(?:[);/ ]|$)", model: "MI 5s Plus" }, { regex: "Xiaomi_2013061|2013061 Build", model: "MI 3" }, { regex: "Mi-4c(?:[);/ ]|$)", model: "MI 4C" }, { regex: "MI 4W(?:[);/ ]|$)", model: "MI 4W" }, { regex: "Mi_4i(?:[);/ ]|$)", model: "MI 4i" }, { regex: "MI MAX 3(?:[);/ ]|$)", model: "MI MAX 3" }, { regex: "MI MAX 2(?:[);/ ]|$)", model: "MI MAX 2" }, { regex: "Mi[ _]A2[ _]Lite(?:[);/ ]|$)", model: "MI A2 Lite" }, { regex: "MIX 3(?:[);/ ]|$)", model: "MI MIX 3" }, { regex: "MIX 2S(?:[);/ ]|$)", model: "MI MIX 2S" }, { regex: "MIX 2(?:[);/ ]|$)", model: "MI MIX 2" }, { regex: "MIX(?:[);/ ]|$)", model: "MI MIX" }, { regex: "POCOPHONE[ _]F1|POCO F1", model: "Pocophone F1" }, { regex: "Redmi 5 Plus", model: "Redmi 5 Plus" }, { regex: "WT88047(?:[);/ ]|$)", model: "Redmi 2" }, { regex: "HM2014819(?:[);/ ]|$)", model: "Redmi 2 Pro" }, { regex: "HM 2A(?:[);/ ]|$)", model: "Redmi 2A" }, { regex: "HM 1S[CW]?(?:[);/ ]|$)", model: "Redmi 1S" }, { regex: "HM 1(?:[);/ ]|$)", model: "Redmi 1" }, { regex: "M2004J7AC(?:[);/ ]|$)", model: "Redmi 10X" }, { regex: "(?:M2004J19C|M2006C3MII)(?:[);/ ]|$)", model: "Redmi 9" }, { regex: "M2010J19SI(?:[);/ ]|$)", model: "Redmi 9 Power" }, { regex: "M2006C3L[GCI](?:[);/ ]|$)", model: "Redmi 9A" }, { regex: "M2006C3LII(?:[);/ ]|$)", model: "Redmi 9i" }, { regex: "M2006C3MG(?:[);/ ]|$)", model: "Redmi 9C" }, { regex: "M2006C3LVG(?:[);/ ]|$)", model: "Redmi 9AT" }, { regex: "M2010J19S[GY](?:[);/ ]|$)", model: "Redmi 9T" }, { regex: "M2006C3MNG(?:[);/ ]|$)", model: "Redmi 9C NFC" }, { regex: "M2004J7BC(?:[);/ ]|$)", model: "Redmi 10X Pro" }, { regex: "Redmi K20 Pro(?:[);/ ]|$)", model: "Redmi K20 Pro" }, { regex: "Redmi K30 5G(?:[);/ ]|$)", model: "Redmi K30 5G" }, { regex: "M2012K11C(?:[);/ ]|$)", model: "Redmi K40 Pro" }, { regex: "M2006J10C(?:[);/ ]|$)", model: "Redmi K30 Ultra" }, { regex: "Redmi Y1 Lite(?:[);/ ]|$)", model: "Redmi Y1 Lite" }, { regex: "MI PAD 4 PLUS(?:[);/ ]|$)", model: "Mi Pad 4 Plus", device: "tablet" }, { regex: "MI PAD 4(?:[);/ ]|$)", model: "Mi Pad 4", device: "tablet" }, { regex: "MI PAD 3(?:[);/ ]|$)", model: "Mi Pad 3", device: "tablet" }, { regex: "MI PAD 2(?:[);/ ]|$)", model: "Mi Pad 2", device: "tablet" }, { regex: "MI PAD(?:[);/ ]|$)", model: "Mi Pad", device: "tablet" }, { regex: "MIBOX3[ _]Pro(?:[);/ ]|$)", model: "Mi Box 3 Pro", device: "tv" }, { regex: "MIBOX([234])(?:[);/ ]|$)", model: "Mi Box $1", device: "tv" }, { regex: "MiBOX1S(?:[);/ ]|$)", model: "Mi Box 1S", device: "tv" }, { regex: "MiTV-MSSP1(?:[);/ ]|$)", model: "MiTV 4S", device: "tv" }, { regex: "(?:MiTV-AXSO0|MiTV4(?:A|-ANSM0)|MiTV-MSSP0)(?:[);/ ]|$)", model: "MiTV 4A", device: "tv" }, { regex: "(MiTV)(4[CSX]|4)(?:[);/ ]|$)", model: "$1 $2", device: "tv" }, { regex: "HM NOTE 1W(?:[);/ ]|$)", device: "phablet", model: "Redmi Note" }, { regex: "HM NOTE 1TD (?:Build|MIUI)", device: "phablet", model: "Hongmi Note 1TD" }, { regex: "HM NOTE 1(?:LTE|S)(?:W|GLOBAL|TD)? (?:Build|MIUI)|HM NOTE 1LTE", device: "phablet", model: "Redmi Note 4G" }, { regex: "Redmi Note 5A Prime", model: "Redmi Note 5A Prime", device: "phablet" }, { regex: "M2010J19SC(?:[);/ ]|$)", model: "Redmi Note 9", device: "phablet" }, { regex: "M2003J15SC(?:[);/ ]|$)", model: "Redmi Note 10X", device: "phablet" }, { regex: "M2007J22G(?:[);/ ]|$)", model: "Redmi Note 9T 5G", device: "phablet" }, { regex: "M2007J22C(?:[);/ ]|$)", model: "Redmi Note 9 5G", device: "phablet" }, { regex: "M2007J17C(?:[);/ ]|$)", model: "Redmi Note 9 Pro 5G", device: "phablet" }, { regex: "M2101K7A[GI]", model: "Redmi Note 10", device: "phablet" }, { regex: "M2101K6[GI]", model: "Redmi Note 10 Pro", device: "phablet" }, { regex: "Redmi Note ([5-9]) Pro(?:[);/ ]|$)", model: "Redmi Note $1 Pro", device: "phablet" }, { regex: "Redmi[ _]Note[ _]([^;/) ]+)?", model: "Redmi Note $1", device: "phablet" }, { regex: "Redmi[ _]([^;/) ]+)?", model: "Redmi $1" }, { regex: "MI_NOTE_Pro", model: "MI Note Pro", device: "phablet" }, { regex: "Mi Note 10 Pro", model: "Mi Note 10 Pro", device: "phablet" }, { regex: "MI[ _]Note[ _]([^;/) ]+)?", model: "MI Note $1", device: "phablet" }, { regex: "(MI(?:-One)?[ _](?:[^;/]*))Build", model: "$1" }, { regex: "(MI[ _][a-z0-9]+|MI-One[ _]?[a-z0-9]+)(?:[);/ ]|$)", model: "$1" }, { regex: "HM Note ([^/;]+) (?:Build|MIUI)", device: "phablet", model: "Note" }, { regex: "HM ([^/;]+) (?:Build|MIUI)", model: "HM $1" }, { regex: "Xiaomi[ _-]([^/;]+)(?: Build|$)", model: "$1" }] }, hae = { regex: "XI-CE(?:655|U[48])", device: "smartphone", models: [{ regex: "XI-CE(655|U[48])", model: "CE$1" }] }, xae = { regex: "Xolo|(?:Q600|Q700s?|Q800|Q1000s|Q1000[ _]Opus|Q1010i|Q2000|Omega[ _]5.[05]|Era5X|Era[ _]2V|Era_4X(?:_2GB)?)(?:[);/ ]|$)|BLACK-1XM", device: "smartphone", models: [{ regex: "BLACK-1XM", model: "Black 1X" }, { regex: "Era_?([45])X(?:[);/ ]|$)", model: "Era $1X" }, { regex: "Era_4X_2GB(?:[);/ ]|$)", model: "Era 4X 2GB" }, { regex: "Era[ _]2V(?:[);/ ]|$)", model: "Era 2V" }, { regex: "(Q600 Club|Q600|Q700s?|Q800|Q1000s Plus|Q1000s|Q1000[ _]Opus|Q1010i|Q2000|Omega[ _]5.[05])(?:[);/ ]|$)", model: "$1" }, { regex: "Xolo[ _]?([^;/]+) Build", model: "$1" }, { regex: "Xolo[ _]?([a-z0-9_-]+)", model: "$1" }] }, vae = { regex: "Xenta[ \\-]Tab|Luna TAB|TAB09-410|TAB10-410|TAB07-485|TAB0[78]-200|TAB08-201-3G|TAB9-200|TAB09-211|TAB10-2[01]1|TAB13-201", device: "tablet", models: [{ regex: "Luna TAB07-920N", model: "Luna 7" }, { regex: "Luna TAB07-10[01]", model: "Luna 7c" }, { regex: "Luna TAB274", model: "Luna 7c" }, { regex: "Luna TAB474", model: "Luna 10" }, { regex: "Luna TAB10-150", model: "Luna 10c" }, { regex: "TAB09-410", model: "Noble 9.7" }, { regex: "TAB10-410", model: "Noble 10.1" }, { regex: "TAB07-485", model: "Noble Mini" }, { regex: "Xenta-TAB07-21[01]", model: "Xenta 7c" }, { regex: "TAB07-200", model: "Xenta 7ic" }, { regex: "TAB08-200", model: "Xenta 8ic" }, { regex: "TAB08-201-3G", model: "Xenta 8c" }, { regex: "TAB9-200", model: "Xenta 9.7ic" }, { regex: "TAB09-211", model: "Xenta 9.7ic+" }, { regex: "TAB10-2[01]1", model: "Xenta 10ic" }, { regex: "TAB13-201", model: "Xenta 13c" }] }, Sae = { regex: "M631Y|M685Y4|M651G_MY|YES (MPY(?:48|54))", device: "smartphone", models: [{ regex: "M631Y", model: "Altitude" }, { regex: "M651G_MY", model: "Altitude 2" }, { regex: "M685Y4", model: "Altitude 3" }, { regex: "YES (MPY(?:48|54))", model: "$1" }] }, bae = { regex: "Yezz|ANDY[ _]|(?:4E4|A5EI|LIV1)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "4E4", model: "Andy 4E4" }, { regex: "Yezz-AC4EI", model: "Andy 4EI" }, { regex: "YEZZ-A4M", model: "Andy A4M" }, { regex: "A5EI", model: "Andy A5EI" }, { regex: "LIV1", model: "LIV1" }, { regex: "Andy[ _]([A-Z]*[0-9]\\.[0-9][A-Z0-9]*)(?:[ _](LTE))?", model: "Andy $1 $2" }, { regex: "Andy[ _]([A-Z]*[0-9])([0-9][A-Z0-9]*)(?:[ _](LTE))?", model: "Andy $1.$2 $3" }, { regex: "Andy[ _]([A-Z]*[0-9][A-Z0-9]+)(?:[ _](LTE))?", model: "Andy $1 $2" }] }, yae = { regex: "(?:YU5[05]10[A]?|YU4711|AO5510|YU5050|YU501[14]|YU5551)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "YU5010[A]?(?:[);/ ]|$)", model: "Yuphoria" }, { regex: "YU5011(?:[);/ ]|$)", model: "Yunique 2" }, { regex: "YU5050(?:[);/ ]|$)", model: "Yutopia" }, { regex: "AO5510(?:[);/ ]|$)", model: "Yureka" }, { regex: "YU5551(?:[);/ ]|$)", model: "Yureka 2" }, { regex: "YU5510[A]?(?:[);/ ]|$)", model: "Yureka Plus" }, { regex: "YU4711(?:[);/ ]|$)", model: "Yunique" }, { regex: "YU5014(?:[);/ ]|$)", model: "Ace" }] }, wae = { regex: "N101[ _]DUAL(?:[ _]CORE)?(?:[ _]?2|\\|\\|)?(?:[ _]V11)?(?:[);/ ]|$)", device: "tablet", model: "N101" }, _ae = { regex: "Yusun|LA2-T", device: "smartphone", models: [{ regex: "LA2-T", model: "LA2-T" }, { regex: "Yusun ([^;/]+) Build", model: "$1" }, { regex: "Yusun ([a-z0-9_\\-\\+]+)", model: "$1" }] }, Tae = { regex: "YTONE[ _\\-]", device: "smartphone", models: [{ regex: "YTONE[ _\\-]?([^/;]+) Build", model: "$1" }, { regex: "YTONE[ _\\-]?([^);/ ]+)", model: "$1" }] }, Aae = { regex: "(ZM(?:CK|EM|TFTV|TN)[a-z0-9]+)|ZA409", device: "feature phone", models: [{ regex: "ZA409", device: "smartphone", model: "Muzic" }, { regex: "(ZM(?:CK|EM|TFTV|TN)[a-z0-9]+)", model: "$1" }] }, Pae = { regex: "ZYQ-Q88|(Q(?:2602|262[436]|638|2688|272[89]|3022|3623|TAB Tab4|328 m9|328|668)|J77|Q[._](?:Up|Boss P99|Dee R09|Good M9|Hi|Hot|Me|Mate R99|Next|TOP-X8|You))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Q638", model: "I7" }, { regex: "Q2624", model: "Cheer 3G" }, { regex: "Q2602", model: "TV Next" }, { regex: "Q2728", model: "Zone 3G" }, { regex: "Q2729", model: "Q2729" }, { regex: "Q2688", model: "Q2688" }, { regex: "Q2623", model: "Win 3G" }, { regex: "Q2626", model: "Care 3G" }, { regex: "Q3623", model: "Braw 3G" }, { regex: "Q3022", model: "Q3022" }, { regex: "Q328 m9", model: "Q328 M9" }, { regex: "Q328", model: "Speed 3G" }, { regex: "Q668", model: "TV I4" }, { regex: "J77", model: "Q.Dee" }, { regex: "Q\\.Up C5", model: "Q.Up C5" }, { regex: "Q\\.Up", model: "Q.Up" }, { regex: "Q\\.Boss P99", model: "Q.Boss P99" }, { regex: "Q[._]Dee R09", model: "Q.Dee R09" }, { regex: "Q\\.Good M9", model: "Q.Good M9" }, { regex: "Q[._]Hi S1", model: "Q.Hi S1" }, { regex: "Q[._]Hi", model: "Q.Hi" }, { regex: "Q[._]Hot P7 3G", model: "Q.Hot P7 3G" }, { regex: "Q[._]Hot", model: "Q.Hot" }, { regex: "Q[._]Me Phone7 3G", model: "Q.Me Phone 7 3G" }, { regex: "Q[._]Me Plus7", model: "Q.Me Plus 7" }, { regex: "Q[._]Me", model: "Q.Me" }, { regex: "Q[._]Mate R99", model: "Q.Mate R99" }, { regex: "Q[._]Next B7", model: "Q.Next B7" }, { regex: "Q[._]Next J2", model: "Q.Next J2" }, { regex: "Q[._]TOP-X8", model: "Q.Top X8" }, { regex: "Q[._]You", model: "Q.You" }, { regex: "QTAB Tab4", model: "QTab Tab4", device: "tablet" }, { regex: "ZYQ-Q88", model: "Q88", device: "tablet" }] }, Mae = { regex: "Toshiba|TSBNetTV/|portalmmm/[12].0 TS|T-01C|T-0[12]D|IS04|IS11T|AT1S0|AT300SE|AT(7-C|10-A|10[PL]E-A|100|200|270|300|330|374|400|470|500|503|570|703|830)", device: "smartphone", models: [{ regex: "T-01C", model: "Regza T-01C" }, { regex: "T-01D", model: "Regza T-01D" }, { regex: "T-02D", model: "Regza T-02D" }, { regex: "IS04", model: "Regza IS04" }, { regex: "IS11T", model: "Regza IS11T" }, { regex: "AT7-C", model: "Excite", device: "tablet" }, { regex: "AT1S0", model: "Regza AT1S0", device: "tablet" }, { regex: "AT300SE", model: "Regza AT300SE", device: "tablet" }, { regex: "AT500a", model: "Regza AT500a", device: "tablet" }, { regex: "AT(100|200|270|300|330|374|400|470|500|503|570|703|830)", model: "Regza AT$1", device: "tablet" }, { regex: "AT10([PL])E-A", model: "Excite AT10$1-A", device: "tablet" }, { regex: "AT10-A", model: "Excite AT10-A", device: "tablet" }, { regex: "TSBNetTV/", device: "tv", model: "" }, { regex: "Toshiba[ /_\\-]?([a-z0-9_ \\-]+) Build", model: "$1" }, { regex: "Toshiba[ /_\\-]?([a-z0-9_\\-]+)", model: "$1" }, { regex: "portalmmm/[12].0 (TS[a-z0-9 ]+)", model: "$1" }] }, $ae = { regex: "VIVAX|(?:Fly5[_ ]Lite|Fun[_ ]S500|Point_(?:X[12]|X501)|PRO3|32LE77SM|40LE77SM|FUN S1|FUN_S20)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Fly5[_ ]Lite(?:[);/ ]|$)", model: "Fly 5 Lite" }, { regex: "Point_X([12])(?:[);/ ]|$)", model: "Point X$1" }, { regex: "Fun[_ ]S500(?:[);/ ]|$)", model: "Fun S500" }, { regex: "FUN[ _]S(1|20)(?:[);/ ]|$)", model: "Fun S$1" }, { regex: "VIVAX[ _]Fly3(?:[);/ ]|$)", model: "Fly 3" }, { regex: "VIVAX[ _]Fly[ _]V1(?:[);/ ]|$)", model: "Fly V1" }, { regex: "(?:VIVAX )?(Point[ _](?:X551|X501))(?:[);/ ]|$)", model: "$1" }, { regex: "SMART Point X5010(?:[);/ ]|$)", model: "Smart Point X5010" }, { regex: "VIVAX[_ ]PRO3", model: "Pro 3" }, { regex: "VIVAX TABLET TPC 802 3G(?:[);/ ]|$)", model: "TPC-802 3G" }, { regex: "(32LE77SM|40LE77SM)", device: "tv", model: "$1" }] }, Cae = { regex: "IQ(?:0705|L550|1010w?|1012N?|1019N|1025|1380|1401|1436|1452a|1453|1470|1502a|1511|1552|1553|1568|1570|1805N|1806|1808|1810B_M|1832|1850|1890|5017|9610|181011N|E[12]00|EL41|G550|GW516|L30|L5[01]|M801|M1001|N700|P50|R300|S300|S1001|W503|W511T|W553N?|W60[38]|W626|M960|D700|9013_4N)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "IQ0705(?:[);/ ]|$)", model: "iQTalk Twist" }, { regex: "IQL550(?:[);/ ]|$)", model: "Notch Lite" }, { regex: "IQ1010W?(?:[);/ ]|$)", model: "iQTab 10", device: "tablet" }, { regex: "IQ1012N?(?:[);/ ]|$)", model: "iQTab Brave 3G", device: "tablet" }, { regex: "IQ1025(?:[);/ ]|$)", model: "iQTab Action 4G", device: "tablet" }, { regex: "iQ9013_4N(?:[);/ ]|$)", model: 'Life 10.1"', device: "tablet" }, { regex: "IQ1019N(?:[);/ ]|$)", model: 'Alu Plus 4G 10.1"', device: "tablet" }, { regex: "iQ1805N(?:[);/ ]|$)", model: 'iQTab Ideal 8.0"', device: "tablet" }, { regex: "iQ181011N(?:[);/ ]|$)", model: 'iQTab Care 8.0"', device: "tablet" }, { regex: "IQ1380(?:[);/ ]|$)", model: "Brain 3G" }, { regex: "IQ1401(?:[);/ ]|$)", model: "iQTalk Verse 4G" }, { regex: "IQ1436(?:[);/ ]|$)", model: "Color mini 4G" }, { regex: "IQ1452a(?:[);/ ]|$)", model: "TOP-S 4G" }, { regex: "IQ1453(?:[);/ ]|$)", model: "Trend 4G" }, { regex: "IQ1470(?:[);/ ]|$)", model: "iQTalk Onyx" }, { regex: "IQ1502a(?:[);/ ]|$)", model: "iQTalk Flame" }, { regex: "IQ1511(?:[);/ ]|$)", model: "iQTalk Spicy" }, { regex: "IQ1552(?:[);/ ]|$)", model: "iQTalk Titan 4G" }, { regex: "IQ1553(?:[);/ ]|$)", model: "Color 3 4G" }, { regex: "IQ1568(?:[);/ ]|$)", model: "Range 4G" }, { regex: "IQ1570(?:[);/ ]|$)", model: "iQTalk Color 5.5 4G" }, { regex: "IQ1806(?:[);/ ]|$)", model: "iQTab Rose", device: "tablet" }, { regex: "IQ1808(?:[);/ ]|$)", model: "iQTab Master", device: "tablet" }, { regex: "IQ1810B_M(?:[);/ ]|$)", model: "iQTab Novel 3G", device: "tablet" }, { regex: "IQ1832(?:[);/ ]|$)", model: "Jet 3G", device: "tablet" }, { regex: "IQ1850(?:[);/ ]|$)", model: "Diamond 5.2 4G" }, { regex: "IQ1890(?:[);/ ]|$)", model: "iQTalk Aura" }, { regex: "IQ5017(?:[);/ ]|$)", model: "Slice 4G" }, { regex: "IQ9610(?:[);/ ]|$)", model: "Angel 3G", device: "tablet" }, { regex: "iQM960(?:[);/ ]|$)", model: "Angel 3G (2018)", device: "tablet" }, { regex: "IQG550(?:[);/ ]|$)", model: "Style 4G" }, { regex: "IQGW516(?:[);/ ]|$)", model: "F5" }, { regex: "IQE100(?:[);/ ]|$)", model: "Energy 4G" }, { regex: "iQE200(?:[);/ ]|$)", model: "MX 4G" }, { regex: "IQEL41(?:[);/ ]|$)", model: "Fab 4G" }, { regex: "IQL30(?:[);/ ]|$)", model: "Status 4G" }, { regex: "IQL50(?:[);/ ]|$)", model: "More 4G" }, { regex: "IQL51(?:[);/ ]|$)", model: "Wave 4G" }, { regex: "IQM801(?:[);/ ]|$)", model: "Brace 2018 4G", device: "tablet" }, { regex: "IQM1001(?:[);/ ]|$)", model: "Level 4G", device: "tablet" }, { regex: "IQN700(?:[);/ ]|$)", model: "Inspire 4G" }, { regex: "IQP50(?:[);/ ]|$)", model: "Ruby 4G" }, { regex: "IQS300(?:[);/ ]|$)", model: "DX 4G" }, { regex: "IQS1001(?:[);/ ]|$)", model: "Vista 4G", device: "tablet" }, { regex: "IQR300(?:[);/ ]|$)", model: "R3 4G" }, { regex: "IQW608(?:[);/ ]|$)", model: "Regal" }, { regex: "iQW603(?:[);/ ]|$)", model: 'Phab 6.0"', device: "phablet" }, { regex: "IQW626(?:[);/ ]|$)", model: "D6 4G" }, { regex: "IQW511T(?:[);/ ]|$)", model: "Liberal" }, { regex: "IQW553N?(?:[);/ ]|$)", model: 'Alu 5.5"' }, { regex: "IQW503(?:[);/ ]|$)", model: "Flame 4G (2018)" }, { regex: "iQD700(?:[);/ ]|$)", model: "Color Fingerprint 4G" }] }, Lae = { regex: "Fly(?!Flow|touch)|Power Plus 5000|Photo Pro|Slimline|Life (?:Ace|Jet|Sky|Compact 4G|Geo)|FS50[1-9]|FS51[0-8]|FS52[0-9]|FS530|FS55[134]|FS40[1-9]|FS45[1-9]|4FS06|MERIDIAN-|(?:IQ(?!10[134]0)[0-9]{3,}[i]?)[ _]?(?:Quad|Firebird|Quattro|Turbo|Magic)?(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:Fly_)?IQ310(?:[);/ ]|$)", model: "Panorama", device: "tablet" }, { regex: "(?:Fly_)?IQ236(?:[);/ ]|$)", model: "Victory" }, { regex: "Slimline(?:[);/ ]|$)", model: "Slimline" }, { regex: "Power Plus 5000(?:[);/ ]|$)", model: "Power Plus 5000" }, { regex: "Photo Pro(?:[);/ ]|$)", model: "Photo Pro" }, { regex: "Life Ace(?:[);/ ]|$)", model: "Life Ace" }, { regex: "Life Jet(?:[);/ ]|$)", model: "Life Jet" }, { regex: "Life Sky(?:[);/ ]|$)", model: "Life Sky" }, { regex: "Life Geo(?:[);/ ]|$)", model: "Life Geo" }, { regex: "Life Compact 4G(?:[);/ ]|$)", model: "Life Compact 4G" }, { regex: "FS506", model: "Cirrus 3" }, { regex: "FS403", model: "Cumulus 1" }, { regex: "FS508", model: "Cirrus 6" }, { regex: "FS511", model: "Cirrus 7" }, { regex: "FS509", model: "Nimbus 9" }, { regex: "FS406", model: "Stratus 5" }, { regex: "FS404", model: "Stratus 3" }, { regex: "FS504", model: "Cirrus 2" }, { regex: "FS407", model: "Stratus 6" }, { regex: "FS401", model: "Stratus 1" }, { regex: "FS402", model: "Stratus 2" }, { regex: "FS501", model: "Nimbus 3" }, { regex: "FS502", model: "Cirrus 1" }, { regex: "FS507", model: "Cirrus 4" }, { regex: "FS505", model: "Nimbus 7" }, { regex: "FS551", model: "Nimbus 4" }, { regex: "FS514", model: "Cirrus 8" }, { regex: "FS553", model: "Cirrus 9" }, { regex: "FS554", model: "Power Plus FHD" }, { regex: "FS517", model: "Cirrus 11" }, { regex: "FS516", model: "Cirrus 12" }, { regex: "FS518", model: "Cirrus 13" }, { regex: "FS520", model: "Selfie 1" }, { regex: "FS521", model: "Power Plus 1" }, { regex: "FS522", model: "Cirrus 14" }, { regex: "FS523", model: "Cirrus 16" }, { regex: "FS524", model: "Knockout" }, { regex: "FS526", model: "Power Plus 2" }, { regex: "FS527", model: "Nimbus 17" }, { regex: "FS528", model: "Memory Plus" }, { regex: "FS529", model: "Сhamp" }, { regex: "FS530", model: "Power Plus XXL" }, { regex: "FS454", model: "Nimbus 8" }, { regex: "FS452", model: "Nimbus 2" }, { regex: "FS512", model: "Nimbus 10" }, { regex: "FS510", model: "Nimbus 12" }, { regex: "FS451", model: "Nimbus 1" }, { regex: "FS405", model: "Stratus 4" }, { regex: "FS408", model: "Stratus 8" }, { regex: "FS409", model: "Stratus 9" }, { regex: "FS455", model: "Nimbus 11" }, { regex: "FS456", model: "Nimbus 14" }, { regex: "FS457", model: "Nimbus 15" }, { regex: "FS459", model: "Nimbus 16" }, { regex: "FS458", model: "Stratus 7" }, { regex: "(?:Fly_)?IQ237(?:[);/ ]|$)", model: "Dynamic" }, { regex: "(?:Fly_)?IQ238(?:[);/ ]|$)", model: "Jazz" }, { regex: "(?:Fly_)?IQ240(?:[);/ ]|$)", model: "Whizz" }, { regex: "(?:Fly_)?IQ255(?:[);/ ]|$)", model: "Pride" }, { regex: "(?:Fly_)?IQ270(?: Firebird)?(?:[);/ ]|$)", model: "Firebird" }, { regex: "(?:Fly_)?IQ275(?:[);/ ]|$)", model: "Marathon" }, { regex: "(?:Fly_)?IQ285(?: Turbo)?(?:[);/ ]|$)", model: "Turbo" }, { regex: "(?:Fly_)?IQ430(?:[);/ ]|$)", model: "Evoke" }, { regex: "(?:Fly_)?IQ431(?:[);/ ]|$)", model: "Glory" }, { regex: "(?:Fly_)?IQ432(?:[);/ ]|$)", model: "Era Nano 1" }, { regex: "(?:Fly_)?IQ436(?:[);/ ]|$)", model: "Era Nano 3" }, { regex: "(?:Fly_)?IQ4490(?:[);/ ]|$)", model: "Era Nano 4" }, { regex: "(?:Fly_)?IQ434(?:[);/ ]|$)", model: "Era Nano 5" }, { regex: "(?:Fly_)?IQ4406(?:[);/ ]|$)", model: "Era Nano 6" }, { regex: "(?:Fly_)?IQ436i(?:[);/ ]|$)", model: "Era Nano 9" }, { regex: "(?:Fly_)?IQ440(?:[);/ ]|$)", model: "Energy" }, { regex: "(?:Fly_)?IQ4401(?:[);/ ]|$)", model: "Era Energy 2" }, { regex: "(?:Fly_)?IQ441(?:[);/ ]|$)", model: "Radiance" }, { regex: "(?:Fly_)?IQ442 Quad(?:[);/ ]|$)", model: "Miracle 2" }, { regex: "(?:Fly_)?IQ442(?:[);/ ]|$)", model: "Miracle" }, { regex: "(?:Fly_)?IQ443(?:[);/ ]|$)", model: "Trend" }, { regex: "(?:Fly_)?IQ444(?: Quattro)?(?:[);/ ]|$)", model: "Diamond 2" }, { regex: "(?:Fly_)?IQ445(?:[);/ ]|$)", model: "Genius" }, { regex: "(?:Fly_)?IQ446(?: Magic)?(?:[);/ ]|$)", model: "Magic" }, { regex: "(?:Fly_)?IQ447(?:[);/ ]|$)", model: "Era Life 1" }, { regex: "(?:Fly_)?IQ456(?:[);/ ]|$)", model: "Era Life 2" }, { regex: "(?:Fly_)?IQ4409 Quad(?:[);/ ]|$)", model: "Era Life 4" }, { regex: "(?:Fly_)?IQ448(?:[);/ ]|$)", model: "Chic" }, { regex: "(?:Fly_)?IQ449(?:[);/ ]|$)", model: "Pronto" }, { regex: "(?:Fly_)?IQ450(?:[);/ ]|$)", model: "Horizon" }, { regex: "(?:Fly_)?IQ450[ _]Quattro(?:[);/ ]|$)", model: "Horizon 2" }, { regex: "(?:Fly_)?IQ451(?:[);/ ]|$)", model: "Vista" }, { regex: "(?:Fly_)?IQ452 Quad(?:[);/ ]|$)", model: "Ego Vision 1" }, { regex: "(?:Fly_)?IQ454(?:[);/ ]|$)", model: "Evo Tech 1" }, { regex: "(?:Fly_)?IQ4403(?:[);/ ]|$)", model: "Energy 3" }, { regex: "(?:Fly_)?IQ4404(?:[);/ ]|$)", model: "Spark" }, { regex: "(?:Fly_)?IQ4410 Quad(?:[);/ ]|$)", model: "Phoenix" }, { regex: "(?:Fly_)?IQ4411(?:[);/ ]|$)", model: "Energy 2" }, { regex: "(?:Fly_)?IQ4412 Quad(?:[);/ ]|$)", model: "Coral" }, { regex: "(?:Fly_)?IQ4413[ _]Quad(?:[);/ ]|$)", model: "Evo Chic 3" }, { regex: "(?:Fly_)?IQ4414 Quad(?:[);/ ]|$)", model: "Evo Tech 3" }, { regex: "(?:Fly_)?IQ4415 Quad(?:[);/ ]|$)", model: "Era Style 3" }, { regex: "(?:Fly_)?IQ4504 Quad(?:[);/ ]|$)", model: "Evo Energy 5" }, { regex: "(?:Fly_)?IQ([0-9]+[i]? ?(?:Quad|Firebird|Quattro)?)(?:[);/ ]|$)", model: "IQ$1" }, { regex: "Fly[ _\\-]?([a-z0-9_]+)/", model: "$1", device: "feature phone" }, { regex: "Flylife[ _\\-]?([^/;]+) Build", model: "Flylife $1", device: "tablet" }, { regex: "Fly[ _\\-]?([a-z0-9]+)", model: "$1" }, { regex: "MERIDIAN-([a-z0-9]+)", model: "$1" }] }, Eae = { regex: "FinePower[_ ]?([AB][1-9]|[CD][1-9])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "FinePower[_ ]?([AB][1-9])(?:[);/ ]|$)", model: "$1", device: "tablet" }, { regex: "FinePower[_ ]?([CD][1-9])(?:[);/ ]|$)", model: "$1" }] }, Oae = { regex: "(?:FTJ17[AC]00|FTJ152[ABCD]|FTU18A00|FT141B|FT142D(?:_LTEXM)?|FT142A?|FTJ161[AB]|FTJ1[56]2E|FTJ162[BD]|FTE161[GE])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "FTJ152C", model: "Samurai Miyabi" }, { regex: "FTJ17A00(?:[);/ ]|$)", model: "Rei 2 Dual" }, { regex: "FTJ17C00(?:[);/ ]|$)", model: "Priori 5" }, { regex: "FTU18A00(?:[);/ ]|$)", model: "Cricket Wave" }, { regex: "FTJ161A", model: "Musashi" }, { regex: "FTE161E", model: "Ice 2" }, { regex: "FTE161G", model: "Ice 2 Plus" }, { regex: "FTJ162E", model: "Raijin" }, { regex: "FT141B", model: "Nico" }, { regex: "FT142D(?:_LTEXM)?(?:[);/ ]|$)", model: "XM" }, { regex: "FT142A?", model: "Priori 2" }, { regex: "FTJ152A", model: "Priori 3" }, { regex: "FTJ162D", model: "Priori 4" }, { regex: "FTJ152B", model: "Priori 3S LTE" }, { regex: "FTJ152D", model: "Samurai Kiwami" }, { regex: "FTJ162B", model: "Samurai Kiwami 2" }, { regex: "FTJ161B", model: "Samurai Rei" }, { regex: "FTJ152E", model: "Katana 1" }] }, Nae = { regex: "ZEEMI[ _-]", device: "smartphone", models: [{ regex: "ZEEMI[ _-]([^/;]+) Build", model: "$1" }, { regex: "ZEEMI[ _-]([^/;)]+)(?:[);/]|$)", model: "$1" }] }, Dae = { regex: "Z5007|Z551[679]|Z6001", device: "smartphone", models: [{ regex: "Z5517", model: "Leopardo" }, { regex: "Z6001", model: "Libelula" }, { regex: "Z5007", model: "Oso" }, { regex: "Z5519", model: "Pingûino" }, { regex: "Z5516", model: "Zebra" }] }, kae = { regex: "ZOPO|(?:ZOPO[_ ])?(Flash X3|ZP[0-9]{2,}[^/;]+)(?:\\)| Build)", device: "smartphone", models: [{ regex: "(?:ZOPO_C2_MOD|ZP998)(?:[);/ ]|$)", model: "C2 II" }, { regex: "ZOPO 9xxQuad(?:[);/ ]|$)", model: "9XX Quad" }, { regex: "(?:ZOPO_)?ZP980[+](?:[);/ ]|$)", model: "ZP980+" }, { regex: "(?:ZOPO_)?ZP980(?:[);/ ]|$)", model: "Scorpio" }, { regex: "ZP952(?:[);/ ]|$)", model: "Speed 7 Plus" }, { regex: "ZP951(?:[);/ ]|$)", model: "Speed 7" }, { regex: "ZP955(?:[);/ ]|$)", model: "Speed 8" }, { regex: "ZP950[+h]?(?:[);/ ]|$)", model: "Leader Max" }, { regex: "ZP(?:900H?|910)(?:[);/ ]|$)", model: "Leader" }, { regex: "ZP(?:800H|810)(?:[);/ ]|$)", model: "Libero HD" }, { regex: "ZP500[+]?(?:[);/ ]|$)", model: "Libero" }, { regex: "ZP330(?:[);/ ]|$)", model: "Color C" }, { regex: "ZP370(?:[);/ ]|$)", model: "Color S" }, { regex: "ZP5(63|86)(?:[);/ ]|$)", model: "Color X" }, { regex: "ZP567(?:[);/ ]|$)", model: "Color C5i" }, { regex: "ZP300[S+]?(?:[);/ ]|$)", model: "Field" }, { regex: "ZP200[+]?(?:[);/ ]|$)", model: "Shining" }, { regex: "ZP100(?:[);/ ]|$)", model: "Pilot" }, { regex: "ZP1790(?:[);/ ]|$)", model: "Flash X2" }, { regex: "ZP781(?:[);/ ]|$)", model: "Flash G5 Plus" }, { regex: "(?:ZOPO_)?(Flash X3|X1i|ZP[0-9]{2,}[^/;)]+)(?: Build|\\))", model: "$1" }] }, Gae = /* @__PURE__ */ JSON.parse('{"regex":"ZTE|AxonPhone|([a-z0-9]+)_USA_Cricket|(?:Blade (?:V0820|L110|L[2357]|L7A|S6|V[6789]|V8Q|V8 SE|V9 VITA|X7|A(310|460|465|475|520|530|602)|V580|V Ultra|Q Lux)|N9[15]8St|NX(?:403A|404H|406E|40[X2]|507J|503A|505J|506J|508J|510J|512J|511J|513J|521J|523J_V1|529J|531J|541J|5[48]9J|551J|563J|569[HJ]|573J|575J|59[157]J|60[1689]J|61[12679]J|62[79]J|65[19]J|907J)|N818S|N951[0579]|N91[38]0|N9101|N913[267]|N952[01]|N9560|N9810|N799D|[UV]9180|[UV]9815|Z(?:233V|331|5031O|559DL|6621O|667T|768G|792|81[25]|818L|82[08]|83[12359]|85[125]|851M|992|(557|71[67]|798|836|861|916)BL|986DL|(232|718|828)TL|(?:233|353|558|717|799|837|862|899|917|963)VL|955A|95[678]|965|97[018]|98[1237]|986U|999|936L)|V769M|Apex2|G (LTE|Lux)|Vec|Z959|V865M|Z3001S|902ZT|KIS II Max|Kis 3|K3DX-V5G|Z930L|Optus X|Blade[ _](A510|A[357] 2019-T|A6 MAX|A0622|X9)|Z3153V|Z836F|Nubia Z(?:9|11)|Ctyon-A9|602ZT|MO-01[JK]|Z963U|402ZT|P545|P609|dandelion|901ZT|A001ZT|Z-01K|UZTE V808|ZR01|ZTG01|K8[37]CA)(?:[);/ ]|$)","device":"smartphone","models":[{"regex":"602ZT(?:[);/ ]|$)","model":"Libero 2"},{"regex":"A001ZT(?:[);/ ]|$)","model":"Libero 3"},{"regex":"901ZT(?:[);/ ]|$)","model":"Libero S10"},{"regex":"ZR01(?:[);/ ]|$)","model":"Rakuten Big"},{"regex":"ZTG01(?:[);/ ]|$)","model":"A1"},{"regex":"A7020(?:[);/ ]|$)","model":"Blade A7s (2020)"},{"regex":"ZTE 2050(?:RU)?","model":"Blade 20 Smart"},{"regex":"902ZT(?:[);/ ]|$)","model":"Axon 10 Pro 5G"},{"regex":"N799D(?:[);/ ]|$)","model":"Blade Eg"},{"regex":"Z818L(?:[);/ ]|$)","model":"Allstar"},{"regex":"Z3001S(?:[);/ ]|$)","model":"Quest Plus"},{"regex":"Ctyon-A9(?:[);/ ]|$)","model":"Ctyon A9"},{"regex":"K3DX-V5G(?:[);/ ]|$)","model":"V5G"},{"regex":"N918St(?:[);/ ]|$)","model":"V5S"},{"regex":"N958St(?:[);/ ]|$)","model":"V5 Max"},{"regex":"N9101(?:[);/ ]|$)","model":"Imperial"},{"regex":"Z963U(?:[);/ ]|$)","model":"Imperial Max"},{"regex":"N9120(?:[);/ ]|$)","model":"Avid"},{"regex":"N9130(?:[);/ ]|$)","model":"Speed"},{"regex":"N9132(?:[);/ ]|$)","model":"Prestige"},{"regex":"N9136(?:[);/ ]|$)","model":"Prestige 2"},{"regex":"N9137(?:[);/ ]|$)","model":"Tempo X"},{"regex":"N9180(?:[);/ ]|$)","model":"V5"},{"regex":"N9510(?:[);/ ]|$)","model":"Warp 4G"},{"regex":"N9517(?:[);/ ]|$)","model":"Blade Force"},{"regex":"Z559DL(?:[);/ ]|$)","model":"Blade T2"},{"regex":"402ZT(?:[);/ ]|$)","model":"Blade Q+"},{"regex":"Blade Q Lux(?:[);/ ]|$)","model":"Blade Q Lux"},{"regex":"N9515(?:[);/ ]|$)","model":"Warp Sync"},{"regex":"N9519(?:[);/ ]|$)","model":"Warp 7"},{"regex":"N9520(?:[);/ ]|$)","model":"Boost Max"},{"regex":"N9521(?:[);/ ]|$)","model":"Boost Max+"},{"regex":"N9560(?:[);/ ]|$)","model":"Max XL"},{"regex":"N9810(?:[);/ ]|$)","model":"Vital"},{"regex":"NX40[X2](?:[);/ ]|$)","model":"Nubia Z5 Mini"},{"regex":"NX(403[AE]|406E|404H)(?:[);/ ]|$)","model":"Nubia Z5S Mini"},{"regex":"NX503A(?:[);/ ]|$)","model":"Nubia Z5S"},{"regex":"NX506J(?:[);/ ]|$)","model":"Nubia Z7"},{"regex":"NX507J(?:[);/ ]|$)","model":"Nubia Z7 Mini"},{"regex":"NX505J(?:[);/ ]|$)","model":"Nubia Z7 Max"},{"regex":"NX508J(?:[);/ ]|$)","model":"Nubia Z9"},{"regex":"(NX5[12]1J|Nubia Z9 mini)(?:[);/ ]|$)","model":"Nubia Z9 Mini"},{"regex":"(NX510J|Nubia Z9 Max)(?:[);/ ]|$)","model":"Nubia Z9 Max"},{"regex":"NX512J(?:[);/ ]|$)","model":"Nubia Z9 Max Dual"},{"regex":"NX531J(?:[);/ ]|$)","model":"Nubia Z11"},{"regex":"NX523J_V1","model":"Nubia Z11 Max"},{"regex":"(?:NX549J|Nubia Z11 mini S)(?:[);/ ]|$)","model":"Nubia Z11 Mini S"},{"regex":"(?:NX529J|Nubia Z11 mini)(?:[);/ ]|$)","model":"Nubia Z11 Mini"},{"regex":"NX606J(?:[);/ ]|$)","model":"Nubia Z18"},{"regex":"NX616J(?:[);/ ]|$)","model":"Nubia Z18S"},{"regex":"NX611J(?:[);/ ]|$)","model":"Nubia Z18 Mini"},{"regex":"NX551J(?:[);/ ]|$)","model":"Nubia M2"},{"regex":"NX563J(?:[);/ ]|$)","model":"Nubia Z17"},{"regex":"NX569[HJ](?:[);/ ]|$)","model":"Nubia Z17 Mini"},{"regex":"NX589J(?:[);/ ]|$)","model":"Nubia Z17 Mini S"},{"regex":"NX591J(?:[);/ ]|$)","model":"Nubia Z17 Lite"},{"regex":"NX595J(?:[);/ ]|$)","model":"Nubia Z17S"},{"regex":"NX612J(?:[);/ ]|$)","model":"Nubia V18"},{"regex":"NX627J","model":"Nubia Z20"},{"regex":"NX513J(?:[);/ ]|$)","model":"Nubia My Prague"},{"regex":"NX601J(?:[);/ ]|$)","model":"Nubia X6"},{"regex":"NX609J(?:[);/ ]|$)","model":"Nubia Red Magic"},{"regex":"NX659J(?:[);/ ]|$)","model":"Nubia Red Magic 5G"},{"regex":"NX651J(?:[);/ ]|$)","model":"Nubia Play"},{"regex":"NX619J(?:[);/ ]|$)","model":"Nubia Red Magic Mars"},{"regex":"NX629J(?:[);/ ]|$)","model":"Nubia Red Magic 3"},{"regex":"NX573J","model":"Nubia M2 Lite"},{"regex":"NX907J(?:[);/ ]|$)","model":"Nubia M2 Play"},{"regex":"NX541J","model":"Nubia N1"},{"regex":"NX597J","model":"Nubia N1 Lite"},{"regex":"NX575J","model":"Nubia N2"},{"regex":"NX6(08|17)J(?:[);/ ]|$)","model":"Nubia N3"},{"regex":"[UV]9180(?:[);/ ]|$)","model":"V5 Red Bull"},{"regex":"[UV]9815(?:[);/ ]|$)","model":"Grand Memo LTE"},{"regex":"V779M","model":"Joey Jump 2"},{"regex":"V807","model":"Blade C"},{"regex":"V809","model":"Blade C2"},{"regex":"ZTE_Blade_C2_Plus","model":"Blade C2 Plus"},{"regex":"Blade G Plus","model":"Blade G Plus"},{"regex":"ZTE_Blade_III","model":"Blade III"},{"regex":"(?:ZTE_)?V829","model":"Blade G Pro"},{"regex":"V882","model":"Lord"},{"regex":"V967S","model":"Grand X2"},{"regex":"V970M?|V987","model":"Grand X"},{"regex":"Z959(?:[);/ ]|$)","model":"Grand X3"},{"regex":"V8000","model":"Nova 4"},{"regex":"Z95[67]","model":"Grand X4"},{"regex":"Z987","model":"Grand X Max+"},{"regex":"(?:ZTE_)?Grand[ _]Era","model":"Grand Era"},{"regex":"V788D","model":"Kis Plus"},{"regex":"Z331(?:[);/ ]|$)","model":"Z331"},{"regex":"N818S(?:[);/ ]|$)","model":"N818S"},{"regex":"Z5031O(?:[);/ ]|$)","model":"Optus X Spirit 2"},{"regex":"P545(?:[);/ ]|$)","model":"Optus X Power 2"},{"regex":"P609(?:[);/ ]|$)","model":"Optus X Wave"},{"regex":"Optus X Start(?:[);/ ]|$)","model":"Optus X Start"},{"regex":"BA520(?:[);/ ]|$)","model":"Blade A520"},{"regex":"Blade (A(0620|310|321|452|460|462|465|475|510|512|52[012]|530|531|602|612|910)|L[12]10|L130|V0730|V0800|V580|V1000)(?:[);/ ]|$)","model":"Blade $1"},{"regex":"Blade L2 Plus(?:[);/ ]|$)","model":"Blade L2 Plus"},{"regex":"(?:ZTE_)?Blade[ _]L2(?:[);/ ]|$)","model":"Blade L2"},{"regex":"Blade L3 Plus(?:[);/ ]|$)","model":"Blade L3 Plus"},{"regex":"Blade L3 Apex(?:[);/ ]|$)","model":"Blade L3 Apex"},{"regex":"Blade L3(?:[);/ ]|$)","model":"Blade L3"},{"regex":"Blade L5 Plus(?:[);/ ]|$)","model":"Blade L5 Plus"},{"regex":"Blade L5(?:[);/ ]|$)","model":"Blade L5"},{"regex":"Blade L6(?:[);/ ]|$)","model":"Blade L6"},{"regex":"Blade L7A(?:[);/ ]|$)","model":"Blade L7A"},{"regex":"Blade L7(?:[);/ ]|$)","model":"Blade L7"},{"regex":"Blade L8(?:RU)?(?:[);/ ]|$)","model":"Blade L8"},{"regex":"Blade A([357]) (20(?:19|20))","model":"Blade A$1 ($2)"},{"regex":"Blade A3 Lite(?:[);/ ]|$)","model":"Blade A3 Lite"},{"regex":"BLADE A0622(?:[);/ ]|$)","model":"Blade A6"},{"regex":"BLADE A6 MAX(?:[);/ ]|$)","model":"Blade A6 Max"},{"regex":"Blade S6 Plus(?:[);/ ]|$)","model":"Blade S6 Plus"},{"regex":"Blade S6(?:[);/ ]|$)","model":"Blade S6"},{"regex":"T920(?:[);/ ]|$)","model":"Blade S7"},{"regex":"BLADE V Ultra(?:[);/ ]|$)","model":"Blade V Ultra"},{"regex":"Blade V6 MAX(?:[);/ ]|$)","model":"Blade V6 Max"},{"regex":"Blade V6 Plus(?:[);/ ]|$)","model":"Blade V6 Plus"},{"regex":"Blade (?:V7 Lite|V0720)(?:[);/ ]|$)","model":"Blade V7 Lite"},{"regex":"Blade V([67])(?:[);/ ]|$)","model":"Blade V$1"},{"regex":"Blade X([79])(?:[);/ ]|$)","model":"Blade X$1"},{"regex":"Blade V8Q(?:[);/ ]|$)","model":"Blade V8Q"},{"regex":"Blade V8 SE(?:[);/ ]|$)","model":"Blade V8 SE"},{"regex":"Blade V(9|10) Vita(?:[);/ ]|$)","model":"Blade V$1 Vita"},{"regex":"Blade V([89]|10)(?:[);/ ]|$)","model":"Blade V$1"},{"regex":"BLADE V0820(?:[);/ ]|$)","model":"Blade V8 Lite"},{"regex":"BLADE V0850(?:[);/ ]|$)","model":"Blade V8 Mini"},{"regex":"(?:Blade[ _])?(Apex2|G (LTE|Lux)|Vec|A510)","model":"Blade $1"},{"regex":"Z768G(?:[);/ ]|$)","model":"Midnight"},{"regex":"Z820","model":"Obsidian"},{"regex":"Z986U","model":"Blade Max 3"},{"regex":"Z971","model":"Blade Spark"},{"regex":"Z978","model":"Blade V8 Pro"},{"regex":"Z839","model":"Blade Vantage"},{"regex":"Z3153V","model":"Blade Vantage 2"},{"regex":"Z930L","model":"Unico LTE"},{"regex":"Z965","model":"Blade X"},{"regex":"Z981","model":"Blade Z Max Pro"},{"regex":"Z982","model":"Blade Z Max"},{"regex":"Z983","model":"Blade X Max"},{"regex":"Z717[BV]L(?:[);/ ]|$)","model":"Citrine LTE"},{"regex":"Z233VL(?:[);/ ]|$)","model":"Cymbal-C LTE"},{"regex":"Z233V","model":"Cymbal LTE"},{"regex":"Z232TL","model":"Cymbal-G LTE"},{"regex":"Z353VL","model":"Cymbal-T LTE"},{"regex":"Z718TL","model":"Jasper LTE"},{"regex":"KIS II Max","model":"Kis II Max"},{"regex":"Kis 3","model":"Kis 3"},{"regex":"(?:Z798BL|Z799VL)(?:[);/ ]|$)","model":"Majesty Pro LTE"},{"regex":"Z899VL","model":"Majesty Pro Plus LTE"},{"regex":"Z828TL","model":"Midnight Pro LTE"},{"regex":"(?:ZTE-)?Z792","model":"Fanfare"},{"regex":"(?:ZTE-)?Z812","model":"Maven"},{"regex":"Z815","model":"Fanfare 2"},{"regex":"Z831","model":"Maven 2"},{"regex":"Z832","model":"Sonata 3"},{"regex":"Z835","model":"Maven 3"},{"regex":"Z851(?:[);/ ]|$)","model":"Prelude Plus"},{"regex":"Z851M","model":"Overture 3"},{"regex":"Z852","model":"Fanfare 3"},{"regex":"Z828","model":"Avid Plus"},{"regex":"Z855","model":"Avid 4"},{"regex":"Z833","model":"Avid TRIO"},{"regex":"(?:Z836BL|Z837VL|Z836F)(?:[);/ ]|$)","model":"ZFive 2 LTE"},{"regex":"Z558VL","model":"ZFive C LTE"},{"regex":"Z557BL","model":"ZFive G LTE"},{"regex":"(?:Z861BL|Z862VL)(?:[);/ ]|$)","model":"ZFive L LTE"},{"regex":"Z916BL","model":"ZMax Grand LTE"},{"regex":"Z917VL","model":"ZMax Champ LTE"},{"regex":"(?:Z958|Z955A)(?:[);/ ]|$)","model":"ZMax 2"},{"regex":"dandelion(?:[);/ ]|$)","model":"ZMax 3"},{"regex":"Z963VL","model":"Max Duo LTE"},{"regex":"Z970","model":"ZMax Z970"},{"regex":"Z986DL","model":"MAX Blue LTE"},{"regex":"(?:ZTE[-_])?Z992","model":"Avail 2"},{"regex":"(?:Z999|Z-01K)(?:[);/ ]|$)","model":"Axon M"},{"regex":"B2016","model":"Axon Mini"},{"regex":"A2015","model":"Axon Tianji"},{"regex":"A2017[GU]?","model":"Axon 7"},{"regex":"A2018","model":"Axon 7s"},{"regex":"A2019G Pro","model":"Axon Pro"},{"regex":"B2017G","model":"Axon 7 Mini"},{"regex":"A2020G? Pro(?:[);/ ]|$)","model":"Axon 10 Pro"},{"regex":"Z667T","model":"Zinger"},{"regex":"V?975|geek","model":"Geek"},{"regex":"Z716BL","model":"Citrine LTE"},{"regex":"X500","model":"Score"},{"regex":"X501","model":"Groove"},{"regex":"(?:ZTE-)?G-X991","model":"Rio"},{"regex":"F-450","model":"Adamant"},{"regex":"Z936L(?:[);/ ]|$)","model":"Lever"},{"regex":"MO-01[JK](?:[);/ ]|$)","model":"Mono"},{"regex":"V865M(?:[);/ ]|$)","model":"V865M"},{"regex":"Z6621O(?:[);/ ]|$)","model":"Optus X Vista"},{"regex":"V769M(?:[);/ ]|$)","model":"Leo Q2"},{"regex":"K83CA(?:[);/ ]|$)","device":"tablet","model":"Grand X View 3"},{"regex":"K87CA(?:[);/ ]|$)","device":"tablet","model":"Grand X View 4"},{"regex":"AxonPhone ([^;/]+) Build","model":"AxonPhone $1"},{"regex":"([a-z0-9]+)_USA_Cricket","model":"$1"},{"regex":"ZTE[- ](V98|V96A|V81|V70)(?:[);/ ]|$)","model":"$1","device":"tablet"},{"regex":"ZTE[- ]([a-z0-9\\\\-_ ]+) Build","model":"$1"},{"regex":"ZTE-(?:G |G-)?([a-z0-9 _]+)","model":"$1"},{"regex":"U?ZTE[ _]([a-z0-9]+)","model":"$1"}]}'), Bae = { regex: "Zuum[ _-]|(?:Akus Z|COVET|MAGNO|ONIX S|STEDI|STELLAR(?:[ _](?:Z|PRO|[MP]1))?|GRAVITY Z|AURA X|COVET_PRO_LITE|RONI)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Akus Z", model: "Akus Z" }, { regex: "COVET_PRO_LITE", model: "Covet Pro Lite" }, { regex: "COVET PRO", model: "Covet Pro" }, { regex: "COVET( Z)?", model: "Covet$1" }, { regex: "MAGNO PLUS", model: "Magno Plus" }, { regex: "MAGNO( C)?", model: "Magno$1" }, { regex: "ONIX S", model: "Onix S" }, { regex: "STEDI", model: "Stedi" }, { regex: "STELLAR PRO", model: "Stellar Pro" }, { regex: "STELLAR PLUS", model: "Stellar Plus" }, { regex: "STELLAR ([MP]1|Z)", model: "Stellar $1" }, { regex: "STELLAR MINI", model: "Stellar Mini" }, { regex: "STELLAR MINI", model: "Stellar Mini" }, { regex: "STELLAR", model: "Stellar" }, { regex: "GRAVITY Z", model: "Gravity Z" }, { regex: "AURA X", model: "Aura X" }, { regex: "RONI", model: "Roni" }, { regex: "Zuum[ _-]([^;/]+) Build", model: "$1" }, { regex: "Zuum[ _-]?([^;/)]+)(?:[);/ ]|$)", model: "$1" }] }, Iae = { regex: "(Admire[_ ][^/;]+|Cinemax[^/;)]+)(?:Build|\\))|AdmireGlam", device: "smartphone", models: [{ regex: "AdmireGlam(?:[);/ ]|$)", model: "Admire Glam" }, { regex: "(Admire[_ ][^/;]+|Cinemax[^/;)]+)(?:Build|\\))", model: "$1" }] }, Rae = { regex: "ZYNC|(Cloud Z5|Z1000|Z18|Z99|Z99[_ ][23]G|Z99|Z900[_ ]Plus|Z909|Z930[+]|Z930)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(Z18| DuZ99al Core|Z99[_ ][23]G|Z99 Dual Core|Z99|Z900[_ ]Plus|Z909|Z930[+]|Z930)", model: "$1" }, { regex: "(Z1000[^/;]+)Build", model: "$1" }, { regex: "Cloud (Z5)", model: "Cloud $1" }, { regex: "ZYNC Cloud[ _]([^;]+)Build", model: "Cloud $1" }, { regex: "ZYNC[ _]([^;]+)Build", model: "$1" }] }, Fae = { regex: "Lemhoov", device: "smartphone", models: [{ regex: "Lemhoov[ _-]([^/;]+) Build", model: "$1" }] }, Vae = { regex: "MTC[ _](968|97[82]|970|982[OT]?|1078)|(?:MTC[_ ])?SMART[ _]?(?:Race[2]?|Sprint|Run|Surf[2]?)[ _]4G|MTC975|Smart_(?:LINE|Light)|MTC[ _]SMART[ _](?:Run|Start_2)|Redbox Mini 5\\(MTS\\)", device: "smartphone", models: [{ regex: "MTC[ _]?(97[258]|970[H]?|982[OT]?|968)", model: "$1" }, { regex: "MTC[ _](1078)", model: "$1", device: "tablet" }, { regex: "SMART[ _]Race[ _]4G", model: "Smart Race 4G" }, { regex: "SMART[ _]Race2[ _]4G", model: "Smart Race 2 4G" }, { regex: "(?:MTC_)?SMART[ _]Sprint[ _]4G", model: "Smart Sprint 4G" }, { regex: "(?:MTC_)?SMART[ _]Start_2", model: "Smart Start 2" }, { regex: "Smart_LINE", model: "Smart Line" }, { regex: "Smart_Light", model: "Smart Light" }, { regex: "SMART[ _]?Run(?:[ _]4G)?", model: "Smart Run 4G" }, { regex: "SMART[ _]Surf2[ _]4G", model: "Smart Surf 2 4G" }, { regex: "SMART[ _]Surf[ _]4G", model: "Smart Surf 4G" }, { regex: "Redbox Mini 5\\(MTS\\)", device: "tv", model: "Redbox Mini 5" }] }, Hae = { regex: "MegaFon|MFLoginPh|MegLogPh|(MFLogin[34]T?|MS3B|SP-A5|SP-A20i)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "MFLoginPh|MegLogPh", model: "Login+" }, { regex: "MFLogin4", model: "Login 4 LTE" }, { regex: "MFLogin3T|MegaFon Login 3", model: "Login 3", device: "tablet" }, { regex: "MS3B|Megafon Optima", model: "Optima" }, { regex: "SP-A20i", model: "Mint" }, { regex: "(SP-A5)", model: "$1" }] }, Uae = { regex: "INOI", device: "smartphone", models: [{ regex: "INOI 2 Lite 2019", model: "2 Lite (2019)" }, { regex: "INOI ([257]) (2019|202[01])(?:[);/ ]|$)", model: "$1 ($2)" }, { regex: "INOI[_ ]([^);/]+)(?: Build|[;)])", model: "$1" }] }, Xae = { regex: "(?:Luck|Lion_Dual|V709X|Tab [43]G (?:7-2|8-1|10-1)|Pro_P3[01]0_4G|Lion_DC|Baccara|Eagle[ _]4G|ImpressMAX)(?:[);/ ]|$)|Impress[ _]([^;/]+)(?:Build|\\))", device: "smartphone", models: [{ regex: "(Lion_Dual|Lion_DC|Baccara|Eagle[ _]4G|Luck)(?:[);/ ]|$)", model: "$1" }, { regex: "ImpressMAX(?:[);/ ]|$)", model: "Impress Max" }, { regex: "Pro_P(3[01]0)_4G(?:[);/ ]|$)", model: "Pro P$1 4G" }, { regex: "(Impress[ _]([^;/]+))(?:Build|\\))", model: "$1" }, { regex: "(V709X)", device: "tablet", model: "$1" }, { regex: "Tab ([43])G ([78]|10)-([21])", device: "tablet", model: 'Tab $1G $2.$3"' }] }, Wae = { regex: "WebTV/(\\d+\\.\\d+)", device: "tv", model: "Web TV" }, Yae = { regex: "Andromeda[ _]S(707|84[05]|850|8)(?:[);/ ]|$)", device: "tablet", model: "Andromeda S$1" }, Kae = { regex: " (TB-PO1|TB-B01|TB-G01)(?:[);/ ]|$)", device: "tv", model: "$1" }, Qae = { regex: "TangoTab|Presto[ )]|Ultimax|Valumax|S72-B|SX2W", device: "tablet", models: [{ regex: "TangoTab", model: "TangoTab" }, { regex: "Ultimax", model: "Ultimax" }, { regex: "Valumax", model: "Valumax" }, { regex: "Presto", model: "Presto" }, { regex: "S72-B", model: "S72-B" }, { regex: "SX2W", model: "SX2W" }] }, jae = { regex: "MYPAD7s", device: "tablet", model: "My Pad 7s" }, Zae = { regex: "(LA2-(?:L|S[N]?)|HLA Note3|20190416Q|20170608S|20180322D)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "HLA Note3(?:[);/ ]|$)", model: "Red Pepper Note 3" }, { regex: "(LA2-(?:L|S[N]?))(?:[);/ ]|$)", model: "$1" }, { regex: "(20190416Q)(?:[);/ ]|$)", model: "$1" }, { regex: "20170608S(?:[);/ ]|$)", model: "Red Pepper Plus" }, { regex: "20180322D(?:[);/ ]|$)", model: "E Sports" }] }, zae = { regex: "(RMD[-_](?:10(?:2[689]|30|5[089])|1121|75[017]|726|85[57]|870)|RMP-(?:450|50[56]|530|600))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "RMD[-_](10(?:2[689]|30|5[089])|1121|75[017]|726|85[57]|870)(?:[);/ ]|$)", model: "RMD-$1" }, { regex: "RMP[-_](450|50[56]|530|600)(?:[);/ ]|$)", model: "RMP-$1", device: "smartphone" }] }, qae = { regex: "(MXQ|MXQ-Pro)-NEXBOX|NEXBOX-([^) ]+)", device: "tv", models: [{ regex: "MXQ-Pro-NEXBOX", model: "MXQ Pro" }, { regex: "MXQ-NEXBOX", model: "MXQ" }, { regex: "NEXBOX-([^) ]+)", model: "$1" }] }, Jae = { regex: " TRUE BEYOND TAB 3G|SMART[ _](MAX 4.0 PLUS|4G[ _](?:GEN C [45].[05]|Champion|Speedy 5.0 Plus|Speedy[_ ]5inch|P1))", device: "smartphone", models: [{ regex: "SMART MAX 4.0 PLUS", model: "Smart Max 4.0 Plus" }, { regex: "SMART 4G Gen C ([45].[05])", model: 'Smart 4G Gen C $1"' }, { regex: "SMART 4G Speedy 5.0 Plus", model: "Smart 4G Speedy 5.0 Plus" }, { regex: "SMART[ _]4G[_ ]Speedy[_ ]5inch", model: "Smart 4G Speedy 5" }, { regex: "SMART[ _]4G[_ ]Champion", model: "Smart 4G Champion" }, { regex: "SMART[ _]4G[_ ]P1 Prime", model: "Smart 4G P1 Prime" }, { regex: "SMART[ _]4G[_ ]P1", model: "Smart 4G P1" }, { regex: "TRUE BEYOND TAB 3G", model: "Beyond Tab 3G" }] }, ele = { regex: "(YNDX-?000SB)(?:[);/ ]|$)", device: "smartphone", model: "YNDX-000SB" }, tle = { regex: "FORME[ _-]", device: "smartphone", models: [{ regex: "FORME[ _-]F520(?:[);/ ]|$)", model: "Forever" }, { regex: "FORME[ _-](A[35]7|R7S?|P6)(?:[);/ ]|$)", model: "$1" }] }, rle = { regex: "(PNT-704[025])(?:[);/ ]|$)", device: "tablet", model: "$1" }, ole = { regex: "(BDF[- ](?:819|P10|K107H|KT107|MT6753|X20)|K960N_MT(?:6580|6753)(?:_32_N)?)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "BDF[- ](819|P10|K107H|KT107|MT6753|X20)(?:[);/ ]|$)", model: "$1" }, { regex: "K960N_MT(6580|6753)(_32_N)?(?:[);/ ]|$)", model: "BK960N MT$1" }] }, nle = { regex: "HIGHSCREEN|(Easy[- ]Power(?:[- ]Pro)?|Pure[_ ](?:Power|F)|Power Ice(?: Max)?|Easy[_ ]([SFL]|XL)(?:_Pro)?|Razar_Pro|Power Rage(?: Evo)?|Zera-S-Power|Zera[ _][UFS]|Power[ _]?Five[ matrixstyle _]?(?:Pro|Evo|Max|Max(?:Lite|2))|PowerFour|BOOST II(?:se)?|Fest(?:XL)?(?:-Pro)?|Tasty|Boost3|Boost 3(?: Pro)? SE|Expanse|Hercules|Alpha Rage|VergeM)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(Power Ice(?:[ ](?:Max|Evo))?|Power Rage(?: Evo)?|Zera[ _][UFS])(?:[);/ ]|$)", model: "$1" }, { regex: "PowerFivePro(?:[);/ ]|$)", model: "Power Five Pro" }, { regex: "PowerFiveMaxLite(?:[);/ ]|$)", model: "Power Five Max Lite" }, { regex: "PowerFiveMax2(?:[);/ ]|$)", model: "Power Five Max 2" }, { regex: "Power Five Evo(?:[);/ ]|$)", model: "Power Five Evo" }, { regex: "Power Five Max(?:[);/ ]|$)", model: "Power Five Max" }, { regex: "FestXL-Pro(?:[);/ ]|$)", model: "Fest XL Pro" }, { regex: "FestXL(?:[);/ ]|$)", model: "Fest XL" }, { regex: "Fest-Pro(?:[);/ ]|$)", model: "Fest Pro" }, { regex: "Fest(?:[);/ ]|$)", model: "Fest" }, { regex: "PowerFour(?:[);/ ]|$)", model: "Power Four" }, { regex: "Pure[_ ]Power(?:[);/ ]|$)", model: "Pure Power" }, { regex: "Pure[ _]F(?:[);/ ]|$)", model: "Pure F" }, { regex: "Razar_Pro(?:[);/ ]|$)", model: "Razar Pro" }, { regex: "Easy[_ ]([SLF]|XL)[_ ]Pro(?:[);/ ]|$)", model: "Easy $1 Pro" }, { regex: "Easy[_ ]([SFL]|XL)(?:[);/ ]|$)", model: "Easy $1" }, { regex: "(?:HIGHSCREEN )?Easy[- ]Power[- ]Pro(?:[);/ ]|$)", model: "Easy Power Pro" }, { regex: "(?:HIGHSCREEN )?Easy-Power(?:[);/ ]|$)", model: "Easy Power" }, { regex: "BOOST II(?:[);/ ]|$)", model: "Boost 2" }, { regex: "BOOST IIse(?:[);/ ]|$)", model: "Boost 2 SE" }, { regex: "Boost 3 SE(?:[);/ ]|$)", model: "Boost 3 SE" }, { regex: "Boost 3 Pro SE(?:[);/ ]|$)", model: "Boost 3 Pro SE" }, { regex: "BOOST3(?:[);/ ]|$)", model: "Boost 3" }, { regex: "Zera-S-Power(?:[);/ ]|$)", model: "Zera S Power" }, { regex: "Tasty(?:[);/ ]|$)", model: "Tasty" }, { regex: "VergeM(?:[);/ ]|$)", model: "Verge M" }, { regex: "WinWin(?:[);/ ]|$)", model: "WinWin" }, { regex: "Expanse(?:[);/ ]|$)", model: "Expanse" }, { regex: "Hercules(?:[);/ ]|$)", model: "Hercules" }, { regex: "Alpha Rage(?:[);/ ]|$)", model: "Alpha Rage" }] }, ale = { regex: "CVTE[_ ](MSD338_(:?1G|512M))(?:[);/ ]|$)", device: "tv", model: "$1" }, lle = { regex: "(GU1011C|GU8012C|GU7013C|GU730C|GU-6012B)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "GU8012C(?:[);/ ]|$)", model: "X8" }, { regex: "GU-6012B(?:[);/ ]|$)", model: "GU6012B" }, { regex: "(GU1011C|GU7013C|GU730C)(?:[);/ ]|$)", model: "$1" }] }, ile = { regex: "ATOM-(108AM|216RK|216AM)(?:[);/ ]|$)", device: "tv", model: "$1" }, sle = { regex: "QUMO[ _]?|(?:Quest[ _]?(?:408|410|45[56]|50[679])|Vega[ _]?78[23]|Sirius[ _]?(?:1001|890))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(?:QUMO[ _]?)?Vega[ _]?(78[23]|8002)(?:[);/ ]|$)", model: "Vega $1" }, { regex: "Yooda(?:[);/ ]|$)", model: "Yooda" }, { regex: "Sirius[ _]?(1001|890)(?:[);/ ]|$)", model: "Sirius $1" }, { regex: "(?:QUMO)?(Sirius 101-4G 8GB Black|Altair 701 8GB Black|Altair 71 4GB Black|Altair 700[24]|Altair 706)(?:[);/ ]|$)", model: "$1" }, { regex: "(?:QUMO[ _])?Quest[ _]?(35[34]|40[268]|410|45[2568]|47[46]|50[679]|5[17]0|600)(?:[);/ ]|$)", device: "smartphone", model: "Quest $1" }] }, dle = { regex: "VisionBook[ _]|[78]Qa_3G(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(VisionBook[ _](?:10Qi|7Q[i]?|8Q[ei]?|P70|8Qi_3G)(?:[ _](?:[34]G|Plus|LTE))?)(?:[);/ ]|$)", model: "$1" }, { regex: "([78])Qa_3G(?:[);/ ]|$)", model: "VisionBook $1Qa 3G" }, { regex: "VisionBook_10Q_LTE(?:[);/ ]|$)", model: "VisionBook 10Q LTE" }, { regex: "VisionBook_P50Plus_LTE(?:[);/ ]|$)", device: "smartphone", model: "VisionBook P50 Plus LTE" }, { regex: "(VisionBook[ _](?:P50 LTE|P55 X2 LTE|P55 LTE(?: Pro)?))(?:[);/ ]|$)", device: "smartphone", model: "$1" }] }, ule = { regex: "(ZUG 3|ZUG 5S(?: Q)?)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, cle = { regex: "(Titan|Jelly-Pro|Atom_X?L)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(Jelly)-(Pro)(?:[);/ ]|$)", model: "$1 $2" }, { regex: "(Titan|Atom_X?L)(?:[);/ ]|$)", model: "$1" }] }, mle = { regex: "(?:CW-(Hi8-super|Hi12|V99i?|V17HD3G|VX8-3G|V88-QUAD|V9-DUAL|V88S|Vi[78]|[HV]i10 (?:pro|plus))|Hi10 (?:Pro|plus)|HiPad X|HiBox-hero|HiBook(?: pro)?|Hi[89] ?(?:Air|Pro)|Hi8SE|Vi10(?: ?Pro)?)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(CW-Hi8-super)(?:[);/ ]|$)", model: "Hi8" }, { regex: "(?:CW-)?(Vi10|Hi10) plus(?:[);/ ]|$)", model: "$1 Plus" }, { regex: "CW-(V88)-QUAD(?:[);/ ]|$)", model: "$1 Quad" }, { regex: "CW-(V9)-DUAL(?:[);/ ]|$)", model: "$1 Dual" }, { regex: "CW-(V17HD|VX8)-?(3G)(?:[);/ ]|$)", model: "$1 $2" }, { regex: "(?:CW-)?(Hi10) pro(?:[);/ ]|$)", model: "$1 Pro" }, { regex: "HiBook pro(?:[);/ ]|$)", model: "HiBook Pro" }, { regex: "HiBook(?:[);/ ]|$)", model: "HiBook" }, { regex: "HiPad X(?:[);/ ]|$)", model: "HiPad X" }, { regex: "Hi([89]) ?Air(?:[);/ ]|$)", model: "Hi$1 Air" }, { regex: "Hi8SE(?:[);/ ]|$)", model: "Hi8 SE" }, { regex: "Hi([89]) ?pro(?:[);/ ]|$)", model: "Hi$1 Pro" }, { regex: "Vi10 Plus(?:[);/ ]|$)", model: "Vi10 Plus" }, { regex: "Vi10 ?Pro(?:[);/ ]|$)", model: "Vi10 Pro" }, { regex: "Vi10(?:[);/ ]|$)", model: "Vi10" }, { regex: "HiBox-hero(?:[);/ ]|$)", model: "HiBox Hero", device: "desktop" }, { regex: "CW-(Vi[78]|Hi12|V99i?|V88S)(?:[);/ ]|$)", model: "$1" }] }, gle = { regex: "BEZKAM (BK-RAM2)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, fle = { regex: "(KATV-01) PRO(?:[);/ ]|$)", device: "tv", model: "$1 Pro" }, ple = { regex: "GHONG(V10)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, hle = { regex: "(?:TelePAD(?:795|731|1032|10A3|7A3)|Era 2X|HMT(?:390Q?|400)|HST 260)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "TelePAD(7|10)A3 4G(?:[);/ ]|$)", model: "TelePad $1 A3 4G" }, { regex: "TelePAD(795|731|1032)(?:[);/ ]|$)", model: "TelePad $1" }, { regex: "HMT(390Q?|400)(?:[);/ ]|$)", model: "HMT $1", device: "portable media player" }, { regex: "HST 260(?:[);/ ]|$)", model: "HST 260", device: "tv" }, { regex: "(Era 2X)(?:[);/ ]|$)", model: "$1", device: "smartphone" }] }, xle = { regex: "VMP-(015-162|021-82|041-162|011-81|025-324|045-664)(?:[);/ ]|$)", device: "tv", models: [{ regex: "VMP-021-82", model: "021" }, { regex: "VMP-025-324", model: "025" }, { regex: "VMP-015-162", model: "015" }, { regex: "VMP-041-162", model: "041" }, { regex: "VMP-045-664", model: "045" }, { regex: "VMP-011-81", model: "011" }] }, vle = { regex: "SMART[_ ](EV[56])(?:[);/ ]|$)", device: "smartphone", model: "Smart $1" }, Sle = { regex: "Nuvo[_ ](NS35|Blue ND40|Green[_ ]ND[_ ]45)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Nuvo[_ ](NS35)(?:[);/ ]|$)", model: "$1" }, { regex: "Blue (ND40)(?:[);/ ]|$)", model: "$1" }, { regex: "Green[_ ]ND[_ ]45(?:[);/ ]|$)", model: "ND45" }] }, ble = { regex: "(?:T95ZPLUS|T95[KU]PRO)(?:[);/ ]|$)", device: "tv", models: [{ regex: "T95ZPLUS", model: "T95Z Plus" }, { regex: "(T95[KU])PRO", model: "$1 Pro" }] }, yle = { regex: "UGOOS-AM6(?:[);/ ]|$)", device: "tv", model: "AM6" }, wle = { regex: "YXTEL_([HU]1|U3)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, _le = { regex: "(H10882M-TN)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Tle = { regex: "(YD20[16]|YOTA 3[+])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "YD20[16](?:[);/ ]|$)", model: "Phone 2" }, { regex: "YOTA 3[+](?:[);/ ]|$)", model: "Phone 3 Plus" }] }, Ale = { regex: "MYSTERY|(MID-(?:123G|72[12]|7[01348]3G|753G|8[23]3G))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "MID-(123G|72[12]|7[01348]3G|753G|8[23]3G)(?:[);/ ]|$)", model: "MID-$1" }, { regex: "MYSTERY_TV_(D3155CH31)", device: "tv", model: "$1" }] }, Ple = { regex: "(RITZVIVA[_ ]S500C)(?:[);/ ]|$)", device: "smartphone", model: "S500C" }, Mle = { regex: "DeWalt (MD501)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, $le = { regex: "Runbo|F1-TT(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Runbo[ _-]?(X5-W|F1 Plus|F1-TT|F1-EN|F1|TT|Q5-S|X5-King|X6|Q5)(?:[);/ ]|$)", model: "$1" }, { regex: "F1-TT", model: "F1-TT" }] }, Cle = { regex: "(CarPad-(?:II|III)-P)(?:[);/ ]|$)", device: "car browser", model: "$1" }, Lle = { regex: "Newsday[_ ](E1|A[12])(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Ele = { regex: "Daewoo|(DTA-07IDRF)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(DTA-07IDRF)(?:[);/ ]|$)", model: "Archive 7P" }, { regex: "Daewoo (Android TV 638)(?:[);/ ]|$)", model: "$1", device: "tv" }] }, Ole = { regex: "VESTA32LD86(?:[);/ ]|$)", device: "tv", model: "SmartT V2.0 32LD86S" }, Nle = { regex: "(CARBONO_5|CUARZO_6|DIAMANTE_5|VULCANO_55)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "VULCANO_55(?:[);/ ]|$)", model: 'Vulcano 5.5"' }, { regex: "CARBONO_5(?:[);/ ]|$)", model: 'Carbono 5.0"' }, { regex: "CUARZO_6(?:[);/ ]|$)", model: 'Cuarzo 6.0"' }, { regex: "DIAMANTE_5(?:[);/ ]|$)", model: 'Diamante 5.0"' }] }, Dle = { regex: "(?:24H600G[RU]|24FR50WU|24HK30B|32HR55GU|4[39]UP50GU|40UR50G[RU]|40U600G[RU]|55U600G[RU]|65UP50GU|55U[PC]50G[RU]|50U600G[RU]|50UX10S|55UR50G[RU]|40FK30G|40FR50BR|43UK35G|50FK30G|50UK35G|32HR50GR|55UC30G|32HK30G|40FK30G|32HR50GU|43UK30G|32FR50(?:WR|BU)|32FK3[02]G)(?:_-Ver0[0-9])?(?:[);/ ]|$)", device: "tv", models: [{ regex: "(24H600G[RU]|24FR50WU|24HK30B|32HR55GU|4[39]UP50GU|40UR50G[RU]|40U600G[RU]|55U600G[RU]|65UP50GU|55U[PC]50G[RU]|50UX10S|50U600G[RU]|55UR50G[RU]|40FK30G|40FR50BR|43UK35G|50FK30G|50UK35G|32HR50GR|32FR50(?:WR|BU)|32FK3[02]G)(?:[);/ ]|$)", model: "$1" }, { regex: "(55UC30G|40FK30G|43UK30G|32HR50G[RU]|32HK30G|32FK32G)_-Ver0([0-9])(?:[);/ ]|$)", model: "$1 v$2" }] }, kle = { regex: "(Divisat)(?:[);/ ]|$)", device: "tv", models: [{ regex: "(J-Link)(?:[);/ ]|$)", model: "$1" }] }, Gle = { regex: "KJ-(OB03|YUBI)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "KJ-OB03(?:[);/ ]|$)", model: "Cata 7" }, { regex: "KJ-YUBI(?:[);/ ]|$)", model: "Yubi 3G" }] }, Ble = { regex: "KaiCloud[ ]?(7[48]4|942)(?:[);/ ]|$)", device: "tablet", model: "KaiCloud $1" }, Ile = { regex: "(NX-32THS100)(?:[);/ ]|$)", device: "tv", model: "$1" }, Rle = { regex: "(?:VSUN (?:ILLUSION|RACE|V9)|MARS TOUCH|MARS NOTE|MARS NOCAM|SATURN SELFIE)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ILLUSION(?:[);/ ]|$)", model: "Illusion" }, { regex: "MARS TOUCH(?:[);/ ]|$)", model: "Mars Touch" }, { regex: "MARS NOTE(?:[);/ ]|$)", model: "Mars Note" }, { regex: "MARS NOCAM(?:[);/ ]|$)", model: "Mars Nocam" }, { regex: "SATURN SELFIE(?:[);/ ]|$)", model: "Saturn Selfie" }, { regex: "RACE(?:[);/ ]|$)", model: "Race" }, { regex: "(V9)(?:[);/ ]|$)", model: "$1" }] }, Fle = { regex: "(RugGear|RG(?:310|500|65[05]|702|7[13]0|850))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(RG[0-9]+)(?:[);/ ]|$)", model: "$1" }] }, Vle = { regex: "ALIGATOR[_ ]", device: "smartphone", models: [{ regex: "ALIGATOR[ _](S4080|S50(?:6[56]|[678]0)|S5540|RX510|S6500|RX710|RX800|S5520)(?:[);/ ]|$)", model: "$1" }] }, Hle = { regex: "(MS(?:45[036]|505|514)|MS457(?:PLUS)?)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(MS457)PLUS(?:[);/ ]|$)", model: "$1 Plus" }, { regex: "MS(45[0367]|505|514)(?:[);/ ]|$)", model: "MS$1" }] }, Ule = { regex: "(?:LUNA[ _](?:V55|G[56]0)|TG-L800S)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "LUNA[ _](V55|G[56]0)(?:[);/ ]|$)", model: "$1" }, { regex: "(TG-L800S)(?:[);/ ]|$)", model: "$1" }] }, Xle = { regex: "PROTRULY[ _](D[78]|V10S)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Wle = { regex: "JFone[ _](JS501)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Yle = { regex: "(A101S)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Kle = { regex: "SOYES[ _]([67]S|XS)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Qle = { regex: "ZIDOO[ _](H6 Pro|X6 Pro|X9S|Z10|X[158]|X20 Pro|Z9S)(?:[);/ ]|$)", device: "tv", model: "$1" }, jle = { regex: "ZFINERY900(?:[);/ ]|$)", device: "tablet", model: "Y900" }, Zle = { regex: "SMART[_ ](G10[12]|S7[02]|G71|G81[H]?)(?:[);/ ]|$)", device: "tablet", model: "Smart $1" }, zle = { regex: "(LAMCY (?:L3[05]0|C100|L400)|IVA S6)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "LAMCY (L3[05]0|C100|L400)(?:[);/ ]|$)", model: "Lamcy $1" }, { regex: "IVA S6(?:[);/ ]|$)", model: "S6" }] }, qle = { regex: "(PHICOMM)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "C630 \\(CLUE L\\)(?:[);/ ]|$)", model: "Clue L" }, { regex: "E653\\(ENERGY L\\)(?:[);/ ]|$)", model: "Energy L" }, { regex: "PHICOMM ENERGY 3\\+(?:[);/ ]|$)", model: "Energy 3+" }, { regex: "CLUE (2S|M)(?:[);/ ]|$)", model: "Clue $1" }] }, Jle = { regex: "Huadoo[ _](HG0[46]|HG11|V[34])(?:[);/ ]|$)", device: "smartphone", model: "$1" }, eie = { regex: "(?:GOME[_ ](?:201[678].+|C7_Note(?:_Plus)?|U9|S[17])|Fenmmy_Note)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "GOME[_ ](?:2018X38A)(?:[);/ ]|$)", model: "C72" }, { regex: "GOME[_ ](?:2018X07A)(?:[);/ ]|$)", model: "C7" }, { regex: "GOME[_ ](?:2017X05A)(?:[);/ ]|$)", model: "C71" }, { regex: "GOME[_ ](?:2016G68A)(?:[);/ ]|$)", model: "K1" }, { regex: "GOME[_ ](?:2016M25A)(?:[);/ ]|$)", model: "U1" }, { regex: "GOME[_ ](?:2017M27A)(?:[);/ ]|$)", model: "U7" }, { regex: "GOME[_ ](C7_Note(?:_Plus)?|U9|S[17])(?:[);/ ]|$)", model: "$1" }, { regex: "(?:GOME[_ ])?(Fenmmy_Note)(?:[);/ ]|$)", device: "phablet", model: "$1" }] }, tie = { regex: "(?:VOYO[_ ](?:A15)|i8-Max|Q101-4G)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "i8-Max(?:[);/ ]|$)", model: "i8 Max" }, { regex: "(Q101)-4G(?:[);/ ]|$)", model: "$1 4G" }, { regex: "VOYO[_ ](A15)(?:[);/ ]|$)", model: "$1" }] }, rie = { regex: "RYTE (U55 LTE)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, oie = { regex: "(HK1 (?:Max|MINI|PLUS|PRO)|VONTAR[ -](?:Z[58]|V1|KIII|MX-4K|X3))(?:[);/ ]|$)", device: "tv", models: [{ regex: "VONTAR[ -](Z[58]|V1|KIII|MX-4K|X3)(?:[);/ ]|$)", model: "$1" }, { regex: "HK1 Max(?:[);/ ]|$)", model: "HK1 Max" }, { regex: "HK1 MINI(?:[);/ ]|$)", model: "HK1 Mini" }, { regex: "HK1 PLUS(?:[);/ ]|$)", model: "HK1 Plus" }, { regex: "HK1 PRO(?:[);/ ]|$)", model: "HK1 Pro" }] }, nie = { regex: "VORKE (Z[157]|Z6(?: Plus)?)(?:[);/ ]|$)", device: "tv", model: "$1" }, aie = { regex: "Wigor (V4)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, lie = { regex: "NEXON (X[1589])(?:[);/ ]|$)", device: "tv", model: "$1" }, iie = { regex: "(ONA19TB00[327]|10000520[6-9]|O8HD)(?:[);/ ]|$)", device: "tablet", model: "$1" }, sie = { regex: "(Wave_i101G|Wave i101[Hb])(?:[);/ ]|$)", device: "tablet", model: "$1" }, die = { regex: "DW-[A-Z0-9]{5}(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(DW-PS3G5)(?:[);/ ]|$)", model: "Pocket Surfer 3G5" }, { regex: "DW-UBT7W", device: "tablet", model: "Ubislate 7W" }] }, uie = { regex: "DROXIO (C40|B45)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, cie = { regex: "Goophone[ _]|(?:M(G492|L7[JK]2)CH|MN(4A2|8J2)ZP|MGA92ZP|MKU82ZP|MNGW2CH|MNH02CH|MNRM2CH)[/]A(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:MG492CH|MGA92ZP)[/]A(?:[);/ ]|$)", model: "I6 Plus" }, { regex: "ML7[JK]2CH[/]A(?:[);/ ]|$)", model: "I6" }, { regex: "MKU82ZP[/]A(?:[);/ ]|$)", model: "I6S" }, { regex: "MNGW2CH[/]A(?:[);/ ]|$)", model: "I6S Plus" }, { regex: "(?:MN4A2ZP|MNH02CH)[/]A(?:[);/ ]|$)", model: "I7" }, { regex: "(?:MN8J2ZP|MNRM2CH)[/]A(?:[);/ ]|$)", model: "I7 Plus" }, { regex: "S4 MEGA(?:[);/ ]|$)", model: "S4 Mega" }, { regex: "Goophone i([69])(?:[);/ ]|$)", model: "I$1" }] }, mie = { regex: "PocketBook[ _/]", device: "tablet", models: [{ regex: 'PocketBook SURFpad 3 \\(([\\d]+).([\\d]+)["]?\\)(?:[);/ ]|$)', model: 'Surfpad 3 $1.$2"' }, { regex: "PocketBook/(62[67]|63[12]|740|840)(?:[);/ ]|$)", model: "$1" }] }, gie = { regex: "(?:Mobitab10c-3G|Tab1011Q_II)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(Mobitab)(10)c-3G(?:[);/ ]|$)", model: "$1 $2C 3G" }, { regex: "Tab1011Q_II(?:[);/ ]|$)", model: "Tab1011Q II" }] }, fie = { regex: "KULIAO (K10)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, pie = { regex: "SUGAR[ _]", device: "smartphone", models: [{ regex: "SUGAR Y([78]) MAX(?:[);/ ]|$)", model: "Y$1 Max" }, { regex: "SUGAR F7 Mini(?:[);/ ]|$)", model: "F7 Mini" }, { regex: "SUGAR (C[12]1|C1[23]|S11|C11s|[SF]20s?|[YF]11|[YFS]9|C[679]|[FY]7|Y12s|Y1[256]|P1)(?:[);/ ]|$)", model: "$1" }] }, hie = { regex: "SUBOR[ _]", device: "smartphone", models: [{ regex: "SUBOR[ _](S5|2019)(?:[);/ ]|$)", model: "$1" }, { regex: "SUBOR[_ ]K10PLUS(?:[);/ ]|$)", model: "K10 Plus" }] }, xie = { regex: "Xshitou[_ ](P7)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, vie = { regex: "JKL[_ ](A28)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Sie = { regex: "(G0215D|G0245D|G0335D)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, bie = { regex: "(?:Vodacom)[ _](Power Tab 10)(?:[);/ ]|$)", device: "tablet", model: "$1" }, yie = { regex: "(?:(?:VK700)-MAX|VK700 Pro|T5SE|VK700X|vk6050|vk6735|vk700)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(VK700)-MAX(?:[);/ ]|$)", model: "$1 Max" }, { regex: "(VK700) Pro(?:[);/ ]|$)", model: "$1 Pro" }, { regex: "T5SE(?:[);/ ]|$)", model: "T5 SE" }, { regex: "VK(700X|6050|6735|700)(?:[);/ ]|$)", model: "VK$1" }] }, wie = { regex: "MITO[- _](A(?:1[0678]|19_[12]GB|21|3[59]|55|180|2[36]0|313|322|33|3[136]0|[35]50|6[89]|7[235]|82|[356]0|810|950)|T(?:8|10|35|3[03]0|510|888)|311)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "MITO[- _](A(?:1[0678]|19_[12]GB|21|3[59]|55|180|2[36]0|33|322|313|3[136]0|[35]50|6[89]|7[235]|82|[356]0|810|950)|311)(?:[);/ ]|$)", model: "$1" }, { regex: "MITO[ _](T(?:8|10|35|3[03]0|510|888))(?:[);/ ]|$)", device: "tablet", model: "$1" }] }, _ie = { regex: "Amazing[ _](X[35]s|X[123567]|A5S|A3[025]|A[468]|A4S|A5[057]|P6)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Amazing[ _](X[35])s(?:[);/ ]|$)", model: "Amazing $1S" }, { regex: "Amazing[ _](A5S|X[123567]|A[468]|A4S|A5[057]|A3[025])(?:[);/ ]|$)", model: "Amazing $1" }, { regex: "Amazing[ _](P6)(?:[);/ ]|$)", device: "tablet", model: "Amazing $1" }] }, Tie = { regex: "TWZ[-_ ](?:TabPlay|Y6[08]|Y52|A49|A[59]5|A567|AA8|QQ[12])|TWZQQ1", device: "smartphone", models: [{ regex: "TWZ[_ ]TabPlay[_ ](12[56])", device: "tablet", model: "TabPlay $1" }, { regex: "TWZ[-_ ]?(Y6[08]|Y52|A49|A[59]5|A567|AA8|QQ[12])", model: "$1" }] }, Aie = { regex: "(?:ONIX S405|AT101-1116)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(AT101-1116)(?:[);/ ]|$)", model: "$1" }, { regex: "(S405)(?:[);/ ]|$)", device: "smartphone", model: "$1" }] }, Pie = { regex: "Apex([13])(?:[);/ ]|$)", device: "smartphone", model: "Apex $1" }, Mie = { regex: "(?:(?:MOBO[_ ]MB7005|MT7-421HD)|(?:MT7-442D|MT7-411D))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(?:MOBO[_ ])?(MB7005|MT7-421HD|MT7-442D|MT7-411D)(?:[);/ ]|$)", model: "$1" }] }, $ie = { regex: "(MC-X7MINI)(?:[);/ ]|$)", device: "smartphone", model: "MC-X7 Mini" }, Cie = { regex: "PRIXTON |(T7012Q)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "PRIXTON (C18)", device: "smartphone", model: "$1" }, { regex: "(T7012Q)(?:[);/ ]|$)", model: "$1" }] }, Lie = { regex: "Magnus[ _](?:bravoZ[23]0|Infinity_?(?:G8|G11))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "bravo(Z[23]0)", model: "Bravo $1" }, { regex: "(?:Magnus[ _])?Infinity_?(G8|G11)", model: "Infinity $1" }] }, Eie = { regex: "(?:NLS-MT90)(?:[);/ ]|$)", device: "smartphone", model: "MT90 Orca" }, Oie = { regex: "(?:RC555L|RC501L)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "RC555L(?:[);/ ]|$)", model: "Wonder" }, { regex: "RC501L(?:[);/ ]|$)", model: "Slim" }] }, Nie = { regex: "(?:H1A1000)(?:[);/ ]|$)", device: "smartphone", model: "Hydrogen One" }, Die = { regex: "Contixo|(?:CX-1045 3G|KT995 3G|CX1045)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "CX-?1045(?: 3G)?(?:[);/ ]|$)", model: "CX-1045 3G" }, { regex: "CONTIXO GX 1035(?:[);/ ]|$)", model: 'GX-1035 4G 10.1"' }, { regex: "Contixo GT1160 4G(?:[);/ ]|$)", model: 'GT1160 4G 10.1"' }, { regex: "B105(?:[);/ ]|$)", model: 'B105 3G 10.1"' }, { regex: "B108(?:[);/ ]|$)", model: 'B108 4G 10.1"' }, { regex: "KT107(?: 3G)?(?:[);/ ]|$)", model: 'KT107 3G 10.1"' }, { regex: "K109(?:[);/ ]|$)", model: 'KT109 4G 10.1"' }, { regex: "KT715 3G(?:[);/ ]|$)", model: 'KT715 3G 7.0"' }, { regex: "KT995(?:[);/ ]|$)", model: 'KT995 3G 10.1"' }, { regex: "KT1100GT(?:[);/ ]|$)", model: "KT1100GT" }] }, kie = { regex: "(?:HT-705XS|705-G Go|1001-G Go)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(HT-705XS)(?:[);/ ]|$)", model: "$1" }, { regex: "(1001-G Go)(?:[);/ ]|$)", model: "HT-1001G Go Kids" }, { regex: "(705-G Go)(?:[);/ ]|$)", model: "HT-$1" }] }, Gie = { regex: "(?:Multilaser[ _](?:[FEGH])(?:[_ ](?:Pro|Max|Lite))?|MS50[LGX]|M7[_-]3G[_-]PLUS|MS5\\.V2|MS45S_A6|ML([02]1|12)-M7s[- ]?Quad-?Core| ML01-M7-SD|MS45S|MS50S|MS60[XZ]|M7SQC_Plus|MS80X|MS40[GS]|MS55M|MS70|M7-3G QUAD CORE|M7sLite|MS50L_4G|MS60F(?:_PLUS)?)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Multilaser[ _]G[_ ]Pro(?:[);/ ]|$)", model: "G Pro" }, { regex: "Multilaser[ _]F[_ ]Pro(?:[);/ ]|$)", model: "F Pro" }, { regex: "Multilaser[ _]G[_ ]Max(?:[);/ ]|$)", model: "G Max" }, { regex: "Multilaser[ _]G(?:[);/ ]|$)", model: "G" }, { regex: "Multilaser[ _]E[_ ]Lite(?:[);/ ]|$)", model: "E Lite" }, { regex: "Multilaser[ _]([FEH])(?:[);/ ]|$)", model: "$1" }, { regex: "MS60F_PLUS(?:[);/ ]|$)", model: "MS60F Plus" }, { regex: "(MS50[LGX]|MS45S_A6|MS40[GS]|MS55M|MS60F|MS70|MS60[XZ]|MS45S|MS80X|MS50L_4G|MS50S|MS5\\.V2)(?:[);/ ]|$)", model: "$1" }, { regex: "M7[_-]3G[_-]PLUS(?:[);/ ]|$)", device: "tablet", model: "M7 3G Plus" }, { regex: "M7SQC_PLUS(?:[);/ ]|$)", device: "tablet", model: "M7SQC Plus" }, { regex: "M7-3G QUAD CORE(?:[);/ ]|$)", device: "tablet", model: "M7 3G Quad Core" }, { regex: "ML([02]1|12)-M7s[- ]?Quad-?Core(?:[);/ ]|$)", device: "tablet", model: "ML$1-M7s Quad Core" }, { regex: "M7sLite(?:[);/ ]|$)", device: "tablet", model: "M7s Lite" }, { regex: "ML01-M7-SD(?:[);/ ]|$)", device: "tablet", model: "ML01-M7 SD" }] }, Bie = { regex: "Maxtron[ _-](V[327]|S[89]|T1)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Maxtron[ _-](V[327]|S[89])(?:[);/ ]|$)", model: "$1" }, { regex: "Maxtron[ _-](T1)(?:[);/ ]|$)", device: "tablet", model: "$1" }] }, Iie = { regex: "PHILCO |(PCS01|PH350B|PTB7R|PTB7PAP_PTB7PAB_PTB7PAR)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(PCS01|PH350B)(?:[);/ ]|$)", model: "$1" }, { regex: "(PTB7R)(?:[);/ ]|$)", device: "tablet", model: "$1" }, { regex: "PHILCO Android TV(?:[);/ ]|$)", device: "tv", model: "" }, { regex: "PTB7PAP_PTB7PAB_PTB7PAR(?:[);/ ]|$)", device: "tablet", model: "PTB7PA" }] }, Rie = { regex: "Newman[ _](P308|K1)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Fie = { regex: "(Elite Sense|Elite_VR)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Vie = { regex: "(?:OWWO[ _]?(?:[1457]S|Q[78])|CARNIVAL B5)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "OWWO[ _]?([1457]S|Q[78])(?:[);/ ]|$)", model: "$1" }, { regex: "CARNIVAL B5(?:[);/ ]|$)", model: "Carnival B5" }] }, Hie = { regex: "RAVOZ[ _](Z5 (?:Lite|Pro)|Z[3-7]|R[478])(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Uie = { regex: "TONE (e19|m15|e20)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Xie = { regex: "(ZBH-)?BIHEE", device: "smartphone", models: [{ regex: "(A1[12]|A[78]\\+|A[56])(?:[);/ ]|$)", model: "$1" }] }, Wie = { regex: "Enot[ _-](E102|J101)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Yie = { regex: "Kooper-mobile-W502(?:[);/ ]|$)", device: "smartphone", model: "Mobile W502" }, Kie = { regex: "ANOVA A5(?:[);/ ]|$)", device: "smartphone", model: "Anova A5" }, Qie = { regex: "ANRY-(RS10|[SX]20)(?:[);/ ]|$)", device: "tablet", model: "$1" }, jie = { regex: "Tinai (K[12])(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Zie = { regex: "NOTE GRACE V(?:[);/ ]|$)", device: "smartphone", model: "Note Grace V" }, zie = { regex: "32LF7130S(?:[);/ ]|$)", device: "tv", model: '32LF7130S 32.0"' }, qie = { regex: "PHONEMAX[_ ](Saturn(?:[_ ]X)?|Mars|Venus X)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "PHONEMAX[_ ]Saturn[_ ]X(?:[);/ ]|$)", model: "Saturn X" }, { regex: "PHONEMAX[_ ]Saturn(?:[);/ ]|$)", model: "Saturn" }, { regex: "PHONEMAX[_ ]Mars(?:[);/ ]|$)", model: "Mars" }, { regex: "PHONEMAX[_ ]Venus X(?:[);/ ]|$)", model: "Venus X" }] }, Jie = { regex: "VIPRO(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "VIPRO PRO2X(?:[);/ ]|$)", model: "Pro 2X" }, { regex: "VIPRO PRO[ _-]?([0-9])(?:[);/ ]|$)", model: "Pro $1" }] }, ese = { regex: "Ozone HD|OzoneHD[ _](T2 WiFi|4K(?: TV)?|Fun)(?:[);/ ]|$)", device: "tv", model: "$1" }, tse = { regex: "(?:Ureki_U1|Victor V1|DART KZ07)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Ureki_U1", model: "Ureki U1" }, { regex: "Victor V1", model: "Victor V1" }, { regex: "DART KZ07", device: "tablet", model: "Dart KZ07" }] }, rse = { regex: "MELROSE_(?:S9|2019)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "MELROSE_S9(?:[);/ ]|$)", model: "S9" }, { regex: "MELROSE_2019(?:[);/ ]|$)", model: '2019 Ultra Slim 3.4"' }] }, ose = { regex: "CRONY-7021(?:[);/ ]|$)", device: "tablet", model: "7021" }, nse = { regex: "(MID211H)(?:[);/ ]|$)", device: "tablet", model: "$1" }, ase = { regex: "(Orion R68G|Draco AW80|Draco H3|Vega S95_(?:Meta|Pro|Telos))(?:[);/ ]|$)", device: "tv", model: "$1" }, lse = { regex: "AMIGOO (R300|R9 Max|M1 Max|X15)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, ise = { regex: "Lumigon[ _](T3)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, sse = { regex: "NEO[ ]?(90[689])(?:[);/ ]|$)", device: "smartphone", model: "Neo $1" }, dse = { regex: "(?:NV5(?:01|10)WAC|NV501|NV510WB)(?:[);/ ]|$)", device: "tv", models: [{ regex: "NV5(01|10)WAC(?:[);/ ]|$)", model: "NV-5$1-Wac" }, { regex: "NV501(?:[);/ ]|$)", model: "NV-501" }, { regex: "NV510WB(?:[);/ ]|$)", model: "NV-510-WB" }] }, use = { regex: "Senkatel[ _](T1009|T8002|T701[12]|T9702)(?:[);/ ]|$)", device: "tablet", model: "$1" }, cse = { regex: "(?:K10[ ]?SE)(?:[);/ ]|$)", device: "tablet", model: "K10 SE" }, mse = { regex: "TERRA[ _]PAD[ _](100[45])(?:[);/ ]|$)", device: "tablet", model: "Terra Pad $1" }, gse = { regex: "Capture\\+(?:[);/ ]|$)", device: "smartphone", model: "Capture Plus" }, fse = { regex: "Tele2[ _]", device: "smartphone", models: [{ regex: "Tele2[ _](Mi[dn]i)[ _]1.1(?:[);/ ]|$)", model: "$1 1.1" }, { regex: "Tele2[ _]Midi[ _]2.0(?:[);/ ]|$)", model: "Midi 2.0" }, { regex: "Tele2[ _]((?:Maxi|Midi)(?:[_ ](?:Plus|LTE))?)(?:[);/ ]|$)", model: "$1" }, { regex: "Tele2[ _](Mi[dn]i)(?:[);/ ]|$)", model: "$1" }] }, pse = { regex: "(?:Alfawise (?:A9)|(?:A95X_R1))(?:[);/ ]|$)", device: "tv", models: [{ regex: "(A95X_R1)(?:[);/ ]|$)", model: "$1" }, { regex: "Alfawise (A9)", model: "$1" }] }, hse = { regex: "KLIPAD_|(?:KL-V905|KL4889|KL9878|7589AN)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:KLIPAD_)?(V355B?|KL600|KL-V905)(?:[);/ ]|$)", model: "$1" }, { regex: "(KL4889|7589AN|KL9878)(?:[);/ ]|$)", device: "tablet", model: "$1" }] }, xse = { regex: "SQOOL-V(41?)(?:[);/ ]|$)", device: "tablet", model: "V$1" }, vse = { regex: "Turbokids[-_ ]?(TMNT|3G|S4)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Sse = { regex: "Jinga[-_ ]|(?:(?:Fresh|Optim)4G|Pass(?:Plus|3G)|PicassoNote|Hotz[_ ]M1|WinPRO|Touch4G|Start3G|IGO[ _]L[41]|Basco (?:L3|L[45]00|XS1|S2))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Optim4G(?:[);/ ]|$)", model: "Optim 4G" }, { regex: "Fresh4G(?:[);/ ]|$)", model: "Fresh 4G" }, { regex: "Hotz[_ ]M1(?:[);/ ]|$)", model: "Hotz M1" }, { regex: "PassPlus(?:[);/ ]|$)", model: "Pass Plus" }, { regex: "Pass3G(?:[);/ ]|$)", model: "Pass 3G" }, { regex: "WinPRO(?:[);/ ]|$)", model: "Win Pro" }, { regex: "Touch4G(?:[);/ ]|$)", model: "Touch 4G" }, { regex: "Start3G(?:[);/ ]|$)", model: "Start 4G" }, { regex: "PicassoNote(?:[);/ ]|$)", model: "Picasso Note" }, { regex: "Jinga Iron(?:[);/ ]|$)", model: "Iron" }, { regex: "Jinga Basco neo(?:[);/ ]|$)", model: "Basco Neo" }, { regex: "(?:Jinga )?Basco (L3|L[45]00|XS1|S2)(?:[);/ ]|$)", model: "Basco $1" }, { regex: "Jinga Trezor S1 Plus(?:[);/ ]|$)", model: "Trezor S1 Plus" }, { regex: "JINGA_IGO_L2(?:[);/ ]|$)", model: "IGO L2" }, { regex: "(?:JINGA[_ ])?IGO[_ ]([ML]1|L4)(?:[);/ ]|$)", model: "IGO $1" }, { regex: "Jinga Trezor S1 Plus(?:[);/ ]|$)", model: "Trezor S1 Plus" }] }, bse = { regex: "(?:TWOE[-_ ]E450R|F534L|F572L|E500A)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "TWOE[-_ ](E450R)(?:[);/ ]|$)", model: "$1" }, { regex: "(F534L|F572L|E500A)(?:[);/ ]|$)", model: "$1" }] }, yse = { regex: "iTRUCK 7 3G(?:[);/ ]|$)", device: "smartphone", model: '7.0" 3G' }, wse = { regex: "TOREX[- ](?:PS12|S18|S27)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "TOREX-(PS12)", model: "$1" }, { regex: "TOREX[- ](S18|S27)", device: "smartphone", model: "$1" }] }, _se = { regex: "(24DHS54)(?:[);/ ]|$)", device: "tv", model: "$1" }, Tse = { regex: "OYYUT11(?:[);/ ]|$)", device: "tablet", model: "T11 3G" }, Ase = { regex: "Primux", device: "smartphone", models: [{ regex: "Primux_ioxphone(?:[);/ ]|$)", model: "IOX Phone" }, { regex: "PrimuxDelta6(?:[);/ ]|$)", model: "Delta 6" }, { regex: "PrimuxKappa(P50[01])(?:[);/ ]|$)", model: "Kappa $1" }, { regex: "PrimuxKappa(?:[);/ ]|$)", model: "Kappa" }, { regex: "Primux_Beta2(?:[);/ ]|$)", model: "Beta 2" }, { regex: "Primux_?Omega([57])(?:[);/ ]|$)", model: "Omega $1" }, { regex: "PrimuxUP(?:[);/ ]|$)", device: "tablet", model: "UP" }, { regex: " PrimuxZonda4(?:[);/ ]|$)", device: "tablet", model: "Zonda 4" }, { regex: "Primux_Siroco6(?:[);/ ]|$)", device: "tablet", model: "Siroco 6" }] }, Pse = { regex: "(?:IMARS VEGA X7|VIVI_8)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "IMARS VEGA X7", model: "Vega X7" }, { regex: "VIVI_8", model: "VIVI 8" }] }, Mse = { regex: "LOGIC[_ ](X[135]|X4M|L5D|X5[AFT]|X60G|L61|X60_PLUS)(:?[_ ]LITE2?)?(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "LOGIC[_ ]X60_PLUS(?:[);/ ]|$)", model: "X60 Plus" }, { regex: "LOGIC[_ ](X5|X4M)[_ ]LITE(?:[);/ ]|$)", model: "$1 Lite" }, { regex: "LOGIC[_ ](X5)[_ ]LITE2(?:[);/ ]|$)", model: "$1 Lite 2" }, { regex: "LOGIC[_ ](X[13]|X4M|L5D|X5[AFT]|X60G|L61)(?:[);/ ]|$)", model: "$1" }] }, $se = { regex: "\\+VT(?:107C|Q007C)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "\\+VT(107C)", model: "+VT$1" }, { regex: "\\+VTQ(007C)", model: "+VTQ$1" }] }, Cse = { regex: "(?:Thrill (?:Boost[ ]?(2|3)?|Snap|Access)|Excite Prime 2 Pro|NBA Edition)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Thrill Boost (2|3)(?:[);/ ]|$)", model: "Thrill Boost $1" }, { regex: "Thrill Boost(?:[);/ ]|$)", model: "Thrill Boost" }, { regex: "Thrill Snap(?:[);/ ]|$)", model: "Thrill Snap" }, { regex: "Thrill Access(?:[);/ ]|$)", model: "Thrill Access" }, { regex: "Excite Prime 2 Pro(?:[);/ ]|$)", model: "Excite Prime 2 Pro" }, { regex: "NBA Edition(?:[);/ ]|$)", model: "NBA Edition" }] }, Lse = { regex: "(?:Joy 1\\+|Active 1\\+|Bee 3|Active 3)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Joy 1\\+(?:[);/ ]|$)", model: "Joy 1 Plus" }, { regex: "Active 1\\+(?:[);/ ]|$)", model: "Active 1 Plus" }, { regex: "Bee 3(?:[);/ ]|$)", model: "Bee 3" }, { regex: "Active 3(?:[);/ ]|$)", model: "Active 3" }] }, Ese = { regex: "(?:MiXzo[ _])?(?:ME1023|ME1030|MX1037|MX1024|MX10[24]1|MX1397)([ _][34]G)?(?:[);/ ]|$)", device: "tablet", models: [{ regex: "MiXzo[_ ]ME(1023|1030)(?:[_ ]3G)(?:[);/ ]|$)", model: "ME$1 3G" }, { regex: "MiXzo[_ ]MX1021(?:[_ ]3G)?(?:[);/ ]|$)", model: "MX1021 3G" }, { regex: "(?:MiXzo[ _])?MX(1037|1041|1024|1397)[ _]4G(?:[);/ ]|$)", model: "MX$1 4G" }] }, Ose = { regex: "Openbox (A[34](?: (?:Pro|Lite))?)(?:[);/ ]|$)", device: "tv", model: "$1" }, Nse = { regex: "ZIOX[_ ]|(?:Astra Viva 4G|Astra NXT Pro|Duopix F9)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ZIOX[_ ]F9[_ ]PRO(?:[);/ ]|$)", model: "F9 Pro" }, { regex: "Astra Viva 4G(?:[);/ ]|$)", model: "Astra Viva 4G" }, { regex: "Astra NXT Pro(?:[);/ ]|$)", model: "Astra NXT Pro" }, { regex: "Duopix F9(?:[);/ ]|$)", model: "Duopix F9" }] }, Dse = { regex: "APACHE G6(?:[);/ ]|$)", device: "smartphone", model: "Apache G6" }, kse = { regex: "aoson(?:R10[1-3]|S[78]|M707TG)(?:[_ ]?Pro)?(?:[);/ ]|$)", device: "tablet", models: [{ regex: "aosonR10([1-3])(?:[);/ ]|$)", model: 'R10$1 10.1"' }, { regex: "aosonS7_Pro(?:[);/ ]|$)", model: 'S7 Pro 7.0"' }, { regex: "aosonS7(?:[);/ ]|$)", model: 'S7 7.0"' }, { regex: "aosonS8Pro(?:[);/ ]|$)", model: 'S8 Pro 8.0"' }, { regex: "aoson(M707TG)(?:[);/ ]|$)", model: "$1" }] }, Gse = { regex: "TAB (A40[13]0)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Bse = { regex: "(TC1050G)(?:[);/ ]|$)", device: "tablet", model: '$1 10.1"' }, Ise = { regex: "(TAB2323GMQC)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Rse = { regex: "(?:Venus[_ ]X1[024569]|Cosmos[ _](?:V8_lite|V19_Plus|V2[0-3]|U2|V19|V[569])|Pearl K2|Magic Q8|Magic 5 Plus|Magic (?:[89]|1[13])|Hot[_ ]6)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Cosmos[ _]V8_lite(?:[);/ ]|$)", model: "Cosmos V8 Lite" }, { regex: "Hot[_ ]6?(?:[);/ ]|$)", model: "Hot 6" }, { regex: "(Venus[_ ]X1[024569]|Cosmos[ _](?:V19_Plus|V2[0-3]|U2|V19|V[569])|Pearl K2|Magic Q8|Magic 5 Plus|Magic (?:[89]|1[13]))(?:[);/ ]|$)", model: "$1" }] }, Fse = { regex: "CASEBOOK_3(?:[);/ ]|$)", device: "tablet", model: "Casebook 3" }, Vse = { regex: "Dolamee[_ -](D[56])(?:[);/ ]|$)", device: "tv", model: "$1" }, Hse = { regex: "INVIN[ _-]|KM5PRO(?:[);/ ]|$)", device: "tv", models: [{ regex: "INVIN[ _-](X[24]|KM[678])", model: "$1" }, { regex: "KM5PRO", model: "KM5 Pro" }] }, Use = { regex: "Doopro P3(?:[);/ ]|$)", device: "smartphone", model: "P3" }, Xse = { regex: "IQM (?:picasso|vivaldi|newton)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "IQM picasso(?:[);/ ]|$)", model: "Picasso" }, { regex: "IQM vivaldi(?:[);/ ]|$)", model: "Vivaldi" }, { regex: "IQM newton(?:[);/ ]|$)", model: "Newton" }] }, Wse = { regex: "Nos (?:FIVE|NOVU|NEVA|Roya)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "NOS FIVE(?:[);/ ]|$)", model: "Five" }, { regex: "NOS NOVU III(?:[);/ ]|$)", model: "Novu III" }, { regex: "NOS NOVU II(?:[);/ ]|$)", model: "Novu II" }, { regex: "NOS NOVU(?:[);/ ]|$)", model: "Novu" }, { regex: "NOS NEVA 80(?:[);/ ]|$)", model: "Neva 80" }, { regex: "NOS Roya(?:[);/ ]|$)", model: "Roya" }] }, Yse = { regex: "(?:ACCENT[_ ]NEON|FAST73G|PEARL[_ ]A[24567]|TANK_P55|CAMELEON[_ ](?:C[456]|A1)(?:[_ ]PLUS)?|Speed[- ](?:[AXYM]2|X2\\+))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ACCENT[_ ]NEON(?:[);/ ]|$)", model: "Neon" }, { regex: "CAMELEON[_ ]C6[_ ]PLUS(?:[);/ ]|$)", model: "Cameleon C6 Plus" }, { regex: "Speed[- ]([AXYM]2)(?:[);/ ]|$)", model: "Speed $1" }, { regex: "Speed-X2\\+(?:[);/ ]|$)", model: "Speed X2 Plus" }, { regex: "CAMELEON[_ ](C[456]|A1)(?:[);/ ]|$)", model: "Cameleon $1" }, { regex: "PEARL A4 Lite(?:[);/ ]|$)", model: "Pearl A4 Lite" }, { regex: "PEARL[_ ]A([2567])(?:[);/ ]|$)", model: "Pearl A$1" }, { regex: "TANK_P55(?:[);/ ]|$)", model: "Tank P55" }, { regex: "FAST73G(?:[);/ ]|$)", device: "phablet", model: "FAST7 3G" }] }, Kse = { regex: "Avenzo(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "MOB4 4G(?:[);/ ]|$)", model: "Mob 4 4G" }, { regex: "MOB4PRO 4G(?:[);/ ]|$)", model: "Mob 4 Pro 4G" }] }, Qse = { regex: "(?:Beelink (?:G[ST]1|LAKE I|SEA I|A1)|GTKing|GT1mini-2|GT1-mini(?:-AT)?)(?:[);/ ]|$)", device: "tv", models: [{ regex: "Beelink (G[ST]1|LAKE I|SEA I|A1)(?:[);/ ]|$)", model: "$1" }, { regex: "GT1-mini(?:-AT)?(?:[);/ ]|$)", model: "GT1 Mini" }, { regex: "GT1mini-2(?:[);/ ]|$)", model: "GT1 Mini 2" }, { regex: "GTKing(?:[);/ ]|$)", model: "GT King" }] }, jse = { regex: "MAXVI[ _](?:MS401)(?:[);/ ]|$)|(?:\\w+)?_MAXVI_\\w+|MS502[_ ]Orion|MS531", device: "smartphone", models: [{ regex: "MAXVI[ _](MS401)", model: "$1" }, { regex: "MS531", model: "MS531 Vega" }, { regex: "MS502[_ ]Orion", model: "MS502 Orion" }, { regex: "(?:\\w+)?MAXVI_(P11|K10|X[358]00)_\\w+", device: "feature phone", model: "$1" }] }, Zse = { regex: "meanIT[ _](?:C[12]|X10|X[126]|MG430|Q[145])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "meanIT[ _]Q1 plus(?:[);/ ]|$)", model: "Q1 Plus" }, { regex: "meanIT[ _](C[12]|X[126]|MG430|Q[145])(?:[);/ ]|$)", model: "$1" }, { regex: "meanIT[ _]X10(?:[);/ ]|$)", device: "tablet", model: "X10" }] }, zse = { regex: "Three[_ ]Proofings[_ ]W([5-9])(?:[);/ ]|$)", device: "smartphone", model: "Three Proofings W$1" }, qse = { regex: "XGODY", device: "smartphone", models: [{ regex: "XGODY Y17(?:[);/ ]|$)", model: "Y17" }, { regex: "XGODY_X96(?:[);/ ]|$)", model: "X96", device: "tv" }] }, Jse = { regex: "(Access_Q784C)(?:[);/ ]|$)", device: "tablet", model: "$1" }, ede = { regex: "IBRIT_|(?:SI5[12])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "IBRIT_I([57])(?:[);/ ]|$)", model: "I$1" }, { regex: "iBRIT_POWER6(?:[);/ ]|$)", model: "Power 6" }, { regex: "iBRIT_Speed Pro(?:[);/ ]|$)", model: "Speed Pro" }, { regex: "SI51(?:[);/ ]|$)", model: "Speed" }, { regex: "SI52(?:[);/ ]|$)", model: "Speed Plus" }] }, tde = { regex: "Jumbo X1", device: "smartphone", model: "Jumbo X1" }, rde = { regex: "Fero[_ ]|Royale[_ ](?:[YX]2|A1)", device: "smartphone", models: [{ regex: "Fero_Y1", model: "Y1" }, { regex: "Royale Y2 Lite", model: "Royale Y2 Lite" }, { regex: "Royale[_ ]([YX]2|A1)", model: "Royale $1" }, { regex: "FERO PACE", model: "Pace" }, { regex: "Fero[ _](A4001|A450[23]|A5001|L100|Iris|Power|Mega LTE|Vibe)", model: "$1" }] }, ode = { regex: "Ruio[ _]", device: "smartphone", models: [{ regex: "Ruio[ _](S4)(?:[);/ ]|$)", model: "$1" }, { regex: "Ruio[ _](S5)Plus(?:[);/ ]|$)", model: "$1 Plus" }] }, nde = { regex: "Transpeed_|(?:TR99 MINI\\+|TR99)(?:[);/ ]|$)", device: "tv", models: [{ regex: "TR99 MINI\\+", model: "TR99 Mini Plus" }, { regex: "(?:Transpeed_)?(TR99|H616|6K)(?:[);/ ]|$)", model: "$1" }] }, ade = { regex: "ZYVV1(?:[);/ ]|$)", device: "smartphone", model: "V1" }, lde = { regex: "A1 (?:Alpha|Alpha 20\\+)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "A1 Alpha 20\\+", model: "Alpha 20 Plus" }, { regex: "A1 Alpha", model: "Alpha" }] }, ide = { regex: "swisstone (SD 5[13]0)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, sde = { regex: "(?:Innelo_1|iV 505)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Innelo_1", model: "Innelo 1" }, { regex: "iV 505", model: "Me 1" }] }, dde = { regex: "Pixelphone S1(?:[);/ ]|$)", device: "smartphone", model: "S1" }, ude = { regex: "Infineum[_ ](Z4?5)(?:[);/ ]|$)", device: "smartphone", model: "Infineum $1" }, cde = { regex: "(?:Vox[_ ](?:[45]S|Alpha|POP|STEEL Plus|Energy)|IS2_?Plus|IS2S|Next_P_PRO|IRS002-16)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Vox[_ ]([45])S", model: "Vox $1S" }, { regex: "VOX Alpha Plus", model: "Vox Alpha Plus" }, { regex: "VOX STEEL Plus", model: "Vox Steel Plus" }, { regex: "VOX Alpha", model: "Vox Alpha" }, { regex: "VOX Energy", model: "Vox Energy" }, { regex: "VOX POP plus", model: "Vox Pop Plus" }, { regex: "VOX POP Pro", model: "Vox Pop Pro" }, { regex: "Next_P_PRO", model: "Next P Pro" }, { regex: "IS2_?Plus", model: "IS2 Plus" }, { regex: "IRS002-16", model: "I-S6" }, { regex: "IS2S", model: "IS2S" }] }, mde = { regex: "Fonos-(O1)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, gde = { regex: "Xtouch[ _](X10|A5)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, fde = { regex: "Conquest[-_](?:S(?:[68]|1[0126])|F2)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Conquest[-_]S([68]|1[0126])", model: "S$1" }, { regex: "Conquest-F2", model: "F2" }] }, pde = { regex: "ZATEC[_ ]|(?:[ ]WIND|ZPLAY1_2018|Zpower_(?:Plus|2018))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ZATEC[_ ]GRAVITY(?:[);/ ]|$)", model: "Gravity" }, { regex: "[ ]WIND(?:[);/ ]|$)", model: "Wind" }, { regex: "ZPLAY1_2018", model: "Zplay (2018)" }, { regex: "Zpower_2018", model: "Zpower (2018)" }, { regex: "Zpower_Plus", model: "Zpower Plus" }] }, hde = { regex: "Selenga[ _](A[134])(?:[);/ ]|$)", device: "tv", model: "$1" }, xde = { regex: "Starlight|(?:My_Star_X|RIO STAR|C_Note_Pro|Star_Mix_2)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "My_Star_X", model: "My Star X" }, { regex: "RIO STAR", model: "Rio Star" }, { regex: "C_Note_Pro", model: "C Note Pro" }, { regex: "Star_Mix_2", model: "Star Mix 2" }, { regex: "Starlight_ROME_X", model: "Rome X" }] }, vde = { regex: "GEOFOX[_](MID743)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Sde = { regex: "TiNMO[- _](A11|K3)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, bde = { regex: "(7116-A5)(?:[);/ ]|$)", device: "tablet", model: "$1" }, yde = { regex: "(RP-UDM0[12]A|RP-UDP05A)(?:[);/ ]|$)", device: "tablet", model: "Uni Pad $1" }, wde = { regex: "(Magictab (?:9GX|7GE|718))(?:[);/ ]|$)", device: "tablet", model: "$1" }, _de = { regex: "eSTAR[_ ](?:Grand|GO\\!?|Zoom Quad|Gemini|MINI[_ ]3G|BEAUTY|MOON)", device: "tablet", models: [{ regex: "eSTAR (Grand|GO\\!?) (HD Intel|IPS Intel|IPS|HD|Intel) Quad Core 3G", model: "$1 $2 Quad Core 3G" }, { regex: "eSTAR (Zoom Quad|Gemini|GO)", model: "$1" }, { regex: "eSTAR GRAND HD quad core( [34]G)?", model: "Grand HD Quad Core$1" }, { regex: "eSTAR GRAND", model: "Grand" }, { regex: "eSTAR BEAUTY HD Quad core", model: "Beauty HD Quad Core" }, { regex: "eSTAR MOON HD Quad core", model: "Moon HD Quad Core 3G" }, { regex: "eSTAR BEAUTY 2 HD Quad core", model: "Beauty 2 HD Quad Core" }, { regex: "eSTAR[_ ]MINI[_ ]3G", model: "Mini 3G" }] }, Tde = { regex: "(?:Ideal (?:10S|Tab [79])|ALFA10TB|ALFA[_ ](?:10RC|10TM?|7RS|[78]RC|7M)|HT[ _](?:7RT|8MZ))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(Ideal (?:10S|Tab 9))(?:[);/ ]|$)", model: "$1" }, { regex: "ALFA[_ ]?(10RC|10T[BM]?|7RS|[78]RC|7M)(?:[);/ ]|$)", model: "ALFA $1" }, { regex: "Ideal Tab 7 Ips( 3G)?", model: "Ideal Tab 7 IPS$1" }, { regex: "HT[ _](7RT|8MZ)(?:[);/ ]|$)", model: "HT $1" }] }, Ade = { regex: "EX(29|45)i(?:[);/ ]|$)", device: "smartphone", model: "EX $1i" }, Pde = { regex: "10DTB12(?:[);/ ]|$)", device: "tablet", model: "Phoenix" }, Mde = { regex: "(NeoTab)[ _-]((?:S1[23]0|S125|H85|H11[05]|KID741|S9700))(?:[);/ ]|$)", device: "tablet", model: "$1 $2" }, $de = { regex: "(NT-TP10)(?:[);/ ]|$)", device: "tablet", model: 'TouchPad 10.0"' }, Cde = { regex: "UNIWA[ _](X5)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Lde = { regex: "ANDOWL-(Q[45])(?:[);/ ]|$)", device: "tv", model: "$1" }, Ede = { regex: "Silelis[ _](T-1)(?:[);/ ]|$)", device: "tv", model: "$1" }, Ode = { regex: "BLUEDOT[_ ]|(?:BNT-71)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "(?:BLUEDOT[_ ])?(BNP-500)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, { regex: "(BNT-71)(?:[);/ ]|$)", model: "$1" }] }, Nde = { regex: "(Allure[_ ](?:Ultra(?:[_]Curve)?|Secure|Admire|Rise))(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Dde = { regex: "(?:Kiona|KANUNA|Halona|Kicka[_ ][45][ _]Plus|Kohana|Kosumi|KWANITA|Lonan|Hotah|Kicka 5|Kiona)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "KANUNA", model: "Kanuna" }, { regex: "KWANITA", model: "Kwanita" }, { regex: "(Kiona|Kicka[_ ][45][ _]Plus|Kohana|Kosumi|Lonan|Halona|Hotah|Kicka 5|Kiona)(?:[);/ ]|$)", model: "$1" }] }, kde = { regex: "(HTB801)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Gde = { regex: "Hurricane[ _]|(?:Flame_Plus)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Hurricane[ _]IGNITE", model: "Ignite" }, { regex: "Hurricane[ _]Bolt", model: "Bolt" }, { regex: "Hurricane[ _]VORTEX", model: "Vortex" }, { regex: "Hurricane[ _]GIGA", model: "Giga" }, { regex: "Flame_Plus", model: "Flame Plus" }] }, Bde = { regex: "ISWAG[ _]", device: "smartphone", models: [{ regex: "ISWAG[_ ]VIPER", model: "Viper" }, { regex: "iSWAG[_ ]Lynx", model: "Lynx" }, { regex: "iSWAG[_ ]MANTRA", model: "Mantra" }, { regex: "iSWAG[_ ]MEGA", model: "Mega" }, { regex: "iSWAG[_ ]NEMESIS", model: "Nemesis" }] }, Ide = { regex: "(?:reeder[_ ](?:3G_Tablet|A7iC|A[78]i[_ ]Quad|A8i Q2|M8 Plus|[TM]8|M10 Plus|P11SE)|P12Curve)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "reeder[_ ](3G_Tablet|A7iC|A[78]i[_ ]Quad|A8i Q2|M8 Plus|[TM]8|M10 Plus|P11SE)(?:[);/ ]|$)", model: "$1" }, { regex: "P12Curve", device: "smartphone", model: "P12 Curve" }] }, Rde = { regex: "KidPhone4G(?:[);/ ]|$)", device: "wearable", model: "KidPhone 4G" }, Fde = { regex: "Altice[ _](S62|S31|S43)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Vde = { regex: "(Ambition|Beyond)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Hde = { regex: "SURVE(10|[26-8]|[12] PRO)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "SURVE([12]) PRO", model: "Surve $1 Pro" }, { regex: "SURVE(10|[26-8])", model: "Surve $1" }] }, Ude = { regex: "(?:BioWolf 8-F30|BIOWOLF8F30|Ruggbo 20 Lite)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "BioWolf 8-F30|BIOWOLF8F30", model: "BioWolf 8-F30" }, { regex: "Ruggbo 20 Lite", model: "Ruggbo 20 Lite" }] }, Xde = { regex: "(?:VPA051|VA-10J)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "VPA051", model: "Phone A" }, { regex: "(VA-10J)", model: "$1" }] }, Wde = { regex: "Spark Plus 3(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Plus 3", model: "Plus 3" }] }, Yde = { regex: "(?:Gravity Max|GRAVITY_OCTACORE|SPC SMART LITE|SPC_ALIEN(?:_STICK)?|SPC Glow9.7)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "GRAVITY_OCTACORE", model: "Gravity OctaCore" }, { regex: "Gravity Max", model: "Gravity Max" }, { regex: "SPC Glow9.7", model: 'Glow 9.7"' }, { regex: "SPC SMART LITE", device: "smartphone", model: "Smart Lite" }, { regex: "SPC_ALIEN_STICK", device: "tv", model: "Alien Stick" }, { regex: "SPC_ALIEN", device: "tv", model: "Alien" }] }, Kde = { regex: "Winmax[ _](?:XC14|XC[46]|TX30)(?:[);/ ]|$)|MAUI.+Winmax_BD45", device: "smartphone", models: [{ regex: "Winmax[ _](XC14|XC[46])(?:[);/ ]|$)", model: "$1" }, { regex: "Winmax[ _](TX30)(?:[);/ ]|$)", device: "tablet", model: "$1" }, { regex: "MAUI.+Winmax_(BD45)", device: "feature phone", model: "$1" }] }, Qde = { regex: " (TC5[16]|TC2[05]|TC75|TC7[05]x|TC700H)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, jde = { regex: "Thuraya[ _](X5-Touch)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Zde = { regex: "Bphone[ _](B111[45]|B2017)(?:[);/ ]|$)", device: "smartphone", model: "Bphone $1" }, zde = { regex: "(BPRIME|BSTAR\\+?|BPRIMES|B-ONE)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, qde = { regex: "GAMETAB-ONE(?:[);/ ]|$)", device: "tablet", model: "GameTab-One" }, Jde = { regex: "(Atractivo)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, eue = { regex: "ASANZO[ _](?:A2|S[23]|[SZ]5|S3_PLUS)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ASANZO[ _]S3[ _]PLUS", model: "S3 Plus" }, { regex: "ASANZO[ _](A2|S[23]|[SZ]5)(?:[);/ ]|$)", model: "$1" }] }, tue = { regex: "Artizlee[ _]S9|ATL-(?:16|21(?:PLUS|[XT])?|31|26)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "ATL-21PLUS(?:[);/ ]|$)", model: "ATL-21 Plus" }, { regex: "(ATL-(?:16|21[XT]?|31|26))(?:[);/ ]|$)", model: "$1" }, { regex: "Artizlee[ _]S9", device: "smartphone", model: "S9" }] }, rue = { regex: "(?:Coolmintt(?:A3|M2)?|Ultramintt(?:S2)?|FRESHMINTT(?:A7|A10)?)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Coolmintt ?([PM]1|P3|A3|M2)(?:[);/ ]|$)", model: "CoolMintt $1" }, { regex: "Ultramintt ?([SR]1|S2)(?:[);/ ]|$)", model: "UltraMintt $1" }, { regex: "FRESHMINTT ?(A7|A10)(?:[);/ ]|$)", device: "tablet", model: "FreshMintt $1" }] }, oue = { regex: "(?:186HS2080531|186HS1050531|186HS1050232|186FT1080231|185FT5050231|PREMIO[ _](?:S50|P420|P451))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "186HS2080531", model: "X1" }, { regex: "186HS1050531", model: "P541" }, { regex: "185FT5050231", model: "P511" }, { regex: "186FT1080231", model: "P571" }, { regex: "186HS1050232", model: "P630" }, { regex: "PREMIO[ _](S50|P420|P451)(?:[);/ ]|$)", model: "$1" }] }, nue = { regex: "Passion[-_](?:1S|PRO|PLUS)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Passion-1S", model: "Passion 1S" }, { regex: "Passion-Plus", model: "Passion Plus" }, { regex: "Passion_Pro", model: "Passion Pro" }] }, aue = { regex: "(?:33GT HD|WV8R-M|WV8R[_-]N)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "33GT HD", model: "Wave 8 HD+" }, { regex: "WV8R-M", model: "Wave 8 Red Marshmallow" }, { regex: "WV8R[_-]N", model: "Wave 8 Red Nougat" }] }, lue = { regex: "Siragon|(?:SP-(?:5250|5400|5050))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:Siragon[_ ])?(SP-(?:5[12]50|5400|5050))", model: "$1" }] }, iue = { regex: "Poppox P3", device: "smartphone", model: "P3" }, sue = { regex: "C-723ULTRA(?:[);/ ]|$)", device: "tablet", model: "C-723 Ultra" }, due = { regex: "(Apollo 5 Neo)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, uue = { regex: " OpelMobile_(SmartJX)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, cue = { regex: "NEO \\[Reloaded\\](?:[);/ ]|$)", device: "smartphone", model: "NEO Reloaded" }, mue = { regex: "(K1 Trio)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, gue = { regex: "Sansui[_ ]", device: "smartphone", models: [{ regex: "Sansui[_ ](Switch|Play|Fun|SA4[01]|U4[56]|U3[02]|Nova)(?:[);/ ]|$)", model: "$1" }] }, fue = { regex: "SICO[_ ](?:PLUS|e1002)|Express3-Max|SSR3-1-51-5M|SSD-1-53-13M", device: "smartphone", models: [{ regex: "SICO[_ ]PLUS2", model: "Plus 2" }, { regex: "SICO[_ ]PLUS", model: "Plus" }, { regex: "SSR3-1-51-5M", model: "Pro 3" }, { regex: "SSD-1-53-13M", model: "Diamond" }, { regex: "SICO[_ ]e1002", device: "tablet", model: "E1002" }, { regex: "Express3-Max", device: "tablet", model: "Express 3 Max" }] }, pue = { regex: "Android.+(?:Safari)(?!/[\\d.]+)(?: Build|\\) AppleWebKit)|SMADL[ _]", device: "smartphone", models: [{ regex: "Android.+(?:Safari)(?!/[\\d.]+)(?: Build|\\) AppleWebKit)", model: "Safari" }, { regex: "SMADL[ _]Matri([2X])", model: "Matri $1" }] }, hue = { regex: "(EX7SL?4|EX10S4)(?:[);/ ]|$)", device: "tablet", model: "$1" }, xue = { regex: "Tymes[ _](V5)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, vue = { regex: "SOLONE|(?:E1457|W145[02])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "E1457", model: "Earth Iron E1457" }, { regex: "W1450", model: "Wind Breeze W1450" }, { regex: "W1452", model: "Wind Air W1452" }, { regex: "SOLONE A47", model: "SL-A47" }, { regex: "SOLONE[ _]Elite[ _]L5501", model: "Elite L5501" }, { regex: "SOLONE[ _]SUMO[_ ]S5001", model: "Sumo S5001" }, { regex: "SOLONE[ _](SL-K40|S5002)(?:[);/ ]|$)", model: "$1" }] }, Sue = { regex: "Smart ?(601|550|50[59])(?:[);/ ]|$)", device: "smartphone", model: "Smart $1" }, bue = { regex: "Smailo_(2GO)(?:[);/ ]|$)", device: "tablet", model: "$1" }, yue = { regex: "(?:Colors[ _](S(?:[19]|11)|P70|P[456]5|P32|E15|P50 Plus)|Pride_1A|P52_Pride5C|P90_Pride5X)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Pride_1A(?:[);/ ]|$)", model: "Pride 1A" }, { regex: "P52_Pride5C(?:[);/ ]|$)", model: "Pride 5C" }, { regex: "P90_Pride5X(?:[);/ ]|$)", model: "Pride 5X" }, { regex: "Colors[ _](S(?:[19]|11)|P70|E15|P[456]5|P32|P50 Plus)(?:[);/ ]|$)", model: "$1" }] }, wue = { regex: "(EDA50K?|EDA70|EDA51)(?:[);/ ]|$)", device: "smartphone", model: "ScanPal $1" }, _ue = { regex: "electroneum(M1)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Tue = { regex: "Pluzz[_-](Z552|PL5[05]10|PL4010|PL501[46]|Elite_Dual)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Aue = { regex: "IUNI[ _]", device: "smartphone", models: [{ regex: "IUNI[ _](U3|i1|N1)", model: "$1" }] }, Pue = { regex: "(LeNumero1)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Mue = { regex: "(M002[DGQK]-2|M002N|M002N-3T|M002W-2T|6M-3T)(?:[);/ ]|$)", device: "tablet", model: "$1" }, $ue = { regex: "Einstein(T3)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Cue = { regex: "(CYGNUSX?|Gravity Z2|ChampionPro)(?:[);/ ]|$)", device: "phablet", models: [{ regex: "CYGNUSX(?:[);/ ]|$)", model: "Cygnus X" }, { regex: "CYGNUS(?:[);/ ]|$)", model: "Cygnus" }, { regex: "Gravity Z2(?:[);/ ]|$)", device: "smartphone", model: "Gravity Z2" }, { regex: "ChampionPro(?:[);/ ]|$)", device: "smartphone", model: "Champion Pro" }] }, Lue = { regex: "(CTAB1044hn|CTAB-1044)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Eue = { regex: "(?:CP6001A)(?:[);/ ]|$)", device: "smartphone", model: "Connect Core 6" }, Oue = { regex: "(?:CLEMPAD[_ ](?:6_XL|HR_Plus|HR|[68]|7_S|201[89])|ClemPhone_7|MFC_(?:2018|8))(?:[);/ ]|$)", device: "tablet", models: [{ regex: "CLEMPAD_(201[89])", model: "Clempad ($1)" }, { regex: "MFC_2018", model: "Clempad (2018)" }, { regex: "MFC_8", model: "Clempad 8" }, { regex: "CLEMPAD_7_S", model: "Clempad 7S" }, { regex: "Clempad[_ ](6_XL|HR_Plus|HR|[68])", model: "Clempad $1" }, { regex: "ClemPhone[ _](7)", device: "smartphone", model: "Clemphone $1" }] }, Nue = { regex: "(?:Camellia_II|Cactus II|Maple III|Maple-II|Cactus-Pro|LavenderII|Jasmine-II)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(Camellia_II|Cactus II|Maple III)(?:[);/ ]|$)", model: "$1" }, { regex: "Cactus-Pro", model: "Cactus Pro" }, { regex: "(Maple|Jasmine|Lavender)-?II(?:[);/ ]|$)", model: "$1 II" }] }, Due = { regex: "(?:Cool_Extreme_2|Earn|Fashion2Plus|Fashion[ _]C|Cool Duo|CHIC_X1)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(Cool_Extreme_2|Earn|Fashion[ _]C|Cool Duo)(?:[);/ ]|$)", model: "$1" }, { regex: "Fashion2Plus", model: "Fashion 2 Plus" }, { regex: "CHIC_X1", model: "Chic X1" }] }, kue = { regex: "Eagle[ _](Classic Pro|Elite|Gold)(?:[);/ ]|$)", device: "tv", model: "$1" }, Gue = { regex: "(Fighter|Eager)(?: Build|[;)])", device: "smartphone", model: "$1" }, Bue = { regex: "Claresta[ _]|(?:AirPhoneS[56]|AirPhone K6)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "AirPhone ?(S[56]|K6)", model: "AirPhone $1" }, { regex: "Claresta (F3) PRO", model: "$1 Pro" }, { regex: "Claresta[ _](F4)", model: "$1" }] }, Iue = { regex: "(?:Camfone (?:SE)|Hero[_ ](?:H5\\+|SE2|H9|(?:H7|XR)_Plus|SX|1[123]|SE3[ _]Max)|Honey (?:Y1|Y2s))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(Hero[_ ](?:H5\\+|SE2|H9|(?:H7|XR)_Plus|SX|1[123]|SE3[ _]Max)|Honey (?:Y1|Y2s))(?:[);/ ]|$)", model: "$1" }, { regex: "Camfone (SE)(?:[);/ ]|$)", model: "$1" }] }, Rue = { regex: "Bp100 X-Plus(?:[);/ ]|$)", device: "smartphone", model: "BP 100 X-Plus" }, Fue = { regex: "Gini[ _]", device: "smartphone", models: [{ regex: "Gini[ _]W(7)", model: "W$1" }, { regex: "Gini[ _]n(8)", model: "N$1" }, { regex: "Gini[ _]s5Pro", model: "S5 Pro" }, { regex: "Gini[ _]Tab[ _](V[78])", device: "tablet", model: "Tab $1" }] }, Vue = { regex: "(Caryota [1245789]|Jazz J[13] 2018)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(Caryota [1245789])(?:[);/ ]|$)", model: "$1" }, { regex: "Jazz (J[13]) 2018", model: "Jazz $1 (2018)" }] }, Hue = { regex: "Jesy_(J7)", device: "smartphone", model: "$1" }, Uue = { regex: "Preo[ _]", device: "smartphone", models: [{ regex: "Preo Teknosa P1", model: "Preo P1" }, { regex: "Preo[ _]P([23])", model: "Preo P$1" }] }, Xue = { regex: "(?:Pryme 01|ST01)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Pryme 01", model: "Pryme 01" }, { regex: "ST01", model: "Storm ST01" }] }, Wue = { regex: "OCTA T720Q(?:[);/ ]|$)", device: "tablet", model: "Octa T720Q" }, Yue = { regex: "(?:Cavion[_ ](?:Solid[_ ]4[\\._]5|Base[ _](?:7|7_3G_Silver|5\\.0|10|7.2 Quad)|10_3GRQ)|Cavion7.1quad)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Cavion[_ ]Solid[_ ]4[\\._]5", model: 'Solid 4.5"' }, { regex: "Cavion BASE 5.0", model: 'Base 5.0"' }, { regex: "CAVION_10_3GRQ", device: "tablet", model: "Base 10 3GR Quad" }, { regex: "Cavion(?:7.1quad)", device: "tablet", model: 'Base 7.1" Quad' }, { regex: "Cavion Base 7.2 Quad", device: "tablet", model: 'Base 7.2" Quad' }, { regex: "Cavion Base 10", device: "tablet", model: "Base 10" }, { regex: "Cavion Base 7 Dual", device: "tablet", model: 'Base 7.0" Dual' }, { regex: "Cavion Base 7 Quad", device: "tablet", model: 'Base 7.0" Quad' }, { regex: "Cavion_Base_7_3G_Silver", device: "tablet", model: 'Base 7.0" 3G Silver' }] }, Kue = { regex: "GLX (?:Aria|Dorna|Taban|Shine|Spark|ASA)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "GLX ASA", model: "Asa" }, { regex: "GLX (Aria|Taban|Shine|Spark)(?:[);/ ]|$)", model: "$1" }, { regex: "GLX (Dorna)(?:[);/ ]|$)", device: "tablet", model: "$1" }] }, Que = { regex: "Seeken[ _-]", device: "smartphone", models: [{ regex: "Seeken[_ -](SG1|SJ1)", model: "$1" }, { regex: "Seeken[_ -](ST-101)", device: "tablet", model: "$1" }] }, jue = { regex: "(?:Revolution TnT3|Xtreme_(?:[37]|3x)|Xtreme (?:XT84|XT309 Plus|1))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Revolution (TnT3)", model: "Revolution $1" }, { regex: "Xtreme (XT84)", model: "Xtreme Klick $1" }, { regex: "Xtreme (XT309) Plus", model: "Xtreme View Pro $1Plus" }, { regex: "Xtreme[ _]([137]|3x)(?:[);/ ]|$)", model: "Xtreme $1" }] }, Zue = { regex: "Winnovo[ _]", device: "tablet", models: [{ regex: "Winnovo[ _](M866|M798|VTab|750[PK])(?:[);/ ]|$)", model: "$1" }, { regex: "Winnovo[ _](K5[46]|K43)[a-z]{2}", device: "smartphone", model: "$1" }] }, zue = { regex: "WE (A[15]0|B3|F[12]0|E[12]|L[3469]|R[34]|V[34]|S1|X[13]|T1)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, que = { regex: "Trio V51 DT(?:[);/ ]|$)", device: "smartphone", model: "V51DT" }, Jue = { regex: "(AUTOID9N)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, ece = { regex: "(?:Centric[- ]CM(?:5001|33[23]1|3321Plus)|CM4331)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(?:Centric[- ])?CM5001", model: "A1" }, { regex: "(?:Centric[- ])?CM3321Plus", model: "P1 Plus" }, { regex: "(?:Centric[- ])?CM3321", model: "P1" }, { regex: "(?:Centric[- ])?CM3331", model: "L3" }, { regex: "(?:Centric[- ])?CM4331", model: "G1" }] }, tce = { regex: "Kata[ _-]", device: "smartphone", models: [{ regex: "Kata[ _-](C3|L1|M3s|M4|V[56])(?:[);/ ]|$)", model: "$1" }, { regex: "Kata[ _-]i5-\\w", model: "I5" }, { regex: "Kata-(T5)(?:[);/ ]|$)", device: "tablet", model: "$1" }, { regex: "Kata-Tmini4(?:[);/ ]|$)", device: "tablet", model: "T Mini 4" }, { regex: "Kata Box 2(?:[);/ ]|$)", device: "tv", model: "Box 2" }] }, rce = { regex: "Leff Shell (?:HV320WHB-N55|LC390TA2A)(?:[);/ ]|$)", device: "tv", model: "" }, oce = { regex: "ODROID[-]?(C2|U2|XU[34])(?:[);/ ]|$)", device: "peripheral", model: "ODROID $1" }, nce = { regex: "WISENET5(?:[);/ ]|$)", device: "peripheral", model: "WISENET5" }, ace = { regex: "([65]5|4[03]|3[29]|28)LEX[-_](81(?:27|39|45|58|61)|71(?:[23]7|4[345]|5[45]|6[368]|[57]8))[_/]([FU]?TS2C)(?:[);/ ]|$)", device: "tv", model: "$1LEX-$2/$3" }, lce = { regex: "WESTPOINT[;,]", device: "tv", models: [{ regex: "(TETS-4919SM)", model: "$1" }] }, ice = { regex: "Q93S", device: "tablet", model: "Q93S" }, sce = { regex: "(AT702)(?:[);/ ]|$)", device: "tablet", model: "$1" }, dce = { regex: "Seatel", device: "smartphone", models: [{ regex: "Seatel[ _](L2|V8[AE]|T[5-8]|R6|V[89])(?:[);/ ]|$)", model: "$1" }] }, uce = { regex: "(M1092R(?:-[12]|V[45])?)(?:[);/ ]|$)", device: "tablet", model: "$1" }, cce = { regex: "(K908H4G)(?:[);/ ]|$)", device: "tablet", model: "$1" }, mce = { regex: "Formuler[ _]", device: "tv", models: [{ regex: "Formuler[ _](Z8(?: Pro)?)(?:[);/ ]|$)", model: "$1" }] }, gce = { regex: "(?:Build/)?Malata[ _]?([a-z0-9]+)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, fce = { regex: "IT-(?:1101S?|1101-QUAD)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "IT-1101-QUAD", model: "1101 Quad" }, { regex: "IT-(1101S?)", model: "$1" }] }, pce = { regex: "NP-752Go(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "NP-752Go", model: "NP-752 Go" }] }, hce = { regex: "(?:JK(?:960|103) 3G|JK-?760)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "JK-?(760)(?:[);/ ]|$)", model: "JK-$1" }, { regex: "JK(960|103) 3G(?:[);/ ]|$)", device: "tablet", model: "JK-$1 3G" }] }, xce = { regex: "(MFSTAB(?:_74G)?)(?:[);/ ]|$)", device: "peripheral", model: "$1" }, vce = { regex: "(?:MEMOR 10)(?:[);/ ]|$)", device: "smartphone", model: "Memor 10" }, Sce = { regex: "NAVITEL[ _]", device: "tablet", models: [{ regex: "NAVITEL[ _](T70[07]) 3G(?:[);/ ]|$)", model: "$1 3G" }, { regex: "NAVITEL[ _](T757)LTE(?:[);/ ]|$)", model: "$1 LTE" }, { regex: "NAVITEL[ _](A73[0157]|A650)(?:[);/ ]|$)", model: "$1" }, { regex: "RE900 Full HD(?:[);/ ]|$)", model: "RE900 Full HD" }] }, bce = { regex: "LI(22)(?:[);/ ]|$)", device: "smartphone", model: "Li $1" }, yce = { regex: "(ST1009)(?:[);/ ]|$)", device: "tablet", model: "$1" }, wce = { regex: "SuperTab(A10|K7|S7G)(?:[);/ ]|$)", device: "tablet", model: "$1" }, _ce = { regex: "SUZUKI[ _]|(?:ECOPAD7|SUMOPad10)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "SUMOPAD(8100|10)(?:[);/ ]|$)", model: "SumoPad $1" }, { regex: "ECOPAD7", model: "ECOPad 7" }] }, Tce = { regex: "Philips|AND1E(?:[);/ ]|$)|NETTV/|PI3210G|TLE(821L|722G)|TPM1[79]1E|70PUH6774_96|QM16[134]E|Xenium S[25]66|S397|W5510", device: "smartphone", models: [{ regex: "(?:Philips[_ ])?Xenium[ _](S[25]66|V787)(?:[);/ ]|$)", model: "Xenium $1" }, { regex: "(?:Philips[_ ])?(S397|W5510)(?:[);/ ]|$)", model: "$1" }, { regex: "AND1E(?: TV)?(?:[);/ ]|$)", model: "Android TV", device: "tv" }, { regex: "(PI3210G)", model: "$1", device: "tablet" }, { regex: "(TPM1[79]1E)", model: "$1", device: "tv" }, { regex: "(QM16[134]E)", model: "$1", device: "tv" }, { regex: "(70PUH6774)_96", model: "$1/96 4K UHD", device: "tv" }, { regex: "(TLE821L)(?:[);/ ]|$)", model: "$1 4G LTE", device: "tablet" }, { regex: "(TLE722G)(?:[);/ ]|$)", model: "$1", device: "tablet" }, { regex: "Philips, BDP([0-9]{4})", model: "Blu-ray Player (BDP$1)", device: "tv" }, { regex: "Philips, ([a-z0-9-]+)", model: "$1", device: "tv" }, { regex: "(NETTV/[0-9\\.]{5})", model: "NetTV Series", device: "tv" }, { regex: "Philips-FISIO ([a-z0-9]+)", model: "Fisio $1" }, { regex: "Philips[ _-]?([a-z0-9\\-@]+)", model: "$1" }] }, Ace = { regex: "(KZCAR)(?:[);/ ]|$)", device: "car browser", model: "$1" }, Pce = { regex: "(?:DMTAB-(?:IN08A|NV08B|NV2[04]A)|NBTY07SMKG|NBFP07PMKG|SNB02-NV7A|NABI2-NV7A)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "DMTAB-(?:IN08A|NV08B)", model: 'Dream Tab HD 8.0"' }, { regex: "DMTAB-NV(2[04])A", model: 'Big Tab HD $1.0"' }, { regex: "NBTY07SMKG", model: 'Barbie Tab 7.0"' }, { regex: "NBFP07PMKG", model: 'Fisher Price Learning Tab 7.0"' }, { regex: "SNB02-NV7A", model: "2S Tab" }, { regex: "NABI2-NV7A", model: "2 Tab" }] }, Mce = { regex: "StrawBerry[ _]", device: "smartphone", models: [{ regex: "StrawBerry[ _](SX|QX15)(?:[);/ ]|$)", model: "$1" }] }, $ce = { regex: "Gresso[ _]", device: "smartphone", models: [{ regex: "Gresso[ _]Regal(?:[);/ ]|$)", model: "Regal" }] }, Cce = { regex: "Pendoo|A5X MAX(?:[\\.-]\\w+)?\\.01\\.d4", device: "tv", models: [{ regex: "Pendoo ?(T95Z|X10) PLUS", model: "$1 Plus" }, { regex: "Pendoo ?X8PRO+", model: "X8 Pro+" }, { regex: "Pendoo[ \\.]?(X9[29])", model: "$1" }, { regex: "pendoo mini", model: "Mini" }, { regex: "A5X MAX(?:[\\.-]\\w+)?\\.01\\.d4", model: "A5X Max" }] }, Lce = { regex: "Pipo[_ ]|PipoM9Pro", device: "tablet", models: [{ regex: "Pipo[_ ]([TP]9)", model: "$1" }, { regex: "PipoM9Pro", model: "M9 Pro" }, { regex: "PIPO[_ ](X10|X9S)", device: "tv", model: "$1" }] }, Ece = { regex: "(EN1007Q)plus(?:[);/ ]|$)", device: "tv", model: "$1 Plus" }, Oce = { regex: "(SK-Mtek GT730[15])(?:[);/ ]|$)", device: "tablet", model: "$1" }, Nce = { regex: "(TVB-906X)(?:[);/ ]|$)", device: "tv", model: "$1" }, Dce = { regex: "(Zero18)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, kce = { regex: "VULKANO(?:[);/ ]|$)", device: "smartphone", model: "Vulkano" }, Gce = { regex: "SOLE[_ ]POP[_ ]S([45]0)(?:[);/ ]|$)", device: "smartphone", model: "Pop S$1" }, Bce = { regex: "SOLO[_ ](Aspire(?: M)?)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Ice = { regex: "OINOM[_ ](V9D|V7H|V[679])(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Rce = { regex: "Singtech|(?:Sapphire[_ ](?:H50S|H7S?|H90))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Sapphire[_ ](H50S|H7S?|H90)(?:[);/ ]|$)", model: "Sapphire $1" }, { regex: "Singtech[ _](Q2|S1)(?:[);/ ]|$)", model: "$1" }] }, Fce = { regex: "(SS4G9 Mira|SS4G7 Sole|SS4G1 Luna|SS4G8 Nora|SS4G6 Lola)(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Vce = { regex: "TEENO", device: "smartphone", models: [{ regex: "TEENO[_ ](S9|A1|S11)(?:[);/ ]|$)", model: "$1" }] }, Hce = { regex: "(TEG9300)(?:[);/ ]|$)", device: "peripheral", model: "$1" }, Uce = { regex: "ASPERA|(?:Wren)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ASPERA[ _](R5h|RT3|A4[02]|A50)(?:[);/ ]|$)", model: "$1" }, { regex: "Wren(?:[);/ ]|$)", model: "Wren" }] }, Xce = { regex: "SMART_VOLT_NX5(?:[);/ ]|$)", device: "smartphone", model: "Smart Volt NX5" }, Wce = { regex: "(Amaze[ _](?:S2_4G|S[56] 4G|S1|S[56](?: Plus)?))(?:[);/ ]|$)", device: "smartphone", model: "$1" }, Yce = { regex: "Bison2021(?:[);/ ]|$)", device: "smartphone", model: "B2021" }, Kce = { regex: "BilimBook mini(?:[);/ ]|$)", device: "desktop", model: "BilimBook Mini" }, Qce = { regex: "X1_Light_Lte(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "X1_Light_Lte", model: "X1 Light LTE" }] }, jce = { regex: "(KA-E410W)(?:[);/ ]|$)", device: "tablet", model: "$1" }, Zce = { regex: "(?:PRESIDENT_GOLD_(9|10))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "PRESIDENT_GOLD_(9|10)", model: "President Gold $1" }] }, zce = { regex: "KINGZONE_", device: "smartphone", models: [{ regex: "KINGZONE_(N5)(?:[);/ ]|$)", model: "$1" }] }, qce = { regex: "FAN-M300H(?:[);/ ]|$)", device: "smartphone", model: "M300H" }, Jce = { regex: "(TB-703G)(?:[);/ ]|$)", device: "tablet", model: "$1" }, eme = { regex: "YUHO_", device: "smartphone", models: [{ regex: "YUHO_(O2|H2|Y[123])_PRO", model: "$1 Pro" }, { regex: "YUHO_Vast_Plus", model: "Vast Plus" }, { regex: "YUHO_Y1_ACE", model: "Y1 Ace" }, { regex: "YUHO_Y1_STAR", model: "Y1 Star" }, { regex: "YUHO_O1_LITE", model: "O1 Lite" }, { regex: "YUHO_(Vast2?|O[12]|Y2)(?:[);/ ]|$)", model: "$1" }] }, tme = {
  360: { regex: "(?:180[1379]-A01|1713-A01|1707-A01|1509-A00|1603-A03|1607-A01|1503-A01)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "1807-A01(?:[);/ ]|$)", model: "N7" }, { regex: "1803-A01(?:[);/ ]|$)", model: "N7 Lite" }, { regex: "1809-A01(?:[);/ ]|$)", model: "N7 Pro" }, { regex: "1713-A01(?:[);/ ]|$)", model: "N6 Lite" }, { regex: "1707-A01(?:[);/ ]|$)", model: "N6" }, { regex: "1801-A01(?:[);/ ]|$)", model: "N6 Pro" }, { regex: "1509-A00(?:[);/ ]|$)", model: "Q5 Plus" }, { regex: "1503-A01(?:[);/ ]|$)", model: "N4" }, { regex: "1603-A03(?:[);/ ]|$)", model: "N4A" }, { regex: "1607-A01(?:[);/ ]|$)", model: "N5S" }] },
  8848: { regex: "8848 (M[3-6])(?:[);/ ]|$)", device: "smartphone", model: "$1" },
  Ace: VZ,
  "Tunisie Telecom": { regex: "StarTrail TT(?:[);/ ]|$)", device: "smartphone", model: "StarTrail by TT" },
  SFR: HZ,
  HTC: UZ,
  Microsoft: XZ,
  Nokia: WZ,
  CnM: YZ,
  RIM: KZ,
  CHIA: QZ,
  Palm: jZ,
  HP: ZZ,
  TiPhone: zZ,
  Apple: qZ,
  MicroMax: JZ,
  "3Q": { regex: "AC0731B|AC1024C|AC7803C|BC9710AM|EL72B|LC0720C|LC0723B|LC0725B|LC0804B|LC0808B|LC0809B|LC0810C|LC0816C|LC0901D|LC1016C|MT0724B|MT0729[BD]|MT0811B|OC1020A|RC0709B|RC0710B|RC0718C|RC0719H|RC0721B|RC0722C|RC0726B|RC0734H|RC0743H|RC0817C|RC1018C|RC1019G|RC1025F|RC1301C|RC780[24]F|RC9711B|RC9712C|RC9716B|RC9717B|RC9724C|RC9726C|RC9727F|RC9730C|RC9731C|TS0807B|TS1013B|VM0711A|VM1017A|RC0813C|QS9719D|QS9718C|QS9715F|QS1023H|QS0815C|QS0730C|QS0728C|QS0717D|QS0716D|QS0715C|MT7801C|TS9708B|AC0732C|MT0739D|MT0812E|(?:3Q_)?ER71B", device: "tablet", models: [{ regex: "MT0724B|LC0901D|LC0816C|LC0810C|LC0809B|LC0808B|LC0804B|LC0725B|LC0723B", model: "Qoo! P-Pad" }, { regex: "VM1017A|TS1013B|TS0807B|RC9731C|RC9730C|RC9727F|RC9726C|RC9724C|RC9717B|RC9716B|RC9712C|RC9711B|RC1301C|RC1025F|RC1019G|RC1018C|RC0817C|RC0813C|RC0743H|RC0734H|RC0726B|RC0722C|RC0721B|RC0719H|RC0718C|RC0710B|RC0709B|QS9715F|QS1023H|QS0815C|QS0730C|QS0728C|QS0717D|QS0716D|QS0715C|MT0811B|MT0739D|MT0729[BD]|LC1016C|LC0720C|BC9710AM|AC1024C|AC0731B", model: "Qoo! Q-Pad" }, { regex: "MT7801C|QS9718C|QS9719D|VM0711A|OC1020A", model: "Qoo! Surf" }, { regex: "TS9708B", model: "Surf TS1009B" }, { regex: "AC7803C|AC0732C", model: "Qoo! Lite" }, { regex: "MT0812E|RC7802F", model: "Qoo! Meta" }, { regex: "EL72B|(?:3Q_)?ER71B", model: "Qoo! Q-Book" }, { regex: "(RC7804F)", model: "Qoo! Glaze" }] },
  "4Good": { regex: "4Good[ _]|S450m [43]G|S555m 4G|S501m 3G|T700i_3G|People (?:G503|G410|GT300)|Light (?:A103|B100)", device: "smartphone", models: [{ regex: "T700i_3G", model: "T700i 3G", device: "tablet" }, { regex: "People GT300", model: "People GT300", device: "tablet" }, { regex: "S555m[_ ]4G", model: "People" }, { regex: "(S(?:450m|501m)[_ ][43]G|Light (?:A103|B100)|People (?:G503|G410))", model: "$1" }, { regex: "4Good[ _]([^;/]+) Build", model: "$1" }, { regex: "4Good[ _]([^);/ ]+)", model: "$1" }] },
  Acteck: ez,
  Alba: tz,
  AllCall: rz,
  Bravis: oz,
  Acer: nz,
  Advan: az,
  Advance: lz,
  AGM: iz,
  Airness: sz,
  Aiwa: dz,
  Akai: uz,
  "Arian Space": { regex: "Arian Space", device: "tablet", models: [{ regex: "100 ST1004PG", model: "100" }, { regex: "80 SS8003PG", model: "80" }, { regex: "71 ST7002PG", model: "71" }, { regex: "70 ST7001RW", model: "70" }] },
  Alcatel: cz,
  Allview: mz,
  Allwinner: gz,
  altron: fz,
  AMGOO: pz,
  Amoi: hz,
  Ainol: xz,
  Archos: vz,
  Axxion: Sz,
  MEU: bz,
  Arnova: yz,
  ARRIS: wz,
  Ask: _z,
  ANS: Tz,
  AOC: Az,
  Assistant: Pz,
  Ark: Mz,
  "Garmin-Asus": { regex: "Garmin-Asus|Garminfone", device: "smartphone", models: [{ regex: "Garminfone[ \\-_]([^;/]*)Build", model: "Garminfone $1" }, { regex: "Garmin-Asus[ \\-_]([^;/]+)Build", model: "$1" }, { regex: "Garmin-Asus[ \\-_]([^;/]+)[\\)/]", model: "$1" }] },
  Asus: $z,
  Audiovox: Cz,
  AVH: Lz,
  Avvio: Ez,
  "Azumi Mobile": { regex: "Azumi[_ -]|(?:SPEED55|A50_Style_Plus)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Azumi[_ -]([^/;]+) Build", model: "$1" }, { regex: "Azumi[_ -]([a-z0-9_]+)", model: "$1" }, { regex: "SPEED55", model: 'Speed 5.5"' }, { regex: "A50_Style_Plus", model: "A50 Style Plus" }] },
  "Barnes & Noble": { regex: "Nook|BN[TR]V[0-9]+", device: "tablet", models: [{ regex: "Nook([a-z0-9]+)", model: "Nook $1" }, { regex: "Nook[ _]([^/;]+)[ _]Build", model: "Nook $1" }, { regex: "(BN[TR]V[0-9]+)", model: "Nook $1" }] },
  BGH: Oz,
  Bitel: Nz,
  Blu: Dz,
  Bluegood: kz,
  Blackview: Gz,
  Bluboo: Bz,
  "Black Fox": { regex: "BMM[ _-]?(?:44[123]D|441[WB]|44[12]S|431D|533D|54[12]S|541[ABW]|54[123]D|543S|531[ABD]|532 S)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "BMM443D", model: "B7 Fox+" }, { regex: "BMM441S", model: "B8 Fox" }, { regex: "BMM442S|BMM441B", model: "B8 Fox+" }, { regex: "BMM441W", model: "B8M" }, { regex: "BMM442D", model: "B7" }, { regex: "BMM531D", model: "B6" }, { regex: "BMM531A", model: "B5" }, { regex: "BMM541A", model: "B5+" }, { regex: "BMM543[DS]", model: "B4" }, { regex: "BMM441D", model: "B4 Mini" }, { regex: "BMM541B", model: "B4 Mini NFC" }, { regex: "BMM531B", model: "B4 Mini (2019)" }, { regex: "BMM542D", model: "B3+" }, { regex: "BMM541D", model: "B3" }, { regex: "BMM541W", model: "B7R Fox" }, { regex: "BMM 532 S", model: "BMM 532S" }, { regex: "BMM[ _-]?(533D|431D|54[12]S)(?:[);/ ]|$)", model: "BMM $1" }] },
  bogo: Iz,
  Boway: Rz,
  Brondi: Fz,
  "VGO TEL": { regex: "(?:Venture V(?:[278]|12)|Ocean[_ ][689]|Ocean9L)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Venture V([278]|12)(?:[);/ ]|$)", model: "Venture V$1" }, { regex: "Ocean[_ ]?([689]|9L)(?:[);/ ]|$)", model: "Ocean $1" }] },
  Vivo: Vz,
  Vinsoc: Hz,
  Bird: Uz,
  Becker: Xz,
  Beeline: Wz,
  Beetel: Yz,
  "BenQ-Siemens": { regex: "BENQ-SIEMENS - ([a-z0-9]+)", device: "feature phone", model: "$1" },
  BenQ: Kz,
  Blaupunkt: Qz,
  Bmobile: jz,
  bq: Zz,
  Bush: zz,
  CAGI: qz,
  Capitel: Jz,
  Captiva: eq,
  Casio: tq,
  Casper: rq,
  Cat: oq,
  Carrefour: nq,
  Celkon: aq,
  Changhong: lq,
  "Cherry Mobile": { regex: "Cherry|Superion S1 DTV|Flare([ _])?(2X|4|A[123]|J[123568]|P[13]|S[4-8]|X2|Y[367]|S Play|HD|LITE|XL|X_V2|Y3s|Tab)(?:[ _](?:Pro|Plus|Max|LTE))?|Fusion Bolt|Omega[_ ](?:Icon 2|Icon Lite 2|lite[_ ][43][Cs]?|HD [45]|HD_Duo)|Spin Max 2|Selfie_Two", device: "smartphone", models: [{ regex: "(Flare2X)", model: "$1" }, { regex: "Flare[_ ]HD[_ ]([345])", model: "Flare HD $1" }, { regex: "Flare_HD_MAX", model: "Flare HD Max" }, { regex: "FLARE LITE", model: "Flare Lite" }, { regex: "Flare S Play", model: "Flare S Play" }, { regex: "Flare[_ ]J([26])S", model: "Flare J$1s" }, { regex: "Flare_(J2|S7)_Prime", model: "Flare $1 Prime" }, { regex: "Flare_S7_Deluxe", model: "Flare S7 Deluxe" }, { regex: "Flare_S7_Power", model: "Flare S7 Power" }, { regex: "Flare[_ ]Y([367])[_ ]Pro", model: "Flare Y$1 Pro" }, { regex: "Flare XL Plus", model: "Flare XL Plus" }, { regex: "Flare[ _]X[_ ]V2", model: "Flare X V2" }, { regex: "Flare[ _](A2|J3|P1|S[467])[ _]Lite", model: "Flare $1 Lite" }, { regex: "Flare[ _](J[12]|S[57]|Y3|J6)[ _]mini", model: "Flare $1 Mini" }, { regex: "Flare_J2_2018", model: "Flare J2 (2018)" }, { regex: "Flare S4 Max LTE", model: "Flare S4 Max LTE" }, { regex: "Flare[_ ](S[47]|J2)[_ ]Max", model: "Flare $1 Max" }, { regex: "FlareS5LiteDTV", model: "Flare S5 Lite DTV" }, { regex: "Flare[_ ](S[567]|J6)[_ ]Plus", model: "Flare $1 Plus" }, { regex: "FLARE S6 POWER", model: "Flare S6 Power" }, { regex: "Flare(?:[ _])?(4|A[123]|J8 LTE|J[13568]|P[13]|S[4-8]|X2|Y3s|Y7_LTE|Y[673])", model: "Flare $1" }, { regex: "OMEGA HD ([45])", model: "Omega HD $1" }, { regex: "Omega_HD_Duo", model: "Omega HD Duo" }, { regex: "Omega Icon Lite 2", model: "Omega Icon Lite 2" }, { regex: "Omega Icon 2", model: "Omega Icon 2" }, { regex: "Omega[_ ]Lite[_ ](3[Cs]|4)", model: "Omega Lite $1" }, { regex: "Spin Max 2", model: "Spin Max 2" }, { regex: "Selfie_Two", model: "Selfie Two" }, { regex: "(Fusion Bolt|Flare Tab Pro|Flare Tab|Superion S1 DTV)", model: "$1", device: "tablet" }, { regex: "Cherry(?:[ _]?Mobile)?[ _]?([^/;]+)(?: Build|[);])", model: "$1" }] },
  "China Mobile": { regex: "(M812C|1501_M02|9930i|A1303|A309W|M651CY) Build", device: "smartphone", models: [{ regex: "M651CY", model: "A3" }, { regex: "(M812C|1501_M02|9930i|A1303|A309W)", model: "$1" }] },
  Comio: iq,
  Compal: sq,
  Artel: dq,
  "ComTrade Tesla": { regex: "Tesla|Impulse 7.85 3G|Impulse 10.1 OCTA|Smartphone_6.1|SP(?:6.2|6.2_Lite)|TTL(?:713G|8)", device: "smartphone", models: [{ regex: "TeslaEvo5.0", model: "Evo 5.0" }, { regex: "(Gravity 9.7 SHD)", model: "$1", device: "tablet" }, { regex: "(Impulse 7.85 3G)", model: "$1", device: "tablet" }, { regex: "Impulse 10.1 OCTA", model: 'Impulse 10.1" OCTA', device: "tablet" }, { regex: "Tesla_SP([^/;]+)L Build", model: "Smartphone $1 Lite" }, { regex: "Smartphone_6.1", model: "Smartphone 6.1" }, { regex: "SP6.2_Lite", model: "Smartphone 6.2 Lite" }, { regex: "Tesla_SP([^/;]+) Build", model: "Smartphone $1" }, { regex: "SP([^/;]+) Build", model: "Smartphone $1" }, { regex: "Smartphone ([36])", model: "Smartphone $1" }, { regex: "Tesla_Tablet_785", model: '7.85"', device: "tablet" }, { regex: "TTH7", model: "H7", device: "tablet" }, { regex: "TTL7 Build", model: "L7", device: "tablet" }, { regex: "Tesla_Tablet_L7_3G", model: "L7 3G", device: "tablet" }, { regex: "(L7.1)", model: "$1", device: "tablet" }, { regex: "TTL713G", model: "L7.1 3G", device: "tablet" }, { regex: "(L7 Quad) Build", model: "$1", device: "tablet" }, { regex: "(L7 Quad Lite)", model: "$1", device: "tablet" }, { regex: "TTL8 Build", model: "L8", device: "tablet" }, { regex: "(L8.1)", model: "$1", device: "tablet" }, { regex: "TESLA_TABLET_M7", model: "M7", device: "tablet" }, { regex: "Tesla_Tablet_M8", model: "M8", device: "tablet" }] },
  ConCorde: uq,
  Condor: cq,
  Coolpad: mq,
  Clarmin: gq,
  CORN: fq,
  Cosmote: pq,
  Cricket: hq,
  "Crius Mea": { regex: "(Q7A\\+?)(?:[);/ ]|$)", device: "tablet", model: "$1" },
  Crosscall: xq,
  AllDocube: vq,
  Cube: Sq,
  CUBOT: bq,
  Clout: yq,
  Concord: wq,
  Crescent: _q,
  Cyrus: Tq,
  Datang: Aq,
  Datsun: Pq,
  Danew: Mq,
  Denver: $q,
  Dell: Cq,
  Desay: Lq,
  DEXP: Eq,
  Dbtel: Oq,
  Dialog: Nq,
  Dicam: Dq,
  Digi: kq,
  Digicel: Gq,
  Digiland: Bq,
  Digma: Iq,
  DoCoMo: Rq,
  Doogee: Fq,
  Doov: Vq,
  Dopod: Hq,
  Doro: Uq,
  "Dune HD": { regex: "DuneHD|SOLO 4K(?:[);/ ]|$)", device: "tv", models: [{ regex: "SOLO 4K(?:[);/ ]|$)", model: "Solo 4k" }, { regex: "DuneHD/\\d.\\d \\([a-z]+__([a-z0-9_-]+);", model: "$1" }, { regex: "DuneHD/\\d.\\d \\(([a-z0-9_-]+);", model: "$1" }] },
  DNS: Xq,
  "E-Boda": { regex: "E-Boda|Eclipse_(?:G400M|G500)", device: "smartphone", models: [{ regex: "E-Boda ((?:Revo|Izzycomm|Essential|Intelligence|Supreme)[^/;]+) Build", device: "tablet", model: "$1" }, { regex: "Eclipse_(G400M|G500)", model: "Eclipse $1" }, { regex: "E-Boda ([^/;]+) Build", model: "$1" }] },
  Easypix: Wq,
  EBEST: Yq,
  "Echo Mobiles": { regex: "ECHO[ _](HOLI|HORIZON|MAX|MOSS|NOTE|POWER|SMART|DUNE|JAVA|FUSION)|HORIZON_M|Stellar 3G|FEELING", device: "smartphone", models: [{ regex: "ECHO_HORIZON_LITE", model: "HORIZON Lite" }, { regex: "(HORIZON_M|FEELING)(?:[);/ ]|$)", model: "$1" }, { regex: "STELLAR 3G", model: "STELLAR 3G" }, { regex: "ECHO_SMART_4G", model: "SMART 4G" }, { regex: "ECHO[ _](HOLI|MAX|MOSS|NOTE|POWER|SMART|DUNE|JAVA|FUSION)", model: "$1" }] },
  ECS: Kq,
  EE: Qq,
  EKT: jq,
  "Eks Mobility": { regex: "S5LS|X4UPlus", device: "smartphone", models: [{ regex: "S5LS", model: "S5LS" }, { regex: "X4UPlus", model: "X4U Plus" }] },
  Elephone: Zq,
  Element: zq,
  Elenberg: qq,
  Ericy: Jq,
  Essential: eJ,
  "E-tel": { regex: "E-tel_i250", device: "smartphone", models: [{ regex: "E-tel[_ ]i250", model: "i250" }] },
  Evercoss: tJ,
  Eurostar: rJ,
  Eton: oJ,
  Essentielb: nJ,
  Facebook: aJ,
  Rikomagic: lJ,
  Rinno: iJ,
  Riviera: sJ,
  Senseit: dJ,
  Sony: uJ,
  Ergo: cJ,
  Ericsson: mJ,
  Energizer: gJ,
  "Energy Sistem": { regex: "ENERGY[ _-]?([^;/]+) Build|Energy Phone Pro 3", device: "smartphone", models: [{ regex: "Energy Phone Pro 3", model: "Energy Phone Pro 3" }, { regex: "ENERGY[ _-]?([^;/]+) Build", device: "tablet", model: "$1" }] },
  eTouch: fJ,
  Etuline: pJ,
  Storex: hJ,
  Evertek: xJ,
  Evolio: vJ,
  Evolveo: SJ,
  Explay: bJ,
  EvroMedia: yJ,
  EKO: wJ,
  Extrem: _J,
  Ezze: TJ,
  Ezio: AJ,
  Forstar: PJ,
  Foxconn: MJ,
  Fondi: $J,
  Fairphone: CJ,
  Famoco: LJ,
  FiGO: EJ,
  FNB: OJ,
  Fujitsu: NJ,
  "G-TiDE": { regex: "G-TiDE", device: "smartphone", models: [{ regex: "Shining7", model: "Shining 7" }, { regex: "G-TiDE_(A1|S[34])", model: "$1" }, { regex: "G-TiDE V6", model: "V6" }, { regex: "E(57|60|66|72|77)", model: "$1" }] },
  Gemini: DJ,
  "General Mobile": { regex: "GM 5 Plus|GM8 go|GM [68] d|GM 8|General Mobile 4G|GM 9 (?:Pro|Plus)|e-tab 20(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "GM 5 Plus", model: "GM 5 Plus" }, { regex: "GM ([68]) d", model: "GM $1D" }, { regex: "GM 8", model: "GM 8" }, { regex: "GM8 go", model: "GM 8 Go" }, { regex: "GM 9 Pro", model: "GM 9 Pro" }, { regex: "GM 9 Plus", model: "GM 9 Plus" }, { regex: "General Mobile 4G Dual", model: "4G Dual" }, { regex: "General Mobile 4G", model: "4G" }, { regex: "e-tab 20(?:[);/ ]|$)", device: "tablet", model: "E-Tab 20" }] },
  Geotel: kJ,
  Ghia: GJ,
  Gigabyte: BJ,
  Gigaset: IJ,
  Ginzzu: RJ,
  Gionee: FJ,
  Grape: VJ,
  Vizio: HJ,
  GOCLEVER: UJ,
  GoMobile: XJ,
  "Gol Mobile": { regex: "F10_PRIME", device: "smartphone", models: [{ regex: "F10_PRIME", model: "F10 Prime" }] },
  Goly: WJ,
  Google: YJ,
  Gradiente: KJ,
  Grundig: QJ,
  Hafury: jJ,
  Haier: ZJ,
  HannSpree: zJ,
  Hasee: qJ,
  Hisense: JJ,
  "Hi-Level": { regex: "HLV-T([a-z0-9]+)", device: "tablet", model: "HLV-T$1" },
  Hoffmann: eee,
  Homtom: tee,
  Hosin: ree,
  Hoozo: oee,
  Minix: nee,
  Huawei: aee,
  Hyundai: lee,
  "i-Joy": { regex: "i-Joy|i-Call|(?:Neon[79]|Sygnus|Deox|Elektra (?:M|L|XL|XXL))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Elektra M(?:[);/ ]|$)", model: "Elektra M" }, { regex: "Elektra L(?:[);/ ]|$)", model: "Elektra L" }, { regex: "Elektra XL(?:[);/ ]|$)", model: "Elektra XL" }, { regex: "Elektra XXL(?:[);/ ]|$)", model: "Elektra XXL", device: "phablet" }, { regex: "Neon([79])(?:[);/ ]|$)", model: "Neon $1", device: "tablet" }, { regex: "Sygnus(?:[);/ ]|$)", model: "Sygnus", device: "tablet" }, { regex: "Deox(?:[);/ ]|$)", model: "Deox", device: "tablet" }, { regex: "i-Call ([^;/]+) Build", model: "i-Call $1" }, { regex: "i-Joy ([^;/]+) Build", model: "$1" }] },
  iBall: iee,
  iRola: see,
  iRulu: dee,
  Irbis: uee,
  iBerry: cee,
  iHunt: mee,
  IconBIT: gee,
  LYF: fee,
  Lumus: pee,
  M4tel: hee,
  "IMO Mobile": { regex: "IMO[ _]\\w", device: "smartphone", models: [{ regex: "IMO[ _]Q([23]) Plus(?:[);/ ]|$)", model: "Q$1 Plus" }, { regex: "IMO[ _]Q2(?:[);/ ]|$)", model: "Q2" }, { regex: "IMO[ _]S2(?:[);/ ]|$)", model: "S2" }, { regex: "IMO[ _]FEEL A2(?:[);/ ]|$)", model: "Feel A2" }, { regex: "IMO[ _]S50(?:[);/ ]|$)", model: "S50 Light" }, { regex: "IMO[ _]S80(?:[);/ ]|$)", model: "S80 Hero" }, { regex: "IMO[ _]S89(?:[);/ ]|$)", model: "S89 Miracle" }, { regex: "IMO[ _]S88(?:[);/ ]|$)", model: "S88 Discovery" }, { regex: "IMO[ _]S99(?:[);/ ]|$)", model: "S99 Ocean" }, { regex: "IMO[ _]S98(?:[);/ ]|$)", model: "S98 Champion" }, { regex: "IMO[ _]S87(?:[);/ ]|$)", model: "S87 Raptor" }, { regex: "IMO[ _]S67(?:[);/ ]|$)", model: "S67 Blast" }, { regex: "IMO[ _]S78(?:[);/ ]|$)", model: "S78 Glory" }, { regex: "IMO[ _]Q8(?:[);/ ]|$)", model: "Q8 Clarity" }, { regex: "IMO[ _]Discovery II(?:[);/ ]|$)", model: "Discovery II" }, { regex: "IMO[ _]Q(?:[);/ ]|$)", model: "Q" }, { regex: "IMO[ _](Y5|Z[67])(?:[);/ ]|$)", model: "Tab $1", device: "tablet" }, { regex: "IMO TAB X9(?:[);/ ]|$)", model: "Tab X9", device: "tablet" }] },
  iLA: xee,
  iNew: vee,
  iPro: See,
  Infinix: bee,
  InFocus: yee,
  InnJoo: wee,
  Inkti: _ee,
  Innos: Tee,
  Innostream: Aee,
  Insignia: Pee,
  INQ: Mee,
  Intex: $ee,
  "i-mate": { regex: "i-mate ([a-z0-9]+)", device: "feature phone", model: "$1" },
  "i-mobile": { regex: "i-mobile ?[a-z0-9]+|i-Style|IQ ?(9\\.1|5\\.5|5\\.6A?)", device: "feature phone", models: [{ regex: "i-mobile (i-note[^/;]*) Build", model: "$1", device: "tablet" }, { regex: "i-Style ?([^;/]+) Build", model: "i-Style $1", device: "smartphone" }, { regex: "IQ ?(9\\.1|5\\.5|5\\.6A?)", model: "IQ $1", device: "smartphone" }, { regex: "i-mobile (IQ[^/;]*) Build", model: "$1", device: "smartphone" }, { regex: "i-mobile(?: )?([a-z0-9\\- ]+) Build", model: "$1" }, { regex: "i-mobile(?: )?([a-z0-9]+)", model: "$1" }] },
  iKoMo: Cee,
  iOcean: Lee,
  iView: Eee,
  Impression: Oee,
  iLife: Nee,
  iTel: Dee,
  iZotron: kee,
  "JAY-Tech": { regex: "TPC-[A-Z0-9]+|TPCY-TX[TE][^);/ ]+", device: "tablet", models: [{ regex: "TPC-([A-Z0-9]+)", model: "Tablet PC $1" }, { regex: "(TPCY-TX[TE][^);/ ]+)", model: "$1" }] },
  Jiayu: Gee,
  Jolla: Bee,
  Just5: Iee,
  Kalley: Ree,
  Kaan: Fee,
  Kazam: Vee,
  Keneksi: Hee,
  "Kempler & Strauss": { regex: "Alumini_?3_?Plus|Alumini ?[23]|KEMPLER_(?:P1|TV|X|8_PLUS)", device: "smartphone", models: [{ regex: "Alumini ?2", model: "Alumini 2" }, { regex: "Alumini_?3_?Plus", model: "Alumini 3 Plus" }, { regex: "Alumini3", model: "Alumini 3" }, { regex: "KEMPLER_P1", model: "P1" }, { regex: "KEMPLER_TV", model: "TV" }, { regex: "KEMPLER_X", model: "X" }, { regex: "KEMPLER_8_PLUS", model: "8 Plus" }] },
  Kiano: Uee,
  Kingsun: Xee,
  Kocaso: Wee,
  Kogan: Yee,
  Komu: Kee,
  Koobee: Qee,
  Kumai: jee,
  "KT-Tech": { regex: "(KM-[a-z0-9]+|EV-[a-z0-9]+)(?:[);/ ]|$)", device: "smartphone", model: "$1" },
  KDDI: Zee,
  Kodak: zee,
  KOPO: qee,
  Koridy: Jee,
  KRONO: ete,
  "K-Touch": { regex: "K-?Touch[ _][a-z0-9]+", device: "smartphone", models: [{ regex: "K-?Touch[ _]([^/;]*)[ _]Build", model: "$1" }, { regex: "K-?Touch[ _]([a-z0-9]+)", model: "$1" }] },
  Diva: tte,
  Kyocera: rte,
  "Krüger&Matz": { regex: "Kruger[ _&]Matz|KrugerMatz[ _]|FLOW ?5PLUS|FLOW_5|FLOW7|FLOW6(?:S|Lite)|DRIVE[_ ]6S?|MOVE8mini|MOVE_|LIVE_6plus|LIVE 5 PLUS|LIVE4_KM043[89]|LIVE 7S|KM(?:106[67]|1065G|0701_1|0702|0805_1)", device: "smartphone", models: [{ regex: "MOVE8mini", model: "MOVE 8 Mini" }, { regex: "MOVE_6_mini", model: "MOVE 6 Mini" }, { regex: "MOVE[_ ]([78]|6S)", model: "MOVE $1" }, { regex: "DRIVE 4 mini LTE", model: "DRIVE 4 mini LTE" }, { regex: "DRIVE[ _]([456][S]?)(?:[);/ ]|$)", model: "DRIVE $1" }, { regex: "FLOW ?5PLUS(?:[);/ ]|$)", model: "FLOW 5 Plus" }, { regex: "FLOW6Lite(?:[);/ ]|$)", model: "FLOW 6 Lite" }, { regex: "FLOW[ _]?([4-7][S]?)(?:[);/ ]|$)", model: "FLOW $1" }, { regex: "LIVE4_(KM043[89])(?:[);/ ]|$)", model: "LIVE 4 $1" }, { regex: "KrugerMatz_LIVE4(?:[);/ ]|$)", model: "LIVE 4" }, { regex: "_LIVE5_(KM0450)(?:[);/ ]|$)", model: "LIVE 5 $1" }, { regex: "LIVE 5 PLUS(?:[);/ ]|$)", model: "LIVE 5 Plus" }, { regex: "LIVE_6plus(?:[);/ ]|$)", model: "LIVE 6 Plus" }, { regex: "LIVE 7S(?:[);/ ]|$)", model: "LIVE 7S" }, { regex: "KM(106[67])(?:[);/ ]|$)", device: "tablet", model: 'EAGLE $1 10.1"' }, { regex: "KM(1065G)(?:[);/ ]|$)", device: "tablet", model: 'EAGLE $1 10.1"' }, { regex: "KM0(701)_1(?:[);/ ]|$)", device: "tablet", model: 'EAGLE $1 7.1"' }, { regex: "KM0(805)_1(?:[);/ ]|$)", device: "tablet", model: 'EAGLE $1 8.0"' }, { regex: "KM0(702)(?:[);/ ]|$)", device: "tablet", model: 'EAGLE $1 7.0"' }] },
  LAIQ: ote,
  AIS: nte,
  Lava: ate,
  SKG: lte,
  Landvo: ite,
  "Land Rover": { regex: "Land[ ]?Rover[d]?[ _-](?:X1[0-9]|Explore|T878|L15\\+|V18|V[168]|X)(?:[);/ ]|$)|Polar3", device: "smartphone", models: [{ regex: "Land[ ]?Rover[d]?[ _-](X1[0-9]|Explore|T878|L15\\+|V18|V[168]|X)(?:[);/ ]|$)", model: "$1" }, { regex: "Polar3", model: "Ioutdoor Polar 3" }] },
  Lanix: ste,
  Lark: dte,
  LCT: ute,
  "Le Pan": { regex: "Le ?Pan|TC970 ([^;/]+)Build", device: "tablet", models: [{ regex: "TC802A", model: "Le Pan Mini" }, { regex: "TC970 ([^;/]+)Build", model: "TC970 $1" }, { regex: "Le ?Pan ?(II|S)(?:[);/ ]|$)", model: "Le Pan $1" }, { regex: "Le ?Pan ?([^;/]+) Build", model: "$1" }] },
  Leagoo: cte,
  Ledstar: mte,
  LeEco: gte,
  Leotec: fte,
  Lephone: pte,
  Lenco: hte,
  Lenovo: xte,
  Lexand: vte,
  Lexibook: Ste,
  LG: bte,
  Lingwin: yte,
  Logicom: wte,
  Konka: _te,
  Konrow: Tte,
  Karbonn: Ate,
  Sagem: Pte,
  "Coby Kyros": { regex: "(MID(?:1024|1125|1126|1045|1048|1060|1065|4331|7012|7015A?|7016|7022|7032|7035|7036|7042|7047|7048|7052|7065|7120|8024|8042|8048|8065|8125|8127|8128|9724|9740|9742))(?:[);/ ]|$)", device: "tablet", model: "$1" },
  Mpman: Mte,
  Majestic: $te,
  "Manta Multimedia": { regex: "MSP950(1[245]|2[01])|MSP96017|((?<!/)MID713|MID(?:06[SN]|08[S]?|12|13|14|15|701|702|703|704|705(?:DC)?|706[AS]?|707|708|709|711|712|714|717|781|801|802|901|1001|1002|1003|1004(?: 3G)?|1005|1009|1010|7802|9701|9702))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "((?<!/)MID713|MID(?:06[SN]|08[S]?|12|13|14|15|701|702|703|704|705(?:DC)?|706[AS]?|707|708|709|711|712|714|717|781|801|802|901|1001|1002|1003|1004(?: 3G)?|1005|1009|1010|7802|9701|9702))(?:[);/ ]|$)", device: "tablet", model: "$1" }, { regex: "MSP95012", model: "Titano 1" }, { regex: "MSP95014", model: "Titano 3" }, { regex: "MSP95015", model: "Mezo 2" }, { regex: "MSP95020", model: "Rocky 2" }, { regex: "MSP95021", model: "Rocky 3 Pro" }, { regex: "MSP96017", model: "Forto 2" }] },
  Masstel: Cte,
  Maxwest: Lte,
  "True Slim": { regex: "(SSB-508[ED])(?:[);/ ]|$)", device: "smartphone", model: "$1" },
  "Maze Speed": { regex: "(SSB-(?:500|508)|SSB408D|SSB504R)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "SSB-?(500|508|408D|504R)(?:[);/ ]|$)", model: "SSB-$1" }] },
  Maze: Ete,
  Mediacom: Ote,
  Medion: Nte,
  MEEG: Dte,
  Fourel: kte,
  Meizu: Gte,
  Meitu: Bte,
  Memup: Ite,
  Mecer: Rte,
  Mio: Fte,
  Miray: Vte,
  Mitsubishi: Hte,
  MIXC: Ute,
  Mobiola: Xte,
  Mobicel: Wte,
  Mobiistar: Yte,
  MSI: Kte,
  MLLED: Qte,
  Mobistel: jte,
  Mecool: Zte,
  Modecom: zte,
  Mofut: qte,
  BrightSign: Jte,
  Motorola: ere,
  Movic: tre,
  MTN: rre,
  MyTab: ore,
  MyPhone: nre,
  MyWigo: are,
  Myros: lre,
  Myria: ire,
  "M.T.T.": { regex: "M.T.T.", device: "smartphone", models: [{ regex: "M.T.T. ?Tablet([^;/]+)? Build", device: "tablet", model: "Tablet$1" }, { regex: "M.T.T. ?([^;/]+) Build", model: "$1" }] },
  Navon: sre,
  NOA: dre,
  Nobby: ure,
  NEC: cre,
  Neffos: mre,
  Nextbit: gre,
  Newgen: fre,
  Netgear: pre,
  NeuImage: hre,
  NextBook: xre,
  NGM: vre,
  Nexian: Sre,
  Noain: bre,
  Noblex: yre,
  Nomu: wre,
  Nomi: _re,
  "NUU Mobile": { regex: "NUU_|(?:(?:N(5702|5001)L|S6001L)|A6L-[CG])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "NUU_A([13])", model: "A$1" }, { regex: "NUU_M([32])(?:[);/ ]|$)", model: "M$1" }, { regex: "NUU_X5(?:[);/ ]|$)", model: "X5" }, { regex: "S6001L", model: "G2" }, { regex: "N5702L", model: "G3" }, { regex: "(N5001L|A6L-[CG])(?:[);/ ]|$)", model: "$1" }] },
  "NYX Mobile": { regex: "NYX[ _]", device: "smartphone", models: [{ regex: "NYX_A1", model: "A1" }, { regex: "NYX_Blink", model: "Blink" }, { regex: "NYX_EGO", model: "Ego" }, { regex: "NYX_FENIX", model: "Fenix" }, { regex: "NYX_FLY_II", model: "Fly II" }, { regex: "NYX_FLY_MINI", model: "Fly Mini" }, { regex: "NYX_FLY", model: "Fly" }, { regex: "NYX_HIT", model: "Hit" }, { regex: "NYX_JAK", model: "Jak" }, { regex: "NYX_JOIN", model: "Join" }, { regex: "NYX_NOBA_II", model: "Noba II" }, { regex: "NYX_NOBA", model: "Noba" }, { regex: "NYX_ORBIS", model: "Orbis" }, { regex: "NYX[ _]REX", model: "Rex" }, { regex: "NYX_SHADE", model: "Shade" }, { regex: "NYX_SKY", model: "Sky" }, { regex: "NYX_SPARK", model: "Spark" }, { regex: "NYX_VOX", model: "Vox" }, { regex: "NYX_ZEUZ_HD", model: "Zeus HD" }] },
  Nous: Tre,
  Nvidia: Are,
  "O+": { regex: "O\\+[ _](Air|Crunch|Ultra|Upsized|Venti|360 ALPHA PLUS 2.0)", device: "smartphone", models: [{ regex: "O\\+[ _](Crunch|Ultra 2.0|Ultra|Upsized|Venti 4G)", model: "$1" }, { regex: "O\\+_AIR", model: "Air" }, { regex: "O\\+ 360 ALPHA PLUS 2.0", model: "360 Alpha Plus 2.0" }] },
  O2: Pre,
  Odys: Mre,
  Obi: $re,
  Okapia: Cre,
  Onda: Lre,
  OnePlus: Ere,
  Realme: Ore,
  OPPO: Nre,
  Opsson: Dre,
  Orange: kre,
  Oukitel: Gre,
  OKWU: Bre,
  Ouki: Ire,
  Overmax: Rre,
  Oysters: Fre,
  öwn: { regex: "OWN[ _]|(?:S4035[ _][34]G|Smart8|SMART PLUS LTE)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "FUN ([67])", model: "Fun $1" }, { regex: "FUN 5\\(4G\\)", model: "Fun 5 4G" }, { regex: "(?:OWN[ _])?(S3000D|S3010|S3020D|S4010|S4025|S4035[ _][34]G)", model: "$1" }, { regex: "One Plus", model: "One Plus" }, { regex: "One", model: "One" }, { regex: "SMART 9", model: "Smart 9" }, { regex: "Smart8(?:[);/ ]|$)", model: "Smart 8" }, { regex: "SMART PLUS LTE(?:[);/ ]|$)", model: "Smart Plus LTE" }] },
  Panacom: Vre,
  Panasonic: Hre,
  PCBOX: Ure,
  PCD: Xre,
  "PCD Argentina": { regex: "PCD[ ]?50[689]", device: "smartphone", models: [{ regex: "PCD[ ]?(50[689])", model: "$1" }] },
  ArmPhone: Wre,
  Pentagram: Yre,
  TCL: Kre,
  JVC: Qre,
  phoneOne: jre,
  Primepad: Zre,
  Pioneer: zre,
  Pixus: qre,
  PULID: Jre,
  "Point of View": { regex: "POV_TV|POV_TAB|MOB-5045", device: "tablet", models: [{ regex: "POV_TV-HDMI-KB-01", model: "HDMI Smart TV Dongle", device: "tv" }, { regex: "POV_TV-HDMI-200BT", model: "Mini PC HDMI Dongle", device: "tv" }, { regex: "MOB-5045", model: "Mobii Phone 5045", device: "smartphone" }, { regex: "POV_TAB-P506", model: "ONYX 506 Navi" }, { regex: "POV_TAB[_-]NAVI7[_-]3G[_-]M", model: "ONYX 507 Navi" }, { regex: "POV_TAB-P527S", model: "ONYX 527S" }, { regex: "POV_TAB-P547", model: "ONYX 547 Navi" }, { regex: "POV_TAB-PROTAB26", model: "ProTab 26 XXL IPS" }, { regex: "POV_TAB-PROTAB25XXL8?", model: "ProTab 25XXL" }, { regex: "POV_TAB-PL1015", model: "Mobii 1015" }, { regex: "POV_TAB-PROTAB([a-z0-9]+)", model: "ProTab $1" }, { regex: "POV_TAB-P?([a-z0-9]+)", model: "Mobii $1" }] },
  Pomp: eoe,
  PPTV: toe,
  ProScan: roe,
  "RCA Tablets": { regex: "RCT([^;/]+) Build|RCA RLTP4028|RCT6513W87|RCT6973W43(?:MD)?|RCT6703W12|RCT(?:6A06P22|6603W47M7|6303W87(?:DK|M)|6773W22B|6203W46L|6873W42M|6K03W13)", device: "smartphone", models: [{ regex: "RCA RLTP4028", model: "RLTP4028" }, { regex: "RCT6513W87", device: "tablet", model: 'Galileo Pro 11.5"' }, { regex: "RCT6873W42M", device: "tablet", model: 'Voyager 7.0"' }, { regex: "RCT6973W43(?:MD)?", device: "tablet", model: 'Voyager III 7.0"' }, { regex: "RCT6773W22B", device: "tablet", model: 'Voyager II 7.0"' }, { regex: "RCT6703W12", device: "tablet", model: 'Atlas 10.0"' }, { regex: "RCT6203W46L", device: "tablet", model: "Pro 10 Edition II" }, { regex: "RCT6A06P22", device: "tablet", model: 'Endeavor 10.0" HD' }, { regex: "RCT(?:6303W87(?:DK|M)|6K03W13)", device: "tablet", model: 'Viking Pro 10.0"' }, { regex: "RCT6603W47M7", device: "tablet", model: 'Viking II 10.0"' }, { regex: "RCT([^;/)]+)(?: Build|[;)])", device: "tablet", model: "RCT$1" }] },
  Readboy: ooe,
  Roku: noe,
  Rokit: aoe,
  Rombica: loe,
  Rover: ioe,
  RoverPad: soe,
  Roadrover: doe,
  "RT Project": { regex: "Shock 5", device: "smartphone", models: [{ regex: "Shock 5", model: "Shock 5" }] },
  "S-TELL": { regex: "S-TELL", device: "smartphone", models: [{ regex: "(?:S-TELL[ _])?M4(61|77|80)", model: "M4$1" }] },
  Safaricom: uoe,
  Santin: coe,
  Siemens: moe,
  Soundmax: goe,
  Samsung: foe,
  Sanei: poe,
  Selfix: hoe,
  Sencor: xoe,
  Senwa: voe,
  Sky: Soe,
  Skyworth: boe,
  Smartfren: yoe,
  Smartisan: woe,
  "STF Mobile": { regex: "(?:Fractal|AERIAL PLUS|Origins Pro|BLOCK_MINI|BLOCK GO|BLOCK 3|SLAY II)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Fractal", model: "Fractal" }, { regex: "Origins Pro", model: "Origins Pro" }, { regex: "AERIAL PLUS", model: "Aerial Plus" }, { regex: "BLOCK_MINI", model: "Block Mini" }, { regex: "BLOCK 3 mini", model: "Block 3 Mini" }, { regex: "BLOCK 3", model: "Block 3" }, { regex: "BLOCK GO", model: "Block Go" }, { regex: "SLAY II", model: "Slay II" }] },
  STK: _oe,
  Stonex: Toe,
  SuperSonic: Aoe,
  Supra: Poe,
  Sumvision: Moe,
  SunVan: $oe,
  SWISSMOBILITY: Coe,
  Thomson: Loe,
  Tanix: Eoe,
  Pantech: Ooe,
  Ployer: Noe,
  Plum: Doe,
  Polaroid: koe,
  PolyPad: Goe,
  Polytron: Boe,
  Positivo: Ioe,
  Prestigio: Roe,
  Sanyo: Foe,
  Qilive: Voe,
  QMobile: Hoe,
  Maximus: Uoe,
  Quantum: Xoe,
  Quechua: Woe,
  Ramos: Yoe,
  Razer: Koe,
  Sendo: Qoe,
  "Turbo-X": { regex: "Turbo-X|Hive V 3G|Turbox_S3", device: "smartphone", models: [{ regex: "Turbox_S3", model: "S3" }, { regex: "Turbo-X_A2(?:[);/ ]|$)", model: "A2" }, { regex: "Turbo-X_e3(?:[);/ ]|$)", model: "E3" }, { regex: "Turbo-X Ice(?:[);/ ]|$)", device: "tablet", model: "Ice" }, { regex: "Hive V 3G(?:[);/ ]|$)", device: "tablet", model: "Hive V 3G" }, { regex: "Turbo-X Tablet([^;/]+) Build", device: "tablet", model: "Tablet$1" }, { regex: "Turbo-X ([^;/]+) Build", model: "$1" }] },
  Turbo: joe,
  "Silent Circle": { regex: "Blackphone 2", device: "smartphone", model: "Blackphone 2" },
  Sigma: Zoe,
  Spice: zoe,
  Sharp: qoe,
  Simply: Joe,
  Softbank: ene,
  Sonim: tne,
  Star: rne,
  Starmobile: one,
  Amazon: nne,
  Symphony: ane,
  Helio: lne,
  Syrox: ine,
  Qtek: sne,
  "Q-Touch": { regex: "( Q09|QS701|Q05A)(?:[);/ ]|$)", device: "smartphone", model: "$1" },
  "G-Touch": { regex: "GTouch[_ ]|(?:Stella (?:XS?|Omega))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Stella (XS?|Omega)", model: "Stella $1" }, { regex: "GTouch[_ ]STELLA", model: "Stella" }] },
  "T-Mobile": { regex: "T-Mobile[ _][a-z0-9 ]+|(?:REVVLRY|REVVL 2(?: PLUS)?|5062[ZW]|5007[ZW])(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "5062[ZW]", model: "REVVL 4 Plus" }, { regex: "5007[ZW]", model: "REVVL 4" }, { regex: "REVVL 2 PLUS", model: "REVVL 2 Plus" }, { regex: "REVVLRY", model: "REVVL Plus" }, { regex: "REVVL 2(?:[);/ ]|$)", model: "REVVL 2" }, { regex: "T-Mobile[ _]([a-z0-9_ ]+) Build", model: "$1" }, { regex: "T-Mobile[ _]([a-z0-9_ ]+)", model: "$1" }] },
  "TB Touch": { regex: "Ignis [89]", device: "tablet", models: [{ regex: "Ignis ([89])", model: "Ignis $1" }] },
  Teclast: dne,
  "Tecno Mobile": { regex: "Tecno|Phantom6|Phantom6-Plus|DP7C Pro-SGA1", device: "smartphone", models: [{ regex: "Phantom6-Plus", model: "Phantom 6 Plus" }, { regex: "Phantom6", model: "Phantom 6" }, { regex: "TECNO-W3", model: "W3" }, { regex: "TECNO[ _]F4 Pro(?:[);/ ]|$)", model: "F4 Pro" }, { regex: "TECNO[ _]KE5j(?:[);/ ]|$)", model: "Spark 6 Go" }, { regex: "TECNO[ _]ID6(?:[);/ ]|$)", model: "Camon iClick 2" }, { regex: "Tecno[ _]7C(?:[);/ ]|$)", model: "DroidPad 7C", device: "tablet" }, { regex: "DP7C Pro-SGA1(?:[);/ ]|$)", model: "DroidPad 7C Pro", device: "tablet" }, { regex: "TECNO[ _]DP10A Pro(?:[);/ ]|$)", model: "DroidPad 10A Pro", device: "tablet" }, { regex: "TECNO[ _]P904(?:[);/ ]|$)", model: "DroidPad 10D 4G", device: "tablet" }, { regex: "Tecno[ _]CB7[j]?", model: "Camon i4" }, { regex: "Tecno[ _]CF7(?:[);/ ]|$)", model: "Camon 11" }, { regex: "Tecno[ _]CC6(?:[);/ ]|$)", model: "Camon 12 Air" }, { regex: "Tecno[ _]CC7(?:[);/ ]|$)", model: "Camon 12" }, { regex: "Tecno[ _]KC8(?:[);/ ]|$)", model: "Spark 4" }, { regex: "Tecno[ _]BB4k(?:[);/ ]|$)", model: "Spark 4 Lite" }, { regex: "Tecno[ _]KD7(?:[);/ ]|$)", model: "Spark 5 Pro" }, { regex: "Tecno[ _]DP8D(?:[);/ ]|$)", model: "DroidPad 8D", device: "tablet" }, { regex: "Tecno[ _]LB8", model: "Pouvoir 3 Plus" }, { regex: "TECNO S9", device: "phablet", model: "S9" }, { regex: "Tecno ([^;/]+) Build", model: "$1" }, { regex: "Tecno[ _]?([a-z0-9_\\-]+)", model: "$1" }] },
  TechPad: une,
  Tesco: cne,
  teXet: mne,
  Telefunken: gne,
  Telego: fne,
  Telenor: pne,
  Telit: hne,
  ThL: xne,
  TIANYU: vne,
  Timovi: Sne,
  Tooky: bne,
  Tolino: yne,
  "Top House": { regex: "Coto[_ ]|X1013", device: "smartphone", models: [{ regex: "Coto W418", model: "Coto W418" }, { regex: "COTO_T117", model: "Coto T117", device: "tablet" }, { regex: "X1013", model: "X1013", device: "tablet" }, { regex: "COTO_T40017", model: "T40017" }] },
  Toplux: wne,
  Touchmate: _ne,
  TrekStor: Tne,
  Trevi: Ane,
  TVC: Pne,
  "U.S. Cellular": { regex: "USCC-", device: "smartphone", models: [{ regex: "USCC-E6762", model: "Kyocera DuraForce" }, { regex: "(USCC-[a-z0-9_\\-]+)", model: "$1" }] },
  Uhappy: Mne,
  Unimax: $ne,
  Unowhy: Cne,
  UTStarcom: Lne,
  Ulefone: Ene,
  UMIDIGI: One,
  Uniscope: Nne,
  Unnecto: Dne,
  Unonu: kne,
  UTOK: Gne,
  Vastking: Bne,
  ViewSonic: Ine,
  Vitelcom: Rne,
  Fengxiang: Fne,
  "VK Mobile": { regex: "VK-VK([79]00)(?:[);/ ]|$)", device: "feature phone", model: "VK$1" },
  Vernee: Vne,
  Vertu: Hne,
  Venso: Une,
  Verizon: Xne,
  Verykool: Wne,
  Vestel: Yne,
  Videocon: Kne,
  Vodafone: Qne,
  Vonino: jne,
  Vorago: Zne,
  Voto: zne,
  Voxtel: qne,
  Vulcan: Jne,
  Walton: eae,
  WellcoM: tae,
  Wexler: rae,
  Inco: oae,
  Wink: nae,
  Wiko: aae,
  Wieppo: lae,
  Weimei: iae,
  Wileyfox: sae,
  Wolder: dae,
  Wolfgang: uae,
  Wonu: cae,
  Woo: mae,
  Woxter: gae,
  "X-View": { regex: "ZEN_U5\\+|AMBER_KIDS|Proton_Amber_HD|PROTON_JADE_2_PRO", device: "smartphone", models: [{ regex: "ZEN_U5\\+", model: "ZEN U5+" }, { regex: "AMBER_KIDS", device: "tablet", model: "Amber Kids" }, { regex: "Proton_Amber_HD", device: "tablet", model: "Proton Amber HD" }, { regex: "PROTON_JADE_2_PRO", device: "tablet", model: "Proton Jade 2 Pro" }] },
  POCO: fae,
  Xiaomi: pae,
  Xion: hae,
  Xolo: xae,
  Yarvik: vae,
  Yes: Sae,
  Yezz: bae,
  Yu: yae,
  Yuandao: wae,
  Yusun: _ae,
  Ytone: Tae,
  Zonda: Aae,
  ZYQ: Pae,
  Toshiba: Mae,
  Vivax: $ae,
  MLS: Cae,
  Fly: Lae,
  FinePower: Eae,
  Freetel: Oae,
  "Western Digital": { regex: "Westerndigital|WDSimpleBrowser", device: "tv", models: [{ regex: "Streamer2010", model: "Streamer (2010)" }] },
  Zeemi: Nae,
  Zenek: Dae,
  Zopo: kae,
  ZTE: Gae,
  Zuum: Bae,
  Zen: Iae,
  Zync: Rae,
  Lemhoov: Fae,
  MTC: Vae,
  MegaFon: Hae,
  Inoi: Uae,
  Vertex: Xae,
  Unknown: Wae,
  Starway: Yae,
  Savio: Kae,
  Simbans: Qae,
  MYFON: jae,
  "X-TIGI": { regex: "X[-_]TIGI|Hope7[_ ]Mate|Photo_P15_Lite", device: "smartphone", models: [{ regex: "X-TIGI_JOY10_PRO", model: "Joy 10 Pro", device: "tablet" }, { regex: "Hope7[_ ]Mate", model: "Hope 7 Mate", device: "tablet" }, { regex: "X-TIGI_JOY7_MAX", model: "Joy 7 Max", device: "tablet" }, { regex: "X-TIGI[_ ]V28[_ ]LTE", model: "V28 LTE" }, { regex: "X[-_]TIGI[_ ]V19", model: "V19" }, { regex: "X-TIGI[_ ]Photo[_ ]P11", model: "Photo P11" }, { regex: "Photo_P15_Lite", model: "Photo P15 Lite" }, { regex: "X[-_]TIGI[ _-]([^/;)]+) Build", model: "$1" }] },
  Xiaolajiao: Zae,
  Ritmix: zae,
  "Ross&Moor": { regex: "RMD[-_](974R|600)(?:[);/ ]|$)", device: "tablet", model: "RMD-$1" },
  "R-TV": { regex: "R-TV BOX[ _]?(MINI\\+|X99|X10 PRO|[RXS]10)", device: "tv", model: "Box $1" },
  NEXBOX: qae,
  True: Jae,
  Yandex: ele,
  FORME: tle,
  Shuttle: rle,
  BDF: ole,
  Highscreen: nle,
  CVTE: ale,
  Globex: lle,
  Atom: ile,
  Qumo: sle,
  Umax: dle,
  Mann: ule,
  Unihertz: cle,
  Chuwi: mle,
  Bezkam: gle,
  "NG Optics": { regex: "(NG3128HD)(?:[);/ ]|$)", device: "tv", model: "$1" },
  KATV1: fle,
  Ghong: ple,
  Xoro: hle,
  Vinga: xle,
  Viumee: vle,
  Nuvo: Sle,
  Sunvell: ble,
  Ugoos: yle,
  Yxtel: wle,
  Proline: _le,
  Yota: Tle,
  Mystery: Ale,
  Ritzviva: Ple,
  DeWalt: Mle,
  Runbo: $le,
  NewsMy: Cle,
  Newsday: Lle,
  Daewoo: Ele,
  Vesta: Ole,
  Spectrum: Nle,
  Kivi: Dle,
  Divisat: kle,
  Kanji: Gle,
  Kaiomy: Ble,
  National: Ile,
  Vsun: Rle,
  "Shift Phones": { regex: "(SHIFT6m)(?:[);/ ]|$)", device: "smartphone", model: "$1" },
  RugGear: Fle,
  Aligator: Vle,
  Maxcom: Hle,
  Luna: Ule,
  Protruly: Xle,
  JFone: Wle,
  Uhans: Yle,
  Soyes: Kle,
  Zidoo: Qle,
  Zfiner: jle,
  iGet: Zle,
  iVA: zle,
  Phicomm: qle,
  Huadoo: Jle,
  Gome: eie,
  Voyo: tie,
  Ryte: rie,
  Vontar: oie,
  Vorke: nie,
  Wigor: aie,
  NEXON: lie,
  ONN: iie,
  EXO: sie,
  "Q.Bell": { regex: "(QPHONE[_ ](?:10.1|9.[12]|7.1|5.[46])|QTAB10EW)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "(QPHONE[_ ](?:10.1|9.[12]|7.1|5.[46]))(?:[);/ ]|$)", model: "$1" }, { regex: "QTAB10EW", device: "tablet", model: "QTAB10EW" }] },
  Datawind: die,
  Droxio: uie,
  Goophone: cie,
  PocketBook: mie,
  Bitmore: gie,
  Kuliao: fie,
  Sugar: pie,
  Subor: hie,
  Xshitou: xie,
  JKL: vie,
  Gree: Sie,
  Vodacom: bie,
  VKworld: yie,
  Mito: wie,
  TWM: _ie,
  TWZ: Tie,
  Onix: Aie,
  Oale: Pie,
  Mobo: Mie,
  Macoox: $ie,
  Prixton: Cie,
  Magnus: Lie,
  Newland: Eie,
  Orbic: Oie,
  RED: Nie,
  Contixo: Die,
  "E-Ceros": { regex: "(?:CT9716(?:-B)?)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "CT9716(?:[);/ ]|$)", model: "Revolution" }, { regex: "CT9716-B(?:[);/ ]|$)", model: "Revolution HD" }] },
  How: kie,
  Multilaser: Gie,
  "Positivo BGH": { regex: "(?:T1060B|S455|Positivo (?:Twist|Ypy|Mini I)|Twist[ _](?:\\(2018\\)|2 (?:Fit|Pro)|Mini|Tab|Metal(?: 32GB)?|Max|XL|SE|[23SM]))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "S455(?:[);/ ]|$)", model: "Selfie" }, { regex: "Twist \\(2018\\)(?:[);/ ]|$)", model: "Twist (2018)" }, { regex: "Twist Metal 32GB(?:[);/ ]|$)", model: "Twist Metal 32GB" }, { regex: "Twist Metal(?:[);/ ]|$)", model: "Twist Metal" }, { regex: "Twist Max(?:[);/ ]|$)", model: "Twist Max" }, { regex: "Twist[ _]Mini(?:[);/ ]|$)", model: "Twist Mini" }, { regex: "Twist 2 Fit(?:[);/ ]|$)", model: "Twist 2 Fit" }, { regex: "Twist 2 Pro(?:[);/ ]|$)", model: "Twist 2 Pro" }, { regex: "Twist XL(?:[);/ ]|$)", model: "Twist XL" }, { regex: "Twist SE(?:[);/ ]|$)", model: "Twist SE" }, { regex: "(?:Positivo )?Twist ([23SM])(?:[);/ ]|$)", model: "Twist $1" }, { regex: "(?:Positivo )Mini I(?:[);/ ]|$)", model: "Mini I" }, { regex: "T1060B(?:[);/ ]|$)", device: "tablet", model: "T1060B" }, { regex: "Positivo Ypy (AB7F|AB10H|L1050E)(?:[);/ ]|$)", device: "tablet", model: "Ypy $1" }, { regex: "Twist Tab(?:[);/ ]|$)", device: "tablet", model: "Twist Tab" }] },
  Maxtron: Bie,
  Philco: Iie,
  "SEMP TCL": { regex: "(?:GO[35]E|5101J|GO3C(?: Plus)?)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "5101J(?:[);/ ]|$)", model: "L9 Plus" }, { regex: "GO3C Plus(?:[);/ ]|$)", model: "GO! 3C Plus" }, { regex: "GO3C(?:[);/ ]|$)", model: "GO! 3C" }, { regex: "(GO[35]E)(?:[);/ ]|$)", model: "$1" }] },
  Newman: Rie,
  Swipe: Fie,
  Owwo: Vie,
  "TD Systems": { regex: "(K32DLX9HS|K40DLM8FS|K40DLX9FS)(?:[);/ ]|$)", device: "tv", model: "$1" },
  Ravoz: Hie,
  Tone: Uie,
  "AT&T": { regex: "(?:U304AA|QS5509A|U705AA)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "U304AA(?:[);/ ]|$)", model: "Radiant Core" }, { regex: "U705AA(?:[);/ ]|$)", model: "Radiant Max" }, { regex: "QS5509A(?:[);/ ]|$)", model: "Axia" }] },
  BIHEE: Xie,
  Enot: Wie,
  Kooper: Yie,
  Lesia: Kie,
  Anry: Qie,
  Tinai: jie,
  Winds: Zie,
  Asano: zie,
  Phonemax: qie,
  Vipro: Jie,
  OzoneHD: ese,
  Kzen: tse,
  Melrose: rse,
  Crony: ose,
  Takara: nse,
  Tronsmart: ase,
  Amigoo: lse,
  Lumigon: ise,
  Neomi: sse,
  Eltex: dse,
  Senkatel: use,
  Bobarry: cse,
  Wortmann: mse,
  "BB Mobile": { regex: "Techno[-_ ](8\\.0|9\\.7|TQ863Q|X595BT|S700BF|I700AJ|10.1 LTE TQ060X|7.0 LTE TQ763I|I785AP|I101BI)(?:[);/ ]|$)", device: "tablet", models: [{ regex: "Techno[_ ]S700BF(?:[);/ ]|$)", model: 'Techno 7.0" Pioneer LTE S700BF' }, { regex: "Techno[_ ]10.1 LTE TQ060X(?:[);/ ]|$)", model: 'Techno 10.0" LTE TQ060X' }, { regex: "Techno[_ ]TQ863Q(?:[);/ ]|$)", model: 'Techno 8.0" Poplar LTE TQ863Q' }, { regex: "Techno[_ ]I700AJ(?:[);/ ]|$)", model: 'Techno 7.0" Mozg LTE I700AJ' }, { regex: "Techno[-_ ]I785AP(?:[);/ ]|$)", model: 'Techno 7.85" Mozg I785AP' }, { regex: "Techno[-_ ]I101BI(?:[);/ ]|$)", model: 'Techno 10.1" Mozg I101BI' }, { regex: "Techno[_ ]7.0 LTE TQ763I(?:[);/ ]|$)", model: 'Techno 7.0" Kalash LTE TQ763I' }, { regex: "Techno[_ ](9\\.7|8\\.0) 3G(?:[);/ ]|$)", model: 'Techno $1" 3G' }, { regex: "Techno[_ ](?:X595BT)(?:[);/ ]|$)", device: "smartphone", model: "Techno Spark 3G X595BT" }] },
  "2E": { regex: "(?:E500A_2019|2E E450 2018)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "E500A_2019(?:[);/ ]|$)", model: "E500A (2019)" }, { regex: "2E E450 2018(?:[);/ ]|$)", model: "E450 (2018)" }] },
  Billion: gse,
  Tele2: fse,
  Alfawise: pse,
  Klipad: hse,
  SQOOL: xse,
  TurboKids: vse,
  Jinga: Sse,
  Twoe: bse,
  iTruck: yse,
  Torex: wse,
  Doffler: _se,
  Oyyu: Tse,
  Primux: Ase,
  iMars: Pse,
  Logic: Mse,
  Cloudpad: $se,
  Cloudfone: Cse,
  Vsmart: Lse,
  MiXzo: Ese,
  Openbox: Ose,
  Ziox: Nse,
  iDroid: Dse,
  Aoson: kse,
  "FireFly Mobile": { regex: "(?:AURII[ _](?:Passion|Virtuoso|ULTRA|Secret Lite|AMUSE[_ ]3G|FORCE|FUSION|F8[_ ]Premium|XCITE|DELIGHT|DREAM[_ ](?:MINI|One))|SECRET_XR|INTENSE[ _](?:POWER|METAL_2|XT)|SUPER SWEET|SWEET MINI)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "AURII[ _]FORCE(?:[);/ ]|$)", model: "Aurii Force" }, { regex: "AURII[ _]DELIGHT(?:[);/ ]|$)", model: "Aurii Delight" }, { regex: "AURII[ _]DREAM[_ ]MINI(?:[);/ ]|$)", model: "Aurii Dream Mini" }, { regex: "AURII[ _]DREAM[_ ]One(?:[);/ ]|$)", model: "Aurii Dream One" }, { regex: "AURII[ _]ULTRA(?:[);/ ]|$)", model: "Aurii Ultra" }, { regex: "AURII[ _]AMUSE[_ ]3G(?:[);/ ]|$)", model: "Aurii Amuse 3G" }, { regex: "AURII[ _]FUSION(?:[);/ ]|$)", model: "Aurii Fusion" }, { regex: "AURII[ _]XCITE(?:[);/ ]|$)", model: "Aurii xCite" }, { regex: "SECRET_XR(?:[);/ ]|$)", model: "Aurii Secret XR" }, { regex: "AURII[ _]((?:Passion|Virtuoso|Secret Lite|F8[_ ]Premium))(?:[);/ ]|$)", model: "Aurii $1" }, { regex: "INTENSE POWER(?:[);/ ]|$)", model: "Intense Power" }, { regex: "INTENSE_XT(?:[);/ ]|$)", model: "Intense XT" }, { regex: "INTENSE_METAL_2(?:[);/ ]|$)", model: "Intense Metal 2" }, { regex: "SUPER SWEET(?:[);/ ]|$)", model: "Super Sweet" }, { regex: "SWEET MINI(?:[);/ ]|$)", model: "Sweet Mini" }] },
  "i-Cherry": { regex: "iCherry_?", device: "smartphone", models: [{ regex: "iCherry[ _](C(?:25[1258]|21[16]|110|121|22[0379]|23[03])|X1)(?:[);/ ]|$)", model: "$1" }, { regex: "iCherry-C256", device: "tablet", model: "C256 Nano 3G" }] },
  NextTab: Gse,
  Time2: Bse,
  Sunstech: Ise,
  Hotwav: Rse,
  Tetratab: Fse,
  Dolamee: Vse,
  Invin: Hse,
  Doopro: Use,
  IQM: Xse,
  Nos: Wse,
  Accent: Yse,
  Avenzo: Kse,
  Beelink: Qse,
  MAXVI: jse,
  "MDC Store": { regex: "Prime_S(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Prime_S(?:[);/ ]|$)", model: "Prime S" }] },
  meanIT: Zse,
  Kenxinda: zse,
  "X-BO": { regex: "X[-]?BO (V[78]|V1[01]|V[89]\\+)(?:[);/ ]|$)", device: "smartphone", model: "$1" },
  Xgody: qse,
  Alcor: Jse,
  iBrit: ede,
  Ovvi: tde,
  Fero: rde,
  Ruio: ode,
  Transpeed: nde,
  VVETIME: ade,
  A1: lde,
  Swisstone: ide,
  "P-UP": { regex: "MD-04P(?:[);/ ]|$)", device: "phablet", model: "Mode 1 RR" },
  iVooMi: sde,
  Pixelphone: dde,
  Pixela: ude,
  Iris: cde,
  Fonos: mde,
  Xtouch: gde,
  Conquest: fde,
  Zatec: pde,
  Selenga: hde,
  Starlight: xde,
  GEOFOX: vde,
  Tinmo: Sde,
  Matrix: bde,
  Verico: yde,
  TTEC: wde,
  eSTAR: _de,
  Hometech: Tde,
  ExMobile: Ade,
  Hipstreet: Pde,
  Navitech: Mde,
  NorthTech: $de,
  UNIWA: Cde,
  Andowl: Lde,
  Silelis: Ede,
  Bluedot: Ode,
  "Planet Computers": { regex: "(Cosmo_Communicator)(?:[);/ ]|$)", device: "tablet", model: "$1" },
  Reach: Nde,
  MobiWire: Dde,
  Hezire: kde,
  Hurricane: Gde,
  iSWAG: Bde,
  Reeder: Ide,
  ELARI: Rde,
  "Epik One": { regex: "(K501 Plus|[ ]K5(?:0[0-4]|1[01]|03T|3[456]|4[05]|73)|[ ]K60[01]|[ ]X507T|[ ]K40[56]|[ ]T700)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "K501 Plus", model: "Leo Plus" }, { regex: "K501", model: "Leo" }, { regex: "K500", model: "Omega Lite" }, { regex: "K502", model: "Omega" }, { regex: "K503T", model: "Leo Turbo" }, { regex: "K503", model: "Leo Max" }, { regex: "K504", model: "Titan 3G" }, { regex: "X507T", model: "Titan II" }, { regex: "K510", model: "Bolt" }, { regex: "K511", model: "Bolt Pro" }, { regex: "K534", model: "Hada" }, { regex: "K535", model: "Hada Turbo" }, { regex: "K545", model: "Rocket" }, { regex: "K536", model: "Royal" }, { regex: "K540", model: "Excalibur" }, { regex: "K573", model: "Panther" }, { regex: "K600", model: "Jupiter" }, { regex: "K601", model: "Jupiter One" }, { regex: "K406", model: "Pebble Plus" }, { regex: "K405", model: "Pebble II" }, { regex: "T700", model: "Palette", device: "tablet" }] },
  Altice: Fde,
  Kult: Vde,
  Beyond: Hde,
  BioRugged: Ude,
  VAIO: Xde,
  Spark: Wde,
  SPC: Yde,
  Winmax: Kde,
  Zebra: Qde,
  Thuraya: jde,
  Bkav: Zde,
  Brandt: zde,
  Bigben: qde,
  SMARTEC: Jde,
  Asanzo: eue,
  Artizlee: tue,
  Mintt: rue,
  Premio: oue,
  Trifone: nue,
  Bluewave: aue,
  Siragon: lue,
  Poppox: iue,
  Zentality: sue,
  "Black Bear": { regex: "(B6 Master|B6 Note X)(?:[);/ ]|$)", device: "smartphone", model: "$1" },
  Fortis: due,
  OpelMobile: uue,
  NuAns: cue,
  Koolnee: mue,
  Sansui: gue,
  Sico: fue,
  Smadl: pue,
  EXCEED: hue,
  Tymes: xue,
  Solone: vue,
  FarEasTone: Sue,
  Smailo: bue,
  Colors: yue,
  Honeywell: wue,
  Electroneum: _ue,
  "High Q": { regex: "(ELT070[46]H|ELT0802H)(?:[);/ ]|$)", device: "tablet", model: "$1" },
  Pluzz: Tue,
  "IKU Mobile": { regex: "(Powerful_K55i|Curvy C50L)(?:[);/ ]|$)", device: "smartphone", model: "$1" },
  "IKI Mobile": { regex: "(?:GO5_55|BLESS_GO55|BLESSPLUS|KF4Go|KF5bless)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "GO5_55", model: 'Go 5.5"' }, { regex: "BLESS_GO55", model: 'Bless Go 5.5"' }, { regex: "BLESSPLUS", model: "Bless Plus" }, { regex: "(KF4Go|KF5bless)", model: "$1" }] },
  "CG Mobile": { regex: "(?:CG_OMEGA6|Omega (?:[38])|CG_EON_Blaze_Pro|CG\\|EON Blaze GOLD)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Omega ([38])(?:[);/ ]|$)", model: "Omega $1" }, { regex: "CG_OMEGA6(?:[);/ ]|$)", model: "Omega 6" }, { regex: "CG_EON_Blaze_Pro(?:[);/ ]|$)", model: "EON Blaze Pro" }, { regex: "CG\\|EON Blaze GOLD(?:[);/ ]|$)", model: "EON Blaze Gold" }] },
  IUNI: Aue,
  "ZH&K": { regex: "(?:ODYSSEY O2|ODYSSEY RANGE)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ODYSSEY O2", model: "Odyssey O2" }, { regex: "ODYSSEY RANGE", model: "Odyssey Range" }] },
  Ordissimo: Pue,
  Necnot: Mue,
  Einstein: $ue,
  AfriOne: Cue,
  Connex: Lue,
  Connectce: Eue,
  Clementoni: Oue,
  "Cell-C": { regex: "Cell_?C_", device: "smartphone", models: [{ regex: "Cell_C_(Summit_Plus|Fame|Evolve)(?:[);/ ]|$)", model: "$1" }, { regex: "CELLC_Evolve", device: "tablet", model: "Evolve" }] },
  VC: Nue,
  CellAllure: Due,
  Eagle: kue,
  Invens: Gue,
  "Chico Mobile": { regex: "(?:ALTO (?:Bombo|classic|Estrella|JUEGO|SUBIR|[235])|FUEGO MAX|OJOS[ _](?:CAMBIO|NUBE|[68i]|ORO))(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "ALTO Bombo", model: "Alto Bombo" }, { regex: "ALTO classic", model: "Alto Classic" }, { regex: "ALTO Estrella", model: "Alto Estrella" }, { regex: "ALTO JUEGO", model: "Alto Juego" }, { regex: "ALTO SUBIR", model: "Alto Subir" }, { regex: "ALTO ([235])", model: "Alto $1" }, { regex: "OJOS[ _]([68i])", model: "Ojos $1" }, { regex: "OJOS NUBE", model: "Ojos Nube" }, { regex: "OJOS CAMBIO", model: "Ojos Cambio" }, { regex: "OJOS ORO", model: "Ojos Oro" }, { regex: "FUEGO MAX", device: "tablet", model: "Fuego Max" }] },
  Claresta: Bue,
  Camfone: Iue,
  Bellphone: Rue,
  Gini: Fue,
  MIVO: Vue,
  Jesy: Hue,
  Teknosa: Uue,
  Hyve: Xue,
  EWIS: Wue,
  "Leader Phone": { regex: "(Vyper|N-5[07]|N-45)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "N-45 light", model: "N-45 Light" }, { regex: "(Vyper|N-5[07]|N-45)(?:[);/ ]|$)", model: "$1" }] },
  Cavion: Yue,
  GLX: Kue,
  Seeken: Que,
  Jivi: jue,
  Winnovo: Zue,
  WE: zue,
  Trio: que,
  Seuic: Jue,
  Centric: ece,
  Kata: tce,
  Leff: rce,
  Hardkernel: oce,
  Wiseasy: nce,
  "Shtrikh-M": { regex: "SHTRIH-SMARTPOS-F2(?:[);/ ]|$)", device: "peripheral", model: "Smartpos F2" },
  BBK: ace,
  "4ife": { regex: "4ife (4K Smart TV Box)(?:[);/ ]|$)", device: "tv", model: "$1" },
  Westpoint: lce,
  Wintouch: ice,
  Aiuto: sce,
  Seatel: dce,
  Ditecma: uce,
  Datamini: cce,
  "3GNET": { regex: "(?<!NetType/)3GNET[ _]", device: "smartphone", models: [{ regex: "3GNET[ _](U8|T800|U6s)(?:[);/ ]|$)", model: "$1" }, { regex: "3GNET[ _]T ?900", model: "T900" }] },
  "Yoka TV": { regex: "KB2 PRO(?:[);/ ]|$)", device: "tv", model: "KB2 Pro" },
  Formuler: mce,
  Malata: gce,
  IT: fce,
  Navcity: pce,
  Jiake: hce,
  "iQ&T": { regex: "(IFoo (?:U200|H55))(?:[);/ ]|$)", device: "smartphone", model: "$1" },
  Mantra: xce,
  Datalogic: vce,
  "Naomi Phone": { regex: "NAOMIPHONE Ambar(?:[);/ ]|$)", device: "smartphone", model: "Ambar" },
  Navitel: Sce,
  Linnex: bce,
  Smartab: yce,
  SuperTab: wce,
  Suzuki: _ce,
  Philips: Tce,
  INCAR: Ace,
  "FaRao Pro": { regex: "(FTRW100)(?:[);/ ]|$)", device: "tablet", model: "$1" },
  Nabi: Pce,
  StrawBerry: Mce,
  Gresso: $ce,
  Pendoo: Cce,
  PiPO: Lce,
  Engel: Ece,
  Genesis: Oce,
  InfoKit: Nce,
  Blloc: Dce,
  Huskee: kce,
  SOLE: Gce,
  SOLO: Bce,
  OINOM: Ice,
  Singtech: Rce,
  Sunny: Fce,
  TEENO: Vce,
  "v-mobile": { regex: "Vmobile[ _]", device: "smartphone", models: [{ regex: "Vmobile[ _](J7)(?:[);/ ]|$)", model: "$1" }, { regex: "Vmobile XS Pro(?:[);/ ]|$)", model: "XS Pro" }] },
  OASYS: Hce,
  Aspera: Uce,
  "Vision Touch": { regex: "Vision ?Touch", device: "smartphone", models: [{ regex: "VisionTouchLife", model: "Life" }, { regex: "Inspire", model: "Inspire" }] },
  NOBUX: Xce,
  Hitech: Wce,
  F150: Yce,
  BilimLand: Kce,
  Greentel: Qce,
  Kyowon: jce,
  "LT Mobile": { regex: "(?:LT-NOTE 10S)", device: "smartphone", models: [{ regex: "LT-NOTE 10S", model: "Note 10S" }] },
  "ONYX BOOX": { regex: "KON_TIKI(?:[);/ ]|$)", device: "tablet", model: "Kon Tiki" },
  GFive: Zce,
  KINGZONE: zce,
  "M-Tech": { regex: "EROS 4G(?:[);/ ]|$)", device: "smartphone", model: "Eros 4G" },
  Fantec: qce,
  AURIS: Jce,
  YUHO: eme,
  "2F Mobile": { regex: "(Z8PLUS|Z8POCKET)(?:[);/ ]|$)", device: "smartphone", models: [{ regex: "Z8PLUS", model: "Z8 Plus" }, { regex: "Z8POCKET", model: "Z8 Pocket" }] }
};
var cc = {}, gS;
function Dh() {
  return gS || (gS = 1, Object.defineProperty(cc, "__esModule", { value: !0 }), cc.buildModel = (e) => (e = e.replace(/_/g, " "), e = e.replace(RegExp(" TD$", "i"), ""), e === "Build" ? "" : e)), cc;
}
var fS;
function rme() {
  if (fS) return ss;
  fS = 1;
  var e = ss && ss.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(ss, "__esModule", { value: !0 });
  const t = e(tme), r = rn(), o = vo(), n = Dh();
  class a {
    constructor() {
      this.parse = (i) => {
        const s = {
          type: "",
          brand: "",
          model: ""
        };
        let u = "";
        for (const [c, g] of Object.entries(t.default)) {
          const p = o.userAgentParser(g.regex, i);
          if (p) {
            if (u = "device" in g && g.device || "", s.brand = c, "model" in g && g.model)
              s.model = n.buildModel(r.variableReplacement(g.model, p)).trim();
            else if ("models" in g && g.models)
              for (const h of g.models) {
                const v = o.userAgentParser(h.regex, i);
                if (v) {
                  s.model = n.buildModel(r.variableReplacement(h.model, v)).trim(), "device" in h && h.device && (u = h.device), "brand" in h && (s.brand = h.brand || "");
                  break;
                }
              }
            break;
          }
        }
        return u === "tv" ? s.type = "television" : u === "car browser" ? s.type = "car" : s.type = u, s.brand === "Unknown" && (s.brand = ""), s;
      };
    }
  }
  return ss.default = a, ss;
}
var ds = {};
const ome = { regex: "Airties", device: "tv", models: [{ regex: "Airties; ?([^);/]+)", model: "$1" }] }, nme = { regex: "AOC", device: "tv", models: [{ regex: "(LE43S5970-20|S50856)", model: "$1" }] }, ame = { regex: "ARRIS[;,]", device: "tv", models: [{ regex: "FS-ARS-01B", model: "FS-ARS-01B" }] }, lme = { regex: "ATVIO", device: "tv", models: [{ regex: "55D1620", model: "55D1620" }] }, ime = { regex: "Bangolufsen", device: "tv", model: "BeoVision" }, sme = { regex: "Blaupunkt_UMC[;,]", device: "tv", models: [{ regex: "LC-65CUG8052E", model: "LC-65CUG8052E" }] }, dme = { regex: "BUSH[;,]", device: "tv", model: "" }, ume = { regex: "CELCUS[;,]", device: "tv", model: "" }, cme = { regex: "Changhong", device: "tv", models: [{ regex: "Changhong; ?([^);/]+)", model: "$1" }] }, mme = { regex: "CreNova", device: "tv", model: "CNV001" }, gme = { regex: "DIGIHOME[;,]", device: "tv", model: "" }, fme = { regex: "DMM", device: "tv", model: "Dreambox" }, pme = { regex: "ELECTRONIA[;,]", device: "tv", model: "" }, hme = { regex: "ESSENTIELB[;,]", device: "tv", model: "" }, xme = { regex: "FINLUX[;,]", device: "tv", model: "" }, vme = { regex: "FUEGO[;,]", device: "tv", model: "" }, Sme = { regex: "GOGEN[;,]", device: "tv", model: "" }, bme = { regex: "(OWB|Grundig|Arcelik)", device: "tv", model: "" }, yme = { regex: "(?:HHW_)?HAIER", device: "tv", models: [{ regex: "LE55X7000U", model: "LE55X7000U" }] }, wme = { regex: "Hisense|Eurofins_Digital_Testing", device: "tv", models: [{ regex: "50ADEVTOOL", model: "50ADEVTOOL" }, { regex: "50A683FEVS", model: "50A683FEVS" }, { regex: "55A6100EE", model: "55A6100EE" }, { regex: "55U62QGAVT", model: "55U62QGAVT" }, { regex: "50A6502EA", model: "50A6502EA" }, { regex: "MICALIDVB6886", model: "MICALIDVB6886" }, { regex: "(L[A-Z]{2,3}[0-9]{2}[A-Z][0-9]{3,4}[A-Z]{0,6}[0-9]?[A-Z]?)", model: "$1" }, { regex: "(H[A-Z]?[0-9]{2}[A-Z][0-9]{3,4}[A-Z]{0,4})", model: "$1" }] }, _me = { regex: "Hitachi[;,]", device: "tv", models: [{ regex: "49D2900", model: "49D2900" }] }, Tme = { regex: "HORIZON[;,]", device: "tv", model: "" }, Ame = { regex: "HOTEL[;,]", device: "tv", model: "" }, Pme = { regex: "Humax", device: "tv", models: [{ regex: "(HD-FOX C|HD (FOX\\+|NANO)|iCord (HD\\+|MINI|Cable)|(CX|IR)HD-5100(C|S)|HM9503HD)", model: "$1" }, { regex: "HMS1000S", model: "HMS-1000S" }, { regex: "Humax; ([^);/]+)", model: "$1" }] }, Mme = { regex: "HYUNDAI[;,]", device: "tv", model: "" }, $me = { regex: "Ikea", device: "tv", model: "" }, Cme = { regex: "Intek", device: "tv", models: [{ regex: "(Vantage|VT-100|VT-1)", model: "$1" }] }, Lme = { regex: "Inverto", device: "tv", models: [{ regex: "inverto; ([^);/]+)", model: "$1" }, { regex: "(Volksbox Web Edition|Volksbox Essential|Volksbox II|Volksbox)", model: "$1" }] }, Eme = { regex: "AFTSO001|JVC[;,]", device: "tv", models: [{ regex: "AFTSO001", model: "4K (2019)" }] }, Ome = { regex: "KALLEY[;,]", device: "tv", models: [{ regex: "32D1620", model: "32D1620" }] }, Nme = { regex: "KUBO[;,]", device: "tv", model: "" }, Dme = { regex: "LAURUS[;,]", device: "tv", model: "" }, kme = { regex: "LGE", device: "tv", models: [{ regex: "XU43WT180N", model: "XU43WT180N" }, { regex: "43LJ614V-ZA", model: "43LJ614V-ZA" }, { regex: "55SK850V-ZA", model: "55SK850V-ZA" }, { regex: "KEY0000213F1z", model: "KEY0000213F1z" }, { regex: "KEY0000213F", model: "KEY0000213F" }, { regex: "KEY000000(2E|2F|3B|3F)", model: "KEY000000$1" }, { regex: "(NetCast [0-9]{1}.[0-9]{1}|GLOBAL_PLAT3)", model: "$1" }, { regex: "(OLED[0-9]{2}[A-Z0-9]{3}[A-Z]{2})", model: "$1" }, { regex: "(OLED[0-9]{2}[A-Z][0-9][A-Z])", model: "$1" }, { regex: "(OLED[0-9]{2}[A-Z0-9]{2})", model: "$1" }, { regex: "([0-9]{2}[A-Z]{2}[0-9]{4}[A-Z0-9]{1}[A-Z]{2})", model: "$1" }, { regex: "([0-9]{2}NANO[0-9]{3}[A-Z]{2})", model: "$1" }, { regex: "([0-9]{2}NANO[0-9]{2})", model: "$1" }, { regex: "LGE;? ?([0-9]{2}[A-Z]{2}[0-9]{2,4}[A-Z]?)", model: "$1" }, { regex: "LM21U", model: "LM21U" }, { regex: "32LM", model: "32LM" }] }, Gme = { regex: "Lifemaxx[;,]", device: "tv", model: "" }, Bme = { regex: "LINSAR[;,]", device: "tv", model: "" }, Ime = { regex: "Loewe", device: "tv", models: [{ regex: "([A-Z]{2}[0-9]{3})", model: "$1" }] }, Rme = { regex: "LUXOR[;,]", device: "tv", model: "" }, Fme = { regex: "Manhattan", device: "tv", models: [{ regex: "T3", model: "T3" }] }, Vme = { regex: "MTK|MediaTek;", device: "tv", models: [{ regex: "(MT[0-9]{4})", model: "$1" }] }, Hme = { regex: "Medion", device: "tv", model: "" }, Ume = { regex: "MIRAY", device: "tv", models: [{ regex: "LEDM-322NIP", model: "LEDM-322NIP" }] }, Xme = { regex: "MStar[;,]", device: "tv", models: [{ regex: "([24])KTV18", model: "$1KTV18" }] }, Wme = { regex: "MTC[;,]", device: "tv", models: [{ regex: "([24])K_Android_TV_V01", model: "$1K Android TV" }] }, Yme = { regex: "NORDMENDE[;,]", device: "tv", model: "" }, Kme = { regex: "Metz", device: "tv", model: "" }, Qme = { regex: "OK[;,]", device: "tv", model: "" }, jme = { regex: "Panasonic", device: "tv", models: [{ regex: "VIERA (201[1-9])", model: "VIERA ($1)" }, { regex: "(DIGA [A-Z]{1}[0-9]{4})", model: "$1" }, { regex: "DIGA Webkit ([A-Z]{1}[0-9]{4})", model: "DIGA $1" }, { regex: "SmartTV(201[89]|202[0-1])", model: "Smart TV ($1)" }] }, Zme = { regex: "PEAQ", device: "tv", model: "" }, zme = { regex: "Philips|NETTV/", device: "tv", models: [{ regex: "Philips[,;] ?((?! )[^),;/]+)", model: "$1" }, { regex: "NETTV/[0-9\\.]{5}", model: "NetTV Series" }] }, qme = { regex: "POLAROID[;,]", device: "tv", model: "" }, Jme = { regex: "PROFILO[;,]", device: "tv", model: "" }, ege = { regex: "QILIVE[;,]", device: "tv", model: "" }, tge = { regex: "REGAL[;,]", device: "tv", model: "" }, rge = { regex: "Saba[;,]", device: "tv", model: "" }, oge = { regex: "Salora[;,]", device: "tv", model: "" }, nge = { regex: "Samsung|Maple_2011", device: "tv", models: [{ regex: "SmartTV(201[2-9]|202[0-1]):([^);/]+)", model: "$2" }, { regex: "SmartTV(201[2-9]|202[0-1])", model: "Smart TV ($1)" }, { regex: "Maple_2011", model: "Smart TV (2011)" }] }, age = { regex: "SCBC[;,]", device: "tv", models: [{ regex: "SCBC586", model: "SCBC586" }, { regex: "43D1850", model: "43D1850" }] }, lge = { regex: "SEG[;,]", device: "tv", model: "" }, ige = { regex: "Selevision", device: "tv", models: [{ regex: "Selevision; (?:Selevision )?([^);/]+)", model: "$1" }, { regex: "(EMC1000i)", model: "$1" }] }, sge = { regex: "(?:UMC-)?Sharp", device: "tv", models: [{ regex: "Sharp[,;] ?((?! |HbbTV)[^),;/]+)", model: "$1" }, { regex: "(LE[0-9]{3}[A-Z]{0,3})", model: "$1" }, { regex: "LC-([^);/]+)", model: "LC-$1" }, { regex: "BLA-43", model: "BLA-43" }] }, dge = { regex: "Sky_worth", device: "tv", models: [{ regex: "Sky_worth;([^);/]+)", model: "$1" }] }, uge = { regex: "Smart[;,]", device: "tv", models: [{ regex: "Smart; ([^);/]+)", model: "$1" }, { regex: "([A-Z]{2}[0-9]{2}|ZAPPIX)", model: "$1" }] }, cge = { regex: "Sony", device: "tv", models: [{ regex: "KDL-GR1", model: "KDL-GR1" }, { regex: "KDL-GN([56])", model: "KDL-GN$1" }, { regex: "BRAVIA (VH1|4K VH2)", model: "BRAVIA $1" }, { regex: "(KDL?-?[0-9]{2}[A-Z]{1}[0-9]{4}[A-Z]{1})", model: "$1" }, { regex: "(KDL?-?[0-9]{2}[A-Z]{1}[0-9]{3}[A-Z]{1})", model: "$1" }, { regex: "(KDL?-?[0-9]{2}[A-Z]{1,2}[0-9]{1,5})", model: "$1" }] }, mge = { regex: "SWTV[;,]", device: "tv", models: [{ regex: "SKWE20E21", model: "SKWE20E21" }] }, gge = { regex: "Technicolor", device: "tv", models: [{ regex: "uzw4054ttg", model: "UZW4054TTG" }] }, fge = { regex: "TECHNIKA[;,]", device: "tv", model: "" }, pge = { regex: "TechniSat", device: "tv", models: [{ regex: "((DigiCorder|MultyVision|Digit) (ISIO S|ISIO C|ISIO))", model: "$1" }] }, hge = { regex: "TechnoTrend", device: "tv", models: [{ regex: "([A-Z]{1}-[0-9]{3})", model: "$1" }] }, xge = { regex: "Techwood[;,]", device: "tv", model: "" }, vge = { regex: "Telefunken", device: "tv", model: "" }, Sge = { regex: "TCL", device: "tv", models: [{ regex: "(32D1820|(?:39|55)D2900|32D2930|(?:32|43)S4900)", model: "$1" }] }, bge = { regex: "THOMSON[,]?|THOM", device: "tv", models: [{ regex: "(TB28D19DHS-01|T28D18SFS-01B)", model: '$1 28.0"' }, { regex: "(T32RTM5040|T32D18SFS-01B)", model: '$1 32.0"' }, { regex: "(T43FSL5031|T43D18SFS-01B)", model: '$1 43.0"' }, { regex: "(T40D18SFS-01B)", model: '$1 40.0"' }, { regex: "(T49D18SFS-01B)", model: '$1 49.0"' }, { regex: "(T55D18[SD]FS-01B)", model: '$1 55.0"' }, { regex: "40FB5426", model: "40FB5426" }] }, yge = { regex: "TOKYO[;,]", device: "tv", models: [{ regex: "TOKTCLED32S", model: "TOKTCLED32S" }] }, wge = { regex: "Toshiba", device: "tv", models: [{ regex: "40L2600", model: "40L2600" }, { regex: "(([0-9]{2}|DTV_)[A-Z]{2}[0-9]{1,3})", model: "$1" }] }, _ge = { regex: "videoweb|tv2n", device: "tv", models: [{ regex: "(tv2n)", model: "$1" }, { regex: "(videowebtv)", model: "VideoWeb TV" }] }, Tge = { regex: "VOX[;,]", device: "tv", model: "" }, Age = { regex: "WELLINGTON[;,]", device: "tv", model: "" }, Pge = { regex: "(?:Vestel.+VESTEL|VESTEL;)", device: "tv", model: "" }, Mge = {
  Airties: ome,
  "ALDI NORD": { regex: "ALDINORD[;,]", device: "tv", model: "" },
  "ALDI SÜD": { regex: "ALDISUED[;,]", device: "tv", model: "" },
  "Altech UEC": { regex: "Altech UEC", device: "tv", models: [{ regex: "Altech UEC; ?([^);/]+)", model: "$1" }] },
  AOC: nme,
  ARRIS: ame,
  Atvio: lme,
  BangOlufsen: ime,
  Blaupunkt: sme,
  Bush: dme,
  Celcus: ume,
  Changhong: cme,
  CreNova: mme,
  Digihome: gme,
  DMM: fme,
  ELECTRONIA: pme,
  Essentielb: hme,
  Finlux: xme,
  "F&U": { regex: "FU[;,]", device: "tv", model: "" },
  Fuego: vme,
  GoGEN: Sme,
  Grundig: bme,
  Haier: yme,
  "Hi-Level": { regex: "HI-LEVEL[;,]", device: "tv", model: "" },
  Hisense: wme,
  Hitachi: _me,
  Horizon: Tme,
  Hotel: Ame,
  Humax: Pme,
  Hyundai: Mme,
  Ikea: $me,
  Intek: Cme,
  Inverto: Lme,
  JVC: Eme,
  Kalley: Ome,
  KUBO: Nme,
  Laurus: Dme,
  LG: kme,
  Lifemaxx: Gme,
  Linsar: Bme,
  Loewe: Ime,
  Luxor: Rme,
  Manhattan: Fme,
  MediaTek: Vme,
  Medion: Hme,
  Miray: Ume,
  MStar: Xme,
  MTC: Wme,
  Nordmende: Yme,
  Metz: Kme,
  Ok: Qme,
  Panasonic: jme,
  PEAQ: Zme,
  Philips: zme,
  Polaroid: qme,
  PROFiLO: Jme,
  Qilive: ege,
  REGAL: tge,
  Saba: rge,
  Salora: oge,
  Samsung: nge,
  SCBC: age,
  SEG: lge,
  Selevision: ige,
  Sharp: sge,
  Skyworth: dge,
  Smart: uge,
  Sony: cge,
  SWTV: mge,
  "TD Systems": { regex: "TDSystems[;,]", device: "tv", models: [{ regex: "SmartTV(2019|2020)", model: "Smart TV ($1)" }] },
  Technicolor: gge,
  Technika: fge,
  TechniSat: pge,
  TechnoTrend: hge,
  Techwood: xge,
  Telefunken: vge,
  TCL: Sge,
  Thomson: bge,
  TOKYO: yge,
  Toshiba: wge,
  Videoweb: _ge,
  VOX: Tge,
  WELLINGTON: Age,
  "X.Vision": { regex: "X-VISION[;,]", device: "tv", model: "" },
  Vestel: Pge
};
var pS;
function $ge() {
  if (pS) return ds;
  pS = 1;
  var e = ds && ds.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(ds, "__esModule", { value: !0 });
  const t = e(Mge), r = rn(), o = vo(), n = Dh();
  class a {
    constructor() {
      this.parse = (i) => {
        const s = {
          type: "",
          brand: "",
          model: ""
        };
        if (!this.isHbbTv(i))
          return s;
        s.type = "television";
        for (const [u, c] of Object.entries(t.default)) {
          const g = o.userAgentParser(c.regex, i);
          if (g) {
            if (s.brand = u, "model" in c && c.model)
              s.model = n.buildModel(r.variableReplacement(c.model, g)).trim();
            else if ("models" in c && c.models)
              for (const p of c.models) {
                const h = o.userAgentParser(p.regex, i);
                if (h) {
                  s.model = n.buildModel(r.variableReplacement(p.model, h)).trim();
                  break;
                }
              }
            break;
          }
        }
        return s;
      }, this.isHbbTv = (i) => o.userAgentParser("HbbTV/([1-9]{1}(?:.[0-9]{1}){1,2})", i);
    }
  }
  return ds.default = a, ds;
}
var us = {};
const Cge = { regex: "(?:Tesla/[0-9.]+|QtCarBrowser)", device: "car browser", models: [{ regex: "QtCarBrowser", model: "Model S" }, { regex: "Tesla/[0-9.]+", model: "" }] }, Lge = { regex: "sp9853i_1h10_vmm", device: "car browser", models: [{ regex: "sp9853i_1h10_vmm", model: "TS9" }] }, Ege = {
  Tesla: Cge,
  "MAC AUDIO": { regex: "Mac Audio Spro", device: "car browser", models: [{ regex: "Spro", model: "S Pro" }] },
  Topway: Lge
};
var hS;
function Oge() {
  if (hS) return us;
  hS = 1;
  var e = us && us.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(us, "__esModule", { value: !0 });
  const t = e(Ege), r = rn(), o = vo();
  class n {
    constructor() {
      this.parse = (l) => {
        const i = {
          type: "",
          brand: "",
          model: ""
        };
        for (const [s, u] of Object.entries(t.default))
          if (o.userAgentParser(u.regex, l)) {
            i.type = "car", i.brand = s;
            for (const g of u.models) {
              const p = o.userAgentParser(g.regex, l);
              p && (i.model = r.variableReplacement(g.model, p).trim());
            }
            break;
          }
        return i;
      };
    }
  }
  return us.default = n, us;
}
var cs = {};
const Nge = { regex: "Archos.*GAMEPAD([2]?)", device: "console", model: "Gamepad $1" }, Dge = { regex: "Xbox", device: "console", models: [{ regex: "Xbox Series X", model: "Xbox Series X" }, { regex: "Xbox One X", model: "Xbox One X" }, { regex: "Xbox One", model: "Xbox One" }, { regex: "XBOX_ONE_ED", model: "Xbox One S" }, { regex: "Xbox", model: "Xbox 360" }] }, kge = { regex: "Nintendo (([3]?DS[i]?)|Wii[U]?|Switch)", device: "console", model: "$1" }, Gge = { regex: "OUYA", device: "console", model: "OUYA" }, Bge = { regex: "Dreamcast", device: "console", model: "Dreamcast" }, Ige = { regex: "PlayStation (3|4 Pro|4|Portable|Vita)", device: "console", model: "PlayStation $1" }, Rge = {
  Archos: Nge,
  Microsoft: Dge,
  Nintendo: kge,
  OUYA: Gge,
  Sega: Bge,
  Sony: Ige
};
var xS;
function Fge() {
  if (xS) return cs;
  xS = 1;
  var e = cs && cs.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(cs, "__esModule", { value: !0 });
  const t = e(Rge), r = rn(), o = vo();
  class n {
    constructor() {
      this.parse = (l) => {
        const i = {
          type: "",
          brand: "",
          model: ""
        };
        for (const [s, u] of Object.entries(t.default)) {
          const c = o.userAgentParser(u.regex, l);
          if (c) {
            if (i.type = u.device, i.brand = s, "model" in u && u.model)
              i.model = r.variableReplacement(u.model, c).trim();
            else if ("models" in u && u.models)
              for (const g of u.models) {
                const p = o.userAgentParser(g.regex, l);
                if (p) {
                  i.model = r.variableReplacement(g.model, p).trim();
                  break;
                }
              }
            break;
          }
        }
        return i;
      };
    }
  }
  return cs.default = n, cs;
}
var ms = {};
const Vge = { regex: "FBMD/(?:Aspire E5-421G|Z5WAL|One S1003);", device: "desktop", models: [{ regex: "FBMD/Aspire E5-421G;", model: "Aspire E5-421G" }, { regex: "FBMD/Z5WAL;", model: "Aspire E5-511" }, { regex: "FBMD/One S1003;", model: "One 10" }] }, Hge = { regex: "FBMD/(?:K50IN|K54L|T100HAN|T103HAF|UX360CAK|X550LB|X553MA|X555LN|X556UQK);", device: "desktop", models: [{ regex: "FBMD/K50IN;", model: "K50IN" }, { regex: "FBMD/K54L;", model: "K54L" }, { regex: "FBMD/T100HAN;", model: "Transformer Book" }, { regex: "FBMD/T103HAF;", model: "Transformer Mini" }, { regex: "FBMD/UX360CAK;", model: "ZenBook Flip" }, { regex: "FBMD/X550LB;", model: "X550LB" }, { regex: "FBMD/X553MA;", model: "X553MA" }, { regex: "FBMD/X555LN;", model: "X555LN" }, { regex: "FBMD/X556UQK;", model: "X556UQK" }] }, Uge = { regex: "FBMD/(?:Latitude E4300|Inspiron 3541|XPS 15 95[35]0);", device: "desktop", models: [{ regex: "Latitude E4300", model: "Latitude E4300" }, { regex: "Inspiron 3541", model: "Inspiron 3541" }, { regex: "XPS 15 9530", model: "XPS 15 9530" }, { regex: "XPS 15 9550", model: "XPS 15 9550" }] }, Xge = { regex: "FBMD/((?:Compaq|HP) |23-f364)", device: "desktop", models: [{ regex: "Compaq Presario CQ61 Notebook PC", model: "Compaq Presario CQ61" }, { regex: "HP Pavilion x2 Detachable", model: "Pavilion x2" }, { regex: "HP Laptop 15-bs0xx", model: "15 Laptop PC" }, { regex: "HP ENVY x360 Convertible 15-bp0xx", model: "ENVY x360 Convertible PC" }, { regex: "HP EliteBook (25[67]0p)", model: "EliteBook $1" }, { regex: "HP ProBook (440 G5|6[35]60b)", model: "ProBook $1" }, { regex: "HP Pavilion dv6 Notebook PC", model: "Pavilion dv6" }, { regex: "HP Pavilion Notebook", model: "Pavilion" }, { regex: "HP Spectre x360 Convertible", model: "Spectre x360" }, { regex: "HP Pavilion All-in-One 24-r0xx", model: "Pavilion 24-r0xx All-in-One Desktop PC", device: "desktop" }, { regex: "23-f364", model: "Pavilion TouchSmart 23-f364 All-in-One Desktop PC", device: "desktop" }] }, Wge = { regex: "FBMD/(?:37021C5|80E5|80SM|80VR);", device: "desktop", models: [{ regex: "FBMD/37021C5;", model: "ThinkPad Helix 3702" }, { regex: "FBMD/80E5;", model: "G50-80" }, { regex: "FBMD/80SM;", model: "Ideapad 310-15ISK" }, { regex: "FBMD/80VR;", model: "Legion Y720" }] }, Yge = { regex: "FBMD/SCL141CTP;", device: "desktop", model: 'Notebook 14" Cherry Trail' }, Kge = { regex: "FBMD/TH360R12.32CTW;", device: "desktop", model: "Prestige TH-360R12.32CTW" }, Qge = { regex: "FBMD/Satellite ", device: "desktop", models: [{ regex: "Satellite (A[25]00|C650|C855|L650|S855)", model: "Satellite $1" }, { regex: "Satellite ([^;\\)]+);", model: "Satellite $1" }] }, jge = {
  Acer: Vge,
  Asus: Hge,
  Dell: Uge,
  HP: Xge,
  Lenovo: Wge,
  Schneider: Yge,
  Thomson: Kge,
  Toshiba: Qge
};
var vS;
function Zge() {
  if (vS) return ms;
  vS = 1;
  var e = ms && ms.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(ms, "__esModule", { value: !0 });
  const t = e(jge), r = rn(), o = vo(), n = Dh();
  class a {
    constructor() {
      this.parse = (i) => {
        const s = {
          type: "",
          brand: "",
          model: ""
        };
        if (!o.userAgentParser("FBMD/", i))
          return s;
        for (const [u, c] of Object.entries(t.default)) {
          const g = o.userAgentParser(c.regex, i);
          if (g) {
            if (s.type = "desktop", s.brand = u, "model" in c && c.model)
              s.model = n.buildModel(r.variableReplacement(c.model, g)).trim();
            else if ("models" in c && c.models)
              for (const p of c.models) {
                const h = o.userAgentParser(p.regex, i);
                h && (s.model = r.variableReplacement(p.model, h).trim());
              }
            break;
          }
        }
        return s;
      };
    }
  }
  return ms.default = a, ms;
}
var gs = {};
const zge = { regex: "(?:Apple-)?iPod", device: "portable media player", models: [{ regex: "(?:Apple-)?iPod1[C,]1", model: "iPod Touch 1G" }, { regex: "(?:Apple-)?iPod2[C,]1", model: "iPod Touch 2G" }, { regex: "(?:Apple-)?iPod3[C,]1", model: "iPod Touch 3" }, { regex: "(?:Apple-)?iPod4[C,]1", model: "iPod Touch 4" }, { regex: "(?:Apple-)?iPod5[C,]1", model: "iPod Touch 5" }, { regex: "(?:Apple-)?iPod7[C,]1", model: "iPod Touch 6" }, { regex: "(?:Apple-)?iPod", model: "iPod Touch" }] }, qge = { regex: "COWON ([^;/]+) Build", device: "portable media player", model: "$1" }, Jge = { regex: "Microsoft ZuneHD", device: "portable media player", model: "Zune HD" }, efe = { regex: "(SV-MV100)", device: "portable media player", model: "$1" }, tfe = { regex: "YP-(G[SIPB]?1|G[57]0|GB70D)", device: "portable media player", models: [{ regex: "YP-G[B]?1", model: "Galaxy Player 4.0" }, { regex: "YP-G70", model: "Galaxy Player 5.0" }, { regex: "YP-GS1", model: "Galaxy Player 3.6" }, { regex: "YP-GI1", model: "Galaxy Player 4.2" }, { regex: "YP-GP1", model: "Galaxy Player 5.8" }, { regex: "YP-G50", model: "Galaxy Player 50" }, { regex: "YP-GB70D", model: "Galaxy Player 70 Plus" }] }, rfe = { regex: "(DV-PTB1080)(?:[);/ ]|$)", device: "portable media player", model: "$1" }, ofe = { regex: "Sonos/.+\\((?:ZP.+)\\)|Sonos;", device: "portable media player", models: [{ regex: "\\((ZPS(?:[13569]|1[1-578]|2[03])|ZP90)\\)", model: "$1" }, { regex: "Sonos;Play5;", model: "Play:5" }, { regex: "Sonos;One;", model: "One" }] }, nfe = {
  Apple: zge,
  Cowon: qge,
  Microsoft: Jge,
  Panasonic: efe,
  Samsung: tfe,
  Wizz: rfe,
  SONOS: ofe
};
var SS;
function afe() {
  if (SS) return gs;
  SS = 1;
  var e = gs && gs.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(gs, "__esModule", { value: !0 });
  const t = e(nfe), r = rn(), o = vo();
  class n {
    constructor() {
      this.parse = (l) => {
        const i = {
          type: "",
          brand: "",
          model: ""
        };
        for (const [s, u] of Object.entries(t.default)) {
          const c = o.userAgentParser(u.regex, l);
          if (c) {
            if (i.type = u.device, i.brand = s, "model" in u && u.model)
              i.model = r.variableReplacement(u.model, c).trim();
            else if ("models" in u && u.models)
              for (const g of u.models) {
                const p = o.userAgentParser(g.regex, l);
                if (p) {
                  i.model = r.variableReplacement(g.model, p).trim();
                  break;
                }
              }
            break;
          }
        }
        return i;
      };
    }
  }
  return gs.default = n, gs;
}
var bS;
function lfe() {
  if (bS) return ls;
  bS = 1;
  var e = ls && ls.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(ls, "__esModule", { value: !0 });
  const t = e(FZ()), r = e(rme()), o = e($ge()), n = e(Oge()), a = e(Fge()), l = e(Zge()), i = e(afe()), s = [
    a.default,
    n.default,
    t.default,
    o.default,
    i.default,
    r.default,
    l.default
  ];
  class u {
    constructor() {
      this.parse = (g) => {
        for (const p of s) {
          const v = new p().parse(g);
          if (v.type !== "")
            return v;
        }
        return null;
      };
    }
  }
  return ls.default = u, ls;
}
var fs = {};
const ife = /* @__PURE__ */ JSON.parse('[{"regex":"Grid OS (\\\\d+[\\\\.\\\\d]+)","name":"GridOS","version":"$1"},{"regex":"CaixaMagica","name":"Caixa Mágica","version":""},{"regex":"Mageia; Linux","name":"Mageia","version":""},{"regex":"(?:WH|WhaleTV/)(\\\\d+[\\\\.\\\\d]+)","name":"Whale OS","version":"$1"},{"regex":"Tizen[ /]?(\\\\d+[\\\\.\\\\d]+)?","name":"Tizen","version":"$1"},{"regex":"Sailfish|Jolla","name":"Sailfish OS","version":""},{"regex":"(?:Ali)?YunOS[ /]?(\\\\d+[\\\\.\\\\d]+)?","name":"YunOS","version":"$1"},{"regex":"Windows Phone;FBSV/(\\\\d+[\\\\.\\\\d]+)","name":"Windows Phone","version":"$1"},{"regex":"(?:Windows Phone (?:OS)?|wds)[ /]?(\\\\d+[\\\\.\\\\d]+)","name":"Windows Phone","version":"$1"},{"regex":"XBLWP7|Windows Phone","name":"Windows Phone","version":""},{"regex":"Windows CE(?: (\\\\d+[\\\\.\\\\d]+))?","name":"Windows CE","version":"$1"},{"regex":"(?:IEMobile|Windows ?Mobile)(?: (\\\\d+[\\\\.\\\\d]+))?","name":"Windows Mobile","version":"$1"},{"regex":"Windows NT 6.2; ARM;","name":"Windows RT","version":""},{"regex":"Windows NT 6.3; ARM;","name":"Windows RT","version":"8.1"},{"regex":"Windows IoT 10.0","name":"Windows IoT","version":"10"},{"regex":"KAIOS(?:/(\\\\d+[\\\\.\\\\d]+))?","name":"KaiOS","version":"$1"},{"regex":"RazoDroiD(?: v(\\\\d+[\\\\.\\\\d]*))?","name":"RazoDroiD","version":"$1"},{"regex":"MildWild(?: CM-(\\\\d+[\\\\.\\\\d]*))?","name":"MildWild","version":"$1"},{"regex":"CyanogenMod(?:[\\\\-/](?:CM)?(\\\\d+[\\\\.\\\\d]*))?","name":"CyanogenMod","version":"$1"},{"regex":"(?:.*_)?MocorDroid(?:(\\\\d+[\\\\.\\\\d]*))?","name":"MocorDroid","version":"$1"},{"regex":"Fire OS(?:/(\\\\d+[\\\\.\\\\d]*))?","name":"Fire OS","version":"$1"},{"regex":"AFTSO001","name":"Fire OS","version":"7"},{"regex":"FydeOS","name":"FydeOS","version":""},{"regex":"(?:Podbean|Podimo)(?:.+)?/Android","name":"Android","version":""},{"regex":"Pinterest for Android/.+; (\\\\d(?:[\\\\d\\\\.]+)?)\\\\)$","name":"Android","version":"$1"},{"regex":"Android; (\\\\d+[\\\\.\\\\d]*); Mobile;","name":"Android","version":"$1"},{"regex":"[ ]([\\\\d\\\\.]+)\\\\) AppleWebKit.*ROBLOX Android App","name":"Android","version":"$1"},{"regex":"(?:(?:Orca-)?Android|Adr)[ /]?(?:[a-z]+ )?(\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"(?:Allview_TX1_Quasar|Cosmote_My_mini_Tab) (\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"Android ?(?:jelly bean|Kit Kat|S.O. Ginger Bread|The FireCyano|:) (\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"(?:Orca-Android|FB4A).*FBSV/(\\\\d+[\\\\.\\\\d]*);","name":"Android","version":"$1"},{"regex":" Adr |Android|Silk-Accelerated=[a-z]{4,5}","name":"Android","version":""},{"regex":"(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"BeyondPod|AntennaPod|Podkicker|DoggCatcher|Player FM|okhttp|Podcatcher Deluxe|.+K_?Android_?TV_|Sonos/.+\\\\(ACR_","name":"Android","version":""},{"regex":"Linux; Andr0id[; ](\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"Linux; diordnA[; ](\\\\d+[\\\\.\\\\d]*)","name":"Android","version":"$1"},{"regex":"AmigaOS[ ]?(\\\\d+[\\\\.\\\\d]+)","name":"AmigaOS","version":"$1"},{"regex":"AmigaOS|AmigaVoyager|Amiga-AWeb","name":"AmigaOS","version":""},{"regex":"ThreadX(?:/(\\\\d+[\\\\.\\\\d]*))?","name":"ThreadX","version":"$1"},{"regex":"Nucleus(?:(?: |/v?)(\\\\d+[\\\\.\\\\d]*))?","name":"MTK / Nucleus","version":"$1"},{"regex":"MTK(?:(?: |/v?)(\\\\d+[\\\\.\\\\d]*))?","name":"MTK / Nucleus","version":"$1"},{"regex":"MRE/(\\\\d+)\\\\.(\\\\d+).*;MAUI","name":"MRE","version":"$1.$2"},{"regex":"dvkbuntu","name":"DVKBuntu","version":""},{"regex":"Helio/(\\\\d+[\\\\.\\\\d]+)","name":"Lumin OS","version":"$1"},{"regex":"HasCodingOs (\\\\d+[\\\\.\\\\d]+)","name":"HasCodingOS","version":"$1"},{"regex":"PCLinuxOS/(\\\\d+[\\\\.\\\\d]+)","name":"PCLinuxOS","version":"$1"},{"regex":"(Ordissimo|webissimo3)","name":"Ordissimo","version":""},{"regex":"(?:Win|Sistema )Fenix","name":"Fenix","version":""},{"regex":"TOS; Linux","name":"TmaxOS","version":""},{"regex":"Maemo","name":"Maemo","version":""},{"regex":"Arch ?Linux(?:[ /\\\\-](\\\\d+[\\\\.\\\\d]+))?","name":"Arch Linux","version":"$1"},{"regex":"VectorLinux(?: package)?(?:[ /\\\\-](\\\\d+[\\\\.\\\\d]+))?","name":"VectorLinux","version":"$1"},{"regex":"Linux; .*((?:Debian|Knoppix|Mint|Ubuntu|Kubuntu|Xubuntu|Lubuntu|Fedora|Red Hat|Mandriva|Gentoo|Sabayon|Slackware|SUSE|CentOS|BackTrack))[ /](\\\\d+[\\\\.\\\\d]+)","name":"$1","version":"$2"},{"regex":"Deepin[ /](\\\\d+[\\\\.\\\\d]+)","name":"Deepin","version":"$1"},{"regex":"(Debian|Knoppix|Mint(?! Browser)|Ubuntu|Kubuntu|Xubuntu|Lubuntu|Fedora|Red Hat|Mandriva|Gentoo|Sabayon|Slackware|SUSE|CentOS|BackTrack|Freebox)(?:(?: Enterprise)? Linux)?(?:[ /\\\\-](\\\\d+[\\\\.\\\\d]+))?","name":"$1","version":"$2"},{"regex":"OS ROSA; Linux","name":"Rosa","version":""},{"regex":"WEBOS(\\\\d+[\\\\.\\\\d]+)","name":"webOS","version":"$1"},{"regex":"Web0S; Linux/SmartTV.+Chrome/68","name":"webOS","version":"5"},{"regex":"Web0S; Linux/SmartTV.+Chrome/53","name":"webOS","version":"4"},{"regex":"Web0S; Linux/SmartTV.+Chrome/38","name":"webOS","version":"3"},{"regex":"Web0S; Linux/SmartTV.+Safari/538","name":"webOS","version":"2"},{"regex":"Web0S; Linux/SmartTV.+Safari/537","name":"webOS","version":"1"},{"regex":"(?:Web0S; .*WEBOS|webOS|web0S|Palm webOS|hpwOS)(?:[/]?(\\\\d+[\\\\.\\\\d]+))?","name":"webOS","version":"$1"},{"regex":"(?:PalmOS|Palm OS)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?|Palm","name":"palmOS","version":"$1"},{"regex":"Xiino(?:.*v\\\\. (\\\\d+[\\\\.\\\\d]+))?","name":"palmOS","version":"$1"},{"regex":"MorphOS(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"MorphOS","version":"$1"},{"regex":"FBW.+FBSV/(\\\\d+[\\\\.\\\\d]*);","name":"Windows","version":"$1"},{"regex":"mingw32","name":"Windows","version":""},{"regex":"Windows/(\\\\d+\\\\.\\\\d+)","name":"Windows","version":"$1"},{"regex":"CYGWIN_NT-10.0|Windows NT 10.0|Windows 10","name":"Windows","version":"10"},{"regex":"CYGWIN_NT-6.4|Windows NT 6.4|Windows 10|win10","name":"Windows","version":"10"},{"regex":"CYGWIN_NT-6.3|Windows NT 6.3|Windows 8.1","name":"Windows","version":"8.1"},{"regex":"CYGWIN_NT-6.2|Windows NT 6.2|Windows 8","name":"Windows","version":"8"},{"regex":"CYGWIN_NT-6.1|Windows NT 6.1|Windows 7|win7","name":"Windows","version":"7"},{"regex":"CYGWIN_NT-6.0|Windows NT 6.0|Windows Vista","name":"Windows","version":"Vista"},{"regex":"CYGWIN_NT-5.2|Windows NT 5.2|Windows Server 2003 / XP x64","name":"Windows","version":"Server 2003"},{"regex":"CYGWIN_NT-5.1|Windows NT 5.1|Windows XP","name":"Windows","version":"XP"},{"regex":"CYGWIN_NT-5.0|Windows NT 5.0|Windows 2000","name":"Windows","version":"2000"},{"regex":"CYGWIN_NT-4.0|Windows NT 4.0|WinNT|Windows NT","name":"Windows","version":"NT"},{"regex":"CYGWIN_ME-4.90|Win 9x 4.90|Windows ME","name":"Windows","version":"ME"},{"regex":"CYGWIN_98-4.10|Win98|Windows 98","name":"Windows","version":"98"},{"regex":"CYGWIN_95-4.0|Win32|Win95|Windows 95|Windows_95","name":"Windows","version":"95"},{"regex":"Windows 3.1","name":"Windows","version":"3.1"},{"regex":"Windows","name":"Windows","version":""},{"regex":"Haiku","name":"Haiku OS","version":""},{"regex":"(?:Watch1,[12]/|Watch OS,|watchOS[ /])(\\\\d+[\\\\.\\\\d]*)","name":"watchOS","version":"$1"},{"regex":"iPad/([89]|1[012]).(\\\\d+[\\\\.\\\\d]*)","name":"iOS","version":"$1.$2"},{"regex":"Pinterest for iOS/.+; (\\\\d(?:[\\\\d\\\\.]+)?)\\\\)$","name":"iOS","version":"$1"},{"regex":"CFNetwork/.+ Darwin/20.4.0(?!.*x86_64)","name":"iOS","version":"14.5"},{"regex":"CFNetwork/.+ Darwin/20.3.0(?!.*x86_64)","name":"iOS","version":"14.4"},{"regex":"CFNetwork/.+ Darwin/20.2.0(?!.*x86_64)","name":"iOS","version":"14.3"},{"regex":"CFNetwork/.+ Darwin/20.1.0(?!.*x86_64)","name":"iOS","version":"14.2"},{"regex":"CFNetwork/.+ Darwin/20.0.0(?!.*x86_64)","name":"iOS","version":"14.0"},{"regex":"CFNetwork/.+ Darwin/19.6.0(?!.*x86_64)","name":"iOS","version":"13.6"},{"regex":"CFNetwork/.+ Darwin/19.5.0(?!.*x86_64)","name":"iOS","version":"13.5"},{"regex":"CFNetwork/.+ Darwin/19.4.0(?!.*x86_64)","name":"iOS","version":"13.4"},{"regex":"CFNetwork/.+ Darwin/19.3.0(?!.*x86_64)","name":"iOS","version":"13.3.1"},{"regex":"CFNetwork/.+ Darwin/19.2.0(?!.*x86_64)","name":"iOS","version":"13.3"},{"regex":"CFNetwork/.+ Darwin/19.0.0(?!.*x86_64)","name":"iOS","version":"13.0"},{"regex":"CFNetwork/.+ Darwin/18.7.0(?!.*x86_64)","name":"iOS","version":"12.4"},{"regex":"CFNetwork/.+ Darwin/18.6.0(?!.*x86_64)","name":"iOS","version":"12.3"},{"regex":"CFNetwork/.+ Darwin/18.5.0(?!.*x86_64)","name":"iOS","version":"12.2"},{"regex":"CFNetwork/.+ Darwin/18.2.0(?!.*x86_64)","name":"iOS","version":"12.1"},{"regex":"CFNetwork/.+ Darwin/18.0.0(?!.*x86_64)","name":"iOS","version":"12.0"},{"regex":"CFNetwork/.+ Darwin/17.7.0(?!.*x86_64)","name":"iOS","version":"11.4.1"},{"regex":"CFNetwork/.+ Darwin/17.6.0(?!.*x86_64)","name":"iOS","version":"11.4"},{"regex":"CFNetwork/889(?!.*x86_64)","name":"iOS","version":"11.1"},{"regex":"CFNetwork/887(?!.*x86_64)","name":"iOS","version":"11.0"},{"regex":"CFNetwork/811(?!.*x86_64)","name":"iOS","version":"10.3"},{"regex":"CFNetwork/808\\\\.3","name":"iOS","version":"10.3"},{"regex":"CFNetwork/808\\\\.2","name":"iOS","version":"10.2"},{"regex":"CFNetwork/808\\\\.1","name":"iOS","version":"10.1"},{"regex":"CFNetwork/808\\\\.0","name":"iOS","version":"10.0"},{"regex":"CFNetwork/808","name":"iOS","version":"10"},{"regex":"CFNetwork/758\\\\.4\\\\.3","name":"iOS","version":"9.3.2"},{"regex":"CFNetwork/758\\\\.3\\\\.15","name":"iOS","version":"9.3"},{"regex":"CFNetwork/758\\\\.2\\\\.[78]","name":"iOS","version":"9.2"},{"regex":"CFNetwork/758\\\\.1\\\\.6","name":"iOS","version":"9.1"},{"regex":"CFNetwork/758\\\\.0\\\\.2","name":"iOS","version":"9.0"},{"regex":"CFNetwork/711\\\\.5\\\\.6","name":"iOS","version":"8.4.1"},{"regex":"CFNetwork/711\\\\.4\\\\.6","name":"iOS","version":"8.4"},{"regex":"CFNetwork/711\\\\.3\\\\.18","name":"iOS","version":"8.3"},{"regex":"CFNetwork/711\\\\.2\\\\.23","name":"iOS","version":"8.2"},{"regex":"CFNetwork/711\\\\.1\\\\.1[26]","name":"iOS","version":"8.1"},{"regex":"CFNetwork/711\\\\.0\\\\.6","name":"iOS","version":"8.0"},{"regex":"CFNetwork/672\\\\.1","name":"iOS","version":"7.1"},{"regex":"CFNetwork/672\\\\.0","name":"iOS","version":"7.0"},{"regex":"CFNetwork/609\\\\.1","name":"iOS","version":"6.1"},{"regex":"CFNetwork/60[29]","name":"iOS","version":"6.0"},{"regex":"CFNetwork/548\\\\.1","name":"iOS","version":"5.1"},{"regex":"CFNetwork/548\\\\.0","name":"iOS","version":"5.0"},{"regex":"CFNetwork/485\\\\.13","name":"iOS","version":"4.3"},{"regex":"CFNetwork/485\\\\.12","name":"iOS","version":"4.2"},{"regex":"CFNetwork/485\\\\.10","name":"iOS","version":"4.1"},{"regex":"CFNetwork/485\\\\.2","name":"iOS","version":"4.0"},{"regex":"CFNetwork/467\\\\.12","name":"iOS","version":"3.2"},{"regex":"CFNetwork/459","name":"iOS","version":"3.1"},{"regex":"iPhone/(\\\\d+[\\\\.\\\\d]*) hw/","name":"iOS","version":"$1"},{"regex":"iOS(\\\\d+\\\\.\\\\d+\\\\.\\\\d+)","name":"iOS","version":"$1"},{"regex":"iOS(\\\\d+)\\\\.(\\\\d+)0","name":"iOS","version":"$1.$2"},{"regex":"iPhone OS ([0-9]{1})([0-9]{1})([0-9]{1})","name":"iOS","version":"$1.$2.$3"},{"regex":"(?:CPU OS|iPh(?:one)?[ _]OS|iOS)[ _/](\\\\d+(?:[_\\\\.]\\\\d+)*)","name":"iOS","version":"$1"},{"regex":"(?:FBIOS|Messenger(?:Lite)?ForiOS).*FBSV/ ?(\\\\d+[\\\\.\\\\d]*);","name":"iOS","version":"$1"},{"regex":"(?:Apple-)?(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\\\d+\\\\.\\\\d+)|; Opera)?","name":"iOS","version":"$1"},{"regex":"(?:Podcasts/(?:[\\\\d\\\\.]+)|Instacast(?:HD)?/(?:\\\\d\\\\.[\\\\d\\\\.abc]+)|Pocket Casts, iOS|\\\\(iOS\\\\)|iOS; Opera|Overcast|Castro|Podcat|iCatcher|RSSRadio/|MobileSafari/)(?!.*x86_64)","name":"iOS","version":""},{"regex":"iTunes-(iPod|iPad|iPhone)/(?:[\\\\d\\\\.]+)","name":"iOS","version":""},{"regex":"iOS/Version ([\\\\d\\\\.]+)","name":"iOS","version":"$1"},{"regex":"Sonos/.+\\\\(ICRU_","name":"iOS","version":""},{"regex":"CFNetwork/.+ Darwin/20.2.0.*(x86_64)|(x86_64-apple-)?darwin20.2.0","name":"Mac","version":"11.1"},{"regex":"CFNetwork/.+ Darwin/20.[01].0.*(x86_64)|(x86_64-apple-)?darwin20.[01].0","name":"Mac","version":"11.0"},{"regex":"CFNetwork/.+ Darwin/19.6.0.*(x86_64)|(x86_64-apple-)?darwin19.6.0","name":"Mac","version":"10.15.6"},{"regex":"CFNetwork/.+ Darwin/19.5.0.*(x86_64)|(x86_64-apple-)?darwin19.5.0","name":"Mac","version":"10.15.5"},{"regex":"CFNetwork/.+ Darwin/19.4.0.*(x86_64)|(x86_64-apple-)?darwin19.4.0","name":"Mac","version":"10.15.4"},{"regex":"CFNetwork/.+ Darwin/19.3.0.*(x86_64)|(x86_64-apple-)?darwin19.3.0","name":"Mac","version":"10.15.3"},{"regex":"CFNetwork/.+ Darwin/19.2.0.*(x86_64)|(x86_64-apple-)?darwin19.2.0","name":"Mac","version":"10.15.2"},{"regex":"CFNetwork/(?:108[258]|109[18]|1103).*(x86_64)","name":"Mac","version":"10.15"},{"regex":"CFNetwork/.+ Darwin/18.2.0.*(x86_64)|(x86_64-apple-)?darwin18.2.0","name":"Mac","version":"10.14.1"},{"regex":"CFNetwork/(?:96[29]|97[14568]).*(x86_64)","name":"Mac","version":"10.14"},{"regex":"CFNetwork/.+ Darwin/17.7.0.*(x86_64)|(x86_64-apple-)?darwin17.7.0","name":"Mac","version":"10.13.6"},{"regex":"CFNetwork/.+ Darwin/17.6.0.*(x86_64)|(x86_64-apple-)?darwin17.6.0","name":"Mac","version":"10.13.5"},{"regex":"CFNetwork/.+ Darwin/17.5.0.*(x86_64)|(x86_64-apple-)?darwin17.5.0","name":"Mac","version":"10.13.4"},{"regex":"CFNetwork/.+ Darwin/17.4.0.*(x86_64)|(x86_64-apple-)?darwin17.4.0","name":"Mac","version":"10.13.3"},{"regex":"CFNetwork/.+ Darwin/17.3.0.*(x86_64)|(x86_64-apple-)?darwin17.3.0","name":"Mac","version":"10.13.2"},{"regex":"CFNetwork/.+ Darwin/17.2.0.*(x86_64)|(x86_64-apple-)?darwin17.2.0","name":"Mac","version":"10.13.1"},{"regex":"CFNetwork/(?:887|889|893|897|901|902).*(x86_64)","name":"Mac","version":"10.13"},{"regex":"CFNetwork/.+ Darwin/16.7.0.*(x86_64)|(x86_64-apple-)?darwin16.7.0","name":"Mac","version":"10.12.6"},{"regex":"CFNetwork/.+ Darwin/16.6.0.*(x86_64)|(x86_64-apple-)?darwin16.6.0","name":"Mac","version":"10.12.5"},{"regex":"CFNetwork/.+ Darwin/16.5.0.*(x86_64)|(x86_64-apple-)?darwin16.5.0","name":"Mac","version":"10.12.4"},{"regex":"CFNetwork/.+ Darwin/16.3.0.*(x86_64)|(x86_64-apple-)?darwin16.3.0","name":"Mac","version":"10.12.3"},{"regex":"CFNetwork/.+ Darwin/16.2.0.*(x86_64)|(x86_64-apple-)?darwin16.2.0","name":"Mac","version":"10.12.2"},{"regex":"CFNetwork/.+ Darwin/16.1.0.*(x86_64)|(x86_64-apple-)?darwin16.1.0","name":"Mac","version":"10.12.1"},{"regex":"CFNetwork/811.*(x86_64)","name":"Mac","version":"10.12"},{"regex":"CFNetwork/807","name":"Mac","version":"10.12"},{"regex":"CFNetwork/.+ Darwin/15.6.0.*(x86_64)|(x86_64-apple-)?darwin15.6.0","name":"Mac","version":"10.11.6"},{"regex":"CFNetwork/.+ Darwin/15.5.0.*(x86_64)|(x86_64-apple-)?darwin15.5.0","name":"Mac","version":"10.11.5"},{"regex":"CFNetwork/.+ Darwin/15.4.0.*(x86_64)|(x86_64-apple-)?darwin15.4.0","name":"Mac","version":"10.11.4"},{"regex":"CFNetwork/.+ Darwin/15.3.0.*(x86_64)|(x86_64-apple-)?darwin15.3.0","name":"Mac","version":"10.11.3"},{"regex":"CFNetwork/.+ Darwin/15.2.0.*(x86_64)|(x86_64-apple-)?darwin15.2.0","name":"Mac","version":"10.11.2"},{"regex":"CFNetwork/760","name":"Mac","version":"10.11"},{"regex":"CFNetwork/.+ Darwin/14.5.0.*(x86_64)|(x86_64-apple-)?darwin14.5.0","name":"Mac","version":"10.10.5"},{"regex":"CFNetwork/.+ Darwin/14.4.0.*(x86_64)|(x86_64-apple-)?darwin14.4.0","name":"Mac","version":"10.10.4"},{"regex":"CFNetwork/.+ Darwin/14.3.0.*(x86_64)|(x86_64-apple-)?darwin14.3.0","name":"Mac","version":"10.10.3"},{"regex":"CFNetwork/.+ Darwin/14.1.0.*(x86_64)|(x86_64-apple-)?darwin14.1.0","name":"Mac","version":"10.10.2"},{"regex":"CFNetwork/720","name":"Mac","version":"10.10"},{"regex":"CFNetwork/.+ Darwin/13.4.0.*(x86_64)|(x86_64-apple-)?darwin13.4.0","name":"Mac","version":"10.9.5"},{"regex":"CFNetwork/.+ Darwin/13.3.0.*(x86_64)|(x86_64-apple-)?darwin13.3.0","name":"Mac","version":"10.9.4"},{"regex":"CFNetwork/.+ Darwin/13.2.0.*(x86_64)|(x86_64-apple-)?darwin13.2.0","name":"Mac","version":"10.9.3"},{"regex":"CFNetwork/.+ Darwin/13.1.0.*(x86_64)|(x86_64-apple-)?darwin13.1.0","name":"Mac","version":"10.9.2"},{"regex":"CFNetwork/673","name":"Mac","version":"10.9"},{"regex":"CFNetwork/.+ Darwin/12.5.0.*(x86_64)|(x86_64-apple-)?darwin12.5.0","name":"Mac","version":"10.8.5"},{"regex":"CFNetwork/.+ Darwin/12.4.0.*(x86_64)|(x86_64-apple-)?darwin12.4.0","name":"Mac","version":"10.8.4"},{"regex":"CFNetwork/.+ Darwin/12.3.0.*(x86_64)|(x86_64-apple-)?darwin12.3.0","name":"Mac","version":"10.8.3"},{"regex":"CFNetwork/.+ Darwin/12.2.0.*(x86_64)|(x86_64-apple-)?darwin12.2.0","name":"Mac","version":"10.8.2"},{"regex":"CFNetwork/.+ Darwin/12.1.0.*(x86_64)|(x86_64-apple-)?darwin12.1.0","name":"Mac","version":"10.8.1"},{"regex":"CFNetwork/596","name":"Mac","version":"10.8"},{"regex":"CFNetwork/.+ Darwin/11.5.0.*(x86_64)|(x86_64-apple-)?darwin11.5.0","name":"Mac","version":"10.7.5"},{"regex":"CFNetwork/.+ Darwin/11.4.0.*(x86_64)|(x86_64-apple-)?darwin11.4.0","name":"Mac","version":"10.7.4"},{"regex":"CFNetwork/.+ Darwin/11.3.0.*(x86_64)|(x86_64-apple-)?darwin11.3.0","name":"Mac","version":"10.7.3"},{"regex":"CFNetwork/.+ Darwin/11.2.0.*(x86_64)|(x86_64-apple-)?darwin11.2.0","name":"Mac","version":"10.7.2"},{"regex":"CFNetwork/.+ Darwin/11.1.0.*(x86_64)|(x86_64-apple-)?darwin11.1.0","name":"Mac","version":"10.7.1"},{"regex":"CFNetwork/520","name":"Mac","version":"10.7"},{"regex":"CFNetwork/454","name":"Mac","version":"10.6"},{"regex":"CFNetwork/(?:438|422|339|330|221|220|217)","name":"Mac","version":"10.5"},{"regex":"CFNetwork/12[89]","name":"Mac","version":"10.4"},{"regex":"CFNetwork/1\\\\.2","name":"Mac","version":"10.3"},{"regex":"CFNetwork/1\\\\.1","name":"Mac","version":"10.2"},{"regex":"Mac[ +]OS[ +]?X(?:[ /](?:Version )?(\\\\d+(?:[_\\\\.]\\\\d+)+))?","name":"Mac","version":"$1"},{"regex":"Mac (?:OS/)?(\\\\d+(?:[_\\\\.]\\\\d+)+)","name":"Mac","version":"$1"},{"regex":"macOS/(\\\\d+[\\\\.\\\\d]+)","name":"Mac","version":"$1"},{"regex":"Darwin|Macintosh|Mac_PowerPC|PPC|Mac PowerPC|iMac|MacBook|macOS|Sonos/.+\\\\(MDCR_","name":"Mac","version":""},{"regex":"SeewoOS x86_64 (\\\\d+[\\\\.\\\\d]+)","name":"SeewoOS","version":"$1"},{"regex":"CrOS [a-z0-9_]+ .* Chrome/(\\\\d+[\\\\.\\\\d]+)","name":"Chrome OS","version":"$1"},{"regex":"(?:BB10;.+Version|Black[Bb]erry[0-9a-z]+|Black[Bb]erry.+Version)/(\\\\d+[\\\\.\\\\d]+)","name":"BlackBerry OS","version":"$1"},{"regex":"RIM Tablet OS (\\\\d+[\\\\.\\\\d]+)","name":"BlackBerry Tablet OS","version":"$1"},{"regex":"RIM Tablet OS|QNX|Play[Bb]ook","name":"BlackBerry Tablet OS","version":""},{"regex":"BlackBerry","name":"BlackBerry OS","version":""},{"regex":"bPod","name":"BlackBerry OS","version":""},{"regex":"BeOS","name":"BeOS","version":""},{"regex":"Symbian/3.+NokiaBrowser/7\\\\.3","name":"Symbian^3","version":"Anna"},{"regex":"Symbian/3.+NokiaBrowser/7\\\\.4","name":"Symbian^3","version":"Belle"},{"regex":"Symbian/3","name":"Symbian^3","version":""},{"regex":"(?:Series ?60|SymbOS|S60)(?:[ /]?(\\\\d+[\\\\.\\\\d]+|V\\\\d+))?","name":"Symbian OS Series 60","version":"$1"},{"regex":"Series40","name":"Symbian OS Series 40","version":""},{"regex":"SymbianOS/(\\\\d+[\\\\.\\\\d]+)","name":"Symbian OS","version":"$1"},{"regex":"MeeGo|WeTab","name":"MeeGo","version":""},{"regex":"Symbian(?: OS)?|SymbOS","name":"Symbian OS","version":""},{"regex":"Nokia","name":"Symbian","version":""},{"regex":"(?:Mobile|Tablet);.+Firefox/\\\\d+\\\\.\\\\d+","name":"Firefox OS","version":""},{"regex":"RISC OS(?:-NC)?(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"RISC OS","version":"$1"},{"regex":"Inferno(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Inferno","version":"$1"},{"regex":"bada(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Bada","version":"$1"},{"regex":"(?:Brew(?!-Applet)(?: MP)?|BMP)(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Brew","version":"$1"},{"regex":"GoogleTV(?:[ /](\\\\d+[\\\\.\\\\d]+))?","name":"Google TV","version":"$1"},{"regex":"AppleTV(?:/?(\\\\d+[\\\\.\\\\d]+))?","name":"Apple TV","version":"$1"},{"regex":"WebTV/(\\\\d+[\\\\.\\\\d]+)","name":"WebTV","version":"$1"},{"regex":"RemixOS 5.1.1","name":"Remix OS","version":"1"},{"regex":"RemixOS 6.0","name":"Remix OS","version":"2"},{"regex":"RemixOS","name":"Remix OS","version":""},{"regex":"(?:SunOS|Solaris)(?:[/ ](\\\\d+[\\\\.\\\\d]+))?","name":"Solaris","version":"$1"},{"regex":"AIX(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"AIX","version":"$1"},{"regex":"HP-UX(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"HP-UX","version":"$1"},{"regex":"FreeBSD(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"FreeBSD","version":"$1"},{"regex":"NetBSD(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"NetBSD","version":"$1"},{"regex":"OpenBSD(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"OpenBSD","version":"$1"},{"regex":"DragonFly(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"DragonFly","version":"$1"},{"regex":"Syllable(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))?","name":"Syllable","version":"$1"},{"regex":"IRIX(?:;64)?(?:[/ ]?(\\\\d+[\\\\.\\\\d]+))","name":"IRIX","version":"$1"},{"regex":"OSF1(?:[/ ]?v?(\\\\d+[\\\\.\\\\d]+))?","name":"OSF1","version":"$1"},{"regex":"Nintendo (Wii|Switch)","name":"Nintendo","version":"$1"},{"regex":"PlayStation ?([34])","name":"PlayStation","version":"$1"},{"regex":"Xbox|KIN\\\\.(?:One|Two)","name":"Xbox","version":"360"},{"regex":"Nitro|Nintendo ([3]?DS[i]?)","name":"Nintendo Mobile","version":"$1"},{"regex":"PlayStation ((?:Portable|Vita))","name":"PlayStation Portable","version":"$1"},{"regex":"OS/2","name":"OS/2","version":""},{"regex":"Linux(?:OS)?[^a-z]","name":"GNU/Linux","version":""}]'), sfe = { AIX: "AIX", AND: "Android", AMG: "AmigaOS", ATV: "Apple TV", ARL: "Arch Linux", BTR: "BackTrack", SBA: "Bada", BEO: "BeOS", BLB: "BlackBerry OS", QNX: "BlackBerry Tablet OS", BMP: "Brew", CES: "CentOS", COS: "Chrome OS", CYN: "CyanogenMod", DEB: "Debian", DEE: "Deepin", DFB: "DragonFly", FED: "Fedora", FOS: "Firefox OS", FIR: "Fire OS", FRE: "Freebox", BSD: "FreeBSD", FYD: "FydeOS", GNT: "Gentoo", GTV: "Google TV", HPX: "HP-UX", HAI: "Haiku OS", IRI: "IRIX", INF: "Inferno", KOS: "KaiOS", KNO: "Knoppix", KBT: "Kubuntu", LIN: "GNU/Linux", LBT: "Lubuntu", VLN: "VectorLinux", MAC: "Mac", MAE: "Maemo", MDR: "Mandriva", SMG: "MeeGo", MCD: "MocorDroid", MIN: "Mint", MLD: "MildWild", MOR: "MorphOS", NBS: "NetBSD", MTK: "MTK / Nucleus", MRE: "MRE", WII: "Nintendo", NDS: "Nintendo Mobile", OS2: "OS/2", T64: "OSF1", OBS: "OpenBSD", ORD: "Ordissimo", PSP: "PlayStation Portable", PS3: "PlayStation", RHT: "Red Hat", ROS: "RISC OS", RSO: "Rosa", REM: "Remix OS", RZD: "RazoDroiD", SAB: "Sabayon", SSE: "SUSE", SAF: "Sailfish OS", SEE: "SeewoOS", SLW: "Slackware", SOS: "Solaris", SYL: "Syllable", SYM: "Symbian", SYS: "Symbian OS", S40: "Symbian OS Series 40", S60: "Symbian OS Series 60", SY3: "Symbian^3", TDX: "ThreadX", TIZ: "Tizen", TOS: "TmaxOS", UBT: "Ubuntu", WAS: "watchOS", WTV: "WebTV", WHS: "Whale OS", WIN: "Windows", WCE: "Windows CE", WIO: "Windows IoT", WMO: "Windows Mobile", WPH: "Windows Phone", WRT: "Windows RT", XBX: "Xbox", XBT: "Xubuntu", YNS: "YunOs", IOS: "iOS", POS: "palmOS", WOS: "webOS" }, dfe = { Android: ["AND", "CYN", "FIR", "REM", "RZD", "MLD", "MCD", "YNS"], AmigaOS: ["AMG", "MOR"], "Apple TV": ["ATV"], BlackBerry: ["BLB", "QNX"], Brew: ["BMP"], BeOS: ["BEO", "HAI"], "Chrome OS": ["COS", "FYD", "SEE"], "Firefox OS": ["FOS", "KOS"], "Gaming Console": ["WII", "PS3"], "Google TV": ["GTV"], IBM: ["OS2"], iOS: ["IOS", "WAS"], "RISC OS": ["ROS"], "GNU/Linux": ["LIN", "ARL", "DEB", "KNO", "MIN", "UBT", "KBT", "XBT", "LBT", "FED", "RHT", "VLN", "MDR", "GNT", "SAB", "SLW", "SSE", "CES", "BTR", "SAF", "ORD", "TOS", "RSO", "DEE", "FRE"], Mac: ["MAC"], "Mobile Gaming Console": ["PSP", "NDS", "XBX"], "Real-time OS": ["MTK", "TDX", "MRE"], "Other Mobile": ["WOS", "POS", "SBA", "TIZ", "SMG", "MAE"], Symbian: ["SYM", "SYS", "SY3", "S60", "S40"], Unix: ["SOS", "AIX", "HPX", "BSD", "NBS", "OBS", "DFB", "SYL", "IRI", "T64", "INF"], WebTV: ["WTV"], Windows: ["WIN"], "Windows Mobile": ["WPH", "WMO", "WCE", "WRT", "WIO"], "Other Smart TV": ["WHS"] }, ufe = {
  operatingSystem: sfe,
  osFamilies: dfe
};
var yS;
function cfe() {
  if (yS) return fs;
  yS = 1;
  var e = fs && fs.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(fs, "__esModule", { value: !0 });
  const t = e(ife), r = Ei(), o = rn(), n = vo(), a = e(ufe), l = ["AmigaOS", "IBM", "GNU/Linux", "Mac", "Unix", "Windows", "BeOS", "Chrome OS"], i = a.default.operatingSystem, s = a.default.osFamilies;
  class u {
    constructor(g) {
      this.options = {
        versionTruncation: 1
      }, this.parse = (p) => {
        const h = {
          name: "",
          version: "",
          platform: this.parsePlatform(p)
        };
        for (const v of t.default) {
          const A = n.userAgentParser(v.regex, p);
          if (A)
            return h.name = o.variableReplacement(v.name, A), h.version = r.formatVersion(o.variableReplacement(v.version, A), this.options.versionTruncation), h.name === "lubuntu" && (h.name = "Lubuntu"), h.name === "debian" && (h.name = "Debian"), h.name === "YunOS" && (h.name = "YunOs"), h;
        }
        return null;
      }, this.parsePlatform = (p) => n.userAgentParser("arm|aarch64|Watch ?OS|Watch1,[12]", p) ? "ARM" : n.userAgentParser("mips", p) ? "MIPS" : n.userAgentParser("sh4", p) ? "SuperH" : n.userAgentParser("WOW64|x64|win64|amd64|x86_?64", p) ? "x64" : n.userAgentParser("(?:i[0-9]|x)86|i86pc", p) ? "x86" : "", this.options = Object.assign(Object.assign({}, this.options), g);
    }
  }
  return fs.default = u, u.getDesktopOsArray = () => l, u.getOsFamily = (c) => {
    const g = u.getOsShortName(c);
    for (const [p, h] of Object.entries(s))
      if (h.includes(g))
        return p;
    return "";
  }, u.getOsShortName = (c) => {
    for (const [g, p] of Object.entries(i))
      if (p === c)
        return g;
    return "";
  }, fs;
}
var ps = {};
const mfe = ["MDDR(JS)?", "MDDC(JS)?", "MDDS(JS)?"], gfe = ["MAAR(JS)?"], ffe = ["MASE(JS)?", "MASP(JS)?", "MASA(JS)?"], pfe = ["MAAU", "NP0[26789]", "ASJB", "ASU2(JS)?"], hfe = ["MASM(JS)?", "SMJB"], xfe = ["MALC(JS)?", "MALE(JS)?", "MALN(JS)?", "LCJB", "LEN2"], vfe = ["MATM(JS)?", "MATB(JS)?", "MATP(JS)?", "TNJB", "TAJB"], Sfe = ["MAMD"], bfe = ["MAMI(JS)?", "MAM3"], yfe = ["MAGW(JS)?"], wfe = ["MAFS(JS)?", "FSJB"], _fe = ["CPDTDF", "CPNTDF(JS?)", "CMNTDF(JS)?", "CMDTDF(JS)?"], Tfe = ["HPCMHP", "HPNTDF(JS)?", "HPDTDF(JS)?"], Afe = ["MANM(JS)?"], Pfe = ["Ordissimo", "webissimo3"], Mfe = {
  Dell: mfe,
  Acer: gfe,
  Sony: ffe,
  Asus: pfe,
  Samsung: hfe,
  Lenovo: xfe,
  Toshiba: vfe,
  Medion: Sfe,
  MSI: bfe,
  Gateway: yfe,
  Fujitsu: wfe,
  Compaq: _fe,
  HP: Tfe,
  Hyrican: Afe,
  Ordissimo: Pfe
};
var wS;
function $fe() {
  if (wS) return ps;
  wS = 1;
  var e = ps && ps.__importDefault || function(n) {
    return n && n.__esModule ? n : { default: n };
  };
  Object.defineProperty(ps, "__esModule", { value: !0 });
  const t = e(Mfe), r = vo();
  class o {
    constructor() {
      this.parse = (a) => {
        for (const [l, i] of Object.entries(t.default))
          for (const s of i)
            if (r.userAgentParser(s, a))
              return l;
        return "";
      };
    }
  }
  return ps.default = o, ps;
}
const Cfe = /* @__PURE__ */ JSON.parse(`[{"regex":"360Spider(-Image|-Video)?","name":"360Spider","category":"Search bot","url":"https://www.so.com/help/help_3_2.html","producer":{"name":"Online Media Group, Inc.","url":""}},{"regex":"Aboundex","name":"Aboundexbot","category":"Search bot","url":"http://www.aboundex.com/crawler/","producer":{"name":"Aboundex.com","url":"http://www.aboundex.com"}},{"regex":"AcoonBot","name":"Acoon","category":"Search bot","url":"http://www.acoon.de/robot.asp","producer":{"name":"Acoon GmbH","url":"http://www.acoon.de"}},{"regex":"AddThis\\\\.com","name":"AddThis.com","category":"Social Media Agent","url":"","producer":{"name":"Clearspring Technologies, Inc.","url":"http://www.clearspring.com"}},{"regex":"AhrefsBot","name":"aHrefs Bot","category":"Crawler","url":"https://ahrefs.com/robot","producer":{"name":"Ahrefs Pte Ltd","url":"https://ahrefs.com/robot"}},{"regex":"ia_archiver|alexabot|verifybot","name":"Alexa Crawler","category":"Search bot","url":"https://support.alexa.com/hc/en-us/sections/200100794-Crawlers","producer":{"name":"Alexa Internet","url":"https://www.alexa.com"}},{"regex":"alexa site audit","name":"Alexa Site Audit","category":"Site Monitor","url":"https://support.alexa.com/hc/en-us/articles/200450194","producer":{"name":"Alexa Internet","url":"https://www.alexa.com"}},{"regex":"Amazon[ -]Route ?53[ -]Health[ -]Check[ -]Service","name":"Amazon Route53 Health Check","category":"Service Agent","producer":{"name":"Amazon Web Services","url":"https://aws.amazon.com/"}},{"regex":"AmorankSpider","name":"Amorank Spider","category":"Crawler","url":"http://amorank.com/webcrawler.html","producer":{"name":"Amorank","url":"http://www.amorank.com"}},{"regex":"ApacheBench","name":"ApacheBench","category":"Benchmark","url":"https://httpd.apache.org/docs/2.4/programs/ab.html","producer":{"name":"The Apache Software Foundation","url":"https://www.apache.org/foundation/"}},{"regex":"Applebot","name":"Applebot","category":"Crawler","url":"https://support.apple.com/en-us/HT204683","producer":{"name":"Apple Inc","url":"https://www.apple.com"}},{"regex":"AppSignalBot","name":"AppSignalBot","category":"Site Monitor","url":"https://docs.appsignal.com/uptime-monitoring/","producer":{"name":"AppSignal","url":"https://appsignal.com/"}},{"regex":"Arachni","name":"Arachni","category":"Security Checker","url":"https://www.arachni-scanner.com/","producer":{"name":"Sarosys LLC","url":"https://www.sarosys.com/"}},{"regex":"AspiegelBot","name":"AspiegelBot","category":"Crawler","url":"https://aspiegel.com/","producer":{"name":"Huawei","url":"https://www.huawei.com/"}},{"regex":"Castro 2, Episode Duration Lookup","name":"Castro 2","category":"Service Agent","url":"http://supertop.co/castro/","producer":{"name":"Supertop","url":"http://supertop.co"}},{"regex":"Curious George","name":"Analytics SEO Crawler","category":"Crawler","url":"http://www.analyticsseo.com/crawler","producer":{"name":"Analytics SEO","url":"http://www.analyticsseo.com"}},{"regex":"archive\\\\.org_bot|special_archiver","name":"archive.org bot","category":"Crawler","url":"https://archive.org/details/archive.org_bot","producer":{"name":"The Internet Archive","url":"https://archive.org"}},{"regex":"Ask Jeeves/Teoma","name":"Ask Jeeves","category":"Search bot","url":"","producer":{"name":"Ask Jeeves Inc.","url":"http://www.ask.com"}},{"regex":"Backlink-Check\\\\.de","name":"Backlink-Check.de","category":"Crawler","url":"http://www.backlink-check.de/bot.html","producer":{"name":"Mediagreen Medienservice","url":"http://www.backlink-check.de"}},{"regex":"BacklinkCrawler","name":"BacklinkCrawler","category":"Crawler","url":"http://www.backlinktest.com/crawler.html","producer":{"name":"2.0Promotion GbR","url":"http://www.backlinktest.com"}},{"regex":"baiduspider(-image)?|baidu Transcoder|baidu.*spider","name":"Baidu Spider","category":"Search bot","url":"http://www.baidu.com/search/spider.htm","producer":{"name":"Baidu","url":"http://www.baidu.com"}},{"regex":"BazQux","name":"BazQux Reader","url":"https://bazqux.com/fetcher","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"MSNBot|msrbot|bingbot|BingPreview|msnbot-(UDiscovery|NewsBlogs)|adidxbot","name":"BingBot","category":"Search bot","url":"http://search.msn.com/msnbot.htmn","producer":{"name":"Microsoft Corporation","url":"http://www.microsoft.com"}},{"regex":"Blekkobot","name":"Blekkobot","category":"Search bot","url":"http://blekko.com/about/blekkobot","producer":{"name":"Blekko","url":"http://blekko.com"}},{"regex":"BLEXBot(Test)?","name":"BLEXBot Crawler","category":"Crawler","url":"http://webmeup-crawler.com","producer":{"name":"WebMeUp","url":"http://webmeup.com"}},{"regex":"Bloglovin","name":"Bloglovin","url":"http://www.bloglovin.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"Blogtrottr","name":"Blogtrottr","url":"","category":"Feed Fetcher","producer":{"name":"Blogtrottr Ltd","url":"https://blogtrottr.com/"}},{"regex":"BoardReader Blog Indexer","name":"BoardReader Blog Indexer","category":"Crawler","producer":{"name":"BoardReader","url":"https://boardreader.com/"}},{"regex":"BountiiBot","name":"Bountii Bot","category":"Search bot","url":"http://bountii.com/contact.php","producer":{"name":"Bountii Inc.","url":"http://bountii.com"}},{"regex":"Browsershots","name":"Browsershots","category":"Service Agent","url":"http://browsershots.org/faq","producer":{"name":"Browsershots.org","url":"http://browsershots.org"}},{"regex":"BUbiNG","name":"BUbiNG","category":"Crawler","url":"http://law.di.unimi.it/BUbiNG.html","producer":{"name":"The Laboratory for Web Algorithmics (LAW)","url":"http://law.di.unimi.it/software.php#buging"}},{"regex":"(?<!HTC)[ _]Butterfly/","name":"Butterfly Robot","category":"Search bot","url":"http://labs.topsy.com/butterfly","producer":{"name":"Topsy Labs","url":"http://labs.topsy.com"}},{"regex":"CareerBot","name":"CareerBot","category":"Crawler","url":"http://www.career-x.de/bot.html","producer":{"name":"career-x GmbH","url":"http://www.career-x.de"}},{"regex":"CCBot","name":"ccBot crawler","category":"Crawler","url":"http://commoncrawl.org/faq/","producer":{"name":"reddit inc.","url":"http://www.reddit.com"}},{"regex":"Cliqzbot","name":"Cliqzbot","category":"Crawler","url":"http://cliqz.com/company/cliqzbot","producer":{"name":"10betterpages GmbH","url":"http://cliqz.com"}},{"regex":"Cloudflare-AMP","name":"CloudFlare AMP Fetcher","category":"Crawler","url":"https://amp.cloudflare.com/doc/fetcher.html","producer":{"name":"CloudFlare","url":"http://www.cloudflare.com"}},{"regex":"CloudflareDiagnostics","name":"Cloudflare Diagnostics","category":"Site Monitor","url":"https://www.cloudflare.com/","producer":{"name":"Cloudflare","url":"https://www.cloudflare.com"}},{"regex":"CloudFlare-AlwaysOnline","name":"CloudFlare Always Online","category":"Site Monitor","url":"http://www.cloudflare.com/always-online","producer":{"name":"CloudFlare","url":"http://www.cloudflare.com"}},{"regex":"coccoc.com","name":"Cốc Cốc Bot","url":"https://help.coccoc.com/en/search-engine/coccoc-robots","category":"Search bot","producer":{"name":"Cốc Cốc","url":"https://coccoc.com/"}},{"regex":"collectd","name":"Collectd","url":"https://collectd.org/","category":"Site Monitor","producer":{"name":"Collectd","url":"https://collectd.org/"}},{"regex":"CommaFeed","name":"CommaFeed","url":"http://www.commafeed.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"CSS Certificate Spider","name":"CSS Certificate Spider","category":"Crawler","url":"http://www.css-security.com/certificatespider/","producer":{"name":"Certified Security Solutions","url":"https://www.css-security.com/company/about-us/"}},{"regex":"Datadog Agent","name":"Datadog Agent","url":"https://github.com/DataDog/dd-agent","category":"Site Monitor","producer":{"name":"Datadog","url":"https://www.datadoghq.com/"}},{"regex":"Datanyze","name":"Datanyze","url":"","category":"Crawler","producer":{"name":"Datanyze","url":"https://www.datanyze.com"}},{"regex":"Dataprovider","name":"Dataprovider","category":"Crawler","url":"","producer":{"name":"Dataprovider B.V.","url":"https://www.dataprovider.com/"}},{"regex":"Daum(oa)?[ /][0-9]","name":"Daum","category":"Search bot","url":"http://tab.search.daum.net/aboutWebSearch_en.html","producer":{"name":"Daum Communications Corp.","url":"http://www.kakaocorp.com/main"}},{"regex":"Dazoobot","name":"Dazoobot","category":"Search bot","url":"","producer":{"name":"DAZOO.FR","url":"http://dazoo.fr"}},{"regex":"discobot(-news)?","name":"Discobot","category":"Search bot","url":"http://discoveryengine.com/discobot.html","producer":{"name":"Discovery Engine","url":"http://discoveryengine.com"}},{"regex":"Domain Re-Animator Bot|support@domainreanimator.com","name":"Domain Re-Animator Bot","category":"Crawler","url":"","producer":{"name":"Domain Re-Animator, LLC","url":"http://domainreanimator.com"}},{"regex":"DotBot","name":"DotBot","category":"Crawler","url":"http://www.opensiteexplorer.org/dotbot","producer":{"name":"SEOmoz, Inc.","url":"http://moz.com/"}},{"regex":"DuckDuck(?:Go-Favicons-)?Bot","name":"DuckDuckGo Bot","category":"Search bot","url":"https://duckduckgo.com/duckduckbot","producer":{"name":"DuckDuckGo","url":"https://duckduckgo.com/"}},{"regex":"EasouSpider","name":"Easou Spider","category":"Search bot","url":"http://www.easou.com/search/spider.html","producer":{"name":"easou ICP","url":"http://www.easou.com"}},{"regex":"eCairn-Grabber","name":"eCairn-Grabber","category":"Crawler","producer":{"name":"eCairn","url":"https://ecairn.com"}},{"regex":"EMail Exractor","name":"EMail Exractor","category":"Crawler","url":"","producer":{"name":"","url":""}},{"regex":"evc-batch","name":"evc-batch","category":"Crawler","url":"","producer":{"name":"eVenture Capital Partners II, LLC","url":"http://www.eventures.vc/"}},{"regex":"Exabot(-Thumbnails|-Images)?|ExaleadCloudview","name":"ExaBot","category":"Crawler","url":"http://www.exabot.com/go/robot","producer":{"name":"Dassault Systèmes","url":"http://www.3ds.com"}},{"regex":"ExactSeek Crawler","name":"ExactSeek Crawler","category":"Search bot","url":"http://www.exactseek.com","producer":{"name":"Jayde Online, Inc.","url":"http://www.jaydeonlineinc.com"}},{"regex":"Ezooms","name":"Ezooms","category":"Crawler","url":"","producer":{"name":"SEOmoz, Inc.","url":"http://moz.com/"}},{"regex":"facebookexternalhit|facebookplatform|facebookexternalua","name":"Facebook External Hit","category":"Social Media Agent","url":"https://www.facebook.com/externalhit_uatext.php","producer":{"name":"Facebook","url":"http://www.facebook.com"}},{"regex":"Feedbin","name":"Feedbin","url":"http://feedbin.com/","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"FeedBurner","name":"FeedBurner","url":"http://www.feedburner.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"Feed Wrangler","name":"Feed Wrangler","url":"https://feedwrangler.net/","category":"Feed Fetcher","producer":{"name":"David Smith & Developing Perspective, LLC","url":"https://david-smith.org"}},{"regex":"(Meta)?Feedly(Bot|App)?","name":"Feedly","url":"http://www.feedly.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"Feedspot","name":"Feedspot","url":"http://www.feedspot.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"Fever/[0-9]","name":"Fever","url":"http://feedafever.com/","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"FlipboardProxy|FlipboardRSS","name":"Flipboard","url":"http://flipboard.com/browserproxy","category":"Feed Fetcher","producer":{"name":"Flipboard","url":"http://flipboard.com/"}},{"regex":"Findxbot","name":"Findxbot","category":"Crawler","url":"http://www.findxbot.com"},{"regex":"FreshRSS","name":"FreshRSS","category":"Feed Fetcher","url":"https://freshrss.org/"},{"regex":"Genieo","name":"Genieo Web filter","category":"","url":"http://www.genieo.com/webfilter.html","producer":{"name":"Genieo","url":"http://www.genieo.com"}},{"regex":"GigablastOpenSource","name":"Gigablast","category":"Search bot","url":"https://github.com/gigablast/open-source-search-engine","producer":{"name":"Matt Wells","url":"http://www.gigablast.com/faq.html"}},{"regex":"Gluten Free Crawler","name":"Gluten Free Crawler","category":"Crawler","url":"http://glutenfreepleasure.com/","producer":{"name":"","url":""}},{"regex":"ichiro/mobile goo","name":"Goo","category":"Search bot","url":"http://search.goo.ne.jp/option/use/sub4/sub4-1","producer":{"name":"NTT Resonant","url":"http://goo.ne.jp"}},{"regex":"Google Favicon","name":"Google Favicon","category":"Crawler"},{"regex":"Google Search Console","name":"Google Search Console","category":"Crawler","url":"https://search.google.com/search-console/about","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"Google Page Speed Insights","name":"Google PageSpeed Insights","category":"Site Monitor","url":"http://developers.google.com/speed/pagespeed/insights/","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"google_partner_monitoring","name":"Google Partner Monitoring","category":"Site Monitor","url":"","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"Google-Cloud-Scheduler","name":"Google Cloud Scheduler","category":"Crawler","url":"https://cloud.google.com/scheduler","producer":{"name":"Google Inc.","url":"https://www.google.com"}},{"regex":"Google-Structured-Data-Testing-Tool","name":"Google Structured Data Testing Tool","category":"Validator","url":"https://search.google.com/structured-data/testing-tool","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"GoogleStackdriverMonitoring","name":"Google Stackdriver Monitoring","category":"Site Monitor","url":"https://cloud.google.com/monitoring","producer":{"name":"Google Inc.","url":"https://www.google.com"}},{"regex":"via ggpht\\\\.com GoogleImageProxy","name":"Gmail Image Proxy","category":"Crawler","url":"","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"SeznamEmailProxy","name":"Seznam Email Proxy","category":"Crawler","url":"","producer":{"name":"Seznam.cz, a.s.","url":"http://www.seznam.cz/"}},{"regex":"Seznam-Zbozi-robot","name":"Seznam Zbozi.cz","category":"Crawler","url":"","producer":{"name":"Seznam.cz, a.s.","url":"https://www.zbozi.cz/"}},{"regex":"Heurekabot-Feed","name":"Heureka Feed","category":"Crawler","url":"https://sluzby.heureka.cz/napoveda/heurekabot/","producer":{"name":"Heureka.cz, a.s.","url":"https://www.heureka.cz/"}},{"regex":"ShopAlike","name":"ShopAlike","category":"Crawler","url":"","producer":{"name":"Visual Meta","url":"https://www.shopalike.cz/"}},{"regex":"AdsBot-Google(-Mobile)?|Adwords-(DisplayAds|Express|Instant)|Google Web Preview|Google[ -]Publisher[ -]Plugin|Google-(Ads-Qualify|Adwords|AMPHTML|Assess|HotelAdsVerifier|Read-Aloud|Shopping-Quality|Site-Verification|speakr|Test|Youtube-Links)|(APIs|DuplexWeb|Feedfetcher|Mediapartners)-Google|Googlebot(-Mobile|-Image|-Video|-News)?|GoogleProducer|Google.*/\\\\+/web/snippet","name":"Googlebot","category":"Search bot","url":"http://www.google.com/bot.html","producer":{"name":"Google Inc.","url":"http://www.google.com"}},{"regex":"heritrix","name":"Heritrix","category":"Crawler","url":"https://webarchive.jira.com/wiki/display/Heritrix/Heritrix","producer":{"name":"The Internet Archive","url":"https://archive.org"}},{"regex":"HubSpot ","name":"HubSpot","category":"Crawler","producer":{"name":"HubSpot Inc.","url":"https://www.hubspot.com"}},{"regex":"HTTPMon","name":"HTTPMon","category":"Site Monitor","url":"http://www.httpmon.com","producer":{"name":"towards GmbH","url":"http://www.towards.ch/"}},{"regex":"ICC-Crawler","name":"ICC-Crawler","category":"Crawler","url":"http://www.nict.go.jp/en/univ-com/plan/crawl.html","producer":{"name":"","url":""}},{"regex":"inoreader.com","name":"inoreader","category":"Feed Reader","url":"https://www.inoreader.com"},{"regex":"iisbot","name":"IIS Site Analysis","category":"Crawler","url":"http://www.iis.net/iisbot.html","producer":{"name":"Microsoft Corporation","url":"http://www.microsoft.com"}},{"regex":"ips-agent","name":"IPS Agent","category":"Crawler","producer":{"name":"VeriSign, Inc","url":"http://www.verisign.com/"}},{"regex":"IP-Guide\\\\.com","name":"IP-Guide Crawler","category":"Crawler","url":"","producer":{"name":"","url":"https://ip-guide.com"}},{"regex":"kouio","name":"Kouio","url":"http://kouio.com/","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"larbin","name":"Larbin web crawler","category":"Crawler","url":"http://larbin.sourceforge.net","producer":{"name":"","url":""}},{"regex":"([A-z0-9]*)-Lighthouse","name":"Lighthouse","category":"Site Monitor","url":"https://developers.google.com/web/tools/lighthouse","producer":{"name":"Lighthouse","url":"https://developers.google.com/web/tools/lighthouse"}},{"regex":"linkdexbot(-mobile)?|linkdex\\\\.com","name":"Linkdex Bot","category":"Search bot","url":"http://www.linkdex.com/bots","producer":{"name":"Mojeek Ltd.","url":"http://www.mojeek.com"}},{"regex":"LinkedInBot","name":"LinkedIn Bot","category":"Social Media Agent","url":"http://www.linkedin.com","producer":{"name":"LinkedIn","url":"http://www.linkedin.com"}},{"regex":"ltx71","name":"LTX71","url":"http://ltx71.com/","producer":{"name":"","url":""}},{"regex":"Mail\\\\.RU(_Bot)?","name":"Mail.Ru Bot","category":"Search bot","url":"http://help.mail.ru/webmaster/indexing/robots/types_robots","producer":{"name":"Mail.Ru Group","url":"http://corp.mail.ru"}},{"regex":"magpie-crawler","name":"Magpie-Crawler","category":"Social Media Agent","url":"http://www.brandwatch.com/magpie-crawler/","producer":{"name":"Brandwatch","url":"http://www.brandwatch.com"}},{"regex":"MagpieRSS","name":"MagpieRSS","url":"http://magpierss.sourceforge.net/","category":"Feed Parser","producer":{"name":"","url":""}},{"regex":"masscan","name":"masscan","url":"https://github.com/robertdavidgraham/masscan","category":"Crawler","producer":{"name":"Robert Graham","url":"https://github.com/robertdavidgraham"}},{"regex":"Mastodon/","name":"Mastodon Bot","category":"Social Media Agent"},{"regex":"meanpathbot","name":"Meanpath Bot","category":"Search bot","url":"http://www.meanpath.com/meanpathbot.html","producer":{"name":"Meanpath","url":"http://www.meanpath.com"}},{"regex":"MetaJobBot","name":"MetaJobBot","category":"Crawler","url":"http://www.metajob.at/the/crawler","producer":{"name":"MetaJob","url":"http://www.metajob.at"}},{"regex":"MetaInspector","name":"MetaInspector","category":"Crawler","url":"https://github.com/jaimeiniesta/metainspector"},{"regex":"MixrankBot","name":"Mixrank Bot","category":"Crawler","url":"http://mixrank.com","producer":{"name":"Online Media Group, Inc.","url":""}},{"regex":"MJ12bot","name":"MJ12 Bot","category":"Search bot","url":"http://majestic12.co.uk/bot.php","producer":{"name":"Majestic-12","url":"http://majestic12.co.uk"}},{"regex":"Mnogosearch","name":"Mnogosearch","category":"Search bot","url":"http://www.mnogosearch.org/","producer":{"name":"Lavtech.Com Corp.","url":""}},{"regex":"MojeekBot","name":"MojeekBot","category":"Search bot","url":"http://www.mojeek.com/bot.html","producer":{"name":"Mojeek Ltd.","url":"http://www.mojeek.com"}},{"regex":"munin","name":"Munin","category":"Site Monitor","url":"http://munin-monitoring.org/","producer":{"name":"Munin","url":"http://munin-monitoring.org/"}},{"regex":"NalezenCzBot","name":"NalezenCzBot","category":"Crawler","url":"http://www.nalezen.cz/about-crawler","producer":{"name":"Jaroslav Kuboš","url":""}},{"regex":"check_http/v","name":"Nagios check_http","category":"Site Monitor","url":"https://nagios.org","producer":{"name":"Nagios Plugins Development Team","url":"https://nagios.org"}},{"regex":"nbertaupete95\\\\(at\\\\)gmail.com","name":"nbertaupete95","category":"Crawler"},{"regex":"Netcraft( Web Server Survey| SSL Server Survey|SurveyAgent)","name":"Netcraft Survey Bot","category":"Search bot","url":"","producer":{"name":"Netcraft","url":"http://www.netcraft.com"}},{"regex":"netEstate NE Crawler","name":"netEstate","category":"Crawler","url":"http://www.website-datenbank.de/Impressum","producer":{"name":"netEstate GmbH","url":"https://www.netestate.de/en/"}},{"regex":"Netvibes","name":"Netvibes","url":"http://www.netvibes.com/","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"NewsBlur .*(Fetcher|Finder)","name":"NewsBlur","url":"http://www.newsblur.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"NewsGatorOnline","name":"NewsGator","url":"http://www.newsgator.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"nlcrawler","name":"NLCrawler","category":"Crawler","url":"","producer":{"name":"Northern Light","url":"http://northernlight.com"}},{"regex":"Nmap Scripting Engine","name":"Nmap","category":"Security Checker","url":"https://nmap.org/book/nse.html","producer":{"name":"Nmap","url":"https://nmap.org/"}},{"regex":"Nuzzel","name":"Nuzzel","category":"Crawler","producer":{"name":"Nuzzel","url":"https://www.nuzzel.com/"}},{"regex":"Octopus [0-9]","name":"Octopus"},{"regex":"omgili(?:bot)?","name":"Omgili bot","category":"Search bot","url":"http://www.omgili.com/Crawler.html","producer":{"name":"Omgili","url":"http://www.omgili.com"}},{"regex":"OpenindexSpider","name":"Openindex Spider","category":"Search bot","url":"http://www.openindex.io/en/webmasters/spider.html","producer":{"name":"Openindex B.V.","url":"http://www.openindex.io"}},{"regex":"spbot","name":"OpenLinkProfiler","category":"Crawler","url":"http://openlinkprofiler.org/bot","producer":{"name":"Axandra GmbH","url":"http://www.axandra.com"}},{"regex":"OpenWebSpider","name":"OpenWebSpider","category":"Crawler","url":"http://www.openwebspider.org","producer":{"name":"OpenWebSpider Lab","url":"http://lab.openwebspider.org"}},{"regex":"OrangeBot|VoilaBot","name":"Orange Bot","category":"Search bot","url":"http://lemoteur.orange.fr","producer":{"name":"Orange","url":"http://www.orange.fr"}},{"regex":"PaperLiBot","name":"PaperLiBot","category":"Search bot","url":"http://support.paper.li/entries/20023257-what-is-paper-li","producer":{"name":"Smallrivers SA","url":"http://www.paper.li"}},{"regex":"phantomas/","name":"Phantomas","category":"Site Monitor","url":"https://github.com/macbre/phantomas"},{"regex":"phpservermon","name":"PHP Server Monitor","category":"Site Monitor","url":"https://github.com/phpservermon/phpservermon","producer":{"name":"PHP Server Monitor","url":"http://www.phpservermonitor.org/"}},{"regex":"PocketParser","name":"PocketParser","category":"Read-it-later Service","url":"https://getpocket.com/pocketparser_ua","producer":{"name":"Pocket","url":"https://getpocket.com/"}},{"regex":"PritTorrent","name":"PritTorrent","category":"Crawler","url":"https://github.com/astro/prittorrent","producer":{"name":"Bitlove","url":"http://bitlove.org/"}},{"regex":"PRTG Network Monitor","name":"PRTG Network Monitor","category":"Network Monitor","url":"https://www.paessler.com/prtg","producer":{"name":"Paessler AG","url":"https://www.paessler.com"}},{"regex":"psbot(-page)?","name":"Picsearch bot","category":"Search bot","url":"http://www.picsearch.com/bot.html","producer":{"name":"Picsearch","url":"http://www.picsearch.com"}},{"regex":"Pingdom(?:\\\\.com|TMS)","name":"Pingdom Bot","category":"Site Monitor","url":"","producer":{"name":"Pingdom AB","url":"https://www.pingdom.com"}},{"regex":"Quora Link Preview","name":"Quora Link Preview","category":"Crawler","url":"","producer":{"name":"Quora","url":"http://www.quora.com"}},{"regex":"Quora-Bot","name":"Quora Bot","category":"Crawler","url":"","producer":{"name":"Quora","url":"https://www.quora.com/"}},{"regex":"RamblerMail","name":"RamblerMail Image Proxy","category":"Crawler","url":"","producer":{"name":"Rambler&Co","url":"https://rambler-co.ru/"}},{"regex":"QuerySeekerSpider","name":"QuerySeekerSpider","category":"Crawler","url":"http://queryseeker.com/bot.html","producer":{"name":"QueryEye Inc.","url":"http://queryeye.com"}},{"regex":"Qwantify","name":"Qwantify","category":"Crawler","url":"https://www.qwant.com/","producer":{"name":"Qwant Corporation","url":"https://www.qwant.com/"}},{"regex":"Rainmeter","name":"Rainmeter","category":"Crawler","url":"https://www.rainmeter.net"},{"regex":"redditbot","name":"Reddit Bot","category":"Social Media Agent","url":"http://www.reddit.com/feedback","producer":{"name":"reddit inc.","url":"http://www.reddit.com"}},{"regex":"Riddler","name":"Riddler","category":"Security search bot","url":"https://riddler.io/about","producer":{"name":"F-Secure","url":"https://www.f-secure.com"}},{"regex":"rogerbot","name":"Rogerbot","category":"Crawler","url":"http://moz.com/help/pro/what-is-rogerbot-","producer":{"name":"SEOmoz, Inc.","url":"http://moz.com/"}},{"regex":"ROI Hunter","name":"ROI Hunter","category":"Crawler","url":"","producer":{"name":"Roihunter a.s.","url":"http://roihunter.com/"}},{"regex":"SafeDNSBot","name":"SafeDNSBot","category":"Crawler","url":"https://www.safedns.com/searchbot","producer":{"name":"SafeDNS, Inc.","url":"https://www.safedns.com/"}},{"regex":"Scrapy","name":"Scrapy","category":"Crawler","url":"http://scrapy.org"},{"regex":"Screaming Frog SEO Spider","name":"Screaming Frog SEO Spider","category":"Crawler","url":"http://www.screamingfrog.co.uk/seo-spider","producer":{"name":"Screaming Frog Ltd","url":"http://www.screamingfrog.co.uk"}},{"regex":"ScreenerBot","name":"ScreenerBot","category":"Crawler","url":"http://www.screenerbot.com","producer":{"name":"","url":""}},{"regex":"SemrushBot","name":"Semrush Bot","category":"Crawler","url":"http://www.semrush.com/bot.html","producer":{"name":"SEMrush","url":"http://www.semrush.com"}},{"regex":"SensikaBot","name":"Sensika Bot","category":"","url":"","producer":{"name":"Sensika","url":"http://sensika.com"}},{"regex":"SEOENG(World)?Bot","name":"SEOENGBot","category":"Crawler","url":"http://www.seoengine.com/seoengbot.htm","producer":{"name":"SEO Engine","url":"http://www.seoengine.com"}},{"regex":"SEOkicks-Robot","name":"SEOkicks-Robot","category":"Crawler","url":"http://www.seokicks.de/robot.html","producer":{"name":"SEOkicks","url":"https://www.seokicks.de/"}},{"regex":"seoscanners\\\\.net","name":"Seoscanners.net","category":"Crawler","url":""},{"regex":"SkypeUriPreview","name":"Skype URI Preview","category":"Service Agent","url":"","producer":{"name":"Skype Communications S.à.r.l.","url":"https://www.skype.com"}},{"regex":"SeznamBot|SklikBot|Seznam screenshot-generator","name":"Seznam Bot","category":"Search bot","url":"http://www.mapy.cz/cz/seznambot.html","producer":{"name":"Seznam.cz, a.s.","url":"http://www.seznam.cz/"}},{"regex":"shopify-partner-homepage-scraper","name":"Shopify Partner","category":"Crawler","url":"https://www.shopify.com/partners","producer":{"name":"Shopify","url":"https://www.shopify.com/"}},{"regex":"ShopWiki","name":"ShopWiki","category":"Search tools","url":"http://www.shopwiki.com/wiki/Help:Bot","producer":{"name":"ShopWiki Corp.","url":"http://www.shopwiki.com"}},{"regex":"SilverReader","name":"SilverReader","url":"http://silverreader.com","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"SimplePie","name":"SimplePie","url":"http://www.simplepie.org","category":"Feed Parser","producer":{"name":"","url":""}},{"regex":"SISTRIX Crawler","name":"SISTRIX Crawler","category":"Crawler","url":"http://crawler.sistrix.net","producer":{"name":"SISTRIX GmbH","url":"http://www.sistrix.de"}},{"regex":"compatible; (?:SISTRIX )?Optimizer","name":"SISTRIX Optimizer","category":"Crawler","url":"https://optimizer.sistrix.com","producer":{"name":"SISTRIX GmbH","url":"http://www.sistrix.de"}},{"regex":"SiteSucker","name":"SiteSucker","category":"Crawler","url":"http://ricks-apps.com/osx/sitesucker/"},{"regex":"sixy.ch","name":"Sixy.ch","category":"Site Monitor","url":"http://sixy.ch","producer":{"name":"Manuel Kasper","url":"https://neon1.net/"}},{"regex":"Slackbot|Slack-ImgProxy","name":"Slackbot","category":"Crawler","url":"https://api.slack.com/robots","producer":{"name":"Slack Technologies","url":"http://slack.com"}},{"regex":"(Sogou (web|inst|Pic) spider)|New-Sogou-Spider","name":"Sogou Spider","category":"Search bot","url":"http://www.sogou.com/docs/help/webmasters.htm","producer":{"name":"Sohu, Inc.","url":"http://www.sogou.com"}},{"regex":"Sosospider|Sosoimagespider","name":"Soso Spider","category":"Search bot","url":"http://help.soso.com/webspider.htm","producer":{"name":"Tencent Holdings","url":"http://www.soso.com"}},{"regex":"Sprinklr","name":"Sprinklr","category":"Crawler","url":"","producer":{"name":"Sprinklr, Inc.","url":"https://www.sprinklr.com/"}},{"regex":"sqlmap/","name":"sqlmap","category":"Security Checker","url":"http://sqlmap.org/","producer":{"name":"sqlmap","url":"http://sqlmap.org/"}},{"regex":"SSL Labs","name":"SSL Labs","category":"Validator","url":"https://www.ssllabs.com/about/assessment.html","producer":{"name":"SSL Labs","url":"https://www.ssllabs.com/about/assessment.html"}},{"regex":"StatusCake","name":"StatusCake","category":"Site Monitor","url":"https://www.statuscake.com","producer":{"name":"StatusCake","url":"https://www.statuscake.com"}},{"regex":"Superfeedr bot","name":"Superfeedr Bot","category":"Feed Fetcher","url":"","producer":{"name":"Superfeedr","url":"https://superfeedr.com/"}},{"regex":"Sparkler/[0-9]","name":"Sparkler","category":"Crawler","url":"https://github.com/USCDataScience/sparkler"},{"regex":"Spinn3r","name":"Spinn3r","category":"Crawler","url":"http://spinn3r.com/robot","producer":{"name":"Tailrank Inc","url":"http://spinn3r.com"}},{"regex":"SputnikBot","name":"Sputnik Bot","category":"Crawler","url":""},{"regex":"SputnikFaviconBot","name":"Sputnik Favicon Bot","category":"Crawler","url":""},{"regex":"SputnikImageBot","name":"Sputnik Image Bot","category":"Crawler","url":""},{"regex":"SurveyBot","name":"Survey Bot","category":"Search bot","url":"http://www.domaintools.com/webmasters/surveybot.php","producer":{"name":"Domain Tools","url":"http://www.domaintools.com"}},{"regex":"TarmotGezgin","name":"Tarmot Gezgin","url":"http://www.tarmot.com/gezgin/","category":"Search bot"},{"regex":"TelegramBot","name":"TelegramBot","url":"https://telegram.org/blog/bot-revolution"},{"regex":"TLSProbe","name":"TLSProbe","url":"https://scan.trustnet.venafi.com/","category":"Security search bot","producer":{"name":"Venafi TrustNet","url":"https://www.venafi.com"}},{"regex":"TinEye-bot","name":"TinEye Crawler","category":"Search bot","url":"http://www.tineye.com/crawler.html","producer":{"name":"Idée Inc.","url":"http://ideeinc.com"}},{"regex":"Tiny Tiny RSS","name":"Tiny Tiny RSS","url":"http://tt-rss.org","category":"Feed Fetcher","producer":{"name":"","url":""}},{"regex":"theoldreader.com","name":"theoldreader","category":"Feed Reader","url":"https://theoldreader.com"},{"regex":"trendictionbot","name":"Trendiction Bot","category":"Crawler","url":"http://www.trendiction.de/bot","producer":{"name":"Talkwalker Inc.","url":"http://www.talkwalker.com"}},{"regex":"TurnitinBot","name":"TurnitinBot","category":"Crawler","url":"http://www.turnitin.com/robot/crawlerinfo.html","producer":{"name":"iParadigms, LLC.","url":"http://www.turnitin.com"}},{"regex":"TweetedTimes Bot","name":"TweetedTimes Bot","category":"Crawler","url":"http://tweetedtimes.com","producer":{"name":"TweetedTimes","url":"http://tweetedtimes.com/"}},{"regex":"TweetmemeBot","name":"Tweetmeme Bot","category":"Crawler","url":"http://tweetmeme.com/","producer":{"name":"Mediasift","url":""}},{"regex":"Twingly Recon","name":"Twingly Recon","category":"Crawler","producer":{"name":"Twingly","url":"https://www.twingly.com"}},{"regex":"Twitterbot","name":"Twitterbot","category":"Social Media Agent","url":"https://dev.twitter.com/docs/cards/getting-started","producer":{"name":"Twitter","url":"http://www.twitter.com"}},{"regex":"UniversalFeedParser","name":"UniversalFeedParser","category":"Feed Fetcher","url":"https://github.com/kurtmckee/feedparser","producer":{"name":"Kurt McKee","url":"https://github.com/kurtmckee"}},{"regex":"via secureurl\\\\.fwdcdn\\\\.com","name":"UkrNet Mail Proxy","category":"Crawler","url":"","producer":{"name":"UkrNet Ltd","url":"https://www.ukr.net/"}},{"regex":"Uptimebot","name":"Uptimebot","category":"Site Monitor","url":"https://uptime.com/uptimebot","producer":{"name":"Uptime","url":"https://uptime.com"}},{"regex":"UptimeRobot","name":"Uptime Robot","category":"Site Monitor","url":"","producer":{"name":"Uptime Robot","url":"http://uptimerobot.com"}},{"regex":"URLAppendBot","name":"URLAppendBot","category":"Crawler","url":"http://www.profound.net/urlappendbot.html","producer":{"name":"Profound Networks","url":"http://www.profound.net"}},{"regex":"Vagabondo","name":"Vagabondo","category":"Crawler","url":"","producer":{"name":"WiseGuys","url":"http://www.wise-guys.nl/"}},{"regex":"vkShare; ","name":"VK Share Button","category":"Crawler","url":"http://vk.com/dev/Share","producer":{"name":"VK","url":"http://vk.com/"}},{"regex":"VSMCrawler","name":"Visual Site Mapper Crawler","category":"Crawler","url":"http://www.visualsitemapper.com/crawler","producer":{"name":"Alentum Software Ltd.","url":"http://www.alentum.com"}},{"regex":"Jigsaw","name":"W3C CSS Validator","category":"Validator","url":"http://jigsaw.w3.org/css-validator","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"W3C_I18n-Checker","name":"W3C I18N Checker","category":"Validator","url":"http://validator.w3.org/i18n-checker","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"W3C-checklink","name":"W3C Link Checker","category":"Validator","url":"http://validator.w3.org/checklink","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"W3C_Validator|Validator.nu","name":"W3C Markup Validation Service","category":"Validator","url":"http://validator.w3.org/services","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"W3C-mobileOK","name":"W3C MobileOK Checker","category":"Validator","url":"http://validator.w3.org/mobile","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"W3C_Unicorn","name":"W3C Unified Validator","category":"Validator","url":"http://validator.w3.org/unicorn","producer":{"name":"W3C","url":"http://www.w3.org"}},{"regex":"Wappalyzer","name":"Wappalyzer","url":"https://github.com/AliasIO/Wappalyzer","producer":{"name":"AliasIO","url":"https://github.com/AliasIO"}},{"regex":"PTST/","name":"WebPageTest","category":"Site Monitor","url":"https://www.webpagetest.org"},{"regex":"WeSEE(:Search)?","name":"WeSEE:Search","category":"Search bot","url":"http://www.wesee.com/bot","producer":{"name":"WeSEE Ltd","url":"http://www.wesee.com"}},{"regex":"WebbCrawler","name":"WebbCrawler","category":"Crawler","url":"http://badcheese.com/crawler.html","producer":{"name":"Steve Webb","url":"http://badcheese.com"}},{"regex":"websitepulse[+ ]checker","name":"WebSitePulse","category":"Site Monitor","url":"http://badcheese.com/crawler.html","producer":{"name":"WebSitePulse","url":"http://www.websitepulse.com/"}},{"regex":"WordPress","name":"WordPress","category":"Service Agent","url":"https://wordpress.org/","producer":{"name":"Wordpress.org","url":"https://wordpress.org/"}},{"regex":"Wotbox","name":"Wotbox","category":"Search bot","url":"http://www.wotbox.com/bot/","producer":{"name":"Wotbox","url":"http://www.wotbox.com"}},{"regex":"XenForo","name":"XenForo","category":"Service Agent","url":"https://xenforo.com/","producer":{"name":"XenForo Ltd.","url":"https://xenforo.com/"}},{"regex":"yacybot","name":"YaCy","category":"Search bot","url":"http://yacy.net/bot.html","producer":{"name":"YaCy","url":"http://yacy.net"}},{"regex":"Yahoo! Slurp|Yahoo!-AdCrawler","name":"Yahoo! Slurp","category":"Search bot","url":"http://help.yahoo.com/ysearch/slurp","producer":{"name":"Yahoo! Inc.","url":"http://www.yahoo.com"}},{"regex":"Yahoo Link Preview|Yahoo:LinkExpander:Slingstone","name":"Yahoo! Link Preview","category":"Crawler","url":"https://help.yahoo.com/kb/mail/yahoo-link-preview-SLN23615.html","producer":{"name":"Yahoo! Inc.","url":"http://www.yahoo.com"}},{"regex":"YahooMailProxy","name":"Yahoo! Mail Proxy","category":"Service Agent","url":"https://help.yahoo.com/kb/yahoo-mail-proxy-SLN28749.html","producer":{"name":"Yahoo! Inc.","url":"http://www.yahoo.com"}},{"regex":"YahooCacheSystem","name":"Yahoo! Cache System","category":"Crawler","url":"","producer":{"name":"Yahoo! Inc.","url":"http://www.yahoo.com"}},{"regex":"Y!J-BRW","name":"Yahoo! Japan BRW","category":"Crawler","url":"https://www.yahoo-help.jp/app/answers/detail/p/595/a_id/42716/~/ウェブページにアクセスするシステムのユーザーエージェントについて","producer":{"name":"Yahoo! Japan Corp.","url":"https://www.yahoo.co.jp/"}},{"regex":"Yandex(SpravBot|ScreenshotBot|MobileBot|AccessibilityBot|ForDomain|Vertis|Market|Catalog|Calendar|Sitelinks|AdNet|Pagechecker|Webmaster|Media|Video|Bot|Images|Antivirus|Direct|Blogs|Favicons|ImageResizer|Verticals|News(links)?|Metrika|\\\\.Gazeta Bot)|YaDirectFetcher|YandexTurbo|YandexTracker|YandexSearchShop|YandexRCA|YandexPartner|YandexOntoDBAPI|YandexOntoDB|YandexMobileScreenShotBot","name":"Yandex Bot","category":"Search bot","url":"http://www.yandex.com/bots","producer":{"name":"Yandex LLC","url":"http://company.yandex.com"}},{"regex":"Yeti|NaverJapan","name":"Yeti/Naverbot","category":"Search bot","url":"http://help.naver.com/robots/","producer":{"name":"Naver","url":"http://www.naver.com"}},{"regex":"YoudaoBot","name":"Youdao Bot","category":"Search bot","url":"http://www.youdao.com/help/webmaster/spider","producer":{"name":"NetEase, Inc.","url":"http://corp.163.com"}},{"regex":"YOURLS v[0-9]","name":"Yourls","category":"Crawler","url":"http://yourls.org"},{"regex":"YRSpider|YYSpider","name":"Yunyun Bot","category":"Search bot","url":"http://www.yunyun.com/SiteInfo.php?r=about","producer":{"name":"YunYun","url":"http://www.yunyun.com"}},{"regex":"zgrab","name":"zgrab","category":"Security Checker","url":"https://github.com/zmap/zgrab"},{"regex":"Zookabot","name":"Zookabot","category":"Crawler","url":"http://zookabot.com","producer":{"name":"Hwacha ApS","url":"http://hwacha.dk"}},{"regex":"ZumBot","name":"ZumBot","category":"Search bot","url":"http://help.zum.com/inquiry","producer":{"name":"ZUM internet","url":"http://www.zuminternet.com/"}},{"regex":"YottaaMonitor","name":"Yottaa Site Monitor","category":"Site Monitor","url":"http://www.yottaa.com/products/site-monitor","producer":{"name":"Yottaa","url":"http://www.yottaa.com/"}},{"regex":"Yahoo Ad monitoring.*yahoo-ad-monitoring-SLN24857.*","name":"Yahoo Gemini","category":"Crawler","url":"https://help.yahoo.com/kb/yahoo-ad-monitoring-SLN24857.html","producer":{"name":"Yahoo! Inc.","url":"http://www.yahoo.com"}},{"regex":".*Java.*outbrain","name":"Outbrain","category":"Crawler","url":"","producer":{"name":"Outbrain","url":"http://www.outbrain.com/"}},{"regex":"HubPages.*crawlingpolicy","name":"HubPages","category":"Crawler","url":"http://hubpages.com/help/crawlingpolicy","producer":{"name":"HubPages","url":"http://hubpages.com/"}},{"regex":"Pinterest(bot)?/\\\\d\\\\.\\\\d.*www\\\\.pinterest\\\\.com.*","name":"Pinterest","url":"http://www.pinterest.com/bot.html","category":"Crawler","producer":{"name":"Pinterest","url":"http://www.pinterest.com/"}},{"regex":"Site24x7","name":"Site24x7 Website Monitoring","category":"Site Monitor","url":"https://www.site24x7.com/site24x7-faq.html","producer":{"name":"Site24x7","url":"https://www.site24x7.com"}},{"regex":"s~snapchat-proxy","name":"Snapchat Proxy","category":"Crawler","url":"https://www.snapchat.com","producer":{"name":"Snapchat Inc.","url":"https://www.snapchat.com"}},{"regex":"Let's Encrypt validation server","name":"Let's Encrypt Validation","category":"Service Agent","url":"https://letsencrypt.org/how-it-works/","producer":{"name":"Let's Encrypt","url":"https://letsencrypt.org"}},{"regex":"GrapeshotCrawler","name":"Grapeshot","category":"Crawler","url":"https://www.grapeshot.com/crawler","producer":{"name":"Grapeshot","url":"https://www.grapeshot.com"}},{"regex":"www\\\\.monitor\\\\.us","name":"Monitor.Us","category":"Site Monitor","url":"http://www.monitor.us","producer":{"name":"Monitor.Us","url":"http://www.monitor.us"}},{"regex":"Catchpoint( bot)?","name":"Catchpoint","category":"Site Monitor","url":"","producer":{"name":"Catchpoint Systems","url":"http://www.catchpoint.com/"}},{"regex":"bitlybot","name":"BitlyBot","category":"Crawler","url":"https://bitly.com","producer":{"name":"Bitly, Inc.","url":"https://bitly.com"}},{"regex":"Zao/","name":"Zao","category":"Crawler"},{"regex":"lycos","name":"Lycos"},{"regex":"Slurp","name":"Inktomi Slurp"},{"regex":"Speedy Spider","name":"Speedy"},{"regex":"ScoutJet","name":"ScoutJet"},{"regex":"nrsbot|netresearch","name":"NetResearchServer"},{"regex":"scooter","name":"Scooter"},{"regex":"gigabot","name":"Gigabot"},{"regex":"charlotte","name":"Charlotte"},{"regex":"Pompos","name":"Pompos"},{"regex":"ichiro","name":"ichiro"},{"regex":"PagePeeker","name":"PagePeeker"},{"regex":"WebThumbnail","name":"WebThumbnail"},{"regex":"Willow Internet Crawler","name":"Willow Internet Crawler"},{"regex":"EmailWolf","name":"EmailWolf"},{"regex":"NetLyzer FastProbe","name":"NetLyzer FastProbe"},{"regex":"AdMantX.*admantx\\\\.com","name":"ADMantX"},{"regex":"Server Density Service Monitoring.*","name":"Server Density"},{"regex":"RSSRadio \\\\(Push Notification Scanner;support@dorada\\\\.co\\\\.uk\\\\)","name":"RSSRadio Bot"},{"regex":"(A6-Indexer|nuhk|TsolCrawler|Yammybot|Openbot|Gulper Web Bot|grub-client|Download Demon|SearchExpress|Microsoft URL Control|borg|altavista|dataminr.com|tweetedtimes.com|TrendsmapResolver|teoma|blitzbot|oegp|furlbot|http%20client|polybot|htdig|mogimogi|larbin|scrubby|searchsight|seekbot|semanticdiscovery|snappy|vortex(?! Build)|zeal|fast-webcrawler|converacrawler|dataparksearch|findlinks|BrowserMob|HttpMonitor|ThumbShotsBot|URL2PNG|ZooShot|GomezA|Google SketchUp|Read%20Later|RackspaceBot|robots|SeopultContentAnalyzer|7Siters|centuryb.o.t9|InterNaetBoten|EasyBib AutoCite|Bidtellect|tomnomnom/meg)","name":"Generic Bot"},{"regex":"^sentry","name":"Sentry Bot","producer":{"name":"Sentry","url":"https://sentry.io"}},{"regex":"^Spotify","name":"Spotify","producer":{"name":"Spotify","url":"https://www.spotify.com"}},{"regex":"The Knowledge AI","name":"The Knowledge AI","category":"Crawler"},{"regex":"Embedly","name":"Embedly","category":"Crawler","url":"https://support.embed.ly/hc/en-us","producer":{"name":"A Medium, Corp.","url":"https://medium.com/"}},{"regex":"BrandVerity","name":"BrandVerity","category":"Crawler","url":"https://www.brandverity.com/why-is-brandverity-visiting-me","producer":{"name":"BrandVerity, Inc.","url":"https://www.brandverity.com/"}},{"regex":"Kaspersky Lab CFR link resolver","name":"Kaspersky","category":"Security Checker","url":"https://www.kaspersky.com/","producer":{"name":"AO Kaspersky Lab","url":"https://www.kaspersky.com/"}},{"regex":"eZ Publish Link Validator","name":"eZ Publish Link Validator","category":"Crawler","url":"https://ez.no/","producer":{"name":"eZ Systems AS","url":"https://ez.no/"}},{"regex":"woorankreview","name":"WooRank","category":"Search bot","url":"https://www.woorank.com/","producer":{"name":"WooRank sprl","url":"https://www.woorank.com/"}},{"regex":"(Match|LinkCheck) by Siteimprove.com","name":"Siteimprove","category":"Search bot","url":"https://siteimprove.com/","producer":{"name":"Siteimprove GmbH","url":"https://siteimprove.com/"}},{"regex":"CATExplorador","name":"CATExplorador","category":"Search bot","url":"https://fundacio.cat/ca/domini/","producer":{"name":"Fundació puntCAT","url":"https://fundacio.cat/ca/domini/"}},{"regex":"Buck","name":"Buck","category":"Search bot","url":"https://hypefactors.com/","producer":{"name":"Hypefactors A/S","url":"https://hypefactors.com/"}},{"regex":"tracemyfile","name":"TraceMyFile","category":"Search bot","url":"https://www.tracemyfile.com/","producer":{"name":"Idee Inc.","url":"http://ideeinc.com/"}},{"regex":"zelist.ro feed parser","name":"Ze List","url":"https://www.zelist.ro/","category":"Feed Fetcher","producer":{"name":"Treeworks SRL","url":"https://www.tree.ro/"}},{"regex":"weborama-fetcher","name":"Weborama","category":"Search bot","url":"https://weborama.com/","producer":{"name":"Weborama SA","url":"https://weborama.com/"}},{"regex":"BoardReader Favicon Fetcher","name":"BoardReader","category":"Search bot","url":"https://boardreader.com/","producer":{"name":"Effyis Inc","url":"https://boardreader.com/"}},{"regex":"IDG/IT","name":"IDG/IT","category":"Search bot","url":"https://spaziodati.eu/","producer":{"name":"SpazioDati S.r.l.","url":"https://spaziodati.eu/"}},{"regex":"Bytespider","name":"Bytespider","category":"Search bot","url":"https://bytedance.com/","producer":{"name":"ByteDance Ltd.","url":"https://bytedance.com/"}},{"regex":"WikiDo","name":"WikiDo","category":"Search bot","url":"https://www.wikido.com/","producer":{"name":"Fotolitografie Fiorentine di Becchi Antonio s.n.c.","url":"https://www.wikido.com/"}},{"regex":"AwarioSmartBot","name":"Awario","category":"Search bot","url":"https://awario.com/bots.html","producer":{"name":"Awario","url":"https://awario.com/"}},{"regex":"AwarioRssBot","name":"Awario","category":"Feed Fetcher","url":"https://awario.com/bots.html","producer":{"name":"Awario","url":"https://awario.com/"}},{"regex":"oBot","name":"oBot","category":"Search bot","url":"https://www.xforce-security.com/crawler/","producer":{"name":"IBM Germany Research & Development GmbH","url":"https://exchange.xforce.ibmcloud.com/"}},{"regex":"SMTBot","name":"SMTBot","category":"Search bot","url":"https://www.similartech.com/smtbot","producer":{"name":"SimilarTech Ltd.","url":"https://www.similartech.com/"}},{"regex":"LCC","name":"LCC","category":"Search bot","url":"https://corpora.uni-leipzig.de/crawler_faq.html","producer":{"name":"Universität Leipzig","url":"https://www.uni-leipzig.de/"}},{"regex":"Startpagina-Linkchecker","name":"Startpagina Linkchecker","category":"Search bot","url":"https://www.startpagina.nl/linkchecker","producer":{"name":"Startpagina B.V.","url":"https://www.startpagina.nl/"}},{"regex":"GTmetrix","name":"GTmetrix","category":"Crawler","url":"https://gtmetrix.com/","producer":{"name":"Carbon60 Operating Co. Ltd.","url":"https://www.carbon60.com/"}},{"regex":"Nutch","name":"Nutch-based Bot","category":"Crawler","url":"https://nutch.apache.org","producer":{"name":"The Apache Software Foundation","url":"https://www.apache.org/foundation/"}},{"regex":"Seobility","name":"Seobility","category":"Crawler","url":"https://www.seobility.net/en/faq/?category=crawling#!aboutourbot"},{"regex":"Vercelbot","name":"Vercel Bot","category":"Service bot","url":"https://vercel.com"},{"regex":"Grammarly","name":"Grammarly","category":"Service bot","url":"https://www.grammarly.com"},{"regex":"Robozilla","name":"Robozilla","category":"Crawler"},{"regex":"Domains Project","name":"Domains Project","category":"Crawler","url":"https://domainsproject.org"},{"regex":"PetalBot","name":"Petal Bot","category":"Crawler","url":"https://aspiegel.com/petalbot"},{"regex":"SerendeputyBot","name":"Serendeputy Bot","category":"Crawler","url":"https://serendeputy.com/about/serendeputy-bot"},{"regex":"ias-va.*admantx.*service-fetcher","name":"ADmantX Service Fetcher","category":"Service bot","url":"https://www.admantx.com/service-fetcher.html"},{"regex":"SemanticScholarBot","name":"Semantic Scholar Bot","category":"Crawler","url":"https://www.semanticscholar.org/crawler"},{"regex":"VelenPublicWebCrawler","name":"Velen Public Web Crawler","category":"Crawler","url":"https://hunter.io/robot"},{"regex":"Barkrowler","name":"Barkrowler","category":"Crawler","url":"http://www.exensa.com/crawl"},{"regex":"BDCbot","name":"BDCbot","category":"Crawler","url":"https://bigweb.bigdatacorp.com.br/pages/faq.aspx","producer":{"name":"BIG Data Solucoes Em Tecnologia de Informatica LTDA","url":"https://bigdatacorp.com.br/"}},{"regex":"adbeat","name":"Adbeat","category":"Crawler","url":"https://www.adbeat.com/operation_policy","producer":{"name":"PPC Labs LLC","url":"https://www.adbeat.com/"}},{"regex":"BW/(?:(\\\\d+[\\\\.\\\\d]+))","name":"BuiltWith","category":"Crawler","url":"https://builtwith.com/biup","producer":{"name":"BuiltWith Pty Ltd","url":"https://builtwith.com/"}},{"regex":"https://whatis.contentkingapp.com","name":"ContentKing","category":"Site Monitor","url":"https://whatis.contentkingapp.com/","producer":{"name":"ContentKing BV","url":"https://www.contentkingapp.com/"}},{"regex":"MicroAdBot","name":"MicroAdBot","category":"Crawler","url":"https://www.microad.co.jp/","producer":{"name":"MicroAd, Inc.","url":"https://www.microad.co.jp/"}},{"regex":"PingAdmin.Ru","name":"PingAdmin.Ru","category":"Site Monitor","url":"https://ping-admin.ru/"},{"regex":"notifyninja.+monitoring","name":"Notify Ninja","category":"Site Monitor","url":"http://notifyninja.com"},{"regex":"WebDataStats","name":"WebDataStats","category":"Crawler","url":"https://webdatastats.com/policy.html","producer":{"name":"WebTehRazrabotka LLC","url":"https://webdatastats.com/"}},{"regex":"parse.ly scraper","name":"parse.ly","category":"Crawler","url":"https://www.parse.ly/help/integration/crawler","producer":{"name":"Parsely, Inc.","url":"https://www.parse.ly/"}},{"regex":"Nimbostratus-Bot","name":"Nimbostratus Bot","category":"Site Monitor","url":"http://cloudsystemnetworks.com"},{"regex":"HeartRails_Capture/\\\\d","name":"Heart Rails Capture","category":"Service Agent","url":"http://capture.heartrails.com"},{"regex":"Project-Resonance","name":"Project Resonance","category":"Crawler","url":"http://project-resonance.com"},{"regex":"DataXu/\\\\d","name":"DataXu","category":"Service Agent","url":"https://advertising.roku.com/dataxu","producer":{"name":"Roku, Inc.","url":"https://roku.com"}},{"regex":"Cocolyzebot","name":"Cocolyzebot","category":"Crawler","url":"https://cocolyze.com/en/cocolyzebot","producer":{"name":"VSI INNOVATION SAS","url":"https://vsi-innovation.com/"}},{"regex":"veryhip","name":"VeryHip","category":"Crawler","url":"https://veryhip.com/","producer":{"name":"VeryHip","url":"https://veryhip.com/"}},{"regex":"LinkpadBot","name":"LinkpadBot","category":"Crawler","url":"https://www.linkpad.org/","producer":{"name":"Solomono LLC","url":"https://www.linkpad.org/"}},{"regex":"MuscatFerret","name":"MuscatFerret","category":"Crawler","url":"http://www.webtop.com/"},{"regex":"PageThing.com","name":"PageThing","category":"Crawler","url":"https://www.pagething.com/","producer":{"name":"SPECIALNOISE LTD","url":"https://www.specialnoise.com/"}},{"regex":"ArchiveBox","name":"ArchiveBox","url":"https://archivebox.io/","category":"Crawler","producer":{"name":"","url":""}},{"regex":"Choosito","name":"Choosito","url":"https://www.choosito.com/","category":"Crawler","producer":{"name":"Choosito! Inc.","url":"https://www.choosito.com/"}},{"regex":"datagnionbot","name":"datagnionbot","url":"https://www.datagnion.com/bot.html","category":"Crawler","producer":{"name":"DATAGNION GMBH","url":"https://www.datagnion.com/"}},{"regex":"WhatCMS","name":"WhatCMS","url":"https://whatcms.org/","category":"Crawler","producer":{"name":"","url":""}},{"regex":"httpx","name":"httpx","url":"https://github.com/projectdiscovery/httpx","category":"Crawler","producer":{"name":"","url":""}},{"regex":"scaninfo@expanseinc.com","name":"Expanse","category":"Security Checker","url":"https://expanse.co/","producer":{"name":"Expanse Inc.","url":"https://expanse.co/"}},{"regex":"HuaweiWebCatBot","name":"HuaweiWebCatBot","category":"Crawler","url":"https://isecurity.huawei.com","producer":{"name":"Huawei Technologies Co., Ltd.","url":"https://huawei.com"}},{"regex":"Hatena-Favicon","name":"Hatena Favicon","category":"Crawler","url":"https://www.hatena.ne.jp/faq/","producer":{"name":"Hatena Co., Ltd.","url":"https://www.hatena.ne.jp"}},{"regex":"RyowlEngine/(\\\\d+)","name":"Ryowl","category":"Crawler","url":"https://ryowl.org"},{"regex":"OdklBot/(\\\\d+)","name":"Odnoklassniki Bot","category":"Crawler","url":"https://odnoklassniki.ru"},{"regex":"Mediatoolkitbot","name":"Mediatoolkit Bot","category":"Crawler","url":"https://mediatoolkit.com"},{"regex":"ZoominfoBot","name":"ZoominfoBot","category":"Crawler","url":"https://www.zoominfo.com"},{"regex":"WeViKaBot/([\\\\d+\\\\.])","name":"WeViKaBot","category":"Crawler","url":"http://www.wevika.de"},{"regex":"SEOkicks","name":"SEOkicks","category":"Crawler","url":"https://www.seokicks.de/robot.html"},{"regex":"Plukkie/([\\\\d+\\\\.])","name":"Plukkie","category":"Crawler","url":"http://www.botje.com/plukkie.htm"},{"regex":"proximic;","name":"Comscore","category":"Crawler","url":"https://www.comscore.com/Web-Crawler"},{"regex":"SurdotlyBot/([\\\\d+\\\\.])","name":"SurdotlyBot","category":"Crawler","url":"http://sur.ly/bot.html"},{"regex":"Gowikibot/([\\\\d+\\\\.])","name":"Gowikibot","category":"Crawler","url":"http:/www.gowikibot.com"},{"regex":"SabsimBot/([\\\\d+\\\\.])","name":"SabsimBot","category":"Crawler","url":"https://sabsim.com"},{"regex":"LumtelBot/([\\\\d+\\\\.])","name":"LumtelBot","category":"Crawler","url":"https://umtel.com"},{"regex":"PiplBot","name":"PiplBot","category":"Crawler","url":"http://www.pipl.com/bot"},{"regex":"woobot/([\\\\d+\\\\.])","name":"WooRank","category":"Crawler","url":"https://www.woorank.com/bot"},{"regex":"[a-z0-9\\\\-_]*((?<!cu|power[ _]|m[ _])bot(?![ _]TAB|[ _]?5[0-9])|crawler|crawl|checker|archiver|transcoder|spider)([^a-z]|$)","name":"Generic Bot"}]`);
var Gd, _S;
function ET() {
  if (_S) return Gd;
  _S = 1;
  var e = Gd && Gd.__importDefault || function(n) {
    return n && n.__esModule ? n : { default: n };
  };
  const t = e(Cfe), r = vo();
  class o {
    constructor() {
      this.parse = (a) => {
        var l, i, s, u;
        for (const c of t.default)
          if (r.userAgentParser(c.regex, a))
            return {
              name: c.name,
              category: c.category || "",
              url: c.url || "",
              producer: {
                name: ((i = (l = c) === null || l === void 0 ? void 0 : l.producer) === null || i === void 0 ? void 0 : i.name) || "",
                url: ((u = (s = c) === null || s === void 0 ? void 0 : s.producer) === null || u === void 0 ? void 0 : u.url) || ""
              }
            };
        return null;
      };
    }
  }
  return Gd = o, Gd;
}
var mc = {}, TS;
function Lfe() {
  return TS || (TS = 1, Object.defineProperty(mc, "__esModule", { value: !0 }), mc.versionCompare = (e, t, r) => {
    let o, n, a = 0;
    const l = {
      dev: -6,
      alpha: -5,
      a: -5,
      beta: -4,
      b: -4,
      RC: -3,
      rc: -3,
      "#": -2,
      p: 1,
      pl: 1
    }, i = (u) => (u = ("" + u).replace(/[_\-+]/g, "."), u = u.replace(/([^.\d]+)/g, ".$1.").replace(/\.{2,}/g, "."), u.length ? u.split(".") : [-8]), s = (u) => u ? isNaN(u) ? l[u] || -7 : parseInt(u, 10) : 0;
    for (e = i(e), t = i(t), n = Math.max(e.length, t.length), o = 0; o < n; o++)
      if (e[o] !== t[o]) {
        if (e[o] = s(e[o]), t[o] = s(t[o]), e[o] < t[o]) {
          a = -1;
          break;
        } else if (e[o] > t[o]) {
          a = 1;
          break;
        }
      }
    if (!r)
      return a;
    switch (r) {
      case ">":
      case "gt":
        return a > 0;
      case ">=":
      case "ge":
        return a >= 0;
      case "<=":
      case "le":
        return a <= 0;
      case "===":
      case "=":
      case "eq":
        return a === 0;
      case "<>":
      case "!==":
      case "ne":
        return a !== 0;
      case "":
      case "<":
      case "lt":
        return a < 0;
      default:
        return null;
    }
  }), mc;
}
var Bd, AS;
function Efe() {
  if (AS) return Bd;
  AS = 1;
  var e = Bd && Bd.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  const t = e(GZ()), r = e(lfe()), o = e(cfe()), n = e($fe()), a = e(LT()), l = ET(), i = vo(), s = Lfe();
  class u {
    constructor(g) {
      this.options = {
        skipBotDetection: !1,
        versionTruncation: 1
      }, this.parse = (p) => {
        var h, v, A, S, b, T, w, N, O, m, _, X, $, E;
        const D = {
          client: this.clientParser.parse(p),
          os: this.operatingSystemParser.parse(p),
          device: this.deviceParser.parse(p),
          bot: this.options.skipBotDetection ? null : this.botParser.parse(p)
        }, U = (h = D.os) === null || h === void 0 ? void 0 : h.name, Y = (v = D.os) === null || v === void 0 ? void 0 : v.version, G = o.default.getOsFamily(U || "");
        if (!(!((A = D.device) === null || A === void 0) && A.brand)) {
          const W = this.vendorFragmentParser.parse(p);
          W && (D.device || (D.device = this.createDeviceObject()), D.device.brand = W);
        }
        return !(!((S = D.device) === null || S === void 0) && S.brand) && ["Apple TV", "watchOS", "iOS", "Mac"].includes(U || "") && (D.device || (D.device = this.createDeviceObject()), D.device.brand = "Apple"), !(!((b = D.device) === null || b === void 0) && b.type) && G === "Android" && i.userAgentParser("Chrome/[\\.0-9]*", p) && (i.userAgentParser("Chrome/[.0-9]* (?:Mobile|eliboM)", p) ? (D.device || (D.device = this.createDeviceObject()), D.device.type = "smartphone") : i.userAgentParser("Chrome/[.0-9]* (?!Mobile)", p) && (D.device || (D.device = this.createDeviceObject()), D.device.type = "tablet")), (!(!((T = D.device) === null || T === void 0) && T.type) && this.hasAndroidTabletFragment(p) || i.userAgentParser("Opera Tablet", p)) && (D.device || (D.device = this.createDeviceObject()), D.device.type = "tablet"), !(!((w = D.device) === null || w === void 0) && w.type) && this.hasAndroidMobileFragment(p) && (D.device || (D.device = this.createDeviceObject()), D.device.type = "smartphone"), !(!((N = D.device) === null || N === void 0) && N.type) && U === "Android" && Y !== "" && (s.versionCompare(Y, "2.0") === -1 ? (D.device || (D.device = this.createDeviceObject()), D.device.type = "smartphone") : s.versionCompare(Y, "3.0") >= 0 && s.versionCompare(Y, "4.0") === -1 && (D.device || (D.device = this.createDeviceObject()), D.device.type = "tablet")), ((O = D.device) === null || O === void 0 ? void 0 : O.type) === "feature phone" && G === "Android" && (D.device.type = "smartphone"), !(!((m = D.device) === null || m === void 0) && m.type) && this.isToucheEnabled(p) && (U === "Windows RT" || U === "Windows" && s.versionCompare(Y, "8.0") >= 0) && (D.device || (D.device = this.createDeviceObject()), D.device.type = "tablet"), i.userAgentParser("Opera TV Store", p) && (D.device || (D.device = this.createDeviceObject()), D.device.type = "television"), i.userAgentParser("SmartTV|Tizen.+ TV .+$", p) && (D.device || (D.device = this.createDeviceObject()), D.device.type = "television"), !(!((_ = D.device) === null || _ === void 0) && _.type) && ["Kylo", "Espial TV Browser"].includes(((X = D.client) === null || X === void 0 ? void 0 : X.name) || "") && (D.device || (D.device = this.createDeviceObject()), D.device.type = "television"), (($ = D.device) === null || $ === void 0 ? void 0 : $.type) !== "desktop" && i.userAgentParser("Desktop", p) !== null && this.hasDesktopFragment(p) && (D.device || (D.device = this.createDeviceObject()), D.device.type = "desktop"), !(!((E = D.device) === null || E === void 0) && E.type) && this.isDesktop(D, G) && (D.device || (D.device = this.createDeviceObject()), D.device.type = "desktop"), D;
      }, this.hasAndroidMobileFragment = (p) => i.userAgentParser("Android( [.0-9]+)?; Mobile;", p), this.hasAndroidTabletFragment = (p) => i.userAgentParser("Android( [.0-9]+)?; Tablet;", p), this.hasDesktopFragment = (p) => i.userAgentParser("Desktop (x(?:32|64)|WOW64);", p), this.isDesktop = (p, h) => !p.os || this.usesMobileBrowser(p.client) ? !1 : o.default.getDesktopOsArray().includes(h), this.usesMobileBrowser = (p) => {
        var h, v;
        return p ? ((h = p) === null || h === void 0 ? void 0 : h.type) === "browser" && a.default.isMobileOnlyBrowser((v = p) === null || v === void 0 ? void 0 : v.name) : !1;
      }, this.isToucheEnabled = (p) => i.userAgentParser("Touch", p), this.createDeviceObject = () => ({
        type: "",
        brand: "",
        model: ""
      }), this.options = Object.assign(Object.assign({}, this.options), g), this.clientParser = new t.default(this.options), this.deviceParser = new r.default(), this.operatingSystemParser = new o.default(this.options), this.vendorFragmentParser = new n.default(), this.botParser = new l();
    }
  }
  return Bd = u, Bd;
}
var Ofe = Efe();
const Nfe = /* @__PURE__ */ Ah(Ofe);
var Dfe = ET();
const kfe = /* @__PURE__ */ Ah(Dfe), che = {
  install: (e, t) => {
    const o = new Nfe().parse(window.navigator.userAgent), a = new kfe().parse(window.navigator.userAgent), l = () => ({
      isMobile: o.device?.type == "smartphone",
      isTablet: o.device?.type == "tablet",
      isDesktop: o.device?.type == "desktop",
      model: o.device?.model,
      brand: o.device?.brand,
      type: o.device?.type,
      os_name: o.os,
      os_platform: o.os?.platform,
      os_version: o.os?.version,
      browser_name: o.client?.name,
      browser_version: o.client?.version,
      // browser_engine: (detector.client?.engine as string) || '',
      // browser_engine_version: (detector.client?.engineVersion as string) || '',
      browser: {
        chrome: o.client?.name == "Chrome",
        chrome_view: o.client?.name == "Chrome Webview",
        chrome_mobile: o.client?.name == "Chrome Mobile",
        chrome_mobile_ios: o.client?.name == "Chrome Mobile iOS",
        safari: o.client?.name == "Safari",
        safari_mobile: o.client?.name == "Mobile Safari",
        msedge: o.client?.name == "Microsoft Edge",
        msie_mobile: o.client?.name == "IE Mobile",
        msie: o.client?.name == "Internet Explorer"
      },
      os: {
        android: o.os?.name == "Android",
        blackberry: o.os?.name == "BlackBerry OS",
        ios: o.os?.name == "iOS",
        windows: o.os?.name == "Windows",
        windows_phone: o.os?.name == "Windows Phone",
        mac: o.os?.name == "Mac",
        linux: o.os?.name == "GNU/Linux" || o.os?.name == "GNU/Linux",
        chrome: o.os?.name == "Chrome OS",
        firefox: o.os?.name == "Firefox OS",
        gamingConsole: o.os?.name == "Gaming Console"
      },
      isAndroid: o.os?.name == "Android",
      isBlackberry: o.os?.name == "BlackBerry OS",
      isIOS: o.os?.name == "iOS",
      isWindows: o.os?.name == "Windows",
      isWindowsPhone: o.os?.name == "Windows Phone",
      isOsx: o.os?.name == "Mac",
      isLinux: o.os?.name == "GNU/Linux" || o.os?.name == "GNU/Linux",
      isChromeOs: o.os?.name == "Chrome OS",
      isFireFoxOS: o.os?.name == "Firefox OS",
      GamingConsole: o.os?.name == "Gaming Console",
      isBot: a,
      machine: {
        brand: o.device?.brand,
        model: o.device?.model,
        os_name: o.os?.name,
        os_version: o.os?.version,
        type: o.device?.type
      },
      bot: a,
      client: o.client,
      device: o.device
    });
    e.provide("getDeviceType", l);
  }
}, mhe = (e) => qI({
  legacy: !1,
  locale: "en",
  globalInjection: !0,
  messages: e,
  warnHtmlMessage: !1
});
class gl {
  events;
  worker;
  /**
   * The constructor expects as first argument the URL of the Worker file.
   *
   * @param {String} scriptPath
   */
  constructor(t) {
    let r = this;
    this.worker = new Worker(t, {
      type: "module"
    }), this.events = {}, this.worker.addEventListener(
      "message",
      function(o) {
        Object.prototype.hasOwnProperty.call(r.events, o.data.event) && r.events[o.data.event].call(null, o.data.data);
      },
      !1
    ), this.worker.addEventListener(
      "error",
      function(o) {
        Object.prototype.hasOwnProperty.call(r.events, "error") && r.events.error.call(null, o);
      },
      !1
    );
  }
  /**
   * Returns the original WebWorker instance.
   *
   * @returns {Worker}
   */
  getWorker() {
    return this.worker;
  }
  /**
   * Triggers an event in the WebWorker.
   *
   * @param {*} eventName
   * @param {*} params
   */
  trigger(t, r) {
    this.worker.postMessage({
      eventName: t,
      actionName: r.action,
      data: r.data,
      url: r.url,
      token: r.token ? r.token : ""
    });
  }
  /**
   * Responds to an event from the web worker.
   *
   * @param {*} eventName
   * @param {*} callback
   */
  on(t, r) {
    this.events[t] = r;
  }
  /**
   * Stop the web worker.
   */
  close() {
    this.worker.terminate();
  }
}
const bs = {
  /**
   * Login Listener.
   *
   * @param {String}   formId
   * @param {Store}    stores   ({ user: any; action: any })
   * @param {any}      options  ({ ruler: { combine: boolean, url: string } })
   * @param {Function} preCheck
   * @param {Function} callback
   *
   * @returns {Promise<boolean | IResponse>}
   */
  login: async (e, t, r, o) => {
    const n = "action" in t ? t.action : "login", a = "defaultRuler" in t ? "login" : n, l = t.stores;
    try {
      let i = await Zl(a, e, l, {
        ...t,
        defaultRuler: "authRules"
      });
      if (i)
        return bs.loginDirect(i, {
          ...t,
          action: n
        });
      l.action.setResponse({
        action: n,
        status: !1,
        message: "",
        data: null,
        error: null
      });
    } catch (i) {
      console.error(`${n}:`, i);
    }
    return !1;
  },
  loginDirect: async (e, t) => {
    const r = "action" in t ? t.action : "login", o = t.stores;
    try {
      if (Object.keys(e).length !== 0) {
        const n = "/workers/auth.min.js";
        return await new Promise((a, l) => {
          var i = new gl(n);
          i.trigger("login", {
            action: r,
            data: e,
            url: o.action.getUrlByKey(r)
          }), i.on("login", function(s) {
            console.debug("login direct res", s), s.status && (o.user.setLoggedIn(!0), o.user.setInfo(s.data.user), o.user.setToken(s.data.token), o.action.clearComponentAction(), o.action.clearError(), o.action.clearFormError(), "expires_at" in s.data && o.user.setExpires(s.data.expires_at), o.user.getInfoByKey("is_new") && o.user.setNewLogin(o.user.getInfoByKey("is_new"))), o.action.setResponse({
              action: r,
              status: s.status,
              message: s.message,
              data: s.data || null,
              error: s.error || null
            }), i?.close(), i = void 0, a(s);
          });
        });
      }
    } catch (n) {
      console.error("login direct:", n);
    }
    return !1;
  },
  /**
   * Logout Listener.
   *
   * @param {Store}    stores   ({ user: any; action: any })
   * @param {any}      options  ({ ruler: { combine: boolean, url: string } })
   * @param {Function} preCheck
   * @param {Function} callback
   *
   * @returns {Promise<boolean | IResponse>}
   */
  logout: async (e, t, r, o) => {
    const n = "action" in t ? t.action : "logout";
    try {
      const a = "/workers/auth.min.js";
      return await new Promise((l, i) => {
        var s = new gl(a);
        s.trigger("logout", {
          action: n,
          url: e.action.getUrlByKey(n),
          token: t.token
        }), s.on("logout", function(u) {
          u.status && (e.user.clearUserStore(), e.action.clearComponentAction(), e.action.clearError(), e.action.clearFormError()), e.action.setResponse({
            action: n,
            status: u.status,
            message: u.message,
            data: u.data || null,
            error: u.error || null
          }), s?.close(), s = void 0, l(u);
        });
      });
    } catch (a) {
      console.error(`${n}:`, a);
    }
    return !1;
  },
  /**
   * Change Password Listener.
   *
   * @param {String}   formId
   * @param {Store}    stores   ({ user: any; action: any })
   * @param {any}      options  ({ ruler: { combine: boolean, url: string } })
   * @param {Function} preCheck
   * @param {Function} callback
   *
   * @returns {Promise<boolean | IResponse>}
   */
  changePassword: async (e, t, r, o) => {
    const n = "action" in t ? t.action : "changePassword", a = "defaultRuler" in t ? t.ruleName ?? "changePassword" : n, l = t.stores;
    try {
      let i = await Zl(a, e, l, {
        ...t,
        defaultRuler: "authRules"
      });
      if (i) {
        if (Object.keys(i).length !== 0) {
          const s = "/workers/auth.min.js";
          return await new Promise((u, c) => {
            var g = new gl(s);
            g.trigger("changePassword", {
              action: n,
              data: i,
              url: l.action.getUrlByKey(n),
              token: l.user.getToken()
            }), g.on("changePassword", function(p) {
              console.debug("changePassword res", p), p.status && (l.action.clearComponentAction(), l.action.clearError(), l.action.clearFormError()), l.action.setResponse({
                action: n,
                status: p.status,
                message: p.message,
                data: p.data || null,
                error: p.error || null
              }), g?.close(), g = void 0, u(p);
            });
          });
        }
      } else
        l.action.setResponse({
          action: n,
          status: !1,
          message: "",
          data: null,
          error: null
        });
    } catch (i) {
      console.error(`${n}:`, i);
    }
    return !1;
  },
  /**
   * Forgot Password Listener.
   *
   * @param {String}   formId
   * @param {Store}    stores   ({ user: any; action: any })
   * @param {any}      options  ({ ruler: { combine: boolean, url: string } })
   * @param {Function} preCheck
   * @param {Function} callback
   *
   * @returns {Promise<boolean | IResponse>}
   */
  forgotPassword: async (e, t, r, o, n) => {
    const a = "forgotPassword";
    try {
      let l = await Zl(a, e, t, {
        ...r,
        defaultRuler: "authRules"
      });
      if (l) {
        if (Object.keys(l).length !== 0) {
          const i = "/workers/auth.min.js";
          return await new Promise((s, u) => {
            var c = new gl(i);
            c.trigger(a, {
              action: a,
              data: l,
              url: t.action.getUrlByKey(a),
              token: t.user.getToken()
            }), c.on(a, function(g) {
              console.debug("forgotPassword res", g), g.status && (t.action.clearComponentAction(), t.action.clearError(), t.action.clearFormError()), t.action.setResponse({
                action: a,
                status: g.status,
                message: g.message,
                data: g.data || null,
                error: g.error || null
              }), c?.close(), c = void 0, s(g);
            });
          });
        }
      } else
        t.action.setResponse({
          action: a,
          status: !1,
          message: "",
          data: null,
          error: null
        });
    } catch (l) {
      console.error(`${a}:`, l);
    }
    return !1;
  },
  /**
   * Register Listener.
   *
   * @param {String}   formId
   * @param {Store}    stores   ({ user: any; action: any })
   * @param {any}      options  ({ ruler: { combine: boolean, url: string } })
   * @param {Function} preCheck
   * @param {Function} callback
   *
   * @returns {Promise<boolean | IResponse>}
   */
  register: async (e, t, r, o, n) => {
    const a = "register";
    try {
      let l = await Zl(a, e, t, {
        ...r,
        defaultRuler: "authRules"
      });
      if (l) {
        if (Object.keys(l).length !== 0) {
          if (r && Object.keys(r).length > 0 && "isSubmit" in r && !r.isSubmit)
            return !0;
          const i = "/workers/auth.min.js";
          return await new Promise((s, u) => {
            var c = new gl(i);
            c.trigger(a, {
              action: a,
              data: l,
              url: t.action.getUrlByKey(a)
            }), c.on(a, function(g) {
              console.debug("register res", g), g.status && (t.action.clearComponentAction(), t.action.clearError(), t.action.clearFormError()), t.action.setResponse({
                action: a,
                status: g.status,
                message: g.message,
                data: g.data || null,
                error: g.error || null
              }), c?.close(), c = void 0, s(g);
            });
          });
        }
      } else
        t.action.setResponse({
          action: a,
          status: !1,
          message: "",
          data: null,
          error: null
        });
    } catch (l) {
      console.error(`${a}:`, l);
    }
    return !1;
  },
  /**
   * Account Duplicate Check Listener.
   *
   * @param {String}   formId
   * @param {Store}    stores   ({ user: any; action: any })
   * @param {any}      options  ({ ruler: { combine: boolean, url: string } })
   * @param {Function} preCheck
   * @param {Function} callback
   *
   * @returns {Promise<boolean | IResponse>}
   */
  accountExisting: async (e, t, r, o, n) => {
  }
}, Ef = {
  /**
   * API Request Listener.
   *
   * @param {String}   formId
   * @param {any}      options  ({ ruler: { combine: boolean, url: string } })
   * @param {Function} preCheck
   * @param {Function} callback
   *
   * @returns {Promise<boolean | IResponse>}
   */
  onRequest: async (e, t, r, o, n) => {
    const a = "action" in t ? t.action : "", l = "method" in t ? t.method : "", i = "id" in t ? t.id : "", s = t.stores;
    try {
      let u = await Zl(a, e, s, {
        ...t,
        defaultRules: {}
      });
      if (u !== !1 && (r && (u = xa(u, r)), o && (u = o(u))), u) {
        if (Object.keys(u).length !== 0) {
          const c = "/workers/general.min.js";
          return await new Promise((g, p) => {
            var h = new gl(c);
            h.trigger(l, {
              action: l,
              data: u,
              url: s.action.getUrlByKey(a) + (i ? `/${i}` : ""),
              token: s.user.getToken()
            }), h.on(l, function(v) {
              console.debug("%c onRequest request", "background: #07789b; color: #ffffff", u), console.debug("%c onRequest response", "background: #383838; color: #bada55", v), v.status == 0 && (s.action.clearComponentAction(), s.action.clearError(), s.action.clearFormError()), s.action.setResponse({
                action: a,
                status: v.status,
                message: v.message,
                data: v.data || null,
                error: v.error || null
              }), h?.close(), h = void 0, g(v);
            });
          });
        }
      } else
        s.action.setResponse({
          action: a,
          status: !1,
          message: "",
          data: null,
          error: null
        });
    } catch (u) {
      console.error(`${a}:`, u);
    }
    return !1;
  },
  /**
   * API Request Listener - Without Form.
   *
   * @param {IFormData} data
   * @param {any}       options  ({ ruler: { combine: boolean, url: string } })
   * @param {Function}  preCheck
   * @param {Function}  callback
   *
   * @returns {Promise<boolean | IResponse>}
   */
  onDirectRequest: async (e, t, r, o) => {
    const n = "action" in t ? t.action : "", a = "method" in t ? t.method : "", l = "id" in t ? t.id : "", i = t.stores;
    var s = "url" in t ? t.url : i.action.getUrlByKey(n) + (l ? `/${l}` : "");
    if (!s || typeof s > "u" || s === "undefined")
      return !1;
    if ("params" in t)
      for (let u in t.params)
        s = s.replace(`{${u}}`, t.params[u]);
    try {
      const u = "/workers/general.min.js";
      return await new Promise((c, g) => {
        var p = new gl(u);
        p.trigger(a, {
          action: a,
          data: xa(e, { locale: i.user.getLanguage() }),
          url: s,
          token: i.user.getToken()
        }), p.on(a, function(h) {
          console.debug("%c onDirectRequest request", "background: #07789b; color: #ffffff", e), console.debug("%c onDirectRequest response", "background: #383838; color: #bada55", h), p?.close(), p = void 0, c(h);
        });
      });
    } catch (u) {
      console.error(`${n}:`, u);
    }
    return !1;
  },
  /**
   * API Request Listener - With File.
   *
   * @param {String}   formId
   * @param {any}      options  ({ ruler: { combine: boolean, url: string } })
   * @param {Function} preCheck
   * @param {Function} callback
   *
   * @returns {Promise<boolean | IResponse>}
   */
  onFileRequest: async (e, t, r, o, n) => {
    const a = "action" in t ? t.action : "", l = "method" in t ? t.method : "", i = "id" in t ? t.id : "", s = t.stores;
    try {
      let u = await Zl(a, e, s, {
        ...t,
        defaultRules: {}
      });
      if (u !== !1 && (r && (u = xa(u, r)), o && (u = o(u))), u) {
        if (Object.keys(u).length !== 0) {
          const c = "/workers/file.min.js";
          return await new Promise((g, p) => {
            var h = new gl(c);
            h.trigger(l, {
              action: l,
              data: u,
              url: s.action.getUrlByKey(a) + (i ? `/${i}` : ""),
              token: s.user.getToken()
            }), h.on(l, function(v) {
              console.debug("%c onFileRequest request", "background: #07789b; color: #ffffff", u), console.debug("%c onFileRequest response", "background: #383838; color: #bada55", v), v.status == 0 && (s.action.clearComponentAction(), s.action.clearError(), s.action.clearFormError()), s.action.setResponse({
                action: a,
                status: v.status,
                message: v.message,
                data: v.data || null,
                error: v.error || null
              }), h?.close(), h = void 0, g(v);
            });
          });
        }
      } else
        s.action.setResponse({
          action: a,
          status: !1,
          message: "",
          data: null,
          error: null
        });
    } catch (u) {
      console.error(`${a}:`, u);
    }
    return !1;
  }
}, Gfe = {
  /**
   * Web app version validation.
   *
   * @returns {IVersionValidate}
   */
  checkAppVersion: async (e) => {
    try {
      const o = (await (await fetch("/version.json", { cache: "no-store" })).json()).version;
      return o !== e ? (console.info(`[Version Check] New version detected: ${o}`), { isNew: !0, appVersion: e, buildVersion: o }) : { isNew: !1, appVersion: e, buildVersion: o };
    } catch (t) {
      return console.error("[Version Check] Failed to fetch version.json", t), { isNew: !1 };
    }
  }
}, ghe = {
  install: (e, t) => {
    e.provide("changePassword", bs.changePassword), e.provide("forgotPassword", bs.forgotPassword), e.provide("login", bs.login), e.provide("logout", bs.logout), e.provide("register", bs.register), e.provide("onRequest", Ef.onRequest), e.provide("onDirectRequest", Ef.onDirectRequest), e.provide("onFileRequest", Ef.onFileRequest), e.provide("validator", wb), e.provide("checkAppVersion", Gfe.checkAppVersion);
  }
};
function fhe(e, t) {
  Object.entries(t).forEach(([, r]) => {
    r?.default?.name && e.component(r.default.name, r.default);
  });
}
const Bfe = { class: "page main-signin-wrapper bg-primary rounded-0" }, Ife = { class: "container" }, Rfe = { class: "text-center text-white" }, Ffe = { class: "col-lg-12" }, Vfe = { class: "tx-15 text-white-50 mt-3 mb-4" }, Hfe = ["href"], Ufe = {
  key: 1,
  href: "javascript:history.back();",
  class: "btn ripple btn btn-white btn-sm"
}, phe = /* @__PURE__ */ wt({
  __name: "404",
  props: {
    propsRoute: {
      type: Object,
      required: !0
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = t.propsStore.app, o = t.propsStore.user, n = ge(() => t.propsRoute.fullPath.split("/").length === 3 ? "home" : `${o.getType()}/home`), a = ge(() => r.getTypes().includes(o.getType()));
    return (l, i) => (C(), k("div", Bfe, [
      L("div", Ife, [
        L("div", Rfe, [
          L("div", null, [
            i[1] || (i[1] = L("div", { class: "col-lg-12" }, [
              L("h1", { class: "tx-140 mb-0" }, "404")
            ], -1)),
            L("div", Ffe, [
              L("h1", null, _e(l.$t("404_error_desc1")), 1),
              L("h6", Vfe, _e(l.$t("404_error_desc2")), 1),
              a.value ? (C(), k("a", {
                key: 0,
                href: n.value,
                class: "btn ripple btn btn-white btn-sm"
              }, _e(l.$t("home")), 9, Hfe)) : (C(), k("a", Ufe, [
                i[0] || (i[0] = L("i", { class: "fas fa-arrow-left pe-1" }, null, -1)),
                Gt(_e(l.$t("back")), 1)
              ]))
            ])
          ])
        ])
      ])
    ]));
  }
}), Xfe = {}, Wfe = { class: "page main-signin-wrapper bg-primary rounded-0" }, Yfe = { class: "container" }, Kfe = { class: "text-center text-white" }, Qfe = { class: "col-lg-12" }, jfe = { class: "tx-15 text-white-50 mt-3 mb-4" };
function Zfe(e, t) {
  return C(), k("div", Wfe, [
    L("div", Yfe, [
      L("div", Kfe, [
        L("div", null, [
          t[0] || (t[0] = L("div", { class: "col-lg-12" }, [
            L("h1", { class: "tx-140 mb-0" }, "500")
          ], -1)),
          L("div", Qfe, [
            L("h1", null, _e(e.$t("500_error_desc1")), 1),
            L("h6", jfe, _e(e.$t("500_error_desc2")), 1)
          ])
        ])
      ])
    ])
  ]);
}
const hhe = /* @__PURE__ */ _m(Xfe, [["render", Zfe]]), zfe = { class: "col-12 col-lg-5 d-flex align-items-center justify-content-center min-vh-100 min-vw-100" }, qfe = { class: "card custom-card mb-0" }, Jfe = { class: "card-header border-bottom-0 mx-1 mt-2" }, epe = { class: "main-content-label mb-1" }, tpe = { class: "text-muted card-sub-title" }, rpe = { class: "card-body" }, ope = ["id"], npe = { class: "row row-sm" }, xhe = /* @__PURE__ */ wt({
  __name: "FirstLoginPassword",
  props: {
    propsFormAction: {
      type: Object,
      required: !0
    },
    propsFunction: {
      type: Object,
      required: !0
    },
    propsStore: {
      type: Object,
      required: !0
    },
    propsRouter: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = t.propsStore.app, o = t.propsStore.user, n = t.propsStore.action, a = Yn("changePassword"), l = () => ({
      new_password: "",
      confirm_password: ""
    }), i = dt({
      action: "firstLoginPassword",
      blade: {
        new_password: {
          type: "password",
          label: "new_password",
          attributes: {
            required: !0,
            minlength: 6
          },
          placeholder: "new_password",
          value: "",
          classes: "",
          divClasses: ""
        },
        confirm_password: {
          type: "password",
          label: "confirm_password",
          attributes: {
            required: !0,
            minlength: 6
          },
          placeholder: "confirm_password",
          value: "",
          classes: "",
          divClasses: ""
        }
      },
      id: `${t.propsFormAction[o.getType()]}Form`,
      isSubmit: !1
    }), s = () => ({
      action: i.action,
      defaultRuler: "authRules",
      ruleName: "firstLoginPassword",
      language: o.getLanguage(),
      stores: { user: o, action: n }
    }), u = () => {
      i.isSubmit || (g(o.getType()), i.isSubmit = !0, a(i.id, s()));
    }, c = (p) => {
      if (p.status) {
        o.setInfo({ ...o.getInfo(), is_new: !1 }), o.setNewLogin(!1), setTimeout(() => {
          const { href: h } = t.propsRouter.resolve({ name: "Home", params: { type: o.getType() } });
          window.location.href = h;
        }, 2e3);
        return;
      }
      "isSubmit" in p && (g(), i.isSubmit = p.isSubmit);
    }, g = (p) => {
      i.action = p ? t.propsFormAction[p] : "firstLoginPassword";
    };
    return (p, h) => (C(), k("div", zfe, [
      L("div", qfe, [
        L("div", Jfe, [
          L("h6", epe, _e(p.$t("set_password")), 1),
          L("p", tpe, _e(p.$t("set_password_desc")), 1)
        ]),
        L("div", rpe, [
          L("form", {
            id: i.id
          }, [
            L("div", npe, [
              vt(I0, {
                "props-blade": i.blade,
                "props-blade-init": l,
                "props-form-option": s(),
                "props-is-disable": i.isSubmit,
                "props-is-edit": !1,
                "props-model": i.action,
                "props-store": {
                  app: R(r),
                  user: R(o),
                  action: R(n)
                },
                onOnPostSubmit: c
              }, null, 8, ["props-blade", "props-form-option", "props-is-disable", "props-model", "props-store"])
            ])
          ], 8, ope)
        ]),
        vt(Q9, {
          "props-function": u,
          "props-is-disabled": i.isSubmit,
          "props-is-submit": i.isSubmit,
          "props-text": "set_password"
        }, {
          "button-before": je(() => [
            L("a", {
              href: "javascript:void(0)",
              class: "btn btn-outline-dark",
              onClick: h[0] || (h[0] = (v) => e.propsFunction.onLogout(R(o).getType()))
            }, _e(p.$t("signout")), 1)
          ]),
          _: 1
        }, 8, ["props-is-disabled", "props-is-submit"])
      ])
    ]));
  }
}), ape = { class: "page main-signin-wrapper" }, lpe = { class: "signpages row text-center" }, ipe = { class: "col-md-12" }, spe = { class: "card" }, dpe = { class: "row row-sm" }, upe = { class: "col-lg-6 col-xl-5 d-none d-lg-block text-center bg-primary left" }, cpe = { class: "mt-5 pt-5 p-2" }, mpe = { class: "text-white mt-4" }, gpe = { class: "tx-white-6 tx-13 mb-5 mt-xl-0" }, fpe = { class: "login_form col-lg-6 col-xl-7 col-xs-12 col-sm-12" }, ppe = { class: "main-container container-fluid" }, hpe = { class: "row row-sm" }, xpe = { class: "d-flex flex-row-reverse mt-3 ms-0" }, vpe = { class: "card-body mt-2 mb-2" }, Spe = { class: "d-flex d-lg-none align-items-end mb-4" }, bpe = { class: "header-brand-text" }, ype = { class: "text-start mb-2" }, wpe = { class: "text-muted text-start tx-13 ms-0 mb-4" }, _pe = { class: "form-group text-start" }, Tpe = ["placeholder", "disabled"], Ape = {
  key: 0,
  class: "form-error"
}, Ppe = { class: "form-group text-start" }, Mpe = ["placeholder", "disabled"], $pe = {
  key: 0,
  class: "form-error"
}, Cpe = ["disabled"], vhe = /* @__PURE__ */ wt({
  __name: "Login",
  props: {
    propsFunction: {
      type: Object,
      required: !0,
      validator: (e) => typeof e.get2FaUrl == "function" && typeof e.getCookieName == "function" && typeof e.getLoginUrl == "function"
    },
    propsImage: {
      type: Object
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  async setup(e) {
    let t, r;
    const o = e, n = o.propsStore.app, a = o.propsStore.user, l = o.propsStore.action, { response: i, forms: s } = om(l), u = { app: n, user: a, action: l }, c = o.propsFunction.getLoginUrl("all"), g = () => ({
      username: "",
      password: ""
    }), p = dt({
      twoFaValidate: {
        "2FAToken": !1,
        newTo2FA: !1
      }
    }), h = dt({
      input: g(),
      error: g(),
      reset: !1,
      isSubmit: !1
    }), v = {
      images: {
        logo: {
          src: "../images/logo/logo.png",
          alt: "logo icon"
        },
        user: {
          src: "../images/login/user.svg",
          alt: "user icon"
        }
      }
    };
    tn(() => {
      h.isSubmit && (h.isSubmit = !1);
    });
    const A = ([t, r] = ri(() => Yn("login")), t = await t, r(), t), S = ([t, r] = ri(() => Yn("onDirectRequest")), t = await t, r(), t), b = ([t, r] = ri(() => Yn("validator")), t = await t, r(), t), T = () => ({
      action: o.propsFunction.getLoginUrl(a.getType()),
      defaultRuler: "authRules",
      language: a.getLanguage(),
      stores: { user: a, action: l }
    }), w = async () => {
      if (!(h.isSubmit || ro.isVisible())) {
        if (!h.input.username || !h.input.password) {
          h.isSubmit = !0, A("loginForm", T());
          return;
        }
        if (h.isSubmit = !0, p.twoFaValidate = await $h(u, h.input, o.propsFunction.get2FaUrl, S), En(p.twoFaValidate)) {
          h.isSubmit = !1;
          return;
        }
        if (p.twoFaValidate["2FAToken"]) {
          const m = await Hm(u);
          if (m)
            h.input.one_time_password = m;
          else {
            h.isSubmit = !1;
            return;
          }
        }
        if (!p.twoFaValidate.newTo2FA) {
          const m = o.propsFunction.getCookieName(a.getType(), { cType: "f_login" });
          document.cookie = `${m}=1; path=/`;
        }
        A("loginForm", T());
      }
    }, N = () => {
      Object.assign(h.input, g()), Object.assign(h.error, g()), h.reset = !0;
    }, O = ge(() => ({
      ...v.images,
      ...o.propsImage ?? {}
    }));
    return nt(() => [h.input.username, h.input.password], ([m, _], [X, $]) => {
      if (h.reset) {
        Kr(() => {
          h.reset = !1;
        });
        return;
      }
      if (m !== X) {
        h.error.username = "", b({ name: "username", type: "text", value: m }, "login", T());
        return;
      }
      if (_ !== $) {
        h.error.password = "", b({ name: "password", type: "password", value: _ }, "login", T());
        return;
      }
    }), nt(() => [s.value.isError, s.value.id, s.value.error], ([m, _, X]) => {
      m && c.includes(_) && Object.assign(h.error, X);
    }), nt(() => [i.value.action, i.value.status], async ([m, _]) => {
      _ && c.includes(m) && N(), _ || (await Mh(), h.isSubmit = !1);
    }), (m, _) => {
      const X = sA("focus");
      return C(), k("div", ape, [
        L("div", lpe, [
          L("div", ipe, [
            L("div", spe, [
              L("div", dpe, [
                L("div", upe, [
                  L("div", cpe, [
                    L("img", ht({ class: "ht-100 mb-0" }, O.value.user), null, 16),
                    L("h5", mpe, _e(R(n).getEnvAttrsByKey("VITE_APP_TITLE")), 1),
                    L("span", gpe, _e(m.$t("app_desc")), 1)
                  ])
                ]),
                L("div", fpe, [
                  L("div", ppe, [
                    L("div", hpe, [
                      L("div", xpe, [
                        vt(oT, {
                          "props-store": { app: R(n), user: R(a) }
                        }, null, 8, ["props-store"])
                      ]),
                      L("div", vpe, [
                        L("div", Spe, [
                          L("img", ht({ class: "header-brand-img text-start float-start" }, O.value.logo), null, 16),
                          L("span", bpe, [
                            L("h4", null, _e(R(n).getEnvAttrsByKey("VITE_APP_TITLE")), 1)
                          ])
                        ]),
                        _[6] || (_[6] = L("div", { class: "clearfix" }, null, -1)),
                        L("form", {
                          id: "loginForm",
                          onKeyup: _[4] || (_[4] = Ao(($) => w(), ["enter"]))
                        }, [
                          L("h5", ype, _e(m.$t("signin_ur_account")), 1),
                          L("p", wpe, _e(m.$t("signin_no_account")), 1),
                          L("div", _pe, [
                            L("label", null, _e(m.$t("username")), 1),
                            Qt(L("input", {
                              type: "text",
                              name: "username",
                              class: "form-control",
                              placeholder: m.$t("username_enter"),
                              required: "",
                              "onUpdate:modelValue": _[0] || (_[0] = ($) => h.input.username = $),
                              disabled: h.isSubmit
                            }, null, 8, Tpe), [
                              [Io, h.input.username],
                              [X]
                            ]),
                            h.error.username ? (C(), k("small", Ape, _e(h.error.username), 1)) : q("", !0)
                          ]),
                          L("div", Ppe, [
                            L("label", null, _e(m.$t("password")), 1),
                            Qt(L("input", {
                              type: "password",
                              name: "password",
                              class: "form-control",
                              placeholder: m.$t("password_enter"),
                              required: "",
                              "onUpdate:modelValue": _[1] || (_[1] = ($) => h.input.password = $),
                              disabled: h.isSubmit
                            }, null, 8, Mpe), [
                              [Io, h.input.password]
                            ]),
                            h.error.password ? (C(), k("small", $pe, _e(h.error.password), 1)) : q("", !0)
                          ]),
                          Qt(L("input", {
                            type: "hidden",
                            name: "one_time_password",
                            "onUpdate:modelValue": _[2] || (_[2] = ($) => h.input.one_time_password = $)
                          }, null, 512), [
                            [Io, h.input.one_time_password]
                          ]),
                          L("button", {
                            type: "button",
                            class: $e([
                              "btn ripple btn-main-primary btn-block btn-loader",
                              { "btn-loading": h.isSubmit }
                            ]),
                            onClick: _[3] || (_[3] = ($) => w()),
                            disabled: h.isSubmit
                          }, [
                            L("span", null, _e(m.$t("signin")), 1),
                            _[5] || (_[5] = L("span", { class: "ms-2 loading" }, [
                              L("i", { class: "fas fa-spinner" })
                            ], -1))
                          ], 10, Cpe)
                        ], 32),
                        _[7] || (_[7] = L("div", { class: "mt-3 mt-lg-4 ms-0" }, null, -1))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]);
    };
  }
}), Lpe = { class: "card-header border-bottom-0 mx-1 mt-2" }, Epe = { class: "main-content-label mb-1" }, Ope = { class: "text-muted card-sub-title" }, Npe = { class: "card-header border-bottom-0 mx-1 mt-2 shimmer" }, Dpe = { class: "main-content-label mb-1" }, kpe = { class: "text-muted card-sub-title" }, Gpe = { class: "card-body" }, Bpe = ["id"], Ipe = { class: "row row-sm" }, Rpe = { class: "card-footer d-grid gap-1 d-flex justify-content-end mb-1" }, Fpe = ["disabled"], She = /* @__PURE__ */ wt({
  __name: "ChangePassword",
  props: {
    propsFormAction: {
      type: Object,
      required: !0
    },
    propsStore: {
      type: Object,
      required: !0
    }
  },
  async setup(e) {
    let t, r;
    const o = e, n = o.propsStore.app, a = o.propsStore.user, l = o.propsStore.action, { initFormWrapper: i, isLoading: s } = QH();
    i({ app: n, user: a, action: l });
    const c = () => ({
      current_password: "",
      new_password: "",
      confirm_password: ""
    }), g = dt({
      action: "",
      blade: {
        current_password: {
          type: "password",
          label: "current_password",
          attributes: {
            required: !0,
            minlength: 6
          },
          placeholder: "current_password",
          value: "",
          classes: "",
          divClasses: ""
        },
        new_password: {
          type: "password",
          label: "new_password",
          attributes: {
            required: !0,
            minlength: 6
          },
          placeholder: "new_password",
          value: "",
          classes: "",
          divClasses: ""
        },
        confirm_password: {
          type: "password",
          label: "confirm_password",
          attributes: {
            required: !0,
            minlength: 6
          },
          placeholder: "confirm_password",
          value: "",
          classes: "",
          divClasses: ""
        }
      },
      data: {},
      id: "",
      isSubmit: !1
    }), p = {
      breadcrumb: {
        title: "reset_password",
        parent: "",
        action: "reset_password"
      }
    };
    Nn(() => {
      b(), T(a.getType());
    });
    const h = ([t, r] = ri(() => Yn("changePassword")), t = await t, r(), t), v = () => ({
      action: g.action,
      defaultRuler: "authRules",
      language: a.getLanguage(),
      stores: { user: a, action: l }
    }), A = () => {
      g.isSubmit || (b(a.getType()), g.isSubmit = !0, h(g.id, v()));
    }, S = (w) => {
      "isSubmit" in w && (b(), g.isSubmit = w.isSubmit);
    }, b = (w) => {
      g.action = w ? o.propsFormAction[w] : "changePassword";
    }, T = (w) => {
      g.id = w ? `${o.propsFormAction[w]}Form` : "changePasswordForm";
    };
    return (w, N) => (C(), ft(vG, {
      "props-breadcrumb": p.breadcrumb,
      "props-blade": g.blade,
      "props-blade-init": c,
      "props-is-edit": !1,
      "props-loading": R(s),
      "props-store": e.propsStore
    }, {
      header: je(() => [
        L("div", Lpe, [
          L("h6", Epe, _e(w.$t("reset_password")), 1),
          L("p", Ope, _e(w.$t("reset_password_desc")), 1)
        ])
      ]),
      "header-skeleton": je(() => [
        L("div", Npe, [
          L("h6", Dpe, _e(w.$t("table.loadingRecords")), 1),
          L("p", kpe, _e(w.$t("table.loadingRecords")), 1)
        ])
      ]),
      form: je(() => [
        L("div", Gpe, [
          L("form", {
            id: g.id
          }, [
            L("div", Ipe, [
              vt(I0, {
                "props-blade": g.blade,
                "props-blade-init": c,
                "props-form-option": v(),
                "props-is-disable": g.isSubmit,
                "props-is-edit": !1,
                "props-model": g.action,
                "props-store": {
                  app: R(n),
                  user: R(a),
                  action: R(l)
                },
                onOnPostSubmit: S
              }, null, 8, ["props-blade", "props-form-option", "props-is-disable", "props-model", "props-store"])
            ])
          ], 8, Bpe)
        ]),
        L("div", Rpe, [
          L("a", {
            href: "javascript:void(0)",
            class: $e(["btn btn-primary btn-loader", { "btn-loading": g.isSubmit }]),
            onClick: N[0] || (N[0] = (O) => A()),
            disabled: g.isSubmit
          }, [
            L("span", null, _e(w.$t("reset_password")), 1),
            N[1] || (N[1] = L("span", { class: "ms-2 loading" }, [
              L("i", { class: "fas fa-spinner" })
            ], -1))
          ], 10, Fpe)
        ])
      ]),
      _: 1
    }, 8, ["props-breadcrumb", "props-blade", "props-loading", "props-store"]));
  }
});
export {
  Q9 as Button,
  She as ChangePassword,
  A0e as DataGroup,
  xhe as FirstLoginPassword,
  I0 as FormGroup,
  T0e as FormListGroup,
  D0e as FormListGroupSkeleton,
  Qk as FormSkeleton,
  vG as FormWrapper,
  sF as ListGroup,
  k0e as ListGroupSkeleton,
  vhe as Login,
  P0e as ModulePermission,
  phe as NotFound404,
  M0e as ReportFilterGroup,
  $0e as ReportWrapper,
  L0e as SecAside,
  qk as SecBack,
  dw as SecBreadcrumb,
  E0e as SecFooter,
  O0e as SecHeader,
  oT as SecLocales,
  N0e as SecScroll,
  hhe as ServerError500,
  C0e as SummaryGroup,
  R0e as interfaces,
  F0e as mx2FaAuth,
  v0 as mxFormGroup,
  QH as mxFormWrapper,
  rT as mxLocale,
  lhe as mxMain,
  ihe as mxModal,
  she as mxProfile,
  dhe as mxReport,
  uhe as mxReportColumn,
  $R as mxScroll,
  gk as mxTRowDrag,
  che as plgDevice,
  mhe as plgI18n,
  ghe as plgSdk,
  fhe as registerLayouts,
  B0e as use2FaAuth,
  Upe as useGeneral,
  Hpe as useHelper,
  I0e as useVersionCheck,
  G0e as useWatch
};
